webpackJsonp([2,0,3],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1823);
	
	__webpack_require__(2921);
	
	__webpack_require__(1564);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays :
	                this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(2911)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.22.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	// SweetAlert
	// 2014-2015 (c) - Tristan Edwards
	// github.com/t4t5/sweetalert
	
	/*
	 * jQuery-like functions for manipulating the DOM
	 */
	
	var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation = __webpack_require__(122);
	
	/*
	 * Handy utilities
	 */
	
	var _extend$hexToRgb$isIE8$logStr$colorLuminance = __webpack_require__(155);
	
	/*
	 *  Handle sweetAlert's DOM elements
	 */
	
	var _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition = __webpack_require__(154);
	
	// Handle button events and keyboard events
	
	var _handleButton$handleConfirm$handleCancel = __webpack_require__(2931);
	
	var _handleKeyDown = __webpack_require__(2932);
	
	var _handleKeyDown2 = _interopRequireWildcard(_handleKeyDown);
	
	// Default values
	
	var _defaultParams = __webpack_require__(570);
	
	var _defaultParams2 = _interopRequireWildcard(_defaultParams);
	
	var _setParameters = __webpack_require__(2934);
	
	var _setParameters2 = _interopRequireWildcard(_setParameters);
	
	/*
	 * Remember state in cases where opening and handling a modal will fiddle with it.
	 * (We also use window.previousActiveElement as a global variable)
	 */
	var previousWindowKeyDown;
	var lastFocusedButton;
	
	/*
	 * Global sweetAlert function
	 * (this is what the user calls)
	 */
	var sweetAlert, swal;
	
	exports['default'] = sweetAlert = swal = function () {
	  var customizations = arguments[0];
	
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(document.body, 'stop-scrolling');
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.resetInput();
	
	  /*
	   * Use argument if defined or default value from params object otherwise.
	   * Supports the case where a default value is boolean true and should be
	   * overridden by a corresponding explicit argument which is boolean false.
	   */
	  function argumentOrDefault(key) {
	    var args = customizations;
	    return args[key] === undefined ? _defaultParams2['default'][key] : args[key];
	  }
	
	  if (customizations === undefined) {
	    _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert expects at least 1 attribute!');
	    return false;
	  }
	
	  var params = _extend$hexToRgb$isIE8$logStr$colorLuminance.extend({}, _defaultParams2['default']);
	
	  switch (typeof customizations) {
	
	    // Ex: swal("Hello", "Just testing", "info");
	    case 'string':
	      params.title = customizations;
	      params.text = arguments[1] || '';
	      params.type = arguments[2] || '';
	      break;
	
	    // Ex: swal({ title:"Hello", text: "Just testing", type: "info" });
	    case 'object':
	      if (customizations.title === undefined) {
	        _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Missing "title" argument!');
	        return false;
	      }
	
	      params.title = customizations.title;
	
	      for (var customName in _defaultParams2['default']) {
	        params[customName] = argumentOrDefault(customName);
	      }
	
	      // Show "Confirm" instead of "OK" if cancel button is visible
	      params.confirmButtonText = params.showCancelButton ? 'Confirm' : _defaultParams2['default'].confirmButtonText;
	      params.confirmButtonText = argumentOrDefault('confirmButtonText');
	
	      // Callback function when clicking on "OK"/"Cancel"
	      params.doneFunction = arguments[1] || null;
	
	      break;
	
	    default:
	      _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Unexpected type of argument! Expected "string" or "object", got ' + typeof customizations);
	      return false;
	
	  }
	
	  _setParameters2['default'](params);
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.fixVerticalPosition();
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.openModal(arguments[1]);
	
	  // Modal interactions
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  /*
	   * Make sure all modal buttons respond to all events
	   */
	  var $buttons = modal.querySelectorAll('button');
	  var buttonEvents = ['onclick', 'onmouseover', 'onmouseout', 'onmousedown', 'onmouseup', 'onfocus'];
	  var onButtonEvent = function onButtonEvent(e) {
	    return _handleButton$handleConfirm$handleCancel.handleButton(e, params, modal);
	  };
	
	  for (var btnIndex = 0; btnIndex < $buttons.length; btnIndex++) {
	    for (var evtIndex = 0; evtIndex < buttonEvents.length; evtIndex++) {
	      var btnEvt = buttonEvents[evtIndex];
	      $buttons[btnIndex][btnEvt] = onButtonEvent;
	    }
	  }
	
	  // Clicking outside the modal dismisses it (if allowed by user)
	  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay().onclick = onButtonEvent;
	
	  previousWindowKeyDown = window.onkeydown;
	
	  var onKeyEvent = function onKeyEvent(e) {
	    return _handleKeyDown2['default'](e, params, modal);
	  };
	  window.onkeydown = onKeyEvent;
	
	  window.onfocus = function () {
	    // When the user has focused away and focused back from the whole window.
	    setTimeout(function () {
	      // Put in a timeout to jump out of the event sequence.
	      // Calling focus() in the event sequence confuses things.
	      if (lastFocusedButton !== undefined) {
	        lastFocusedButton.focus();
	        lastFocusedButton = undefined;
	      }
	    }, 0);
	  };
	
	  // Show alert with enabled buttons always
	  swal.enableButtons();
	};
	
	/*
	 * Set default params for each popup
	 * @param {Object} userParams
	 */
	sweetAlert.setDefaults = swal.setDefaults = function (userParams) {
	  if (!userParams) {
	    throw new Error('userParams is required');
	  }
	  if (typeof userParams !== 'object') {
	    throw new Error('userParams has to be a object');
	  }
	
	  _extend$hexToRgb$isIE8$logStr$colorLuminance.extend(_defaultParams2['default'], userParams);
	};
	
	/*
	 * Animation when closing modal
	 */
	sweetAlert.close = swal.close = function () {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(_sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay(), 5);
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(modal, 5);
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'showSweetAlert');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(modal, 'hideSweetAlert');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'visible');
	
	  /*
	   * Reset icon animations
	   */
	  var $successIcon = modal.querySelector('.sa-icon.sa-success');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon, 'animate');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-tip'), 'animateSuccessTip');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-long'), 'animateSuccessLong');
	
	  var $errorIcon = modal.querySelector('.sa-icon.sa-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'animateErrorIcon');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon.querySelector('.sa-x-mark'), 'animateXMark');
	
	  var $warningIcon = modal.querySelector('.sa-icon.sa-warning');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon, 'pulseWarning');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-body'), 'pulseWarningIns');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-dot'), 'pulseWarningIns');
	
	  // Reset custom class (delay so that UI changes aren't visible)
	  setTimeout(function () {
	    var customClass = modal.getAttribute('data-custom-class');
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, customClass);
	  }, 300);
	
	  // Make page scrollable again
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(document.body, 'stop-scrolling');
	
	  // Reset the page to its previous state
	  window.onkeydown = previousWindowKeyDown;
	  if (window.previousActiveElement) {
	    window.previousActiveElement.focus();
	  }
	  lastFocusedButton = undefined;
	  clearTimeout(modal.timeout);
	
	  return true;
	};
	
	/*
	 * Validation of the input field is done by user
	 * If something is wrong => call showInputError with errorMessage
	 */
	sweetAlert.showInputError = swal.showInputError = function (errorMessage) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  var $errorIcon = modal.querySelector('.sa-input-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorIcon, 'show');
	
	  var $errorContainer = modal.querySelector('.sa-error-container');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorContainer, 'show');
	
	  $errorContainer.querySelector('p').innerHTML = errorMessage;
	
	  setTimeout(function () {
	    sweetAlert.enableButtons();
	  }, 1);
	
	  modal.querySelector('input').focus();
	};
	
	/*
	 * Reset input error DOM elements
	 */
	sweetAlert.resetInputError = swal.resetInputError = function (event) {
	  // If press enter => ignore
	  if (event && event.keyCode === 13) {
	    return false;
	  }
	
	  var $modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	
	  var $errorIcon = $modal.querySelector('.sa-input-error');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'show');
	
	  var $errorContainer = $modal.querySelector('.sa-error-container');
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorContainer, 'show');
	};
	
	/*
	 * Disable confirm and cancel buttons
	 */
	sweetAlert.disableButtons = swal.disableButtons = function (event) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	  var $confirmButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  $confirmButton.disabled = true;
	  $cancelButton.disabled = true;
	};
	
	/*
	 * Enable confirm and cancel buttons
	 */
	sweetAlert.enableButtons = swal.enableButtons = function (event) {
	  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
	  var $confirmButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  $confirmButton.disabled = false;
	  $cancelButton.disabled = false;
	};
	
	if (typeof window !== 'undefined') {
	  // The 'handle-click' module requires
	  // that 'sweetAlert' was set as global.
	  window.sweetAlert = window.swal = sweetAlert;
	} else {
	  _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert is a frontend module!');
	}
	module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var core = __webpack_require__(51);
	var hide = __webpack_require__(38);
	var redefine = __webpack_require__(39);
	var ctx = __webpack_require__(52);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1566), __esModule: true };

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.5.0
	 * (c) 2017 Evan You
	 * @license MIT
	 */
	'use strict';
	
	var applyMixin = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    Vue.mixin({ beforeCreate: vuexInit });
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit;
	      _init.call(this, options);
	    };
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options;
	    // store injection
	    if (options.store) {
	      this.$store = typeof options.store === 'function'
	        ? options.store()
	        : options.store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	  }
	};
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook;
	
	  devtoolHook.emit('vuex:init', store);
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  this._children = Object.create(null);
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};
	
	var prototypeAccessors$1 = { namespaced: { configurable: true } };
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  if (false) {
	    assertRawModule(path, rawModule);
	  }
	
	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key);
	};
	
	function update (path, targetModule, newModule) {
	  if (false) {
	    assertRawModule(path, newModule);
	  }
	
	  // update target module
	  targetModule.update(newModule);
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        if (false) {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}
	
	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};
	
	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};
	
	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};
	
	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }
	
	    var assertOptions = assertTypes[key];
	
	    forEachValue(rawModule[key], function (value, type) {
	      assert(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}
	
	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}
	
	var Vue; // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  // Auto install if it is not done yet and `window` has `Vue`.
	  // To allow users to avoid auto-installation in some cases,
	  // this code should be placed here. See #731
	  if (!Vue && typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  if (false) {
	    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
	    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert(this instanceof Store, "Store must be called with the new operator.");
	  }
	
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  if (typeof state === 'function') {
	    state = state() || {};
	  }
	
	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._watcherVM = new Vue();
	
	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };
	
	  // strict mode
	  this.strict = strict;
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state);
	
	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });
	
	  if (Vue.config.devtools) {
	    devtoolPlugin(this);
	  }
	};
	
	var prototypeAccessors = { state: { configurable: true } };
	
	prototypeAccessors.state.get = function () {
	  return this._vm._data.$$state
	};
	
	prototypeAccessors.state.set = function (v) {
	  if (false) {
	    assert(false, "Use store.replaceState() to explicit replace store state.");
	  }
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });
	
	  if (
	    false
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;
	
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }
	
	  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });
	
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  return genericSubscribe(fn, this._subscribers)
	};
	
	Store.prototype.subscribeAction = function subscribeAction (fn) {
	  return genericSubscribe(fn, this._actionSubscribers)
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  if (false) {
	    assert(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm._data.$$state = state;
	  });
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	    assert(path.length > 0, 'cannot register the root module by using registerModule.');
	  }
	
	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreVM(this, this.state);
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	  }
	
	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    Vue.delete(parentState, path[path.length - 1]);
	  });
	  resetStore(this);
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function genericSubscribe (fn, subs) {
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}
	
	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset vm
	  resetStoreVM(store, state, hot);
	}
	
	function resetStoreVM (store, state, hot) {
	  var oldVm = store._vm;
	
	  // bind store public getters
	  store.getters = {};
	  var wrappedGetters = store._wrappedGetters;
	  var computed = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); };
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    });
	  });
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  store._vm = new Vue({
	    data: {
	      $$state: state
	    },
	    computed: computed
	  });
	  Vue.config.silent = silent;
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store);
	  }
	
	  if (oldVm) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldVm._data.$$state = null;
	      });
	    }
	    Vue.nextTick(function () { return oldVm.$destroy(); });
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);
	
	  // register in namespace map
	  if (module.namespaced) {
	    store._modulesNamespaceMap[namespace] = module;
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state);
	    });
	  }
	
	  var local = module.context = makeLocalContext(store, namespace, path);
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });
	
	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}
	
	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      store.commit(type, payload, options);
	    }
	  };
	
	  // getters and state object must be gotten lazily
	  // because they will be changed by vm update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {};
	
	  var splitPos = namespace.length;
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos);
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    });
	  });
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}
	
	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb);
	    if (!isPromise(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}
	
	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    if (false) {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch(function () { return this._data.$$state }, function () {
	    if (false) {
	      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, sync: true });
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }
	
	  if (false) {
	    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
	  }
	
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      console.error(
	        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	      );
	    }
	    return
	  }
	  Vue = _Vue;
	  applyMixin(Vue);
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if (false) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}
	
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if (false) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.5.0',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers
	};
	
	module.exports = index;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(20);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(368);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// since we are requiring the top level of faker, load all locales by default
	var Faker = __webpack_require__(1938);
	var faker = new Faker({ locales: __webpack_require__(1940) });
	module['exports'] = faker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1568), __esModule: true };

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.10';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(1)(module)))

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(128);
	module.exports.easing = __webpack_require__(1546);
	module.exports.canvas = __webpack_require__(1545);
	module.exports.options = __webpack_require__(1547);


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1571), __esModule: true };

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(19);
	
	module.exports = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers.merge(this[scope] || (this[scope] = {}), values);
		}
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(145)('wks');
	var uid = __webpack_require__(89);
	var Symbol = __webpack_require__(18).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1500)
	var ieee754 = __webpack_require__(2890)
	var isArray = __webpack_require__(1517)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(21)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(17);
	var IE8_DOM_DEFINE = __webpack_require__(409);
	var toPrimitive = __webpack_require__(63);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(27) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(62);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(60);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var core = __webpack_require__(26);
	var ctx = __webpack_require__(70);
	var hide = __webpack_require__(72);
	var has = __webpack_require__(79);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(184)('wks');
	var uid = __webpack_require__(133);
	var Symbol = __webpack_require__(32).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(28);
	var createDesc = __webpack_require__(85);
	module.exports = __webpack_require__(27) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var hide = __webpack_require__(38);
	var has = __webpack_require__(43);
	var SRC = __webpack_require__(89)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(51).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var fails = __webpack_require__(21);
	var defined = __webpack_require__(60);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(231);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(120);
	var createDesc = __webpack_require__(85);
	var toIObject = __webpack_require__(46);
	var toPrimitive = __webpack_require__(63);
	var has = __webpack_require__(43);
	var IE8_DOM_DEFINE = __webpack_require__(409);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(27) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(43);
	var toObject = __webpack_require__(30);
	var IE_PROTO = __webpack_require__(208)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(119);
	var defined = __webpack_require__(60);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/* **********************************************
	     Begin prism-core.js
	********************************************** */
	
	var _self = (typeof window !== 'undefined')
		? window   // if in browser
		: (
			(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
		);
	
	/**
	 * Prism: Lightweight, robust, elegant syntax highlighting
	 * MIT license http://www.opensource.org/licenses/mit-license.php/
	 * @author Lea Verou http://lea.verou.me
	 */
	
	var Prism = (function(){
	
	// Private helper vars
	var lang = /\blang(?:uage)?-([\w-]+)\b/i;
	var uniqueId = 0;
	
	var _ = _self.Prism = {
		manual: _self.Prism && _self.Prism.manual,
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
		util: {
			encode: function (tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
				} else if (_.util.type(tokens) === 'Array') {
					return tokens.map(_.util.encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},
	
			type: function (o) {
				return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
			},
	
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},
	
			// Deep clone a language definition (e.g. to extend it)
			clone: function (o, visited) {
				var type = _.util.type(o);
				visited = visited || {};
	
				switch (type) {
					case 'Object':
						if (visited[_.util.objId(o)]) {
							return visited[_.util.objId(o)];
						}
						var clone = {};
						visited[_.util.objId(o)] = clone;
	
						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = _.util.clone(o[key], visited);
							}
						}
	
						return clone;
	
					case 'Array':
						if (visited[_.util.objId(o)]) {
							return visited[_.util.objId(o)];
						}
						var clone = [];
						visited[_.util.objId(o)] = clone;
	
						o.forEach(function (v, i) {
							clone[i] = _.util.clone(v, visited);
						});
	
						return clone;
				}
	
				return o;
			}
		},
	
		languages: {
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);
	
				for (var key in redef) {
					lang[key] = redef[key];
				}
	
				return lang;
			},
	
			/**
			 * Insert a token before another token in a language literal
			 * As this needs to recreate the object (we cannot actually insert before keys in object literals),
			 * we cannot just provide an object, we need anobject and a key.
			 * @param inside The key (or language id) of the parent
			 * @param before The key to insert before. If not provided, the function appends instead.
			 * @param insert Object with the key/value pairs to insert
			 * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || _.languages;
				var grammar = root[inside];
	
				if (arguments.length == 2) {
					insert = arguments[1];
	
					for (var newToken in insert) {
						if (insert.hasOwnProperty(newToken)) {
							grammar[newToken] = insert[newToken];
						}
					}
	
					return grammar;
				}
	
				var ret = {};
	
				for (var token in grammar) {
	
					if (grammar.hasOwnProperty(token)) {
	
						if (token == before) {
	
							for (var newToken in insert) {
	
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}
	
						ret[token] = grammar[token];
					}
				}
	
				// Update references in other language definitions
				_.languages.DFS(_.languages, function(key, value) {
					if (value === root[inside] && key != inside) {
						this[key] = ret;
					}
				});
	
				return root[inside] = ret;
			},
	
			// Traverse a language definition with Depth First Search
			DFS: function(o, callback, type, visited) {
				visited = visited || {};
				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);
	
						if (_.util.type(o[i]) === 'Object' && !visited[_.util.objId(o[i])]) {
							visited[_.util.objId(o[i])] = true;
							_.languages.DFS(o[i], callback, null, visited);
						}
						else if (_.util.type(o[i]) === 'Array' && !visited[_.util.objId(o[i])]) {
							visited[_.util.objId(o[i])] = true;
							_.languages.DFS(o[i], callback, i, visited);
						}
					}
				}
			}
		},
		plugins: {},
	
		highlightAll: function(async, callback) {
			_.highlightAllUnder(document, async, callback);
		},
	
		highlightAllUnder: function(container, async, callback) {
			var env = {
				callback: callback,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};
	
			_.hooks.run("before-highlightall", env);
	
			var elements = env.elements || container.querySelectorAll(env.selector);
	
			for (var i=0, element; element = elements[i++];) {
				_.highlightElement(element, async === true, env.callback);
			}
		},
	
		highlightElement: function(element, async, callback) {
			// Find language
			var language, grammar, parent = element;
	
			while (parent && !lang.test(parent.className)) {
				parent = parent.parentNode;
			}
	
			if (parent) {
				language = (parent.className.match(lang) || [,''])[1].toLowerCase();
				grammar = _.languages[language];
			}
	
			// Set language on the element, if not present
			element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
	
			if (element.parentNode) {
				// Set language on the parent, for styling
				parent = element.parentNode;
	
				if (/pre/i.test(parent.nodeName)) {
					parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
				}
			}
	
			var code = element.textContent;
	
			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};
	
			_.hooks.run('before-sanity-check', env);
	
			if (!env.code || !env.grammar) {
				if (env.code) {
					_.hooks.run('before-highlight', env);
					env.element.textContent = env.code;
					_.hooks.run('after-highlight', env);
				}
				_.hooks.run('complete', env);
				return;
			}
	
			_.hooks.run('before-highlight', env);
	
			if (async && _self.Worker) {
				var worker = new Worker(_.filename);
	
				worker.onmessage = function(evt) {
					env.highlightedCode = evt.data;
	
					_.hooks.run('before-insert', env);
	
					env.element.innerHTML = env.highlightedCode;
	
					callback && callback.call(env.element);
					_.hooks.run('after-highlight', env);
					_.hooks.run('complete', env);
				};
	
				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			}
			else {
				env.highlightedCode = _.highlight(env.code, env.grammar, env.language);
	
				_.hooks.run('before-insert', env);
	
				env.element.innerHTML = env.highlightedCode;
	
				callback && callback.call(element);
	
				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
			}
		},
	
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},
	
		matchGrammar: function (text, strarr, grammar, index, startPos, oneshot, target) {
			var Token = _.Token;
	
			for (var token in grammar) {
				if(!grammar.hasOwnProperty(token) || !grammar[token]) {
					continue;
				}
	
				if (token == target) {
					return;
				}
	
				var patterns = grammar[token];
				patterns = (_.util.type(patterns) === "Array") ? patterns : [patterns];
	
				for (var j = 0; j < patterns.length; ++j) {
					var pattern = patterns[j],
						inside = pattern.inside,
						lookbehind = !!pattern.lookbehind,
						greedy = !!pattern.greedy,
						lookbehindLength = 0,
						alias = pattern.alias;
	
					if (greedy && !pattern.pattern.global) {
						// Without the global flag, lastIndex won't work
						var flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
						pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
					}
	
					pattern = pattern.pattern || pattern;
	
					// Don’t cache length as it changes during the loop
					for (var i = index, pos = startPos; i < strarr.length; pos += strarr[i].length, ++i) {
	
						var str = strarr[i];
	
						if (strarr.length > text.length) {
							// Something went terribly wrong, ABORT, ABORT!
							return;
						}
	
						if (str instanceof Token) {
							continue;
						}
	
						if (greedy && i != strarr.length - 1) {
							pattern.lastIndex = pos;
							var match = pattern.exec(text);
							if (!match) {
								break;
							}
	
							var from = match.index + (lookbehind ? match[1].length : 0),
							    to = match.index + match[0].length,
							    k = i,
							    p = pos;
	
							for (var len = strarr.length; k < len && (p < to || (!strarr[k].type && !strarr[k - 1].greedy)); ++k) {
								p += strarr[k].length;
								// Move the index i to the element in strarr that is closest to from
								if (from >= p) {
									++i;
									pos = p;
								}
							}
	
							// If strarr[i] is a Token, then the match starts inside another Token, which is invalid
							if (strarr[i] instanceof Token) {
								continue;
							}
	
							// Number of tokens to delete and replace with the new match
							delNum = k - i;
							str = text.slice(pos, p);
							match.index -= pos;
						} else {
							pattern.lastIndex = 0;
	
							var match = pattern.exec(str),
								delNum = 1;
						}
	
						if (!match) {
							if (oneshot) {
								break;
							}
	
							continue;
						}
	
						if(lookbehind) {
							lookbehindLength = match[1] ? match[1].length : 0;
						}
	
						var from = match.index + lookbehindLength,
						    match = match[0].slice(lookbehindLength),
						    to = from + match.length,
						    before = str.slice(0, from),
						    after = str.slice(to);
	
						var args = [i, delNum];
	
						if (before) {
							++i;
							pos += before.length;
							args.push(before);
						}
	
						var wrapped = new Token(token, inside? _.tokenize(match, inside) : match, alias, match, greedy);
	
						args.push(wrapped);
	
						if (after) {
							args.push(after);
						}
	
						Array.prototype.splice.apply(strarr, args);
	
						if (delNum != 1)
							_.matchGrammar(text, strarr, grammar, i, pos, true, token);
	
						if (oneshot)
							break;
					}
				}
			}
		},
	
		tokenize: function(text, grammar, language) {
			var strarr = [text];
	
			var rest = grammar.rest;
	
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}
	
				delete grammar.rest;
			}
	
			_.matchGrammar(text, strarr, grammar, 0, 0, false);
	
			return strarr;
		},
	
		hooks: {
			all: {},
	
			add: function (name, callback) {
				var hooks = _.hooks.all;
	
				hooks[name] = hooks[name] || [];
	
				hooks[name].push(callback);
			},
	
			run: function (name, env) {
				var callbacks = _.hooks.all[name];
	
				if (!callbacks || !callbacks.length) {
					return;
				}
	
				for (var i=0, callback; callback = callbacks[i++];) {
					callback(env);
				}
			}
		}
	};
	
	var Token = _.Token = function(type, content, alias, matchedStr, greedy) {
		this.type = type;
		this.content = content;
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || "").length|0;
		this.greedy = !!greedy;
	};
	
	Token.stringify = function(o, language, parent) {
		if (typeof o == 'string') {
			return o;
		}
	
		if (_.util.type(o) === 'Array') {
			return o.map(function(element) {
				return Token.stringify(element, language, o);
			}).join('');
		}
	
		var env = {
			type: o.type,
			content: Token.stringify(o.content, language, parent),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language,
			parent: parent
		};
	
		if (o.alias) {
			var aliases = _.util.type(o.alias) === 'Array' ? o.alias : [o.alias];
			Array.prototype.push.apply(env.classes, aliases);
		}
	
		_.hooks.run('wrap', env);
	
		var attributes = Object.keys(env.attributes).map(function(name) {
			return name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}).join(' ');
	
		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';
	
	};
	
	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _self.Prism;
		}
	
		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data),
					lang = message.language,
					code = message.code,
					immediateClose = message.immediateClose;
	
				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}
	
		return _self.Prism;
	}
	
	//Get current script and highlight
	var script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();
	
	if (script) {
		_.filename = script.src;
	
		if (!_.manual && !script.hasAttribute('data-manual')) {
			if(document.readyState !== "loading") {
				if (window.requestAnimationFrame) {
					window.requestAnimationFrame(_.highlightAll);
				} else {
					window.setTimeout(_.highlightAll, 16);
				}
			}
			else {
				document.addEventListener('DOMContentLoaded', _.highlightAll);
			}
		}
	}
	
	return _self.Prism;
	
	})();
	
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Prism;
	}
	
	// hack for components to work correctly in node.js
	if (typeof global !== 'undefined') {
		global.Prism = Prism;
	}
	
	
	/* **********************************************
	     Begin prism-markup.js
	********************************************** */
	
	Prism.languages.markup = {
		'comment': /<!--[\s\S]*?-->/,
		'prolog': /<\?[\s\S]+?\?>/,
		'doctype': /<!DOCTYPE[\s\S]+?>/i,
		'cdata': /<!\[CDATA\[[\s\S]*?]]>/i,
		'tag': {
			pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,
			greedy: true,
			inside: {
				'tag': {
					pattern: /^<\/?[^\s>\/]+/i,
					inside: {
						'punctuation': /^<\/?/,
						'namespace': /^[^\s>\/:]+:/
					}
				},
				'attr-value': {
					pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,
					inside: {
						'punctuation': [
							/^=/,
							{
								pattern: /(^|[^\\])["']/,
								lookbehind: true
							}
						]
					}
				},
				'punctuation': /\/?>/,
				'attr-name': {
					pattern: /[^\s>\/]+/,
					inside: {
						'namespace': /^[^\s>\/:]+:/
					}
				}
	
			}
		},
		'entity': /&#?[\da-z]{1,8};/i
	};
	
	Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
		Prism.languages.markup['entity'];
	
	// Plugin to make entity title show the real entity, idea by Roman Komarov
	Prism.hooks.add('wrap', function(env) {
	
		if (env.type === 'entity') {
			env.attributes['title'] = env.content.replace(/&amp;/, '&');
		}
	});
	
	Prism.languages.xml = Prism.languages.markup;
	Prism.languages.html = Prism.languages.markup;
	Prism.languages.mathml = Prism.languages.markup;
	Prism.languages.svg = Prism.languages.markup;
	
	
	/* **********************************************
	     Begin prism-css.js
	********************************************** */
	
	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: /@[\w-]+?.*?(?:;|(?=\s*\{))/i,
			inside: {
				'rule': /@[\w-]+/
				// See rest below
			}
		},
		'url': /url\((?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
		'selector': /[^{}\s][^{};]*?(?=\s*\{)/,
		'string': {
			pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: true
		},
		'property': /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
		'important': /\B!important\b/i,
		'function': /[-a-z0-9]+(?=\()/i,
		'punctuation': /[(){};:]/
	};
	
	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
	
	if (Prism.languages.markup) {
		Prism.languages.insertBefore('markup', 'tag', {
			'style': {
				pattern: /(<style[\s\S]*?>)[\s\S]*?(?=<\/style>)/i,
				lookbehind: true,
				inside: Prism.languages.css,
				alias: 'language-css',
				greedy: true
			}
		});
	
		Prism.languages.insertBefore('inside', 'attr-value', {
			'style-attr': {
				pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
				inside: {
					'attr-name': {
						pattern: /^\s*style/i,
						inside: Prism.languages.markup.tag.inside
					},
					'punctuation': /^\s*=\s*['"]|['"]\s*$/,
					'attr-value': {
						pattern: /.+/i,
						inside: Prism.languages.css
					}
				},
				alias: 'language-css'
			}
		}, Prism.languages.markup.tag);
	}
	
	/* **********************************************
	     Begin prism-clike.js
	********************************************** */
	
	Prism.languages.clike = {
		'comment': [
			{
				pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
				lookbehind: true
			},
			{
				pattern: /(^|[^\\:])\/\/.*/,
				lookbehind: true,
				greedy: true
			}
		],
		'string': {
			pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: true
		},
		'class-name': {
			pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
			lookbehind: true,
			inside: {
				punctuation: /[.\\]/
			}
		},
		'keyword': /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
		'boolean': /\b(?:true|false)\b/,
		'function': /[a-z0-9_]+(?=\()/i,
		'number': /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
		'operator': /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
		'punctuation': /[{}[\];(),.:]/
	};
	
	
	/* **********************************************
	     Begin prism-javascript.js
	********************************************** */
	
	Prism.languages.javascript = Prism.languages.extend('clike', {
		'keyword': /\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
		'number': /\b(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+|NaN|Infinity)\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
		// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
		'function': /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*\()/i,
		'operator': /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
	});
	
	Prism.languages.insertBefore('javascript', 'keyword', {
		'regex': {
			pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[[^\]\r\n]+]|\\.|[^/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
			lookbehind: true,
			greedy: true
		},
		// This must be declared before keyword because we use "function" inside the look-forward
		'function-variable': {
			pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)|[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/i,
			alias: 'function'
		},
		'constant': /\b[A-Z][A-Z\d_]*\b/
	});
	
	Prism.languages.insertBefore('javascript', 'string', {
		'template-string': {
			pattern: /`(?:\\[\s\S]|[^\\`])*`/,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /\$\{[^}]+\}/,
					inside: {
						'interpolation-punctuation': {
							pattern: /^\$\{|\}$/,
							alias: 'punctuation'
						},
						rest: Prism.languages.javascript
					}
				},
				'string': /[\s\S]+/
			}
		}
	});
	
	if (Prism.languages.markup) {
		Prism.languages.insertBefore('markup', 'tag', {
			'script': {
				pattern: /(<script[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,
				lookbehind: true,
				inside: Prism.languages.javascript,
				alias: 'language-javascript',
				greedy: true
			}
		});
	}
	
	Prism.languages.js = Prism.languages.javascript;
	
	
	/* **********************************************
	     Begin prism-file-highlight.js
	********************************************** */
	
	(function () {
		if (typeof self === 'undefined' || !self.Prism || !self.document || !document.querySelector) {
			return;
		}
	
		self.Prism.fileHighlight = function() {
	
			var Extensions = {
				'js': 'javascript',
				'py': 'python',
				'rb': 'ruby',
				'ps1': 'powershell',
				'psm1': 'powershell',
				'sh': 'bash',
				'bat': 'batch',
				'h': 'c',
				'tex': 'latex'
			};
	
			Array.prototype.slice.call(document.querySelectorAll('pre[data-src]')).forEach(function (pre) {
				var src = pre.getAttribute('data-src');
	
				var language, parent = pre;
				var lang = /\blang(?:uage)?-(?!\*)([\w-]+)\b/i;
				while (parent && !lang.test(parent.className)) {
					parent = parent.parentNode;
				}
	
				if (parent) {
					language = (pre.className.match(lang) || [, ''])[1];
				}
	
				if (!language) {
					var extension = (src.match(/\.(\w+)$/) || [, ''])[1];
					language = Extensions[extension] || extension;
				}
	
				var code = document.createElement('code');
				code.className = 'language-' + language;
	
				pre.textContent = '';
	
				code.textContent = 'Loading…';
	
				pre.appendChild(code);
	
				var xhr = new XMLHttpRequest();
	
				xhr.open('GET', src, true);
	
				xhr.onreadystatechange = function () {
					if (xhr.readyState == 4) {
	
						if (xhr.status < 400 && xhr.responseText) {
							code.textContent = xhr.responseText;
	
							Prism.highlightElement(code);
						}
						else if (xhr.status >= 400) {
							code.textContent = '✖ Error ' + xhr.status + ' while fetching file: ' + xhr.statusText;
						}
						else {
							code.textContent = '✖ Error: File does not exist or is empty';
						}
					}
				};
	
				if (pre.hasAttribute('data-download-link') && Prism.plugins.toolbar) {
					Prism.plugins.toolbar.registerButton('download-file', function () {
						var a = document.createElement('a');
						a.textContent = pre.getAttribute('data-download-link-label') || 'Download';
						a.setAttribute('download', '');
						a.href = src;
						return a;
					});
				}
	
				xhr.send(null);
			});
	
		};
	
		document.addEventListener('DOMContentLoaded', self.Prism.fileHighlight);
	
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(71)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(65);
	var IE8_DOM_DEFINE = __webpack_require__(383);
	var toPrimitive = __webpack_require__(187);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(48) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(34);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(21);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(634);

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var color = __webpack_require__(381);
	var helpers = __webpack_require__(19);
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = color(origin);
					if (c0.valid) {
						c1 = color(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers.extend(Element.prototype, {
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers.clone(me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = model;
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers.inherits;
	
	module.exports = Element;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(52);
	var IObject = __webpack_require__(119);
	var toObject = __webpack_require__(30);
	var toLength = __webpack_require__(29);
	var asc = __webpack_require__(193);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(5);
	var core = __webpack_require__(51);
	var fails = __webpack_require__(21);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(22);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(58);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(430);
	var $export = __webpack_require__(5);
	var shared = __webpack_require__(145)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(433))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(27)) {
	  var LIBRARY = __webpack_require__(74);
	  var global = __webpack_require__(18);
	  var fails = __webpack_require__(21);
	  var $export = __webpack_require__(5);
	  var $typed = __webpack_require__(147);
	  var $buffer = __webpack_require__(214);
	  var ctx = __webpack_require__(52);
	  var anInstance = __webpack_require__(80);
	  var propertyDesc = __webpack_require__(85);
	  var hide = __webpack_require__(38);
	  var redefineAll = __webpack_require__(86);
	  var toInteger = __webpack_require__(62);
	  var toLength = __webpack_require__(29);
	  var toIndex = __webpack_require__(428);
	  var toAbsoluteIndex = __webpack_require__(88);
	  var toPrimitive = __webpack_require__(63);
	  var has = __webpack_require__(43);
	  var classof = __webpack_require__(118);
	  var isObject = __webpack_require__(22);
	  var toObject = __webpack_require__(30);
	  var isArrayIter = __webpack_require__(200);
	  var create = __webpack_require__(82);
	  var getPrototypeOf = __webpack_require__(45);
	  var gOPN = __webpack_require__(83).f;
	  var getIterFn = __webpack_require__(216);
	  var uid = __webpack_require__(89);
	  var wks = __webpack_require__(24);
	  var createArrayMethod = __webpack_require__(59);
	  var createArrayIncludes = __webpack_require__(134);
	  var speciesConstructor = __webpack_require__(146);
	  var ArrayIterators = __webpack_require__(217);
	  var Iterators = __webpack_require__(96);
	  var $iterDetect = __webpack_require__(140);
	  var setSpecies = __webpack_require__(87);
	  var arrayFill = __webpack_require__(192);
	  var arrayCopyWithin = __webpack_require__(401);
	  var $DP = __webpack_require__(28);
	  var $GOPD = __webpack_require__(44);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {};
	module.exports.Arc = __webpack_require__(1541);
	module.exports.Line = __webpack_require__(1542);
	module.exports.Point = __webpack_require__(1543);
	module.exports.Rectangle = __webpack_require__(1544);


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(109);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(49);
	var createDesc = __webpack_require__(114);
	module.exports = __webpack_require__(48) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(24)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(38)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(89)('meta');
	var isObject = __webpack_require__(22);
	var has = __webpack_require__(43);
	var setDesc = __webpack_require__(28).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(21)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1574), __esModule: true };

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(52);
	var call = __webpack_require__(412);
	var isArrayIter = __webpack_require__(200);
	var anObject = __webpack_require__(17);
	var toLength = __webpack_require__(29);
	var getIterFn = __webpack_require__(216);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(17);
	var dPs = __webpack_require__(418);
	var enumBugKeys = __webpack_require__(196);
	var IE_PROTO = __webpack_require__(208)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(195)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(198).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(420);
	var hiddenKeys = __webpack_require__(196).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(420);
	var enumBugKeys = __webpack_require__(196);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(39);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var dP = __webpack_require__(28);
	var DESCRIPTORS = __webpack_require__(27);
	var SPECIES = __webpack_require__(24)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(62);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(152);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(121);
	util.inherits = __webpack_require__(64);
	/*</replacement>*/
	
	var Readable = __webpack_require__(565);
	var Writable = __webpack_require__(219);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(176);
	var defined = __webpack_require__(130);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1602)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(177)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(28).f;
	var has = __webpack_require__(43);
	var TAG = __webpack_require__(24)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var defined = __webpack_require__(60);
	var fails = __webpack_require__(21);
	var spaces = __webpack_require__(212);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["vue2-dropzone"]=t():e["vue2-dropzone"]=t()}(this,function(){return function(e){function t(n){if(i[n])return i[n].exports;var o=i[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var i={};return t.m=e,t.c=i,t.p="",t(0)}([function(e,t,i){var n,o,r={};i(8),n=i(2),o=i(6),e.exports=n||{},e.exports.__esModule&&(e.exports=e.exports.default);var s="function"==typeof e.exports?e.exports.options||(e.exports.options={}):e.exports;o&&(s.template=o),s.computed||(s.computed={}),Object.keys(r).forEach(function(e){var t=r[e];s.computed[e]=function(){return t}})},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var i=this[t];i[2]?e.push("@media "+i[2]+"{"+i[1]+"}"):e.push(i[1])}return e.join("")},e.i=function(t,i){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},o=0;o<this.length;o++){var r=this[o][0];"number"==typeof r&&(n[r]=!0)}for(o=0;o<t.length;o++){var s=t[o];"number"==typeof s[0]&&n[s[0]]||(i&&!s[2]?s[2]=i:i&&(s[2]="("+s[2]+") and ("+i+")"),e.push(s))}},e}},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={props:{id:{type:String,required:!0},url:{type:String,required:!0},clickable:{type:[Boolean,String],default:!0},confirm:{type:Function,default:void 0},paramName:{type:String,default:"file"},acceptedFileTypes:{type:String},thumbnailHeight:{type:Number,default:200},thumbnailWidth:{type:Number,default:200},showRemoveLink:{type:Boolean,default:!0},maxFileSizeInMB:{type:Number,default:2},maxNumberOfFiles:{type:Number,default:5},autoProcessQueue:{type:Boolean,default:!0},useFontAwesome:{type:Boolean,default:!1},headers:{type:Object},language:{type:Object,default:function(){return{}}},previewTemplate:{type:Function,default:function(e){return'\n                    <div class="dz-preview dz-file-preview">\n                        <div class="dz-image" style="width: '+e.thumbnailWidth+"px;height: "+e.thumbnailHeight+'px">\n                        <img data-dz-thumbnail /></div>\n                        <div class="dz-details">\n                            <div class="dz-size"><span data-dz-size></span></div>\n                            <div class="dz-filename"><span data-dz-name></span></div>\n                        </div>\n                        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n                        <div class="dz-error-message"><span data-dz-errormessage></span></div>\n                        <div class="dz-success-mark">'+e.doneIcon+'</div>\n                        <div class="dz-error-mark">'+e.errorIcon+"</div>\n                    </div>\n                "}},useCustomDropzoneOptions:{type:Boolean,default:!1},dropzoneOptions:{type:Object,default:function(){return{}}},resizeWidth:{type:Number,default:null},resizeHeight:{type:Number,default:null},resizeMimeType:{type:String,default:null},resizeQuality:{type:Number,default:.8},resizeMethod:{type:String,default:"contain"},uploadMultiple:{type:Boolean,default:!1},duplicateCheck:{type:Boolean,default:!1},parallelUploads:{type:Number,default:2},timeout:{type:Number,default:3e4},method:{type:String,default:"POST"},withCredentials:{type:Boolean,default:!1},capture:{type:String,default:null},hiddenInputContainer:{type:String,default:"body"}},methods:{manuallyAddFile:function(e,t,i,n,o){this.dropzone.emit("addedfile",e),this.dropzone.emit("thumbnail",e,t),this.dropzone.createThumbnailFromUrl(e,t,i,n),this.dropzone.emit("complete",e),"undefined"!=typeof o.dontSubstractMaxFiles&&o.dontSubstractMaxFiles||(this.dropzone.options.maxFiles=this.dropzone.options.maxFiles-1),"undefined"!=typeof o.addToFiles&&o.addToFiles&&this.dropzone.files.push(e),this.$emit("vdropzone-file-added-manually",e)},setOption:function(e,t){this.dropzone.options[e]=t},removeAllFiles:function(){this.dropzone.removeAllFiles(!0)},processQueue:function(){var e=this.dropzone;this.dropzone.processQueue(),this.dropzone.on("success",function(){e.options.autoProcessQueue=!0}),this.dropzone.on("queuecomplete",function(){e.options.autoProcessQueue=!1})},removeFile:function(e){this.dropzone.removeFile(e)},getAcceptedFiles:function(){return this.dropzone.getAcceptedFiles()},getRejectedFiles:function(){return this.dropzone.getRejectedFiles()},getUploadingFiles:function(){return this.dropzone.getUploadingFiles()},getQueuedFiles:function(){return this.dropzone.getQueuedFiles()},getProp:function(e,t){return this.useCustomDropzoneOptions&&void 0!==t&&null!==t&&""!==t?t:e}},computed:{languageSettings:function(){var e={dictDefaultMessage:"<br>Drop files here to upload",dictCancelUpload:"Cancel upload",dictCancelUploadConfirmation:"Are you sure you want to cancel this upload?",dictFallbackMessage:"Your browser does not support drag and drop file uploads.",dictFallbackText:"Please use the fallback form below to upload your files like in the olden days.",dictFileTooBig:"File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",dictInvalidFileType:"You can't upload files of this type.",dictMaxFilesExceeded:"You can not upload any more files. (max: {{maxFiles}})",dictRemoveFile:"Remove",dictRemoveFileConfirmation:null,dictResponseError:"Server responded with {{statusCode}} code."};for(var t in this.language)e[t]=this.language[t];if(this.useCustomDropzoneOptions&&this.dropzoneOptions.language)for(var i in this.dropzoneOptions.language)e[i]=this.dropzoneOptions.language[i];return e},cloudIcon:function(){return this.useFontAwesome?'<i class="fa fa-cloud-upload"></i>':'<i class="material-icons">cloud_upload</i>'},doneIcon:function(){return this.useFontAwesome?'<i class="fa fa-check"></i>':' <i class="material-icons">done</i>'},errorIcon:function(){return this.useFontAwesome?'<i class="fa fa-close"></i>':' <i class="material-icons">error</i>'}},mounted:function(){if(!this.$isServer){var e=i(5);e.autoDiscover=!1,this.confirm&&(e.confirm=this.getProp(this.confirm,this.dropzoneOptions.confirm));var t=document.getElementById(this.id);this.dropzone=new e(t,{clickable:this.getProp(this.clickable,this.dropzoneOptions.clickable),paramName:this.getProp(this.paramName,this.dropzoneOptions.paramName),thumbnailWidth:this.getProp(this.thumbnailWidth,this.dropzoneOptions.thumbnailWidth),thumbnailHeight:this.getProp(this.thumbnailHeight,this.dropzoneOptions.thumbnailHeight),maxFiles:this.getProp(this.maxNumberOfFiles,this.dropzoneOptions.maxNumberOfFiles),maxFilesize:this.getProp(this.maxFileSizeInMB,this.dropzoneOptions.maxFileSizeInMB),addRemoveLinks:this.getProp(this.showRemoveLink,this.dropzoneOptions.showRemoveLink),acceptedFiles:this.getProp(this.acceptedFileTypes,this.dropzoneOptions.acceptedFileTypes),autoProcessQueue:this.getProp(this.autoProcessQueue,this.dropzoneOptions.autoProcessQueue),headers:this.getProp(this.headers,this.dropzoneOptions.headers),previewTemplate:this.previewTemplate(this),dictDefaultMessage:this.cloudIcon+this.languageSettings.dictDefaultMessage,dictCancelUpload:this.languageSettings.dictCancelUpload,dictCancelUploadConfirmation:this.languageSettings.dictCancelUploadConfirmation,dictFallbackMessage:this.languageSettings.dictFallbackMessage,dictFallbackText:this.languageSettings.dictFallbackText,dictFileTooBig:this.languageSettings.dictFileTooBig,dictInvalidFileType:this.languageSettings.dictInvalidFileType,dictMaxFilesExceeded:this.languageSettings.dictMaxFilesExceeded,dictRemoveFile:this.languageSettings.dictRemoveFile,dictRemoveFileConfirmation:this.languageSettings.dictRemoveFileConfirmation,dictResponseError:this.languageSettings.dictResponseError,resizeWidth:this.getProp(this.resizeWidth,this.dropzoneOptions.resizeWidth),resizeHeight:this.getProp(this.resizeHeight,this.dropzoneOptions.resizeHeight),resizeMimeType:this.getProp(this.resizeMimeType,this.dropzoneOptions.resizeMimeType),resizeQuality:this.getProp(this.resizeQuality,this.dropzoneOptions.resizeQuality),resizeMethod:this.getProp(this.resizeMethod,this.dropzoneOptions.resizeMethod),uploadMultiple:this.getProp(this.uploadMultiple,this.dropzoneOptions.uploadMultiple),parallelUploads:this.getProp(this.parallelUploads,this.dropzoneOptions.parallelUploads),timeout:this.getProp(this.timeout,this.dropzoneOptions.timeout),method:this.getProp(this.method,this.dropzoneOptions.method),capture:this.getProp(this.capture,this.dropzoneOptions.capture),hiddenInputContainer:this.getProp(this.hiddenInputContainer,this.dropzoneOptions.hiddenInputContainer),withCredentials:this.getProp(this.withCredentials,this.dropzoneOptions.withCredentials)});var n=this;this.dropzone.on("thumbnail",function(e,t){n.$emit("vdropzone-thumbnail",e,t)}),this.dropzone.on("addedfile",function(e){if(n.duplicateCheck&&this.files.length){var t,i;for(t=0,i=this.files.length;t<i-1;t++)this.files[t].name===e.name&&(this.removeFile(e),n.$emit("duplicate-file",e))}n.$emit("vdropzone-file-added",e)}),this.dropzone.on("addedfiles",function(e){n.$emit("vdropzone-files-added",e)}),this.dropzone.on("removedfile",function(e){n.$emit("vdropzone-removed-file",e)}),this.dropzone.on("success",function(e,t){n.$emit("vdropzone-success",e,t)}),this.dropzone.on("successmultiple",function(e,t){n.$emit("vdropzone-success-multiple",e,t)}),this.dropzone.on("error",function(e,t,i){n.$emit("vdropzone-error",e,t,i)}),this.dropzone.on("sending",function(e,t,i){n.$emit("vdropzone-sending",e,t,i)}),this.dropzone.on("sendingmultiple",function(e,t,i){n.$emit("vdropzone-sending-multiple",e,t,i)}),this.dropzone.on("queuecomplete",function(e,t,i){n.$emit("vdropzone-queue-complete",e,t,i)}),this.dropzone.on("totaluploadprogress",function(e,t,i){n.$emit("vdropzone-total-upload-progress",e,t,i)}),n.$emit("vdropzone-mounted")}},beforeDestroy:function(){this.dropzone.destroy()}}},function(e,t,i){t=e.exports=i(1)(),t.push([e.id,'@-webkit-keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%,70%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(-40px);transform:translateY(-40px)}}@keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%,70%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(-40px);transform:translateY(-40px)}}@-webkit-keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);transform:scale(1)}}.dropzone,.dropzone *{box-sizing:border-box}.dropzone{min-height:150px;border:2px solid rgba(0,0,0,.3);background:#fff;padding:20px}.dropzone.dz-clickable{cursor:pointer}.dropzone.dz-clickable *{cursor:default}.dropzone.dz-clickable .dz-message,.dropzone.dz-clickable .dz-message *{cursor:pointer}.dropzone.dz-started .dz-message{display:none}.dropzone.dz-drag-hover{border-style:solid}.dropzone.dz-drag-hover .dz-message{opacity:.5}.dropzone .dz-message{text-align:center;margin:2em 0}.dropzone .dz-preview{position:relative;display:inline-block;vertical-align:top;margin:16px;min-height:100px}.dropzone .dz-preview:hover{z-index:1000}.dropzone .dz-preview.dz-file-preview .dz-image{border-radius:20px;background:#999;background:linear-gradient(180deg,#eee,#ddd)}.dropzone .dz-preview.dz-file-preview .dz-details{opacity:1}.dropzone .dz-preview.dz-image-preview{background:#fff}.dropzone .dz-preview.dz-image-preview .dz-details{transition:opacity .2s linear}.dropzone .dz-preview .dz-remove{font-size:14px;text-align:center;display:block;cursor:pointer;border:none}.dropzone .dz-preview .dz-remove:hover{text-decoration:underline}.dropzone .dz-preview:hover .dz-details{opacity:1}.dropzone .dz-preview .dz-details{z-index:20;position:absolute;top:0;left:0;opacity:0;font-size:13px;min-width:100%;max-width:100%;padding:2em 1em;text-align:center;color:rgba(0,0,0,.9);line-height:150%}.dropzone .dz-preview .dz-details .dz-size{margin-bottom:1em;font-size:16px}.dropzone .dz-preview .dz-details .dz-filename{white-space:nowrap}.dropzone .dz-preview .dz-details .dz-filename:hover span{border:1px solid hsla(0,0%,78%,.8);background-color:hsla(0,0%,100%,.8)}.dropzone .dz-preview .dz-details .dz-filename:not(:hover){overflow:hidden;text-overflow:ellipsis}.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:1px solid transparent}.dropzone .dz-preview .dz-details .dz-filename span,.dropzone .dz-preview .dz-details .dz-size span{background-color:hsla(0,0%,100%,.4);padding:0 .4em;border-radius:3px}.dropzone .dz-preview:hover .dz-image img{-webkit-transform:scale(1.05);transform:scale(1.05);-webkit-filter:blur(8px);filter:blur(8px)}.dropzone .dz-preview .dz-image{border-radius:20px;overflow:hidden;width:120px;height:120px;position:relative;display:block;z-index:10}.dropzone .dz-preview .dz-image img{display:block}.dropzone .dz-preview.dz-success .dz-success-mark{-webkit-animation:passing-through 3s cubic-bezier(.77,0,.175,1);animation:passing-through 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview.dz-error .dz-error-mark{opacity:1;-webkit-animation:slide-in 3s cubic-bezier(.77,0,.175,1);animation:slide-in 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-success-mark{pointer-events:none;opacity:0;z-index:500;position:absolute;display:block;top:50%;left:50%;margin-left:-27px;margin-top:-27px}.dropzone .dz-preview .dz-error-mark svg,.dropzone .dz-preview .dz-success-mark svg{display:block;width:54px;height:54px}.dropzone .dz-preview.dz-processing .dz-progress{opacity:1;transition:all .2s linear}.dropzone .dz-preview.dz-complete .dz-progress{opacity:0;transition:opacity .4s ease-in}.dropzone .dz-preview:not(.dz-processing) .dz-progress{-webkit-animation:pulse 6s ease infinite;animation:pulse 6s ease infinite}.dropzone .dz-preview .dz-progress{opacity:1;z-index:1000;pointer-events:none;position:absolute;height:16px;left:50%;top:50%;margin-top:-8px;width:80px;margin-left:-40px;background:hsla(0,0%,100%,.9);-webkit-transform:scale(1);border-radius:8px;overflow:hidden}.dropzone .dz-preview .dz-progress .dz-upload{background:#333;background:linear-gradient(180deg,#666,#444);position:absolute;top:0;left:0;bottom:0;width:0;transition:width .3s ease-in-out}.dropzone .dz-preview.dz-error .dz-error-message{display:block}.dropzone .dz-preview.dz-error:hover .dz-error-message{opacity:1;pointer-events:auto}.dropzone .dz-preview .dz-error-message{pointer-events:none;z-index:1000;position:absolute;display:block;display:none;opacity:0;transition:opacity .3s ease;border-radius:8px;font-size:13px;top:130px;left:-10px;width:140px;background:#be2626;background:linear-gradient(180deg,#be2626,#a92222);padding:.5em 1.2em;color:#fff}.dropzone .dz-preview .dz-error-message:after{content:"";position:absolute;top:-6px;left:64px;width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #be2626}',""])},function(e,t,i){t=e.exports=i(1)(),t.i(i(3),""),t.push([e.id,".vue-dropzone{border:2px solid #e5e5e5;font-family:Arial,sans-serif;letter-spacing:.2px;color:#777;transition:background-color .2s linear}.vue-dropzone:hover{background-color:#f6f6f6}.vue-dropzone i{color:#ccc}.vue-dropzone .dz-preview .dz-image{border-radius:0}.vue-dropzone .dz-preview .dz-image:hover img{-webkit-transform:none;transform:none;-webkit-filter:none}.vue-dropzone .dz-preview .dz-details{bottom:0;top:0;color:#fff;background-color:rgba(33,150,243,.8);transition:opacity .2s linear;text-align:left}.vue-dropzone .dz-preview .dz-details .dz-filename span,.vue-dropzone .dz-preview .dz-details .dz-size span{background-color:transparent}.vue-dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:none}.vue-dropzone .dz-preview .dz-details .dz-filename:hover span{background-color:transparent;border:none}.vue-dropzone .dz-preview .dz-progress .dz-upload{background:#ccc}.vue-dropzone .dz-preview .dz-remove{position:absolute;z-index:30;color:#fff;margin-left:15px;padding:10px;top:inherit;bottom:15px;border:2px solid #fff;text-decoration:none;text-transform:uppercase;font-size:.8rem;font-weight:800;letter-spacing:1.1px;opacity:0}.vue-dropzone .dz-preview:hover .dz-remove{opacity:1}.vue-dropzone .dz-preview .dz-error-mark,.vue-dropzone .dz-preview .dz-success-mark{margin-left:auto!important;margin-top:auto!important;width:100%!important;top:35%!important;left:0}.vue-dropzone .dz-preview .dz-error-mark i,.vue-dropzone .dz-preview .dz-success-mark i{color:#fff!important;font-size:5rem!important}.vue-dropzone .dz-preview .dz-error-message{top:75%;left:15%}",""])},function(e,t,i){(function(e){(function(){var t,i,n,o,r,s,a,l,d,p=[].slice,u=function(e,t){function i(){this.constructor=e}for(var n in t)c.call(t,n)&&(e[n]=t[n]);return i.prototype=t.prototype,e.prototype=new i,e.__super__=t.prototype,e},c={}.hasOwnProperty;l=function(){},i=function(){function e(){}return e.prototype.addEventListener=e.prototype.on,e.prototype.on=function(e,t){return this._callbacks=this._callbacks||{},this._callbacks[e]||(this._callbacks[e]=[]),this._callbacks[e].push(t),this},e.prototype.emit=function(){var e,t,i,n,o,r;if(n=arguments[0],e=2<=arguments.length?p.call(arguments,1):[],this._callbacks=this._callbacks||{},i=this._callbacks[n])for(o=0,r=i.length;o<r;o++)t=i[o],t.apply(this,e);return this},e.prototype.removeListener=e.prototype.off,e.prototype.removeAllListeners=e.prototype.off,e.prototype.removeEventListener=e.prototype.off,e.prototype.off=function(e,t){var i,n,o,r,s;if(!this._callbacks||0===arguments.length)return this._callbacks={},this;if(n=this._callbacks[e],!n)return this;if(1===arguments.length)return delete this._callbacks[e],this;for(o=r=0,s=n.length;r<s;o=++r)if(i=n[o],i===t){n.splice(o,1);break}return this},e}(),t=function(e){function t(e,i){var n,r,s;if(this.element=e,this.version=t.version,this.defaultOptions.previewTemplate=this.defaultOptions.previewTemplate.replace(/\n*/g,""),this.clickableElements=[],this.listeners=[],this.files=[],"string"==typeof this.element&&(this.element=document.querySelector(this.element)),!this.element||null==this.element.nodeType)throw new Error("Invalid dropzone element.");if(this.element.dropzone)throw new Error("Dropzone already attached.");if(t.instances.push(this),this.element.dropzone=this,n=null!=(s=t.optionsForElement(this.element))?s:{},this.options=o({},this.defaultOptions,n,null!=i?i:{}),this.options.forceFallback||!t.isBrowserSupported())return this.options.fallback.call(this);if(null==this.options.url&&(this.options.url=this.element.getAttribute("action")),!this.options.url)throw new Error("No URL provided.");if(this.options.acceptedFiles&&this.options.acceptedMimeTypes)throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");this.options.acceptedMimeTypes&&(this.options.acceptedFiles=this.options.acceptedMimeTypes,delete this.options.acceptedMimeTypes),null!=this.options.renameFilename&&(this.options.renameFile=function(e){return function(t){return e.options.renameFilename.call(e,t.name,t)}}(this)),this.options.method=this.options.method.toUpperCase(),(r=this.getExistingFallback())&&r.parentNode&&r.parentNode.removeChild(r),this.options.previewsContainer!==!1&&(this.options.previewsContainer?this.previewsContainer=t.getElement(this.options.previewsContainer,"previewsContainer"):this.previewsContainer=this.element),this.options.clickable&&(this.options.clickable===!0?this.clickableElements=[this.element]:this.clickableElements=t.getElements(this.options.clickable,"clickable")),this.init()}var o,r;return u(t,e),t.prototype.Emitter=i,t.prototype.events=["drop","dragstart","dragend","dragenter","dragover","dragleave","addedfile","addedfiles","removedfile","thumbnail","error","errormultiple","processing","processingmultiple","uploadprogress","totaluploadprogress","sending","sendingmultiple","success","successmultiple","canceled","canceledmultiple","complete","completemultiple","reset","maxfilesexceeded","maxfilesreached","queuecomplete"],t.prototype.defaultOptions={url:null,method:"post",withCredentials:!1,timeout:3e4,parallelUploads:2,uploadMultiple:!1,maxFilesize:256,paramName:"file",createImageThumbnails:!0,maxThumbnailFilesize:10,thumbnailWidth:120,thumbnailHeight:120,thumbnailMethod:"crop",resizeWidth:null,resizeHeight:null,resizeMimeType:null,resizeQuality:.8,resizeMethod:"contain",filesizeBase:1e3,maxFiles:null,params:{},headers:null,clickable:!0,ignoreHiddenFiles:!0,acceptedFiles:null,acceptedMimeTypes:null,autoProcessQueue:!0,autoQueue:!0,addRemoveLinks:!1,previewsContainer:null,hiddenInputContainer:"body",capture:null,renameFilename:null,renameFile:null,forceFallback:!1,dictDefaultMessage:"Drop files here to upload",dictFallbackMessage:"Your browser does not support drag'n'drop file uploads.",dictFallbackText:"Please use the fallback form below to upload your files like in the olden days.",dictFileTooBig:"File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",dictInvalidFileType:"You can't upload files of this type.",dictResponseError:"Server responded with {{statusCode}} code.",dictCancelUpload:"Cancel upload",dictCancelUploadConfirmation:"Are you sure you want to cancel this upload?",dictRemoveFile:"Remove file",dictRemoveFileConfirmation:null,dictMaxFilesExceeded:"You can not upload any more files.",dictFileSizeUnits:{tb:"TB",gb:"GB",mb:"MB",kb:"KB",b:"b"},init:function(){return l},accept:function(e,t){return t()},fallback:function(){var e,i,n,o,r,s;for(this.element.className=this.element.className+" dz-browser-not-supported",r=this.element.getElementsByTagName("div"),i=0,n=r.length;i<n;i++)e=r[i],/(^| )dz-message($| )/.test(e.className)&&(o=e,e.className="dz-message");return o||(o=t.createElement('<div class="dz-message"><span></span></div>'),this.element.appendChild(o)),s=o.getElementsByTagName("span")[0],s&&(null!=s.textContent?s.textContent=this.options.dictFallbackMessage:null!=s.innerText&&(s.innerText=this.options.dictFallbackMessage)),this.element.appendChild(this.getFallbackForm())},resize:function(e,t,i,n){var o,r,s;if(o={srcX:0,srcY:0,srcWidth:e.width,srcHeight:e.height},r=e.width/e.height,null==t&&null==i?(t=o.srcWidth,i=o.srcHeight):null==t?t=i*r:null==i&&(i=t/r),t=Math.min(t,o.srcWidth),i=Math.min(i,o.srcHeight),s=t/i,o.srcWidth>t||o.srcHeight>i)if("crop"===n)r>s?(o.srcHeight=e.height,o.srcWidth=o.srcHeight*s):(o.srcWidth=e.width,o.srcHeight=o.srcWidth/s);else{if("contain"!==n)throw new Error("Unknown resizeMethod '"+n+"'");r>s?i=t/r:t=i*r}return o.srcX=(e.width-o.srcWidth)/2,o.srcY=(e.height-o.srcHeight)/2,o.trgWidth=t,o.trgHeight=i,o},transformFile:function(e,t){return(this.options.resizeWidth||this.options.resizeHeight)&&e.type.match(/image.*/)?this.resizeImage(e,this.options.resizeWidth,this.options.resizeHeight,this.options.resizeMethod,t):t(e)},previewTemplate:'<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail /></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size></span></div>\n    <div class="dz-filename"><span data-dz-name></span></div>\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-error-message"><span data-dz-errormessage></span></div>\n  <div class="dz-success-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Check</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>\n      </g>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Error</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">\n          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>',drop:function(e){return this.element.classList.remove("dz-drag-hover")},dragstart:l,dragend:function(e){return this.element.classList.remove("dz-drag-hover")},dragenter:function(e){return this.element.classList.add("dz-drag-hover")},dragover:function(e){return this.element.classList.add("dz-drag-hover")},dragleave:function(e){return this.element.classList.remove("dz-drag-hover")},paste:l,reset:function(){return this.element.classList.remove("dz-started")},addedfile:function(e){var i,n,o,r,s,a,l,d,p,u,c,h,f;if(this.element===this.previewsContainer&&this.element.classList.add("dz-started"),this.previewsContainer){for(e.previewElement=t.createElement(this.options.previewTemplate.trim()),e.previewTemplate=e.previewElement,this.previewsContainer.appendChild(e.previewElement),d=e.previewElement.querySelectorAll("[data-dz-name]"),i=0,r=d.length;i<r;i++)l=d[i],l.textContent=e.name;for(p=e.previewElement.querySelectorAll("[data-dz-size]"),n=0,s=p.length;n<s;n++)l=p[n],l.innerHTML=this.filesize(e.size);for(this.options.addRemoveLinks&&(e._removeLink=t.createElement('<a class="dz-remove" href="javascript:undefined;" data-dz-remove>'+this.options.dictRemoveFile+"</a>"),e.previewElement.appendChild(e._removeLink)),c=function(i){return function(n){return n.preventDefault(),n.stopPropagation(),e.status===t.UPLOADING?t.confirm(i.options.dictCancelUploadConfirmation,function(){return i.removeFile(e)}):i.options.dictRemoveFileConfirmation?t.confirm(i.options.dictRemoveFileConfirmation,function(){return i.removeFile(e)}):i.removeFile(e)}}(this),u=e.previewElement.querySelectorAll("[data-dz-remove]"),f=[],o=0,a=u.length;o<a;o++)h=u[o],f.push(h.addEventListener("click",c));return f}},removedfile:function(e){var t;return e.previewElement&&null!=(t=e.previewElement)&&t.parentNode.removeChild(e.previewElement),this._updateMaxFilesReachedClass()},thumbnail:function(e,t){var i,n,o,r;if(e.previewElement){for(e.previewElement.classList.remove("dz-file-preview"),o=e.previewElement.querySelectorAll("[data-dz-thumbnail]"),i=0,n=o.length;i<n;i++)r=o[i],r.alt=e.name,r.src=t;return setTimeout(function(t){return function(){return e.previewElement.classList.add("dz-image-preview")}}(this),1)}},error:function(e,t){var i,n,o,r,s;if(e.previewElement){for(e.previewElement.classList.add("dz-error"),"String"!=typeof t&&t.error&&(t=t.error),r=e.previewElement.querySelectorAll("[data-dz-errormessage]"),s=[],i=0,n=r.length;i<n;i++)o=r[i],s.push(o.textContent=t);return s}},errormultiple:l,processing:function(e){if(e.previewElement&&(e.previewElement.classList.add("dz-processing"),e._removeLink))return e._removeLink.textContent=this.options.dictCancelUpload},processingmultiple:l,uploadprogress:function(e,t,i){var n,o,r,s,a;if(e.previewElement){for(s=e.previewElement.querySelectorAll("[data-dz-uploadprogress]"),a=[],n=0,o=s.length;n<o;n++)r=s[n],"PROGRESS"===r.nodeName?a.push(r.value=t):a.push(r.style.width=t+"%");return a}},totaluploadprogress:l,sending:l,sendingmultiple:l,success:function(e){if(e.previewElement)return e.previewElement.classList.add("dz-success")},successmultiple:l,canceled:function(e){return this.emit("error",e,"Upload canceled.")},canceledmultiple:l,complete:function(e){if(e._removeLink&&(e._removeLink.textContent=this.options.dictRemoveFile),e.previewElement)return e.previewElement.classList.add("dz-complete")},completemultiple:l,maxfilesexceeded:l,maxfilesreached:l,queuecomplete:l,addedfiles:l},o=function(){var e,t,i,n,o,r,s;for(r=arguments[0],o=2<=arguments.length?p.call(arguments,1):[],e=0,i=o.length;e<i;e++){n=o[e];for(t in n)s=n[t],r[t]=s}return r},t.prototype.getAcceptedFiles=function(){var e,t,i,n,o;for(n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],e.accepted&&o.push(e);return o},t.prototype.getRejectedFiles=function(){var e,t,i,n,o;for(n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],e.accepted||o.push(e);return o},t.prototype.getFilesWithStatus=function(e){var t,i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)t=o[i],t.status===e&&r.push(t);return r},t.prototype.getQueuedFiles=function(){return this.getFilesWithStatus(t.QUEUED)},t.prototype.getUploadingFiles=function(){return this.getFilesWithStatus(t.UPLOADING)},t.prototype.getAddedFiles=function(){return this.getFilesWithStatus(t.ADDED)},t.prototype.getActiveFiles=function(){var e,i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)e=o[i],e.status!==t.UPLOADING&&e.status!==t.QUEUED||r.push(e);return r},t.prototype.init=function(){var e,i,n,o,r,s,a;for("form"===this.element.tagName&&this.element.setAttribute("enctype","multipart/form-data"),this.element.classList.contains("dropzone")&&!this.element.querySelector(".dz-message")&&this.element.appendChild(t.createElement('<div class="dz-default dz-message"><span>'+this.options.dictDefaultMessage+"</span></div>")),this.clickableElements.length&&(a=function(e){return function(){return e.hiddenFileInput&&e.hiddenFileInput.parentNode.removeChild(e.hiddenFileInput),e.hiddenFileInput=document.createElement("input"),e.hiddenFileInput.setAttribute("type","file"),(null==e.options.maxFiles||e.options.maxFiles>1)&&e.hiddenFileInput.setAttribute("multiple","multiple"),e.hiddenFileInput.className="dz-hidden-input",null!=e.options.acceptedFiles&&e.hiddenFileInput.setAttribute("accept",e.options.acceptedFiles),null!=e.options.capture&&e.hiddenFileInput.setAttribute("capture",e.options.capture),
	e.hiddenFileInput.style.visibility="hidden",e.hiddenFileInput.style.position="absolute",e.hiddenFileInput.style.top="0",e.hiddenFileInput.style.left="0",e.hiddenFileInput.style.height="0",e.hiddenFileInput.style.width="0",document.querySelector(e.options.hiddenInputContainer).appendChild(e.hiddenFileInput),e.hiddenFileInput.addEventListener("change",function(){var t,i,n,o;if(i=e.hiddenFileInput.files,i.length)for(n=0,o=i.length;n<o;n++)t=i[n],e.addFile(t);return e.emit("addedfiles",i),a()})}}(this))(),this.URL=null!=(r=window.URL)?r:window.webkitURL,s=this.events,i=0,n=s.length;i<n;i++)e=s[i],this.on(e,this.options[e]);return this.on("uploadprogress",function(e){return function(){return e.updateTotalUploadProgress()}}(this)),this.on("removedfile",function(e){return function(){return e.updateTotalUploadProgress()}}(this)),this.on("canceled",function(e){return function(t){return e.emit("complete",t)}}(this)),this.on("complete",function(e){return function(t){if(0===e.getAddedFiles().length&&0===e.getUploadingFiles().length&&0===e.getQueuedFiles().length)return setTimeout(function(){return e.emit("queuecomplete")},0)}}(this)),o=function(e){return e.stopPropagation(),e.preventDefault?e.preventDefault():e.returnValue=!1},this.listeners=[{element:this.element,events:{dragstart:function(e){return function(t){return e.emit("dragstart",t)}}(this),dragenter:function(e){return function(t){return o(t),e.emit("dragenter",t)}}(this),dragover:function(e){return function(t){var i;try{i=t.dataTransfer.effectAllowed}catch(e){}return t.dataTransfer.dropEffect="move"===i||"linkMove"===i?"move":"copy",o(t),e.emit("dragover",t)}}(this),dragleave:function(e){return function(t){return e.emit("dragleave",t)}}(this),drop:function(e){return function(t){return o(t),e.drop(t)}}(this),dragend:function(e){return function(t){return e.emit("dragend",t)}}(this)}}],this.clickableElements.forEach(function(e){return function(i){return e.listeners.push({element:i,events:{click:function(n){return(i!==e.element||n.target===e.element||t.elementInside(n.target,e.element.querySelector(".dz-message")))&&e.hiddenFileInput.click(),!0}}})}}(this)),this.enable(),this.options.init.call(this)},t.prototype.destroy=function(){var e;return this.disable(),this.removeAllFiles(!0),(null!=(e=this.hiddenFileInput)?e.parentNode:void 0)&&(this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput),this.hiddenFileInput=null),delete this.element.dropzone,t.instances.splice(t.instances.indexOf(this),1)},t.prototype.updateTotalUploadProgress=function(){var e,t,i,n,o,r,s,a;if(s=0,r=0,e=this.getActiveFiles(),e.length){for(o=this.getActiveFiles(),i=0,n=o.length;i<n;i++)t=o[i],s+=t.upload.bytesSent,r+=t.upload.total;a=100*s/r}else a=100;return this.emit("totaluploadprogress",a,r,s)},t.prototype._getParamName=function(e){return"function"==typeof this.options.paramName?this.options.paramName(e):""+this.options.paramName+(this.options.uploadMultiple?"["+e+"]":"")},t.prototype._renameFile=function(e){return"function"!=typeof this.options.renameFile?e.name:this.options.renameFile(e)},t.prototype.getFallbackForm=function(){var e,i,n,o;return(e=this.getExistingFallback())?e:(n='<div class="dz-fallback">',this.options.dictFallbackText&&(n+="<p>"+this.options.dictFallbackText+"</p>"),n+='<input type="file" name="'+this._getParamName(0)+'" '+(this.options.uploadMultiple?'multiple="multiple"':void 0)+' /><input type="submit" value="Upload!"></div>',i=t.createElement(n),"FORM"!==this.element.tagName?(o=t.createElement('<form action="'+this.options.url+'" enctype="multipart/form-data" method="'+this.options.method+'"></form>'),o.appendChild(i)):(this.element.setAttribute("enctype","multipart/form-data"),this.element.setAttribute("method",this.options.method)),null!=o?o:i)},t.prototype.getExistingFallback=function(){var e,t,i,n,o,r;for(t=function(e){var t,i,n;for(i=0,n=e.length;i<n;i++)if(t=e[i],/(^| )fallback($| )/.test(t.className))return t},o=["div","form"],i=0,n=o.length;i<n;i++)if(r=o[i],e=t(this.element.getElementsByTagName(r)))return e},t.prototype.setupEventListeners=function(){var e,t,i,n,o,r,s;for(r=this.listeners,s=[],i=0,n=r.length;i<n;i++)e=r[i],s.push(function(){var i,n;i=e.events,n=[];for(t in i)o=i[t],n.push(e.element.addEventListener(t,o,!1));return n}());return s},t.prototype.removeEventListeners=function(){var e,t,i,n,o,r,s;for(r=this.listeners,s=[],i=0,n=r.length;i<n;i++)e=r[i],s.push(function(){var i,n;i=e.events,n=[];for(t in i)o=i[t],n.push(e.element.removeEventListener(t,o,!1));return n}());return s},t.prototype.disable=function(){var e,t,i,n,o;for(this.clickableElements.forEach(function(e){return e.classList.remove("dz-clickable")}),this.removeEventListeners(),n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],o.push(this.cancelUpload(e));return o},t.prototype.enable=function(){return this.clickableElements.forEach(function(e){return e.classList.add("dz-clickable")}),this.setupEventListeners()},t.prototype.filesize=function(e){var t,i,n,o,r,s,a,l;if(r=0,s="b",e>0){for(l=["tb","gb","mb","kb","b"],i=n=0,o=l.length;n<o;i=++n)if(a=l[i],t=Math.pow(this.options.filesizeBase,4-i)/10,e>=t){r=e/Math.pow(this.options.filesizeBase,4-i),s=a;break}r=Math.round(10*r)/10}return"<strong>"+r+"</strong> "+this.options.dictFileSizeUnits[s]},t.prototype._updateMaxFilesReachedClass=function(){return null!=this.options.maxFiles&&this.getAcceptedFiles().length>=this.options.maxFiles?(this.getAcceptedFiles().length===this.options.maxFiles&&this.emit("maxfilesreached",this.files),this.element.classList.add("dz-max-files-reached")):this.element.classList.remove("dz-max-files-reached")},t.prototype.drop=function(e){var t,i;e.dataTransfer&&(this.emit("drop",e),t=e.dataTransfer.files,this.emit("addedfiles",t),t.length&&(i=e.dataTransfer.items,i&&i.length&&null!=i[0].webkitGetAsEntry?this._addFilesFromItems(i):this.handleFiles(t)))},t.prototype.paste=function(e){var t,i;if(null!=(null!=e&&null!=(i=e.clipboardData)?i.items:void 0))return this.emit("paste",e),t=e.clipboardData.items,t.length?this._addFilesFromItems(t):void 0},t.prototype.handleFiles=function(e){var t,i,n,o;for(o=[],i=0,n=e.length;i<n;i++)t=e[i],o.push(this.addFile(t));return o},t.prototype._addFilesFromItems=function(e){var t,i,n,o,r;for(r=[],n=0,o=e.length;n<o;n++)i=e[n],null!=i.webkitGetAsEntry&&(t=i.webkitGetAsEntry())?t.isFile?r.push(this.addFile(i.getAsFile())):t.isDirectory?r.push(this._addFilesFromDirectory(t,t.name)):r.push(void 0):null!=i.getAsFile&&(null==i.kind||"file"===i.kind)?r.push(this.addFile(i.getAsFile())):r.push(void 0);return r},t.prototype._addFilesFromDirectory=function(e,t){var i,n,o;return i=e.createReader(),n=function(e){return"undefined"!=typeof console&&null!==console&&"function"==typeof console.log?console.log(e):void 0},(o=function(e){return function(){return i.readEntries(function(i){var n,r,s;if(i.length>0){for(r=0,s=i.length;r<s;r++)n=i[r],n.isFile?n.file(function(i){if(!e.options.ignoreHiddenFiles||"."!==i.name.substring(0,1))return i.fullPath=t+"/"+i.name,e.addFile(i)}):n.isDirectory&&e._addFilesFromDirectory(n,t+"/"+n.name);o()}return null},n)}}(this))()},t.prototype.accept=function(e,i){return e.size>1024*this.options.maxFilesize*1024?i(this.options.dictFileTooBig.replace("{{filesize}}",Math.round(e.size/1024/10.24)/100).replace("{{maxFilesize}}",this.options.maxFilesize)):t.isValidFile(e,this.options.acceptedFiles)?null!=this.options.maxFiles&&this.getAcceptedFiles().length>=this.options.maxFiles?(i(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}",this.options.maxFiles)),this.emit("maxfilesexceeded",e)):this.options.accept.call(this,e,i):i(this.options.dictInvalidFileType)},t.prototype.addFile=function(e){return e.upload={progress:0,total:e.size,bytesSent:0,filename:this._renameFile(e)},this.files.push(e),e.status=t.ADDED,this.emit("addedfile",e),this._enqueueThumbnail(e),this.accept(e,function(t){return function(i){return i?(e.accepted=!1,t._errorProcessing([e],i)):(e.accepted=!0,t.options.autoQueue&&t.enqueueFile(e)),t._updateMaxFilesReachedClass()}}(this))},t.prototype.enqueueFiles=function(e){var t,i,n;for(i=0,n=e.length;i<n;i++)t=e[i],this.enqueueFile(t);return null},t.prototype.enqueueFile=function(e){if(e.status!==t.ADDED||e.accepted!==!0)throw new Error("This file can't be queued because it has already been processed or was rejected.");if(e.status=t.QUEUED,this.options.autoProcessQueue)return setTimeout(function(e){return function(){return e.processQueue()}}(this),0)},t.prototype._thumbnailQueue=[],t.prototype._processingThumbnail=!1,t.prototype._enqueueThumbnail=function(e){if(this.options.createImageThumbnails&&e.type.match(/image.*/)&&e.size<=1024*this.options.maxThumbnailFilesize*1024)return this._thumbnailQueue.push(e),setTimeout(function(e){return function(){return e._processThumbnailQueue()}}(this),0)},t.prototype._processThumbnailQueue=function(){var e;if(!this._processingThumbnail&&0!==this._thumbnailQueue.length)return this._processingThumbnail=!0,e=this._thumbnailQueue.shift(),this.createThumbnail(e,this.options.thumbnailWidth,this.options.thumbnailHeight,this.options.thumbnailMethod,!0,function(t){return function(i){return t.emit("thumbnail",e,i),t._processingThumbnail=!1,t._processThumbnailQueue()}}(this))},t.prototype.removeFile=function(e){if(e.status===t.UPLOADING&&this.cancelUpload(e),this.files=d(this.files,e),this.emit("removedfile",e),0===this.files.length)return this.emit("reset")},t.prototype.removeAllFiles=function(e){var i,n,o,r;for(null==e&&(e=!1),r=this.files.slice(),n=0,o=r.length;n<o;n++)i=r[n],(i.status!==t.UPLOADING||e)&&this.removeFile(i);return null},t.prototype.resizeImage=function(e,i,o,r,s){return this.createThumbnail(e,i,o,r,!1,function(i){return function(o,r){var a,l;return null===r?s(e):(a=i.options.resizeMimeType,null==a&&(a=e.type),l=r.toDataURL(a,i.options.resizeQuality),"image/jpeg"!==a&&"image/jpg"!==a||(l=n.restore(e.dataURL,l)),s(t.dataURItoBlob(l)))}}(this))},t.prototype.createThumbnail=function(e,t,i,n,o,r){var s;return s=new FileReader,s.onload=function(a){return function(){return e.dataURL=s.result,"image/svg+xml"===e.type?void(null!=r&&r(s.result)):a.createThumbnailFromUrl(e,t,i,n,o,r)}}(this),s.readAsDataURL(e)},t.prototype.createThumbnailFromUrl=function(e,t,i,n,o,r,s){var l;return l=document.createElement("img"),s&&(l.crossOrigin=s),l.onload=function(s){return function(){var d;return d=function(e){return e(1)},"undefined"!=typeof EXIF&&null!==EXIF&&o&&(d=function(e){return EXIF.getData(l,function(){return e(EXIF.getTag(this,"Orientation"))})}),d(function(o){var d,p,u,c,h,f,m,g;switch(e.width=l.width,e.height=l.height,m=s.options.resize.call(s,e,t,i,n),d=document.createElement("canvas"),p=d.getContext("2d"),d.width=m.trgWidth,d.height=m.trgHeight,o>4&&(d.width=m.trgHeight,d.height=m.trgWidth),o){case 2:p.translate(d.width,0),p.scale(-1,1);break;case 3:p.translate(d.width,d.height),p.rotate(Math.PI);break;case 4:p.translate(0,d.height),p.scale(1,-1);break;case 5:p.rotate(.5*Math.PI),p.scale(1,-1);break;case 6:p.rotate(.5*Math.PI),p.translate(0,-d.height);break;case 7:p.rotate(.5*Math.PI),p.translate(d.width,-d.height),p.scale(-1,1);break;case 8:p.rotate(-.5*Math.PI),p.translate(-d.width,0)}if(a(p,l,null!=(u=m.srcX)?u:0,null!=(c=m.srcY)?c:0,m.srcWidth,m.srcHeight,null!=(h=m.trgX)?h:0,null!=(f=m.trgY)?f:0,m.trgWidth,m.trgHeight),g=d.toDataURL("image/png"),null!=r)return r(g,d)})}}(this),null!=r&&(l.onerror=r),l.src=e.dataURL},t.prototype.processQueue=function(){var e,t,i,n;if(t=this.options.parallelUploads,i=this.getUploadingFiles().length,e=i,!(i>=t)&&(n=this.getQueuedFiles(),n.length>0)){if(this.options.uploadMultiple)return this.processFiles(n.slice(0,t-i));for(;e<t;){if(!n.length)return;this.processFile(n.shift()),e++}}},t.prototype.processFile=function(e){return this.processFiles([e])},t.prototype.processFiles=function(e){var i,n,o;for(n=0,o=e.length;n<o;n++)i=e[n],i.processing=!0,i.status=t.UPLOADING,this.emit("processing",i);return this.options.uploadMultiple&&this.emit("processingmultiple",e),this.uploadFiles(e)},t.prototype._getFilesWithXhr=function(e){var t,i;return i=function(){var i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)t=o[i],t.xhr===e&&r.push(t);return r}.call(this)},t.prototype.cancelUpload=function(e){var i,n,o,r,s,a,l;if(e.status===t.UPLOADING){for(n=this._getFilesWithXhr(e.xhr),o=0,s=n.length;o<s;o++)i=n[o],i.status=t.CANCELED;for(e.xhr.abort(),r=0,a=n.length;r<a;r++)i=n[r],this.emit("canceled",i);this.options.uploadMultiple&&this.emit("canceledmultiple",n)}else(l=e.status)!==t.ADDED&&l!==t.QUEUED||(e.status=t.CANCELED,this.emit("canceled",e),this.options.uploadMultiple&&this.emit("canceledmultiple",[e]));if(this.options.autoProcessQueue)return this.processQueue()},r=function(){var e,t;return t=arguments[0],e=2<=arguments.length?p.call(arguments,1):[],"function"==typeof t?t.apply(this,e):t},t.prototype.uploadFile=function(e){return this.uploadFiles([e])},t.prototype.uploadFiles=function(e){var i,n,s,a,l,d,p,u,c,h,f,m,g,v,z,b,y,w,F,x,k,E,C,T,S,M,A,L,I,O,U,N,P,R,D,_,B;for(B=new XMLHttpRequest,g=0,y=e.length;g<y;g++)s=e[g],s.xhr=B;E=r(this.options.method,e),D=r(this.options.url,e),B.open(E,D,!0),B.timeout=r(this.options.timeout,e),B.withCredentials=!!this.options.withCredentials,N=null,l=function(t){return function(){var i,n,o;for(o=[],i=0,n=e.length;i<n;i++)s=e[i],o.push(t._errorProcessing(e,N||t.options.dictResponseError.replace("{{statusCode}}",B.status),B));return o}}(this),R=function(t){return function(i){var n,o,r,a,l,d,p,u,c;if(null!=i)for(u=100*i.loaded/i.total,o=0,a=e.length;o<a;o++)s=e[o],s.upload.progress=u,s.upload.total=i.total,s.upload.bytesSent=i.loaded;else{for(n=!0,u=100,r=0,l=e.length;r<l;r++)s=e[r],100===s.upload.progress&&s.upload.bytesSent===s.upload.total||(n=!1),s.upload.progress=u,s.upload.bytesSent=s.upload.total;if(n)return}for(c=[],p=0,d=e.length;p<d;p++)s=e[p],c.push(t.emit("uploadprogress",s,u,s.upload.bytesSent));return c}}(this),B.onload=function(i){return function(n){var o;if(e[0].status!==t.CANCELED&&4===B.readyState){if("arraybuffer"!==B.responseType&&"blob"!==B.responseType&&(N=B.responseText,B.getResponseHeader("content-type")&&~B.getResponseHeader("content-type").indexOf("application/json")))try{N=JSON.parse(N)}catch(e){n=e,N="Invalid JSON response from server."}return R(),200<=(o=B.status)&&o<300?i._finished(e,N,n):l()}}}(this),B.onerror=function(i){return function(){if(e[0].status!==t.CANCELED)return l()}}(this),S=null!=(M=B.upload)?M:B,S.onprogress=R,u={Accept:"application/json","Cache-Control":"no-cache","X-Requested-With":"XMLHttpRequest"},this.options.headers&&o(u,this.options.headers);for(d in u)p=u[d],p&&B.setRequestHeader(d,p);if(a=new FormData,this.options.params){A=this.options.params;for(z in A)_=A[z],a.append(z,_)}for(v=0,w=e.length;v<w;v++)s=e[v],this.emit("sending",s,B,a);if(this.options.uploadMultiple&&this.emit("sendingmultiple",e,B,a),"FORM"===this.element.tagName)for(L=this.element.querySelectorAll("input, textarea, select, button"),b=0,F=L.length;b<F;b++)if(h=L[b],f=h.getAttribute("name"),m=h.getAttribute("type"),"SELECT"===h.tagName&&h.hasAttribute("multiple"))for(I=h.options,k=0,x=I.length;k<x;k++)T=I[k],T.selected&&a.append(f,T.value);else(!m||"checkbox"!==(O=m.toLowerCase())&&"radio"!==O||h.checked)&&a.append(f,h.value);for(i=0,P=[],c=C=0,U=e.length-1;0<=U?C<=U:C>=U;c=0<=U?++C:--C)n=function(t){return function(n,o,r){return function(n){if(a.append(o,n,r),++i===e.length)return t.submitRequest(B,a,e)}}}(this),P.push(this.options.transformFile.call(this,e[c],n(e[c],this._getParamName(c),e[c].upload.filename)));return P},t.prototype.submitRequest=function(e,t,i){return e.send(t)},t.prototype._finished=function(e,i,n){var o,r,s;for(r=0,s=e.length;r<s;r++)o=e[r],o.status=t.SUCCESS,this.emit("success",o,i,n),this.emit("complete",o);if(this.options.uploadMultiple&&(this.emit("successmultiple",e,i,n),this.emit("completemultiple",e)),this.options.autoProcessQueue)return this.processQueue()},t.prototype._errorProcessing=function(e,i,n){var o,r,s;for(r=0,s=e.length;r<s;r++)o=e[r],o.status=t.ERROR,this.emit("error",o,i,n),this.emit("complete",o);if(this.options.uploadMultiple&&(this.emit("errormultiple",e,i,n),this.emit("completemultiple",e)),this.options.autoProcessQueue)return this.processQueue()},t}(i),t.version="5.1.1",t.options={},t.optionsForElement=function(e){return e.getAttribute("id")?t.options[o(e.getAttribute("id"))]:void 0},t.instances=[],t.forElement=function(e){if("string"==typeof e&&(e=document.querySelector(e)),null==(null!=e?e.dropzone:void 0))throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");return e.dropzone},t.autoDiscover=!0,t.discover=function(){var e,i,n,o,r,s;for(document.querySelectorAll?n=document.querySelectorAll(".dropzone"):(n=[],e=function(e){var t,i,o,r;for(r=[],i=0,o=e.length;i<o;i++)t=e[i],/(^| )dropzone($| )/.test(t.className)?r.push(n.push(t)):r.push(void 0);return r},e(document.getElementsByTagName("div")),e(document.getElementsByTagName("form"))),s=[],o=0,r=n.length;o<r;o++)i=n[o],t.optionsForElement(i)!==!1?s.push(new t(i)):s.push(void 0);return s},t.blacklistedBrowsers=[/opera.*Macintosh.*version\/12/i],t.isBrowserSupported=function(){var e,i,n,o,r;if(e=!0,window.File&&window.FileReader&&window.FileList&&window.Blob&&window.FormData&&document.querySelector)if("classList"in document.createElement("a"))for(o=t.blacklistedBrowsers,i=0,n=o.length;i<n;i++)r=o[i],r.test(navigator.userAgent)&&(e=!1);else e=!1;else e=!1;return e},t.dataURItoBlob=function(e){var t,i,n,o,r,s,a;for(i=atob(e.split(",")[1]),s=e.split(",")[0].split(":")[1].split(";")[0],t=new ArrayBuffer(i.length),o=new Uint8Array(t),n=r=0,a=i.length;0<=a?r<=a:r>=a;n=0<=a?++r:--r)o[n]=i.charCodeAt(n);return new Blob([t],{type:s})},d=function(e,t){var i,n,o,r;for(r=[],n=0,o=e.length;n<o;n++)i=e[n],i!==t&&r.push(i);return r},o=function(e){return e.replace(/[\-_](\w)/g,function(e){return e.charAt(1).toUpperCase()})},t.createElement=function(e){var t;return t=document.createElement("div"),t.innerHTML=e,t.childNodes[0]},t.elementInside=function(e,t){if(e===t)return!0;for(;e=e.parentNode;)if(e===t)return!0;return!1},t.getElement=function(e,t){var i;if("string"==typeof e?i=document.querySelector(e):null!=e.nodeType&&(i=e),null==i)throw new Error("Invalid `"+t+"` option provided. Please provide a CSS selector or a plain HTML element.");return i},t.getElements=function(e,t){var i,n,o,r,s,a,l,d;if(e instanceof Array){o=[];try{for(r=0,a=e.length;r<a;r++)n=e[r],o.push(this.getElement(n,t))}catch(e){i=e,o=null}}else if("string"==typeof e)for(o=[],d=document.querySelectorAll(e),s=0,l=d.length;s<l;s++)n=d[s],o.push(n);else null!=e.nodeType&&(o=[e]);if(null==o||!o.length)throw new Error("Invalid `"+t+"` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");return o},t.confirm=function(e,t,i){return window.confirm(e)?t():null!=i?i():void 0},t.isValidFile=function(e,t){var i,n,o,r,s;if(!t)return!0;for(t=t.split(","),r=e.type,i=r.replace(/\/.*$/,""),n=0,o=t.length;n<o;n++)if(s=t[n],s=s.trim(),"."===s.charAt(0)){if(e.name.toLowerCase().indexOf(s.toLowerCase(),e.name.length-s.length)!==-1)return!0}else if(/\/\*$/.test(s)){if(i===s.replace(/\/.*$/,""))return!0}else if(r===s)return!0;return!1},"undefined"!=typeof jQuery&&null!==jQuery&&(jQuery.fn.dropzone=function(e){return this.each(function(){return new t(this,e)})}),"undefined"!=typeof e&&null!==e?e.exports=t:window.Dropzone=t,t.ADDED="added",t.QUEUED="queued",t.ACCEPTED=t.QUEUED,t.UPLOADING="uploading",t.PROCESSING=t.UPLOADING,t.CANCELED="canceled",t.ERROR="error",t.SUCCESS="success",s=function(e){var t,i,n,o,r,s,a,l,d,p;for(a=e.naturalWidth,s=e.naturalHeight,i=document.createElement("canvas"),i.width=1,i.height=s,n=i.getContext("2d"),n.drawImage(e,0,0),o=n.getImageData(1,0,1,s).data,p=0,r=s,l=s;l>p;)t=o[4*(l-1)+3],0===t?r=l:p=l,l=r+p>>1;return d=l/s,0===d?1:d},a=function(e,t,i,n,o,r,a,l,d,p){var u;return u=s(t),e.drawImage(t,i,n,o,r,a,l,d,p/u)},n=function(){function e(){}return e.KEY_STR="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",e.encode64=function(e){var t,i,n,o,r,s,a,l,d;for(d="",t=void 0,i=void 0,n="",o=void 0,r=void 0,s=void 0,a="",l=0;;)if(t=e[l++],i=e[l++],n=e[l++],o=t>>2,r=(3&t)<<4|i>>4,s=(15&i)<<2|n>>6,a=63&n,isNaN(i)?s=a=64:isNaN(n)&&(a=64),d=d+this.KEY_STR.charAt(o)+this.KEY_STR.charAt(r)+this.KEY_STR.charAt(s)+this.KEY_STR.charAt(a),t=i=n="",o=r=s=a="",!(l<e.length))break;return d},e.restore=function(e,t){var i,n,o;return e.match("data:image/jpeg;base64,")?(n=this.decode64(e.replace("data:image/jpeg;base64,","")),o=this.slice2Segments(n),i=this.exifManipulation(t,o),"data:image/jpeg;base64,"+this.encode64(i)):t},e.exifManipulation=function(e,t){var i,n,o;return n=this.getExifArray(t),o=this.insertExif(e,n),i=new Uint8Array(o)},e.getExifArray=function(e){var t,i;for(t=void 0,i=0;i<e.length;){if(t=e[i],255===t[0]&225===t[1])return t;i++}return[]},e.insertExif=function(e,t){var i,n,o,r,s,a;return r=e.replace("data:image/jpeg;base64,",""),o=this.decode64(r),a=o.indexOf(255,3),s=o.slice(0,a),n=o.slice(a),i=s,i=i.concat(t),i=i.concat(n)},e.slice2Segments=function(e){var t,i,n,o,r;for(i=0,r=[];;){if(255===e[i]&218===e[i+1])break;if(255===e[i]&216===e[i+1]?i+=2:(n=256*e[i+2]+e[i+3],t=i+n+2,o=e.slice(i,t),r.push(o),i=t),i>e.length)break}return r},e.decode64=function(e){var t,i,n,o,r,s,a,l,d,p,u;for(u="",n=void 0,o=void 0,r="",s=void 0,a=void 0,l=void 0,d="",p=0,i=[],t=/[^A-Za-z0-9\+\/\=]/g,t.exec(e)&&console.warning("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."),e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");;)if(s=this.KEY_STR.indexOf(e.charAt(p++)),a=this.KEY_STR.indexOf(e.charAt(p++)),l=this.KEY_STR.indexOf(e.charAt(p++)),d=this.KEY_STR.indexOf(e.charAt(p++)),n=s<<2|a>>4,o=(15&a)<<4|l>>2,r=(3&l)<<6|d,i.push(n),64!==l&&i.push(o),64!==d&&i.push(r),n=o=r="",s=a=l=d="",!(p<e.length))break;return i},e}(),r=function(e,t){var i,n,o,r,s,a,l,d,p;if(o=!1,p=!0,n=e.document,d=n.documentElement,i=n.addEventListener?"addEventListener":"attachEvent",l=n.addEventListener?"removeEventListener":"detachEvent",a=n.addEventListener?"":"on",r=function(i){if("readystatechange"!==i.type||"complete"===n.readyState)return("load"===i.type?e:n)[l](a+i.type,r,!1),!o&&(o=!0)?t.call(e,i.type||i):void 0},s=function(){var e;try{d.doScroll("left")}catch(t){return e=t,void setTimeout(s,50)}return r("poll")},"complete"!==n.readyState){if(n.createEventObject&&d.doScroll){try{p=!e.frameElement}catch(e){}p&&s()}return n[i](a+"DOMContentLoaded",r,!1),n[i](a+"readystatechange",r,!1),e[i](a+"load",r,!1)}},t._autoDiscoverFunction=function(){if(t.autoDiscover)return t.discover()},r(window,t._autoDiscoverFunction)}).call(this)}).call(t,i(9)(e))},function(e,t){e.exports=' <form :action=url class="vue-dropzone dropzone" :id=id> <slot></slot> </form> '},function(e,t,i){function n(e,t){for(var i=0;i<e.length;i++){var n=e[i],o=u[n.id];if(o){o.refs++;for(var r=0;r<o.parts.length;r++)o.parts[r](n.parts[r]);for(;r<n.parts.length;r++)o.parts.push(l(n.parts[r],t))}else{for(var s=[],r=0;r<n.parts.length;r++)s.push(l(n.parts[r],t));u[n.id]={id:n.id,refs:1,parts:s}}}}function o(e){for(var t=[],i={},n=0;n<e.length;n++){var o=e[n],r=o[0],s=o[1],a=o[2],l=o[3],d={css:s,media:a,sourceMap:l};i[r]?i[r].parts.push(d):t.push(i[r]={id:r,parts:[d]})}return t}function r(e,t){var i=f(),n=v[v.length-1];if("top"===e.insertAt)n?n.nextSibling?i.insertBefore(t,n.nextSibling):i.appendChild(t):i.insertBefore(t,i.firstChild),v.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");i.appendChild(t)}}function s(e){e.parentNode.removeChild(e);var t=v.indexOf(e);t>=0&&v.splice(t,1)}function a(e){var t=document.createElement("style");return t.type="text/css",r(e,t),t}function l(e,t){var i,n,o;if(t.singleton){var r=g++;i=m||(m=a(t)),n=d.bind(null,i,r,!1),o=d.bind(null,i,r,!0)}else i=a(t),n=p.bind(null,i),o=function(){s(i)};return n(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;n(e=t)}else o()}}function d(e,t,i,n){var o=i?"":n.css;if(e.styleSheet)e.styleSheet.cssText=z(t,o);else{var r=document.createTextNode(o),s=e.childNodes;s[t]&&e.removeChild(s[t]),s.length?e.insertBefore(r,s[t]):e.appendChild(r)}}function p(e,t){var i=t.css,n=t.media,o=t.sourceMap;if(n&&e.setAttribute("media",n),o&&(i+="\n/*# sourceURL="+o.sources[0]+" */",i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),e.styleSheet)e.styleSheet.cssText=i;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(i))}}var u={},c=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},h=c(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),f=c(function(){return document.head||document.getElementsByTagName("head")[0]}),m=null,g=0,v=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=h()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var i=o(e);return n(i,t),function(e){for(var r=[],s=0;s<i.length;s++){var a=i[s],l=u[a.id];l.refs--,r.push(l)}if(e){var d=o(e);n(d,t)}for(var s=0;s<r.length;s++){var l=r[s];if(0===l.refs){for(var p=0;p<l.parts.length;p++)l.parts[p]();delete u[l.id]}}}};var z=function(){var e=[];return function(t,i){return e[t]=i,e.filter(Boolean).join("\n")}}()},function(e,t,i){var n=i(4);"string"==typeof n&&(n=[[e.id,n,""]]);i(7)(n,{});n.locals&&(e.exports=n.locals)},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children=[],e.webpackPolyfill=1),e}}])});

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1569), __esModule: true };

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1575), __esModule: true };

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(19);
	
	function filterByPosition(array, position) {
		return helpers.where(array, function(v) {
			return v.position === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		array.forEach(function(v, i) {
			v._tmpIndex_ = i;
			return v;
		});
		array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0._tmpIndex_ - v1._tmpIndex_ :
				v0.weight - v1.weight;
		});
		array.forEach(function(v) {
			delete v._tmpIndex_;
		});
	}
	
	/**
	 * @interface ILayoutItem
	 * @prop {String} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {Function} getPadding -  Returns an object with padding on the edges
	 * @prop {Number} width - Width of item. Must be valid after update()
	 * @prop {Number} height - Height of item. Must be valid after update()
	 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	module.exports = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {Object} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {Object} item - the item to configure with the given options
		 * @param {Object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {Number} width - the width to fit into
		 * @param {Number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers.options.toPadding(layoutOptions.padding);
			var leftPadding = padding.left;
			var rightPadding = padding.right;
			var topPadding = padding.top;
			var bottomPadding = padding.bottom;
	
			var leftBoxes = filterByPosition(chart.boxes, 'left');
			var rightBoxes = filterByPosition(chart.boxes, 'right');
			var topBoxes = filterByPosition(chart.boxes, 'top');
			var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
			var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');
	
			// Sort boxes by weight. A higher weight is further away from the chart area
			sortByWeight(leftBoxes, true);
			sortByWeight(rightBoxes, false);
			sortByWeight(topBoxes, true);
			sortByWeight(bottomBoxes, false);
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
			// What we do to find the best sizing, we do the following
			// 1. Determine the minimum size of the chart area.
			// 2. Split the remaining width equally between each vertical axis
			// 3. Split the remaining height equally between each horizontal axis
			// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
			// 5. Adjust the sizes of each axis based on it's minimum reported size.
			// 6. Refit each axis
			// 7. Position each axis in the final location
			// 8. Tell the chart the final location of the chart area
			// 9. Tell any axes that overlay the chart area the positions of the chart area
	
			// Step 1
			var chartWidth = width - leftPadding - rightPadding;
			var chartHeight = height - topPadding - bottomPadding;
			var chartAreaWidth = chartWidth / 2; // min 50%
			var chartAreaHeight = chartHeight / 2; // min 50%
	
			// Step 2
			var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
			// Step 3
			var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
			// Step 4
			var maxChartAreaWidth = chartWidth;
			var maxChartAreaHeight = chartHeight;
			var minBoxSizes = [];
	
			function getMinimumBoxSize(box) {
				var minSize;
				var isHorizontal = box.isHorizontal();
	
				if (isHorizontal) {
					minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
					maxChartAreaHeight -= minSize.height;
				} else {
					minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
					maxChartAreaWidth -= minSize.width;
				}
	
				minBoxSizes.push({
					horizontal: isHorizontal,
					minSize: minSize,
					box: box,
				});
			}
	
			helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
			// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
			var maxHorizontalLeftPadding = 0;
			var maxHorizontalRightPadding = 0;
			var maxVerticalTopPadding = 0;
			var maxVerticalBottomPadding = 0;
	
			helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
				if (horizontalBox.getPadding) {
					var boxPadding = horizontalBox.getPadding();
					maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
					maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
				}
			});
	
			helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
				if (verticalBox.getPadding) {
					var boxPadding = verticalBox.getPadding();
					maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
					maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
				}
			});
	
			// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
			// be if the axes are drawn at their minimum sizes.
			// Steps 5 & 6
			var totalLeftBoxesWidth = leftPadding;
			var totalRightBoxesWidth = rightPadding;
			var totalTopBoxesHeight = topPadding;
			var totalBottomBoxesHeight = bottomPadding;
	
			// Function to fit a box
			function fitBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
					return minBox.box === box;
				});
	
				if (minBoxSize) {
					if (box.isHorizontal()) {
						var scaleMargin = {
							left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
							right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
							top: 0,
							bottom: 0
						};
	
						// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
						// on the margin. Sometimes they need to increase in size slightly
						box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
					} else {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight);
					}
				}
			}
	
			// Update, and calculate the left and right margins for the horizontal boxes
			helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});
	
			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});
	
			// Set the Left and Right margins for the horizontal boxes
			helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
			// Figure out how much margin is on the top and bottom of the vertical boxes
			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});
	
			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});
	
			function finalFitVerticalBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
					return minSize.box === box;
				});
	
				var scaleMargin = {
					left: 0,
					right: 0,
					top: totalTopBoxesHeight,
					bottom: totalBottomBoxesHeight
				};
	
				if (minBoxSize) {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
				}
			}
	
			// Let the left layout know the final margin
			helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
			// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
			totalLeftBoxesWidth = leftPadding;
			totalRightBoxesWidth = rightPadding;
			totalTopBoxesHeight = topPadding;
			totalBottomBoxesHeight = bottomPadding;
	
			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});
	
			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});
	
			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});
			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});
	
			// We may be adding some padding to account for rotated x axis labels
			var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
			totalLeftBoxesWidth += leftPaddingAddition;
			totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);
	
			var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
			totalTopBoxesHeight += topPaddingAddition;
			totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);
	
			// Figure out if our chart area changed. This would occur if the dataset layout label rotation
			// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
			// without calling `fit` again
			var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
			var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
			if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
				helpers.each(leftBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});
	
				helpers.each(rightBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});
	
				helpers.each(topBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});
	
				helpers.each(bottomBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});
	
				maxChartAreaHeight = newMaxChartAreaHeight;
				maxChartAreaWidth = newMaxChartAreaWidth;
			}
	
			// Step 7 - Position the boxes
			var left = leftPadding + leftPaddingAddition;
			var top = topPadding + topPaddingAddition;
	
			function placeBox(box) {
				if (box.isHorizontal()) {
					box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
					box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
					box.top = top;
					box.bottom = top + box.height;
	
					// Move to next point
					top = box.bottom;
	
				} else {
	
					box.left = left;
					box.right = left + box.width;
					box.top = totalTopBoxesHeight;
					box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
					// Move to next point
					left = box.right;
				}
			}
	
			helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
			// Account for chart width and height
			left += maxChartAreaWidth;
			top += maxChartAreaHeight;
	
			helpers.each(rightBoxes, placeBox);
			helpers.each(bottomBoxes, placeBox);
	
			// Step 8
			chart.chartArea = {
				left: totalLeftBoxesWidth,
				top: totalTopBoxesHeight,
				right: totalLeftBoxesWidth + maxChartAreaWidth,
				bottom: totalTopBoxesHeight + maxChartAreaHeight
			};
	
			// Step 9
			helpers.each(chartAreaBoxes, function(box) {
				box.left = chart.chartArea.left;
				box.top = chart.chartArea.top;
				box.right = chart.chartArea.right;
				box.bottom = chart.chartArea.bottom;
	
				box.update(maxChartAreaWidth, maxChartAreaHeight);
			});
		}
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(19);
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	module.exports = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {String|Array} the label to display
			 */
			values: function(value) {
				return helpers.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {Number} the value to be formatted
			 * @param index {Number} the position of the tickValue parameter in the ticks array
			 * @param ticks {Array<Number>} the list of ticks being converted
			 * @return {String} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(70);
	var call = __webpack_require__(386);
	var isArrayIter = __webpack_require__(384);
	var anObject = __webpack_require__(65);
	var toLength = __webpack_require__(132);
	var getIterFn = __webpack_require__(190);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(391);
	var enumBugKeys = __webpack_require__(175);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(49).f;
	var has = __webpack_require__(79);
	var TAG = __webpack_require__(33)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(130);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1608);
	var global = __webpack_require__(32);
	var hide = __webpack_require__(72);
	var Iterators = __webpack_require__(93);
	var TO_STRING_TAG = __webpack_require__(33)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(50);
	var TAG = __webpack_require__(24)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(50);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var hasClass = function hasClass(elem, className) {
	  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
	};
	
	var addClass = function addClass(elem, className) {
	  if (!hasClass(elem, className)) {
	    elem.className += ' ' + className;
	  }
	};
	
	var removeClass = function removeClass(elem, className) {
	  var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
	  if (hasClass(elem, className)) {
	    while (newClass.indexOf(' ' + className + ' ') >= 0) {
	      newClass = newClass.replace(' ' + className + ' ', ' ');
	    }
	    elem.className = newClass.replace(/^\s+|\s+$/g, '');
	  }
	};
	
	var escapeHtml = function escapeHtml(str) {
	  var div = document.createElement('div');
	  div.appendChild(document.createTextNode(str));
	  return div.innerHTML;
	};
	
	var _show = function _show(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'block';
	};
	
	var show = function show(elems) {
	  if (elems && !elems.length) {
	    return _show(elems);
	  }
	  for (var i = 0; i < elems.length; ++i) {
	    _show(elems[i]);
	  }
	};
	
	var _hide = function _hide(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'none';
	};
	
	var hide = function hide(elems) {
	  if (elems && !elems.length) {
	    return _hide(elems);
	  }
	  for (var i = 0; i < elems.length; ++i) {
	    _hide(elems[i]);
	  }
	};
	
	var isDescendant = function isDescendant(parent, child) {
	  var node = child.parentNode;
	  while (node !== null) {
	    if (node === parent) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	};
	
	var getTopMargin = function getTopMargin(elem) {
	  elem.style.left = '-9999px';
	  elem.style.display = 'block';
	
	  var height = elem.clientHeight,
	      padding;
	  if (typeof getComputedStyle !== 'undefined') {
	    // IE 8
	    padding = parseInt(getComputedStyle(elem).getPropertyValue('padding-top'), 10);
	  } else {
	    padding = parseInt(elem.currentStyle.padding);
	  }
	
	  elem.style.left = '';
	  elem.style.display = 'none';
	  return '-' + parseInt((height + padding) / 2) + 'px';
	};
	
	var fadeIn = function fadeIn(elem, interval) {
	  if (+elem.style.opacity < 1) {
	    interval = interval || 16;
	    elem.style.opacity = 0;
	    elem.style.display = 'block';
	    var last = +new Date();
	    var tick = (function (_tick) {
	      function tick() {
	        return _tick.apply(this, arguments);
	      }
	
	      tick.toString = function () {
	        return _tick.toString();
	      };
	
	      return tick;
	    })(function () {
	      elem.style.opacity = +elem.style.opacity + (new Date() - last) / 100;
	      last = +new Date();
	
	      if (+elem.style.opacity < 1) {
	        setTimeout(tick, interval);
	      }
	    });
	    tick();
	  }
	  elem.style.display = 'block'; //fallback IE8
	};
	
	var fadeOut = function fadeOut(elem, interval) {
	  interval = interval || 16;
	  elem.style.opacity = 1;
	  var last = +new Date();
	  var tick = (function (_tick2) {
	    function tick() {
	      return _tick2.apply(this, arguments);
	    }
	
	    tick.toString = function () {
	      return _tick2.toString();
	    };
	
	    return tick;
	  })(function () {
	    elem.style.opacity = +elem.style.opacity - (new Date() - last) / 100;
	    last = +new Date();
	
	    if (+elem.style.opacity > 0) {
	      setTimeout(tick, interval);
	    } else {
	      elem.style.display = 'none';
	    }
	  });
	  tick();
	};
	
	var fireClick = function fireClick(node) {
	  // Taken from http://www.nonobtrusive.com/2011/11/29/programatically-fire-crossbrowser-click-event-with-javascript/
	  // Then fixed for today's Chrome browser.
	  if (typeof MouseEvent === 'function') {
	    // Up-to-date approach
	    var mevt = new MouseEvent('click', {
	      view: window,
	      bubbles: false,
	      cancelable: true
	    });
	    node.dispatchEvent(mevt);
	  } else if (document.createEvent) {
	    // Fallback
	    var evt = document.createEvent('MouseEvents');
	    evt.initEvent('click', false, false);
	    node.dispatchEvent(evt);
	  } else if (document.createEventObject) {
	    node.fireEvent('onclick');
	  } else if (typeof node.onclick === 'function') {
	    node.onclick();
	  }
	};
	
	var stopEventPropagation = function stopEventPropagation(e) {
	  // In particular, make sure the space bar doesn't scroll the main window.
	  if (typeof e.stopPropagation === 'function') {
	    e.stopPropagation();
	    e.preventDefault();
	  } else if (window.event && window.event.hasOwnProperty('cancelBubble')) {
	    window.event.cancelBubble = true;
	  }
	};
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.escapeHtml = escapeHtml;
	exports._show = _show;
	exports.show = show;
	exports._hide = _hide;
	exports.hide = hide;
	exports.isDescendant = isDescendant;
	exports.getTopMargin = getTopMargin;
	exports.fadeIn = fadeIn;
	exports.fadeOut = fadeOut;
	exports.fireClick = fireClick;
	exports.stopEventPropagation = stopEventPropagation;

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(370);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(369);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {Number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @function
		 */
		isArray: Array.isArray ? Array.isArray : function(value) {
			return Object.prototype.toString.call(value) === '[object Array]';
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {Number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {Function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {Object|Array} loopable - The object or array to be iterated.
		 * @param {Function} fn - The function to call for each item.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see http://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {Boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @param {Object} [options] - Merging options:
		 * @param {Function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {Object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @returns {Object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {Object} target - The target object in which all objects are merged into.
		 * @param {Object} arg1 - Object containing additional properties to merge in target.
		 * @param {Object} argN - Additional objects containing properties to merge in target.
		 * @returns {Object} The `target` object.
		 */
		extend: function(target) {
			var setFn = function(value, key) {
				target[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
				helpers.each(arguments[i], setFn);
			}
			return target;
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		}
	};
	
	module.exports = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(110);
	var TAG = __webpack_require__(33)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(186);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(46);
	var toLength = __webpack_require__(29);
	var toAbsoluteIndex = __webpack_require__(88);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(39);
	var redefineAll = __webpack_require__(86);
	var meta = __webpack_require__(75);
	var forOf = __webpack_require__(81);
	var anInstance = __webpack_require__(80);
	var isObject = __webpack_require__(22);
	var fails = __webpack_require__(21);
	var $iterDetect = __webpack_require__(140);
	var setToStringTag = __webpack_require__(97);
	var inheritIfRequired = __webpack_require__(199);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(38);
	var redefine = __webpack_require__(39);
	var fails = __webpack_require__(21);
	var defined = __webpack_require__(60);
	var wks = __webpack_require__(24);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(17);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(50);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(22);
	var cof = __webpack_require__(50);
	var MATCH = __webpack_require__(24)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(24)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(74) || !__webpack_require__(21)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(18)[K];
	});


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(5);
	var aFunction = __webpack_require__(34);
	var ctx = __webpack_require__(52);
	var forOf = __webpack_require__(81);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(5);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(51);
	var global = __webpack_require__(18);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(74) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(17);
	var aFunction = __webpack_require__(34);
	var SPECIES = __webpack_require__(24)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var hide = __webpack_require__(38);
	var uid = __webpack_require__(89);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval( code, doc, node ) {
			doc = doc || document;
	
			var i,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.3.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
	
			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
	
			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(2903),
	    isArguments = __webpack_require__(150),
	    isArray = __webpack_require__(100);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(25)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _hexToRgb = __webpack_require__(155);
	
	var _removeClass$getTopMargin$fadeIn$show$addClass = __webpack_require__(122);
	
	var _defaultParams = __webpack_require__(570);
	
	var _defaultParams2 = _interopRequireWildcard(_defaultParams);
	
	/*
	 * Add modal + overlay to DOM
	 */
	
	var _injectedHTML = __webpack_require__(2933);
	
	var _injectedHTML2 = _interopRequireWildcard(_injectedHTML);
	
	var modalClass = '.sweet-alert';
	var overlayClass = '.sweet-overlay';
	
	var sweetAlertInitialize = function sweetAlertInitialize() {
	  var sweetWrap = document.createElement('div');
	  sweetWrap.innerHTML = _injectedHTML2['default'];
	
	  // Append elements to body
	  while (sweetWrap.firstChild) {
	    document.body.appendChild(sweetWrap.firstChild);
	  }
	};
	
	/*
	 * Get DOM element of modal
	 */
	var getModal = (function (_getModal) {
	  function getModal() {
	    return _getModal.apply(this, arguments);
	  }
	
	  getModal.toString = function () {
	    return _getModal.toString();
	  };
	
	  return getModal;
	})(function () {
	  var $modal = document.querySelector(modalClass);
	
	  if (!$modal) {
	    sweetAlertInitialize();
	    $modal = getModal();
	  }
	
	  return $modal;
	});
	
	/*
	 * Get DOM element of input (in modal)
	 */
	var getInput = function getInput() {
	  var $modal = getModal();
	  if ($modal) {
	    return $modal.querySelector('input');
	  }
	};
	
	/*
	 * Get DOM element of overlay
	 */
	var getOverlay = function getOverlay() {
	  return document.querySelector(overlayClass);
	};
	
	/*
	 * Add box-shadow style to button (depending on its chosen bg-color)
	 */
	var setFocusStyle = function setFocusStyle($button, bgColor) {
	  var rgbColor = _hexToRgb.hexToRgb(bgColor);
	  $button.style.boxShadow = '0 0 2px rgba(' + rgbColor + ', 0.8), inset 0 0 0 1px rgba(0, 0, 0, 0.05)';
	};
	
	/*
	 * Animation when opening modal
	 */
	var openModal = function openModal(callback) {
	  var $modal = getModal();
	  _removeClass$getTopMargin$fadeIn$show$addClass.fadeIn(getOverlay(), 10);
	  _removeClass$getTopMargin$fadeIn$show$addClass.show($modal);
	  _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'showSweetAlert');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'hideSweetAlert');
	
	  window.previousActiveElement = document.activeElement;
	  var $okButton = $modal.querySelector('button.confirm');
	  $okButton.focus();
	
	  setTimeout(function () {
	    _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'visible');
	  }, 500);
	
	  var timer = $modal.getAttribute('data-timer');
	
	  if (timer !== 'null' && timer !== '') {
	    var timerCallback = callback;
	    $modal.timeout = setTimeout(function () {
	      var doneFunctionExists = (timerCallback || null) && $modal.getAttribute('data-has-done-function') === 'true';
	      if (doneFunctionExists) {
	        timerCallback(null);
	      } else {
	        sweetAlert.close();
	      }
	    }, timer);
	  }
	};
	
	/*
	 * Reset the styling of the input
	 * (for example if errors have been shown)
	 */
	var resetInput = function resetInput() {
	  var $modal = getModal();
	  var $input = getInput();
	
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'show-input');
	  $input.value = _defaultParams2['default'].inputValue;
	  $input.setAttribute('type', _defaultParams2['default'].inputType);
	  $input.setAttribute('placeholder', _defaultParams2['default'].inputPlaceholder);
	
	  resetInputError();
	};
	
	var resetInputError = function resetInputError(event) {
	  // If press enter => ignore
	  if (event && event.keyCode === 13) {
	    return false;
	  }
	
	  var $modal = getModal();
	
	  var $errorIcon = $modal.querySelector('.sa-input-error');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorIcon, 'show');
	
	  var $errorContainer = $modal.querySelector('.sa-error-container');
	  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorContainer, 'show');
	};
	
	/*
	 * Set "margin-top"-property on modal based on its computed height
	 */
	var fixVerticalPosition = function fixVerticalPosition() {
	  var $modal = getModal();
	  $modal.style.marginTop = _removeClass$getTopMargin$fadeIn$show$addClass.getTopMargin(getModal());
	};
	
	exports.sweetAlertInitialize = sweetAlertInitialize;
	exports.getModal = getModal;
	exports.getOverlay = getOverlay;
	exports.getInput = getInput;
	exports.setFocusStyle = setFocusStyle;
	exports.openModal = openModal;
	exports.resetInput = resetInput;
	exports.resetInputError = resetInputError;
	exports.fixVerticalPosition = fixVerticalPosition;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	/*
	 * Allow user to pass their own params
	 */
	var extend = function extend(a, b) {
	  for (var key in b) {
	    if (b.hasOwnProperty(key)) {
	      a[key] = b[key];
	    }
	  }
	  return a;
	};
	
	/*
	 * Convert HEX codes to RGB values (#000000 -> rgb(0,0,0))
	 */
	var hexToRgb = function hexToRgb(hex) {
	  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	  return result ? parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) : null;
	};
	
	/*
	 * Check if the user is using Internet Explorer 8 (for fallbacks)
	 */
	var isIE8 = function isIE8() {
	  return window.attachEvent && !window.addEventListener;
	};
	
	/*
	 * IE compatible logging for developers
	 */
	var logStr = function logStr(string) {
	  if (window.console) {
	    // IE...
	    window.console.log('SweetAlert: ' + string);
	  }
	};
	
	/*
	 * Set hover, active and focus-states for buttons 
	 * (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
	 */
	var colorLuminance = function colorLuminance(hex, lum) {
	  // Validate hex string
	  hex = String(hex).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	  }
	  lum = lum || 0;
	
	  // Convert to decimal and change luminosity
	  var rgb = '#';
	  var c;
	  var i;
	
	  for (i = 0; i < 3; i++) {
	    c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	
	  return rgb;
	};
	
	exports.extend = extend;
	exports.hexToRgb = hexToRgb;
	exports.isIE8 = isIE8;
	exports.logStr = logStr;
	exports.colorLuminance = colorLuminance;

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.5.16
	 * (c) 2014-2018 Evan You
	 * Released under the MIT License.
	 */
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.Vue=t()}(this,function(){"use strict";var y=Object.freeze({});function M(e){return null==e}function D(e){return null!=e}function S(e){return!0===e}function T(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function P(e){return null!==e&&"object"==typeof e}var r=Object.prototype.toString;function l(e){return"[object Object]"===r.call(e)}function i(e){var t=parseFloat(String(e));return 0<=t&&Math.floor(t)===t&&isFinite(e)}function t(e){return null==e?"":"object"==typeof e?JSON.stringify(e,null,2):String(e)}function F(e){var t=parseFloat(e);return isNaN(t)?e:t}function s(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}var c=s("slot,component",!0),u=s("key,ref,slot,slot-scope,is");function f(e,t){if(e.length){var n=e.indexOf(t);if(-1<n)return e.splice(n,1)}}var n=Object.prototype.hasOwnProperty;function p(e,t){return n.call(e,t)}function e(t){var n=Object.create(null);return function(e){return n[e]||(n[e]=t(e))}}var o=/-(\w)/g,g=e(function(e){return e.replace(o,function(e,t){return t?t.toUpperCase():""})}),d=e(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),a=/\B([A-Z])/g,_=e(function(e){return e.replace(a,"-$1").toLowerCase()});var v=Function.prototype.bind?function(e,t){return e.bind(t)}:function(n,r){function e(e){var t=arguments.length;return t?1<t?n.apply(r,arguments):n.call(r,e):n.call(r)}return e._length=n.length,e};function h(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function m(e,t){for(var n in t)e[n]=t[n];return e}function b(e){for(var t={},n=0;n<e.length;n++)e[n]&&m(t,e[n]);return t}function $(e,t,n){}var O=function(e,t,n){return!1},w=function(e){return e};function C(t,n){if(t===n)return!0;var e=P(t),r=P(n);if(!e||!r)return!e&&!r&&String(t)===String(n);try{var i=Array.isArray(t),o=Array.isArray(n);if(i&&o)return t.length===n.length&&t.every(function(e,t){return C(e,n[t])});if(i||o)return!1;var a=Object.keys(t),s=Object.keys(n);return a.length===s.length&&a.every(function(e){return C(t[e],n[e])})}catch(e){return!1}}function x(e,t){for(var n=0;n<e.length;n++)if(C(e[n],t))return n;return-1}function R(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}var E="data-server-rendered",k=["component","directive","filter"],A=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured"],j={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:O,isReservedAttr:O,isUnknownElement:O,getTagNamespace:$,parsePlatformTagName:w,mustUseProp:O,_lifecycleHooks:A};function N(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var L=/[^\w.$]/;var I,H="__proto__"in{},B="undefined"!=typeof window,U="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,V=U&&WXEnvironment.platform.toLowerCase(),z=B&&window.navigator.userAgent.toLowerCase(),K=z&&/msie|trident/.test(z),J=z&&0<z.indexOf("msie 9.0"),q=z&&0<z.indexOf("edge/"),W=(z&&z.indexOf("android"),z&&/iphone|ipad|ipod|ios/.test(z)||"ios"===V),G=(z&&/chrome\/\d+/.test(z),{}.watch),Z=!1;if(B)try{var X={};Object.defineProperty(X,"passive",{get:function(){Z=!0}}),window.addEventListener("test-passive",null,X)}catch(e){}var Y=function(){return void 0===I&&(I=!B&&!U&&"undefined"!=typeof global&&"server"===global.process.env.VUE_ENV),I},Q=B&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function ee(e){return"function"==typeof e&&/native code/.test(e.toString())}var te,ne="undefined"!=typeof Symbol&&ee(Symbol)&&"undefined"!=typeof Reflect&&ee(Reflect.ownKeys);te="undefined"!=typeof Set&&ee(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var re=$,ie=0,oe=function(){this.id=ie++,this.subs=[]};oe.prototype.addSub=function(e){this.subs.push(e)},oe.prototype.removeSub=function(e){f(this.subs,e)},oe.prototype.depend=function(){oe.target&&oe.target.addDep(this)},oe.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},oe.target=null;var ae=[];function se(e){oe.target&&ae.push(oe.target),oe.target=e}function ce(){oe.target=ae.pop()}var le=function(e,t,n,r,i,o,a,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},ue={child:{configurable:!0}};ue.child.get=function(){return this.componentInstance},Object.defineProperties(le.prototype,ue);var fe=function(e){void 0===e&&(e="");var t=new le;return t.text=e,t.isComment=!0,t};function pe(e){return new le(void 0,void 0,void 0,String(e))}function de(e){var t=new le(e.tag,e.data,e.children,e.text,e.elm,e.context,e.componentOptions,e.asyncFactory);return t.ns=e.ns,t.isStatic=e.isStatic,t.key=e.key,t.isComment=e.isComment,t.fnContext=e.fnContext,t.fnOptions=e.fnOptions,t.fnScopeId=e.fnScopeId,t.isCloned=!0,t}var ve=Array.prototype,he=Object.create(ve);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(o){var a=ve[o];N(he,o,function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];var n,r=a.apply(this,e),i=this.__ob__;switch(o){case"push":case"unshift":n=e;break;case"splice":n=e.slice(2)}return n&&i.observeArray(n),i.dep.notify(),r})});var me=Object.getOwnPropertyNames(he),ye=!0;function ge(e){ye=e}var _e=function(e){(this.value=e,this.dep=new oe,this.vmCount=0,N(e,"__ob__",this),Array.isArray(e))?((H?be:$e)(e,he,me),this.observeArray(e)):this.walk(e)};function be(e,t,n){e.__proto__=t}function $e(e,t,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];N(e,o,t[o])}}function we(e,t){var n;if(P(e)&&!(e instanceof le))return p(e,"__ob__")&&e.__ob__ instanceof _e?n=e.__ob__:ye&&!Y()&&(Array.isArray(e)||l(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new _e(e)),t&&n&&n.vmCount++,n}function Ce(n,e,r,t,i){var o=new oe,a=Object.getOwnPropertyDescriptor(n,e);if(!a||!1!==a.configurable){var s=a&&a.get;s||2!==arguments.length||(r=n[e]);var c=a&&a.set,l=!i&&we(r);Object.defineProperty(n,e,{enumerable:!0,configurable:!0,get:function(){var e=s?s.call(n):r;return oe.target&&(o.depend(),l&&(l.dep.depend(),Array.isArray(e)&&function e(t){for(var n=void 0,r=0,i=t.length;r<i;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&e(n)}(e))),e},set:function(e){var t=s?s.call(n):r;e===t||e!=e&&t!=t||(c?c.call(n,e):r=e,l=!i&&we(e),o.notify())}})}}function xe(e,t,n){if(Array.isArray(e)&&i(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n;var r=e.__ob__;return e._isVue||r&&r.vmCount?n:r?(Ce(r.value,t,n),r.dep.notify(),n):e[t]=n}function ke(e,t){if(Array.isArray(e)&&i(t))e.splice(t,1);else{var n=e.__ob__;e._isVue||n&&n.vmCount||p(e,t)&&(delete e[t],n&&n.dep.notify())}}_e.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)Ce(e,t[n])},_e.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)we(e[t])};var Ae=j.optionMergeStrategies;function Oe(e,t){if(!t)return e;for(var n,r,i,o=Object.keys(t),a=0;a<o.length;a++)r=e[n=o[a]],i=t[n],p(e,n)?l(r)&&l(i)&&Oe(r,i):xe(e,n,i);return e}function Se(n,r,i){return i?function(){var e="function"==typeof r?r.call(i,i):r,t="function"==typeof n?n.call(i,i):n;return e?Oe(e,t):t}:r?n?function(){return Oe("function"==typeof r?r.call(this,this):r,"function"==typeof n?n.call(this,this):n)}:r:n}function Te(e,t){return t?e?e.concat(t):Array.isArray(t)?t:[t]:e}function Ee(e,t,n,r){var i=Object.create(e||null);return t?m(i,t):i}Ae.data=function(e,t,n){return n?Se(e,t,n):t&&"function"!=typeof t?e:Se(e,t)},A.forEach(function(e){Ae[e]=Te}),k.forEach(function(e){Ae[e+"s"]=Ee}),Ae.watch=function(e,t,n,r){if(e===G&&(e=void 0),t===G&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var i={};for(var o in m(i,e),t){var a=i[o],s=t[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},Ae.props=Ae.methods=Ae.inject=Ae.computed=function(e,t,n,r){if(!e)return t;var i=Object.create(null);return m(i,e),t&&m(i,t),i},Ae.provide=Se;var je=function(e,t){return void 0===t?e:t};function Ne(n,r,i){"function"==typeof r&&(r=r.options),function(e,t){var n=e.props;if(n){var r,i,o={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(o[g(i)]={type:null});else if(l(n))for(var a in n)i=n[a],o[g(a)]=l(i)?i:{type:i};e.props=o}}(r),function(e,t){var n=e.inject;if(n){var r=e.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(l(n))for(var o in n){var a=n[o];r[o]=l(a)?m({from:o},a):{from:a}}}}(r),function(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}(r);var e=r.extends;if(e&&(n=Ne(n,e,i)),r.mixins)for(var t=0,o=r.mixins.length;t<o;t++)n=Ne(n,r.mixins[t],i);var a,s={};for(a in n)c(a);for(a in r)p(n,a)||c(a);function c(e){var t=Ae[e]||je;s[e]=t(n[e],r[e],i,e)}return s}function Le(e,t,n,r){if("string"==typeof n){var i=e[t];if(p(i,n))return i[n];var o=g(n);if(p(i,o))return i[o];var a=d(o);return p(i,a)?i[a]:i[n]||i[o]||i[a]}}function Ie(e,t,n,r){var i=t[e],o=!p(n,e),a=n[e],s=Pe(Boolean,i.type);if(-1<s)if(o&&!p(i,"default"))a=!1;else if(""===a||a===_(e)){var c=Pe(String,i.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(e,t,n){if(!p(t,"default"))return;var r=t.default;if(e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n])return e._props[n];return"function"==typeof r&&"Function"!==Me(t.type)?r.call(e):r}(r,i,e);var l=ye;ge(!0),we(a),ge(l)}return a}function Me(e){var t=e&&e.toString().match(/^\s*function (\w+)/);return t?t[1]:""}function De(e,t){return Me(e)===Me(t)}function Pe(e,t){if(!Array.isArray(t))return De(t,e)?0:-1;for(var n=0,r=t.length;n<r;n++)if(De(t[n],e))return n;return-1}function Fe(e,t,n){if(t)for(var r=t;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,e,t,n))return}catch(e){Re(e,r,"errorCaptured hook")}}Re(e,t,n)}function Re(e,t,n){if(j.errorHandler)try{return j.errorHandler.call(null,e,t,n)}catch(e){He(e,null,"config.errorHandler")}He(e,t,n)}function He(e,t,n){if(!B&&!U||"undefined"==typeof console)throw e;console.error(e)}var Be,Ue,Ve=[],ze=!1;function Ke(){ze=!1;for(var e=Ve.slice(0),t=Ve.length=0;t<e.length;t++)e[t]()}var Je=!1;if("undefined"!=typeof setImmediate&&ee(setImmediate))Ue=function(){setImmediate(Ke)};else if("undefined"==typeof MessageChannel||!ee(MessageChannel)&&"[object MessageChannelConstructor]"!==MessageChannel.toString())Ue=function(){setTimeout(Ke,0)};else{var qe=new MessageChannel,We=qe.port2;qe.port1.onmessage=Ke,Ue=function(){We.postMessage(1)}}if("undefined"!=typeof Promise&&ee(Promise)){var Ge=Promise.resolve();Be=function(){Ge.then(Ke),W&&setTimeout($)}}else Be=Ue;function Ze(e,t){var n;if(Ve.push(function(){if(e)try{e.call(t)}catch(e){Fe(e,t,"nextTick")}else n&&n(t)}),ze||(ze=!0,Je?Ue():Be()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}var Xe=new te;function Ye(e){!function e(t,n){var r,i;var o=Array.isArray(t);if(!o&&!P(t)||Object.isFrozen(t)||t instanceof le)return;if(t.__ob__){var a=t.__ob__.dep.id;if(n.has(a))return;n.add(a)}if(o)for(r=t.length;r--;)e(t[r],n);else for(i=Object.keys(t),r=i.length;r--;)e(t[i[r]],n)}(e,Xe),Xe.clear()}var Qe,et=e(function(e){var t="&"===e.charAt(0),n="~"===(e=t?e.slice(1):e).charAt(0),r="!"===(e=n?e.slice(1):e).charAt(0);return{name:e=r?e.slice(1):e,once:n,capture:r,passive:t}});function tt(e){function i(){var e=arguments,t=i.fns;if(!Array.isArray(t))return t.apply(null,arguments);for(var n=t.slice(),r=0;r<n.length;r++)n[r].apply(null,e)}return i.fns=e,i}function nt(e,t,n,r,i){var o,a,s,c;for(o in e)a=e[o],s=t[o],c=et(o),M(a)||(M(s)?(M(a.fns)&&(a=e[o]=tt(a)),n(c.name,a,c.once,c.capture,c.passive,c.params)):a!==s&&(s.fns=a,e[o]=s));for(o in t)M(e[o])&&r((c=et(o)).name,t[o],c.capture)}function rt(e,t,n){var r;e instanceof le&&(e=e.data.hook||(e.data.hook={}));var i=e[t];function o(){n.apply(this,arguments),f(r.fns,o)}M(i)?r=tt([o]):D(i.fns)&&S(i.merged)?(r=i).fns.push(o):r=tt([i,o]),r.merged=!0,e[t]=r}function it(e,t,n,r,i){if(D(t)){if(p(t,n))return e[n]=t[n],i||delete t[n],!0;if(p(t,r))return e[n]=t[r],i||delete t[r],!0}return!1}function ot(e){return T(e)?[pe(e)]:Array.isArray(e)?function e(t,n){var r=[];var i,o,a,s;for(i=0;i<t.length;i++)M(o=t[i])||"boolean"==typeof o||(a=r.length-1,s=r[a],Array.isArray(o)?0<o.length&&(at((o=e(o,(n||"")+"_"+i))[0])&&at(s)&&(r[a]=pe(s.text+o[0].text),o.shift()),r.push.apply(r,o)):T(o)?at(s)?r[a]=pe(s.text+o):""!==o&&r.push(pe(o)):at(o)&&at(s)?r[a]=pe(s.text+o.text):(S(t._isVList)&&D(o.tag)&&M(o.key)&&D(n)&&(o.key="__vlist"+n+"_"+i+"__"),r.push(o)));return r}(e):void 0}function at(e){return D(e)&&D(e.text)&&!1===e.isComment}function st(e,t){return(e.__esModule||ne&&"Module"===e[Symbol.toStringTag])&&(e=e.default),P(e)?t.extend(e):e}function ct(e){return e.isComment&&e.asyncFactory}function lt(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var n=e[t];if(D(n)&&(D(n.componentOptions)||ct(n)))return n}}function ut(e,t,n){n?Qe.$once(e,t):Qe.$on(e,t)}function ft(e,t){Qe.$off(e,t)}function pt(e,t,n){Qe=e,nt(t,n||{},ut,ft),Qe=void 0}function dt(e,t){var n={};if(!e)return n;for(var r=0,i=e.length;r<i;r++){var o=e[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==t&&o.fnContext!==t||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var l in n)n[l].every(vt)&&delete n[l];return n}function vt(e){return e.isComment&&!e.asyncFactory||" "===e.text}function ht(e,t){t=t||{};for(var n=0;n<e.length;n++)Array.isArray(e[n])?ht(e[n],t):t[e[n].key]=e[n].fn;return t}var mt=null;function yt(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function gt(e,t){if(t){if(e._directInactive=!1,yt(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)gt(e.$children[n]);_t(e,"activated")}}function _t(t,n){se();var e=t.$options[n];if(e)for(var r=0,i=e.length;r<i;r++)try{e[r].call(t)}catch(e){Fe(e,t,n+" hook")}t._hasHookEvent&&t.$emit("hook:"+n),ce()}var bt=[],$t=[],wt={},Ct=!1,xt=!1,kt=0;function At(){var e,t;for(xt=!0,bt.sort(function(e,t){return e.id-t.id}),kt=0;kt<bt.length;kt++)t=(e=bt[kt]).id,wt[t]=null,e.run();var n=$t.slice(),r=bt.slice();kt=bt.length=$t.length=0,wt={},Ct=xt=!1,function(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,gt(e[t],!0)}(n),function(e){var t=e.length;for(;t--;){var n=e[t],r=n.vm;r._watcher===n&&r._isMounted&&_t(r,"updated")}}(r),Q&&j.devtools&&Q.emit("flush")}var Ot=0,St=function(e,t,n,r,i){this.vm=e,i&&(e._watcher=this),e._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++Ot,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new te,this.newDepIds=new te,this.expression="","function"==typeof t?this.getter=t:(this.getter=function(e){if(!L.test(e)){var n=e.split(".");return function(e){for(var t=0;t<n.length;t++){if(!e)return;e=e[n[t]]}return e}}}(t),this.getter||(this.getter=function(){})),this.value=this.lazy?void 0:this.get()};St.prototype.get=function(){var e;se(this);var t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;Fe(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&Ye(e),ce(),this.cleanupDeps()}return e},St.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},St.prototype.cleanupDeps=function(){for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},St.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(e){var t=e.id;if(null==wt[t]){if(wt[t]=!0,xt){for(var n=bt.length-1;kt<n&&bt[n].id>e.id;)n--;bt.splice(n+1,0,e)}else bt.push(e);Ct||(Ct=!0,Ze(At))}}(this)},St.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||P(e)||this.deep){var t=this.value;if(this.value=e,this.user)try{this.cb.call(this.vm,e,t)}catch(e){Fe(e,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,e,t)}}},St.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},St.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},St.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||f(this.vm._watchers,this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1}};var Tt={enumerable:!0,configurable:!0,get:$,set:$};function Et(e,t,n){Tt.get=function(){return this[t][n]},Tt.set=function(e){this[t][n]=e},Object.defineProperty(e,n,Tt)}function jt(e){e._watchers=[];var t=e.$options;t.props&&function(n,r){var i=n.$options.propsData||{},o=n._props={},a=n.$options._propKeys=[];n.$parent&&ge(!1);var e=function(e){a.push(e);var t=Ie(e,r,i,n);Ce(o,e,t),e in n||Et(n,"_props",e)};for(var t in r)e(t);ge(!0)}(e,t.props),t.methods&&function(e,t){e.$options.props;for(var n in t)e[n]=null==t[n]?$:v(t[n],e)}(e,t.methods),t.data?function(e){var t=e.$options.data;l(t=e._data="function"==typeof t?function(e,t){se();try{return e.call(t,t)}catch(e){return Fe(e,t,"data()"),{}}finally{ce()}}(t,e):t||{})||(t={});var n=Object.keys(t),r=e.$options.props,i=(e.$options.methods,n.length);for(;i--;){var o=n[i];r&&p(r,o)||(void 0,36!==(a=(o+"").charCodeAt(0))&&95!==a&&Et(e,"_data",o))}var a;we(t,!0)}(e):we(e._data={},!0),t.computed&&function(e,t){var n=e._computedWatchers=Object.create(null),r=Y();for(var i in t){var o=t[i],a="function"==typeof o?o:o.get;r||(n[i]=new St(e,a||$,$,Nt)),i in e||Lt(e,i,o)}}(e,t.computed),t.watch&&t.watch!==G&&function(e,t){for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)Mt(e,n,r[i]);else Mt(e,n,r)}}(e,t.watch)}var Nt={lazy:!0};function Lt(e,t,n){var r=!Y();"function"==typeof n?(Tt.get=r?It(t):n,Tt.set=$):(Tt.get=n.get?r&&!1!==n.cache?It(t):n.get:$,Tt.set=n.set?n.set:$),Object.defineProperty(e,t,Tt)}function It(t){return function(){var e=this._computedWatchers&&this._computedWatchers[t];if(e)return e.dirty&&e.evaluate(),oe.target&&e.depend(),e.value}}function Mt(e,t,n,r){return l(n)&&(n=(r=n).handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}function Dt(t,e){if(t){for(var n=Object.create(null),r=ne?Reflect.ownKeys(t).filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}):Object.keys(t),i=0;i<r.length;i++){for(var o=r[i],a=t[o].from,s=e;s;){if(s._provided&&p(s._provided,a)){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in t[o]){var c=t[o].default;n[o]="function"==typeof c?c.call(e):c}}return n}}function Pt(e,t){var n,r,i,o,a;if(Array.isArray(e)||"string"==typeof e)for(n=new Array(e.length),r=0,i=e.length;r<i;r++)n[r]=t(e[r],r);else if("number"==typeof e)for(n=new Array(e),r=0;r<e;r++)n[r]=t(r+1,r);else if(P(e))for(o=Object.keys(e),n=new Array(o.length),r=0,i=o.length;r<i;r++)a=o[r],n[r]=t(e[a],a,r);return D(n)&&(n._isVList=!0),n}function Ft(e,t,n,r){var i,o=this.$scopedSlots[e];if(o)n=n||{},r&&(n=m(m({},r),n)),i=o(n)||t;else{var a=this.$slots[e];a&&(a._rendered=!0),i=a||t}var s=n&&n.slot;return s?this.$createElement("template",{slot:s},i):i}function Rt(e){return Le(this.$options,"filters",e)||w}function Ht(e,t){return Array.isArray(e)?-1===e.indexOf(t):e!==t}function Bt(e,t,n,r,i){var o=j.keyCodes[t]||n;return i&&r&&!j.keyCodes[t]?Ht(i,r):o?Ht(o,e):r?_(r)!==t:void 0}function Ut(n,r,i,o,a){if(i)if(P(i)){var s;Array.isArray(i)&&(i=b(i));var e=function(t){if("class"===t||"style"===t||u(t))s=n;else{var e=n.attrs&&n.attrs.type;s=o||j.mustUseProp(r,e,t)?n.domProps||(n.domProps={}):n.attrs||(n.attrs={})}t in s||(s[t]=i[t],a&&((n.on||(n.on={}))["update:"+t]=function(e){i[t]=e}))};for(var t in i)e(t)}else;return n}function Vt(e,t){var n=this._staticTrees||(this._staticTrees=[]),r=n[e];return r&&!t||Kt(r=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),"__static__"+e,!1),r}function zt(e,t,n){return Kt(e,"__once__"+t+(n?"_"+n:""),!0),e}function Kt(e,t,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)e[r]&&"string"!=typeof e[r]&&Jt(e[r],t+"_"+r,n);else Jt(e,t,n)}function Jt(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function qt(e,t){if(t)if(l(t)){var n=e.on=e.on?m({},e.on):{};for(var r in t){var i=n[r],o=t[r];n[r]=i?[].concat(i,o):o}}else;return e}function Wt(e){e._o=zt,e._n=F,e._s=t,e._l=Pt,e._t=Ft,e._q=C,e._i=x,e._m=Vt,e._f=Rt,e._k=Bt,e._b=Ut,e._v=pe,e._e=fe,e._u=ht,e._g=qt}function Gt(e,t,n,o,r){var a,s=r.options;p(o,"_uid")?(a=Object.create(o))._original=o:o=(a=o)._original;var i=S(s._compiled),c=!i;this.data=e,this.props=t,this.children=n,this.parent=o,this.listeners=e.on||y,this.injections=Dt(s.inject,o),this.slots=function(){return dt(n,o)},i&&(this.$options=s,this.$slots=this.slots(),this.$scopedSlots=e.scopedSlots||y),s._scopeId?this._c=function(e,t,n,r){var i=rn(a,e,t,n,r,c);return i&&!Array.isArray(i)&&(i.fnScopeId=s._scopeId,i.fnContext=o),i}:this._c=function(e,t,n,r){return rn(a,e,t,n,r,c)}}function Zt(e,t,n,r){var i=de(e);return i.fnContext=n,i.fnOptions=r,t.slot&&((i.data||(i.data={})).slot=t.slot),i}function Xt(e,t){for(var n in t)e[g(n)]=t[n]}Wt(Gt.prototype);var Yt={init:function(e,t,n,r){if(e.componentInstance&&!e.componentInstance._isDestroyed&&e.data.keepAlive){var i=e;Yt.prepatch(i,i)}else{(e.componentInstance=function(e,t,n,r){var i={_isComponent:!0,parent:t,_parentVnode:e,_parentElm:n||null,_refElm:r||null},o=e.data.inlineTemplate;D(o)&&(i.render=o.render,i.staticRenderFns=o.staticRenderFns);return new e.componentOptions.Ctor(i)}(e,mt,n,r)).$mount(t?e.elm:void 0,t)}},prepatch:function(e,t){var n=t.componentOptions;!function(e,t,n,r,i){var o=!!(i||e.$options._renderChildren||r.data.scopedSlots||e.$scopedSlots!==y);if(e.$options._parentVnode=r,e.$vnode=r,e._vnode&&(e._vnode.parent=r),e.$options._renderChildren=i,e.$attrs=r.data.attrs||y,e.$listeners=n||y,t&&e.$options.props){ge(!1);for(var a=e._props,s=e.$options._propKeys||[],c=0;c<s.length;c++){var l=s[c],u=e.$options.props;a[l]=Ie(l,u,t,e)}ge(!0),e.$options.propsData=t}n=n||y;var f=e.$options._parentListeners;e.$options._parentListeners=n,pt(e,n,f),o&&(e.$slots=dt(i,r.context),e.$forceUpdate())}(t.componentInstance=e.componentInstance,n.propsData,n.listeners,t,n.children)},insert:function(e){var t,n=e.context,r=e.componentInstance;r._isMounted||(r._isMounted=!0,_t(r,"mounted")),e.data.keepAlive&&(n._isMounted?((t=r)._inactive=!1,$t.push(t)):gt(r,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?function e(t,n){if(!(n&&(t._directInactive=!0,yt(t))||t._inactive)){t._inactive=!0;for(var r=0;r<t.$children.length;r++)e(t.$children[r]);_t(t,"deactivated")}}(t,!0):t.$destroy())}},Qt=Object.keys(Yt);function en(e,t,n,r,i){if(!M(e)){var o=n.$options._base;if(P(e)&&(e=o.extend(e)),"function"==typeof e){var a,s,c,l,u,f,p;if(M(e.cid)&&void 0===(e=function(t,n,e){if(S(t.error)&&D(t.errorComp))return t.errorComp;if(D(t.resolved))return t.resolved;if(S(t.loading)&&D(t.loadingComp))return t.loadingComp;if(!D(t.contexts)){var r=t.contexts=[e],i=!0,o=function(){for(var e=0,t=r.length;e<t;e++)r[e].$forceUpdate()},a=R(function(e){t.resolved=st(e,n),i||o()}),s=R(function(e){D(t.errorComp)&&(t.error=!0,o())}),c=t(a,s);return P(c)&&("function"==typeof c.then?M(t.resolved)&&c.then(a,s):D(c.component)&&"function"==typeof c.component.then&&(c.component.then(a,s),D(c.error)&&(t.errorComp=st(c.error,n)),D(c.loading)&&(t.loadingComp=st(c.loading,n),0===c.delay?t.loading=!0:setTimeout(function(){M(t.resolved)&&M(t.error)&&(t.loading=!0,o())},c.delay||200)),D(c.timeout)&&setTimeout(function(){M(t.resolved)&&s(null)},c.timeout))),i=!1,t.loading?t.loadingComp:t.resolved}t.contexts.push(e)}(a=e,o,n)))return s=a,c=t,l=n,u=r,f=i,(p=fe()).asyncFactory=s,p.asyncMeta={data:c,context:l,children:u,tag:f},p;t=t||{},dn(e),D(t.model)&&function(e,t){var n=e.model&&e.model.prop||"value",r=e.model&&e.model.event||"input";(t.props||(t.props={}))[n]=t.model.value;var i=t.on||(t.on={});D(i[r])?i[r]=[t.model.callback].concat(i[r]):i[r]=t.model.callback}(e.options,t);var d=function(e,t,n){var r=t.options.props;if(!M(r)){var i={},o=e.attrs,a=e.props;if(D(o)||D(a))for(var s in r){var c=_(s);it(i,a,s,c,!0)||it(i,o,s,c,!1)}return i}}(t,e);if(S(e.options.functional))return function(e,t,n,r,i){var o=e.options,a={},s=o.props;if(D(s))for(var c in s)a[c]=Ie(c,s,t||y);else D(n.attrs)&&Xt(a,n.attrs),D(n.props)&&Xt(a,n.props);var l=new Gt(n,a,i,r,e),u=o.render.call(null,l._c,l);if(u instanceof le)return Zt(u,n,l.parent,o);if(Array.isArray(u)){for(var f=ot(u)||[],p=new Array(f.length),d=0;d<f.length;d++)p[d]=Zt(f[d],n,l.parent,o);return p}}(e,d,t,n,r);var v=t.on;if(t.on=t.nativeOn,S(e.options.abstract)){var h=t.slot;t={},h&&(t.slot=h)}!function(e){for(var t=e.hook||(e.hook={}),n=0;n<Qt.length;n++){var r=Qt[n];t[r]=Yt[r]}}(t);var m=e.options.name||i;return new le("vue-component-"+e.cid+(m?"-"+m:""),t,void 0,void 0,void 0,n,{Ctor:e,propsData:d,listeners:v,tag:i,children:r},a)}}}var tn=1,nn=2;function rn(e,t,n,r,i,o){return(Array.isArray(n)||T(n))&&(i=r,r=n,n=void 0),S(o)&&(i=nn),function(e,t,n,r,i){if(D(n)&&D(n.__ob__))return fe();D(n)&&D(n.is)&&(t=n.is);if(!t)return fe();Array.isArray(r)&&"function"==typeof r[0]&&((n=n||{}).scopedSlots={default:r[0]},r.length=0);i===nn?r=ot(r):i===tn&&(r=function(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}(r));var o,a;if("string"==typeof t){var s;a=e.$vnode&&e.$vnode.ns||j.getTagNamespace(t),o=j.isReservedTag(t)?new le(j.parsePlatformTagName(t),n,r,void 0,void 0,e):D(s=Le(e.$options,"components",t))?en(s,n,e,r,t):new le(t,n,r,void 0,void 0,e)}else o=en(t,n,e,r);return Array.isArray(o)?o:D(o)?(D(a)&&function e(t,n,r){t.ns=n;"foreignObject"===t.tag&&(n=void 0,r=!0);if(D(t.children))for(var i=0,o=t.children.length;i<o;i++){var a=t.children[i];D(a.tag)&&(M(a.ns)||S(r)&&"svg"!==a.tag)&&e(a,n,r)}}(o,a),D(n)&&function(e){P(e.style)&&Ye(e.style);P(e.class)&&Ye(e.class)}(n),o):fe()}(e,t,n,r,i)}var on,an,sn,cn,ln,un,fn,pn=0;function dn(e){var t=e.options;if(e.super){var n=dn(e.super);if(n!==e.superOptions){e.superOptions=n;var r=function(e){var t,n=e.options,r=e.extendOptions,i=e.sealedOptions;for(var o in n)n[o]!==i[o]&&(t||(t={}),t[o]=vn(n[o],r[o],i[o]));return t}(e);r&&m(e.extendOptions,r),(t=e.options=Ne(n,e.extendOptions)).name&&(t.components[t.name]=e)}}return t}function vn(e,t,n){if(Array.isArray(e)){var r=[];n=Array.isArray(n)?n:[n],t=Array.isArray(t)?t:[t];for(var i=0;i<e.length;i++)(0<=t.indexOf(e[i])||n.indexOf(e[i])<0)&&r.push(e[i]);return r}return e}function hn(e){this._init(e)}function mn(e){e.cid=0;var a=1;e.extend=function(e){e=e||{};var t=this,n=t.cid,r=e._Ctor||(e._Ctor={});if(r[n])return r[n];var i=e.name||t.options.name,o=function(e){this._init(e)};return((o.prototype=Object.create(t.prototype)).constructor=o).cid=a++,o.options=Ne(t.options,e),o.super=t,o.options.props&&function(e){var t=e.options.props;for(var n in t)Et(e.prototype,"_props",n)}(o),o.options.computed&&function(e){var t=e.options.computed;for(var n in t)Lt(e.prototype,n,t[n])}(o),o.extend=t.extend,o.mixin=t.mixin,o.use=t.use,k.forEach(function(e){o[e]=t[e]}),i&&(o.options.components[i]=o),o.superOptions=t.options,o.extendOptions=e,o.sealedOptions=m({},o.options),r[n]=o}}function yn(e){return e&&(e.Ctor.options.name||e.tag)}function gn(e,t){return Array.isArray(e)?-1<e.indexOf(t):"string"==typeof e?-1<e.split(",").indexOf(t):(n=e,"[object RegExp]"===r.call(n)&&e.test(t));var n}function _n(e,t){var n=e.cache,r=e.keys,i=e._vnode;for(var o in n){var a=n[o];if(a){var s=yn(a.componentOptions);s&&!t(s)&&bn(n,o,r,i)}}}function bn(e,t,n,r){var i=e[t];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),e[t]=null,f(n,t)}hn.prototype._init=function(e){var t,n,r,i,o=this;o._uid=pn++,o._isVue=!0,e&&e._isComponent?function(e,t){var n=e.$options=Object.create(e.constructor.options),r=t._parentVnode;n.parent=t.parent,n._parentVnode=r,n._parentElm=t._parentElm,n._refElm=t._refElm;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}(o,e):o.$options=Ne(dn(o.constructor),e||{},o),function(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}((o._renderProxy=o)._self=o),function(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&pt(e,t)}(o),function(i){i._vnode=null,i._staticTrees=null;var e=i.$options,t=i.$vnode=e._parentVnode,n=t&&t.context;i.$slots=dt(e._renderChildren,n),i.$scopedSlots=y,i._c=function(e,t,n,r){return rn(i,e,t,n,r,!1)},i.$createElement=function(e,t,n,r){return rn(i,e,t,n,r,!0)};var r=t&&t.data;Ce(i,"$attrs",r&&r.attrs||y,null,!0),Ce(i,"$listeners",e._parentListeners||y,null,!0)}(o),_t(o,"beforeCreate"),(n=Dt((t=o).$options.inject,t))&&(ge(!1),Object.keys(n).forEach(function(e){Ce(t,e,n[e])}),ge(!0)),jt(o),(i=(r=o).$options.provide)&&(r._provided="function"==typeof i?i.call(r):i),_t(o,"created"),o.$options.el&&o.$mount(o.$options.el)},on=hn,an={get:function(){return this._data}},sn={get:function(){return this._props}},Object.defineProperty(on.prototype,"$data",an),Object.defineProperty(on.prototype,"$props",sn),on.prototype.$set=xe,on.prototype.$delete=ke,on.prototype.$watch=function(e,t,n){if(l(t))return Mt(this,e,t,n);(n=n||{}).user=!0;var r=new St(this,e,t,n);return n.immediate&&t.call(this,r.value),function(){r.teardown()}},ln=/^hook:/,(cn=hn).prototype.$on=function(e,t){if(Array.isArray(e))for(var n=0,r=e.length;n<r;n++)this.$on(e[n],t);else(this._events[e]||(this._events[e]=[])).push(t),ln.test(e)&&(this._hasHookEvent=!0);return this},cn.prototype.$once=function(e,t){var n=this;function r(){n.$off(e,r),t.apply(n,arguments)}return r.fn=t,n.$on(e,r),n},cn.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(e)){for(var r=0,i=e.length;r<i;r++)this.$off(e[r],t);return n}var o=n._events[e];if(!o)return n;if(!t)return n._events[e]=null,n;if(t)for(var a,s=o.length;s--;)if((a=o[s])===t||a.fn===t){o.splice(s,1);break}return n},cn.prototype.$emit=function(t){var n=this,e=n._events[t];if(e){e=1<e.length?h(e):e;for(var r=h(arguments,1),i=0,o=e.length;i<o;i++)try{e[i].apply(n,r)}catch(e){Fe(e,n,'event handler for "'+t+'"')}}return n},(un=hn).prototype._update=function(e,t){var n=this;n._isMounted&&_t(n,"beforeUpdate");var r=n.$el,i=n._vnode,o=mt;(mt=n)._vnode=e,i?n.$el=n.__patch__(i,e):(n.$el=n.__patch__(n.$el,e,t,!1,n.$options._parentElm,n.$options._refElm),n.$options._parentElm=n.$options._refElm=null),mt=o,r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},un.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},un.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){_t(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||f(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),_t(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}},Wt((fn=hn).prototype),fn.prototype.$nextTick=function(e){return Ze(e,this)},fn.prototype._render=function(){var t,n=this,e=n.$options,r=e.render,i=e._parentVnode;i&&(n.$scopedSlots=i.data.scopedSlots||y),n.$vnode=i;try{t=r.call(n._renderProxy,n.$createElement)}catch(e){Fe(e,n,"render"),t=n._vnode}return t instanceof le||(t=fe()),t.parent=i,t};var $n,wn,Cn,xn=[String,RegExp,Array],kn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:xn,exclude:xn,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var e in this.cache)bn(this.cache,e,this.keys)},mounted:function(){var e=this;this.$watch("include",function(t){_n(e,function(e){return gn(t,e)})}),this.$watch("exclude",function(t){_n(e,function(e){return!gn(t,e)})})},render:function(){var e=this.$slots.default,t=lt(e),n=t&&t.componentOptions;if(n){var r=yn(n),i=this.include,o=this.exclude;if(i&&(!r||!gn(i,r))||o&&r&&gn(o,r))return t;var a=this.cache,s=this.keys,c=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;a[c]?(t.componentInstance=a[c].componentInstance,f(s,c),s.push(c)):(a[c]=t,s.push(c),this.max&&s.length>parseInt(this.max)&&bn(a,s[0],s,this._vnode)),t.data.keepAlive=!0}return t||e&&e[0]}}};$n=hn,Cn={get:function(){return j}},Object.defineProperty($n,"config",Cn),$n.util={warn:re,extend:m,mergeOptions:Ne,defineReactive:Ce},$n.set=xe,$n.delete=ke,$n.nextTick=Ze,$n.options=Object.create(null),k.forEach(function(e){$n.options[e+"s"]=Object.create(null)}),m(($n.options._base=$n).options.components,kn),$n.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(-1<t.indexOf(e))return this;var n=h(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this},$n.mixin=function(e){return this.options=Ne(this.options,e),this},mn($n),wn=$n,k.forEach(function(n){wn[n]=function(e,t){return t?("component"===n&&l(t)&&(t.name=t.name||e,t=this.options._base.extend(t)),"directive"===n&&"function"==typeof t&&(t={bind:t,update:t}),this.options[n+"s"][e]=t):this.options[n+"s"][e]}}),Object.defineProperty(hn.prototype,"$isServer",{get:Y}),Object.defineProperty(hn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(hn,"FunctionalRenderContext",{value:Gt}),hn.version="2.5.16";var An=s("style,class"),On=s("input,textarea,option,select,progress"),Sn=function(e,t,n){return"value"===n&&On(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Tn=s("contenteditable,draggable,spellcheck"),En=s("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),jn="http://www.w3.org/1999/xlink",Nn=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},Ln=function(e){return Nn(e)?e.slice(6,e.length):""},In=function(e){return null==e||!1===e};function Mn(e){for(var t=e.data,n=e,r=e;D(r.componentInstance);)(r=r.componentInstance._vnode)&&r.data&&(t=Dn(r.data,t));for(;D(n=n.parent);)n&&n.data&&(t=Dn(t,n.data));return function(e,t){if(D(e)||D(t))return Pn(e,Fn(t));return""}(t.staticClass,t.class)}function Dn(e,t){return{staticClass:Pn(e.staticClass,t.staticClass),class:D(e.class)?[e.class,t.class]:t.class}}function Pn(e,t){return e?t?e+" "+t:e:t||""}function Fn(e){return Array.isArray(e)?function(e){for(var t,n="",r=0,i=e.length;r<i;r++)D(t=Fn(e[r]))&&""!==t&&(n&&(n+=" "),n+=t);return n}(e):P(e)?function(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}(e):"string"==typeof e?e:""}var Rn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Hn=s("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Bn=s("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Un=function(e){return Hn(e)||Bn(e)};function Vn(e){return Bn(e)?"svg":"math"===e?"math":void 0}var zn=Object.create(null);var Kn=s("text,number,password,search,email,tel,url");function Jn(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}var qn=Object.freeze({createElement:function(e,t){var n=document.createElement(e);return"select"!==e||t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n},createElementNS:function(e,t){return document.createElementNS(Rn[e],t)},createTextNode:function(e){return document.createTextNode(e)},createComment:function(e){return document.createComment(e)},insertBefore:function(e,t,n){e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},appendChild:function(e,t){e.appendChild(t)},parentNode:function(e){return e.parentNode},nextSibling:function(e){return e.nextSibling},tagName:function(e){return e.tagName},setTextContent:function(e,t){e.textContent=t},setStyleScope:function(e,t){e.setAttribute(t,"")}}),Wn={create:function(e,t){Gn(t)},update:function(e,t){e.data.ref!==t.data.ref&&(Gn(e,!0),Gn(t))},destroy:function(e){Gn(e,!0)}};function Gn(e,t){var n=e.data.ref;if(D(n)){var r=e.context,i=e.componentInstance||e.elm,o=r.$refs;t?Array.isArray(o[n])?f(o[n],i):o[n]===i&&(o[n]=void 0):e.data.refInFor?Array.isArray(o[n])?o[n].indexOf(i)<0&&o[n].push(i):o[n]=[i]:o[n]=i}}var Zn=new le("",{},[]),Xn=["create","activate","update","remove","destroy"];function Yn(e,t){return e.key===t.key&&(e.tag===t.tag&&e.isComment===t.isComment&&D(e.data)===D(t.data)&&function(e,t){if("input"!==e.tag)return!0;var n,r=D(n=e.data)&&D(n=n.attrs)&&n.type,i=D(n=t.data)&&D(n=n.attrs)&&n.type;return r===i||Kn(r)&&Kn(i)}(e,t)||S(e.isAsyncPlaceholder)&&e.asyncFactory===t.asyncFactory&&M(t.asyncFactory.error))}function Qn(e,t,n){var r,i,o={};for(r=t;r<=n;++r)D(i=e[r].key)&&(o[i]=r);return o}var er={create:tr,update:tr,destroy:function(e){tr(e,Zn)}};function tr(e,t){(e.data.directives||t.data.directives)&&function(t,n){var e,r,i,o=t===Zn,a=n===Zn,s=rr(t.data.directives,t.context),c=rr(n.data.directives,n.context),l=[],u=[];for(e in c)r=s[e],i=c[e],r?(i.oldValue=r.value,ir(i,"update",n,t),i.def&&i.def.componentUpdated&&u.push(i)):(ir(i,"bind",n,t),i.def&&i.def.inserted&&l.push(i));if(l.length){var f=function(){for(var e=0;e<l.length;e++)ir(l[e],"inserted",n,t)};o?rt(n,"insert",f):f()}u.length&&rt(n,"postpatch",function(){for(var e=0;e<u.length;e++)ir(u[e],"componentUpdated",n,t)});if(!o)for(e in s)c[e]||ir(s[e],"unbind",t,t,a)}(e,t)}var nr=Object.create(null);function rr(e,t){var n,r,i,o=Object.create(null);if(!e)return o;for(n=0;n<e.length;n++)(r=e[n]).modifiers||(r.modifiers=nr),(o[(i=r,i.rawName||i.name+"."+Object.keys(i.modifiers||{}).join("."))]=r).def=Le(t.$options,"directives",r.name);return o}function ir(t,n,r,e,i){var o=t.def&&t.def[n];if(o)try{o(r.elm,t,r,e,i)}catch(e){Fe(e,r.context,"directive "+t.name+" "+n+" hook")}}var or=[Wn,er];function ar(e,t){var n=t.componentOptions;if(!(D(n)&&!1===n.Ctor.options.inheritAttrs||M(e.data.attrs)&&M(t.data.attrs))){var r,i,o=t.elm,a=e.data.attrs||{},s=t.data.attrs||{};for(r in D(s.__ob__)&&(s=t.data.attrs=m({},s)),s)i=s[r],a[r]!==i&&sr(o,r,i);for(r in(K||q)&&s.value!==a.value&&sr(o,"value",s.value),a)M(s[r])&&(Nn(r)?o.removeAttributeNS(jn,Ln(r)):Tn(r)||o.removeAttribute(r))}}function sr(e,t,n){-1<e.tagName.indexOf("-")?cr(e,t,n):En(t)?In(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n)):Tn(t)?e.setAttribute(t,In(n)||"false"===n?"false":"true"):Nn(t)?In(n)?e.removeAttributeNS(jn,Ln(t)):e.setAttributeNS(jn,t,n):cr(e,t,n)}function cr(t,e,n){if(In(n))t.removeAttribute(e);else{if(K&&!J&&"TEXTAREA"===t.tagName&&"placeholder"===e&&!t.__ieph){var r=function(e){e.stopImmediatePropagation(),t.removeEventListener("input",r)};t.addEventListener("input",r),t.__ieph=!0}t.setAttribute(e,n)}}var lr={create:ar,update:ar};function ur(e,t){var n=t.elm,r=t.data,i=e.data;if(!(M(r.staticClass)&&M(r.class)&&(M(i)||M(i.staticClass)&&M(i.class)))){var o=Mn(t),a=n._transitionClasses;D(a)&&(o=Pn(o,Fn(a))),o!==n._prevClass&&(n.setAttribute("class",o),n._prevClass=o)}}var fr,pr,dr,vr,hr,mr,yr={create:ur,update:ur},gr=/[\w).+\-_$\]]/;function _r(e){var t,n,r,i,o,a=!1,s=!1,c=!1,l=!1,u=0,f=0,p=0,d=0;for(r=0;r<e.length;r++)if(n=t,t=e.charCodeAt(r),a)39===t&&92!==n&&(a=!1);else if(s)34===t&&92!==n&&(s=!1);else if(c)96===t&&92!==n&&(c=!1);else if(l)47===t&&92!==n&&(l=!1);else if(124!==t||124===e.charCodeAt(r+1)||124===e.charCodeAt(r-1)||u||f||p){switch(t){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:p++;break;case 41:p--;break;case 91:f++;break;case 93:f--;break;case 123:u++;break;case 125:u--}if(47===t){for(var v=r-1,h=void 0;0<=v&&" "===(h=e.charAt(v));v--);h&&gr.test(h)||(l=!0)}}else void 0===i?(d=r+1,i=e.slice(0,r).trim()):m();function m(){(o||(o=[])).push(e.slice(d,r).trim()),d=r+1}if(void 0===i?i=e.slice(0,r).trim():0!==d&&m(),o)for(r=0;r<o.length;r++)i=br(i,o[r]);return i}function br(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+(")"!==i?","+i:i)}function $r(e){console.error("[Vue compiler]: "+e)}function wr(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function Cr(e,t,n){(e.props||(e.props=[])).push({name:t,value:n}),e.plain=!1}function xr(e,t,n){(e.attrs||(e.attrs=[])).push({name:t,value:n}),e.plain=!1}function kr(e,t,n){e.attrsMap[t]=n,e.attrsList.push({name:t,value:n})}function Ar(e,t,n,r,i,o){var a;(r=r||y).capture&&(delete r.capture,t="!"+t),r.once&&(delete r.once,t="~"+t),r.passive&&(delete r.passive,t="&"+t),"click"===t&&(r.right?(t="contextmenu",delete r.right):r.middle&&(t="mouseup")),r.native?(delete r.native,a=e.nativeEvents||(e.nativeEvents={})):a=e.events||(e.events={});var s={value:n.trim()};r!==y&&(s.modifiers=r);var c=a[t];Array.isArray(c)?i?c.unshift(s):c.push(s):a[t]=c?i?[s,c]:[c,s]:s,e.plain=!1}function Or(e,t,n){var r=Sr(e,":"+t)||Sr(e,"v-bind:"+t);if(null!=r)return _r(r);if(!1!==n){var i=Sr(e,t);if(null!=i)return JSON.stringify(i)}}function Sr(e,t,n){var r;if(null!=(r=e.attrsMap[t]))for(var i=e.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===t){i.splice(o,1);break}return n&&delete e.attrsMap[t],r}function Tr(e,t,n){var r=n||{},i=r.number,o="$$v",a=o;r.trim&&(a="(typeof $$v === 'string'? $$v.trim(): $$v)"),i&&(a="_n("+a+")");var s=Er(t,a);e.model={value:"("+t+")",expression:'"'+t+'"',callback:"function ($$v) {"+s+"}"}}function Er(e,t){var n=function(e){if(e=e.trim(),fr=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<fr-1)return-1<(vr=e.lastIndexOf("."))?{exp:e.slice(0,vr),key:'"'+e.slice(vr+1)+'"'}:{exp:e,key:null};pr=e,vr=hr=mr=0;for(;!Nr();)Lr(dr=jr())?Mr(dr):91===dr&&Ir(dr);return{exp:e.slice(0,hr),key:e.slice(hr+1,mr)}}(e);return null===n.key?e+"="+t:"$set("+n.exp+", "+n.key+", "+t+")"}function jr(){return pr.charCodeAt(++vr)}function Nr(){return fr<=vr}function Lr(e){return 34===e||39===e}function Ir(e){var t=1;for(hr=vr;!Nr();)if(Lr(e=jr()))Mr(e);else if(91===e&&t++,93===e&&t--,0===t){mr=vr;break}}function Mr(e){for(var t=e;!Nr()&&(e=jr())!==t;);}var Dr,Pr="__r",Fr="__c";function Rr(e,t,n,r,i){var o,a,s,c,l;t=(o=t)._withTask||(o._withTask=function(){Je=!0;var e=o.apply(null,arguments);return Je=!1,e}),n&&(a=t,s=e,c=r,l=Dr,t=function e(){null!==a.apply(null,arguments)&&Hr(s,e,c,l)}),Dr.addEventListener(e,t,Z?{capture:r,passive:i}:r)}function Hr(e,t,n,r){(r||Dr).removeEventListener(e,t._withTask||t,n)}function Br(e,t){if(!M(e.data.on)||!M(t.data.on)){var n=t.data.on||{},r=e.data.on||{};Dr=t.elm,function(e){if(D(e[Pr])){var t=K?"change":"input";e[t]=[].concat(e[Pr],e[t]||[]),delete e[Pr]}D(e[Fr])&&(e.change=[].concat(e[Fr],e.change||[]),delete e[Fr])}(n),nt(n,r,Rr,Hr,t.context),Dr=void 0}}var Ur={create:Br,update:Br};function Vr(e,t){if(!M(e.data.domProps)||!M(t.data.domProps)){var n,r,i,o,a=t.elm,s=e.data.domProps||{},c=t.data.domProps||{};for(n in D(c.__ob__)&&(c=t.data.domProps=m({},c)),s)M(c[n])&&(a[n]="");for(n in c){if(r=c[n],"textContent"===n||"innerHTML"===n){if(t.children&&(t.children.length=0),r===s[n])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===n){var l=M(a._value=r)?"":String(r);o=l,(i=a).composing||"OPTION"!==i.tagName&&!function(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}(i,o)&&!function(e,t){var n=e.value,r=e._vModifiers;if(D(r)){if(r.lazy)return!1;if(r.number)return F(n)!==F(t);if(r.trim)return n.trim()!==t.trim()}return n!==t}(i,o)||(a.value=l)}else a[n]=r}}}var zr={create:Vr,update:Vr},Kr=e(function(e){var n={},r=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function(e){if(e){var t=e.split(r);1<t.length&&(n[t[0].trim()]=t[1].trim())}}),n});function Jr(e){var t=qr(e.style);return e.staticStyle?m(e.staticStyle,t):t}function qr(e){return Array.isArray(e)?b(e):"string"==typeof e?Kr(e):e}var Wr,Gr=/^--/,Zr=/\s*!important$/,Xr=function(e,t,n){if(Gr.test(t))e.style.setProperty(t,n);else if(Zr.test(n))e.style.setProperty(t,n.replace(Zr,""),"important");else{var r=Qr(t);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)e.style[r]=n[i];else e.style[r]=n}},Yr=["Webkit","Moz","ms"],Qr=e(function(e){if(Wr=Wr||document.createElement("div").style,"filter"!==(e=g(e))&&e in Wr)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<Yr.length;n++){var r=Yr[n]+t;if(r in Wr)return r}});function ei(e,t){var n=t.data,r=e.data;if(!(M(n.staticStyle)&&M(n.style)&&M(r.staticStyle)&&M(r.style))){var i,o,a=t.elm,s=r.staticStyle,c=r.normalizedStyle||r.style||{},l=s||c,u=qr(t.data.style)||{};t.data.normalizedStyle=D(u.__ob__)?m({},u):u;var f=function(e,t){var n,r={};if(t)for(var i=e;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=Jr(i.data))&&m(r,n);(n=Jr(e.data))&&m(r,n);for(var o=e;o=o.parent;)o.data&&(n=Jr(o.data))&&m(r,n);return r}(t,!0);for(o in l)M(f[o])&&Xr(a,o,"");for(o in f)(i=f[o])!==l[o]&&Xr(a,o,null==i?"":i)}}var ti={create:ei,update:ei};function ni(t,e){if(e&&(e=e.trim()))if(t.classList)-1<e.indexOf(" ")?e.split(/\s+/).forEach(function(e){return t.classList.add(e)}):t.classList.add(e);else{var n=" "+(t.getAttribute("class")||"")+" ";n.indexOf(" "+e+" ")<0&&t.setAttribute("class",(n+e).trim())}}function ri(t,e){if(e&&(e=e.trim()))if(t.classList)-1<e.indexOf(" ")?e.split(/\s+/).forEach(function(e){return t.classList.remove(e)}):t.classList.remove(e),t.classList.length||t.removeAttribute("class");else{for(var n=" "+(t.getAttribute("class")||"")+" ",r=" "+e+" ";0<=n.indexOf(r);)n=n.replace(r," ");(n=n.trim())?t.setAttribute("class",n):t.removeAttribute("class")}}function ii(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&m(t,oi(e.name||"v")),m(t,e),t}return"string"==typeof e?oi(e):void 0}}var oi=e(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),ai=B&&!J,si="transition",ci="animation",li="transition",ui="transitionend",fi="animation",pi="animationend";ai&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(li="WebkitTransition",ui="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(fi="WebkitAnimation",pi="webkitAnimationEnd"));var di=B?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()};function vi(e){di(function(){di(e)})}function hi(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),ni(e,t))}function mi(e,t){e._transitionClasses&&f(e._transitionClasses,t),ri(e,t)}function yi(t,e,n){var r=_i(t,e),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===si?ui:pi,c=0,l=function(){t.removeEventListener(s,u),n()},u=function(e){e.target===t&&++c>=a&&l()};setTimeout(function(){c<a&&l()},o+1),t.addEventListener(s,u)}var gi=/\b(transform|all)(,|$)/;function _i(e,t){var n,r=window.getComputedStyle(e),i=r[li+"Delay"].split(", "),o=r[li+"Duration"].split(", "),a=bi(i,o),s=r[fi+"Delay"].split(", "),c=r[fi+"Duration"].split(", "),l=bi(s,c),u=0,f=0;return t===si?0<a&&(n=si,u=a,f=o.length):t===ci?0<l&&(n=ci,u=l,f=c.length):f=(n=0<(u=Math.max(a,l))?l<a?si:ci:null)?n===si?o.length:c.length:0,{type:n,timeout:u,propCount:f,hasTransform:n===si&&gi.test(r[li+"Property"])}}function bi(n,e){for(;n.length<e.length;)n=n.concat(n);return Math.max.apply(null,e.map(function(e,t){return $i(e)+$i(n[t])}))}function $i(e){return 1e3*Number(e.slice(0,-1))}function wi(n,e){var r=n.elm;D(r._leaveCb)&&(r._leaveCb.cancelled=!0,r._leaveCb());var t=ii(n.data.transition);if(!M(t)&&!D(r._enterCb)&&1===r.nodeType){for(var i=t.css,o=t.type,a=t.enterClass,s=t.enterToClass,c=t.enterActiveClass,l=t.appearClass,u=t.appearToClass,f=t.appearActiveClass,p=t.beforeEnter,d=t.enter,v=t.afterEnter,h=t.enterCancelled,m=t.beforeAppear,y=t.appear,g=t.afterAppear,_=t.appearCancelled,b=t.duration,$=mt,w=mt.$vnode;w&&w.parent;)$=(w=w.parent).context;var C=!$._isMounted||!n.isRootInsert;if(!C||y||""===y){var x=C&&l?l:a,k=C&&f?f:c,A=C&&u?u:s,O=C&&m||p,S=C&&"function"==typeof y?y:d,T=C&&g||v,E=C&&_||h,j=F(P(b)?b.enter:b),N=!1!==i&&!J,L=ki(S),I=r._enterCb=R(function(){N&&(mi(r,A),mi(r,k)),I.cancelled?(N&&mi(r,x),E&&E(r)):T&&T(r),r._enterCb=null});n.data.show||rt(n,"insert",function(){var e=r.parentNode,t=e&&e._pending&&e._pending[n.key];t&&t.tag===n.tag&&t.elm._leaveCb&&t.elm._leaveCb(),S&&S(r,I)}),O&&O(r),N&&(hi(r,x),hi(r,k),vi(function(){mi(r,x),I.cancelled||(hi(r,A),L||(xi(j)?setTimeout(I,j):yi(r,o,I)))})),n.data.show&&(e&&e(),S&&S(r,I)),N||L||I()}}}function Ci(e,t){var n=e.elm;D(n._enterCb)&&(n._enterCb.cancelled=!0,n._enterCb());var r=ii(e.data.transition);if(M(r)||1!==n.nodeType)return t();if(!D(n._leaveCb)){var i=r.css,o=r.type,a=r.leaveClass,s=r.leaveToClass,c=r.leaveActiveClass,l=r.beforeLeave,u=r.leave,f=r.afterLeave,p=r.leaveCancelled,d=r.delayLeave,v=r.duration,h=!1!==i&&!J,m=ki(u),y=F(P(v)?v.leave:v),g=n._leaveCb=R(function(){n.parentNode&&n.parentNode._pending&&(n.parentNode._pending[e.key]=null),h&&(mi(n,s),mi(n,c)),g.cancelled?(h&&mi(n,a),p&&p(n)):(t(),f&&f(n)),n._leaveCb=null});d?d(_):_()}function _(){g.cancelled||(e.data.show||((n.parentNode._pending||(n.parentNode._pending={}))[e.key]=e),l&&l(n),h&&(hi(n,a),hi(n,c),vi(function(){mi(n,a),g.cancelled||(hi(n,s),m||(xi(y)?setTimeout(g,y):yi(n,o,g)))})),u&&u(n,g),h||m||g())}}function xi(e){return"number"==typeof e&&!isNaN(e)}function ki(e){if(M(e))return!1;var t=e.fns;return D(t)?ki(Array.isArray(t)?t[0]:t):1<(e._length||e.length)}function Ai(e,t){!0!==t.data.show&&wi(t)}var Oi=function(e){var r,t,g={},n=e.modules,_=e.nodeOps;for(r=0;r<Xn.length;++r)for(g[Xn[r]]=[],t=0;t<n.length;++t)D(n[t][Xn[r]])&&g[Xn[r]].push(n[t][Xn[r]]);function o(e){var t=_.parentNode(e);D(t)&&_.removeChild(t,e)}function b(e,t,n,r,i,o,a){if(D(e.elm)&&D(o)&&(e=o[a]=de(e)),e.isRootInsert=!i,!function(e,t,n,r){var i=e.data;if(D(i)){var o=D(e.componentInstance)&&i.keepAlive;if(D(i=i.hook)&&D(i=i.init)&&i(e,!1,n,r),D(e.componentInstance))return d(e,t),S(o)&&function(e,t,n,r){for(var i,o=e;o.componentInstance;)if(o=o.componentInstance._vnode,D(i=o.data)&&D(i=i.transition)){for(i=0;i<g.activate.length;++i)g.activate[i](Zn,o);t.push(o);break}u(n,e.elm,r)}(e,t,n,r),!0}}(e,t,n,r)){var s=e.data,c=e.children,l=e.tag;D(l)?(e.elm=e.ns?_.createElementNS(e.ns,l):_.createElement(l,e),f(e),v(e,c,t),D(s)&&h(e,t)):S(e.isComment)?e.elm=_.createComment(e.text):e.elm=_.createTextNode(e.text),u(n,e.elm,r)}}function d(e,t){D(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,$(e)?(h(e,t),f(e)):(Gn(e),t.push(e))}function u(e,t,n){D(e)&&(D(n)?n.parentNode===e&&_.insertBefore(e,t,n):_.appendChild(e,t))}function v(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)b(t[r],n,e.elm,null,!0,t,r);else T(e.text)&&_.appendChild(e.elm,_.createTextNode(String(e.text)))}function $(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return D(e.tag)}function h(e,t){for(var n=0;n<g.create.length;++n)g.create[n](Zn,e);D(r=e.data.hook)&&(D(r.create)&&r.create(Zn,e),D(r.insert)&&t.push(e))}function f(e){var t;if(D(t=e.fnScopeId))_.setStyleScope(e.elm,t);else for(var n=e;n;)D(t=n.context)&&D(t=t.$options._scopeId)&&_.setStyleScope(e.elm,t),n=n.parent;D(t=mt)&&t!==e.context&&t!==e.fnContext&&D(t=t.$options._scopeId)&&_.setStyleScope(e.elm,t)}function y(e,t,n,r,i,o){for(;r<=i;++r)b(n[r],o,e,t,!1,n,r)}function w(e){var t,n,r=e.data;if(D(r))for(D(t=r.hook)&&D(t=t.destroy)&&t(e),t=0;t<g.destroy.length;++t)g.destroy[t](e);if(D(t=e.children))for(n=0;n<e.children.length;++n)w(e.children[n])}function C(e,t,n,r){for(;n<=r;++n){var i=t[n];D(i)&&(D(i.tag)?(a(i),w(i)):o(i.elm))}}function a(e,t){if(D(t)||D(e.data)){var n,r=g.remove.length+1;for(D(t)?t.listeners+=r:t=function(e,t){function n(){0==--n.listeners&&o(e)}return n.listeners=t,n}(e.elm,r),D(n=e.componentInstance)&&D(n=n._vnode)&&D(n.data)&&a(n,t),n=0;n<g.remove.length;++n)g.remove[n](e,t);D(n=e.data.hook)&&D(n=n.remove)?n(e,t):t()}else o(e.elm)}function x(e,t,n,r){for(var i=n;i<r;i++){var o=t[i];if(D(o)&&Yn(e,o))return i}}function k(e,t,n,r){if(e!==t){var i=t.elm=e.elm;if(S(e.isAsyncPlaceholder))D(t.asyncFactory.resolved)?O(e.elm,t,n):t.isAsyncPlaceholder=!0;else if(S(t.isStatic)&&S(e.isStatic)&&t.key===e.key&&(S(t.isCloned)||S(t.isOnce)))t.componentInstance=e.componentInstance;else{var o,a=t.data;D(a)&&D(o=a.hook)&&D(o=o.prepatch)&&o(e,t);var s=e.children,c=t.children;if(D(a)&&$(t)){for(o=0;o<g.update.length;++o)g.update[o](e,t);D(o=a.hook)&&D(o=o.update)&&o(e,t)}M(t.text)?D(s)&&D(c)?s!==c&&function(e,t,n,r,i){for(var o,a,s,c=0,l=0,u=t.length-1,f=t[0],p=t[u],d=n.length-1,v=n[0],h=n[d],m=!i;c<=u&&l<=d;)M(f)?f=t[++c]:M(p)?p=t[--u]:Yn(f,v)?(k(f,v,r),f=t[++c],v=n[++l]):Yn(p,h)?(k(p,h,r),p=t[--u],h=n[--d]):Yn(f,h)?(k(f,h,r),m&&_.insertBefore(e,f.elm,_.nextSibling(p.elm)),f=t[++c],h=n[--d]):(Yn(p,v)?(k(p,v,r),m&&_.insertBefore(e,p.elm,f.elm),p=t[--u]):(M(o)&&(o=Qn(t,c,u)),M(a=D(v.key)?o[v.key]:x(v,t,c,u))?b(v,r,e,f.elm,!1,n,l):Yn(s=t[a],v)?(k(s,v,r),t[a]=void 0,m&&_.insertBefore(e,s.elm,f.elm)):b(v,r,e,f.elm,!1,n,l)),v=n[++l]);u<c?y(e,M(n[d+1])?null:n[d+1].elm,n,l,d,r):d<l&&C(0,t,c,u)}(i,s,c,n,r):D(c)?(D(e.text)&&_.setTextContent(i,""),y(i,null,c,0,c.length-1,n)):D(s)?C(0,s,0,s.length-1):D(e.text)&&_.setTextContent(i,""):e.text!==t.text&&_.setTextContent(i,t.text),D(a)&&D(o=a.hook)&&D(o=o.postpatch)&&o(e,t)}}}function A(e,t,n){if(S(n)&&D(e.parent))e.parent.data.pendingInsert=t;else for(var r=0;r<t.length;++r)t[r].data.hook.insert(t[r])}var m=s("attrs,class,staticClass,staticStyle,key");function O(e,t,n,r){var i,o=t.tag,a=t.data,s=t.children;if(r=r||a&&a.pre,t.elm=e,S(t.isComment)&&D(t.asyncFactory))return t.isAsyncPlaceholder=!0;if(D(a)&&(D(i=a.hook)&&D(i=i.init)&&i(t,!0),D(i=t.componentInstance)))return d(t,n),!0;if(D(o)){if(D(s))if(e.hasChildNodes())if(D(i=a)&&D(i=i.domProps)&&D(i=i.innerHTML)){if(i!==e.innerHTML)return!1}else{for(var c=!0,l=e.firstChild,u=0;u<s.length;u++){if(!l||!O(l,s[u],n,r)){c=!1;break}l=l.nextSibling}if(!c||l)return!1}else v(t,s,n);if(D(a)){var f=!1;for(var p in a)if(!m(p)){f=!0,h(t,n);break}!f&&a.class&&Ye(a.class)}}else e.data!==t.text&&(e.data=t.text);return!0}return function(e,t,n,r,i,o){if(!M(t)){var a,s=!1,c=[];if(M(e))s=!0,b(t,c,i,o);else{var l=D(e.nodeType);if(!l&&Yn(e,t))k(e,t,c,r);else{if(l){if(1===e.nodeType&&e.hasAttribute(E)&&(e.removeAttribute(E),n=!0),S(n)&&O(e,t,c))return A(t,c,!0),e;a=e,e=new le(_.tagName(a).toLowerCase(),{},[],void 0,a)}var u=e.elm,f=_.parentNode(u);if(b(t,c,u._leaveCb?null:f,_.nextSibling(u)),D(t.parent))for(var p=t.parent,d=$(t);p;){for(var v=0;v<g.destroy.length;++v)g.destroy[v](p);if(p.elm=t.elm,d){for(var h=0;h<g.create.length;++h)g.create[h](Zn,p);var m=p.data.hook.insert;if(m.merged)for(var y=1;y<m.fns.length;y++)m.fns[y]()}else Gn(p);p=p.parent}D(f)?C(0,[e],0,0):D(e.tag)&&w(e)}}return A(t,c,s),t.elm}D(e)&&w(e)}}({nodeOps:qn,modules:[lr,yr,Ur,zr,ti,B?{create:Ai,activate:Ai,remove:function(e,t){!0!==e.data.show?Ci(e,t):t()}}:{}].concat(or)});J&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Mi(e,"input")});var Si={inserted:function(e,t,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?rt(n,"postpatch",function(){Si.componentUpdated(e,t,n)}):Ti(e,t,n.context),e._vOptions=[].map.call(e.options,Ni)):("textarea"===n.tag||Kn(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("compositionstart",Li),e.addEventListener("compositionend",Ii),e.addEventListener("change",Ii),J&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Ti(e,t,n.context);var r=e._vOptions,i=e._vOptions=[].map.call(e.options,Ni);if(i.some(function(e,t){return!C(e,r[t])}))(e.multiple?t.value.some(function(e){return ji(e,i)}):t.value!==t.oldValue&&ji(t.value,i))&&Mi(e,"change")}}};function Ti(e,t,n){Ei(e,t,n),(K||q)&&setTimeout(function(){Ei(e,t,n)},0)}function Ei(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=e.options.length;s<c;s++)if(a=e.options[s],i)o=-1<x(r,Ni(a)),a.selected!==o&&(a.selected=o);else if(C(Ni(a),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function ji(t,e){return e.every(function(e){return!C(e,t)})}function Ni(e){return"_value"in e?e._value:e.value}function Li(e){e.target.composing=!0}function Ii(e){e.target.composing&&(e.target.composing=!1,Mi(e.target,"input"))}function Mi(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function Di(e){return!e.componentInstance||e.data&&e.data.transition?e:Di(e.componentInstance._vnode)}var Pi={model:Si,show:{bind:function(e,t,n){var r=t.value,i=(n=Di(n)).data&&n.data.transition,o=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;r&&i?(n.data.show=!0,wi(n,function(){e.style.display=o})):e.style.display=r?o:"none"},update:function(e,t,n){var r=t.value;!r!=!t.oldValue&&((n=Di(n)).data&&n.data.transition?(n.data.show=!0,r?wi(n,function(){e.style.display=e.__vOriginalDisplay}):Ci(n,function(){e.style.display="none"})):e.style.display=r?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,r,i){i||(e.style.display=e.__vOriginalDisplay)}}},Fi={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function Ri(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?Ri(lt(t.children)):e}function Hi(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var o in i)t[g(o)]=i[o];return t}function Bi(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}var Ui={name:"transition",props:Fi,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(function(e){return e.tag||ct(e)})).length){var r=this.mode,i=n[0];if(function(e){for(;e=e.parent;)if(e.data.transition)return!0}(this.$vnode))return i;var o=Ri(i);if(!o)return i;if(this._leaving)return Bi(e,i);var a="__transition-"+this._uid+"-";o.key=null==o.key?o.isComment?a+"comment":a+o.tag:T(o.key)?0===String(o.key).indexOf(a)?o.key:a+o.key:o.key;var s,c,l=(o.data||(o.data={})).transition=Hi(this),u=this._vnode,f=Ri(u);if(o.data.directives&&o.data.directives.some(function(e){return"show"===e.name})&&(o.data.show=!0),f&&f.data&&(s=o,(c=f).key!==s.key||c.tag!==s.tag)&&!ct(f)&&(!f.componentInstance||!f.componentInstance._vnode.isComment)){var p=f.data.transition=m({},l);if("out-in"===r)return this._leaving=!0,rt(p,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),Bi(e,i);if("in-out"===r){if(ct(o))return u;var d,v=function(){d()};rt(l,"afterEnter",v),rt(l,"enterCancelled",v),rt(p,"delayLeave",function(e){d=e})}}return i}}},Vi=m({tag:String,moveClass:String},Fi);function zi(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function Ki(e){e.data.newPos=e.elm.getBoundingClientRect()}function Ji(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var o=e.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}delete Vi.mode;var qi={Transition:Ui,TransitionGroup:{props:Vi,render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=Hi(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),((n[c.key]=c).data||(c.data={})).transition=a)}if(r){for(var l=[],u=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?l.push(p):u.push(p)}this.kept=e(t,null,l),this.removed=u}return e(t,null,o)},beforeUpdate:function(){this.__patch__(this._vnode,this.kept,!1,!0),this._vnode=this.kept},updated:function(){var e=this.prevChildren,r=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,r)&&(e.forEach(zi),e.forEach(Ki),e.forEach(Ji),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,t=n.style;hi(n,r),t.transform=t.WebkitTransform=t.transitionDuration="",n.addEventListener(ui,n._moveCb=function e(t){t&&!/transform$/.test(t.propertyName)||(n.removeEventListener(ui,e),n._moveCb=null,mi(n,r))})}}))},methods:{hasMove:function(e,t){if(!ai)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){ri(n,e)}),ni(n,t),n.style.display="none",this.$el.appendChild(n);var r=_i(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};hn.config.mustUseProp=Sn,hn.config.isReservedTag=Un,hn.config.isReservedAttr=An,hn.config.getTagNamespace=Vn,hn.config.isUnknownElement=function(e){if(!B)return!0;if(Un(e))return!1;if(e=e.toLowerCase(),null!=zn[e])return zn[e];var t=document.createElement(e);return-1<e.indexOf("-")?zn[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:zn[e]=/HTMLUnknownElement/.test(t.toString())},m(hn.options.directives,Pi),m(hn.options.components,qi),hn.prototype.__patch__=B?Oi:$,hn.prototype.$mount=function(e,t){return e=e&&B?Jn(e):void 0,r=e,i=t,(n=this).$el=r,n.$options.render||(n.$options.render=fe),_t(n,"beforeMount"),new St(n,function(){n._update(n._render(),i)},$,null,!0),i=!1,null==n.$vnode&&(n._isMounted=!0,_t(n,"mounted")),n;var n,r,i},B&&setTimeout(function(){j.devtools&&Q&&Q.emit("init",hn)},0);var Wi=/\{\{((?:.|\n)+?)\}\}/g,Gi=/[-.*+?^${}()|[\]\/\\]/g,Zi=e(function(e){var t=e[0].replace(Gi,"\\$&"),n=e[1].replace(Gi,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")});var Xi={staticKeys:["staticClass"],transformNode:function(e,t){t.warn;var n=Sr(e,"class");n&&(e.staticClass=JSON.stringify(n));var r=Or(e,"class",!1);r&&(e.classBinding=r)},genData:function(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}};var Yi,Qi={staticKeys:["staticStyle"],transformNode:function(e,t){t.warn;var n=Sr(e,"style");n&&(e.staticStyle=JSON.stringify(Kr(n)));var r=Or(e,"style",!1);r&&(e.styleBinding=r)},genData:function(e){var t="";return e.staticStyle&&(t+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(t+="style:("+e.styleBinding+"),"),t}},eo=function(e){return(Yi=Yi||document.createElement("div")).innerHTML=e,Yi.textContent},to=s("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),no=s("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),ro=s("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),io=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,oo="[a-zA-Z_][\\w\\-\\.]*",ao="((?:"+oo+"\\:)?"+oo+")",so=new RegExp("^<"+ao),co=/^\s*(\/?)>/,lo=new RegExp("^<\\/"+ao+"[^>]*>"),uo=/^<!DOCTYPE [^>]+>/i,fo=/^<!\--/,po=/^<!\[/,vo=!1;"x".replace(/x(.)?/g,function(e,t){vo=""===t});var ho=s("script,style,textarea",!0),mo={},yo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t"},go=/&(?:lt|gt|quot|amp);/g,_o=/&(?:lt|gt|quot|amp|#10|#9);/g,bo=s("pre,textarea",!0),$o=function(e,t){return e&&bo(e)&&"\n"===t[0]};var wo,Co,xo,ko,Ao,Oo,So,To,Eo=/^@|^v-on:/,jo=/^v-|^@|^:/,No=/([^]*?)\s+(?:in|of)\s+([^]*)/,Lo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,Io=/^\(|\)$/g,Mo=/:(.*)$/,Do=/^:|^v-bind:/,Po=/\.[^.]+/g,Fo=e(eo);function Ro(e,t,n){return{type:1,tag:e,attrsList:t,attrsMap:function(e){for(var t={},n=0,r=e.length;n<r;n++)t[e[n].name]=e[n].value;return t}(t),parent:n,children:[]}}function Ho(e,p){wo=p.warn||$r,Oo=p.isPreTag||O,So=p.mustUseProp||O,To=p.getTagNamespace||O,xo=wr(p.modules,"transformNode"),ko=wr(p.modules,"preTransformNode"),Ao=wr(p.modules,"postTransformNode"),Co=p.delimiters;var d,v,h=[],i=!1!==p.preserveWhitespace,m=!1,y=!1;function g(e){e.pre&&(m=!1),Oo(e.tag)&&(y=!1);for(var t=0;t<Ao.length;t++)Ao[t](e,p)}return function(i,d){for(var e,v,h=[],m=d.expectHTML,y=d.isUnaryTag||O,g=d.canBeLeftOpenTag||O,a=0;i;){if(e=i,v&&ho(v)){var r=0,o=v.toLowerCase(),t=mo[o]||(mo[o]=new RegExp("([\\s\\S]*?)(</"+o+"[^>]*>)","i")),n=i.replace(t,function(e,t,n){return r=n.length,ho(o)||"noscript"===o||(t=t.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),$o(o,t)&&(t=t.slice(1)),d.chars&&d.chars(t),""});a+=i.length-n.length,i=n,A(o,a-r,a)}else{var s=i.indexOf("<");if(0===s){if(fo.test(i)){var c=i.indexOf("--\x3e");if(0<=c){d.shouldKeepComment&&d.comment(i.substring(4,c)),C(c+3);continue}}if(po.test(i)){var l=i.indexOf("]>");if(0<=l){C(l+2);continue}}var u=i.match(uo);if(u){C(u[0].length);continue}var f=i.match(lo);if(f){var p=a;C(f[0].length),A(f[1],p,a);continue}var _=x();if(_){k(_),$o(v,i)&&C(1);continue}}var b=void 0,$=void 0,w=void 0;if(0<=s){for($=i.slice(s);!(lo.test($)||so.test($)||fo.test($)||po.test($)||(w=$.indexOf("<",1))<0);)s+=w,$=i.slice(s);b=i.substring(0,s),C(s)}s<0&&(b=i,i=""),d.chars&&b&&d.chars(b)}if(i===e){d.chars&&d.chars(i);break}}function C(e){a+=e,i=i.substring(e)}function x(){var e=i.match(so);if(e){var t,n,r={tagName:e[1],attrs:[],start:a};for(C(e[0].length);!(t=i.match(co))&&(n=i.match(io));)C(n[0].length),r.attrs.push(n);if(t)return r.unarySlash=t[1],C(t[0].length),r.end=a,r}}function k(e){var t=e.tagName,n=e.unarySlash;m&&("p"===v&&ro(t)&&A(v),g(t)&&v===t&&A(t));for(var r,i,o,a=y(t)||!!n,s=e.attrs.length,c=new Array(s),l=0;l<s;l++){var u=e.attrs[l];vo&&-1===u[0].indexOf('""')&&(""===u[3]&&delete u[3],""===u[4]&&delete u[4],""===u[5]&&delete u[5]);var f=u[3]||u[4]||u[5]||"",p="a"===t&&"href"===u[1]?d.shouldDecodeNewlinesForHref:d.shouldDecodeNewlines;c[l]={name:u[1],value:(r=f,i=p,o=i?_o:go,r.replace(o,function(e){return yo[e]}))}}a||(h.push({tag:t,lowerCasedTag:t.toLowerCase(),attrs:c}),v=t),d.start&&d.start(t,c,a,e.start,e.end)}function A(e,t,n){var r,i;if(null==t&&(t=a),null==n&&(n=a),e&&(i=e.toLowerCase()),e)for(r=h.length-1;0<=r&&h[r].lowerCasedTag!==i;r--);else r=0;if(0<=r){for(var o=h.length-1;r<=o;o--)d.end&&d.end(h[o].tag,t,n);h.length=r,v=r&&h[r-1].tag}else"br"===i?d.start&&d.start(e,[],!0,t,n):"p"===i&&(d.start&&d.start(e,[],!1,t,n),d.end&&d.end(e,t,n))}A()}(e,{warn:wo,expectHTML:p.expectHTML,isUnaryTag:p.isUnaryTag,canBeLeftOpenTag:p.canBeLeftOpenTag,shouldDecodeNewlines:p.shouldDecodeNewlines,shouldDecodeNewlinesForHref:p.shouldDecodeNewlinesForHref,shouldKeepComment:p.comments,start:function(e,t,n){var r=v&&v.ns||To(e);K&&"svg"===r&&(t=function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];Ko.test(r.name)||(r.name=r.name.replace(Jo,""),t.push(r))}return t}(t));var i,o,a,s,c,l=Ro(e,t,v);r&&(l.ns=r),"style"!==(i=l).tag&&("script"!==i.tag||i.attrsMap.type&&"text/javascript"!==i.attrsMap.type)||Y()||(l.forbidden=!0);for(var u=0;u<ko.length;u++)l=ko[u](l,p)||l;if(m||(null!=Sr(o=l,"v-pre")&&(o.pre=!0),l.pre&&(m=!0)),Oo(l.tag)&&(y=!0),m?function(e){var t=e.attrsList.length;if(t)for(var n=e.attrs=new Array(t),r=0;r<t;r++)n[r]={name:e.attrsList[r].name,value:JSON.stringify(e.attrsList[r].value)};else e.pre||(e.plain=!0)}(l):l.processed||(Uo(l),function(e){var t=Sr(e,"v-if");if(t)e.if=t,Vo(e,{exp:t,block:e});else{null!=Sr(e,"v-else")&&(e.else=!0);var n=Sr(e,"v-else-if");n&&(e.elseif=n)}}(l),null!=Sr(a=l,"v-once")&&(a.once=!0),Bo(l,p)),d?h.length||d.if&&(l.elseif||l.else)&&Vo(d,{exp:l.elseif,block:l}):d=l,v&&!l.forbidden)if(l.elseif||l.else)s=l,(c=function(e){var t=e.length;for(;t--;){if(1===e[t].type)return e[t];e.pop()}}(v.children))&&c.if&&Vo(c,{exp:s.elseif,block:s});else if(l.slotScope){v.plain=!1;var f=l.slotTarget||'"default"';(v.scopedSlots||(v.scopedSlots={}))[f]=l}else v.children.push(l),l.parent=v;n?g(l):(v=l,h.push(l))},end:function(){var e=h[h.length-1],t=e.children[e.children.length-1];t&&3===t.type&&" "===t.text&&!y&&e.children.pop(),h.length-=1,v=h[h.length-1],g(e)},chars:function(e){if(v&&(!K||"textarea"!==v.tag||v.attrsMap.placeholder!==e)){var t,n,r=v.children;if(e=y||e.trim()?"script"===(t=v).tag||"style"===t.tag?e:Fo(e):i&&r.length?" ":"")!m&&" "!==e&&(n=function(e,t){var n=t?Zi(t):Wi;if(n.test(e)){for(var r,i,o,a=[],s=[],c=n.lastIndex=0;r=n.exec(e);){c<(i=r.index)&&(s.push(o=e.slice(c,i)),a.push(JSON.stringify(o)));var l=_r(r[1].trim());a.push("_s("+l+")"),s.push({"@binding":l}),c=i+r[0].length}return c<e.length&&(s.push(o=e.slice(c)),a.push(JSON.stringify(o))),{expression:a.join("+"),tokens:s}}}(e,Co))?r.push({type:2,expression:n.expression,tokens:n.tokens,text:e}):" "===e&&r.length&&" "===r[r.length-1].text||r.push({type:3,text:e})}},comment:function(e){v.children.push({type:3,text:e,isComment:!0})}}),d}function Bo(e,t){var n,r,i,o;(r=Or(n=e,"key"))&&(n.key=r),e.plain=!e.key&&!e.attrsList.length,(o=Or(i=e,"ref"))&&(i.ref=o,i.refInFor=function(e){for(var t=e;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}(i)),function(e){if("slot"===e.tag)e.slotName=Or(e,"name");else{var t;"template"===e.tag?(t=Sr(e,"scope"),e.slotScope=t||Sr(e,"slot-scope")):(t=Sr(e,"slot-scope"))&&(e.slotScope=t);var n=Or(e,"slot");n&&(e.slotTarget='""'===n?'"default"':n,"template"===e.tag||e.slotScope||xr(e,"slot",n))}}(e),function(e){var t;(t=Or(e,"is"))&&(e.component=t);null!=Sr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var a=0;a<xo.length;a++)e=xo[a](e,t)||e;!function(e){var t,n,r,i,o,a,s,c=e.attrsList;for(t=0,n=c.length;t<n;t++)if(r=i=c[t].name,o=c[t].value,jo.test(r))if(e.hasBindings=!0,(a=zo(r))&&(r=r.replace(Po,"")),Do.test(r))r=r.replace(Do,""),o=_r(o),s=!1,a&&(a.prop&&(s=!0,"innerHtml"===(r=g(r))&&(r="innerHTML")),a.camel&&(r=g(r)),a.sync&&Ar(e,"update:"+g(r),Er(o,"$event"))),s||!e.component&&So(e.tag,e.attrsMap.type,r)?Cr(e,r,o):xr(e,r,o);else if(Eo.test(r))r=r.replace(Eo,""),Ar(e,r,o,a,!1);else{var l=(r=r.replace(jo,"")).match(Mo),u=l&&l[1];u&&(r=r.slice(0,-(u.length+1))),p=r,d=i,v=o,h=u,m=a,((f=e).directives||(f.directives=[])).push({name:p,rawName:d,value:v,arg:h,modifiers:m}),f.plain=!1}else xr(e,r,JSON.stringify(o)),!e.component&&"muted"===r&&So(e.tag,e.attrsMap.type,r)&&Cr(e,r,"true");var f,p,d,v,h,m}(e)}function Uo(e){var t;if(t=Sr(e,"v-for")){var n=function(e){var t=e.match(No);if(!t)return;var n={};n.for=t[2].trim();var r=t[1].trim().replace(Io,""),i=r.match(Lo);i?(n.alias=r.replace(Lo,""),n.iterator1=i[1].trim(),i[2]&&(n.iterator2=i[2].trim())):n.alias=r;return n}(t);n&&m(e,n)}}function Vo(e,t){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(t)}function zo(e){var t=e.match(Po);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}var Ko=/^xmlns:NS\d+/,Jo=/^NS\d+:/;function qo(e){return Ro(e.tag,e.attrsList.slice(),e.parent)}var Wo=[Xi,Qi,{preTransformNode:function(e,t){if("input"===e.tag){var n,r=e.attrsMap;if(!r["v-model"])return;if((r[":type"]||r["v-bind:type"])&&(n=Or(e,"type")),r.type||n||!r["v-bind"]||(n="("+r["v-bind"]+").type"),n){var i=Sr(e,"v-if",!0),o=i?"&&("+i+")":"",a=null!=Sr(e,"v-else",!0),s=Sr(e,"v-else-if",!0),c=qo(e);Uo(c),kr(c,"type","checkbox"),Bo(c,t),c.processed=!0,c.if="("+n+")==='checkbox'"+o,Vo(c,{exp:c.if,block:c});var l=qo(e);Sr(l,"v-for",!0),kr(l,"type","radio"),Bo(l,t),Vo(c,{exp:"("+n+")==='radio'"+o,block:l});var u=qo(e);return Sr(u,"v-for",!0),kr(u,":type",n),Bo(u,t),Vo(c,{exp:i,block:u}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var Go,Zo,Xo,Yo={expectHTML:!0,modules:Wo,directives:{model:function(e,t,n){var r,i,o,a,s,c,l,u,f,p,d,v,h,m,y,g,_=t.value,b=t.modifiers,$=e.tag,w=e.attrsMap.type;if(e.component)return Tr(e,_,b),!1;if("select"===$)h=e,m=_,g=(g='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+((y=b)&&y.number?"_n(val)":"val")+"});")+" "+Er(m,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Ar(h,"change",g,null,!0);else if("input"===$&&"checkbox"===w)c=e,l=_,f=(u=b)&&u.number,p=Or(c,"value")||"null",d=Or(c,"true-value")||"true",v=Or(c,"false-value")||"false",Cr(c,"checked","Array.isArray("+l+")?_i("+l+","+p+")>-1"+("true"===d?":("+l+")":":_q("+l+","+d+")")),Ar(c,"change","var $$a="+l+",$$el=$event.target,$$c=$$el.checked?("+d+"):("+v+");if(Array.isArray($$a)){var $$v="+(f?"_n("+p+")":p)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Er(l,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Er(l,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Er(l,"$$c")+"}",null,!0);else if("input"===$&&"radio"===w)r=e,i=_,a=(o=b)&&o.number,s=Or(r,"value")||"null",Cr(r,"checked","_q("+i+","+(s=a?"_n("+s+")":s)+")"),Ar(r,"change",Er(i,s),null,!0);else if("input"===$||"textarea"===$)!function(e,t,n){var r=e.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,l=o?"change":"range"===r?Pr:"input",u="$event.target.value";s&&(u="$event.target.value.trim()"),a&&(u="_n("+u+")");var f=Er(t,u);c&&(f="if($event.target.composing)return;"+f),Cr(e,"value","("+t+")"),Ar(e,l,f,null,!0),(s||a)&&Ar(e,"blur","$forceUpdate()")}(e,_,b);else if(!j.isReservedTag($))return Tr(e,_,b),!1;return!0},text:function(e,t){t.value&&Cr(e,"textContent","_s("+t.value+")")},html:function(e,t){t.value&&Cr(e,"innerHTML","_s("+t.value+")")}},isPreTag:function(e){return"pre"===e},isUnaryTag:to,mustUseProp:Sn,canBeLeftOpenTag:no,isReservedTag:Un,getTagNamespace:Vn,staticKeys:(Go=Wo,Go.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(","))},Qo=e(function(e){return s("type,tag,attrsList,attrsMap,plain,parent,children,attrs"+(e?","+e:""))});function ea(e,t){e&&(Zo=Qo(t.staticKeys||""),Xo=t.isReservedTag||O,function e(t){t.static=function(e){if(2===e.type)return!1;if(3===e.type)return!0;return!(!e.pre&&(e.hasBindings||e.if||e.for||c(e.tag)||!Xo(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every(Zo)))}(t);if(1===t.type){if(!Xo(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var n=0,r=t.children.length;n<r;n++){var i=t.children[n];e(i),i.static||(t.static=!1)}if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++){var s=t.ifConditions[o].block;e(s),s.static||(t.static=!1)}}}(e),function e(t,n){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=n),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var r=0,i=t.children.length;r<i;r++)e(t.children[r],n||!!t.for);if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++)e(t.ifConditions[o].block,n)}}(e,!1))}var ta=/^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/,na=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,ra={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},ia={esc:"Escape",tab:"Tab",enter:"Enter",space:" ",up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete"]},oa=function(e){return"if("+e+")return null;"},aa={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:oa("$event.target !== $event.currentTarget"),ctrl:oa("!$event.ctrlKey"),shift:oa("!$event.shiftKey"),alt:oa("!$event.altKey"),meta:oa("!$event.metaKey"),left:oa("'button' in $event && $event.button !== 0"),middle:oa("'button' in $event && $event.button !== 1"),right:oa("'button' in $event && $event.button !== 2")};function sa(e,t,n){var r=t?"nativeOn:{":"on:{";for(var i in e)r+='"'+i+'":'+ca(i,e[i])+",";return r.slice(0,-1)+"}"}function ca(t,e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return ca(t,e)}).join(",")+"]";var n=na.test(e.value),r=ta.test(e.value);if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(aa[s])o+=aa[s],ra[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=oa(["ctrl","shift","alt","meta"].filter(function(e){return!c[e]}).map(function(e){return"$event."+e+"Key"}).join("||"))}else a.push(s);return a.length&&(i+="if(!('button' in $event)&&"+a.map(la).join("&&")+")return null;"),o&&(i+=o),"function($event){"+i+(n?"return "+e.value+"($event)":r?"return ("+e.value+")($event)":e.value)+"}"}return n||r?e.value:"function($event){"+e.value+"}"}function la(e){var t=parseInt(e,10);if(t)return"$event.keyCode!=="+t;var n=ra[e],r=ia[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(r)+")"}var ua={on:function(e,t){e.wrapListeners=function(e){return"_g("+e+","+t.value+")"}},bind:function(t,n){t.wrapData=function(e){return"_b("+e+",'"+t.tag+"',"+n.value+","+(n.modifiers&&n.modifiers.prop?"true":"false")+(n.modifiers&&n.modifiers.sync?",true":"")+")"}},cloak:$},fa=function(e){this.options=e,this.warn=e.warn||$r,this.transforms=wr(e.modules,"transformCode"),this.dataGenFns=wr(e.modules,"genData"),this.directives=m(m({},ua),e.directives);var t=e.isReservedTag||O;this.maybeComponent=function(e){return!t(e.tag)},this.onceId=0,this.staticRenderFns=[]};function pa(e,t){var n=new fa(t);return{render:"with(this){return "+(e?da(e,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function da(e,t){if(e.staticRoot&&!e.staticProcessed)return va(e,t);if(e.once&&!e.onceProcessed)return ha(e,t);if(e.for&&!e.forProcessed)return f=t,v=(u=e).for,h=u.alias,m=u.iterator1?","+u.iterator1:"",y=u.iterator2?","+u.iterator2:"",u.forProcessed=!0,(d||"_l")+"(("+v+"),function("+h+m+y+"){return "+(p||da)(u,f)+"})";if(e.if&&!e.ifProcessed)return ma(e,t);if("template"!==e.tag||e.slotTarget){if("slot"===e.tag)return function(e,t){var n=e.slotName||'"default"',r=_a(e,t),i="_t("+n+(r?","+r:""),o=e.attrs&&"{"+e.attrs.map(function(e){return g(e.name)+":"+e.value}).join(",")+"}",a=e.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(e,t);var n;if(e.component)a=e.component,c=t,l=(s=e).inlineTemplate?null:_a(s,c,!0),n="_c("+a+","+ya(s,c)+(l?","+l:"")+")";else{var r=e.plain?void 0:ya(e,t),i=e.inlineTemplate?null:_a(e,t,!0);n="_c('"+e.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<t.transforms.length;o++)n=t.transforms[o](e,n);return n}return _a(e,t)||"void 0";var a,s,c,l,u,f,p,d,v,h,m,y}function va(e,t){return e.staticProcessed=!0,t.staticRenderFns.push("with(this){return "+da(e,t)+"}"),"_m("+(t.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function ha(e,t){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return ma(e,t);if(e.staticInFor){for(var n="",r=e.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+da(e,t)+","+t.onceId+++","+n+")":da(e,t)}return va(e,t)}function ma(e,t,n,r){return e.ifProcessed=!0,function e(t,n,r,i){if(!t.length)return i||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+a(o.block)+":"+e(t,n,r,i):""+a(o.block);function a(e){return r?r(e,n):e.once?ha(e,n):da(e,n)}}(e.ifConditions.slice(),t,n,r)}function ya(e,t){var n,r,i="{",o=function(e,t){var n=e.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var l=t.directives[o.name];l&&(a=!!l(e,o,t.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?',arg:"'+o.arg+'"':"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(e,t);o&&(i+=o+","),e.key&&(i+="key:"+e.key+","),e.ref&&(i+="ref:"+e.ref+","),e.refInFor&&(i+="refInFor:true,"),e.pre&&(i+="pre:true,"),e.component&&(i+='tag:"'+e.tag+'",');for(var a=0;a<t.dataGenFns.length;a++)i+=t.dataGenFns[a](e);if(e.attrs&&(i+="attrs:{"+wa(e.attrs)+"},"),e.props&&(i+="domProps:{"+wa(e.props)+"},"),e.events&&(i+=sa(e.events,!1,t.warn)+","),e.nativeEvents&&(i+=sa(e.nativeEvents,!0,t.warn)+","),e.slotTarget&&!e.slotScope&&(i+="slot:"+e.slotTarget+","),e.scopedSlots&&(i+=(n=e.scopedSlots,r=t,"scopedSlots:_u(["+Object.keys(n).map(function(e){return ga(e,n[e],r)}).join(",")+"]),")),e.model&&(i+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var s=function(e,t){var n=e.children[0];if(1===n.type){var r=pa(n,t.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}(e,t);s&&(i+=s+",")}return i=i.replace(/,$/,"")+"}",e.wrapData&&(i=e.wrapData(i)),e.wrapListeners&&(i=e.wrapListeners(i)),i}function ga(e,t,n){return t.for&&!t.forProcessed?(r=e,o=n,a=(i=t).for,s=i.alias,c=i.iterator1?","+i.iterator1:"",l=i.iterator2?","+i.iterator2:"",i.forProcessed=!0,"_l(("+a+"),function("+s+c+l+"){return "+ga(r,i,o)+"})"):"{key:"+e+",fn:"+("function("+String(t.slotScope)+"){return "+("template"===t.tag?t.if?t.if+"?"+(_a(t,n)||"undefined")+":undefined":_a(t,n)||"undefined":da(t,n))+"}")+"}";var r,i,o,a,s,c,l}function _a(e,t,n,r,i){var o=e.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag)return(r||da)(a,t);var s=n?function(e,t){for(var n=0,r=0;r<e.length;r++){var i=e[r];if(1===i.type){if(ba(i)||i.ifConditions&&i.ifConditions.some(function(e){return ba(e.block)})){n=2;break}(t(i)||i.ifConditions&&i.ifConditions.some(function(e){return t(e.block)}))&&(n=1)}}return n}(o,t.maybeComponent):0,c=i||$a;return"["+o.map(function(e){return c(e,t)}).join(",")+"]"+(s?","+s:"")}}function ba(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function $a(e,t){return 1===e.type?da(e,t):3===e.type&&e.isComment?(r=e,"_e("+JSON.stringify(r.text)+")"):"_v("+(2===(n=e).type?n.expression:Ca(JSON.stringify(n.text)))+")";var n,r}function wa(e){for(var t="",n=0;n<e.length;n++){var r=e[n];t+='"'+r.name+'":'+Ca(r.value)+","}return t.slice(0,-1)}function Ca(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b"),new RegExp("\\b"+"delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b")+"\\s*\\([^\\)]*\\)");function xa(t,n){try{return new Function(t)}catch(e){return n.push({err:e,code:t}),$}}var ka,Aa,Oa=(ka=function(e,t){var n=Ho(e.trim(),t);!1!==t.optimize&&ea(n,t);var r=pa(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(s){function e(e,t){var n=Object.create(s),r=[],i=[];if(n.warn=function(e,t){(t?i:r).push(e)},t)for(var o in t.modules&&(n.modules=(s.modules||[]).concat(t.modules)),t.directives&&(n.directives=m(Object.create(s.directives||null),t.directives)),t)"modules"!==o&&"directives"!==o&&(n[o]=t[o]);var a=ka(e,n);return a.errors=r,a.tips=i,a}return{compile:e,compileToFunctions:(c=e,l=Object.create(null),function(e,t,n){(t=m({},t)).warn,delete t.warn;var r=t.delimiters?String(t.delimiters)+e:e;if(l[r])return l[r];var i=c(e,t),o={},a=[];return o.render=xa(i.render,a),o.staticRenderFns=i.staticRenderFns.map(function(e){return xa(e,a)}),l[r]=o})};var c,l})(Yo).compileToFunctions;function Sa(e){return(Aa=Aa||document.createElement("div")).innerHTML=e?'<a href="\n"/>':'<div a="\n"/>',0<Aa.innerHTML.indexOf("&#10;")}var Ta=!!B&&Sa(!1),Ea=!!B&&Sa(!0),ja=e(function(e){var t=Jn(e);return t&&t.innerHTML}),Na=hn.prototype.$mount;return hn.prototype.$mount=function(e,t){if((e=e&&Jn(e))===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=ja(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=function(e){{if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}}(e));if(r){var i=Oa(r,{shouldDecodeNewlines:Ta,shouldDecodeNewlinesForHref:Ea,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return Na.call(this,e,t)},hn.compile=Oa,hn});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(571).setImmediate))

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(42);
	var normalizeHeaderName = __webpack_require__(648);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(227);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(227);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1565), __esModule: true };

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(2930).Transform;
	var inherits = __webpack_require__(64);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(58);
	var document = __webpack_require__(32).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(110);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(112);
	var $export = __webpack_require__(31);
	var redefine = __webpack_require__(394);
	var hide = __webpack_require__(72);
	var Iterators = __webpack_require__(93);
	var $iterCreate = __webpack_require__(1591);
	var setToStringTag = __webpack_require__(115);
	var getPrototypeOf = __webpack_require__(1596);
	var ITERATOR = __webpack_require__(33)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(133)('meta');
	var isObject = __webpack_require__(58);
	var has = __webpack_require__(79);
	var setDesc = __webpack_require__(49).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(71)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(109);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(65);
	var dPs = __webpack_require__(389);
	var enumBugKeys = __webpack_require__(175);
	var IE_PROTO = __webpack_require__(183)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(174)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(382).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(72);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(184)('keys');
	var uid = __webpack_require__(133);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(26);
	var global = __webpack_require__(32);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(112) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(58);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var core = __webpack_require__(26);
	var LIBRARY = __webpack_require__(112);
	var wksExt = __webpack_require__(189);
	var defineProperty = __webpack_require__(49).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(33);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(129);
	var ITERATOR = __webpack_require__(33)('iterator');
	var Iterators = __webpack_require__(93);
	module.exports = __webpack_require__(26).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 191 */
/***/ (function(module, exports) {



/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(30);
	var toAbsoluteIndex = __webpack_require__(88);
	var toLength = __webpack_require__(29);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1625);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(28);
	var createDesc = __webpack_require__(85);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	var document = __webpack_require__(18).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(24)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(18).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	var setPrototypeOf = __webpack_require__(207).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(96);
	var ITERATOR = __webpack_require__(24)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(82);
	var descriptor = __webpack_require__(85);
	var setToStringTag = __webpack_require__(97);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(38)(IteratorPrototype, __webpack_require__(24)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(74);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(39);
	var hide = __webpack_require__(38);
	var Iterators = __webpack_require__(96);
	var $iterCreate = __webpack_require__(201);
	var setToStringTag = __webpack_require__(97);
	var getPrototypeOf = __webpack_require__(45);
	var ITERATOR = __webpack_require__(24)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var macrotask = __webpack_require__(213).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(50)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(34);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(22);
	var anObject = __webpack_require__(17);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(52)(Function.call, __webpack_require__(44).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(145)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(62);
	var defined = __webpack_require__(60);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(139);
	var defined = __webpack_require__(60);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(62);
	var defined = __webpack_require__(60);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(52);
	var invoke = __webpack_require__(410);
	var html = __webpack_require__(198);
	var cel = __webpack_require__(195);
	var global = __webpack_require__(18);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(50)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var DESCRIPTORS = __webpack_require__(27);
	var LIBRARY = __webpack_require__(74);
	var $typed = __webpack_require__(147);
	var hide = __webpack_require__(38);
	var redefineAll = __webpack_require__(86);
	var fails = __webpack_require__(21);
	var anInstance = __webpack_require__(80);
	var toInteger = __webpack_require__(62);
	var toLength = __webpack_require__(29);
	var toIndex = __webpack_require__(428);
	var gOPN = __webpack_require__(83).f;
	var dP = __webpack_require__(28).f;
	var arrayFill = __webpack_require__(192);
	var setToStringTag = __webpack_require__(97);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var core = __webpack_require__(51);
	var LIBRARY = __webpack_require__(74);
	var wksExt = __webpack_require__(429);
	var defineProperty = __webpack_require__(28).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(118);
	var ITERATOR = __webpack_require__(24)('iterator');
	var Iterators = __webpack_require__(96);
	module.exports = __webpack_require__(51).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(73);
	var step = __webpack_require__(413);
	var Iterators = __webpack_require__(96);
	var toIObject = __webpack_require__(46);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(202)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(152);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(121);
	util.inherits = __webpack_require__(64);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(3008)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(568);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(153).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(567);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(90);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(90);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76), __webpack_require__(571).setImmediate, (function() { return this; }())))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(565);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(219);
	exports.Duplex = __webpack_require__(90);
	exports.Transform = __webpack_require__(566);
	exports.PassThrough = __webpack_require__(2915);


/***/ }),
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(3010);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(3009);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(76)))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-chartjs v2.8.7
	 * (c) 2017 Jakub Juszczak <jakub@posteo.de>
	 * http://vue-chartjs.org
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(161), __webpack_require__(1518));
		else if(typeof define === 'function' && define.amd)
			define("VueChartJs", ["vue", "chart.js"], factory);
		else if(typeof exports === 'object')
			exports["VueChartJs"] = factory(require("vue"), require("chart.js"));
		else
			root["VueChartJs"] = factory(root["vue"], root["chart.js"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.mixins = exports.Scatter = exports.Bubble = exports.Radar = exports.PolarArea = exports.Pie = exports.Line = exports.Doughnut = exports.HorizontalBar = exports.Bar = exports.VueCharts = undefined;
	
		var _Bar = __webpack_require__(1);
	
		var _Bar2 = _interopRequireDefault(_Bar);
	
		var _HorizontalBar = __webpack_require__(7);
	
		var _HorizontalBar2 = _interopRequireDefault(_HorizontalBar);
	
		var _Doughnut = __webpack_require__(8);
	
		var _Doughnut2 = _interopRequireDefault(_Doughnut);
	
		var _Line = __webpack_require__(9);
	
		var _Line2 = _interopRequireDefault(_Line);
	
		var _Pie = __webpack_require__(10);
	
		var _Pie2 = _interopRequireDefault(_Pie);
	
		var _PolarArea = __webpack_require__(11);
	
		var _PolarArea2 = _interopRequireDefault(_PolarArea);
	
		var _Radar = __webpack_require__(12);
	
		var _Radar2 = _interopRequireDefault(_Radar);
	
		var _Bubble = __webpack_require__(13);
	
		var _Bubble2 = _interopRequireDefault(_Bubble);
	
		var _Scatter = __webpack_require__(14);
	
		var _Scatter2 = _interopRequireDefault(_Scatter);
	
		var _index = __webpack_require__(15);
	
		var _index2 = _interopRequireDefault(_index);
	
		var _package = __webpack_require__(55);
	
		var _package2 = _interopRequireDefault(_package);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var VueCharts = {
		  version: _package2.default.version,
		  Bar: _Bar2.default,
		  HorizontalBar: _HorizontalBar2.default,
		  Doughnut: _Doughnut2.default,
		  Line: _Line2.default,
		  Pie: _Pie2.default,
		  PolarArea: _PolarArea2.default,
		  Radar: _Radar2.default,
		  Bubble: _Bubble2.default,
		  Scatter: _Scatter2.default,
		  mixins: _index2.default
		};
	
		exports.default = VueCharts;
		exports.VueCharts = VueCharts;
		exports.Bar = _Bar2.default;
		exports.HorizontalBar = _HorizontalBar2.default;
		exports.Doughnut = _Doughnut2.default;
		exports.Line = _Line2.default;
		exports.Pie = _Pie2.default;
		exports.PolarArea = _PolarArea2.default;
		exports.Radar = _Radar2.default;
		exports.Bubble = _Bubble2.default;
		exports.Scatter = _Scatter2.default;
		exports.mixins = _index2.default;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
		  props: {
		    chartId: {
		      default: 'bar-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          yAxes: [{
		            ticks: {
		              beginAtZero: true
		            },
		            gridLines: {
		              display: false
		            }
		          }],
		          xAxes: [{
		            gridLines: {
		              display: false
		            },
		            categoryPercentage: 0.5,
		            barPercentage: 0.2
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'bar',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.mergeOptions = mergeOptions;
	
		var _lodash = __webpack_require__(5);
	
		var _lodash2 = _interopRequireDefault(_lodash);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function mergeOptions(obj, src) {
		  return (0, _lodash2.default)(obj, src);
		}
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global, module) {/**
		 * lodash (Custom Build) <https://lodash.com/>
		 * Build: `lodash modularize exports="npm" -o ./`
		 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
		 * Released under MIT license <https://lodash.com/license>
		 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
		 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
		 */
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
		/** Used to match `RegExp` flags from their coerced string values. */
		var reFlags = /\w*$/;
	
		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;
	
		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;
	
		/** Used to identify `toStringTag` values supported by `_.clone`. */
		var cloneableTags = {};
		cloneableTags[argsTag] = cloneableTags[arrayTag] =
		cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
		cloneableTags[boolTag] = cloneableTags[dateTag] =
		cloneableTags[float32Tag] = cloneableTags[float64Tag] =
		cloneableTags[int8Tag] = cloneableTags[int16Tag] =
		cloneableTags[int32Tag] = cloneableTags[mapTag] =
		cloneableTags[numberTag] = cloneableTags[objectTag] =
		cloneableTags[regexpTag] = cloneableTags[setTag] =
		cloneableTags[stringTag] = cloneableTags[symbolTag] =
		cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
		cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
		cloneableTags[errorTag] = cloneableTags[funcTag] =
		cloneableTags[weakMapTag] = false;
	
		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();
	
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;
	
		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding('util');
		  } catch (e) {}
		}());
	
		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
		/**
		 * Adds the key-value `pair` to `map`.
		 *
		 * @private
		 * @param {Object} map The map to modify.
		 * @param {Array} pair The key-value pair to add.
		 * @returns {Object} Returns `map`.
		 */
		function addMapEntry(map, pair) {
		  // Don't return `map.set` because it's not chainable in IE 11.
		  map.set(pair[0], pair[1]);
		  return map;
		}
	
		/**
		 * Adds `value` to `set`.
		 *
		 * @private
		 * @param {Object} set The set to modify.
		 * @param {*} value The value to add.
		 * @returns {Object} Returns `set`.
		 */
		function addSetEntry(set, value) {
		  // Don't return `set.add` because it's not chainable in IE 11.
		  set.add(value);
		  return set;
		}
	
		/**
		 * A faster alternative to `Function#apply`, this function invokes `func`
		 * with the `this` binding of `thisArg` and the arguments of `args`.
		 *
		 * @private
		 * @param {Function} func The function to invoke.
		 * @param {*} thisArg The `this` binding of `func`.
		 * @param {Array} args The arguments to invoke `func` with.
		 * @returns {*} Returns the result of `func`.
		 */
		function apply(func, thisArg, args) {
		  switch (args.length) {
		    case 0: return func.call(thisArg);
		    case 1: return func.call(thisArg, args[0]);
		    case 2: return func.call(thisArg, args[0], args[1]);
		    case 3: return func.call(thisArg, args[0], args[1], args[2]);
		  }
		  return func.apply(thisArg, args);
		}
	
		/**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */
		function arrayEach(array, iteratee) {
		  var index = -1,
		      length = array ? array.length : 0;
	
		  while (++index < length) {
		    if (iteratee(array[index], index, array) === false) {
		      break;
		    }
		  }
		  return array;
		}
	
		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;
	
		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}
	
		/**
		 * A specialized version of `_.reduce` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {*} [accumulator] The initial value.
		 * @param {boolean} [initAccum] Specify using the first element of `array` as
		 *  the initial value.
		 * @returns {*} Returns the accumulated value.
		 */
		function arrayReduce(array, iteratee, accumulator, initAccum) {
		  var index = -1,
		      length = array ? array.length : 0;
	
		  if (initAccum && length) {
		    accumulator = array[++index];
		  }
		  while (++index < length) {
		    accumulator = iteratee(accumulator, array[index], index, array);
		  }
		  return accumulator;
		}
	
		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);
	
		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}
	
		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}
	
		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}
	
		/**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */
		function isHostObject(value) {
		  // Many host objects are `Object` objects that can coerce to strings
		  // despite having improperly defined `toString` methods.
		  var result = false;
		  if (value != null && typeof value.toString != 'function') {
		    try {
		      result = !!(value + '');
		    } catch (e) {}
		  }
		  return result;
		}
	
		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);
	
		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}
	
		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}
	
		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);
	
		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}
	
		/** Used for built-in method references. */
		var arrayProto = Array.prototype,
		    funcProto = Function.prototype,
		    objectProto = Object.prototype;
	
		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];
	
		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to infer the `Object` constructor. */
		var objectCtorString = funcToString.call(Object);
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);
	
		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    Symbol = root.Symbol,
		    Uint8Array = root.Uint8Array,
		    getPrototype = overArg(Object.getPrototypeOf, Object),
		    objectCreate = Object.create,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
		    splice = arrayProto.splice;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols,
		    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
		    nativeKeys = overArg(Object.keys, Object),
		    nativeMax = Math.max;
	
		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView'),
		    Map = getNative(root, 'Map'),
		    Promise = getNative(root, 'Promise'),
		    Set = getNative(root, 'Set'),
		    WeakMap = getNative(root, 'WeakMap'),
		    nativeCreate = getNative(Object, 'create');
	
		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		}
	
		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  return this.has(key) && delete this.__data__[key];
		}
	
		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}
	
		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
		}
	
		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}
	
		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;
	
		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		}
	
		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  return true;
		}
	
		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  return index < 0 ? undefined : data[index][1];
		}
	
		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}
	
		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}
	
		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;
	
		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries ? entries.length : 0;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}
	
		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  return getMapData(this, key)['delete'](key);
		}
	
		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}
	
		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}
	
		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  getMapData(this, key).set(key, value);
		  return this;
		}
	
		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;
	
		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  this.__data__ = new ListCache(entries);
		}
	
		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		}
	
		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  return this.__data__['delete'](key);
		}
	
		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}
	
		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}
	
		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var cache = this.__data__;
		  if (cache instanceof ListCache) {
		    var pairs = cache.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      return this;
		    }
		    cache = this.__data__ = new MapCache(pairs);
		  }
		  cache.set(key, value);
		  return this;
		}
	
		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;
	
		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
		  // Safari 9 makes `arguments.length` enumerable in strict mode.
		  var result = (isArray(value) || isArguments(value))
		    ? baseTimes(value.length, String)
		    : [];
	
		  var length = result.length,
		      skipIndexes = !!length;
	
		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		/**
		 * This function is like `assignValue` except that it doesn't assign
		 * `undefined` values.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignMergeValue(object, key, value) {
		  if ((value !== undefined && !eq(object[key], value)) ||
		      (typeof key == 'number' && value === undefined && !(key in object))) {
		    object[key] = value;
		  }
		}
	
		/**
		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignValue(object, key, value) {
		  var objValue = object[key];
		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
		      (value === undefined && !(key in object))) {
		    object[key] = value;
		  }
		}
	
		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}
	
		/**
		 * The base implementation of `_.assign` without support for multiple sources
		 * or `customizer` functions.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @returns {Object} Returns `object`.
		 */
		function baseAssign(object, source) {
		  return object && copyObject(source, keys(source), object);
		}
	
		/**
		 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
		 * traversed objects.
		 *
		 * @private
		 * @param {*} value The value to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @param {boolean} [isFull] Specify a clone including symbols.
		 * @param {Function} [customizer] The function to customize cloning.
		 * @param {string} [key] The key of `value`.
		 * @param {Object} [object] The parent object of `value`.
		 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
		 * @returns {*} Returns the cloned value.
		 */
		function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
		  var result;
		  if (customizer) {
		    result = object ? customizer(value, key, object, stack) : customizer(value);
		  }
		  if (result !== undefined) {
		    return result;
		  }
		  if (!isObject(value)) {
		    return value;
		  }
		  var isArr = isArray(value);
		  if (isArr) {
		    result = initCloneArray(value);
		    if (!isDeep) {
		      return copyArray(value, result);
		    }
		  } else {
		    var tag = getTag(value),
		        isFunc = tag == funcTag || tag == genTag;
	
		    if (isBuffer(value)) {
		      return cloneBuffer(value, isDeep);
		    }
		    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
		      if (isHostObject(value)) {
		        return object ? value : {};
		      }
		      result = initCloneObject(isFunc ? {} : value);
		      if (!isDeep) {
		        return copySymbols(value, baseAssign(result, value));
		      }
		    } else {
		      if (!cloneableTags[tag]) {
		        return object ? value : {};
		      }
		      result = initCloneByTag(value, tag, baseClone, isDeep);
		    }
		  }
		  // Check for circular references and return its corresponding clone.
		  stack || (stack = new Stack);
		  var stacked = stack.get(value);
		  if (stacked) {
		    return stacked;
		  }
		  stack.set(value, result);
	
		  if (!isArr) {
		    var props = isFull ? getAllKeys(value) : keys(value);
		  }
		  arrayEach(props || value, function(subValue, key) {
		    if (props) {
		      key = subValue;
		      subValue = value[key];
		    }
		    // Recursively populate clone (susceptible to call stack limits).
		    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
		  });
		  return result;
		}
	
		/**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} prototype The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */
		function baseCreate(proto) {
		  return isObject(proto) ? objectCreate(proto) : {};
		}
	
		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}
	
		/**
		 * The base implementation of `getTag`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  return objectToString.call(value);
		}
	
		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}
	
		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
		}
	
		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		/**
		 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeysIn(object) {
		  if (!isObject(object)) {
		    return nativeKeysIn(object);
		  }
		  var isProto = isPrototype(object),
		      result = [];
	
		  for (var key in object) {
		    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		/**
		 * The base implementation of `_.merge` without support for multiple sources.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} [customizer] The function to customize merged values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMerge(object, source, srcIndex, customizer, stack) {
		  if (object === source) {
		    return;
		  }
		  if (!(isArray(source) || isTypedArray(source))) {
		    var props = baseKeysIn(source);
		  }
		  arrayEach(props || source, function(srcValue, key) {
		    if (props) {
		      key = srcValue;
		      srcValue = source[key];
		    }
		    if (isObject(srcValue)) {
		      stack || (stack = new Stack);
		      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
		    }
		    else {
		      var newValue = customizer
		        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
		        : undefined;
	
		      if (newValue === undefined) {
		        newValue = srcValue;
		      }
		      assignMergeValue(object, key, newValue);
		    }
		  });
		}
	
		/**
		 * A specialized version of `baseMerge` for arrays and objects which performs
		 * deep merges and tracks traversed objects enabling objects with circular
		 * references to be merged.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {string} key The key of the value to merge.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} mergeFunc The function to merge values.
		 * @param {Function} [customizer] The function to customize assigned values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
		  var objValue = object[key],
		      srcValue = source[key],
		      stacked = stack.get(srcValue);
	
		  if (stacked) {
		    assignMergeValue(object, key, stacked);
		    return;
		  }
		  var newValue = customizer
		    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
		    : undefined;
	
		  var isCommon = newValue === undefined;
	
		  if (isCommon) {
		    newValue = srcValue;
		    if (isArray(srcValue) || isTypedArray(srcValue)) {
		      if (isArray(objValue)) {
		        newValue = objValue;
		      }
		      else if (isArrayLikeObject(objValue)) {
		        newValue = copyArray(objValue);
		      }
		      else {
		        isCommon = false;
		        newValue = baseClone(srcValue, true);
		      }
		    }
		    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
		      if (isArguments(objValue)) {
		        newValue = toPlainObject(objValue);
		      }
		      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
		        isCommon = false;
		        newValue = baseClone(srcValue, true);
		      }
		      else {
		        newValue = objValue;
		      }
		    }
		    else {
		      isCommon = false;
		    }
		  }
		  if (isCommon) {
		    // Recursively merge objects and arrays (susceptible to call stack limits).
		    stack.set(srcValue, newValue);
		    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
		    stack['delete'](srcValue);
		  }
		  assignMergeValue(object, key, newValue);
		}
	
		/**
		 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @returns {Function} Returns the new function.
		 */
		function baseRest(func, start) {
		  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
		  return function() {
		    var args = arguments,
		        index = -1,
		        length = nativeMax(args.length - start, 0),
		        array = Array(length);
	
		    while (++index < length) {
		      array[index] = args[start + index];
		    }
		    index = -1;
		    var otherArgs = Array(start + 1);
		    while (++index < start) {
		      otherArgs[index] = args[index];
		    }
		    otherArgs[start] = array;
		    return apply(func, this, otherArgs);
		  };
		}
	
		/**
		 * Creates a clone of  `buffer`.
		 *
		 * @private
		 * @param {Buffer} buffer The buffer to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Buffer} Returns the cloned buffer.
		 */
		function cloneBuffer(buffer, isDeep) {
		  if (isDeep) {
		    return buffer.slice();
		  }
		  var result = new buffer.constructor(buffer.length);
		  buffer.copy(result);
		  return result;
		}
	
		/**
		 * Creates a clone of `arrayBuffer`.
		 *
		 * @private
		 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
		 * @returns {ArrayBuffer} Returns the cloned array buffer.
		 */
		function cloneArrayBuffer(arrayBuffer) {
		  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
		  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
		  return result;
		}
	
		/**
		 * Creates a clone of `dataView`.
		 *
		 * @private
		 * @param {Object} dataView The data view to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned data view.
		 */
		function cloneDataView(dataView, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
		  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
		}
	
		/**
		 * Creates a clone of `map`.
		 *
		 * @private
		 * @param {Object} map The map to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned map.
		 */
		function cloneMap(map, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
		  return arrayReduce(array, addMapEntry, new map.constructor);
		}
	
		/**
		 * Creates a clone of `regexp`.
		 *
		 * @private
		 * @param {Object} regexp The regexp to clone.
		 * @returns {Object} Returns the cloned regexp.
		 */
		function cloneRegExp(regexp) {
		  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
		  result.lastIndex = regexp.lastIndex;
		  return result;
		}
	
		/**
		 * Creates a clone of `set`.
		 *
		 * @private
		 * @param {Object} set The set to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned set.
		 */
		function cloneSet(set, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
		  return arrayReduce(array, addSetEntry, new set.constructor);
		}
	
		/**
		 * Creates a clone of the `symbol` object.
		 *
		 * @private
		 * @param {Object} symbol The symbol object to clone.
		 * @returns {Object} Returns the cloned symbol object.
		 */
		function cloneSymbol(symbol) {
		  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
		}
	
		/**
		 * Creates a clone of `typedArray`.
		 *
		 * @private
		 * @param {Object} typedArray The typed array to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned typed array.
		 */
		function cloneTypedArray(typedArray, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
		  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
		}
	
		/**
		 * Copies the values of `source` to `array`.
		 *
		 * @private
		 * @param {Array} source The array to copy values from.
		 * @param {Array} [array=[]] The array to copy values to.
		 * @returns {Array} Returns `array`.
		 */
		function copyArray(source, array) {
		  var index = -1,
		      length = source.length;
	
		  array || (array = Array(length));
		  while (++index < length) {
		    array[index] = source[index];
		  }
		  return array;
		}
	
		/**
		 * Copies properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy properties from.
		 * @param {Array} props The property identifiers to copy.
		 * @param {Object} [object={}] The object to copy properties to.
		 * @param {Function} [customizer] The function to customize copied values.
		 * @returns {Object} Returns `object`.
		 */
		function copyObject(source, props, object, customizer) {
		  object || (object = {});
	
		  var index = -1,
		      length = props.length;
	
		  while (++index < length) {
		    var key = props[index];
	
		    var newValue = customizer
		      ? customizer(object[key], source[key], key, object, source)
		      : undefined;
	
		    assignValue(object, key, newValue === undefined ? source[key] : newValue);
		  }
		  return object;
		}
	
		/**
		 * Copies own symbol properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy symbols from.
		 * @param {Object} [object={}] The object to copy symbols to.
		 * @returns {Object} Returns `object`.
		 */
		function copySymbols(source, object) {
		  return copyObject(source, getSymbols(source), object);
		}
	
		/**
		 * Creates a function like `_.assign`.
		 *
		 * @private
		 * @param {Function} assigner The function to assign values.
		 * @returns {Function} Returns the new assigner function.
		 */
		function createAssigner(assigner) {
		  return baseRest(function(object, sources) {
		    var index = -1,
		        length = sources.length,
		        customizer = length > 1 ? sources[length - 1] : undefined,
		        guard = length > 2 ? sources[2] : undefined;
	
		    customizer = (assigner.length > 3 && typeof customizer == 'function')
		      ? (length--, customizer)
		      : undefined;
	
		    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
		      customizer = length < 3 ? undefined : customizer;
		      length = 1;
		    }
		    object = Object(object);
		    while (++index < length) {
		      var source = sources[index];
		      if (source) {
		        assigner(object, source, index, customizer);
		      }
		    }
		    return object;
		  });
		}
	
		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}
	
		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}
	
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}
	
		/**
		 * Creates an array of the own enumerable symbol properties of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;
	
		// Fallback for data views, maps, sets, and weak maps in IE 11,
		// for data views in Edge < 14, and promises in Node.js.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = objectToString.call(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : undefined;
	
		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}
	
		/**
		 * Initializes an array clone.
		 *
		 * @private
		 * @param {Array} array The array to clone.
		 * @returns {Array} Returns the initialized clone.
		 */
		function initCloneArray(array) {
		  var length = array.length,
		      result = array.constructor(length);
	
		  // Add properties assigned by `RegExp#exec`.
		  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
		    result.index = array.index;
		    result.input = array.input;
		  }
		  return result;
		}
	
		/**
		 * Initializes an object clone.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneObject(object) {
		  return (typeof object.constructor == 'function' && !isPrototype(object))
		    ? baseCreate(getPrototype(object))
		    : {};
		}
	
		/**
		 * Initializes an object clone based on its `toStringTag`.
		 *
		 * **Note:** This function only supports cloning values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @param {string} tag The `toStringTag` of the object to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneByTag(object, tag, cloneFunc, isDeep) {
		  var Ctor = object.constructor;
		  switch (tag) {
		    case arrayBufferTag:
		      return cloneArrayBuffer(object);
	
		    case boolTag:
		    case dateTag:
		      return new Ctor(+object);
	
		    case dataViewTag:
		      return cloneDataView(object, isDeep);
	
		    case float32Tag: case float64Tag:
		    case int8Tag: case int16Tag: case int32Tag:
		    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
		      return cloneTypedArray(object, isDeep);
	
		    case mapTag:
		      return cloneMap(object, isDeep, cloneFunc);
	
		    case numberTag:
		    case stringTag:
		      return new Ctor(object);
	
		    case regexpTag:
		      return cloneRegExp(object);
	
		    case setTag:
		      return cloneSet(object, isDeep, cloneFunc);
	
		    case symbolTag:
		      return cloneSymbol(object);
		  }
		}
	
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}
	
		/**
		 * Checks if the given arguments are from an iteratee call.
		 *
		 * @private
		 * @param {*} value The potential iteratee value argument.
		 * @param {*} index The potential iteratee index or key argument.
		 * @param {*} object The potential iteratee object argument.
		 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
		 *  else `false`.
		 */
		function isIterateeCall(value, index, object) {
		  if (!isObject(object)) {
		    return false;
		  }
		  var type = typeof index;
		  if (type == 'number'
		        ? (isArrayLike(object) && isIndex(index, object.length))
		        : (type == 'string' && index in object)
		      ) {
		    return eq(object[index], value);
		  }
		  return false;
		}
	
		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}
	
		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}
	
		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
		  return value === proto;
		}
	
		/**
		 * This function is like
		 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * except that it includes inherited enumerable properties.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function nativeKeysIn(object) {
		  var result = [];
		  if (object != null) {
		    for (var key in Object(object)) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}
	
		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}
	
		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		function isArguments(value) {
		  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
		  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
		    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
		}
	
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;
	
		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}
	
		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}
	
		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;
	
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 8-9 which returns 'object' for typed array and other constructors.
		  var tag = isObject(value) ? objectToString.call(value) : '';
		  return tag == funcTag || tag == genTag;
		}
	
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
	
		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}
	
		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return !!value && typeof value == 'object';
		}
	
		/**
		 * Checks if `value` is a plain object, that is, an object created by the
		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.8.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * _.isPlainObject(new Foo);
		 * // => false
		 *
		 * _.isPlainObject([1, 2, 3]);
		 * // => false
		 *
		 * _.isPlainObject({ 'x': 0, 'y': 0 });
		 * // => true
		 *
		 * _.isPlainObject(Object.create(null));
		 * // => true
		 */
		function isPlainObject(value) {
		  if (!isObjectLike(value) ||
		      objectToString.call(value) != objectTag || isHostObject(value)) {
		    return false;
		  }
		  var proto = getPrototype(value);
		  if (proto === null) {
		    return true;
		  }
		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
		  return (typeof Ctor == 'function' &&
		    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
		}
	
		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
		/**
		 * Converts `value` to a plain object flattening inherited enumerable string
		 * keyed properties of `value` to own properties of the plain object.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {Object} Returns the converted plain object.
		 * @example
		 *
		 * function Foo() {
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.assign({ 'a': 1 }, new Foo);
		 * // => { 'a': 1, 'b': 2 }
		 *
		 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
		 * // => { 'a': 1, 'b': 2, 'c': 3 }
		 */
		function toPlainObject(value) {
		  return copyObject(value, keysIn(value));
		}
	
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}
	
		/**
		 * Creates an array of the own and inherited enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keysIn(new Foo);
		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
		 */
		function keysIn(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
		}
	
		/**
		 * This method is like `_.assign` except that it recursively merges own and
		 * inherited enumerable string keyed properties of source objects into the
		 * destination object. Source properties that resolve to `undefined` are
		 * skipped if a destination value exists. Array and plain object properties
		 * are merged recursively. Other objects and value types are overridden by
		 * assignment. Source objects are applied from left to right. Subsequent
		 * sources overwrite property assignments of previous sources.
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.5.0
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @example
		 *
		 * var object = {
		 *   'a': [{ 'b': 2 }, { 'd': 4 }]
		 * };
		 *
		 * var other = {
		 *   'a': [{ 'c': 3 }, { 'e': 5 }]
		 * };
		 *
		 * _.merge(object, other);
		 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
		 */
		var merge = createAssigner(function(object, source, srcIndex) {
		  baseMerge(object, source, srcIndex);
		});
	
		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}
	
		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}
	
		module.exports = merge;
	
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(6)(module)))
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		module.exports = function(module) {
			if(!module.webpackPolyfill) {
				module.deprecate = function() {};
				module.paths = [];
				// module.parent = undefined by default
				module.children = [];
				module.webpackPolyfill = 1;
			}
			return module;
		}
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'horizontalbar-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          yAxes: [{
		            ticks: {
		              beginAtZero: true
		            },
		            gridLines: {
		              display: false
		            }
		          }],
		          xAxes: [{
		            gridLines: {
		              display: false
		            },
		            categoryPercentage: 0.5,
		            barPercentage: 0.2
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options, type) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'horizontalBar',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'doughnut-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {},
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'doughnut',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'line-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          yAxes: [{
		            ticks: {
		              beginAtZero: true
		            },
		            gridLines: {
		              display: false
		            }
		          }],
		          xAxes: [{
		            gridLines: {
		              display: false
		            }
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'line',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'pie-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {},
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'pie',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'polar-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {},
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'polarArea',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'radar-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {},
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'radar',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'bubble-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          yAxes: [{
		            ticks: {
		              beginAtZero: true
		            },
		            gridLines: {
		              display: false
		            }
		          }],
		          xAxes: [{
		            gridLines: {
		              display: false
		            },
		            categoryPercentage: 0.5,
		            barPercentage: 0.2
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'bubble',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vue = __webpack_require__(2);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _chart = __webpack_require__(3);
	
		var _chart2 = _interopRequireDefault(_chart);
	
		var _options = __webpack_require__(4);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _vue2.default.extend({
		  render: function render(createElement) {
		    return createElement('div', {
		      style: this.styles,
		      class: this.cssClasses
		    }, [createElement('canvas', {
		      attrs: {
		        id: this.chartId,
		        width: this.width,
		        height: this.height
		      },
		      ref: 'canvas'
		    })]);
		  },
	
		  props: {
		    chartId: {
		      default: 'scatter-chart',
		      type: String
		    },
		    width: {
		      default: 400,
		      type: Number
		    },
		    height: {
		      default: 400,
		      type: Number
		    },
		    cssClasses: {
		      type: String,
		      default: ''
		    },
		    styles: {
		      type: Object
		    }
		  },
	
		  data: function data() {
		    return {
		      defaultOptions: {
		        scales: {
		          xAxes: [{
		            type: 'linear',
		            position: 'bottom'
		          }]
		        }
		      },
		      plugins: []
		    };
		  },
	
	
		  methods: {
		    addPlugin: function addPlugin(plugin) {
		      this.plugins.push(plugin);
		    },
		    renderChart: function renderChart(data, options) {
		      var chartOptions = (0, _options.mergeOptions)(this.defaultOptions, options);
	
		      this._chart = new _chart2.default(this.$refs.canvas.getContext('2d'), {
		        type: 'scatter',
		        data: data,
		        options: chartOptions,
		        plugins: this.plugins
		      });
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this._chart) {
		      this._chart.destroy();
		    }
		  }
		});
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _reactiveData = __webpack_require__(16);
	
		var _reactiveData2 = _interopRequireDefault(_reactiveData);
	
		var _reactiveProp = __webpack_require__(54);
	
		var _reactiveProp2 = _interopRequireDefault(_reactiveProp);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  reactiveData: _reactiveData2.default,
		  reactiveProp: _reactiveProp2.default
		};
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keys = __webpack_require__(17);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _stringify = __webpack_require__(52);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = {
		  data: function data() {
		    return {
		      chartData: null
		    };
		  },
	
		  watch: {
		    'chartData': {
		      handler: function handler(newData, oldData) {
		        if (oldData) {
		          var chart = this._chart;
	
		          var newDatasetLabels = newData.datasets.map(function (dataset) {
		            return dataset.label;
		          });
	
		          var oldDatasetLabels = oldData.datasets.map(function (dataset) {
		            return dataset.label;
		          });
	
		          var oldLabels = (0, _stringify2.default)(oldDatasetLabels);
		          var newLabels = (0, _stringify2.default)(newDatasetLabels);
	
		          if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
		            newData.datasets.forEach(function (dataset, i) {
		              var oldDatasetKeys = (0, _keys2.default)(oldData.datasets[i]);
		              var newDatasetKeys = (0, _keys2.default)(dataset);
	
		              var deletionKeys = oldDatasetKeys.filter(function (key) {
		                return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
		              });
	
		              deletionKeys.forEach(function (deletionKey) {
		                delete chart.data.datasets[i][deletionKey];
		              });
	
		              for (var attribute in dataset) {
		                if (dataset.hasOwnProperty(attribute)) {
		                  chart.data.datasets[i][attribute] = dataset[attribute];
		                }
		              }
		            });
	
		            if (newData.hasOwnProperty('labels')) {
		              chart.data.labels = newData.labels;
		            }
		            if (newData.hasOwnProperty('xLabels')) {
		              chart.data.xLabels = newData.xLabels;
		            }
		            if (newData.hasOwnProperty('yLabels')) {
		              chart.data.yLabels = newData.yLabels;
		            }
		            chart.update();
		          } else {
		            chart.destroy();
		            this.renderChart(this.chartData, this.options);
		          }
		        } else {
		          this.renderChart(this.chartData, this.options);
		        }
		      }
		    }
		  }
		};
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(18), __esModule: true };
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(19);
		module.exports = __webpack_require__(39).Object.keys;
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 Object.keys(O)
		var toObject = __webpack_require__(20)
		  , $keys    = __webpack_require__(22);
	
		__webpack_require__(37)('keys', function(){
		  return function keys(it){
		    return $keys(toObject(it));
		  };
		});
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.13 ToObject(argument)
		var defined = __webpack_require__(21);
		module.exports = function(it){
		  return Object(defined(it));
		};
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		// 7.2.1 RequireObjectCoercible(argument)
		module.exports = function(it){
		  if(it == undefined)throw TypeError("Can't call method on  " + it);
		  return it;
		};
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 / 15.2.3.14 Object.keys(O)
		var $keys       = __webpack_require__(23)
		  , enumBugKeys = __webpack_require__(36);
	
		module.exports = Object.keys || function keys(O){
		  return $keys(O, enumBugKeys);
		};
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		var has          = __webpack_require__(24)
		  , toIObject    = __webpack_require__(25)
		  , arrayIndexOf = __webpack_require__(28)(false)
		  , IE_PROTO     = __webpack_require__(32)('IE_PROTO');
	
		module.exports = function(object, names){
		  var O      = toIObject(object)
		    , i      = 0
		    , result = []
		    , key;
		  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
		  // Don't enum bug & hidden keys
		  while(names.length > i)if(has(O, key = names[i++])){
		    ~arrayIndexOf(result, key) || result.push(key);
		  }
		  return result;
		};
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		var hasOwnProperty = {}.hasOwnProperty;
		module.exports = function(it, key){
		  return hasOwnProperty.call(it, key);
		};
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		// to indexed object, toObject with fallback for non-array-like ES3 strings
		var IObject = __webpack_require__(26)
		  , defined = __webpack_require__(21);
		module.exports = function(it){
		  return IObject(defined(it));
		};
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		// fallback for non-array-like ES3 and non-enumerable old V8 strings
		var cof = __webpack_require__(27);
		module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
		  return cof(it) == 'String' ? it.split('') : Object(it);
		};
	
	/***/ },
	/* 27 */
	/***/ function(module, exports) {
	
		var toString = {}.toString;
	
		module.exports = function(it){
		  return toString.call(it).slice(8, -1);
		};
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		// false -> Array#indexOf
		// true  -> Array#includes
		var toIObject = __webpack_require__(25)
		  , toLength  = __webpack_require__(29)
		  , toIndex   = __webpack_require__(31);
		module.exports = function(IS_INCLUDES){
		  return function($this, el, fromIndex){
		    var O      = toIObject($this)
		      , length = toLength(O.length)
		      , index  = toIndex(fromIndex, length)
		      , value;
		    // Array#includes uses SameValueZero equality algorithm
		    if(IS_INCLUDES && el != el)while(length > index){
		      value = O[index++];
		      if(value != value)return true;
		    // Array#toIndex ignores holes, Array#includes - not
		    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
		      if(O[index] === el)return IS_INCLUDES || index || 0;
		    } return !IS_INCLUDES && -1;
		  };
		};
	
	/***/ },
	/* 29 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.15 ToLength
		var toInteger = __webpack_require__(30)
		  , min       = Math.min;
		module.exports = function(it){
		  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
		};
	
	/***/ },
	/* 30 */
	/***/ function(module, exports) {
	
		// 7.1.4 ToInteger
		var ceil  = Math.ceil
		  , floor = Math.floor;
		module.exports = function(it){
		  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
		};
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toInteger = __webpack_require__(30)
		  , max       = Math.max
		  , min       = Math.min;
		module.exports = function(index, length){
		  index = toInteger(index);
		  return index < 0 ? max(index + length, 0) : min(index, length);
		};
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		var shared = __webpack_require__(33)('keys')
		  , uid    = __webpack_require__(35);
		module.exports = function(key){
		  return shared[key] || (shared[key] = uid(key));
		};
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global = __webpack_require__(34)
		  , SHARED = '__core-js_shared__'
		  , store  = global[SHARED] || (global[SHARED] = {});
		module.exports = function(key){
		  return store[key] || (store[key] = {});
		};
	
	/***/ },
	/* 34 */
	/***/ function(module, exports) {
	
		// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		var global = module.exports = typeof window != 'undefined' && window.Math == Math
		  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
		if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		var id = 0
		  , px = Math.random();
		module.exports = function(key){
		  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
		};
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		// IE 8- don't enum bug keys
		module.exports = (
		  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
		).split(',');
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		// most Object methods by ES6 should accept primitives
		var $export = __webpack_require__(38)
		  , core    = __webpack_require__(39)
		  , fails   = __webpack_require__(48);
		module.exports = function(KEY, exec){
		  var fn  = (core.Object || {})[KEY] || Object[KEY]
		    , exp = {};
		  exp[KEY] = exec(fn);
		  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
		};
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global    = __webpack_require__(34)
		  , core      = __webpack_require__(39)
		  , ctx       = __webpack_require__(40)
		  , hide      = __webpack_require__(42)
		  , PROTOTYPE = 'prototype';
	
		var $export = function(type, name, source){
		  var IS_FORCED = type & $export.F
		    , IS_GLOBAL = type & $export.G
		    , IS_STATIC = type & $export.S
		    , IS_PROTO  = type & $export.P
		    , IS_BIND   = type & $export.B
		    , IS_WRAP   = type & $export.W
		    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
		    , expProto  = exports[PROTOTYPE]
		    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
		    , key, own, out;
		  if(IS_GLOBAL)source = name;
		  for(key in source){
		    // contains in native
		    own = !IS_FORCED && target && target[key] !== undefined;
		    if(own && key in exports)continue;
		    // export native or passed
		    out = own ? target[key] : source[key];
		    // prevent global pollution for namespaces
		    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
		    // bind timers to global for call from export context
		    : IS_BIND && own ? ctx(out, global)
		    // wrap global constructors for prevent change them in library
		    : IS_WRAP && target[key] == out ? (function(C){
		      var F = function(a, b, c){
		        if(this instanceof C){
		          switch(arguments.length){
		            case 0: return new C;
		            case 1: return new C(a);
		            case 2: return new C(a, b);
		          } return new C(a, b, c);
		        } return C.apply(this, arguments);
		      };
		      F[PROTOTYPE] = C[PROTOTYPE];
		      return F;
		    // make static versions for prototype methods
		    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
		    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
		    if(IS_PROTO){
		      (exports.virtual || (exports.virtual = {}))[key] = out;
		      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
		      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
		    }
		  }
		};
		// type bitmap
		$export.F = 1;   // forced
		$export.G = 2;   // global
		$export.S = 4;   // static
		$export.P = 8;   // proto
		$export.B = 16;  // bind
		$export.W = 32;  // wrap
		$export.U = 64;  // safe
		$export.R = 128; // real proto method for `library` 
		module.exports = $export;
	
	/***/ },
	/* 39 */
	/***/ function(module, exports) {
	
		var core = module.exports = {version: '2.4.0'};
		if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
		// optional / simple context binding
		var aFunction = __webpack_require__(41);
		module.exports = function(fn, that, length){
		  aFunction(fn);
		  if(that === undefined)return fn;
		  switch(length){
		    case 1: return function(a){
		      return fn.call(that, a);
		    };
		    case 2: return function(a, b){
		      return fn.call(that, a, b);
		    };
		    case 3: return function(a, b, c){
		      return fn.call(that, a, b, c);
		    };
		  }
		  return function(/* ...args */){
		    return fn.apply(that, arguments);
		  };
		};
	
	/***/ },
	/* 41 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
		  return it;
		};
	
	/***/ },
	/* 42 */
	/***/ function(module, exports, __webpack_require__) {
	
		var dP         = __webpack_require__(43)
		  , createDesc = __webpack_require__(51);
		module.exports = __webpack_require__(47) ? function(object, key, value){
		  return dP.f(object, key, createDesc(1, value));
		} : function(object, key, value){
		  object[key] = value;
		  return object;
		};
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
		var anObject       = __webpack_require__(44)
		  , IE8_DOM_DEFINE = __webpack_require__(46)
		  , toPrimitive    = __webpack_require__(50)
		  , dP             = Object.defineProperty;
	
		exports.f = __webpack_require__(47) ? Object.defineProperty : function defineProperty(O, P, Attributes){
		  anObject(O);
		  P = toPrimitive(P, true);
		  anObject(Attributes);
		  if(IE8_DOM_DEFINE)try {
		    return dP(O, P, Attributes);
		  } catch(e){ /* empty */ }
		  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
		  if('value' in Attributes)O[P] = Attributes.value;
		  return O;
		};
	
	/***/ },
	/* 44 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(45);
		module.exports = function(it){
		  if(!isObject(it))throw TypeError(it + ' is not an object!');
		  return it;
		};
	
	/***/ },
	/* 45 */
	/***/ function(module, exports) {
	
		module.exports = function(it){
		  return typeof it === 'object' ? it !== null : typeof it === 'function';
		};
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = !__webpack_require__(47) && !__webpack_require__(48)(function(){
		  return Object.defineProperty(__webpack_require__(49)('div'), 'a', {get: function(){ return 7; }}).a != 7;
		});
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		// Thank's IE8 for his funny defineProperty
		module.exports = !__webpack_require__(48)(function(){
		  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
		});
	
	/***/ },
	/* 48 */
	/***/ function(module, exports) {
	
		module.exports = function(exec){
		  try {
		    return !!exec();
		  } catch(e){
		    return true;
		  }
		};
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(45)
		  , document = __webpack_require__(34).document
		  // in old IE typeof document.createElement is 'object'
		  , is = isObject(document) && isObject(document.createElement);
		module.exports = function(it){
		  return is ? document.createElement(it) : {};
		};
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.1 ToPrimitive(input [, PreferredType])
		var isObject = __webpack_require__(45);
		// instead of the ES6 spec version, we didn't implement @@toPrimitive case
		// and the second argument - flag - preferred type is a string
		module.exports = function(it, S){
		  if(!isObject(it))return it;
		  var fn, val;
		  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
		  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
		  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
		  throw TypeError("Can't convert object to primitive value");
		};
	
	/***/ },
	/* 51 */
	/***/ function(module, exports) {
	
		module.exports = function(bitmap, value){
		  return {
		    enumerable  : !(bitmap & 1),
		    configurable: !(bitmap & 2),
		    writable    : !(bitmap & 4),
		    value       : value
		  };
		};
	
	/***/ },
	/* 52 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(53), __esModule: true };
	
	/***/ },
	/* 53 */
	/***/ function(module, exports, __webpack_require__) {
	
		var core  = __webpack_require__(39)
		  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
		module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
		  return $JSON.stringify.apply($JSON, arguments);
		};
	
	/***/ },
	/* 54 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keys = __webpack_require__(17);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _stringify = __webpack_require__(52);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = {
		  props: {
		    chartData: {
		      required: true
		    }
		  },
		  watch: {
		    'chartData': {
		      handler: function handler(newData, oldData) {
		        if (oldData) {
		          var chart = this._chart;
	
		          var newDatasetLabels = newData.datasets.map(function (dataset) {
		            return dataset.label;
		          });
	
		          var oldDatasetLabels = oldData.datasets.map(function (dataset) {
		            return dataset.label;
		          });
	
		          var oldLabels = (0, _stringify2.default)(oldDatasetLabels);
		          var newLabels = (0, _stringify2.default)(newDatasetLabels);
	
		          if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
		            newData.datasets.forEach(function (dataset, i) {
		              var oldDatasetKeys = (0, _keys2.default)(oldData.datasets[i]);
		              var newDatasetKeys = (0, _keys2.default)(dataset);
	
		              var deletionKeys = oldDatasetKeys.filter(function (key) {
		                return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
		              });
	
		              deletionKeys.forEach(function (deletionKey) {
		                delete chart.data.datasets[i][deletionKey];
		              });
	
		              for (var attribute in dataset) {
		                if (dataset.hasOwnProperty(attribute)) {
		                  chart.data.datasets[i][attribute] = dataset[attribute];
		                }
		              }
		            });
	
		            if (newData.hasOwnProperty('labels')) {
		              chart.data.labels = newData.labels;
		            }
		            if (newData.hasOwnProperty('xLabels')) {
		              chart.data.xLabels = newData.xLabels;
		            }
		            if (newData.hasOwnProperty('yLabels')) {
		              chart.data.yLabels = newData.yLabels;
		            }
		            chart.update();
		          } else {
		            chart.destroy();
		            this.renderChart(this.chartData, this.options);
		          }
		        } else {
		          this.renderChart(this.chartData, this.options);
		        }
		      }
		    }
		  }
		};
	
	/***/ },
	/* 55 */
	/***/ function(module, exports) {
	
		module.exports = {
			"name": "vue-chartjs",
			"version": "2.8.7",
			"description": "Vue.js wrapper for chart.js for creating beautiful charts.",
			"author": "Jakub Juszczak <jakub@posteo.de>",
			"homepage": "http://vue-chartjs.org",
			"license": "MIT",
			"contributors": [
				{
					"name": "Thorsten Lünborg",
					"web": "https://github.com/LinusBorg"
				},
				{
					"name": "Juan Carlos Alonso",
					"web": "https://github.com/jcalonso"
				}
			],
			"maintainers": [
				{
					"name": "Jakub Juszczak",
					"email": "jakub@posteo.de",
					"web": "http://www.jakubjuszczak.de"
				}
			],
			"repository": {
				"type": "git",
				"url": "git+ssh://git@github.com:apertureless/vue-chartjs.git"
			},
			"bugs": {
				"url": "https://github.com/apertureless/vue-chartjs/issues"
			},
			"keywords": [
				"ChartJs",
				"Vue",
				"Visualisation",
				"Wrapper",
				"Charts"
			],
			"main": "dist/vue-chartjs.js",
			"unpkg": "dist/vue-chartjs.full.min.js",
			"module": "es/index.js",
			"jsnext:main": "es/index.js",
			"files": [
				"src",
				"dist",
				"es"
			],
			"scripts": {
				"dev": "node build/dev-server.js",
				"build": "yarn run release && yarn run build:es",
				"build:es": "cross-env BABEL_ENV=es babel src --out-dir es",
				"unit": "karma start test/unit/karma.conf.js --single-run",
				"e2e": "node test/e2e/runner.js",
				"test": "npm run unit",
				"lint": "eslint --ext .js,.vue src test/unit/specs test/e2e/specs",
				"release": "webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js",
				"prepublish": "yarn run lint && yarn run test && yarn run build"
			},
			"dependencies": {
				"lodash.merge": "^4.6.0"
			},
			"peerDependencies": {
				"chart.js": "^2.7.0",
				"vue": "^2.4.4"
			},
			"devDependencies": {
				"babel-cli": "^6.24.1",
				"babel-core": "^6.25.0",
				"babel-loader": "^7.0.0",
				"babel-plugin-transform-object-assign": "^6.22.0",
				"babel-plugin-transform-runtime": "^6.23.0",
				"babel-preset-es2015": "^6.24.1",
				"babel-preset-stage-2": "^6.24.1",
				"babel-runtime": "^6.23.0",
				"chai": "^3.5.0",
				"chart.js": "^2.7.0",
				"chromedriver": "^2.28.0",
				"connect-history-api-fallback": "^1.1.0",
				"cross-env": "^3.2.4",
				"cross-spawn": "^5.1.0",
				"css-loader": "^0.28.0",
				"eslint": "^3.19.0",
				"eslint-config-standard": "^10.2.1",
				"eslint-friendly-formatter": "^2.0.7",
				"eslint-loader": "^1.7.1",
				"eslint-plugin-html": "^2.0.1",
				"eslint-plugin-import": "^2.2.0",
				"eslint-plugin-node": "^4.2.2",
				"eslint-plugin-promise": "^3.5.0",
				"eslint-plugin-standard": "^3.0.1",
				"eventsource-polyfill": "^0.9.6",
				"express": "^4.15.2",
				"extract-text-webpack-plugin": "^1.0.1",
				"file-loader": "^0.10.1",
				"function-bind": "^1.0.2",
				"html-webpack-plugin": "^2.28.0",
				"http-proxy-middleware": "^0.17.4",
				"inject-loader": "^3.0.0",
				"isparta-loader": "^2.0.0",
				"jasmine-core": "^2.5.2",
				"json-loader": "^0.5.4",
				"karma": "^1.5.0",
				"karma-coverage": "^1.1.1",
				"karma-jasmine": "^1.0.2",
				"karma-mocha": "^1.2.0",
				"karma-phantomjs-launcher": "^1.0.4",
				"karma-sinon-chai": "^1.2.0",
				"karma-sourcemap-loader": "^0.3.7",
				"karma-spec-reporter": "0.0.30",
				"karma-webpack": "1.8.1",
				"lolex": "^1.6.0",
				"mocha": "^3.1.0",
				"nightwatch": "^0.9.14",
				"ora": "^1.2.0",
				"phantomjs-prebuilt": "^2.1.13",
				"selenium-server": "^3.3.1",
				"shelljs": "^0.7.7",
				"sinon": "^2.1.0",
				"sinon-chai": "^2.9.0",
				"url-loader": "^0.5.8",
				"vue": "^2.4.4",
				"vue-hot-reload-api": "^2.1.0",
				"vue-html-loader": "^1.2.4",
				"vue-loader": "^12.2.2",
				"vue-style-loader": "^3.0.1",
				"vue-template-compiler": "^2.4.2",
				"webpack": "^1.13.2",
				"webpack-dev-middleware": "^1.10.1",
				"webpack-hot-middleware": "^2.17.1",
				"webpack-merge": "1.1.1"
			},
			"engines": {
				"node": ">=6.9.0"
			},
			"babel": {
				"presets": [
					"es2015"
				]
			},
			"browserify": {
				"transform": [
					"babelify"
				]
			},
			"greenkeeper": {
				"ignore": [
					"extract-text-webpack-plugin",
					"karma-webpack",
					"webpack",
					"webpack-merge"
				]
			}
		};
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	var settle = __webpack_require__(640);
	var buildURL = __webpack_require__(643);
	var parseHeaders = __webpack_require__(649);
	var isURLSameOrigin = __webpack_require__(647);
	var createError = __webpack_require__(230);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(642);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(645);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(639);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1573), __esModule: true };

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1577), __esModule: true };

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1578), __esModule: true };

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(127);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(127);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(127);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(127);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(170);
	var Transform = __webpack_require__(171);
	var inherits = __webpack_require__(64);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(19);
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {Point} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param chart {chart} the chart
	 * @param handler {Function} the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var datasets = chart.data.datasets;
		var meta, i, j, ilen, jlen;
	
		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!chart.isDatasetVisible(i)) {
				continue;
			}
	
			meta = chart.getDatasetMeta(i);
			for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
				var element = meta.data[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param items {ChartElement[]} elements to filter
	 * @param position {Point} the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param chart {Chart} the chart to look at elements from
	 * @param position {Point} the point to be nearest to
	 * @param intersect {Boolean} if true, only consider items that intersect the position
	 * @param distanceMetric {Function} function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
	
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {String} axis the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart.data.datasets.forEach(function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var element = meta.data[items[0]._index];
	
				// don't count items that are skipped (null data)
				if (element && !element._view.skip) {
					elements.push(element);
				}
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	module.exports = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);
	
				// We have multiple items at the same distance from the event. Now sort by smallest
				if (nearestItems.length > 1) {
					nearestItems.sort(function(a, b) {
						var sizeA = a.getArea();
						var sizeB = b.getArea();
						var ret = sizeA - sizeB;
	
						if (ret === 0) {
							// if equal sort by dataset index
							ret = a._datasetIndex - b._datasetIndex;
						}
	
						return ret;
					});
				}
	
				// Return only 1 item
				return nearestItems.slice(0, 1);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var helpers = __webpack_require__(19);
	
	defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	module.exports = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {Number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {Array} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Object} chart - The chart instance for which plugins should be called.
		 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {Boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {Array} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers.clone(defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	/**
	 * Plugin extension hooks.
	 * @interface IPlugin
	 * @since 2.1.0
	 */
	/**
	 * @method IPlugin#beforeInit
	 * @desc Called before initializing `chart`.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterInit
	 * @desc Called after `chart` has been initialized and before the first update.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeUpdate
	 * @desc Called before updating `chart`. If any plugin returns `false`, the update
	 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart update.
	 */
	/**
	 * @method IPlugin#afterUpdate
	 * @desc Called after `chart` has been updated and before rendering. Note that this
	 * hook will not be called if the chart update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsUpdate
	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
	 * the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} false to cancel the datasets update.
	 * @since version 2.1.5
	*/
	/**
	 * @method IPlugin#afterDatasetsUpdate
	 * @desc Called after the `chart` datasets have been updated. Note that this hook
	 * will not be called if the datasets update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#beforeDatasetUpdate
	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
	 * returns `false`, the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetUpdate
	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
	 * that this hook will not be called if the datasets update has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeLayout
	 * @desc Called before laying out `chart`. If any plugin returns `false`,
	 * the layout update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart layout.
	 */
	/**
	 * @method IPlugin#afterLayout
	 * @desc Called after the `chart` has been layed out. Note that this hook will not
	 * be called if the layout update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeRender
	 * @desc Called before rendering `chart`. If any plugin returns `false`,
	 * the rendering is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart rendering.
	 */
	/**
	 * @method IPlugin#afterRender
	 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
	 * that this hook will not be called if the rendering has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDraw
	 * @desc Called before drawing `chart` at every animation frame specified by the given
	 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
	 * another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart drawing.
	 */
	/**
	 * @method IPlugin#afterDraw
	 * @desc Called after the `chart` has been drawn for the specific easing value. Note
	 * that this hook will not be called if the drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsDraw
	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
	 * the datasets drawing is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetsDraw
	 * @desc Called after the `chart` datasets have been drawn. Note that this hook
	 * will not be called if the datasets drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetDraw
	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
	 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
	 * is cancelled until another `render` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetDraw
	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
	 * (datasets are drawn in the reverse order). Note that this hook will not be called
	 * if the datasets drawing has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeTooltipDraw
	 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
	 * the tooltip drawing is cancelled until another `render` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Object} args.tooltip - The tooltip.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
	 */
	/**
	 * @method IPlugin#afterTooltipDraw
	 * @desc Called after drawing the `tooltip`. Note that this hook will not
	 * be called if the tooltip drawing has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Object} args.tooltip - The tooltip.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeEvent
	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
	 * the event will be discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterEvent
	 * @desc Called after the `event` has been consumed. Note that this hook
	 * will not be called if the `event` has been previously discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#resize
	 * @desc Called after the chart as been resized.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#destroy
	 * @desc Called after the chart as been destroyed.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(19);
	var basic = __webpack_require__(1548);
	var dom = __webpack_require__(1549);
	
	// @TODO Make possible to select another platform at build time.
	var implementation = dom._enabled ? dom : basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	module.exports = helpers.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {Object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {Boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {String} type - The ({@link IEvent}) type to listen for
		 * @param {Function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart -Chart from which to remove the listener
		 * @param {String} type - The ({@link IEvent}) type to remove
		 * @param {Function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	/**
	 * @interface IPlatform
	 * Allows abstracting platform dependencies away from the chart
	 * @borrows Chart.platform.acquireContext as acquireContext
	 * @borrows Chart.platform.releaseContext as releaseContext
	 * @borrows Chart.platform.addEventListener as addEventListener
	 * @borrows Chart.platform.removeEventListener as removeEventListener
	 */
	
	/**
	 * @interface IEvent
	 * @prop {String} type - The event type name, possible values are:
	 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
	 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
	 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
	 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
	 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
	 */


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(1562);
	var string = __webpack_require__(1560);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(32).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(48) && !__webpack_require__(71)(function () {
	  return Object.defineProperty(__webpack_require__(174)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(93);
	var ITERATOR = __webpack_require__(33)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(110);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(65);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(33)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 388 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(49);
	var anObject = __webpack_require__(65);
	var getKeys = __webpack_require__(113);
	
	module.exports = __webpack_require__(48) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(391);
	var hiddenKeys = __webpack_require__(175).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(79);
	var toIObject = __webpack_require__(94);
	var arrayIndexOf = __webpack_require__(1581)(false);
	var IE_PROTO = __webpack_require__(183)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(65);
	var isObject = __webpack_require__(58);
	var newPromiseCapability = __webpack_require__(179);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(72);


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(32);
	var core = __webpack_require__(26);
	var dP = __webpack_require__(49);
	var DESCRIPTORS = __webpack_require__(48);
	var SPECIES = __webpack_require__(33)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(65);
	var aFunction = __webpack_require__(109);
	var SPECIES = __webpack_require__(33)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	var defined = __webpack_require__(130);
	var fails = __webpack_require__(71);
	var spaces = __webpack_require__(185);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(70);
	var invoke = __webpack_require__(1590);
	var html = __webpack_require__(382);
	var cel = __webpack_require__(174);
	var global = __webpack_require__(32);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(110)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(58);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(50);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(30);
	var toAbsoluteIndex = __webpack_require__(88);
	var toLength = __webpack_require__(29);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(81);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(34);
	var toObject = __webpack_require__(30);
	var IObject = __webpack_require__(119);
	var toLength = __webpack_require__(29);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(34);
	var isObject = __webpack_require__(22);
	var invoke = __webpack_require__(410);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(28).f;
	var create = __webpack_require__(82);
	var redefineAll = __webpack_require__(86);
	var ctx = __webpack_require__(52);
	var anInstance = __webpack_require__(80);
	var forOf = __webpack_require__(81);
	var $iterDefine = __webpack_require__(202);
	var step = __webpack_require__(413);
	var setSpecies = __webpack_require__(87);
	var DESCRIPTORS = __webpack_require__(27);
	var fastKey = __webpack_require__(75).fastKey;
	var validate = __webpack_require__(99);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(118);
	var from = __webpack_require__(402);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(86);
	var getWeak = __webpack_require__(75).getWeak;
	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(22);
	var anInstance = __webpack_require__(80);
	var forOf = __webpack_require__(81);
	var createArrayMethod = __webpack_require__(59);
	var $has = __webpack_require__(43);
	var validate = __webpack_require__(99);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(138);
	var isObject = __webpack_require__(22);
	var toLength = __webpack_require__(29);
	var ctx = __webpack_require__(52);
	var IS_CONCAT_SPREADABLE = __webpack_require__(24)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(27) && !__webpack_require__(21)(function () {
	  return Object.defineProperty(__webpack_require__(195)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 410 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(22);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(17);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 413 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(204);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 415 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 416 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(84);
	var gOPS = __webpack_require__(142);
	var pIE = __webpack_require__(120);
	var toObject = __webpack_require__(30);
	var IObject = __webpack_require__(119);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(21)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(28);
	var anObject = __webpack_require__(17);
	var getKeys = __webpack_require__(84);
	
	module.exports = __webpack_require__(27) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(46);
	var gOPN = __webpack_require__(83).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(43);
	var toIObject = __webpack_require__(46);
	var arrayIndexOf = __webpack_require__(134)(false);
	var IE_PROTO = __webpack_require__(208)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(84);
	var toIObject = __webpack_require__(46);
	var isEnum = __webpack_require__(120).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(83);
	var gOPS = __webpack_require__(142);
	var anObject = __webpack_require__(17);
	var Reflect = __webpack_require__(18).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(18).parseFloat;
	var $trim = __webpack_require__(98).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(212) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(18).parseInt;
	var $trim = __webpack_require__(98).trim;
	var ws = __webpack_require__(212);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(22);
	var newPromiseCapability = __webpack_require__(206);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(29);
	var repeat = __webpack_require__(211);
	var defined = __webpack_require__(60);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(62);
	var toLength = __webpack_require__(29);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(24);


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(405);
	var validate = __webpack_require__(99);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(135)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(27) && /./g.flags != 'g') __webpack_require__(28).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(137)
	});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(405);
	var validate = __webpack_require__(99);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(135)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(59)(0);
	var redefine = __webpack_require__(39);
	var meta = __webpack_require__(75);
	var assign = __webpack_require__(417);
	var weak = __webpack_require__(407);
	var isObject = __webpack_require__(22);
	var fails = __webpack_require__(21);
	var validate = __webpack_require__(99);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(135)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(2925)
	
	var md5 = toConstructor(__webpack_require__(1827))
	var rmd160 = toConstructor(__webpack_require__(2922))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 435 */,
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var mersenne = __webpack_require__(2885);
	
	/**
	 *
	 * @namespace faker.random
	 */
	function Random (faker, seed) {
	  // Use a user provided seed if it exists
	  if (seed) {
	    if (Array.isArray(seed) && seed.length) {
	      mersenne.seed_array(seed);
	    }
	    else {
	      mersenne.seed(seed);
	    }
	  }
	  /**
	   * returns a single random number based on a max number or range
	   *
	   * @method faker.random.number
	   * @param {mixed} options
	   */
	  this.number = function (options) {
	
	    if (typeof options === "number") {
	      options = {
	        max: options
	      };
	    }
	
	    options = options || {};
	
	    if (typeof options.min === "undefined") {
	      options.min = 0;
	    }
	
	    if (typeof options.max === "undefined") {
	      options.max = 99999;
	    }
	    if (typeof options.precision === "undefined") {
	      options.precision = 1;
	    }
	
	    // Make the range inclusive of the max value
	    var max = options.max;
	    if (max >= 0) {
	      max += options.precision;
	    }
	
	    var randomNumber = options.precision * Math.floor(
	      mersenne.rand(max / options.precision, options.min / options.precision));
	
	    return randomNumber;
	
	  }
	
	  /**
	   * takes an array and returns a random element of the array
	   *
	   * @method faker.random.arrayElement
	   * @param {array} array
	   */
	  this.arrayElement = function (array) {
	      array = array || ["a", "b", "c"];
	      var r = faker.random.number({ max: array.length - 1 });
	      return array[r];
	  }
	
	  /**
	   * takes an object and returns the randomly key or value
	   *
	   * @method faker.random.objectElement
	   * @param {object} object
	   * @param {mixed} field
	   */
	  this.objectElement = function (object, field) {
	      object = object || { "foo": "bar", "too": "car" };
	      var array = Object.keys(object);
	      var key = faker.random.arrayElement(array);
	
	      return field === "key" ? key : object[key];
	  }
	
	  /**
	   * uuid
	   *
	   * @method faker.random.uuid
	   */
	  this.uuid = function () {
	      var self = this;
	      var RFC4122_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	      var replacePlaceholders = function (placeholder) {
	          var random = self.number({ min: 0, max: 15 });
	          var value = placeholder == 'x' ? random : (random &0x3 | 0x8);
	          return value.toString(16);
	      };
	      return RFC4122_TEMPLATE.replace(/[xy]/g, replacePlaceholders);
	  }
	
	  /**
	   * boolean
	   *
	   * @method faker.random.boolean
	   */
	  this.boolean = function () {
	      return !!faker.random.number(1)
	  }
	
	  // TODO: have ability to return specific type of word? As in: noun, adjective, verb, etc
	  /**
	   * word
	   *
	   * @method faker.random.word
	   * @param {string} type
	   */
	  this.word = function randomWord (type) {
	
	    var wordMethods = [
	    'commerce.department',
	    'commerce.productName',
	    'commerce.productAdjective',
	    'commerce.productMaterial',
	    'commerce.product',
	    'commerce.color',
	
	    'company.catchPhraseAdjective',
	    'company.catchPhraseDescriptor',
	    'company.catchPhraseNoun',
	    'company.bsAdjective',
	    'company.bsBuzz',
	    'company.bsNoun',
	    'address.streetSuffix',
	    'address.county',
	    'address.country',
	    'address.state',
	
	    'finance.accountName',
	    'finance.transactionType',
	    'finance.currencyName',
	
	    'hacker.noun',
	    'hacker.verb',
	    'hacker.adjective',
	    'hacker.ingverb',
	    'hacker.abbreviation',
	
	    'name.jobDescriptor',
	    'name.jobArea',
	    'name.jobType'];
	
	    // randomly pick from the many faker methods that can generate words
	    var randomWordMethod = faker.random.arrayElement(wordMethods);
	    return faker.fake('{{' + randomWordMethod + '}}');
	
	  }
	
	  /**
	   * randomWords
	   *
	   * @method faker.random.words
	   * @param {number} count defaults to a random value between 1 and 3
	   */
	  this.words = function randomWords (count) {
	    var words = [];
	    if (typeof count === "undefined") {
	      count = faker.random.number({min:1, max: 3});
	    }
	    for (var i = 0; i<count; i++) {
	      words.push(faker.random.word());
	    }
	    return words.join(' ');
	  }
	
	  /**
	   * locale
	   *
	   * @method faker.random.image
	   */
	  this.image = function randomImage () {
	    return faker.image.image();
	  }
	
	  /**
	   * locale
	   *
	   * @method faker.random.locale
	   */
	  this.locale = function randomLocale () {
	    return faker.random.arrayElement(Object.keys(faker.locales));
	  };
	
	  /**
	   * alphaNumeric
	   *
	   * @method faker.random.alphaNumeric
	   */
	  this.alphaNumeric = function alphaNumeric() {
	    return faker.random.arrayElement(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]);
	  }
	
	  return this;
	
	}
	
	module['exports'] = Random;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 437 */,
/* 438 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(2900),
	    isArguments = __webpack_require__(150),
	    keysIn = __webpack_require__(441);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.6 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(150),
	    isArray = __webpack_require__(100);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'MMMM [de] D [de] YYYY',
	            LLL : 'MMMM [de] D [de] YYYY h:mm A',
	            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka horan', 'ek hor'],
	            'hh': [number + ' horanim', number + ' horam'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(152);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(2917);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(218).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(568);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(153).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(121);
	util.inherits = __webpack_require__(64);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(4037);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(2916);
	var destroyImpl = __webpack_require__(567);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(90);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(569).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(90);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(569).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(76)))

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(90);
	
	/*<replacement>*/
	var util = __webpack_require__(121);
	util.inherits = __webpack_require__(64);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(152);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(218).EventEmitter;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(153).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var defaultParams = {
	  title: '',
	  text: '',
	  type: null,
	  allowOutsideClick: false,
	  showConfirmButton: true,
	  showCancelButton: false,
	  closeOnConfirm: true,
	  closeOnCancel: true,
	  confirmButtonText: 'OK',
	  confirmButtonColor: '#8CD4F5',
	  cancelButtonText: 'Cancel',
	  imageUrl: null,
	  imageSize: null,
	  timer: null,
	  customClass: '',
	  html: false,
	  animation: true,
	  allowEscapeKey: true,
	  inputType: 'text',
	  inputPlaceholder: '',
	  inputValue: '',
	  showLoaderOnConfirm: false
	};
	
	exports['default'] = defaultParams;
	module.exports = exports['default'];

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(2923);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {/* xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported XLSX */
	/*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */
	var XLSX = {};
	(function make_xlsx(XLSX){
	XLSX.version = '0.11.19';
	var current_codepage = 1200, current_ansi = 1252;
	/*global cptable:true */
	if(true) {
		if(typeof cptable === 'undefined') global.cptable = __webpack_require__(4032);
	}
	
	var VALID_ANSI = [ 874, 932, 936, 949, 950 ];
	for(var i = 0; i <= 8; ++i) VALID_ANSI.push(1250 + i);
	/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
	var CS2CP = ({
	0:    1252, /* ANSI */
	1:   65001, /* DEFAULT */
	2:   65001, /* SYMBOL */
	77:  10000, /* MAC */
	128:   932, /* SHIFTJIS */
	129:   949, /* HANGUL */
	130:  1361, /* JOHAB */
	134:   936, /* GB2312 */
	136:   950, /* CHINESEBIG5 */
	161:  1253, /* GREEK */
	162:  1254, /* TURKISH */
	163:  1258, /* VIETNAMESE */
	177:  1255, /* HEBREW */
	178:  1256, /* ARABIC */
	186:  1257, /* BALTIC */
	204:  1251, /* RUSSIAN */
	222:   874, /* THAI */
	238:  1250, /* EASTEUROPE */
	255:  1252, /* OEM */
	69:   6969  /* MISC */
	});
	
	var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
	function reset_ansi() { set_ansi(1252); }
	
	var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	function reset_cp() { set_cp(1200); reset_ansi(); }
	
	function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }
	
	function utf16leread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
		return o.join("");
	}
	function utf16beread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
		return o.join("");
	}
	
	var debom = function(data) {
		var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
		if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
		if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
		if(c1 == 0xFEFF) return data.slice(1);
		return data;
	};
	
	var _getchar = function _gc1(x) { return String.fromCharCode(x); };
	if(typeof cptable !== 'undefined') {
		set_cp = function(cp) { current_codepage = cp; };
		debom = function(data) {
			if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return cptable.utils.decode(1200, char_codes(data.slice(2))); }
			return data;
		};
		_getchar = function _gc2(x) {
			if(current_codepage === 1200) return String.fromCharCode(x);
			return cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
		};
	}
	var DENSE = null;
	var DIF_XL = true;
	var Base64 = (function make_b64(){
		var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
		return {
			encode: function(input) {
				var o = "";
				var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
				for(var i = 0; i < input.length; ) {
					c1 = input.charCodeAt(i++);
					c2 = input.charCodeAt(i++);
					c3 = input.charCodeAt(i++);
					e1 = c1 >> 2;
					e2 = ((c1 & 3) << 4) | (c2 >> 4);
					e3 = ((c2 & 15) << 2) | (c3 >> 6);
					e4 = c3 & 63;
					if (isNaN(c2)) { e3 = e4 = 64; }
					else if (isNaN(c3)) { e4 = 64; }
					o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
				}
				return o;
			},
			decode: function b64_decode(input) {
				var o = "";
				var c1=0, c2=0, c3=0;
				var e1=0, e2=0, e3=0, e4=0;
				input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
				for(var i = 0; i < input.length;) {
					e1 = map.indexOf(input.charAt(i++));
					e2 = map.indexOf(input.charAt(i++));
					e3 = map.indexOf(input.charAt(i++));
					e4 = map.indexOf(input.charAt(i++));
					c1 = (e1 << 2) | (e2 >> 4);
					c2 = ((e2 & 15) << 4) | (e3 >> 2);
					c3 = ((e3 & 3) << 6) | e4;
					o += String.fromCharCode(c1);
					if (e3 !== 64) { o += String.fromCharCode(c2); }
					if (e4 !== 64) { o += String.fromCharCode(c3); }
				}
				return o;
			}
		};
	})();
	var has_buf = (typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && process.versions.node);
	
	function new_raw_buf(len) {
		/* jshint -W056 */
		// $FlowIgnore
		return new (has_buf ? Buffer : Array)(len);
		/* jshint +W056 */
	}
	
	function s2a(s) {
		if(has_buf) return new Buffer(s, "binary");
		return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
	}
	
	function s2ab(s) {
		if(typeof ArrayBuffer === 'undefined') return s2a(s);
		var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
		for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	}
	
	function a2s(data) {
		if(Array.isArray(data)) return data.map(_chr).join("");
		var o = []; for(var i = 0; i < data.length; ++i) o[i] = _chr(data[i]); return o.join("");
	}
	
	function a2u(data) {
		if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
		return new Uint8Array(data);
	}
	
	function ab2a(data) {
		if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
		if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	var o = new Array(data.length);
		for(var i = 0; i < data.length; ++i) o[i] = data[i];
		return o;
	}
	
	var bconcat = function(bufs) { return [].concat.apply([], bufs); };
	
	var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
	/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	var SSF = ({});
	var make_ssf = function make_ssf(SSF){
	SSF.version = '0.10.0';
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	function isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	var days = [
		['Sun', 'Sunday'],
		['Mon', 'Monday'],
		['Tue', 'Tuesday'],
		['Wed', 'Wednesday'],
		['Thu', 'Thursday'],
		['Fri', 'Friday'],
		['Sat', 'Saturday']
	];
	var months = [
		['J', 'Jan', 'January'],
		['F', 'Feb', 'February'],
		['M', 'Mar', 'March'],
		['A', 'Apr', 'April'],
		['M', 'May', 'May'],
		['J', 'Jun', 'June'],
		['J', 'Jul', 'July'],
		['A', 'Aug', 'August'],
		['S', 'Sep', 'September'],
		['O', 'Oct', 'October'],
		['N', 'Nov', 'November'],
		['D', 'Dec', 'December']
	];
	function init_table(t) {
		t[0]=  'General';
		t[1]=  '0';
		t[2]=  '0.00';
		t[3]=  '#,##0';
		t[4]=  '#,##0.00';
		t[9]=  '0%';
		t[10]= '0.00%';
		t[11]= '0.00E+00';
		t[12]= '# ?/?';
		t[13]= '# ??/??';
		t[14]= 'm/d/yy';
		t[15]= 'd-mmm-yy';
		t[16]= 'd-mmm';
		t[17]= 'mmm-yy';
		t[18]= 'h:mm AM/PM';
		t[19]= 'h:mm:ss AM/PM';
		t[20]= 'h:mm';
		t[21]= 'h:mm:ss';
		t[22]= 'm/d/yy h:mm';
		t[37]= '#,##0 ;(#,##0)';
		t[38]= '#,##0 ;[Red](#,##0)';
		t[39]= '#,##0.00;(#,##0.00)';
		t[40]= '#,##0.00;[Red](#,##0.00)';
		t[45]= 'mm:ss';
		t[46]= '[h]:mm:ss';
		t[47]= 'mmss.0';
		t[48]= '##0.0E+0';
		t[49]= '@';
		t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
		t[65535]= 'General';
	}
	
	var table_fmt = {};
	init_table(table_fmt);
	function frac(x, D, mixed) {
		var sgn = x < 0 ? -1 : 1;
		var B = x * sgn;
		var P_2 = 0, P_1 = 1, P = 0;
		var Q_2 = 1, Q_1 = 0, Q = 0;
		var A = Math.floor(B);
		while(Q_1 < D) {
			A = Math.floor(B);
			P = A * P_1 + P_2;
			Q = A * Q_1 + Q_2;
			if((B - A) < 0.00000005) break;
			B = 1 / (B - A);
			P_2 = P_1; P_1 = P;
			Q_2 = Q_1; Q_1 = Q;
		}
		if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
		if(!mixed) return [0, sgn * P, Q];
		var q = Math.floor(sgn * P/Q);
		return [q, sgn*P - q*Q, Q];
	}
	function parse_date_code(v,opts,b2) {
		if(v > 2958465 || v < 0) return null;
		var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
		var dout=[];
		var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
		if(Math.abs(out.u) < 1e-6) out.u = 0;
		if(opts && opts.date1904) date += 1462;
		if(out.u > 0.9999) {
			out.u = 0;
			if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
		}
		if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
		else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
		else {
			if(date > 60) --date;
			/* 1 = Jan 1 1900 in Gregorian */
			var d = new Date(1900, 0, 1);
			d.setDate(d.getDate() + date - 1);
			dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
			dow = d.getDay();
			if(date < 60) dow = (dow + 6) % 7;
			if(b2) dow = fix_hijri(d, dout);
		}
		out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
		out.S = time % 60; time = Math.floor(time / 60);
		out.M = time % 60; time = Math.floor(time / 60);
		out.H = time;
		out.q = dow;
		return out;
	}
	SSF.parse_date_code = parse_date_code;
	var basedate = new Date(1899, 11, 31, 0, 0, 0);
	var dnthresh = basedate.getTime();
	var base1904 = new Date(1900, 2, 1, 0, 0, 0);
	function datenum_local(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1461*24*60*60*1000;
		else if(v >= base1904) epoch += 24*60*60*1000;
		return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
	}
	function general_fmt_int(v) { return v.toString(10); }
	SSF._general_int = general_fmt_int;
	var general_fmt_num = (function make_general_fmt_num() {
	var gnr1 = /\.(\d*[1-9])0+$/, gnr2 = /\.0*$/, gnr4 = /\.(\d*[1-9])0+/, gnr5 = /\.0*[Ee]/, gnr6 = /(E[+-])(\d)$/;
	function gfn2(v) {
		var w = (v<0?12:11);
		var o = gfn5(v.toFixed(12)); if(o.length <= w) return o;
		o = v.toPrecision(10); if(o.length <= w) return o;
		return v.toExponential(5);
	}
	function gfn3(v) {
		var o = v.toFixed(11).replace(gnr1,".$1");
		if(o.length > (v<0?12:11)) o = v.toPrecision(6);
		return o;
	}
	function gfn4(o) {
		for(var i = 0; i != o.length; ++i) if((o.charCodeAt(i) | 0x20) === 101) return o.replace(gnr4,".$1").replace(gnr5,"E").replace("e","E").replace(gnr6,"$10$2");
		return o;
	}
	function gfn5(o) {
		return o.indexOf(".") > -1 ? o.replace(gnr2,"").replace(gnr1,".$1") : o;
	}
	return function general_fmt_num(v) {
		var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
		if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
		else if(Math.abs(V) <= 9) o = gfn2(v);
		else if(V === 10) o = v.toFixed(10).substr(0,12);
		else o = gfn3(v);
		return gfn5(gfn4(o));
	};})();
	SSF._general_num = general_fmt_num;
	function general_fmt(v, opts) {
		switch(typeof v) {
			case 'string': return v;
			case 'boolean': return v ? "TRUE" : "FALSE";
			case 'number': return (v|0) === v ? general_fmt_int(v) : general_fmt_num(v);
			case 'undefined': return "";
			case 'object':
				if(v == null) return "";
				if(v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
		}
		throw new Error("unsupported value in General format: " + v);
	}
	SSF._general = general_fmt;
	function fix_hijri() { return 0; }
	/*jshint -W086 */
	function write_date(type, fmt, val, ss0) {
		var o="", ss=0, tt=0, y = val.y, out, outl = 0;
		switch(type) {
			case 98: /* 'b' buddhist year */
				y = val.y + 543;
				/* falls through */
			case 121: /* 'y' year */
			switch(fmt.length) {
				case 1: case 2: out = y % 100; outl = 2; break;
				default: out = y % 10000; outl = 4; break;
			} break;
			case 109: /* 'm' month */
			switch(fmt.length) {
				case 1: case 2: out = val.m; outl = fmt.length; break;
				case 3: return months[val.m-1][1];
				case 5: return months[val.m-1][0];
				default: return months[val.m-1][2];
			} break;
			case 100: /* 'd' day */
			switch(fmt.length) {
				case 1: case 2: out = val.d; outl = fmt.length; break;
				case 3: return days[val.q][0];
				default: return days[val.q][1];
			} break;
			case 104: /* 'h' 12-hour */
			switch(fmt.length) {
				case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 72: /* 'H' 24-hour */
			switch(fmt.length) {
				case 1: case 2: out = val.H; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 77: /* 'M' minutes */
			switch(fmt.length) {
				case 1: case 2: out = val.M; outl = fmt.length; break;
				default: throw 'bad minute format: ' + fmt;
			} break;
			case 115: /* 's' seconds */
				if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
				if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
	if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
				else tt = ss0 === 1 ? 10 : 1;
				ss = Math.round((tt)*(val.S + val.u));
				if(ss >= 60*tt) ss = 0;
				if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
				o = pad0(ss,2 + ss0);
				if(fmt === 'ss') return o.substr(0,2);
				return "." + o.substr(2,fmt.length-1);
			case 90: /* 'Z' absolute time */
			switch(fmt) {
				case '[h]': case '[hh]': out = val.D*24+val.H; break;
				case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
				case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
				default: throw 'bad abstime format: ' + fmt;
			} outl = fmt.length === 3 ? 1 : 2; break;
			case 101: /* 'e' era */
				out = y; outl = 1;
		}
		if(outl > 0) return pad0(out, outl); else return "";
	}
	/*jshint +W086 */
	function commaify(s) {
		var w = 3;
		if(s.length <= w) return s;
		var j = (s.length % w), o = s.substr(0,j);
		for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
		return o;
	}
	var write_num = (function make_write_num(){
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_cm(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_exp(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(o.indexOf("e") === -1) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				while(o.substr(0,2) === "0.") {
					o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
					o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
				}
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
		var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
		var myn = (rr - base*den), myd = den;
		return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
		return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.([0#]+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
		var o = "", cc;
		for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
			case 35: break;
			case 63: o+= " "; break;
			case 48: o+= "0"; break;
			default: o+= String.fromCharCode(cc);
		}
		return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 0;
		}
		return Math.round((val-Math.floor(val))*Math.pow(10,d));
	}
	function carry(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 1;
		}
		return 0;
	}
	function flr(val) { if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0)); return ""+Math.floor(val); }
	function write_num_flt(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_flt('n', ffmt, val);
			return '(' + write_num_flt('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = pad0r(val,0); if(o === "0") o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
			o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_flt(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = pad0r(val, 0);
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			ri = dec(val, r[1].length);
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
		}
		switch(fmt) {
			case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
			case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
			case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp2(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(!o.match(/[Ee]/)) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_int('n', ffmt, val);
			return '(' + write_num_int('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = (""+val); if(val === 0) o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
	o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
			o = o.replace(/\.(\d*)$/,function($$, $1) {
	return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_int(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = "" + val;
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
		}
		switch(fmt) {
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
			default:
				if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	return function write_num(type, fmt, val) {
		return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	};})();
	function split_fmt(fmt) {
		var out = [];
		var in_str = false/*, cc*/;
		for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
			case 34: /* '"' */
				in_str = !in_str; break;
			case 95: case 42: case 92: /* '_' '*' '\\' */
				++i; break;
			case 59: /* ';' */
				out[out.length] = fmt.substr(j,i-j);
				j = i+1;
		}
		out[out.length] = fmt.substr(j);
		if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
		return out;
	}
	SSF._split = split_fmt;
	var abstime = /\[[HhMmSs]*\]/;
	function fmt_is_date(fmt) {
		var i = 0, /*cc = 0,*/ c = "", o = "";
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': if(isgeneral(fmt, i)) i+= 6; i++; break;
				case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) ++i; ++i; break;
				case '\\': i+=2; break;
				case '_': i+=2; break;
				case '@': ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
				case 'A': case 'a':
					if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
					if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
					++i; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.match(abstime)) return true;
					break;
				case '.':
					/* falls through */
				case '0': case '#':
					while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
					break;
				case '?': while(fmt.charAt(++i) === c){/* empty */} break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
				case '(': case ')': ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
				case ' ': ++i; break;
				default: ++i; break;
			}
		}
		return false;
	}
	SSF.is_date = fmt_is_date;
	function eval_fmt(fmt, v, opts, flen) {
		var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
		var hr='H';
		/* Tokenize */
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': /* General */
					if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
					out[out.length] = {t:'G', v:'General'}; i+=7; break;
				case '"': /* Literal text */
					for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
					out[out.length] = {t:'t', v:o}; ++i; break;
				case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
					out[out.length] = {t:t, v:w}; ++i; break;
				case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
				case '@': /* Text Placeholder */
					out[out.length] = {t:'T', v:v}; ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
						if(dt==null) { dt=parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
						out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
					}
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					c = c.toLowerCase();
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
					if(v < 0) return "";
					if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
					o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
					if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
					if(c === 'h') c = hr;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case 'A': case 'a':
					var q={t:c, v:c};
					if(dt==null) dt=parse_date_code(v, opts);
					if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
					else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
					else { q.t = "t"; ++i; }
					if(dt==null && q.t === 'T') return "";
					out[out.length] = q; lst = c; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
					if(o.match(abstime)) {
						if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
						out[out.length] = {t:'Z', v:o.toLowerCase()};
						lst = o.charAt(1);
					} else if(o.indexOf("$") > -1) {
						o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
						if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
					}
					break;
				/* Numbers */
				case '.':
					if(dt != null) {
						o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
						out[out.length] = {t:'s', v:o}; break;
					}
					/* falls through */
				case '0': case '#':
					o = c; while((++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) || (c=='\\' && fmt.charAt(i+1) == "-" && i < fmt.length - 2 && "0#".indexOf(fmt.charAt(i+2))>-1)) o += c;
					out[out.length] = {t:'n', v:o}; break;
				case '?':
					o = c; while(fmt.charAt(++i) === c) o+=c;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
				case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
					out[out.length] = {t:'D', v:o}; break;
				case ' ': out[out.length] = {t:c, v:c}; ++i; break;
				default:
					if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
					out[out.length] = {t:'t', v:c}; ++i; break;
			}
		}
		var bt = 0, ss0 = 0, ssm;
		for(i=out.length-1, lst='t'; i >= 0; --i) {
			switch(out[i].t) {
				case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
				case 's':
					if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
					if(bt < 3) bt = 3;
				/* falls through */
				case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
				case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
				case 'X': /*if(out[i].v === "B2");*/
					break;
				case 'Z':
					if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
					if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
					if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
			}
		}
		switch(bt) {
			case 0: break;
			case 1:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				if(dt.M >=  60) { dt.M = 0; ++dt.H; }
				break;
			case 2:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				break;
		}
		/* replace fields */
		var nstr = "", jj;
		for(i=0; i < out.length; ++i) {
			switch(out[i].t) {
				case 't': case 'T': case ' ': case 'D': break;
				case 'X': out[i].v = ""; out[i].t = ";"; break;
				case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
	out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
					out[i].t = 't'; break;
				case 'n': case '(': case '?':
					jj = i+1;
					while(out[jj] != null && (
						(c=out[jj].t) === "?" || c === "D" ||
						((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
						(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
						(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
					)) {
						out[i].v += out[jj].v;
						out[jj] = {v:"", t:";"}; ++jj;
					}
					nstr += out[i].v;
					i = jj-1; break;
				case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
			}
		}
		var vv = "", myv, ostr;
		if(nstr.length > 0) {
			if(nstr.charCodeAt(0) == 40) /* '(' */ {
				myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
				ostr = write_num('(', nstr, myv);
			} else {
				myv = (v<0 && flen > 1 ? -v : v);
				ostr = write_num('n', nstr, myv);
				if(myv < 0 && out[0] && out[0].t == 't') {
					ostr = ostr.substr(1);
					out[0].v = "-" + out[0].v;
				}
			}
			jj=ostr.length-1;
			var decpt = out.length;
			for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
			var lasti=out.length;
			if(decpt === out.length && ostr.indexOf("E") === -1) {
				for(i=out.length-1; i>= 0;--i) {
					if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
					if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
					else if(jj < 0) out[i].v = "";
					else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			}
			else if(decpt !== out.length && ostr.indexOf("E") === -1) {
				jj = ostr.indexOf(".")-1;
				for(i=decpt; i>= 0; --i) {
					if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
					vv = out[i].v.substr(j+1);
					for(; j>=0; --j) {
						if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
				jj = ostr.indexOf(".")+1;
				for(i=decpt; i<out.length; ++i) {
					if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
					vv = out[i].v.substr(0,j);
					for(; j<out[i].v.length; ++j) {
						if(jj<ostr.length) vv += ostr.charAt(jj++);
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
			}
		}
		for(i=0; i<out.length; ++i) if(out[i] != null && 'n(?'.indexOf(out[i].t)>-1) {
			myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
			out[i].v = write_num(out[i].t, out[i].v, myv);
			out[i].t = 't';
		}
		var retval = "";
		for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
		return retval;
	}
	SSF._eval = eval_fmt;
	var cfregex = /\[[=<>]/;
	var cfregex2 = /\[([=<>]*)(-?\d+\.?\d*)\]/;
	function chkcond(v, rr) {
		if(rr == null) return false;
		var thresh = parseFloat(rr[2]);
		switch(rr[1]) {
			case "=":  if(v == thresh) return true; break;
			case ">":  if(v >  thresh) return true; break;
			case "<":  if(v <  thresh) return true; break;
			case "<>": if(v != thresh) return true; break;
			case ">=": if(v >= thresh) return true; break;
			case "<=": if(v <= thresh) return true; break;
		}
		return false;
	}
	function choose_fmt(f, v) {
		var fmt = split_fmt(f);
		var l = fmt.length, lat = fmt[l-1].indexOf("@");
		if(l<4 && lat>-1) --l;
		if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
		if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
		switch(fmt.length) {
			case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
			case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
			case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
			case 4: break;
		}
		var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
		if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
		if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
			var m1 = fmt[0].match(cfregex2);
			var m2 = fmt[1].match(cfregex2);
			return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
		}
		return [l, ff];
	}
	function format(fmt,v,o) {
		if(o == null) o = {};
		var sfmt = "";
		switch(typeof fmt) {
			case "string":
				if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
				else sfmt = fmt;
				break;
			case "number":
				if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
				else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
				break;
		}
		if(isgeneral(sfmt,0)) return general_fmt(v, o);
		if(v instanceof Date) v = datenum_local(v, o.date1904);
		var f = choose_fmt(sfmt, v);
		if(isgeneral(f[1])) return general_fmt(v, o);
		if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
		else if(v === "" || v == null) return "";
		return eval_fmt(f[1], v, o, f[0]);
	}
	function load_entry(fmt, idx) {
		if(typeof idx != 'number') {
			idx = +idx || -1;
	for(var i = 0; i < 0x0188; ++i) {
	if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
				if(table_fmt[i] == fmt) { idx = i; break; }
			}
	if(idx < 0) idx = 0x187;
		}
	table_fmt[idx] = fmt;
		return idx;
	}
	SSF.load = load_entry;
	SSF._table = table_fmt;
	SSF.get_table = function get_table() { return table_fmt; };
	SSF.load_table = function load_table(tbl) {
		for(var i=0; i!=0x0188; ++i)
			if(tbl[i] !== undefined) load_entry(tbl[i], i);
	};
	SSF.init_table = init_table;
	SSF.format = format;
	};
	make_ssf(SSF);
	/* map from xlml named formats to SSF TODO: localize */
	var XLMLFormatMap/*{[string]:string}*/ = ({
		"General Number": "General",
		"General Date": SSF._table[22],
		"Long Date": "dddd, mmmm dd, yyyy",
		"Medium Date": SSF._table[15],
		"Short Date": SSF._table[14],
		"Long Time": SSF._table[19],
		"Medium Time": SSF._table[18],
		"Short Time": SSF._table[20],
		"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"Fixed": SSF._table[2],
		"Standard": SSF._table[4],
		"Percent": SSF._table[10],
		"Scientific": SSF._table[11],
		"Yes/No": '"Yes";"Yes";"No";@',
		"True/False": '"True";"True";"False";@',
		"On/Off": '"Yes";"Yes";"No";@'
	});
	
	/* dateNF parse TODO: move to SSF */
	var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
	function dateNF_regex(dateNF) {
		var fmt = typeof dateNF == "number" ? SSF._table[dateNF] : dateNF;
		fmt = fmt.replace(dateNFregex, "(\\d+)");
		return new RegExp("^" + fmt + "$");
	}
	function dateNF_fix(str, dateNF, match) {
		var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
		(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
			var v = parseInt(match[i+1], 10);
			switch(n.toLowerCase().charAt(0)) {
				case 'y': Y = v; break; case 'd': d = v; break;
				case 'h': H = v; break; case 's': S = v; break;
				case 'm': if(H >= 0) M = v; else m = v; break;
			}
		});
		if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
		var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
		if(datestr.length == 7) datestr = "0" + datestr;
		if(datestr.length == 8) datestr = "20" + datestr;
		var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
		if(H == -1 && M == -1 && S == -1) return datestr;
		if(Y == -1 && m == -1 && d == -1) return timestr;
		return datestr + "T" + timestr;
	}
	
	var DO_NOT_EXPORT_CFB = true;
	/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint eqnull:true */
	/*exported CFB */
	/*global module, require:false, process:false, Buffer:false, Uint8Array:false */
	
	/* [MS-CFB] v20130118 */
	var CFB = (function _CFB(){
	var exports = {};
	exports.version = '1.0.2';
	/* [MS-CFB] 2.6.4 */
	function namecmp(l, r) {
		var L = l.split("/"), R = r.split("/");
		for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
			if((c = L[i].length - R[i].length)) return c;
			if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
		}
		return L.length - R.length;
	}
	function dirname(p) {
		if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(0, c+1);
	}
	
	function filename(p) {
		if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(c+1);
	}
	var fs;
	function get_fs() { return fs || (fs = __webpack_require__(633)); }
	function parse(file, options) {
	var mver = 3;
	var ssz = 512;
	var nmfs = 0; // number of mini FAT sectors
	var difat_sec_cnt = 0;
	var dir_start = 0;
	var minifat_start = 0;
	var difat_start = 0;
	
	var fat_addrs = []; // locations of FAT sectors
	
	/* [MS-CFB] 2.2 Compound File Header */
	var blob = file.slice(0,512);
	prep_blob(blob, 0);
	
	/* major version */
	var mv = check_get_mver(blob);
	mver = mv[0];
	switch(mver) {
		case 3: ssz = 512; break; case 4: ssz = 4096; break;
		default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
	}
	
	/* reprocess header */
	if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
	/* Save header for final object */
	var header = file.slice(0,ssz);
	
	check_shifts(blob, mver);
	
	// Number of Directory Sectors
	var dir_cnt = blob.read_shift(4, 'i');
	if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
	
	// Number of FAT Sectors
	blob.l += 4;
	
	// First Directory Sector Location
	dir_start = blob.read_shift(4, 'i');
	
	// Transaction Signature
	blob.l += 4;
	
	// Mini Stream Cutoff Size
	blob.chk('00100000', 'Mini Stream Cutoff Size: ');
	
	// First Mini FAT Sector Location
	minifat_start = blob.read_shift(4, 'i');
	
	// Number of Mini FAT Sectors
	nmfs = blob.read_shift(4, 'i');
	
	// First DIFAT sector location
	difat_start = blob.read_shift(4, 'i');
	
	// Number of DIFAT Sectors
	difat_sec_cnt = blob.read_shift(4, 'i');
	
	// Grab FAT Sector Locations
	for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
		q = blob.read_shift(4, 'i');
		if(q<0) break;
		fat_addrs[j] = q;
	}
	
	/** Break the file up into sectors */
	var sectors = sectorify(file, ssz);
	
	sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
	
	/** Chains */
	var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
	
	sector_list[dir_start].name = "!Directory";
	if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
	sector_list[fat_addrs[0]].name = "!FAT";
	sector_list.fat_addrs = fat_addrs;
	sector_list.ssz = ssz;
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	var files = {}, Paths = [], FileIndex = [], FullPaths = [];
	read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
	
	build_full_paths(FileIndex, FullPaths, Paths);
	Paths.shift();
	
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	
	// $FlowIgnore
	if(options && options.raw) o.raw = {header: header, sectors: sectors};
	return o;
	} // parse
	
	/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
	function check_get_mver(blob) {
		// header signature 8
		blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
	
		// clsid 16
		blob.chk(HEADER_CLSID, 'CLSID: ');
	
		// minor version 2
		var mver = blob.read_shift(2, 'u');
	
		return [blob.read_shift(2,'u'), mver];
	}
	function check_shifts(blob, mver) {
		var shift = 0x09;
	
		// Byte Order
		//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
		blob.l += 2;
	
		// Sector Shift
		switch((shift = blob.read_shift(2))) {
			case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
			case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
			default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
		}
	
		// Mini Sector Shift
		blob.chk('0600', 'Mini Sector Shift: ');
	
		// Reserved
		blob.chk('000000000000', 'Reserved: ');
	}
	
	/** Break the file up into sectors */
	function sectorify(file, ssz) {
		var nsectors = Math.ceil(file.length/ssz)-1;
		var sectors = [];
		for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
		sectors[nsectors-1] = file.slice(nsectors*ssz);
		return sectors;
	}
	
	/* [MS-CFB] 2.6.4 Red-Black Tree */
	function build_full_paths(FI, FP, Paths) {
		var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
		var dad = [], q = [];
	
		for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }
	
		for(; j < q.length; ++j) {
			i = q[j];
			L = FI[i].L; R = FI[i].R; C = FI[i].C;
			if(dad[i] === i) {
				if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
				if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
			}
			if(C !== -1 /*NOSTREAM*/) dad[C] = i;
			if(L !== -1) { dad[L] = dad[i]; q.push(L); }
			if(R !== -1) { dad[R] = dad[i]; q.push(R); }
		}
		for(i=1; i !== pl; ++i) if(dad[i] === i) {
			if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
			else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
		}
	
		for(i=1; i < pl; ++i) {
			if(FI[i].type === 0 /* unknown */) continue;
			j = dad[i];
			if(j === 0) FP[i] = FP[0] + "/" + FP[i];
			else while(j !== 0 && j !== dad[j]) {
				FP[i] = FP[j] + "/" + FP[i];
				j = dad[j];
			}
			dad[i] = 0;
		}
	
		FP[0] += "/";
		for(i=1; i < pl; ++i) {
			if(FI[i].type !== 2 /* stream */) FP[i] += "/";
		}
	}
	
	function get_mfat_entry(entry, payload, mini) {
		var start = entry.start, size = entry.size;
		//return (payload.slice(start*MSSZ, start*MSSZ + size));
		var o = [];
		var idx = start;
		while(mini && size > 0 && idx >= 0) {
			o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
			size -= MSSZ;
			idx = __readInt32LE(mini, idx * 4);
		}
		if(o.length === 0) return (new_buf(0));
		return (bconcat(o).slice(0, entry.size));
	}
	
	/** Chase down the rest of the DIFAT chain to build a comprehensive list
	    DIFAT chains by storing the next sector number as the last 32 bits */
	function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
		var q = ENDOFCHAIN;
		if(idx === ENDOFCHAIN) {
			if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
		} else if(idx !== -1 /*FREESECT*/) {
			var sector = sectors[idx], m = (ssz>>>2)-1;
			if(!sector) return;
			for(var i = 0; i < m; ++i) {
				if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
				fat_addrs.push(q);
			}
			sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
		}
	}
	
	/** Follow the linked list of sectors for a given starting point */
	function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
		var buf = [], buf_chain = [];
		if(!chkd) chkd = [];
		var modulus = ssz - 1, j = 0, jj = 0;
		for(j=start; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		return {nodes: buf, data:__toBuffer([buf_chain])};
	}
	
	/** Chase down the sector linked lists */
	function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
		var sl = sectors.length, sector_list = ([]);
		var chkd = [], buf = [], buf_chain = [];
		var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
		for(i=0; i < sl; ++i) {
			buf = ([]);
			k = (i + dir_start); if(k >= sl) k-=sl;
			if(chkd[k]) continue;
			buf_chain = [];
			for(j=k; j>=0;) {
				chkd[j] = true;
				buf[buf.length] = j;
				buf_chain.push(sectors[j]);
				var addr = fat_addrs[Math.floor(j*4/ssz)];
				jj = ((j*4) & modulus);
				if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
				if(!sectors[addr]) break;
				j = __readInt32LE(sectors[addr], jj);
			}
			sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
		}
		return sector_list;
	}
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
		var minifat_store = 0, pl = (Paths.length?2:0);
		var sector = sector_list[dir_start].data;
		var i = 0, namelen = 0, name;
		for(; i < sector.length; i+= 128) {
			var blob = sector.slice(i, i+128);
			prep_blob(blob, 64);
			namelen = blob.read_shift(2);
			name = __utf16le(blob,0,namelen-pl);
			Paths.push(name);
			var o = ({
				name:  name,
				type:  blob.read_shift(1),
				color: blob.read_shift(1),
				L:     blob.read_shift(4, 'i'),
				R:     blob.read_shift(4, 'i'),
				C:     blob.read_shift(4, 'i'),
				clsid: blob.read_shift(16),
				state: blob.read_shift(4, 'i'),
				start: 0,
				size: 0
			});
			var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
			var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
			o.start = blob.read_shift(4, 'i');
			o.size = blob.read_shift(4, 'i');
			if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
			if(o.type === 5) { /* root */
				minifat_store = o.start;
				if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
				/*minifat_size = o.size;*/
			} else if(o.size >= 4096 /* MSCSZ */) {
				o.storage = 'fat';
				if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
				sector_list[o.start].name = o.name;
				o.content = (sector_list[o.start].data.slice(0,o.size));
				prep_blob(o.content, 0);
			} else {
				o.storage = 'minifat';
				if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
					o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
					prep_blob(o.content, 0);
				}
			}
			files[name] = o;
			FileIndex.push(o);
		}
	}
	
	function read_date(blob, offset) {
		return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
	}
	
	function read_file(filename, options) {
		get_fs();
		return parse(fs.readFileSync(filename), options);
	}
	
	function read(blob, options) {
		switch(options && options.type || "base64") {
			case "file": return read_file(blob, options);
			case "base64": return parse(s2a(Base64.decode(blob)), options);
			case "binary": return parse(s2a(blob), options);
		}
		return parse(blob, options);
	}
	
	function init_cfb(cfb, opts) {
		var o = opts || {}, root = o.root || "Root Entry";
		if(!cfb.FullPaths) cfb.FullPaths = [];
		if(!cfb.FileIndex) cfb.FileIndex = [];
		if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
		if(cfb.FullPaths.length === 0) {
			cfb.FullPaths[0] = root + "/";
			cfb.FileIndex[0] = ({ name: root, type: 5 });
		}
		if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
		seed_cfb(cfb);
	}
	function seed_cfb(cfb) {
		var nm = "\u0001Sh33tJ5";
		if(CFB.find(cfb, "/" + nm)) return;
		var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
		cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
		cfb.FullPaths.push(cfb.FullPaths[0] + nm);
		rebuild_cfb(cfb);
	}
	function rebuild_cfb(cfb, f) {
		init_cfb(cfb);
		var gc = false, s = false;
		for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
			var _file = cfb.FileIndex[i];
			switch(_file.type) {
				case 0:
					if(s) gc = true;
					else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
					break;
				case 1: case 2: case 5:
					s = true;
					if(isNaN(_file.R * _file.L * _file.C)) gc = true;
					if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
					break;
				default: gc = true; break;
			}
		}
		if(!gc && !f) return;
	
		var now = new Date(1987, 1, 19), j = 0;
		var data = [];
		for(i = 0; i < cfb.FullPaths.length; ++i) {
			if(cfb.FileIndex[i].type === 0) continue;
			data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
		}
		for(i = 0; i < data.length; ++i) {
			var dad = dirname(data[i][0]);
			s = false;
			for(j = 0; j < data.length; ++j) if(data[j][0] === dad) s = true;
			if(!s) data.push([dad, ({
				name: filename(dad).replace("/",""),
				type: 1,
				clsid: HEADER_CLSID,
				ct: now, mt: now,
				content: null
			})]);
		}
	
		data.sort(function(x,y) { return namecmp(x[0], y[0]); });
		cfb.FullPaths = []; cfb.FileIndex = [];
		for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
		for(i = 0; i < data.length; ++i) {
			var elt = cfb.FileIndex[i];
			var nm = cfb.FullPaths[i];
	
			elt.name =  filename(nm).replace("/","");
			elt.L = elt.R = elt.C = -(elt.color = 1);
			elt.size = elt.content ? elt.content.length : 0;
			elt.start = 0;
			elt.clsid = (elt.clsid || HEADER_CLSID);
			if(i === 0) {
				elt.C = data.length > 1 ? 1 : -1;
				elt.size = 0;
				elt.type = 5;
			} else if(nm.slice(-1) == "/") {
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
				elt.C = j >= data.length ? -1 : j;
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
				elt.R = j >= data.length ? -1 : j;
				elt.type = 1;
			} else {
				if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
				elt.type = 2;
			}
		}
	
	}
	
	function _write(cfb, options) {
		var _opts = options || {};
		rebuild_cfb(cfb);
		var L = (function(cfb){
			var mini_size = 0, fat_size = 0;
			for(var i = 0; i < cfb.FileIndex.length; ++i) {
				var file = cfb.FileIndex[i];
				if(!file.content) continue;
	var flen = file.content.length;
				if(flen > 0){
					if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
					else fat_size += (flen + 0x01FF) >> 9;
				}
			}
			var dir_cnt = (cfb.FullPaths.length +3) >> 2;
			var mini_cnt = (mini_size + 7) >> 3;
			var mfat_cnt = (mini_size + 0x7F) >> 7;
			var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
			var fat_cnt = (fat_base + 0x7F) >> 7;
			var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
			cfb.FileIndex[0].size = mini_size << 6;
			L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
			return L;
		})(cfb);
		var o = new_buf(L[7] << 9);
		var i = 0, T = 0;
		{
			for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
			for(i = 0; i < 8; ++i) o.write_shift(2, 0);
			o.write_shift(2, 0x003E);
			o.write_shift(2, 0x0003);
			o.write_shift(2, 0xFFFE);
			o.write_shift(2, 0x0009);
			o.write_shift(2, 0x0006);
			for(i = 0; i < 3; ++i) o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, L[2]);
			o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
			o.write_shift(4, 0);
			o.write_shift(4, 1<<12);
			o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
			o.write_shift(4, L[3]);
			o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
			o.write_shift(4, L[1]);
			for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
		}
		if(L[1]) {
			for(T = 0; T < L[1]; ++T) {
				for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
				o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
			}
		}
		var chainit = function(w) {
			for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
			if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
		};
		T = i = 0;
		for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
		for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
		chainit(L[3]);
		chainit(L[4]);
		var j = 0, flen = 0;
		var file = cfb.FileIndex[0];
		for(; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(flen < 0x1000) continue;
			file.start = T;
			chainit((flen + 0x01FF) >> 9);
		}
		chainit((L[6] + 7) >> 3);
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		T = i = 0;
		for(j = 0; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(!flen || flen >= 0x1000) continue;
			file.start = T;
			chainit((flen + 0x3F) >> 6);
		}
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		for(i = 0; i < L[4]<<2; ++i) {
			var nm = cfb.FullPaths[i];
			if(!nm || nm.length === 0) {
				for(j = 0; j < 17; ++j) o.write_shift(4, 0);
				for(j = 0; j < 3; ++j) o.write_shift(4, -1);
				for(j = 0; j < 12; ++j) o.write_shift(4, 0);
				continue;
			}
			file = cfb.FileIndex[i];
			if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
			var _nm = (i === 0 && _opts.root) || file.name;
			flen = 2*(_nm.length+1);
			o.write_shift(64, _nm, "utf16le");
			o.write_shift(2, flen);
			o.write_shift(1, file.type);
			o.write_shift(1, file.color);
			o.write_shift(-4, file.L);
			o.write_shift(-4, file.R);
			o.write_shift(-4, file.C);
			if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
			else o.write_shift(16, file.clsid, "hex");
			o.write_shift(4, file.state || 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, file.start);
			o.write_shift(4, file.size); o.write_shift(4, 0);
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size >= 0x1000) {
				o.l = (file.start+1) << 9;
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x1FF; ++j) o.write_shift(1, 0);
			}
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size > 0 && file.size < 0x1000) {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x3F; ++j) o.write_shift(1, 0);
			}
		}
		while(o.l < o.length) o.write_shift(1, 0);
		return o;
	}
	/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
	function find(cfb, path) {
		//return cfb.find(path);
		var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
		var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
		var k = false;
		if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
		else k = path.indexOf("/") !== -1;
		var UCPath = path.toUpperCase();
		var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
		if(w !== -1) return cfb.FileIndex[w];
	
		UCPath = UCPath.replace(chr0,'').replace(chr1,'!');
		for(w = 0; w < UCFullPaths.length; ++w) {
			if(UCFullPaths[w].replace(chr0,'').replace(chr1,'!') == UCPath) return cfb.FileIndex[w];
			if(UCPaths[w].replace(chr0,'').replace(chr1,'!') == UCPath) return cfb.FileIndex[w];
		}
		return null;
	}
	/** CFB Constants */
	var MSSZ = 64; /* Mini Sector Size = 1<<6 */
	//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
	/* 2.1 Compound File Sector Numbers and Types */
	var ENDOFCHAIN = -2;
	/* 2.2 Compound File Header */
	var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
	var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
	var HEADER_CLSID = '00000000000000000000000000000000';
	var consts = {
		/* 2.1 Compund File Sector Numbers and Types */
		MAXREGSECT: -6,
		DIFSECT: -4,
		FATSECT: -3,
		ENDOFCHAIN: ENDOFCHAIN,
		FREESECT: -1,
		/* 2.2 Compound File Header */
		HEADER_SIGNATURE: HEADER_SIGNATURE,
		HEADER_MINOR_VERSION: '3e00',
		MAXREGSID: -6,
		NOSTREAM: -1,
		HEADER_CLSID: HEADER_CLSID,
		/* 2.6.1 Compound File Directory Entry */
		EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
	};
	
	function write_file(cfb, filename, options) {
		get_fs();
		var o = _write(cfb, options);
	fs.writeFileSync(filename, o);
	}
	
	function a2s(o) {
		var out = new Array(o.length);
		for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
		return out.join("");
	}
	
	function write(cfb, options) {
		var o = _write(cfb, options);
		switch(options && options.type) {
			case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
			case "binary": return a2s(o);
			case "base64": return Base64.encode(a2s(o));
		}
		return o;
	}
	function cfb_new(opts) {
		var o = ({});
		init_cfb(o, opts);
		return o;
	}
	
	function cfb_add(cfb, name, content, opts) {
		init_cfb(cfb);
		var file = CFB.find(cfb, name);
		if(!file) {
			var fpath = cfb.FullPaths[0];
			if(name.slice(0, fpath.length) == fpath) fpath = name;
			else {
				if(fpath.slice(-1) != "/") fpath += "/";
				fpath = (fpath + name).replace("//","/");
			}
			file = ({name: filename(name), type: 2});
			cfb.FileIndex.push(file);
			cfb.FullPaths.push(fpath);
			CFB.utils.cfb_gc(cfb);
		}
	file.content = (content);
		file.size = content ? content.length : 0;
		if(opts) {
			if(opts.CLSID) file.clsid = opts.CLSID;
		}
		return file;
	}
	
	function cfb_del(cfb, name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex.splice(j, 1);
			cfb.FullPaths.splice(j, 1);
			return true;
		}
		return false;
	}
	
	function cfb_mov(cfb, old_name, new_name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, old_name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex[j].name = filename(new_name);
			cfb.FullPaths[j] = new_name;
			return true;
		}
		return false;
	}
	
	function cfb_gc(cfb) { rebuild_cfb(cfb, true); }
	
	exports.find = find;
	exports.read = read;
	exports.parse = parse;
	exports.write = write;
	exports.writeFile = write_file;
	exports.utils = {
		cfb_new: cfb_new,
		cfb_add: cfb_add,
		cfb_del: cfb_del,
		cfb_mov: cfb_mov,
		cfb_gc: cfb_gc,
		ReadShift: ReadShift,
		CheckField: CheckField,
		prep_blob: prep_blob,
		bconcat: bconcat,
		consts: consts
	};
	
	return exports;
	})();
	
	if("function" !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }
	var _fs;
	if(true) try { _fs = __webpack_require__(633); } catch(e) {}
	
	/* normalize data for blob ctor */
	function blobify(data) {
		if(typeof data === "string") return s2ab(data);
		if(Array.isArray(data)) return a2u(data);
		return data;
	}
	/* write or download file */
	function write_dl(fname, payload, enc) {
		/*global IE_SaveFile, Blob, navigator, saveAs, URL, document */
		if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
		var data = (enc == "utf8") ? utf8write(payload) : payload;
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
		if(typeof Blob !== 'undefined') {
			var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
	if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
	if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
			if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
				var a = document.createElement("a");
				if(a.download != null) {
					var url = URL.createObjectURL(blob);
	a.download = fname; a.href = url; document.body.appendChild(a); a.click();
	document.body.removeChild(a);
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return url;
				}
			}
		}
		throw new Error("cannot initiate download");
	}
	
	function keys(o) { return Object.keys(o); }
	
	function evert_key(obj, key) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]][key]] = K[i];
		return o;
	}
	
	function evert(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
		return o;
	}
	
	function evert_num(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
		return o;
	}
	
	function evert_arr(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) {
			if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
			o[obj[K[i]]].push(K[i]);
		}
		return o;
	}
	
	var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
	var dnthresh = basedate.getTime() + (new Date().getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	function datenum(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1462*24*60*60*1000;
		return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
	}
	function numdate(v) {
		var out = new Date();
		out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
		return out;
	}
	
	/* ISO 8601 Duration */
	function parse_isodur(s) {
		var sec = 0, mt = 0, time = false;
		var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
		if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
		for(var i = 1; i != m.length; ++i) {
			if(!m[i]) continue;
			mt = 1;
			if(i > 3) time = true;
			switch(m[i].slice(m[i].length-1)) {
				case 'Y':
					throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
				case 'D': mt *= 24;
					/* falls through */
				case 'H': mt *= 60;
					/* falls through */
				case 'M':
					if(!time) throw new Error("Unsupported ISO Duration Field: M");
					else mt *= 60;
					/* falls through */
				case 'S': break;
			}
			sec += mt * parseInt(m[i], 10);
		}
		return sec;
	}
	
	var good_pd_date = new Date('2017-02-19T19:06:09.000Z');
	if(isNaN(good_pd_date.getFullYear())) good_pd_date = new Date('2/19/17');
	var good_pd = good_pd_date.getFullYear() == 2017;
	/* parses a date as a local date */
	function parseDate(str, fixdate) {
		var d = new Date(str);
		if(good_pd) {
	if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
			else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
			return d;
		}
		if(str instanceof Date) return str;
		if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
			var s = d.getFullYear();
			if(str.indexOf("" + s) > -1) return d;
			d.setFullYear(d.getFullYear() + 100); return d;
		}
		var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
		var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
		if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
		return out;
	}
	
	function cc2str(arr) {
		var o = "";
		for(var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]);
		return o;
	}
	
	function dup(o) {
		if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
		if(typeof o != 'object' || o == null) return o;
		if(o instanceof Date) return new Date(o.getTime());
		var out = {};
		for(var k in o) if(o.hasOwnProperty(k)) out[k] = dup(o[k]);
		return out;
	}
	
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	
	/* TODO: stress test */
	function fuzzynum(s) {
		var v = Number(s);
		if(!isNaN(v)) return v;
		var wt = 1;
		var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
		if(!isNaN(v = Number(ss))) return v / wt;
		ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
		if(!isNaN(v = Number(ss))) return v / wt;
		return v;
	}
	function fuzzydate(s) {
		var o = new Date(s), n = new Date(NaN);
		var y = o.getYear(), m = o.getMonth(), d = o.getDate();
		if(isNaN(d)) return n;
		if(y < 0 || y > 8099) return n;
		if((m > 0 || d > 1) && y != 101) return o;
		if(s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) return o;
		if(s.match(/[^-0-9:,\/\\]/)) return n;
		return o;
	}
	
	var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
	function split_regex(str, re, def) {
		if(safe_split_regex || typeof re == "string") return str.split(re);
		var p = str.split(re), o = [p[0]];
		for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
		return o;
	}
	function getdatastr(data) {
		if(!data) return null;
		if(data.data) return debom(data.data);
		if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
		if(data.asBinary) return debom(data.asBinary());
		if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
		return null;
	}
	
	function getdatabin(data) {
		if(!data) return null;
		if(data.data) return char_codes(data.data);
		if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
		if(data._data && data._data.getContent) {
			var o = data._data.getContent();
			if(typeof o == "string") return char_codes(o);
			return Array.prototype.slice.call(o);
		}
		return null;
	}
	
	function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }
	
	/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
	/* OASIS does not comment on filename case sensitivity */
	function safegetzipfile(zip, file) {
		var k = keys(zip.files);
		var f = file.toLowerCase(), g = f.replace(/\//g,'\\');
		for(var i=0; i<k.length; ++i) {
			var n = k[i].toLowerCase();
			if(f == n || g == n) return zip.files[k[i]];
		}
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	function getzipstr(zip, file, safe) {
		if(!safe) return getdatastr(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipstr(zip, file); } catch(e) { return null; }
	}
	
	var jszip;
	/*global JSZip:true */
	if(typeof JSZip !== 'undefined') jszip = JSZip;
	if(true) {
		if(typeof module !== 'undefined' && module.exports) {
			if(typeof jszip === 'undefined') jszip = __webpack_require__(4033);
		}
	}
	
	function resolve_path(path, base) {
		var result = base.split('/');
		if(base.slice(-1) != "/") result.pop(); // folder path
		var target = path.split('/');
		while (target.length !== 0) {
			var step = target.shift();
			if (step === '..') result.pop();
			else if (step !== '.') result.push(step);
		}
		return result.join('/');
	}
	var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
	var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
	var tagregex=/<[\/\?]?[a-zA-Z0-9:]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s]+))*\s?[\/\?]?>/g;
	if(!(XML_HEADER.match(tagregex))) tagregex = /<[^>]*>/g;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root) {
		var z = ({});
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.slice(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.slice(0,c).trim();
			while(cc.charCodeAt(c+1) == 32) ++c;
			quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
			v = cc.slice(c+1+quot, cc.length-quot);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) {
				if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
				z[q] = v;
			}
			else {
				var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
				if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
				z[k] = v;
			}
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = evert(encodings);
	//var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var unescapexml = (function() {
		/* 22.4.2.4 bstr (Basic String) */
		var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g, coderegex = /_x([\da-fA-F]{4})_/g;
		return function unescapexml(text) {
			var s = text + '', i = s.indexOf("<![CDATA[");
			if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
			var j = s.indexOf("]]>");
			return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
		};
	})();
	
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
	}
	function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }
	
	var htmlcharegex = /[\u0000-\u001f]/g;
	function escapehtml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
	}
	
	function escapexlml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
	}
	
	/* TODO: handle codepages */
	var xlml_fixstr = (function() {
		var entregex = /&#(\d+);/g;
		function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
		return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
	})();
	var xlml_unfixstr = (function() {
		return function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); };
	})();
	
	function parsexmlbool(value) {
		switch(value) {
			case 1: case true: case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	var utf8read = function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	};
	
	var utf8write = function(orig) {
		var out = [], i = 0, c = 0, d = 0;
		while(i < orig.length) {
			c = orig.charCodeAt(i++);
			switch(true) {
				case c < 128: out.push(String.fromCharCode(c)); break;
				case c < 2048:
					out.push(String.fromCharCode(192 + (c >> 6)));
					out.push(String.fromCharCode(128 + (c & 63)));
					break;
				case c >= 55296 && c < 57344:
					c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
					out.push(String.fromCharCode(240 + ((d >>18) & 7)));
					out.push(String.fromCharCode(144 + ((d >>12) & 63)));
					out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
					out.push(String.fromCharCode(128 + (d & 63)));
					break;
				default:
					out.push(String.fromCharCode(224 + (c >> 12)));
					out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
					out.push(String.fromCharCode(128 + (c & 63)));
			}
		}
		return out.join("");
	};
	
	if(has_buf) {
		var utf8readb = function utf8readb(data) {
			var out = new Buffer(2*data.length), w, i, j = 1, k = 0, ww=0, c;
			for(i = 0; i < data.length; i+=j) {
				j = 1;
				if((c=data.charCodeAt(i)) < 128) w = c;
				else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
				else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
				else { j = 4;
					w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
					w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
				}
				if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
				out[k++] = w%256; out[k++] = w>>>8;
			}
			return out.slice(0,k).toString('ucs2');
		};
		var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
		if(utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
		// $FlowIgnore
		var utf8readc = function utf8readc(data) { return Buffer(data, 'binary').toString('utf8'); };
		if(utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;
	
		utf8write = function(data) { return new Buffer(data, 'utf8').toString("binary"); };
	}
	
	// matches <foo>...</foo> extracts content
	var matchtag = (function() {
		var mtcache = ({});
		return function matchtag(f,g) {
			var t = f+"|"+(g||"");
			if(mtcache[t]) return mtcache[t];
			return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
		};
	})();
	
	var htmldecode = (function() {
		var entities = [
			['nbsp', ' '], ['middot', '·'],
			['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
		].map(function(x) { return [new RegExp('&' + x[0] + ';', "g"), x[1]]; });
		return function htmldecode(str) {
			var o = str.trim().replace(/\s+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");
			for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
			return o;
		};
	})();
	
	var vtregex = (function(){ var vt_cache = {};
		return function vt_regex(bt) {
			if(vt_cache[bt] !== undefined) return vt_cache[bt];
			return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
	};})();
	var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
	function parseVector(data, opts) {
		var h = parsexmltag(data);
	
		var matches = data.match(vtregex(h.baseType))||[];
		var res = [];
		if(matches.length != h.size) {
			if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
			return res;
		}
		matches.forEach(function(x) {
			var v = x.replace(vtvregex,"").match(vtmregex);
			if(v) res.push({v:utf8read(v[2]), t:v[1]});
		});
		return res;
	}
	
	var wtregex = /(^\s|\s$|\n)/;
	function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }
	
	function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
	function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}
	
	function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }
	
	function write_vt(s) {
		switch(typeof s) {
			case 'string': return writextag('vt:lpwstr', s);
			case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', String(s));
			case 'boolean': return writextag('vt:bool',s?'true':'false');
		}
		if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
		throw new Error("Unable to serialize " + s);
	}
	
	var XMLNS = ({
		'dc': 'http://purl.org/dc/elements/1.1/',
		'dcterms': 'http://purl.org/dc/terms/',
		'dcmitype': 'http://purl.org/dc/dcmitype/',
		'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
		'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
		'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
		'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
		'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
		'xsd': 'http://www.w3.org/2001/XMLSchema'
	});
	
	XMLNS.main = [
		'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
		'http://purl.oclc.org/ooxml/spreadsheetml/main',
		'http://schemas.microsoft.com/office/excel/2006/main',
		'http://schemas.microsoft.com/office/excel/2006/2'
	];
	
	var XLMLNS = ({
		'o':    'urn:schemas-microsoft-com:office:office',
		'x':    'urn:schemas-microsoft-com:office:excel',
		'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
		'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
		'mv':   'http://macVmlSchemaUri',
		'v':    'urn:schemas-microsoft-com:vml',
		'html': 'http://www.w3.org/TR/REC-html40'
	});
	function read_double_le(b, idx) {
		var s = 1 - 2 * (b[idx + 7] >>> 7);
		var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
		var m = (b[idx+6]&0x0f);
		for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
		if(e == 0x7ff) return m == 0 ? s * Infinity : NaN;
		if(e == 0) e = -1022;
		else { e -= 1023; m += Math.pow(2,52); }
		return s * Math.pow(2, e - 52) * m;
	}
	
	function write_double_le(b, v, idx) {
		var bs = ((v < 0 || 1/v == -Infinity) ? 1 : 0) << 7, e = 0, m = 0;
		var av = bs ? -v : v;
		if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
		else if(av == 0) e = m = 0;
		else {
			e = Math.floor(Math.log(av) / Math.LN2);
			m = av * Math.pow(2, 52 - e);
			if(e <= -1023 && (!isFinite(m) || m < Math.pow(2,52))) { e = -1022; }
			else { m -= Math.pow(2,52); e+=1023; }
		}
		for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
		b[idx + 6] = ((e & 0x0f) << 4) | m & 0xf;
		b[idx + 7] = (e >> 4) | bs;
	}
	
	var __toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
	var ___toBuffer = __toBuffer;
	var __utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
	var ___utf16le = __utf16le;
	var __hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
	var ___hexlify = __hexlify;
	var __utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
	var __lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___lpstr = __lpstr;
	var __cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___cpstr = __cpstr;
	var __lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___lpwstr = __lpwstr;
	var __lpp4, ___lpp4;
	__lpp4 = ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
	var __8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
	var ___8lpp4 = __8lpp4;
	var __double, ___double;
	__double = ___double = function(b, idx) { return read_double_le(b, idx);};
	var is_buf = function is_buf_a(a) { return Array.isArray(a); };
	
	if(has_buf) {
		__utf16le = function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; };
		__hexlify = function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
		__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
		__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
		__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
		__utf8 = function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : __utf8(b,s,e); };
		__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs);};
		bconcat = function(bufs) { return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : [].concat.apply([], bufs); };
		__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
		is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a); };
	}
	
	/* from js-xls */
	if(typeof cptable !== 'undefined') {
		__utf16le = function(b,s,e) { return cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
		__utf8 = function(b,s,e) { return cptable.utils.decode(65001, b.slice(s,e)); };
		__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
		__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
		__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
		__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
		__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
	}
	
	var __readUInt8 = function(b, idx) { return b[idx]; };
	var __readUInt16LE = function(b, idx) { return b[idx+1]*(1<<8)+b[idx]; };
	var __readInt16LE = function(b, idx) { var u = b[idx+1]*(1<<8)+b[idx]; return (u < 0x8000) ? u : (0xffff - u + 1) * -1; };
	var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
	var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
	var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };
	
	function ReadShift(size, t) {
		var o="", oI, oR, oo=[], w, vv, i, loc;
		switch(t) {
			case 'dbcs':
				loc = this.l;
				if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
				else for(i = 0; i != size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
				size *= 2;
				break;
	
			case 'utf8': o = __utf8(this, this.l, this.l + size); break;
			case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;
	
			case 'wstr':
				if(typeof cptable !== 'undefined') o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
				else return ReadShift.call(this, size, 'dbcs');
				size = 2 * size; break;
	
			/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
			case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
			case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
			/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
			case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
			/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
			case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;
	
			case 'cstr': size = 0; o = "";
				while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
				o = oo.join(""); break;
			case '_wstr': size = 0; o = "";
				while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
				size+=2; o = oo.join(""); break;
	
			/* sbcs and dbcs support continue records in the SST way TODO codepages */
			case 'dbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt16LE(this, loc)));
					loc+=2;
				} o = oo.join(""); size *= 2; break;
	
			case 'cpstr':
				if(typeof cptable !== 'undefined') {
					o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
					break;
				}
			/* falls through */
			case 'sbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt8(this, loc)));
					loc+=1;
				} o = oo.join(""); break;
	
			default:
		switch(size) {
			case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
			case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
			case 4: case -4:
				if(t === 'i' || (this[this.l+3] & 0x80)===0) { oI = (size > 0 ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
				else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
			case 8: case -8:
				if(t === 'f') {
					if(size == 8) oR = __double(this, this.l);
					else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
					this.l += 8; return oR;
				} else size = 8;
			/* falls through */
			case 16: o = __hexlify(this, this.l, size); break;
		}}
		this.l+=size; return o;
	}
	
	var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
	var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
	var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };
	
	function WriteShift(t, val, f) {
		var size = 0, i = 0;
		if(f === 'dbcs') {
	for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
			size = 2 * val.length;
		} else if(f === 'sbcs') {
			/* TODO: codepage */
	val = val.replace(/[^\x00-\x7F]/g, "_");
	for(i = 0; i != val.length; ++i) this[this.l + i] = val.charCodeAt(i) & 0xFF;
			size = val.length;
		} else if(f === 'hex') {
			for(; i < t; ++i) {
	this[this.l++] = parseInt(val.slice(2*i, 2*i+2), 16)||0;
			} return this;
		} else if(f === 'utf16le') {
	var end = this.l + t;
				for(i = 0; i < Math.min(val.length, t); ++i) {
					var cc = val.charCodeAt(i);
					this[this.l++] = cc & 0xff;
					this[this.l++] = cc >> 8;
				}
				while(this.l < end) this[this.l++] = 0;
				return this;
		} else  switch(t) {
			case  1: size = 1; this[this.l] = val&0xFF; break;
			case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
			case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
			case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
			case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
			/* falls through */
			case 16: break;
			case -4: size = 4; __writeInt32LE(this, val, this.l); break;
		}
		this.l += size; return this;
	}
	
	function CheckField(hexstr, fld) {
		var m = __hexlify(this,this.l,hexstr.length>>1);
		if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
		this.l += hexstr.length>>1;
	}
	
	function prep_blob(blob, pos) {
		blob.l = pos;
		blob.read_shift = ReadShift;
		blob.chk = CheckField;
		blob.write_shift = WriteShift;
	}
	
	function parsenoop(blob, length) { blob.l += length; }
	
	function new_buf(sz) {
		var o = new_raw_buf(sz);
		prep_blob(o, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.4 Record */
	function recordhopper(data, cb, opts) {
		if(!data) return;
		var tmpbyte, cntbyte, length;
		prep_blob(data, data.l || 0);
		var L = data.length, RT = 0, tgt = 0;
		while(data.l < L) {
			RT = data.read_shift(1);
			if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
			var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
			tmpbyte = data.read_shift(1);
			length = tmpbyte & 0x7F;
			for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
			tgt = data.l + length;
			var d = (R.f||parsenoop)(data, length, opts);
			data.l = tgt;
			if(cb(d, R.n, RT)) return;
		}
	}
	
	/* control buffer usage for fixed-length buffers */
	function buf_array() {
		var bufs = [], blksz = has_buf ? 256 : 2048;
		var newblk = function ba_newblk(sz) {
			var o = (new_buf(sz));
			prep_blob(o, 0);
			return o;
		};
	
		var curbuf = newblk(blksz);
	
		var endbuf = function ba_endbuf() {
			if(!curbuf) return;
			if(curbuf.length > curbuf.l) curbuf = curbuf.slice(0, curbuf.l);
			if(curbuf.length > 0) bufs.push(curbuf);
			curbuf = null;
		};
	
		var next = function ba_next(sz) {
			if(curbuf && sz < curbuf.length - curbuf.l) return curbuf;
			endbuf();
			return (curbuf = newblk(Math.max(sz+1, blksz)));
		};
	
		var end = function ba_end() {
			endbuf();
			return __toBuffer([bufs]);
		};
	
		var push = function ba_push(buf) { endbuf(); curbuf = buf; next(blksz); };
	
		return ({ next:next, push:push, end:end, _bufs:bufs });
	}
	
	function write_record(ba, type, payload, length) {
		var t = +XLSBRE[type], l;
		if(isNaN(t)) return; // TODO: throw something here?
		if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
		l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
		if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
		var o = ba.next(l);
		if(t <= 0x7F) o.write_shift(1, t);
		else {
			o.write_shift(1, (t & 0x7F) + 0x80);
			o.write_shift(1, (t >> 7));
		}
		for(var i = 0; i != 4; ++i) {
			if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
			else { o.write_shift(1, length); break; }
		}
		if(length > 0 && is_buf(payload)) ba.push(payload);
	}
	/* XLS ranges enforced */
	function shift_cell_xls(cell, tgt, opts) {
		var out = dup(cell);
		if(tgt.s) {
			if(out.cRel) out.c += tgt.s.c;
			if(out.rRel) out.r += tgt.s.r;
		} else {
			if(out.cRel) out.c += tgt.c;
			if(out.rRel) out.r += tgt.r;
		}
		if(!opts || opts.biff < 12) {
			while(out.c >= 0x100) out.c -= 0x100;
			while(out.r >= 0x10000) out.r -= 0x10000;
		}
		return out;
	}
	
	function shift_range_xls(cell, range, opts) {
		var out = dup(cell);
		out.s = shift_cell_xls(out.s, range.s, opts);
		out.e = shift_cell_xls(out.e, range.s, opts);
		return out;
	}
	
	function encode_cell_xls(c) {
		var s = encode_cell(c);
		if(c.cRel === 0) s = fix_col(s);
		if(c.rRel === 0) s = fix_row(s);
		return s;
	}
	
	function encode_range_xls(r, opts) {
		if(r.s.r == 0 && !r.s.rRel) {
			if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : 0xFFFF) && !r.e.rRel) {
				return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
			}
		}
		if(r.s.c == 0 && !r.s.cRel) {
			if(r.e.c == (opts.biff >= 12 ? 0xFFFF : 0xFF) && !r.e.cRel) {
				return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
			}
		}
		return encode_cell_xls(r.s) + ":" + encode_cell_xls(r.e);
	}
	var OFFCRYPTO = {};
	
	var make_offcrypto = function(O, _crypto) {
		var crypto;
		if(typeof _crypto !== 'undefined') crypto = _crypto;
		else if(true) {
			try { crypto = __webpack_require__(4040); }
			catch(e) { crypto = null; }
		}
	
		O.rc4 = function(key, data) {
			var S = new Array(256);
			var c = 0, i = 0, j = 0, t = 0;
			for(i = 0; i != 256; ++i) S[i] = i;
			for(i = 0; i != 256; ++i) {
				j = (j + S[i] + (key[i%key.length]).charCodeAt(0))&255;
				t = S[i]; S[i] = S[j]; S[j] = t;
			}
			// $FlowIgnore
			i = j = 0; var out = Buffer(data.length);
			for(c = 0; c != data.length; ++c) {
				i = (i + 1)&255;
				j = (j + S[i])%256;
				t = S[i]; S[i] = S[j]; S[j] = t;
				out[c] = (data[c] ^ S[(S[i]+S[j])&255]);
			}
			return out;
		};
	
		O.md5 = function(hex) {
			if(!crypto) throw new Error("Unsupported crypto");
			return crypto.createHash('md5').update(hex).digest('hex');
		};
	};
	/*global crypto:true */
	make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);
	
	function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
	function encode_row(row) { return "" + (row + 1); }
	function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
	function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }
	
	function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
	function encode_col(col) { var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
	function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
	function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }
	
	function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
	function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
	function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
	function decode_range(range) { var x =range.split(":").map(decode_cell); return {s:x[0],e:x[x.length-1]}; }
	function encode_range(cs,ce) {
		if(typeof ce === 'undefined' || typeof ce === 'number') {
	return encode_range(cs.s, cs.e);
		}
	if(typeof cs !== 'string') cs = encode_cell((cs));
		if(typeof ce !== 'string') ce = encode_cell((ce));
	return cs == ce ? cs : cs + ":" + ce;
	}
	
	function safe_decode_range(range) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		var idx = 0, i = 0, cc = 0;
		var len = range.length;
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.s.c = --idx;
	
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.s.r = --idx;
	
		if(i === len || range.charCodeAt(++i) === 58) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.e.c = --idx;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.e.r = --idx;
		return o;
	}
	
	function safe_format_cell(cell, v) {
		var q = (cell.t == 'd' && v instanceof Date);
		if(cell.z != null) try { return (cell.w = SSF.format(cell.z, q ? datenum(v) : v)); } catch(e) { }
		try { return (cell.w = SSF.format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
	}
	
	function format_cell(cell, v, o) {
		if(cell == null || cell.t == null || cell.t == 'z') return "";
		if(cell.w !== undefined) return cell.w;
		if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
		if(v == undefined) return safe_format_cell(cell, cell.v);
		return safe_format_cell(cell, v);
	}
	
	function sheet_to_workbook(sheet, opts) {
		var n = opts && opts.sheet ? opts.sheet : "Sheet1";
		var sheets = {}; sheets[n] = sheet;
		return { SheetNames: [n], Sheets: sheets };
	}
	
	function sheet_add_aoa(_ws, data, opts) {
		var o = opts || {};
		var dense = _ws ? Array.isArray(_ws) : o.dense;
		if(DENSE != null && dense == null) dense = DENSE;
		var ws = _ws || (dense ? ([]) : ({}));
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.s.c = _range.s.c;
			range.s.r = _range.s.r;
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) range.e.r = _R = _range.e.r + 1;
		}
		for(var R = 0; R != data.length; ++R) {
			for(var C = 0; C != data[R].length; ++C) {
				if(typeof data[R][C] === 'undefined') continue;
				var cell = ({v: data[R][C] });
				if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
				var __R = _R + R, __C = _C + C;
				if(range.s.r > __R) range.s.r = __R;
				if(range.s.c > __C) range.s.c = __C;
				if(range.e.r < __R) range.e.r = __R;
				if(range.e.c < __C) range.e.c = __C;
				if(cell.v === null) { if(cell.f) cell.t = 'n'; else if(!o.cellStubs) continue; else cell.t = 'z'; }
				else if(typeof cell.v === 'number') cell.t = 'n';
				else if(typeof cell.v === 'boolean') cell.t = 'b';
				else if(cell.v instanceof Date) {
					cell.z = o.dateNF || SSF._table[14];
					if(o.cellDates) { cell.t = 'd'; cell.w = SSF.format(cell.z, datenum(cell.v)); }
					else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF.format(cell.z, cell.v); }
				}
				else cell.t = 's';
				if(dense) {
					if(!ws[__R]) ws[__R] = [];
					ws[__R][__C] = cell;
				} else {
					var cell_ref = encode_cell(({c:__C,r:__R}));
					ws[cell_ref] = cell;
				}
			}
		}
		if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
		return ws;
	}
	function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }
	
	function write_UInt32LE(x, o) {
		if(!o) o = new_buf(4);
		o.write_shift(4, x);
		return o;
	}
	
	/* [MS-XLSB] 2.5.168 */
	function parse_XLWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLWideString(data, o) {
		var _null = false; if(o == null) { _null = true; o = new_buf(4+2*data.length); }
		o.write_shift(4, data.length);
		if(data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.143 */
	function parse_StrRun(data) {
		return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
	}
	function write_StrRun(run, o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, run.ich || 0);
		o.write_shift(2, run.ifnt || 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.7.121 */
	function parse_RichStr(data, length) {
		var start = data.l;
		var flags = data.read_shift(1);
		var str = parse_XLWideString(data);
		var rgsStrRun = [];
		var z = ({ t: str, h: str });
		if((flags & 1) !== 0) { /* fRichStr */
			/* TODO: formatted string */
			var dwSizeStrRun = data.read_shift(4);
			for(var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
			z.r = rgsStrRun;
		}
		else z.r = [{ich:0, ifnt:0}];
		//if((flags & 2) !== 0) { /* fExtStr */
		//	/* TODO: phonetic string */
		//}
		data.l = start + length;
		return z;
	}
	function write_RichStr(str, o) {
		/* TODO: formatted string */
		var _null = false; if(o == null) { _null = true; o = new_buf(15+4*str.t.length); }
		o.write_shift(1,0);
		write_XLWideString(str.t, o);
		return _null ? o.slice(0, o.l) : o;
	}
	/* [MS-XLSB] 2.4.325 BrtCommentText (RichStr w/1 run) */
	var parse_BrtCommentText = parse_RichStr;
	function write_BrtCommentText(str, o) {
		/* TODO: formatted string */
		var _null = false; if(o == null) { _null = true; o = new_buf(23+4*str.t.length); }
		o.write_shift(1,1);
		write_XLWideString(str.t, o);
		o.write_shift(4,1);
		write_StrRun({ich:0,ifnt:0}, o);
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.9 */
	function parse_XLSBCell(data) {
		var col = data.read_shift(4);
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) <<16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c:col, iStyleRef: iStyleRef };
	}
	function write_XLSBCell(cell, o) {
		if(o == null) o = new_buf(8);
		o.write_shift(-4, cell.c);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	
	/* [MS-XLSB] 2.5.21 */
	var parse_XLSBCodeName = parse_XLWideString;
	var write_XLSBCodeName = write_XLWideString;
	
	/* [MS-XLSB] 2.5.166 */
	function parse_XLNullableWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLNullableWideString(data, o) {
		var _null = false; if(o == null) { _null = true; o = new_buf(127); }
		o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
		if(data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.165 */
	var parse_XLNameWideString = parse_XLWideString;
	//var write_XLNameWideString = write_XLWideString;
	
	/* [MS-XLSB] 2.5.114 */
	var parse_RelID = parse_XLNullableWideString;
	var write_RelID = write_XLNullableWideString;
	
	
	/* [MS-XLSB] 2.5.122 */
	/* [MS-XLS] 2.5.217 */
	function parse_RkNumber(data) {
		var b = data.slice(data.l, data.l+4);
		var fX100 = b[0] & 1, fInt = b[0] & 2;
		data.l+=4;
		b[0] &= 0xFC; // b[0] &= ~3;
		var RK = fInt === 0 ? __double([0,0,0,0,b[0],b[1],b[2],b[3]],0) : __readInt32LE(b,0)>>2;
		return fX100 ? RK/100 : RK;
	}
	function write_RkNumber(data, o) {
		if(o == null) o = new_buf(4);
		var fX100 = 0, fInt = 0, d100 = data * 100;
		if(data == (data | 0) && data >= -(1<<29) && data < (1 << 29)) { fInt = 1; }
		else if(d100 == (d100 | 0) && d100 >= -(1<<29) && d100 < (1 << 29)) { fInt = 1; fX100 = 1; }
		if(fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
		else throw new Error("unsupported RkNumber " + data); // TODO
	}
	
	
	/* [MS-XLSB] 2.5.117 RfX */
	function parse_RfX(data ) {
		var cell = ({s: {}, e: {}});
		cell.s.r = data.read_shift(4);
		cell.e.r = data.read_shift(4);
		cell.s.c = data.read_shift(4);
		cell.e.c = data.read_shift(4);
		return cell;
	}
	
	function write_RfX(r, o) {
		if(!o) o = new_buf(16);
		o.write_shift(4, r.s.r);
		o.write_shift(4, r.e.r);
		o.write_shift(4, r.s.c);
		o.write_shift(4, r.e.c);
		return o;
	}
	
	/* [MS-XLSB] 2.5.153 UncheckedRfX */
	var parse_UncheckedRfX = parse_RfX;
	var write_UncheckedRfX = write_RfX;
	
	/* [MS-XLSB] 2.5.171 */
	/* [MS-XLS] 2.5.342 */
	/* TODO: error checking, NaN and Infinity values are not valid Xnum */
	function parse_Xnum(data) { return data.read_shift(8, 'f'); }
	function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }
	
	/* [MS-XLSB] 2.5.198.2 */
	var BErr = {
	0x00: "#NULL!",
	0x07: "#DIV/0!",
	0x0F: "#VALUE!",
	0x17: "#REF!",
	0x1D: "#NAME?",
	0x24: "#NUM!",
	0x2A: "#N/A",
	0x2B: "#GETTING_DATA",
	0xFF: "#WTF?"
	};
	var RBErr = evert_num(BErr);
	
	/* [MS-XLSB] 2.4.321 BrtColor */
	function parse_BrtColor(data) {
		var out = {};
		var d = data.read_shift(1);
	
		//var fValidRGB = d & 1;
		var xColorType = d >>> 1;
	
		var index = data.read_shift(1);
		var nTS = data.read_shift(2, 'i');
		var bR = data.read_shift(1);
		var bG = data.read_shift(1);
		var bB = data.read_shift(1);
		data.l++; //var bAlpha = data.read_shift(1);
	
		switch(xColorType) {
			case 0: out.auto = 1; break;
			case 1:
				out.index = index;
				var icv = XLSIcv[index];
				/* automatic pseudo index 81 */
				if(icv) out.rgb = rgb2Hex(icv);
				break;
			case 2:
				/* if(!fValidRGB) throw new Error("invalid"); */
				out.rgb = rgb2Hex([bR, bG, bB]);
				break;
			case 3: out.theme = index; break;
		}
		if(nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
	
		return out;
	}
	function write_BrtColor(color, o) {
		if(!o) o = new_buf(8);
		if(!color||color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
		if(color.index) {
			o.write_shift(1, 0x02);
			o.write_shift(1, color.index);
		} else if(color.theme) {
			o.write_shift(1, 0x06);
			o.write_shift(1, color.theme);
		} else {
			o.write_shift(1, 0x05);
			o.write_shift(1, 0);
		}
		var nTS = color.tint || 0;
		if(nTS > 0) nTS *= 32767;
		else if(nTS < 0) nTS *= 32768;
		o.write_shift(2, nTS);
		if(!color.rgb) {
			o.write_shift(2, 0);
			o.write_shift(1, 0);
			o.write_shift(1, 0);
		} else {
			var rgb = (color.rgb || 'FFFFFF');
			o.write_shift(1, parseInt(rgb.slice(0,2),16));
			o.write_shift(1, parseInt(rgb.slice(2,4),16));
			o.write_shift(1, parseInt(rgb.slice(4,6),16));
			o.write_shift(1, 0xFF);
		}
		return o;
	}
	
	/* [MS-XLSB] 2.5.52 */
	function parse_FontFlags(data) {
		var d = data.read_shift(1);
		data.l++;
		var out = {
			/* fBold: d & 0x01 */
			fItalic: d & 0x02,
			/* fUnderline: d & 0x04 */
			fStrikeout: d & 0x08,
			fOutline: d & 0x10,
			fShadow: d & 0x20,
			fCondense: d & 0x40,
			fExtend: d & 0x80
		};
		return out;
	}
	function write_FontFlags(font, o) {
		if(!o) o = new_buf(2);
		var grbit =
			(font.italic   ? 0x02 : 0) |
			(font.strike   ? 0x08 : 0) |
			(font.outline  ? 0x10 : 0) |
			(font.shadow   ? 0x20 : 0) |
			(font.condense ? 0x40 : 0) |
			(font.extend   ? 0x80 : 0);
		o.write_shift(1, grbit);
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-OLEDS] 2.3.1 and 2.3.2 */
	function parse_ClipboardFormatOrString(o, w) {
		// $FlowIgnore
		var ClipFmt = {2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};
		var m = o.read_shift(4);
		switch(m) {
			case 0x00000000: return "";
			case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)]||"";
		}
		if(m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
		o.l -= 4;
		return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
	}
	function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
	function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }
	
	/* [MS-OLEPS] 2.2 PropertyType */
	//var VT_EMPTY    = 0x0000;
	//var VT_NULL     = 0x0001;
	var VT_I2       = 0x0002;
	var VT_I4       = 0x0003;
	//var VT_R4       = 0x0004;
	//var VT_R8       = 0x0005;
	//var VT_CY       = 0x0006;
	//var VT_DATE     = 0x0007;
	//var VT_BSTR     = 0x0008;
	//var VT_ERROR    = 0x000A;
	var VT_BOOL     = 0x000B;
	var VT_VARIANT  = 0x000C;
	//var VT_DECIMAL  = 0x000E;
	//var VT_I1       = 0x0010;
	//var VT_UI1      = 0x0011;
	//var VT_UI2      = 0x0012;
	var VT_UI4      = 0x0013;
	//var VT_I8       = 0x0014;
	//var VT_UI8      = 0x0015;
	//var VT_INT      = 0x0016;
	//var VT_UINT     = 0x0017;
	var VT_LPSTR    = 0x001E;
	//var VT_LPWSTR   = 0x001F;
	var VT_FILETIME = 0x0040;
	//var VT_BLOB     = 0x0041;
	//var VT_STREAM   = 0x0042;
	//var VT_STORAGE  = 0x0043;
	//var VT_STREAMED_Object  = 0x0044;
	//var VT_STORED_Object    = 0x0045;
	//var VT_BLOB_Object      = 0x0046;
	var VT_CF       = 0x0047;
	//var VT_CLSID    = 0x0048;
	//var VT_VERSIONED_STREAM = 0x0049;
	var VT_VECTOR   = 0x1000;
	//var VT_ARRAY    = 0x2000;
	
	var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
	var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
	var VT_CUSTOM   = [VT_STRING, VT_USTR];
	
	/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
	var DocSummaryPIDDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Category', t: VT_STRING },
	0x03: { n: 'PresentationFormat', t: VT_STRING },
	0x04: { n: 'ByteCount', t: VT_I4 },
	0x05: { n: 'LineCount', t: VT_I4 },
	0x06: { n: 'ParagraphCount', t: VT_I4 },
	0x07: { n: 'SlideCount', t: VT_I4 },
	0x08: { n: 'NoteCount', t: VT_I4 },
	0x09: { n: 'HiddenCount', t: VT_I4 },
	0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
	0x0b: { n: 'Scale', t: VT_BOOL },
	0x0c: { n: 'HeadingPair', t: VT_VECTOR | VT_VARIANT },
	0x0d: { n: 'DocParts', t: VT_VECTOR | VT_LPSTR },
	0x0e: { n: 'Manager', t: VT_STRING },
	0x0f: { n: 'Company', t: VT_STRING },
	0x10: { n: 'LinksDirty', t: VT_BOOL },
	0x11: { n: 'CharacterCount', t: VT_I4 },
	0x13: { n: 'SharedDoc', t: VT_BOOL },
	0x16: { n: 'HLinksChanged', t: VT_BOOL },
	0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
	0x1A: { n: 'ContentType', t: VT_STRING },
	0x1B: { n: 'ContentStatus', t: VT_STRING },
	0x1C: { n: 'Language', t: VT_STRING },
	0x1D: { n: 'Version', t: VT_STRING },
	0xFF: {}
	};
	
	/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
	var SummaryPIDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Title', t: VT_STRING },
	0x03: { n: 'Subject', t: VT_STRING },
	0x04: { n: 'Author', t: VT_STRING },
	0x05: { n: 'Keywords', t: VT_STRING },
	0x06: { n: 'Comments', t: VT_STRING },
	0x07: { n: 'Template', t: VT_STRING },
	0x08: { n: 'LastAuthor', t: VT_STRING },
	0x09: { n: 'RevNumber', t: VT_STRING },
	0x0A: { n: 'EditTime', t: VT_FILETIME },
	0x0B: { n: 'LastPrinted', t: VT_FILETIME },
	0x0C: { n: 'CreatedDate', t: VT_FILETIME },
	0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
	0x0E: { n: 'PageCount', t: VT_I4 },
	0x0F: { n: 'WordCount', t: VT_I4 },
	0x10: { n: 'CharCount', t: VT_I4 },
	0x11: { n: 'Thumbnail', t: VT_CF },
	0x12: { n: 'ApplicationName', t: VT_STRING },
	0x13: { n: 'DocumentSecurity', t: VT_I4 },
	0xFF: {}
	};
	
	/* [MS-OLEPS] 2.18 */
	var SpecialProperties = {
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	(function() {
		for(var y in SpecialProperties) if(SpecialProperties.hasOwnProperty(y))
		DocSummaryPIDDSI[y] = SummaryPIDSI[y] = SpecialProperties[y];
	})();
	
	/* [MS-XLS] 2.4.63 Country/Region codes */
	var CountryEnum = {
	0x0001: "US", // United States
	0x0002: "CA", // Canada
	0x0003: "", // Latin America (except Brazil)
	0x0007: "RU", // Russia
	0x0014: "EG", // Egypt
	0x001E: "GR", // Greece
	0x001F: "NL", // Netherlands
	0x0020: "BE", // Belgium
	0x0021: "FR", // France
	0x0022: "ES", // Spain
	0x0024: "HU", // Hungary
	0x0027: "IT", // Italy
	0x0029: "CH", // Switzerland
	0x002B: "AT", // Austria
	0x002C: "GB", // United Kingdom
	0x002D: "DK", // Denmark
	0x002E: "SE", // Sweden
	0x002F: "NO", // Norway
	0x0030: "PL", // Poland
	0x0031: "DE", // Germany
	0x0034: "MX", // Mexico
	0x0037: "BR", // Brazil
	0x003d: "AU", // Australia
	0x0040: "NZ", // New Zealand
	0x0042: "TH", // Thailand
	0x0051: "JP", // Japan
	0x0052: "KR", // Korea
	0x0054: "VN", // Viet Nam
	0x0056: "CN", // China
	0x005A: "TR", // Turkey
	0x0069: "JS", // Ramastan
	0x00D5: "DZ", // Algeria
	0x00D8: "MA", // Morocco
	0x00DA: "LY", // Libya
	0x015F: "PT", // Portugal
	0x0162: "IS", // Iceland
	0x0166: "FI", // Finland
	0x01A4: "CZ", // Czech Republic
	0x0376: "TW", // Taiwan
	0x03C1: "LB", // Lebanon
	0x03C2: "JO", // Jordan
	0x03C3: "SY", // Syria
	0x03C4: "IQ", // Iraq
	0x03C5: "KW", // Kuwait
	0x03C6: "SA", // Saudi Arabia
	0x03CB: "AE", // United Arab Emirates
	0x03CC: "IL", // Israel
	0x03CE: "QA", // Qatar
	0x03D5: "IR", // Iran
	0xFFFF: "US"  // United States
	};
	
	/* [MS-XLS] 2.5.127 */
	var XLSFillPattern = [
		null,
		'solid',
		'mediumGray',
		'darkGray',
		'lightGray',
		'darkHorizontal',
		'darkVertical',
		'darkDown',
		'darkUp',
		'darkGrid',
		'darkTrellis',
		'lightHorizontal',
		'lightVertical',
		'lightDown',
		'lightUp',
		'lightGrid',
		'lightTrellis',
		'gray125',
		'gray0625'
	];
	
	function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }
	
	/* [MS-XLS] 2.5.161 */
	/* [MS-XLSB] 2.5.75 */
	var XLSIcv = rgbify([
		/* Color Constants */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		/* Overridable Defaults */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		0x800000,
		0x008000,
		0x000080,
		0x808000,
		0x800080,
		0x008080,
		0xC0C0C0,
		0x808080,
		0x9999FF,
		0x993366,
		0xFFFFCC,
		0xCCFFFF,
		0x660066,
		0xFF8080,
		0x0066CC,
		0xCCCCFF,
	
		0x000080,
		0xFF00FF,
		0xFFFF00,
		0x00FFFF,
		0x800080,
		0x800000,
		0x008080,
		0x0000FF,
		0x00CCFF,
		0xCCFFFF,
		0xCCFFCC,
		0xFFFF99,
		0x99CCFF,
		0xFF99CC,
		0xCC99FF,
		0xFFCC99,
	
		0x3366FF,
		0x33CCCC,
		0x99CC00,
		0xFFCC00,
		0xFF9900,
		0xFF6600,
		0x666699,
		0x969696,
		0x003366,
		0x339966,
		0x003300,
		0x333300,
		0x993300,
		0x993366,
		0x333399,
		0x333333,
	
		/* Other entries to appease BIFF8/12 */
		0xFFFFFF, /* 0x40 icvForeground ?? */
		0x000000, /* 0x41 icvBackground ?? */
		0x000000, /* 0x42 icvFrame ?? */
		0x000000, /* 0x43 icv3D ?? */
		0x000000, /* 0x44 icv3DText ?? */
		0x000000, /* 0x45 icv3DHilite ?? */
		0x000000, /* 0x46 icv3DShadow ?? */
		0x000000, /* 0x47 icvHilite ?? */
		0x000000, /* 0x48 icvCtlText ?? */
		0x000000, /* 0x49 icvCtlScrl ?? */
		0x000000, /* 0x4A icvCtlInv ?? */
		0x000000, /* 0x4B icvCtlBody ?? */
		0x000000, /* 0x4C icvCtlFrame ?? */
		0x000000, /* 0x4D icvCtlFore ?? */
		0x000000, /* 0x4E icvCtlBack ?? */
		0x000000, /* 0x4F icvCtlNeutral */
		0x000000, /* 0x50 icvInfoBk ?? */
		0x000000 /* 0x51 icvInfoText ?? */
	]);
	
	/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
	/* 12.3 Part Summary <SpreadsheetML> */
	/* 14.2 Part Summary <DrawingML> */
	/* [MS-XLSX] 2.1 Part Enumerations */
	/* [MS-XLSB] 2.1.7 Part Enumeration */
	var ct2type/*{[string]:string}*/ = ({
		/* Workbook */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
	
		/* Worksheet */
		"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */
	
		/* Macrosheet */
		"application/vnd.ms-excel.intlmacrosheet": "TODO",
		"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */
	
		/* File Properties */
		"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
		"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
		"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
	
		/* Custom Data Properties */
		"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
	
		/* PivotTable */
		"application/vnd.ms-excel.pivotTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
	
		/* Chart Colors */
		"application/vnd.ms-office.chartcolorstyle+xml": "TODO",
	
		/* Chart Style */
		"application/vnd.ms-office.chartstyle+xml": "TODO",
	
		/* Calculation Chain */
		"application/vnd.ms-excel.calcChain": "calcchains",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
	
		/* Printer Settings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
	
		/* ActiveX */
		"application/vnd.ms-office.activeX": "TODO",
		"application/vnd.ms-office.activeX+xml": "TODO",
	
		/* Custom Toolbars */
		"application/vnd.ms-excel.attachedToolbars": "TODO",
	
		/* External Data Connections */
		"application/vnd.ms-excel.connections": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
	
		/* External Links */
		"application/vnd.ms-excel.externalLink": "links",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
	
		/* Metadata */
		"application/vnd.ms-excel.sheetMetadata": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",
	
		/* PivotCache */
		"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
		"application/vnd.ms-excel.pivotCacheRecords": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
	
		/* Query Table */
		"application/vnd.ms-excel.queryTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
	
		/* Shared Workbook */
		"application/vnd.ms-excel.userNames": "TODO",
		"application/vnd.ms-excel.revisionHeaders": "TODO",
		"application/vnd.ms-excel.revisionLog": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
	
		/* Single Cell Table */
		"application/vnd.ms-excel.tableSingleCells": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
	
		/* Slicer */
		"application/vnd.ms-excel.slicer": "TODO",
		"application/vnd.ms-excel.slicerCache": "TODO",
		"application/vnd.ms-excel.slicer+xml": "TODO",
		"application/vnd.ms-excel.slicerCache+xml": "TODO",
	
		/* Sort Map */
		"application/vnd.ms-excel.wsSortMap": "TODO",
	
		/* Table */
		"application/vnd.ms-excel.table": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
	
		/* Themes */
		"application/vnd.openxmlformats-officedocument.theme+xml": "themes",
	
		/* Theme Override */
		"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
	
		/* Timeline */
		"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
		"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */
	
		/* VBA */
		"application/vnd.ms-office.vbaProject": "vba",
		"application/vnd.ms-office.vbaProjectSignature": "vba",
	
		/* Volatile Dependencies */
		"application/vnd.ms-office.volatileDependencies": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
	
		/* Control Properties */
		"application/vnd.ms-excel.controlproperties+xml": "TODO",
	
		/* Data Model */
		"application/vnd.openxmlformats-officedocument.model+data": "TODO",
	
		/* Survey */
		"application/vnd.ms-excel.Survey+xml": "TODO",
	
		/* Drawing */
		"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
		"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
	
		/* VML */
		"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
	
		"application/vnd.openxmlformats-package.relationships+xml": "rels",
		"application/vnd.openxmlformats-officedocument.oleObject": "TODO",
	
		/* Image */
		"image/png": "TODO",
	
		"sheet": "js"
	});
	
	var CT_LIST = (function(){
		var o = {
			workbooks: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
				xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
				xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
				xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
				xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
			},
			strs: { /* Shared Strings */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
				xlsb: "application/vnd.ms-excel.sharedStrings"
			},
			comments: { /* Comments */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
				xlsb: "application/vnd.ms-excel.comments"
			},
			sheets: { /* Worksheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
				xlsb: "application/vnd.ms-excel.worksheet"
			},
			charts: { /* Chartsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
				xlsb: "application/vnd.ms-excel.chartsheet"
			},
			dialogs: { /* Dialogsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
				xlsb: "application/vnd.ms-excel.dialogsheet"
			},
			macros: { /* Macrosheet (Excel 4.0 Macros) */
				xlsx: "application/vnd.ms-excel.macrosheet+xml",
				xlsb: "application/vnd.ms-excel.macrosheet"
			},
			styles: { /* Styles */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
				xlsb: "application/vnd.ms-excel.styles"
			}
		};
		keys(o).forEach(function(k) { ["xlsm", "xlam"].forEach(function(v) { if(!o[k][v]) o[k][v] = o[k].xlsx; }); });
		keys(o).forEach(function(k){ keys(o[k]).forEach(function(v) { ct2type[o[k][v]] = k; }); });
		return o;
	})();
	
	var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);
	
	XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';
	
	function new_ct() {
		return ({
			workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
			rels:[], strs:[], comments:[], links:[],
			coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
			calcchains:[], vba: [], drawings: [],
			TODO:[], xmlns: "" });
	}
	
	function parse_ct(data) {
		var ct = new_ct();
		if(!data || !data.match) return ct;
		var ctext = {};
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0].replace(nsregex,"<")) {
				case '<?xml': break;
				case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
				case '<Default': ctext[y.Extension] = y.ContentType; break;
				case '<Override':
					if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
					break;
			}
		});
		if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
		ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
		ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
		ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
		ct.defaults = ctext;
		delete ct.calcchains;
		return ct;
	}
	
	var CTYPE_XML_ROOT = writextag('Types', null, {
		'xmlns': XMLNS.CT,
		'xmlns:xsd': XMLNS.xsd,
		'xmlns:xsi': XMLNS.xsi
	});
	
	var CTYPE_DEFAULTS = [
		['xml', 'application/xml'],
		['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
		['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
		/* from test files */
		['bmp', 'image/bmp'],
		['png', 'image/png'],
		['gif', 'image/gif'],
		['emf', 'image/x-emf'],
		['wmf', 'image/x-wmf'],
		['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
		['tif', 'image/tiff'], ['tiff', 'image/tiff'],
		['pdf', 'application/pdf'],
		['rels', type2ct.rels[0]]
	].map(function(x) {
		return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
	});
	
	function write_ct(ct, opts) {
		var o = [], v;
		o[o.length] = (XML_HEADER);
		o[o.length] = (CTYPE_XML_ROOT);
		o = o.concat(CTYPE_DEFAULTS);
		var f1 = function(w) {
			if(ct[w] && ct[w].length > 0) {
				v = ct[w][0];
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
				}));
			}
		};
		var f2 = function(w) {
			(ct[w]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
				}));
			});
		};
		var f3 = function(t) {
			(ct[t]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': type2ct[t][0]
				}));
			});
		};
		f1('workbooks');
		f2('sheets');
		f2('charts');
		f3('themes');
		['strs', 'styles'].forEach(f1);
		['coreprops', 'extprops', 'custprops'].forEach(f3);
		f3('vba');
		f3('comments');
		f3('drawings');
		if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 9.3 Relationships */
	var RELS = ({
		WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
		VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
		VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
	});
	
	/* 9.3.3 Representing Relationships */
	function get_rels_path(file) {
		var n = file.lastIndexOf("/");
		return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
	}
	
	function parse_rels(data, currentFilePath) {
		if (!data) return data;
		if (currentFilePath.charAt(0) !== '/') {
			currentFilePath = '/'+currentFilePath;
		}
		var rels = {};
		var hash = {};
	
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			/* 9.3.2.2 OPC_Relationships */
			if (y[0] === '<Relationship') {
				var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; rel.TargetMode = y.TargetMode;
				var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
				rels[canonictarget] = rel;
				hash[y.Id] = rel;
			}
		});
		rels["!id"] = hash;
		return rels;
	}
	
	XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';
	
	var RELS_ROOT = writextag('Relationships', null, {
		//'xmlns:ns0': XMLNS.RELS,
		'xmlns': XMLNS.RELS
	});
	
	/* TODO */
	function write_rels(rels) {
		var o = [XML_HEADER, RELS_ROOT];
		keys(rels['!id']).forEach(function(rid) {
			o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
		});
		if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	function add_rels(rels, rId, f, type, relobj) {
		if(!relobj) relobj = {};
		if(!rels['!id']) rels['!id'] = {};
		if(rId < 0) for(rId = 1; rels['!id']['rId' + rId]; ++rId){/* empty */}
		relobj.Id = 'rId' + rId;
		relobj.Type = type;
		relobj.Target = f;
		if(relobj.Type == RELS.HLINK) relobj.TargetMode = "External";
		if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
		rels['!id'][relobj.Id] = relobj;
		rels[('/' + relobj.Target).replace("//","/")] = relobj;
		return rId;
	}
	/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
	/* Part 3 Section 4 Manifest File */
	var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
	function parse_manifest(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var FEtag;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'manifest': break; // 4.2 <manifest:manifest>
			case 'file-entry': // 4.3 <manifest:file-entry>
				FEtag = parsexmltag(Rn[0], false);
				if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
				break;
			case 'encryption-data': // 4.4 <manifest:encryption-data>
			case 'algorithm': // 4.5 <manifest:algorithm>
			case 'start-key-generation': // 4.6 <manifest:start-key-generation>
			case 'key-derivation': // 4.7 <manifest:key-derivation>
				throw new Error("Unsupported ODS Encryption");
			default: if(opts && opts.WTF) throw Rn;
		}
	}
	
	function write_manifest(manifest) {
		var o = [XML_HEADER];
		o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
		o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
		for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
		o.push('</manifest:manifest>');
		return o.join("");
	}
	
	/* Part 3 Section 6 Metadata Manifest File */
	function write_rdf_type(file, res, tag) {
		return [
			'  <rdf:Description rdf:about="' + file + '">\n',
			'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf_has(base, file) {
		return [
			'  <rdf:Description rdf:about="' + base + '">\n',
			'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf(rdf) {
		var o = [XML_HEADER];
		o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
		for(var i = 0; i != rdf.length; ++i) {
			o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
			o.push(write_rdf_has("",rdf[i][0]));
		}
		o.push(write_rdf_type("","Document", "pkg"));
		o.push('</rdf:RDF>');
		return o.join("");
	}
	/* TODO: pull properties */
	var write_meta_ods = (function() {
		var payload = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
		return function wmo() {
			return payload;
		};
	})();
	
	/* ECMA-376 Part II 11.1 Core Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var CORE_PROPS = [
		["cp:category", "Category"],
		["cp:contentStatus", "ContentStatus"],
		["cp:keywords", "Keywords"],
		["cp:lastModifiedBy", "LastAuthor"],
		["cp:lastPrinted", "LastPrinted"],
		["cp:revision", "RevNumber"],
		["cp:version", "Version"],
		["dc:creator", "Author"],
		["dc:description", "Comments"],
		["dc:identifier", "Identifier"],
		["dc:language", "Language"],
		["dc:subject", "Subject"],
		["dc:title", "Title"],
		["dcterms:created", "CreatedDate", 'date'],
		["dcterms:modified", "ModifiedDate", 'date']
	];
	
	XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
	RELS.CORE_PROPS  = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';
	
	var CORE_PROPS_REGEX = (function() {
		var r = new Array(CORE_PROPS.length);
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
			r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
		}
		return r;
	})();
	
	function parse_core_props(data) {
		var p = {};
		data = utf8read(data);
	
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
			if(cur != null && cur.length > 0) p[f[1]] = cur[1];
			if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
		}
	
		return p;
	}
	
	var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
		//'xmlns': XMLNS.CORE_PROPS,
		'xmlns:cp': XMLNS.CORE_PROPS,
		'xmlns:dc': XMLNS.dc,
		'xmlns:dcterms': XMLNS.dcterms,
		'xmlns:dcmitype': XMLNS.dcmitype,
		'xmlns:xsi': XMLNS.xsi
	});
	
	function cp_doit(f, g, h, o, p) {
		if(p[f] != null || g == null || g === "") return;
		p[f] = g;
		o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
	}
	
	function write_core_props(cp, _opts) {
		var opts = _opts || {};
		var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {};
		if(!cp && !opts.Props) return o.join("");
	
		if(cp) {
			if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
			if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		}
	
		for(var i = 0; i != CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
			if(v === true) v = "1";
			else if(v === false) v = "0";
			else if(typeof v == "number") v = String(v);
			if(v != null) cp_doit(f[0], v, null, o, p);
		}
		if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.3 Extended File Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var EXT_PROPS = [
		["Application", "Application", "string"],
		["AppVersion", "AppVersion", "string"],
		["Company", "Company", "string"],
		["DocSecurity", "DocSecurity", "string"],
		["Manager", "Manager", "string"],
		["HyperlinksChanged", "HyperlinksChanged", "bool"],
		["SharedDoc", "SharedDoc", "bool"],
		["LinksUpToDate", "LinksUpToDate", "bool"],
		["ScaleCrop", "ScaleCrop", "bool"],
		["HeadingPairs", "HeadingPairs", "raw"],
		["TitlesOfParts", "TitlesOfParts", "raw"]
	];
	
	XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
	RELS.EXT_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';
	
	function parse_ext_props(data, p, opts) {
		var q = {}; if(!p) p = {};
		data = utf8read(data);
	
		EXT_PROPS.forEach(function(f) {
			switch(f[2]) {
				case "string": p[f[1]] = (data.match(matchtag(f[0]))||[])[1]; break;
				case "bool": p[f[1]] = (data.match(matchtag(f[0]))||[])[1] === "true"; break;
				case "raw":
					var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
					if(cur && cur.length > 0) q[f[1]] = cur[1];
					break;
			}
		});
	
		if(q.HeadingPairs && q.TitlesOfParts) {
			var v = parseVector(q.HeadingPairs, opts);
			var parts = parseVector(q.TitlesOfParts, opts).map(function (x) { return x.v; });
			var idx = 0, len = 0;
			if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
				len = +(v[i+1].v);
				switch(v[i].v) {
					case "Worksheets":
					case "工作表":
					case "Листы":
					case "أوراق العمل":
					case "ワークシート":
					case "גליונות עבודה":
					case "Arbeitsblätter":
					case "Çalışma Sayfaları":
					case "Feuilles de calcul":
					case "Fogli di lavoro":
					case "Folhas de cálculo":
					case "Planilhas":
					case "Regneark":
					case "Werkbladen":
						p.Worksheets = len;
						p.SheetNames = parts.slice(idx, idx + len);
						break;
	
					case "Named Ranges":
					case "名前付き一覧":
					case "Benannte Bereiche":
					case "Navngivne områder":
						p.NamedRanges = len;
						p.DefinedNames = parts.slice(idx, idx + len);
						break;
	
					case "Charts":
					case "Diagramme":
						p.Chartsheets = len;
						p.ChartNames = parts.slice(idx, idx + len);
						break;
				}
				idx += len;
			}
		}
	
		return p;
	}
	
	var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
		'xmlns': XMLNS.EXT_PROPS,
		'xmlns:vt': XMLNS.vt
	});
	
	function write_ext_props(cp) {
		var o = [], W = writextag;
		if(!cp) cp = {};
		cp.Application = "SheetJS";
		o[o.length] = (XML_HEADER);
		o[o.length] = (EXT_PROPS_XML_ROOT);
	
		EXT_PROPS.forEach(function(f) {
			if(cp[f[1]] === undefined) return;
			var v;
			switch(f[2]) {
				case 'string': v = String(cp[f[1]]); break;
				case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
			}
			if(v !== undefined) o[o.length] = (W(f[0], v));
		});
	
		/* TODO: HeadingPairs, TitlesOfParts */
		o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
		o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
		if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.2 Custom File Properties Part */
	XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
	RELS.CUST_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';
	
	var custregex = /<[^>]+>[^<]*/g;
	function parse_cust_props(data, opts) {
		var p = {}, name = "";
		var m = data.match(custregex);
		if(m) for(var i = 0; i != m.length; ++i) {
			var x = m[i], y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				case '<Properties': break;
				case '<property': name = y.name; break;
				case '</property>': name = null; break;
				default: if (x.indexOf('<vt:') === 0) {
					var toks = x.split('>');
					var type = toks[0].slice(4), text = toks[1];
					/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
					switch(type) {
						case 'lpstr': case 'bstr': case 'lpwstr':
							p[name] = unescapexml(text);
							break;
						case 'bool':
							p[name] = parsexmlbool(text);
							break;
						case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
							p[name] = parseInt(text, 10);
							break;
						case 'r4': case 'r8': case 'decimal':
							p[name] = parseFloat(text);
							break;
						case 'filetime': case 'date':
							p[name] = parseDate(text);
							break;
						case 'cy': case 'error':
							p[name] = unescapexml(text);
							break;
						default:
							if(type.slice(-1) == '/') break;
							if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
					}
				} else if(x.slice(0,2) === "</") {/* empty */
				} else if(opts.WTF) throw new Error(x);
			}
		}
		return p;
	}
	
	var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
		'xmlns': XMLNS.CUST_PROPS,
		'xmlns:vt': XMLNS.vt
	});
	
	function write_cust_props(cp) {
		var o = [XML_HEADER, CUST_PROPS_XML_ROOT];
		if(!cp) return o.join("");
		var pid = 1;
		keys(cp).forEach(function custprop(k) { ++pid;
			// $FlowIgnore
			o[o.length] = (writextag('property', write_vt(cp[k]), {
				'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
				'pid': pid,
				'name': k
			}));
		});
		if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* Common Name -> XLML Name */
	var XLMLDocPropsMap = {
		Title: 'Title',
		Subject: 'Subject',
		Author: 'Author',
		Keywords: 'Keywords',
		Comments: 'Description',
		LastAuthor: 'LastAuthor',
		RevNumber: 'Revision',
		Application: 'AppName',
		/* TotalTime: 'TotalTime', */
		LastPrinted: 'LastPrinted',
		CreatedDate: 'Created',
		ModifiedDate: 'LastSaved',
		/* Pages */
		/* Words */
		/* Characters */
		Category: 'Category',
		/* PresentationFormat */
		Manager: 'Manager',
		Company: 'Company',
		/* Guid */
		/* HyperlinkBase */
		/* Bytes */
		/* Lines */
		/* Paragraphs */
		/* CharactersWithSpaces */
		AppVersion: 'Version',
	
		ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
		Identifier: 'Identifier', /* NOTE: missing from schema */
		Language: 'Language' /* NOTE: missing from schema */
	};
	var evert_XLMLDPM = evert(XLMLDocPropsMap);
	
	function xlml_set_prop(Props, tag, val) {
		tag = evert_XLMLDPM[tag] || tag;
		Props[tag] = val;
	}
	
	function xlml_write_docprops(Props, opts) {
		var o = [];
		keys(XLMLDocPropsMap).map(function(m) {
			for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
			for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
			throw m;
		}).forEach(function(p) {
			if(Props[p[1]] == null) return;
			var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
			switch(p[2]) {
				case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
			}
			if(typeof m == 'number') m = String(m);
			else if(m === true || m === false) { m = m ? "1" : "0"; }
			else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
			o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
		});
		return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
	}
	function xlml_write_custprops(Props, Custprops) {
		var BLACKLIST = ["Worksheets","SheetNames"];
		var T = 'CustomDocumentProperties';
		var o = [];
		if(Props) keys(Props).forEach(function(k) {
	if(!Props.hasOwnProperty(k)) return;
			for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
			for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
			for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;
	
			var m = Props[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		if(Custprops) keys(Custprops).forEach(function(k) {
	if(!Custprops.hasOwnProperty(k)) return;
			if(Props && Props.hasOwnProperty(k)) return;
			var m = Custprops[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
	}
	/* [MS-DTYP] 2.3.3 FILETIME */
	/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
	/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
	function parse_FILETIME(blob) {
		var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
		return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
	}
	
	/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
	function parse_lpstr(blob, type, pad) {
		var start = blob.l;
		var str = blob.read_shift(0, 'lpstr-cp');
		if(pad) while((blob.l - start) & 3) ++blob.l;
		return str;
	}
	
	/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
	function parse_lpwstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpwstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.11 VtString */
	/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
	function parse_VtStringBase(blob, stringType, pad) {
		if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
		return parse_lpstr(blob, stringType, pad);
	}
	
	function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
	function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }
	
	/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
	function parse_VtVecUnalignedLpstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
		return ret;
	}
	
	/* [MS-OSHARED] 2.3.3.1.10 VtVecUnalignedLpstr */
	function parse_VtVecUnalignedLpstr(blob) {
		return parse_VtVecUnalignedLpstrValue(blob);
	}
	
	/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
	function parse_VtHeadingPair(blob) {
		var headingString = parse_TypedPropertyValue(blob, VT_USTR);
		var headerParts = parse_TypedPropertyValue(blob, VT_I4);
		return [headingString, headerParts];
	}
	
	/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
	function parse_VtVecHeadingPairValue(blob) {
		var cElements = blob.read_shift(4);
		var out = [];
		for(var i = 0; i != cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
		return out;
	}
	
	/* [MS-OSHARED] 2.3.3.1.15 VtVecHeadingPair */
	function parse_VtVecHeadingPair(blob) {
		// NOTE: When invoked, wType & padding were already consumed
		return parse_VtVecHeadingPairValue(blob);
	}
	
	/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
	function parse_dictionary(blob,CodePage) {
		var cnt = blob.read_shift(4);
		var dict = ({});
		for(var j = 0; j != cnt; ++j) {
			var pid = blob.read_shift(4);
			var len = blob.read_shift(4);
			dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
		}
		if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
		return dict;
	}
	
	/* [MS-OLEPS] 2.9 BLOB */
	function parse_BLOB(blob) {
		var size = blob.read_shift(4);
		var bytes = blob.slice(blob.l,blob.l+size);
		if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
		return bytes;
	}
	
	/* [MS-OLEPS] 2.11 ClipboardData */
	function parse_ClipboardData(blob) {
		// TODO
		var o = {};
		o.Size = blob.read_shift(4);
		//o.Format = blob.read_shift(4);
		blob.l += o.Size;
		return o;
	}
	
	/* [MS-OLEPS] 2.15 TypedPropertyValue */
	function parse_TypedPropertyValue(blob, type, _opts) {
		var t = blob.read_shift(2), ret, opts = _opts||{};
		blob.l += 2;
		if(type !== VT_VARIANT)
		if(t !== type && VT_CUSTOM.indexOf(type)===-1) throw new Error('Expected type ' + type + ' saw ' + t);
		switch(type === VT_VARIANT ? t : type) {
			case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
			case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
			case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
			case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
			case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
			case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
			case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
			case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
			case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
			case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
			case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
			case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPair(blob);
			case 0x101E /*VT_LPSTR*/: return parse_VtVecUnalignedLpstr(blob);
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
		}
	}
	
	/* [MS-OLEPS] 2.20 PropertySet */
	function parse_PropertySet(blob, PIDSI) {
		var start_addr = blob.l;
		var size = blob.read_shift(4);
		var NumProps = blob.read_shift(4);
		var Props = [], i = 0;
		var CodePage = 0;
		var Dictionary = -1, DictObj = ({});
		for(i = 0; i != NumProps; ++i) {
			var PropID = blob.read_shift(4);
			var Offset = blob.read_shift(4);
			Props[i] = [PropID, Offset + start_addr];
		}
		Props.sort(function(x,y) { return x[1] - y[1]; });
		var PropH = {};
		for(i = 0; i != NumProps; ++i) {
			if(blob.l !== Props[i][1]) {
				var fail = true;
				if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
					case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
					case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
					case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				}
				if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
				if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
			}
			if(PIDSI) {
				var piddsi = PIDSI[Props[i][0]];
				PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
				if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + String(PropH[piddsi.n] & 0xFFFF);
				if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
					case 0: PropH[piddsi.n] = 1252;
						/* falls through */
					case 874:
					case 932:
					case 936:
					case 949:
					case 950:
					case 1250:
					case 1251:
					case 1253:
					case 1254:
					case 1255:
					case 1256:
					case 1257:
					case 1258:
					case 10000:
					case 1200:
					case 1201:
					case 1252:
					case 65000: case -536:
					case 65001: case -535:
						set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
					default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
				}
			} else {
				if(Props[i][0] === 0x1) {
					CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
					set_cp(CodePage);
					if(Dictionary !== -1) {
						var oldpos = blob.l;
						blob.l = Props[Dictionary][1];
						DictObj = parse_dictionary(blob,CodePage);
						blob.l = oldpos;
					}
				} else if(Props[i][0] === 0) {
					if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
					DictObj = parse_dictionary(blob,CodePage);
				} else {
					var name = DictObj[Props[i][0]];
					var val;
					/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
					switch(blob[blob.l]) {
						case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
						case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]); break;
						case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]); break;
						case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
						case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
						case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
						case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
						case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
						default: throw new Error("unparsed value: " + blob[blob.l]);
					}
					PropH[name] = val;
				}
			}
		}
		blob.l = start_addr + size; /* step ahead to skip padding */
		return PropH;
	}
	
	/* [MS-OLEPS] 2.21 PropertySetStream */
	function parse_PropertySetStream(file, PIDSI) {
		var blob = file.content;
		if(!blob) return ({});
		prep_blob(blob, 0);
	
		var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
		blob.chk('feff', 'Byte Order: ');
	
		/*var vers = */blob.read_shift(2); // TODO: check version
		var SystemIdentifier = blob.read_shift(4);
		blob.chk(CFB.utils.consts.HEADER_CLSID, 'CLSID: ');
		NumSets = blob.read_shift(4);
		if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
		FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);
	
		if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
		else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
		var PSet0 = parse_PropertySet(blob, PIDSI);
	
		var rval = ({ SystemIdentifier: SystemIdentifier });
		for(var y in PSet0) rval[y] = PSet0[y];
		//rval.blob = blob;
		rval.FMTID = FMTID0;
		//rval.PSet0 = PSet0;
		if(NumSets === 1) return rval;
		if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
		var PSet1;
		try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
		for(y in PSet1) rval[y] = PSet1[y];
		rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
		return rval;
	}
	
	
	function parsenoop2(blob, length) { blob.read_shift(length); return null; }
	function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }
	
	function parslurp(blob, length, cb) {
		var arr = [], target = blob.l + length;
		while(blob.l < target) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
	function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }
	
	function parseuint16(blob) { return blob.read_shift(2, 'u'); }
	function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
	function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}
	
	/* --- 2.5 Structures --- */
	
	/* [MS-XLS] 2.5.10 Bes (boolean or error) */
	function parse_Bes(blob) {
		var v = blob.read_shift(1), t = blob.read_shift(1);
		return t === 0x01 ? v : v === 0x01;
	}
	function write_Bes(v, t, o) {
		if(!o) o = new_buf(2);
		o.write_shift(1, +v);
		o.write_shift(1, t == 'e' ? 1 : 0);
		return o;
	}
	
	/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
	function parse_ShortXLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
		var encoding = 'sbcs-cont';
		var cp = current_codepage;
		if(opts && opts.biff >= 8) current_codepage = 1200;
		if(!opts || opts.biff == 8 ) {
			var fHighByte = blob.read_shift(1);
			if(fHighByte) { encoding = 'dbcs-cont'; }
		} else if(opts.biff == 12) {
			encoding = 'wstr';
		}
		if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
		var o = cch ? blob.read_shift(cch, encoding) : "";
		current_codepage = cp;
		return o;
	}
	
	/* 2.5.293 XLUnicodeRichExtendedString */
	function parse_XLUnicodeRichExtendedString(blob) {
		var cp = current_codepage;
		current_codepage = 1200;
		var cch = blob.read_shift(2), flags = blob.read_shift(1);
		var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
		var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
		var cRun = 0, cbExtRst;
		var z = {};
		if(fRichSt) cRun = blob.read_shift(2);
		if(fExtSt) cbExtRst = blob.read_shift(4);
		var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
		var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
		if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
		if(fExtSt) blob.l += cbExtRst; //TODO: parse this
		z.t = msg;
		if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
		current_codepage = cp;
		return z;
	}
	
	/* 2.5.296 XLUnicodeStringNoCch */
	function parse_XLUnicodeStringNoCch(blob, cch, opts) {
		var retval;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
			if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
		}
		var fHighByte = blob.read_shift(1);
		if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
		else { retval = blob.read_shift(cch, 'dbcs-cont'); }
		return retval;
	}
	
	/* 2.5.294 XLUnicodeString */
	function parse_XLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		if(cch === 0) { blob.l++; return ""; }
		return parse_XLUnicodeStringNoCch(blob, cch, opts);
	}
	/* BIFF5 override */
	function parse_XLUnicodeString2(blob, length, opts) {
		if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
	}
	/* TODO: BIFF5 and lower, codepage awareness */
	function write_XLUnicodeString(str, opts, o) {
		if(!o) o = new_buf(3 + 2 * str.length);
		o.write_shift(2, str.length);
		o.write_shift(1, 1);
		o.write_shift(31, str, 'utf16le');
		return o;
	}
	
	/* [MS-XLS] 2.5.61 ControlInfo */
	function parse_ControlInfo(blob) {
		var flags = blob.read_shift(1);
		blob.l++;
		var accel = blob.read_shift(2);
		blob.l += 2;
		return [flags, accel];
	}
	
	/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
	function parse_URLMoniker(blob) {
		var len = blob.read_shift(4), start = blob.l;
		var extra = false;
		if(len > 24) {
			/* look ahead */
			blob.l += len - 24;
			if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
			blob.l = start;
		}
		var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
		if(extra) blob.l += 24;
		return url;
	}
	
	/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
	function parse_FileMoniker(blob) {
		blob.l += 2; //var cAnti = blob.read_shift(2);
		var ansiPath = blob.read_shift(0, 'lpstr-ansi');
		blob.l += 2; //var endServer = blob.read_shift(2);
		if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
		var sz = blob.read_shift(4);
		if(sz === 0) return ansiPath.replace(/\\/g,"/");
		var bytes = blob.read_shift(4);
		if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
		var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
		return unicodePath;
	}
	
	/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
	function parse_HyperlinkMoniker(blob, length) {
		var clsid = blob.read_shift(16); length -= 16;
		switch(clsid) {
			case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
			case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
			default: throw new Error("Unsupported Moniker " + clsid);
		}
	}
	
	/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
	function parse_HyperlinkString(blob) {
		var len = blob.read_shift(4);
		var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
		return o;
	}
	
	/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
	function parse_Hyperlink(blob, length) {
		var end = blob.l + length;
		var sVer = blob.read_shift(4);
		if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
		var flags = blob.read_shift(2);
		blob.l += 2;
		var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
		if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
		if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0020) guid = blob.read_shift(16);
		if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
		blob.l = end;
		var target = targetFrameName||moniker||oleMoniker||"";
		if(target && Loc) target+="#"+Loc;
		if(!target) target = "#" + Loc;
		var out = ({Target:target});
		if(guid) out.guid = guid;
		if(fileTime) out.time = fileTime;
		if(displayName) out.Tooltip = displayName;
		return out;
	}
	function write_Hyperlink(hl) {
		var out = new_buf(512), i = 0;
		var Target = hl.Target;
		var F = Target.indexOf("#") > -1 ? 0x1f : 0x17;
		switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
		out.write_shift(4,2); out.write_shift(4, F);
		var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
		if(F == 0x1C) {
			Target = Target.slice(1);
			out.write_shift(4, Target.length + 1);
			for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
			out.write_shift(2, 0);
		} else if(F & 0x02) {
			data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			out.write_shift(4, 2*(Target.length + 1));
			for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
			out.write_shift(2, 0);
		} else {
			data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var P = 0;
			while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
			out.write_shift(2, P);
			out.write_shift(4, Target.length + 1);
			for(i = 0; i < Target.length; ++i) out.write_shift(1, Target.charCodeAt(i) & 0xFF);
			out.write_shift(1, 0);
			out.write_shift(2, 0xFFFF);
			out.write_shift(2, 0xDEAD);
			for(i = 0; i < 6; ++i) out.write_shift(4, 0);
		}
		return out.slice(0, out.l);
	}
	
	/* 2.5.178 LongRGBA */
	function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }
	
	/* 2.5.177 LongRGB */
	function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }
	
	
	/* --- MS-XLS --- */
	
	/* 2.5.19 */
	function parse_XLSCell(blob) {
		var rw = blob.read_shift(2); // 0-indexed
		var col = blob.read_shift(2);
		var ixfe = blob.read_shift(2);
		return ({r:rw, c:col, ixfe:ixfe});
	}
	function write_XLSCell(R, C, ixfe, o) {
		if(!o) o = new_buf(6);
		o.write_shift(2, R);
		o.write_shift(2, C);
		o.write_shift(2, ixfe||0);
		return o;
	}
	
	/* 2.5.134 */
	function parse_frtHeader(blob) {
		var rt = blob.read_shift(2);
		var flags = blob.read_shift(2); // TODO: parse these flags
		blob.l += 8;
		return {type: rt, flags: flags};
	}
	
	
	
	function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }
	
	/* 2.5.344 */
	function parse_XTI(blob, length, opts) {
		var w = opts.biff > 8 ? 4 : 2;
		var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
		return [iSupBook, itabFirst, itabLast];
	}
	
	/* 2.5.218 */
	function parse_RkRec(blob) {
		var ixfe = blob.read_shift(2);
		var RK = parse_RkNumber(blob);
		return [ixfe, RK];
	}
	
	/* 2.5.1 */
	function parse_AddinUdf(blob, length, opts) {
		blob.l += 4; length -= 4;
		var l = blob.l + length;
		var udfName = parse_ShortXLUnicodeString(blob, length, opts);
		var cb = blob.read_shift(2);
		l -= blob.l;
		if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
		blob.l += cb;
		return udfName;
	}
	
	/* 2.5.209 TODO: Check sizes */
	function parse_Ref8U(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(2);
		var colLast = blob.read_shift(2);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	function write_Ref8U(r, o) {
		if(!o) o = new_buf(8);
		o.write_shift(2, r.s.r);
		o.write_shift(2, r.e.r);
		o.write_shift(2, r.s.c);
		o.write_shift(2, r.e.c);
		return o;
	}
	
	/* 2.5.211 */
	function parse_RefU(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(1);
		var colLast = blob.read_shift(1);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* 2.5.207 */
	var parse_Ref = parse_RefU;
	
	/* 2.5.143 */
	function parse_FtCmo(blob) {
		blob.l += 4;
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var flags = blob.read_shift(2);
		blob.l+=12;
		return [id, ot, flags];
	}
	
	/* 2.5.149 */
	function parse_FtNts(blob) {
		var out = {};
		blob.l += 4;
		blob.l += 16; // GUID TODO
		out.fSharedNote = blob.read_shift(2);
		blob.l += 4;
		return out;
	}
	
	/* 2.5.142 */
	function parse_FtCf(blob) {
		var out = {};
		blob.l += 4;
		blob.cf = blob.read_shift(2);
		return out;
	}
	
	/* 2.5.140 - 2.5.154 and friends */
	function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
	var FtTab = {
	0x00: parse_FtSkip,      /* FtEnd */
	0x04: parse_FtSkip,      /* FtMacro */
	0x05: parse_FtSkip,      /* FtButton */
	0x06: parse_FtSkip,      /* FtGmo */
	0x07: parse_FtCf,        /* FtCf */
	0x08: parse_FtSkip,      /* FtPioGrbit */
	0x09: parse_FtSkip,      /* FtPictFmla */
	0x0A: parse_FtSkip,      /* FtCbls */
	0x0B: parse_FtSkip,      /* FtRbo */
	0x0C: parse_FtSkip,      /* FtSbs */
	0x0D: parse_FtNts,       /* FtNts */
	0x0E: parse_FtSkip,      /* FtSbsFmla */
	0x0F: parse_FtSkip,      /* FtGboData */
	0x10: parse_FtSkip,      /* FtEdoData */
	0x11: parse_FtSkip,      /* FtRboData */
	0x12: parse_FtSkip,      /* FtCblsData */
	0x13: parse_FtSkip,      /* FtLbsData */
	0x14: parse_FtSkip,      /* FtCblsFmla */
	0x15: parse_FtCmo
	};
	function parse_FtArray(blob, length) {
		var tgt = blob.l + length;
		var fts = [];
		while(blob.l < tgt) {
			var ft = blob.read_shift(2);
			blob.l-=2;
			try {
				fts.push(FtTab[ft](blob, tgt - blob.l));
			} catch(e) { blob.l = tgt; return fts; }
		}
		if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
		return fts;
	}
	
	/* --- 2.4 Records --- */
	
	/* 2.4.21 */
	function parse_BOF(blob, length) {
		var o = {BIFFVer:0, dt:0};
		o.BIFFVer = blob.read_shift(2); length -= 2;
		if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
		switch(o.BIFFVer) {
			case 0x0600: /* BIFF8 */
			case 0x0500: /* BIFF5 */
			case 0x0002: case 0x0007: /* BIFF2 */
				break;
			default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
		}
	
		blob.read_shift(length);
		return o;
	}
	function write_BOF(wb, t, o) {
		var h = 0x0600, w = 16;
		switch(o.bookType) {
			case 'biff8': break;
			case 'biff5': h = 0x0500; w = 8; break;
			case 'biff4': h = 0x0004; w = 6; break;
			case 'biff3': h = 0x0003; w = 6; break;
			case 'biff2': h = 0x0002; w = 4; break;
			case 'xla': break;
			default: throw new Error("unsupported BIFF version");
		}
		var out = new_buf(w);
		out.write_shift(2, h);
		out.write_shift(2, t);
		if(w > 4) out.write_shift(2, 0x7262);
		if(w > 6) out.write_shift(2, 0x07CD);
		if(w > 8) {
			out.write_shift(2, 0xC009);
			out.write_shift(2, 0x0001);
			out.write_shift(2, 0x0706);
			out.write_shift(2, 0x0000);
		}
		return out;
	}
	
	
	/* 2.4.146 */
	function parse_InterfaceHdr(blob, length) {
		if(length === 0) return 0x04b0;
		if((blob.read_shift(2))!==0x04b0){/* empty */}
		return 0x04b0;
	}
	
	
	/* 2.4.349 */
	function parse_WriteAccess(blob, length, opts) {
		if(opts.enc) { blob.l += length; return ""; }
		var l = blob.l;
		// TODO: make sure XLUnicodeString doesnt overrun
		var UserName = parse_XLUnicodeString2(blob, 0, opts);
		blob.read_shift(length + l - blob.l);
		return UserName;
	}
	function write_WriteAccess(s, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(b8 ? 112 : 54);
		o.write_shift(opts.biff == 8 ? 2 : 1, 7);
		o.write_shift(1, 0);
		o.write_shift(4, 0x33336853);
		o.write_shift(4, 0x00534A74);
		while(o.l < o.length) o.write_shift(1, 0);
		return o;
	}
	
	/* 2.4.351 */
	function parse_WsBool(blob, length, opts) {
		var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
		return { fDialog: flags & 0x10 };
	}
	
	/* 2.4.28 */
	function parse_BoundSheet8(blob, length, opts) {
		var pos = blob.read_shift(4);
		var hidden = blob.read_shift(1) & 0x03;
		var dt = blob.read_shift(1);
		switch(dt) {
			case 0: dt = 'Worksheet'; break;
			case 1: dt = 'Macrosheet'; break;
			case 2: dt = 'Chartsheet'; break;
			case 6: dt = 'VBAModule'; break;
		}
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		if(name.length === 0) name = "Sheet1";
		return { pos:pos, hs:hidden, dt:dt, name:name };
	}
	function write_BoundSheet8(data, opts) {
		var w = (!opts || opts.biff >= 8 ? 2 : 1);
		var o = new_buf(8 + w * data.name.length);
		o.write_shift(4, data.pos);
		o.write_shift(1, data.hs || 0);
		o.write_shift(1, data.dt);
		o.write_shift(1, data.name.length);
		if(opts.biff >= 8) o.write_shift(1, 1);
		o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
		return o.slice(0, o.l);
	}
	
	/* 2.4.265 TODO */
	function parse_SST(blob, length) {
		var end = blob.l + length;
		var cnt = blob.read_shift(4);
		var ucnt = blob.read_shift(4);
		var strs = ([]);
		for(var i = 0; i != ucnt && blob.l < end; ++i) {
			strs.push(parse_XLUnicodeRichExtendedString(blob));
		}
		strs.Count = cnt; strs.Unique = ucnt;
		return strs;
	}
	
	/* 2.4.107 */
	function parse_ExtSST(blob, length) {
		var extsst = {};
		extsst.dsst = blob.read_shift(2);
		blob.l += length-2;
		return extsst;
	}
	
	
	/* 2.4.221 TODO: check BIFF2-4 */
	function parse_Row(blob) {
		var z = ({});
		z.r = blob.read_shift(2);
		z.c = blob.read_shift(2);
		z.cnt = blob.read_shift(2) - z.c;
		var miyRw = blob.read_shift(2);
		blob.l += 4; // reserved(2), unused(2)
		var flags = blob.read_shift(1); // various flags
		blob.l += 3; // reserved(8), ixfe(12), flags(4)
		if(flags & 0x07) z.level = flags & 0x07;
		// collapsed: flags & 0x10
		if(flags & 0x20) z.hidden = true;
		if(flags & 0x40) z.hpt = miyRw / 20;
		return z;
	}
	
	
	/* 2.4.125 */
	function parse_ForceFullCalculation(blob) {
		var header = parse_frtHeader(blob);
		if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
		var fullcalc = blob.read_shift(4);
		return fullcalc !== 0x0;
	}
	
	
	
	
	
	/* 2.4.215 rt */
	function parse_RecalcId(blob) {
		blob.read_shift(2);
		return blob.read_shift(4);
	}
	
	/* 2.4.87 */
	function parse_DefaultRowHeight(blob, length, opts) {
		var f = 0;
		if(!(opts && opts.biff == 2)) {
			f = blob.read_shift(2);
		}
		var miyRw = blob.read_shift(2);
		if((opts && opts.biff == 2)) {
			f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
		}
		var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
		return [fl, miyRw];
	}
	
	/* 2.4.345 TODO */
	function parse_Window1(blob) {
		var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
		var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
		var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
		return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
			FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
	}
	function write_Window1() {
		var o = new_buf(18);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0x7260);
		o.write_shift(2, 0x44c0);
		o.write_shift(2, 0x38);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 1);
		o.write_shift(2, 0x01f4);
		return o;
	}
	/* 2.4.346 TODO */
	function parse_Window2(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff < 8) return {};
		var f = blob.read_shift(2);
		return { RTL: f & 0x40 };
	}
	function write_Window2(view) {
		var o = new_buf(18), f = 0x6b6;
		if(view && view.RTL) f |= 0x40;
		o.write_shift(2, f);
		o.write_shift(4, 0);
		o.write_shift(4, 64);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* 2.4.122 TODO */
	function parse_Font(blob, length, opts) {
		var o = {
			dyHeight: blob.read_shift(2),
			fl: blob.read_shift(2)
		};
		switch(opts && opts.biff || 8) {
			case 2: break;
			case 3: case 4: blob.l += 2; break;
			default: blob.l += 10; break;
		}
		o.name = parse_ShortXLUnicodeString(blob, 0, opts);
		return o;
	}
	
	/* 2.4.149 */
	function parse_LabelSst(blob) {
		var cell = parse_XLSCell(blob);
		cell.isst = blob.read_shift(4);
		return cell;
	}
	
	/* 2.4.148 */
	function parse_Label(blob, length, opts) {
		var target = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) blob.l++;
		var str = parse_XLUnicodeString(blob, target - blob.l, opts);
		cell.val = str;
		return cell;
	}
	function write_Label(R, C, v, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
		write_XLSCell(R, C, 0, o);
		o.write_shift(2, v.length);
		if(b8) o.write_shift(1, 1);
		o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
		return o;
	}
	
	
	/* 2.4.126 Number Formats */
	function parse_Format(blob, length, opts) {
		var numFmtId = blob.read_shift(2);
		var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
		return [numFmtId, fmtstr];
	}
	var parse_BIFF2Format = parse_XLUnicodeString2;
	
	/* 2.4.90 */
	function parse_Dimensions(blob, length, opts) {
		var end = blob.l + length;
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var r = blob.read_shift(w), R = blob.read_shift(w);
		var c = blob.read_shift(2), C = blob.read_shift(2);
		blob.l = end;
		return {s: {r:r, c:c}, e: {r:R, c:C}};
	}
	function write_Dimensions(range, opts) {
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var o = new_buf(2*w + 6);
		o.write_shift(w, range.s.r);
		o.write_shift(w, range.e.r + 1);
		o.write_shift(2, range.s.c);
		o.write_shift(2, range.e.c + 1);
		o.write_shift(2, 0);
		return o;
	}
	
	/* 2.4.220 */
	function parse_RK(blob) {
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrec = parse_RkRec(blob);
		return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
	}
	
	/* 2.4.175 */
	function parse_MulRk(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrecs = [];
		while(blob.l < target) rkrecs.push(parse_RkRec(blob));
		if(blob.l !== target) throw new Error("MulRK read error");
		var lastcol = blob.read_shift(2);
		if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
		return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
	}
	/* 2.4.174 */
	function parse_MulBlank(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var ixfes = [];
		while(blob.l < target) ixfes.push(blob.read_shift(2));
		if(blob.l !== target) throw new Error("MulBlank read error");
		var lastcol = blob.read_shift(2);
		if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
		return {r:rw, c:col, C:lastcol, ixfe:ixfes};
	}
	
	/* 2.5.20 2.5.249 TODO: interpret values here */
	function parse_CellStyleXF(blob, length, style, opts) {
		var o = {};
		var a = blob.read_shift(4), b = blob.read_shift(4);
		var c = blob.read_shift(4), d = blob.read_shift(2);
		o.patternType = XLSFillPattern[c >> 26];
	
		if(!opts.cellStyles) return o;
		o.alc = a & 0x07;
		o.fWrap = (a >> 3) & 0x01;
		o.alcV = (a >> 4) & 0x07;
		o.fJustLast = (a >> 7) & 0x01;
		o.trot = (a >> 8) & 0xFF;
		o.cIndent = (a >> 16) & 0x0F;
		o.fShrinkToFit = (a >> 20) & 0x01;
		o.iReadOrder = (a >> 22) & 0x02;
		o.fAtrNum = (a >> 26) & 0x01;
		o.fAtrFnt = (a >> 27) & 0x01;
		o.fAtrAlc = (a >> 28) & 0x01;
		o.fAtrBdr = (a >> 29) & 0x01;
		o.fAtrPat = (a >> 30) & 0x01;
		o.fAtrProt = (a >> 31) & 0x01;
	
		o.dgLeft = b & 0x0F;
		o.dgRight = (b >> 4) & 0x0F;
		o.dgTop = (b >> 8) & 0x0F;
		o.dgBottom = (b >> 12) & 0x0F;
		o.icvLeft = (b >> 16) & 0x7F;
		o.icvRight = (b >> 23) & 0x7F;
		o.grbitDiag = (b >> 30) & 0x03;
	
		o.icvTop = c & 0x7F;
		o.icvBottom = (c >> 7) & 0x7F;
		o.icvDiag = (c >> 14) & 0x7F;
		o.dgDiag = (c >> 21) & 0x0F;
	
		o.icvFore = d & 0x7F;
		o.icvBack = (d >> 7) & 0x7F;
		o.fsxButton = (d >> 14) & 0x01;
		return o;
	}
	//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
	//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
	
	/* 2.4.353 TODO: actually do this right */
	function parse_XF(blob, length, opts) {
		var o = {};
		o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
		o.fStyle = (o.flags >> 2) & 0x01;
		length -= 6;
		o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
		return o;
	}
	
	/* 2.4.134 */
	function parse_Guts(blob) {
		blob.l += 4;
		var out = [blob.read_shift(2), blob.read_shift(2)];
		if(out[0] !== 0) out[0]--;
		if(out[1] !== 0) out[1]--;
		if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
		return out;
	}
	function write_Guts(guts) {
		var o = new_buf(8);
		o.write_shift(4, 0);
		o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
		o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
		return o;
	}
	
	/* 2.4.24 */
	function parse_BoolErr(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_Bes(blob, 2);
		cell.val = val;
		cell.t = (val === true || val === false) ? 'b' : 'e';
		return cell;
	}
	function write_BoolErr(R, C, v, opts, t) {
		var o = new_buf(8);
		write_XLSCell(R, C, 0, o);
		write_Bes(v, t, o);
		return o;
	}
	
	/* 2.4.180 Number */
	function parse_Number(blob) {
		var cell = parse_XLSCell(blob, 6);
		var xnum = parse_Xnum(blob, 8);
		cell.val = xnum;
		return cell;
	}
	function write_Number(R, C, v) {
		var o = new_buf(14);
		write_XLSCell(R, C, 0, o);
		write_Xnum(v, o);
		return o;
	}
	
	var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
	
	/* 2.4.271 */
	function parse_SupBook(blob, length, opts) {
		var end = blob.l + length;
		var ctab = blob.read_shift(2);
		var cch = blob.read_shift(2);
		opts.sbcch = cch;
		if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
		if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
		var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
		/* TODO: 2.5.277 Virtual Path */
		var rgst = [];
		while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
		return [cch, ctab, virtPath, rgst];
	}
	
	/* 2.4.105 TODO */
	function parse_ExternName(blob, length, opts) {
		var flags = blob.read_shift(2);
		var body;
		var o = ({
			fBuiltIn: flags & 0x01,
			fWantAdvise: (flags >>> 1) & 0x01,
			fWantPict: (flags >>> 2) & 0x01,
			fOle: (flags >>> 3) & 0x01,
			fOleLink: (flags >>> 4) & 0x01,
			cf: (flags >>> 5) & 0x3FF,
			fIcon: flags >>> 15 & 0x01
		});
		if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
		//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
		o.body = body || blob.read_shift(length-2);
		if(typeof body === "string") o.Name = body;
		return o;
	}
	
	/* 2.4.150 TODO */
	var XLSLblBuiltIn = [
		"_xlnm.Consolidate_Area",
		"_xlnm.Auto_Open",
		"_xlnm.Auto_Close",
		"_xlnm.Extract",
		"_xlnm.Database",
		"_xlnm.Criteria",
		"_xlnm.Print_Area",
		"_xlnm.Print_Titles",
		"_xlnm.Recorder",
		"_xlnm.Data_Form",
		"_xlnm.Auto_Activate",
		"_xlnm.Auto_Deactivate",
		"_xlnm.Sheet_Title",
		"_xlnm._FilterDatabase"
	];
	function parse_Lbl(blob, length, opts) {
		var target = blob.l + length;
		var flags = blob.read_shift(2);
		var chKey = blob.read_shift(1);
		var cch = blob.read_shift(1);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var itab = 0;
		if(!opts || opts.biff >= 5) {
			if(opts.biff != 5) blob.l += 2;
			itab = blob.read_shift(2);
			if(opts.biff == 5) blob.l += 2;
			blob.l += 4;
		}
		var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
		if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
		var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
		var rgce = target == blob.l || cce === 0 ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
		return {
			chKey: chKey,
			Name: name,
			itab: itab,
			rgce: rgce
		};
	}
	
	/* 2.4.106 TODO: verify filename encoding */
	function parse_ExternSheet(blob, length, opts) {
		if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
		var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
		while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
			// [iSupBook, itabFirst, itabLast];
		if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
		return o;
	}
	function parse_BIFF5ExternSheet(blob, length, opts) {
		if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
		var o = parse_ShortXLUnicodeString(blob, length, opts);
		return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
	}
	
	/* 2.4.176 TODO: check older biff */
	function parse_NameCmt(blob, length, opts) {
		if(opts.biff < 8) { blob.l += length; return; }
		var cchName = blob.read_shift(2);
		var cchComment = blob.read_shift(2);
		var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
		var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
		return [name, comment];
	}
	
	/* 2.4.260 */
	function parse_ShrFmla(blob, length, opts) {
		var ref = parse_RefU(blob, 6);
		blob.l++;
		var cUse = blob.read_shift(1);
		length -= 8;
		return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
	}
	
	/* 2.4.4 TODO */
	function parse_Array(blob, length, opts) {
		var ref = parse_Ref(blob, 6);
		/* TODO: fAlwaysCalc */
		switch(opts.biff) {
			case 2: blob.l ++; length -= 7; break;
			case 3: case 4: blob.l += 2; length -= 8; break;
			default: blob.l += 6; length -= 12;
		}
		return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
	}
	
	/* 2.4.173 */
	function parse_MTRSettings(blob) {
		var fMTREnabled = blob.read_shift(4) !== 0x00;
		var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
		var cUserThreadCount = blob.read_shift(4);
		return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
	}
	
	/* 2.5.186 TODO: BIFF5 */
	function parse_NoteSh(blob, length, opts) {
		if(opts.biff < 8) return;
		var row = blob.read_shift(2), col = blob.read_shift(2);
		var flags = blob.read_shift(2), idObj = blob.read_shift(2);
		var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
		if(opts.biff < 8) blob.read_shift(1);
		return [{r:row,c:col}, stAuthor, idObj, flags];
	}
	
	/* 2.4.179 */
	function parse_Note(blob, length, opts) {
		/* TODO: Support revisions */
		return parse_NoteSh(blob, length, opts);
	}
	
	/* 2.4.168 */
	function parse_MergeCells(blob, length) {
		var merges = [];
		var cmcs = blob.read_shift(2);
		while (cmcs--) merges.push(parse_Ref8U(blob,length));
		return merges;
	}
	function write_MergeCells(merges) {
		var o = new_buf(2 + merges.length * 8);
		o.write_shift(2, merges.length);
		for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
		return o;
	}
	
	/* 2.4.181 TODO: parse all the things! */
	function parse_Obj(blob, length, opts) {
		if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
		var cmo = parse_FtCmo(blob, 22); // id, ot, flags
		var fts = parse_FtArray(blob, length-22, cmo[1]);
		return { cmo: cmo, ft:fts };
	}
	/* from older spec */
	var parse_BIFF5OT = [];
	parse_BIFF5OT[0x08] = function(blob, length) {
		var tgt = blob.l + length;
		blob.l += 10; // todo
		var cf = blob.read_shift(2);
		blob.l += 4;
		blob.l += 2; //var cbPictFmla = blob.read_shift(2);
		blob.l += 2;
		blob.l += 2; //var grbit = blob.read_shift(2);
		blob.l += 4;
		var cchName = blob.read_shift(1);
		blob.l += cchName; // TODO: stName
		blob.l = tgt; // TODO: fmla
		return { fmt:cf };
	};
	
	function parse_BIFF5Obj(blob, length, opts) {
		blob.l += 4; //var cnt = blob.read_shift(4);
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var grbit = blob.read_shift(2);
		blob.l += 2; //var colL = blob.read_shift(2);
		blob.l += 2; //var dxL = blob.read_shift(2);
		blob.l += 2; //var rwT = blob.read_shift(2);
		blob.l += 2; //var dyT = blob.read_shift(2);
		blob.l += 2; //var colR = blob.read_shift(2);
		blob.l += 2; //var dxR = blob.read_shift(2);
		blob.l += 2; //var rwB = blob.read_shift(2);
		blob.l += 2; //var dyB = blob.read_shift(2);
		blob.l += 2; //var cbMacro = blob.read_shift(2);
		blob.l += 6;
		length -= 36;
		var fts = [];
		fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
		return { cmo: [id, ot, grbit], ft:fts };
	}
	
	/* 2.4.329 TODO: parse properly */
	function parse_TxO(blob, length, opts) {
		var s = blob.l;
		var texts = "";
	try {
		blob.l += 4;
		var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
		var controlInfo; // eslint-disable-line no-unused-vars
		if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
		else controlInfo = parse_ControlInfo(blob, 6, opts);
		var cchText = blob.read_shift(2);
		/*var cbRuns = */blob.read_shift(2);
		/*var ifntEmpty = */parseuint16(blob, 2);
		var len = blob.read_shift(2);
		blob.l += len;
		//var fmla = parse_ObjFmla(blob, s + length - blob.l);
	
		for(var i = 1; i < blob.lens.length-1; ++i) {
			if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
			var hdr = blob[blob.l];
			var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
			texts += t;
			if(texts.length >= (hdr ? cchText : 2*cchText)) break;
		}
		if(texts.length !== cchText && texts.length !== cchText*2) {
			throw new Error("cchText: " + cchText + " != " + texts.length);
		}
	
		blob.l = s + length;
		/* 2.5.272 TxORuns */
	//	var rgTxoRuns = [];
	//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
	//	var cchText2 = blob.read_shift(2);
	//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
	//	blob.l += 6;
	//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
		return { t: texts };
	} catch(e) { blob.l = s + length; return { t: texts }; }
	}
	
	/* 2.4.140 */
	function parse_HLink(blob, length) {
		var ref = parse_Ref8U(blob, 8);
		blob.l += 16; /* CLSID */
		var hlink = parse_Hyperlink(blob, length-24);
		return [ref, hlink];
	}
	function write_HLink(hl) {
		var O = new_buf(24);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
		return bconcat([O, write_Hyperlink(hl[1])]);
	}
	
	
	/* 2.4.141 */
	function parse_HLinkTooltip(blob, length) {
		blob.read_shift(2);
		var ref = parse_Ref8U(blob, 8);
		var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
		wzTooltip = wzTooltip.replace(chr0,"");
		return [ref, wzTooltip];
	}
	function write_HLinkTooltip(hl) {
		var TT = hl[1].Tooltip;
		var O = new_buf(10 + 2 * (TT.length + 1));
		O.write_shift(2, 0x0800);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
		O.write_shift(2, 0);
		return O;
	}
	
	/* 2.4.63 */
	function parse_Country(blob) {
		var o = [0,0], d;
		d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
		d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
		return o;
	}
	function write_Country(o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, 0x01);
		o.write_shift(2, 0x01);
		return o;
	}
	
	/* 2.4.50 ClrtClient */
	function parse_ClrtClient(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* 2.4.188 */
	function parse_Palette(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* 2.4.354 */
	function parse_XFCRC(blob) {
		blob.l += 2;
		var o = {cxfs:0, crc:0};
		o.cxfs = blob.read_shift(2);
		o.crc = blob.read_shift(4);
		return o;
	}
	
	/* 2.4.53 TODO: parse flags */
	/* [MS-XLSB] 2.4.323 TODO: parse flags */
	function parse_ColInfo(blob, length, opts) {
		if(!opts.cellStyles) return parsenoop(blob, length);
		var w = opts && opts.biff >= 12 ? 4 : 2;
		var colFirst = blob.read_shift(w);
		var colLast = blob.read_shift(w);
		var coldx = blob.read_shift(w);
		var ixfe = blob.read_shift(w);
		var flags = blob.read_shift(2);
		if(w == 2) blob.l += 2;
		return {s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags};
	}
	
	/* 2.4.257 */
	function parse_Setup(blob/*, length*/) {
		var o = {};
		blob.l += 16;
		o.header = parse_Xnum(blob, 8);
		o.footer = parse_Xnum(blob, 8);
		blob.l += 2;
		return o;
	}
	
	/* 2.4.261 */
	function parse_ShtProps(blob, length, opts) {
		var def = {area:false};
		if(opts.biff != 5) { blob.l += length; return def; }
		var d = blob.read_shift(1); blob.l += 3;
		if((d & 0x10)) def.area = true;
		return def;
	}
	
	/* 2.4.241 */
	function write_RRTabId(n) {
		var out = new_buf(2 * n);
		for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
		return out;
	}
	
	var parse_Blank = parse_XLSCell; /* 2.4.20 Just the cell */
	var parse_Scl = parseuint16a; /* 2.4.247 num, den */
	var parse_String = parse_XLUnicodeString; /* 2.4.268 */
	
	/* --- Specific to versions before BIFF8 --- */
	function parse_ImData(blob) {
		var cf = blob.read_shift(2);
		var env = blob.read_shift(2);
		var lcb = blob.read_shift(4);
		var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
		blob.l += lcb;
		return o;
	}
	
	/* BIFF2_??? where ??? is the name from [XLS] */
	function parse_BIFF2STR(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var str = parse_XLUnicodeString2(blob, length-7, opts);
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	
	function parse_BIFF2NUM(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = parse_Xnum(blob, 8);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2NUM(r, c, val) {
		var out = new_buf(15);
		write_BIFF2Cell(out, r, c);
		out.write_shift(8, val, 'f');
		return out;
	}
	
	function parse_BIFF2INT(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = blob.read_shift(2);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2INT(r, c, val) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		out.write_shift(2, val);
		return out;
	}
	
	function parse_BIFF2STRING(blob) {
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, 'sbcs-cont');
	}
	
	/* TODO: convert to BIFF8 font struct */
	function parse_BIFF2FONTXTRA(blob, length) {
		blob.l += 6; // unknown
		blob.l += 2; // font weight "bls"
		blob.l += 1; // charset
		blob.l += 3; // unknown
		blob.l += 1; // font family
		blob.l += length - 13;
	}
	
	/* TODO: parse rich text runs */
	function parse_RString(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		var cch = blob.read_shift(2);
		var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
		blob.l = end;
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	/* from js-harb (C) 2014-present  SheetJS */
	var DBF = (function() {
	var dbf_codepage_map = {
		/* Code Pages Supported by Visual FoxPro */
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	
		/* shapefile DBF extension */
	0x00: 20127,           0x08:   865,
	0x09:   437,           0x0A:   850,
	0x0B:   437,           0x0D:   437,
	0x0E:   850,           0x0F:   437,
	0x10:   850,           0x11:   437,
	0x12:   850,           0x13:   932,
	0x14:   850,           0x15:   437,
	0x16:   850,           0x17:   865,
	0x18:   437,           0x19:   437,
	0x1A:   850,           0x1B:   437,
	0x1C:   863,           0x1D:   850,
	0x1F:   852,           0x22:   852,
	0x23:   852,           0x24:   860,
	0x25:   850,           0x26:   866,
	0x37:   850,           0x40:   852,
	0x4D:   936,           0x4E:   949,
	0x4F:   950,           0x50:   874,
	0x57:  1252,           0x58:  1252,
	0x59:  1252,
	
	0xFF: 16969
	};
	
	/* TODO: find an actual specification */
	function dbf_to_aoa(buf, opts) {
		var out = [];
		/* TODO: browser based */
		var d = (new_raw_buf(1));
		switch(opts.type) {
			case 'base64': d = s2a(Base64.decode(buf)); break;
			case 'binary': d = s2a(buf); break;
			case 'buffer':
			case 'array': d = buf; break;
		}
		prep_blob(d, 0);
		/* header */
		var ft = d.read_shift(1);
		var memo = false;
		var vfp = false, l7 = false;
		switch(ft) {
			case 0x02: case 0x03: break;
			case 0x30: vfp = true; memo = true; break;
			case 0x31: vfp = true; break;
			case 0x83: memo = true; break;
			case 0x8B: memo = true; break;
			case 0x8C: memo = true; l7 = true; break;
			case 0xF5: memo = true; break;
			default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
		}
		var /*filedate = new Date(),*/ nrow = 0, fpos = 0;
		if(ft == 0x02) nrow = d.read_shift(2);
		/*filedate = new Date(d.read_shift(1) + 1900, d.read_shift(1) - 1, d.read_shift(1));*/d.l += 3;
		if(ft != 0x02) nrow = d.read_shift(4);
		if(ft != 0x02) fpos = d.read_shift(2);
		var rlen = d.read_shift(2);
	
		var /*flags = 0,*/ current_cp = 1252;
		if(ft != 0x02) {
		d.l+=16;
		/*flags = */d.read_shift(1);
		//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
	
		/* codepage present in FoxPro */
		if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
		d.l+=1;
	
		d.l+=2;
		}
		if(l7) d.l += 36;
	var fields = [], field = ({});
		var hend = fpos - 10 - (vfp ? 264 : 0), ww = l7 ? 32 : 11;
		while(ft == 0x02 ? d.l < d.length && d[d.l] != 0x0d: d.l < hend) {
			field = ({});
			field.name = cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
			d.l += ww;
			field.type = String.fromCharCode(d.read_shift(1));
			if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
			field.len = d.read_shift(1);
			if(ft == 0x02) field.offset = d.read_shift(2);
			field.dec = d.read_shift(1);
			if(field.name.length) fields.push(field);
			if(ft != 0x02) d.l += l7 ? 13 : 14;
			switch(field.type) {
				case 'B': // VFP Double
					if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'G': // General
				case 'P': // Picture
					if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'C': // character
				case 'D': // date
				case 'F': // floating point
				case 'I': // long
				case 'L': // boolean
				case 'M': // memo
				case 'N': // number
				case 'O': // double
				case 'T': // datetime
				case 'Y': // currency
				case '0': // VFP _NullFlags
				case '@': // timestamp
				case '+': // autoincrement
					break;
				default: throw new Error('Unknown Field Type: ' + field.type);
			}
		}
		if(d[d.l] !== 0x0D) d.l = fpos-1;
		else if(ft == 0x02) d.l = 0x209;
		if(ft != 0x02) {
			if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
			d.l = fpos;
		}
		/* data */
		var R = 0, C = 0;
		out[0] = [];
		for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
		while(nrow-- > 0) {
			if(d[d.l] === 0x2A) { d.l+=rlen; continue; }
			++d.l;
			out[++R] = []; C = 0;
			for(C = 0; C != fields.length; ++C) {
				var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
				prep_blob(dd, 0);
				var s = cptable.utils.decode(current_cp, dd);
				switch(fields[C].type) {
					case 'C':
						out[R][C] = cptable.utils.decode(current_cp, dd);
						out[R][C] = out[R][C].trim();
						break;
					case 'D':
						if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
						else out[R][C] = s;
						break;
					case 'F': out[R][C] = parseFloat(s.trim()); break;
					case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
					case 'L': switch(s.toUpperCase()) {
						case 'Y': case 'T': out[R][C] = true; break;
						case 'N': case 'F': out[R][C] = false; break;
						case ' ': case '?': out[R][C] = false; break; /* NOTE: technically uninitialized */
						default: throw new Error("DBF Unrecognized L:|" + s + "|");
						} break;
					case 'M': /* TODO: handle memo files */
						if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
						out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
						break;
					case 'N': out[R][C] = +s.replace(/\u0000/g,"").trim(); break;
					case '@': out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400); break;
					case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
					case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4; break;
					case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
					case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
						/* falls through */
					case 'G': case 'P': dd.l += fields[C].len; break;
					case '0':
						if(fields[C].name === '_NullFlags') break;
						/* falls through */
					default: throw new Error("DBF Unsupported data type " + fields[C].type);
				}
			}
		}
		if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
		return out;
	}
	
	function dbf_to_sheet(buf, opts) {
		var o = opts || {};
		if(!o.dateNF) o.dateNF = "yyyymmdd";
		return aoa_to_sheet(dbf_to_aoa(buf, o), o);
	}
	
	function dbf_to_workbook(buf, opts) {
		try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
		catch(e) { if(opts && opts.WTF) throw e; }
		return ({SheetNames:[],Sheets:{}});
	}
	
	var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
	function sheet_to_dbf(ws, opts) {
		var o = opts || {};
		if(o.type == "string") throw new Error("Cannot write DBF to JS string");
		var ba = buf_array();
		var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
		var headers = aoa[0], data = aoa.slice(1);
		var i = 0, j = 0, hcnt = 0, rlen = 1;
		for(i = 0; i < headers.length; ++i) {
			if(i == null) continue;
			++hcnt;
			if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name");
			if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
				if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
		}
		var range = safe_decode_range(ws['!ref']);
		var coltypes = [];
		for(i = 0; i <= range.e.c - range.s.c; ++i) {
			var col = [];
			for(j=0; j < data.length; ++j) {
				if(data[j][i] != null) col.push(data[j][i]);
			}
			if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
			var guess = '', _guess = '';
			for(j = 0; j < col.length; ++j) {
				switch(typeof col[j]) {
					/* TODO: check if L2 compat is desired */
					case 'number': _guess = 'B'; break;
					case 'string': _guess = 'C'; break;
					case 'boolean': _guess = 'L'; break;
					case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
					default: _guess = 'C';
				}
				guess = guess && guess != _guess ? 'C' : _guess;
				if(guess == 'C') break;
			}
			rlen += _RLEN[guess] || 0;
			coltypes[i] = guess;
		}
	
		var h = ba.next(32);
		h.write_shift(4, 0x13021130);
		h.write_shift(4, data.length);
		h.write_shift(2, 296 + 32 * hcnt);
		h.write_shift(2, rlen);
		for(i=0; i < 4; ++i) h.write_shift(4, 0);
		h.write_shift(4, 0x00000300); // TODO: CP
	
		for(i = 0, j = 0; i < headers.length; ++i) {
			if(headers[i] == null) continue;
			var hf = ba.next(32);
			var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
			hf.write_shift(1, _f, "sbcs");
			hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
			hf.write_shift(4, j);
			hf.write_shift(1, _RLEN[coltypes[i]] || 0);
			hf.write_shift(1, 0);
			hf.write_shift(1, 0x02);
			hf.write_shift(4, 0);
			hf.write_shift(1, 0);
			hf.write_shift(4, 0);
			hf.write_shift(4, 0);
			j += _RLEN[coltypes[i]] || 0;
		}
	
		var hb = ba.next(264);
		hb.write_shift(4, 0x0000000D);
		for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
		for(i=0; i < data.length; ++i) {
			var rout = ba.next(rlen);
			rout.write_shift(1, 0);
			for(j=0; j<headers.length; ++j) {
				if(headers[j] == null) continue;
				switch(coltypes[j]) {
					case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
					case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
					case 'D':
						if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
						else {
							rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
							rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
							rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
						} break;
					case 'C':
						var _s = String(data[i][j]||"");
						rout.write_shift(1, _s, "sbcs");
						for(hcnt=0; hcnt < 250-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
				}
			}
			// data
		}
		ba.next(1).write_shift(1, 0x1A);
		return ba.end();
	}
		return {
			to_workbook: dbf_to_workbook,
			to_sheet: dbf_to_sheet,
			from_sheet: sheet_to_dbf
		};
	})();
	
	var SYLK = (function() {
		/* TODO: find an actual specification */
		function sylk_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return sylk_to_aoa_str(Base64.decode(d), opts);
				case 'binary': return sylk_to_aoa_str(d, opts);
				case 'buffer': return sylk_to_aoa_str(d.toString('binary'), opts);
				case 'array': return sylk_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function sylk_to_aoa_str(str, opts) {
			var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
			var formats = [];
			var next_cell_format = null;
			var sht = {}, rowinfo = [], colinfo = [], cw = [];
			var Mval = 0, j;
			for (; ri !== records.length; ++ri) {
				Mval = 0;
				var rstr=records[ri].trim();
				var record=rstr.replace(/;;/g, "\u0001").split(";").map(function(x) { return x.replace(/\u0001/g, ";"); });
				var RT=record[0], val;
				if(rstr.length > 0) switch(RT) {
				case 'ID': break; /* header */
				case 'E': break; /* EOF */
				case 'B': break; /* dimensions */
				case 'O': break; /* options? */
				case 'P':
					if(record[1].charAt(0) == 'P')
						formats.push(rstr.slice(3).replace(/;;/g, ";"));
					break;
				case 'C':
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; C = 0;
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'K':
						val = record[rj].slice(1);
						if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
						else if(val === 'TRUE') val = true;
						else if(val === 'FALSE') val = false;
						else if(!isNaN(fuzzynum(val))) {
							val = fuzzynum(val);
							if(next_cell_format !== null && SSF.is_date(next_cell_format)) val = numdate(val);
						} else if(!isNaN(fuzzydate(val).getDate())) {
							val = parseDate(val);
						}
						arr[R][C] = val;
						next_cell_format = null;
						break;
					case 'E':
						var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
						arr[R][C] = [arr[R][C], formula];
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				} break;
				case 'F':
				var F_seen = 0;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
					case 'F': break; /* ??? */
					case 'P':
						next_cell_format = formats[parseInt(record[rj].slice(1))];
						break;
					case 'S': break; /* cell style */
					case 'D': break; /* column */
					case 'N': break; /* font */
					case 'W':
						cw = record[rj].slice(1).split(" ");
						for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
							Mval = parseInt(cw[2], 10);
							colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
						} break;
					case 'C': /* default column format */
						C = parseInt(record[rj].slice(1))-1;
						if(!colinfo[C]) colinfo[C] = {};
						break;
					case 'R': /* row properties */
						R = parseInt(record[rj].slice(1))-1;
						if(!rowinfo[R]) rowinfo[R] = {};
						if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
						else if(Mval === 0) rowinfo[R].hidden = true;
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(F_seen < 1) next_cell_format = null; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
			}
			if(rowinfo.length > 0) sht['!rows'] = rowinfo;
			if(colinfo.length > 0) sht['!cols'] = colinfo;
			return [arr, sht];
		}
	
		function sylk_to_sheet(d, opts) {
			var aoasht = sylk_to_aoa(d, opts);
			var aoa = aoasht[0], ws = aoasht[1];
			var o = aoa_to_sheet(aoa, opts);
			keys(ws).forEach(function(k) { o[k] = ws[k]; });
			return o;
		}
	
		function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }
	
		function write_ws_cell_sylk(cell, ws, R, C) {
			var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
			switch(cell.t) {
				case 'n':
					o += (cell.v||0);
					if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
				case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
				case 'e': o += cell.w || cell.v; break;
				case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
				case 's': o += '"' + cell.v.replace(/"/g,"") + '"'; break;
			}
			return o;
		}
	
		function write_ws_cols_sylk(out, cols) {
			cols.forEach(function(col, i) {
				var rec = "F;W" + (i+1) + " " + (i+1) + " ";
				if(col.hidden) rec += "0";
				else {
					if(typeof col.width == 'number') col.wpx = width2px(col.width);
					if(typeof col.wpx == 'number') col.wch = px2char(col.wpx);
					if(typeof col.wch == 'number') rec += Math.round(col.wch);
				}
				if(rec.charAt(rec.length - 1) != " ") out.push(rec);
			});
		}
	
		function write_ws_rows_sylk(out, rows) {
			rows.forEach(function(row, i) {
				var rec = "F;";
				if(row.hidden) rec += "M0;";
				else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
				else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
				if(rec.length > 2) out.push(rec + "R" + (i+1));
			});
		}
	
		function sheet_to_sylk(ws, opts) {
			var preamble = ["ID;PWXL;N;E"], o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			var RS = "\r\n";
	
			preamble.push("P;PGeneral");
			preamble.push("F;P0;DG0G8;M255");
			if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
			if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
	
			preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
					o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
				}
			}
			return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
		}
	
		return {
			to_workbook: sylk_to_workbook,
			to_sheet: sylk_to_sheet,
			from_sheet: sheet_to_sylk
		};
	})();
	
	var DIF = (function() {
		function dif_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return dif_to_aoa_str(Base64.decode(d), opts);
				case 'binary': return dif_to_aoa_str(d, opts);
				case 'buffer': return dif_to_aoa_str(d.toString('binary'), opts);
				case 'array': return dif_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function dif_to_aoa_str(str) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
				if (R < 0) continue;
				var metadata = records[ri].trim().split(",");
				var type = metadata[0], value = metadata[1];
				++ri;
				var data = records[ri].trim();
				switch (+type) {
					case -1:
						if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
						else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
						break;
					case 0:
						if(data === 'TRUE') arr[R][C] = true;
						else if(data === 'FALSE') arr[R][C] = false;
						else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
						else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
						else arr[R][C] = value;
						++C; break;
					case 1:
						data = data.slice(1,data.length-1);
						arr[R][C++] = data !== '' ? data : null;
						break;
				}
				if (data === 'EOD') break;
			}
			return arr;
		}
	
		function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
		function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }
	
		var sheet_to_dif = (function() {
			var push_field = function pf(o, topic, v, n, s) {
				o.push(topic);
				o.push(v + "," + n);
				o.push('"' + s.replace(/"/g,'""') + '"');
			};
			var push_value = function po(o, type, v, s) {
				o.push(type + "," + v);
				o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
			};
			return function sheet_to_dif(ws) {
				var o = [];
				var r = safe_decode_range(ws['!ref']), cell;
				var dense = Array.isArray(ws);
				push_field(o, "TABLE", 0, 1, "sheetjs");
				push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
				push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
				push_field(o, "DATA", 0, 0,"");
				for(var R = r.s.r; R <= r.e.r; ++R) {
					push_value(o, -1, 0, "BOT");
					for(var C = r.s.c; C <= r.e.c; ++C) {
						var coord = encode_cell({r:R,c:C});
						cell = dense ? (ws[R]||[])[C] : ws[coord];
						if(!cell) { push_value(o, 1, 0, ""); continue;}
						switch(cell.t) {
							case 'n':
								var val = DIF_XL ? cell.w : cell.v;
								if(!val && cell.v != null) val = cell.v;
								if(val == null) {
									if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
									else push_value(o, 1, 0, "");
								}
								else push_value(o, 0, val, "V");
								break;
							case 'b':
								push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
								break;
							case 's':
								push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
								break;
							case 'd':
								if(!cell.w) cell.w = SSF.format(cell.z || SSF._table[14], datenum(parseDate(cell.v)));
								if(DIF_XL) push_value(o, 0, cell.w, "V");
								else push_value(o, 1, 0, cell.w);
								break;
							default: push_value(o, 1, 0, "");
						}
					}
				}
				push_value(o, -1, 0, "EOD");
				var RS = "\r\n";
				var oo = o.join(RS);
				//while((oo.length & 0x7F) != 0) oo += "\0";
				return oo;
			};
		})();
		return {
			to_workbook: dif_to_workbook,
			to_sheet: dif_to_sheet,
			from_sheet: sheet_to_dif
		};
	})();
	
	var ETH = (function() {
		function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
		function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }
	
		function eth_to_aoa(str) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				var record = records[ri].trim().split(":");
				if(record[0] !== 'cell') continue;
				var addr = decode_cell(record[1]);
				if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
				R = addr.r; C = addr.c;
				switch(record[2]) {
					case 't': arr[R][C] = decode(record[3]); break;
					case 'v': arr[R][C] = +record[3]; break;
					case 'vtf': var _f = record[record.length - 1];
						/* falls through */
					case 'vtc':
						switch(record[3]) {
							case 'nl': arr[R][C] = +record[4] ? true : false; break;
							default: arr[R][C] = +record[4]; break;
						}
						if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
				}
			}
			return arr;
		}
	
		function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
		function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }
	
		var header = [
			"socialcalc:version:1.5",
			"MIME-Version: 1.0",
			"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
		].join("\n");
	
		var sep = [
			"--SocialCalcSpreadsheetControlSave",
			"Content-type: text/plain; charset=UTF-8"
		].join("\n") + "\n";
	
		/* TODO: the other parts */
		var meta = [
			"# SocialCalc Spreadsheet Control Save",
			"part:sheet"
		].join("\n");
	
		var end = "--SocialCalcSpreadsheetControlSave--";
	
		function sheet_to_eth_data(ws) {
			if(!ws || !ws['!ref']) return "";
			var o = [], oo = [], cell, coord = "";
			var r = decode_range(ws['!ref']);
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null || cell.t === 'z') continue;
					oo = ["cell", coord, 't'];
					switch(cell.t) {
						case 's': case 'str': oo.push(encode(cell.v)); break;
						case 'n':
							if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
							else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
							break;
						case 'b':
							oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
							oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
							break;
						case 'd':
							var t = datenum(parseDate(cell.v));
							oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
							oo[5] = cell.w || SSF.format(cell.z || SSF._table[14], t);
							break;
						case 'e': continue;
					}
					o.push(oo.join(":"));
				}
			}
			o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
			o.push("valueformat:1:text-wiki");
			//o.push("copiedfrom:" + ws['!ref']); // clipboard only
			return o.join("\n");
		}
	
		function sheet_to_eth(ws) {
			return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
			// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
		}
	
		return {
			to_workbook: eth_to_workbook,
			to_sheet: eth_to_sheet,
			from_sheet: sheet_to_eth
		};
	})();
	
	var PRN = (function() {
		function set_text_arr(data, arr, R, C, o) {
			if(o.raw) arr[R][C] = data;
			else if(data === 'TRUE') arr[R][C] = true;
			else if(data === 'FALSE') arr[R][C] = false;
			else if(data === ""){/* empty */}
			else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
			else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
			else arr[R][C] = data;
		}
	
		function prn_to_aoa_str(f, opts) {
			var o = opts || {};
			var arr = ([]);
			if(!f || f.length === 0) return arr;
			var lines = f.split(/[\r\n]/);
			var L = lines.length - 1;
			while(L >= 0 && lines[L].length === 0) --L;
			var start = 10, idx = 0;
			var R = 0;
			for(; R <= L; ++R) {
				idx = lines[R].indexOf(" ");
				if(idx == -1) idx = lines[R].length; else idx++;
				start = Math.max(start, idx);
			}
			for(R = 0; R <= L; ++R) {
				arr[R] = [];
				/* TODO: confirm that widths are always 10 */
				var C = 0;
				set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
				for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
					set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
			}
			return arr;
		}
	
		// List of accepted CSV separators
		var guess_seps = {
	0x2C: ',',
	0x09: "\t",
	0x3B: ';'
		};
	
		// CSV separator weights to be used in case of equal numbers
		var guess_sep_weights = {
	0x2C: 3,
	0x09: 2,
	0x3B: 1
		};
	
		function guess_sep(str) {
			var cnt = {}, instr = false, end = 0, cc = 0;
			for(;end < str.length;++end) {
				if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
				else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
			}
	
			cc = [];
			for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
				cc.push([ cnt[end], end ]);
			}
	
			if ( !cc.length ) {
				cnt = guess_sep_weights;
				for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
					cc.push([ cnt[end], end ]);
				}
			}
	
			cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });
	
			return guess_seps[cc.pop()[1]];
		}
	
		function dsv_to_sheet_str(str, opts) {
			var o = opts || {};
			var sep = "";
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			if(str.slice(0,4) == "sep=" && str.charCodeAt(5) == 10) { sep = str.charAt(4); str = str.slice(6); }
			else sep = guess_sep(str.slice(0,1024));
			var R = 0, C = 0, v = 0;
			var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0;
			str = str.replace(/\r\n/mg, "\n");
			var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
			function finish_cell() {
				var s = str.slice(start, end);
				var cell = ({});
				if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
				if(s.length === 0) cell.t = 'z';
				else if(o.raw) { cell.t = 's'; cell.v = s; }
				else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
				else if(s.charCodeAt(0) == 0x3D) {
					if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
					else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
					else { cell.t = 's'; cell.v = s; } }
				else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
				else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
				else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
				else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
					cell.z = o.dateNF || SSF._table[14];
					var k = 0;
					if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
					if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
					else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
					if(o.cellText !== false) cell.w = SSF.format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
					if(!o.cellNF) delete cell.z;
				} else {
					cell.t = 's';
					cell.v = s;
				}
				if(cell.t == 'z'){}
				else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
				else ws[encode_cell({c:C,r:R})] = cell;
				start = end+1;
				if(range.e.c < C) range.e.c = C;
				if(range.e.r < R) range.e.r = R;
				if(cc == sepcc) ++C; else { C = 0; ++R; }
			}
			for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
				case 0x22: instr = !instr; break;
				case sepcc: case 0x0a: case 0x0d: if(!instr) finish_cell(); break;
				default: break;
			}
			if(end - start > 0) finish_cell();
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function prn_to_sheet_str(str, opts) {
			if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
			if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
			return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
		}
	
		function prn_to_sheet(d, opts) {
			var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
			switch(opts.type) {
				case 'base64': str = Base64.decode(d); break;
				case 'binary': str = d; break;
				case 'buffer': str = d.toString('binary'); break;
				case 'array': str = cc2str(d); break;
				case 'string': str = d; break;
				default: throw new Error("Unrecognized type " + opts.type);
			}
			if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
			else if((opts.type == 'binary' || opts.type == 'buffer') && typeof cptable !== 'undefined' && opts.codepage)  str = cptable.utils.decode(opts.codepage, cptable.utils.encode(1252,str));
			if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
			return prn_to_sheet_str(str, opts);
		}
	
		function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }
	
		function sheet_to_prn(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				var oo = [];
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null) { oo.push("          "); continue; }
					var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
					while(w.length < 10) w += " ";
					oo.push(w + (C === 0 ? " " : ""));
				}
				o.push(oo.join(""));
			}
			return o.join("\n");
		}
	
		return {
			to_workbook: prn_to_workbook,
			to_sheet: prn_to_sheet,
			from_sheet: sheet_to_prn
		};
	})();
	
	/* Excel defaults to SYLK but warns if data is not valid */
	function read_wb_ID(d, opts) {
		var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
		try {
			var out = SYLK.to_workbook(d, o);
			o.WTF = OLD_WTF;
			return out;
		} catch(e) {
			o.WTF = OLD_WTF;
			if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
			return PRN.to_workbook(d, opts);
		}
	}
	
	var WK_ = (function() {
		function lotushopper(data, cb, opts) {
			if(!data) return;
			prep_blob(data, data.l || 0);
			var Enum = opts.Enum || WK1Enum;
			while(data.l < data.length) {
				var RT = data.read_shift(2);
				var R = Enum[RT] || Enum[0xFF];
				var length = data.read_shift(2);
				var tgt = data.l + length;
				var d = (R.f||parsenoop)(data, length, opts);
				data.l = tgt;
				if(cb(d, R.n, RT)) return;
			}
		}
	
		function lotus_to_workbook(d, opts) {
			switch(opts.type) {
				case 'base64': return lotus_to_workbook_buf(s2a(Base64.decode(d)), opts);
				case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
				case 'buffer':
				case 'array': return lotus_to_workbook_buf(d, opts);
			}
			throw "Unsupported type " + opts.type;
		}
	
		function lotus_to_workbook_buf(d,opts) {
			if(!d) return d;
			var o = opts || {};
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var s = ((o.dense ? [] : {})), n = "Sheet1", sidx = 0;
			var sheets = {}, snames = [n];
	
			var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
	
			if(d[2] == 0x02) o.Enum = WK1Enum;
			else if(d[2] == 0x1a) o.Enum = WK3Enum;
			else if(d[2] == 0x0e) { o.Enum = WK3Enum; o.qpro = true; d.l = 0; }
			else throw new Error("Unrecognized LOTUS BOF " + d[2]);
			lotushopper(d, function(val, Rn, RT) {
				if(d[2] == 0x02) switch(RT) {
					case 0x00:
						o.vers = val;
						if(val >= 0x1000) o.qpro = true;
						break;
					case 0x06: refguess = val; break; /* RANGE */
					case 0x0F: /* LABEL */
						if(!o.qpro) val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x0D: /* INTEGER */
					case 0x0E: /* NUMBER */
					case 0x10: /* FORMULA */
					case 0x33: /* STRING */
						/* TODO: actual translation of the format code */
						if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
							val[1].z = o.dateNF || SSF._table[14];
							if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
						}
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						break;
				} else switch(RT) {
					case 0x16: /* LABEL16 */
						val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x17: /* NUMBER17 */
					case 0x18: /* NUMBER18 */
					case 0x19: /* FORMULA19 */
					case 0x25: /* NUMBER25 */
					case 0x27: /* NUMBER27 */
					case 0x28: /* FORMULA28 */
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = "Sheet" + (sidx + 1);
							snames.push(n);
						}
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
						if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
						break;
					default: break;
				}
			}, o);
	
			s["!ref"] = encode_range(refguess);
			sheets[n] = s;
			return { SheetNames: snames, Sheets:sheets };
		}
	
		function parse_RANGE(blob) {
			var o = {s:{c:0,r:0},e:{c:0,r:0}};
			o.s.c = blob.read_shift(2);
			o.s.r = blob.read_shift(2);
			o.e.c = blob.read_shift(2);
			o.e.r = blob.read_shift(2);
			if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
			return o;
		}
	
		function parse_cell(blob, length, opts) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			if(opts.qpro && opts.vers != 0x5120) {
				o[0].c = blob.read_shift(1);
				blob.l++;
				o[0].r = blob.read_shift(2);
				blob.l+=2;
			} else {
				o[2] = blob.read_shift(1);
				o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
			}
			return o;
		}
	
		function parse_LABEL(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			o[1].t = 's';
			if(opts.vers == 0x5120) {
				blob.l++;
				var len = blob.read_shift(1);
				o[1].v = blob.read_shift(len, 'utf8');
				return o;
			}
			if(opts.qpro) blob.l++;
			o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
			return o;
		}
	
		function parse_INTEGER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(2, 'i');
			return o;
		}
	
		function parse_NUMBER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(8, 'f');
			return o;
		}
	
		function parse_FORMULA(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			/* TODO: formula */
			o[1].v = blob.read_shift(8, 'f');
			if(opts.qpro) blob.l = tgt;
			else {
				var flen = blob.read_shift(2);
				blob.l += flen;
			}
			return o;
		}
	
		function parse_cell_3(blob) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
			return o;
		}
	
		function parse_LABEL_16(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].t = 's';
			o[1].v = blob.read_shift(length - 4, 'cstr');
			return o;
		}
	
		function parse_NUMBER_18(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].v = blob.read_shift(2);
			var v = o[1].v >> 1;
			/* TODO: figure out all of the corner cases */
			if(o[1].v & 0x1) {
				switch(v & 0x07) {
					case 1: v = (v >> 3) * 500; break;
					case 2: v = (v >> 3) / 20; break;
					case 4: v = (v >> 3) / 2000; break;
					case 6: v = (v >> 3) / 16; break;
					case 7: v = (v >> 3) / 64; break;
					default: throw "unknown NUMBER_18 encoding " + (v & 0x07);
				}
			}
			o[1].v = v;
			return o;
		}
	
		function parse_NUMBER_17(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			var v2 = blob.read_shift(4);
			var e = blob.read_shift(2);
			if(e == 0xFFFF) { o[1].v = 0; return o; }
			var s = e & 0x8000; e = (e&0x7FFF) - 16446;
			o[1].v = (s*2 - 1) * ((e > 0 ? (v2 << e) : (v2 >>> -e)) + (e > -32 ? (v1 << (e + 32)) : (v1 >>> -(e + 32))));
			return o;
		}
	
		function parse_FORMULA_19(blob, length) {
			var o = parse_NUMBER_17(blob, 14);
			blob.l += length - 14; /* TODO: formula */
			return o;
		}
	
		function parse_NUMBER_25(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			o[1].v = v1 >> 6;
			return o;
		}
	
		function parse_NUMBER_27(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(8,'f');
			o[1].v = v1;
			return o;
		}
	
		function parse_FORMULA_28(blob, length) {
			var o = parse_NUMBER_27(blob, 14);
			blob.l += length - 10; /* TODO: formula */
			return o;
		}
	
		var WK1Enum = {
	0x0000: { n:"BOF", f:parseuint16 },
	0x0001: { n:"EOF" },
	0x0002: { n:"CALCMODE" },
	0x0003: { n:"CALCORDER" },
	0x0004: { n:"SPLIT" },
	0x0005: { n:"SYNC" },
	0x0006: { n:"RANGE", f:parse_RANGE },
	0x0007: { n:"WINDOW1" },
	0x0008: { n:"COLW1" },
	0x0009: { n:"WINTWO" },
	0x000A: { n:"COLW2" },
	0x000B: { n:"NAME" },
	0x000C: { n:"BLANK" },
	0x000D: { n:"INTEGER", f:parse_INTEGER },
	0x000E: { n:"NUMBER", f:parse_NUMBER },
	0x000F: { n:"LABEL", f:parse_LABEL },
	0x0010: { n:"FORMULA", f:parse_FORMULA },
	0x0018: { n:"TABLE" },
	0x0019: { n:"ORANGE" },
	0x001A: { n:"PRANGE" },
	0x001B: { n:"SRANGE" },
	0x001C: { n:"FRANGE" },
	0x001D: { n:"KRANGE1" },
	0x0020: { n:"HRANGE" },
	0x0023: { n:"KRANGE2" },
	0x0024: { n:"PROTEC" },
	0x0025: { n:"FOOTER" },
	0x0026: { n:"HEADER" },
	0x0027: { n:"SETUP" },
	0x0028: { n:"MARGINS" },
	0x0029: { n:"LABELFMT" },
	0x002A: { n:"TITLES" },
	0x002B: { n:"SHEETJS" },
	0x002D: { n:"GRAPH" },
	0x002E: { n:"NGRAPH" },
	0x002F: { n:"CALCCOUNT" },
	0x0030: { n:"UNFORMATTED" },
	0x0031: { n:"CURSORW12" },
	0x0032: { n:"WINDOW" },
	0x0033: { n:"STRING", f:parse_LABEL },
	0x0037: { n:"PASSWORD" },
	0x0038: { n:"LOCKED" },
	0x003C: { n:"QUERY" },
	0x003D: { n:"QUERYNAME" },
	0x003E: { n:"PRINT" },
	0x003F: { n:"PRINTNAME" },
	0x0040: { n:"GRAPH2" },
	0x0041: { n:"GRAPHNAME" },
	0x0042: { n:"ZOOM" },
	0x0043: { n:"SYMSPLIT" },
	0x0044: { n:"NSROWS" },
	0x0045: { n:"NSCOLS" },
	0x0046: { n:"RULER" },
	0x0047: { n:"NNAME" },
	0x0048: { n:"ACOMM" },
	0x0049: { n:"AMACRO" },
	0x004A: { n:"PARSE" },
	0x00FF: { n:"", f:parsenoop }
		};
	
		var WK3Enum = {
	0x0000: { n:"BOF" },
	0x0001: { n:"EOF" },
	0x0003: { n:"??" },
	0x0004: { n:"??" },
	0x0005: { n:"??" },
	0x0006: { n:"??" },
	0x0007: { n:"??" },
	0x0009: { n:"??" },
	0x000a: { n:"??" },
	0x000b: { n:"??" },
	0x000c: { n:"??" },
	0x000e: { n:"??" },
	0x000f: { n:"??" },
	0x0010: { n:"??" },
	0x0011: { n:"??" },
	0x0012: { n:"??" },
	0x0013: { n:"??" },
	0x0015: { n:"??" },
	0x0016: { n:"LABEL16", f:parse_LABEL_16},
	0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
	0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
	0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
	0x001a: { n:"??" },
	0x001b: { n:"??" },
	0x001c: { n:"??" },
	0x001d: { n:"??" },
	0x001e: { n:"??" },
	0x001f: { n:"??" },
	0x0021: { n:"??" },
	0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
	0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
	0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
	0x00FF: { n:"", f:parsenoop }
		};
		return {
			to_workbook: lotus_to_workbook
		};
	})();
	/* Parse a list of <r> tags */
	var parse_rs = (function parse_rs_factory() {
		var tregex = matchtag("t"), rpregex = matchtag("rPr"), rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/, nlregex = /\r\n/g;
		/* 18.4.7 rPr CT_RPrElt */
		var parse_rpr = function parse_rpr(rpr, intro, outro) {
			var font = {}, cp = 65001, align = "";
			var m = rpr.match(tagregex), i = 0;
			if(m) for(;i!=m.length; ++i) {
				var y = parsexmltag(m[i]);
				switch(y[0].replace(/\w*:/g,"")) {
					/* 18.8.12 condense CT_BooleanProperty */
					/* ** not required . */
					case '<condense': break;
					/* 18.8.17 extend CT_BooleanProperty */
					/* ** not required . */
					case '<extend': break;
					/* 18.8.36 shadow CT_BooleanProperty */
					/* ** not required . */
					case '<shadow':
						if(!y.val) break;
						/* falls through */
					case '<shadow>':
					case '<shadow/>': font.shadow = 1; break;
					case '</shadow>': break;
	
					/* 18.4.1 charset CT_IntProperty TODO */
					case '<charset':
						if(y.val == '1') break;
						cp = CS2CP[parseInt(y.val, 10)];
						break;
	
					/* 18.4.2 outline CT_BooleanProperty TODO */
					case '<outline':
						if(!y.val) break;
						/* falls through */
					case '<outline>':
					case '<outline/>': font.outline = 1; break;
					case '</outline>': break;
	
					/* 18.4.5 rFont CT_FontName */
					case '<rFont': font.name = y.val; break;
	
					/* 18.4.11 sz CT_FontSize */
					case '<sz': font.sz = y.val; break;
	
					/* 18.4.10 strike CT_BooleanProperty */
					case '<strike':
						if(!y.val) break;
						/* falls through */
					case '<strike>':
					case '<strike/>': font.strike = 1; break;
					case '</strike>': break;
	
					/* 18.4.13 u CT_UnderlineProperty */
					case '<u':
						if(!y.val) break;
						switch(y.val) {
							case 'double': font.uval = "double"; break;
							case 'singleAccounting': font.uval = "single-accounting"; break;
							case 'doubleAccounting': font.uval = "double-accounting"; break;
						}
						/* falls through */
					case '<u>':
					case '<u/>': font.u = 1; break;
					case '</u>': break;
	
					/* 18.8.2 b */
					case '<b':
						if(y.val == '0') break;
						/* falls through */
					case '<b>':
					case '<b/>': font.b = 1; break;
					case '</b>': break;
	
					/* 18.8.26 i */
					case '<i':
						if(y.val == '0') break;
						/* falls through */
					case '<i>':
					case '<i/>': font.i = 1; break;
					case '</i>': break;
	
					/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
					case '<color':
						if(y.rgb) font.color = y.rgb.slice(2,8);
						break;
	
					/* 18.8.18 family ST_FontFamily */
					case '<family': font.family = y.val; break;
	
					/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
					case '<vertAlign': align = y.val; break;
	
					/* 18.8.35 scheme CT_FontScheme TODO */
					case '<scheme': break;
	
					default:
						if(y[0].charCodeAt(1) !== 47) throw 'Unrecognized rich format ' + y[0];
				}
			}
			var style = [];
	
			if(font.u) style.push("text-decoration: underline;");
			if(font.uval) style.push("text-underline-style:" + font.uval + ";");
			if(font.sz) style.push("font-size:" + font.sz + ";");
			if(font.outline) style.push("text-effect: outline;");
			if(font.shadow) style.push("text-shadow: auto;");
			intro.push('<span style="' + style.join("") + '">');
	
			if(font.b) { intro.push("<b>"); outro.push("</b>"); }
			if(font.i) { intro.push("<i>"); outro.push("</i>"); }
			if(font.strike) { intro.push("<s>"); outro.push("</s>"); }
	
			if(align == "superscript") align = "sup";
			else if(align == "subscript") align = "sub";
			if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }
	
			outro.push("</span>");
			return cp;
		};
	
		/* 18.4.4 r CT_RElt */
		function parse_r(r) {
			var terms = [[],"",[]];
			/* 18.4.12 t ST_Xstring */
			var t = r.match(tregex)/*, cp = 65001*/;
			if(!t) return "";
			terms[1] = t[1];
	
			var rpr = r.match(rpregex);
			if(rpr) /*cp = */parse_rpr(rpr[1], terms[0], terms[2]);
	
			return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
		}
		return function parse_rs(rs) {
			return rs.replace(rregex,"").split(rend).map(parse_r).join("");
		};
	})();
	
	/* 18.4.8 si CT_Rst */
	var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
	var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
	function parse_si(x, opts) {
		var html = opts ? opts.cellHTML : true;
		var z = {};
		if(!x) return null;
		//var y;
		/* 18.4.12 t ST_Xstring (Plaintext String) */
		// TODO: is whitespace actually valid here?
		if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
			z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
			z.r = utf8read(x);
			if(html) z.h = escapehtml(z.t);
		}
		/* 18.4.4 r CT_RElt (Rich Text Run) */
		else if((/*y = */x.match(sirregex))) {
			z.r = utf8read(x);
			z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
			if(html) z.h = parse_rs(z.r);
		}
		/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
		/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
		return z;
	}
	
	/* 18.4 Shared String Table */
	var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
	var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
	var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
	function parse_sst_xml(data, opts) {
		var s = ([]), ss = "";
		if(!data) return s;
		/* 18.4.9 sst CT_Sst */
		var sst = data.match(sstr0);
		if(sst) {
			ss = sst[2].replace(sstr1,"").split(sstr2);
			for(var i = 0; i != ss.length; ++i) {
				var o = parse_si(ss[i].trim(), opts);
				if(o != null) s[s.length] = o;
			}
			sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
		}
		return s;
	}
	
	RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
	var straywsregex = /^\s|\s$|[\t\n\r]/;
	function write_sst_xml(sst, opts) {
		if(!opts.bookSST) return "";
		var o = [XML_HEADER];
		o[o.length] = (writextag('sst', null, {
			xmlns: XMLNS.main[0],
			count: sst.Count,
			uniqueCount: sst.Unique
		}));
		for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
			var s = sst[i];
			var sitag = "<si>";
			if(s.r) sitag += s.r;
			else {
				sitag += "<t";
				if(!s.t) s.t = "";
				if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
				sitag += ">" + escapexml(s.t) + "</t>";
			}
			sitag += "</si>";
			o[o.length] = (sitag);
		}
		if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.219 BrtBeginSst */
	function parse_BrtBeginSst(data) {
		return [data.read_shift(4), data.read_shift(4)];
	}
	
	/* [MS-XLSB] 2.1.7.45 Shared Strings */
	function parse_sst_bin(data, opts) {
		var s = ([]);
		var pass = false;
		recordhopper(data, function hopper_sst(val, R_n, RT) {
			switch(RT) {
				case 0x009F: /* 'BrtBeginSst' */
					s.Count = val[0]; s.Unique = val[1]; break;
				case 0x0013: /* 'BrtSSTItem' */
					s.push(val); break;
				case 0x00A0: /* 'BrtEndSst' */
					return true;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if(R_n.indexOf("Begin") > 0){/* empty */}
					else if(R_n.indexOf("End") > 0){/* empty */}
					if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return s;
	}
	
	function write_BrtBeginSst(sst, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, sst.Count);
		o.write_shift(4, sst.Unique);
		return o;
	}
	
	var write_BrtSSTItem = write_RichStr;
	
	function write_sst_bin(sst) {
		var ba = buf_array();
		write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
		for(var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
		/* FRTSST */
		write_record(ba, "BrtEndSst");
		return ba.end();
	}
	function _JS2ANSI(str) {
		if(typeof cptable !== 'undefined') return cptable.utils.encode(current_ansi, str);
		var o = [], oo = str.split("");
		for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.4 Version */
	function parse_CRYPTOVersion(blob, length) {
		var o = {};
		o.Major = blob.read_shift(2);
		o.Minor = blob.read_shift(2);
	if(length >= 4) blob.l += length - 4;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
	function parse_DataSpaceVersionInfo(blob) {
		var o = {};
		o.id = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
	function parse_DataSpaceMapEntry(blob) {
		var len = blob.read_shift(4);
		var end = blob.l + len - 4;
		var o = {};
		var cnt = blob.read_shift(4);
		var comps = [];
		/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
		while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
		o.name = blob.read_shift(0, 'lpp4');
		o.comps = comps;
		if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
	function parse_DataSpaceMap(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
	function parse_DataSpaceDefinition(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
	function parse_TransformInfoHeader(blob) {
		var o = {};
		/*var len = */blob.read_shift(4);
		blob.l += 4; // must be 0x1
		o.id = blob.read_shift(0, 'lpp4');
		o.name = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	function parse_Primary(blob) {
		/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
		var hdr = parse_TransformInfoHeader(blob);
		/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
		hdr.ename = blob.read_shift(0, '8lpp4');
		hdr.blksz = blob.read_shift(4);
		hdr.cmode = blob.read_shift(4);
		if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
		return hdr;
	}
	
	/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
	function parse_EncryptionHeader(blob, length) {
		var tgt = blob.l + length;
		var o = {};
		o.Flags = (blob.read_shift(4) & 0x3F);
		blob.l += 4;
		o.AlgID = blob.read_shift(4);
		var valid = false;
		switch(o.AlgID) {
			case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
			case 0x6801: valid = (o.Flags == 0x04); break;
			case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
			default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
		}
		if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
		o.AlgIDHash = blob.read_shift(4);
		o.KeySize = blob.read_shift(4);
		o.ProviderType = blob.read_shift(4);
		blob.l += 8;
		o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
		blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
	function parse_EncryptionVerifier(blob, length) {
		var o = {}, tgt = blob.l + length;
		blob.l += 4; // SaltSize must be 0x10
		o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
		o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
		/*var sz = */blob.read_shift(4);
		o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
	function parse_EncryptionInfo(blob) {
		var vers = parse_CRYPTOVersion(blob);
		switch(vers.Minor) {
			case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
			case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
			case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
		}
		throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
	function parse_EncInfoStd(blob) {
		var flags = blob.read_shift(4);
		if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
		var sz = blob.read_shift(4);
		//var tgt = blob.l + sz;
		var hdr = parse_EncryptionHeader(blob, sz);
		var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
		return { t:"Std", h:hdr, v:verifier };
	}
	/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
	function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
	/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
	function parse_EncInfoAgl(blob) {
		var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
		blob.l+=4;
		var xml = blob.read_shift(blob.length - blob.l, 'utf8');
		var o = {};
		xml.replace(tagregex, function xml_agile(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
				case '<encryption': case '</encryption>': break;
				case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
				case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
				case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
				case '</keyEncryptors>': break;
	
				case '<keyEncryptor': o.uri = y.uri; break;
				case '</keyEncryptor>': break;
				case '<encryptedKey': o.encs.push(y); break;
				default: throw y[0];
			}
		});
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
	function parse_RC4CryptoHeader(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
		if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
		if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
		o.Flags = blob.read_shift(4); length -= 4;
		var sz = blob.read_shift(4); length -= 4;
		o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
		o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
	function parse_RC4Header(blob) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
		if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
		o.Salt = blob.read_shift(16);
		o.EncryptedVerifier = blob.read_shift(16);
		o.EncryptedVerifierHash = blob.read_shift(16);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
	function crypto_CreatePasswordVerifier_Method1(Password) {
		var Verifier = 0x0000, PasswordArray;
		var PasswordDecoded = _JS2ANSI(Password);
		var len = PasswordDecoded.length + 1, i, PasswordByte;
		var Intermediate1, Intermediate2, Intermediate3;
		PasswordArray = new_raw_buf(len);
		PasswordArray[0] = PasswordDecoded.length;
		for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
		for(i = len-1; i >= 0; --i) {
			PasswordByte = PasswordArray[i];
			Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
			Intermediate2 = (Verifier << 1) & 0x7FFF;
			Intermediate3 = Intermediate1 | Intermediate2;
			Verifier = Intermediate3 ^ PasswordByte;
		}
		return Verifier ^ 0xCE4B;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
	var crypto_CreateXorArray_Method1 = (function() {
		var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
		var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
		var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
		var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
		var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
		var CreateXorKey_Method1 = function(Password) {
			var XorKey = InitialCode[Password.length - 1];
			var CurrentElement = 0x68;
			for(var i = Password.length-1; i >= 0; --i) {
				var Char = Password[i];
				for(var j = 0; j != 7; ++j) {
					if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
					Char *= 2; --CurrentElement;
				}
			}
			return XorKey;
		};
		return function(password) {
			var Password = _JS2ANSI(password);
			var XorKey = CreateXorKey_Method1(Password);
			var Index = Password.length;
			var ObfuscationArray = new_raw_buf(16);
			for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
			var Temp, PasswordLastChar, PadIndex;
			if((Index & 1) === 1) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				PasswordLastChar = Password[Password.length - 1];
				ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
			}
			while(Index > 0) {
				--Index;
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			}
			Index = 15;
			PadIndex = 15 - Password.length;
			while(PadIndex > 0) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
				--Index;
				--PadIndex;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				--PadIndex;
			}
			return ObfuscationArray;
		};
	})();
	
	/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
	var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
		/* If XorArray is set, use it; if O is not set, make changes in-place */
		if(!O) O = Data;
		if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
		var Index, Value;
		for(Index = 0; Index != Data.length; ++Index) {
			Value = Data[Index];
			Value ^= XorArray[XorArrayIndex];
			Value = ((Value>>5) | (Value<<3)) & 0xFF;
			O[Index] = Value;
			++XorArrayIndex;
		}
		return [O, XorArrayIndex, XorArray];
	};
	
	var crypto_MakeXorDecryptor = function(password) {
		var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
		return function(Data) {
			var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
			XorArrayIndex = O[1];
			return O[0];
		};
	};
	
	/* 2.5.343 */
	function parse_XORObfuscation(blob, length, opts, out) {
		var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
		if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
		out.valid = o.verificationBytes === o.verifier;
		if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
		return o;
	}
	
	/* 2.4.117 */
	function parse_FilePassHeader(blob, length, oo) {
		var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
		if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
		else o.Data = parse_RC4CryptoHeader(blob, length);
		return o;
	}
	function parse_FilePass(blob, length, opts) {
		var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
		if(o.Type) parse_FilePassHeader(blob, length-2, o);
		else parse_XORObfuscation(blob, length-2, opts, o);
		return o;
	}
	
	
	var RTF = (function() {
		function rtf_to_sheet(d, opts) {
			switch(opts.type) {
				case 'base64': return rtf_to_sheet_str(Base64.decode(d), opts);
				case 'binary': return rtf_to_sheet_str(d, opts);
				case 'buffer': return rtf_to_sheet_str(d.toString('binary'), opts);
				case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
	
		function rtf_to_sheet_str(str, opts) {
			var o = opts || {};
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			// TODO: parse
			if(!str.match(/\\trowd/)) throw new Error("RTF missing table");
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }
	
		/* TODO: this is a stub */
		function sheet_to_rtf(ws) {
			var o = ["{\\rtf1\\ansi"];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				o.push("\\trowd\\trautofit1");
				for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
				o.push("\\pard\\intbl");
				for(C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
					o.push(" " + (cell.w || (format_cell(cell), cell.w)));
					o.push("\\cell");
				}
				o.push("\\pard\\intbl\\row");
			}
			return o.join("") + "}";
		}
	
		return {
			to_workbook: rtf_to_workbook,
			to_sheet: rtf_to_sheet,
			from_sheet: sheet_to_rtf
		};
	})();
	function hex2RGB(h) {
		var o = h.slice(h[0]==="#"?1:0).slice(0,6);
		return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
	}
	function rgb2Hex(rgb) {
		for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
		return o.toString(16).toUpperCase().slice(1);
	}
	
	function rgb2HSL(rgb) {
		var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
		var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
		if(C === 0) return [0, 0, R];
	
		var H6 = 0, S = 0, L2 = (M + m);
		S = C / (L2 > 1 ? 2 - L2 : L2);
		switch(M){
			case R: H6 = ((G - B) / C + 6)%6; break;
			case G: H6 = ((B - R) / C + 2); break;
			case B: H6 = ((R - G) / C + 4); break;
		}
		return [H6 / 6, S, L2 / 2];
	}
	
	function hsl2RGB(hsl){
		var H = hsl[0], S = hsl[1], L = hsl[2];
		var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
		var rgb = [m,m,m], h6 = 6*H;
	
		var X;
		if(S !== 0) switch(h6|0) {
			case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
			case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
			case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
			case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
			case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
			case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
		}
		for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
		return rgb;
	}
	
	/* 18.8.3 bgColor tint algorithm */
	function rgb_tint(hex, tint) {
		if(tint === 0) return hex;
		var hsl = rgb2HSL(hex2RGB(hex));
		if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
		else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
		return rgb2Hex(hsl2RGB(hsl));
	}
	
	/* 18.3.1.13 width calculations */
	/* [MS-OI29500] 2.1.595 Column Width & Formatting */
	var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
	function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
	function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
	function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
	//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
	//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
	function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
	/* XLSX/XLSB/XLS specify width in units of MDW */
	function find_mdw_colw(collw) {
		var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
		if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
		MDW = _MDW;
	}
	/* XLML specifies width in terms of pixels */
	/*function find_mdw_wpx(wpx) {
		var delta = Infinity, guess = 0, _MDW = MIN_MDW;
		for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
			guess = char2width_(px2char_(wpx))*256;
			guess = (guess) % 1;
			if(guess > 0.5) guess--;
			if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
		}
		MDW = _MDW;
	}*/
	
	function process_col(coll) {
		if(coll.width) {
			coll.wpx = width2px(coll.width);
			coll.wch = px2char(coll.wpx);
			coll.MDW = MDW;
		} else if(coll.wpx) {
			coll.wch = px2char(coll.wpx);
			coll.width = char2width(coll.wch);
			coll.MDW = MDW;
		} else if(typeof coll.wch == 'number') {
			coll.width = char2width(coll.wch);
			coll.wpx = width2px(coll.width);
			coll.MDW = MDW;
		}
		if(coll.customWidth) delete coll.customWidth;
	}
	
	var DEF_PPI = 96, PPI = DEF_PPI;
	function px2pt(px) { return px * 96 / PPI; }
	function pt2px(pt) { return pt * PPI / 96; }
	
	/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
	var XLMLPatternTypeMap = {
		"None": "none",
		"Solid": "solid",
		"Gray50": "mediumGray",
		"Gray75": "darkGray",
		"Gray25": "lightGray",
		"HorzStripe": "darkHorizontal",
		"VertStripe": "darkVertical",
		"ReverseDiagStripe": "darkDown",
		"DiagStripe": "darkUp",
		"DiagCross": "darkGrid",
		"ThickDiagCross": "darkTrellis",
		"ThinHorzStripe": "lightHorizontal",
		"ThinVertStripe": "lightVertical",
		"ThinReverseDiagStripe": "lightDown",
		"ThinHorzCross": "lightGrid"
	};
	
	/* 18.8.5 borders CT_Borders */
	function parse_borders(t, styles, themes, opts) {
		styles.Borders = [];
		var border = {}/*, sub_border = {}*/;
		t[0].match(tagregex).forEach(function(x) {
			var y = parsexmltag(x);
			switch (y[0]) {
				case '<borders': case '<borders>': case '</borders>': break;
	
				/* 18.8.4 border CT_Border */
				case '<border': case '<border>': case '<border/>':
					border = {};
					if (y.diagonalUp) { border.diagonalUp = y.diagonalUp; }
					if (y.diagonalDown) { border.diagonalDown = y.diagonalDown; }
					styles.Borders.push(border);
					break;
				case '</border>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<left/>': break;
				case '<left': case '<left>': break;
				case '</left>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<right/>': break;
				case '<right': case '<right>': break;
				case '</right>': break;
	
				/* 18.8.43 top CT_BorderPr */
				case '<top/>': break;
				case '<top': case '<top>': break;
				case '</top>': break;
	
				/* 18.8.6 bottom CT_BorderPr */
				case '<bottom/>': break;
				case '<bottom': case '<bottom>': break;
				case '</bottom>': break;
	
				/* 18.8.13 diagonal CT_BorderPr */
				case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
				case '</diagonal>': break;
	
				/* 18.8.25 horizontal CT_BorderPr */
				case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
				case '</horizontal>': break;
	
				/* 18.8.44 vertical CT_BorderPr */
				case '<vertical': case '<vertical>': case '<vertical/>': break;
				case '</vertical>': break;
	
				/* 18.8.37 start CT_BorderPr */
				case '<start': case '<start>': case '<start/>': break;
				case '</start>': break;
	
				/* 18.8.16 end CT_BorderPr */
				case '<end': case '<end>': case '<end/>': break;
				case '</end>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color>': break;
				case '<color/>': case '</color>': break;
	
				default: if(opts && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in borders');
			}
		});
	}
	
	/* 18.8.21 fills CT_Fills */
	function parse_fills(t, styles, themes, opts) {
		styles.Fills = [];
		var fill = {};
		t[0].match(tagregex).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<fills': case '<fills>': case '</fills>': break;
	
				/* 18.8.20 fill CT_Fill */
				case '<fill>': case '<fill': case '<fill/>':
					fill = {}; styles.Fills.push(fill); break;
				case '</fill>': break;
	
				/* 18.8.24 gradientFill CT_GradientFill */
				case '<gradientFill>': break;
				case '<gradientFill':
				case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;
	
				/* 18.8.32 patternFill CT_PatternFill */
				case '<patternFill': case '<patternFill>':
					if(y.patternType) fill.patternType = y.patternType;
					break;
				case '<patternFill/>': case '</patternFill>': break;
	
				/* 18.8.3 bgColor CT_Color */
				case '<bgColor':
					if(!fill.bgColor) fill.bgColor = {};
					if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
					if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
					break;
				case '<bgColor/>': case '</bgColor>': break;
	
				/* 18.8.19 fgColor CT_Color */
				case '<fgColor':
					if(!fill.fgColor) fill.fgColor = {};
					if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb) fill.fgColor.rgb = y.rgb.slice(-6);
					break;
				case '<fgColor/>': case '</fgColor>': break;
	
				/* 18.8.38 stop CT_GradientStop */
				case '<stop': case '<stop/>': break;
				case '</stop>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color/>': break;
				case '</color>': break;
	
				default: if(opts && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in fills');
			}
		});
	}
	
	/* 18.8.23 fonts CT_Fonts */
	function parse_fonts(t, styles, themes, opts) {
		styles.Fonts = [];
		var font = {};
		t[0].match(tagregex).forEach(function(x) {
			var y = parsexmltag(x);
			switch (y[0]) {
				case '<fonts': case '<fonts>': case '</fonts>': break;
	
				/* 18.8.22 font CT_Font */
				case '<font': case '<font>': break;
				case '</font>': case '<font/>':
					styles.Fonts.push(font);
					font = {};
					break;
	
				/* 18.8.29 name CT_FontName */
				case '<name': if(y.val) font.name = y.val; break;
				case '<name/>': case '</name>': break;
	
				/* 18.8.2  b CT_BooleanProperty */
				case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
				case '<b/>': font.bold = 1; break;
	
				/* 18.8.26 i CT_BooleanProperty */
				case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
				case '<i/>': font.italic = 1; break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					switch(y.val) {
						case "none": font.underline = 0x00; break;
						case "single": font.underline = 0x01; break;
						case "double": font.underline = 0x02; break;
						case "singleAccounting": font.underline = 0x21; break;
						case "doubleAccounting": font.underline = 0x22; break;
					} break;
				case '<u/>': font.underline = 1; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
				case '<strike/>': font.strike = 1; break;
	
				/* 18.4.2  outline CT_BooleanProperty */
				case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
				case '<outline/>': font.outline = 1; break;
	
				/* 18.8.36 shadow CT_BooleanProperty */
				case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
				case '<shadow/>': font.shadow = 1; break;
	
				/* 18.8.12 condense CT_BooleanProperty */
				case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
				case '<condense/>': font.condense = 1; break;
	
				/* 18.8.17 extend CT_BooleanProperty */
				case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
				case '<extend/>': font.extend = 1; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': if(y.val) font.sz = +y.val; break;
				case '<sz/>': case '</sz>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
				case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
				case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.18 family CT_FontFamily */
				case '<family': if(y.val) font.family = parseInt(y.val,10); break;
				case '<family/>': case '</family>': break;
	
				/* 18.8.35 scheme CT_FontScheme */
				case '<scheme': if(y.val) font.scheme = y.val; break;
				case '<scheme/>': case '</scheme>': break;
	
				/* 18.4.1 charset CT_IntProperty */
				case '<charset':
					if(y.val == '1') break;
					y.codepage = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.?.? color CT_Color */
				case '<color':
					if(!font.color) font.color = {};
					if(y.auto) font.color.auto = parsexmlbool(y.auto);
	
					if(y.rgb) font.color.rgb = y.rgb.slice(-6);
					else if(y.indexed) {
						font.color.index = parseInt(y.indexed, 10);
						var icv = XLSIcv[font.color.index];
						if(font.color.index == 81) icv = XLSIcv[1];
						if(!icv) throw new Error(x);
						font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
					} else if(y.theme) {
						font.color.theme = parseInt(y.theme, 10);
						if(y.tint) font.color.tint = parseFloat(y.tint);
						if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
							font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
						}
					}
	
					break;
				case '<color/>': case '</color>': break;
	
				default: if(opts && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in fonts');
			}
		});
	}
	
	/* 18.8.31 numFmts CT_NumFmts */
	function parse_numFmts(t, styles, opts) {
		styles.NumberFmt = [];
		var k/*Array<number>*/ = (keys(SSF._table));
		for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]];
		var m = t[0].match(tagregex);
		if(!m) return;
		for(i=0; i < m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0]) {
				case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
				case '<numFmt': {
					var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
					styles.NumberFmt[j] = f;
					if(j>0) {
						if(j > 0x188) {
							for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
							styles.NumberFmt[j] = f;
						}
						SSF.load(f,j);
					}
				} break;
				case '</numFmt>': break;
				default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
			}
		}
	}
	
	function write_numFmts(NF) {
		var o = ["<numFmts>"];
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
			for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
		});
		if(o.length === 1) return "";
		o[o.length] = ("</numFmts>");
		o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
		return o.join("");
	}
	
	/* 18.8.10 cellXfs CT_CellXfs */
	var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
	var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
	function parse_cellXfs(t, styles, opts) {
		styles.CellXf = [];
		var xf;
		t[0].match(tagregex).forEach(function(x) {
			var y = parsexmltag(x), i = 0;
			switch(y[0]) {
				case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;
	
				/* 18.8.45 xf CT_Xf */
				case '<xf': case '<xf/>':
					xf = y;
					delete xf[0];
					for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
						xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
					for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
						xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
					if(xf.numFmtId > 0x188) {
						for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
					}
					styles.CellXf.push(xf); break;
				case '</xf>': break;
	
				/* 18.8.1 alignment CT_CellAlignment */
				case '<alignment': case '<alignment/>':
					var alignment = {};
					if(y.vertical) alignment.vertical = y.vertical;
					if(y.horizontal) alignment.horizontal = y.horizontal;
					if(y.textRotation != null) alignment.textRotation = y.textRotation;
					if(y.indent) alignment.indent = y.indent;
					if(y.wrapText) alignment.wrapText = y.wrapText;
					xf.alignment = alignment;
					break;
				case '</alignment>': break;
	
				/* 18.8.33 protection CT_CellProtection */
				case '<protection': case '</protection>': case '<protection/>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '</extLst>': break;
				case '<ext': break;
				default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
			}
		});
	}
	
	function write_cellXfs(cellXfs) {
		var o = [];
		o[o.length] = (writextag('cellXfs',null));
		cellXfs.forEach(function(c) { o[o.length] = (writextag('xf', null, c)); });
		o[o.length] = ("</cellXfs>");
		if(o.length === 2) return "";
		o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
		return o.join("");
	}
	
	/* 18.8 Styles CT_Stylesheet*/
	var parse_sty_xml= (function make_pstyx() {
	var numFmtRegex = /<numFmts([^>]*)>[\S\s]*?<\/numFmts>/;
	var cellXfRegex = /<cellXfs([^>]*)>[\S\s]*?<\/cellXfs>/;
	var fillsRegex = /<fills([^>]*)>[\S\s]*?<\/fills>/;
	var fontsRegex = /<fonts([^>]*)>[\S\s]*?<\/fonts>/;
	var bordersRegex = /<borders([^>]*)>[\S\s]*?<\/borders>/;
	
	return function parse_sty_xml(data, themes, opts) {
		var styles = {};
		if(!data) return styles;
		data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		/* 18.8.39 styleSheet CT_Stylesheet */
		var t;
	
		/* 18.8.31 numFmts CT_NumFmts ? */
		if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);
	
		/* 18.8.23 fonts CT_Fonts ? */
		if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);
	
		/* 18.8.21 fills CT_Fills ? */
		if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);
	
		/* 18.8.5  borders CT_Borders ? */
		if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);
	
		/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
	
		/* 18.8.10 cellXfs CT_CellXfs ? */
		if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);
	
		/* 18.8.8  cellStyles CT_CellStyles ? */
		/* 18.8.15 dxfs CT_Dxfs ? */
		/* 18.8.42 tableStyles CT_TableStyles ? */
		/* 18.8.11 colors CT_Colors ? */
		/* 18.2.10 extLst CT_ExtensionList ? */
	
		return styles;
	};
	})();
	
	var STYLES_XML_ROOT = writextag('styleSheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:vt': XMLNS.vt
	});
	
	RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
	
	function write_sty_xml(wb, opts) {
		var o = [XML_HEADER, STYLES_XML_ROOT], w;
		if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
		o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
		o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
		o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
		o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
		if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
		o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
		o[o.length] = ('<dxfs count="0"/>');
		o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');
	
		if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.651 BrtFmt */
	function parse_BrtFmt(data, length) {
		var numFmtId = data.read_shift(2);
		var stFmtCode = parse_XLWideString(data,length-2);
		return [numFmtId, stFmtCode];
	}
	function write_BrtFmt(i, f, o) {
		if(!o) o = new_buf(6 + 4 * f.length);
		o.write_shift(2, i);
		write_XLWideString(f, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.653 BrtFont TODO */
	function parse_BrtFont(data, length, opts) {
		var out = ({});
	
		out.sz = data.read_shift(2) / 20;
	
		var grbit = parse_FontFlags(data, 2, opts);
		if(grbit.fCondense) out.condense = 1;
		if(grbit.fExtend) out.extend = 1;
		if(grbit.fShadow) out.shadow = 1;
		if(grbit.fOutline) out.outline = 1;
		if(grbit.fStrikeout) out.strike = 1;
		if(grbit.fItalic) out.italic = 1;
	
		var bls = data.read_shift(2);
		if(bls === 0x02BC) out.bold = 1;
	
		switch(data.read_shift(2)) {
			/* case 0: out.vertAlign = "baseline"; break; */
			case 1: out.vertAlign = "superscript"; break;
			case 2: out.vertAlign = "subscript"; break;
		}
	
		var underline = data.read_shift(1);
		if(underline != 0) out.underline = underline;
	
		var family = data.read_shift(1);
		if(family > 0) out.family = family;
	
		var bCharSet = data.read_shift(1);
		if(bCharSet > 0) out.charset = bCharSet;
	
		data.l++;
		out.color = parse_BrtColor(data, 8);
	
		switch(data.read_shift(1)) {
			/* case 0: out.scheme = "none": break; */
			case 1: out.scheme = "major"; break;
			case 2: out.scheme = "minor"; break;
		}
	
		out.name = parse_XLWideString(data, length - 21);
	
		return out;
	}
	function write_BrtFont(font, o) {
		if(!o) o = new_buf(25+4*32);
		o.write_shift(2, font.sz * 20);
		write_FontFlags(font, o);
		o.write_shift(2, font.bold ? 0x02BC : 0x0190);
		var sss = 0;
		if(font.vertAlign == "superscript") sss = 1;
		else if(font.vertAlign == "subscript") sss = 2;
		o.write_shift(2, sss);
		o.write_shift(1, font.underline || 0);
		o.write_shift(1, font.family || 0);
		o.write_shift(1, font.charset || 0);
		o.write_shift(1, 0);
		write_BrtColor(font.color, o);
		var scheme = 0;
		if(font.scheme == "major") scheme = 1;
		if(font.scheme == "minor") scheme = 2;
		o.write_shift(1, scheme);
		write_XLWideString(font.name, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.644 BrtFill */
	var XLSBFillPTNames = [
		"none",
		"solid",
		"mediumGray",
		"darkGray",
		"lightGray",
		"darkHorizontal",
		"darkVertical",
		"darkDown",
		"darkUp",
		"darkGrid",
		"darkTrellis",
		"lightHorizontal",
		"lightVertical",
		"lightDown",
		"lightUp",
		"lightGrid",
		"lightTrellis",
		"gray125",
		"gray0625"
	];
	var rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
	/* TODO: gradient fill representation */
	var parse_BrtFill = parsenoop;
	function write_BrtFill(fill, o) {
		if(!o) o = new_buf(4*3 + 8*7 + 16*1);
		var fls = rev_XLSBFillPTNames[fill.patternType];
		if(fls == null) fls = 0x28;
		o.write_shift(4, fls);
		var j = 0;
		if(fls != 0x28) {
			/* TODO: custom FG Color */
			write_BrtColor({auto:1}, o);
			/* TODO: custom BG Color */
			write_BrtColor({auto:1}, o);
	
			for(; j < 12; ++j) o.write_shift(4, 0);
		} else {
			for(; j < 4; ++j) o.write_shift(4, 0);
	
			for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
			/* iGradientType */
			/* xnumDegree */
			/* xnumFillToLeft */
			/* xnumFillToRight */
			/* xnumFillToTop */
			/* xnumFillToBottom */
			/* cNumStop */
			/* xfillGradientStop */
		}
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.816 BrtXF */
	function parse_BrtXF(data, length) {
		var tgt = data.l + length;
		var ixfeParent = data.read_shift(2);
		var ifmt = data.read_shift(2);
		data.l = tgt;
		return {ixfe:ixfeParent, numFmtId:ifmt };
	}
	function write_BrtXF(data, ixfeP, o) {
		if(!o) o = new_buf(16);
		o.write_shift(2, ixfeP||0);
		o.write_shift(2, data.numFmtId||0);
		o.write_shift(2, 0); /* iFont */
		o.write_shift(2, 0); /* iFill */
		o.write_shift(2, 0); /* ixBorder */
		o.write_shift(1, 0); /* trot */
		o.write_shift(1, 0); /* indent */
		o.write_shift(1, 0); /* flags */
		o.write_shift(1, 0); /* flags */
		o.write_shift(1, 0); /* xfGrbitAtr */
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.4 Blxf TODO */
	function write_Blxf(data, o) {
		if(!o) o = new_buf(10);
		o.write_shift(1, 0); /* dg */
		o.write_shift(1, 0);
		o.write_shift(4, 0); /* color */
		o.write_shift(4, 0); /* color */
		return o;
	}
	/* [MS-XLSB] 2.4.299 BrtBorder TODO */
	var parse_BrtBorder = parsenoop;
	function write_BrtBorder(border, o) {
		if(!o) o = new_buf(51);
		o.write_shift(1, 0); /* diagonal */
		write_Blxf(null, o); /* top */
		write_Blxf(null, o); /* bottom */
		write_Blxf(null, o); /* left */
		write_Blxf(null, o); /* right */
		write_Blxf(null, o); /* diag */
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.755 BrtStyle TODO */
	function write_BrtStyle(style, o) {
		if(!o) o = new_buf(12+4*10);
		o.write_shift(4, style.xfId);
		o.write_shift(2, 1);
		o.write_shift(1, +style.builtinId);
		o.write_shift(1, 0); /* iLevel */
		write_XLNullableWideString(style.name || "", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.269 BrtBeginTableStyles */
	function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
		var o = new_buf(4+256*2*4);
		o.write_shift(4, cnt);
		write_XLNullableWideString(defTableStyle, o);
		write_XLNullableWideString(defPivotStyle, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function parse_sty_bin(data, themes, opts) {
		var styles = {};
		styles.NumberFmt = ([]);
		for(var y in SSF._table) styles.NumberFmt[y] = SSF._table[y];
	
		styles.CellXf = [];
		styles.Fonts = [];
		var state = [];
		var pass = false;
		recordhopper(data, function hopper_sty(val, R_n, RT) {
			switch(RT) {
				case 0x002C: /* 'BrtFmt' */
					styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]);
					break;
				case 0x002B: /* 'BrtFont' */
					styles.Fonts.push(val);
					if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
						val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
					}
					break;
				case 0x0401: /* 'BrtKnownFonts' */ break;
				case 0x002D: /* 'BrtFill' */ break;
				case 0x002E: /* 'BrtBorder' */ break;
				case 0x002F: /* 'BrtXF' */
					if(state[state.length - 1] == "BrtBeginCellXFs") {
						styles.CellXf.push(val);
					}
					break;
				case 0x0030: /* 'BrtStyle' */
				case 0x01FB: /* 'BrtDXF' */
				case 0x023C: /* 'BrtMRUColor' */
				case 0x01DB: /* 'BrtIndexedColor': */
					break;
	
				case 0x0493: /* 'BrtDXF14' */
				case 0x0836: /* 'BrtDXF15' */
				case 0x046A: /* 'BrtSlicerStyleElement' */
				case 0x0200: /* 'BrtTableStyleElement' */
				case 0x082F: /* 'BrtTimelineStyleElement' */
				/* case 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
					else if((R_n||"").indexOf("End") > 0) state.pop();
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return styles;
	}
	
	function write_FMTS_bin(ba, NF) {
		if(!NF) return;
		var cnt = 0;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
		});
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFmts", write_UInt32LE(cnt));
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, "BrtFmt", write_BrtFmt(i, NF[i]));
		});
		write_record(ba, "BrtEndFmts");
	}
	
	function write_FONTS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFonts", write_UInt32LE(cnt));
		write_record(ba, "BrtFont", write_BrtFont({
			sz:12,
			color: {theme:1},
			name: "Calibri",
			family: 2,
			scheme: "minor"
		}));
		/* 1*65491BrtFont [ACFONTS] */
		write_record(ba, "BrtEndFonts");
	}
	
	function write_FILLS_bin(ba) {
		var cnt = 2;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFills", write_UInt32LE(cnt));
		write_record(ba, "BrtFill", write_BrtFill({patternType:"none"}));
		write_record(ba, "BrtFill", write_BrtFill({patternType:"gray125"}));
		/* 1*65431BrtFill */
		write_record(ba, "BrtEndFills");
	}
	
	function write_BORDERS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginBorders", write_UInt32LE(cnt));
		write_record(ba, "BrtBorder", write_BrtBorder({}));
		/* 1*65430BrtBorder */
		write_record(ba, "BrtEndBorders");
	}
	
	function write_CELLSTYLEXFS_bin(ba) {
		var cnt = 1;
		write_record(ba, "BrtBeginCellStyleXFs", write_UInt32LE(cnt));
		write_record(ba, "BrtXF", write_BrtXF({
			numFmtId:0,
			fontId:0,
			fillId:0,
			borderId:0
		}, 0xFFFF));
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, "BrtEndCellStyleXFs");
	}
	
	function write_CELLXFS_bin(ba, data) {
		write_record(ba, "BrtBeginCellXFs", write_UInt32LE(data.length));
		data.forEach(function(c) { write_record(ba, "BrtXF", write_BrtXF(c,0)); });
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, "BrtEndCellXFs");
	}
	
	function write_STYLES_bin(ba) {
		var cnt = 1;
	
		write_record(ba, "BrtBeginStyles", write_UInt32LE(cnt));
		write_record(ba, "BrtStyle", write_BrtStyle({
			xfId:0,
			builtinId:0,
			name:"Normal"
		}));
		/* 1*65430(BrtStyle *FRT) */
		write_record(ba, "BrtEndStyles");
	}
	
	function write_DXFS_bin(ba) {
		var cnt = 0;
	
		write_record(ba, "BrtBeginDXFs", write_UInt32LE(cnt));
		/* *2147483647(BrtDXF *FRT) */
		write_record(ba, "BrtEndDXFs");
	}
	
	function write_TABLESTYLES_bin(ba) {
		var cnt = 0;
	
		write_record(ba, "BrtBeginTableStyles", write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
		/* *TABLESTYLE */
		write_record(ba, "BrtEndTableStyles");
	}
	
	function write_COLORPALETTE_bin() {
		return;
		/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function write_sty_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginStyleSheet");
		write_FMTS_bin(ba, wb.SSF);
		write_FONTS_bin(ba, wb);
		write_FILLS_bin(ba, wb);
		write_BORDERS_bin(ba, wb);
		write_CELLSTYLEXFS_bin(ba, wb);
		write_CELLXFS_bin(ba, opts.cellXfs);
		write_STYLES_bin(ba, wb);
		write_DXFS_bin(ba, wb);
		write_TABLESTYLES_bin(ba, wb);
		write_COLORPALETTE_bin(ba, wb);
		/* FRTSTYLESHEET*/
		write_record(ba, "BrtEndStyleSheet");
		return ba.end();
	}
	RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
	
	/* 20.1.6.2 clrScheme CT_ColorScheme */
	function parse_clrScheme(t, themes, opts) {
		themes.themeElements.clrScheme = [];
		var color = {};
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
				case '<a:clrScheme': case '</a:clrScheme>': break;
	
				/* 20.1.2.3.32 srgbClr CT_SRgbColor */
				case '<a:srgbClr':
					color.rgb = y.val; break;
	
				/* 20.1.2.3.33 sysClr CT_SystemColor */
				case '<a:sysClr':
					color.rgb = y.lastClr; break;
	
				/* 20.1.4.1.1 accent1 (Accent 1) */
				/* 20.1.4.1.2 accent2 (Accent 2) */
				/* 20.1.4.1.3 accent3 (Accent 3) */
				/* 20.1.4.1.4 accent4 (Accent 4) */
				/* 20.1.4.1.5 accent5 (Accent 5) */
				/* 20.1.4.1.6 accent6 (Accent 6) */
				/* 20.1.4.1.9 dk1 (Dark 1) */
				/* 20.1.4.1.10 dk2 (Dark 2) */
				/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
				/* 20.1.4.1.19 hlink (Hyperlink) */
				/* 20.1.4.1.22 lt1 (Light 1) */
				/* 20.1.4.1.23 lt2 (Light 2) */
				case '<a:dk1>': case '</a:dk1>':
				case '<a:lt1>': case '</a:lt1>':
				case '<a:dk2>': case '</a:dk2>':
				case '<a:lt2>': case '</a:lt2>':
				case '<a:accent1>': case '</a:accent1>':
				case '<a:accent2>': case '</a:accent2>':
				case '<a:accent3>': case '</a:accent3>':
				case '<a:accent4>': case '</a:accent4>':
				case '<a:accent5>': case '</a:accent5>':
				case '<a:accent6>': case '</a:accent6>':
				case '<a:hlink>': case '</a:hlink>':
				case '<a:folHlink>': case '</a:folHlink>':
					if (y[0].charAt(1) === '/') {
						themes.themeElements.clrScheme.push(color);
						color = {};
					} else {
						color.name = y[0].slice(3, y[0].length - 1);
					}
					break;
	
				default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
			}
		});
	}
	
	/* 20.1.4.1.18 fontScheme CT_FontScheme */
	function parse_fontScheme() { }
	
	/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
	function parse_fmtScheme() { }
	
	var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
	var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
	var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
	
	/* 20.1.6.10 themeElements CT_BaseStyles */
	function parse_themeElements(data, themes, opts) {
		themes.themeElements = {};
	
		var t;
	
		[
			/* clrScheme CT_ColorScheme */
			['clrScheme', clrsregex, parse_clrScheme],
			/* fontScheme CT_FontScheme */
			['fontScheme', fntsregex, parse_fontScheme],
			/* fmtScheme CT_StyleMatrix */
			['fmtScheme', fmtsregex, parse_fmtScheme]
		].forEach(function(m) {
			if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
			m[2](t, themes, opts);
		});
	}
	
	var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
	
	/* 14.2.7 Theme Part */
	function parse_theme_xml(data, opts) {
		/* 20.1.6.9 theme CT_OfficeStyleSheet */
		if(!data || data.length === 0) return parse_theme_xml(write_theme());
	
		var t;
		var themes = {};
	
		/* themeElements CT_BaseStyles */
		if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
		parse_themeElements(t[0], themes, opts);
	
		return themes;
	}
	
	function write_theme(Themes, opts) {
		if(opts && opts.themeXLSX) return opts.themeXLSX;
		var o = [XML_HEADER];
		o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
		o[o.length] =  '<a:themeElements>';
	
		o[o.length] =   '<a:clrScheme name="Office">';
		o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
		o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
		o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
		o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
		o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
		o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
		o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
		o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
		o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
		o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
		o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
		o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
		o[o.length] =   '</a:clrScheme>';
	
		o[o.length] =   '<a:fontScheme name="Office">';
		o[o.length] =    '<a:majorFont>';
		o[o.length] =     '<a:latin typeface="Cambria"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:majorFont>';
		o[o.length] =    '<a:minorFont>';
		o[o.length] =     '<a:latin typeface="Calibri"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:minorFont>';
		o[o.length] =   '</a:fontScheme>';
	
		o[o.length] =   '<a:fmtScheme name="Office">';
		o[o.length] =    '<a:fillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:fillStyleLst>';
		o[o.length] =    '<a:lnStyleLst>';
		o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =    '</a:lnStyleLst>';
		o[o.length] =    '<a:effectStyleLst>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
		o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =    '</a:effectStyleLst>';
		o[o.length] =    '<a:bgFillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:bgFillStyleLst>';
		o[o.length] =   '</a:fmtScheme>';
		o[o.length] =  '</a:themeElements>';
	
		o[o.length] =  '<a:objectDefaults>';
		o[o.length] =   '<a:spDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:spDef>';
		o[o.length] =   '<a:lnDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:lnDef>';
		o[o.length] =  '</a:objectDefaults>';
		o[o.length] =  '<a:extraClrSchemeLst/>';
		o[o.length] = '</a:theme>';
		return o.join("");
	}
	/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
	function parse_Theme(blob, length, opts) {
		var end = blob.l + length;
		var dwThemeVersion = blob.read_shift(4);
		if(dwThemeVersion === 124226) return;
		if(!opts.cellStyles || !jszip) { blob.l = end; return; }
		var data = blob.slice(blob.l);
		blob.l = end;
		var zip; try { zip = new jszip(data); } catch(e) { return; }
		var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
		if(!themeXML) return;
		return parse_theme_xml(themeXML, opts);
	}
	
	/* 2.5.49 */
	function parse_ColorTheme(blob) { return blob.read_shift(4); }
	
	/* 2.5.155 */
	function parse_FullColorExt(blob) {
		var o = {};
		o.xclrType = blob.read_shift(2);
		o.nTintShade = blob.read_shift(2);
		switch(o.xclrType) {
			case 0: blob.l += 4; break;
			case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
			case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
			case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
			case 4: blob.l += 4; break;
		}
		blob.l += 8;
		return o;
	}
	
	/* 2.5.164 TODO: read 7 bits*/
	function parse_IcvXF(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.280 */
	function parse_XFExtGradient(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.108 */
	function parse_ExtProp(blob) {
		var extType = blob.read_shift(2);
		var cb = blob.read_shift(2);
		var o = [extType];
		switch(extType) {
			case 0x04: case 0x05: case 0x07: case 0x08:
			case 0x09: case 0x0A: case 0x0B: case 0x0D:
				o[1] = parse_FullColorExt(blob, cb); break;
			case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
			case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 5 ? 1 : 2); break;
			default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
		}
		return o;
	}
	
	/* 2.4.355 */
	function parse_XFExt(blob, length) {
		var end = blob.l + length;
		blob.l += 2;
		var ixfe = blob.read_shift(2);
		blob.l += 2;
		var cexts = blob.read_shift(2);
		var ext = [];
		while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
		return {ixfe:ixfe, ext:ext};
	}
	
	/* xf is an XF, see parse_XFExt for xfext */
	function update_xfext(xf, xfext) {
		xfext.forEach(function(xfe) {
			switch(xfe[0]) { /* 2.5.108 extPropData */
				case 0x04: break; /* foreground color */
				case 0x05: break; /* background color */
				case 0x06: break; /* gradient fill */
				case 0x07: break; /* top cell border color */
				case 0x08: break; /* bottom cell border color */
				case 0x09: break; /* left cell border color */
				case 0x0a: break; /* right cell border color */
				case 0x0b: break; /* diagonal cell border color */
				case 0x0d: break; /* text color */
				case 0x0e: break; /* font scheme */
				case 0x0f: break; /* indentation level */
			}
		});
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_xml(data) {
		var d = [];
		if(!data) return d;
		var i = 1;
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				/* 18.6.2  calcChain CT_CalcChain 1 */
				case '<calcChain': case '<calcChain>': case '</calcChain>': break;
				/* 18.6.1  c CT_CalcCell 1 */
				case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
			}
		});
		return d;
	}
	
	//function write_cc_xml(data, opts) { }
	
	/* [MS-XLSB] 2.6.4.1 */
	function parse_BrtCalcChainItem$(data) {
		var out = {};
		out.i = data.read_shift(4);
		var cell = {};
		cell.r = data.read_shift(4);
		cell.c = data.read_shift(4);
		out.r = encode_cell(cell);
		var flags = data.read_shift(1);
		if(flags & 0x2) out.l = '1';
		if(flags & 0x8) out.a = '1';
		return out;
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_bin(data, name, opts) {
		var out = [];
		var pass = false;
		recordhopper(data, function hopper_cc(val, R_n, RT) {
			switch(RT) {
				case 0x003F: /* 'BrtCalcChainItem$' */
					out.push(val); break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return out;
	}
	
	//function write_cc_bin(data, opts) { }
	/* 18.14 Supplementary Workbook Data */
	function parse_xlink_xml() {
		//var opts = _opts || {};
		//if(opts.WTF) throw "XLSX External Link";
	}
	
	/* [MS-XLSB] 2.1.7.25 External Link */
	function parse_xlink_bin(data, name, _opts) {
		if(!data) return data;
		var opts = _opts || {};
	
		var pass = false, end = false;
	
		recordhopper(data, function xlink_parse(val, R_n, RT) {
			if(end) return;
			switch(RT) {
				case 0x0167: /* 'BrtSupTabs' */
				case 0x016B: /* 'BrtExternTableStart' */
				case 0x016C: /* 'BrtExternTableEnd' */
				case 0x016E: /* 'BrtExternRowHdr' */
				case 0x016F: /* 'BrtExternCellBlank' */
				case 0x0170: /* 'BrtExternCellReal' */
				case 0x0171: /* 'BrtExternCellBool' */
				case 0x0172: /* 'BrtExternCellError' */
				case 0x0173: /* 'BrtExternCellString' */
				case 0x01D8: /* 'BrtExternValueMeta' */
				case 0x0241: /* 'BrtSupNameStart' */
				case 0x0242: /* 'BrtSupNameValueStart' */
				case 0x0243: /* 'BrtSupNameValueEnd' */
				case 0x0244: /* 'BrtSupNameNum' */
				case 0x0245: /* 'BrtSupNameErr' */
				case 0x0246: /* 'BrtSupNameSt' */
				case 0x0247: /* 'BrtSupNameNil' */
				case 0x0248: /* 'BrtSupNameBool' */
				case 0x0249: /* 'BrtSupNameFmla' */
				case 0x024A: /* 'BrtSupNameBits' */
				case 0x024B: /* 'BrtSupNameEnd' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT.toString(16) + " " + R_n);
			}
		}, opts);
	}
	RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
	RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
	/* 20.5 DrawingML - SpreadsheetML Drawing */
	function parse_drawing(data, rels) {
		if(!data) return "??";
		/*
		  Chartsheet Drawing:
		   - 20.5.2.35 wsDr CT_Drawing
		    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
		     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
		      - 20.1.2.2.16 graphic CT_GraphicalObject
		       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
	          - chart reference
		   the actual type is based on the URI of the graphicData
			TODO: handle embedded charts and other types of graphics
		*/
		var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];
	
		return rels['!id'][id].Target;
	}
	
	/* L.5.5.2 SpreadsheetML Comments + VML Schema */
	var _shapeid = 1024;
	function write_comments_vml(rId, comments) {
		var csize = [21600, 21600];
		/* L.5.2.1.2 Path Attribute */
		var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
		var o = [
			writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
			writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
			writextag("v:shapetype", [
				writextag("v:stroke", null, {joinstyle:"miter"}),
				writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
			].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
		];
		while(_shapeid < rId * 1000) _shapeid += 1000;
	
		comments.map(function(x) { return decode_cell(x[0]); }).forEach(function(c) { o = o.concat([
		'<v:shape' + wxt_helper({
			id:'_x0000_s' + (++_shapeid),
			type:"#_x0000_t202",
			style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10;visibility:hidden",
			fillcolor:"#ECFAD4",
			strokecolor:"#edeaa1"
		}) + '>',
			writextag('v:fill', writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}), {'color2':"#BEFF82", 'angle':"-180", 'type':"gradient"}),
			writextag("v:shadow", null, {on:"t", 'obscured':"t"}),
			writextag("v:path", null, {'o:connecttype':"none"}),
			'<v:textbox><div style="text-align:left"></div></v:textbox>',
			'<x:ClientData ObjectType="Note">',
				'<x:MoveWithCells/>',
				'<x:SizeWithCells/>',
				/* Part 4 19.4.2.3 Anchor (Anchor) */
				writetag('x:Anchor', [c.c, 0, c.r, 0, c.c+3, 100, c.r+5, 100].join(",")),
				writetag('x:AutoFill', "False"),
				writetag('x:Row', String(c.r)),
				writetag('x:Column', String(c.c)),
				'<x:Visible/>',
			'</x:ClientData>',
		'</v:shape>'
		]); });
		o.push('</xml>');
		return o.join("");
	}
	
	RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
	
	function parse_comments(zip, dirComments, sheets, sheetRels, opts) {
		for(var i = 0; i != dirComments.length; ++i) {
			var canonicalpath=dirComments[i];
			var comments=parse_cmnt(getzipdata(zip, canonicalpath.replace(/^\//,''), true), canonicalpath, opts);
			if(!comments || !comments.length) continue;
			// find the sheets targeted by these comments
			var sheetNames = keys(sheets);
			for(var j = 0; j != sheetNames.length; ++j) {
				var sheetName = sheetNames[j];
				var rels = sheetRels[sheetName];
				if(rels) {
					var rel = rels[canonicalpath];
					if(rel) insertCommentsIntoSheet(sheetName, sheets[sheetName], comments);
				}
			}
		}
	}
	
	function insertCommentsIntoSheet(sheetName, sheet, comments) {
		var dense = Array.isArray(sheet);
		var cell, r;
		comments.forEach(function(comment) {
			if(dense) {
				r = decode_cell(comment.ref);
				if(!sheet[r.r]) sheet[r.r] = [];
				cell = sheet[r.r][r.c];
			} else cell = sheet[comment.ref];
			if (!cell) {
				cell = {};
				if(dense) sheet[r.r][r.c] = cell;
				else sheet[comment.ref] = cell;
				var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
				var thisCell = decode_cell(comment.ref);
				if(range.s.r > thisCell.r) range.s.r = thisCell.r;
				if(range.e.r < thisCell.r) range.e.r = thisCell.r;
				if(range.s.c > thisCell.c) range.s.c = thisCell.c;
				if(range.e.c < thisCell.c) range.e.c = thisCell.c;
				var encoded = encode_range(range);
				if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
			}
	
			if (!cell.c) cell.c = [];
			var o = ({a: comment.author, t: comment.t, r: comment.r});
			if(comment.h) o.h = comment.h;
			cell.c.push(o);
		});
	}
	
	/* 18.7 Comments */
	function parse_comments_xml(data, opts) {
		/* 18.7.6 CT_Comments */
		if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
		var authors = [];
		var commentList = [];
		var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
		if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
			if(a) authors.push(a[1]);
		});
		var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
		if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
			if(!cm) return;
			var y = parsexmltag(cm[0]);
			var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
			var cell = decode_cell(y.ref);
			if(opts.sheetRows && opts.sheetRows <= cell.r) return;
			var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
			var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
			comment.r = rt.r;
			if(rt.r == "<t></t>") rt.t = rt.h = "";
			comment.t = rt.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
			if(opts.cellHTML) comment.h = rt.h;
			commentList.push(comment);
		});
		return commentList;
	}
	
	var CMNT_XML_ROOT = writextag('comments', null, { 'xmlns': XMLNS.main[0] });
	function write_comments_xml(data) {
		var o = [XML_HEADER, CMNT_XML_ROOT];
	
		var iauthor = [];
		o.push("<authors>");
		data.map(function(x) { return x[1]; }).forEach(function(comment) {
			comment.map(function(x) { return escapexml(x.a); }).forEach(function(a) {
				if(iauthor.indexOf(a) > -1) return;
				iauthor.push(a);
				o.push("<author>" + a + "</author>");
			});
		});
		o.push("</authors>");
		o.push("<commentList>");
		data.forEach(function(d) {
			d[1].forEach(function(c) {
				/* 18.7.3 CT_Comment */
				o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
				o.push(writetag("t", c.t == null ? "" : c.t));
				o.push('</text></comment>');
			});
		});
		o.push("</commentList>");
		if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.28 BrtBeginComment */
	function parse_BrtBeginComment(data) {
		var out = {};
		out.iauthor = data.read_shift(4);
		var rfx = parse_UncheckedRfX(data, 16);
		out.rfx = rfx.s;
		out.ref = encode_cell(rfx.s);
		data.l += 16; /*var guid = parse_GUID(data); */
		return out;
	}
	function write_BrtBeginComment(data, o) {
		if(o == null) o = new_buf(36);
		o.write_shift(4, data[1].iauthor);
		write_UncheckedRfX((data[0]), o);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.324 BrtCommentAuthor */
	var parse_BrtCommentAuthor = parse_XLWideString;
	function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }
	
	/* [MS-XLSB] 2.1.7.8 Comments */
	function parse_comments_bin(data, opts) {
		var out = [];
		var authors = [];
		var c = {};
		var pass = false;
		recordhopper(data, function hopper_cmnt(val, R_n, RT) {
			switch(RT) {
				case 0x0278: /* 'BrtCommentAuthor' */
					authors.push(val); break;
				case 0x027B: /* 'BrtBeginComment' */
					c = val; break;
				case 0x027D: /* 'BrtCommentText' */
					c.t = val.t; c.h = val.h; c.r = val.r; break;
				case 0x027C: /* 'BrtEndComment' */
					c.author = authors[c.iauthor];
					delete c.iauthor;
					if(opts.sheetRows && opts.sheetRows <= c.rfx.r) break;
					if(!c.t) c.t = "";
					delete c.rfx; out.push(c); break;
	
				/* case 'BrtUid': */
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return out;
	}
	
	function write_comments_bin(data) {
		var ba = buf_array();
		var iauthor = [];
		write_record(ba, "BrtBeginComments");
	
		write_record(ba, "BrtBeginCommentAuthors");
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				if(iauthor.indexOf(c.a) > -1) return;
				iauthor.push(c.a.slice(0,54));
				write_record(ba, "BrtCommentAuthor", write_BrtCommentAuthor(c.a));
			});
		});
		write_record(ba, "BrtEndCommentAuthors");
	
		write_record(ba, "BrtBeginCommentList");
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				c.iauthor = iauthor.indexOf(c.a);
				var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
				write_record(ba, "BrtBeginComment", write_BrtBeginComment([range, c]));
				if(c.t && c.t.length > 0) write_record(ba, "BrtCommentText", write_BrtCommentText(c));
				write_record(ba, "BrtEndComment");
				delete c.iauthor;
			});
		});
		write_record(ba, "BrtEndCommentList");
	
		write_record(ba, "BrtEndComments");
		return ba.end();
	}
	function make_vba_xls(cfb) {
		var newcfb = CFB.utils.cfb_new({root:"R"});
		cfb.FullPaths.forEach(function(p, i) {
			if(p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
			var newpath = p.replace(/^[^/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
			CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
		});
		return CFB.write(newcfb);
	}
	
	function fill_vba_xls(cfb, vba) {
		vba.FullPaths.forEach(function(p, i) {
			if(i == 0) return;
			var newpath = p.replace(/[^/]*[/]/, "/_VBA_PROJECT_CUR/");
			if(newpath.slice(-1) !== "/") CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
		});
	}
	
	var VBAFMTS = [ "xlsb", "xlsm", "xlam", "biff8", "xla" ];
	
	RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
	RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";
	
	/* macro and dialog sheet stubs */
	function parse_ds_bin() { return {'!type':'dialog'}; }
	function parse_ds_xml() { return {'!type':'dialog'}; }
	function parse_ms_bin() { return {'!type':'macro'}; }
	function parse_ms_xml() { return {'!type':'macro'}; }
	/* TODO: it will be useful to parse the function str */
	var rc_to_a1 = (function(){
		var rcregex = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;
		var rcbase = ({r:0,c:0});
		function rcfunc($$,$1,$2,$3,$4,$5) {
			var R = $3.length>0?parseInt($3,10)|0:0, C = $5.length>0?parseInt($5,10)|0:0;
			if(C<0 && $4.length === 0) C=0;
			var cRel = false, rRel = false;
			if($4.length > 0 || $5.length == 0) cRel = true; if(cRel) C += rcbase.c; else --C;
			if($2.length > 0 || $3.length == 0) rRel = true; if(rRel) R += rcbase.r; else --R;
			return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
		}
		return function rc_to_a1(fstr, base) {
			rcbase = base;
			return fstr.replace(rcregex, rcfunc);
		};
	})();
	
	var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;
	var a1_to_rc =(function(){
		return function a1_to_rc(fstr, base) {
			return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
				var c = decode_col($3) - ($2 ? 0 : base.c);
				var r = decode_row($5) - ($4 ? 0 : base.r);
				var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
				var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
				return $1 + "R" + R + "C" + C;
			});
		};
	})();
	
	/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
	function shift_formula_str(f, delta) {
		return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
		});
	}
	
	function shift_formula_xlsx(f, range, cell) {
		var r = decode_range(range), s = r.s, c = decode_cell(cell);
		var delta = {r:c.r - s.r, c:c.c - s.c};
		return shift_formula_str(f, delta);
	}
	
	/* TODO: parse formula */
	function fuzzyfmla(f) {
		if(f.length == 1) return false;
		return true;
	}
	
	function _xlfn(f) {
		return f.replace(/_xlfn\./g,"");
	}
	/* --- formula references point to MS-XLS --- */
	/* Small helpers */
	function parseread1(blob) { blob.l+=1; return; }
	
	/* Rgce Helpers */
	
	/* 2.5.51 */
	function parse_ColRelU(blob, length) {
		var c = blob.read_shift(length == 1 ? 1 : 2);
		return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
	}
	
	/* [MS-XLS] 2.5.198.105 */
	/* [MS-XLSB] 2.5.97.89 */
	function parse_RgceArea(blob, length, opts) {
		var w = 2;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
			else if(opts.biff == 12) w = 4;
		}
		var r=blob.read_shift(w), R=blob.read_shift(w);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	/* BIFF 2-5 encodes flags in the row field */
	function parse_RgceArea_BIFF2(blob) {
		var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
		var c=blob.read_shift(1);
		var C=blob.read_shift(1);
		return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
	}
	
	/* 2.5.198.105 TODO */
	function parse_RgceAreaRel(blob, length) {
		var r=blob.read_shift(length == 12 ? 4 : 2), R=blob.read_shift(length == 12 ? 4 : 2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* 2.5.198.109 */
	function parse_RgceLoc(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
		var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
		var c = parse_ColRelU(blob, 2);
		return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
	}
	function parse_RgceLoc_BIFF2(blob) {
		var r = parse_ColRelU(blob, 2);
		var c = blob.read_shift(1);
		return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
	}
	
	/* 2.5.198.107 , 2.5.47 */
	function parse_RgceElfLoc(blob) {
		var r = blob.read_shift(2);
		var c = blob.read_shift(2);
		return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
	}
	
	/* [MS-XLS] 2.5.198.111 TODO */
	/* [MS-XLSB] 2.5.97.92 TODO */
	function parse_RgceLocRel(blob, length, opts) {
		var biff = opts && opts.biff ? opts.biff : 8;
		if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
		var r = blob.read_shift(biff >= 12 ? 4 : 2);
		var cl = blob.read_shift(2);
		var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
		cl &= 0x3FFF;
		if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
		if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
		return {r:r,c:cl,cRel:cRel,rRel:rRel};
	}
	function parse_RgceLocRel_BIFF2(blob) {
		var rl = blob.read_shift(2);
		var c = blob.read_shift(1);
		var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
		rl &= 0x3FFF;
		if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
		if(cRel == 1 && c >= 0x80) c = c - 0x100;
		return {r:rl,c:c,cRel:cRel,rRel:rRel};
	}
	
	/* Ptg Tokens */
	
	/* 2.5.198.27 */
	function parse_PtgArea(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.28 */
	/* [MS-XLSB] 2.5.97.19 */
	function parse_PtgArea3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2, 'i');
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		var area = parse_RgceArea(blob, w, opts);
		return [type, ixti, area];
	}
	
	/* 2.5.198.29 */
	function parse_PtgAreaErr(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts && opts.biff > 8 ? 12 : 8;
		return [type];
	}
	/* 2.5.198.30 */
	function parse_PtgAreaErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* 2.5.198.31 */
	function parse_PtgAreaN(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceAreaRel(blob, opts && opts.biff > 8 ? 12 : 8, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.32 */
	/* [MS-XLSB] 2.5.97.23 */
	function parse_PtgArray(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
		return [type];
	}
	
	/* 2.5.198.33 */
	function parse_PtgAttrBaxcel(blob) {
		var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
		var bitBaxcel = 1;
		blob.l += 4;
		return [bitSemi, bitBaxcel];
	}
	
	/* 2.5.198.34 */
	function parse_PtgAttrChoose(blob, length, opts) {
		blob.l +=2;
		var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var o = [];
		/* offset is 1 less than the number of elements */
		for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
		return o;
	}
	
	/* 2.5.198.35 */
	function parse_PtgAttrGoto(blob, length, opts) {
		var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* 2.5.198.36 */
	function parse_PtgAttrIf(blob, length, opts) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLSB] 2.5.97.28 */
	function parse_PtgAttrIfError(blob) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(2)];
	}
	
	/* 2.5.198.37 */
	function parse_PtgAttrSemi(blob, length, opts) {
		var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += opts && opts.biff == 2 ? 3 : 4;
		return [bitSemi];
	}
	
	/* 2.5.198.40 (used by PtgAttrSpace and PtgAttrSpaceSemi) */
	function parse_PtgAttrSpaceType(blob) {
		var type = blob.read_shift(1), cch = blob.read_shift(1);
		return [type, cch];
	}
	
	/* 2.5.198.38 */
	function parse_PtgAttrSpace(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* 2.5.198.39 */
	function parse_PtgAttrSpaceSemi(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* 2.5.198.84 TODO */
	function parse_PtgRef(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLoc(blob, 0, opts);
		return [type, loc];
	}
	
	/* 2.5.198.88 TODO */
	function parse_PtgRefN(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLocRel(blob, 0, opts);
		return [type, loc];
	}
	
	/* 2.5.198.85 TODO */
	function parse_PtgRef3d(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var ixti = blob.read_shift(2); // XtiIndex
		var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
		return [type, ixti, loc];
	}
	
	
	/* 2.5.198.62 TODO */
	function parse_PtgFunc(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
		return [FtabArgc[iftab], Ftab[iftab], type];
	}
	/* 2.5.198.63 TODO */
	function parse_PtgFuncVar(blob, length, opts) {
		blob.l++;
		var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [0, blob.read_shift(1)]: parsetab(blob);
		return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
	}
	
	function parsetab(blob) {
		return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
	}
	
	/* 2.5.198.41 */
	function parse_PtgAttrSum(blob, length, opts) {
		blob.l += opts && opts.biff == 2 ? 3 : 4; return;
	}
	
	/* 2.5.198.58 */
	function parse_PtgExp(blob, length, opts) {
		blob.l++;
		if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
		var row = blob.read_shift(2);
		var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [row, col];
	}
	
	/* 2.5.198.57 */
	function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }
	
	/* 2.5.198.66 */
	function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }
	
	/* 2.5.198.42 */
	function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}
	
	/* 2.5.198.79 */
	function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }
	
	/* 2.5.198.89 */
	function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }
	
	/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
	/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
	function parse_SerAr(blob, biff) {
		var val = [blob.read_shift(1)];
		if(biff == 12) switch(val[0]) {
			case 0x02: val[0] = 0x04; break; /* SerBool */
			case 0x04: val[0] = 0x10; break; /* SerErr */
			case 0x00: val[0] = 0x01; break; /* SerNum */
			case 0x01: val[0] = 0x02; break; /* SerStr */
		}
		switch(val[0]) {
			/* 2.5.192.113 */
			case 0x04: /* SerBool -- boolean */
				val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
				blob.l += 7; break;
			/* 2.5.192.114 */
			case 0x10: /* SerErr -- error */
				val[1] = BErr[blob[blob.l]];
				blob.l += 8; break;
			/* 2.5.192.115 */
			case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
				blob.l += 8; break;
			/* 2.5.192.116 */
			case 0x01: /* SerNum -- Xnum */
				val[1] = parse_Xnum(blob, 8); break;
			/* 2.5.192.117 */
			case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
				val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
			// default: throw "Bad SerAr: " + val[0]; /* Unreachable */
		}
		return val;
	}
	
	/* 2.5.198.61 */
	function parse_PtgExtraMem(blob) {
		var count = blob.read_shift(2);
		var out = [];
		for(var i = 0; i != count; ++i) out.push(parse_Ref8U(blob, 8));
		return out;
	}
	
	/* 2.5.198.59 */
	function parse_PtgExtraArray(blob, length, opts) {
		var rows = 0, cols = 0;
		if(opts.biff == 12) {
			rows = blob.read_shift(4); // DRw
			cols = blob.read_shift(4); // DCol
		} else {
			cols = 1 + blob.read_shift(1); //DColByteU
			rows = 1 + blob.read_shift(2); //DRw
		}
		if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
		// $FlowIgnore
		for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
			for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
		return o;
	}
	
	/* 2.5.198.76 */
	function parse_PtgName(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
		var nameindex = blob.read_shift(w);
		switch(opts.biff) {
			case 2: blob.l += 5; break;
			case 3: case 4: blob.l += 8; break;
			case 5: blob.l += 12; break;
		}
		return [type, 0, nameindex];
	}
	
	/* 2.5.198.77 */
	function parse_PtgNameX(blob, length, opts) {
		if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2); // XtiIndex
		var nameindex = blob.read_shift(4);
		return [type, ixti, nameindex];
	}
	function parse_PtgNameX_BIFF5(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2, 'i'); // XtiIndex
		blob.l += 8;
		var nameindex = blob.read_shift(2);
		blob.l += 12;
		return [type, ixti, nameindex];
	}
	
	/* 2.5.198.70 */
	function parse_PtgMemArea(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += (opts && opts.biff == 2 ? 3 : 4);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	/* 2.5.198.72 */
	function parse_PtgMemFunc(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	
	/* 2.5.198.86 */
	function parse_PtgRefErr(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		if(opts.biff == 12) blob.l += 2;
		return [type];
	}
	
	/* 2.5.198.87 */
	function parse_PtgRefErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 4;
		if(opts) switch(opts.biff) {
			case 5: throw new Error("PtgRefErr3d -- 5"); // TODO: find test case
			case 12: w = 6; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* 2.5.198.71 */
	var parse_PtgMemErr = parsenoop;
	/* 2.5.198.73 */
	var parse_PtgMemNoMem = parsenoop;
	/* 2.5.198.92 */
	var parse_PtgTbl = parsenoop;
	
	function parse_PtgElfLoc(blob, length, opts) {
		blob.l += 2;
		return [parse_RgceElfLoc(blob, 4, opts)];
	}
	function parse_PtgElfNoop(blob) {
		blob.l += 6;
		return [];
	}
	/* 2.5.198.46 */
	var parse_PtgElfCol = parse_PtgElfLoc;
	/* 2.5.198.47 */
	var parse_PtgElfColS = parse_PtgElfNoop;
	/* 2.5.198.48 */
	var parse_PtgElfColSV = parse_PtgElfNoop;
	/* 2.5.198.49 */
	var parse_PtgElfColV = parse_PtgElfLoc;
	/* 2.5.198.50 */
	function parse_PtgElfLel(blob) {
		blob.l += 2;
		return [parseuint16(blob), blob.read_shift(2) & 0x01];
	}
	/* 2.5.198.51 */
	var parse_PtgElfRadical = parse_PtgElfLoc;
	/* 2.5.198.52 */
	var parse_PtgElfRadicalLel = parse_PtgElfLel;
	/* 2.5.198.53 */
	var parse_PtgElfRadicalS = parse_PtgElfNoop;
	/* 2.5.198.54 */
	var parse_PtgElfRw = parse_PtgElfLoc;
	/* 2.5.198.55 */
	var parse_PtgElfRwV = parse_PtgElfLoc;
	
	/* [MS-XLSB] 2.5.97.52 */
	function parse_PtgList(blob) {
		blob.l += 2;
		var ixti = blob.read_shift(2);
		blob.l += 10;
		return {ixti: ixti};
	}
	/* 2.5.198.91 */
	function parse_PtgSxName(blob) {
		blob.l += 2;
		return [blob.read_shift(4)];
	}
	
	/* 2.5.198.25 */
	var PtgTypes = {
	0x01: { n:'PtgExp', f:parse_PtgExp },
	0x02: { n:'PtgTbl', f:parse_PtgTbl },
	0x03: { n:'PtgAdd', f:parseread1 },
	0x04: { n:'PtgSub', f:parseread1 },
	0x05: { n:'PtgMul', f:parseread1 },
	0x06: { n:'PtgDiv', f:parseread1 },
	0x07: { n:'PtgPower', f:parseread1 },
	0x08: { n:'PtgConcat', f:parseread1 },
	0x09: { n:'PtgLt', f:parseread1 },
	0x0A: { n:'PtgLe', f:parseread1 },
	0x0B: { n:'PtgEq', f:parseread1 },
	0x0C: { n:'PtgGe', f:parseread1 },
	0x0D: { n:'PtgGt', f:parseread1 },
	0x0E: { n:'PtgNe', f:parseread1 },
	0x0F: { n:'PtgIsect', f:parseread1 },
	0x10: { n:'PtgUnion', f:parseread1 },
	0x11: { n:'PtgRange', f:parseread1 },
	0x12: { n:'PtgUplus', f:parseread1 },
	0x13: { n:'PtgUminus', f:parseread1 },
	0x14: { n:'PtgPercent', f:parseread1 },
	0x15: { n:'PtgParen', f:parseread1 },
	0x16: { n:'PtgMissArg', f:parseread1 },
	0x17: { n:'PtgStr', f:parse_PtgStr },
	0x1C: { n:'PtgErr', f:parse_PtgErr },
	0x1D: { n:'PtgBool', f:parse_PtgBool },
	0x1E: { n:'PtgInt', f:parse_PtgInt },
	0x1F: { n:'PtgNum', f:parse_PtgNum },
	0x20: { n:'PtgArray', f:parse_PtgArray },
	0x21: { n:'PtgFunc', f:parse_PtgFunc },
	0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	0x23: { n:'PtgName', f:parse_PtgName },
	0x24: { n:'PtgRef', f:parse_PtgRef },
	0x25: { n:'PtgArea', f:parse_PtgArea },
	0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
	0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
	0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
	0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	0x2C: { n:'PtgRefN', f:parse_PtgRefN },
	0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
	0x39: { n:'PtgNameX', f:parse_PtgNameX },
	0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
	0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
	0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	0xFF: {}
	};
	/* These are duplicated in the PtgTypes table */
	var PtgDupes = {
	0x40: 0x20, 0x60: 0x20,
	0x41: 0x21, 0x61: 0x21,
	0x42: 0x22, 0x62: 0x22,
	0x43: 0x23, 0x63: 0x23,
	0x44: 0x24, 0x64: 0x24,
	0x45: 0x25, 0x65: 0x25,
	0x46: 0x26, 0x66: 0x26,
	0x47: 0x27, 0x67: 0x27,
	0x48: 0x28, 0x68: 0x28,
	0x49: 0x29, 0x69: 0x29,
	0x4A: 0x2A, 0x6A: 0x2A,
	0x4B: 0x2B, 0x6B: 0x2B,
	0x4C: 0x2C, 0x6C: 0x2C,
	0x4D: 0x2D, 0x6D: 0x2D,
	0x59: 0x39, 0x79: 0x39,
	0x5A: 0x3A, 0x7A: 0x3A,
	0x5B: 0x3B, 0x7B: 0x3B,
	0x5C: 0x3C, 0x7C: 0x3C,
	0x5D: 0x3D, 0x7D: 0x3D
	};
	(function(){for(var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];})();
	
	var Ptg18 = {
	0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
	0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
	0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
	0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
	0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
	0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	0x19: { n:'PtgList', f:parse_PtgList },
	0x1D: { n:'PtgSxName', f:parse_PtgSxName },
	0xFF: {}
	};
	var Ptg19 = {
	0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	0xFF: {}
	};
	Ptg19[0x21] = Ptg19[0x20];
	
	/* 2.5.198.103 */
	function parse_RgbExtra(blob, length, rgce, opts) {
		if(opts.biff < 8) return parsenoop(blob, length);
		var target = blob.l + length;
		var o = [];
		for(var i = 0; i !== rgce.length; ++i) {
			switch(rgce[i][0]) {
				case 'PtgArray': /* PtgArray -> PtgExtraArray */
					rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
					o.push(rgce[i][1]);
					break;
				case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
					rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1]);
					o.push(rgce[i][2]);
					break;
				case 'PtgExp': /* PtgExp -> PtgExtraCol */
					if(opts && opts.biff == 12) {
						rgce[i][1][1] = blob.read_shift(4);
						o.push(rgce[i][1]);
					} break;
				case 'PtgList': /* TODO: PtgList -> PtgExtraList */
				case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
				case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
				case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
					throw "Unsupported " + rgce[i][0];
				default: break;
			}
		}
		length = target - blob.l;
		/* note: this is technically an error but Excel disregards */
		//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
		if(length !== 0) o.push(parsenoop(blob, length));
		return o;
	}
	
	/* 2.5.198.104 */
	function parse_Rgce(blob, length, opts) {
		var target = blob.l + length;
		var R, id, ptgs = [];
		while(target != blob.l) {
			length = target - blob.l;
			id = blob[blob.l];
			R = PtgTypes[id];
			if(id === 0x18 || id === 0x19) {
				id = blob[blob.l + 1];
				R = (id === 0x18 ? Ptg18 : Ptg19)[id];
			}
			if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
			// $FlowIgnore
			else { ptgs.push([R.n, R.f(blob, length, opts)]); }
		}
		return ptgs;
	}
	
	function stringify_array(f) {
		var o = [];
		for(var i = 0; i < f.length; ++i) {
			var x = f[i], r = [];
			for(var j = 0; j < x.length; ++j) {
				var y = x[j];
				if(y) switch(y[0]) {
					// TODO: handle embedded quotes
					case 0x02:
	r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
					default: r.push(y[1]);
				} else r.push("");
			}
			o.push(r.join(","));
		}
		return o.join(";");
	}
	
	/* [MS-XLS] 2.2.2 TODO */
	/* [MS-XLSB] 2.2.2 */
	var PtgBinOp = {
		PtgAdd: "+",
		PtgConcat: "&",
		PtgDiv: "/",
		PtgEq: "=",
		PtgGe: ">=",
		PtgGt: ">",
		PtgLe: "<=",
		PtgLt: "<",
		PtgMul: "*",
		PtgNe: "<>",
		PtgPower: "^",
		PtgSub: "-"
	};
	function formula_quote_sheet_name(sname, opts) {
		if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
		if(sname.indexOf(" ") > -1) return "'" + sname + "'";
		return sname;
	}
	function get_ixti_raw(supbooks, ixti, opts) {
		if(!supbooks) return "SH33TJSERR0";
		if(!supbooks.XTI) return "SH33TJSERR6";
		var XTI = supbooks.XTI[ixti];
		if(opts.biff > 8 && !supbooks.XTI[ixti]) return supbooks.SheetNames[ixti];
		if(opts.biff < 8) {
			if(ixti > 10000) ixti-= 65536;
			if(ixti < 0) ixti = -ixti;
			return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
		}
		if(!XTI) return "SH33TJSERR1";
		var o = "";
		if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
			case 0x0165: /* 'BrtSupSelf' */
				o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x0166: /* 'BrtSupSame' */
				if(opts.SID != null) return supbooks.SheetNames[opts.SID];
				return "SH33TJSSAME" + supbooks[XTI[0]][0];
			case 0x0163: /* 'BrtSupBookSrc' */
				/* falls through */
			default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
		}
		switch(supbooks[XTI[0]][0][0]) {
			case 0x0401:
				o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x3A01: return "SH33TJSERR8";
			default:
				if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
				o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
		}
	}
	function get_ixti(supbooks, ixti, opts) {
		return formula_quote_sheet_name(get_ixti_raw(supbooks, ixti, opts), opts);
	}
	function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
		var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
		var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
		if(!formula[0] || !formula[0][0]) return "";
		var last_sp = -1, sp = "";
		for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
			var f = formula[0][ff];
			switch(f[0]) {
				case 'PtgUminus': /* 2.5.198.93 */
					stack.push("-" + stack.pop()); break;
				case 'PtgUplus': /* 2.5.198.95 */
					stack.push("+" + stack.pop()); break;
				case 'PtgPercent': /* 2.5.198.81 */
					stack.push(stack.pop() + "%"); break;
	
				case 'PtgAdd':    /* 2.5.198.26 */
				case 'PtgConcat': /* 2.5.198.43 */
				case 'PtgDiv':    /* 2.5.198.45 */
				case 'PtgEq':     /* 2.5.198.56 */
				case 'PtgGe':     /* 2.5.198.64 */
				case 'PtgGt':     /* 2.5.198.65 */
				case 'PtgLe':     /* 2.5.198.68 */
				case 'PtgLt':     /* 2.5.198.69 */
				case 'PtgMul':    /* 2.5.198.75 */
				case 'PtgNe':     /* 2.5.198.78 */
				case 'PtgPower':  /* 2.5.198.82 */
				case 'PtgSub':    /* 2.5.198.90 */
					e1 = stack.pop(); e2 = stack.pop();
					if(last_sp >= 0) {
						switch(formula[0][last_sp][1][0]) {
							case 0:
								// $FlowIgnore
								sp = fill(" ", formula[0][last_sp][1][1]); break;
							case 1:
								// $FlowIgnore
								sp = fill("\r", formula[0][last_sp][1][1]); break;
							default:
								sp = "";
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						e2 = e2 + sp;
						last_sp = -1;
					}
					stack.push(e2+PtgBinOp[f[0]]+e1);
					break;
	
				case 'PtgIsect': /* 2.5.198.67 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+" "+e1);
					break;
				case 'PtgUnion': /* 2.5.198.94 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+","+e1);
					break;
				case 'PtgRange': /* 2.5.198.83 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+":"+e1);
					break;
	
				case 'PtgAttrChoose': /* 2.5.198.34 */
					break;
				case 'PtgAttrGoto': /* 2.5.198.35 */
					break;
				case 'PtgAttrIf': /* 2.5.198.36 */
					break;
				case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
					break;
	
	
				case 'PtgRef': /* 2.5.198.84 */
	c = shift_cell_xls((f[1][1]), _range, opts);
					stack.push(encode_cell_xls(c));
					break;
				case 'PtgRefN': /* 2.5.198.88 */
	c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
					stack.push(encode_cell_xls(c));
					break;
				case 'PtgRef3d': /* 2.5.198.85 */
	ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
					sname = get_ixti(supbooks, ixti, opts);
					var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
					stack.push(sname + "!" + encode_cell_xls(c));
					break;
	
				case 'PtgFunc': /* 2.5.198.62 */
				case 'PtgFuncVar': /* 2.5.198.63 */
					/* f[1] = [argc, func, type] */
					var argc = (f[1][0]), func = (f[1][1]);
					if(!argc) argc = 0;
					var args = argc == 0 ? [] : stack.slice(-argc);
					stack.length -= argc;
					if(func === 'User') func = args.shift();
					stack.push(func + "(" + args.join(",") + ")");
					break;
	
				case 'PtgBool': /* 2.5.198.42 */
					stack.push(f[1] ? "TRUE" : "FALSE"); break;
				case 'PtgInt': /* 2.5.198.66 */
					stack.push(f[1]); break;
				case 'PtgNum': /* 2.5.198.79 TODO: precision? */
					stack.push(String(f[1])); break;
				case 'PtgStr': /* 2.5.198.89 */
					// $FlowIgnore
					stack.push('"' + f[1] + '"'); break;
				case 'PtgErr': /* 2.5.198.57 */
					stack.push(f[1]); break;
				case 'PtgAreaN': /* 2.5.198.31 TODO */
	r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea': /* 2.5.198.27 TODO: fixed points */
	r = shift_range_xls(f[1][1], _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea3d': /* 2.5.198.28 TODO */
	ixti = f[1][1]; r = f[1][2];
					sname = get_ixti(supbooks, ixti, opts);
					stack.push(sname + "!" + encode_range_xls((r), opts));
					break;
				case 'PtgAttrSum': /* 2.5.198.41 */
					stack.push("SUM(" + stack.pop() + ")");
					break;
	
				case 'PtgAttrSemi': /* 2.5.198.37 */
					break;
	
				case 'PtgName': /* 2.5.97.60 TODO: revisions */
					/* f[1] = type, 0, nameindex */
					nameidx = (f[1][2]);
					var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
					var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
					if(name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
					stack.push(name);
					break;
	
				case 'PtgNameX': /* 2.5.97.61 TODO: revisions */
					/* f[1] = type, ixti, nameindex */
					var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
					/* TODO: Properly handle missing values */
					if(opts.biff <= 5) {
						if(bookidx < 0) bookidx = -bookidx;
						if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
					} else {
						var o = "";
						if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
						else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
							if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
								o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
							}
						}
						else o = supbooks.SheetNames[nameidx-1]+ "!";
						if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
						else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
						else o += "SH33TJSERRX";
						stack.push(o);
						break;
					}
					if(!externbook) externbook = {Name: "SH33TJSERRY"};
					stack.push(externbook.Name);
					break;
	
				case 'PtgParen': /* 2.5.198.80 */
					var lp = '(', rp = ')';
					if(last_sp >= 0) {
						sp = "";
						switch(formula[0][last_sp][1][0]) {
							// $FlowIgnore
							case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
							// $FlowIgnore
							case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
							default:
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						last_sp = -1;
					}
					stack.push(lp + stack.pop() + rp); break;
	
				case 'PtgRefErr': /* 2.5.198.86 */
					stack.push('#REF!'); break;
	
				case 'PtgRefErr3d': /* 2.5.198.87 */
					stack.push('#REF!'); break;
	
				case 'PtgExp': /* 2.5.198.58 TODO */
					c = {c:(f[1][1]),r:(f[1][0])};
					var q = ({c: cell.c, r:cell.r});
					if(supbooks.sharedf[encode_cell(c)]) {
						var parsedf = (supbooks.sharedf[encode_cell(c)]);
						stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
					}
					else {
						var fnd = false;
						for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
							/* TODO: should be something like range_has */
							e2 = supbooks.arrayf[e1];
							if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
							if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
							stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
							fnd = true;
							break;
						}
						if(!fnd) stack.push(f[1]);
					}
					break;
	
				case 'PtgArray': /* 2.5.198.32 TODO */
					stack.push("{" + stringify_array(f[1]) + "}");
					break;
	
				case 'PtgMemArea': /* 2.5.198.70 TODO: confirm this is a non-display */
					//stack.push("(" + f[2].map(encode_range).join(",") + ")");
					break;
	
				case 'PtgAttrSpace': /* 2.5.198.38 */
				case 'PtgAttrSpaceSemi': /* 2.5.198.39 */
					last_sp = ff;
					break;
	
				case 'PtgTbl': /* 2.5.198.92 TODO */
					break;
	
				case 'PtgMemErr': /* 2.5.198.71 */
					break;
	
				case 'PtgMissArg': /* 2.5.198.74 */
					stack.push("");
					break;
	
				case 'PtgAreaErr': /* 2.5.198.29 */
					stack.push("#REF!"); break;
	
				case 'PtgAreaErr3d': /* 2.5.198.30 */
					stack.push("#REF!"); break;
	
				case 'PtgMemFunc': /* 2.5.198.72 TODO */
					break;
				case 'PtgMemNoMem': /* 2.5.198.73 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
	
				case 'PtgElfCol': /* 2.5.198.46 */
				case 'PtgElfColS': /* 2.5.198.47 */
				case 'PtgElfColSV': /* 2.5.198.48 */
				case 'PtgElfColV': /* 2.5.198.49 */
				case 'PtgElfLel': /* 2.5.198.50 */
				case 'PtgElfRadical': /* 2.5.198.51 */
				case 'PtgElfRadicalLel': /* 2.5.198.52 */
				case 'PtgElfRadicalS': /* 2.5.198.53 */
				case 'PtgElfRw': /* 2.5.198.54 */
				case 'PtgElfRwV': /* 2.5.198.55 */
					throw new Error("Unsupported ELFs");
	
				case 'PtgAttrBaxcel': /* 2.5.198.33 TODO -- find a test case*/
					throw new Error('Unrecognized Formula Token: ' + String(f));
				case 'PtgSxName': /* 2.5.198.91 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
				case 'PtgList': /* [MS-XLSB] 2.5.97.52 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
	
				default: throw new Error('Unrecognized Formula Token: ' + String(f));
			}
			var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
			if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
				f = formula[0][last_sp];
				var _left = true;
				switch(f[1][0]) {
					/* note: some bad XLSB files omit the PtgParen */
					case 4: _left = false;
					/* falls through */
					case 0:
						// $FlowIgnore
						sp = fill(" ", f[1][1]); break;
					case 5: _left = false;
					/* falls through */
					case 1:
						// $FlowIgnore
						sp = fill("\r", f[1][1]); break;
					default:
						sp = "";
						// $FlowIgnore
						if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
				}
				stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
				last_sp = -1;
			}
		}
		if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
		return stack[0];
	}
	
	/* [MS-XLS] 2.5.198.1 TODO */
	function parse_ArrayParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.3 TODO */
	function parse_XLSCellParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.21 */
	function parse_NameParsedFormula(blob, length, opts, cce) {
		var target = blob.l + length;
		var rgce = parse_Rgce(blob, cce, opts);
		var rgcb;
		if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.118 TODO */
	function parse_SharedParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		var rgce = parse_Rgce(blob, cce, opts);
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
	function parse_FormulaValue(blob) {
		var b;
		if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
		switch(blob[blob.l]) {
			case 0x00: blob.l += 8; return ["String", 's'];
			case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
			case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
			case 0x03: blob.l += 8; return ["",'s'];
		}
		return [];
	}
	
	/* [MS-XLS] 2.4.127 TODO */
	function parse_Formula(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_FormulaValue(blob,8);
		var flags = blob.read_shift(1);
		if(opts.biff != 2) {
			blob.read_shift(1);
			if(opts.biff >= 5) {
				/*var chn = */blob.read_shift(4);
			}
		}
		var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
		return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
	}
	
	/* XLSB Parsed Formula records have the same shape */
	function parse_XLSBParsedFormula(data, length, opts) {
		//var end = data.l + length;
		var cce = data.read_shift(4);
		var rgce = parse_Rgce(data, cce, opts);
		var cb = data.read_shift(4);
		var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
		return [rgce, rgcb];
	}
	
	/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
	var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
	var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
	var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
	var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLS] 2.5.198.4 */
	var Cetab = {
	0x0000: 'BEEP',
	0x0001: 'OPEN',
	0x0002: 'OPEN.LINKS',
	0x0003: 'CLOSE.ALL',
	0x0004: 'SAVE',
	0x0005: 'SAVE.AS',
	0x0006: 'FILE.DELETE',
	0x0007: 'PAGE.SETUP',
	0x0008: 'PRINT',
	0x0009: 'PRINTER.SETUP',
	0x000A: 'QUIT',
	0x000B: 'NEW.WINDOW',
	0x000C: 'ARRANGE.ALL',
	0x000D: 'WINDOW.SIZE',
	0x000E: 'WINDOW.MOVE',
	0x000F: 'FULL',
	0x0010: 'CLOSE',
	0x0011: 'RUN',
	0x0016: 'SET.PRINT.AREA',
	0x0017: 'SET.PRINT.TITLES',
	0x0018: 'SET.PAGE.BREAK',
	0x0019: 'REMOVE.PAGE.BREAK',
	0x001A: 'FONT',
	0x001B: 'DISPLAY',
	0x001C: 'PROTECT.DOCUMENT',
	0x001D: 'PRECISION',
	0x001E: 'A1.R1C1',
	0x001F: 'CALCULATE.NOW',
	0x0020: 'CALCULATION',
	0x0022: 'DATA.FIND',
	0x0023: 'EXTRACT',
	0x0024: 'DATA.DELETE',
	0x0025: 'SET.DATABASE',
	0x0026: 'SET.CRITERIA',
	0x0027: 'SORT',
	0x0028: 'DATA.SERIES',
	0x0029: 'TABLE',
	0x002A: 'FORMAT.NUMBER',
	0x002B: 'ALIGNMENT',
	0x002C: 'STYLE',
	0x002D: 'BORDER',
	0x002E: 'CELL.PROTECTION',
	0x002F: 'COLUMN.WIDTH',
	0x0030: 'UNDO',
	0x0031: 'CUT',
	0x0032: 'COPY',
	0x0033: 'PASTE',
	0x0034: 'CLEAR',
	0x0035: 'PASTE.SPECIAL',
	0x0036: 'EDIT.DELETE',
	0x0037: 'INSERT',
	0x0038: 'FILL.RIGHT',
	0x0039: 'FILL.DOWN',
	0x003D: 'DEFINE.NAME',
	0x003E: 'CREATE.NAMES',
	0x003F: 'FORMULA.GOTO',
	0x0040: 'FORMULA.FIND',
	0x0041: 'SELECT.LAST.CELL',
	0x0042: 'SHOW.ACTIVE.CELL',
	0x0043: 'GALLERY.AREA',
	0x0044: 'GALLERY.BAR',
	0x0045: 'GALLERY.COLUMN',
	0x0046: 'GALLERY.LINE',
	0x0047: 'GALLERY.PIE',
	0x0048: 'GALLERY.SCATTER',
	0x0049: 'COMBINATION',
	0x004A: 'PREFERRED',
	0x004B: 'ADD.OVERLAY',
	0x004C: 'GRIDLINES',
	0x004D: 'SET.PREFERRED',
	0x004E: 'AXES',
	0x004F: 'LEGEND',
	0x0050: 'ATTACH.TEXT',
	0x0051: 'ADD.ARROW',
	0x0052: 'SELECT.CHART',
	0x0053: 'SELECT.PLOT.AREA',
	0x0054: 'PATTERNS',
	0x0055: 'MAIN.CHART',
	0x0056: 'OVERLAY',
	0x0057: 'SCALE',
	0x0058: 'FORMAT.LEGEND',
	0x0059: 'FORMAT.TEXT',
	0x005A: 'EDIT.REPEAT',
	0x005B: 'PARSE',
	0x005C: 'JUSTIFY',
	0x005D: 'HIDE',
	0x005E: 'UNHIDE',
	0x005F: 'WORKSPACE',
	0x0060: 'FORMULA',
	0x0061: 'FORMULA.FILL',
	0x0062: 'FORMULA.ARRAY',
	0x0063: 'DATA.FIND.NEXT',
	0x0064: 'DATA.FIND.PREV',
	0x0065: 'FORMULA.FIND.NEXT',
	0x0066: 'FORMULA.FIND.PREV',
	0x0067: 'ACTIVATE',
	0x0068: 'ACTIVATE.NEXT',
	0x0069: 'ACTIVATE.PREV',
	0x006A: 'UNLOCKED.NEXT',
	0x006B: 'UNLOCKED.PREV',
	0x006C: 'COPY.PICTURE',
	0x006D: 'SELECT',
	0x006E: 'DELETE.NAME',
	0x006F: 'DELETE.FORMAT',
	0x0070: 'VLINE',
	0x0071: 'HLINE',
	0x0072: 'VPAGE',
	0x0073: 'HPAGE',
	0x0074: 'VSCROLL',
	0x0075: 'HSCROLL',
	0x0076: 'ALERT',
	0x0077: 'NEW',
	0x0078: 'CANCEL.COPY',
	0x0079: 'SHOW.CLIPBOARD',
	0x007A: 'MESSAGE',
	0x007C: 'PASTE.LINK',
	0x007D: 'APP.ACTIVATE',
	0x007E: 'DELETE.ARROW',
	0x007F: 'ROW.HEIGHT',
	0x0080: 'FORMAT.MOVE',
	0x0081: 'FORMAT.SIZE',
	0x0082: 'FORMULA.REPLACE',
	0x0083: 'SEND.KEYS',
	0x0084: 'SELECT.SPECIAL',
	0x0085: 'APPLY.NAMES',
	0x0086: 'REPLACE.FONT',
	0x0087: 'FREEZE.PANES',
	0x0088: 'SHOW.INFO',
	0x0089: 'SPLIT',
	0x008A: 'ON.WINDOW',
	0x008B: 'ON.DATA',
	0x008C: 'DISABLE.INPUT',
	0x008E: 'OUTLINE',
	0x008F: 'LIST.NAMES',
	0x0090: 'FILE.CLOSE',
	0x0091: 'SAVE.WORKBOOK',
	0x0092: 'DATA.FORM',
	0x0093: 'COPY.CHART',
	0x0094: 'ON.TIME',
	0x0095: 'WAIT',
	0x0096: 'FORMAT.FONT',
	0x0097: 'FILL.UP',
	0x0098: 'FILL.LEFT',
	0x0099: 'DELETE.OVERLAY',
	0x009B: 'SHORT.MENUS',
	0x009F: 'SET.UPDATE.STATUS',
	0x00A1: 'COLOR.PALETTE',
	0x00A2: 'DELETE.STYLE',
	0x00A3: 'WINDOW.RESTORE',
	0x00A4: 'WINDOW.MAXIMIZE',
	0x00A6: 'CHANGE.LINK',
	0x00A7: 'CALCULATE.DOCUMENT',
	0x00A8: 'ON.KEY',
	0x00A9: 'APP.RESTORE',
	0x00AA: 'APP.MOVE',
	0x00AB: 'APP.SIZE',
	0x00AC: 'APP.MINIMIZE',
	0x00AD: 'APP.MAXIMIZE',
	0x00AE: 'BRING.TO.FRONT',
	0x00AF: 'SEND.TO.BACK',
	0x00B9: 'MAIN.CHART.TYPE',
	0x00BA: 'OVERLAY.CHART.TYPE',
	0x00BB: 'SELECT.END',
	0x00BC: 'OPEN.MAIL',
	0x00BD: 'SEND.MAIL',
	0x00BE: 'STANDARD.FONT',
	0x00BF: 'CONSOLIDATE',
	0x00C0: 'SORT.SPECIAL',
	0x00C1: 'GALLERY.3D.AREA',
	0x00C2: 'GALLERY.3D.COLUMN',
	0x00C3: 'GALLERY.3D.LINE',
	0x00C4: 'GALLERY.3D.PIE',
	0x00C5: 'VIEW.3D',
	0x00C6: 'GOAL.SEEK',
	0x00C7: 'WORKGROUP',
	0x00C8: 'FILL.GROUP',
	0x00C9: 'UPDATE.LINK',
	0x00CA: 'PROMOTE',
	0x00CB: 'DEMOTE',
	0x00CC: 'SHOW.DETAIL',
	0x00CE: 'UNGROUP',
	0x00CF: 'OBJECT.PROPERTIES',
	0x00D0: 'SAVE.NEW.OBJECT',
	0x00D1: 'SHARE',
	0x00D2: 'SHARE.NAME',
	0x00D3: 'DUPLICATE',
	0x00D4: 'APPLY.STYLE',
	0x00D5: 'ASSIGN.TO.OBJECT',
	0x00D6: 'OBJECT.PROTECTION',
	0x00D7: 'HIDE.OBJECT',
	0x00D8: 'SET.EXTRACT',
	0x00D9: 'CREATE.PUBLISHER',
	0x00DA: 'SUBSCRIBE.TO',
	0x00DB: 'ATTRIBUTES',
	0x00DC: 'SHOW.TOOLBAR',
	0x00DE: 'PRINT.PREVIEW',
	0x00DF: 'EDIT.COLOR',
	0x00E0: 'SHOW.LEVELS',
	0x00E1: 'FORMAT.MAIN',
	0x00E2: 'FORMAT.OVERLAY',
	0x00E3: 'ON.RECALC',
	0x00E4: 'EDIT.SERIES',
	0x00E5: 'DEFINE.STYLE',
	0x00F0: 'LINE.PRINT',
	0x00F3: 'ENTER.DATA',
	0x00F9: 'GALLERY.RADAR',
	0x00FA: 'MERGE.STYLES',
	0x00FB: 'EDITION.OPTIONS',
	0x00FC: 'PASTE.PICTURE',
	0x00FD: 'PASTE.PICTURE.LINK',
	0x00FE: 'SPELLING',
	0x0100: 'ZOOM',
	0x0103: 'INSERT.OBJECT',
	0x0104: 'WINDOW.MINIMIZE',
	0x0109: 'SOUND.NOTE',
	0x010A: 'SOUND.PLAY',
	0x010B: 'FORMAT.SHAPE',
	0x010C: 'EXTEND.POLYGON',
	0x010D: 'FORMAT.AUTO',
	0x0110: 'GALLERY.3D.BAR',
	0x0111: 'GALLERY.3D.SURFACE',
	0x0112: 'FILL.AUTO',
	0x0114: 'CUSTOMIZE.TOOLBAR',
	0x0115: 'ADD.TOOL',
	0x0116: 'EDIT.OBJECT',
	0x0117: 'ON.DOUBLECLICK',
	0x0118: 'ON.ENTRY',
	0x0119: 'WORKBOOK.ADD',
	0x011A: 'WORKBOOK.MOVE',
	0x011B: 'WORKBOOK.COPY',
	0x011C: 'WORKBOOK.OPTIONS',
	0x011D: 'SAVE.WORKSPACE',
	0x0120: 'CHART.WIZARD',
	0x0121: 'DELETE.TOOL',
	0x0122: 'MOVE.TOOL',
	0x0123: 'WORKBOOK.SELECT',
	0x0124: 'WORKBOOK.ACTIVATE',
	0x0125: 'ASSIGN.TO.TOOL',
	0x0127: 'COPY.TOOL',
	0x0128: 'RESET.TOOL',
	0x0129: 'CONSTRAIN.NUMERIC',
	0x012A: 'PASTE.TOOL',
	0x012E: 'WORKBOOK.NEW',
	0x0131: 'SCENARIO.CELLS',
	0x0132: 'SCENARIO.DELETE',
	0x0133: 'SCENARIO.ADD',
	0x0134: 'SCENARIO.EDIT',
	0x0135: 'SCENARIO.SHOW',
	0x0136: 'SCENARIO.SHOW.NEXT',
	0x0137: 'SCENARIO.SUMMARY',
	0x0138: 'PIVOT.TABLE.WIZARD',
	0x0139: 'PIVOT.FIELD.PROPERTIES',
	0x013A: 'PIVOT.FIELD',
	0x013B: 'PIVOT.ITEM',
	0x013C: 'PIVOT.ADD.FIELDS',
	0x013E: 'OPTIONS.CALCULATION',
	0x013F: 'OPTIONS.EDIT',
	0x0140: 'OPTIONS.VIEW',
	0x0141: 'ADDIN.MANAGER',
	0x0142: 'MENU.EDITOR',
	0x0143: 'ATTACH.TOOLBARS',
	0x0144: 'VBAActivate',
	0x0145: 'OPTIONS.CHART',
	0x0148: 'VBA.INSERT.FILE',
	0x014A: 'VBA.PROCEDURE.DEFINITION',
	0x0150: 'ROUTING.SLIP',
	0x0152: 'ROUTE.DOCUMENT',
	0x0153: 'MAIL.LOGON',
	0x0156: 'INSERT.PICTURE',
	0x0157: 'EDIT.TOOL',
	0x0158: 'GALLERY.DOUGHNUT',
	0x015E: 'CHART.TREND',
	0x0160: 'PIVOT.ITEM.PROPERTIES',
	0x0162: 'WORKBOOK.INSERT',
	0x0163: 'OPTIONS.TRANSITION',
	0x0164: 'OPTIONS.GENERAL',
	0x0172: 'FILTER.ADVANCED',
	0x0175: 'MAIL.ADD.MAILER',
	0x0176: 'MAIL.DELETE.MAILER',
	0x0177: 'MAIL.REPLY',
	0x0178: 'MAIL.REPLY.ALL',
	0x0179: 'MAIL.FORWARD',
	0x017A: 'MAIL.NEXT.LETTER',
	0x017B: 'DATA.LABEL',
	0x017C: 'INSERT.TITLE',
	0x017D: 'FONT.PROPERTIES',
	0x017E: 'MACRO.OPTIONS',
	0x017F: 'WORKBOOK.HIDE',
	0x0180: 'WORKBOOK.UNHIDE',
	0x0181: 'WORKBOOK.DELETE',
	0x0182: 'WORKBOOK.NAME',
	0x0184: 'GALLERY.CUSTOM',
	0x0186: 'ADD.CHART.AUTOFORMAT',
	0x0187: 'DELETE.CHART.AUTOFORMAT',
	0x0188: 'CHART.ADD.DATA',
	0x0189: 'AUTO.OUTLINE',
	0x018A: 'TAB.ORDER',
	0x018B: 'SHOW.DIALOG',
	0x018C: 'SELECT.ALL',
	0x018D: 'UNGROUP.SHEETS',
	0x018E: 'SUBTOTAL.CREATE',
	0x018F: 'SUBTOTAL.REMOVE',
	0x0190: 'RENAME.OBJECT',
	0x019C: 'WORKBOOK.SCROLL',
	0x019D: 'WORKBOOK.NEXT',
	0x019E: 'WORKBOOK.PREV',
	0x019F: 'WORKBOOK.TAB.SPLIT',
	0x01A0: 'FULL.SCREEN',
	0x01A1: 'WORKBOOK.PROTECT',
	0x01A4: 'SCROLLBAR.PROPERTIES',
	0x01A5: 'PIVOT.SHOW.PAGES',
	0x01A6: 'TEXT.TO.COLUMNS',
	0x01A7: 'FORMAT.CHARTTYPE',
	0x01A8: 'LINK.FORMAT',
	0x01A9: 'TRACER.DISPLAY',
	0x01AE: 'TRACER.NAVIGATE',
	0x01AF: 'TRACER.CLEAR',
	0x01B0: 'TRACER.ERROR',
	0x01B1: 'PIVOT.FIELD.GROUP',
	0x01B2: 'PIVOT.FIELD.UNGROUP',
	0x01B3: 'CHECKBOX.PROPERTIES',
	0x01B4: 'LABEL.PROPERTIES',
	0x01B5: 'LISTBOX.PROPERTIES',
	0x01B6: 'EDITBOX.PROPERTIES',
	0x01B7: 'PIVOT.REFRESH',
	0x01B8: 'LINK.COMBO',
	0x01B9: 'OPEN.TEXT',
	0x01BA: 'HIDE.DIALOG',
	0x01BB: 'SET.DIALOG.FOCUS',
	0x01BC: 'ENABLE.OBJECT',
	0x01BD: 'PUSHBUTTON.PROPERTIES',
	0x01BE: 'SET.DIALOG.DEFAULT',
	0x01BF: 'FILTER',
	0x01C0: 'FILTER.SHOW.ALL',
	0x01C1: 'CLEAR.OUTLINE',
	0x01C2: 'FUNCTION.WIZARD',
	0x01C3: 'ADD.LIST.ITEM',
	0x01C4: 'SET.LIST.ITEM',
	0x01C5: 'REMOVE.LIST.ITEM',
	0x01C6: 'SELECT.LIST.ITEM',
	0x01C7: 'SET.CONTROL.VALUE',
	0x01C8: 'SAVE.COPY.AS',
	0x01CA: 'OPTIONS.LISTS.ADD',
	0x01CB: 'OPTIONS.LISTS.DELETE',
	0x01CC: 'SERIES.AXES',
	0x01CD: 'SERIES.X',
	0x01CE: 'SERIES.Y',
	0x01CF: 'ERRORBAR.X',
	0x01D0: 'ERRORBAR.Y',
	0x01D1: 'FORMAT.CHART',
	0x01D2: 'SERIES.ORDER',
	0x01D3: 'MAIL.LOGOFF',
	0x01D4: 'CLEAR.ROUTING.SLIP',
	0x01D5: 'APP.ACTIVATE.MICROSOFT',
	0x01D6: 'MAIL.EDIT.MAILER',
	0x01D7: 'ON.SHEET',
	0x01D8: 'STANDARD.WIDTH',
	0x01D9: 'SCENARIO.MERGE',
	0x01DA: 'SUMMARY.INFO',
	0x01DB: 'FIND.FILE',
	0x01DC: 'ACTIVE.CELL.FONT',
	0x01DD: 'ENABLE.TIPWIZARD',
	0x01DE: 'VBA.MAKE.ADDIN',
	0x01E0: 'INSERTDATATABLE',
	0x01E1: 'WORKGROUP.OPTIONS',
	0x01E2: 'MAIL.SEND.MAILER',
	0x01E5: 'AUTOCORRECT',
	0x01E9: 'POST.DOCUMENT',
	0x01EB: 'PICKLIST',
	0x01ED: 'VIEW.SHOW',
	0x01EE: 'VIEW.DEFINE',
	0x01EF: 'VIEW.DELETE',
	0x01FD: 'SHEET.BACKGROUND',
	0x01FE: 'INSERT.MAP.OBJECT',
	0x01FF: 'OPTIONS.MENONO',
	0x0205: 'MSOCHECKS',
	0x0206: 'NORMAL',
	0x0207: 'LAYOUT',
	0x0208: 'RM.PRINT.AREA',
	0x0209: 'CLEAR.PRINT.AREA',
	0x020A: 'ADD.PRINT.AREA',
	0x020B: 'MOVE.BRK',
	0x0221: 'HIDECURR.NOTE',
	0x0222: 'HIDEALL.NOTES',
	0x0223: 'DELETE.NOTE',
	0x0224: 'TRAVERSE.NOTES',
	0x0225: 'ACTIVATE.NOTES',
	0x026C: 'PROTECT.REVISIONS',
	0x026D: 'UNPROTECT.REVISIONS',
	0x0287: 'OPTIONS.ME',
	0x028D: 'WEB.PUBLISH',
	0x029B: 'NEWWEBQUERY',
	0x02A1: 'PIVOT.TABLE.CHART',
	0x02F1: 'OPTIONS.SAVE',
	0x02F3: 'OPTIONS.SPELL',
	0x0328: 'HIDEALL.INKANNOTS'
	};
	
	/* [MS-XLS] 2.5.198.17 */
	/* [MS-XLSB] 2.5.97.10 */
	var Ftab = {
	0x0000: 'COUNT',
	0x0001: 'IF',
	0x0002: 'ISNA',
	0x0003: 'ISERROR',
	0x0004: 'SUM',
	0x0005: 'AVERAGE',
	0x0006: 'MIN',
	0x0007: 'MAX',
	0x0008: 'ROW',
	0x0009: 'COLUMN',
	0x000A: 'NA',
	0x000B: 'NPV',
	0x000C: 'STDEV',
	0x000D: 'DOLLAR',
	0x000E: 'FIXED',
	0x000F: 'SIN',
	0x0010: 'COS',
	0x0011: 'TAN',
	0x0012: 'ATAN',
	0x0013: 'PI',
	0x0014: 'SQRT',
	0x0015: 'EXP',
	0x0016: 'LN',
	0x0017: 'LOG10',
	0x0018: 'ABS',
	0x0019: 'INT',
	0x001A: 'SIGN',
	0x001B: 'ROUND',
	0x001C: 'LOOKUP',
	0x001D: 'INDEX',
	0x001E: 'REPT',
	0x001F: 'MID',
	0x0020: 'LEN',
	0x0021: 'VALUE',
	0x0022: 'TRUE',
	0x0023: 'FALSE',
	0x0024: 'AND',
	0x0025: 'OR',
	0x0026: 'NOT',
	0x0027: 'MOD',
	0x0028: 'DCOUNT',
	0x0029: 'DSUM',
	0x002A: 'DAVERAGE',
	0x002B: 'DMIN',
	0x002C: 'DMAX',
	0x002D: 'DSTDEV',
	0x002E: 'VAR',
	0x002F: 'DVAR',
	0x0030: 'TEXT',
	0x0031: 'LINEST',
	0x0032: 'TREND',
	0x0033: 'LOGEST',
	0x0034: 'GROWTH',
	0x0035: 'GOTO',
	0x0036: 'HALT',
	0x0037: 'RETURN',
	0x0038: 'PV',
	0x0039: 'FV',
	0x003A: 'NPER',
	0x003B: 'PMT',
	0x003C: 'RATE',
	0x003D: 'MIRR',
	0x003E: 'IRR',
	0x003F: 'RAND',
	0x0040: 'MATCH',
	0x0041: 'DATE',
	0x0042: 'TIME',
	0x0043: 'DAY',
	0x0044: 'MONTH',
	0x0045: 'YEAR',
	0x0046: 'WEEKDAY',
	0x0047: 'HOUR',
	0x0048: 'MINUTE',
	0x0049: 'SECOND',
	0x004A: 'NOW',
	0x004B: 'AREAS',
	0x004C: 'ROWS',
	0x004D: 'COLUMNS',
	0x004E: 'OFFSET',
	0x004F: 'ABSREF',
	0x0050: 'RELREF',
	0x0051: 'ARGUMENT',
	0x0052: 'SEARCH',
	0x0053: 'TRANSPOSE',
	0x0054: 'ERROR',
	0x0055: 'STEP',
	0x0056: 'TYPE',
	0x0057: 'ECHO',
	0x0058: 'SET.NAME',
	0x0059: 'CALLER',
	0x005A: 'DEREF',
	0x005B: 'WINDOWS',
	0x005C: 'SERIES',
	0x005D: 'DOCUMENTS',
	0x005E: 'ACTIVE.CELL',
	0x005F: 'SELECTION',
	0x0060: 'RESULT',
	0x0061: 'ATAN2',
	0x0062: 'ASIN',
	0x0063: 'ACOS',
	0x0064: 'CHOOSE',
	0x0065: 'HLOOKUP',
	0x0066: 'VLOOKUP',
	0x0067: 'LINKS',
	0x0068: 'INPUT',
	0x0069: 'ISREF',
	0x006A: 'GET.FORMULA',
	0x006B: 'GET.NAME',
	0x006C: 'SET.VALUE',
	0x006D: 'LOG',
	0x006E: 'EXEC',
	0x006F: 'CHAR',
	0x0070: 'LOWER',
	0x0071: 'UPPER',
	0x0072: 'PROPER',
	0x0073: 'LEFT',
	0x0074: 'RIGHT',
	0x0075: 'EXACT',
	0x0076: 'TRIM',
	0x0077: 'REPLACE',
	0x0078: 'SUBSTITUTE',
	0x0079: 'CODE',
	0x007A: 'NAMES',
	0x007B: 'DIRECTORY',
	0x007C: 'FIND',
	0x007D: 'CELL',
	0x007E: 'ISERR',
	0x007F: 'ISTEXT',
	0x0080: 'ISNUMBER',
	0x0081: 'ISBLANK',
	0x0082: 'T',
	0x0083: 'N',
	0x0084: 'FOPEN',
	0x0085: 'FCLOSE',
	0x0086: 'FSIZE',
	0x0087: 'FREADLN',
	0x0088: 'FREAD',
	0x0089: 'FWRITELN',
	0x008A: 'FWRITE',
	0x008B: 'FPOS',
	0x008C: 'DATEVALUE',
	0x008D: 'TIMEVALUE',
	0x008E: 'SLN',
	0x008F: 'SYD',
	0x0090: 'DDB',
	0x0091: 'GET.DEF',
	0x0092: 'REFTEXT',
	0x0093: 'TEXTREF',
	0x0094: 'INDIRECT',
	0x0095: 'REGISTER',
	0x0096: 'CALL',
	0x0097: 'ADD.BAR',
	0x0098: 'ADD.MENU',
	0x0099: 'ADD.COMMAND',
	0x009A: 'ENABLE.COMMAND',
	0x009B: 'CHECK.COMMAND',
	0x009C: 'RENAME.COMMAND',
	0x009D: 'SHOW.BAR',
	0x009E: 'DELETE.MENU',
	0x009F: 'DELETE.COMMAND',
	0x00A0: 'GET.CHART.ITEM',
	0x00A1: 'DIALOG.BOX',
	0x00A2: 'CLEAN',
	0x00A3: 'MDETERM',
	0x00A4: 'MINVERSE',
	0x00A5: 'MMULT',
	0x00A6: 'FILES',
	0x00A7: 'IPMT',
	0x00A8: 'PPMT',
	0x00A9: 'COUNTA',
	0x00AA: 'CANCEL.KEY',
	0x00AB: 'FOR',
	0x00AC: 'WHILE',
	0x00AD: 'BREAK',
	0x00AE: 'NEXT',
	0x00AF: 'INITIATE',
	0x00B0: 'REQUEST',
	0x00B1: 'POKE',
	0x00B2: 'EXECUTE',
	0x00B3: 'TERMINATE',
	0x00B4: 'RESTART',
	0x00B5: 'HELP',
	0x00B6: 'GET.BAR',
	0x00B7: 'PRODUCT',
	0x00B8: 'FACT',
	0x00B9: 'GET.CELL',
	0x00BA: 'GET.WORKSPACE',
	0x00BB: 'GET.WINDOW',
	0x00BC: 'GET.DOCUMENT',
	0x00BD: 'DPRODUCT',
	0x00BE: 'ISNONTEXT',
	0x00BF: 'GET.NOTE',
	0x00C0: 'NOTE',
	0x00C1: 'STDEVP',
	0x00C2: 'VARP',
	0x00C3: 'DSTDEVP',
	0x00C4: 'DVARP',
	0x00C5: 'TRUNC',
	0x00C6: 'ISLOGICAL',
	0x00C7: 'DCOUNTA',
	0x00C8: 'DELETE.BAR',
	0x00C9: 'UNREGISTER',
	0x00CC: 'USDOLLAR',
	0x00CD: 'FINDB',
	0x00CE: 'SEARCHB',
	0x00CF: 'REPLACEB',
	0x00D0: 'LEFTB',
	0x00D1: 'RIGHTB',
	0x00D2: 'MIDB',
	0x00D3: 'LENB',
	0x00D4: 'ROUNDUP',
	0x00D5: 'ROUNDDOWN',
	0x00D6: 'ASC',
	0x00D7: 'DBCS',
	0x00D8: 'RANK',
	0x00DB: 'ADDRESS',
	0x00DC: 'DAYS360',
	0x00DD: 'TODAY',
	0x00DE: 'VDB',
	0x00DF: 'ELSE',
	0x00E0: 'ELSE.IF',
	0x00E1: 'END.IF',
	0x00E2: 'FOR.CELL',
	0x00E3: 'MEDIAN',
	0x00E4: 'SUMPRODUCT',
	0x00E5: 'SINH',
	0x00E6: 'COSH',
	0x00E7: 'TANH',
	0x00E8: 'ASINH',
	0x00E9: 'ACOSH',
	0x00EA: 'ATANH',
	0x00EB: 'DGET',
	0x00EC: 'CREATE.OBJECT',
	0x00ED: 'VOLATILE',
	0x00EE: 'LAST.ERROR',
	0x00EF: 'CUSTOM.UNDO',
	0x00F0: 'CUSTOM.REPEAT',
	0x00F1: 'FORMULA.CONVERT',
	0x00F2: 'GET.LINK.INFO',
	0x00F3: 'TEXT.BOX',
	0x00F4: 'INFO',
	0x00F5: 'GROUP',
	0x00F6: 'GET.OBJECT',
	0x00F7: 'DB',
	0x00F8: 'PAUSE',
	0x00FB: 'RESUME',
	0x00FC: 'FREQUENCY',
	0x00FD: 'ADD.TOOLBAR',
	0x00FE: 'DELETE.TOOLBAR',
	0x00FF: 'User',
	0x0100: 'RESET.TOOLBAR',
	0x0101: 'EVALUATE',
	0x0102: 'GET.TOOLBAR',
	0x0103: 'GET.TOOL',
	0x0104: 'SPELLING.CHECK',
	0x0105: 'ERROR.TYPE',
	0x0106: 'APP.TITLE',
	0x0107: 'WINDOW.TITLE',
	0x0108: 'SAVE.TOOLBAR',
	0x0109: 'ENABLE.TOOL',
	0x010A: 'PRESS.TOOL',
	0x010B: 'REGISTER.ID',
	0x010C: 'GET.WORKBOOK',
	0x010D: 'AVEDEV',
	0x010E: 'BETADIST',
	0x010F: 'GAMMALN',
	0x0110: 'BETAINV',
	0x0111: 'BINOMDIST',
	0x0112: 'CHIDIST',
	0x0113: 'CHIINV',
	0x0114: 'COMBIN',
	0x0115: 'CONFIDENCE',
	0x0116: 'CRITBINOM',
	0x0117: 'EVEN',
	0x0118: 'EXPONDIST',
	0x0119: 'FDIST',
	0x011A: 'FINV',
	0x011B: 'FISHER',
	0x011C: 'FISHERINV',
	0x011D: 'FLOOR',
	0x011E: 'GAMMADIST',
	0x011F: 'GAMMAINV',
	0x0120: 'CEILING',
	0x0121: 'HYPGEOMDIST',
	0x0122: 'LOGNORMDIST',
	0x0123: 'LOGINV',
	0x0124: 'NEGBINOMDIST',
	0x0125: 'NORMDIST',
	0x0126: 'NORMSDIST',
	0x0127: 'NORMINV',
	0x0128: 'NORMSINV',
	0x0129: 'STANDARDIZE',
	0x012A: 'ODD',
	0x012B: 'PERMUT',
	0x012C: 'POISSON',
	0x012D: 'TDIST',
	0x012E: 'WEIBULL',
	0x012F: 'SUMXMY2',
	0x0130: 'SUMX2MY2',
	0x0131: 'SUMX2PY2',
	0x0132: 'CHITEST',
	0x0133: 'CORREL',
	0x0134: 'COVAR',
	0x0135: 'FORECAST',
	0x0136: 'FTEST',
	0x0137: 'INTERCEPT',
	0x0138: 'PEARSON',
	0x0139: 'RSQ',
	0x013A: 'STEYX',
	0x013B: 'SLOPE',
	0x013C: 'TTEST',
	0x013D: 'PROB',
	0x013E: 'DEVSQ',
	0x013F: 'GEOMEAN',
	0x0140: 'HARMEAN',
	0x0141: 'SUMSQ',
	0x0142: 'KURT',
	0x0143: 'SKEW',
	0x0144: 'ZTEST',
	0x0145: 'LARGE',
	0x0146: 'SMALL',
	0x0147: 'QUARTILE',
	0x0148: 'PERCENTILE',
	0x0149: 'PERCENTRANK',
	0x014A: 'MODE',
	0x014B: 'TRIMMEAN',
	0x014C: 'TINV',
	0x014E: 'MOVIE.COMMAND',
	0x014F: 'GET.MOVIE',
	0x0150: 'CONCATENATE',
	0x0151: 'POWER',
	0x0152: 'PIVOT.ADD.DATA',
	0x0153: 'GET.PIVOT.TABLE',
	0x0154: 'GET.PIVOT.FIELD',
	0x0155: 'GET.PIVOT.ITEM',
	0x0156: 'RADIANS',
	0x0157: 'DEGREES',
	0x0158: 'SUBTOTAL',
	0x0159: 'SUMIF',
	0x015A: 'COUNTIF',
	0x015B: 'COUNTBLANK',
	0x015C: 'SCENARIO.GET',
	0x015D: 'OPTIONS.LISTS.GET',
	0x015E: 'ISPMT',
	0x015F: 'DATEDIF',
	0x0160: 'DATESTRING',
	0x0161: 'NUMBERSTRING',
	0x0162: 'ROMAN',
	0x0163: 'OPEN.DIALOG',
	0x0164: 'SAVE.DIALOG',
	0x0165: 'VIEW.GET',
	0x0166: 'GETPIVOTDATA',
	0x0167: 'HYPERLINK',
	0x0168: 'PHONETIC',
	0x0169: 'AVERAGEA',
	0x016A: 'MAXA',
	0x016B: 'MINA',
	0x016C: 'STDEVPA',
	0x016D: 'VARPA',
	0x016E: 'STDEVA',
	0x016F: 'VARA',
	0x0170: 'BAHTTEXT',
	0x0171: 'THAIDAYOFWEEK',
	0x0172: 'THAIDIGIT',
	0x0173: 'THAIMONTHOFYEAR',
	0x0174: 'THAINUMSOUND',
	0x0175: 'THAINUMSTRING',
	0x0176: 'THAISTRINGLENGTH',
	0x0177: 'ISTHAIDIGIT',
	0x0178: 'ROUNDBAHTDOWN',
	0x0179: 'ROUNDBAHTUP',
	0x017A: 'THAIYEAR',
	0x017B: 'RTD',
	
	0x017C: 'CUBEVALUE',
	0x017D: 'CUBEMEMBER',
	0x017E: 'CUBEMEMBERPROPERTY',
	0x017F: 'CUBERANKEDMEMBER',
	0x0180: 'HEX2BIN',
	0x0181: 'HEX2DEC',
	0x0182: 'HEX2OCT',
	0x0183: 'DEC2BIN',
	0x0184: 'DEC2HEX',
	0x0185: 'DEC2OCT',
	0x0186: 'OCT2BIN',
	0x0187: 'OCT2HEX',
	0x0188: 'OCT2DEC',
	0x0189: 'BIN2DEC',
	0x018A: 'BIN2OCT',
	0x018B: 'BIN2HEX',
	0x018C: 'IMSUB',
	0x018D: 'IMDIV',
	0x018E: 'IMPOWER',
	0x018F: 'IMABS',
	0x0190: 'IMSQRT',
	0x0191: 'IMLN',
	0x0192: 'IMLOG2',
	0x0193: 'IMLOG10',
	0x0194: 'IMSIN',
	0x0195: 'IMCOS',
	0x0196: 'IMEXP',
	0x0197: 'IMARGUMENT',
	0x0198: 'IMCONJUGATE',
	0x0199: 'IMAGINARY',
	0x019A: 'IMREAL',
	0x019B: 'COMPLEX',
	0x019C: 'IMSUM',
	0x019D: 'IMPRODUCT',
	0x019E: 'SERIESSUM',
	0x019F: 'FACTDOUBLE',
	0x01A0: 'SQRTPI',
	0x01A1: 'QUOTIENT',
	0x01A2: 'DELTA',
	0x01A3: 'GESTEP',
	0x01A4: 'ISEVEN',
	0x01A5: 'ISODD',
	0x01A6: 'MROUND',
	0x01A7: 'ERF',
	0x01A8: 'ERFC',
	0x01A9: 'BESSELJ',
	0x01AA: 'BESSELK',
	0x01AB: 'BESSELY',
	0x01AC: 'BESSELI',
	0x01AD: 'XIRR',
	0x01AE: 'XNPV',
	0x01AF: 'PRICEMAT',
	0x01B0: 'YIELDMAT',
	0x01B1: 'INTRATE',
	0x01B2: 'RECEIVED',
	0x01B3: 'DISC',
	0x01B4: 'PRICEDISC',
	0x01B5: 'YIELDDISC',
	0x01B6: 'TBILLEQ',
	0x01B7: 'TBILLPRICE',
	0x01B8: 'TBILLYIELD',
	0x01B9: 'PRICE',
	0x01BA: 'YIELD',
	0x01BB: 'DOLLARDE',
	0x01BC: 'DOLLARFR',
	0x01BD: 'NOMINAL',
	0x01BE: 'EFFECT',
	0x01BF: 'CUMPRINC',
	0x01C0: 'CUMIPMT',
	0x01C1: 'EDATE',
	0x01C2: 'EOMONTH',
	0x01C3: 'YEARFRAC',
	0x01C4: 'COUPDAYBS',
	0x01C5: 'COUPDAYS',
	0x01C6: 'COUPDAYSNC',
	0x01C7: 'COUPNCD',
	0x01C8: 'COUPNUM',
	0x01C9: 'COUPPCD',
	0x01CA: 'DURATION',
	0x01CB: 'MDURATION',
	0x01CC: 'ODDLPRICE',
	0x01CD: 'ODDLYIELD',
	0x01CE: 'ODDFPRICE',
	0x01CF: 'ODDFYIELD',
	0x01D0: 'RANDBETWEEN',
	0x01D1: 'WEEKNUM',
	0x01D2: 'AMORDEGRC',
	0x01D3: 'AMORLINC',
	0x01D4: 'CONVERT',
	0x02D4: 'SHEETJS',
	0x01D5: 'ACCRINT',
	0x01D6: 'ACCRINTM',
	0x01D7: 'WORKDAY',
	0x01D8: 'NETWORKDAYS',
	0x01D9: 'GCD',
	0x01DA: 'MULTINOMIAL',
	0x01DB: 'LCM',
	0x01DC: 'FVSCHEDULE',
	0x01DD: 'CUBEKPIMEMBER',
	0x01DE: 'CUBESET',
	0x01DF: 'CUBESETCOUNT',
	0x01E0: 'IFERROR',
	0x01E1: 'COUNTIFS',
	0x01E2: 'SUMIFS',
	0x01E3: 'AVERAGEIF',
	0x01E4: 'AVERAGEIFS'
	};
	var FtabArgc = {
	0x0002: 1, /* ISNA */
	0x0003: 1, /* ISERROR */
	0x000F: 1, /* SIN */
	0x0010: 1, /* COS */
	0x0011: 1, /* TAN */
	0x0012: 1, /* ATAN */
	0x0013: 0, /* PI */
	0x0014: 1, /* SQRT */
	0x0015: 1, /* EXP */
	0x0016: 1, /* LN */
	0x0017: 1, /* LOG10 */
	0x0018: 1, /* ABS */
	0x0019: 1, /* INT */
	0x001A: 1, /* SIGN */
	0x001B: 2, /* ROUND */
	0x001E: 2, /* REPT */
	0x001F: 3, /* MID */
	0x0020: 1, /* LEN */
	0x0021: 1, /* VALUE */
	0x0026: 1, /* NOT */
	0x0027: 2, /* MOD */
	0x0028: 3, /* DCOUNT */
	0x0029: 3, /* DSUM */
	0x002A: 3, /* DAVERAGE */
	0x002B: 3, /* DMIN */
	0x002C: 3, /* DMAX */
	0x002D: 3, /* DSTDEV */
	0x002F: 3, /* DVAR */
	0x0030: 2, /* TEXT */
	0x0035: 1, /* GOTO */
	0x003D: 3, /* MIRR */
	0x0041: 3, /* DATE */
	0x0042: 3, /* TIME */
	0x0043: 1, /* DAY */
	0x0044: 1, /* MONTH */
	0x0045: 1, /* YEAR */
	0x0046: 1, /* WEEKDAY */
	0x0047: 1, /* HOUR */
	0x0048: 1, /* MINUTE */
	0x0049: 1, /* SECOND */
	0x004B: 1, /* AREAS */
	0x004C: 1, /* ROWS */
	0x004D: 1, /* COLUMNS */
	0x004F: 2, /* ABSREF */
	0x0050: 2, /* RELREF */
	0x0053: 1, /* TRANSPOSE */
	0x0055: 0, /* STEP */
	0x0056: 1, /* TYPE */
	0x005A: 1, /* DEREF */
	0x0061: 2, /* ATAN2 */
	0x0062: 1, /* ASIN */
	0x0063: 1, /* ACOS */
	0x0065: 3, /* HLOOKUP */
	0x0066: 3, /* VLOOKUP */
	0x0069: 1, /* ISREF */
	0x006F: 1, /* CHAR */
	0x0070: 1, /* LOWER */
	0x0071: 1, /* UPPER */
	0x0072: 1, /* PROPER */
	0x0075: 2, /* EXACT */
	0x0076: 1, /* TRIM */
	0x0077: 4, /* REPLACE */
	0x0079: 1, /* CODE */
	0x007E: 1, /* ISERR */
	0x007F: 1, /* ISTEXT */
	0x0080: 1, /* ISNUMBER */
	0x0081: 1, /* ISBLANK */
	0x0082: 1, /* T */
	0x0083: 1, /* N */
	0x0085: 1, /* FCLOSE */
	0x0086: 1, /* FSIZE */
	0x0087: 1, /* FREADLN */
	0x0088: 2, /* FREAD */
	0x0089: 2, /* FWRITELN */
	0x008A: 2, /* FWRITE */
	0x008C: 1, /* DATEVALUE */
	0x008D: 1, /* TIMEVALUE */
	0x008E: 3, /* SLN */
	0x008F: 4, /* SYD */
	0x0090: 4, /* DDB */
	0x00A2: 1, /* CLEAN */
	0x00A3: 1, /* MDETERM */
	0x00A4: 1, /* MINVERSE */
	0x00A5: 2, /* MMULT */
	0x00AC: 1, /* WHILE */
	0x00AF: 2, /* INITIATE */
	0x00B0: 2, /* REQUEST */
	0x00B1: 3, /* POKE */
	0x00B2: 2, /* EXECUTE */
	0x00B3: 1, /* TERMINATE */
	0x00B8: 1, /* FACT */
	0x00BD: 3, /* DPRODUCT */
	0x00BE: 1, /* ISNONTEXT */
	0x00C3: 3, /* DSTDEVP */
	0x00C4: 3, /* DVARP */
	0x00C5: 1, /* TRUNC */
	0x00C6: 1, /* ISLOGICAL */
	0x00C7: 3, /* DCOUNTA */
	0x00C9: 1, /* UNREGISTER */
	0x00CF: 4, /* REPLACEB */
	0x00D2: 3, /* MIDB */
	0x00D3: 1, /* LENB */
	0x00D4: 2, /* ROUNDUP */
	0x00D5: 2, /* ROUNDDOWN */
	0x00D6: 1, /* ASC */
	0x00D7: 1, /* DBCS */
	0x00E5: 1, /* SINH */
	0x00E6: 1, /* COSH */
	0x00E7: 1, /* TANH */
	0x00E8: 1, /* ASINH */
	0x00E9: 1, /* ACOSH */
	0x00EA: 1, /* ATANH */
	0x00EB: 3, /* DGET */
	0x00F4: 1, /* INFO */
	0x00F7: 4, /* DB */
	0x00FC: 2, /* FREQUENCY */
	0x0101: 1, /* EVALUATE */
	0x0105: 1, /* ERROR.TYPE */
	0x010F: 1, /* GAMMALN */
	0x0111: 4, /* BINOMDIST */
	0x0112: 2, /* CHIDIST */
	0x0113: 2, /* CHIINV */
	0x0114: 2, /* COMBIN */
	0x0115: 3, /* CONFIDENCE */
	0x0116: 3, /* CRITBINOM */
	0x0117: 1, /* EVEN */
	0x0118: 3, /* EXPONDIST */
	0x0119: 3, /* FDIST */
	0x011A: 3, /* FINV */
	0x011B: 1, /* FISHER */
	0x011C: 1, /* FISHERINV */
	0x011D: 2, /* FLOOR */
	0x011E: 4, /* GAMMADIST */
	0x011F: 3, /* GAMMAINV */
	0x0120: 2, /* CEILING */
	0x0121: 4, /* HYPGEOMDIST */
	0x0122: 3, /* LOGNORMDIST */
	0x0123: 3, /* LOGINV */
	0x0124: 3, /* NEGBINOMDIST */
	0x0125: 4, /* NORMDIST */
	0x0126: 1, /* NORMSDIST */
	0x0127: 3, /* NORMINV */
	0x0128: 1, /* NORMSINV */
	0x0129: 3, /* STANDARDIZE */
	0x012A: 1, /* ODD */
	0x012B: 2, /* PERMUT */
	0x012C: 3, /* POISSON */
	0x012D: 3, /* TDIST */
	0x012E: 4, /* WEIBULL */
	0x012F: 2, /* SUMXMY2 */
	0x0130: 2, /* SUMX2MY2 */
	0x0131: 2, /* SUMX2PY2 */
	0x0132: 2, /* CHITEST */
	0x0133: 2, /* CORREL */
	0x0134: 2, /* COVAR */
	0x0135: 3, /* FORECAST */
	0x0136: 2, /* FTEST */
	0x0137: 2, /* INTERCEPT */
	0x0138: 2, /* PEARSON */
	0x0139: 2, /* RSQ */
	0x013A: 2, /* STEYX */
	0x013B: 2, /* SLOPE */
	0x013C: 4, /* TTEST */
	0x0145: 2, /* LARGE */
	0x0146: 2, /* SMALL */
	0x0147: 2, /* QUARTILE */
	0x0148: 2, /* PERCENTILE */
	0x014B: 2, /* TRIMMEAN */
	0x014C: 2, /* TINV */
	0x0151: 2, /* POWER */
	0x0156: 1, /* RADIANS */
	0x0157: 1, /* DEGREES */
	0x015A: 2, /* COUNTIF */
	0x015B: 1, /* COUNTBLANK */
	0x015E: 4, /* ISPMT */
	0x015F: 3, /* DATEDIF */
	0x0160: 1, /* DATESTRING */
	0x0161: 2, /* NUMBERSTRING */
	0x0168: 1, /* PHONETIC */
	0x0170: 1, /* BAHTTEXT */
	0x0171: 1, /* THAIDAYOFWEEK */
	0x0172: 1, /* THAIDIGIT */
	0x0173: 1, /* THAIMONTHOFYEAR */
	0x0174: 1, /* THAINUMSOUND */
	0x0175: 1, /* THAINUMSTRING */
	0x0176: 1, /* THAISTRINGLENGTH */
	0x0177: 1, /* ISTHAIDIGIT */
	0x0178: 1, /* ROUNDBAHTDOWN */
	0x0179: 1, /* ROUNDBAHTUP */
	0x017A: 1, /* THAIYEAR */
	0x017E: 3, /* CUBEMEMBERPROPERTY */
	0x0181: 1, /* HEX2DEC */
	0x0188: 1, /* OCT2DEC */
	0x0189: 1, /* BIN2DEC */
	0x018C: 2, /* IMSUB */
	0x018D: 2, /* IMDIV */
	0x018E: 2, /* IMPOWER */
	0x018F: 1, /* IMABS */
	0x0190: 1, /* IMSQRT */
	0x0191: 1, /* IMLN */
	0x0192: 1, /* IMLOG2 */
	0x0193: 1, /* IMLOG10 */
	0x0194: 1, /* IMSIN */
	0x0195: 1, /* IMCOS */
	0x0196: 1, /* IMEXP */
	0x0197: 1, /* IMARGUMENT */
	0x0198: 1, /* IMCONJUGATE */
	0x0199: 1, /* IMAGINARY */
	0x019A: 1, /* IMREAL */
	0x019E: 4, /* SERIESSUM */
	0x019F: 1, /* FACTDOUBLE */
	0x01A0: 1, /* SQRTPI */
	0x01A1: 2, /* QUOTIENT */
	0x01A4: 1, /* ISEVEN */
	0x01A5: 1, /* ISODD */
	0x01A6: 2, /* MROUND */
	0x01A8: 1, /* ERFC */
	0x01A9: 2, /* BESSELJ */
	0x01AA: 2, /* BESSELK */
	0x01AB: 2, /* BESSELY */
	0x01AC: 2, /* BESSELI */
	0x01AE: 3, /* XNPV */
	0x01B6: 3, /* TBILLEQ */
	0x01B7: 3, /* TBILLPRICE */
	0x01B8: 3, /* TBILLYIELD */
	0x01BB: 2, /* DOLLARDE */
	0x01BC: 2, /* DOLLARFR */
	0x01BD: 2, /* NOMINAL */
	0x01BE: 2, /* EFFECT */
	0x01BF: 6, /* CUMPRINC */
	0x01C0: 6, /* CUMIPMT */
	0x01C1: 2, /* EDATE */
	0x01C2: 2, /* EOMONTH */
	0x01D0: 2, /* RANDBETWEEN */
	0x01D4: 3, /* CONVERT */
	0x01DC: 2, /* FVSCHEDULE */
	0x01DF: 1, /* CUBESETCOUNT */
	0x01E0: 2, /* IFERROR */
	0xFFFF: 0
	};
	/* [MS-XLSX] 2.2.3 Functions */
	/* [MS-XLSB] 2.5.97.10 Ftab */
	var XLSXFutureFunctions = {
		"_xlfn.ACOT": "ACOT",
		"_xlfn.ACOTH": "ACOTH",
		"_xlfn.AGGREGATE": "AGGREGATE",
		"_xlfn.ARABIC": "ARABIC",
		"_xlfn.AVERAGEIF": "AVERAGEIF",
		"_xlfn.AVERAGEIFS": "AVERAGEIFS",
		"_xlfn.BASE": "BASE",
		"_xlfn.BETA.DIST": "BETA.DIST",
		"_xlfn.BETA.INV": "BETA.INV",
		"_xlfn.BINOM.DIST": "BINOM.DIST",
		"_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
		"_xlfn.BINOM.INV": "BINOM.INV",
		"_xlfn.BITAND": "BITAND",
		"_xlfn.BITLSHIFT": "BITLSHIFT",
		"_xlfn.BITOR": "BITOR",
		"_xlfn.BITRSHIFT": "BITRSHIFT",
		"_xlfn.BITXOR": "BITXOR",
		"_xlfn.CEILING.MATH": "CEILING.MATH",
		"_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
		"_xlfn.CHISQ.DIST": "CHISQ.DIST",
		"_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
		"_xlfn.CHISQ.INV": "CHISQ.INV",
		"_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
		"_xlfn.CHISQ.TEST": "CHISQ.TEST",
		"_xlfn.COMBINA": "COMBINA",
		"_xlfn.CONCAT": "CONCAT",
		"_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
		"_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
		"_xlfn.COT": "COT",
		"_xlfn.COTH": "COTH",
		"_xlfn.COUNTIFS": "COUNTIFS",
		"_xlfn.COVARIANCE.P": "COVARIANCE.P",
		"_xlfn.COVARIANCE.S": "COVARIANCE.S",
		"_xlfn.CSC": "CSC",
		"_xlfn.CSCH": "CSCH",
		"_xlfn.DAYS": "DAYS",
		"_xlfn.DECIMAL": "DECIMAL",
		"_xlfn.ECMA.CEILING": "ECMA.CEILING",
		"_xlfn.ERF.PRECISE": "ERF.PRECISE",
		"_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
		"_xlfn.EXPON.DIST": "EXPON.DIST",
		"_xlfn.F.DIST": "F.DIST",
		"_xlfn.F.DIST.RT": "F.DIST.RT",
		"_xlfn.F.INV": "F.INV",
		"_xlfn.F.INV.RT": "F.INV.RT",
		"_xlfn.F.TEST": "F.TEST",
		"_xlfn.FILTERXML": "FILTERXML",
		"_xlfn.FLOOR.MATH": "FLOOR.MATH",
		"_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
		"_xlfn.FORECAST.ETS": "FORECAST.ETS",
		"_xlfn.FORECAST.ETS.CONFINT": "FORECAST.ETS.CONFINT",
		"_xlfn.FORECAST.ETS.SEASONALITY": "FORECAST.ETS.SEASONALITY",
		"_xlfn.FORECAST.ETS.STAT": "FORECAST.ETS.STAT",
		"_xlfn.FORECAST.LINEAR": "FORECAST.LINEAR",
		"_xlfn.FORMULATEXT": "FORMULATEXT",
		"_xlfn.GAMMA": "GAMMA",
		"_xlfn.GAMMA.DIST": "GAMMA.DIST",
		"_xlfn.GAMMA.INV": "GAMMA.INV",
		"_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
		"_xlfn.GAUSS": "GAUSS",
		"_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
		"_xlfn.IFERROR": "IFERROR",
		"_xlfn.IFNA": "IFNA",
		"_xlfn.IFS": "IFS",
		"_xlfn.IMCOSH": "IMCOSH",
		"_xlfn.IMCOT": "IMCOT",
		"_xlfn.IMCSC": "IMCSC",
		"_xlfn.IMCSCH": "IMCSCH",
		"_xlfn.IMSEC": "IMSEC",
		"_xlfn.IMSECH": "IMSECH",
		"_xlfn.IMSINH": "IMSINH",
		"_xlfn.IMTAN": "IMTAN",
		"_xlfn.ISFORMULA": "ISFORMULA",
		"_xlfn.ISO.CEILING": "ISO.CEILING",
		"_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
		"_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
		"_xlfn.LOGNORM.INV": "LOGNORM.INV",
		"_xlfn.MAXIFS": "MAXIFS",
		"_xlfn.MINIFS": "MINIFS",
		"_xlfn.MODE.MULT": "MODE.MULT",
		"_xlfn.MODE.SNGL": "MODE.SNGL",
		"_xlfn.MUNIT": "MUNIT",
		"_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
		"_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
		"_xlfn.NIGBINOM": "NIGBINOM",
		"_xlfn.NORM.DIST": "NORM.DIST",
		"_xlfn.NORM.INV": "NORM.INV",
		"_xlfn.NORM.S.DIST": "NORM.S.DIST",
		"_xlfn.NORM.S.INV": "NORM.S.INV",
		"_xlfn.NUMBERVALUE": "NUMBERVALUE",
		"_xlfn.PDURATION": "PDURATION",
		"_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
		"_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
		"_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
		"_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
		"_xlfn.PERMUTATIONA": "PERMUTATIONA",
		"_xlfn.PHI": "PHI",
		"_xlfn.POISSON.DIST": "POISSON.DIST",
		"_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
		"_xlfn.QUARTILE.INC": "QUARTILE.INC",
		"_xlfn.QUERYSTRING": "QUERYSTRING",
		"_xlfn.RANK.AVG": "RANK.AVG",
		"_xlfn.RANK.EQ": "RANK.EQ",
		"_xlfn.RRI": "RRI",
		"_xlfn.SEC": "SEC",
		"_xlfn.SECH": "SECH",
		"_xlfn.SHEET": "SHEET",
		"_xlfn.SHEETS": "SHEETS",
		"_xlfn.SKEW.P": "SKEW.P",
		"_xlfn.STDEV.P": "STDEV.P",
		"_xlfn.STDEV.S": "STDEV.S",
		"_xlfn.SUMIFS": "SUMIFS",
		"_xlfn.SWITCH": "SWITCH",
		"_xlfn.T.DIST": "T.DIST",
		"_xlfn.T.DIST.2T": "T.DIST.2T",
		"_xlfn.T.DIST.RT": "T.DIST.RT",
		"_xlfn.T.INV": "T.INV",
		"_xlfn.T.INV.2T": "T.INV.2T",
		"_xlfn.T.TEST": "T.TEST",
		"_xlfn.TEXTJOIN": "TEXTJOIN",
		"_xlfn.UNICHAR": "UNICHAR",
		"_xlfn.UNICODE": "UNICODE",
		"_xlfn.VAR.P": "VAR.P",
		"_xlfn.VAR.S": "VAR.S",
		"_xlfn.WEBSERVICE": "WEBSERVICE",
		"_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
		"_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
		"_xlfn.XOR": "XOR",
		"_xlfn.Z.TEST": "Z.TEST"
	};
	
	/* Part 3 TODO: actually parse formulae */
	function ods_to_csf_formula(f) {
		if(f.slice(0,3) == "of:") f = f.slice(3);
		/* 5.2 Basic Expressions */
		if(f.charCodeAt(0) == 61) {
			f = f.slice(1);
			if(f.charCodeAt(0) == 61) f = f.slice(1);
		}
		f = f.replace(/COM\.MICROSOFT\./g, "");
		/* Part 3 Section 5.8 References */
		f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
		/* TODO: something other than this */
		f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
		return f.replace(/[;~]/g,",").replace(/\|/g,";");
	}
	
	function csf_to_ods_formula(f) {
		var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
		/* TODO: something other than this */
		return o.replace(/;/g, "|").replace(/,/g,";");
	}
	
	function ods_to_csf_3D(r) {
		var a = r.split(":");
		var s = a[0].split(".")[0];
		return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
	}
	
	function csf_to_ods_3D(r) {
		return r.replace(/\./,"!");
	}
	
	var strs = {}; // shared strings
	var _ssfopts = {}; // spreadsheet formatting options
	
	RELS.WS = [
		"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
		"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
	];
	
	function get_sst_id(sst, str) {
		for(var i = 0, len = sst.length; i < len; ++i) if(sst[i].t === str) { sst.Count ++; return i; }
		sst[len] = {t:str}; sst.Count ++; sst.Unique ++; return len;
	}
	
	function col_obj_w(C, col) {
		var p = ({min:C+1,max:C+1});
		/* wch (chars), wpx (pixels) */
		var wch = -1;
		if(col.MDW) MDW = col.MDW;
		if(col.width != null) p.customWidth = 1;
		else if(col.wpx != null) wch = px2char(col.wpx);
		else if(col.wch != null) wch = col.wch;
		if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
		else if(col.width != null) p.width = col.width;
		if(col.hidden) p.hidden = true;
		return p;
	}
	
	function default_margins(margins, mode) {
		if(!margins) return;
		var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
		if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
		if(margins.left   == null) margins.left   = defs[0];
		if(margins.right  == null) margins.right  = defs[1];
		if(margins.top    == null) margins.top    = defs[2];
		if(margins.bottom == null) margins.bottom = defs[3];
		if(margins.header == null) margins.header = defs[4];
		if(margins.footer == null) margins.footer = defs[5];
	}
	
	function get_cell_style(styles, cell, opts) {
		var z = opts.revssf[cell.z != null ? cell.z : "General"];
		var i = 0x3c, len = styles.length;
		if(z == null && opts.ssf) {
			for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
				SSF.load(cell.z, i);
				// $FlowIgnore
				opts.ssf[i] = cell.z;
				opts.revssf[cell.z] = z = i;
				break;
			}
		}
		for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
		styles[len] = {
			numFmtId:z,
			fontId:0,
			fillId:0,
			borderId:0,
			xfId:0,
			applyNumberFormat:1
		};
		return len;
	}
	
	function safe_format(p, fmtid, fillid, opts, themes, styles) {
		if(p.t === 'z') return;
		if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
		try {
			if(opts.cellNF) p.z = SSF._table[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts || opts.cellText !== false) try {
			if(p.t === 'e') p.w = p.w || BErr[p.v];
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
					else p.w = SSF._general_num(p.v);
				}
				else if(p.t === 'd') {
					var dd = datenum(p.v);
					if((dd|0) === dd) p.w = SSF._general_int(dd);
					else p.w = SSF._general_num(dd);
				}
				else if(p.v === undefined) return "";
				else p.w = SSF._general(p.v,_ssfopts);
			}
			else if(p.t === 'd') p.w = SSF.format(fmtid,datenum(p.v),_ssfopts);
			else p.w = SSF.format(fmtid,p.v,_ssfopts);
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts.cellStyles) return;
		if(fillid != null) try {
			p.s = styles.Fills[fillid];
			if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
				p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
				if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
			}
			if (p.s.bgColor && p.s.bgColor.theme) {
				p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
				if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
			}
		} catch(e) { if(opts.WTF && styles.Fills) throw e; }
	}
	function parse_ws_xml_dim(ws, s) {
		var d = safe_decode_range(s);
		if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
	}
	var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
	var sheetdataregex = /<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/;
	var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
	var dimregex = /"(\w*:\w*)"/;
	var colregex = /<(?:\w:)?col[^>]*[\/]?>/g;
	var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
	var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
	var sheetprregex = /<(?:\w:)?sheetPr(?:[^>a-z][^>]*)?\/>/;
	var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
	/* 18.3 Worksheets */
	function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	
		/* 18.3.1.99 worksheet CT_Worksheet */
		var s = opts.dense ? ([]) : ({});
		var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });
	
		var data1 = "", data2 = "";
		var mtch = data.match(sheetdataregex);
		if(mtch) {
			data1 = data.slice(0, mtch.index);
			data2 = data.slice(mtch.index + mtch[0].length);
		} else data1 = data2 = data;
	
		/* 18.3.1.82 sheetPr CT_SheetPr */
		var sheetPr = data1.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.35 dimension CT_SheetDimension */
		// $FlowIgnore
		var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
		if(ridx > 0) {
			var ref = data1.slice(ridx,ridx+50).match(dimregex);
			if(ref) parse_ws_xml_dim(s, ref[1]);
		}
	
		/* 18.3.1.88 sheetViews CT_SheetViews */
		var svs = data1.match(svsregex);
		if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
	
		/* 18.3.1.17 cols CT_Cols */
		var columns = [];
		if(opts.cellStyles) {
			/* 18.3.1.13 col CT_Col */
			var cols = data1.match(colregex);
			if(cols) parse_ws_xml_cols(columns, cols);
		}
	
		/* 18.3.1.80 sheetData CT_SheetData ? */
		if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
	
		/* 18.3.1.2  autoFilter CT_AutoFilter */
		var afilter = data2.match(afregex);
		if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);
	
		/* 18.3.1.55 mergeCells CT_MergeCells */
		var merges = [];
		var _merge = data2.match(mergecregex);
		if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
			merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));
	
		/* 18.3.1.48 hyperlinks CT_Hyperlinks */
		var hlink = data2.match(hlinkregex);
		if(hlink) parse_ws_xml_hlinks(s, hlink, rels);
	
		/* 18.3.1.62 pageMargins CT_PageMargins */
		var margins = data2.match(marginregex);
		if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));
	
		if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
		if(opts.sheetRows > 0 && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows < +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(columns.length > 0) s["!cols"] = columns;
		if(merges.length > 0) s["!merges"] = merges;
		return s;
	}
	
	function write_ws_xml_merges(merges) {
		if(merges.length === 0) return "";
		var o = '<mergeCells count="' + merges.length + '">';
		for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
		return o + '</mergeCells>';
	}
	
	/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
	function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
		var data = parsexmltag(sheetPr);
		if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
		if(data.codeName) wb.Sheets[idx].CodeName = data.codeName;
	}
	
	/* 18.3.1.85 sheetProtection CT_SheetProtection */
	function write_ws_xml_protection(sp) {
		// algorithmName, hashValue, saltValue, spinCountpassword
		var o = ({sheet:1});
		var deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
		var deftrue = [
			"formatColumns", "formatRows", "formatCells",
			"insertColumns", "insertRows", "insertHyperlinks",
			"deleteColumns", "deleteRows",
			"sort", "autoFilter", "pivotTables"
		];
		deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
		deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
		/* TODO: algorithm */
		if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
		return writextag('sheetProtection', null, o);
	}
	
	function parse_ws_xml_hlinks(s, data, rels) {
		var dense = Array.isArray(s);
		for(var i = 0; i != data.length; ++i) {
			var val = parsexmltag(utf8read(data[i]), true);
			if(!val.ref) return;
			var rel = ((rels || {})['!id']||[])[val.id];
			if(rel) {
				val.Target = rel.Target;
				if(val.location) val.Target += "#"+val.location;
			} else {
				val.Target = "#" + val.location;
				rel = {Target: val.Target, TargetMode: 'Internal'};
			}
			val.Rel = rel;
			if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
			var rng = safe_decode_range(val.ref);
			for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
				var addr = encode_cell({c:C,r:R});
				if(dense) {
					if(!s[R]) s[R] = [];
					if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
					s[R][C].l = val;
				} else {
					if(!s[addr]) s[addr] = {t:"z",v:undefined};
					s[addr].l = val;
				}
			}
		}
	}
	
	function parse_ws_xml_margins(margin) {
		var o = {};
		["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
			if(margin[k]) o[k] = parseFloat(margin[k]);
		});
		return o;
	}
	function write_ws_xml_margins(margin) {
		default_margins(margin);
		return writextag('pageMargins', null, margin);
	}
	
	function parse_ws_xml_cols(columns, cols) {
		var seencol = false;
		for(var coli = 0; coli != cols.length; ++coli) {
			var coll = parsexmltag(cols[coli], true);
			if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
			var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
			delete coll.min; delete coll.max; coll.width = +coll.width;
			if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
			process_col(coll);
			while(colm <= colM) columns[colm++] = dup(coll);
		}
	}
	
	function write_ws_xml_cols(ws, cols) {
		var o = ["<cols>"], col;
		for(var i = 0; i != cols.length; ++i) {
			if(!(col = cols[i])) continue;
			o[o.length] = (writextag('col', null, col_obj_w(i, col)));
		}
		o[o.length] = "</cols>";
		return o.join("");
	}
	
	function parse_ws_xml_autofilter(data) {
		var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
		return o;
	}
	function write_ws_xml_autofilter(data) {
		return writextag("autoFilter", null, {ref:data.ref});
	}
	
	/* 18.3.1.88 sheetViews CT_SheetViews */
	/* 18.3.1.87 sheetView CT_SheetView */
	var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/>/;
	function parse_ws_xml_sheetviews(data, wb) {
		(data.match(sviewregex)||[]).forEach(function(r) {
			var tag = parsexmltag(r);
			if(parsexmlbool(tag.rightToLeft)) {
				if(!wb.Views) wb.Views = [{}];
				if(!wb.Views[0]) wb.Views[0] = {};
				wb.Views[0].RTL = true;
			}
		});
	}
	function write_ws_xml_sheetviews(ws, opts, idx, wb) {
		var sview = {workbookViewId:"0"};
		// $FlowIgnore
		if( (((wb||{}).Workbook||{}).Views||[])[0] ) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
		return writextag("sheetViews", writextag("sheetView", null, sview), {});
	}
	
	function write_ws_xml_cell(cell, ref, ws, opts) {
		if(cell.v === undefined && cell.f === undefined || cell.t === 'z') return "";
		var vv = "";
		var oldt = cell.t, oldv = cell.v;
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'n': vv = ''+cell.v; break;
			case 'e': vv = BErr[cell.v]; break;
			case 'd':
				if(opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
				else {
					cell = dup(cell);
					cell.t = 'n';
					vv = ''+(cell.v = datenum(parseDate(cell.v)));
				}
				if(typeof cell.z === 'undefined') cell.z = SSF._table[14];
				break;
			default: vv = cell.v; break;
		}
		var v = writetag('v', escapexml(vv)), o = ({r:ref});
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		if(os !== 0) o.s = os;
		switch(cell.t) {
			case 'n': break;
			case 'd': o.t = "d"; break;
			case 'b': o.t = "b"; break;
			case 'e': o.t = "e"; break;
			default: if(cell.v == null) { delete cell.t; break; }
				if(opts.bookSST) {
					v = writetag('v', ''+get_sst_id(opts.Strings, cell.v));
					o.t = "s"; break;
				}
				o.t = "str"; break;
		}
		if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
		if(cell.f) {
			var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
			v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
		}
		if(cell.l) ws['!links'].push([ref, cell.l]);
		if(cell.c) ws['!comments'].push([ref, cell.c]);
		return writextag('c', v, o);
	}
	
	var parse_ws_xml_data = (function() {
		var cellregex = /<(?:\w+:)?c[ >]/, rowregex = /<\/(?:\w+:)?row>/;
		var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
		var refregex = /ref=["']([^"']*)["']/;
		var match_v = matchtag("v"), match_f = matchtag("f");
	
	return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
		var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
		var tag, tagr = 0, tagc = 0;
		var sstr, ftag;
		var fmtid = 0, fillid = 0;
		var do_format = Array.isArray(styles.CellXf), cf;
		var arrayf = [];
		var sharedf = [];
		var dense = Array.isArray(s);
		var rows = [], rowobj = {}, rowrite = false;
		for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
			x = marr[mt].trim();
			var xlen = x.length;
			if(xlen === 0) continue;
	
			/* 18.3.1.73 row CT_Row */
			for(ri = 0; ri < xlen; ++ri) if(x.charCodeAt(ri) === 62) break; ++ri;
			tag = parsexmltag(x.slice(0,ri), true);
			tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
			if(opts.sheetRows && opts.sheetRows < tagr) continue;
			if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
			if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;
	
			if(opts && opts.cellStyles) {
				rowobj = {}; rowrite = false;
				if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
				if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
				if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
				if(rowrite) rows[tagr-1] = rowobj;
			}
	
			/* 18.3.1.4 c CT_Cell */
			cells = x.slice(ri).split(cellregex);
			for(ri = 0; ri != cells.length; ++ri) {
				x = cells[ri].trim();
				if(x.length === 0) continue;
				cref = x.match(rregex); idx = ri; i=0; cc=0;
				x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
				if(cref != null && cref.length === 2) {
					idx = 0; d=cref[1];
					for(i=0; i != d.length; ++i) {
						if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
						idx = 26*idx + cc;
					}
					--idx;
					tagc = idx;
				} else ++tagc;
				for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
				tag = parsexmltag(x.slice(0,i), true);
				if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
				d = x.slice(i);
				p = ({t:""});
	
				if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
				if(opts.cellFormula) {
					if((cref=d.match(match_f))!= null && cref[1] !== '') {
						/* TODO: match against XLSXFutureFunctions */
						p.f=_xlfn(unescapexml(utf8read(cref[1])));
						if(cref[0].indexOf('t="array"') > -1) {
							p.F = (d.match(refregex)||[])[1];
							if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
						} else if(cref[0].indexOf('t="shared"') > -1) {
							// TODO: parse formula
							ftag = parsexmltag(cref[0]);
							sharedf[parseInt(ftag.si, 10)] = [ftag, _xlfn(unescapexml(utf8read(cref[1])))];
						}
					} else if((cref=d.match(/<f[^>]*\/>/))) {
						ftag = parsexmltag(cref[0]);
						if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][0].ref, tag.r);
					}
					/* TODO: factor out contains logic */
					var _tag = decode_cell(tag.r);
					for(i = 0; i < arrayf.length; ++i)
						if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
							if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
								p.F = arrayf[i][1];
				}
	
				if(tag.t == null && p.v === undefined) {
					if(p.f || p.F) {
						p.v = 0; p.t = "n";
					} else if(!opts.sheetStubs) continue;
					else p.t = "z";
				}
				else p.t = tag.t || "n";
				if(guess.s.c > idx) guess.s.c = idx;
				if(guess.e.c < idx) guess.e.c = idx;
				/* 18.18.11 t ST_CellType */
				switch(p.t) {
					case 'n':
						if(p.v == "" || p.v == null) {
							if(!opts.sheetStubs) continue;
							p.t = 'z';
						} else p.v = parseFloat(p.v);
						break;
					case 's':
						if(typeof p.v == 'undefined') {
							if(!opts.sheetStubs) continue;
							p.t = 'z';
						} else {
							sstr = strs[parseInt(p.v, 10)];
							p.v = sstr.t;
							p.r = sstr.r;
							if(opts.cellHTML) p.h = sstr.h;
						}
						break;
					case 'str':
						p.t = "s";
						p.v = (p.v!=null) ? utf8read(p.v) : '';
						if(opts.cellHTML) p.h = escapehtml(p.v);
						break;
					case 'inlineStr':
						cref = d.match(isregex);
						p.t = 's';
						if(cref != null && (sstr = parse_si(cref[1]))) p.v = sstr.t; else p.v = "";
						break;
					case 'b': p.v = parsexmlbool(p.v); break;
					case 'd':
						if(opts.cellDates) p.v = parseDate(p.v, 1);
						else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
						break;
					/* error string in .w, number in .v */
					case 'e':
						if(!opts || opts.cellText !== false) p.w = p.v;
						p.v = RBErr[p.v]; break;
				}
				/* formatting */
				fmtid = fillid = 0;
				if(do_format && tag.s !== undefined) {
					cf = styles.CellXf[tag.s];
					if(cf != null) {
						if(cf.numFmtId != null) fmtid = cf.numFmtId;
						if(opts.cellStyles) {
							if(cf.fillId != null) fillid = cf.fillId;
						}
					}
				}
				safe_format(p, fmtid, fillid, opts, themes, styles);
				if(opts.cellDates && do_format && p.t == 'n' && SSF.is_date(SSF._table[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
				if(dense) {
					var _r = decode_cell(tag.r);
					if(!s[_r.r]) s[_r.r] = [];
					s[_r.r][_r.c] = p;
				} else s[tag.r] = p;
			}
		}
		if(rows.length > 0) s['!rows'] = rows;
	}; })();
	
	function write_ws_xml_data(ws, opts, idx, wb) {
		var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
		var dense = Array.isArray(ws);
		var params = ({r:rr}), row, height = -1;
		for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
		for(R = range.s.r; R <= range.e.r; ++R) {
			r = [];
			rr = encode_row(R);
			for(C = range.s.c; C <= range.e.c; ++C) {
				ref = cols[C] + rr;
				var _cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(_cell === undefined) continue;
				if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
			}
			if(r.length > 0 || rows && rows[R]) {
				params = ({r:rr});
				if(rows && rows[R]) {
					row = rows[R];
					if(row.hidden) params.hidden = 1;
					height = -1;
					if (row.hpx) height = px2pt(row.hpx);
					else if (row.hpt) height = row.hpt;
					if (height > -1) { params.ht = height; params.customHeight = 1; }
					if (row.level) { params.outlineLevel = row.level; }
				}
				o[o.length] = (writextag('row', r.join(""), params));
			}
		}
		if(rows) for(; R < rows.length; ++R) {
			if(rows && rows[R]) {
				params = ({r:R+1});
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
				o[o.length] = (writextag('row', "", params));
			}
		}
		return o.join("");
	}
	
	var WS_XML_ROOT = writextag('worksheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	function write_ws_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, WS_XML_ROOT];
		var s = wb.SheetNames[idx], sidx = 0, rdata = "";
		var ws = wb.Sheets[s];
		if(ws == null) ws = {};
		var ref = ws['!ref']; if(ref == null) ref = 'A1';
		if(!rels) rels = {};
		ws['!comments'] = [];
		ws['!drawing'] = [];
	
		var cname = wb.SheetNames[idx];
		try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
		o[o.length] = (writextag('sheetPr', null, {'codeName': escapexml(cname)}));
	
		o[o.length] = (writextag('dimension', null, {'ref': ref}));
	
		o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
	
		/* TODO: store in WB, process styles */
		if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
			defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
			baseColWidth:opts.sheetFormat.baseColWidth||'10',
			outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
		}));
	
		if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));
	
		o[sidx = o.length] = '<sheetData/>';
		ws['!links'] = [];
		if(ws['!ref'] != null) {
			rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
			if(rdata.length > 0) o[o.length] = (rdata);
		}
		if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }
	
		/* sheetCalcPr */
	
		if(ws['!protect'] != null) o[o.length] = write_ws_xml_protection(ws['!protect']);
	
		/* protectedRanges */
		/* scenarios */
	
		if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter']);
	
		/* sortState */
		/* dataConsolidate */
		/* customSheetViews */
	
		if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));
	
		/* phoneticPr */
		/* conditionalFormatting */
		/* dataValidations */
	
		var relc = -1, rel, rId = -1;
		if(ws['!links'].length > 0) {
			o[o.length] = "<hyperlinks>";
			ws['!links'].forEach(function(l) {
				if(!l[1].Target) return;
				rel = ({"ref":l[0]});
				if(l[1].Target.charAt(0) != "#") {
					rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
					rel["r:id"] = "rId"+rId;
				}
				if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
				if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
				o[o.length] = writextag("hyperlink",null,rel);
			});
			o[o.length] = "</hyperlinks>";
		}
		delete ws['!links'];
	
		/* printOptions */
		if (ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
		/* pageSetup */
	
		//var hfidx = o.length;
		o[o.length] = "";
	
		/* rowBreaks */
		/* colBreaks */
		/* customProperties */
		/* cellWatches */
		/* ignoredErrors */
		/* smartTags */
	
		if(ws['!drawing'].length > 0) {
			rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
			o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
		}
		else delete ws['!drawing'];
	
		if(ws['!comments'].length > 0) {
			rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
			ws['!legacy'] = rId;
		}
	
		/* drawingHF */
		/* picture */
		/* oleObjects */
		/* controls */
		/* webPublishItems */
		/* tableParts */
		/* extList */
	
		if(o.length>2) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.718 BrtRowHdr */
	function parse_BrtRowHdr(data, length) {
		var z = ({});
		var tgt = data.l + length;
		z.r = data.read_shift(4);
		data.l += 4; // TODO: ixfe
		var miyRw = data.read_shift(2);
		data.l += 1; // TODO: top/bot padding
		var flags = data.read_shift(1);
		data.l = tgt;
		if(flags & 0x07) z.level = flags & 0x07;
		if(flags & 0x10) z.hidden = true;
		if(flags & 0x20) z.hpt = miyRw / 20;
		return z;
	}
	function write_BrtRowHdr(R, range, ws) {
		var o = new_buf(17+8*16);
		var row = (ws['!rows']||[])[R]||{};
		o.write_shift(4, R);
	
		o.write_shift(4, 0); /* TODO: ixfe */
	
		var miyRw = 0x0140;
		if(row.hpx) miyRw = px2pt(row.hpx) * 20;
		else if(row.hpt) miyRw = row.hpt * 20;
		o.write_shift(2, miyRw);
	
		o.write_shift(1, 0); /* top/bot padding */
	
		var flags = 0x0;
		if(row.level) flags |= row.level;
		if(row.hidden) flags |= 0x10;
		if(row.hpx || row.hpt) flags |= 0x20;
		o.write_shift(1, flags);
	
		o.write_shift(1, 0); /* phonetic guide */
	
		/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
		var ncolspan = 0, lcs = o.l;
		o.l += 4;
	
		var caddr = {r:R, c:0};
		for(var i = 0; i < 16; ++i) {
			if(range.s.c > ((i+1) << 10) || range.e.c < (i << 10)) continue;
			var first = -1, last = -1;
			for(var j = (i<<10); j < ((i+1)<<10); ++j) {
				caddr.c = j;
				var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
				if(cell) { if(first < 0) first = j; last = j; }
			}
			if(first < 0) continue;
			++ncolspan;
			o.write_shift(4, first);
			o.write_shift(4, last);
		}
	
		var l = o.l;
		o.l = lcs;
		o.write_shift(4, ncolspan);
		o.l = l;
	
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function write_row_header(ba, ws, range, R) {
		var o = write_BrtRowHdr(R, range, ws);
		if(o.length > 17 || (ws['!rows']||[])[R]) write_record(ba, 'BrtRowHdr', o);
	}
	
	/* [MS-XLSB] 2.4.812 BrtWsDim */
	var parse_BrtWsDim = parse_UncheckedRfX;
	var write_BrtWsDim = write_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.813 BrtWsFmtInfo */
	function parse_BrtWsFmtInfo() {
	}
	//function write_BrtWsFmtInfo(ws, o) { }
	
	/* [MS-XLSB] 2.4.815 BrtWsProp */
	function parse_BrtWsProp(data, length) {
		var z = {};
		/* TODO: pull flags */
		data.l += 19;
		z.name = parse_XLSBCodeName(data, length - 19);
		return z;
	}
	function write_BrtWsProp(str, o) {
		if(o == null) o = new_buf(84+4*str.length);
		for(var i = 0; i < 3; ++i) o.write_shift(1,0);
		write_BrtColor({auto:1}, o);
		o.write_shift(-4,-1);
		o.write_shift(-4,-1);
		write_XLSBCodeName(str, o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.303 BrtCellBlank */
	function parse_BrtCellBlank(data) {
		var cell = parse_XLSBCell(data);
		return [cell];
	}
	function write_BrtCellBlank(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		return write_XLSBCell(ncell, o);
	}
	
	
	/* [MS-XLSB] 2.4.304 BrtCellBool */
	function parse_BrtCellBool(data) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtCellBool(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.305 BrtCellError */
	function parse_BrtCellError(data) {
		var cell = parse_XLSBCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	
	/* [MS-XLSB] 2.4.308 BrtCellIsst */
	function parse_BrtCellIsst(data) {
		var cell = parse_XLSBCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtCellIsst(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	
	/* [MS-XLSB] 2.4.310 BrtCellReal */
	function parse_BrtCellReal(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellReal(cell, ncell, o) {
		if(o == null) o = new_buf(16);
		write_XLSBCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.311 BrtCellRk */
	function parse_BrtCellRk(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellRk(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	
	
	/* [MS-XLSB] 2.4.314 BrtCellSt */
	function parse_BrtCellSt(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtCellSt(cell, ncell, o) {
		if(o == null) o = new_buf(12 + 4 * cell.v.length);
		write_XLSBCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.647 BrtFmlaBool */
	function parse_BrtFmlaBool(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'b'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.648 BrtFmlaError */
	function parse_BrtFmlaError(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'e'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.649 BrtFmlaNum */
	function parse_BrtFmlaNum(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_Xnum(data);
		var o = [cell, value, 'n'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.650 BrtFmlaString */
	function parse_BrtFmlaString(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_XLWideString(data);
		var o = [cell, value, 'str'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.676 BrtMergeCell */
	var parse_BrtMergeCell = parse_UncheckedRfX;
	var write_BrtMergeCell = write_UncheckedRfX;
	/* [MS-XLSB] 2.4.108 BrtBeginMergeCells */
	function write_BrtBeginMergeCells(cnt, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(4, cnt);
		return o;
	}
	
	/* [MS-XLSB] 2.4.656 BrtHLink */
	function parse_BrtHLink(data, length) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var relId = parse_XLNullableWideString(data);
		var loc = parse_XLWideString(data);
		var tooltip = parse_XLWideString(data);
		var display = parse_XLWideString(data);
		data.l = end;
		var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
		if(tooltip) o.Tooltip = tooltip;
		return o;
	}
	function write_BrtHLink(l, rId) {
		var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
		write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
		write_RelID("rId" + rId, o);
		var locidx = l[1].Target.indexOf("#");
		var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
		write_XLWideString(loc || "", o);
		write_XLWideString(l[1].Tooltip || "", o);
		write_XLWideString("", o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.6 BrtArrFmla */
	function parse_BrtArrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_RfX(data, 16);
		var fAlwaysCalc = data.read_shift(1);
		var o = [rfx]; o[2] = fAlwaysCalc;
		if(opts.cellFormula) {
			var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
			o[1] = formula;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.742 BrtShrFmla */
	function parse_BrtShrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var o = [rfx];
		if(opts.cellFormula) {
			var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
			o[1] = formula;
			data.l = end;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtColInfo */
	/* TODO: once XLS ColInfo is set, combine the functions */
	function write_BrtColInfo(C, col, o) {
		if(o == null) o = new_buf(18);
		var p = col_obj_w(C, col);
		o.write_shift(-4, C);
		o.write_shift(-4, C);
		o.write_shift(4, (p.width || 10) * 256);
		o.write_shift(4, 0/*ixfe*/); // style
		var flags = 0;
		if(col.hidden) flags |= 0x01;
		if(typeof p.width == 'number') flags |= 0x02;
		o.write_shift(1, flags); // bit flag
		o.write_shift(1, 0); // bit flag
		return o;
	}
	
	/* [MS-XLSB] 2.4.672 BrtMargins */
	var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
	function parse_BrtMargins(data) {
		var margins = ({});
		BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
		return margins;
	}
	function write_BrtMargins(margins, o) {
		if(o == null) o = new_buf(6*8);
		default_margins(margins);
		BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
		return o;
	}
	
	/* [MS-XLSB] 2.4.292 BrtBeginWsView */
	function parse_BrtBeginWsView(data) {
		var f = data.read_shift(2);
		data.l += 28;
		return { RTL: f & 0x20 };
	}
	function write_BrtBeginWsView(ws, Workbook, o) {
		if(o == null) o = new_buf(30);
		var f = 0x39c;
		// $FlowIgnore
		if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
		o.write_shift(2, f); // bit flag
		o.write_shift(4, 0);
		o.write_shift(4, 0); // view first row
		o.write_shift(4, 0); // view first col
		o.write_shift(1, 0); // gridline color ICV
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 100); // zoom scale
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0); // workbook view id
		return o;
	}
	
	/* [MS-XLSB] 2.4.740 BrtSheetProtection */
	function write_BrtSheetProtection(sp, o) {
		if(o == null) o = new_buf(16*4+2);
		o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
		o.write_shift(4, 1); // this record should not be written if no protection
		[
			["objects",             false], // fObjects
			["scenarios",           false], // fScenarios
			["formatCells",          true], // fFormatCells
			["formatColumns",        true], // fFormatColumns
			["formatRows",           true], // fFormatRows
			["insertColumns",        true], // fInsertColumns
			["insertRows",           true], // fInsertRows
			["insertHyperlinks",     true], // fInsertHyperlinks
			["deleteColumns",        true], // fDeleteColumns
			["deleteRows",           true], // fDeleteRows
			["selectLockedCells",   false], // fSelLockedCells
			["sort",                 true], // fSort
			["autoFilter",           true], // fAutoFilter
			["pivotTables",          true], // fPivotTables
			["selectUnlockedCells", false]  // fSelUnlockedCells
		].forEach(function(n) {
	if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
			else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
		});
		return o;
	}
	
	/* [MS-XLSB] 2.1.7.61 Worksheet */
	function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		var opts = _opts || {};
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var s = (opts.dense ? [] : {});
	
		var ref;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		var pass = false, end = false;
		var row, p, cf, R, C, addr, sstr, rr, cell;
		var merges = [];
		opts.biff = 12;
		opts['!row'] = 0;
	
		var ai = 0, af = false;
	
		var arrayf = [];
		var sharedf = {};
		var supbooks = opts.supbooks || ([[]]);
		supbooks.sharedf = sharedf;
		supbooks.arrayf = arrayf;
		supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
		if(!opts.supbooks) {
			opts.supbooks = supbooks;
			if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
		}
	
		var colinfo = [], rowinfo = [];
		var seencol = false;
	
		recordhopper(data, function ws_parse(val, R_n, RT) {
			if(end) return;
			switch(RT) {
				case 0x0094: /* 'BrtWsDim' */
					ref = val; break;
				case 0x0000: /* 'BrtRowHdr' */
					row = val;
					if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
					rr = encode_row(R = row.r);
					opts['!row'] = row.r;
					if(val.hidden || val.hpt || val.level != null) {
						if(val.hpt) val.hpx = pt2px(val.hpt);
						rowinfo[val.r] = val;
					}
					break;
	
				case 0x0002: /* 'BrtCellRk' */
				case 0x0003: /* 'BrtCellError' */
				case 0x0004: /* 'BrtCellBool' */
				case 0x0005: /* 'BrtCellReal' */
				case 0x0006: /* 'BrtCellSt' */
				case 0x0007: /* 'BrtCellIsst' */
				case 0x0008: /* 'BrtFmlaString' */
				case 0x0009: /* 'BrtFmlaNum' */
				case 0x000A: /* 'BrtFmlaBool' */
				case 0x000B: /* 'BrtFmlaError' */
					p = ({t:val[2]});
					switch(val[2]) {
						case 'n': p.v = val[1]; break;
						case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
						case 'b': p.v = val[1] ? true : false; break;
						case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
						case 'str': p.t = 's'; p.v = val[1]; break;
					}
					if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
					C = val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(opts.cellFormula) {
						af = false;
						for(ai = 0; ai < arrayf.length; ++ai) {
							var aii = arrayf[ai];
							if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
								if(C >= aii[0].s.c && C <= aii[0].e.c) {
									p.F = encode_range(aii[0]); af = true;
								}
						}
						if(!af && val.length > 3) p.f = val[3];
					}
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(opts.cellDates && cf && p.t == 'n' && SSF.is_date(SSF._table[cf.numFmtId])) {
						var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
					}
					break;
	
				case 0x0001: /* 'BrtCellBlank' */
					if(!opts.sheetStubs || pass) break;
					p = ({t:'z',v:undefined});
					C = val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					break;
	
				case 0x00B0: /* 'BrtMergeCell' */
					merges.push(val); break;
	
				case 0x01EE: /* 'BrtHLink' */
					var rel = rels['!id'][val.relId];
					if(rel) {
						val.Target = rel.Target;
						if(val.loc) val.Target += "#"+val.loc;
						val.Rel = rel;
					} else if(val.relId == '') {
						val.Target = "#" + val.loc;
					}
					for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
						if(opts.dense) {
							if(!s[R]) s[R] = [];
							if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
							s[R][C].l = val;
						} else {
							addr = encode_cell({c:C,r:R});
							if(!s[addr]) s[addr] = {t:'z',v:undefined};
							s[addr].l = val;
						}
					}
					break;
	
				case 0x01AA: /* 'BrtArrFmla' */
					if(!opts.cellFormula) break;
					arrayf.push(val);
					cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					cell.F = encode_range(val[0]);
					break;
				case 0x01AB: /* 'BrtShrFmla' */
					if(!opts.cellFormula) break;
					sharedf[encode_cell(val[0].s)] = val[1];
					cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					break;
	
				/* identical to 'ColInfo' in XLS */
				case 0x003C: /* 'BrtColInfo' */
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01) };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
					break;
	
				case 0x00A1: /* 'BrtBeginAFilter' */
					s['!autofilter'] = { ref:encode_range(val) };
					break;
	
				case 0x01DC: /* 'BrtMargins' */
					s['!margins'] = val;
					break;
	
				case 0x0093: /* 'BrtWsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				case 0x0089: /* 'BrtBeginWsView' */
					if(!wb.Views) wb.Views = [{}];
					if(!wb.Views[0]) wb.Views[0] = {};
					if(val.RTL) wb.Views[0].RTL = true;
					break;
	
				case 0x01E5: /* 'BrtWsFmtInfo' */
					break;
				/* case 'BrtUid' */
				case 0x00AF: /* 'BrtAFilterDateGroupItem' */
				case 0x0284: /* 'BrtActiveX' */
				case 0x0271: /* 'BrtBigName' */
				case 0x0232: /* 'BrtBkHim' */
				case 0x018C: /* 'BrtBrk' */
				case 0x0458: /* 'BrtCFIcon' */
				case 0x047A: /* 'BrtCFRuleExt' */
				case 0x01D7: /* 'BrtCFVO' */
				case 0x041A: /* 'BrtCFVO14' */
				case 0x0289: /* 'BrtCellIgnoreEC' */
				case 0x0451: /* 'BrtCellIgnoreEC14' */
				case 0x0031: /* 'BrtCellMeta' */
				case 0x024D: /* 'BrtCellSmartTagProperty' */
				case 0x025F: /* 'BrtCellWatch' */
				case 0x0234: /* 'BrtColor' */
				case 0x041F: /* 'BrtColor14' */
				case 0x00A8: /* 'BrtColorFilter' */
				case 0x00AE: /* 'BrtCustomFilter' */
				case 0x049C: /* 'BrtCustomFilter14' */
				case 0x01F3: /* 'BrtDRef' */
				case 0x0040: /* 'BrtDVal' */
				case 0x041D: /* 'BrtDVal14' */
				case 0x0226: /* 'BrtDrawing' */
				case 0x00AB: /* 'BrtDynamicFilter' */
				case 0x00A7: /* 'BrtFilter' */
				case 0x0499: /* 'BrtFilter14' */
				case 0x00A9: /* 'BrtIconFilter' */
				case 0x049D: /* 'BrtIconFilter14' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x0295: /* 'BrtListPart' */
				case 0x027F: /* 'BrtOleObject' */
				case 0x01DE: /* 'BrtPageSetup' */
				case 0x0097: /* 'BrtPane' */
				case 0x0219: /* 'BrtPhoneticInfo' */
				case 0x01DD: /* 'BrtPrintOptions' */
				case 0x0218: /* 'BrtRangeProtection' */
				case 0x044F: /* 'BrtRangeProtection14' */
				case 0x02A8: /* 'BrtRangeProtectionIso' */
				case 0x0450: /* 'BrtRangeProtectionIso14' */
				case 0x0400: /* 'BrtRwDescent' */
				case 0x0098: /* 'BrtSel' */
				case 0x0297: /* 'BrtSheetCalcProp' */
				case 0x0217: /* 'BrtSheetProtection' */
				case 0x02A6: /* 'BrtSheetProtectionIso' */
				case 0x01F8: /* 'BrtSlc' */
				case 0x0413: /* 'BrtSparkline' */
				case 0x01AC: /* 'BrtTable' */
				case 0x00AA: /* 'BrtTop10Filter' */
				case 0x0032: /* 'BrtValueMeta' */
				case 0x0816: /* 'BrtWebExtension' */
				case 0x0415: /* 'BrtWsFmtInfoEx14' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		delete opts.supbooks;
		delete opts['!row'];
	
		if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
		if(opts.sheetRows && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows < +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(merges.length > 0) s["!merges"] = merges;
		if(colinfo.length > 0) s["!cols"] = colinfo;
		if(rowinfo.length > 0) s["!rows"] = rowinfo;
		return s;
	}
	
	/* TODO: something useful -- this is a stub */
	function write_ws_bin_cell(ba, cell, R, C, opts, ws) {
		if(cell.v === undefined) return "";
		var vv = "";
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'd': // no BrtCellDate :(
				cell = dup(cell);
				cell.z = cell.z || SSF._table[14];
				cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
				break;
			/* falls through */
			case 'n': case 'e': vv = ''+cell.v; break;
			default: vv = cell.v; break;
		}
		var o = ({r:R, c:C});
		/* TODO: cell style */
		o.s = get_cell_style(opts.cellXfs, cell, opts);
		if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
		if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
		switch(cell.t) {
			case 's': case 'str':
				if(opts.bookSST) {
					vv = get_sst_id(opts.Strings, (cell.v));
					o.t = "s"; o.v = vv;
					write_record(ba, "BrtCellIsst", write_BrtCellIsst(cell, o));
				} else {
					o.t = "str";
					write_record(ba, "BrtCellSt", write_BrtCellSt(cell, o));
				}
				return;
			case 'n':
				/* TODO: determine threshold for Real vs RK */
				if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) write_record(ba, "BrtCellRk", write_BrtCellRk(cell, o));
				else write_record(ba, "BrtCellReal", write_BrtCellReal(cell, o));
				return;
			case 'b':
				o.t = "b";
				write_record(ba, "BrtCellBool", write_BrtCellBool(cell, o));
				return;
			case 'e': /* TODO: error */ o.t = "e"; break;
		}
		write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
	}
	
	function write_CELLTABLE(ba, ws, idx, opts) {
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		write_record(ba, 'BrtBeginSheetData');
		var dense = Array.isArray(ws);
		var cap = range.e.r;
		if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
		for(var R = range.s.r; R <= cap; ++R) {
			rr = encode_row(R);
			/* [ACCELLTABLE] */
			/* BrtRowHdr */
			write_row_header(ba, ws, range, R);
			if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
				/* *16384CELL */
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_bin_cell(ba, cell, R, C, opts, ws);
			}
		}
		write_record(ba, 'BrtEndSheetData');
	}
	
	function write_MERGECELLS(ba, ws) {
		if(!ws || !ws['!merges']) return;
		write_record(ba, 'BrtBeginMergeCells', write_BrtBeginMergeCells(ws['!merges'].length));
		ws['!merges'].forEach(function(m) { write_record(ba, 'BrtMergeCell', write_BrtMergeCell(m)); });
		write_record(ba, 'BrtEndMergeCells');
	}
	
	function write_COLINFOS(ba, ws) {
		if(!ws || !ws['!cols']) return;
		write_record(ba, 'BrtBeginColInfos');
		ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 'BrtColInfo', write_BrtColInfo(i, m)); });
		write_record(ba, 'BrtEndColInfos');
	}
	
	function write_HLINKS(ba, ws, rels) {
		/* *BrtHLink */
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
			write_record(ba, "BrtHLink", write_BrtHLink(l, rId));
		});
		delete ws['!links'];
	}
	function write_LEGACYDRAWING(ba, ws, idx, rels) {
		/* [BrtLegacyDrawing] */
		if(ws['!comments'].length > 0) {
			var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			write_record(ba, "BrtLegacyDrawing", write_RelID("rId" + rId));
			ws['!legacy'] = rId;
		}
	}
	
	function write_AUTOFILTER(ba, ws) {
		if(!ws['!autofilter']) return;
		write_record(ba, "BrtBeginAFilter", write_UncheckedRfX(decode_range(ws['!autofilter'].ref)));
		/* *FILTERCOLUMN */
		/* [SORTSTATE] */
		/* BrtEndAFilter */
		write_record(ba, "BrtEndAFilter");
	}
	
	function write_WSVIEWS2(ba, ws, Workbook) {
		write_record(ba, "BrtBeginWsViews");
		{ /* 1*WSVIEW2 */
			/* [ACUID] */
			write_record(ba, "BrtBeginWsView", write_BrtBeginWsView(ws, Workbook));
			/* [BrtPane] */
			/* *4BrtSel */
			/* *4SXSELECT */
			/* *FRT */
			write_record(ba, "BrtEndWsView");
		}
		/* *FRT */
		write_record(ba, "BrtEndWsViews");
	}
	
	function write_WSFMTINFO() {
		/* [ACWSFMTINFO] */
		//write_record(ba, "BrtWsFmtInfo", write_BrtWsFmtInfo(ws));
	}
	
	function write_SHEETPROTECT(ba, ws) {
		if(!ws['!protect']) return;
		/* [BrtSheetProtectionIso] */
		write_record(ba, "BrtSheetProtection", write_BrtSheetProtection(ws['!protect']));
	}
	
	function write_ws_bin(idx, opts, wb, rels) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
		var r = safe_decode_range(ws['!ref'] || "A1");
		ws['!links'] = [];
		/* passed back to write_zip and removed there */
		ws['!comments'] = [];
		write_record(ba, "BrtBeginSheet");
		write_record(ba, "BrtWsProp", write_BrtWsProp(c));
		write_record(ba, "BrtWsDim", write_BrtWsDim(r));
		write_WSVIEWS2(ba, ws, wb.Workbook);
		write_WSFMTINFO(ba, ws);
		write_COLINFOS(ba, ws, idx, opts, wb);
		write_CELLTABLE(ba, ws, idx, opts, wb);
		/* [BrtSheetCalcProp] */
		write_SHEETPROTECT(ba, ws);
		/* *([BrtRangeProtectionIso] BrtRangeProtection) */
		/* [SCENMAN] */
		write_AUTOFILTER(ba, ws);
		/* [SORTSTATE] */
		/* [DCON] */
		/* [USERSHVIEWS] */
		write_MERGECELLS(ba, ws);
		/* [BrtPhoneticInfo] */
		/* *CONDITIONALFORMATTING */
		/* [DVALS] */
		write_HLINKS(ba, ws, rels);
		/* [BrtPrintOptions] */
		if(ws['!margins']) write_record(ba, "BrtMargins", write_BrtMargins(ws['!margins']));
		/* [BrtPageSetup] */
		/* [HEADERFOOTER] */
		/* [RWBRK] */
		/* [COLBRK] */
		/* *BrtBigName */
		/* [CELLWATCHES] */
		/* [IGNOREECS] */
		/* [SMARTTAGS] */
		/* [BrtDrawing] */
		write_LEGACYDRAWING(ba, ws, idx, rels);
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [OLEOBJECTS] */
		/* [ACTIVEXCONTROLS] */
		/* [WEBPUBITEMS] */
		/* [LISTPARTS] */
		/* FRTWORKSHEET */
		write_record(ba, "BrtEndSheet");
		return ba.end();
	}
	function parse_numCache(data) {
		var col = [];
	
		/* 21.2.2.150 pt CT_NumVal */
		(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
			var q = pt.match(/<c:pt idx="(.*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
			if(!q) return;
			col[+q[1]] = +q[2];
		});
	
		/* 21.2.2.71 formatCode CT_Xstring */
		var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);
	
		return [col, nf];
	}
	
	/* 21.2 DrawingML - Charts */
	function parse_chart(data, name, opts, rels, wb, csheet) {
		var cs = ((csheet || {"!type":"chart"}));
		if(!data) return csheet;
		/* 21.2.2.27 chart CT_Chart */
	
		var C = 0, R = 0, col = "A";
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		/* 21.2.2.120 numCache CT_NumData */
		(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
			var cache = parse_numCache(nc);
			refguess.s.r = refguess.s.c = 0;
			refguess.e.c = C;
			col = encode_col(C);
			cache[0].forEach(function(n,i) {
				cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
				R = i;
			});
			if(refguess.e.r < R) refguess.e.r = R;
			++C;
		});
		if(C > 0) cs["!ref"] = encode_range(refguess);
		return cs;
	}
	RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";
	
	var CS_XML_ROOT = writextag('chartsheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	/* 18.3 Worksheets also covers Chartsheets */
	function parse_cs_xml(data, opts, idx, rels, wb) {
		if(!data) return data;
		/* 18.3.1.12 chartsheet CT_ChartSheet */
		if(!rels) rels = {'!id':{}};
		var s = {'!type':"chart", '!chart':null, '!rel':""};
		var m;
	
		/* 18.3.1.83 sheetPr CT_ChartsheetPr */
		var sheetPr = data.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.36 drawing CT_Drawing */
		if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];
	
		if(rels['!id'][s['!rel']]) s['!chart'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, CS_XML_ROOT];
		o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
		add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.331 BrtCsProp */
	function parse_BrtCsProp(data, length) {
		data.l += 10;
		var name = parse_XLWideString(data, length - 10);
		return { name: name };
	}
	
	/* [MS-XLSB] 2.1.7.7 Chart Sheet */
	function parse_cs_bin(data, opts, idx, rels, wb) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		var s = {'!type':"chart", '!chart':null, '!rel':""};
		var state = [];
		var pass = false;
		recordhopper(data, function cs_parse(val, R_n, RT) {
			switch(RT) {
	
				case 0x0226: /* 'BrtDrawing' */
					s['!rel'] = val; break;
	
				case 0x028B: /* 'BrtCsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				/* case 'BrtUid': */
				case 0x0232: /* 'BrtBkHim' */
				case 0x028C: /* 'BrtCsPageSetup' */
				case 0x029D: /* 'BrtCsProtection' */
				case 0x02A7: /* 'BrtCsProtectionIso' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x01DC: /* 'BrtMargins' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
					else if((R_n||"").indexOf("End") > 0) state.pop();
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		if(rels['!id'][s['!rel']]) s['!chart'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_bin() {
		var ba = buf_array();
		write_record(ba, "BrtBeginSheet");
		/* [BrtCsProp] */
		/* CSVIEWS */
		/* [[BrtCsProtectionIso] BrtCsProtection] */
		/* [USERCSVIEWS] */
		/* [BrtMargins] */
		/* [BrtCsPageSetup] */
		/* [HEADERFOOTER] */
		/* BrtDrawing */
		/* [BrtLegacyDrawing] */
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [WEBPUBITEMS] */
		/* FRTCHARTSHEET */
		write_record(ba, "BrtEndSheet");
		return ba.end();
	}
	/* 18.2.28 (CT_WorkbookProtection) Defaults */
	var WBPropsDef = [
		['allowRefreshQuery',           false, "bool"],
		['autoCompressPictures',        true,  "bool"],
		['backupFile',                  false, "bool"],
		['checkCompatibility',          false, "bool"],
		['CodeName',                    ''],
		['date1904',                    false, "bool"],
		['defaultThemeVersion',         0,      "int"],
		['filterPrivacy',               false, "bool"],
		['hidePivotFieldList',          false, "bool"],
		['promptedSolutions',           false, "bool"],
		['publishItems',                false, "bool"],
		['refreshAllConnections',       false, "bool"],
		['saveExternalLinkValues',      true,  "bool"],
		['showBorderUnselectedTables',  true,  "bool"],
		['showInkAnnotation',           true,  "bool"],
		['showObjects',                 'all'],
		['showPivotChartFilter',        false, "bool"],
		['updateLinks', 'userSet']
	];
	
	/* 18.2.30 (CT_BookView) Defaults */
	var WBViewDef = [
		['activeTab',                   0,      "int"],
		['autoFilterDateGrouping',      true,  "bool"],
		['firstSheet',                  0,      "int"],
		['minimized',                   false, "bool"],
		['showHorizontalScroll',        true,  "bool"],
		['showSheetTabs',               true,  "bool"],
		['showVerticalScroll',          true,  "bool"],
		['tabRatio',                    600,    "int"],
		['visibility',                  'visible']
		//window{Height,Width}, {x,y}Window
	];
	
	/* 18.2.19 (CT_Sheet) Defaults */
	var SheetDef = [
		//['state', 'visible']
	];
	
	/* 18.2.2  (CT_CalcPr) Defaults */
	var CalcPrDef = [
		['calcCompleted', 'true'],
		['calcMode', 'auto'],
		['calcOnSave', 'true'],
		['concurrentCalc', 'true'],
		['fullCalcOnLoad', 'false'],
		['fullPrecision', 'true'],
		['iterate', 'false'],
		['iterateCount', '100'],
		['iterateDelta', '0.001'],
		['refMode', 'A1']
	];
	
	/* 18.2.3 (CT_CustomWorkbookView) Defaults */
	/*var CustomWBViewDef = [
		['autoUpdate', 'false'],
		['changesSavedWin', 'false'],
		['includeHiddenRowCol', 'true'],
		['includePrintSettings', 'true'],
		['maximized', 'false'],
		['minimized', 'false'],
		['onlySync', 'false'],
		['personalView', 'false'],
		['showComments', 'commIndicator'],
		['showFormulaBar', 'true'],
		['showHorizontalScroll', 'true'],
		['showObjects', 'all'],
		['showSheetTabs', 'true'],
		['showStatusbar', 'true'],
		['showVerticalScroll', 'true'],
		['tabRatio', '600'],
		['xWindow', '0'],
		['yWindow', '0']
	];*/
	
	function push_defaults_array(target, defaults) {
		for(var j = 0; j != target.length; ++j) { var w = target[j];
			for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
				if(w[z[0]] == null) w[z[0]] = z[1];
				else switch(z[2]) {
				case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
				case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
				}
			}
		}
	}
	function push_defaults(target, defaults) {
		for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
			if(target[z[0]] == null) target[z[0]] = z[1];
			else switch(z[2]) {
				case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
				case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
			}
		}
	}
	
	function parse_wb_defaults(wb) {
		push_defaults(wb.WBProps, WBPropsDef);
		push_defaults(wb.CalcPr, CalcPrDef);
	
		push_defaults_array(wb.WBView, WBViewDef);
		push_defaults_array(wb.Sheets, SheetDef);
	
		_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
	}
	
	function safe1904(wb) {
		/* TODO: store date1904 somewhere else */
		if(!wb.Workbook) return "false";
		if(!wb.Workbook.WBProps) return "false";
		return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
	}
	
	var badchars = "][*?\/\\".split("");
	function check_ws_name(n, safe) {
		if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
		var _good = true;
		badchars.forEach(function(c) {
			if(n.indexOf(c) == -1) return;
			if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
			_good = false;
		});
		return _good;
	}
	function check_wb_names(N) {
		N.forEach(function(n,i) {
			check_ws_name(n);
			for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
		});
	}
	function check_wb(wb) {
		if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
		if(!wb.SheetNames.length) throw new Error("Workbook is empty");
		check_wb_names(wb.SheetNames);
		/* TODO: validate workbook */
	}
	/* 18.2 Workbook */
	var wbnsregex = /<\w+:workbook/;
	function parse_wb_xml(data, opts) {
		if(!data) throw new Error("Could not find file");
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
		var pass = false, xmlns = "xmlns";
		var dname = {}, dnstart = 0;
		data.replace(tagregex, function xml_wb(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 18.2.27 workbook CT_Workbook 1 */
				case '<workbook':
					if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
					wb.xmlns = y[xmlns];
					break;
				case '</workbook>': break;
	
				/* 18.2.13 fileVersion CT_FileVersion ? */
				case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
				case '<fileVersion/>': case '</fileVersion>': break;
	
				/* 18.2.12 fileSharing CT_FileSharing ? */
				case '<fileSharing': case '<fileSharing/>': break;
	
				/* 18.2.28 workbookPr CT_WorkbookPr ? */
				case '<workbookPr':
				case '<workbookPr/>':
					WBPropsDef.forEach(function(w) {
						if(y[w[0]] == null) return;
						switch(w[2]) {
							case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
							case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
							default: wb.WBProps[w[0]] = y[w[0]];
						}
					});
					if(y.codeName) wb.WBProps.CodeName = y.codeName;
					break;
				case '</workbookPr>': break;
	
				/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
				case '<workbookProtection': break;
				case '<workbookProtection/>': break;
	
				/* 18.2.1  bookViews CT_BookViews ? */
				case '<bookViews': case '<bookViews>': case '</bookViews>': break;
				/* 18.2.30   workbookView CT_BookView + */
				case '<workbookView': delete y[0]; wb.WBView.push(y); break;
				case '</workbookView>': break;
	
				/* 18.2.20 sheets CT_Sheets 1 */
				case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
				/* 18.2.19   sheet CT_Sheet + */
				case '<sheet':
					switch(y.state) {
						case "hidden": y.Hidden = 1; break;
						case "veryHidden": y.Hidden = 2; break;
						default: y.Hidden = 0;
					}
					delete y.state;
					y.name = unescapexml(utf8read(y.name));
					delete y[0]; wb.Sheets.push(y); break;
				case '</sheet>': break;
	
				/* 18.2.15 functionGroups CT_FunctionGroups ? */
				case '<functionGroups': case '<functionGroups/>': break;
				/* 18.2.14   functionGroup CT_FunctionGroup + */
				case '<functionGroup': break;
	
				/* 18.2.9  externalReferences CT_ExternalReferences ? */
				case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
				/* 18.2.8    externalReference CT_ExternalReference + */
				case '<externalReference': break;
	
				/* 18.2.6  definedNames CT_DefinedNames ? */
				case '<definedNames/>': break;
				case '<definedNames>': case '<definedNames': pass=true; break;
				case '</definedNames>': pass=false; break;
				/* 18.2.5    definedName CT_DefinedName + */
				case '<definedName': {
					dname = {};
					dname.Name = y.name;
					if(y.comment) dname.Comment = y.comment;
					if(y.localSheetId) dname.Sheet = +y.localSheetId;
					dnstart = idx + x.length;
				}	break;
				case '</definedName>': {
					dname.Ref = data.slice(dnstart, idx);
					wb.Names.push(dname);
				} break;
				case '<definedName/>': break;
	
				/* 18.2.2  calcPr CT_CalcPr ? */
				case '<calcPr': delete y[0]; wb.CalcPr = y; break;
				case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
				case '</calcPr>': break;
	
				/* 18.2.16 oleSize CT_OleSize ? (ref required) */
				case '<oleSize': break;
	
				/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
				case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
				/* 18.2.3    customWorkbookView CT_CustomWorkbookView + */
				case '<customWorkbookView': case '</customWorkbookView>': break;
	
				/* 18.2.18 pivotCaches CT_PivotCaches ? */
				case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
				/* 18.2.17 pivotCache CT_PivotCache ? */
				case '<pivotCache': break;
	
				/* 18.2.21 smartTagPr CT_SmartTagPr ? */
				case '<smartTagPr': case '<smartTagPr/>': break;
	
				/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
				case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
				/* 18.2.22   smartTagType CT_SmartTagType ? */
				case '<smartTagType': break;
	
				/* 18.2.24 webPublishing CT_WebPublishing ? */
				case '<webPublishing': case '<webPublishing/>': break;
	
				/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
				case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;
	
				/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
				case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
				/* 18.2.25 webPublishObject CT_WebPublishObject ? */
				case '<webPublishObject': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7    ext CT_Extension + */
				case '<ext': pass=true; break; //TODO: check with versions of excel
				case '</ext>': pass=false; break;
	
				/* Others */
				case '<ArchID': break;
				case '<AlternateContent':
				case '<AlternateContent>': pass=true; break;
				case '</AlternateContent>': pass=false; break;
	
				/* TODO */
				case '<revisionPtr': break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
			}
			return x;
		});
		if(XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	var WB_XML_ROOT = writextag('workbook', null, {
		'xmlns': XMLNS.main[0],
		//'xmlns:mx': XMLNS.mx,
		//'xmlns:s': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	function write_wb_xml(wb) {
		var o = [XML_HEADER];
		o[o.length] = WB_XML_ROOT;
	
		var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);
	
		/* fileVersion */
		/* fileSharing */
	
		var workbookPr = ({codeName:"ThisWorkbook"});
		if(wb.Workbook && wb.Workbook.WBProps) {
			WBPropsDef.forEach(function(x) {
	if((wb.Workbook.WBProps[x[0]]) == null) return;
				if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
				workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
			});
	if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
		}
		o[o.length] = (writextag('workbookPr', null, workbookPr));
	
		/* workbookProtection */
		/* bookViews */
	
		o[o.length] = "<sheets>";
		var sheets = wb.Workbook && wb.Workbook.Sheets || [];
		for(var i = 0; i != wb.SheetNames.length; ++i) {
			var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
			sht.sheetId = ""+(i+1);
			sht["r:id"] = "rId"+(i+1);
			if(sheets[i]) switch(sheets[i].Hidden) {
				case 1: sht.state = "hidden"; break;
				case 2: sht.state = "veryHidden"; break;
			}
			o[o.length] = (writextag('sheet',null,sht));
		}
		o[o.length] = "</sheets>";
	
		/* functionGroups */
		/* externalReferences */
	
		if(write_names) {
			o[o.length] = "<definedNames>";
			if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
				var d = {name:n.Name};
				if(n.Comment) d.comment = n.Comment;
				if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
				if(!n.Ref) return;
				o[o.length] = writextag('definedName', String(n.Ref), d);
			});
			o[o.length] = "</definedNames>";
		}
	
		/* calcPr */
		/* oleSize */
		/* customWorkbookViews */
		/* pivotCaches */
		/* smartTagPr */
		/* smartTagTypes */
		/* webPublishing */
		/* fileRecoveryPr */
		/* webPublishObjects */
		/* extLst */
	
		if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.301 BrtBundleSh */
	function parse_BrtBundleSh(data, length) {
		var z = {};
		z.Hidden = data.read_shift(4); //hsState ST_SheetState
		z.iTabID = data.read_shift(4);
		z.strRelID = parse_RelID(data,length-8);
		z.name = parse_XLWideString(data);
		return z;
	}
	function write_BrtBundleSh(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.Hidden);
		o.write_shift(4, data.iTabID);
		write_RelID(data.strRelID, o);
		write_XLWideString(data.name.slice(0,31), o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.807 BrtWbProp */
	function parse_BrtWbProp(data, length) {
		var o = ({});
		var flags = data.read_shift(4);
		o.defaultThemeVersion = data.read_shift(4);
		var strName = (length > 8) ? parse_XLWideString(data) : "";
		if(strName.length > 0) o.CodeName = strName;
		o.autoCompressPictures = !!(flags & 0x10000);
		o.backupFile = !!(flags & 0x40);
		o.checkCompatibility = !!(flags & 0x1000);
		o.date1904 = !!(flags & 0x01);
		o.filterPrivacy = !!(flags & 0x08);
		o.hidePivotFieldList = !!(flags & 0x400);
		o.promptedSolutions = !!(flags & 0x10);
		o.publishItems = !!(flags & 0x800);
		o.refreshAllConnections = !!(flags & 0x40000);
		o.saveExternalLinkValues = !!(flags & 0x80);
		o.showBorderUnselectedTables = !!(flags & 0x04);
		o.showInkAnnotation = !!(flags & 0x20);
		o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
		o.showPivotChartFilter = !!(flags & 0x8000);
		o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
		return o;
	}
	function write_BrtWbProp(data, o) {
		if(!o) o = new_buf(72);
		var flags = 0;
		if(data) {
			/* TODO: mirror parse_BrtWbProp fields */
			if(data.filterPrivacy) flags |= 0x08;
		}
		o.write_shift(4, flags);
		o.write_shift(4, 0);
		write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
		return o.slice(0, o.l);
	}
	
	function parse_BrtFRTArchID$(data, length) {
		var o = {};
		data.read_shift(4);
		o.ArchID = data.read_shift(4);
		data.l += length - 8;
		return o;
	}
	
	/* [MS-XLSB] 2.4.680 BrtName */
	function parse_BrtName(data, length, opts) {
		var end = data.l + length;
		data.l += 4; //var flags = data.read_shift(4);
		data.l += 1; //var chKey = data.read_shift(1);
		var itab = data.read_shift(4);
		var name = parse_XLNameWideString(data);
		var formula = parse_XLSBNameParsedFormula(data, 0, opts);
		var comment = parse_XLNullableWideString(data);
		//if(0 /* fProc */) {
			// unusedstring1: XLNullableWideString
			// description: XLNullableWideString
			// helpTopic: XLNullableWideString
			// unusedstring2: XLNullableWideString
		//}
		data.l = end;
		var out = ({Name:name, Ptg:formula});
		if(itab < 0xFFFFFFF) out.Sheet = itab;
		if(comment) out.Comment = comment;
		return out;
	}
	
	/* [MS-XLSB] 2.1.7.60 Workbook */
	function parse_wb_bin(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var pass = false;
	
		if(!opts) opts = {};
		opts.biff = 12;
	
		var Names = [];
		var supbooks = ([[]]);
		supbooks.SheetNames = [];
		supbooks.XTI = [];
	
		recordhopper(data, function hopper_wb(val, R_n, RT) {
			switch(RT) {
				case 0x009C: /* 'BrtBundleSh' */
					supbooks.SheetNames.push(val.name);
					wb.Sheets.push(val); break;
	
				case 0x0099: /* 'BrtWbProp' */
					wb.WBProps = val; break;
	
				case 0x0027: /* 'BrtName' */
					if(val.Sheet != null) opts.SID = val.Sheet;
					val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
					delete opts.SID;
					delete val.Ptg;
					Names.push(val);
					break;
				case 0x040C: /* 'BrtNameExt' */ break;
	
				case 0x0165: /* 'BrtSupSelf' */
				case 0x0166: /* 'BrtSupSame' */
				case 0x0163: /* 'BrtSupBookSrc' */
				case 0x029B: /* 'BrtSupAddin' */
					if(!supbooks[0].length) supbooks[0] = [RT, val];
					else supbooks.push([RT, val]);
					supbooks[supbooks.length - 1].XTI = [];
					break;
				case 0x016A: /* 'BrtExternSheet' */
					if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
					supbooks.XTI = supbooks.XTI.concat(val);
					break;
				case 0x0169: /* 'BrtPlaceholderName' */
					break;
	
				/* case 'BrtModelTimeGroupingCalcCol' */
				/* case 'BrtRevisionPtr' */
				/* case 'BrtUid' */
				case 0x0817: /* 'BrtAbsPath15' */
				case 0x0216: /* 'BrtBookProtection' */
				case 0x02A5: /* 'BrtBookProtectionIso' */
				case 0x009E: /* 'BrtBookView' */
				case 0x009D: /* 'BrtCalcProp' */
				case 0x0262: /* 'BrtCrashRecErr' */
				case 0x0802: /* 'BrtDecoupledPivotCacheID' */
				case 0x009B: /* 'BrtFileRecover' */
				case 0x0224: /* 'BrtFileSharing' */
				case 0x02A4: /* 'BrtFileSharingIso' */
				case 0x0080: /* 'BrtFileVersion' */
				case 0x0299: /* 'BrtFnGroup' */
				case 0x0850: /* 'BrtModelRelationship' */
				case 0x084D: /* 'BrtModelTable' */
				case 0x0225: /* 'BrtOleSize' */
				case 0x0805: /* 'BrtPivotTableRef' */
				case 0x0254: /* 'BrtSmartTagType' */
				case 0x081C: /* 'BrtTableSlicerCacheID' */
				case 0x081B: /* 'BrtTableSlicerCacheIDs' */
				case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
				case 0x018D: /* 'BrtUserBookView' */
				case 0x009A: /* 'BrtWbFactoid' */
				case 0x045D: /* 'BrtWbProp14' */
				case 0x0229: /* 'BrtWebOpt' */
				case 0x082B: /* 'BrtWorkBookPr15' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
				case 0x0010: /* 'BrtFRTArchID$' */ break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		parse_wb_defaults(wb);
	
		// $FlowIgnore
		wb.Names = Names;
	
		(wb).supbooks = supbooks;
		return wb;
	}
	
	/* [MS-XLSB] 2.1.7.60 Workbook */
	function write_BUNDLESHS(ba, wb) {
		write_record(ba, "BrtBeginBundleShs");
		for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
			var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
			var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
			write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
		}
		write_record(ba, "BrtEndBundleShs");
	}
	
	/* [MS-XLSB] 2.4.643 BrtFileVersion */
	function write_BrtFileVersion(data, o) {
		if(!o) o = new_buf(127);
		for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
		write_XLWideString("SheetJS", o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString("7262", o);
		o.length = o.l;
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.298 BrtBookView */
	function write_BrtBookView(idx, o) {
		if(!o) o = new_buf(29);
		o.write_shift(-4, 0);
		o.write_shift(-4, 460);
		o.write_shift(4,  28800);
		o.write_shift(4,  17600);
		o.write_shift(4,  500);
		o.write_shift(4,  idx);
		o.write_shift(4,  idx);
		var flags = 0x78;
		o.write_shift(1,  flags);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.1.7.60 Workbook */
	function write_BOOKVIEWS(ba, wb) {
		/* required if hidden tab appears before visible tab */
		if(!wb.Workbook || !wb.Workbook.Sheets) return;
		var sheets = wb.Workbook.Sheets;
		var i = 0, vistab = -1, hidden = -1;
		for(; i < sheets.length; ++i) {
			if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
			else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
		}
		if(hidden > vistab) return;
		write_record(ba, "BrtBeginBookViews");
		write_record(ba, "BrtBookView", write_BrtBookView(vistab));
		/* 1*(BrtBookView *FRT) */
		write_record(ba, "BrtEndBookViews");
	}
	
	/* [MS-XLSB] 2.4.302 BrtCalcProp */
	/*function write_BrtCalcProp(data, o) {
		if(!o) o = new_buf(26);
		o.write_shift(4,0); // force recalc
		o.write_shift(4,1);
		o.write_shift(4,0);
		write_Xnum(0, o);
		o.write_shift(-4, 1023);
		o.write_shift(1, 0x33);
		o.write_shift(1, 0x00);
		return o;
	}*/
	
	/* [MS-XLSB] 2.4.640 BrtFileRecover */
	/*function write_BrtFileRecover(data, o) {
		if(!o) o = new_buf(1);
		o.write_shift(1,0);
		return o;
	}*/
	
	/* [MS-XLSB] 2.1.7.60 Workbook */
	function write_wb_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginBook");
		write_record(ba, "BrtFileVersion", write_BrtFileVersion());
		/* [[BrtFileSharingIso] BrtFileSharing] */
		write_record(ba, "BrtWbProp", write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
		/* [ACABSPATH] */
		/* [[BrtBookProtectionIso] BrtBookProtection] */
		write_BOOKVIEWS(ba, wb, opts);
		write_BUNDLESHS(ba, wb, opts);
		/* [FNGROUP] */
		/* [EXTERNALS] */
		/* *BrtName */
		/* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */
		/* [BrtOleSize] */
		/* *(BrtUserBookView *FRT) */
		/* [PIVOTCACHEIDS] */
		/* [BrtWbFactoid] */
		/* [SMARTTAGTYPES] */
		/* [BrtWebOpt] */
		/* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */
		/* [WEBPUBITEMS] */
		/* [CRERRS] */
		/* FRTWORKBOOK */
		write_record(ba, "BrtEndBook");
	
		return ba.end();
	}
	function parse_wb(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
		return parse_wb_xml((data), opts);
	}
	
	function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_sty(data, name, themes, opts) {
		if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
		return parse_sty_xml((data), themes, opts);
	}
	
	function parse_theme(data, name, opts) {
		return parse_theme_xml(data, opts);
	}
	
	function parse_sst(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
		return parse_sst_xml((data), opts);
	}
	
	function parse_cmnt(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
		return parse_comments_xml((data), opts);
	}
	
	function parse_cc(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
		return parse_cc_xml((data), name, opts);
	}
	
	function parse_xlink(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlink_bin((data), name, opts);
		return parse_xlink_xml((data), name, opts);
	}
	
	function write_wb(wb, name, opts) {
		return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
	}
	
	function write_ws(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
	}
	
	// eslint-disable-next-line no-unused-vars
	function write_cs(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
	}
	
	function write_sty(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
	}
	
	function write_sst(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
	}
	
	function write_cmnt(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
	}
	/*
	function write_cc(data, name:string, opts) {
		return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
	}
	*/
	var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
	var _chr = function(c) { return String.fromCharCode(c); };
	function xlml_parsexmltag(tag, skip_root) {
		var words = tag.split(/\s+/);
		var z = ([]); if(!skip_root) z[0] = words[0];
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	function xlml_parsexmltagobj(tag) {
		var words = tag.split(/\s+/);
		var z = {};
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	
	// ----
	
	function xlml_format(format, value) {
		var fmt = XLMLFormatMap[format] || unescapexml(format);
		if(fmt === "General") return SSF._general(value);
		return SSF.format(fmt, value);
	}
	
	function xlml_set_custprop(Custprops, key, cp, val) {
		var oval = val;
		switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
			case "boolean": oval = parsexmlbool(val); break;
			case "i2": case "int": oval = parseInt(val, 10); break;
			case "r4": case "float": oval = parseFloat(val); break;
			case "date": case "dateTime.tz": oval = parseDate(val); break;
			case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
			default: throw new Error("bad custprop:" + cp[0]);
		}
		Custprops[unescapexml(key)] = oval;
	}
	
	function safe_format_xlml(cell, nf, o) {
		if(cell.t === 'z') return;
		if(!o || o.cellText !== false) try {
			if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
			else if(nf === "General") {
				if(cell.t === 'n') {
					if((cell.v|0) === cell.v) cell.w = SSF._general_int(cell.v);
					else cell.w = SSF._general_num(cell.v);
				}
				else cell.w = SSF._general(cell.v);
			}
			else cell.w = xlml_format(nf||"General", cell.v);
		} catch(e) { if(o.WTF) throw e; }
		try {
			var z = XLMLFormatMap[nf]||nf||"General";
			if(o.cellNF) cell.z = z;
			if(o.cellDates && cell.t == 'n' && SSF.is_date(z)) {
				var _d = SSF.parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
			}
		} catch(e) { if(o.WTF) throw e; }
	}
	
	function process_style_xlml(styles, stag, opts) {
		if(opts.cellStyles) {
			if(stag.Interior) {
				var I = stag.Interior;
				if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
			}
		}
		styles[stag.ID] = stag;
	}
	
	/* TODO: there must exist some form of OSP-blessed spec */
	function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
		var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
		var interiors = [];
		var i = 0;
		if(sid === undefined && row) sid = row.StyleID;
		if(sid === undefined && csty) sid = csty.StyleID;
		while(styles[sid] !== undefined) {
			if(styles[sid].nf) nf = styles[sid].nf;
			if(styles[sid].Interior) interiors.push(styles[sid].Interior);
			if(!styles[sid].Parent) break;
			sid = styles[sid].Parent;
		}
		switch(data.Type) {
			case 'Boolean':
				cell.t = 'b';
				cell.v = parsexmlbool(xml);
				break;
			case 'String':
				cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
				cell.v = xml.indexOf("<") > -1 ? unescapexml(ss) : cell.r;
				break;
			case 'DateTime':
				if(xml.slice(-1) != "Z") xml += "Z";
				cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				if(cell.v !== cell.v) cell.v = unescapexml(xml);
				else if(cell.v<60) cell.v = cell.v -1;
				if(!nf || nf == "General") nf = "yyyy-mm-dd";
				/* falls through */
			case 'Number':
				if(cell.v === undefined) cell.v=+xml;
				if(!cell.t) cell.t = 'n';
				break;
			case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
			default: cell.t = 's'; cell.v = xlml_fixstr(ss||xml); break;
		}
		safe_format_xlml(cell, nf, o);
		if(o.cellFormula !== false) {
			if(cell.Formula) {
				var fstr = unescapexml(cell.Formula);
				/* strictly speaking, the leading = is required but some writers omit */
				if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
				cell.f = rc_to_a1(fstr, base);
				delete cell.Formula;
				if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
				else if(cell.ArrayRange) {
					cell.F = rc_to_a1(cell.ArrayRange, base);
					arrayf.push([safe_decode_range(cell.F), cell.F]);
				}
			} else {
				for(i = 0; i < arrayf.length; ++i)
					if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
						if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
							cell.F = arrayf[i][1];
			}
		}
		if(o.cellStyles) {
			interiors.forEach(function(x) {
				if(!S.patternType && x.patternType) S.patternType = x.patternType;
			});
			cell.s = S;
		}
		if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
	}
	
	function xlml_clean_comment(comment) {
		comment.t = comment.v || "";
		comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		comment.v = comment.w = comment.ixfe = undefined;
	}
	
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		throw new Error("Bad input format: expected Buffer or string");
	}
	
	/* TODO: Everything */
	/* UOS uses CJK in tags */
	var xlmlregex = /<(\/?)([^\s?>!\/:]*:|)([^\s?>]*[^\s?>\/])[^>]*>/mg;
	//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
	function parse_xlml_xml(d, _opts) {
		var opts = _opts || {};
		make_ssf(SSF);
		var str = debom(xlml_normalize(d));
		if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
			if(typeof cptable !== 'undefined') str = cptable.utils.decode(65001, char_codes(str));
			else str = utf8read(str);
		}
		var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
		if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
		if(ishtml) return HTML_.to_workbook(str, opts);
		var Rn;
		var state = [], tmp;
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
		var table = {}, cell = ({}), row = {};// eslint-disable-line no-unused-vars
		var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
		var c = 0, r = 0;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
		var styles = {}, stag = {};
		var ss = "", fidx = 0;
		var merges = [];
		var Props = {}, Custprops = {}, pidx = 0, cp = [];
		var comments = [], comment = ({});
		var cstys = [], csty, seencol = false;
		var arrayf = [];
		var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
		var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"");
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'Data':
				if(state[state.length-1][1]) break;
				if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]=="Comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
				else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
				break;
			case 'Cell':
				if(Rn[1]==='/'){
					if(comments.length > 0) cell.c = comments;
					if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
						if(opts.dense) {
							if(!cursheet[r]) cursheet[r] = [];
							cursheet[r][c] = cell;
						} else cursheet[encode_col(c) + encode_row(r)] = cell;
					}
					if(cell.HRef) {
						cell.l = ({Target:cell.HRef});
						if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
						delete cell.HRef; delete cell.HRefScreenTip;
					}
					if(cell.MergeAcross || cell.MergeDown) {
						cc = c + (parseInt(cell.MergeAcross,10)|0);
						rr = r + (parseInt(cell.MergeDown,10)|0);
						merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
					}
					if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
					else if(cell.MergeAcross || cell.MergeDown) {
	for(var cma = c; cma <= cc; ++cma) {
							for(var cmd = r; cmd <= rr; ++cmd) {
								if(cma > c || cmd > r) {
									if(opts.dense) {
										if(!cursheet[cmd]) cursheet[cmd] = [];
										cursheet[cmd][cma] = {t:'z'};
									} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
								}
							}
						}
						c = cc + 1;
					}
					else ++c;
				} else {
					cell = xlml_parsexmltagobj(Rn[0]);
					if(cell.Index) c = +cell.Index - 1;
					if(c < refguess.s.c) refguess.s.c = c;
					if(c > refguess.e.c) refguess.e.c = c;
					if(Rn[0].slice(-2) === "/>") ++c;
					comments = [];
				}
				break;
			case 'Row':
				if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
					if(r < refguess.s.r) refguess.s.r = r;
					if(r > refguess.e.r) refguess.e.r = r;
					if(Rn[0].slice(-2) === "/>") {
						row = xlml_parsexmltag(Rn[0]);
						if(row.Index) r = +row.Index - 1;
					}
					c = 0; ++r;
				} else {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
					rowobj = {};
					if(row.AutoFitHeight == "0" || row.Height) {
						rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
						rowinfo[r] = rowobj;
					}
					if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
				}
				break;
			case 'Worksheet': /* TODO: read range from FullRows/FullColumns */
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					sheetnames.push(sheetname);
					if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) cursheet["!ref"] = encode_range(refguess);
					if(merges.length) cursheet["!merges"] = merges;
					if(cstys.length > 0) cursheet["!cols"] = cstys;
					if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
					sheets[sheetname] = cursheet;
				} else {
					refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
					r = c = 0;
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					sheetname = unescapexml(tmp.Name);
					cursheet = (opts.dense ? [] : {});
					merges = [];
					arrayf = [];
					rowinfo = [];
					wsprops = {name:sheetname, Hidden:0};
					Workbook.Sheets.push(wsprops);
				}
				break;
			case 'Table':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].slice(-2) == "/>") break;
				else {
					table = xlml_parsexmltag(Rn[0]);
					state.push([Rn[3], false]);
					cstys = []; seencol = false;
				}
				break;
	
			case 'Style':
				if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
				else stag = xlml_parsexmltag(Rn[0]);
				break;
	
			case 'NumberFormat':
				stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
				if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
				for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == stag.nf) break;
				if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == null) { SSF.load(stag.nf, ssfidx); break; }
				break;
	
			case 'Column':
				if(state[state.length-1][0] !== 'Table') break;
				csty = xlml_parsexmltag(Rn[0]);
				if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
				if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
				if(!seencol && csty.wpx > 10) {
					seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
					for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
				}
				if(seencol) process_col(csty);
				cstys[(csty.Index-1||cstys.length)] = csty;
				for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
				break;
	
			case 'NamedRange':
				if(!Workbook.Names) Workbook.Names = [];
				var _NamedRange = parsexmltag(Rn[0]);
				var _DefinedName = ({
					Name: _NamedRange.Name,
					Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
				});
				if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
	Workbook.Names.push(_DefinedName);
				break;
	
			case 'NamedCell': break;
			case 'B': break;
			case 'I': break;
			case 'U': break;
			case 'S': break;
			case 'Sub': break;
			case 'Sup': break;
			case 'Span': break;
			case 'Border': break;
			case 'Alignment': break;
			case 'Borders': break;
			case 'Font':
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
				else fidx = Rn.index + Rn[0].length;
				break;
			case 'Interior':
				if(!opts.cellStyles) break;
				stag.Interior = xlml_parsexmltag(Rn[0]);
				break;
			case 'Protection': break;
	
			case 'Author':
			case 'Title':
			case 'Description':
			case 'Created':
			case 'Keywords':
			case 'Subject':
			case 'Category':
			case 'Company':
			case 'LastAuthor':
			case 'LastSaved':
			case 'LastPrinted':
			case 'Version':
			case 'Revision':
			case 'TotalTime':
			case 'HyperlinkBase':
			case 'Manager':
			case 'ContentStatus':
			case 'Identifier':
			case 'Language':
			case 'AppName':
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_prop(Props, Rn[3], str.slice(pidx, Rn.index));
				else pidx = Rn.index + Rn[0].length;
				break;
			case 'Paragraphs': break;
	
			case 'Styles':
			case 'Workbook':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else state.push([Rn[3], false]);
				break;
	
			case 'Comment':
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					xlml_clean_comment(comment);
					comments.push(comment);
				} else {
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					comment = ({a:tmp.Author});
				}
				break;
	
			case 'AutoFilter':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					var AutoFilter = xlml_parsexmltag(Rn[0]);
					cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
					state.push([Rn[3], true]);
				}
				break;
	
			case 'Name': break;
	
			case 'ComponentOptions':
			case 'DocumentProperties':
			case 'CustomDocumentProperties':
			case 'OfficeDocumentSettings':
			case 'PivotTable':
			case 'PivotCache':
			case 'Names':
			case 'MapInfo':
			case 'PageBreaks':
			case 'QueryTable':
			case 'DataValidation':
			case 'Sorting':
			case 'Schema':
			case 'data':
			case 'ConditionalFormatting':
			case 'SmartTagType':
			case 'SmartTags':
			case 'ExcelWorkbook':
			case 'WorkbookOptions':
			case 'WorksheetOptions':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
	
			default:
				/* FODS file root is <office:document> */
				if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
				/* UOS file root is <uof:UOF> */
				if(state.length == 0 && Rn[3] == "UOF") return parse_fods(str, opts);
	
				var seen = true;
				switch(state[state.length-1][0]) {
					/* OfficeDocumentSettings */
					case 'OfficeDocumentSettings': switch(Rn[3]) {
						case 'AllowPNG': break;
						case 'RemovePersonalInformation': break;
						case 'DownloadComponents': break;
						case 'LocationOfComponents': break;
						case 'Colors': break;
						case 'Color': break;
						case 'Index': break;
						case 'RGB': break;
						case 'PixelsPerInch': break; // TODO: set PPI
						case 'TargetScreenSize': break;
						case 'ReadOnlyRecommended': break;
						default: seen = false;
					} break;
	
					/* ComponentOptions */
					case 'ComponentOptions': switch(Rn[3]) {
						case 'Toolbar': break;
						case 'HideOfficeLogo': break;
						case 'SpreadsheetAutoFit': break;
						case 'Label': break;
						case 'Caption': break;
						case 'MaxHeight': break;
						case 'MaxWidth': break;
						case 'NextSheetNumber': break;
						default: seen = false;
					} break;
	
					/* ExcelWorkbook */
					case 'ExcelWorkbook': switch(Rn[3]) {
						case 'Date1904':
	Workbook.WBProps.date1904 = true;
							break;
						case 'WindowHeight': break;
						case 'WindowWidth': break;
						case 'WindowTopX': break;
						case 'WindowTopY': break;
						case 'TabRatio': break;
						case 'ProtectStructure': break;
						case 'ProtectWindows': break;
						case 'ActiveSheet': break;
						case 'DisplayInkNotes': break;
						case 'FirstVisibleSheet': break;
						case 'SupBook': break;
						case 'SheetName': break;
						case 'SheetIndex': break;
						case 'SheetIndexFirst': break;
						case 'SheetIndexLast': break;
						case 'Dll': break;
						case 'AcceptLabelsInFormulas': break;
						case 'DoNotSaveLinkValues': break;
						case 'Iteration': break;
						case 'MaxIterations': break;
						case 'MaxChange': break;
						case 'Path': break;
						case 'Xct': break;
						case 'Count': break;
						case 'SelectedSheets': break;
						case 'Calculation': break;
						case 'Uncalced': break;
						case 'StartupPrompt': break;
						case 'Crn': break;
						case 'ExternName': break;
						case 'Formula': break;
						case 'ColFirst': break;
						case 'ColLast': break;
						case 'WantAdvise': break;
						case 'Boolean': break;
						case 'Error': break;
						case 'Text': break;
						case 'OLE': break;
						case 'NoAutoRecover': break;
						case 'PublishObjects': break;
						case 'DoNotCalculateBeforeSave': break;
						case 'Number': break;
						case 'RefModeR1C1': break;
						case 'EmbedSaveSmartTags': break;
						default: seen = false;
					} break;
	
					/* WorkbookOptions */
					case 'WorkbookOptions': switch(Rn[3]) {
						case 'OWCVersion': break;
						case 'Height': break;
						case 'Width': break;
						default: seen = false;
					} break;
	
					/* WorksheetOptions */
					case 'WorksheetOptions': switch(Rn[3]) {
						case 'Visible':
							if(Rn[0].slice(-2) === "/>"){/* empty */}
							else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
								case "SheetHidden": wsprops.Hidden = 1; break;
								case "SheetVeryHidden": wsprops.Hidden = 2; break;
							}
							else pidx = Rn.index + Rn[0].length;
							break;
						case 'Header':
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							cursheet['!margins'].header = parsexmltag(Rn[0]).Margin;
							break;
						case 'Footer':
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							cursheet['!margins'].footer = parsexmltag(Rn[0]).Margin;
							break;
						case 'PageMargins':
							var pagemargins = parsexmltag(Rn[0]);
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
							if(pagemargins.Top) cursheet['!margins'].top = pagemargins.Top;
							if(pagemargins.Left) cursheet['!margins'].left = pagemargins.Left;
							if(pagemargins.Right) cursheet['!margins'].right = pagemargins.Right;
							if(pagemargins.Bottom) cursheet['!margins'].bottom = pagemargins.Bottom;
							break;
						case 'DisplayRightToLeft':
							if(!Workbook.Views) Workbook.Views = [];
							if(!Workbook.Views[0]) Workbook.Views[0] = {};
							Workbook.Views[0].RTL = true;
							break;
	
						case 'Unsynced': break;
						case 'Print': break;
						case 'Panes': break;
						case 'Scale': break;
						case 'Pane': break;
						case 'Number': break;
						case 'Layout': break;
						case 'PageSetup': break;
						case 'Selected': break;
						case 'ProtectObjects': break;
						case 'EnableSelection': break;
						case 'ProtectScenarios': break;
						case 'ValidPrinterInfo': break;
						case 'HorizontalResolution': break;
						case 'VerticalResolution': break;
						case 'NumberofCopies': break;
						case 'ActiveRow': break;
						case 'ActiveCol': break;
						case 'ActivePane': break;
						case 'TopRowVisible': break;
						case 'TopRowBottomPane': break;
						case 'LeftColumnVisible': break;
						case 'LeftColumnRightPane': break;
						case 'FitToPage': break;
						case 'RangeSelection': break;
						case 'PaperSizeIndex': break;
						case 'PageLayoutZoom': break;
						case 'PageBreakZoom': break;
						case 'FilterOn': break;
						case 'DoNotDisplayGridlines': break;
						case 'SplitHorizontal': break;
						case 'SplitVertical': break;
						case 'FreezePanes': break;
						case 'FrozenNoSplit': break;
						case 'FitWidth': break;
						case 'FitHeight': break;
						case 'CommentsLayout': break;
						case 'Zoom': break;
						case 'LeftToRight': break;
						case 'Gridlines': break;
						case 'AllowSort': break;
						case 'AllowFilter': break;
						case 'AllowInsertRows': break;
						case 'AllowDeleteRows': break;
						case 'AllowInsertCols': break;
						case 'AllowDeleteCols': break;
						case 'AllowInsertHyperlinks': break;
						case 'AllowFormatCells': break;
						case 'AllowSizeCols': break;
						case 'AllowSizeRows': break;
						case 'NoSummaryRowsBelowDetail': break;
						case 'TabColorIndex': break;
						case 'DoNotDisplayHeadings': break;
						case 'ShowPageLayoutZoom': break;
						case 'NoSummaryColumnsRightDetail': break;
						case 'BlackAndWhite': break;
						case 'DoNotDisplayZeros': break;
						case 'DisplayPageBreak': break;
						case 'RowColHeadings': break;
						case 'DoNotDisplayOutline': break;
						case 'NoOrientation': break;
						case 'AllowUsePivotTables': break;
						case 'ZeroHeight': break;
						case 'ViewableRange': break;
						case 'Selection': break;
						case 'ProtectContents': break;
						default: seen = false;
					} break;
	
					/* PivotTable */
					case 'PivotTable': case 'PivotCache': switch(Rn[3]) {
						case 'ImmediateItemsOnDrop': break;
						case 'ShowPageMultipleItemLabel': break;
						case 'CompactRowIndent': break;
						case 'Location': break;
						case 'PivotField': break;
						case 'Orientation': break;
						case 'LayoutForm': break;
						case 'LayoutSubtotalLocation': break;
						case 'LayoutCompactRow': break;
						case 'Position': break;
						case 'PivotItem': break;
						case 'DataType': break;
						case 'DataField': break;
						case 'SourceName': break;
						case 'ParentField': break;
						case 'PTLineItems': break;
						case 'PTLineItem': break;
						case 'CountOfSameItems': break;
						case 'Item': break;
						case 'ItemType': break;
						case 'PTSource': break;
						case 'CacheIndex': break;
						case 'ConsolidationReference': break;
						case 'FileName': break;
						case 'Reference': break;
						case 'NoColumnGrand': break;
						case 'NoRowGrand': break;
						case 'BlankLineAfterItems': break;
						case 'Hidden': break;
						case 'Subtotal': break;
						case 'BaseField': break;
						case 'MapChildItems': break;
						case 'Function': break;
						case 'RefreshOnFileOpen': break;
						case 'PrintSetTitles': break;
						case 'MergeLabels': break;
						case 'DefaultVersion': break;
						case 'RefreshName': break;
						case 'RefreshDate': break;
						case 'RefreshDateCopy': break;
						case 'VersionLastRefresh': break;
						case 'VersionLastUpdate': break;
						case 'VersionUpdateableMin': break;
						case 'VersionRefreshableMin': break;
						case 'Calculation': break;
						default: seen = false;
					} break;
	
					/* PageBreaks */
					case 'PageBreaks': switch(Rn[3]) {
						case 'ColBreaks': break;
						case 'ColBreak': break;
						case 'RowBreaks': break;
						case 'RowBreak': break;
						case 'ColStart': break;
						case 'ColEnd': break;
						case 'RowEnd': break;
						default: seen = false;
					} break;
	
					/* AutoFilter */
					case 'AutoFilter': switch(Rn[3]) {
						case 'AutoFilterColumn': break;
						case 'AutoFilterCondition': break;
						case 'AutoFilterAnd': break;
						case 'AutoFilterOr': break;
						default: seen = false;
					} break;
	
					/* QueryTable */
					case 'QueryTable': switch(Rn[3]) {
						case 'Id': break;
						case 'AutoFormatFont': break;
						case 'AutoFormatPattern': break;
						case 'QuerySource': break;
						case 'QueryType': break;
						case 'EnableRedirections': break;
						case 'RefreshedInXl9': break;
						case 'URLString': break;
						case 'HTMLTables': break;
						case 'Connection': break;
						case 'CommandText': break;
						case 'RefreshInfo': break;
						case 'NoTitles': break;
						case 'NextId': break;
						case 'ColumnInfo': break;
						case 'OverwriteCells': break;
						case 'DoNotPromptForFile': break;
						case 'TextWizardSettings': break;
						case 'Source': break;
						case 'Number': break;
						case 'Decimal': break;
						case 'ThousandSeparator': break;
						case 'TrailingMinusNumbers': break;
						case 'FormatSettings': break;
						case 'FieldType': break;
						case 'Delimiters': break;
						case 'Tab': break;
						case 'Comma': break;
						case 'AutoFormatName': break;
						case 'VersionLastEdit': break;
						case 'VersionLastRefresh': break;
						default: seen = false;
					} break;
	
					case 'Sorting':
					case 'ConditionalFormatting':
					case 'DataValidation':
					switch(Rn[3]) {
						case 'Range': break;
						case 'Type': break;
						case 'Min': break;
						case 'Max': break;
						case 'Sort': break;
						case 'Descending': break;
						case 'Order': break;
						case 'CaseSensitive': break;
						case 'Value': break;
						case 'ErrorStyle': break;
						case 'ErrorMessage': break;
						case 'ErrorTitle': break;
						case 'CellRangeList': break;
						case 'InputMessage': break;
						case 'InputTitle': break;
						case 'ComboHide': break;
						case 'InputHide': break;
						case 'Condition': break;
						case 'Qualifier': break;
						case 'UseBlank': break;
						case 'Value1': break;
						case 'Value2': break;
						case 'Format': break;
						default: seen = false;
					} break;
	
					/* MapInfo (schema) */
					case 'MapInfo': case 'Schema': case 'data': switch(Rn[3]) {
						case 'Map': break;
						case 'Entry': break;
						case 'Range': break;
						case 'XPath': break;
						case 'Field': break;
						case 'XSDType': break;
						case 'FilterOn': break;
						case 'Aggregate': break;
						case 'ElementType': break;
						case 'AttributeType': break;
					/* These are from xsd (XML Schema Definition) */
						case 'schema':
						case 'element':
						case 'complexType':
						case 'datatype':
						case 'all':
						case 'attribute':
						case 'extends': break;
	
						case 'row': break;
						default: seen = false;
					} break;
	
					/* SmartTags (can be anything) */
					case 'SmartTags': break;
	
					default: seen = false; break;
				}
				if(seen) break;
				/* CustomDocumentProperties */
				if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
				if(state[state.length-1][0]==='CustomDocumentProperties') {
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") xlml_set_custprop(Custprops, Rn[3], cp, str.slice(pidx, Rn.index));
					else { cp = Rn; pidx = Rn.index + Rn[0].length; }
					break;
				}
				if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
		}
		var out = ({});
		if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
		out.SheetNames = sheetnames;
		out.Workbook = Workbook;
		out.SSF = SSF.get_table();
		out.Props = Props;
		out.Custprops = Custprops;
		return out;
	}
	
	function parse_xlml(data, opts) {
		fix_read_opts(opts=opts||{});
		switch(opts.type||"base64") {
			case "base64": return parse_xlml_xml(Base64.decode(data), opts);
			case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
			case "array": return parse_xlml_xml(a2s(data), opts);
		}
	}
	
	/* TODO */
	function write_props_xlml(wb, opts) {
		var o = [];
		/* DocumentProperties */
		if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
		/* CustomDocumentProperties */
		if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
		return o.join("");
	}
	/* TODO */
	function write_wb_xlml() {
		/* OfficeDocumentSettings */
		/* ExcelWorkbook */
		return "";
	}
	/* TODO */
	function write_sty_xlml(wb, opts) {
		/* Styles */
		var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
		opts.cellXfs.forEach(function(xf, id) {
			var payload = [];
			payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(SSF._table[xf.numFmtId])}));
			styles.push(writextag('Style', payload.join(""), {"ss:ID": "s" + (21+id)}));
		});
		return writextag("Styles", styles.join(""));
	}
	function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
	function write_names_xlml(wb) {
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != null) continue;
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return writextag("Names", out.join(""));
	}
	function write_ws_xlml_names(ws, opts, idx, wb) {
		if(!ws) return "";
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		outer: for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != idx) continue;
			/*switch(n.Name) {
				case "_": continue;
			}*/
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return out.join("");
	}
	/* WorksheetOptions */
	function write_ws_xlml_wsopts(ws, opts, idx, wb) {
		if(!ws) return "";
		var o = [];
		/* NOTE: spec technically allows any order, but stick with implied order */
	
		/* FitToPage */
		/* DoNotDisplayColHeaders */
		/* DoNotDisplayRowHeaders */
		/* ViewableRange */
		/* Selection */
		/* GridlineColor */
		/* Name */
		/* ExcelWorksheetType */
		/* IntlMacro */
		/* Unsynced */
		/* Selected */
		/* CodeName */
	
		if(ws['!margins']) {
			o.push("<PageSetup>");
			if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
			if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
			o.push(writextag("PageMargins", null, {
				'x:Bottom': ws['!margins'].bottom || "0.75",
				'x:Left': ws['!margins'].left || "0.7",
				'x:Right': ws['!margins'].right || "0.7",
				'x:Top': ws['!margins'].top || "0.75"
			}));
			o.push("</PageSetup>");
		}
	
		/* PageSetup */
		/* DisplayPageBreak */
		/* TransitionExpressionEvaluation */
		/* TransitionFormulaEntry */
		/* Print */
		/* Zoom */
		/* PageLayoutZoom */
		/* PageBreakZoom */
		/* ShowPageBreakZoom */
		/* DefaultRowHeight */
		/* DefaultColumnWidth */
		/* StandardWidth */
	
		if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
			/* Visible */
			if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
			else {
				/* Selected */
				for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
				if(i == idx) o.push("<Selected/>");
			}
		}
	
		/* LeftColumnVisible */
	
		// $FlowIgnore
		if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");
	
		/* GridlineColorIndex */
		/* DisplayFormulas */
		/* DoNotDisplayGridlines */
		/* DoNotDisplayHeadings */
		/* DoNotDisplayOutline */
		/* ApplyAutomaticOutlineStyles */
		/* NoSummaryRowsBelowDetail */
		/* NoSummaryColumnsRightDetail */
		/* DoNotDisplayZeros */
		/* ActiveRow */
		/* ActiveColumn */
		/* FilterOn */
		/* RangeSelection */
		/* TopRowVisible */
		/* TopRowBottomPane */
		/* LeftColumnRightPane */
		/* ActivePane */
		/* SplitHorizontal */
		/* SplitVertical */
		/* FreezePanes */
		/* FrozenNoSplit */
		/* TabColorIndex */
		/* Panes */
	
		/* NOTE: Password not supported in XLML Format */
		if(ws['!protect']) {
			o.push(writetag("ProtectContents", "True"));
			if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
			if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
			if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
			else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
		[
			[ "formatCells", "AllowFormatCells" ],
			[ "formatColumns", "AllowSizeCols" ],
			[ "formatRows", "AllowSizeRows" ],
			[ "insertColumns", "AllowInsertCols" ],
			[ "insertRows", "AllowInsertRows" ],
			[ "insertHyperlinks", "AllowInsertHyperlinks" ],
			[ "deleteColumns", "AllowDeleteCols" ],
			[ "deleteRows", "AllowDeleteRows" ],
			[ "sort", "AllowSort" ],
			[ "autoFilter", "AllowFilter" ],
			[ "pivotTables", "AllowUsePivotTables" ]
		].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
		}
	
		if(o.length == 0) return "";
		return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
	}
	function write_ws_xlml_comment(comments) {
		return comments.map(function(c) {
			// TODO: formatted text
			var t = xlml_unfixstr(c.t||"");
			var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
			return writextag("Comment", d, {"ss:Author":c.a});
		}).join("");
	}
	function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
		if(!cell || cell.v == undefined && cell.f == undefined) return "";
	
		var attr = {};
		if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
		if(cell.F && cell.F.slice(0, ref.length) == ref) {
			var end = decode_cell(cell.F.slice(ref.length + 1));
			attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
		}
	
		if(cell.l && cell.l.Target) {
			attr["ss:HRef"] = escapexml(cell.l.Target);
			if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
		}
	
		if(ws['!merges']) {
			var marr = ws['!merges'];
			for(var mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
				if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
				if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
			}
		}
	
		var t = "", p = "";
		switch(cell.t) {
			case 'z': return "";
			case 'n': t = 'Number'; p = String(cell.v); break;
			case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
			case 'e': t = 'Error'; p = BErr[cell.v]; break;
			case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || SSF._table[14]; break;
			case 's': t = 'String'; p = escapexlml(cell.v||""); break;
		}
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		attr["ss:StyleID"] = "s" + (21+os);
		attr["ss:Index"] = addr.c + 1;
		var _v = (cell.v != null ? p : "");
		var m = '<Data ss:Type="' + t + '">' + _v + '</Data>';
	
		if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);
	
		return writextag("Cell", m, attr);
	}
	function write_ws_xlml_row(R, row) {
		var o = '<Row ss:Index="' + (R+1) + '"';
		if(row) {
			if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
			if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
			if(row.hidden) o += ' ss:Hidden="1"';
		}
		return o + '>';
	}
	/* TODO */
	function write_ws_xlml_table(ws, opts, idx, wb) {
		if(!ws['!ref']) return "";
		var range = safe_decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var o = [];
		if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
			process_col(n);
			var w = !!n.width;
			var p = col_obj_w(i, n);
			var k = {"ss:Index":i+1};
			if(w) k['ss:Width'] = width2px(p.width);
			if(n.hidden) k['ss:Hidden']="1";
			o.push(writextag("Column",null,k));
		});
		var dense = Array.isArray(ws);
		for(var R = range.s.r; R <= range.e.r; ++R) {
			var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
			for(var C = range.s.c; C <= range.e.c; ++C) {
				var skip = false;
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					break;
				}
				if(skip) continue;
				var addr = {r:R,c:C};
				var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
				row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
			}
			row.push("</Row>");
			if(row.length > 2) o.push(row.join(""));
		}
		return o.join("");
	}
	function write_ws_xlml(idx, opts, wb) {
		var o = [];
		var s = wb.SheetNames[idx];
		var ws = wb.Sheets[s];
	
		var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Names>" + t + "</Names>");
	
		/* Table */
		t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Table>" + t + "</Table>");
	
		/* WorksheetOptions */
		o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
	
		return o.join("");
	}
	function write_xlml(wb, opts) {
		if(!opts) opts = {};
		if(!wb.SSF) wb.SSF = SSF.get_table();
		if(wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
			opts.cellXfs = [];
			get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
		}
		var d = [];
		d.push(write_props_xlml(wb, opts));
		d.push(write_wb_xlml(wb, opts));
		d.push("");
		d.push("");
		for(var i = 0; i < wb.SheetNames.length; ++i)
			d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
		d[2] = write_sty_xlml(wb, opts);
		d[3] = write_names_xlml(wb, opts);
		return XML_HEADER + writextag("Workbook", d.join(""), {
			'xmlns':      XLMLNS.ss,
			'xmlns:o':    XLMLNS.o,
			'xmlns:x':    XLMLNS.x,
			'xmlns:ss':   XLMLNS.ss,
			'xmlns:dt':   XLMLNS.dt,
			'xmlns:html': XLMLNS.html
		});
	}
	/* [MS-OLEDS] 2.3.8 CompObjStream */
	function parse_compobj(obj) {
		var v = {};
		var o = obj.content;
	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
		o.l = 28;
	
		v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
		v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
	
		if(o.length - o.l <= 4) return v;
	
		var m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");
	
		if(o.length - o.l <= 4) return v;
		m = o.read_shift(4);
		if(m !== 0x71b239f4) return v;
		v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
	
		m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
	}
	
	/*
		Continue logic for:
		- 2.4.58 Continue
		- 2.4.59 ContinueBigName
		- 2.4.60 ContinueFrt
		- 2.4.61 ContinueFrt11
		- 2.4.62 ContinueFrt12
	*/
	function slurp(R, blob, length, opts) {
		var l = length;
		var bufs = [];
		var d = blob.slice(blob.l,blob.l+l);
		if(opts && opts.enc && opts.enc.insitu) switch(R.n) {
		case 'BOF': case 'FilePass': case 'FileLock': case 'InterfaceHdr': case 'RRDInfo': case 'RRDHead': case 'UsrExcl': break;
		default:
			if(d.length === 0) break;
			opts.enc.insitu(d);
		}
		bufs.push(d);
		blob.l += l;
		var next = (XLSRecordEnum[__readUInt16LE(blob,blob.l)]);
		var start = 0;
		while(next != null && next.n.slice(0,8) === 'Continue') {
			l = __readUInt16LE(blob,blob.l+2);
			start = blob.l + 4;
			if(next.n == 'ContinueFrt') start += 4;
			else if(next.n.slice(0,11) == 'ContinueFrt') start += 12;
			bufs.push(blob.slice(start,blob.l+4+l));
			blob.l += 4+l;
			next = (XLSRecordEnum[__readUInt16LE(blob, blob.l)]);
		}
		var b = (bconcat(bufs));
		prep_blob(b, 0);
		var ll = 0; b.lens = [];
		for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
		return R.f(b, b.length, opts);
	}
	
	function safe_format_xf(p, opts, date1904) {
		if(p.t === 'z') return;
		if(!p.XF) return;
		var fmtid = 0;
		try {
			fmtid = p.z || p.XF.numFmtId || 0;
			if(opts.cellNF) p.z = SSF._table[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts || opts.cellText !== false) try {
			if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
			else if(fmtid === 0 || fmtid == "General") {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
					else p.w = SSF._general_num(p.v);
				}
				else p.w = SSF._general(p.v);
			}
			else p.w = SSF.format(fmtid,p.v, {date1904:!!date1904});
		} catch(e) { if(opts.WTF) throw e; }
		if(opts.cellDates && fmtid && p.t == 'n' && SSF.is_date(SSF._table[fmtid] || String(fmtid))) {
			var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	}
	
	function make_cell(val, ixfe, t) {
		return ({v:val, ixfe:ixfe, t:t});
	}
	
	// 2.3.2
	function parse_workbook(blob, options) {
		var wb = ({opts:{}});
		var Sheets = {};
		if(DENSE != null && options.dense == null) options.dense = DENSE;
		var out = ((options.dense ? [] : {}));
		var Directory = {};
		var range = ({});
		var last_formula = null;
		var sst = ([]);
		var cur_sheet = "";
		var Preamble = {};
		var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
		var sharedf = {};
		var arrayf = [];
		var temp_val;
		var country;
		var cell_valid = true;
		var XFs = []; /* XF records */
		var palette = [];
		var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
		var get_rgb = function getrgb(icv) {
			if(icv < 8) return XLSIcv[icv];
			if(icv < 64) return palette[icv-8] || XLSIcv[icv];
			return XLSIcv[icv];
		};
		var process_cell_style = function pcs(cell, line, options) {
			var xfd = line.XF.data;
			if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
			line.s = ({});
			line.s.patternType = xfd.patternType;
			var t;
			if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
			if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
		};
		var addcell = function addcell(cell, line, options) {
			if(file_depth > 1) return;
			if(!cell_valid) return;
			if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
			delete line.ixfe; delete line.XF;
			lastcell = cell;
			last_cell = encode_cell(cell);
			if(range.s) {
				if(cell.r < range.s.r) range.s.r = cell.r;
				if(cell.c < range.s.c) range.s.c = cell.c;
			}
			if(range.e) {
				if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
				if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
			}
			if(options.cellFormula && line.f) {
				for(var afi = 0; afi < arrayf.length; ++afi) {
					if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
					if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
					line.F = encode_range(arrayf[afi][0]);
					if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
					if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
					break;
				}
			}
			if(options.sheetRows && lastcell.r >= options.sheetRows) cell_valid = false;
			else {
				if(options.dense) {
					if(!out[cell.r]) out[cell.r] = [];
					out[cell.r][cell.c] = line;
				} else out[last_cell] = line;
			}
		};
		var opts = ({
			enc: false, // encrypted
			sbcch: 0, // cch in the preceding SupBook
			snames: [], // sheetnames
			sharedf: sharedf, // shared formulae by address
			arrayf: arrayf, // array formulae array
			rrtabid: [], // RRTabId
			lastuser: "", // Last User from WriteAccess
			biff: 8, // BIFF version
			codepage: 0, // CP from CodePage record
			winlocked: 0, // fLockWn from WinProtect
			cellStyles: !!options && !!options.cellStyles,
			WTF: !!options && !!options.wtf
		});
		if(options.password) opts.password = options.password;
		var themes;
		var merges = [];
		var objects = [];
		var colinfo = [], rowinfo = [];
		// eslint-disable-next-line no-unused-vars
		var defwidth = 0, defheight = 0; // twips / MDW respectively
		var seencol = false;
		var supbooks = ([]); // 1-indexed, will hold extern names
		supbooks.SheetNames = opts.snames;
		supbooks.sharedf = opts.sharedf;
		supbooks.arrayf = opts.arrayf;
		supbooks.names = [];
		supbooks.XTI = [];
		var last_Rn = '';
		var file_depth = 0; /* TODO: make a real stack */
		var BIFF2Fmt = 0, BIFF2FmtTable = [];
		var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
		var last_lbl;
	
		/* explicit override for some broken writers */
		opts.codepage = 1200;
		set_cp(1200);
		var seen_codepage = false;
		while(blob.l < blob.length - 1) {
			var s = blob.l;
			var RecordType = blob.read_shift(2);
			if(RecordType === 0 && last_Rn === 'EOF') break;
			var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
			var R = XLSRecordEnum[RecordType];
			//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
			//if(!R) console.log(blob.slice(blob.l, blob.l + length));
			if(R && R.f) {
				if(options.bookSheets) {
					if(last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
				}
				last_Rn = R.n;
				if(R.r === 2 || R.r == 12) {
					var rt = blob.read_shift(2); length -= 2;
					if(!opts.enc && rt !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
					if(R.r == 12){ blob.l += 10; length -= 10; } // skip FRT
				}
				//console.error(R,blob.l,length,blob.length);
				var val;
				if(R.n === 'EOF') val = R.f(blob, length, opts);
				else val = slurp(R, blob, length, opts);
				var Rn = R.n;
				if(file_depth == 0 && Rn != 'BOF') continue;
				/* nested switch statements to workaround V8 128 limit */
				switch(Rn) {
					/* Workbook Options */
					case 'Date1904':
	wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
					case 'WriteProtect': wb.opts.WriteProtect = true; break;
					case 'FilePass':
						if(!opts.enc) blob.l = 0;
						opts.enc = val;
						if(opts.WTF) console.error(val);
						if(!options.password) throw new Error("File is password-protected");
						if(val.valid == null) throw new Error("Encryption scheme unsupported");
						if(!val.valid) throw new Error("Password is incorrect");
						break;
					case 'WriteAccess': opts.lastuser = val; break;
					case 'FileSharing': break; //TODO
					case 'CodePage':
						/* overrides based on test cases */
						switch(val) {
							case 0x5212: val =  1200; break;
							case 0x8000: val = 10000; break;
							case 0x8001: val =  1252; break;
						}
						set_cp(opts.codepage = val);
						seen_codepage = true;
						break;
					case 'RRTabId': opts.rrtabid = val; break;
					case 'WinProtect': opts.winlocked = val; break;
					case 'Template': break; // TODO
					case 'BookBool': break; // TODO
					case 'UsesELFs': break;
					case 'MTRSettings': break;
					case 'RefreshAll':
					case 'CalcCount':
					case 'CalcDelta':
					case 'CalcIter':
					case 'CalcMode':
					case 'CalcPrecision':
					case 'CalcSaveRecalc':
						wb.opts[Rn] = val; break;
					case 'CalcRefMode': opts.CalcRefMode = val; break; // TODO: implement R1C1
					case 'Uncalced': break;
					case 'ForceFullCalculation': wb.opts.FullCalc = val; break;
					case 'WsBool':
						if(val.fDialog) out["!type"] = "dialog";
						break; // TODO
					case 'XF': XFs.push(val); break;
					case 'ExtSST': break; // TODO
					case 'BookExt': break; // TODO
					case 'RichTextStream': break;
					case 'BkHim': break;
	
					case 'SupBook':
						supbooks.push([val]);
						supbooks[supbooks.length-1].XTI = [];
						break;
					case 'ExternName':
						supbooks[supbooks.length-1].push(val);
						break;
					case 'Index': break; // TODO
					case 'Lbl':
						last_lbl = ({
							Name: val.Name,
							Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
						});
						if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
						supbooks.names.push(last_lbl);
						if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length-1].push(val);
						if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
							if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
								FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
						break;
					case 'ExternCount': opts.ExternCount = val; break;
					case 'ExternSheet':
						if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
					case 'NameCmt':
						/* TODO: search for correct name */
						if(opts.biff < 8) break;
						if(last_lbl != null) last_lbl.Comment = val[1];
						break;
	
					case 'Protect': out["!protect"] = val; break; /* for sheet or book */
					case 'Password': if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
					case 'Prot4Rev': case 'Prot4RevPass': break; /*TODO: Revision Control*/
	
					case 'BoundSheet8': {
						Directory[val.pos] = val;
						opts.snames.push(val.name);
					} break;
					case 'EOF': {
						if(--file_depth) break;
						if(range.e) {
							if(range.e.r > 0 && range.e.c > 0) {
								range.e.r--; range.e.c--;
								out["!ref"] = encode_range(range);
								range.e.r++; range.e.c++;
							}
							if(merges.length > 0) out["!merges"] = merges;
							if(objects.length > 0) out["!objects"] = objects;
							if(colinfo.length > 0) out["!cols"] = colinfo;
							if(rowinfo.length > 0) out["!rows"] = rowinfo;
							Workbook.Sheets.push(wsprops);
						}
						if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
						out = ((options.dense ? [] : {}));
					} break;
					case 'BOF': {
						if(opts.biff === 8) opts.biff = {
	0x0009:2,
	0x0209:3,
	0x0409:4
						}[RecordType] || {
	0x0500:5,
	0x0600:8,
	0x0002:2,
	0x0007:2
						}[val.BIFFVer] || 8;
						if(file_depth++) break;
						cell_valid = true;
						out = ((options.dense ? [] : {}));
	
						if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
						if(opts.biff < 5) {
							if(cur_sheet === "") cur_sheet = "Sheet1";
							range = {s:{r:0,c:0},e:{r:0,c:0}};
							/* fake BoundSheet8 */
							var fakebs8 = {pos: blob.l - length, name:cur_sheet};
							Directory[fakebs8.pos] = fakebs8;
							opts.snames.push(cur_sheet);
						}
						else cur_sheet = (Directory[s] || {name:""}).name;
						if(val.dt == 0x20) out["!type"] = "chart";
						if(val.dt == 0x40) out["!type"] = "macro";
						merges = [];
						objects = [];
						opts.arrayf = arrayf = [];
						colinfo = []; rowinfo = [];
						defwidth = defheight = 0;
						seencol = false;
						wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
					} break;
	
					case 'Number': case 'BIFF2NUM': case 'BIFF2INT': {
						if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'BoolErr': {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'RK': {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'MulRk': {
						for(var j = val.c; j <= val.C; ++j) {
							var ixfe = val.rkrec[j-val.c][0];
							temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:j, r:val.r}, temp_val, options);
						}
					} break;
					case 'Formula': {
						if(val.val == 'String') { last_formula = val; break; }
						temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							var _f = val.formula;
							if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
								var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
								var _fe = encode_cell({r:_fr, c:_fc});
								if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
								else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
							} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(val.cell, temp_val, options);
						last_formula = val;
					} break;
					case 'String': {
						if(last_formula) { /* technically always true */
							last_formula.val = val;
							temp_val = make_cell(val, last_formula.cell.ixfe, 's');
							temp_val.XF = XFs[temp_val.ixfe];
							if(options.cellFormula) {
								temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
							}
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell(last_formula.cell, temp_val, options);
							last_formula = null;
						} else throw new Error("String record expects Formula");
					} break;
					case 'Array': {
						arrayf.push(val);
						var _arraystart = encode_cell(val[0].s);
						cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
						if(options.cellFormula && cc) {
							if(!last_formula) break; /* technically unreachable */
							if(!_arraystart || !cc) break;
							cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
							cc.F = encode_range(val[0]);
						}
					} break;
					case 'ShrFmla': {
						if(!cell_valid) break;
						if(!options.cellFormula) break;
						if(last_cell) {
							/* TODO: capture range */
							if(!last_formula) break; /* technically unreachable */
							sharedf[encode_cell(last_formula.cell)]= val[0];
							cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
							(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
						}
					} break;
					case 'LabelSst':
						temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 'Blank': if(options.sheetStubs) {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'MulBlank': if(options.sheetStubs) {
						for(var _j = val.c; _j <= val.C; ++_j) {
							var _ixfe = val.ixfe[_j-val.c];
							temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:_j, r:val.r}, temp_val, options);
						}
					} break;
					case 'RString':
					case 'Label': case 'BIFF2STR':
						temp_val=make_cell(val.val, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
	
					case 'Dimensions': {
						if(file_depth === 1) range = val; /* TODO: stack */
					} break;
					case 'SST': {
						sst = val;
					} break;
					case 'Format': { /* val = [id, fmt] */
						if(opts.biff == 4) {
							BIFF2FmtTable[BIFF2Fmt++] = val[1];
							for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(SSF._table[b4idx] == val[1]) break;
							if(b4idx >= 163) SSF.load(val[1], BIFF2Fmt + 163);
						}
						else SSF.load(val[1], val[0]);
					} break;
					case 'BIFF2FORMAT': {
						BIFF2FmtTable[BIFF2Fmt++] = val;
						for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(SSF._table[b2idx] == val) break;
						if(b2idx >= 163) SSF.load(val, BIFF2Fmt + 163);
					} break;
	
					case 'MergeCells': merges = merges.concat(val); break;
	
					case 'Obj': objects[val.cmo[0]] = opts.lastobj = val; break;
					case 'TxO': opts.lastobj.TxO = val; break;
					case 'ImData': opts.lastobj.ImData = val; break;
	
					case 'HLink': {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc) cc.l = val[1];
							}
					} break;
					case 'HLinkTooltip': {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc) cc.l.Tooltip = val[1];
								}
					} break;
	
					/* Comments */
					case 'Note': {
						if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
						cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
						var noteobj = objects[val[2]];
						if(!cc) break;
						if(!cc.c) cc.c = [];
						cmnt = {a:val[1],t:noteobj.TxO.t};
						cc.c.push(cmnt);
					} break;
	
					default: switch(R.n) { /* nested */
					case 'ClrtClient': break;
					case 'XFExt': update_xfext(XFs[val.ixfe], val.ext); break;
	
					case 'DefColWidth': defwidth = val; break;
					case 'DefaultRowHeight': defheight = val[1]; break; // TODO: flags
	
					case 'ColInfo': {
						if(!opts.cellStyles) break;
						while(val.e >= val.s) {
							colinfo[val.e--] = { width: val.w/256 };
							if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
							process_col(colinfo[val.e+1]);
						}
					} break;
					case 'Row': {
						var rowobj = {};
						if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
						if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
						if(val.hpt) {
							rowinfo[val.r] = rowobj;
							rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
						}
					} break;
	
					case 'LeftMargin':
					case 'RightMargin':
					case 'TopMargin':
					case 'BottomMargin':
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'][Rn.slice(0,-6).toLowerCase()] = val;
						break;
	
					case 'Setup': // TODO
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'].header = val.header;
						out['!margins'].footer = val.footer;
						break;
	
					case 'Window2': // TODO
						// $FlowIgnore
						if(val.RTL) Workbook.Views[0].RTL = true;
						break;
	
					case 'Header': break; // TODO
					case 'Footer': break; // TODO
					case 'HCenter': break; // TODO
					case 'VCenter': break; // TODO
					case 'Pls': break; // TODO
					case 'GCW': break;
					case 'LHRecord': break;
					case 'DBCell': break; // TODO
					case 'EntExU2': break; // TODO
					case 'SxView': break; // TODO
					case 'Sxvd': break; // TODO
					case 'SXVI': break; // TODO
					case 'SXVDEx': break; // TODO
					case 'SxIvd': break; // TODO
					case 'SXString': break; // TODO
					case 'Sync': break;
					case 'Addin': break;
					case 'SXDI': break; // TODO
					case 'SXLI': break; // TODO
					case 'SXEx': break; // TODO
					case 'QsiSXTag': break; // TODO
					case 'Selection': break;
					case 'Feat': break;
					case 'FeatHdr': case 'FeatHdr11': break;
					case 'Feature11': case 'Feature12': case 'List12': break;
					case 'Country': country = val; break;
					case 'RecalcId': break;
					case 'DxGCol': break; // TODO: htmlify
					case 'Fbi': case 'Fbi2': case 'GelFrame': break;
					case 'Font': break; // TODO
					case 'XFCRC': break; // TODO
					case 'Style': break; // TODO
					case 'StyleExt': break; // TODO
					case 'Palette': palette = val; break;
					case 'Theme': themes = val; break;
					/* Protection */
					case 'ScenarioProtect': break;
					case 'ObjProtect': break;
	
					/* Conditional Formatting */
					case 'CondFmt12': break;
	
					/* Table */
					case 'Table': break; // TODO
					case 'TableStyles': break; // TODO
					case 'TableStyle': break; // TODO
					case 'TableStyleElement': break; // TODO
	
					/* PivotTable */
					case 'SXStreamID': break; // TODO
					case 'SXVS': break; // TODO
					case 'DConRef': break; // TODO
					case 'SXAddl': break; // TODO
					case 'DConBin': break; // TODO
					case 'DConName': break; // TODO
					case 'SXPI': break; // TODO
					case 'SxFormat': break; // TODO
					case 'SxSelect': break; // TODO
					case 'SxRule': break; // TODO
					case 'SxFilt': break; // TODO
					case 'SxItm': break; // TODO
					case 'SxDXF': break; // TODO
	
					/* Scenario Manager */
					case 'ScenMan': break;
	
					/* Data Consolidation */
					case 'DCon': break;
	
					/* Watched Cell */
					case 'CellWatch': break;
	
					/* Print Settings */
					case 'PrintRowCol': break;
					case 'PrintGrid': break;
					case 'PrintSize': break;
	
					case 'XCT': break;
					case 'CRN': break;
	
					case 'Scl': {
						//console.log("Zoom Level:", val[0]/val[1],val);
					} break;
					case 'SheetExt': {
						/* empty */
					} break;
					case 'SheetExtOptional': {
						/* empty */
					} break;
	
					/* VBA */
					case 'ObNoMacros': {
						/* empty */
					} break;
					case 'ObProj': {
						/* empty */
					} break;
					case 'CodeName': {
	if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
						else wsprops.CodeName = val || wsprops.name;
					} break;
					case 'GUIDTypeLib': {
						/* empty */
					} break;
	
					case 'WOpt': break; // TODO: WTF?
					case 'PhoneticInfo': break;
	
					case 'OleObjectSize': break;
	
					/* Differential Formatting */
					case 'DXF': case 'DXFN': case 'DXFN12': case 'DXFN12List': case 'DXFN12NoCB': break;
	
					/* Data Validation */
					case 'Dv': case 'DVal': break;
	
					/* Data Series */
					case 'BRAI': case 'Series': case 'SeriesText': break;
	
					/* Data Connection */
					case 'DConn': break;
					case 'DbOrParamQry': break;
					case 'DBQueryExt': break;
	
					case 'OleDbConn': break;
					case 'ExtString': break;
	
					/* Formatting */
					case 'IFmtRecord': break;
					case 'CondFmt': case 'CF': case 'CF12': case 'CFEx': break;
	
					/* Explicitly Ignored */
					case 'Excel9File': break;
					case 'Units': break;
					case 'InterfaceHdr': case 'Mms': case 'InterfaceEnd': case 'DSF': break;
					case 'BuiltInFnGroupCount': /* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */ break;
					/* View Stuff */
					case 'Window1': case 'HideObj': case 'GridSet': case 'Guts':
					case 'UserBView': case 'UserSViewBegin': case 'UserSViewEnd':
					case 'Pane': break;
					default: switch(R.n) { /* nested */
					/* Chart */
					case 'Dat':
					case 'Begin': case 'End':
					case 'StartBlock': case 'EndBlock':
					case 'Frame': case 'Area':
					case 'Axis': case 'AxisLine': case 'Tick': break;
					case 'AxesUsed':
					case 'CrtLayout12': case 'CrtLayout12A': case 'CrtLink': case 'CrtLine': case 'CrtMlFrt': case 'CrtMlFrtContinue': break;
					case 'LineFormat': case 'AreaFormat':
					case 'Chart': case 'Chart3d': case 'Chart3DBarShape': case 'ChartFormat': case 'ChartFrtInfo': break;
					case 'PlotArea': case 'PlotGrowth': break;
					case 'SeriesList': case 'SerParent': case 'SerAuxTrend': break;
					case 'DataFormat': case 'SerToCrt': case 'FontX': break;
					case 'CatSerRange': case 'AxcExt': case 'SerFmt': break;
					case 'ShtProps': break;
					case 'DefaultText': case 'Text': case 'CatLab': break;
					case 'DataLabExtContents': break;
					case 'Legend': case 'LegendException': break;
					case 'Pie': case 'Scatter': break;
					case 'PieFormat': case 'MarkerFormat': break;
					case 'StartObject': case 'EndObject': break;
					case 'AlRuns': case 'ObjectLink': break;
					case 'SIIndex': break;
					case 'AttachedLabel': case 'YMult': break;
	
					/* Chart Group */
					case 'Line': case 'Bar': break;
					case 'Surf': break;
	
					/* Axis Group */
					case 'AxisParent': break;
					case 'Pos': break;
					case 'ValueRange': break;
	
					/* Pivot Chart */
					case 'SXViewEx9': break; // TODO
					case 'SXViewLink': break;
					case 'PivotChartBits': break;
					case 'SBaseRef': break;
					case 'TextPropsStream': break;
	
					/* Chart Misc */
					case 'LnExt': break;
					case 'MkrExt': break;
					case 'CrtCoopt': break;
	
					/* Query Table */
					case 'Qsi': case 'Qsif': case 'Qsir': case 'QsiSXTag': break;
					case 'TxtQry': break;
	
					/* Filter */
					case 'FilterMode': break;
					case 'AutoFilter': case 'AutoFilterInfo': break;
					case 'AutoFilter12': break;
					case 'DropDownObjIds': break;
					case 'Sort': break;
					case 'SortData': break;
	
					/* Drawing */
					case 'ShapePropsStream': break;
					case 'MsoDrawing': case 'MsoDrawingGroup': case 'MsoDrawingSelection': break;
					/* Pub Stuff */
					case 'WebPub': case 'AutoWebPub': break;
	
					/* Print Stuff */
					case 'HeaderFooter': case 'HFPicture': case 'PLV':
					case 'HorizontalPageBreaks': case 'VerticalPageBreaks': break;
					/* Behavioral */
					case 'Backup': case 'CompressPictures': case 'Compat12': break;
	
					/* Should not Happen */
					case 'Continue': case 'ContinueFrt12': break;
	
					/* Future Records */
					case 'FrtFontList': case 'FrtWrapper': break;
	
					default: switch(R.n) { /* nested */
					/* BIFF5 records */
					case 'TabIdConf': case 'Radar': case 'RadarArea': case 'DropBar': case 'Intl': case 'CoordList': case 'SerAuxErrBar': break;
	
					/* BIFF2-4 records */
					case 'BIFF2FONTCLR': case 'BIFF2FMTCNT': case 'BIFF2FONTXTRA': break;
					case 'BIFF2XF': case 'BIFF3XF': case 'BIFF4XF': break;
					case 'BIFF4FMTCNT': case 'BIFF2ROW': case 'BIFF2WINDOW2': break;
	
					/* Miscellaneous */
					case 'SCENARIO': case 'DConBin': case 'PicF': case 'DataLabExt':
					case 'Lel': case 'BopPop': case 'BopPopCustom': case 'RealTimeData':
					case 'Name': break;
					case 'LHNGraph': case 'FnGroupName': case 'AddMenu': case 'LPr': break;
					case 'ListObj': case 'ListField': break;
					case 'RRSort': break;
					case 'BigName': break;
					case 'ToolbarHdr': case 'ToolbarEnd': break;
					case 'DDEObjName': break;
					case 'FRTArchId$': break;
					default: if(options.WTF) throw 'Unrecognized Record ' + R.n;
				}}}}
			} else blob.l += length;
		}
		wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
		if(!options.bookSheets) wb.Sheets=Sheets;
		if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
		wb.Preamble=Preamble;
		wb.Strings = sst;
		wb.SSF = SSF.get_table();
		if(opts.enc) wb.Encryption = opts.enc;
		if(themes) wb.Themes = themes;
		wb.Metadata = {};
		if(country !== undefined) wb.Metadata.Country = country;
		if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
		wb.Workbook = Workbook;
		return wb;
	}
	
	/* TODO: WTF */
	function parse_props(cfb, props, o) {
		/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
		var DSI = CFB.find(cfb, '!DocumentSummaryInformation');
		if(DSI) try {
			var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI);
			for(var d in DocSummary) props[d] = DocSummary[d];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
		var SI = CFB.find(cfb, '!SummaryInformation');
		if(SI) try {
			var Summary = parse_PropertySetStream(SI, SummaryPIDSI);
			for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	}
	
	function parse_xlscfb(cfb, options) {
	if(!options) options = {};
	fix_read_opts(options);
	reset_cp();
	if(options.codepage) set_ansi(options.codepage);
	var CompObj, WB;
	if(cfb.FullPaths) {
		if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
		CompObj = CFB.find(cfb, '!CompObj');
		WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
	} else {
		switch(options.type) {
			case 'base64': cfb = s2a(Base64.decode(cfb)); break;
			case 'binary': cfb = s2a(cfb); break;
			case 'buffer': break;
			case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
		}
		prep_blob(cfb, 0);
		WB = ({content: cfb});
	}
	var WorkbookP;
	
	var _data;
	if(CompObj) parse_compobj(CompObj);
	if(options.bookProps && !options.bookSheets) WorkbookP = ({});
	else {
		var T = has_buf ? 'buffer' : 'array';
		if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
		/* Quattro Pro 7-8 */
		else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Quattro Pro 9 */
		else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		else throw new Error("Cannot find Workbook stream");
		if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
	}
	
	var props = {};
	if(cfb.FullPaths) parse_props(cfb, props, options);
	
	WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
	if(options.bookFiles) WorkbookP.cfb = cfb;
	/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
	return WorkbookP;
	}
	
	
	function write_xlscfb(wb, opts) {
		var o = opts || {};
		var cfb = CFB.utils.cfb_new({root:"R"});
		var wbpath = "/Workbook";
		switch(o.bookType || "xls") {
			case "xls": o.bookType = "biff8";
			/* falls through */
			case "xla": if(!o.bookType) o.bookType = "xla";
			/* falls through */
			case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
			case "biff5": wbpath = "/Book"; o.biff = 5; break;
			default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
		}
		CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
		// TODO: SI, DSI, CO
		if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
		return cfb;
	}
	/* [MS-XLSB] 2.3 Record Enumeration */
	var XLSBRecordEnum = {
	0x0000: { n:"BrtRowHdr", f:parse_BrtRowHdr },
	0x0001: { n:"BrtCellBlank", f:parse_BrtCellBlank },
	0x0002: { n:"BrtCellRk", f:parse_BrtCellRk },
	0x0003: { n:"BrtCellError", f:parse_BrtCellError },
	0x0004: { n:"BrtCellBool", f:parse_BrtCellBool },
	0x0005: { n:"BrtCellReal", f:parse_BrtCellReal },
	0x0006: { n:"BrtCellSt", f:parse_BrtCellSt },
	0x0007: { n:"BrtCellIsst", f:parse_BrtCellIsst },
	0x0008: { n:"BrtFmlaString", f:parse_BrtFmlaString },
	0x0009: { n:"BrtFmlaNum", f:parse_BrtFmlaNum },
	0x000A: { n:"BrtFmlaBool", f:parse_BrtFmlaBool },
	0x000B: { n:"BrtFmlaError", f:parse_BrtFmlaError },
	0x0010: { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ },
	0x0013: { n:"BrtSSTItem", f:parse_RichStr },
	0x0014: { n:"BrtPCDIMissing" },
	0x0015: { n:"BrtPCDINumber" },
	0x0016: { n:"BrtPCDIBoolean" },
	0x0017: { n:"BrtPCDIError" },
	0x0018: { n:"BrtPCDIString" },
	0x0019: { n:"BrtPCDIDatetime" },
	0x001A: { n:"BrtPCDIIndex" },
	0x001B: { n:"BrtPCDIAMissing" },
	0x001C: { n:"BrtPCDIANumber" },
	0x001D: { n:"BrtPCDIABoolean" },
	0x001E: { n:"BrtPCDIAError" },
	0x001F: { n:"BrtPCDIAString" },
	0x0020: { n:"BrtPCDIADatetime" },
	0x0021: { n:"BrtPCRRecord" },
	0x0022: { n:"BrtPCRRecordDt" },
	0x0023: { n:"BrtFRTBegin" },
	0x0024: { n:"BrtFRTEnd" },
	0x0025: { n:"BrtACBegin" },
	0x0026: { n:"BrtACEnd" },
	0x0027: { n:"BrtName", f:parse_BrtName },
	0x0028: { n:"BrtIndexRowBlock" },
	0x002A: { n:"BrtIndexBlock" },
	0x002B: { n:"BrtFont", f:parse_BrtFont },
	0x002C: { n:"BrtFmt", f:parse_BrtFmt },
	0x002D: { n:"BrtFill", f:parse_BrtFill },
	0x002E: { n:"BrtBorder", f:parse_BrtBorder },
	0x002F: { n:"BrtXF", f:parse_BrtXF },
	0x0030: { n:"BrtStyle" },
	0x0031: { n:"BrtCellMeta" },
	0x0032: { n:"BrtValueMeta" },
	0x0033: { n:"BrtMdb" },
	0x0034: { n:"BrtBeginFmd" },
	0x0035: { n:"BrtEndFmd" },
	0x0036: { n:"BrtBeginMdx" },
	0x0037: { n:"BrtEndMdx" },
	0x0038: { n:"BrtBeginMdxTuple" },
	0x0039: { n:"BrtEndMdxTuple" },
	0x003A: { n:"BrtMdxMbrIstr" },
	0x003B: { n:"BrtStr" },
	0x003C: { n:"BrtColInfo", f:parse_ColInfo },
	0x003E: { n:"BrtCellRString" },
	0x003F: { n:"BrtCalcChainItem$", f:parse_BrtCalcChainItem$ },
	0x0040: { n:"BrtDVal" },
	0x0041: { n:"BrtSxvcellNum" },
	0x0042: { n:"BrtSxvcellStr" },
	0x0043: { n:"BrtSxvcellBool" },
	0x0044: { n:"BrtSxvcellErr" },
	0x0045: { n:"BrtSxvcellDate" },
	0x0046: { n:"BrtSxvcellNil" },
	0x0080: { n:"BrtFileVersion" },
	0x0081: { n:"BrtBeginSheet" },
	0x0082: { n:"BrtEndSheet" },
	0x0083: { n:"BrtBeginBook", f:parsenoop, p:0 },
	0x0084: { n:"BrtEndBook" },
	0x0085: { n:"BrtBeginWsViews" },
	0x0086: { n:"BrtEndWsViews" },
	0x0087: { n:"BrtBeginBookViews" },
	0x0088: { n:"BrtEndBookViews" },
	0x0089: { n:"BrtBeginWsView", f:parse_BrtBeginWsView },
	0x008A: { n:"BrtEndWsView" },
	0x008B: { n:"BrtBeginCsViews" },
	0x008C: { n:"BrtEndCsViews" },
	0x008D: { n:"BrtBeginCsView" },
	0x008E: { n:"BrtEndCsView" },
	0x008F: { n:"BrtBeginBundleShs" },
	0x0090: { n:"BrtEndBundleShs" },
	0x0091: { n:"BrtBeginSheetData" },
	0x0092: { n:"BrtEndSheetData" },
	0x0093: { n:"BrtWsProp", f:parse_BrtWsProp },
	0x0094: { n:"BrtWsDim", f:parse_BrtWsDim, p:16 },
	0x0097: { n:"BrtPane" },
	0x0098: { n:"BrtSel" },
	0x0099: { n:"BrtWbProp", f:parse_BrtWbProp },
	0x009A: { n:"BrtWbFactoid" },
	0x009B: { n:"BrtFileRecover" },
	0x009C: { n:"BrtBundleSh", f:parse_BrtBundleSh },
	0x009D: { n:"BrtCalcProp" },
	0x009E: { n:"BrtBookView" },
	0x009F: { n:"BrtBeginSst", f:parse_BrtBeginSst },
	0x00A0: { n:"BrtEndSst" },
	0x00A1: { n:"BrtBeginAFilter", f:parse_UncheckedRfX },
	0x00A2: { n:"BrtEndAFilter" },
	0x00A3: { n:"BrtBeginFilterColumn" },
	0x00A4: { n:"BrtEndFilterColumn" },
	0x00A5: { n:"BrtBeginFilters" },
	0x00A6: { n:"BrtEndFilters" },
	0x00A7: { n:"BrtFilter" },
	0x00A8: { n:"BrtColorFilter" },
	0x00A9: { n:"BrtIconFilter" },
	0x00AA: { n:"BrtTop10Filter" },
	0x00AB: { n:"BrtDynamicFilter" },
	0x00AC: { n:"BrtBeginCustomFilters" },
	0x00AD: { n:"BrtEndCustomFilters" },
	0x00AE: { n:"BrtCustomFilter" },
	0x00AF: { n:"BrtAFilterDateGroupItem" },
	0x00B0: { n:"BrtMergeCell", f:parse_BrtMergeCell },
	0x00B1: { n:"BrtBeginMergeCells" },
	0x00B2: { n:"BrtEndMergeCells" },
	0x00B3: { n:"BrtBeginPivotCacheDef" },
	0x00B4: { n:"BrtEndPivotCacheDef" },
	0x00B5: { n:"BrtBeginPCDFields" },
	0x00B6: { n:"BrtEndPCDFields" },
	0x00B7: { n:"BrtBeginPCDField" },
	0x00B8: { n:"BrtEndPCDField" },
	0x00B9: { n:"BrtBeginPCDSource" },
	0x00BA: { n:"BrtEndPCDSource" },
	0x00BB: { n:"BrtBeginPCDSRange" },
	0x00BC: { n:"BrtEndPCDSRange" },
	0x00BD: { n:"BrtBeginPCDFAtbl" },
	0x00BE: { n:"BrtEndPCDFAtbl" },
	0x00BF: { n:"BrtBeginPCDIRun" },
	0x00C0: { n:"BrtEndPCDIRun" },
	0x00C1: { n:"BrtBeginPivotCacheRecords" },
	0x00C2: { n:"BrtEndPivotCacheRecords" },
	0x00C3: { n:"BrtBeginPCDHierarchies" },
	0x00C4: { n:"BrtEndPCDHierarchies" },
	0x00C5: { n:"BrtBeginPCDHierarchy" },
	0x00C6: { n:"BrtEndPCDHierarchy" },
	0x00C7: { n:"BrtBeginPCDHFieldsUsage" },
	0x00C8: { n:"BrtEndPCDHFieldsUsage" },
	0x00C9: { n:"BrtBeginExtConnection" },
	0x00CA: { n:"BrtEndExtConnection" },
	0x00CB: { n:"BrtBeginECDbProps" },
	0x00CC: { n:"BrtEndECDbProps" },
	0x00CD: { n:"BrtBeginECOlapProps" },
	0x00CE: { n:"BrtEndECOlapProps" },
	0x00CF: { n:"BrtBeginPCDSConsol" },
	0x00D0: { n:"BrtEndPCDSConsol" },
	0x00D1: { n:"BrtBeginPCDSCPages" },
	0x00D2: { n:"BrtEndPCDSCPages" },
	0x00D3: { n:"BrtBeginPCDSCPage" },
	0x00D4: { n:"BrtEndPCDSCPage" },
	0x00D5: { n:"BrtBeginPCDSCPItem" },
	0x00D6: { n:"BrtEndPCDSCPItem" },
	0x00D7: { n:"BrtBeginPCDSCSets" },
	0x00D8: { n:"BrtEndPCDSCSets" },
	0x00D9: { n:"BrtBeginPCDSCSet" },
	0x00DA: { n:"BrtEndPCDSCSet" },
	0x00DB: { n:"BrtBeginPCDFGroup" },
	0x00DC: { n:"BrtEndPCDFGroup" },
	0x00DD: { n:"BrtBeginPCDFGItems" },
	0x00DE: { n:"BrtEndPCDFGItems" },
	0x00DF: { n:"BrtBeginPCDFGRange" },
	0x00E0: { n:"BrtEndPCDFGRange" },
	0x00E1: { n:"BrtBeginPCDFGDiscrete" },
	0x00E2: { n:"BrtEndPCDFGDiscrete" },
	0x00E3: { n:"BrtBeginPCDSDTupleCache" },
	0x00E4: { n:"BrtEndPCDSDTupleCache" },
	0x00E5: { n:"BrtBeginPCDSDTCEntries" },
	0x00E6: { n:"BrtEndPCDSDTCEntries" },
	0x00E7: { n:"BrtBeginPCDSDTCEMembers" },
	0x00E8: { n:"BrtEndPCDSDTCEMembers" },
	0x00E9: { n:"BrtBeginPCDSDTCEMember" },
	0x00EA: { n:"BrtEndPCDSDTCEMember" },
	0x00EB: { n:"BrtBeginPCDSDTCQueries" },
	0x00EC: { n:"BrtEndPCDSDTCQueries" },
	0x00ED: { n:"BrtBeginPCDSDTCQuery" },
	0x00EE: { n:"BrtEndPCDSDTCQuery" },
	0x00EF: { n:"BrtBeginPCDSDTCSets" },
	0x00F0: { n:"BrtEndPCDSDTCSets" },
	0x00F1: { n:"BrtBeginPCDSDTCSet" },
	0x00F2: { n:"BrtEndPCDSDTCSet" },
	0x00F3: { n:"BrtBeginPCDCalcItems" },
	0x00F4: { n:"BrtEndPCDCalcItems" },
	0x00F5: { n:"BrtBeginPCDCalcItem" },
	0x00F6: { n:"BrtEndPCDCalcItem" },
	0x00F7: { n:"BrtBeginPRule" },
	0x00F8: { n:"BrtEndPRule" },
	0x00F9: { n:"BrtBeginPRFilters" },
	0x00FA: { n:"BrtEndPRFilters" },
	0x00FB: { n:"BrtBeginPRFilter" },
	0x00FC: { n:"BrtEndPRFilter" },
	0x00FD: { n:"BrtBeginPNames" },
	0x00FE: { n:"BrtEndPNames" },
	0x00FF: { n:"BrtBeginPName" },
	0x0100: { n:"BrtEndPName" },
	0x0101: { n:"BrtBeginPNPairs" },
	0x0102: { n:"BrtEndPNPairs" },
	0x0103: { n:"BrtBeginPNPair" },
	0x0104: { n:"BrtEndPNPair" },
	0x0105: { n:"BrtBeginECWebProps" },
	0x0106: { n:"BrtEndECWebProps" },
	0x0107: { n:"BrtBeginEcWpTables" },
	0x0108: { n:"BrtEndECWPTables" },
	0x0109: { n:"BrtBeginECParams" },
	0x010A: { n:"BrtEndECParams" },
	0x010B: { n:"BrtBeginECParam" },
	0x010C: { n:"BrtEndECParam" },
	0x010D: { n:"BrtBeginPCDKPIs" },
	0x010E: { n:"BrtEndPCDKPIs" },
	0x010F: { n:"BrtBeginPCDKPI" },
	0x0110: { n:"BrtEndPCDKPI" },
	0x0111: { n:"BrtBeginDims" },
	0x0112: { n:"BrtEndDims" },
	0x0113: { n:"BrtBeginDim" },
	0x0114: { n:"BrtEndDim" },
	0x0115: { n:"BrtIndexPartEnd" },
	0x0116: { n:"BrtBeginStyleSheet" },
	0x0117: { n:"BrtEndStyleSheet" },
	0x0118: { n:"BrtBeginSXView" },
	0x0119: { n:"BrtEndSXVI" },
	0x011A: { n:"BrtBeginSXVI" },
	0x011B: { n:"BrtBeginSXVIs" },
	0x011C: { n:"BrtEndSXVIs" },
	0x011D: { n:"BrtBeginSXVD" },
	0x011E: { n:"BrtEndSXVD" },
	0x011F: { n:"BrtBeginSXVDs" },
	0x0120: { n:"BrtEndSXVDs" },
	0x0121: { n:"BrtBeginSXPI" },
	0x0122: { n:"BrtEndSXPI" },
	0x0123: { n:"BrtBeginSXPIs" },
	0x0124: { n:"BrtEndSXPIs" },
	0x0125: { n:"BrtBeginSXDI" },
	0x0126: { n:"BrtEndSXDI" },
	0x0127: { n:"BrtBeginSXDIs" },
	0x0128: { n:"BrtEndSXDIs" },
	0x0129: { n:"BrtBeginSXLI" },
	0x012A: { n:"BrtEndSXLI" },
	0x012B: { n:"BrtBeginSXLIRws" },
	0x012C: { n:"BrtEndSXLIRws" },
	0x012D: { n:"BrtBeginSXLICols" },
	0x012E: { n:"BrtEndSXLICols" },
	0x012F: { n:"BrtBeginSXFormat" },
	0x0130: { n:"BrtEndSXFormat" },
	0x0131: { n:"BrtBeginSXFormats" },
	0x0132: { n:"BrtEndSxFormats" },
	0x0133: { n:"BrtBeginSxSelect" },
	0x0134: { n:"BrtEndSxSelect" },
	0x0135: { n:"BrtBeginISXVDRws" },
	0x0136: { n:"BrtEndISXVDRws" },
	0x0137: { n:"BrtBeginISXVDCols" },
	0x0138: { n:"BrtEndISXVDCols" },
	0x0139: { n:"BrtEndSXLocation" },
	0x013A: { n:"BrtBeginSXLocation" },
	0x013B: { n:"BrtEndSXView" },
	0x013C: { n:"BrtBeginSXTHs" },
	0x013D: { n:"BrtEndSXTHs" },
	0x013E: { n:"BrtBeginSXTH" },
	0x013F: { n:"BrtEndSXTH" },
	0x0140: { n:"BrtBeginISXTHRws" },
	0x0141: { n:"BrtEndISXTHRws" },
	0x0142: { n:"BrtBeginISXTHCols" },
	0x0143: { n:"BrtEndISXTHCols" },
	0x0144: { n:"BrtBeginSXTDMPS" },
	0x0145: { n:"BrtEndSXTDMPs" },
	0x0146: { n:"BrtBeginSXTDMP" },
	0x0147: { n:"BrtEndSXTDMP" },
	0x0148: { n:"BrtBeginSXTHItems" },
	0x0149: { n:"BrtEndSXTHItems" },
	0x014A: { n:"BrtBeginSXTHItem" },
	0x014B: { n:"BrtEndSXTHItem" },
	0x014C: { n:"BrtBeginMetadata" },
	0x014D: { n:"BrtEndMetadata" },
	0x014E: { n:"BrtBeginEsmdtinfo" },
	0x014F: { n:"BrtMdtinfo" },
	0x0150: { n:"BrtEndEsmdtinfo" },
	0x0151: { n:"BrtBeginEsmdb" },
	0x0152: { n:"BrtEndEsmdb" },
	0x0153: { n:"BrtBeginEsfmd" },
	0x0154: { n:"BrtEndEsfmd" },
	0x0155: { n:"BrtBeginSingleCells" },
	0x0156: { n:"BrtEndSingleCells" },
	0x0157: { n:"BrtBeginList" },
	0x0158: { n:"BrtEndList" },
	0x0159: { n:"BrtBeginListCols" },
	0x015A: { n:"BrtEndListCols" },
	0x015B: { n:"BrtBeginListCol" },
	0x015C: { n:"BrtEndListCol" },
	0x015D: { n:"BrtBeginListXmlCPr" },
	0x015E: { n:"BrtEndListXmlCPr" },
	0x015F: { n:"BrtListCCFmla" },
	0x0160: { n:"BrtListTrFmla" },
	0x0161: { n:"BrtBeginExternals" },
	0x0162: { n:"BrtEndExternals" },
	0x0163: { n:"BrtSupBookSrc", f:parse_RelID},
	0x0165: { n:"BrtSupSelf" },
	0x0166: { n:"BrtSupSame" },
	0x0167: { n:"BrtSupTabs" },
	0x0168: { n:"BrtBeginSupBook" },
	0x0169: { n:"BrtPlaceholderName" },
	0x016A: { n:"BrtExternSheet", f:parse_ExternSheet },
	0x016B: { n:"BrtExternTableStart" },
	0x016C: { n:"BrtExternTableEnd" },
	0x016E: { n:"BrtExternRowHdr" },
	0x016F: { n:"BrtExternCellBlank" },
	0x0170: { n:"BrtExternCellReal" },
	0x0171: { n:"BrtExternCellBool" },
	0x0172: { n:"BrtExternCellError" },
	0x0173: { n:"BrtExternCellString" },
	0x0174: { n:"BrtBeginEsmdx" },
	0x0175: { n:"BrtEndEsmdx" },
	0x0176: { n:"BrtBeginMdxSet" },
	0x0177: { n:"BrtEndMdxSet" },
	0x0178: { n:"BrtBeginMdxMbrProp" },
	0x0179: { n:"BrtEndMdxMbrProp" },
	0x017A: { n:"BrtBeginMdxKPI" },
	0x017B: { n:"BrtEndMdxKPI" },
	0x017C: { n:"BrtBeginEsstr" },
	0x017D: { n:"BrtEndEsstr" },
	0x017E: { n:"BrtBeginPRFItem" },
	0x017F: { n:"BrtEndPRFItem" },
	0x0180: { n:"BrtBeginPivotCacheIDs" },
	0x0181: { n:"BrtEndPivotCacheIDs" },
	0x0182: { n:"BrtBeginPivotCacheID" },
	0x0183: { n:"BrtEndPivotCacheID" },
	0x0184: { n:"BrtBeginISXVIs" },
	0x0185: { n:"BrtEndISXVIs" },
	0x0186: { n:"BrtBeginColInfos" },
	0x0187: { n:"BrtEndColInfos" },
	0x0188: { n:"BrtBeginRwBrk" },
	0x0189: { n:"BrtEndRwBrk" },
	0x018A: { n:"BrtBeginColBrk" },
	0x018B: { n:"BrtEndColBrk" },
	0x018C: { n:"BrtBrk" },
	0x018D: { n:"BrtUserBookView" },
	0x018E: { n:"BrtInfo" },
	0x018F: { n:"BrtCUsr" },
	0x0190: { n:"BrtUsr" },
	0x0191: { n:"BrtBeginUsers" },
	0x0193: { n:"BrtEOF" },
	0x0194: { n:"BrtUCR" },
	0x0195: { n:"BrtRRInsDel" },
	0x0196: { n:"BrtRREndInsDel" },
	0x0197: { n:"BrtRRMove" },
	0x0198: { n:"BrtRREndMove" },
	0x0199: { n:"BrtRRChgCell" },
	0x019A: { n:"BrtRREndChgCell" },
	0x019B: { n:"BrtRRHeader" },
	0x019C: { n:"BrtRRUserView" },
	0x019D: { n:"BrtRRRenSheet" },
	0x019E: { n:"BrtRRInsertSh" },
	0x019F: { n:"BrtRRDefName" },
	0x01A0: { n:"BrtRRNote" },
	0x01A1: { n:"BrtRRConflict" },
	0x01A2: { n:"BrtRRTQSIF" },
	0x01A3: { n:"BrtRRFormat" },
	0x01A4: { n:"BrtRREndFormat" },
	0x01A5: { n:"BrtRRAutoFmt" },
	0x01A6: { n:"BrtBeginUserShViews" },
	0x01A7: { n:"BrtBeginUserShView" },
	0x01A8: { n:"BrtEndUserShView" },
	0x01A9: { n:"BrtEndUserShViews" },
	0x01AA: { n:"BrtArrFmla", f:parse_BrtArrFmla },
	0x01AB: { n:"BrtShrFmla", f:parse_BrtShrFmla },
	0x01AC: { n:"BrtTable" },
	0x01AD: { n:"BrtBeginExtConnections" },
	0x01AE: { n:"BrtEndExtConnections" },
	0x01AF: { n:"BrtBeginPCDCalcMems" },
	0x01B0: { n:"BrtEndPCDCalcMems" },
	0x01B1: { n:"BrtBeginPCDCalcMem" },
	0x01B2: { n:"BrtEndPCDCalcMem" },
	0x01B3: { n:"BrtBeginPCDHGLevels" },
	0x01B4: { n:"BrtEndPCDHGLevels" },
	0x01B5: { n:"BrtBeginPCDHGLevel" },
	0x01B6: { n:"BrtEndPCDHGLevel" },
	0x01B7: { n:"BrtBeginPCDHGLGroups" },
	0x01B8: { n:"BrtEndPCDHGLGroups" },
	0x01B9: { n:"BrtBeginPCDHGLGroup" },
	0x01BA: { n:"BrtEndPCDHGLGroup" },
	0x01BB: { n:"BrtBeginPCDHGLGMembers" },
	0x01BC: { n:"BrtEndPCDHGLGMembers" },
	0x01BD: { n:"BrtBeginPCDHGLGMember" },
	0x01BE: { n:"BrtEndPCDHGLGMember" },
	0x01BF: { n:"BrtBeginQSI" },
	0x01C0: { n:"BrtEndQSI" },
	0x01C1: { n:"BrtBeginQSIR" },
	0x01C2: { n:"BrtEndQSIR" },
	0x01C3: { n:"BrtBeginDeletedNames" },
	0x01C4: { n:"BrtEndDeletedNames" },
	0x01C5: { n:"BrtBeginDeletedName" },
	0x01C6: { n:"BrtEndDeletedName" },
	0x01C7: { n:"BrtBeginQSIFs" },
	0x01C8: { n:"BrtEndQSIFs" },
	0x01C9: { n:"BrtBeginQSIF" },
	0x01CA: { n:"BrtEndQSIF" },
	0x01CB: { n:"BrtBeginAutoSortScope" },
	0x01CC: { n:"BrtEndAutoSortScope" },
	0x01CD: { n:"BrtBeginConditionalFormatting" },
	0x01CE: { n:"BrtEndConditionalFormatting" },
	0x01CF: { n:"BrtBeginCFRule" },
	0x01D0: { n:"BrtEndCFRule" },
	0x01D1: { n:"BrtBeginIconSet" },
	0x01D2: { n:"BrtEndIconSet" },
	0x01D3: { n:"BrtBeginDatabar" },
	0x01D4: { n:"BrtEndDatabar" },
	0x01D5: { n:"BrtBeginColorScale" },
	0x01D6: { n:"BrtEndColorScale" },
	0x01D7: { n:"BrtCFVO" },
	0x01D8: { n:"BrtExternValueMeta" },
	0x01D9: { n:"BrtBeginColorPalette" },
	0x01DA: { n:"BrtEndColorPalette" },
	0x01DB: { n:"BrtIndexedColor" },
	0x01DC: { n:"BrtMargins", f:parse_BrtMargins },
	0x01DD: { n:"BrtPrintOptions" },
	0x01DE: { n:"BrtPageSetup" },
	0x01DF: { n:"BrtBeginHeaderFooter" },
	0x01E0: { n:"BrtEndHeaderFooter" },
	0x01E1: { n:"BrtBeginSXCrtFormat" },
	0x01E2: { n:"BrtEndSXCrtFormat" },
	0x01E3: { n:"BrtBeginSXCrtFormats" },
	0x01E4: { n:"BrtEndSXCrtFormats" },
	0x01E5: { n:"BrtWsFmtInfo", f:parse_BrtWsFmtInfo },
	0x01E6: { n:"BrtBeginMgs" },
	0x01E7: { n:"BrtEndMGs" },
	0x01E8: { n:"BrtBeginMGMaps" },
	0x01E9: { n:"BrtEndMGMaps" },
	0x01EA: { n:"BrtBeginMG" },
	0x01EB: { n:"BrtEndMG" },
	0x01EC: { n:"BrtBeginMap" },
	0x01ED: { n:"BrtEndMap" },
	0x01EE: { n:"BrtHLink", f:parse_BrtHLink },
	0x01EF: { n:"BrtBeginDCon" },
	0x01F0: { n:"BrtEndDCon" },
	0x01F1: { n:"BrtBeginDRefs" },
	0x01F2: { n:"BrtEndDRefs" },
	0x01F3: { n:"BrtDRef" },
	0x01F4: { n:"BrtBeginScenMan" },
	0x01F5: { n:"BrtEndScenMan" },
	0x01F6: { n:"BrtBeginSct" },
	0x01F7: { n:"BrtEndSct" },
	0x01F8: { n:"BrtSlc" },
	0x01F9: { n:"BrtBeginDXFs" },
	0x01FA: { n:"BrtEndDXFs" },
	0x01FB: { n:"BrtDXF" },
	0x01FC: { n:"BrtBeginTableStyles" },
	0x01FD: { n:"BrtEndTableStyles" },
	0x01FE: { n:"BrtBeginTableStyle" },
	0x01FF: { n:"BrtEndTableStyle" },
	0x0200: { n:"BrtTableStyleElement" },
	0x0201: { n:"BrtTableStyleClient" },
	0x0202: { n:"BrtBeginVolDeps" },
	0x0203: { n:"BrtEndVolDeps" },
	0x0204: { n:"BrtBeginVolType" },
	0x0205: { n:"BrtEndVolType" },
	0x0206: { n:"BrtBeginVolMain" },
	0x0207: { n:"BrtEndVolMain" },
	0x0208: { n:"BrtBeginVolTopic" },
	0x0209: { n:"BrtEndVolTopic" },
	0x020A: { n:"BrtVolSubtopic" },
	0x020B: { n:"BrtVolRef" },
	0x020C: { n:"BrtVolNum" },
	0x020D: { n:"BrtVolErr" },
	0x020E: { n:"BrtVolStr" },
	0x020F: { n:"BrtVolBool" },
	0x0210: { n:"BrtBeginCalcChain$" },
	0x0211: { n:"BrtEndCalcChain$" },
	0x0212: { n:"BrtBeginSortState" },
	0x0213: { n:"BrtEndSortState" },
	0x0214: { n:"BrtBeginSortCond" },
	0x0215: { n:"BrtEndSortCond" },
	0x0216: { n:"BrtBookProtection" },
	0x0217: { n:"BrtSheetProtection" },
	0x0218: { n:"BrtRangeProtection" },
	0x0219: { n:"BrtPhoneticInfo" },
	0x021A: { n:"BrtBeginECTxtWiz" },
	0x021B: { n:"BrtEndECTxtWiz" },
	0x021C: { n:"BrtBeginECTWFldInfoLst" },
	0x021D: { n:"BrtEndECTWFldInfoLst" },
	0x021E: { n:"BrtBeginECTwFldInfo" },
	0x0224: { n:"BrtFileSharing" },
	0x0225: { n:"BrtOleSize" },
	0x0226: { n:"BrtDrawing", f:parse_RelID },
	0x0227: { n:"BrtLegacyDrawing" },
	0x0228: { n:"BrtLegacyDrawingHF" },
	0x0229: { n:"BrtWebOpt" },
	0x022A: { n:"BrtBeginWebPubItems" },
	0x022B: { n:"BrtEndWebPubItems" },
	0x022C: { n:"BrtBeginWebPubItem" },
	0x022D: { n:"BrtEndWebPubItem" },
	0x022E: { n:"BrtBeginSXCondFmt" },
	0x022F: { n:"BrtEndSXCondFmt" },
	0x0230: { n:"BrtBeginSXCondFmts" },
	0x0231: { n:"BrtEndSXCondFmts" },
	0x0232: { n:"BrtBkHim" },
	0x0234: { n:"BrtColor" },
	0x0235: { n:"BrtBeginIndexedColors" },
	0x0236: { n:"BrtEndIndexedColors" },
	0x0239: { n:"BrtBeginMRUColors" },
	0x023A: { n:"BrtEndMRUColors" },
	0x023C: { n:"BrtMRUColor" },
	0x023D: { n:"BrtBeginDVals" },
	0x023E: { n:"BrtEndDVals" },
	0x0241: { n:"BrtSupNameStart" },
	0x0242: { n:"BrtSupNameValueStart" },
	0x0243: { n:"BrtSupNameValueEnd" },
	0x0244: { n:"BrtSupNameNum" },
	0x0245: { n:"BrtSupNameErr" },
	0x0246: { n:"BrtSupNameSt" },
	0x0247: { n:"BrtSupNameNil" },
	0x0248: { n:"BrtSupNameBool" },
	0x0249: { n:"BrtSupNameFmla" },
	0x024A: { n:"BrtSupNameBits" },
	0x024B: { n:"BrtSupNameEnd" },
	0x024C: { n:"BrtEndSupBook" },
	0x024D: { n:"BrtCellSmartTagProperty" },
	0x024E: { n:"BrtBeginCellSmartTag" },
	0x024F: { n:"BrtEndCellSmartTag" },
	0x0250: { n:"BrtBeginCellSmartTags" },
	0x0251: { n:"BrtEndCellSmartTags" },
	0x0252: { n:"BrtBeginSmartTags" },
	0x0253: { n:"BrtEndSmartTags" },
	0x0254: { n:"BrtSmartTagType" },
	0x0255: { n:"BrtBeginSmartTagTypes" },
	0x0256: { n:"BrtEndSmartTagTypes" },
	0x0257: { n:"BrtBeginSXFilters" },
	0x0258: { n:"BrtEndSXFilters" },
	0x0259: { n:"BrtBeginSXFILTER" },
	0x025A: { n:"BrtEndSXFilter" },
	0x025B: { n:"BrtBeginFills" },
	0x025C: { n:"BrtEndFills" },
	0x025D: { n:"BrtBeginCellWatches" },
	0x025E: { n:"BrtEndCellWatches" },
	0x025F: { n:"BrtCellWatch" },
	0x0260: { n:"BrtBeginCRErrs" },
	0x0261: { n:"BrtEndCRErrs" },
	0x0262: { n:"BrtCrashRecErr" },
	0x0263: { n:"BrtBeginFonts" },
	0x0264: { n:"BrtEndFonts" },
	0x0265: { n:"BrtBeginBorders" },
	0x0266: { n:"BrtEndBorders" },
	0x0267: { n:"BrtBeginFmts" },
	0x0268: { n:"BrtEndFmts" },
	0x0269: { n:"BrtBeginCellXFs" },
	0x026A: { n:"BrtEndCellXFs" },
	0x026B: { n:"BrtBeginStyles" },
	0x026C: { n:"BrtEndStyles" },
	0x0271: { n:"BrtBigName" },
	0x0272: { n:"BrtBeginCellStyleXFs" },
	0x0273: { n:"BrtEndCellStyleXFs" },
	0x0274: { n:"BrtBeginComments" },
	0x0275: { n:"BrtEndComments" },
	0x0276: { n:"BrtBeginCommentAuthors" },
	0x0277: { n:"BrtEndCommentAuthors" },
	0x0278: { n:"BrtCommentAuthor", f:parse_BrtCommentAuthor },
	0x0279: { n:"BrtBeginCommentList" },
	0x027A: { n:"BrtEndCommentList" },
	0x027B: { n:"BrtBeginComment", f:parse_BrtBeginComment},
	0x027C: { n:"BrtEndComment" },
	0x027D: { n:"BrtCommentText", f:parse_BrtCommentText },
	0x027E: { n:"BrtBeginOleObjects" },
	0x027F: { n:"BrtOleObject" },
	0x0280: { n:"BrtEndOleObjects" },
	0x0281: { n:"BrtBeginSxrules" },
	0x0282: { n:"BrtEndSxRules" },
	0x0283: { n:"BrtBeginActiveXControls" },
	0x0284: { n:"BrtActiveX" },
	0x0285: { n:"BrtEndActiveXControls" },
	0x0286: { n:"BrtBeginPCDSDTCEMembersSortBy" },
	0x0288: { n:"BrtBeginCellIgnoreECs" },
	0x0289: { n:"BrtCellIgnoreEC" },
	0x028A: { n:"BrtEndCellIgnoreECs" },
	0x028B: { n:"BrtCsProp", f:parse_BrtCsProp },
	0x028C: { n:"BrtCsPageSetup" },
	0x028D: { n:"BrtBeginUserCsViews" },
	0x028E: { n:"BrtEndUserCsViews" },
	0x028F: { n:"BrtBeginUserCsView" },
	0x0290: { n:"BrtEndUserCsView" },
	0x0291: { n:"BrtBeginPcdSFCIEntries" },
	0x0292: { n:"BrtEndPCDSFCIEntries" },
	0x0293: { n:"BrtPCDSFCIEntry" },
	0x0294: { n:"BrtBeginListParts" },
	0x0295: { n:"BrtListPart" },
	0x0296: { n:"BrtEndListParts" },
	0x0297: { n:"BrtSheetCalcProp" },
	0x0298: { n:"BrtBeginFnGroup" },
	0x0299: { n:"BrtFnGroup" },
	0x029A: { n:"BrtEndFnGroup" },
	0x029B: { n:"BrtSupAddin" },
	0x029C: { n:"BrtSXTDMPOrder" },
	0x029D: { n:"BrtCsProtection" },
	0x029F: { n:"BrtBeginWsSortMap" },
	0x02A0: { n:"BrtEndWsSortMap" },
	0x02A1: { n:"BrtBeginRRSort" },
	0x02A2: { n:"BrtEndRRSort" },
	0x02A3: { n:"BrtRRSortItem" },
	0x02A4: { n:"BrtFileSharingIso" },
	0x02A5: { n:"BrtBookProtectionIso" },
	0x02A6: { n:"BrtSheetProtectionIso" },
	0x02A7: { n:"BrtCsProtectionIso" },
	0x02A8: { n:"BrtRangeProtectionIso" },
	0x0400: { n:"BrtRwDescent" },
	0x0401: { n:"BrtKnownFonts" },
	0x0402: { n:"BrtBeginSXTupleSet" },
	0x0403: { n:"BrtEndSXTupleSet" },
	0x0404: { n:"BrtBeginSXTupleSetHeader" },
	0x0405: { n:"BrtEndSXTupleSetHeader" },
	0x0406: { n:"BrtSXTupleSetHeaderItem" },
	0x0407: { n:"BrtBeginSXTupleSetData" },
	0x0408: { n:"BrtEndSXTupleSetData" },
	0x0409: { n:"BrtBeginSXTupleSetRow" },
	0x040A: { n:"BrtEndSXTupleSetRow" },
	0x040B: { n:"BrtSXTupleSetRowItem" },
	0x040C: { n:"BrtNameExt" },
	0x040D: { n:"BrtPCDH14" },
	0x040E: { n:"BrtBeginPCDCalcMem14" },
	0x040F: { n:"BrtEndPCDCalcMem14" },
	0x0410: { n:"BrtSXTH14" },
	0x0411: { n:"BrtBeginSparklineGroup" },
	0x0412: { n:"BrtEndSparklineGroup" },
	0x0413: { n:"BrtSparkline" },
	0x0414: { n:"BrtSXDI14" },
	0x0415: { n:"BrtWsFmtInfoEx14" },
	0x0416: { n:"BrtBeginConditionalFormatting14" },
	0x0417: { n:"BrtEndConditionalFormatting14" },
	0x0418: { n:"BrtBeginCFRule14" },
	0x0419: { n:"BrtEndCFRule14" },
	0x041A: { n:"BrtCFVO14" },
	0x041B: { n:"BrtBeginDatabar14" },
	0x041C: { n:"BrtBeginIconSet14" },
	0x041D: { n:"BrtDVal14" },
	0x041E: { n:"BrtBeginDVals14" },
	0x041F: { n:"BrtColor14" },
	0x0420: { n:"BrtBeginSparklines" },
	0x0421: { n:"BrtEndSparklines" },
	0x0422: { n:"BrtBeginSparklineGroups" },
	0x0423: { n:"BrtEndSparklineGroups" },
	0x0425: { n:"BrtSXVD14" },
	0x0426: { n:"BrtBeginSxview14" },
	0x0427: { n:"BrtEndSxview14" },
	0x042A: { n:"BrtBeginPCD14" },
	0x042B: { n:"BrtEndPCD14" },
	0x042C: { n:"BrtBeginExtConn14" },
	0x042D: { n:"BrtEndExtConn14" },
	0x042E: { n:"BrtBeginSlicerCacheIDs" },
	0x042F: { n:"BrtEndSlicerCacheIDs" },
	0x0430: { n:"BrtBeginSlicerCacheID" },
	0x0431: { n:"BrtEndSlicerCacheID" },
	0x0433: { n:"BrtBeginSlicerCache" },
	0x0434: { n:"BrtEndSlicerCache" },
	0x0435: { n:"BrtBeginSlicerCacheDef" },
	0x0436: { n:"BrtEndSlicerCacheDef" },
	0x0437: { n:"BrtBeginSlicersEx" },
	0x0438: { n:"BrtEndSlicersEx" },
	0x0439: { n:"BrtBeginSlicerEx" },
	0x043A: { n:"BrtEndSlicerEx" },
	0x043B: { n:"BrtBeginSlicer" },
	0x043C: { n:"BrtEndSlicer" },
	0x043D: { n:"BrtSlicerCachePivotTables" },
	0x043E: { n:"BrtBeginSlicerCacheOlapImpl" },
	0x043F: { n:"BrtEndSlicerCacheOlapImpl" },
	0x0440: { n:"BrtBeginSlicerCacheLevelsData" },
	0x0441: { n:"BrtEndSlicerCacheLevelsData" },
	0x0442: { n:"BrtBeginSlicerCacheLevelData" },
	0x0443: { n:"BrtEndSlicerCacheLevelData" },
	0x0444: { n:"BrtBeginSlicerCacheSiRanges" },
	0x0445: { n:"BrtEndSlicerCacheSiRanges" },
	0x0446: { n:"BrtBeginSlicerCacheSiRange" },
	0x0447: { n:"BrtEndSlicerCacheSiRange" },
	0x0448: { n:"BrtSlicerCacheOlapItem" },
	0x0449: { n:"BrtBeginSlicerCacheSelections" },
	0x044A: { n:"BrtSlicerCacheSelection" },
	0x044B: { n:"BrtEndSlicerCacheSelections" },
	0x044C: { n:"BrtBeginSlicerCacheNative" },
	0x044D: { n:"BrtEndSlicerCacheNative" },
	0x044E: { n:"BrtSlicerCacheNativeItem" },
	0x044F: { n:"BrtRangeProtection14" },
	0x0450: { n:"BrtRangeProtectionIso14" },
	0x0451: { n:"BrtCellIgnoreEC14" },
	0x0457: { n:"BrtList14" },
	0x0458: { n:"BrtCFIcon" },
	0x0459: { n:"BrtBeginSlicerCachesPivotCacheIDs" },
	0x045A: { n:"BrtEndSlicerCachesPivotCacheIDs" },
	0x045B: { n:"BrtBeginSlicers" },
	0x045C: { n:"BrtEndSlicers" },
	0x045D: { n:"BrtWbProp14" },
	0x045E: { n:"BrtBeginSXEdit" },
	0x045F: { n:"BrtEndSXEdit" },
	0x0460: { n:"BrtBeginSXEdits" },
	0x0461: { n:"BrtEndSXEdits" },
	0x0462: { n:"BrtBeginSXChange" },
	0x0463: { n:"BrtEndSXChange" },
	0x0464: { n:"BrtBeginSXChanges" },
	0x0465: { n:"BrtEndSXChanges" },
	0x0466: { n:"BrtSXTupleItems" },
	0x0468: { n:"BrtBeginSlicerStyle" },
	0x0469: { n:"BrtEndSlicerStyle" },
	0x046A: { n:"BrtSlicerStyleElement" },
	0x046B: { n:"BrtBeginStyleSheetExt14" },
	0x046C: { n:"BrtEndStyleSheetExt14" },
	0x046D: { n:"BrtBeginSlicerCachesPivotCacheID" },
	0x046E: { n:"BrtEndSlicerCachesPivotCacheID" },
	0x046F: { n:"BrtBeginConditionalFormattings" },
	0x0470: { n:"BrtEndConditionalFormattings" },
	0x0471: { n:"BrtBeginPCDCalcMemExt" },
	0x0472: { n:"BrtEndPCDCalcMemExt" },
	0x0473: { n:"BrtBeginPCDCalcMemsExt" },
	0x0474: { n:"BrtEndPCDCalcMemsExt" },
	0x0475: { n:"BrtPCDField14" },
	0x0476: { n:"BrtBeginSlicerStyles" },
	0x0477: { n:"BrtEndSlicerStyles" },
	0x0478: { n:"BrtBeginSlicerStyleElements" },
	0x0479: { n:"BrtEndSlicerStyleElements" },
	0x047A: { n:"BrtCFRuleExt" },
	0x047B: { n:"BrtBeginSXCondFmt14" },
	0x047C: { n:"BrtEndSXCondFmt14" },
	0x047D: { n:"BrtBeginSXCondFmts14" },
	0x047E: { n:"BrtEndSXCondFmts14" },
	0x0480: { n:"BrtBeginSortCond14" },
	0x0481: { n:"BrtEndSortCond14" },
	0x0482: { n:"BrtEndDVals14" },
	0x0483: { n:"BrtEndIconSet14" },
	0x0484: { n:"BrtEndDatabar14" },
	0x0485: { n:"BrtBeginColorScale14" },
	0x0486: { n:"BrtEndColorScale14" },
	0x0487: { n:"BrtBeginSxrules14" },
	0x0488: { n:"BrtEndSxrules14" },
	0x0489: { n:"BrtBeginPRule14" },
	0x048A: { n:"BrtEndPRule14" },
	0x048B: { n:"BrtBeginPRFilters14" },
	0x048C: { n:"BrtEndPRFilters14" },
	0x048D: { n:"BrtBeginPRFilter14" },
	0x048E: { n:"BrtEndPRFilter14" },
	0x048F: { n:"BrtBeginPRFItem14" },
	0x0490: { n:"BrtEndPRFItem14" },
	0x0491: { n:"BrtBeginCellIgnoreECs14" },
	0x0492: { n:"BrtEndCellIgnoreECs14" },
	0x0493: { n:"BrtDxf14" },
	0x0494: { n:"BrtBeginDxF14s" },
	0x0495: { n:"BrtEndDxf14s" },
	0x0499: { n:"BrtFilter14" },
	0x049A: { n:"BrtBeginCustomFilters14" },
	0x049C: { n:"BrtCustomFilter14" },
	0x049D: { n:"BrtIconFilter14" },
	0x049E: { n:"BrtPivotCacheConnectionName" },
	0x0800: { n:"BrtBeginDecoupledPivotCacheIDs" },
	0x0801: { n:"BrtEndDecoupledPivotCacheIDs" },
	0x0802: { n:"BrtDecoupledPivotCacheID" },
	0x0803: { n:"BrtBeginPivotTableRefs" },
	0x0804: { n:"BrtEndPivotTableRefs" },
	0x0805: { n:"BrtPivotTableRef" },
	0x0806: { n:"BrtSlicerCacheBookPivotTables" },
	0x0807: { n:"BrtBeginSxvcells" },
	0x0808: { n:"BrtEndSxvcells" },
	0x0809: { n:"BrtBeginSxRow" },
	0x080A: { n:"BrtEndSxRow" },
	0x080C: { n:"BrtPcdCalcMem15" },
	0x0813: { n:"BrtQsi15" },
	0x0814: { n:"BrtBeginWebExtensions" },
	0x0815: { n:"BrtEndWebExtensions" },
	0x0816: { n:"BrtWebExtension" },
	0x0817: { n:"BrtAbsPath15" },
	0x0818: { n:"BrtBeginPivotTableUISettings" },
	0x0819: { n:"BrtEndPivotTableUISettings" },
	0x081B: { n:"BrtTableSlicerCacheIDs" },
	0x081C: { n:"BrtTableSlicerCacheID" },
	0x081D: { n:"BrtBeginTableSlicerCache" },
	0x081E: { n:"BrtEndTableSlicerCache" },
	0x081F: { n:"BrtSxFilter15" },
	0x0820: { n:"BrtBeginTimelineCachePivotCacheIDs" },
	0x0821: { n:"BrtEndTimelineCachePivotCacheIDs" },
	0x0822: { n:"BrtTimelineCachePivotCacheID" },
	0x0823: { n:"BrtBeginTimelineCacheIDs" },
	0x0824: { n:"BrtEndTimelineCacheIDs" },
	0x0825: { n:"BrtBeginTimelineCacheID" },
	0x0826: { n:"BrtEndTimelineCacheID" },
	0x0827: { n:"BrtBeginTimelinesEx" },
	0x0828: { n:"BrtEndTimelinesEx" },
	0x0829: { n:"BrtBeginTimelineEx" },
	0x082A: { n:"BrtEndTimelineEx" },
	0x082B: { n:"BrtWorkBookPr15" },
	0x082C: { n:"BrtPCDH15" },
	0x082D: { n:"BrtBeginTimelineStyle" },
	0x082E: { n:"BrtEndTimelineStyle" },
	0x082F: { n:"BrtTimelineStyleElement" },
	0x0830: { n:"BrtBeginTimelineStylesheetExt15" },
	0x0831: { n:"BrtEndTimelineStylesheetExt15" },
	0x0832: { n:"BrtBeginTimelineStyles" },
	0x0833: { n:"BrtEndTimelineStyles" },
	0x0834: { n:"BrtBeginTimelineStyleElements" },
	0x0835: { n:"BrtEndTimelineStyleElements" },
	0x0836: { n:"BrtDxf15" },
	0x0837: { n:"BrtBeginDxfs15" },
	0x0838: { n:"brtEndDxfs15" },
	0x0839: { n:"BrtSlicerCacheHideItemsWithNoData" },
	0x083A: { n:"BrtBeginItemUniqueNames" },
	0x083B: { n:"BrtEndItemUniqueNames" },
	0x083C: { n:"BrtItemUniqueName" },
	0x083D: { n:"BrtBeginExtConn15" },
	0x083E: { n:"BrtEndExtConn15" },
	0x083F: { n:"BrtBeginOledbPr15" },
	0x0840: { n:"BrtEndOledbPr15" },
	0x0841: { n:"BrtBeginDataFeedPr15" },
	0x0842: { n:"BrtEndDataFeedPr15" },
	0x0843: { n:"BrtTextPr15" },
	0x0844: { n:"BrtRangePr15" },
	0x0845: { n:"BrtDbCommand15" },
	0x0846: { n:"BrtBeginDbTables15" },
	0x0847: { n:"BrtEndDbTables15" },
	0x0848: { n:"BrtDbTable15" },
	0x0849: { n:"BrtBeginDataModel" },
	0x084A: { n:"BrtEndDataModel" },
	0x084B: { n:"BrtBeginModelTables" },
	0x084C: { n:"BrtEndModelTables" },
	0x084D: { n:"BrtModelTable" },
	0x084E: { n:"BrtBeginModelRelationships" },
	0x084F: { n:"BrtEndModelRelationships" },
	0x0850: { n:"BrtModelRelationship" },
	0x0851: { n:"BrtBeginECTxtWiz15" },
	0x0852: { n:"BrtEndECTxtWiz15" },
	0x0853: { n:"BrtBeginECTWFldInfoLst15" },
	0x0854: { n:"BrtEndECTWFldInfoLst15" },
	0x0855: { n:"BrtBeginECTWFldInfo15" },
	0x0856: { n:"BrtFieldListActiveItem" },
	0x0857: { n:"BrtPivotCacheIdVersion" },
	0x0858: { n:"BrtSXDI15" },
	0xFFFF: { n:"" }
	};
	
	var XLSBRE = evert_key(XLSBRecordEnum, 'n');
	
	/* [MS-XLS] 2.3 Record Enumeration */
	var XLSRecordEnum = {
	0x0003: { n:"BIFF2NUM", f:parse_BIFF2NUM },
	0x0004: { n:"BIFF2STR", f:parse_BIFF2STR },
	0x0006: { n:"Formula", f:parse_Formula },
	0x0009: { n:'BOF', f:parse_BOF },
	0x000a: { n:'EOF', f:parsenoop2 },
	0x000c: { n:"CalcCount", f:parseuint16 },
	0x000d: { n:"CalcMode", f:parseuint16 },
	0x000e: { n:"CalcPrecision", f:parsebool },
	0x000f: { n:"CalcRefMode", f:parsebool },
	0x0010: { n:"CalcDelta", f:parse_Xnum },
	0x0011: { n:"CalcIter", f:parsebool },
	0x0012: { n:"Protect", f:parsebool },
	0x0013: { n:"Password", f:parseuint16 },
	0x0014: { n:"Header", f:parse_XLHeaderFooter },
	0x0015: { n:"Footer", f:parse_XLHeaderFooter },
	0x0017: { n:"ExternSheet", f:parse_ExternSheet },
	0x0018: { n:"Lbl", f:parse_Lbl },
	0x0019: { n:"WinProtect", f:parsebool },
	0x001a: { n:"VerticalPageBreaks" },
	0x001b: { n:"HorizontalPageBreaks" },
	0x001c: { n:"Note", f:parse_Note },
	0x001d: { n:"Selection" },
	0x0022: { n:"Date1904", f:parsebool },
	0x0023: { n:"ExternName", f:parse_ExternName },
	0x0026: { n:"LeftMargin", f:parse_Xnum },
	0x0027: { n:"RightMargin", f:parse_Xnum },
	0x0028: { n:"TopMargin", f:parse_Xnum },
	0x0029: { n:"BottomMargin", f:parse_Xnum },
	0x002a: { n:"PrintRowCol", f:parsebool },
	0x002b: { n:"PrintGrid", f:parsebool },
	0x002f: { n:"FilePass", f:parse_FilePass },
	0x0031: { n:"Font", f:parse_Font },
	0x0033: { n:"PrintSize", f:parseuint16 },
	0x003c: { n:"Continue" },
	0x003d: { n:"Window1", f:parse_Window1 },
	0x0040: { n:"Backup", f:parsebool },
	0x0041: { n:"Pane" },
	0x0042: { n:'CodePage', f:parseuint16 },
	0x004d: { n:"Pls" },
	0x0050: { n:"DCon" },
	0x0051: { n:"DConRef" },
	0x0052: { n:"DConName" },
	0x0055: { n:"DefColWidth", f:parseuint16 },
	0x0059: { n:"XCT" },
	0x005a: { n:"CRN" },
	0x005b: { n:"FileSharing" },
	0x005c: { n:'WriteAccess', f:parse_WriteAccess },
	0x005d: { n:"Obj", f:parse_Obj },
	0x005e: { n:"Uncalced" },
	0x005f: { n:"CalcSaveRecalc", f:parsebool },
	0x0060: { n:"Template" },
	0x0061: { n:"Intl" },
	0x0063: { n:"ObjProtect", f:parsebool },
	0x007d: { n:"ColInfo", f:parse_ColInfo },
	0x0080: { n:"Guts", f:parse_Guts },
	0x0081: { n:"WsBool", f:parse_WsBool },
	0x0082: { n:"GridSet", f:parseuint16 },
	0x0083: { n:"HCenter", f:parsebool },
	0x0084: { n:"VCenter", f:parsebool },
	0x0085: { n:'BoundSheet8', f:parse_BoundSheet8 },
	0x0086: { n:"WriteProtect" },
	0x008c: { n:"Country", f:parse_Country },
	0x008d: { n:"HideObj", f:parseuint16 },
	0x0090: { n:"Sort" },
	0x0092: { n:"Palette", f:parse_Palette },
	0x0097: { n:"Sync" },
	0x0098: { n:"LPr" },
	0x0099: { n:"DxGCol" },
	0x009a: { n:"FnGroupName" },
	0x009b: { n:"FilterMode" },
	0x009c: { n:"BuiltInFnGroupCount", f:parseuint16 },
	0x009d: { n:"AutoFilterInfo" },
	0x009e: { n:"AutoFilter" },
	0x00a0: { n:"Scl", f:parse_Scl },
	0x00a1: { n:"Setup", f:parse_Setup },
	0x00ae: { n:"ScenMan" },
	0x00af: { n:"SCENARIO" },
	0x00b0: { n:"SxView" },
	0x00b1: { n:"Sxvd" },
	0x00b2: { n:"SXVI" },
	0x00b4: { n:"SxIvd" },
	0x00b5: { n:"SXLI" },
	0x00b6: { n:"SXPI" },
	0x00b8: { n:"DocRoute" },
	0x00b9: { n:"RecipName" },
	0x00bd: { n:"MulRk", f:parse_MulRk },
	0x00be: { n:"MulBlank", f:parse_MulBlank },
	0x00c1: { n:'Mms', f:parsenoop2 },
	0x00c5: { n:"SXDI" },
	0x00c6: { n:"SXDB" },
	0x00c7: { n:"SXFDB" },
	0x00c8: { n:"SXDBB" },
	0x00c9: { n:"SXNum" },
	0x00ca: { n:"SxBool", f:parsebool },
	0x00cb: { n:"SxErr" },
	0x00cc: { n:"SXInt" },
	0x00cd: { n:"SXString" },
	0x00ce: { n:"SXDtr" },
	0x00cf: { n:"SxNil" },
	0x00d0: { n:"SXTbl" },
	0x00d1: { n:"SXTBRGIITM" },
	0x00d2: { n:"SxTbpg" },
	0x00d3: { n:"ObProj" },
	0x00d5: { n:"SXStreamID" },
	0x00d7: { n:"DBCell" },
	0x00d8: { n:"SXRng" },
	0x00d9: { n:"SxIsxoper" },
	0x00da: { n:"BookBool", f:parseuint16 },
	0x00dc: { n:"DbOrParamQry" },
	0x00dd: { n:"ScenarioProtect", f:parsebool },
	0x00de: { n:"OleObjectSize" },
	0x00e0: { n:"XF", f:parse_XF },
	0x00e1: { n:'InterfaceHdr', f:parse_InterfaceHdr },
	0x00e2: { n:'InterfaceEnd', f:parsenoop2 },
	0x00e3: { n:"SXVS" },
	0x00e5: { n:"MergeCells", f:parse_MergeCells },
	0x00e9: { n:"BkHim" },
	0x00eb: { n:"MsoDrawingGroup" },
	0x00ec: { n:"MsoDrawing" },
	0x00ed: { n:"MsoDrawingSelection" },
	0x00ef: { n:"PhoneticInfo" },
	0x00f0: { n:"SxRule" },
	0x00f1: { n:"SXEx" },
	0x00f2: { n:"SxFilt" },
	0x00f4: { n:"SxDXF" },
	0x00f5: { n:"SxItm" },
	0x00f6: { n:"SxName" },
	0x00f7: { n:"SxSelect" },
	0x00f8: { n:"SXPair" },
	0x00f9: { n:"SxFmla" },
	0x00fb: { n:"SxFormat" },
	0x00fc: { n:"SST", f:parse_SST },
	0x00fd: { n:"LabelSst", f:parse_LabelSst },
	0x00ff: { n:"ExtSST", f:parse_ExtSST },
	0x0100: { n:"SXVDEx" },
	0x0103: { n:"SXFormula" },
	0x0122: { n:"SXDBEx" },
	0x0137: { n:"RRDInsDel" },
	0x0138: { n:"RRDHead" },
	0x013b: { n:"RRDChgCell" },
	0x013d: { n:"RRTabId", f:parseuint16a },
	0x013e: { n:"RRDRenSheet" },
	0x013f: { n:"RRSort" },
	0x0140: { n:"RRDMove" },
	0x014a: { n:"RRFormat" },
	0x014b: { n:"RRAutoFmt" },
	0x014d: { n:"RRInsertSh" },
	0x014e: { n:"RRDMoveBegin" },
	0x014f: { n:"RRDMoveEnd" },
	0x0150: { n:"RRDInsDelBegin" },
	0x0151: { n:"RRDInsDelEnd" },
	0x0152: { n:"RRDConflict" },
	0x0153: { n:"RRDDefName" },
	0x0154: { n:"RRDRstEtxp" },
	0x015f: { n:"LRng" },
	0x0160: { n:"UsesELFs", f:parsebool },
	0x0161: { n:"DSF", f:parsenoop2 },
	0x0191: { n:"CUsr" },
	0x0192: { n:"CbUsr" },
	0x0193: { n:"UsrInfo" },
	0x0194: { n:"UsrExcl" },
	0x0195: { n:"FileLock" },
	0x0196: { n:"RRDInfo" },
	0x0197: { n:"BCUsrs" },
	0x0198: { n:"UsrChk" },
	0x01a9: { n:"UserBView" },
	0x01aa: { n:"UserSViewBegin" },
	0x01ab: { n:"UserSViewEnd" },
	0x01ac: { n:"RRDUserView" },
	0x01ad: { n:"Qsi" },
	0x01ae: { n:"SupBook", f:parse_SupBook },
	0x01af: { n:"Prot4Rev", f:parsebool },
	0x01b0: { n:"CondFmt" },
	0x01b1: { n:"CF" },
	0x01b2: { n:"DVal" },
	0x01b5: { n:"DConBin" },
	0x01b6: { n:"TxO", f:parse_TxO },
	0x01b7: { n:"RefreshAll", f:parsebool },
	0x01b8: { n:"HLink", f:parse_HLink },
	0x01b9: { n:"Lel" },
	0x01ba: { n:"CodeName", f:parse_XLUnicodeString },
	0x01bb: { n:"SXFDBType" },
	0x01bc: { n:"Prot4RevPass", f:parseuint16 },
	0x01bd: { n:"ObNoMacros" },
	0x01be: { n:"Dv" },
	0x01c0: { n:"Excel9File", f:parsenoop2 },
	0x01c1: { n:"RecalcId", f:parse_RecalcId, r:2},
	0x01c2: { n:"EntExU2", f:parsenoop2 },
	0x0200: { n:"Dimensions", f:parse_Dimensions },
	0x0201: { n:"Blank", f:parse_Blank },
	0x0203: { n:"Number", f:parse_Number },
	0x0204: { n:"Label", f:parse_Label },
	0x0205: { n:"BoolErr", f:parse_BoolErr },
	0x0206: { n:"Formula", f:parse_Formula },
	0x0207: { n:"String", f:parse_String },
	0x0208: { n:'Row', f:parse_Row },
	0x020b: { n:"Index" },
	0x0221: { n:"Array", f:parse_Array },
	0x0225: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
	0x0236: { n:"Table" },
	0x023e: { n:"Window2", f:parse_Window2 },
	0x027e: { n:"RK", f:parse_RK },
	0x0293: { n:"Style" },
	0x0406: { n:"Formula", f:parse_Formula },
	0x0418: { n:"BigName" },
	0x041e: { n:"Format", f:parse_Format },
	0x043c: { n:"ContinueBigName" },
	0x04bc: { n:"ShrFmla", f:parse_ShrFmla },
	0x0800: { n:"HLinkTooltip", f:parse_HLinkTooltip },
	0x0801: { n:"WebPub" },
	0x0802: { n:"QsiSXTag" },
	0x0803: { n:"DBQueryExt" },
	0x0804: { n:"ExtString" },
	0x0805: { n:"TxtQry" },
	0x0806: { n:"Qsir" },
	0x0807: { n:"Qsif" },
	0x0808: { n:"RRDTQSIF" },
	0x0809: { n:'BOF', f:parse_BOF },
	0x080a: { n:"OleDbConn" },
	0x080b: { n:"WOpt" },
	0x080c: { n:"SXViewEx" },
	0x080d: { n:"SXTH" },
	0x080e: { n:"SXPIEx" },
	0x080f: { n:"SXVDTEx" },
	0x0810: { n:"SXViewEx9" },
	0x0812: { n:"ContinueFrt" },
	0x0813: { n:"RealTimeData" },
	0x0850: { n:"ChartFrtInfo" },
	0x0851: { n:"FrtWrapper" },
	0x0852: { n:"StartBlock" },
	0x0853: { n:"EndBlock" },
	0x0854: { n:"StartObject" },
	0x0855: { n:"EndObject" },
	0x0856: { n:"CatLab" },
	0x0857: { n:"YMult" },
	0x0858: { n:"SXViewLink" },
	0x0859: { n:"PivotChartBits" },
	0x085a: { n:"FrtFontList" },
	0x0862: { n:"SheetExt" },
	0x0863: { n:"BookExt", r:12},
	0x0864: { n:"SXAddl" },
	0x0865: { n:"CrErr" },
	0x0866: { n:"HFPicture" },
	0x0867: { n:'FeatHdr', f:parsenoop2 },
	0x0868: { n:"Feat" },
	0x086a: { n:"DataLabExt" },
	0x086b: { n:"DataLabExtContents" },
	0x086c: { n:"CellWatch" },
	0x0871: { n:"FeatHdr11" },
	0x0872: { n:"Feature11" },
	0x0874: { n:"DropDownObjIds" },
	0x0875: { n:"ContinueFrt11" },
	0x0876: { n:"DConn" },
	0x0877: { n:"List12" },
	0x0878: { n:"Feature12" },
	0x0879: { n:"CondFmt12" },
	0x087a: { n:"CF12" },
	0x087b: { n:"CFEx" },
	0x087c: { n:"XFCRC", f:parse_XFCRC, r:12 },
	0x087d: { n:"XFExt", f:parse_XFExt, r:12 },
	0x087e: { n:"AutoFilter12" },
	0x087f: { n:"ContinueFrt12" },
	0x0884: { n:"MDTInfo" },
	0x0885: { n:"MDXStr" },
	0x0886: { n:"MDXTuple" },
	0x0887: { n:"MDXSet" },
	0x0888: { n:"MDXProp" },
	0x0889: { n:"MDXKPI" },
	0x088a: { n:"MDB" },
	0x088b: { n:"PLV" },
	0x088c: { n:"Compat12", f:parsebool, r:12 },
	0x088d: { n:"DXF" },
	0x088e: { n:"TableStyles", r:12 },
	0x088f: { n:"TableStyle" },
	0x0890: { n:"TableStyleElement" },
	0x0892: { n:"StyleExt" },
	0x0893: { n:"NamePublish" },
	0x0894: { n:"NameCmt", f:parse_NameCmt, r:12 },
	0x0895: { n:"SortData" },
	0x0896: { n:"Theme", f:parse_Theme, r:12 },
	0x0897: { n:"GUIDTypeLib" },
	0x0898: { n:"FnGrp12" },
	0x0899: { n:"NameFnGrp12" },
	0x089a: { n:"MTRSettings", f:parse_MTRSettings, r:12 },
	0x089b: { n:"CompressPictures", f:parsenoop2 },
	0x089c: { n:"HeaderFooter" },
	0x089d: { n:"CrtLayout12" },
	0x089e: { n:"CrtMlFrt" },
	0x089f: { n:"CrtMlFrtContinue" },
	0x08a3: { n:"ForceFullCalculation", f:parse_ForceFullCalculation },
	0x08a4: { n:"ShapePropsStream" },
	0x08a5: { n:"TextPropsStream" },
	0x08a6: { n:"RichTextStream" },
	0x08a7: { n:"CrtLayout12A" },
	0x1001: { n:"Units" },
	0x1002: { n:"Chart" },
	0x1003: { n:"Series" },
	0x1006: { n:"DataFormat" },
	0x1007: { n:"LineFormat" },
	0x1009: { n:"MarkerFormat" },
	0x100a: { n:"AreaFormat" },
	0x100b: { n:"PieFormat" },
	0x100c: { n:"AttachedLabel" },
	0x100d: { n:"SeriesText" },
	0x1014: { n:"ChartFormat" },
	0x1015: { n:"Legend" },
	0x1016: { n:"SeriesList" },
	0x1017: { n:"Bar" },
	0x1018: { n:"Line" },
	0x1019: { n:"Pie" },
	0x101a: { n:"Area" },
	0x101b: { n:"Scatter" },
	0x101c: { n:"CrtLine" },
	0x101d: { n:"Axis" },
	0x101e: { n:"Tick" },
	0x101f: { n:"ValueRange" },
	0x1020: { n:"CatSerRange" },
	0x1021: { n:"AxisLine" },
	0x1022: { n:"CrtLink" },
	0x1024: { n:"DefaultText" },
	0x1025: { n:"Text" },
	0x1026: { n:"FontX", f:parseuint16 },
	0x1027: { n:"ObjectLink" },
	0x1032: { n:"Frame" },
	0x1033: { n:"Begin" },
	0x1034: { n:"End" },
	0x1035: { n:"PlotArea" },
	0x103a: { n:"Chart3d" },
	0x103c: { n:"PicF" },
	0x103d: { n:"DropBar" },
	0x103e: { n:"Radar" },
	0x103f: { n:"Surf" },
	0x1040: { n:"RadarArea" },
	0x1041: { n:"AxisParent" },
	0x1043: { n:"LegendException" },
	0x1044: { n:"ShtProps", f:parse_ShtProps },
	0x1045: { n:"SerToCrt" },
	0x1046: { n:"AxesUsed" },
	0x1048: { n:"SBaseRef" },
	0x104a: { n:"SerParent" },
	0x104b: { n:"SerAuxTrend" },
	0x104e: { n:"IFmtRecord" },
	0x104f: { n:"Pos" },
	0x1050: { n:"AlRuns" },
	0x1051: { n:"BRAI" },
	0x105b: { n:"SerAuxErrBar" },
	0x105c: { n:"ClrtClient", f:parse_ClrtClient },
	0x105d: { n:"SerFmt" },
	0x105f: { n:"Chart3DBarShape" },
	0x1060: { n:"Fbi" },
	0x1061: { n:"BopPop" },
	0x1062: { n:"AxcExt" },
	0x1063: { n:"Dat" },
	0x1064: { n:"PlotGrowth" },
	0x1065: { n:"SIIndex" },
	0x1066: { n:"GelFrame" },
	0x1067: { n:"BopPopCustom" },
	0x1068: { n:"Fbi2" },
	
	0x0000: { n:"Dimensions", f:parse_Dimensions },
	0x0002: { n:"BIFF2INT", f:parse_BIFF2INT },
	0x0005: { n:"BoolErr", f:parse_BoolErr },
	0x0007: { n:"String", f:parse_BIFF2STRING },
	0x0008: { n:"BIFF2ROW" },
	0x000b: { n:"Index" },
	0x0016: { n:"ExternCount", f:parseuint16 },
	0x001e: { n:"BIFF2FORMAT", f:parse_BIFF2Format },
	0x001f: { n:"BIFF2FMTCNT" }, /* 16-bit cnt of BIFF2FORMAT records */
	0x0020: { n:"BIFF2COLINFO" },
	0x0021: { n:"Array", f:parse_Array },
	0x0025: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
	0x0032: { n:"BIFF2FONTXTRA", f:parse_BIFF2FONTXTRA },
	0x0034: { n:"DDEObjName" },
	0x003e: { n:"BIFF2WINDOW2" },
	0x0043: { n:"BIFF2XF" },
	0x0045: { n:"BIFF2FONTCLR" },
	0x0056: { n:"BIFF4FMTCNT" }, /* 16-bit cnt, similar to BIFF2 */
	0x007e: { n:"RK" }, /* Not necessarily same as 0x027e */
	0x007f: { n:"ImData", f:parse_ImData },
	0x0087: { n:"Addin" },
	0x0088: { n:"Edg" },
	0x0089: { n:"Pub" },
	0x0091: { n:"Sub" },
	0x0094: { n:"LHRecord" },
	0x0095: { n:"LHNGraph" },
	0x0096: { n:"Sound" },
	0x00a9: { n:"CoordList" },
	0x00ab: { n:"GCW" },
	0x00bc: { n:"ShrFmla" }, /* Not necessarily same as 0x04bc */
	0x00bf: { n:"ToolbarHdr" },
	0x00c0: { n:"ToolbarEnd" },
	0x00c2: { n:"AddMenu" },
	0x00c3: { n:"DelMenu" },
	0x00d6: { n:"RString", f:parse_RString },
	0x00df: { n:"UDDesc" },
	0x00ea: { n:"TabIdConf" },
	0x0162: { n:"XL5Modify" },
	0x01a5: { n:"FileSharing2" },
	0x0209: { n:'BOF', f:parse_BOF },
	0x0218: { n:"Lbl", f:parse_Lbl },
	0x0223: { n:"ExternName", f:parse_ExternName },
	0x0231: { n:"Font" },
	0x0243: { n:"BIFF3XF" },
	0x0409: { n:'BOF', f:parse_BOF },
	0x0443: { n:"BIFF4XF" },
	0x086d: { n:"FeatInfo" },
	0x0873: { n:"FeatInfo11" },
	0x0881: { n:"SXAddl12" },
	0x08c0: { n:"AutoWebPub" },
	0x08c1: { n:"ListObj" },
	0x08c2: { n:"ListField" },
	0x08c3: { n:"ListDV" },
	0x08c4: { n:"ListCondFmt" },
	0x08c5: { n:"ListCF" },
	0x08c6: { n:"FMQry" },
	0x08c7: { n:"FMSQry" },
	0x08c8: { n:"PLV" },
	0x08c9: { n:"LnExt" },
	0x08ca: { n:"MkrExt" },
	0x08cb: { n:"CrtCoopt" },
	0x08d6: { n:"FRTArchId$", r:12 },
	
	0x7262: {}
	};
	
	var XLSRE = evert_key(XLSRecordEnum, 'n');
	function write_biff_rec(ba, type, payload, length) {
		var t = +type || +XLSRE[type];
		if(isNaN(t)) return;
		var len = length || (payload||[]).length || 0;
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, len);
		if(len > 0 && is_buf(payload)) ba.push(payload);
	}
	
	function write_BIFF2Cell(out, r, c) {
		if(!out) out = new_buf(7);
		out.write_shift(2, r);
		out.write_shift(2, c);
		out.write_shift(2, 0);
		out.write_shift(1, 0);
		return out;
	}
	
	function write_BIFF2BERR(r, c, val, t) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		if(t == 'e') { out.write_shift(1, val); out.write_shift(1, 1); }
		else { out.write_shift(1, val?1:0); out.write_shift(1, 0); }
		return out;
	}
	
	/* TODO: codepage, large strings */
	function write_BIFF2LABEL(r, c, val) {
		var out = new_buf(8 + 2*val.length);
		write_BIFF2Cell(out, r, c);
		out.write_shift(1, val.length);
		out.write_shift(val.length, val, 'sbcs');
		return out.l < out.length ? out.slice(0, out.l) : out;
	}
	
	function write_ws_biff2_cell(ba, cell, R, C) {
		if(cell.v != null) switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				if((v == (v|0)) && (v >= 0) && (v < 65536))
					write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
				else
					write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
				return;
			case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, cell.v));
				return;
		}
		write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
	}
	
	function write_ws_biff2(ba, ws, idx, opts) {
		var dense = Array.isArray(ws);
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff2_cell(ba, cell, R, C, opts);
			}
		}
	}
	
	/* Based on test files */
	function write_biff2_buf(wb, opts) {
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ba = buf_array();
		var idx = 0;
		for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
		if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
		write_biff_rec(ba, 0x0009, write_BOF(wb, 0x10, o));
		/* ... */
		write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
		/* ... */
		write_biff_rec(ba, 0x000A);
		return ba.end();
	}
	
	function write_ws_biff8_hlinks(ba, ws) {
		for(var R=0; R<ws['!links'].length; ++R) {
			var HL = ws['!links'][R];
			write_biff_rec(ba, "HLink", write_HLink(HL));
			if(HL[1].Tooltip) write_biff_rec(ba, "HLinkTooltip", write_HLinkTooltip(HL));
		}
		delete ws['!links'];
	}
	
	function write_ws_biff8_cell(ba, cell, R, C, opts) {
		if(cell.v != null) switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				/* TODO: emit RK as appropriate */
				write_biff_rec(ba, "Number", write_Number(R, C, v, opts));
				return;
			case 'b': case 'e': write_biff_rec(ba, "BoolErr", write_BoolErr(R, C, cell.v, opts, cell.t)); return;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, "Label", write_Label(R, C, cell.v, opts));
				return;
		}
		write_biff_rec(ba, "Blank", write_XLSCell(R, C));
	}
	
	/* [MS-XLS] 2.1.7.20.5 */
	function write_ws_biff8(idx, opts, wb) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var _WB = ((wb||{}).Workbook||{});
		var _sheet = ((_WB.Sheets||[])[idx]||{});
		var dense = Array.isArray(ws);
		var ref, rr = "", cols = [];
		var range = safe_decode_range(ws['!ref'] || "A1");
		var b8 = opts.biff == 8;
		write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
		/* ... */
		write_biff_rec(ba, "CalcMode", writeuint16(1));
		write_biff_rec(ba, "CalcCount", writeuint16(100));
		write_biff_rec(ba, "CalcRefMode", writebool(true));
		write_biff_rec(ba, "CalcIter", writebool(false));
		write_biff_rec(ba, "CalcDelta", write_Xnum(0.001));
		write_biff_rec(ba, "CalcSaveRecalc", writebool(true));
		write_biff_rec(ba, "PrintRowCol", writebool(false));
		write_biff_rec(ba, "PrintGrid", writebool(false));
		write_biff_rec(ba, "GridSet", writeuint16(1));
		write_biff_rec(ba, "Guts", write_Guts([0,0]));
		/* ... */
		write_biff_rec(ba, "HCenter", writebool(false));
		write_biff_rec(ba, "VCenter", writebool(false));
		/* ... */
		write_biff_rec(ba, "Dimensions", write_Dimensions(range, opts));
		/* ... */
	
		if(b8) ws['!links'] = [];
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff8_cell(ba, cell, R, C, opts);
				if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
			}
		}
		var cname = _sheet.CodeName || _sheet.name || s;
		/* ... */
		if(b8 && _WB.Views) write_biff_rec(ba, "Window2", write_Window2(_WB.Views[0]));
		/* ... */
		if(b8) write_biff_rec(ba, "MergeCells", write_MergeCells(ws['!merges']||[]));
		/* ... */
		if(b8) write_ws_biff8_hlinks(ba, ws);
		/* ... */
		write_biff_rec(ba, "CodeName", write_XLUnicodeString(cname, opts));
		/* ... */
		write_biff_rec(ba, "EOF");
		return ba.end();
	}
	
	/* [MS-XLS] 2.1.7.20.3 */
	function write_biff8_global(wb, bufs, opts) {
		var A = buf_array();
		var _wb = (wb.Workbook||{}).WBProps||{};
		var b8 = opts.biff == 8, b5 = opts.biff == 5;
		write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
		if(opts.bookType == "xla") write_biff_rec(A, "Addin");
		write_biff_rec(A, "InterfaceHdr", b8 ? writeuint16(0x04b0) : null);
		write_biff_rec(A, "Mms", writezeroes(2));
		if(b5) write_biff_rec(A, "ToolbarHdr");
		if(b5) write_biff_rec(A, "ToolbarEnd");
		write_biff_rec(A, "InterfaceEnd");
		write_biff_rec(A, "WriteAccess", write_WriteAccess("SheetJS", opts));
		write_biff_rec(A, "CodePage", writeuint16(b8 ? 0x04b0 : 0x04E4));
		if(b8) write_biff_rec(A, "DSF", writeuint16(0));
		write_biff_rec(A, "RRTabId", write_RRTabId(wb.SheetNames.length));
		if(b8 && wb.vbaraw) {
			write_biff_rec(A, "ObProj");
			// $FlowIgnore
			var cname = _wb.CodeName || "ThisWorkbook";
			write_biff_rec(A, "CodeName", write_XLUnicodeString(cname, opts));
		}
		write_biff_rec(A, "BuiltInFnGroupCount", writeuint16(0x11));
		write_biff_rec(A, "WinProtect", writebool(false));
		write_biff_rec(A, "Protect", writebool(false));
		write_biff_rec(A, "Password", writeuint16(0));
		if(b8) write_biff_rec(A, "Prot4Rev", writebool(false));
		if(b8) write_biff_rec(A, "Prot4RevPass", writeuint16(0));
		write_biff_rec(A, "Window1", write_Window1(opts));
		write_biff_rec(A, "Backup", writebool(false));
		write_biff_rec(A, "HideObj", writeuint16(0));
		write_biff_rec(A, "Date1904", writebool(safe1904(wb)=="true"));
		write_biff_rec(A, "CalcPrecision", writebool(true));
		if(b8) write_biff_rec(A, "RefreshAll", writebool(false));
		write_biff_rec(A, "BookBool", writeuint16(0));
		/* ... */
		if(b8) write_biff_rec(A, "UsesELFs", writebool(false));
		var a = A.end();
	
		var C = buf_array();
		if(b8) write_biff_rec(C, "Country", write_Country());
		/* BIFF8: [SST *Continue] ExtSST */
		write_biff_rec(C, "EOF");
		var c = C.end();
	
		var B = buf_array();
		var blen = 0, j = 0;
		for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
		var start = a.length + blen + c.length;
		for(j = 0; j < wb.SheetNames.length; ++j) {
			write_biff_rec(B, "BoundSheet8", write_BoundSheet8({pos:start, hs:0, dt:0, name:wb.SheetNames[j]}, opts));
			start += bufs[j].length;
		}
		/* 1*BoundSheet8 */
		var b = B.end();
		if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
	
		var out = [];
		if(a.length) out.push(a);
		if(b.length) out.push(b);
		if(c.length) out.push(c);
		return __toBuffer([out]);
	}
	
	/* [MS-XLS] 2.1.7.20 Workbook Stream */
	function write_biff8_buf(wb, opts) {
		var o = opts || {};
		var bufs = [];
		for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
		bufs.unshift(write_biff8_global(wb, bufs, o));
		return __toBuffer([bufs]);
	}
	
	function write_biff_buf(wb, opts) {
		var o = opts || {};
		switch(o.biff || 2) {
			case 8: case 5: return write_biff8_buf(wb, opts);
			case 4: case 3: case 2: return write_biff2_buf(wb, opts);
		}
		throw new Error("invalid type " + o.bookType + " for BIFF");
	}
	/* note: browser DOM element cannot see mso- style attrs, must parse */
	var HTML_ = (function() {
		function html_to_sheet(str, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var ws = opts.dense ? ([]) : ({});
			var mtch = str.match(/<table/i);
			if(!mtch) throw new Error("Invalid HTML: could not find <table>");
			var mtch2 = str.match(/<\/table/i);
			var i = mtch.index, j = mtch2 && mtch2.index || str.length;
			var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
			var R = -1, C = 0, RS = 0, CS = 0;
			var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
			var merges = [];
			for(i = 0; i < rows.length; ++i) {
				var row = rows[i].trim();
				var hd = row.slice(0,3).toLowerCase();
				if(hd == "<tr") { ++R; C = 0; continue; }
				if(hd != "<td") continue;
				var cells = row.split(/<\/td>/i);
				for(j = 0; j < cells.length; ++j) {
					var cell = cells[j].trim();
					if(cell.slice(0,3).toLowerCase() != "<td") continue;
					var m = cell, cc = 0;
					/* TODO: parse styles etc */
					while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
					var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
					CS = tag.colspan ? +tag.colspan : 1;
					if((RS = +tag.rowspan)>0 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
					var _t = tag.t || "";
					/* TODO: generate stub cells */
					if(!m.length) { C += CS; continue; }
					m = htmldecode(unescapexml(m));
					if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
					if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
					if(!m.length) continue;
					var o = {t:'s', v:m};
					if(opts.raw || !m.trim().length || _t == 's'){}
					else if(m === 'TRUE') o = {t:'b', v:true};
					else if(m === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
					else if(!isNaN(fuzzydate(m).getDate())) {
						o = ({t:'d', v:parseDate(m)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || SSF._table[14];
					}
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
					else ws[encode_cell({r:R, c:C})] = o;
					C += CS;
				}
			}
			ws['!ref'] = encode_range(range);
			return ws;
		}
		function html_to_book(str, opts) {
			return sheet_to_workbook(html_to_sheet(str, opts), opts);
		}
		function make_html_row(ws, r, R, o) {
			var M = (ws['!merges'] ||[]);
			var oo = [];
			var nullcell = "<td>" + (o.editable ? '<span contenteditable="true"></span>' : "" ) + "</td>";
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var RS = 0, CS = 0;
				for(var j = 0; j < M.length; ++j) {
					if(M[j].s.r > R || M[j].s.c > C) continue;
					if(M[j].e.r < R || M[j].e.c < C) continue;
					if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
					RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
				}
				if(RS < 0) continue;
				var coord = encode_cell({r:R,c:C});
				var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null) { oo.push(nullcell); continue; }
				/* TODO: html entities */
				var w = cell.h || escapexml(cell.w || (format_cell(cell), cell.w) || "");
				var sp = {};
				if(RS > 1) sp.rowspan = RS;
				if(CS > 1) sp.colspan = CS;
				sp.t = cell.t;
				if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
				sp.id = "sjs-" + coord;
				oo.push(writextag('td', w, sp));
			}
			var preamble = "<tr>";
			return preamble + oo.join("") + "</tr>";
		}
		function make_html_preamble(ws, R, o) {
			var out = [];
			return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
		}
		var _BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
		var _END = '</body></html>';
		function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
			var o = opts || {};
			var header = o.header != null ? o.header : _BEGIN;
			var footer = o.footer != null ? o.footer : _END;
			var out = [header];
			var r = decode_range(ws['!ref']);
			o.dense = Array.isArray(ws);
			out.push(make_html_preamble(ws, r, o));
			for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
			out.push("</table>" + footer);
			return out.join("");
		}
	
		return {
			to_workbook: html_to_book,
			to_sheet: html_to_sheet,
			_row: make_html_row,
			BEGIN: _BEGIN,
			END: _END,
			_preamble: make_html_preamble,
			from_sheet: sheet_to_html
		};
	})();
	
	function parse_dom_table(table, _opts) {
		var opts = _opts || {};
		if(DENSE != null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		var rows = table.getElementsByTagName('tr');
		var range = {s:{r:0,c:0},e:{r:rows.length - 1,c:0}};
		var merges = [], midx = 0;
		var R = 0, _C = 0, C = 0, RS = 0, CS = 0;
		for(; R < rows.length; ++R) {
			var row = rows[R];
			var elts = (row.children);
			for(_C = C = 0; _C < elts.length; ++_C) {
				var elt = elts[_C], v = htmldecode(elts[_C].innerHTML);
				for(midx = 0; midx < merges.length; ++midx) {
					var m = merges[midx];
					if(m.s.c == C && m.s.r <= R && R <= m.e.r) { C = m.e.c+1; midx = -1; }
				}
				/* TODO: figure out how to extract nonstandard mso- style */
				CS = +elt.getAttribute("colspan") || 1;
				if((RS = +elt.getAttribute("rowspan"))>0 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var o = {t:'s', v:v};
				var _t = elt.getAttribute("t") || "";
				if(v != null) {
					if(v.length == 0) o.t = _t || 'z';
					else if(opts.raw || v.trim().length == 0 || _t == "s"){}
					else if(v === 'TRUE') o = {t:'b', v:true};
					else if(v === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
					else if(!isNaN(fuzzydate(v).getDate())) {
						o = ({t:'d', v:parseDate(v)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || SSF._table[14];
					}
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({c:C, r:R})] = o;
				if(range.e.c < C) range.e.c = C;
				C += CS;
			}
		}
		ws['!merges'] = merges;
		ws['!ref'] = encode_range(range);
		return ws;
	}
	
	function table_to_book(table, opts) {
		return sheet_to_workbook(parse_dom_table(table, opts), opts);
	}
	/* OpenDocument */
	var parse_content_xml = (function() {
	
		/* 6.1.2 White Space Characters */
		var parse_text_p = function(text) {
			return unescapexml(text
				.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
				.replace(/<text:s\/>/g," ")
				.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
				.replace(/<text:tab[^>]*\/>/g,"\t")
				.replace(/<text:line-break\/>/g,"\n")
				.replace(/<[^>]*>/g,"")
			);
		};
	
		var number_formats = {
			/* ods name: [short ssf fmt, long ssf fmt] */
			day:           ["d",   "dd"],
			month:         ["m",   "mm"],
			year:          ["y",   "yy"],
			hours:         ["h",   "hh"],
			minutes:       ["m",   "mm"],
			seconds:       ["s",   "ss"],
			"am-pm":       ["A/P", "AM/PM"],
			"day-of-week": ["ddd", "dddd"],
			era:           ["e",   "ee"],
			/* there is no native representation of LO "Q" format */
			quarter:       ["\\Qm", "m\\\"th quarter\""]
		};
	
		return function pcx(d, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var str = xlml_normalize(d);
			var state = [], tmp;
			var tag;
			var NFtag = {name:""}, NF = "", pidx = 0;
			var sheetag;
			var rowtag;
			var Sheets = {}, SheetNames = [];
			var ws = opts.dense ? ([]) : ({});
			var Rn, q;
			var ctag = ({value:""});
			var textp = "", textpidx = 0, textptag;
			var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
			var row_ol = 0;
			var number_format_map = {};
			var merges = [], mrange = {}, mR = 0, mC = 0;
			var rowinfo = [], rowpeat = 1, colpeat = 1;
			var arrayf = [];
			var WB = {Names:[]};
			var atag = ({});
			var _Ref = ["", ""];
			var comments = [], comment = ({});
			var creator = "", creatoridx = 0;
			var isstub = false, intable = false;
			var i = 0;
			xlmlregex.lastIndex = 0;
			str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
			while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {
	
				case 'table': case '工作表': // 9.1.2 <table:table>
					if(Rn[1]==='/') {
						if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
						if(merges.length) ws['!merges'] = merges;
						if(rowinfo.length) ws["!rows"] = rowinfo;
						sheetag.name = utf8read(sheetag['名称'] || sheetag.name);
						SheetNames.push(sheetag.name);
						Sheets[sheetag.name] = ws;
						intable = false;
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						sheetag = parsexmltag(Rn[0], false);
						R = C = -1;
						range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
						ws = opts.dense ? ([]) : ({}); merges = [];
						rowinfo = [];
						intable = true;
					}
					break;
	
				case 'table-row-group': // 9.1.9 <table:table-row-group>
					if(Rn[1] === "/") --row_ol; else ++row_ol;
					break;
				case 'table-row': case '行': // 9.1.3 <table:table-row>
					if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
					rowtag = parsexmltag(Rn[0], false);
					if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
					rowpeat = +rowtag['number-rows-repeated'] || 1;
					/* TODO: remove magic */
					if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
					C = -1; break;
				case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
					++C;
					if(opts.sheetStubs) {
						if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
						else ws[encode_cell({r:R,c:C})] = {t:'z'};
					}
					break; /* stub */
				case 'table-cell': case '数据':
					if(Rn[0].charAt(Rn[0].length-2) === '/') {
						++C;
						ctag = parsexmltag(Rn[0], false);
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						q = ({t:'z', v:null});
						if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
						if((ctag['数据类型'] || ctag['value-type']) == "string") {
							q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
							if(opts.dense) {
								if(!ws[R]) ws[R] = [];
								ws[R][C] = q;
							} else {
								ws[encode_cell({r:R,c:C})] = q;
							}
						}
						C+= colpeat-1;
					} else if(Rn[1]!=='/') {
						++C;
						colpeat = 1;
						var rptR = rowpeat ? R + rowpeat - 1 : R;
						if(C > range.e.c) range.e.c = C;
						if(C < range.s.c) range.s.c = C;
						if(R < range.s.r) range.s.r = R;
						if(rptR > range.e.r) range.e.r = rptR;
						ctag = parsexmltag(Rn[0], false);
						comments = []; comment = ({});
						q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
						if(opts.cellFormula) {
							if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
							if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
								mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
								mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
								mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
								q.F = encode_range(mrange);
								arrayf.push([mrange, q.F]);
							}
							if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
							else for(i = 0; i < arrayf.length; ++i)
								if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
									if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
										q.F = arrayf[i][1];
						}
						if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
							mR = parseInt(ctag['number-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							merges.push(mrange);
						}
	
						/* 19.675.2 table:number-columns-repeated */
						if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
	
						/* 19.385 office:value-type */
						switch(q.t) {
							case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
							case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
								if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
								q.z = 'm/d/yy'; break;
							case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400; break;
							case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
							default:
								if(q.t === 'string' || q.t === 'text' || !q.t) {
									q.t = 's';
									if(ctag['string-value'] != null) textp = unescapexml(ctag['string-value']);
								} else throw new Error('Unsupported value type ' + q.t);
						}
					} else {
						isstub = false;
						if(q.t === 's') {
							q.v = textp || '';
							isstub = textpidx == 0;
						}
						if(atag.Target) q.l = atag;
						if(comments.length > 0) { q.c = comments; comments = []; }
						if(textp && opts.cellText !== false) q.w = textp;
						if(!isstub || opts.sheetStubs) {
							if(!(opts.sheetRows && opts.sheetRows < R)) {
								for(var rpt = 0; rpt < rowpeat; ++rpt) {
									colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
									if(opts.dense) {
										if(!ws[R + rpt]) ws[R + rpt] = [];
										ws[R + rpt][C] = rpt == 0 ? q : dup(q);
										while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
									} else {
										ws[encode_cell({r:R + rpt,c:C})] = q;
										while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
									}
									if(range.e.c <= C) range.e.c = C;
								}
							}
						}
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						C += colpeat-1; colpeat = 0;
						q = {};
						textp = "";
					}
					atag = ({});
					break; // 9.1.4 <table:table-cell>
	
				/* pure state */
				case 'document': // TODO: <office:document> is the root for FODS
				case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
				case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
				case 'scripts': // 3.12 <office:scripts>
				case 'styles': // TODO <office:styles>
				case 'font-face-decls': // 3.14 <office:font-face-decls>
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
	
				case 'annotation': // 14.1 <office:annotation>
					if(Rn[1]==='/'){
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
						comment.t = textp;
						comment.a = creator;
						comments.push(comment);
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
					creator = ""; creatoridx = 0;
					textp = ""; textpidx = 0;
					break;
	
				case 'creator': // 4.3.2.7 <dc:creator>
					if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
					else creatoridx = Rn.index + Rn[0].length;
					break;
	
				/* ignore state */
				case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
				case 'settings': // TODO: <office:settings>
				case 'config-item-set': // TODO: <office:config-item-set>
				case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
				case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
				case 'config-item-map-named': // TODO: <office:config-item-map-entry>
				case 'shapes': // 9.2.8 <table:shapes>
				case 'frame': // 10.4.2 <draw:frame>
				case 'text-box': // 10.4.3 <draw:text-box>
				case 'image': // 10.4.4 <draw:image>
				case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
				case 'list-style': // 16.30 <text:list-style>
				case 'form': // 13.13 <form:form>
				case 'dde-links': // 9.8 <table:dde-links>
				case 'event-listeners': // TODO
				case 'chart': // TODO
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
					textp = ""; textpidx = 0;
					break;
	
				case 'scientific-number': // TODO: <number:scientific-number>
					break;
				case 'currency-symbol': // TODO: <number:currency-symbol>
					break;
				case 'currency-style': // TODO: <number:currency-style>
					break;
				case 'number-style': // 16.27.2 <number:number-style>
				case 'percentage-style': // 16.27.9 <number:percentage-style>
				case 'date-style': // 16.27.10 <number:date-style>
				case 'time-style': // 16.27.18 <number:time-style>
					if(Rn[1]==='/'){
						number_format_map[NFtag.name] = NF;
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						NF = "";
						NFtag = parsexmltag(Rn[0], false);
						state.push([Rn[3], true]);
					} break;
	
				case 'script': break; // 3.13 <office:script>
				case 'libraries': break; // TODO: <ooo:libraries>
				case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
				case 'master-styles': break; // TODO: <office:master-styles>
	
				case 'default-style': // TODO: <style:default-style>
				case 'page-layout': break; // TODO: <style:page-layout>
				case 'style': break; // 16.2 <style:style>
				case 'map': break; // 16.3 <style:map>
				case 'font-face': break; // 16.21 <style:font-face>
	
				case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
				case 'table-properties': break; // 17.15 <style:table-properties>
				case 'table-column-properties': break; // 17.16 <style:table-column-properties>
				case 'table-row-properties': break; // 17.17 <style:table-row-properties>
				case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>
	
				case 'number': // 16.27.3 <number:number>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'fraction': break; // TODO 16.27.6 <number:fraction>
	
				case 'day': // 16.27.11 <number:day>
				case 'month': // 16.27.12 <number:month>
				case 'year': // 16.27.13 <number:year>
				case 'era': // 16.27.14 <number:era>
				case 'day-of-week': // 16.27.15 <number:day-of-week>
				case 'week-of-year': // 16.27.16 <number:week-of-year>
				case 'quarter': // 16.27.17 <number:quarter>
				case 'hours': // 16.27.19 <number:hours>
				case 'minutes': // 16.27.20 <number:minutes>
				case 'seconds': // 16.27.21 <number:seconds>
				case 'am-pm': // 16.27.22 <number:am-pm>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'boolean-style': break; // 16.27.23 <number:boolean-style>
				case 'boolean': break; // 16.27.24 <number:boolean>
				case 'text-style': break; // 16.27.25 <number:text-style>
				case 'text': // 16.27.26 <number:text>
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") switch(state[state.length-1][0]) {
						case 'number-style':
						case 'date-style':
						case 'time-style':
							NF += str.slice(pidx, Rn.index);
							break;
					}
					else pidx = Rn.index + Rn[0].length;
					break;
	
				case 'named-range': // 9.4.12 <table:named-range>
					tag = parsexmltag(Rn[0], false);
					_Ref = ods_to_csf_3D(tag['cell-range-address']);
					var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
					if(intable) nrange.Sheet = SheetNames.length;
					WB.Names.push(nrange);
					break;
	
				case 'text-content': break; // 16.27.27 <number:text-content>
				case 'text-properties': break; // 16.27.27 <style:text-properties>
				case 'embedded-text': break; // 16.27.4 <number:embedded-text>
	
				case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3
	
				case 'forms': break; // 12.25.2 13.2
				case 'table-column': break; // 9.1.6 <table:table-column>
				case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
				case 'table-rows': break; // 9.1.12 <table:table-rows>
				/* TODO: outline levels */
				case 'table-column-group': break; // 9.1.10 <table:table-column-group>
				case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
				case 'table-columns': break; // 9.1.12 <table:table-columns>
	
				case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904
	
				case 'graphic-properties': break; // 17.21 <style:graphic-properties>
				case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
				case 'named-expressions': break; // 9.4.11 <table:named-expressions>
				case 'label-range': break; // 9.4.9 <table:label-range>
				case 'label-ranges': break; // 9.4.10 <table:label-ranges>
				case 'named-expression': break; // 9.4.13 <table:named-expression>
				case 'sort': break; // 9.4.19 <table:sort>
				case 'sort-by': break; // 9.4.20 <table:sort-by>
				case 'sort-groups': break; // 9.4.22 <table:sort-groups>
	
				case 'tab': break; // 6.1.4 <text:tab>
				case 'line-break': break; // 6.1.5 <text:line-break>
				case 'span': break; // 6.1.7 <text:span>
				case 'p': case '文本串': // 5.1.3 <text:p>
					if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) textp = (textp.length > 0 ? textp + "\n" : "") + parse_text_p(str.slice(textpidx,Rn.index), textptag);
					else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
					break; // <text:p>
				case 's': break; // <text:s>
	
				case 'database-range': // 9.4.15 <table:database-range>
					if(Rn[1]==='/') break;
					try {
						_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
						Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
					} catch(e) {/* empty */}
					break;
	
				case 'date': break; // <*:date>
	
				case 'object': break; // 10.4.6.2 <draw:object>
				case 'title': case '标题': break; // <*:title> OR <uof:标题>
				case 'desc': break; // <*:desc>
				case 'binary-data': break; // 10.4.5 TODO: b64 blob
	
				/* 9.2 Advanced Tables */
				case 'table-source': break; // 9.2.6
				case 'scenario': break; // 9.2.6
	
				case 'iteration': break; // 9.4.3 <table:iteration>
				case 'content-validations': break; // 9.4.4 <table:
				case 'content-validation': break; // 9.4.5 <table:
				case 'help-message': break; // 9.4.6 <table:
				case 'error-message': break; // 9.4.7 <table:
				case 'database-ranges': break; // 9.4.14 <table:database-ranges>
				case 'filter': break; // 9.5.2 <table:filter>
				case 'filter-and': break; // 9.5.3 <table:filter-and>
				case 'filter-or': break; // 9.5.4 <table:filter-or>
				case 'filter-condition': break; // 9.5.5 <table:filter-condition>
	
				case 'list-level-style-bullet': break; // 16.31 <text:
				case 'list-level-style-number': break; // 16.32 <text:
				case 'list-level-properties': break; // 17.19 <style:
	
				/* 7.3 Document Fields */
				case 'sender-firstname': // 7.3.6.2
				case 'sender-lastname': // 7.3.6.3
				case 'sender-initials': // 7.3.6.4
				case 'sender-title': // 7.3.6.5
				case 'sender-position': // 7.3.6.6
				case 'sender-email': // 7.3.6.7
				case 'sender-phone-private': // 7.3.6.8
				case 'sender-fax': // 7.3.6.9
				case 'sender-company': // 7.3.6.10
				case 'sender-phone-work': // 7.3.6.11
				case 'sender-street': // 7.3.6.12
				case 'sender-city': // 7.3.6.13
				case 'sender-postal-code': // 7.3.6.14
				case 'sender-country': // 7.3.6.15
				case 'sender-state-or-province': // 7.3.6.16
				case 'author-name': // 7.3.7.1
				case 'author-initials': // 7.3.7.2
				case 'chapter': // 7.3.8
				case 'file-name': // 7.3.9
				case 'template-name': // 7.3.9
				case 'sheet-name': // 7.3.9
					break;
	
				case 'event-listener':
					break;
				/* TODO: FODS Properties */
				case 'initial-creator':
				case 'creation-date':
				case 'print-date':
				case 'generator':
				case 'document-statistic':
				case 'user-defined':
				case 'editing-duration':
				case 'editing-cycles':
					break;
	
				/* TODO: FODS Config */
				case 'config-item':
					break;
	
				/* TODO: style tokens */
				case 'page-number': break; // TODO <text:page-number>
				case 'page-count': break; // TODO <text:page-count>
				case 'time': break; // TODO <text:time>
	
				/* 9.3 Advanced Table Cells */
				case 'cell-range-source': break; // 9.3.1 <table:
				case 'detective': break; // 9.3.2 <table:
				case 'operation': break; // 9.3.3 <table:
				case 'highlighted-range': break; // 9.3.4 <table:
	
				/* 9.6 Data Pilot Tables <table: */
				case 'data-pilot-table': // 9.6.3
				case 'source-cell-range': // 9.6.5
				case 'source-service': // 9.6.6
				case 'data-pilot-field': // 9.6.7
				case 'data-pilot-level': // 9.6.8
				case 'data-pilot-subtotals': // 9.6.9
				case 'data-pilot-subtotal': // 9.6.10
				case 'data-pilot-members': // 9.6.11
				case 'data-pilot-member': // 9.6.12
				case 'data-pilot-display-info': // 9.6.13
				case 'data-pilot-sort-info': // 9.6.14
				case 'data-pilot-layout-info': // 9.6.15
				case 'data-pilot-field-reference': // 9.6.16
				case 'data-pilot-groups': // 9.6.17
				case 'data-pilot-group': // 9.6.18
				case 'data-pilot-group-member': // 9.6.19
					break;
	
				/* 10.3 Drawing Shapes */
				case 'rect': // 10.3.2
					break;
	
				/* 14.6 DDE Connections */
				case 'dde-connection-decls': // 14.6.2 <text:
				case 'dde-connection-decl': // 14.6.3 <text:
				case 'dde-link': // 14.6.4 <table:
				case 'dde-source': // 14.6.5 <office:
					break;
	
				case 'properties': break; // 13.7 <form:properties>
				case 'property': break; // 13.8 <form:property>
	
				case 'a': // 6.1.8 hyperlink
					if(Rn[1]!== '/') {
						atag = parsexmltag(Rn[0], false);
						if(!atag.href) break;
						atag.Target = atag.href; delete atag.href;
						if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
							_Ref = ods_to_csf_3D(atag.Target.slice(1));
							atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
						}
					}
					break;
	
				/* non-standard */
				case 'table-protection': break;
				case 'data-pilot-grand-total': break; // <table:
				case 'office-document-common-attrs': break; // bare
				default: switch(Rn[2]) {
					case 'dc:':       // TODO: properties
					case 'calcext:':  // ignore undocumented extensions
					case 'loext:':    // ignore undocumented extensions
					case 'ooo:':      // ignore undocumented extensions
					case 'chartooo:': // ignore undocumented extensions
					case 'draw:':     // TODO: drawing
					case 'style:':    // TODO: styles
					case 'chart:':    // TODO: charts
					case 'form:':     // TODO: forms
					case 'uof:':      // TODO: uof
					case '表:':       // TODO: uof
					case '字:':       // TODO: uof
						break;
					default: if(opts.WTF) throw new Error(Rn);
				}
			}
			var out = ({
				Sheets: Sheets,
				SheetNames: SheetNames,
				Workbook: WB
			});
			if(opts.bookSheets) delete out.Sheets;
			return out;
		};
	})();
	
	function parse_ods(zip, opts) {
		opts = opts || ({});
		var ods = !!safegetzipfile(zip, 'objectdata');
		if(ods) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
		var content = getzipstr(zip, 'content.xml');
		if(!content) throw new Error("Missing content.xml in " + (ods ? "ODS" : "UOF")+ " file");
		var wb = parse_content_xml(ods ? content : utf8read(content), opts);
		if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
		return wb;
	}
	function parse_fods(data, opts) {
		return parse_content_xml(data, opts);
	}
	
	/* OpenDocument */
	var write_styles_ods = (function() {
		var payload = '<office:document-styles ' + wxt_helper({
			'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':    "http://www.w3.org/1999/xlink",
			'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
			'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'office:version': "1.2"
		}) + '></office:document-styles>';
		return function wso() {
			return XML_HEADER + payload;
		};
	})();
	var write_content_ods = (function() {
		/* 6.1.2 White Space Characters */
		var write_text_p = function(text) {
			return escapexml(text)
				.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
				.replace(/\t/g, "<text:tab/>")
				.replace(/\n/g, "<text:line-break/>")
				.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
		};
	
		var null_cell_xml = '          <table:table-cell />\n';
		var covered_cell_xml = '          <table:covered-table-cell/>\n';
		var write_ws = function(ws, wb, i) {
			/* Section 9 Tables */
			var o = [];
			o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '">\n');
			var R=0,C=0, range = decode_range(ws['!ref']);
			var marr = ws['!merges'] || [], mi = 0;
			var dense = Array.isArray(ws);
			for(R = 0; R < range.s.r; ++R) o.push('        <table:table-row></table:table-row>\n');
			for(; R <= range.e.r; ++R) {
				o.push('        <table:table-row>\n');
				for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
				for(; C <= range.e.c; ++C) {
					var skip = false, ct = {}, textp = "";
					for(mi = 0; mi != marr.length; ++mi) {
						if(marr[mi].s.c > C) continue;
						if(marr[mi].s.r > R) continue;
						if(marr[mi].e.c < C) continue;
						if(marr[mi].e.r < R) continue;
						if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
						ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
						ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
						break;
					}
					if(skip) { o.push(covered_cell_xml); continue; }
					var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
					if(cell && cell.f) {
						ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
						if(cell.F) {
							if(cell.F.slice(0, ref.length) == ref) {
								var _Fref = decode_range(cell.F);
								ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
								ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
							}
						}
					}
					if(!cell) { o.push(null_cell_xml); continue; }
					switch(cell.t) {
						case 'b':
							textp = (cell.v ? 'TRUE' : 'FALSE');
							ct['office:value-type'] = "boolean";
							ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
							break;
						case 'n':
							textp = (cell.w||String(cell.v||0));
							ct['office:value-type'] = "float";
							ct['office:value'] = (cell.v||0);
							break;
						case 's': case 'str':
							textp = cell.v;
							ct['office:value-type'] = "string";
							break;
						case 'd':
							textp = (cell.w||(parseDate(cell.v).toISOString()));
							ct['office:value-type'] = "date";
							ct['office:date-value'] = (parseDate(cell.v).toISOString());
							ct['table:style-name'] = "ce1";
							break;
						//case 'e':
						default: o.push(null_cell_xml); continue;
					}
					var text_p = write_text_p(textp);
					if(cell.l && cell.l.Target) {
						var _tgt = cell.l.Target; _tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
						text_p = writextag('text:a', text_p, {'xlink:href': _tgt});
					}
					o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
				}
				o.push('        </table:table-row>\n');
			}
			o.push('      </table:table>\n');
			return o.join("");
		};
	
		var write_automatic_styles_ods = function(o) {
			o.push(' <office:automatic-styles>\n');
			o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
			o.push('   <number:month number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:day number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:year/>\n');
			o.push('  </number:date-style>\n');
			o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
			o.push(' </office:automatic-styles>\n');
		};
	
		return function wcx(wb, opts) {
			var o = [XML_HEADER];
			/* 3.1.3.2 */
			var attr = wxt_helper({
				'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
				'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
				'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
				'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
				'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
				'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
				'xmlns:xlink':        "http://www.w3.org/1999/xlink",
				'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
				'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
				'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
				'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
				'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
				'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
				'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
				'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
				'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
				'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
				'xmlns:ooo':          "http://openoffice.org/2004/office",
				'xmlns:ooow':         "http://openoffice.org/2004/writer",
				'xmlns:oooc':         "http://openoffice.org/2004/calc",
				'xmlns:dom':          "http://www.w3.org/2001/xml-events",
				'xmlns:xforms':       "http://www.w3.org/2002/xforms",
				'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
				'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
				'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
				'xmlns:rpt':          "http://openoffice.org/2005/report",
				'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
				'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
				'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
				'xmlns:tableooo':     "http://openoffice.org/2009/table",
				'xmlns:drawooo':      "http://openoffice.org/2010/draw",
				'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
				'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
				'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
				'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
				'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
				'office:version':     "1.2"
			});
	
			var fods = wxt_helper({
				'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
				'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
			});
	
			if(opts.bookType == "fods") o.push('<office:document' + attr + fods + '>\n');
			else o.push('<office:document-content' + attr  + '>\n');
			write_automatic_styles_ods(o);
			o.push('  <office:body>\n');
			o.push('    <office:spreadsheet>\n');
			for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
			o.push('    </office:spreadsheet>\n');
			o.push('  </office:body>\n');
			if(opts.bookType == "fods") o.push('</office:document>');
			else o.push('</office:document-content>');
			return o.join("");
		};
	})();
	
	function write_ods(wb, opts) {
		if(opts.bookType == "fods") return write_content_ods(wb, opts);
	
	var zip = new jszip();
		var f = "";
	
		var manifest = [];
		var rdf = [];
	
		/* Part 3 Section 3.3 MIME Media Type */
		f = "mimetype";
		zip.file(f, "application/vnd.oasis.opendocument.spreadsheet");
	
		/* Part 1 Section 2.2 Documents */
		f = "content.xml";
		zip.file(f, write_content_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "ContentFile"]);
	
		/* TODO: these are hard-coded styles to satiate excel */
		f = "styles.xml";
		zip.file(f, write_styles_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "StylesFile"]);
	
		/* TODO: this is hard-coded to satiate excel */
		f = "meta.xml";
		zip.file(f, write_meta_ods());
		manifest.push([f, "text/xml"]);
		rdf.push([f, "MetadataFile"]);
	
		/* Part 3 Section 6 Metadata Manifest File */
		f = "manifest.rdf";
		zip.file(f, write_rdf(rdf/*, opts*/));
		manifest.push([f, "application/rdf+xml"]);
	
		/* Part 3 Section 4 Manifest File */
		f = "META-INF/manifest.xml";
		zip.file(f, write_manifest(manifest/*, opts*/));
	
		return zip;
	}
	
	function write_sheet_index(wb, sheet) {
		if(!sheet) return 0;
		var idx = wb.SheetNames.indexOf(sheet);
		if(idx == -1) throw new Error("Sheet not found: " + sheet);
		return idx;
	}
	
	function write_obj_str(factory) {
		return function write_str(wb, o) {
			var idx = write_sheet_index(wb, o.sheet);
			return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb);
		};
	}
	
	var write_htm_str = write_obj_str(HTML_);
	var write_csv_str = write_obj_str({from_sheet:sheet_to_csv});
	var write_slk_str = write_obj_str(SYLK);
	var write_dif_str = write_obj_str(DIF);
	var write_prn_str = write_obj_str(PRN);
	var write_rtf_str = write_obj_str(RTF);
	var write_txt_str = write_obj_str({from_sheet:sheet_to_txt});
	// $FlowIgnore
	var write_dbf_buf = write_obj_str(DBF);
	var write_eth_str = write_obj_str(ETH);
	
	function fix_opts_func(defaults) {
		return function fix_opts(opts) {
			for(var i = 0; i != defaults.length; ++i) {
				var d = defaults[i];
				if(opts[d[0]] === undefined) opts[d[0]] = d[1];
				if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
			}
		};
	}
	
	var fix_read_opts = fix_opts_func([
		['cellNF', false], /* emit cell number format string as .z */
		['cellHTML', true], /* emit html string as .h */
		['cellFormula', true], /* emit formulae as .f */
		['cellStyles', false], /* emits style/theme as .s */
		['cellText', true], /* emit formatted text as .w */
		['cellDates', false], /* emit date cells with type `d` */
	
		['sheetStubs', false], /* emit empty cells */
		['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */
	
		['bookDeps', false], /* parse calculation chains */
		['bookSheets', false], /* only try to get sheet names (no Sheets) */
		['bookProps', false], /* only try to get properties (no Sheets) */
		['bookFiles', false], /* include raw file structure (keys, files, cfb) */
		['bookVBA', false], /* include vba raw data (vbaraw) */
	
		['password',''], /* password */
		['WTF', false] /* WTF mode (throws errors) */
	]);
	
	
	var fix_write_opts = fix_opts_func([
		['cellDates', false], /* write date cells with type `d` */
	
		['bookSST', false], /* Generate Shared String Table */
	
		['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */
	
		['compression', false], /* Use file compression */
	
		['WTF', false] /* WTF mode (throws errors) */
	]);
	function get_sheet_type(n) {
		if(RELS.WS.indexOf(n) > -1) return "sheet";
		if(RELS.CS && n == RELS.CS) return "chart";
		if(RELS.DS && n == RELS.DS) return "dialog";
		if(RELS.MS && n == RELS.MS) return "macro";
		return (n && n.length) ? n : "sheet";
	}
	function safe_parse_wbrels(wbrels, sheets) {
		if(!wbrels) return 0;
		try {
			wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
		} catch(e) { return null; }
		return !wbrels || wbrels.length === 0 ? null : wbrels;
	}
	
	function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
		try {
			sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
			var data = getzipdata(zip, path);
			switch(stype) {
				case 'sheet': sheets[sheet]=parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'chart':
					var cs = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
					sheets[sheet] = cs;
					if(!cs || !cs['!chart']) break;
					var dfile = resolve_path(cs['!chart'].Target, path);
					var drelsp = get_rels_path(dfile);
					var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
					var chartp = resolve_path(draw, dfile);
					var crelsp = get_rels_path(chartp);
					cs = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, cs);
					break;
				case 'macro': sheets[sheet]=parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'dialog': sheets[sheet]=parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			}
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	var nodirs = function nodirs(x){return x.slice(-1) != '/';};
	function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }
	
	function parse_zip(zip, opts) {
		make_ssf(SSF);
		opts = opts || {};
		fix_read_opts(opts);
	
		/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
		/* UOC */
		if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
		/* Numbers */
		if(safegetzipfile(zip, 'Index/Document.iwa')) throw new Error('Unsupported NUMBERS file');
	
		var entries = keys(zip.files).filter(nodirs).sort();
		var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
		var xlsb = false;
		var sheets, binname;
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.xml";
			if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
		}
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.bin";
			if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
			dir.workbooks.push(binname);
			xlsb = true;
		}
		if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;
	
		var themes = ({});
		var styles = ({});
		if(!opts.bookSheets && !opts.bookProps) {
			strs = [];
			if(dir.sst) strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts);
	
			if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);
	
			if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
		}
	
		/*var externbooks = */dir.links.map(function(link) {
			return parse_xlink(getzipdata(zip, strip_front_slash(link)), link, opts);
		});
	
		var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
	
		var props = {}, propdata = "";
	
		if(dir.coreprops.length) {
			propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
			if(propdata) props = parse_core_props(propdata);
			if(dir.extprops.length !== 0) {
				propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
				if(propdata) parse_ext_props(propdata, props, opts);
			}
		}
	
		var custprops = {};
		if(!opts.bookSheets || opts.bookProps) {
			if (dir.custprops.length !== 0) {
				propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
				if(propdata) custprops = parse_cust_props(propdata, opts);
			}
		}
	
		var out = ({});
		if(opts.bookSheets || opts.bookProps) {
			if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
			else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
			if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
			if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
			if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
		}
		sheets = {};
	
		var deps = {};
		if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);
	
		var i=0;
		var sheetRels = ({});
		var path, relsPath;
	
		{
			var wbsheets = wb.Sheets;
			props.Worksheets = wbsheets.length;
			props.SheetNames = [];
			for(var j = 0; j != wbsheets.length; ++j) {
				props.SheetNames[j] = wbsheets[j].name;
			}
		}
	
		var wbext = xlsb ? "bin" : "xml";
		var wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
		var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile);
		if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
		/* Numbers iOS hack */
		var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
		for(i = 0; i != props.Worksheets; ++i) {
			var stype = "sheet";
			if(wbrels && wbrels[i]) {
				path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
				stype = wbrels[i][2];
			} else {
				path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
				path = path.replace(/sheet0\./,"sheet.");
			}
			relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
			safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
		}
	
		if(dir.comments) parse_comments(zip, dir.comments, sheets, sheetRels, opts);
	
		out = ({
			Directory: dir,
			Workbook: wb,
			Props: props,
			Custprops: custprops,
			Deps: deps,
			Sheets: sheets,
			SheetNames: props.SheetNames,
			Strings: strs,
			Styles: styles,
			Themes: themes,
			SSF: SSF.get_table()
		});
		if(opts.bookFiles) {
			out.keys = entries;
			out.files = zip.files;
		}
		if(opts.bookVBA) {
			if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
			else if(dir.defaults && dir.defaults.bin === 'application/vnd.ms-office.vbaProject') out.vbaraw = getzipdata(zip,'xl/vbaProject.bin',true);
		}
		return out;
	}
	
	/* [MS-OFFCRYPTO] 2.1.1 */
	function parse_xlsxcfb(cfb, _opts) {
		var opts = _opts || {};
		var f = '/!DataSpaces/Version';
		var data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var version = */parse_DataSpaceVersionInfo(data.content);
	
		/* 2.3.4.1 */
		f = '/!DataSpaces/DataSpaceMap';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var dsm = parse_DataSpaceMap(data.content);
		if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.2 */
		f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var seds = parse_DataSpaceDefinition(data.content);
		if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.3 */
		f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var hdr = */parse_Primary(data.content);
	
		f = '/EncryptionInfo';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var einfo = parse_EncryptionInfo(data.content);
	
		/* 2.3.4.4 */
		f = '/EncryptedPackage';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	
	/*global decrypt_agile */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
	/*global decrypt_std76 */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
		throw new Error("File is password-protected");
	}
	
	function write_zip(wb, opts) {
		_shapeid = 1024;
		if(opts.bookType == "ods") return write_ods(wb, opts);
		if(wb && !wb.SSF) {
			wb.SSF = SSF.get_table();
		}
		if(wb && wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
	var zip = new jszip();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip.file(f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		// $FlowIgnore
		else wb.Props.SheetNames = wb.SheetNames.map(function(x,i) { return [(wb.Workbook.Sheets[i]||{}).Hidden != 2, x];}).filter(function(x) { return x[0]; }).map(function(x) { return x[1]; });
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip.file(f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip.file(f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		f = "xl/workbook." + wbext;
		zip.file(f, write_wb(wb, f, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart": /*
				f = "xl/chartsheets/sheet" + rId + "." + wbext;
				zip.file(f, write_cs(rId-1, f, opts, wb, wsrels));
				ct.charts.push(f);
				add_rels(wsrels, -1, "chartsheets/sheet" + rId + "." + wbext, RELS.CS);
				break; */
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip.file(f, write_ws(rId-1, f, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				if(comments && comments.length > 0) {
					var cf = "xl/comments" + rId + "." + wbext;
					zip.file(cf, write_cmnt(comments, cf, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
				}
				if(ws['!legacy']) {
					zip.file("xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip.file(get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip.file(f, write_sst(opts.Strings, f, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip.file(f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip.file(f, write_sty(wb, f, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip.file(f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		zip.file("[Content_Types].xml", write_ct(ct, opts));
		zip.file('_rels/.rels', write_rels(opts.rels));
		zip.file('xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	function firstbyte(f,o) {
		var x = "";
		switch((o||{}).type || "base64") {
			case 'buffer': return [f[0], f[1], f[2], f[3]];
			case 'base64': x = Base64.decode(f.slice(0,24)); break;
			case 'binary': x = f; break;
			case 'array':  return [f[0], f[1], f[2], f[3]];
			default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
		}
		return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3)];
	}
	
	function read_cfb(cfb, opts) {
		if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
		return parse_xlscfb(cfb, opts);
	}
	
	function read_zip(data, opts) {
	var zip, d = data;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		switch(o.type) {
			case "base64": zip = new jszip(d, { base64:true }); break;
			case "binary": case "array": zip = new jszip(d, { base64:false }); break;
			case "buffer": zip = new jszip(d); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		return parse_zip(zip, o);
	}
	
	function read_plaintext(data, o) {
		var i = 0;
		main: while(i < data.length) switch(data.charCodeAt(i)) {
			case 0x0A: case 0x0D: case 0x20: ++i; break;
			case 0x3C: return parse_xlml(data.slice(i),o);
			default: break main;
		}
		return PRN.to_workbook(data, o);
	}
	
	function read_plaintext_raw(data, o) {
		var str = "", bytes = firstbyte(data, o);
		switch(o.type) {
			case 'base64': str = Base64.decode(data); break;
			case 'binary': str = data; break;
			case 'buffer': str = data.toString('binary'); break;
			case 'array': str = cc2str(data); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
		return read_plaintext(str, o);
	}
	
	function read_utf16(data, o) {
		var d = data;
		if(o.type == 'base64') d = Base64.decode(d);
		d = cptable.utils.decode(1200, d.slice(2), 'str');
		o.type = "binary";
		return read_plaintext(d, o);
	}
	
	function bstrify(data) {
		return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
	}
	
	function read_prn(data, d, o, str) {
		if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
		return PRN.to_workbook(d, o);
	}
	
	function readSync(data, opts) {
		reset_cp();
		if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), opts);
		var d = data, n = [0,0,0,0], str = false;
		var o = opts||{};
		_ssfopts = {};
		if(o.dateNF) _ssfopts.dateNF = o.dateNF;
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		if(o.type == "file") { o.type = "buffer"; d = _fs.readFileSync(data); }
		if(o.type == "string") { str = true; o.type = "binary"; d = bstrify(data); }
		if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
			// $FlowIgnore
			var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
			// $FlowIgnore
			if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
		}
		switch((n = firstbyte(d, o))[0]) {
			case 0xD0: return read_cfb(CFB.read(d, o), o);
			case 0x09: return parse_xlscfb(d, o);
			case 0x3C: return parse_xlml(d, o);
			case 0x49: if(n[1] === 0x44) return read_wb_ID(d, o); break;
			case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
			case 0x50: if(n[1] === 0x4B && n[2] < 0x20 && n[3] < 0x20) return read_zip(d, o); break;
			case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
			case 0xFF: if(n[1] === 0xFE) { return read_utf16(d, o); } break;
			case 0x00: if(n[1] === 0x00 && n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o); break;
			case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
			case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
			case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
		}
		if(n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
		return read_prn(data, d, o, str);
	}
	
	function readFileSync(filename, opts) {
		var o = opts||{}; o.type = 'file';
		return readSync(filename, o);
	}
	function write_zip_type(wb, opts) {
		var o = opts||{};
		var z = write_zip(wb, o);
		var oopts = {};
		if(o.compression) oopts.compression = 'DEFLATE';
		switch(o.type) {
			case "base64": oopts.type = "base64"; break;
			case "binary": oopts.type = "string"; break;
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			case "buffer":
			case "file": oopts.type = has_buf ? "nodebuffer" : "string"; break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		if(o.type === "file") return write_dl(o.file, z.generate(oopts));
		var out = z.generate(oopts);
		// $FlowIgnore
		return o.type == "string" ? utf8read(out) : out;
	}
	
	function write_cfb_type(wb, opts) {
		var o = opts||{};
		var cfb = write_xlscfb(wb, o);
		switch(o.type) {
			case "base64": case "binary": break;
			case "buffer": case "array": o.type = ""; break;
			case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			default: throw new Error("Unrecognized type " + o.type);
		}
		return CFB.write(cfb, o);
	}
	
	function write_string_type(out, opts, bom) {
		if(!bom) bom = "";
		var o = bom + out;
		switch(opts.type) {
			case "base64": return Base64.encode(utf8write(o));
			case "binary": return utf8write(o);
			case "string": return out;
			case "file": return write_dl(opts.file, o, 'utf8');
			case "buffer": {
				if(has_buf) return new Buffer(o, 'utf8');
				else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	function write_stxt_type(out, opts) {
		switch(opts.type) {
			case "base64": return Base64.encode(out);
			case "binary": return out;
			case "string": return out; /* override in sheet_to_txt */
			case "file": return write_dl(opts.file, out, 'binary');
			case "buffer": {
				if(has_buf) return new Buffer(out, 'binary');
				else return out.split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	/* TODO: test consistency */
	function write_binary_type(out, opts) {
		switch(opts.type) {
			case "string":
			case "base64":
			case "binary":
				var bstr = "";
				// $FlowIgnore
				for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
				return opts.type == 'base64' ? Base64.encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
			case "file": return write_dl(opts.file, out);
			case "buffer": return out;
			default: throw new Error("Unrecognized type " + opts.type);
		}
	}
	
	function writeSync(wb, opts) {
		check_wb(wb);
		var o = opts||{};
		if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
		switch(o.bookType || 'xlsb') {
			case 'xml':
			case 'xlml': return write_string_type(write_xlml(wb, o), o);
			case 'slk':
			case 'sylk': return write_string_type(write_slk_str(wb, o), o);
			case 'html': return write_string_type(write_htm_str(wb, o), o);
			case 'txt': return write_stxt_type(write_txt_str(wb, o), o);
			case 'csv': return write_string_type(write_csv_str(wb, o), o, "\ufeff");
			case 'dif': return write_string_type(write_dif_str(wb, o), o);
			// $FlowIgnore
			case 'dbf': return write_binary_type(write_dbf_buf(wb, o), o);
			case 'prn': return write_string_type(write_prn_str(wb, o), o);
			case 'rtf': return write_string_type(write_rtf_str(wb, o), o);
			case 'eth': return write_string_type(write_eth_str(wb, o), o);
			case 'fods': return write_string_type(write_ods(wb, o), o);
			case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
			case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
			case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
			case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
			case 'biff8':
			case 'xla':
			case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
			case 'xlsx':
			case 'xlsm':
			case 'xlam':
			case 'xlsb':
			case 'ods': return write_zip_type(wb, o);
			default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
		}
	}
	
	function resolve_book_type(o) {
		if(o.bookType) return;
		var _BT = {
			"xls": "biff8",
			"htm": "html",
			"slk": "sylk",
			"socialcalc": "eth",
			"Sh33tJS": "WTF"
		};
		var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
		if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
		o.bookType = _BT[o.bookType] || o.bookType;
	}
	
	function writeFileSync(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSync(wb, o);
	}
	
	function writeFileAsync(filename, wb, opts, cb) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		o.type = 'buffer';
		var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
		return _fs.writeFile(filename, writeSync(wb, o), _cb);
	}
	function sheet_to_json(sheet, opts) {
		if(sheet == null || sheet["!ref"] == null) return [];
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], isempty = true, v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var raw = o.raw;
		var defval = o.defval;
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var out = [];
		var outi = 0, counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0, CC = 0;
		if(dense && !sheet[R]) sheet[R] = [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = 0;
					for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
					hdr[C] = vv;
			}
		}
		var row = (header === 1) ? [] : {};
		for (R = r.s.r + offset; R <= r.e.r; ++R) {
			rr = encode_row(R);
			isempty = true;
			if(header === 1) row = [];
			else {
				row = {};
				if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
				else row.__rowNum__ = R;
			}
			if(!dense || sheet[R]) for (C = r.s.c; C <= r.e.c; ++C) {
				val = dense ? sheet[R][C] : sheet[cols[C] + rr];
				if(val === undefined || val.t === undefined) {
					if(defval === undefined) continue;
					if(hdr[C] != null) { row[hdr[C]] = defval; isempty = false; }
					continue;
				}
				v = val.v;
				switch(val.t){
					case 'z': if(v == null) break; continue;
					case 'e': continue;
					case 's': case 'd': case 'b': case 'n': break;
					default: throw new Error('unrecognized type ' + val.t);
				}
				if(hdr[C] != null) {
					if(v == null) {
						if(defval !== undefined) row[hdr[C]] = defval;
						else if(raw && v === null) row[hdr[C]] = null;
						else continue;
					} else {
						row[hdr[C]] = raw ? v : format_cell(val,v,o);
					}
					isempty = false;
				}
			}
			if((isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row;
		}
		out.length = outi;
		return out;
	}
	
	var qreg = /"/g;
	function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
		var isempty = true;
		var row = [], txt = "", rr = encode_row(R);
		for(var C = r.s.c; C <= r.e.c; ++C) {
			if (!cols[C]) continue;
			var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
			if(val == null) txt = "";
			else if(val.v != null) {
				isempty = false;
				txt = ''+format_cell(val, null, o);
				for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
				if(txt == "ID") txt = '"ID"';
			} else if(val.f != null && !val.F) {
				isempty = false;
				txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
			} else txt = "";
			/* NOTE: Excel CSV does not support array formulae */
			row.push(txt);
		}
		if(o.blankrows === false && isempty) return null;
		return row.join(FS);
	}
	
	function sheet_to_csv(sheet, opts) {
		var out = [];
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
			if(row == null) { continue; }
			if(o.strip) row = row.replace(endregex,"");
			out.push(row + RS);
		}
		delete o.dense;
		return out.join("");
	}
	
	function sheet_to_txt(sheet, opts) {
		if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
		var s = sheet_to_csv(sheet, opts);
		if(typeof cptable == 'undefined' || opts.type == 'string') return s;
		var o = cptable.utils.encode(1200, s, 'str');
		return String.fromCharCode(255) + String.fromCharCode(254) + o;
	}
	
	function sheet_to_formulae(sheet) {
		var y = "", x, val="";
		if(sheet == null || sheet["!ref"] == null) return [];
		var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
		var cmds = [];
		var dense = Array.isArray(sheet);
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				y = cols[C] + rr;
				x = dense ? (sheet[R]||[])[C] : sheet[y];
				val = "";
				if(x === undefined) continue;
				else if(x.F != null) {
					y = x.F;
					if(!x.f) continue;
					val = x.f;
					if(y.indexOf(":") == -1) y = y + ":" + y;
				}
				if(x.f != null) val = x.f;
				else if(x.t == 'z') continue;
				else if(x.t == 'n' && x.v != null) val = "" + x.v;
				else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
				else if(x.w !== undefined) val = "'" + x.w;
				else if(x.v === undefined) continue;
				else if(x.t == 's') val = "'" + x.v;
				else val = ""+x.v;
				cmds[cmds.length] = y + "=" + val;
			}
		}
		return cmds;
	}
	
	function sheet_add_json(_ws, js, opts) {
		var o = opts || {};
		var offset = +!o.skipHeader;
		var ws = _ws || ({});
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var cell;
		var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) { _R = range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
		}
		var hdr = o.header || [], C = 0;
	
		js.forEach(function (JS, R) {
			keys(JS).filter(function(x) { return JS.hasOwnProperty(x); }).forEach(function(k) {
				if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
				var v = JS[k];
				var t = 'z';
				var z = "";
				if(typeof v == 'number') t = 'n';
				else if(typeof v == 'boolean') t = 'b';
				else if(typeof v == 'string') t = 's';
				else if(v instanceof Date) {
					t = 'd';
					if(!o.cellDates) { t = 'n'; v = datenum(v); }
					z = o.dateNF || SSF._table[14];
				}
				ws[encode_cell({c:_C + C,r:_R + R + offset})] = cell = ({t:t, v:v});
				if(z) cell.z = z;
			});
		});
		range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
		var __R = encode_row(_R);
		if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }
	
	var utils = {
		encode_col: encode_col,
		encode_row: encode_row,
		encode_cell: encode_cell,
		encode_range: encode_range,
		decode_col: decode_col,
		decode_row: decode_row,
		split_cell: split_cell,
		decode_cell: decode_cell,
		decode_range: decode_range,
		format_cell: format_cell,
		get_formulae: sheet_to_formulae,
		make_csv: sheet_to_csv,
		make_json: sheet_to_json,
		make_formulae: sheet_to_formulae,
		sheet_add_aoa: sheet_add_aoa,
		sheet_add_json: sheet_add_json,
		aoa_to_sheet: aoa_to_sheet,
		json_to_sheet: json_to_sheet,
		table_to_sheet: parse_dom_table,
		table_to_book: table_to_book,
		sheet_to_csv: sheet_to_csv,
		sheet_to_txt: sheet_to_txt,
		sheet_to_json: sheet_to_json,
		sheet_to_html: HTML_.from_sheet,
		sheet_to_dif: DIF.from_sheet,
		sheet_to_slk: SYLK.from_sheet,
		sheet_to_eth: ETH.from_sheet,
		sheet_to_formulae: sheet_to_formulae,
		sheet_to_row_object_array: sheet_to_json
	};
	
	(function(utils) {
	utils.consts = utils.consts || {};
	function add_consts(R/*Array<any>*/) { R.forEach(function(a){ utils.consts[a[0]] = a[1]; }); }
	
	function get_default(x, y, z) { return x[y] != null ? x[y] : (x[y] = z); }
	
	/* get cell, creating a stub if necessary */
	function ws_get_cell_stub(ws, R, C) {
		/* A1 cell address */
		if(typeof R == "string") return ws[R] || (ws[R] = {t:'z'});
		/* cell address object */
		if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
		/* R and C are 0-based indices */
		return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
	}
	
	/* find sheet index for given name / validate index */
	function wb_sheet_idx(wb, sh) {
		if(typeof sh == "number") {
			if(sh >= 0 && wb.SheetNames.length > sh) return sh;
			throw new Error("Cannot find sheet # " + sh);
		} else if(typeof sh == "string") {
			var idx = wb.SheetNames.indexOf(sh);
			if(idx > -1) return idx;
			throw new Error("Cannot find sheet name |" + sh + "|");
		} else throw new Error("Cannot find sheet |" + sh + "|");
	}
	
	/* simple blank workbook object */
	utils.book_new = function() {
		return { SheetNames: [], Sheets: {} };
	};
	
	/* add a worksheet to the end of a given workbook */
	utils.book_append_sheet = function(wb, ws, name) {
		if(!name) for(var i = 1; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
		if(!name) throw new Error("Too many worksheets");
		check_ws_name(name);
		if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
	
		wb.SheetNames.push(name);
		wb.Sheets[name] = ws;
	};
	
	/* set sheet visibility (visible/hidden/very hidden) */
	utils.book_set_sheet_visibility = function(wb, sh, vis) {
		get_default(wb,"Workbook",{});
		get_default(wb.Workbook,"Sheets",[]);
	
		var idx = wb_sheet_idx(wb, sh);
		// $FlowIgnore
		get_default(wb.Workbook.Sheets,idx, {});
	
		switch(vis) {
			case 0: case 1: case 2: break;
			default: throw new Error("Bad sheet visibility setting " + vis);
		}
		// $FlowIgnore
		wb.Workbook.Sheets[idx].Hidden = vis;
	};
	add_consts([
		["SHEET_VISIBLE", 0],
		["SHEET_HIDDEN", 1],
		["SHEET_VERY_HIDDEN", 2]
	]);
	
	/* set number format */
	utils.cell_set_number_format = function(cell, fmt) {
		cell.z = fmt;
		return cell;
	};
	
	/* set cell hyperlink */
	utils.cell_set_hyperlink = function(cell, target, tooltip) {
		if(!target) {
			delete cell.l;
		} else {
			cell.l = ({ Target: target });
			if(tooltip) cell.l.Tooltip = tooltip;
		}
		return cell;
	};
	utils.cell_set_internal_link = function(cell, range, tooltip) { return utils.cell_set_hyperlink(cell, "#" + range, tooltip); };
	
	/* add to cell comments */
	utils.cell_add_comment = function(cell, text, author) {
		if(!cell.c) cell.c = [];
		cell.c.push({t:text, a:author||"SheetJS"});
	};
	
	/* set array formula and flush related cells */
	utils.sheet_set_array_formula = function(ws, range, formula) {
		var rng = typeof range != "string" ? range : safe_decode_range(range);
		var rngstr = typeof range == "string" ? range : encode_range(range);
		for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
			var cell = ws_get_cell_stub(ws, R, C);
			cell.t = 'n';
			cell.F = rngstr;
			delete cell.v;
			if(R == rng.s.r && C == rng.s.c) cell.f = formula;
		}
		return ws;
	};
	
	return utils;
	})(utils);
	
	if(has_buf && "function" != 'undefined') (function() {
		var Readable = __webpack_require__(4041).Readable;
	
		var write_csv_stream = function(sheet, opts) {
			var stream = Readable();
			var o = opts == null ? {} : opts;
			if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
			var r = safe_decode_range(sheet["!ref"]);
			var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
			var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
			var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
			var row = "", cols = [];
			o.dense = Array.isArray(sheet);
			var colinfo = o.skipHidden && sheet["!cols"] || [];
			var rowinfo = o.skipHidden && sheet["!rows"] || [];
			for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
			var R = r.s.r;
			stream._read = function() {
				if(R > r.e.r) return stream.push(null);
				while(R <= r.e.r) {
					++R;
					if ((rowinfo[R-1]||{}).hidden) continue;
					row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
					if(row != null) {
						if(o.strip) row = row.replace(endregex,"");
						stream.push(row + RS);
						break;
					}
				}
			};
			return stream;
		};
	
		var write_html_stream = function(ws, opts) {
			var stream = Readable();
	
			var o = opts || {};
			var header = o.header != null ? o.header : HTML_.BEGIN;
			var footer = o.footer != null ? o.footer : HTML_.END;
			stream.push(header);
			var r = decode_range(ws['!ref']);
			o.dense = Array.isArray(ws);
			stream.push(HTML_._preamble(ws, r, o));
			var R = r.s.r;
			var end = false;
			stream._read = function() {
				if(R > r.e.r) {
					if(!end) { end = true; stream.push("</table>" + footer); }
					return stream.push(null);
				}
				while(R <= r.e.r) {
					stream.push(HTML_._row(ws, r, R, o));
					++R;
					break;
				}
			};
			return stream;
		};
	
		XLSX.stream = {
			to_html: write_html_stream,
			to_csv: write_csv_stream
		};
	})();
	
	XLSX.parse_xlscfb = parse_xlscfb;
	XLSX.parse_ods = parse_ods;
	XLSX.parse_fods = parse_fods;
	XLSX.write_ods = write_ods;
	XLSX.parse_zip = parse_zip;
	XLSX.read = readSync; //xlsread
	XLSX.readFile = readFileSync; //readFile
	XLSX.readFileSync = readFileSync;
	XLSX.write = writeSync;
	XLSX.writeFile = writeFileSync;
	XLSX.writeFileSync = writeFileSync;
	XLSX.writeFileAsync = writeFileAsync;
	XLSX.utils = utils;
	XLSX.SSF = SSF;
	XLSX.CFB = CFB;
	})( true ? exports : XLSX);
	/*exported XLS, ODS */
	var XLS = XLSX, ODS = XLSX;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(25).Buffer, __webpack_require__(76)))

/***/ }),
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	var bind = __webpack_require__(231);
	var Axios = __webpack_require__(636);
	var defaults = __webpack_require__(162);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(228);
	axios.CancelToken = __webpack_require__(635);
	axios.isCancel = __webpack_require__(229);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(650);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(228);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(162);
	var utils = __webpack_require__(42);
	var InterceptorManager = __webpack_require__(637);
	var dispatchRequest = __webpack_require__(638);
	var isAbsoluteURL = __webpack_require__(646);
	var combineURLs = __webpack_require__(644);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	var transformData = __webpack_require__(641);
	var isCancel = __webpack_require__(229);
	var defaults = __webpack_require__(162);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 639 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(230);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 642 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 644 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 646 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 650 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1567), __esModule: true };

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1570), __esModule: true };

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1572), __esModule: true };

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1576), __esModule: true };

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(368);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1492);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(7);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(169);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
	__webpack_require__(1513)
	__webpack_require__(1503)
	__webpack_require__(1504)
	__webpack_require__(1505)
	__webpack_require__(1506)
	__webpack_require__(1507)
	__webpack_require__(1508)
	__webpack_require__(1512)
	__webpack_require__(1509)
	__webpack_require__(1510)
	__webpack_require__(1511)
	__webpack_require__(1502)

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);


/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);


/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);


/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);


/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);


/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);


/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(170);
	var Transform = __webpack_require__(171);
	var inherits = __webpack_require__(64);
	var modes = __webpack_require__(172);
	var StreamCipher = __webpack_require__(377);
	var ebtk = __webpack_require__(371);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(375),
	  CBC: __webpack_require__(372),
	  CFB: __webpack_require__(373),
	  OFB: __webpack_require__(376),
	  CTR: __webpack_require__(374)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(170);
	var Transform = __webpack_require__(171);
	var inherits = __webpack_require__(64);
	var modes = __webpack_require__(172);
	var ebtk = __webpack_require__(371);
	var StreamCipher = __webpack_require__(377);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(375),
	  CBC: __webpack_require__(372),
	  CFB: __webpack_require__(373),
	  OFB: __webpack_require__(376),
	  CTR: __webpack_require__(374)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(1515)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(1514)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(172);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(1537)();
	
	Chart.helpers = __webpack_require__(19);
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	__webpack_require__(1536)(Chart);
	
	Chart.defaults = __webpack_require__(23);
	Chart.Element = __webpack_require__(57);
	Chart.elements = __webpack_require__(69);
	Chart.Interaction = __webpack_require__(378);
	Chart.layouts = __webpack_require__(107);
	Chart.platform = __webpack_require__(380);
	Chart.plugins = __webpack_require__(379);
	Chart.Ticks = __webpack_require__(108);
	
	__webpack_require__(1533)(Chart);
	__webpack_require__(1534)(Chart);
	__webpack_require__(1535)(Chart);
	__webpack_require__(1539)(Chart);
	__webpack_require__(1538)(Chart);
	__webpack_require__(1540)(Chart);
	
	__webpack_require__(1556)(Chart);
	__webpack_require__(1554)(Chart);
	__webpack_require__(1555)(Chart);
	__webpack_require__(1557)(Chart);
	__webpack_require__(1558)(Chart);
	__webpack_require__(1559)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(1526)(Chart);
	__webpack_require__(1527)(Chart);
	__webpack_require__(1528)(Chart);
	__webpack_require__(1529)(Chart);
	__webpack_require__(1530)(Chart);
	__webpack_require__(1531)(Chart);
	__webpack_require__(1532)(Chart);
	
	__webpack_require__(1519)(Chart);
	__webpack_require__(1520)(Chart);
	__webpack_require__(1521)(Chart);
	__webpack_require__(1522)(Chart);
	__webpack_require__(1523)(Chart);
	__webpack_require__(1524)(Chart);
	__webpack_require__(1525)(Chart);
	
	// Loading built-it plugins
	var plugins = __webpack_require__(1550);
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			Chart.plugins.register(plugins[k]);
		}
	}
	
	Chart.platform.initialize();
	
	module.exports = Chart;
	if (typeof window !== 'undefined') {
		window.Chart = Chart;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.pluginService = Chart.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.PluginBase = Chart.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.canvasHelpers = Chart.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.layoutService = Chart.layouts;


/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	};


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var elements = __webpack_require__(69);
	var helpers = __webpack_require__(19);
	
	defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
	
				// Specific to Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,
	
				// offset settings
				offset: true,
	
				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				position: 'left',
				type: 'category',
	
				// Specific to Horizontal Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,
	
				// offset settings
				offset: true,
	
				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			callbacks: {
				title: function(item, data) {
					// Pick first xLabel for now
					var title = '';
	
					if (item.length > 0) {
						if (item[0].yLabel) {
							title = item[0].yLabel;
						} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
							title = data.labels[item[0].index];
						}
					}
	
					return title;
				},
	
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					return datasetLabel + ': ' + item.xLabel;
				}
			},
			mode: 'index',
			axis: 'y'
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale.isHorizontal() ? scale.width : scale.height;
		var ticks = scale.getTicks();
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, pixels[i] - pixels[i - 1]);
		}
	
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, curr - prev) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var size, ratio;
	
		if (helpers.isNullOrUndef(thickness)) {
			size = ruler.min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale end extremity.
			prev = curr - (next === null ? ruler.end - curr : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - ((curr - prev) / 2) * percent;
		size = ((next - prev) / 2) * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	module.exports = function(Chart) {
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: elements.Rectangle,
	
			initialize: function() {
				var me = this;
				var meta;
	
				Chart.DatasetController.prototype.initialize.apply(me, arguments);
	
				meta = me.getMeta();
				meta.stack = me.getDataset().stack;
				meta.bar = true;
			},
	
			update: function(reset) {
				var me = this;
				var rects = me.getMeta().data;
				var i, ilen;
	
				me._ruler = me.getRuler();
	
				for (i = 0, ilen = rects.length; i < ilen; ++i) {
					me.updateElement(rects[i], i, reset);
				}
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var dataset = me.getDataset();
				var custom = rectangle.custom || {};
				var rectangleOptions = chart.options.elements.rectangle;
	
				rectangle._xScale = me.getScaleForId(meta.xAxisID);
				rectangle._yScale = me.getScaleForId(meta.yAxisID);
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				rectangle._model = {
					datasetLabel: dataset.label,
					label: chart.data.labels[index],
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
				};
	
				me.updateElementGeometry(rectangle, index, reset);
	
				rectangle.pivot();
			},
	
			/**
			 * @private
			 */
			updateElementGeometry: function(rectangle, index, reset) {
				var me = this;
				var model = rectangle._model;
				var vscale = me.getValueScale();
				var base = vscale.getBasePixel();
				var horizontal = vscale.isHorizontal();
				var ruler = me._ruler || me.getRuler();
				var vpixels = me.calculateBarValuePixels(me.index, index);
				var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);
	
				model.horizontal = horizontal;
				model.base = reset ? base : vpixels.base;
				model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
				model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
				model.height = horizontal ? ipixels.size : undefined;
				model.width = horizontal ? undefined : ipixels.size;
			},
	
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().yAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getValueScale: function() {
				return this.getScaleForId(this.getValueScaleId());
			},
	
			/**
			 * @private
			 */
			getIndexScale: function() {
				return this.getScaleForId(this.getIndexScaleId());
			},
	
			/**
			 * Returns the stacks based on groups and bar visibility.
			 * @param {Number} [last] - The dataset index
			 * @returns {Array} The stack list
			 * @private
			 */
			_getStacks: function(last) {
				var me = this;
				var chart = me.chart;
				var scale = me.getIndexScale();
				var stacked = scale.options.stacked;
				var ilen = last === undefined ? chart.data.datasets.length : last + 1;
				var stacks = [];
				var i, meta;
	
				for (i = 0; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					if (meta.bar && chart.isDatasetVisible(i) &&
						(stacked === false ||
						(stacked === true && stacks.indexOf(meta.stack) === -1) ||
						(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
						stacks.push(meta.stack);
					}
				}
	
				return stacks;
			},
	
			/**
			 * Returns the effective number of stacks based on groups and bar visibility.
			 * @private
			 */
			getStackCount: function() {
				return this._getStacks().length;
			},
	
			/**
			 * Returns the stack index for the given dataset based on groups and bar visibility.
			 * @param {Number} [datasetIndex] - The dataset index
			 * @param {String} [name] - The stack name to find
			 * @returns {Number} The stack index
			 * @private
			 */
			getStackIndex: function(datasetIndex, name) {
				var stacks = this._getStacks(datasetIndex);
				var index = (name !== undefined)
					? stacks.indexOf(name)
					: -1; // indexOf returns -1 if element is not present
	
				return (index === -1)
					? stacks.length - 1
					: index;
			},
	
			/**
			 * @private
			 */
			getRuler: function() {
				var me = this;
				var scale = me.getIndexScale();
				var stackCount = me.getStackCount();
				var datasetIndex = me.index;
				var isHorizontal = scale.isHorizontal();
				var start = isHorizontal ? scale.left : scale.top;
				var end = start + (isHorizontal ? scale.width : scale.height);
				var pixels = [];
				var i, ilen, min;
	
				for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
					pixels.push(scale.getPixelForValue(null, i, datasetIndex));
				}
	
				min = helpers.isNullOrUndef(scale.options.barThickness)
					? computeMinSampleSize(scale, pixels)
					: -1;
	
				return {
					min: min,
					pixels: pixels,
					start: start,
					end: end,
					stackCount: stackCount,
					scale: scale
				};
			},
	
			/**
			 * Note: pixel values are not clamped to the scale area.
			 * @private
			 */
			calculateBarValuePixels: function(datasetIndex, index) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var scale = me.getValueScale();
				var datasets = chart.data.datasets;
				var value = scale.getRightValue(datasets[datasetIndex].data[index]);
				var stacked = scale.options.stacked;
				var stack = meta.stack;
				var start = 0;
				var i, imeta, ivalue, base, head, size;
	
				if (stacked || (stacked === undefined && stack !== undefined)) {
					for (i = 0; i < datasetIndex; ++i) {
						imeta = chart.getDatasetMeta(i);
	
						if (imeta.bar &&
							imeta.stack === stack &&
							imeta.controller.getValueScaleId() === scale.id &&
							chart.isDatasetVisible(i)) {
	
							ivalue = scale.getRightValue(datasets[i].data[index]);
							if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
								start += ivalue;
							}
						}
					}
				}
	
				base = scale.getPixelForValue(start);
				head = scale.getPixelForValue(start + value);
				size = (head - base) / 2;
	
				return {
					size: size,
					base: base,
					head: head,
					center: head + size / 2
				};
			},
	
			/**
			 * @private
			 */
			calculateBarIndexPixels: function(datasetIndex, index, ruler) {
				var me = this;
				var options = ruler.scale.options;
				var range = options.barThickness === 'flex'
					? computeFlexCategoryTraits(index, ruler, options)
					: computeFitCategoryTraits(index, ruler, options);
	
				var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
				var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
				var size = Math.min(
					helpers.valueOrDefault(options.maxBarThickness, Infinity),
					range.chunk * range.ratio);
	
				return {
					base: center - size / 2,
					head: center + size / 2,
					center: center,
					size: size
				};
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var scale = me.getValueScale();
				var rects = me.getMeta().data;
				var dataset = me.getDataset();
				var ilen = rects.length;
				var i = 0;
	
				helpers.canvas.clipArea(chart.ctx, chart.chartArea);
	
				for (; i < ilen; ++i) {
					if (!isNaN(scale.getRightValue(dataset.data[i]))) {
						rects[i].draw();
					}
				}
	
				helpers.canvas.unclipArea(chart.ctx);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
		});
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().yAxisID;
			}
		});
	};


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var elements = __webpack_require__(69);
	var helpers = __webpack_require__(19);
	
	defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	
	module.exports = function(Chart) {
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
			/**
			 * @protected
			 */
			dataElementType: elements.Point,
	
			/**
			 * @protected
			 */
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			/**
			 * @protected
			 */
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var options = me._resolveElementOptions(point, index);
				var data = me.getDataset().data[index];
				var dsIndex = me.index;
	
				var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
				var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
				point._xScale = xScale;
				point._yScale = yScale;
				point._options = options;
				point._datasetIndex = dsIndex;
				point._index = index;
				point._model = {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					hitRadius: options.hitRadius,
					pointStyle: options.pointStyle,
					radius: reset ? 0 : options.radius,
					skip: custom.skip || isNaN(x) || isNaN(y),
					x: x,
					y: y,
				};
	
				point.pivot();
			},
	
			/**
			 * @protected
			 */
			setHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
	
				model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
				model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
				model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
				model.radius = options.radius + options.hoverRadius;
			},
	
			/**
			 * @protected
			 */
			removeHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
	
				model.backgroundColor = options.backgroundColor;
				model.borderColor = options.borderColor;
				model.borderWidth = options.borderWidth;
				model.radius = options.radius;
			},
	
			/**
			 * @private
			 */
			_resolveElementOptions: function(point, index) {
				var me = this;
				var chart = me.chart;
				var datasets = chart.data.datasets;
				var dataset = datasets[me.index];
				var custom = point.custom || {};
				var options = chart.options.elements.point;
				var resolve = helpers.options.resolve;
				var data = dataset.data[index];
				var values = {};
				var i, ilen, key;
	
				// Scriptable options
				var context = {
					chart: chart,
					dataIndex: index,
					dataset: dataset,
					datasetIndex: me.index
				};
	
				var keys = [
					'backgroundColor',
					'borderColor',
					'borderWidth',
					'hoverBackgroundColor',
					'hoverBorderColor',
					'hoverBorderWidth',
					'hoverRadius',
					'hitRadius',
					'pointStyle'
				];
	
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						dataset[key],
						options[key]
					], context, index);
				}
	
				// Custom radius resolution
				values.radius = resolve([
					custom.radius,
					data ? data.r : undefined,
					dataset.radius,
					options.radius
				], context, index);
	
				return values;
			}
		});
	};


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var elements = __webpack_require__(69);
	var helpers = __webpack_require__(19);
	
	defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc && arc.custom || {};
							var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: Math.PI * -0.5,
	
		// The total circumference of the chart.
		circumference: Math.PI * 2.0,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	defaults._set('pie', helpers.clone(defaults.doughnut));
	defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
				var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
				var minSize = Math.min(availableWidth, availableHeight);
				var offset = {x: 0, y: 0};
				var meta = me.getMeta();
				var cutoutPercentage = opts.cutoutPercentage;
				var circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var animationOpts = opts.animation;
				var centerX = (chartArea.left + chartArea.right) / 2;
				var centerY = (chartArea.top + chartArea.bottom) / 2;
				var startAngle = opts.rotation; // non reset case handled later
				var endAngle = opts.rotation; // non reset case handled later
				var dataset = me.getDataset();
				var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
				var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
				var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
				var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (Math.abs(value) / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(arcs) {
				var max = 0;
				var index = this.index;
				var length = arcs.length;
				var borderWidth;
				var hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
					hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var elements = __webpack_require__(69);
	var helpers = __webpack_require__(19);
	
	defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	module.exports = function(Chart) {
	
		function lineEnabled(dataset, options) {
			return helpers.valueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: elements.Line,
	
			dataElementType: elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
					borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var points = meta.data || [];
				var area = chart.chartArea;
				var ilen = points.length;
				var i = 0;
	
				helpers.canvas.clipArea(chart.ctx, area);
	
				if (lineEnabled(me.getDataset(), chart.options)) {
					meta.dataset.draw();
				}
	
				helpers.canvas.unclipArea(chart.ctx);
	
				// Draw the points
				for (; i < ilen; ++i) {
					points[i].draw(area);
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var elements = __webpack_require__(69);
	var helpers = __webpack_require__(19);
	
	defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc.custom || {};
							var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var elements = __webpack_require__(69);
	var helpers = __webpack_require__(19);
	
	defaults._set('radar', {
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				tension: 0 // no bezier in radar
			}
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: elements.Line,
	
			dataElementType: elements.Point,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					_scale: scale,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	
	defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		showLines: false,
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	module.exports = function(Chart) {
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
	};


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	var helpers = __webpack_require__(19);
	
	defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.Animation = Element.extend({
			chart: null, // the animation associated chart instance
			currentStep: 0, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null, // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
	
			/**
			 * @param {Chart} chart - The chart to animate.
			 * @param {Chart.Animation} animation - The animation that we will animate.
			 * @param {Number} duration - The animation duration in ms.
			 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
			 */
			addAnimation: function(chart, animation, duration, lazy) {
				var animations = this.animations;
				var i, ilen;
	
				animation.chart = chart;
	
				if (!lazy) {
					chart.animating = true;
				}
	
				for (i = 0, ilen = animations.length; i < ilen; ++i) {
					if (animations[i].chart === chart) {
						animations[i] = animation;
						return;
					}
				}
	
				animations.push(animation);
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (animations.length === 1) {
					this.requestAnimationFrame();
				}
			},
	
			cancelAnimation: function(chart) {
				var index = helpers.findIndex(this.animations, function(animation) {
					return animation.chart === chart;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chart.animating = false;
				}
			},
	
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
	
			/**
			 * @private
			 */
			startDigest: function() {
				var me = this;
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				me.advance(1 + framesToDrop);
	
				var endTime = Date.now();
	
				me.dropFrames += (endTime - startTime) / me.frameDuration;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			},
	
			/**
			 * @private
			 */
			advance: function(count) {
				var animations = this.animations;
				var animation, chart;
				var i = 0;
	
				while (i < animations.length) {
					animation = animations[i];
					chart = animation.chart;
	
					animation.currentStep = (animation.currentStep || 0) + count;
					animation.currentStep = Math.min(animation.currentStep, animation.numSteps);
	
					helpers.callback(animation.render, [chart, animation], chart);
					helpers.callback(animation.onAnimationProgress, [animation], chart);
	
					if (animation.currentStep >= animation.numSteps) {
						helpers.callback(animation.onAnimationComplete, [animation], chart);
						chart.animating = false;
						animations.splice(i, 1);
					} else {
						++i;
					}
				}
			}
		};
	
		/**
		 * Provided for backward compatibility, use Chart.Animation instead
		 * @prop Chart.Animation#animationObject
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
			get: function() {
				return this;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart.Animation#chart instead
		 * @prop Chart.Animation#chartInstance
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
			get: function() {
				return this.chart;
			},
			set: function(value) {
				this.chart = value;
			}
		});
	
	};


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var helpers = __webpack_require__(19);
	var Interaction = __webpack_require__(378);
	var layouts = __webpack_require__(107);
	var platform = __webpack_require__(380);
	var plugins = __webpack_require__(379);
	
	module.exports = function(Chart) {
	
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};
	
			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];
	
			config.options = helpers.configMerge(
				defaults.global,
				defaults[config.type],
				config.options || {});
	
			return config;
		}
	
		/**
		 * Updates the config of the chart
		 * @param chart {Chart} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;
	
			helpers.each(chart.scales, function(scale) {
				layouts.removeBox(chart, scale);
			});
	
			newOptions = helpers.configMerge(
				Chart.defaults.global,
				Chart.defaults[chart.config.type],
				newOptions);
	
			chart.options = chart.config.options = newOptions;
			chart.ensureScalesHaveIDs();
			chart.buildOrUpdateScales();
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
			chart.tooltip.initialize();
		}
	
		function positionIsHorizontal(position) {
			return position === 'top' || position === 'bottom';
		}
	
		helpers.extend(Chart.prototype, /** @lends Chart */ {
			/**
			 * @private
			 */
			construct: function(item, config) {
				var me = this;
	
				config = initConfig(config);
	
				var context = platform.acquireContext(item, config);
				var canvas = context && context.canvas;
				var height = canvas && canvas.height;
				var width = canvas && canvas.width;
	
				me.id = helpers.uid();
				me.ctx = context;
				me.canvas = canvas;
				me.config = config;
				me.width = width;
				me.height = height;
				me.aspectRatio = height ? width / height : null;
				me.options = config.options;
				me._bufferedRender = false;
	
				/**
				 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
				 * the "instance" still need to be defined since it might be called from plugins.
				 * @prop Chart#chart
				 * @deprecated since version 2.6.0
				 * @todo remove at version 3
				 * @private
				 */
				me.chart = me;
				me.controller = me; // chart.chart.controller #inception
	
				// Add the chart instance to the global namespace
				Chart.instances[me.id] = me;
	
				// Define alias to the config data: `chart.data === chart.config.data`
				Object.defineProperty(me, 'data', {
					get: function() {
						return me.config.data;
					},
					set: function(value) {
						me.config.data = value;
					}
				});
	
				if (!context || !canvas) {
					// The given item is not a compatible context2d element, let's return before finalizing
					// the chart initialization but after setting basic chart / controller properties that
					// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
					// https://github.com/chartjs/Chart.js/issues/2807
					console.error("Failed to create chart: can't acquire context from the given item");
					return;
				}
	
				me.initialize();
				me.update();
			},
	
			/**
			 * @private
			 */
			initialize: function() {
				var me = this;
	
				// Before init plugin notification
				plugins.notify(me, 'beforeInit');
	
				helpers.retinaScale(me, me.options.devicePixelRatio);
	
				me.bindEvents();
	
				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}
	
				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildOrUpdateScales();
				me.initToolTip();
	
				// After init plugin notification
				plugins.notify(me, 'afterInit');
	
				return me;
			},
	
			clear: function() {
				helpers.canvas.clear(this);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occurring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var options = me.options;
				var canvas = me.canvas;
				var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.
	
				// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
				var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
				var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));
	
				if (me.width === newWidth && me.height === newHeight) {
					return;
				}
	
				canvas.width = me.width = newWidth;
				canvas.height = me.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';
	
				helpers.retinaScale(me, options.devicePixelRatio);
	
				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);
	
					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}
	
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildOrUpdateScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales || {};
				var items = [];
				var updated = Object.keys(scales).reduce(function(obj, id) {
					obj[id] = false;
					return obj;
				}, {});
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
						})
					);
				}
	
				if (options.scale) {
					items.push({
						options: options.scale,
						dtype: 'radialLinear',
						isDefault: true,
						dposition: 'chartArea'
					});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var id = scaleOptions.id;
					var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);
	
					if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
						scaleOptions.position = item.dposition;
					}
	
					updated[id] = true;
					var scale = null;
					if (id in scales && scales[id].type === scaleType) {
						scale = scales[id];
						scale.options = scaleOptions;
						scale.ctx = me.ctx;
						scale.chart = me;
					} else {
						var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
						if (!scaleClass) {
							return;
						}
						scale = new scaleClass({
							id: id,
							type: scaleType,
							options: scaleOptions,
							ctx: me.ctx,
							chart: me
						});
						scales[scale.id] = scale;
					}
	
					scale.mergeTicksOptions();
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
				// clear up discarded scales
				helpers.each(updated, function(hasUpdated, id) {
					if (!hasUpdated) {
						delete scales[id];
					}
				});
	
				me.scales = scales;
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					var type = dataset.type || me.config.type;
	
					if (meta.type && meta.type !== type) {
						me.destroyDatasetMeta(datasetIndex);
						meta = me.getDatasetMeta(datasetIndex);
					}
					meta.type = type;
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
						meta.controller.linkScales();
					} else {
						var ControllerClass = Chart.controllers[meta.type];
						if (ControllerClass === undefined) {
							throw new Error('"' + meta.type + '" is not a chart type.');
						}
	
						meta.controller = new ControllerClass(me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				return newControllers;
			},
	
			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},
	
			update: function(config) {
				var me = this;
	
				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}
	
				updateConfig(me);
	
				// plugins options references might have change, let's invalidate the cache
				// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
				plugins._invalidate(me);
	
				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				me.updateLayout();
	
				// Can only reset the new controllers after the scales have been updated
				if (me.options.animation && me.options.animation.duration) {
					helpers.each(newControllers, function(controller) {
						controller.reset();
					});
				}
	
				me.updateDatasets();
	
				// Need to reset tooltip in case it is displayed with elements that are removed
				// after update.
				me.tooltip.initialize();
	
				// Last active contains items that were previously in the tooltip.
				// When we reset the tooltip, we need to clear it
				me.lastActive = [];
	
				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');
	
				if (me._bufferedRender) {
					me._bufferedRequest = {
						duration: config.duration,
						easing: config.easing,
						lazy: config.lazy
					};
				} else {
					me.render(config);
				}
			},
	
			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}
	
				layouts.update(this, this.width, this.height);
	
				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 * @private
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},
	
			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}
	
				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.updateDataset(i);
				}
	
				plugins.notify(me, 'afterDatasetsUpdate');
			},
	
			/**
			 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
			 * @private
			 */
			updateDataset: function(index) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index
				};
	
				if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
					return;
				}
	
				meta.controller.update();
	
				plugins.notify(me, 'afterDatasetUpdate', [args]);
			},
	
			render: function(config) {
				var me = this;
	
				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}
	
				var duration = config.duration;
				var lazy = config.lazy;
	
				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}
	
				var animationOptions = me.options.animation;
				var onComplete = function(animation) {
					plugins.notify(me, 'afterRender');
					helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
				};
	
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation({
						numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
						easing: config.easing || animationOptions.easing,
	
						render: function(chart, animationObject) {
							var easingFunction = helpers.easing.effects[animationObject.easing];
							var currentStep = animationObject.currentStep;
							var stepDecimal = currentStep / animationObject.numSteps;
	
							chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
						},
	
						onAnimationProgress: animationOptions.onProgress,
						onAnimationComplete: onComplete
					});
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
	
					// See https://github.com/chartjs/Chart.js/issues/3781
					onComplete(new Chart.Animation({numSteps: 0, chart: me}));
				}
	
				return me;
			},
	
			draw: function(easingValue) {
				var me = this;
	
				me.clear();
	
				if (helpers.isNullOrUndef(easingValue)) {
					easingValue = 1;
				}
	
				me.transition(easingValue);
	
				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
	
				if (me.scale) {
					me.scale.draw();
				}
	
				me.drawDatasets(easingValue);
				me._drawTooltip(easingValue);
	
				plugins.notify(me, 'afterDraw', [easingValue]);
			},
	
			/**
			 * @private
			 */
			transition: function(easingValue) {
				var me = this;
	
				for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
					if (me.isDatasetVisible(i)) {
						me.getDatasetMeta(i).controller.transition(easingValue);
					}
				}
	
				me.tooltip.transition(easingValue);
			},
	
			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw datasets reversed to support proper line stacking
				for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
					if (me.isDatasetVisible(i)) {
						me.drawDataset(i, easingValue);
					}
				}
	
				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},
	
			/**
			 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
			 * @private
			 */
			drawDataset: function(index, easingValue) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
					return;
				}
	
				meta.controller.draw(easingValue);
	
				plugins.notify(me, 'afterDatasetDraw', [args]);
			},
	
			/**
			 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
			 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
			 * @private
			 */
			_drawTooltip: function(easingValue) {
				var me = this;
				var tooltip = me.tooltip;
				var args = {
					tooltip: tooltip,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
					return;
				}
	
				tooltip.draw();
	
				plugins.notify(me, 'afterTooltipDraw', [args]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Interaction.modes.single(this, e);
			},
	
			getElementsAtEvent: function(e) {
				return Interaction.modes.label(this, e, {intersect: true});
			},
	
			getElementsAtXAxis: function(e) {
				return Interaction.modes['x-axis'](this, e, {intersect: true});
			},
	
			getElementsAtEventForMode: function(e, mode, options) {
				var method = Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}
	
				return [];
			},
	
			getDatasetAtEvent: function(e) {
				return Interaction.modes.dataset(this, e, {intersect: true});
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			/**
			 * @private
			 */
			destroyDatasetMeta: function(datasetIndex) {
				var id = this.id;
				var dataset = this.data.datasets[datasetIndex];
				var meta = dataset._meta && dataset._meta[id];
	
				if (meta) {
					meta.controller.destroy();
					delete dataset._meta[id];
				}
			},
	
			destroy: function() {
				var me = this;
				var canvas = me.canvas;
				var i, ilen;
	
				me.stop();
	
				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.destroyDatasetMeta(i);
				}
	
				if (canvas) {
					me.unbindEvents();
					helpers.canvas.clear(me);
					platform.releaseContext(me.ctx);
					me.canvas = null;
					me.ctx = null;
				}
	
				plugins.notify(me, 'destroy');
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.canvas.toDataURL.apply(this.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me,
					_chartInstance: me, // deprecated, backward compatibility
					_data: me.data,
					_options: me.options.tooltips
				}, me);
			},
	
			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};
	
				helpers.each(me.options.events, function(type) {
					platform.addEventListener(me, type, listener);
					listeners[type] = listener;
				});
	
				// Elements used to detect size change should not be injected for non responsive charts.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};
	
					platform.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},
	
			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}
	
				delete me._listeners;
				helpers.each(listeners, function(listener, type) {
					platform.removeEventListener(me, type, listener);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				for (i = 0, ilen = elements.length; i < ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
	
				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}
	
				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;
	
				var changed = me.handleEvent(e);
				// for smooth tooltip animations issue #4989
				// the tooltip should be the source of change
				// Animation check workaround:
				// tooltip._start will be null when tooltip isn't animating
				if (tooltip) {
					changed = tooltip._start
						? tooltip.handleEvent(e)
						: changed | tooltip.handleEvent(e);
				}
	
				plugins.notify(me, 'afterEvent', [e]);
	
				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();
	
					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render(me.options.hover.animationDuration, true);
				}
	
				me._bufferedRender = false;
				me._bufferedRequest = null;
	
				return me;
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;
	
				me.lastActive = me.lastActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}
	
				// Invoke onHover hook
				// Need to call with native event here to not break backwards compatibility
				helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				changed = !helpers.arrayEquals(me.active, me.lastActive);
	
				// Remember Last Actives
				me.lastActive = me.active;
	
				return changed;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart instead.
		 * @class Chart.Controller
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.Controller = Chart;
	};


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(19);
	
	module.exports = function(Chart) {
	
		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}
	
			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});
	
			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];
	
				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);
	
						helpers.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});
	
						return res;
					}
				});
			});
		}
	
		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}
	
			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}
	
			if (listeners.length > 0) {
				return;
			}
	
			arrayEvents.forEach(function(key) {
				delete array[key];
			});
	
			delete array._chartjs;
		}
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i = 0, ilen = data.length; i < ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);
	
				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}
	
					listenArrayEvents(data, me);
					me._data = data;
				}
	
				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},
	
			update: helpers.noop,
	
			transition: function(easingValue) {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				for (; i < ilen; ++i) {
					elements[i].transition(easingValue);
				}
	
				if (meta.dataset) {
					meta.dataset.transition(easingValue);
				}
			},
	
			draw: function() {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				if (meta.dataset) {
					meta.dataset.draw();
				}
	
				for (; i < ilen; ++i) {
					elements[i].draw();
				}
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers.valueAtIndexOrDefault;
				var model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers.valueAtIndexOrDefault;
				var getHoverColor = helpers.getHoverColor;
				var model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;
	
				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},
	
			/**
			 * @private
			 */
			insertElements: function(start, count) {
				for (var i = 0; i < count; ++i) {
					this.addElementAndReset(start + i);
				}
			},
	
			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length - 1, arguments.length);
			},
	
			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},
	
			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},
	
			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},
	
			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(381);
	var defaults = __webpack_require__(23);
	var helpers = __webpack_require__(19);
	
	module.exports = function(Chart) {
	
		// -- Basic js utility methods
	
		helpers.configMerge = function(/* objects ... */) {
			return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					var tval = target[key] || {};
					var sval = source[key];
	
					if (key === 'scales') {
						// scale config merging is complex. Add our own function here for that
						target[key] = helpers.scaleMerge(tval, sval);
					} else if (key === 'scale') {
						// used in polar area & radar charts since there is only one scale
						target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
					} else {
						helpers._merger(key, target, source, options);
					}
				}
			});
		};
	
		helpers.scaleMerge = function(/* objects ... */) {
			return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					if (key === 'xAxes' || key === 'yAxes') {
						var slen = source[key].length;
						var i, type, scale;
	
						if (!target[key]) {
							target[key] = [];
						}
	
						for (i = 0; i < slen; ++i) {
							scale = source[key][i];
							type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
							if (i >= target[key].length) {
								target[key].push({});
							}
	
							if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
								// new/untyped scale or type changed: let's apply the new defaults
								// then merge source scale to correctly overwrite the defaults.
								helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
							} else {
								// scales type are the same
								helpers.merge(target[key][i], scale);
							}
						}
					} else {
						helpers._merger(key, target, source, options);
					}
				}
			});
		};
	
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10 ?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
				// Check for whole powers of 10,
				// which due to floating point rounding error should be corrected.
				var powerOf10 = Math.round(exponent);
				var isPowerOf10 = x === Math.pow(10, powerOf10);
	
				return isPowerOf10 ? powerOf10 : exponent;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.currentTarget || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			if (!container) {
				return domNode.clientWidth;
			}
	
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			if (!container) {
				return domNode.clientHeight;
			}
	
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers.color = !color ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = defaults.global.defaultColor;
				}
	
				return color(value);
			};
	
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	
	defaults._set('global', {
		responsive: true,
		responsiveAnimationDuration: 0,
		maintainAspectRatio: true,
		events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		showLines: true,
	
		// Element defaults defined in element extensions
		elements: {},
	
		// Layout options such as padding
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.construct(item, config);
			return this;
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	};


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	var helpers = __webpack_require__(19);
	var Ticks = __webpack_require__(108);
	
	defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// line height
			lineHeight: 1.2,
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: Ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	function labelsFromTicks(ticks) {
		var labels = [];
		var i, ilen;
	
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(ticks[i].label);
		}
	
		return labels;
	}
	
	function getLineValue(scale, index, offsetGridLines) {
		var lineValue = scale.getPixelForTick(index);
	
		if (offsetGridLines) {
			if (index === 0) {
				lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
			}
		}
		return lineValue;
	}
	
	module.exports = function(Chart) {
	
		function computeTextSize(context, tick, font) {
			return helpers.isArray(tick) ?
				helpers.longestText(context, font, tick) :
				context.measureText(tick).width;
		}
	
		function parseFontOptions(options) {
			var valueOrDefault = helpers.valueOrDefault;
			var globalDefaults = defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
			var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);
	
			return {
				size: size,
				style: style,
				family: family,
				font: helpers.fontString(size, style, family)
			};
		}
	
		function parseLineHeight(options) {
			return helpers.options.toLineHeight(
				helpers.valueOrDefault(options.lineHeight, 1.2),
				helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
		}
	
		Chart.Scale = Element.extend({
			/**
			 * Get the padding needed for the scale
			 * @method getPadding
			 * @private
			 * @returns {Padding} the necessary padding
			 */
			getPadding: function() {
				var me = this;
				return {
					left: me.paddingLeft || 0,
					top: me.paddingTop || 0,
					right: me.paddingRight || 0,
					bottom: me.paddingBottom || 0
				};
			},
	
			/**
			 * Returns the scale tick objects ({label, major})
			 * @since 2.7
			 */
			getTicks: function() {
				return this._ticks;
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			mergeTicksOptions: function() {
				var ticks = this.options.ticks;
				if (ticks.minor === false) {
					ticks.minor = {
						display: false
					};
				}
				if (ticks.major === false) {
					ticks.major = {
						display: false
					};
				}
				for (var key in ticks) {
					if (key !== 'major' && key !== 'minor') {
						if (typeof ticks.minor[key] === 'undefined') {
							ticks.minor[key] = ticks[key];
						}
						if (typeof ticks.major[key] === 'undefined') {
							ticks.major[key] = ticks[key];
						}
					}
				}
			},
			beforeUpdate: function() {
				helpers.callback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
				var i, ilen, labels, label, ticks, tick;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
				me.longestTextCache = me.longestTextCache || {};
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks - `this.ticks` is now DEPRECATED!
				// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
				// and must not be accessed directly from outside this class. `this.ticks` being
				// around for long time and not marked as private, we can't change its structure
				// without unexpected breaking changes. If you need to access the scale ticks,
				// use scale.getTicks() instead.
	
				me.beforeBuildTicks();
	
				// New implementations should return an array of objects but for BACKWARD COMPAT,
				// we still support no return (`this.ticks` internally set by calling this method).
				ticks = me.buildTicks() || [];
	
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
	
				// New implementations should return the formatted tick labels but for BACKWARD
				// COMPAT, we still support no return (`this.ticks` internally changed by calling
				// this method and supposed to contain only string values).
				labels = me.convertTicksToLabels(ticks) || me.ticks;
	
				me.afterTickToLabelConversion();
	
				me.ticks = labels;   // BACKWARD COMPATIBILITY
	
				// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!
	
				// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
				for (i = 0, ilen = labels.length; i < ilen; ++i) {
					label = labels[i];
					tick = ticks[i];
					if (!tick) {
						ticks.push(tick = {
							label: label,
							major: false
						});
					} else {
						tick.label = label;
					}
				}
	
				me._ticks = ticks;
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				var tickOpts = me.options.ticks;
				me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
			},
			afterTickToLabelConversion: function() {
				helpers.callback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var tickOpts = me.options.ticks;
				var labels = labelsFromTicks(me._ticks);
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFont = parseFontOptions(tickOpts);
				context.font = tickFont.font;
	
				var labelRotation = tickOpts.minRotation || 0;
	
				if (labels.length && me.options.display && me.isHorizontal()) {
					var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
					var labelWidth = originalLabelWidth;
					var cosRotation, sinRotation;
	
					// Allow 3 pixels x2 padding either side for label readability
					var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
					// Max label rotation can be set or default to 90 - also act as a loop counter
					while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
						var angleRadians = helpers.toRadians(labelRotation);
						cosRotation = Math.cos(angleRadians);
						sinRotation = Math.sin(angleRadians);
	
						if (sinRotation * originalLabelWidth > me.maxHeight) {
							// go back one step
							labelRotation--;
							break;
						}
	
						labelRotation++;
						labelWidth = cosRotation * originalLabelWidth;
					}
				}
	
				me.labelRotation = labelRotation;
			},
			afterCalculateTickRotation: function() {
				helpers.callback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var labels = labelsFromTicks(me._ticks);
	
				var opts = me.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFont = parseFontOptions(tickOpts);
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
					var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
					var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;
	
					if (isHorizontal) {
						minSize.height += deltaHeight;
					} else {
						minSize.width += deltaHeight;
					}
				}
	
				// Don't bother fitting the ticks if we are not showing them
				if (tickOpts.display && display) {
					var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
					var lineSpace = tickFont.size * 0.5;
					var tickPadding = me.options.ticks.padding;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						var angleRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(angleRadians);
						var sinRotation = Math.sin(angleRadians);
	
						// TODO - improve this calculation
						var labelHeight = (sinRotation * largestTextWidth)
							+ (tickFont.size * tallestLabelHeightInLines)
							+ (lineSpace * (tallestLabelHeightInLines - 1))
							+ lineSpace; // padding
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
						me.ctx.font = tickFont.font;
						var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
						var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
						// which means that the right padding is dominated by the font height
						if (me.labelRotation !== 0) {
							me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
							me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
						} else {
							me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
							me.paddingRight = lastLabelWidth / 2 + 3;
						}
					} else {
						// A vertical axis is more constrained by the width. Labels are the
						// dominant factor here, so get that length first and account for padding
						if (tickOpts.mirror) {
							largestTextWidth = 0;
						} else {
							// use lineSpace for consistency with horizontal axis
							// tickPadding is not implemented for horizontal
							largestTextWidth += tickPadding + lineSpace;
						}
	
						minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);
	
						me.paddingTop = tickFont.size / 2;
						me.paddingBottom = tickFont.size / 2;
					}
				}
	
				me.handleMargins();
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
	
			/**
			 * Handle margins and padding interactions
			 * @private
			 */
			handleMargins: function() {
				var me = this;
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
			},
	
			afterFit: function() {
				helpers.callback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (helpers.isNullOrUndef(rawValue)) {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
				if (typeof rawValue === 'number' && !isFinite(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (rawValue) {
					if (this.isHorizontal()) {
						if (rawValue.x !== undefined) {
							return this.getRightValue(rawValue.x);
						}
					} else if (rawValue.y !== undefined) {
						return this.getRightValue(rawValue.y);
					}
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			/**
			 * Used to get the value to display in the tooltip for the data at the given index
			 * @param index
			 * @param datasetIndex
			 */
			getLabelForIndex: helpers.noop,
	
			/**
			 * Returns the location of the given data point. Value can either be an index or a numerical value
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 * @param value
			 * @param index
			 * @param datasetIndex
			 */
			getPixelForValue: helpers.noop,
	
			/**
			 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 * @param pixel
			 */
			getValueForPixel: helpers.noop,
	
			/**
			 * Returns the location of the tick at the given index
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getPixelForTick: function(index) {
				var me = this;
				var offset = me.options.offset;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (offset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me._ticks.length - 1)));
			},
	
			/**
			 * Utility for getting the pixel location of a percentage of scale
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getPixelForDecimal: function(decimal) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			/**
			 * Returns the pixel for the minimum chart value
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getBasePixel: function() {
				return this.getPixelForValue(this.getBaseValue());
			},
	
			getBaseValue: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0;
			},
	
			/**
			 * Returns a subset of ticks to be plotted to avoid overlapping labels.
			 * @private
			 */
			_autoSkip: function(ticks) {
				var skipRatio;
				var me = this;
				var isHorizontal = me.isHorizontal();
				var optionTicks = me.options.ticks.minor;
				var tickCount = ticks.length;
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
				var result = [];
				var i, tick, shouldSkip;
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				if (isHorizontal) {
					skipRatio = false;
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && tickCount > maxTicks) {
						skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
					}
				}
	
				for (i = 0; i < tickCount; i++) {
					tick = ticks[i];
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
					if (shouldSkip && i !== tickCount - 1) {
						// leave tick in place but make sure it's not displayed (#4635)
						delete tick.label;
					}
					result.push(tick);
				}
				return result;
			},
	
			// Actually draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = defaults.global;
				var optionTicks = options.ticks.minor;
				var optionMajorTicks = options.ticks.major || optionTicks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var isHorizontal = me.isHorizontal();
	
				var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
				var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFont = parseFontOptions(optionTicks);
				var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
				var majorTickFont = parseFontOptions(optionMajorTicks);
	
				var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
	
				var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFont = parseFontOptions(scaleLabel);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
	
				var itemsToDraw = [];
	
				var axisWidth = me.options.gridLines.lineWidth;
				var xTickStart = options.position === 'right' ? me.right : me.right - axisWidth - tl;
				var xTickEnd = options.position === 'right' ? me.right + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top + axisWidth : me.bottom - tl - axisWidth;
				var yTickEnd = options.position === 'bottom' ? me.top + axisWidth + tl : me.bottom + axisWidth;
	
				helpers.each(ticks, function(tick, index) {
					// autoskipper skipped this tick (#4635)
					if (helpers.isNullOrUndef(tick.label)) {
						return;
					}
	
					var label = tick.label;
					var lineWidth, lineColor, borderDash, borderDashOffset;
					if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
						borderDash = gridLines.zeroLineBorderDash;
						borderDashOffset = gridLines.zeroLineBorderDashOffset;
					} else {
						lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
						borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
						borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
					var tickPadding = optionTicks.padding;
	
					if (isHorizontal) {
						var labelYOffset = tl + tickPadding;
	
						if (options.position === 'bottom') {
							// bottom
							textBaseline = !isRotated ? 'top' : 'middle';
							textAlign = !isRotated ? 'center' : 'right';
							labelY = me.top + labelYOffset;
						} else {
							// top
							textBaseline = !isRotated ? 'bottom' : 'middle';
							textAlign = !isRotated ? 'center' : 'left';
							labelY = me.bottom - labelYOffset;
						}
	
						var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
						if (xLineValue < me.left) {
							lineColor = 'rgba(0,0,0,0)';
						}
						xLineValue += helpers.aliasPixel(lineWidth);
	
						labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom + axisWidth;
					} else {
						var isLeft = options.position === 'left';
						var labelXOffset;
	
						if (optionTicks.mirror) {
							textAlign = isLeft ? 'left' : 'right';
							labelXOffset = tickPadding;
						} else {
							textAlign = isLeft ? 'right' : 'left';
							labelXOffset = tl + tickPadding;
						}
	
						labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;
	
						var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
						if (yLineValue < me.top) {
							lineColor = 'rgba(0,0,0,0)';
						}
						yLineValue += helpers.aliasPixel(lineWidth);
	
						labelY = me.getPixelForTick(index) + optionTicks.labelOffset;
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right + axisWidth;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						major: tick.major,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						// Make sure we draw text in the correct color and font
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
						context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							var lineCount = label.length;
							var lineHeight = tickFont.size * 1.5;
							var y = me.isHorizontal() ? 0 : -lineHeight * (lineCount - 1) / 2;
	
							for (var i = 0; i < lineCount; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += lineHeight;
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
					var halfLineHeight = parseLineHeight(scaleLabel) / 2;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom'
							? me.bottom - halfLineHeight - scaleLabelPadding.bottom
							: me.top + halfLineHeight + scaleLabelPadding.top;
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft
							? me.left + halfLineHeight + scaleLabelPadding.top
							: me.right - halfLineHeight - scaleLabelPadding.top;
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont.font;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left;
					var x2 = me.right + axisWidth;
					var y1 = me.top;
					var y2 = me.bottom + axisWidth;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var helpers = __webpack_require__(19);
	var layouts = __webpack_require__(107);
	
	module.exports = function(Chart) {
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, scaleDefaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(scaleDefaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var me = this;
				if (me.defaults.hasOwnProperty(type)) {
					me.defaults[type] = helpers.extend(me.defaults[type], additions);
				}
			},
			addScalesToLayout: function(chart) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chart.scales, function(scale) {
					// Set ILayoutItem parameters for backwards compatibility
					scale.fullWidth = scale.options.fullWidth;
					scale.position = scale.options.position;
					scale.weight = scale.options.weight;
					layouts.addBox(chart, scale);
				});
			}
		};
	};


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	var helpers = __webpack_require__(19);
	
	defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					label += tooltipItem.yLabel;
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		}
	});
	
	module.exports = function(Chart) {
	
		/**
	 	 * Helper method to merge the opacity into a color
	 	 */
		function mergeOpacity(colorString, opacity) {
			var color = helpers.color(colorString);
			return color.alpha(opacity * color.alpha()).rgbaString();
		}
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		// Private helper to create a tooltip item model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index;
			var datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex,
				x: element._model.x,
				y: element._model.y
			};
		}
	
		/**
		 * Helper to get the reset model for the tooltip
		 * @param tooltipOpts {Object} the tooltip options
		 */
		function getBaseModel(tooltipOpts) {
			var globalDefaults = defaults.global;
			var valueOrDefault = helpers.valueOrDefault;
	
			return {
				// Positioning
				xPadding: tooltipOpts.xPadding,
				yPadding: tooltipOpts.yPadding,
				xAlign: tooltipOpts.xAlign,
				yAlign: tooltipOpts.yAlign,
	
				// Body
				bodyFontColor: tooltipOpts.bodyFontColor,
				_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
				_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
				_bodyAlign: tooltipOpts.bodyAlign,
				bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
				bodySpacing: tooltipOpts.bodySpacing,
	
				// Title
				titleFontColor: tooltipOpts.titleFontColor,
				_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
				_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
				titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
				_titleAlign: tooltipOpts.titleAlign,
				titleSpacing: tooltipOpts.titleSpacing,
				titleMarginBottom: tooltipOpts.titleMarginBottom,
	
				// Footer
				footerFontColor: tooltipOpts.footerFontColor,
				_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
				_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
				footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
				_footerAlign: tooltipOpts.footerAlign,
				footerSpacing: tooltipOpts.footerSpacing,
				footerMarginTop: tooltipOpts.footerMarginTop,
	
				// Appearance
				caretSize: tooltipOpts.caretSize,
				cornerRadius: tooltipOpts.cornerRadius,
				backgroundColor: tooltipOpts.backgroundColor,
				opacity: 0,
				legendColorBackground: tooltipOpts.multiKeyBackground,
				displayColors: tooltipOpts.displayColors,
				borderColor: tooltipOpts.borderColor,
				borderWidth: tooltipOpts.borderWidth
			};
		}
	
		/**
		 * Get the size of the tooltip
		 */
		function getTooltipSize(tooltip, model) {
			var ctx = tooltip._chart.ctx;
	
			var height = model.yPadding * 2; // Tooltip Padding
			var width = 0;
	
			// Count of all lines in the body
			var body = model.body;
			var combinedBodyLength = body.reduce(function(count, bodyItem) {
				return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
			}, 0);
			combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
			var titleLineCount = model.title.length;
			var footerLineCount = model.footer.length;
			var titleFontSize = model.titleFontSize;
			var bodyFontSize = model.bodyFontSize;
			var footerFontSize = model.footerFontSize;
	
			height += titleLineCount * titleFontSize; // Title Lines
			height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
			height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
			height += combinedBodyLength * bodyFontSize; // Body Lines
			height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
			height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
			height += footerLineCount * (footerFontSize); // Footer Lines
			height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
			// Title width
			var widthPadding = 0;
			var maxLineWidth = function(line) {
				width = Math.max(width, ctx.measureText(line).width + widthPadding);
			};
	
			ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
			helpers.each(model.title, maxLineWidth);
	
			// Body width
			ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
			helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
			// Body lines may include some extra width due to the color box
			widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
			helpers.each(body, function(bodyItem) {
				helpers.each(bodyItem.before, maxLineWidth);
				helpers.each(bodyItem.lines, maxLineWidth);
				helpers.each(bodyItem.after, maxLineWidth);
			});
	
			// Reset back to 0
			widthPadding = 0;
	
			// Footer width
			ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
			helpers.each(model.footer, maxLineWidth);
	
			// Add padding
			width += 2 * model.xPadding;
	
			return {
				width: width,
				height: height
			};
		}
	
		/**
		 * Helper to get the alignment of a tooltip given the size
		 */
		function determineAlignment(tooltip, size) {
			var model = tooltip._model;
			var chart = tooltip._chart;
			var chartArea = tooltip._chart.chartArea;
			var xAlign = 'center';
			var yAlign = 'center';
	
			if (model.y < size.height) {
				yAlign = 'top';
			} else if (model.y > (chart.height - size.height)) {
				yAlign = 'bottom';
			}
	
			var lf, rf; // functions to determine left, right alignment
			var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
			var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
			var midX = (chartArea.left + chartArea.right) / 2;
			var midY = (chartArea.top + chartArea.bottom) / 2;
	
			if (yAlign === 'center') {
				lf = function(x) {
					return x <= midX;
				};
				rf = function(x) {
					return x > midX;
				};
			} else {
				lf = function(x) {
					return x <= (size.width / 2);
				};
				rf = function(x) {
					return x >= (chart.width - (size.width / 2));
				};
			}
	
			olf = function(x) {
				return x + size.width + model.caretSize + model.caretPadding > chart.width;
			};
			orf = function(x) {
				return x - size.width - model.caretSize - model.caretPadding < 0;
			};
			yf = function(y) {
				return y <= midY ? 'top' : 'bottom';
			};
	
			if (lf(model.x)) {
				xAlign = 'left';
	
				// Is tooltip too wide and goes over the right side of the chart.?
				if (olf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			} else if (rf(model.x)) {
				xAlign = 'right';
	
				// Is tooltip too wide and goes outside left edge of canvas?
				if (orf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			}
	
			var opts = tooltip._options;
			return {
				xAlign: opts.xAlign ? opts.xAlign : xAlign,
				yAlign: opts.yAlign ? opts.yAlign : yAlign
			};
		}
	
		/**
		 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
		 */
		function getBackgroundPoint(vm, size, alignment, chart) {
			// Background Position
			var x = vm.x;
			var y = vm.y;
	
			var caretSize = vm.caretSize;
			var caretPadding = vm.caretPadding;
			var cornerRadius = vm.cornerRadius;
			var xAlign = alignment.xAlign;
			var yAlign = alignment.yAlign;
			var paddingAndSize = caretSize + caretPadding;
			var radiusAndPadding = cornerRadius + caretPadding;
	
			if (xAlign === 'right') {
				x -= size.width;
			} else if (xAlign === 'center') {
				x -= (size.width / 2);
				if (x + size.width > chart.width) {
					x = chart.width - size.width;
				}
				if (x < 0) {
					x = 0;
				}
			}
	
			if (yAlign === 'top') {
				y += paddingAndSize;
			} else if (yAlign === 'bottom') {
				y -= size.height + paddingAndSize;
			} else {
				y -= (size.height / 2);
			}
	
			if (yAlign === 'center') {
				if (xAlign === 'left') {
					x += paddingAndSize;
				} else if (xAlign === 'right') {
					x -= paddingAndSize;
				}
			} else if (xAlign === 'left') {
				x -= radiusAndPadding;
			} else if (xAlign === 'right') {
				x += radiusAndPadding;
			}
	
			return {
				x: x,
				y: y
			};
		}
	
		Chart.Tooltip = Element.extend({
			initialize: function() {
				this._model = getBaseModel(this._options);
				this._lastActive = [];
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
				var title = callbacks.title.apply(me, arguments);
				var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
	
				// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
				// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
				// which breaks any animations.
				var existingModel = me._model;
				var model = me._model = getBaseModel(opts);
				var active = me._active;
	
				var data = me._data;
	
				// In the case where active.length === 0 we need to keep these at existing values for good animations
				var alignment = {
					xAlign: existingModel.xAlign,
					yAlign: existingModel.yAlign
				};
				var backgroundPoint = {
					x: existingModel.x,
					y: existingModel.y
				};
				var tooltipSize = {
					width: existingModel.width,
					height: existingModel.height
				};
				var tooltipPosition = {
					x: existingModel.caretX,
					y: existingModel.caretY
				};
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [];
					var labelTextColors = [];
					tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a filter function, use it to modify the tooltip items
					if (opts.filter) {
						tooltipItems = tooltipItems.filter(function(a) {
							return opts.filter(a, data);
						});
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// Determine colors for boxes
					helpers.each(tooltipItems, function(tooltipItem) {
						labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
						labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
					});
	
	
					// Build the Text Lines
					model.title = me.getTitle(tooltipItems, data);
					model.beforeBody = me.getBeforeBody(tooltipItems, data);
					model.body = me.getBody(tooltipItems, data);
					model.afterBody = me.getAfterBody(tooltipItems, data);
					model.footer = me.getFooter(tooltipItems, data);
	
					// Initial positioning and colors
					model.x = Math.round(tooltipPosition.x);
					model.y = Math.round(tooltipPosition.y);
					model.caretPadding = opts.caretPadding;
					model.labelColors = labelColors;
					model.labelTextColors = labelTextColors;
	
					// data points
					model.dataPoints = tooltipItems;
	
					// We need to determine alignment of the tooltip
					tooltipSize = getTooltipSize(this, model);
					alignment = determineAlignment(this, tooltipSize);
					// Final Size and Position
					backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
				} else {
					model.opacity = 0;
				}
	
				model.xAlign = alignment.xAlign;
				model.yAlign = alignment.yAlign;
				model.x = backgroundPoint.x;
				model.y = backgroundPoint.y;
				model.width = tooltipSize.width;
				model.height = tooltipSize.height;
	
				// Point where the caret on the tooltip points to
				model.caretX = tooltipPosition.x;
				model.caretY = tooltipPosition.y;
	
				me._model = model;
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			drawCaret: function(tooltipPoint, size) {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
				ctx.lineTo(caretPosition.x1, caretPosition.y1);
				ctx.lineTo(caretPosition.x2, caretPosition.y2);
				ctx.lineTo(caretPosition.x3, caretPosition.y3);
			},
			getCaretPosition: function(tooltipPoint, size, vm) {
				var x1, x2, x3, y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var ptX = tooltipPoint.x;
				var ptY = tooltipPoint.y;
				var width = size.width;
				var height = size.height;
	
				if (yAlign === 'center') {
					y2 = ptY + (height / 2);
	
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
	
						y1 = y2 + caretSize;
						y3 = y2 - caretSize;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
	
						y1 = y2 - caretSize;
						y3 = y2 + caretSize;
					}
				} else {
					if (xAlign === 'left') {
						x2 = ptX + cornerRadius + (caretSize);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x2 = ptX + width - cornerRadius - caretSize;
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else {
						x2 = vm.caretX;
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
						// invert drawing order
						var tmp = x3;
						x3 = x1;
						x1 = tmp;
					}
				}
				return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize;
					var titleSpacing = vm.titleSpacing;
	
					ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = vm.displayColors;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
					ctx.fillStyle = textColor;
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.lineWidth = 1;
							ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
				ctx.lineWidth = vm.borderWidth;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var x = pt.x;
				var y = pt.y;
				var width = tooltipSize.width;
				var height = tooltipSize.height;
				var radius = vm.cornerRadius;
	
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				if (yAlign === 'top') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width - radius, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
				if (yAlign === 'center' && xAlign === 'right') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width, y + height - radius);
				ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
				if (yAlign === 'bottom') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + radius, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
				if (yAlign === 'center' && xAlign === 'left') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x, y + radius);
				ctx.quadraticCurveTo(x, y, x + radius, y);
				ctx.closePath();
	
				ctx.fill();
	
				if (vm.borderWidth > 0) {
					ctx.stroke();
				}
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = {
					width: vm.width,
					height: vm.height
				};
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				// Truthy/falsey value for empty tooltip
				var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
				if (this._options.enabled && hasTooltipContent) {
					// Draw Background
					this.drawBackground(pt, vm, ctx, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @returns {Boolean} true if the tooltip changed
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me._options;
				var changed = false;
	
				me._lastActive = me._lastActive || [];
	
				// Find Active Elements for tooltips
				if (e.type === 'mouseout') {
					me._active = [];
				} else {
					me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				}
	
				// Remember Last Actives
				changed = !helpers.arrayEquals(me._active, me._lastActive);
	
				// Only handle target event on tooltip change
				if (changed) {
					me._lastActive = me._active;
	
					if (options.enabled || options.custom) {
						me._eventPosition = {
							x: e.x,
							y: e.y
						};
	
						me.update(true);
						me.pivot();
					}
				}
	
				return changed;
			}
		});
	
		/**
		 * @namespace Chart.Tooltip.positioners
		 */
		Chart.Tooltip.positioners = {
			/**
			 * Average mode places the tooltip at the average position of the elements shown
			 * @function Chart.Tooltip.positioners.average
			 * @param elements {ChartElement[]} the elements being displayed in the tooltip
			 * @returns {Point} tooltip position
			 */
			average: function(elements) {
				if (!elements.length) {
					return false;
				}
	
				var i, len;
				var x = 0;
				var y = 0;
				var count = 0;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var pos = el.tooltipPosition();
						x += pos.x;
						y += pos.y;
						++count;
					}
				}
	
				return {
					x: Math.round(x / count),
					y: Math.round(y / count)
				};
			},
	
			/**
			 * Gets the tooltip position nearest of the item nearest to the event position
			 * @function Chart.Tooltip.positioners.nearest
			 * @param elements {Chart.Element[]} the tooltip elements
			 * @param eventPosition {Point} the position of the event in canvas coordinates
			 * @returns {Point} the tooltip position
			 */
			nearest: function(elements, eventPosition) {
				var x = eventPosition.x;
				var y = eventPosition.y;
				var minDistance = Number.POSITIVE_INFINITY;
				var i, len, nearestElement;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var center = el.getCenterPoint();
						var d = helpers.distanceBetweenPoints(eventPosition, center);
	
						if (d < minDistance) {
							minDistance = d;
							nearestElement = el;
						}
					}
				}
	
				if (nearestElement) {
					var tp = nearestElement.tooltipPosition();
					x = tp.x;
					y = tp.y;
				}
	
				return {
					x: x,
					y: y
				};
			}
		};
	};


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	var helpers = __webpack_require__(19);
	
	defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2
			}
		}
	});
	
	module.exports = Element.extend({
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var	angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += 2.0 * Math.PI;
				}
				while (angle > endAngle) {
					angle -= 2.0 * Math.PI;
				}
				while (angle < startAngle) {
					angle += 2.0 * Math.PI;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var sA = vm.startAngle;
			var eA = vm.endAngle;
	
			ctx.beginPath();
	
			ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
			ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
			ctx.closePath();
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
	
			ctx.fillStyle = vm.backgroundColor;
	
			ctx.fill();
			ctx.lineJoin = 'bevel';
	
			if (vm.borderWidth) {
				ctx.stroke();
			}
		}
	});


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	var helpers = __webpack_require__(19);
	
	var globalDefaults = defaults.global;
	
	defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: globalDefaults.defaultColor,
				borderWidth: 3,
				borderColor: globalDefaults.defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	module.exports = Element.extend({
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var index, current, previous, currentVM;
	
			// If we are looping, adding the first point again
			if (me._loop && points.length) {
				points.push(points[0]);
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
			lastDrawnIndex = -1;
	
			for (index = 0; index < points.length; ++index) {
				current = points[index];
				previous = helpers.previousItem(points, index);
				currentVM = current._view;
	
				// First point moves to it's starting position no matter what
				if (index === 0) {
					if (!currentVM.skip) {
						ctx.moveTo(currentVM.x, currentVM.y);
						lastDrawnIndex = index;
					}
				} else {
					previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
					if (!currentVM.skip) {
						if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
							// There was a gap and this is the first point after the gap
							ctx.moveTo(currentVM.x, currentVM.y);
						} else {
							// Line to next point
							helpers.canvas.lineTo(ctx, previous._view, current._view);
						}
						lastDrawnIndex = index;
					}
				}
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	var helpers = __webpack_require__(19);
	
	var defaultColor = defaults.global.defaultColor;
	
	defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor,
				borderColor: defaultColor,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	module.exports = Element.extend({
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var model = this._model;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var color = helpers.color;
			var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
			var ratio = 0;
	
			if (vm.skip) {
				return;
			}
	
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
	
			// Cliping for Points.
			// going out from inner charArea?
			if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
				// Point fade out
				if (model.x < chartArea.left) {
					ratio = (x - model.x) / (chartArea.left - model.x);
				} else if (chartArea.right * errMargin < model.x) {
					ratio = (model.x - x) / (model.x - chartArea.right);
				} else if (model.y < chartArea.top) {
					ratio = (y - model.y) / (chartArea.top - model.y);
				} else if (chartArea.bottom * errMargin < model.y) {
					ratio = (model.y - y) / (model.y - chartArea.bottom);
				}
				ratio = Math.round(ratio * 100) / 100;
				ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
				ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
			}
	
			helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
		}
	});


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	
	defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaults.global.defaultColor,
				borderColor: defaults.global.defaultColor,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(bar) {
		return bar._view.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(bar) {
		var vm = bar._view;
		var x1, x2, y1, y2;
	
		if (isVertical(bar)) {
			// vertical
			var halfWidth = vm.width / 2;
			x1 = vm.x - halfWidth;
			x2 = vm.x + halfWidth;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			// horizontal bar
			var halfHeight = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - halfHeight;
			y2 = vm.y + halfHeight;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	module.exports = Element.extend({
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var left, right, top, bottom, signX, signY, borderSkipped;
			var borderWidth = vm.borderWidth;
	
			if (!vm.horizontal) {
				// bar
				left = vm.x - vm.width / 2;
				right = vm.x + vm.width / 2;
				top = vm.y;
				bottom = vm.base;
				signX = 1;
				signY = bottom > top ? 1 : -1;
				borderSkipped = vm.borderSkipped || 'bottom';
			} else {
				// horizontal bar
				left = vm.base;
				right = vm.x;
				top = vm.y - vm.height / 2;
				bottom = vm.y + vm.height / 2;
				signX = right > left ? 1 : -1;
				signY = 1;
				borderSkipped = vm.borderSkipped || 'left';
			}
	
			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
			if (borderWidth) {
				// borderWidth shold be less than bar width and bar height.
				var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
				borderWidth = borderWidth > barSize ? barSize : borderWidth;
				var halfStroke = borderWidth / 2;
				// Adjust borderWidth when bar top position is near vm.base(zero).
				var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
				var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
				var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
				var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
				// not become a vertical line?
				if (borderLeft !== borderRight) {
					top = borderTop;
					bottom = borderBottom;
				}
				// not become a horizontal line?
				if (borderTop !== borderBottom) {
					left = borderLeft;
					right = borderRight;
				}
			}
	
			ctx.beginPath();
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = borderWidth;
	
			// Corner points, from bottom-left to bottom-right clockwise
			// | 1 2 |
			// | 0 3 |
			var corners = [
				[left, bottom],
				[left, top],
				[right, top],
				[right, bottom]
			];
	
			// Find first (starting) corner with fallback to 'bottom'
			var borders = ['bottom', 'left', 'top', 'right'];
			var startCorner = borders.indexOf(borderSkipped, 0);
			if (startCorner === -1) {
				startCorner = 0;
			}
	
			function cornerAt(index) {
				return corners[(startCorner + index) % 4];
			}
	
			// Draw rectangle from 'startCorner'
			var corner = cornerAt(0);
			ctx.moveTo(corner[0], corner[1]);
	
			for (var i = 1; i < 4; i++) {
				corner = cornerAt(i);
				ctx.lineTo(corner[0], corner[1]);
			}
	
			ctx.fill();
			if (borderWidth) {
				ctx.stroke();
			}
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			var inRange = false;
	
			if (this._view) {
				var bounds = getBarBounds(this);
				inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
			}
	
			return inRange;
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var me = this;
			if (!me._view) {
				return false;
			}
	
			var inRange = false;
			var bounds = getBarBounds(me);
	
			if (isVertical(me)) {
				inRange = mouseX >= bounds.left && mouseX <= bounds.right;
			} else {
				inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
			}
	
			return inRange;
		},
	
		inXRange: function(mouseX) {
			var bounds = getBarBounds(this);
			return mouseX >= bounds.left && mouseX <= bounds.right;
		},
	
		inYRange: function(mouseY) {
			var bounds = getBarBounds(this);
			return mouseY >= bounds.top && mouseY <= bounds.bottom;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(this)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
			return vm.width * Math.abs(vm.y - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(128);
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports = module.exports = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {Number} width - The rectangle's width.
		 * @param {Number} height - The rectangle's height.
		 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var rx = Math.min(radius, width / 2);
				var ry = Math.min(radius, height / 2);
	
				ctx.moveTo(x + rx, y);
				ctx.lineTo(x + width - rx, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
				ctx.lineTo(x + width, y + height - ry);
				ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
				ctx.lineTo(x + rx, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
				ctx.lineTo(x, y + ry);
				ctx.quadraticCurveTo(x, y, x + rx, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (style) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = x - offset;
				var topY = y - offset;
				var sideSize = Math.SQRT2 * radius;
				ctx.beginPath();
				this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			if (target.steppedLine) {
				if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.clear = exports.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports.roundedRect.apply(exports, arguments);
		ctx.closePath();
	};


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(128);
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	module.exports = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.easingEffects = effects;


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(128);
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	module.exports = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			default:
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {Number|Object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {Object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array[]} inputs - An array of values, falling back to the last value.
		 * @param {Object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {Number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index) {
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
				}
				if (index !== undefined && helpers.isArray(value)) {
					value = value[index];
				}
				if (value !== undefined) {
					return value;
				}
			}
		}
	};


/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	module.exports = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Chart.Platform implementation for targeting a web browser
	 */
	
	'use strict';
	
	var helpers = __webpack_require__(19);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {Number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addEventListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeEventListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var resizer = document.createElement('div');
		var cls = CSS_PREFIX + 'size-monitor';
		var maxSize = 1000000;
		var style =
			'position:absolute;' +
			'left:0;' +
			'top:0;' +
			'right:0;' +
			'bottom:0;' +
			'overflow:hidden;' +
			'pointer-events:none;' +
			'visibility:hidden;' +
			'z-index:-1;';
	
		resizer.style.cssText = style;
		resizer.className = cls;
		resizer.innerHTML =
			'<div class="' + cls + '-expand" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:' + maxSize + 'px;' +
					'height:' + maxSize + 'px;' +
					'left:0;' +
					'top:0">' +
				'</div>' +
			'</div>' +
			'<div class="' + cls + '-shrink" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:200%;' +
					'height:200%;' +
					'left:0; ' +
					'top:0">' +
				'</div>' +
			'</div>';
	
		var expand = resizer.childNodes[0];
		var shrink = resizer.childNodes[1];
	
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			addEventListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers.each(ANIMATION_START_EVENTS, function(type) {
				removeEventListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				return listener(createEvent('resize', chart));
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	function injectCSS(platform, css) {
		// http://stackoverflow.com/q/3922139
		var style = platform._style || document.createElement('style');
		if (!platform._style) {
			platform._style = style;
			css = '/* Chart.js */\n' + css;
			style.setAttribute('type', 'text/css');
			document.getElementsByTagName('head')[0].appendChild(style);
		}
	
		style.appendChild(document.createTextNode(css));
	}
	
	module.exports = {
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		initialize: function() {
			var keyframes = 'from{opacity:0.99}to{opacity:1}';
	
			injectCSS(this,
				// DOM rendering detection
				// https://davidwalsh.name/detect-node-insertion
				'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'.' + CSS_RENDER_MONITOR + '{' +
					'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
					'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'}'
			);
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addEventListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas, listener);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeEventListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.addEvent = addEventListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.removeEvent = removeEventListener;


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {};
	module.exports.filler = __webpack_require__(1551);
	module.exports.legend = __webpack_require__(1552);
	module.exports.title = __webpack_require__(1553);


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Plugin based on discussion from the following Chart.js issues:
	 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
	 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
	 */
	
	'use strict';
	
	var defaults = __webpack_require__(23);
	var elements = __webpack_require__(69);
	var helpers = __webpack_require__(19);
	
	defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePosition) {
			target = scale.getBasePosition();
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (typeof target === 'number' && isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1;
	
		ctx.beginPath();
	
		for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	module.exports = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetDraw: function(chart, args) {
			var meta = args.meta.$filler;
			if (!meta) {
				return;
			}
	
			var ctx = chart.ctx;
			var el = meta.el;
			var view = el._view;
			var points = el._children || [];
			var mapper = meta.mapper;
			var color = view.backgroundColor || defaults.global.defaultColor;
	
			if (mapper && color && points.length) {
				helpers.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers.canvas.unclipArea(ctx);
			}
		}
	};


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	var helpers = __webpack_require__(19);
	var layouts = __webpack_require__(107);
	
	var noop = helpers.noop;
	
	defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		},
	
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
			for (var i = 0; i < chart.data.datasets.length; i++) {
				text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
				if (chart.data.datasets[i].label) {
					text.push(chart.data.datasets[i].label);
				}
				text.push('</li>');
			}
			text.push('</ul>');
			return text.join('');
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param labelopts {Object} the label options on the legend
	 * @param fontSize {Number} the label font size
	 * @return {Number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle ?
			fontSize * Math.SQRT2 :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = Element.extend({
	
		initialize: function(config) {
			helpers.extend(this, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			this.legendHitBoxes = [];
	
			// Are we in doughnut mode which has a different data type
			this.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop,
	
		//
	
		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,
	
		//
	
		beforeBuildLabels: noop,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop,
	
		//
	
		beforeFit: noop,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var globalDefault = defaults.global;
			var valueOrDefault = helpers.valueOrDefault;
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (display) {
				ctx.font = labelFont;
	
				if (isHorizontal) {
					// Labels
	
					// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
					var lineWidths = me.lineWidths = [0];
					var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
	
					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
						if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
							totalHeight += fontSize + (labelOpts.padding);
							lineWidths[lineWidths.length] = me.left;
						}
	
						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: width,
							height: fontSize
						};
	
						lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
					});
	
					minSize.height += totalHeight;
	
				} else {
					var vPadding = labelOpts.padding;
					var columnWidths = me.columnWidths = [];
					var totalWidth = labelOpts.padding;
					var currentColWidth = 0;
					var currentColHeight = 0;
					var itemHeight = fontSize + vPadding;
	
					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
						// If too tall, go to new column
						if (currentColHeight + itemHeight > minSize.height) {
							totalWidth += currentColWidth + labelOpts.padding;
							columnWidths.push(currentColWidth); // previous column width
	
							currentColWidth = 0;
							currentColHeight = 0;
						}
	
						// Get max width
						currentColWidth = Math.max(currentColWidth, itemWidth);
						currentColHeight += itemHeight;
	
						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: itemWidth,
							height: fontSize
						};
					});
	
					totalWidth += currentColWidth;
					columnWidths.push(currentColWidth);
					minSize.width += totalWidth;
				}
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefault = defaults.global;
			var lineDefault = globalDefault.elements.line;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (opts.display) {
				var ctx = me.ctx;
				var valueOrDefault = helpers.valueOrDefault;
				var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
				var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
				var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
				var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
				var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
				var cursor;
	
				// Canvas setup
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.lineWidth = 0.5;
				ctx.strokeStyle = fontColor; // for strikethrough effect
				ctx.fillStyle = fontColor; // render in correct colour
				ctx.font = labelFont;
	
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var hitboxes = me.legendHitBoxes;
	
				// current position
				var drawLegendBox = function(x, y, legendItem) {
					if (isNaN(boxWidth) || boxWidth <= 0) {
						return;
					}
	
					// Set the ctx for the box
					ctx.save();
	
					ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
					ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
					ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
					ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
					ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
					ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
					var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
					if (ctx.setLineDash) {
						// IE 9 and 10 do not support line dash
						ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
					}
	
					if (opts.labels && opts.labels.usePointStyle) {
						// Recalculate x and y for drawPoint() because its expecting
						// x and y to be center of figure (instead of top left)
						var radius = fontSize * Math.SQRT2 / 2;
						var offSet = radius / Math.SQRT2;
						var centerX = x + offSet;
						var centerY = y + offSet;
	
						// Draw pointStyle as legend symbol
						helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
					} else {
						// Draw box as legend symbol
						if (!isLineWidthZero) {
							ctx.strokeRect(x, y, boxWidth, fontSize);
						}
						ctx.fillRect(x, y, boxWidth, fontSize);
					}
	
					ctx.restore();
				};
				var fillText = function(x, y, legendItem, textWidth) {
					var halfFontSize = fontSize / 2;
					var xLeft = boxWidth + halfFontSize + x;
					var yMiddle = y + halfFontSize;
	
					ctx.fillText(legendItem.text, xLeft, yMiddle);
	
					if (legendItem.hidden) {
						// Strikethrough the text if hidden
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.moveTo(xLeft, yMiddle);
						ctx.lineTo(xLeft + textWidth, yMiddle);
						ctx.stroke();
					}
				};
	
				// Horizontal
				var isHorizontal = me.isHorizontal();
				if (isHorizontal) {
					cursor = {
						x: me.left + ((legendWidth - lineWidths[0]) / 2),
						y: me.top + labelOpts.padding,
						line: 0
					};
				} else {
					cursor = {
						x: me.left + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				}
	
				var itemHeight = fontSize + labelOpts.padding;
				helpers.each(me.legendItems, function(legendItem, i) {
					var textWidth = ctx.measureText(legendItem.text).width;
					var width = boxWidth + (fontSize / 2) + textWidth;
					var x = cursor.x;
					var y = cursor.y;
	
					if (isHorizontal) {
						if (x + width >= legendWidth) {
							y = cursor.y += itemHeight;
							cursor.line++;
							x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
						}
					} else if (y + itemHeight > me.bottom) {
						x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
						y = cursor.y = me.top + labelOpts.padding;
						cursor.line++;
					}
	
					drawLegendBox(x, y, legendItem);
	
					hitboxes[i].left = x;
					hitboxes[i].top = y;
	
					// Fill the actual label
					fillText(x, y, legendItem, textWidth);
	
					if (isHorizontal) {
						cursor.x += width + (labelOpts.padding);
					} else {
						cursor.y += itemHeight;
					}
	
				});
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @return {Boolean} true if a change occured
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var changed = false;
	
			if (type === 'mousemove') {
				if (!opts.onHover) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			var x = e.x;
			var y = e.y;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				var lh = me.legendHitBoxes;
				for (var i = 0; i < lh.length; ++i) {
					var hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						if (type === 'click') {
							// use e.native for backwards compatibility
							opts.onClick.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						} else if (type === 'mousemove') {
							// use e.native for backwards compatibility
							opts.onHover.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						}
					}
				}
			}
	
			return changed;
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		layouts.configure(chart, legend, legendOpts);
		layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	module.exports = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers.mergeIf(legendOpts, defaults.global.legend);
	
				if (legend) {
					layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var Element = __webpack_require__(57);
	var helpers = __webpack_require__(19);
	var layouts = __webpack_require__(107);
	
	var noop = helpers.noop;
	
	defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			lineHeight: 1.2,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = Element.extend({
		initialize: function(config) {
			var me = this;
			helpers.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop,
	
		//
	
		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,
	
		//
	
		beforeBuildLabels: noop,
		buildLabels: noop,
		afterBuildLabels: noop,
	
		//
	
		beforeFit: noop,
		fit: function() {
			var me = this;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = me.options;
			var display = opts.display;
			var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
			var minSize = me.minSize;
			var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
			var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
			var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;
	
			if (me.isHorizontal()) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = textSize;
			} else {
				minSize.width = textSize;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
	
		},
		afterFit: noop,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = me.options;
			var globalDefaults = defaults.global;
	
			if (opts.display) {
				var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
				var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
				var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
				var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
				var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
				var offset = lineHeight / 2 + opts.padding;
				var rotation = 0;
				var top = me.top;
				var left = me.left;
				var bottom = me.bottom;
				var right = me.right;
				var maxWidth, titleX, titleY;
	
				ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
				ctx.font = titleFont;
	
				// Horizontal
				if (me.isHorizontal()) {
					titleX = left + ((right - left) / 2); // midpoint of the width
					titleY = top + offset;
					maxWidth = right - left;
				} else {
					titleX = opts.position === 'left' ? left + offset : right - offset;
					titleY = top + ((bottom - top) / 2);
					maxWidth = bottom - top;
					rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
				}
	
				ctx.save();
				ctx.translate(titleX, titleY);
				ctx.rotate(rotation);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';
	
				var text = opts.text;
				if (helpers.isArray(text)) {
					var y = 0;
					for (var i = 0; i < text.length; ++i) {
						ctx.fillText(text[i], 0, y, maxWidth);
						y += lineHeight;
					}
				} else {
					ctx.fillText(text, 0, 0, maxWidth);
				}
	
				ctx.restore();
			}
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		layouts.configure(chart, title, titleOpts);
		layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	module.exports = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers.mergeIf(titleOpts, defaults.global.title);
	
				if (titleBlock) {
					layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};


/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
	
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = labels.indexOf(me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = labels.indexOf(me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index) {
				var me = this;
				var offset = me.options.offset;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);
	
				// If value is a data object, then index is the index in the data array,
				// not the index of the scale. We need to change that.
				var valueCategory;
				if (value !== undefined && value !== null) {
					valueCategory = me.isHorizontal() ? value.x : value.y;
				}
				if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
					var labels = me.getLabels();
					value = valueCategory || value;
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));
	
					if (offset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));
	
				if (offset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var offset = me.options.offset;
				var value;
				var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (offset) {
					pixel -= (valueDimension / 2);
				}
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value + me.minIndex;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var helpers = __webpack_require__(19);
	var Ticks = __webpack_require__(108);
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Ticks.formatters.linear
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
	
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
				var DEFAULT_MIN = 0;
				var DEFAULT_MAX = 1;
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
				me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
				} else {
					pixel = me.bottom - (me.height / range * (rightValue - start));
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(19);
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {Array<Number>} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var spacing;
		if (generationOptions.stepSize && generationOptions.stepSize > 0) {
			spacing = generationOptions.stepSize;
		} else {
			var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
			spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
		}
		var niceMin = Math.floor(dataRange.min / spacing) * spacing;
		var niceMax = Math.ceil(dataRange.max / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
			// If very close to our whole number, use it.
			if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
				niceMin = generationOptions.min;
				niceMax = generationOptions.max;
			}
		}
	
		var numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		var precision = 1;
		if (spacing < 1) {
			precision = Math.pow(10, spacing.toString().length - 2);
			niceMin = Math.round(niceMin * precision) / precision;
			niceMax = Math.round(niceMax * precision) / precision;
		}
		ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * precision) / precision);
		}
		ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);
	
		return ticks;
	}
	
	
	module.exports = function(Chart) {
	
		var noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			getRightValue: function(value) {
				if (typeof value === 'string') {
					return +value;
				}
				return Chart.Scale.prototype.getRightValue.call(this, value);
			},
	
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}
	
				var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
				var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					if (me.min === null) {
						me.min = tickOpts.suggestedMin;
					} else {
						me.min = Math.min(me.min, tickOpts.suggestedMin);
					}
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					if (me.max === null) {
						me.max = tickOpts.suggestedMax;
					} else {
						me.max = Math.max(me.max, tickOpts.suggestedMax);
					}
				}
	
				if (setMin !== setMax) {
					// We set the min or the max but not both.
					// So ensure that our range is good
					// Inverted or 0 length range can happen when
					// ticks.min is set, and no datasets are visible
					if (me.min >= me.max) {
						if (setMin) {
							me.max = me.min + 1;
						} else {
							me.min = me.max - 1;
						}
					}
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);
	
				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(19);
	var Ticks = __webpack_require__(108);
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {Array<Number>} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		var valueOrDefault = helpers.valueOrDefault;
	
		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph
		var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));
	
		var endExp = Math.floor(helpers.log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(helpers.log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(helpers.log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: Ticks.formatters.logarithmic
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								// invalid, hidden and negative values are ignored
								if (isNaN(value) || meta.data[index].hidden || value < 0) {
									return;
								}
								values[index] = values[index] || 0;
								values[index] += value;
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						if (valuesForType.length > 0) {
							var minVal = helpers.min(valuesForType);
							var maxVal = helpers.max(valuesForType);
							me.min = me.min === null ? minVal : Math.min(me.min, minVal);
							me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
						}
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								// invalid, hidden and negative values are ignored
								if (isNaN(value) || meta.data[index].hidden || value < 0) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				// Common base implementation to handle ticks.min, ticks.max
				this.handleTickRangeOptions();
			},
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var valueOrDefault = helpers.valueOrDefault;
				var DEFAULT_MIN = 1;
				var DEFAULT_MAX = 10;
	
				me.min = valueOrDefault(tickOpts.min, me.min);
				me.max = valueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = DEFAULT_MIN;
						me.max = DEFAULT_MAX;
					}
				}
				if (me.min === null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.max)) - 1);
				}
				if (me.max === null) {
					me.max = me.min !== 0
						? Math.pow(10, Math.floor(helpers.log10(me.min)) + 1)
						: DEFAULT_MAX;
				}
				if (me.minNotZero === null) {
					if (me.min > 0) {
						me.minNotZero = me.min;
					} else if (me.max < 1) {
						me.minNotZero = Math.pow(10, Math.floor(helpers.log10(me.max)));
					} else {
						me.minNotZero = DEFAULT_MIN;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var reverse = !me.isHorizontal();
	
				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = generateTicks(generationOptions, me);
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					reverse = !reverse;
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
				if (reverse) {
					ticks.reverse();
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			/**
			 * Returns the value of the first tick.
			 * @param {Number} value - The minimum not zero value.
			 * @return {Number} The first tick value.
			 * @private
			 */
			_getFirstTickValue: function(value) {
				var exp = Math.floor(helpers.log10(value));
				var significand = Math.floor(value / Math.pow(10, exp));
	
				return significand * Math.pow(10, exp);
			},
			getPixelForValue: function(value) {
				var me = this;
				var reverse = me.options.ticks.reverse;
				var log10 = helpers.log10;
				var firstTickValue = me._getFirstTickValue(me.minNotZero);
				var offset = 0;
				var innerDimension, pixel, start, end, sign;
	
				value = +me.getRightValue(value);
				if (reverse) {
					start = me.end;
					end = me.start;
					sign = -1;
				} else {
					start = me.start;
					end = me.end;
					sign = 1;
				}
				if (me.isHorizontal()) {
					innerDimension = me.width;
					pixel = reverse ? me.right : me.left;
				} else {
					innerDimension = me.height;
					sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
					pixel = reverse ? me.top : me.bottom;
				}
				if (value !== start) {
					if (start === 0) { // include zero tick
						offset = helpers.getValueOrDefault(
							me.options.ticks.fontSize,
							Chart.defaults.global.defaultFontSize
						);
						innerDimension -= offset;
						start = firstTickValue;
					}
					if (value !== 0) {
						offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
					}
					pixel += sign * offset;
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var reverse = me.options.ticks.reverse;
				var log10 = helpers.log10;
				var firstTickValue = me._getFirstTickValue(me.minNotZero);
				var innerDimension, start, end, value;
	
				if (reverse) {
					start = me.end;
					end = me.start;
				} else {
					start = me.start;
					end = me.end;
				}
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = reverse ? me.right - pixel : pixel - me.left;
				} else {
					innerDimension = me.height;
					value = reverse ? pixel - me.top : me.bottom - pixel;
				}
				if (value !== start) {
					if (start === 0) { // include zero tick
						var offset = helpers.getValueOrDefault(
							me.options.ticks.fontSize,
							Chart.defaults.global.defaultFontSize
						);
						value -= offset;
						innerDimension -= offset;
						start = firstTickValue;
					}
					value *= log10(end) - log10(start);
					value /= innerDimension;
					value = Math.pow(10, log10(start) + value);
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(23);
	var helpers = __webpack_require__(19);
	var Ticks = __webpack_require__(108);
	
	module.exports = function(Chart) {
	
		var globalDefaults = defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			gridLines: {
				circular: false
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,
	
				callback: Ticks.formatters.linear
			},
	
			pointLabels: {
				// Boolean - if true, show point labels
				display: true,
	
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		function getValueCount(scale) {
			var opts = scale.options;
			return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
		}
	
		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}
	
		function measureLabelSize(ctx, fontSize, label) {
			if (helpers.isArray(label)) {
				return {
					w: helpers.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}
	
			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}
	
		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}
	
			return {
				start: pos,
				end: pos + size + 5
			};
		}
	
		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */
	
			var plFont = getPointLabelFontOptions(scale);
	
			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				r: scale.width,
				l: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i, textSize, pointPosition;
	
			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];
	
			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;
	
				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}
	
				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}
	
				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}
	
				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}
	
			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}
	
		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}
	
		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}
	
			return 'right';
		}
	
		function fillText(ctx, text, position, fontSize) {
			if (helpers.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;
	
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y += spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}
	
		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}
	
		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;
	
			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;
	
			var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	
			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);
	
			ctx.textBaseline = 'top';
	
			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}
	
				if (pointLabelOpts.display) {
					// Extra 3px out for some label spacing
					var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);
	
					// Keep this in loop since we may support array properties here
					var pointLabelFontColor = helpers.valueAtIndexOrDefault(pointLabelOpts.fontColor, i, globalDefaults.defaultFontColor);
					ctx.font = plFont.font;
					ctx.fillStyle = pointLabelFontColor;
	
					var angleRadians = scale.getIndexAngle(i);
					var angle = helpers.toDegrees(angleRadians);
					ctx.textAlign = getTextAlignForAngle(angle);
					adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
					fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
				}
			}
		}
	
		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
			if (scale.options.gridLines.circular) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);
	
				if (valueCount === 0) {
					return;
				}
	
				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);
	
				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}
	
				ctx.closePath();
				ctx.stroke();
			}
		}
	
		function numberOrZero(param) {
			return helpers.isNumber(param) ? param : 0;
		}
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});
	
				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
	
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.pointLabels.display) {
					fitWithPointLabels(this);
				} else {
					fit(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);
	
				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea;
				var maxLeft = leftMovement + me.drawingArea;
				var maxTop = topMovement + me.drawingArea;
				var maxBottom = me.height - bottomMovement - me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.ticks.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var valueOrDefault = helpers.valueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
					var startAngle = this.getIndexAngle(0);
	
					// Tick Font
					var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || tickOpts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}
	
							if (tickOpts.display) {
								var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								ctx.save();
								ctx.translate(me.xCenter, me.yCenter);
								ctx.rotate(startAngle);
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										-labelWidth / 2 - tickOpts.backdropPaddingX,
										-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, 0, -yCenterOffset);
								ctx.restore();
							}
						}
					});
	
					if (opts.angleLines.display || opts.pointLabels.display) {
						drawPointLabels(me);
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(2);
	moment = typeof moment === 'function' ? moment : window.moment;
	
	var defaults = __webpack_require__(23);
	var helpers = __webpack_require__(19);
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
		},
		second: {
			common: true,
			size: 1000,
			steps: [1, 2, 5, 10, 30]
		},
		minute: {
			common: true,
			size: 60000,
			steps: [1, 2, 5, 10, 30]
		},
		hour: {
			common: true,
			size: 3600000,
			steps: [1, 2, 3, 6, 12]
		},
		day: {
			common: true,
			size: 86400000,
			steps: [1, 2, 5]
		},
		week: {
			common: false,
			size: 604800000,
			steps: [1, 2, 3, 4]
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: [1, 2, 3]
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: [1, 2, 3, 4]
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	/**
	 * Convert the given value to a moment object using the given time options.
	 * @see http://momentjs.com/docs/#/parsing/
	 */
	function momentify(value, options) {
		var parser = options.parser;
		var format = options.parser || options.format;
	
		if (typeof parser === 'function') {
			return parser(value);
		}
	
		if (typeof value === 'string' && typeof format === 'string') {
			return moment(value, format);
		}
	
		if (!(value instanceof moment)) {
			value = moment(value);
		}
	
		if (value.isValid()) {
			return value;
		}
	
		// Labels are in an incompatible moment format and no `parser` has been provided.
		// The user might still use the deprecated `format` option to convert his inputs.
		if (typeof format === 'function') {
			return format(value);
		}
	
		return value;
	}
	
	function parse(input, scale) {
		if (helpers.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = momentify(scale.getRightValue(input), options);
		if (!value.isValid()) {
			return null;
		}
	
		if (options.round) {
			value.startOf(options.round);
		}
	
		return value.valueOf();
	}
	
	/**
	 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
	 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
	 */
	function determineStepSize(min, max, unit, capacity) {
		var range = max - min;
		var interval = INTERVALS[unit];
		var milliseconds = interval.size;
		var steps = interval.steps;
		var i, ilen, factor;
	
		if (!steps) {
			return Math.ceil(range / (capacity * milliseconds));
		}
	
		for (i = 0, ilen = steps.length; i < ilen; ++i) {
			factor = steps[i];
			if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
				break;
			}
		}
	
		return factor;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(ticks, minUnit, min, max) {
		var duration = moment.duration(moment(max).diff(moment(min)));
		var ilen = UNITS.length;
		var i, unit;
	
		for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(min, max, capacity, options) {
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var major = determineMajorUnit(minor);
		var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var majorTicksEnabled = options.ticks.major.enabled;
		var interval = INTERVALS[minor];
		var first = moment(min);
		var last = moment(max);
		var ticks = [];
		var time;
	
		if (!stepSize) {
			stepSize = determineStepSize(min, max, minor, capacity);
		}
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = first.isoWeekday(weekday);
			last = last.isoWeekday(weekday);
		}
	
		// Align first/last ticks on unit
		first = first.startOf(weekday ? 'day' : minor);
		last = last.startOf(weekday ? 'day' : minor);
	
		// Make sure that the last tick include max
		if (last < max) {
			last.add(1, minor);
		}
	
		time = moment(first);
	
		if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
			// Align the first tick on the previous `minor` unit aligned on the `major` unit:
			// we first aligned time on the previous `major` unit then add the number of full
			// stepSize there is between first and the previous major time.
			time.startOf(major);
			time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
		}
	
		for (; time < last; time.add(stepSize, minor)) {
			ticks.push(+time);
		}
	
		ticks.push(+time);
	
		return ticks;
	}
	
	/**
	 * Returns the right and left offsets from edges in the form of {left, right}.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var left = 0;
		var right = 0;
		var upper, lower;
	
		if (options.offset && ticks.length) {
			if (!options.time.min) {
				upper = ticks.length > 1 ? ticks[1] : max;
				lower = ticks[0];
				left = (
					interpolate(table, 'time', upper, 'pos') -
					interpolate(table, 'time', lower, 'pos')
				) / 2;
			}
			if (!options.time.max) {
				upper = ticks[ticks.length - 1];
				lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
				right = (
					interpolate(table, 'time', upper, 'pos') -
					interpolate(table, 'time', lower, 'pos')
				) / 2;
			}
		}
	
		return {left: left, right: right};
	}
	
	function ticksFromTimestamps(values, majorUnit) {
		var ticks = [];
		var i, ilen, value, major;
	
		for (i = 0, ilen = values.length; i < ilen; ++i) {
			value = values[i];
			major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;
	
			ticks.push({
				value: value,
				major: major
			});
		}
	
		return ticks;
	}
	
	function determineLabelFormat(data, timeOpts) {
		var i, momentDate, hasTime;
		var ilen = data.length;
	
		// find the label with the most parts (milliseconds, minutes, etc.)
		// format all labels with the same level of detail as the most specific label
		for (i = 0; i < ilen; i++) {
			momentDate = momentify(data[i], timeOpts);
			if (momentDate.millisecond() !== 0) {
				return 'MMM D, YYYY h:mm:ss.SSS a';
			}
			if (momentDate.second() !== 0 || momentDate.minute() !== 0 || momentDate.hour() !== 0) {
				hasTime = true;
			}
		}
		if (hasTime) {
			return 'MMM D, YYYY h:mm:ss a';
		}
		return 'MMM D, YYYY';
	}
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'bottom',
	
			/**
			 * Data distribution along the scale:
			 * - 'linear': data are spread according to their time (distances can vary),
			 * - 'series': data are spread at the same distance from each other.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			distribution: 'linear',
	
			/**
			 * Scale boundary strategy (bypassed by min/max time options)
			 * - `data`: make sure data are fully visible, ticks outside are removed
			 * - `ticks`: make sure ticks are fully visible, data outside are truncated
			 * @see https://github.com/chartjs/Chart.js/pull/4556
			 * @since 2.7.0
			 */
			bounds: 'data',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm a', // 11:20 AM
					hour: 'hA', // 5PM
					day: 'MMM D', // Sep 4
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				},
			},
			ticks: {
				autoSkip: false,
	
				/**
				 * Ticks generation input values:
				 * - 'auto': generates "optimal" ticks based on scale size and time options.
				 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
				 * - 'labels': generates ticks from user given `data.labels` values ONLY.
				 * @see https://github.com/chartjs/Chart.js/pull/4507
				 * @since 2.7.0
				 */
				source: 'auto',
	
				major: {
					enabled: false
				}
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				this.mergeTicksOptions();
	
				Chart.Scale.prototype.initialize.call(this);
			},
	
			update: function() {
				var me = this;
				var options = me.options;
	
				// DEPRECATIONS: output a message only one time per update
				if (options.time && options.time.format) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser.');
				}
	
				return Chart.Scale.prototype.update.apply(me, arguments);
			},
	
			/**
			 * Allows data to be referenced via 't' attribute
			 */
			getRightValue: function(rawValue) {
				if (rawValue && rawValue.t !== undefined) {
					rawValue = rawValue.t;
				}
				return Chart.Scale.prototype.getRightValue.call(this, rawValue);
			},
	
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var timeOpts = me.options.time;
				var unit = timeOpts.unit || 'day';
				var min = MAX_INTEGER;
				var max = MIN_INTEGER;
				var timestamps = [];
				var datasets = [];
				var labels = [];
				var i, j, ilen, jlen, data, timestamp;
	
				// Convert labels to timestamps
				for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
					labels.push(parse(chart.data.labels[i], me));
				}
	
				// Convert data to timestamps
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						data = chart.data.datasets[i].data;
	
						// Let's consider that all data have the same format.
						if (helpers.isObject(data[0])) {
							datasets[i] = [];
	
							for (j = 0, jlen = data.length; j < jlen; ++j) {
								timestamp = parse(data[j], me);
								timestamps.push(timestamp);
								datasets[i][j] = timestamp;
							}
						} else {
							timestamps.push.apply(timestamps, labels);
							datasets[i] = labels.slice(0);
						}
					} else {
						datasets[i] = [];
					}
				}
	
				if (labels.length) {
					// Sort labels **after** data have been converted
					labels = arrayUnique(labels).sort(sorter);
					min = Math.min(min, labels[0]);
					max = Math.max(max, labels[labels.length - 1]);
				}
	
				if (timestamps.length) {
					timestamps = arrayUnique(timestamps).sort(sorter);
					min = Math.min(min, timestamps[0]);
					max = Math.max(max, timestamps[timestamps.length - 1]);
				}
	
				min = parse(timeOpts.min, me) || min;
				max = parse(timeOpts.max, me) || max;
	
				// In case there is no valid min/max, set limits based on unit time option
				min = min === MAX_INTEGER ? +moment().startOf(unit) : min;
				max = max === MIN_INTEGER ? +moment().endOf(unit) + 1 : max;
	
				// Make sure that max is strictly higher than min (required by the lookup table)
				me.min = Math.min(min, max);
				me.max = Math.max(min + 1, max);
	
				// PRIVATE
				me._horizontal = me.isHorizontal();
				me._table = [];
				me._timestamps = {
					data: timestamps,
					datasets: datasets,
					labels: labels
				};
			},
	
			buildTicks: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
				var options = me.options;
				var timeOpts = options.time;
				var timestamps = [];
				var ticks = [];
				var i, ilen, timestamp;
	
				switch (options.ticks.source) {
				case 'data':
					timestamps = me._timestamps.data;
					break;
				case 'labels':
					timestamps = me._timestamps.labels;
					break;
				case 'auto':
				default:
					timestamps = generate(min, max, me.getLabelCapacity(min), options);
				}
	
				if (options.bounds === 'ticks' && timestamps.length) {
					min = timestamps[0];
					max = timestamps[timestamps.length - 1];
				}
	
				// Enforce limits with user min/max options
				min = parse(timeOpts.min, me) || min;
				max = parse(timeOpts.max, me) || max;
	
				// Remove ticks outside the min/max range
				for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
					timestamp = timestamps[i];
					if (timestamp >= min && timestamp <= max) {
						ticks.push(timestamp);
					}
				}
	
				me.min = min;
				me.max = max;
	
				// PRIVATE
				me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
				me._majorUnit = determineMajorUnit(me._unit);
				me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
				me._offsets = computeOffsets(me._table, ticks, min, max, options);
				me._labelFormat = determineLabelFormat(me._timestamps.data, timeOpts);
	
				return ticksFromTimestamps(ticks, me._majorUnit);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var timeOpts = me.options.time;
				var label = data.labels && index < data.labels.length ? data.labels[index] : '';
				var value = data.datasets[datasetIndex].data[index];
	
				if (helpers.isObject(value)) {
					label = me.getRightValue(value);
				}
				if (timeOpts.tooltipFormat) {
					return momentify(label, timeOpts).format(timeOpts.tooltipFormat);
				}
				if (typeof label === 'string') {
					return label;
				}
	
				return momentify(label, timeOpts).format(me._labelFormat);
			},
	
			/**
			 * Function to format an individual tick mark
			 * @private
			 */
			tickFormatFunction: function(tick, index, ticks, formatOverride) {
				var me = this;
				var options = me.options;
				var time = tick.valueOf();
				var formats = options.time.displayFormats;
				var minorFormat = formats[me._unit];
				var majorUnit = me._majorUnit;
				var majorFormat = formats[majorUnit];
				var majorTime = tick.clone().startOf(majorUnit).valueOf();
				var majorTickOpts = options.ticks.major;
				var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
				var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
				var tickOpts = major ? majorTickOpts : options.ticks.minor;
				var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				return formatter ? formatter(label, index, ticks) : label;
			},
	
			convertTicksToLabels: function(ticks) {
				var labels = [];
				var i, ilen;
	
				for (i = 0, ilen = ticks.length; i < ilen; ++i) {
					labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
				}
	
				return labels;
			},
	
			/**
			 * @private
			 */
			getPixelForOffset: function(time) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = interpolate(me._table, 'time', time, 'pos');
	
				return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
			},
	
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var time = null;
	
				if (index !== undefined && datasetIndex !== undefined) {
					time = me._timestamps.datasets[datasetIndex][index];
				}
	
				if (time === null) {
					time = parse(value, me);
				}
	
				if (time !== null) {
					return me.getPixelForOffset(time);
				}
			},
	
			getPixelForTick: function(index) {
				var ticks = this.getTicks();
				return index >= 0 && index < ticks.length ?
					this.getPixelForOffset(ticks[index].value) :
					null;
			},
	
			getValueForPixel: function(pixel) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
				var time = interpolate(me._table, 'pos', pos, 'time');
	
				return moment(time);
			},
	
			/**
			 * Crude approximation of what the label width might be
			 * @private
			 */
			getLabelWidth: function(label) {
				var me = this;
				var ticksOpts = me.options.ticks;
				var tickLabelWidth = me.ctx.measureText(label).width;
				var angle = helpers.toRadians(ticksOpts.maxRotation);
				var cosRotation = Math.cos(angle);
				var sinRotation = Math.sin(angle);
				var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);
	
				return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
			},
	
			/**
			 * @private
			 */
			getLabelCapacity: function(exampleTime) {
				var me = this;
	
				var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation
	
				var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
				var tickLabelWidth = me.getLabelWidth(exampleLabel);
				var innerWidth = me.isHorizontal() ? me.width : me.height;
	
				var capacity = Math.floor(innerWidth / tickLabelWidth);
				return capacity > 0 ? capacity : 1;
			}
		});
	
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	};


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(1563);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/i,
	       hex =  /^#([a-fA-F0-9]{6})$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(1561);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1631);
	module.exports = __webpack_require__(51).RegExp.escape;


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(95);
	__webpack_require__(1607);
	module.exports = __webpack_require__(26).Array.from;


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(117);
	__webpack_require__(95);
	module.exports = __webpack_require__(1605);


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(117);
	__webpack_require__(95);
	module.exports = __webpack_require__(1606);


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(26);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1609);
	module.exports = __webpack_require__(26).Number.parseFloat;


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1610);
	module.exports = __webpack_require__(26).Number.parseInt;


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1611);
	module.exports = __webpack_require__(26).Object.assign;


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1612);
	var $Object = __webpack_require__(26).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1613);
	var $Object = __webpack_require__(26).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1614);
	module.exports = __webpack_require__(26).Object.keys;


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(191);
	__webpack_require__(95);
	__webpack_require__(117);
	__webpack_require__(1615);
	__webpack_require__(1618);
	__webpack_require__(1619);
	module.exports = __webpack_require__(26).Promise;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(191);
	__webpack_require__(95);
	__webpack_require__(117);
	__webpack_require__(1616);
	__webpack_require__(1622);
	__webpack_require__(1621);
	__webpack_require__(1620);
	module.exports = __webpack_require__(26).Set;


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1617);
	__webpack_require__(191);
	__webpack_require__(1623);
	__webpack_require__(1624);
	module.exports = __webpack_require__(26).Symbol;


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(95);
	__webpack_require__(117);
	module.exports = __webpack_require__(189).f('iterator');


/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(111);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(94);
	var toLength = __webpack_require__(132);
	var toAbsoluteIndex = __webpack_require__(1603);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(70);
	var IObject = __webpack_require__(176);
	var toObject = __webpack_require__(116);
	var toLength = __webpack_require__(132);
	var asc = __webpack_require__(1584);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(58);
	var isArray = __webpack_require__(385);
	var SPECIES = __webpack_require__(33)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1583);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(49).f;
	var create = __webpack_require__(180);
	var redefineAll = __webpack_require__(182);
	var ctx = __webpack_require__(70);
	var anInstance = __webpack_require__(173);
	var forOf = __webpack_require__(111);
	var $iterDefine = __webpack_require__(177);
	var step = __webpack_require__(388);
	var setSpecies = __webpack_require__(395);
	var DESCRIPTORS = __webpack_require__(48);
	var fastKey = __webpack_require__(178).fastKey;
	var validate = __webpack_require__(399);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(129);
	var from = __webpack_require__(1580);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(32);
	var $export = __webpack_require__(31);
	var meta = __webpack_require__(178);
	var fails = __webpack_require__(71);
	var hide = __webpack_require__(72);
	var redefineAll = __webpack_require__(182);
	var forOf = __webpack_require__(111);
	var anInstance = __webpack_require__(173);
	var isObject = __webpack_require__(58);
	var setToStringTag = __webpack_require__(115);
	var dP = __webpack_require__(49).f;
	var each = __webpack_require__(1582)(0);
	var DESCRIPTORS = __webpack_require__(48);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(49);
	var createDesc = __webpack_require__(114);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(113);
	var gOPS = __webpack_require__(181);
	var pIE = __webpack_require__(131);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(180);
	var descriptor = __webpack_require__(114);
	var setToStringTag = __webpack_require__(115);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(72)(IteratorPrototype, __webpack_require__(33)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var macrotask = __webpack_require__(398).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(110)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(113);
	var gOPS = __webpack_require__(181);
	var pIE = __webpack_require__(131);
	var toObject = __webpack_require__(116);
	var IObject = __webpack_require__(176);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(71)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(131);
	var createDesc = __webpack_require__(114);
	var toIObject = __webpack_require__(94);
	var toPrimitive = __webpack_require__(187);
	var has = __webpack_require__(79);
	var IE8_DOM_DEFINE = __webpack_require__(383);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(48) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(94);
	var gOPN = __webpack_require__(390).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(79);
	var toObject = __webpack_require__(116);
	var IE_PROTO = __webpack_require__(183)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(31);
	var core = __webpack_require__(26);
	var fails = __webpack_require__(71);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(32).parseFloat;
	var $trim = __webpack_require__(397).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(185) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(32).parseInt;
	var $trim = __webpack_require__(397).trim;
	var ws = __webpack_require__(185);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(31);
	var aFunction = __webpack_require__(109);
	var ctx = __webpack_require__(70);
	var forOf = __webpack_require__(111);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(31);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(186);
	var defined = __webpack_require__(130);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(186);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(65);
	var get = __webpack_require__(190);
	module.exports = __webpack_require__(26).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(129);
	var ITERATOR = __webpack_require__(33)('iterator');
	var Iterators = __webpack_require__(93);
	module.exports = __webpack_require__(26).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(70);
	var $export = __webpack_require__(31);
	var toObject = __webpack_require__(116);
	var call = __webpack_require__(386);
	var isArrayIter = __webpack_require__(384);
	var toLength = __webpack_require__(132);
	var createProperty = __webpack_require__(1588);
	var getIterFn = __webpack_require__(190);
	
	$export($export.S + $export.F * !__webpack_require__(387)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1579);
	var step = __webpack_require__(388);
	var Iterators = __webpack_require__(93);
	var toIObject = __webpack_require__(94);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(177)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	var $parseFloat = __webpack_require__(1598);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	var $parseInt = __webpack_require__(1599);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(31);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1593) });


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(48), 'Object', { defineProperties: __webpack_require__(389) });


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(48), 'Object', { defineProperty: __webpack_require__(49).f });


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(116);
	var $keys = __webpack_require__(113);
	
	__webpack_require__(1597)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(112);
	var global = __webpack_require__(32);
	var ctx = __webpack_require__(70);
	var classof = __webpack_require__(129);
	var $export = __webpack_require__(31);
	var isObject = __webpack_require__(58);
	var aFunction = __webpack_require__(109);
	var anInstance = __webpack_require__(173);
	var forOf = __webpack_require__(111);
	var speciesConstructor = __webpack_require__(396);
	var task = __webpack_require__(398).set;
	var microtask = __webpack_require__(1592)();
	var newPromiseCapabilityModule = __webpack_require__(179);
	var perform = __webpack_require__(392);
	var userAgent = __webpack_require__(1604);
	var promiseResolve = __webpack_require__(393);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(33)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(182)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(115)($Promise, PROMISE);
	__webpack_require__(395)(PROMISE);
	Wrapper = __webpack_require__(26)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(387)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(1585);
	var validate = __webpack_require__(399);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(1587)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(32);
	var has = __webpack_require__(79);
	var DESCRIPTORS = __webpack_require__(48);
	var $export = __webpack_require__(31);
	var redefine = __webpack_require__(394);
	var META = __webpack_require__(178).KEY;
	var $fails = __webpack_require__(71);
	var shared = __webpack_require__(184);
	var setToStringTag = __webpack_require__(115);
	var uid = __webpack_require__(133);
	var wks = __webpack_require__(33);
	var wksExt = __webpack_require__(189);
	var wksDefine = __webpack_require__(188);
	var enumKeys = __webpack_require__(1589);
	var isArray = __webpack_require__(385);
	var anObject = __webpack_require__(65);
	var isObject = __webpack_require__(58);
	var toIObject = __webpack_require__(94);
	var toPrimitive = __webpack_require__(187);
	var createDesc = __webpack_require__(114);
	var _create = __webpack_require__(180);
	var gOPNExt = __webpack_require__(1595);
	var $GOPD = __webpack_require__(1594);
	var $DP = __webpack_require__(49);
	var $keys = __webpack_require__(113);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(390).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(131).f = $propertyIsEnumerable;
	  __webpack_require__(181).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(112)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(72)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(31);
	var core = __webpack_require__(26);
	var global = __webpack_require__(32);
	var speciesConstructor = __webpack_require__(396);
	var promiseResolve = __webpack_require__(393);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(31);
	var newPromiseCapability = __webpack_require__(179);
	var perform = __webpack_require__(392);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(1600)('Set');


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(1601)('Set');


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(31);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1586)('Set') });


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(188)('asyncIterator');


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(188)('observable');


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	var isArray = __webpack_require__(138);
	var SPECIES = __webpack_require__(24)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(21);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(63);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(84);
	var gOPS = __webpack_require__(142);
	var pIE = __webpack_require__(120);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(5);
	var $re = __webpack_require__(1629)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(401) });
	
	__webpack_require__(73)('copyWithin');


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $every = __webpack_require__(59)(4);
	
	$export($export.P + $export.F * !__webpack_require__(53)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Array', { fill: __webpack_require__(192) });
	
	__webpack_require__(73)('fill');


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $filter = __webpack_require__(59)(2);
	
	$export($export.P + $export.F * !__webpack_require__(53)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(5);
	var $find = __webpack_require__(59)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(73)(KEY);


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(5);
	var $find = __webpack_require__(59)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(73)(KEY);


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $forEach = __webpack_require__(59)(0);
	var STRICT = __webpack_require__(53)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(52);
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(30);
	var call = __webpack_require__(412);
	var isArrayIter = __webpack_require__(200);
	var toLength = __webpack_require__(29);
	var createProperty = __webpack_require__(194);
	var getIterFn = __webpack_require__(216);
	
	$export($export.S + $export.F * !__webpack_require__(140)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $indexOf = __webpack_require__(134)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(53)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(138) });


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(5);
	var toIObject = __webpack_require__(46);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(119) != Object || !__webpack_require__(53)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toIObject = __webpack_require__(46);
	var toInteger = __webpack_require__(62);
	var toLength = __webpack_require__(29);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(53)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $map = __webpack_require__(59)(1);
	
	$export($export.P + $export.F * !__webpack_require__(53)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var createProperty = __webpack_require__(194);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(21)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $reduce = __webpack_require__(403);
	
	$export($export.P + $export.F * !__webpack_require__(53)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $reduce = __webpack_require__(403);
	
	$export($export.P + $export.F * !__webpack_require__(53)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var html = __webpack_require__(198);
	var cof = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(88);
	var toLength = __webpack_require__(29);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(21)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $some = __webpack_require__(59)(3);
	
	$export($export.P + $export.F * !__webpack_require__(53)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var aFunction = __webpack_require__(34);
	var toObject = __webpack_require__(30);
	var fails = __webpack_require__(21);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(53)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(87)('Array');


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(5);
	var toISOString = __webpack_require__(1626);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(30);
	var toPrimitive = __webpack_require__(63);
	
	$export($export.P + $export.F * __webpack_require__(21)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(24)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(38)(proto, TO_PRIMITIVE, __webpack_require__(1627));


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(39)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(5);
	
	$export($export.P, 'Function', { bind: __webpack_require__(404) });


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(45);
	var HAS_INSTANCE = __webpack_require__(24)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(28).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(28).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(27) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(5);
	var log1p = __webpack_require__(415);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(5);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(5);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(5);
	var sign = __webpack_require__(204);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(5);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(5);
	var $expm1 = __webpack_require__(203);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { fround: __webpack_require__(414) });


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(5);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(5);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(21)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(415) });


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { sign: __webpack_require__(204) });


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(5);
	var expm1 = __webpack_require__(203);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(21)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(5);
	var expm1 = __webpack_require__(203);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var has = __webpack_require__(43);
	var cof = __webpack_require__(50);
	var inheritIfRequired = __webpack_require__(199);
	var toPrimitive = __webpack_require__(63);
	var fails = __webpack_require__(21);
	var gOPN = __webpack_require__(83).f;
	var gOPD = __webpack_require__(44).f;
	var dP = __webpack_require__(28).f;
	var $trim = __webpack_require__(98).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(82)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(27) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(39)(global, NUMBER, $Number);
	}


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(5);
	var _isFinite = __webpack_require__(18).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(411) });


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(5);
	var isInteger = __webpack_require__(411);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $parseFloat = __webpack_require__(423);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $parseInt = __webpack_require__(424);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toInteger = __webpack_require__(62);
	var aNumberValue = __webpack_require__(400);
	var repeat = __webpack_require__(211);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(21)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $fails = __webpack_require__(21);
	var aNumberValue = __webpack_require__(400);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(5);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(417) });


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(82) });


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperties: __webpack_require__(418) });


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(27), 'Object', { defineProperty: __webpack_require__(28).f });


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(22);
	var meta = __webpack_require__(75).onFreeze;
	
	__webpack_require__(61)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(46);
	var $getOwnPropertyDescriptor = __webpack_require__(44).f;
	
	__webpack_require__(61)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(61)('getOwnPropertyNames', function () {
	  return __webpack_require__(419).f;
	});


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(30);
	var $getPrototypeOf = __webpack_require__(45);
	
	__webpack_require__(61)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(22);
	
	__webpack_require__(61)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(22);
	
	__webpack_require__(61)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(22);
	
	__webpack_require__(61)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(5);
	$export($export.S, 'Object', { is: __webpack_require__(1630) });


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(30);
	var $keys = __webpack_require__(84);
	
	__webpack_require__(61)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(22);
	var meta = __webpack_require__(75).onFreeze;
	
	__webpack_require__(61)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(22);
	var meta = __webpack_require__(75).onFreeze;
	
	__webpack_require__(61)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(5);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(207).set });


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(118);
	var test = {};
	test[__webpack_require__(24)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(39)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $parseFloat = __webpack_require__(423);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $parseInt = __webpack_require__(424);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(74);
	var global = __webpack_require__(18);
	var ctx = __webpack_require__(52);
	var classof = __webpack_require__(118);
	var $export = __webpack_require__(5);
	var isObject = __webpack_require__(22);
	var aFunction = __webpack_require__(34);
	var anInstance = __webpack_require__(80);
	var forOf = __webpack_require__(81);
	var speciesConstructor = __webpack_require__(146);
	var task = __webpack_require__(213).set;
	var microtask = __webpack_require__(205)();
	var newPromiseCapabilityModule = __webpack_require__(206);
	var perform = __webpack_require__(425);
	var userAgent = __webpack_require__(148);
	var promiseResolve = __webpack_require__(426);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(24)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(86)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(97)($Promise, PROMISE);
	__webpack_require__(87)(PROMISE);
	Wrapper = __webpack_require__(51)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(140)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(5);
	var aFunction = __webpack_require__(34);
	var anObject = __webpack_require__(17);
	var rApply = (__webpack_require__(18).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(21)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(5);
	var create = __webpack_require__(82);
	var aFunction = __webpack_require__(34);
	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(22);
	var fails = __webpack_require__(21);
	var bind = __webpack_require__(404);
	var rConstruct = (__webpack_require__(18).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(28);
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(63);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(21)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(5);
	var gOPD = __webpack_require__(44).f;
	var anObject = __webpack_require__(17);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(17);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(201)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(44);
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(17);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(5);
	var getProto = __webpack_require__(45);
	var anObject = __webpack_require__(17);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(44);
	var getPrototypeOf = __webpack_require__(45);
	var has = __webpack_require__(43);
	var $export = __webpack_require__(5);
	var isObject = __webpack_require__(22);
	var anObject = __webpack_require__(17);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(17);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(422) });


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(5);
	var anObject = __webpack_require__(17);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(5);
	var setProto = __webpack_require__(207);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(28);
	var gOPD = __webpack_require__(44);
	var getPrototypeOf = __webpack_require__(45);
	var has = __webpack_require__(43);
	var $export = __webpack_require__(5);
	var createDesc = __webpack_require__(85);
	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(22);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var inheritIfRequired = __webpack_require__(199);
	var dP = __webpack_require__(28).f;
	var gOPN = __webpack_require__(83).f;
	var isRegExp = __webpack_require__(139);
	var $flags = __webpack_require__(137);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(27) && (!CORRECT_NEW || __webpack_require__(21)(function () {
	  re2[__webpack_require__(24)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(39)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(87)('RegExp');


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(136)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(136)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(136)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(136)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(139);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(431);
	var anObject = __webpack_require__(17);
	var $flags = __webpack_require__(137);
	var DESCRIPTORS = __webpack_require__(27);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(39)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(21)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(40)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(40)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(40)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(40)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $at = __webpack_require__(209)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(5);
	var toLength = __webpack_require__(29);
	var context = __webpack_require__(210);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(197)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(40)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(40)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(40)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var toAbsoluteIndex = __webpack_require__(88);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(5);
	var context = __webpack_require__(210);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(197)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(40)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(209)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(202)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(40)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var toIObject = __webpack_require__(46);
	var toLength = __webpack_require__(29);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(211)
	});


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(40)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(5);
	var toLength = __webpack_require__(29);
	var context = __webpack_require__(210);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(197)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(40)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(40)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(40)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(98)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(18);
	var has = __webpack_require__(43);
	var DESCRIPTORS = __webpack_require__(27);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(39);
	var META = __webpack_require__(75).KEY;
	var $fails = __webpack_require__(21);
	var shared = __webpack_require__(145);
	var setToStringTag = __webpack_require__(97);
	var uid = __webpack_require__(89);
	var wks = __webpack_require__(24);
	var wksExt = __webpack_require__(429);
	var wksDefine = __webpack_require__(215);
	var enumKeys = __webpack_require__(1628);
	var isArray = __webpack_require__(138);
	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(22);
	var toIObject = __webpack_require__(46);
	var toPrimitive = __webpack_require__(63);
	var createDesc = __webpack_require__(85);
	var _create = __webpack_require__(82);
	var gOPNExt = __webpack_require__(419);
	var $GOPD = __webpack_require__(44);
	var $DP = __webpack_require__(28);
	var $keys = __webpack_require__(84);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(83).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(120).f = $propertyIsEnumerable;
	  __webpack_require__(142).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(74)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(38)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var $typed = __webpack_require__(147);
	var buffer = __webpack_require__(214);
	var anObject = __webpack_require__(17);
	var toAbsoluteIndex = __webpack_require__(88);
	var toLength = __webpack_require__(29);
	var isObject = __webpack_require__(22);
	var ArrayBuffer = __webpack_require__(18).ArrayBuffer;
	var speciesConstructor = __webpack_require__(146);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(21)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(87)(ARRAY_BUFFER);


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	$export($export.G + $export.W + $export.F * !__webpack_require__(147).ABV, {
	  DataView: __webpack_require__(214).DataView
	});


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(407);
	var validate = __webpack_require__(99);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(135)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(5);
	var flattenIntoArray = __webpack_require__(408);
	var toObject = __webpack_require__(30);
	var toLength = __webpack_require__(29);
	var aFunction = __webpack_require__(34);
	var arraySpeciesCreate = __webpack_require__(193);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(73)('flatMap');


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(5);
	var flattenIntoArray = __webpack_require__(408);
	var toObject = __webpack_require__(30);
	var toLength = __webpack_require__(29);
	var toInteger = __webpack_require__(62);
	var arraySpeciesCreate = __webpack_require__(193);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(73)('flatten');


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(5);
	var $includes = __webpack_require__(134)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(73)('includes');


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(5);
	var microtask = __webpack_require__(205)();
	var process = __webpack_require__(18).process;
	var isNode = __webpack_require__(50)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(5);
	var cof = __webpack_require__(50);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(5);
	
	$export($export.G, { global: __webpack_require__(18) });


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(143)('Map');


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(144)('Map');


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(5);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(406)('Map') });


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	var scale = __webpack_require__(416);
	var fround = __webpack_require__(414);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { scale: __webpack_require__(416) });


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(5);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(30);
	var aFunction = __webpack_require__(34);
	var $defineProperty = __webpack_require__(28);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(27) && $export($export.P + __webpack_require__(141), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(30);
	var aFunction = __webpack_require__(34);
	var $defineProperty = __webpack_require__(28);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(27) && $export($export.P + __webpack_require__(141), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(5);
	var $entries = __webpack_require__(421)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(5);
	var ownKeys = __webpack_require__(422);
	var toIObject = __webpack_require__(46);
	var gOPD = __webpack_require__(44);
	var createProperty = __webpack_require__(194);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(30);
	var toPrimitive = __webpack_require__(63);
	var getPrototypeOf = __webpack_require__(45);
	var getOwnPropertyDescriptor = __webpack_require__(44).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(27) && $export($export.P + __webpack_require__(141), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(30);
	var toPrimitive = __webpack_require__(63);
	var getPrototypeOf = __webpack_require__(45);
	var getOwnPropertyDescriptor = __webpack_require__(44).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(27) && $export($export.P + __webpack_require__(141), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(5);
	var $values = __webpack_require__(421)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(5);
	var global = __webpack_require__(18);
	var core = __webpack_require__(51);
	var microtask = __webpack_require__(205)();
	var OBSERVABLE = __webpack_require__(24)('observable');
	var aFunction = __webpack_require__(34);
	var anObject = __webpack_require__(17);
	var anInstance = __webpack_require__(80);
	var redefineAll = __webpack_require__(86);
	var hide = __webpack_require__(38);
	var forOf = __webpack_require__(81);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(87)('Observable');


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(5);
	var core = __webpack_require__(51);
	var global = __webpack_require__(18);
	var speciesConstructor = __webpack_require__(146);
	var promiseResolve = __webpack_require__(426);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(5);
	var newPromiseCapability = __webpack_require__(206);
	var perform = __webpack_require__(425);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(432);
	var from = __webpack_require__(402);
	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var getPrototypeOf = __webpack_require__(45);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var getPrototypeOf = __webpack_require__(45);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var getPrototypeOf = __webpack_require__(45);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(66);
	var anObject = __webpack_require__(17);
	var aFunction = __webpack_require__(34);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(143)('Set');


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(144)('Set');


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(5);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(406)('Set') });


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(5);
	var $at = __webpack_require__(209)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(5);
	var defined = __webpack_require__(60);
	var toLength = __webpack_require__(29);
	var isRegExp = __webpack_require__(139);
	var getFlags = __webpack_require__(137);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(201)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(5);
	var $pad = __webpack_require__(427);
	var userAgent = __webpack_require__(148);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(5);
	var $pad = __webpack_require__(427);
	var userAgent = __webpack_require__(148);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(98)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(98)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(215)('asyncIterator');


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(215)('observable');


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(5);
	
	$export($export.S, 'System', { global: __webpack_require__(18) });


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(143)('WeakMap');


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(144)('WeakMap');


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(143)('WeakSet');


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(144)('WeakSet');


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(217);
	var getKeys = __webpack_require__(84);
	var redefine = __webpack_require__(39);
	var global = __webpack_require__(18);
	var hide = __webpack_require__(38);
	var Iterators = __webpack_require__(96);
	var wks = __webpack_require__(24);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	var $task = __webpack_require__(213);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(18);
	var $export = __webpack_require__(5);
	var userAgent = __webpack_require__(148);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1751);
	__webpack_require__(1690);
	__webpack_require__(1692);
	__webpack_require__(1691);
	__webpack_require__(1694);
	__webpack_require__(1696);
	__webpack_require__(1701);
	__webpack_require__(1695);
	__webpack_require__(1693);
	__webpack_require__(1703);
	__webpack_require__(1702);
	__webpack_require__(1698);
	__webpack_require__(1699);
	__webpack_require__(1697);
	__webpack_require__(1689);
	__webpack_require__(1700);
	__webpack_require__(1704);
	__webpack_require__(1705);
	__webpack_require__(1657);
	__webpack_require__(1659);
	__webpack_require__(1658);
	__webpack_require__(1707);
	__webpack_require__(1706);
	__webpack_require__(1677);
	__webpack_require__(1687);
	__webpack_require__(1688);
	__webpack_require__(1678);
	__webpack_require__(1679);
	__webpack_require__(1680);
	__webpack_require__(1681);
	__webpack_require__(1682);
	__webpack_require__(1683);
	__webpack_require__(1684);
	__webpack_require__(1685);
	__webpack_require__(1686);
	__webpack_require__(1660);
	__webpack_require__(1661);
	__webpack_require__(1662);
	__webpack_require__(1663);
	__webpack_require__(1664);
	__webpack_require__(1665);
	__webpack_require__(1666);
	__webpack_require__(1667);
	__webpack_require__(1668);
	__webpack_require__(1669);
	__webpack_require__(1670);
	__webpack_require__(1671);
	__webpack_require__(1672);
	__webpack_require__(1673);
	__webpack_require__(1674);
	__webpack_require__(1675);
	__webpack_require__(1676);
	__webpack_require__(1738);
	__webpack_require__(1743);
	__webpack_require__(1750);
	__webpack_require__(1741);
	__webpack_require__(1733);
	__webpack_require__(1734);
	__webpack_require__(1739);
	__webpack_require__(1744);
	__webpack_require__(1746);
	__webpack_require__(1729);
	__webpack_require__(1730);
	__webpack_require__(1731);
	__webpack_require__(1732);
	__webpack_require__(1735);
	__webpack_require__(1736);
	__webpack_require__(1737);
	__webpack_require__(1740);
	__webpack_require__(1742);
	__webpack_require__(1745);
	__webpack_require__(1747);
	__webpack_require__(1748);
	__webpack_require__(1749);
	__webpack_require__(1652);
	__webpack_require__(1654);
	__webpack_require__(1653);
	__webpack_require__(1656);
	__webpack_require__(1655);
	__webpack_require__(1641);
	__webpack_require__(1639);
	__webpack_require__(1645);
	__webpack_require__(1642);
	__webpack_require__(1648);
	__webpack_require__(1650);
	__webpack_require__(1638);
	__webpack_require__(1644);
	__webpack_require__(1635);
	__webpack_require__(1649);
	__webpack_require__(1633);
	__webpack_require__(1647);
	__webpack_require__(1646);
	__webpack_require__(1640);
	__webpack_require__(1643);
	__webpack_require__(1632);
	__webpack_require__(1634);
	__webpack_require__(1637);
	__webpack_require__(1636);
	__webpack_require__(1651);
	__webpack_require__(217);
	__webpack_require__(1723);
	__webpack_require__(1728);
	__webpack_require__(431);
	__webpack_require__(1724);
	__webpack_require__(1725);
	__webpack_require__(1726);
	__webpack_require__(1727);
	__webpack_require__(1708);
	__webpack_require__(430);
	__webpack_require__(432);
	__webpack_require__(433);
	__webpack_require__(1763);
	__webpack_require__(1752);
	__webpack_require__(1753);
	__webpack_require__(1758);
	__webpack_require__(1761);
	__webpack_require__(1762);
	__webpack_require__(1756);
	__webpack_require__(1759);
	__webpack_require__(1757);
	__webpack_require__(1760);
	__webpack_require__(1754);
	__webpack_require__(1755);
	__webpack_require__(1709);
	__webpack_require__(1710);
	__webpack_require__(1711);
	__webpack_require__(1712);
	__webpack_require__(1713);
	__webpack_require__(1716);
	__webpack_require__(1714);
	__webpack_require__(1715);
	__webpack_require__(1717);
	__webpack_require__(1718);
	__webpack_require__(1719);
	__webpack_require__(1720);
	__webpack_require__(1722);
	__webpack_require__(1721);
	__webpack_require__(1766);
	__webpack_require__(1764);
	__webpack_require__(1765);
	__webpack_require__(1807);
	__webpack_require__(1810);
	__webpack_require__(1809);
	__webpack_require__(1811);
	__webpack_require__(1812);
	__webpack_require__(1808);
	__webpack_require__(1813);
	__webpack_require__(1814);
	__webpack_require__(1788);
	__webpack_require__(1791);
	__webpack_require__(1787);
	__webpack_require__(1785);
	__webpack_require__(1786);
	__webpack_require__(1789);
	__webpack_require__(1790);
	__webpack_require__(1772);
	__webpack_require__(1806);
	__webpack_require__(1771);
	__webpack_require__(1805);
	__webpack_require__(1817);
	__webpack_require__(1819);
	__webpack_require__(1770);
	__webpack_require__(1804);
	__webpack_require__(1816);
	__webpack_require__(1818);
	__webpack_require__(1769);
	__webpack_require__(1815);
	__webpack_require__(1768);
	__webpack_require__(1773);
	__webpack_require__(1774);
	__webpack_require__(1775);
	__webpack_require__(1776);
	__webpack_require__(1777);
	__webpack_require__(1779);
	__webpack_require__(1778);
	__webpack_require__(1780);
	__webpack_require__(1781);
	__webpack_require__(1782);
	__webpack_require__(1784);
	__webpack_require__(1783);
	__webpack_require__(1793);
	__webpack_require__(1794);
	__webpack_require__(1795);
	__webpack_require__(1796);
	__webpack_require__(1798);
	__webpack_require__(1797);
	__webpack_require__(1800);
	__webpack_require__(1799);
	__webpack_require__(1801);
	__webpack_require__(1802);
	__webpack_require__(1803);
	__webpack_require__(1767);
	__webpack_require__(1792);
	__webpack_require__(1822);
	__webpack_require__(1821);
	__webpack_require__(1820);
	module.exports = __webpack_require__(51);


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(434)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(1829)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(434)
	
	exports.createHmac = __webpack_require__(1824)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(1828)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(1516)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(1825);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(2913)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(4036)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(25).Buffer))

/***/ }),
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */
/***/ (function(module, exports) {

	/**
	 *
	 * @namespace faker.address
	 */
	function Address (faker) {
	  var f = faker.fake,
	      Helpers = faker.helpers;
	
	  /**
	   * Generates random zipcode from format. If format is not specified, the
	   * locale's zip format is used.
	   *
	   * @method faker.address.zipCode
	   * @param {String} format
	   */
	  this.zipCode = function(format) {
	    // if zip format is not specified, use the zip format defined for the locale
	    if (typeof format === 'undefined') {
	      var localeFormat = faker.definitions.address.postcode;
	      if (typeof localeFormat === 'string') {
	        format = localeFormat;
	      } else {
	        format = faker.random.arrayElement(localeFormat);
	      }
	    }
	    return Helpers.replaceSymbols(format);
	  }
	
	  /**
	   * Generates a random localized city name. The format string can contain any
	   * method provided by faker wrapped in `{{}}`, e.g. `{{name.firstName}}` in
	   * order to build the city name.
	   *
	   * If no format string is provided one of the following is randomly used:
	   * 
	   * * `{{address.cityPrefix}} {{name.firstName}}{{address.citySuffix}}`
	   * * `{{address.cityPrefix}} {{name.firstName}}`
	   * * `{{name.firstName}}{{address.citySuffix}}`
	   * * `{{name.lastName}}{{address.citySuffix}}`
	   *
	   * @method faker.address.city
	   * @param {String} format
	   */
	  this.city = function (format) {
	    var formats = [
	      '{{address.cityPrefix}} {{name.firstName}}{{address.citySuffix}}',
	      '{{address.cityPrefix}} {{name.firstName}}',
	      '{{name.firstName}}{{address.citySuffix}}',
	      '{{name.lastName}}{{address.citySuffix}}'
	    ];
	
	    if (typeof format !== "number") {
	      format = faker.random.number(formats.length - 1);
	    }
	
	    return f(formats[format]);
	
	  }
	
	  /**
	   * Return a random localized city prefix
	   * @method faker.address.cityPrefix
	   */
	  this.cityPrefix = function () {
	    return faker.random.arrayElement(faker.definitions.address.city_prefix);
	  }
	
	  /**
	   * Return a random localized city suffix
	   *
	   * @method faker.address.citySuffix
	   */
	  this.citySuffix = function () {
	    return faker.random.arrayElement(faker.definitions.address.city_suffix);
	  }
	
	  /**
	   * Returns a random localized street name
	   *
	   * @method faker.address.streetName
	   */
	  this.streetName = function () {
	      var result;
	      var suffix = faker.address.streetSuffix();
	      if (suffix !== "") {
	          suffix = " " + suffix
	      }
	
	      switch (faker.random.number(1)) {
	      case 0:
	          result = faker.name.lastName() + suffix;
	          break;
	      case 1:
	          result = faker.name.firstName() + suffix;
	          break;
	      }
	      return result;
	  }
	
	  //
	  // TODO: change all these methods that accept a boolean to instead accept an options hash.
	  //
	  /**
	   * Returns a random localized street address
	   *
	   * @method faker.address.streetAddress
	   * @param {Boolean} useFullAddress
	   */
	  this.streetAddress = function (useFullAddress) {
	      if (useFullAddress === undefined) { useFullAddress = false; }
	      var address = "";
	      switch (faker.random.number(2)) {
	      case 0:
	          address = Helpers.replaceSymbolWithNumber("#####") + " " + faker.address.streetName();
	          break;
	      case 1:
	          address = Helpers.replaceSymbolWithNumber("####") +  " " + faker.address.streetName();
	          break;
	      case 2:
	          address = Helpers.replaceSymbolWithNumber("###") + " " + faker.address.streetName();
	          break;
	      }
	      return useFullAddress ? (address + " " + faker.address.secondaryAddress()) : address;
	  }
	
	  /**
	   * streetSuffix
	   *
	   * @method faker.address.streetSuffix
	   */
	  this.streetSuffix = function () {
	      return faker.random.arrayElement(faker.definitions.address.street_suffix);
	  }
	  
	  /**
	   * streetPrefix
	   *
	   * @method faker.address.streetPrefix
	   */
	  this.streetPrefix = function () {
	      return faker.random.arrayElement(faker.definitions.address.street_prefix);
	  }
	
	  /**
	   * secondaryAddress
	   *
	   * @method faker.address.secondaryAddress
	   */
	  this.secondaryAddress = function () {
	      return Helpers.replaceSymbolWithNumber(faker.random.arrayElement(
	          [
	              'Apt. ###',
	              'Suite ###'
	          ]
	      ));
	  }
	
	  /**
	   * county
	   *
	   * @method faker.address.county
	   */
	  this.county = function () {
	    return faker.random.arrayElement(faker.definitions.address.county);
	  }
	
	  /**
	   * country
	   *
	   * @method faker.address.country
	   */
	  this.country = function () {
	    return faker.random.arrayElement(faker.definitions.address.country);
	  }
	
	  /**
	   * countryCode
	   *
	   * @method faker.address.countryCode
	   */
	  this.countryCode = function () {
	    return faker.random.arrayElement(faker.definitions.address.country_code);
	  }
	
	  /**
	   * state
	   *
	   * @method faker.address.state
	   * @param {Boolean} useAbbr
	   */
	  this.state = function (useAbbr) {
	      return faker.random.arrayElement(faker.definitions.address.state);
	  }
	
	  /**
	   * stateAbbr
	   *
	   * @method faker.address.stateAbbr
	   */
	  this.stateAbbr = function () {
	      return faker.random.arrayElement(faker.definitions.address.state_abbr);
	  }
	
	  /**
	   * latitude
	   *
	   * @method faker.address.latitude
	   */
	  this.latitude = function () {
	      return (faker.random.number(180 * 10000) / 10000.0 - 90.0).toFixed(4);
	  }
	
	  /**
	   * longitude
	   *
	   * @method faker.address.longitude
	   */
	  this.longitude = function () {
	      return (faker.random.number(360 * 10000) / 10000.0 - 180.0).toFixed(4);
	  }
	  
	  return this;
	}
	
	
	module.exports = Address;


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.commerce
	 */
	var Commerce = function (faker) {
	  var self = this;
	
	  /**
	   * color
	   *
	   * @method faker.commerce.color
	   */
	  self.color = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.color);
	  };
	
	  /**
	   * department
	   *
	   * @method faker.commerce.department
	   * @param {number} max
	   * @param {number} fixedAmount
	   */
	  self.department = function(max, fixedAmount) {
	      return faker.random.arrayElement(faker.definitions.commerce.department);
	  };
	
	  /**
	   * productName
	   *
	   * @method faker.commerce.productName
	   */
	  self.productName = function() {
	      return faker.commerce.productAdjective() + " " +
	              faker.commerce.productMaterial() + " " +
	              faker.commerce.product();
	  };
	
	  /**
	   * price
	   *
	   * @method faker.commerce.price
	   * @param {number} min
	   * @param {number} max
	   * @param {number} dec
	   * @param {string} symbol
	   */
	  self.price = function(min, max, dec, symbol) {
	      min = min || 0;
	      max = max || 1000;
	      dec = dec || 2;
	      symbol = symbol || '';
	
	      if(min < 0 || max < 0) {
	          return symbol + 0.00;
	      }
	
	      var randValue = faker.random.number({ max: max, min: min });
	
	      return symbol + (Math.round(randValue * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec);
	  };
	
	  /*
	  self.categories = function(num) {
	      var categories = [];
	
	      do {
	          var category = faker.random.arrayElement(faker.definitions.commerce.department);
	          if(categories.indexOf(category) === -1) {
	              categories.push(category);
	          }
	      } while(categories.length < num);
	
	      return categories;
	  };
	
	  */
	  /*
	  self.mergeCategories = function(categories) {
	      var separator = faker.definitions.separator || " &";
	      // TODO: find undefined here
	      categories = categories || faker.definitions.commerce.categories;
	      var commaSeparated = categories.slice(0, -1).join(', ');
	
	      return [commaSeparated, categories[categories.length - 1]].join(separator + " ");
	  };
	  */
	
	  /**
	   * productAdjective
	   *
	   * @method faker.commerce.productAdjective
	   */
	  self.productAdjective = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.adjective);
	  };
	
	  /**
	   * productMaterial
	   *
	   * @method faker.commerce.productMaterial
	   */
	  self.productMaterial = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.material);
	  };
	
	  /**
	   * product
	   *
	   * @method faker.commerce.product
	   */
	  self.product = function() {
	      return faker.random.arrayElement(faker.definitions.commerce.product_name.product);
	  }
	
	  return self;
	};
	
	module['exports'] = Commerce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.company
	 */
	var Company = function (faker) {
	  
	  var self = this;
	  var f = faker.fake;
	  
	  /**
	   * suffixes
	   *
	   * @method faker.company.suffixes
	   */
	  this.suffixes = function () {
	    // Don't want the source array exposed to modification, so return a copy
	    return faker.definitions.company.suffix.slice(0);
	  }
	
	  /**
	   * companyName
	   *
	   * @method faker.company.companyName
	   * @param {string} format
	   */
	  this.companyName = function (format) {
	
	    var formats = [
	      '{{name.lastName}} {{company.companySuffix}}',
	      '{{name.lastName}} - {{name.lastName}}',
	      '{{name.lastName}}, {{name.lastName}} and {{name.lastName}}'
	    ];
	
	    if (typeof format !== "number") {
	      format = faker.random.number(formats.length - 1);
	    }
	
	    return f(formats[format]);
	  }
	
	  /**
	   * companySuffix
	   *
	   * @method faker.company.companySuffix
	   */
	  this.companySuffix = function () {
	      return faker.random.arrayElement(faker.company.suffixes());
	  }
	
	  /**
	   * catchPhrase
	   *
	   * @method faker.company.catchPhrase
	   */
	  this.catchPhrase = function () {
	    return f('{{company.catchPhraseAdjective}} {{company.catchPhraseDescriptor}} {{company.catchPhraseNoun}}')
	  }
	
	  /**
	   * bs
	   *
	   * @method faker.company.bs
	   */
	  this.bs = function () {
	    return f('{{company.bsAdjective}} {{company.bsBuzz}} {{company.bsNoun}}');
	  }
	
	  /**
	   * catchPhraseAdjective
	   *
	   * @method faker.company.catchPhraseAdjective
	   */
	  this.catchPhraseAdjective = function () {
	      return faker.random.arrayElement(faker.definitions.company.adjective);
	  }
	
	  /**
	   * catchPhraseDescriptor
	   *
	   * @method faker.company.catchPhraseDescriptor
	   */
	  this.catchPhraseDescriptor = function () {
	      return faker.random.arrayElement(faker.definitions.company.descriptor);
	  }
	
	  /**
	   * catchPhraseNoun
	   *
	   * @method faker.company.catchPhraseNoun
	   */
	  this.catchPhraseNoun = function () {
	      return faker.random.arrayElement(faker.definitions.company.noun);
	  }
	
	  /**
	   * bsAdjective
	   *
	   * @method faker.company.bsAdjective
	   */
	  this.bsAdjective = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_adjective);
	  }
	
	  /**
	   * bsBuzz
	   *
	   * @method faker.company.bsBuzz
	   */
	  this.bsBuzz = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_verb);
	  }
	
	  /**
	   * bsNoun
	   *
	   * @method faker.company.bsNoun
	   */
	  this.bsNoun = function () {
	      return faker.random.arrayElement(faker.definitions.company.bs_noun);
	  }
	  
	}
	
	module['exports'] = Company;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.date
	 */
	var _Date = function (faker) {
	  var self = this;
	  /**
	   * past
	   *
	   * @method faker.date.past
	   * @param {number} years
	   * @param {date} refDate
	   */
	  self.past = function (years, refDate) {
	      var date = (refDate) ? new Date(Date.parse(refDate)) : new Date();
	      var range = {
	        min: 1000,
	        max: (years || 1) * 365 * 24 * 3600 * 1000
	      };
	
	      var past = date.getTime();
	      past -= faker.random.number(range); // some time from now to N years ago, in milliseconds
	      date.setTime(past);
	
	      return date;
	  };
	
	  /**
	   * future
	   *
	   * @method faker.date.future
	   * @param {number} years
	   * @param {date} refDate
	   */
	  self.future = function (years, refDate) {
	      var date = (refDate) ? new Date(Date.parse(refDate)) : new Date();
	      var range = {
	        min: 1000,
	        max: (years || 1) * 365 * 24 * 3600 * 1000
	      };
	
	      var future = date.getTime();
	      future += faker.random.number(range); // some time from now to N years later, in milliseconds
	      date.setTime(future);
	
	      return date;
	  };
	
	  /**
	   * between
	   *
	   * @method faker.date.between
	   * @param {date} from
	   * @param {date} to
	   */
	  self.between = function (from, to) {
	      var fromMilli = Date.parse(from);
	      var dateOffset = faker.random.number(Date.parse(to) - fromMilli);
	
	      var newDate = new Date(fromMilli + dateOffset);
	
	      return newDate;
	  };
	
	  /**
	   * recent
	   *
	   * @method faker.date.recent
	   * @param {number} days
	   */
	  self.recent = function (days) {
	      var date = new Date();
	      var range = {
	        min: 1000,
	        max: (days || 1) * 24 * 3600 * 1000
	      };
	
	      var future = date.getTime();
	      future -= faker.random.number(range); // some time from now to N days ago, in milliseconds
	      date.setTime(future);
	
	      return date;
	  };
	
	  /**
	   * month
	   *
	   * @method faker.date.month
	   * @param {object} options
	   */
	  self.month = function (options) {
	      options = options || {};
	
	      var type = 'wide';
	      if (options.abbr) {
	          type = 'abbr';
	      }
	      if (options.context && typeof faker.definitions.date.month[type + '_context'] !== 'undefined') {
	          type += '_context';
	      }
	
	      var source = faker.definitions.date.month[type];
	
	      return faker.random.arrayElement(source);
	  };
	
	  /**
	   * weekday
	   *
	   * @param {object} options
	   * @method faker.date.weekday
	   */
	  self.weekday = function (options) {
	      options = options || {};
	
	      var type = 'wide';
	      if (options.abbr) {
	          type = 'abbr';
	      }
	      if (options.context && typeof faker.definitions.date.weekday[type + '_context'] !== 'undefined') {
	          type += '_context';
	      }
	
	      var source = faker.definitions.date.weekday[type];
	
	      return faker.random.arrayElement(source);
	  };
	  
	  return self;
	  
	};
	
	module['exports'] = _Date;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	  fake.js - generator method for combining faker methods based on string input
	
	*/
	
	function Fake (faker) {
	  
	  /**
	   * Generator method for combining faker methods based on string input
	   *
	   * __Example:__
	   *
	   * ```
	   * console.log(faker.fake('{{name.lastName}}, {{name.firstName}} {{name.suffix}}'));
	   * //outputs: "Marks, Dean Sr."
	   * ```
	   *
	   * This will interpolate the format string with the value of methods
	   * [name.lastName]{@link faker.name.lastName}, [name.firstName]{@link faker.name.firstName},
	   * and [name.suffix]{@link faker.name.suffix}
	   *
	   * @method faker.fake
	   * @param {string} str
	   */
	  this.fake = function fake (str) {
	    // setup default response as empty string
	    var res = '';
	
	    // if incoming str parameter is not provided, return error message
	    if (typeof str !== 'string' || str.length === 0) {
	      res = 'string parameter is required!';
	      return res;
	    }
	
	    // find first matching {{ and }}
	    var start = str.search('{{');
	    var end = str.search('}}');
	
	    // if no {{ and }} is found, we are done
	    if (start === -1 && end === -1) {
	      return str;
	    }
	
	    // console.log('attempting to parse', str);
	
	    // extract method name from between the {{ }} that we found
	    // for example: {{name.firstName}}
	    var token = str.substr(start + 2,  end - start - 2);
	    var method = token.replace('}}', '').replace('{{', '');
	
	    // console.log('method', method)
	
	    // extract method parameters
	    var regExp = /\(([^)]+)\)/;
	    var matches = regExp.exec(method);
	    var parameters = '';
	    if (matches) {
	      method = method.replace(regExp, '');
	      parameters = matches[1];
	    }
	
	    // split the method into module and function
	    var parts = method.split('.');
	
	    if (typeof faker[parts[0]] === "undefined") {
	      throw new Error('Invalid module: ' + parts[0]);
	    }
	
	    if (typeof faker[parts[0]][parts[1]] === "undefined") {
	      throw new Error('Invalid method: ' + parts[0] + "." + parts[1]);
	    }
	
	    // assign the function from the module.function namespace
	    var fn = faker[parts[0]][parts[1]];
	
	    // If parameters are populated here, they are always going to be of string type
	    // since we might actually be dealing with an object or array,
	    // we always attempt to the parse the incoming parameters into JSON
	    var params;
	    // Note: we experience a small performance hit here due to JSON.parse try / catch
	    // If anyone actually needs to optimize this specific code path, please open a support issue on github
	    try {
	      params = JSON.parse(parameters)
	    } catch (err) {
	      // since JSON.parse threw an error, assume parameters was actually a string
	      params = parameters;
	    }
	
	    var result;
	    if (typeof params === "string" && params.length === 0) {
	      result = fn.call(this);
	    } else {
	      result = fn.call(this, params);
	    }
	
	    // replace the found tag with the returned fake value
	    res = str.replace('{{' + token + '}}', result);
	
	    // return the response recursively until we are done finding all tags
	    return fake(res);    
	  }
	  
	  return this;
	  
	  
	}
	
	module['exports'] = Fake;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.finance
	 */
	var Finance = function (faker) {
	  var Helpers = faker.helpers,
	      self = this;
	
	  /**
	   * account
	   *
	   * @method faker.finance.account
	   * @param {number} length
	   */
	  self.account = function (length) {
	
	      length = length || 8;
	
	      var template = '';
	
	      for (var i = 0; i < length; i++) {
	          template = template + '#';
	      }
	      length = null;
	      return Helpers.replaceSymbolWithNumber(template);
	  }
	
	  /**
	   * accountName
	   *
	   * @method faker.finance.accountName
	   */
	  self.accountName = function () {
	
	      return [Helpers.randomize(faker.definitions.finance.account_type), 'Account'].join(' ');
	  }
	
	  /**
	   * mask
	   *
	   * @method faker.finance.mask
	   * @param {number} length
	   * @param {boolean} parens
	   * @param {boolean} elipsis
	   */
	  self.mask = function (length, parens, elipsis) {
	
	
	      //set defaults
	      length = (length == 0 || !length || typeof length == 'undefined') ? 4 : length;
	      parens = (parens === null) ? true : parens;
	      elipsis = (elipsis === null) ? true : elipsis;
	
	      //create a template for length
	      var template = '';
	
	      for (var i = 0; i < length; i++) {
	          template = template + '#';
	      }
	
	      //prefix with elipsis
	      template = (elipsis) ? ['...', template].join('') : template;
	
	      template = (parens) ? ['(', template, ')'].join('') : template;
	
	      //generate random numbers
	      template = Helpers.replaceSymbolWithNumber(template);
	
	      return template;
	
	  }
	
	  //min and max take in minimum and maximum amounts, dec is the decimal place you want rounded to, symbol is $, €, £, etc
	  //NOTE: this returns a string representation of the value, if you want a number use parseFloat and no symbol
	
	  /**
	   * amount
	   *
	   * @method faker.finance.amount
	   * @param {number} min
	   * @param {number} max
	   * @param {number} dec
	   * @param {string} symbol
	   */
	  self.amount = function (min, max, dec, symbol) {
	
	      min = min || 0;
	      max = max || 1000;
	      dec = dec || 2;
	      symbol = symbol || '';
	      var randValue = faker.random.number({ max: max, min: min });
	
	      return symbol + (Math.round(randValue * Math.pow(10, dec)) / Math.pow(10, dec)).toFixed(dec);
	
	  }
	
	  /**
	   * transactionType
	   *
	   * @method faker.finance.transactionType
	   */
	  self.transactionType = function () {
	      return Helpers.randomize(faker.definitions.finance.transaction_type);
	  }
	
	  /**
	   * currencyCode
	   *
	   * @method faker.finance.currencyCode
	   */
	  self.currencyCode = function () {
	      return faker.random.objectElement(faker.definitions.finance.currency)['code'];
	  }
	
	  /**
	   * currencyName
	   *
	   * @method faker.finance.currencyName
	   */
	  self.currencyName = function () {
	      return faker.random.objectElement(faker.definitions.finance.currency, 'key');
	  }
	
	  /**
	   * currencySymbol
	   *
	   * @method faker.finance.currencySymbol
	   */
	  self.currencySymbol = function () {
	      var symbol;
	
	      while (!symbol) {
	          symbol = faker.random.objectElement(faker.definitions.finance.currency)['symbol'];
	      }
	      return symbol;
	  }
	
	  /**
	   * bitcoinAddress
	   *
	   * @method  faker.finance.bitcoinAddress
	   */
	  self.bitcoinAddress = function () {
	    var addressLength = faker.random.number({ min: 27, max: 34 });
	
	    var address = faker.random.arrayElement(['1', '3']);
	
	    for (var i = 0; i < addressLength - 1; i++)
	      address += faker.random.alphaNumeric().toUpperCase();
	
	    return address;
	  }
	}
	
	module['exports'] = Finance;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.hacker
	 */
	var Hacker = function (faker) {
	  var self = this;
	  
	  /**
	   * abbreviation
	   *
	   * @method faker.hacker.abbreviation
	   */
	  self.abbreviation = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.abbreviation);
	  };
	
	  /**
	   * adjective
	   *
	   * @method faker.hacker.adjective
	   */
	  self.adjective = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.adjective);
	  };
	
	  /**
	   * noun
	   *
	   * @method faker.hacker.noun
	   */
	  self.noun = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.noun);
	  };
	
	  /**
	   * verb
	   *
	   * @method faker.hacker.verb
	   */
	  self.verb = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.verb);
	  };
	
	  /**
	   * ingverb
	   *
	   * @method faker.hacker.ingverb
	   */
	  self.ingverb = function () {
	    return faker.random.arrayElement(faker.definitions.hacker.ingverb);
	  };
	
	  /**
	   * phrase
	   *
	   * @method faker.hacker.phrase
	   */
	  self.phrase = function () {
	
	    var data = {
	      abbreviation: self.abbreviation,
	      adjective: self.adjective,
	      ingverb: self.ingverb,
	      noun: self.noun,
	      verb: self.verb
	    };
	
	    var phrase = faker.random.arrayElement([ "If we {{verb}} the {{noun}}, we can get to the {{abbreviation}} {{noun}} through the {{adjective}} {{abbreviation}} {{noun}}!",
	      "We need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "Try to {{verb}} the {{abbreviation}} {{noun}}, maybe it will {{verb}} the {{adjective}} {{noun}}!",
	      "You can't {{verb}} the {{noun}} without {{ingverb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "Use the {{adjective}} {{abbreviation}} {{noun}}, then you can {{verb}} the {{adjective}} {{noun}}!",
	      "The {{abbreviation}} {{noun}} is down, {{verb}} the {{adjective}} {{noun}} so we can {{verb}} the {{abbreviation}} {{noun}}!",
	      "{{ingverb}} the {{noun}} won't do anything, we need to {{verb}} the {{adjective}} {{abbreviation}} {{noun}}!",
	      "I'll {{verb}} the {{adjective}} {{abbreviation}} {{noun}}, that should {{noun}} the {{abbreviation}} {{noun}}!"
	   ]);
	
	   return faker.helpers.mustache(phrase, data);
	
	  };
	  
	  return self;
	};
	
	module['exports'] = Hacker;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.helpers
	 */
	var Helpers = function (faker) {
	
	  var self = this;
	
	  /**
	   * backword-compatibility
	   *
	   * @method faker.helpers.randomize
	   * @param {array} array
	   */
	  self.randomize = function (array) {
	      array = array || ["a", "b", "c"];
	      return faker.random.arrayElement(array);
	  };
	
	  /**
	   * slugifies string
	   *
	   * @method faker.helpers.slugify
	   * @param {string} string
	   */
	  self.slugify = function (string) {
	      string = string || "";
	      return string.replace(/ /g, '-').replace(/[^\w\.\-]+/g, '');
	  };
	
	  /**
	   * parses string for a symbol and replace it with a random number from 1-10
	   *
	   * @method faker.helpers.replaceSymbolWithNumber
	   * @param {string} string
	   * @param {string} symbol defaults to `"#"`
	   */
	  self.replaceSymbolWithNumber = function (string, symbol) {
	      string = string || "";
	      // default symbol is '#'
	      if (symbol === undefined) {
	          symbol = '#';
	      }
	
	      var str = '';
	      for (var i = 0; i < string.length; i++) {
	          if (string.charAt(i) == symbol) {
	              str += faker.random.number(9);
	          } else {
	              str += string.charAt(i);
	          }
	      }
	      return str;
	  };
	
	  /**
	   * parses string for symbols (numbers or letters) and replaces them appropriately
	   *
	   * @method faker.helpers.replaceSymbols
	   * @param {string} string
	   */
	  self.replaceSymbols = function (string) {
	      string = string || "";
	  	var alpha = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
	      var str = '';
	
	      for (var i = 0; i < string.length; i++) {
	          if (string.charAt(i) == "#") {
	              str += faker.random.number(9);
	  		} else if (string.charAt(i) == "?") {
	  			str += faker.random.arrayElement(alpha);
	          } else {
	              str += string.charAt(i);
	          }
	      }
	      return str;
	  };
	
	  /**
	   * takes an array and returns it randomized
	   *
	   * @method faker.helpers.shuffle
	   * @param {array} o
	   */
	  self.shuffle = function (o) {
	      o = o || ["a", "b", "c"];
	      for (var j, x, i = o.length-1; i; j = faker.random.number(i), x = o[--i], o[i] = o[j], o[j] = x);
	      return o;
	  };
	
	  /**
	   * mustache
	   *
	   * @method faker.helpers.mustache
	   * @param {string} str
	   * @param {object} data
	   */
	  self.mustache = function (str, data) {
	    if (typeof str === 'undefined') {
	      return '';
	    }
	    for(var p in data) {
	      var re = new RegExp('{{' + p + '}}', 'g')
	      str = str.replace(re, data[p]);
	    }
	    return str;
	  };
	
	  /**
	   * createCard
	   *
	   * @method faker.helpers.createCard
	   */
	  self.createCard = function () {
	      return {
	          "name": faker.name.findName(),
	          "username": faker.internet.userName(),
	          "email": faker.internet.email(),
	          "address": {
	              "streetA": faker.address.streetName(),
	              "streetB": faker.address.streetAddress(),
	              "streetC": faker.address.streetAddress(true),
	              "streetD": faker.address.secondaryAddress(),
	              "city": faker.address.city(),
	              "state": faker.address.state(),
	              "country": faker.address.country(),
	              "zipcode": faker.address.zipCode(),
	              "geo": {
	                  "lat": faker.address.latitude(),
	                  "lng": faker.address.longitude()
	              }
	          },
	          "phone": faker.phone.phoneNumber(),
	          "website": faker.internet.domainName(),
	          "company": {
	              "name": faker.company.companyName(),
	              "catchPhrase": faker.company.catchPhrase(),
	              "bs": faker.company.bs()
	          },
	          "posts": [
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              },
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              },
	              {
	                  "words": faker.lorem.words(),
	                  "sentence": faker.lorem.sentence(),
	                  "sentences": faker.lorem.sentences(),
	                  "paragraph": faker.lorem.paragraph()
	              }
	          ],
	          "accountHistory": [faker.helpers.createTransaction(), faker.helpers.createTransaction(), faker.helpers.createTransaction()]
	      };
	  };
	
	  /**
	   * contextualCard
	   *
	   * @method faker.helpers.contextualCard
	   */
	  self.contextualCard = function () {
	    var name = faker.name.firstName(),
	        userName = faker.internet.userName(name);
	    return {
	        "name": name,
	        "username": userName,
	        "avatar": faker.internet.avatar(),
	        "email": faker.internet.email(userName),
	        "dob": faker.date.past(50, new Date("Sat Sep 20 1992 21:35:02 GMT+0200 (CEST)")),
	        "phone": faker.phone.phoneNumber(),
	        "address": {
	            "street": faker.address.streetName(true),
	            "suite": faker.address.secondaryAddress(),
	            "city": faker.address.city(),
	            "zipcode": faker.address.zipCode(),
	            "geo": {
	                "lat": faker.address.latitude(),
	                "lng": faker.address.longitude()
	            }
	        },
	        "website": faker.internet.domainName(),
	        "company": {
	            "name": faker.company.companyName(),
	            "catchPhrase": faker.company.catchPhrase(),
	            "bs": faker.company.bs()
	        }
	    };
	  };
	
	
	  /**
	   * userCard
	   *
	   * @method faker.helpers.userCard
	   */
	  self.userCard = function () {
	      return {
	          "name": faker.name.findName(),
	          "username": faker.internet.userName(),
	          "email": faker.internet.email(),
	          "address": {
	              "street": faker.address.streetName(true),
	              "suite": faker.address.secondaryAddress(),
	              "city": faker.address.city(),
	              "zipcode": faker.address.zipCode(),
	              "geo": {
	                  "lat": faker.address.latitude(),
	                  "lng": faker.address.longitude()
	              }
	          },
	          "phone": faker.phone.phoneNumber(),
	          "website": faker.internet.domainName(),
	          "company": {
	              "name": faker.company.companyName(),
	              "catchPhrase": faker.company.catchPhrase(),
	              "bs": faker.company.bs()
	          }
	      };
	  };
	
	  /**
	   * createTransaction
	   *
	   * @method faker.helpers.createTransaction
	   */
	  self.createTransaction = function(){
	    return {
	      "amount" : faker.finance.amount(),
	      "date" : new Date(2012, 1, 2),  //TODO: add a ranged date method
	      "business": faker.company.companyName(),
	      "name": [faker.finance.accountName(), faker.finance.mask()].join(' '),
	      "type" : self.randomize(faker.definitions.finance.transaction_type),
	      "account" : faker.finance.account()
	    };
	  };
	
	  return self;
	
	};
	
	
	/*
	String.prototype.capitalize = function () { //v1.0
	    return this.replace(/\w+/g, function (a) {
	        return a.charAt(0).toUpperCase() + a.substr(1).toLowerCase();
	    });
	};
	*/
	
	module['exports'] = Helpers;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.image
	 */
	var Image = function (faker) {
	
	  var self = this;
	
	  /**
	   * image
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.image
	   */
	  self.image = function (width, height, randomize) {
	    var categories = ["abstract", "animals", "business", "cats", "city", "food", "nightlife", "fashion", "people", "nature", "sports", "technics", "transport"];
	    return self[faker.random.arrayElement(categories)](width, height, randomize);
	  };
	  /**
	   * avatar
	   *
	   * @method faker.image.avatar
	   */
	  self.avatar = function () {
	    return faker.internet.avatar();
	  };
	  /**
	   * imageUrl
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {string} category
	   * @param {boolean} randomize
	   * @method faker.image.imageUrl
	   */
	  self.imageUrl = function (width, height, category, randomize) {
	      var width = width || 640;
	      var height = height || 480;
	
	      var url ='http://lorempixel.com/' + width + '/' + height;
	      if (typeof category !== 'undefined') {
	        url += '/' + category;
	      }
	
	      if (randomize) {
	        url += '?' + faker.random.number()
	      }
	
	      return url;
	  };
	  /**
	   * abstract
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.abstract
	   */
	  self.abstract = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'abstract', randomize);
	  };
	  /**
	   * animals
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.animals
	   */
	  self.animals = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'animals', randomize);
	  };
	  /**
	   * business
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.business
	   */
	  self.business = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'business', randomize);
	  };
	  /**
	   * cats
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.cats
	   */
	  self.cats = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'cats', randomize);
	  };
	  /**
	   * city
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.city
	   */
	  self.city = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'city', randomize);
	  };
	  /**
	   * food
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.food
	   */
	  self.food = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'food', randomize);
	  };
	  /**
	   * nightlife
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.nightlife
	   */
	  self.nightlife = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'nightlife', randomize);
	  };
	  /**
	   * fashion
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.fashion
	   */
	  self.fashion = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'fashion', randomize);
	  };
	  /**
	   * people
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.people
	   */
	  self.people = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'people', randomize);
	  };
	  /**
	   * nature
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.nature
	   */
	  self.nature = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'nature', randomize);
	  };
	  /**
	   * sports
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.sports
	   */
	  self.sports = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'sports', randomize);
	  };
	  /**
	   * technics
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.technics
	   */
	  self.technics = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'technics', randomize);
	  };
	  /**
	   * transport
	   *
	   * @param {number} width
	   * @param {number} height
	   * @param {boolean} randomize
	   * @method faker.image.transport
	   */
	  self.transport = function (width, height, randomize) {
	    return faker.image.imageUrl(width, height, 'transport', randomize);
	  }  
	}
	
	module["exports"] = Image;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	
	   this index.js file is used for including the faker library as a CommonJS module, instead of a bundle
	
	   you can include the faker library into your existing node.js application by requiring the entire /faker directory
	
	    var faker = require(./faker);
	    var randomName = faker.name.findName();
	
	   you can also simply include the "faker.js" file which is the auto-generated bundled version of the faker library
	
	    var faker = require(./customAppPath/faker);
	    var randomName = faker.name.findName();
	
	
	  if you plan on modifying the faker library you should be performing your changes in the /lib/ directory
	
	*/
	
	/**
	 *
	 * @namespace faker
	 */
	function Faker (opts) {
	
	  var self = this;
	
	  opts = opts || {};
	
	  // assign options
	  var locales = self.locales || opts.locales || {};
	  var locale = self.locale || opts.locale || "en";
	  var localeFallback = self.localeFallback || opts.localeFallback || "en";
	
	  self.locales = locales;
	  self.locale = locale;
	  self.localeFallback = localeFallback;
	
	  self.definitions = {};
	
	  var Fake = __webpack_require__(1933);
	  self.fake = new Fake(self).fake;
	
	  var Random = __webpack_require__(436);
	  self.random = new Random(self);
	  // self.random = require('./random');
	
	  var Helpers = __webpack_require__(1936);
	  self.helpers = new Helpers(self);
	
	  var Name = __webpack_require__(2882);
	  self.name = new Name(self);
	  // self.name = require('./name');
	
	  var Address = __webpack_require__(1929);
	  self.address = new Address(self);
	
	  var Company = __webpack_require__(1931);
	  self.company = new Company(self);
	
	  var Finance = __webpack_require__(1934);
	  self.finance = new Finance(self);
	
	  var Image = __webpack_require__(1937);
	  self.image = new Image(self);
	
	  var Lorem = __webpack_require__(2881);
	  self.lorem = new Lorem(self);
	
	  var Hacker = __webpack_require__(1935);
	  self.hacker = new Hacker(self);
	
	  var Internet = __webpack_require__(1939);
	  self.internet = new Internet(self);
	
	  var Phone = __webpack_require__(2883);
	  self.phone = new Phone(self);
	
	  var _Date = __webpack_require__(1932);
	  self.date = new _Date(self);
	
	  var Commerce = __webpack_require__(1930);
	  self.commerce = new Commerce(self);
	
	  var System = __webpack_require__(2884);
	  self.system = new System(self);
	
	  var _definitions = {
	    "name": ["first_name", "last_name", "prefix", "suffix", "title", "male_first_name", "female_first_name", "male_middle_name", "female_middle_name", "male_last_name", "female_last_name"],
	    "address": ["city_prefix", "city_suffix", "street_suffix", "county", "country", "country_code", "state", "state_abbr", "street_prefix", "postcode"],
	    "company": ["adjective", "noun", "descriptor", "bs_adjective", "bs_noun", "bs_verb", "suffix"],
	    "lorem": ["words"],
	    "hacker": ["abbreviation", "adjective", "noun", "verb", "ingverb"],
	    "phone_number": ["formats"],
	    "finance": ["account_type", "transaction_type", "currency"],
	    "internet": ["avatar_uri", "domain_suffix", "free_email", "example_email", "password"],
	    "commerce": ["color", "department", "product_name", "price", "categories"],
	    "system": ["mimeTypes"],
	    "date": ["month", "weekday"],
	    "title": "",
	    "separator": ""
	  };
	
	  // Create a Getter for all definitions.foo.bar propetries
	  Object.keys(_definitions).forEach(function(d){
	    if (typeof self.definitions[d] === "undefined") {
	      self.definitions[d] = {};
	    }
	
	    if (typeof _definitions[d] === "string") {
	        self.definitions[d] = _definitions[d];
	      return;
	    }
	
	    _definitions[d].forEach(function(p){
	      Object.defineProperty(self.definitions[d], p, {
	        get: function () {
	          if (typeof self.locales[self.locale][d] === "undefined" || typeof self.locales[self.locale][d][p] === "undefined") {
	            // certain localization sets contain less data then others.
	            // in the case of a missing defintion, use the default localeFallback to substitute the missing set data
	            // throw new Error('unknown property ' + d + p)
	            return self.locales[localeFallback][d][p];
	          } else {
	            // return localized data
	            return self.locales[self.locale][d][p];
	          }
	        }
	      });
	    });
	  });
	
	};
	
	Faker.prototype.seed = function(value) {
	  var Random = __webpack_require__(436);
	  this.seedValue = value;
	  this.random = new Random(this, this.seedValue);
	}
	module['exports'] = Faker;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var password_generator = __webpack_require__(2886),
	    random_ua = __webpack_require__(2887);
	
	/**
	 *
	 * @namespace faker.internet
	 */
	var Internet = function (faker) {
	  var self = this;
	  /**
	   * avatar
	   *
	   * @method faker.internet.avatar
	   */
	  self.avatar = function () {
	      return faker.random.arrayElement(faker.definitions.internet.avatar_uri);
	  };
	
	  self.avatar.schema = {
	    "description": "Generates a URL for an avatar.",
	    "sampleResults": ["https://s3.amazonaws.com/uifaces/faces/twitter/igorgarybaldi/128.jpg"]
	  };
	
	  /**
	   * email
	   *
	   * @method faker.internet.email
	   * @param {string} firstName
	   * @param {string} lastName
	   * @param {string} provider
	   */
	  self.email = function (firstName, lastName, provider) {
	      provider = provider || faker.random.arrayElement(faker.definitions.internet.free_email);
	      return  faker.helpers.slugify(faker.internet.userName(firstName, lastName)) + "@" + provider;
	  };
	
	  self.email.schema = {
	    "description": "Generates a valid email address based on optional input criteria",
	    "sampleResults": ["foo.bar@gmail.com"],
	    "properties": {
	      "firstName": {
	        "type": "string",
	        "required": false,
	        "description": "The first name of the user"
	      },
	      "lastName": {
	        "type": "string",
	        "required": false,
	        "description": "The last name of the user"
	      },
	      "provider": {
	        "type": "string",
	        "required": false,
	        "description": "The domain of the user"
	      }
	    }
	  };
	  /**
	   * exampleEmail
	   *
	   * @method faker.internet.exampleEmail
	   * @param {string} firstName
	   * @param {string} lastName
	   */
	  self.exampleEmail = function (firstName, lastName) {
	      var provider = faker.random.arrayElement(faker.definitions.internet.example_email);
	      return self.email(firstName, lastName, provider);
	  };
	
	  /**
	   * userName
	   *
	   * @method faker.internet.userName
	   * @param {string} firstName
	   * @param {string} lastName
	   */
	  self.userName = function (firstName, lastName) {
	      var result;
	      firstName = firstName || faker.name.firstName();
	      lastName = lastName || faker.name.lastName();
	      switch (faker.random.number(2)) {
	      case 0:
	          result = firstName + faker.random.number(99);
	          break;
	      case 1:
	          result = firstName + faker.random.arrayElement([".", "_"]) + lastName;
	          break;
	      case 2:
	          result = firstName + faker.random.arrayElement([".", "_"]) + lastName + faker.random.number(99);
	          break;
	      }
	      result = result.toString().replace(/'/g, "");
	      result = result.replace(/ /g, "");
	      return result;
	  };
	
	  self.userName.schema = {
	    "description": "Generates a username based on one of several patterns. The pattern is chosen randomly.",
	    "sampleResults": [
	      "Kirstin39",
	      "Kirstin.Smith",
	      "Kirstin.Smith39",
	      "KirstinSmith",
	      "KirstinSmith39",
	    ],
	    "properties": {
	      "firstName": {
	        "type": "string",
	        "required": false,
	        "description": "The first name of the user"
	      },
	      "lastName": {
	        "type": "string",
	        "required": false,
	        "description": "The last name of the user"
	      }
	    }
	  };
	
	  /**
	   * protocol
	   *
	   * @method faker.internet.protocol
	   */
	  self.protocol = function () {
	      var protocols = ['http','https'];
	      return faker.random.arrayElement(protocols);
	  };
	
	  self.protocol.schema = {
	    "description": "Randomly generates http or https",
	    "sampleResults": ["https", "http"]
	  };
	
	  /**
	   * url
	   *
	   * @method faker.internet.url
	   */
	  self.url = function () {
	      return faker.internet.protocol() + '://' + faker.internet.domainName();
	  };
	
	  self.url.schema = {
	    "description": "Generates a random URL. The URL could be secure or insecure.",
	    "sampleResults": [
	      "http://rashawn.name",
	      "https://rashawn.name"
	    ]
	  };
	
	  /**
	   * domainName
	   *
	   * @method faker.internet.domainName
	   */
	  self.domainName = function () {
	      return faker.internet.domainWord() + "." + faker.internet.domainSuffix();
	  };
	
	  self.domainName.schema = {
	    "description": "Generates a random domain name.",
	    "sampleResults": ["marvin.org"]
	  };
	
	  /**
	   * domainSuffix
	   *
	   * @method faker.internet.domainSuffix
	   */
	  self.domainSuffix = function () {
	      return faker.random.arrayElement(faker.definitions.internet.domain_suffix);
	  };
	
	  self.domainSuffix.schema = {
	    "description": "Generates a random domain suffix.",
	    "sampleResults": ["net"]
	  };
	
	  /**
	   * domainWord
	   *
	   * @method faker.internet.domainWord
	   */
	  self.domainWord = function () {
	      return faker.name.firstName().replace(/([\\~#&*{}/:<>?|\"'])/ig, '').toLowerCase();
	  };
	
	  self.domainWord.schema = {
	    "description": "Generates a random domain word.",
	    "sampleResults": ["alyce"]
	  };
	
	  /**
	   * ip
	   *
	   * @method faker.internet.ip
	   */
	  self.ip = function () {
	      var randNum = function () {
	          return (faker.random.number(255)).toFixed(0);
	      };
	
	      var result = [];
	      for (var i = 0; i < 4; i++) {
	          result[i] = randNum();
	      }
	
	      return result.join(".");
	  };
	
	  self.ip.schema = {
	    "description": "Generates a random IP.",
	    "sampleResults": ["97.238.241.11"]
	  };
	
	  /**
	   * userAgent
	   *
	   * @method faker.internet.userAgent
	   */
	  self.userAgent = function () {
	    return random_ua.generate();
	  };
	
	  self.userAgent.schema = {
	    "description": "Generates a random user agent.",
	    "sampleResults": ["Mozilla/5.0 (Macintosh; U; PPC Mac OS X 10_7_5 rv:6.0; SL) AppleWebKit/532.0.1 (KHTML, like Gecko) Version/7.1.6 Safari/532.0.1"]
	  };
	
	  /**
	   * color
	   *
	   * @method faker.internet.color
	   * @param {number} baseRed255
	   * @param {number} baseGreen255
	   * @param {number} baseBlue255
	   */
	  self.color = function (baseRed255, baseGreen255, baseBlue255) {
	      baseRed255 = baseRed255 || 0;
	      baseGreen255 = baseGreen255 || 0;
	      baseBlue255 = baseBlue255 || 0;
	      // based on awesome response : http://stackoverflow.com/questions/43044/algorithm-to-randomly-generate-an-aesthetically-pleasing-color-palette
	      var red = Math.floor((faker.random.number(256) + baseRed255) / 2);
	      var green = Math.floor((faker.random.number(256) + baseGreen255) / 2);
	      var blue = Math.floor((faker.random.number(256) + baseBlue255) / 2);
	      var redStr = red.toString(16);
	      var greenStr = green.toString(16);
	      var blueStr = blue.toString(16);
	      return '#' +
	        (redStr.length === 1 ? '0' : '') + redStr +
	        (greenStr.length === 1 ? '0' : '') + greenStr +
	        (blueStr.length === 1 ? '0': '') + blueStr;
	
	  };
	
	  self.color.schema = {
	    "description": "Generates a random hexadecimal color.",
	    "sampleResults": ["#06267f"],
	    "properties": {
	      "baseRed255": {
	        "type": "number",
	        "required": false,
	        "description": "The red value. Valid values are 0 - 255."
	      },
	      "baseGreen255": {
	        "type": "number",
	        "required": false,
	        "description": "The green value. Valid values are 0 - 255."
	      },
	      "baseBlue255": {
	        "type": "number",
	        "required": false,
	        "description": "The blue value. Valid values are 0 - 255."
	      }
	    }
	  };
	
	  /**
	   * mac
	   *
	   * @method faker.internet.mac
	   */
	  self.mac = function(){
	      var i, mac = "";
	      for (i=0; i < 12; i++) {
	          mac+= faker.random.number(15).toString(16);
	          if (i%2==1 && i != 11) {
	              mac+=":";
	          }
	      }
	      return mac;
	  };
	
	  self.mac.schema = {
	    "description": "Generates a random mac address.",
	    "sampleResults": ["78:06:cc:ae:b3:81"]
	  };
	
	  /**
	   * password
	   *
	   * @method faker.internet.password
	   * @param {number} len
	   * @param {boolean} memorable
	   * @param {string} pattern
	   * @param {string} prefix
	   */
	  self.password = function (len, memorable, pattern, prefix) {
	    len = len || 15;
	    if (typeof memorable === "undefined") {
	      memorable = false;
	    }
	    return password_generator(len, memorable, pattern, prefix);
	  }
	
	  self.password.schema = {
	    "description": "Generates a random password.",
	    "sampleResults": [
	      "AM7zl6Mg",
	      "susejofe"
	    ],
	    "properties": {
	      "length": {
	        "type": "number",
	        "required": false,
	        "description": "The number of characters in the password."
	      },
	      "memorable": {
	        "type": "boolean",
	        "required": false,
	        "description": "Whether a password should be easy to remember."
	      },
	      "pattern": {
	        "type": "regex",
	        "required": false,
	        "description": "A regex to match each character of the password against. This parameter will be negated if the memorable setting is turned on."
	      },
	      "prefix": {
	        "type": "string",
	        "required": false,
	        "description": "A value to prepend to the generated password. The prefix counts towards the length of the password."
	      }
	    }
	  };
	
	};
	
	
	module["exports"] = Internet;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	exports['de'] = __webpack_require__(1961);
	exports['de_AT'] = __webpack_require__(1994);
	exports['de_CH'] = __webpack_require__(2013);
	exports['en'] = __webpack_require__(2088);
	exports['en_AU'] = __webpack_require__(2120);
	exports['en_BORK'] = __webpack_require__(2128);
	exports['en_CA'] = __webpack_require__(2136);
	exports['en_GB'] = __webpack_require__(2149);
	exports['en_IE'] = __webpack_require__(2159);
	exports['en_IND'] = __webpack_require__(2171);
	exports['en_US'] = __webpack_require__(2183);
	exports['en_au_ocker'] = __webpack_require__(2203);
	exports['es'] = __webpack_require__(2235);
	exports['es_MX'] = __webpack_require__(2279);
	exports['fa'] = __webpack_require__(2298);
	exports['fr'] = __webpack_require__(2324);
	exports['fr_CA'] = __webpack_require__(2344);
	exports['ge'] = __webpack_require__(2370);
	exports['id_ID'] = __webpack_require__(2399);
	exports['it'] = __webpack_require__(2436);
	exports['ja'] = __webpack_require__(2458);
	exports['ko'] = __webpack_require__(2479);
	exports['nb_NO'] = __webpack_require__(2509);
	exports['nep'] = __webpack_require__(2529);
	exports['nl'] = __webpack_require__(2553);
	exports['pl'] = __webpack_require__(2593);
	exports['pt_BR'] = __webpack_require__(2622);
	exports['ru'] = __webpack_require__(2659);
	exports['sk'] = __webpack_require__(2699);
	exports['sv'] = __webpack_require__(2746);
	exports['tr'] = __webpack_require__(2772);
	exports['uk'] = __webpack_require__(2805);
	exports['vi'] = __webpack_require__(2832);
	exports['zh_CN'] = __webpack_require__(2855);
	exports['zh_TW'] = __webpack_require__(2874);


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nord",
	  "Ost",
	  "West",
	  "Süd",
	  "Neu",
	  "Alt",
	  "Bad"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "stadt",
	  "dorf",
	  "land",
	  "scheid",
	  "burg"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ägypten",
	  "Äquatorialguinea",
	  "Äthiopien",
	  "Österreich",
	  "Afghanistan",
	  "Albanien",
	  "Algerien",
	  "Amerikanisch-Samoa",
	  "Amerikanische Jungferninseln",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarktis",
	  "Antigua und Barbuda",
	  "Argentinien",
	  "Armenien",
	  "Aruba",
	  "Aserbaidschan",
	  "Australien",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesch",
	  "Barbados",
	  "Belarus",
	  "Belgien",
	  "Belize",
	  "Benin",
	  "die Bermudas",
	  "Bhutan",
	  "Bolivien",
	  "Bosnien und Herzegowina",
	  "Botsuana",
	  "Bouvetinsel",
	  "Brasilien",
	  "Britische Jungferninseln",
	  "Britisches Territorium im Indischen Ozean",
	  "Brunei Darussalam",
	  "Bulgarien",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "China",
	  "Cookinseln",
	  "Costa Rica",
	  "Dänemark",
	  "Demokratische Republik Kongo",
	  "Demokratische Volksrepublik Korea",
	  "Deutschland",
	  "Dominica",
	  "Dominikanische Republik",
	  "Dschibuti",
	  "Ecuador",
	  "El Salvador",
	  "Eritrea",
	  "Estland",
	  "Färöer",
	  "Falklandinseln",
	  "Fidschi",
	  "Finnland",
	  "Frankreich",
	  "Französisch-Guayana",
	  "Französisch-Polynesien",
	  "Französische Gebiete im südlichen Indischen Ozean",
	  "Gabun",
	  "Gambia",
	  "Georgien",
	  "Ghana",
	  "Gibraltar",
	  "Grönland",
	  "Grenada",
	  "Griechenland",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard und McDonaldinseln",
	  "Honduras",
	  "Hongkong",
	  "Indien",
	  "Indonesien",
	  "Irak",
	  "Iran",
	  "Irland",
	  "Island",
	  "Israel",
	  "Italien",
	  "Jamaika",
	  "Japan",
	  "Jemen",
	  "Jordanien",
	  "Jugoslawien",
	  "Kaimaninseln",
	  "Kambodscha",
	  "Kamerun",
	  "Kanada",
	  "Kap Verde",
	  "Kasachstan",
	  "Katar",
	  "Kenia",
	  "Kirgisistan",
	  "Kiribati",
	  "Kleinere amerikanische Überseeinseln",
	  "Kokosinseln",
	  "Kolumbien",
	  "Komoren",
	  "Kongo",
	  "Kroatien",
	  "Kuba",
	  "Kuwait",
	  "Laos",
	  "Lesotho",
	  "Lettland",
	  "Libanon",
	  "Liberia",
	  "Libyen",
	  "Liechtenstein",
	  "Litauen",
	  "Luxemburg",
	  "Macau",
	  "Madagaskar",
	  "Malawi",
	  "Malaysia",
	  "Malediven",
	  "Mali",
	  "Malta",
	  "ehemalige jugoslawische Republik Mazedonien",
	  "Marokko",
	  "Marshallinseln",
	  "Martinique",
	  "Mauretanien",
	  "Mauritius",
	  "Mayotte",
	  "Mexiko",
	  "Mikronesien",
	  "Monaco",
	  "Mongolei",
	  "Montserrat",
	  "Mosambik",
	  "Myanmar",
	  "Nördliche Marianen",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Neukaledonien",
	  "Neuseeland",
	  "Nicaragua",
	  "Niederländische Antillen",
	  "Niederlande",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolkinsel",
	  "Norwegen",
	  "Oman",
	  "Osttimor",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Neuguinea",
	  "Paraguay",
	  "Peru",
	  "Philippinen",
	  "Pitcairninseln",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Réunion",
	  "Republik Korea",
	  "Republik Moldau",
	  "Ruanda",
	  "Rumänien",
	  "Russische Föderation",
	  "São Tomé und Príncipe",
	  "Südafrika",
	  "Südgeorgien und Südliche Sandwichinseln",
	  "Salomonen",
	  "Sambia",
	  "Samoa",
	  "San Marino",
	  "Saudi-Arabien",
	  "Schweden",
	  "Schweiz",
	  "Senegal",
	  "Seychellen",
	  "Sierra Leone",
	  "Simbabwe",
	  "Singapur",
	  "Slowakei",
	  "Slowenien",
	  "Somalien",
	  "Spanien",
	  "Sri Lanka",
	  "St. Helena",
	  "St. Kitts und Nevis",
	  "St. Lucia",
	  "St. Pierre und Miquelon",
	  "St. Vincent und die Grenadinen",
	  "Sudan",
	  "Surinam",
	  "Svalbard und Jan Mayen",
	  "Swasiland",
	  "Syrien",
	  "Türkei",
	  "Tadschikistan",
	  "Taiwan",
	  "Tansania",
	  "Thailand",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad und Tobago",
	  "Tschad",
	  "Tschechische Republik",
	  "Tunesien",
	  "Turkmenistan",
	  "Turks- und Caicosinseln",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "Ungarn",
	  "Uruguay",
	  "Usbekistan",
	  "Vanuatu",
	  "Vatikanstadt",
	  "Venezuela",
	  "Vereinigte Arabische Emirate",
	  "Vereinigte Staaten",
	  "Vereinigtes Königreich",
	  "Vietnam",
	  "Wallis und Futuna",
	  "Weihnachtsinsel",
	  "Westsahara",
	  "Zentralafrikanische Republik",
	  "Zypern"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Deutschland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(1943);
	address.city_suffix = __webpack_require__(1944);
	address.country = __webpack_require__(1945);
	address.street_root = __webpack_require__(1954);
	address.building_number = __webpack_require__(1941);
	address.secondary_address = __webpack_require__(1949);
	address.postcode = __webpack_require__(1948);
	address.state = __webpack_require__(1950);
	address.state_abbr = __webpack_require__(1951);
	address.city = __webpack_require__(1942);
	address.street_name = __webpack_require__(1953);
	address.street_address = __webpack_require__(1952);
	address.default_country = __webpack_require__(1946);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Zimmer ###",
	  "# OG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Baden-Württemberg",
	  "Bayern",
	  "Berlin",
	  "Brandenburg",
	  "Bremen",
	  "Hamburg",
	  "Hessen",
	  "Mecklenburg-Vorpommern",
	  "Niedersachsen",
	  "Nordrhein-Westfalen",
	  "Rheinland-Pfalz",
	  "Saarland",
	  "Sachsen",
	  "Sachsen-Anhalt",
	  "Schleswig-Holstein",
	  "Thüringen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "BW",
	  "BY",
	  "BE",
	  "BB",
	  "HB",
	  "HH",
	  "HE",
	  "MV",
	  "NI",
	  "NW",
	  "RP",
	  "SL",
	  "SN",
	  "ST",
	  "SH",
	  "TH"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ackerweg",
	  "Adalbert-Stifter-Str.",
	  "Adalbertstr.",
	  "Adolf-Baeyer-Str.",
	  "Adolf-Kaschny-Str.",
	  "Adolf-Reichwein-Str.",
	  "Adolfsstr.",
	  "Ahornweg",
	  "Ahrstr.",
	  "Akazienweg",
	  "Albert-Einstein-Str.",
	  "Albert-Schweitzer-Str.",
	  "Albertus-Magnus-Str.",
	  "Albert-Zarthe-Weg",
	  "Albin-Edelmann-Str.",
	  "Albrecht-Haushofer-Str.",
	  "Aldegundisstr.",
	  "Alexanderstr.",
	  "Alfred-Delp-Str.",
	  "Alfred-Kubin-Str.",
	  "Alfred-Stock-Str.",
	  "Alkenrather Str.",
	  "Allensteiner Str.",
	  "Alsenstr.",
	  "Alt Steinbücheler Weg",
	  "Alte Garten",
	  "Alte Heide",
	  "Alte Landstr.",
	  "Alte Ziegelei",
	  "Altenberger Str.",
	  "Altenhof",
	  "Alter Grenzweg",
	  "Altstadtstr.",
	  "Am Alten Gaswerk",
	  "Am Alten Schafstall",
	  "Am Arenzberg",
	  "Am Benthal",
	  "Am Birkenberg",
	  "Am Blauen Berg",
	  "Am Borsberg",
	  "Am Brungen",
	  "Am Büchelter Hof",
	  "Am Buttermarkt",
	  "Am Ehrenfriedhof",
	  "Am Eselsdamm",
	  "Am Falkenberg",
	  "Am Frankenberg",
	  "Am Gesundheitspark",
	  "Am Gierlichshof",
	  "Am Graben",
	  "Am Hagelkreuz",
	  "Am Hang",
	  "Am Heidkamp",
	  "Am Hemmelrather Hof",
	  "Am Hofacker",
	  "Am Hohen Ufer",
	  "Am Höllers Eck",
	  "Am Hühnerberg",
	  "Am Jägerhof",
	  "Am Junkernkamp",
	  "Am Kemperstiegel",
	  "Am Kettnersbusch",
	  "Am Kiesberg",
	  "Am Klösterchen",
	  "Am Knechtsgraben",
	  "Am Köllerweg",
	  "Am Köttersbach",
	  "Am Kreispark",
	  "Am Kronefeld",
	  "Am Küchenhof",
	  "Am Kühnsbusch",
	  "Am Lindenfeld",
	  "Am Märchen",
	  "Am Mittelberg",
	  "Am Mönchshof",
	  "Am Mühlenbach",
	  "Am Neuenhof",
	  "Am Nonnenbruch",
	  "Am Plattenbusch",
	  "Am Quettinger Feld",
	  "Am Rosenhügel",
	  "Am Sandberg",
	  "Am Scherfenbrand",
	  "Am Schokker",
	  "Am Silbersee",
	  "Am Sonnenhang",
	  "Am Sportplatz",
	  "Am Stadtpark",
	  "Am Steinberg",
	  "Am Telegraf",
	  "Am Thelenhof",
	  "Am Vogelkreuz",
	  "Am Vogelsang",
	  "Am Vogelsfeldchen",
	  "Am Wambacher Hof",
	  "Am Wasserturm",
	  "Am Weidenbusch",
	  "Am Weiher",
	  "Am Weingarten",
	  "Am Werth",
	  "Amselweg",
	  "An den Irlen",
	  "An den Rheinauen",
	  "An der Bergerweide",
	  "An der Dingbank",
	  "An der Evangelischen Kirche",
	  "An der Evgl. Kirche",
	  "An der Feldgasse",
	  "An der Fettehenne",
	  "An der Kante",
	  "An der Laach",
	  "An der Lehmkuhle",
	  "An der Lichtenburg",
	  "An der Luisenburg",
	  "An der Robertsburg",
	  "An der Schmitten",
	  "An der Schusterinsel",
	  "An der Steinrütsch",
	  "An St. Andreas",
	  "An St. Remigius",
	  "Andreasstr.",
	  "Ankerweg",
	  "Annette-Kolb-Str.",
	  "Apenrader Str.",
	  "Arnold-Ohletz-Str.",
	  "Atzlenbacher Str.",
	  "Auerweg",
	  "Auestr.",
	  "Auf dem Acker",
	  "Auf dem Blahnenhof",
	  "Auf dem Bohnbüchel",
	  "Auf dem Bruch",
	  "Auf dem End",
	  "Auf dem Forst",
	  "Auf dem Herberg",
	  "Auf dem Lehn",
	  "Auf dem Stein",
	  "Auf dem Weierberg",
	  "Auf dem Weiherhahn",
	  "Auf den Reien",
	  "Auf der Donnen",
	  "Auf der Grieße",
	  "Auf der Ohmer",
	  "Auf der Weide",
	  "Auf'm Berg",
	  "Auf'm Kamp",
	  "Augustastr.",
	  "August-Kekulé-Str.",
	  "A.-W.-v.-Hofmann-Str.",
	  "Bahnallee",
	  "Bahnhofstr.",
	  "Baltrumstr.",
	  "Bamberger Str.",
	  "Baumberger Str.",
	  "Bebelstr.",
	  "Beckers Kämpchen",
	  "Beerenstr.",
	  "Beethovenstr.",
	  "Behringstr.",
	  "Bendenweg",
	  "Bensberger Str.",
	  "Benzstr.",
	  "Bergische Landstr.",
	  "Bergstr.",
	  "Berliner Platz",
	  "Berliner Str.",
	  "Bernhard-Letterhaus-Str.",
	  "Bernhard-Lichtenberg-Str.",
	  "Bernhard-Ridder-Str.",
	  "Bernsteinstr.",
	  "Bertha-Middelhauve-Str.",
	  "Bertha-von-Suttner-Str.",
	  "Bertolt-Brecht-Str.",
	  "Berzeliusstr.",
	  "Bielertstr.",
	  "Biesenbach",
	  "Billrothstr.",
	  "Birkenbergstr.",
	  "Birkengartenstr.",
	  "Birkenweg",
	  "Bismarckstr.",
	  "Bitterfelder Str.",
	  "Blankenburg",
	  "Blaukehlchenweg",
	  "Blütenstr.",
	  "Boberstr.",
	  "Böcklerstr.",
	  "Bodelschwinghstr.",
	  "Bodestr.",
	  "Bogenstr.",
	  "Bohnenkampsweg",
	  "Bohofsweg",
	  "Bonifatiusstr.",
	  "Bonner Str.",
	  "Borkumstr.",
	  "Bornheimer Str.",
	  "Borsigstr.",
	  "Borussiastr.",
	  "Bracknellstr.",
	  "Brahmsweg",
	  "Brandenburger Str.",
	  "Breidenbachstr.",
	  "Breslauer Str.",
	  "Bruchhauser Str.",
	  "Brückenstr.",
	  "Brucknerstr.",
	  "Brüder-Bonhoeffer-Str.",
	  "Buchenweg",
	  "Bürgerbuschweg",
	  "Burgloch",
	  "Burgplatz",
	  "Burgstr.",
	  "Burgweg",
	  "Bürriger Weg",
	  "Burscheider Str.",
	  "Buschkämpchen",
	  "Butterheider Str.",
	  "Carl-Duisberg-Platz",
	  "Carl-Duisberg-Str.",
	  "Carl-Leverkus-Str.",
	  "Carl-Maria-von-Weber-Platz",
	  "Carl-Maria-von-Weber-Str.",
	  "Carlo-Mierendorff-Str.",
	  "Carl-Rumpff-Str.",
	  "Carl-von-Ossietzky-Str.",
	  "Charlottenburger Str.",
	  "Christian-Heß-Str.",
	  "Claasbruch",
	  "Clemens-Winkler-Str.",
	  "Concordiastr.",
	  "Cranachstr.",
	  "Dahlemer Str.",
	  "Daimlerstr.",
	  "Damaschkestr.",
	  "Danziger Str.",
	  "Debengasse",
	  "Dechant-Fein-Str.",
	  "Dechant-Krey-Str.",
	  "Deichtorstr.",
	  "Dhünnberg",
	  "Dhünnstr.",
	  "Dianastr.",
	  "Diedenhofener Str.",
	  "Diepental",
	  "Diepenthaler Str.",
	  "Dieselstr.",
	  "Dillinger Str.",
	  "Distelkamp",
	  "Dohrgasse",
	  "Domblick",
	  "Dönhoffstr.",
	  "Dornierstr.",
	  "Drachenfelsstr.",
	  "Dr.-August-Blank-Str.",
	  "Dresdener Str.",
	  "Driescher Hecke",
	  "Drosselweg",
	  "Dudweilerstr.",
	  "Dünenweg",
	  "Dünfelder Str.",
	  "Dünnwalder Grenzweg",
	  "Düppeler Str.",
	  "Dürerstr.",
	  "Dürscheider Weg",
	  "Düsseldorfer Str.",
	  "Edelrather Weg",
	  "Edmund-Husserl-Str.",
	  "Eduard-Spranger-Str.",
	  "Ehrlichstr.",
	  "Eichenkamp",
	  "Eichenweg",
	  "Eidechsenweg",
	  "Eifelstr.",
	  "Eifgenstr.",
	  "Eintrachtstr.",
	  "Elbestr.",
	  "Elisabeth-Langgässer-Str.",
	  "Elisabethstr.",
	  "Elisabeth-von-Thadden-Str.",
	  "Elisenstr.",
	  "Elsa-Brändström-Str.",
	  "Elsbachstr.",
	  "Else-Lasker-Schüler-Str.",
	  "Elsterstr.",
	  "Emil-Fischer-Str.",
	  "Emil-Nolde-Str.",
	  "Engelbertstr.",
	  "Engstenberger Weg",
	  "Entenpfuhl",
	  "Erbelegasse",
	  "Erftstr.",
	  "Erfurter Str.",
	  "Erich-Heckel-Str.",
	  "Erich-Klausener-Str.",
	  "Erich-Ollenhauer-Str.",
	  "Erlenweg",
	  "Ernst-Bloch-Str.",
	  "Ernst-Ludwig-Kirchner-Str.",
	  "Erzbergerstr.",
	  "Eschenallee",
	  "Eschenweg",
	  "Esmarchstr.",
	  "Espenweg",
	  "Euckenstr.",
	  "Eulengasse",
	  "Eulenkamp",
	  "Ewald-Flamme-Str.",
	  "Ewald-Röll-Str.",
	  "Fährstr.",
	  "Farnweg",
	  "Fasanenweg",
	  "Faßbacher Hof",
	  "Felderstr.",
	  "Feldkampstr.",
	  "Feldsiefer Weg",
	  "Feldsiefer Wiesen",
	  "Feldstr.",
	  "Feldtorstr.",
	  "Felix-von-Roll-Str.",
	  "Ferdinand-Lassalle-Str.",
	  "Fester Weg",
	  "Feuerbachstr.",
	  "Feuerdornweg",
	  "Fichtenweg",
	  "Fichtestr.",
	  "Finkelsteinstr.",
	  "Finkenweg",
	  "Fixheider Str.",
	  "Flabbenhäuschen",
	  "Flensburger Str.",
	  "Fliederweg",
	  "Florastr.",
	  "Florianweg",
	  "Flotowstr.",
	  "Flurstr.",
	  "Föhrenweg",
	  "Fontanestr.",
	  "Forellental",
	  "Fortunastr.",
	  "Franz-Esser-Str.",
	  "Franz-Hitze-Str.",
	  "Franz-Kail-Str.",
	  "Franz-Marc-Str.",
	  "Freiburger Str.",
	  "Freiheitstr.",
	  "Freiherr-vom-Stein-Str.",
	  "Freudenthal",
	  "Freudenthaler Weg",
	  "Fridtjof-Nansen-Str.",
	  "Friedenberger Str.",
	  "Friedensstr.",
	  "Friedhofstr.",
	  "Friedlandstr.",
	  "Friedlieb-Ferdinand-Runge-Str.",
	  "Friedrich-Bayer-Str.",
	  "Friedrich-Bergius-Platz",
	  "Friedrich-Ebert-Platz",
	  "Friedrich-Ebert-Str.",
	  "Friedrich-Engels-Str.",
	  "Friedrich-List-Str.",
	  "Friedrich-Naumann-Str.",
	  "Friedrich-Sertürner-Str.",
	  "Friedrichstr.",
	  "Friedrich-Weskott-Str.",
	  "Friesenweg",
	  "Frischenberg",
	  "Fritz-Erler-Str.",
	  "Fritz-Henseler-Str.",
	  "Fröbelstr.",
	  "Fürstenbergplatz",
	  "Fürstenbergstr.",
	  "Gabriele-Münter-Str.",
	  "Gartenstr.",
	  "Gebhardstr.",
	  "Geibelstr.",
	  "Gellertstr.",
	  "Georg-von-Vollmar-Str.",
	  "Gerhard-Domagk-Str.",
	  "Gerhart-Hauptmann-Str.",
	  "Gerichtsstr.",
	  "Geschwister-Scholl-Str.",
	  "Gezelinallee",
	  "Gierener Weg",
	  "Ginsterweg",
	  "Gisbert-Cremer-Str.",
	  "Glücksburger Str.",
	  "Gluckstr.",
	  "Gneisenaustr.",
	  "Goetheplatz",
	  "Goethestr.",
	  "Golo-Mann-Str.",
	  "Görlitzer Str.",
	  "Görresstr.",
	  "Graebestr.",
	  "Graf-Galen-Platz",
	  "Gregor-Mendel-Str.",
	  "Greifswalder Str.",
	  "Grillenweg",
	  "Gronenborner Weg",
	  "Große Kirchstr.",
	  "Grunder Wiesen",
	  "Grundermühle",
	  "Grundermühlenhof",
	  "Grundermühlenweg",
	  "Grüner Weg",
	  "Grunewaldstr.",
	  "Grünstr.",
	  "Günther-Weisenborn-Str.",
	  "Gustav-Freytag-Str.",
	  "Gustav-Heinemann-Str.",
	  "Gustav-Radbruch-Str.",
	  "Gut Reuschenberg",
	  "Gutenbergstr.",
	  "Haberstr.",
	  "Habichtgasse",
	  "Hafenstr.",
	  "Hagenauer Str.",
	  "Hahnenblecher",
	  "Halenseestr.",
	  "Halfenleimbach",
	  "Hallesche Str.",
	  "Halligstr.",
	  "Hamberger Str.",
	  "Hammerweg",
	  "Händelstr.",
	  "Hannah-Höch-Str.",
	  "Hans-Arp-Str.",
	  "Hans-Gerhard-Str.",
	  "Hans-Sachs-Str.",
	  "Hans-Schlehahn-Str.",
	  "Hans-von-Dohnanyi-Str.",
	  "Hardenbergstr.",
	  "Haselweg",
	  "Hauptstr.",
	  "Haus-Vorster-Str.",
	  "Hauweg",
	  "Havelstr.",
	  "Havensteinstr.",
	  "Haydnstr.",
	  "Hebbelstr.",
	  "Heckenweg",
	  "Heerweg",
	  "Hegelstr.",
	  "Heidberg",
	  "Heidehöhe",
	  "Heidestr.",
	  "Heimstättenweg",
	  "Heinrich-Böll-Str.",
	  "Heinrich-Brüning-Str.",
	  "Heinrich-Claes-Str.",
	  "Heinrich-Heine-Str.",
	  "Heinrich-Hörlein-Str.",
	  "Heinrich-Lübke-Str.",
	  "Heinrich-Lützenkirchen-Weg",
	  "Heinrichstr.",
	  "Heinrich-Strerath-Str.",
	  "Heinrich-von-Kleist-Str.",
	  "Heinrich-von-Stephan-Str.",
	  "Heisterbachstr.",
	  "Helenenstr.",
	  "Helmestr.",
	  "Hemmelrather Weg",
	  "Henry-T.-v.-Böttinger-Str.",
	  "Herderstr.",
	  "Heribertstr.",
	  "Hermann-Ehlers-Str.",
	  "Hermann-Hesse-Str.",
	  "Hermann-König-Str.",
	  "Hermann-Löns-Str.",
	  "Hermann-Milde-Str.",
	  "Hermann-Nörrenberg-Str.",
	  "Hermann-von-Helmholtz-Str.",
	  "Hermann-Waibel-Str.",
	  "Herzogstr.",
	  "Heymannstr.",
	  "Hindenburgstr.",
	  "Hirzenberg",
	  "Hitdorfer Kirchweg",
	  "Hitdorfer Str.",
	  "Höfer Mühle",
	  "Höfer Weg",
	  "Hohe Str.",
	  "Höhenstr.",
	  "Höltgestal",
	  "Holunderweg",
	  "Holzer Weg",
	  "Holzer Wiesen",
	  "Hornpottweg",
	  "Hubertusweg",
	  "Hufelandstr.",
	  "Hufer Weg",
	  "Humboldtstr.",
	  "Hummelsheim",
	  "Hummelweg",
	  "Humperdinckstr.",
	  "Hüscheider Gärten",
	  "Hüscheider Str.",
	  "Hütte",
	  "Ilmstr.",
	  "Im Bergischen Heim",
	  "Im Bruch",
	  "Im Buchenhain",
	  "Im Bühl",
	  "Im Burgfeld",
	  "Im Dorf",
	  "Im Eisholz",
	  "Im Friedenstal",
	  "Im Frohental",
	  "Im Grunde",
	  "Im Hederichsfeld",
	  "Im Jücherfeld",
	  "Im Kalkfeld",
	  "Im Kirberg",
	  "Im Kirchfeld",
	  "Im Kreuzbruch",
	  "Im Mühlenfeld",
	  "Im Nesselrader Kamp",
	  "Im Oberdorf",
	  "Im Oberfeld",
	  "Im Rosengarten",
	  "Im Rottland",
	  "Im Scheffengarten",
	  "Im Staderfeld",
	  "Im Steinfeld",
	  "Im Weidenblech",
	  "Im Winkel",
	  "Im Ziegelfeld",
	  "Imbach",
	  "Imbacher Weg",
	  "Immenweg",
	  "In den Blechenhöfen",
	  "In den Dehlen",
	  "In der Birkenau",
	  "In der Dasladen",
	  "In der Felderhütten",
	  "In der Hartmannswiese",
	  "In der Höhle",
	  "In der Schaafsdellen",
	  "In der Wasserkuhl",
	  "In der Wüste",
	  "In Holzhausen",
	  "Insterstr.",
	  "Jacob-Fröhlen-Str.",
	  "Jägerstr.",
	  "Jahnstr.",
	  "Jakob-Eulenberg-Weg",
	  "Jakobistr.",
	  "Jakob-Kaiser-Str.",
	  "Jenaer Str.",
	  "Johannes-Baptist-Str.",
	  "Johannes-Dott-Str.",
	  "Johannes-Popitz-Str.",
	  "Johannes-Wislicenus-Str.",
	  "Johannisburger Str.",
	  "Johann-Janssen-Str.",
	  "Johann-Wirtz-Weg",
	  "Josefstr.",
	  "Jüch",
	  "Julius-Doms-Str.",
	  "Julius-Leber-Str.",
	  "Kaiserplatz",
	  "Kaiserstr.",
	  "Kaiser-Wilhelm-Allee",
	  "Kalkstr.",
	  "Kämpchenstr.",
	  "Kämpenwiese",
	  "Kämper Weg",
	  "Kamptalweg",
	  "Kanalstr.",
	  "Kandinskystr.",
	  "Kantstr.",
	  "Kapellenstr.",
	  "Karl-Arnold-Str.",
	  "Karl-Bosch-Str.",
	  "Karl-Bückart-Str.",
	  "Karl-Carstens-Ring",
	  "Karl-Friedrich-Goerdeler-Str.",
	  "Karl-Jaspers-Str.",
	  "Karl-König-Str.",
	  "Karl-Krekeler-Str.",
	  "Karl-Marx-Str.",
	  "Karlstr.",
	  "Karl-Ulitzka-Str.",
	  "Karl-Wichmann-Str.",
	  "Karl-Wingchen-Str.",
	  "Käsenbrod",
	  "Käthe-Kollwitz-Str.",
	  "Katzbachstr.",
	  "Kerschensteinerstr.",
	  "Kiefernweg",
	  "Kieler Str.",
	  "Kieselstr.",
	  "Kiesweg",
	  "Kinderhausen",
	  "Kleiberweg",
	  "Kleine Kirchstr.",
	  "Kleingansweg",
	  "Kleinheider Weg",
	  "Klief",
	  "Kneippstr.",
	  "Knochenbergsweg",
	  "Kochergarten",
	  "Kocherstr.",
	  "Kockelsberg",
	  "Kolberger Str.",
	  "Kolmarer Str.",
	  "Kölner Gasse",
	  "Kölner Str.",
	  "Kolpingstr.",
	  "Königsberger Platz",
	  "Konrad-Adenauer-Platz",
	  "Köpenicker Str.",
	  "Kopernikusstr.",
	  "Körnerstr.",
	  "Köschenberg",
	  "Köttershof",
	  "Kreuzbroicher Str.",
	  "Kreuzkamp",
	  "Krummer Weg",
	  "Kruppstr.",
	  "Kuhlmannweg",
	  "Kump",
	  "Kumper Weg",
	  "Kunstfeldstr.",
	  "Küppersteger Str.",
	  "Kursiefen",
	  "Kursiefer Weg",
	  "Kurtekottenweg",
	  "Kurt-Schumacher-Ring",
	  "Kyllstr.",
	  "Langenfelder Str.",
	  "Längsleimbach",
	  "Lärchenweg",
	  "Legienstr.",
	  "Lehner Mühle",
	  "Leichlinger Str.",
	  "Leimbacher Hof",
	  "Leinestr.",
	  "Leineweberstr.",
	  "Leipziger Str.",
	  "Lerchengasse",
	  "Lessingstr.",
	  "Libellenweg",
	  "Lichstr.",
	  "Liebigstr.",
	  "Lindenstr.",
	  "Lingenfeld",
	  "Linienstr.",
	  "Lippe",
	  "Löchergraben",
	  "Löfflerstr.",
	  "Loheweg",
	  "Lohrbergstr.",
	  "Lohrstr.",
	  "Löhstr.",
	  "Lortzingstr.",
	  "Lötzener Str.",
	  "Löwenburgstr.",
	  "Lucasstr.",
	  "Ludwig-Erhard-Platz",
	  "Ludwig-Girtler-Str.",
	  "Ludwig-Knorr-Str.",
	  "Luisenstr.",
	  "Lupinenweg",
	  "Lurchenweg",
	  "Lützenkirchener Str.",
	  "Lycker Str.",
	  "Maashofstr.",
	  "Manforter Str.",
	  "Marc-Chagall-Str.",
	  "Maria-Dresen-Str.",
	  "Maria-Terwiel-Str.",
	  "Marie-Curie-Str.",
	  "Marienburger Str.",
	  "Mariendorfer Str.",
	  "Marienwerderstr.",
	  "Marie-Schlei-Str.",
	  "Marktplatz",
	  "Markusweg",
	  "Martin-Buber-Str.",
	  "Martin-Heidegger-Str.",
	  "Martin-Luther-Str.",
	  "Masurenstr.",
	  "Mathildenweg",
	  "Maurinusstr.",
	  "Mauspfad",
	  "Max-Beckmann-Str.",
	  "Max-Delbrück-Str.",
	  "Max-Ernst-Str.",
	  "Max-Holthausen-Platz",
	  "Max-Horkheimer-Str.",
	  "Max-Liebermann-Str.",
	  "Max-Pechstein-Str.",
	  "Max-Planck-Str.",
	  "Max-Scheler-Str.",
	  "Max-Schönenberg-Str.",
	  "Maybachstr.",
	  "Meckhofer Feld",
	  "Meisenweg",
	  "Memelstr.",
	  "Menchendahler Str.",
	  "Mendelssohnstr.",
	  "Merziger Str.",
	  "Mettlacher Str.",
	  "Metzer Str.",
	  "Michaelsweg",
	  "Miselohestr.",
	  "Mittelstr.",
	  "Mohlenstr.",
	  "Moltkestr.",
	  "Monheimer Str.",
	  "Montanusstr.",
	  "Montessoriweg",
	  "Moosweg",
	  "Morsbroicher Str.",
	  "Moselstr.",
	  "Moskauer Str.",
	  "Mozartstr.",
	  "Mühlenweg",
	  "Muhrgasse",
	  "Muldestr.",
	  "Mülhausener Str.",
	  "Mülheimer Str.",
	  "Münsters Gäßchen",
	  "Münzstr.",
	  "Müritzstr.",
	  "Myliusstr.",
	  "Nachtigallenweg",
	  "Nauener Str.",
	  "Neißestr.",
	  "Nelly-Sachs-Str.",
	  "Netzestr.",
	  "Neuendriesch",
	  "Neuenhausgasse",
	  "Neuenkamp",
	  "Neujudenhof",
	  "Neukronenberger Str.",
	  "Neustadtstr.",
	  "Nicolai-Hartmann-Str.",
	  "Niederblecher",
	  "Niederfeldstr.",
	  "Nietzschestr.",
	  "Nikolaus-Groß-Str.",
	  "Nobelstr.",
	  "Norderneystr.",
	  "Nordstr.",
	  "Ober dem Hof",
	  "Obere Lindenstr.",
	  "Obere Str.",
	  "Oberölbach",
	  "Odenthaler Str.",
	  "Oderstr.",
	  "Okerstr.",
	  "Olof-Palme-Str.",
	  "Ophovener Str.",
	  "Opladener Platz",
	  "Opladener Str.",
	  "Ortelsburger Str.",
	  "Oskar-Moll-Str.",
	  "Oskar-Schlemmer-Str.",
	  "Oststr.",
	  "Oswald-Spengler-Str.",
	  "Otto-Dix-Str.",
	  "Otto-Grimm-Str.",
	  "Otto-Hahn-Str.",
	  "Otto-Müller-Str.",
	  "Otto-Stange-Str.",
	  "Ottostr.",
	  "Otto-Varnhagen-Str.",
	  "Otto-Wels-Str.",
	  "Ottweilerstr.",
	  "Oulustr.",
	  "Overfeldweg",
	  "Pappelweg",
	  "Paracelsusstr.",
	  "Parkstr.",
	  "Pastor-Louis-Str.",
	  "Pastor-Scheibler-Str.",
	  "Pastorskamp",
	  "Paul-Klee-Str.",
	  "Paul-Löbe-Str.",
	  "Paulstr.",
	  "Peenestr.",
	  "Pescher Busch",
	  "Peschstr.",
	  "Pestalozzistr.",
	  "Peter-Grieß-Str.",
	  "Peter-Joseph-Lenné-Str.",
	  "Peter-Neuenheuser-Str.",
	  "Petersbergstr.",
	  "Peterstr.",
	  "Pfarrer-Jekel-Str.",
	  "Pfarrer-Klein-Str.",
	  "Pfarrer-Röhr-Str.",
	  "Pfeilshofstr.",
	  "Philipp-Ott-Str.",
	  "Piet-Mondrian-Str.",
	  "Platanenweg",
	  "Pommernstr.",
	  "Porschestr.",
	  "Poststr.",
	  "Potsdamer Str.",
	  "Pregelstr.",
	  "Prießnitzstr.",
	  "Pützdelle",
	  "Quarzstr.",
	  "Quettinger Str.",
	  "Rat-Deycks-Str.",
	  "Rathenaustr.",
	  "Ratherkämp",
	  "Ratiborer Str.",
	  "Raushofstr.",
	  "Regensburger Str.",
	  "Reinickendorfer Str.",
	  "Renkgasse",
	  "Rennbaumplatz",
	  "Rennbaumstr.",
	  "Reuschenberger Str.",
	  "Reusrather Str.",
	  "Reuterstr.",
	  "Rheinallee",
	  "Rheindorfer Str.",
	  "Rheinstr.",
	  "Rhein-Wupper-Platz",
	  "Richard-Wagner-Str.",
	  "Rilkestr.",
	  "Ringstr.",
	  "Robert-Blum-Str.",
	  "Robert-Koch-Str.",
	  "Robert-Medenwald-Str.",
	  "Rolandstr.",
	  "Romberg",
	  "Röntgenstr.",
	  "Roonstr.",
	  "Ropenstall",
	  "Ropenstaller Weg",
	  "Rosenthal",
	  "Rostocker Str.",
	  "Rotdornweg",
	  "Röttgerweg",
	  "Rückertstr.",
	  "Rudolf-Breitscheid-Str.",
	  "Rudolf-Mann-Platz",
	  "Rudolf-Stracke-Str.",
	  "Ruhlachplatz",
	  "Ruhlachstr.",
	  "Rüttersweg",
	  "Saalestr.",
	  "Saarbrücker Str.",
	  "Saarlauterner Str.",
	  "Saarstr.",
	  "Salamanderweg",
	  "Samlandstr.",
	  "Sanddornstr.",
	  "Sandstr.",
	  "Sauerbruchstr.",
	  "Schäfershütte",
	  "Scharnhorststr.",
	  "Scheffershof",
	  "Scheidemannstr.",
	  "Schellingstr.",
	  "Schenkendorfstr.",
	  "Schießbergstr.",
	  "Schillerstr.",
	  "Schlangenhecke",
	  "Schlebuscher Heide",
	  "Schlebuscher Str.",
	  "Schlebuschrath",
	  "Schlehdornstr.",
	  "Schleiermacherstr.",
	  "Schloßstr.",
	  "Schmalenbruch",
	  "Schnepfenflucht",
	  "Schöffenweg",
	  "Schöllerstr.",
	  "Schöne Aussicht",
	  "Schöneberger Str.",
	  "Schopenhauerstr.",
	  "Schubertplatz",
	  "Schubertstr.",
	  "Schulberg",
	  "Schulstr.",
	  "Schumannstr.",
	  "Schwalbenweg",
	  "Schwarzastr.",
	  "Sebastianusweg",
	  "Semmelweisstr.",
	  "Siebelplatz",
	  "Siemensstr.",
	  "Solinger Str.",
	  "Sonderburger Str.",
	  "Spandauer Str.",
	  "Speestr.",
	  "Sperberweg",
	  "Sperlingsweg",
	  "Spitzwegstr.",
	  "Sporrenberger Mühle",
	  "Spreestr.",
	  "St. Ingberter Str.",
	  "Starenweg",
	  "Stauffenbergstr.",
	  "Stefan-Zweig-Str.",
	  "Stegerwaldstr.",
	  "Steglitzer Str.",
	  "Steinbücheler Feld",
	  "Steinbücheler Str.",
	  "Steinstr.",
	  "Steinweg",
	  "Stephan-Lochner-Str.",
	  "Stephanusstr.",
	  "Stettiner Str.",
	  "Stixchesstr.",
	  "Stöckenstr.",
	  "Stralsunder Str.",
	  "Straßburger Str.",
	  "Stresemannplatz",
	  "Strombergstr.",
	  "Stromstr.",
	  "Stüttekofener Str.",
	  "Sudestr.",
	  "Sürderstr.",
	  "Syltstr.",
	  "Talstr.",
	  "Tannenbergstr.",
	  "Tannenweg",
	  "Taubenweg",
	  "Teitscheider Weg",
	  "Telegrafenstr.",
	  "Teltower Str.",
	  "Tempelhofer Str.",
	  "Theodor-Adorno-Str.",
	  "Theodor-Fliedner-Str.",
	  "Theodor-Gierath-Str.",
	  "Theodor-Haubach-Str.",
	  "Theodor-Heuss-Ring",
	  "Theodor-Storm-Str.",
	  "Theodorstr.",
	  "Thomas-Dehler-Str.",
	  "Thomas-Morus-Str.",
	  "Thomas-von-Aquin-Str.",
	  "Tönges Feld",
	  "Torstr.",
	  "Treptower Str.",
	  "Treuburger Str.",
	  "Uhlandstr.",
	  "Ulmenweg",
	  "Ulmer Str.",
	  "Ulrichstr.",
	  "Ulrich-von-Hassell-Str.",
	  "Umlag",
	  "Unstrutstr.",
	  "Unter dem Schildchen",
	  "Unterölbach",
	  "Unterstr.",
	  "Uppersberg",
	  "Van\\'t-Hoff-Str.",
	  "Veit-Stoß-Str.",
	  "Vereinsstr.",
	  "Viktor-Meyer-Str.",
	  "Vincent-van-Gogh-Str.",
	  "Virchowstr.",
	  "Voigtslach",
	  "Volhardstr.",
	  "Völklinger Str.",
	  "Von-Brentano-Str.",
	  "Von-Diergardt-Str.",
	  "Von-Eichendorff-Str.",
	  "Von-Ketteler-Str.",
	  "Von-Knoeringen-Str.",
	  "Von-Pettenkofer-Str.",
	  "Von-Siebold-Str.",
	  "Wacholderweg",
	  "Waldstr.",
	  "Walter-Flex-Str.",
	  "Walter-Hempel-Str.",
	  "Walter-Hochapfel-Str.",
	  "Walter-Nernst-Str.",
	  "Wannseestr.",
	  "Warnowstr.",
	  "Warthestr.",
	  "Weddigenstr.",
	  "Weichselstr.",
	  "Weidenstr.",
	  "Weidfeldstr.",
	  "Weiherfeld",
	  "Weiherstr.",
	  "Weinhäuser Str.",
	  "Weißdornweg",
	  "Weißenseestr.",
	  "Weizkamp",
	  "Werftstr.",
	  "Werkstättenstr.",
	  "Werner-Heisenberg-Str.",
	  "Werrastr.",
	  "Weyerweg",
	  "Widdauener Str.",
	  "Wiebertshof",
	  "Wiehbachtal",
	  "Wiembachallee",
	  "Wiesdorfer Platz",
	  "Wiesenstr.",
	  "Wilhelm-Busch-Str.",
	  "Wilhelm-Hastrich-Str.",
	  "Wilhelm-Leuschner-Str.",
	  "Wilhelm-Liebknecht-Str.",
	  "Wilhelmsgasse",
	  "Wilhelmstr.",
	  "Willi-Baumeister-Str.",
	  "Willy-Brandt-Ring",
	  "Winand-Rossi-Str.",
	  "Windthorststr.",
	  "Winkelweg",
	  "Winterberg",
	  "Wittenbergstr.",
	  "Wolf-Vostell-Str.",
	  "Wolkenburgstr.",
	  "Wupperstr.",
	  "Wuppertalstr.",
	  "Wüstenhof",
	  "Yitzhak-Rabin-Str.",
	  "Zauberkuhle",
	  "Zedernweg",
	  "Zehlendorfer Str.",
	  "Zehntenweg",
	  "Zeisigweg",
	  "Zeppelinstr.",
	  "Zschopaustr.",
	  "Zum Claashäuschen",
	  "Zündhütchenweg",
	  "Zur Alten Brauerei",
	  "Zur alten Fabrik"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+49-1##-#######",
	  "+49-1###-########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1955);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1960);
	company.legal_form = __webpack_require__(1958);
	company.name = __webpack_require__(1959);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de = {};
	module['exports'] = de;
	de.title = "German";
	de.address = __webpack_require__(1947);
	de.company = __webpack_require__(1957);
	de.internet = __webpack_require__(1964);
	de.lorem = __webpack_require__(1965);
	de.name = __webpack_require__(1968);
	de.phone_number = __webpack_require__(1974);
	de.cell_phone = __webpack_require__(1956);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "info",
	  "name",
	  "net",
	  "org",
	  "de",
	  "ch"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1963);
	internet.domain_suffix = __webpack_require__(1962);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(1966);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abdul",
	  "Abdullah",
	  "Adam",
	  "Adrian",
	  "Adriano",
	  "Ahmad",
	  "Ahmed",
	  "Ahmet",
	  "Alan",
	  "Albert",
	  "Alessandro",
	  "Alessio",
	  "Alex",
	  "Alexander",
	  "Alfred",
	  "Ali",
	  "Amar",
	  "Amir",
	  "Amon",
	  "Andre",
	  "Andreas",
	  "Andrew",
	  "Angelo",
	  "Ansgar",
	  "Anthony",
	  "Anton",
	  "Antonio",
	  "Arda",
	  "Arian",
	  "Armin",
	  "Arne",
	  "Arno",
	  "Arthur",
	  "Artur",
	  "Arved",
	  "Arvid",
	  "Ayman",
	  "Baran",
	  "Baris",
	  "Bastian",
	  "Batuhan",
	  "Bela",
	  "Ben",
	  "Benedikt",
	  "Benjamin",
	  "Bennet",
	  "Bennett",
	  "Benno",
	  "Bent",
	  "Berat",
	  "Berkay",
	  "Bernd",
	  "Bilal",
	  "Bjarne",
	  "Björn",
	  "Bo",
	  "Boris",
	  "Brandon",
	  "Brian",
	  "Bruno",
	  "Bryan",
	  "Burak",
	  "Calvin",
	  "Can",
	  "Carl",
	  "Carlo",
	  "Carlos",
	  "Caspar",
	  "Cedric",
	  "Cedrik",
	  "Cem",
	  "Charlie",
	  "Chris",
	  "Christian",
	  "Christiano",
	  "Christoph",
	  "Christopher",
	  "Claas",
	  "Clemens",
	  "Colin",
	  "Collin",
	  "Conner",
	  "Connor",
	  "Constantin",
	  "Corvin",
	  "Curt",
	  "Damian",
	  "Damien",
	  "Daniel",
	  "Danilo",
	  "Danny",
	  "Darian",
	  "Dario",
	  "Darius",
	  "Darren",
	  "David",
	  "Davide",
	  "Davin",
	  "Dean",
	  "Deniz",
	  "Dennis",
	  "Denny",
	  "Devin",
	  "Diego",
	  "Dion",
	  "Domenic",
	  "Domenik",
	  "Dominic",
	  "Dominik",
	  "Dorian",
	  "Dustin",
	  "Dylan",
	  "Ecrin",
	  "Eddi",
	  "Eddy",
	  "Edgar",
	  "Edwin",
	  "Efe",
	  "Ege",
	  "Elia",
	  "Eliah",
	  "Elias",
	  "Elijah",
	  "Emanuel",
	  "Emil",
	  "Emilian",
	  "Emilio",
	  "Emir",
	  "Emirhan",
	  "Emre",
	  "Enes",
	  "Enno",
	  "Enrico",
	  "Eren",
	  "Eric",
	  "Erik",
	  "Etienne",
	  "Fabian",
	  "Fabien",
	  "Fabio",
	  "Fabrice",
	  "Falk",
	  "Felix",
	  "Ferdinand",
	  "Fiete",
	  "Filip",
	  "Finlay",
	  "Finley",
	  "Finn",
	  "Finnley",
	  "Florian",
	  "Francesco",
	  "Franz",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Friedrich",
	  "Fritz",
	  "Furkan",
	  "Fynn",
	  "Gabriel",
	  "Georg",
	  "Gerrit",
	  "Gian",
	  "Gianluca",
	  "Gino",
	  "Giuliano",
	  "Giuseppe",
	  "Gregor",
	  "Gustav",
	  "Hagen",
	  "Hamza",
	  "Hannes",
	  "Hanno",
	  "Hans",
	  "Hasan",
	  "Hassan",
	  "Hauke",
	  "Hendrik",
	  "Hennes",
	  "Henning",
	  "Henri",
	  "Henrick",
	  "Henrik",
	  "Henry",
	  "Hugo",
	  "Hussein",
	  "Ian",
	  "Ibrahim",
	  "Ilias",
	  "Ilja",
	  "Ilyas",
	  "Immanuel",
	  "Ismael",
	  "Ismail",
	  "Ivan",
	  "Iven",
	  "Jack",
	  "Jacob",
	  "Jaden",
	  "Jakob",
	  "Jamal",
	  "James",
	  "Jamie",
	  "Jan",
	  "Janek",
	  "Janis",
	  "Janne",
	  "Jannek",
	  "Jannes",
	  "Jannik",
	  "Jannis",
	  "Jano",
	  "Janosch",
	  "Jared",
	  "Jari",
	  "Jarne",
	  "Jarno",
	  "Jaron",
	  "Jason",
	  "Jasper",
	  "Jay",
	  "Jayden",
	  "Jayson",
	  "Jean",
	  "Jens",
	  "Jeremias",
	  "Jeremie",
	  "Jeremy",
	  "Jermaine",
	  "Jerome",
	  "Jesper",
	  "Jesse",
	  "Jim",
	  "Jimmy",
	  "Joe",
	  "Joel",
	  "Joey",
	  "Johann",
	  "Johannes",
	  "John",
	  "Johnny",
	  "Jon",
	  "Jona",
	  "Jonah",
	  "Jonas",
	  "Jonathan",
	  "Jonte",
	  "Joost",
	  "Jordan",
	  "Joris",
	  "Joscha",
	  "Joschua",
	  "Josef",
	  "Joseph",
	  "Josh",
	  "Joshua",
	  "Josua",
	  "Juan",
	  "Julian",
	  "Julien",
	  "Julius",
	  "Juri",
	  "Justin",
	  "Justus",
	  "Kaan",
	  "Kai",
	  "Kalle",
	  "Karim",
	  "Karl",
	  "Karlo",
	  "Kay",
	  "Keanu",
	  "Kenan",
	  "Kenny",
	  "Keno",
	  "Kerem",
	  "Kerim",
	  "Kevin",
	  "Kian",
	  "Kilian",
	  "Kim",
	  "Kimi",
	  "Kjell",
	  "Klaas",
	  "Klemens",
	  "Konrad",
	  "Konstantin",
	  "Koray",
	  "Korbinian",
	  "Kurt",
	  "Lars",
	  "Lasse",
	  "Laurence",
	  "Laurens",
	  "Laurenz",
	  "Laurin",
	  "Lean",
	  "Leander",
	  "Leandro",
	  "Leif",
	  "Len",
	  "Lenn",
	  "Lennard",
	  "Lennart",
	  "Lennert",
	  "Lennie",
	  "Lennox",
	  "Lenny",
	  "Leo",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leonhard",
	  "Leonidas",
	  "Leopold",
	  "Leroy",
	  "Levent",
	  "Levi",
	  "Levin",
	  "Lewin",
	  "Lewis",
	  "Liam",
	  "Lian",
	  "Lias",
	  "Lino",
	  "Linus",
	  "Lio",
	  "Lion",
	  "Lionel",
	  "Logan",
	  "Lorenz",
	  "Lorenzo",
	  "Loris",
	  "Louis",
	  "Luan",
	  "Luc",
	  "Luca",
	  "Lucas",
	  "Lucian",
	  "Lucien",
	  "Ludwig",
	  "Luis",
	  "Luiz",
	  "Luk",
	  "Luka",
	  "Lukas",
	  "Luke",
	  "Lutz",
	  "Maddox",
	  "Mads",
	  "Magnus",
	  "Maik",
	  "Maksim",
	  "Malik",
	  "Malte",
	  "Manuel",
	  "Marc",
	  "Marcel",
	  "Marco",
	  "Marcus",
	  "Marek",
	  "Marian",
	  "Mario",
	  "Marius",
	  "Mark",
	  "Marko",
	  "Markus",
	  "Marlo",
	  "Marlon",
	  "Marten",
	  "Martin",
	  "Marvin",
	  "Marwin",
	  "Mateo",
	  "Mathis",
	  "Matis",
	  "Mats",
	  "Matteo",
	  "Mattes",
	  "Matthias",
	  "Matthis",
	  "Matti",
	  "Mattis",
	  "Maurice",
	  "Max",
	  "Maxim",
	  "Maximilian",
	  "Mehmet",
	  "Meik",
	  "Melvin",
	  "Merlin",
	  "Mert",
	  "Michael",
	  "Michel",
	  "Mick",
	  "Miguel",
	  "Mika",
	  "Mikail",
	  "Mike",
	  "Milan",
	  "Milo",
	  "Mio",
	  "Mirac",
	  "Mirco",
	  "Mirko",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moritz",
	  "Morten",
	  "Muhammed",
	  "Murat",
	  "Mustafa",
	  "Nathan",
	  "Nathanael",
	  "Nelson",
	  "Neo",
	  "Nevio",
	  "Nick",
	  "Niclas",
	  "Nico",
	  "Nicolai",
	  "Nicolas",
	  "Niels",
	  "Nikita",
	  "Niklas",
	  "Niko",
	  "Nikolai",
	  "Nikolas",
	  "Nils",
	  "Nino",
	  "Noah",
	  "Noel",
	  "Norman",
	  "Odin",
	  "Oke",
	  "Ole",
	  "Oliver",
	  "Omar",
	  "Onur",
	  "Oscar",
	  "Oskar",
	  "Pascal",
	  "Patrice",
	  "Patrick",
	  "Paul",
	  "Peer",
	  "Pepe",
	  "Peter",
	  "Phil",
	  "Philip",
	  "Philipp",
	  "Pierre",
	  "Piet",
	  "Pit",
	  "Pius",
	  "Quentin",
	  "Quirin",
	  "Rafael",
	  "Raik",
	  "Ramon",
	  "Raphael",
	  "Rasmus",
	  "Raul",
	  "Rayan",
	  "René",
	  "Ricardo",
	  "Riccardo",
	  "Richard",
	  "Rick",
	  "Rico",
	  "Robert",
	  "Robin",
	  "Rocco",
	  "Roman",
	  "Romeo",
	  "Ron",
	  "Ruben",
	  "Ryan",
	  "Said",
	  "Salih",
	  "Sam",
	  "Sami",
	  "Sammy",
	  "Samuel",
	  "Sandro",
	  "Santino",
	  "Sascha",
	  "Sean",
	  "Sebastian",
	  "Selim",
	  "Semih",
	  "Shawn",
	  "Silas",
	  "Simeon",
	  "Simon",
	  "Sinan",
	  "Sky",
	  "Stefan",
	  "Steffen",
	  "Stephan",
	  "Steve",
	  "Steven",
	  "Sven",
	  "Sönke",
	  "Sören",
	  "Taha",
	  "Tamino",
	  "Tammo",
	  "Tarik",
	  "Tayler",
	  "Taylor",
	  "Teo",
	  "Theo",
	  "Theodor",
	  "Thies",
	  "Thilo",
	  "Thomas",
	  "Thorben",
	  "Thore",
	  "Thorge",
	  "Tiago",
	  "Til",
	  "Till",
	  "Tillmann",
	  "Tim",
	  "Timm",
	  "Timo",
	  "Timon",
	  "Timothy",
	  "Tino",
	  "Titus",
	  "Tizian",
	  "Tjark",
	  "Tobias",
	  "Tom",
	  "Tommy",
	  "Toni",
	  "Tony",
	  "Torben",
	  "Tore",
	  "Tristan",
	  "Tyler",
	  "Tyron",
	  "Umut",
	  "Valentin",
	  "Valentino",
	  "Veit",
	  "Victor",
	  "Viktor",
	  "Vin",
	  "Vincent",
	  "Vito",
	  "Vitus",
	  "Wilhelm",
	  "Willi",
	  "William",
	  "Willy",
	  "Xaver",
	  "Yannic",
	  "Yannick",
	  "Yannik",
	  "Yannis",
	  "Yasin",
	  "Youssef",
	  "Yunus",
	  "Yusuf",
	  "Yven",
	  "Yves",
	  "Ömer",
	  "Aaliyah",
	  "Abby",
	  "Abigail",
	  "Ada",
	  "Adelina",
	  "Adriana",
	  "Aileen",
	  "Aimee",
	  "Alana",
	  "Alea",
	  "Alena",
	  "Alessa",
	  "Alessia",
	  "Alexa",
	  "Alexandra",
	  "Alexia",
	  "Alexis",
	  "Aleyna",
	  "Alia",
	  "Alica",
	  "Alice",
	  "Alicia",
	  "Alina",
	  "Alisa",
	  "Alisha",
	  "Alissa",
	  "Aliya",
	  "Aliyah",
	  "Allegra",
	  "Alma",
	  "Alyssa",
	  "Amalia",
	  "Amanda",
	  "Amelia",
	  "Amelie",
	  "Amina",
	  "Amira",
	  "Amy",
	  "Ana",
	  "Anabel",
	  "Anastasia",
	  "Andrea",
	  "Angela",
	  "Angelina",
	  "Angelique",
	  "Anja",
	  "Ann",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalena",
	  "Anne",
	  "Anneke",
	  "Annelie",
	  "Annemarie",
	  "Anni",
	  "Annie",
	  "Annika",
	  "Anny",
	  "Anouk",
	  "Antonia",
	  "Arda",
	  "Ariana",
	  "Ariane",
	  "Arwen",
	  "Ashley",
	  "Asya",
	  "Aurelia",
	  "Aurora",
	  "Ava",
	  "Ayleen",
	  "Aylin",
	  "Ayse",
	  "Azra",
	  "Betty",
	  "Bianca",
	  "Bianka",
	  "Caitlin",
	  "Cara",
	  "Carina",
	  "Carla",
	  "Carlotta",
	  "Carmen",
	  "Carolin",
	  "Carolina",
	  "Caroline",
	  "Cassandra",
	  "Catharina",
	  "Catrin",
	  "Cecile",
	  "Cecilia",
	  "Celia",
	  "Celina",
	  "Celine",
	  "Ceyda",
	  "Ceylin",
	  "Chantal",
	  "Charleen",
	  "Charlotta",
	  "Charlotte",
	  "Chayenne",
	  "Cheyenne",
	  "Chiara",
	  "Christin",
	  "Christina",
	  "Cindy",
	  "Claire",
	  "Clara",
	  "Clarissa",
	  "Colleen",
	  "Collien",
	  "Cora",
	  "Corinna",
	  "Cosima",
	  "Dana",
	  "Daniela",
	  "Daria",
	  "Darleen",
	  "Defne",
	  "Delia",
	  "Denise",
	  "Diana",
	  "Dilara",
	  "Dina",
	  "Dorothea",
	  "Ecrin",
	  "Eda",
	  "Eileen",
	  "Ela",
	  "Elaine",
	  "Elanur",
	  "Elea",
	  "Elena",
	  "Eleni",
	  "Eleonora",
	  "Eliana",
	  "Elif",
	  "Elina",
	  "Elisa",
	  "Elisabeth",
	  "Ella",
	  "Ellen",
	  "Elli",
	  "Elly",
	  "Elsa",
	  "Emelie",
	  "Emely",
	  "Emilia",
	  "Emilie",
	  "Emily",
	  "Emma",
	  "Emmely",
	  "Emmi",
	  "Emmy",
	  "Enie",
	  "Enna",
	  "Enya",
	  "Esma",
	  "Estelle",
	  "Esther",
	  "Eva",
	  "Evelin",
	  "Evelina",
	  "Eveline",
	  "Evelyn",
	  "Fabienne",
	  "Fatima",
	  "Fatma",
	  "Felicia",
	  "Felicitas",
	  "Felina",
	  "Femke",
	  "Fenja",
	  "Fine",
	  "Finia",
	  "Finja",
	  "Finnja",
	  "Fiona",
	  "Flora",
	  "Florentine",
	  "Francesca",
	  "Franka",
	  "Franziska",
	  "Frederike",
	  "Freya",
	  "Frida",
	  "Frieda",
	  "Friederike",
	  "Giada",
	  "Gina",
	  "Giulia",
	  "Giuliana",
	  "Greta",
	  "Hailey",
	  "Hana",
	  "Hanna",
	  "Hannah",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helin",
	  "Henriette",
	  "Henrike",
	  "Hermine",
	  "Ida",
	  "Ilayda",
	  "Imke",
	  "Ina",
	  "Ines",
	  "Inga",
	  "Inka",
	  "Irem",
	  "Isa",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Ivonne",
	  "Jacqueline",
	  "Jamie",
	  "Jamila",
	  "Jana",
	  "Jane",
	  "Janin",
	  "Janina",
	  "Janine",
	  "Janna",
	  "Janne",
	  "Jara",
	  "Jasmin",
	  "Jasmina",
	  "Jasmine",
	  "Jella",
	  "Jenna",
	  "Jennifer",
	  "Jenny",
	  "Jessica",
	  "Jessy",
	  "Jette",
	  "Jil",
	  "Jill",
	  "Joana",
	  "Joanna",
	  "Joelina",
	  "Joeline",
	  "Joelle",
	  "Johanna",
	  "Joleen",
	  "Jolie",
	  "Jolien",
	  "Jolin",
	  "Jolina",
	  "Joline",
	  "Jona",
	  "Jonah",
	  "Jonna",
	  "Josefin",
	  "Josefine",
	  "Josephin",
	  "Josephine",
	  "Josie",
	  "Josy",
	  "Joy",
	  "Joyce",
	  "Judith",
	  "Judy",
	  "Jule",
	  "Julia",
	  "Juliana",
	  "Juliane",
	  "Julie",
	  "Julienne",
	  "Julika",
	  "Julina",
	  "Juna",
	  "Justine",
	  "Kaja",
	  "Karina",
	  "Karla",
	  "Karlotta",
	  "Karolina",
	  "Karoline",
	  "Kassandra",
	  "Katarina",
	  "Katharina",
	  "Kathrin",
	  "Katja",
	  "Katrin",
	  "Kaya",
	  "Kayra",
	  "Kiana",
	  "Kiara",
	  "Kim",
	  "Kimberley",
	  "Kimberly",
	  "Kira",
	  "Klara",
	  "Korinna",
	  "Kristin",
	  "Kyra",
	  "Laila",
	  "Lana",
	  "Lara",
	  "Larissa",
	  "Laura",
	  "Laureen",
	  "Lavinia",
	  "Lea",
	  "Leah",
	  "Leana",
	  "Leandra",
	  "Leann",
	  "Lee",
	  "Leila",
	  "Lena",
	  "Lene",
	  "Leni",
	  "Lenia",
	  "Lenja",
	  "Lenya",
	  "Leona",
	  "Leoni",
	  "Leonie",
	  "Leonora",
	  "Leticia",
	  "Letizia",
	  "Levke",
	  "Leyla",
	  "Lia",
	  "Liah",
	  "Liana",
	  "Lili",
	  "Lilia",
	  "Lilian",
	  "Liliana",
	  "Lilith",
	  "Lilli",
	  "Lillian",
	  "Lilly",
	  "Lily",
	  "Lina",
	  "Linda",
	  "Lindsay",
	  "Line",
	  "Linn",
	  "Linnea",
	  "Lisa",
	  "Lisann",
	  "Lisanne",
	  "Liv",
	  "Livia",
	  "Liz",
	  "Lola",
	  "Loreen",
	  "Lorena",
	  "Lotta",
	  "Lotte",
	  "Louisa",
	  "Louise",
	  "Luana",
	  "Luca",
	  "Lucia",
	  "Lucie",
	  "Lucienne",
	  "Lucy",
	  "Luisa",
	  "Luise",
	  "Luka",
	  "Luna",
	  "Luzie",
	  "Lya",
	  "Lydia",
	  "Lyn",
	  "Lynn",
	  "Madeleine",
	  "Madita",
	  "Madleen",
	  "Madlen",
	  "Magdalena",
	  "Maike",
	  "Mailin",
	  "Maira",
	  "Maja",
	  "Malena",
	  "Malia",
	  "Malin",
	  "Malina",
	  "Mandy",
	  "Mara",
	  "Marah",
	  "Mareike",
	  "Maren",
	  "Maria",
	  "Mariam",
	  "Marie",
	  "Marieke",
	  "Mariella",
	  "Marika",
	  "Marina",
	  "Marisa",
	  "Marissa",
	  "Marit",
	  "Marla",
	  "Marleen",
	  "Marlen",
	  "Marlena",
	  "Marlene",
	  "Marta",
	  "Martha",
	  "Mary",
	  "Maryam",
	  "Mathilda",
	  "Mathilde",
	  "Matilda",
	  "Maxi",
	  "Maxima",
	  "Maxine",
	  "Maya",
	  "Mayra",
	  "Medina",
	  "Medine",
	  "Meike",
	  "Melanie",
	  "Melek",
	  "Melike",
	  "Melina",
	  "Melinda",
	  "Melis",
	  "Melisa",
	  "Melissa",
	  "Merle",
	  "Merve",
	  "Meryem",
	  "Mette",
	  "Mia",
	  "Michaela",
	  "Michelle",
	  "Mieke",
	  "Mila",
	  "Milana",
	  "Milena",
	  "Milla",
	  "Mina",
	  "Mira",
	  "Miray",
	  "Miriam",
	  "Mirja",
	  "Mona",
	  "Monique",
	  "Nadine",
	  "Nadja",
	  "Naemi",
	  "Nancy",
	  "Naomi",
	  "Natalia",
	  "Natalie",
	  "Nathalie",
	  "Neele",
	  "Nela",
	  "Nele",
	  "Nelli",
	  "Nelly",
	  "Nia",
	  "Nicole",
	  "Nika",
	  "Nike",
	  "Nikita",
	  "Nila",
	  "Nina",
	  "Nisa",
	  "Noemi",
	  "Nora",
	  "Olivia",
	  "Patricia",
	  "Patrizia",
	  "Paula",
	  "Paulina",
	  "Pauline",
	  "Penelope",
	  "Philine",
	  "Phoebe",
	  "Pia",
	  "Rahel",
	  "Rania",
	  "Rebecca",
	  "Rebekka",
	  "Riana",
	  "Rieke",
	  "Rike",
	  "Romina",
	  "Romy",
	  "Ronja",
	  "Rosa",
	  "Rosalie",
	  "Ruby",
	  "Sabrina",
	  "Sahra",
	  "Sally",
	  "Salome",
	  "Samantha",
	  "Samia",
	  "Samira",
	  "Sandra",
	  "Sandy",
	  "Sanja",
	  "Saphira",
	  "Sara",
	  "Sarah",
	  "Saskia",
	  "Selin",
	  "Selina",
	  "Selma",
	  "Sena",
	  "Sidney",
	  "Sienna",
	  "Silja",
	  "Sina",
	  "Sinja",
	  "Smilla",
	  "Sofia",
	  "Sofie",
	  "Sonja",
	  "Sophia",
	  "Sophie",
	  "Soraya",
	  "Stefanie",
	  "Stella",
	  "Stephanie",
	  "Stina",
	  "Sude",
	  "Summer",
	  "Susanne",
	  "Svea",
	  "Svenja",
	  "Sydney",
	  "Tabea",
	  "Talea",
	  "Talia",
	  "Tamara",
	  "Tamia",
	  "Tamina",
	  "Tanja",
	  "Tara",
	  "Tarja",
	  "Teresa",
	  "Tessa",
	  "Thalea",
	  "Thalia",
	  "Thea",
	  "Theresa",
	  "Tia",
	  "Tina",
	  "Tomke",
	  "Tuana",
	  "Valentina",
	  "Valeria",
	  "Valerie",
	  "Vanessa",
	  "Vera",
	  "Veronika",
	  "Victoria",
	  "Viktoria",
	  "Viola",
	  "Vivian",
	  "Vivien",
	  "Vivienne",
	  "Wibke",
	  "Wiebke",
	  "Xenia",
	  "Yara",
	  "Yaren",
	  "Yasmin",
	  "Ylvi",
	  "Ylvie",
	  "Yvonne",
	  "Zara",
	  "Zehra",
	  "Zeynep",
	  "Zoe",
	  "Zoey",
	  "Zoé"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1967);
	name.last_name = __webpack_require__(1969);
	name.prefix = __webpack_require__(1972);
	name.nobility_title_prefix = __webpack_require__(1971);
	name.name = __webpack_require__(1970);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abel",
	  "Abicht",
	  "Abraham",
	  "Abramovic",
	  "Abt",
	  "Achilles",
	  "Achkinadze",
	  "Ackermann",
	  "Adam",
	  "Adams",
	  "Ade",
	  "Agostini",
	  "Ahlke",
	  "Ahrenberg",
	  "Ahrens",
	  "Aigner",
	  "Albert",
	  "Albrecht",
	  "Alexa",
	  "Alexander",
	  "Alizadeh",
	  "Allgeyer",
	  "Amann",
	  "Amberg",
	  "Anding",
	  "Anggreny",
	  "Apitz",
	  "Arendt",
	  "Arens",
	  "Arndt",
	  "Aryee",
	  "Aschenbroich",
	  "Assmus",
	  "Astafei",
	  "Auer",
	  "Axmann",
	  "Baarck",
	  "Bachmann",
	  "Badane",
	  "Bader",
	  "Baganz",
	  "Bahl",
	  "Bak",
	  "Balcer",
	  "Balck",
	  "Balkow",
	  "Balnuweit",
	  "Balzer",
	  "Banse",
	  "Barr",
	  "Bartels",
	  "Barth",
	  "Barylla",
	  "Baseda",
	  "Battke",
	  "Bauer",
	  "Bauermeister",
	  "Baumann",
	  "Baumeister",
	  "Bauschinger",
	  "Bauschke",
	  "Bayer",
	  "Beavogui",
	  "Beck",
	  "Beckel",
	  "Becker",
	  "Beckmann",
	  "Bedewitz",
	  "Beele",
	  "Beer",
	  "Beggerow",
	  "Beh",
	  "Behr",
	  "Behrenbruch",
	  "Belz",
	  "Bender",
	  "Benecke",
	  "Benner",
	  "Benninger",
	  "Benzing",
	  "Berends",
	  "Berger",
	  "Berner",
	  "Berning",
	  "Bertenbreiter",
	  "Best",
	  "Bethke",
	  "Betz",
	  "Beushausen",
	  "Beutelspacher",
	  "Beyer",
	  "Biba",
	  "Bichler",
	  "Bickel",
	  "Biedermann",
	  "Bieler",
	  "Bielert",
	  "Bienasch",
	  "Bienias",
	  "Biesenbach",
	  "Bigdeli",
	  "Birkemeyer",
	  "Bittner",
	  "Blank",
	  "Blaschek",
	  "Blassneck",
	  "Bloch",
	  "Blochwitz",
	  "Blockhaus",
	  "Blum",
	  "Blume",
	  "Bock",
	  "Bode",
	  "Bogdashin",
	  "Bogenrieder",
	  "Bohge",
	  "Bolm",
	  "Borgschulze",
	  "Bork",
	  "Bormann",
	  "Bornscheuer",
	  "Borrmann",
	  "Borsch",
	  "Boruschewski",
	  "Bos",
	  "Bosler",
	  "Bourrouag",
	  "Bouschen",
	  "Boxhammer",
	  "Boyde",
	  "Bozsik",
	  "Brand",
	  "Brandenburg",
	  "Brandis",
	  "Brandt",
	  "Brauer",
	  "Braun",
	  "Brehmer",
	  "Breitenstein",
	  "Bremer",
	  "Bremser",
	  "Brenner",
	  "Brettschneider",
	  "Breu",
	  "Breuer",
	  "Briesenick",
	  "Bringmann",
	  "Brinkmann",
	  "Brix",
	  "Broening",
	  "Brosch",
	  "Bruckmann",
	  "Bruder",
	  "Bruhns",
	  "Brunner",
	  "Bruns",
	  "Bräutigam",
	  "Brömme",
	  "Brüggmann",
	  "Buchholz",
	  "Buchrucker",
	  "Buder",
	  "Bultmann",
	  "Bunjes",
	  "Burger",
	  "Burghagen",
	  "Burkhard",
	  "Burkhardt",
	  "Burmeister",
	  "Busch",
	  "Buschbaum",
	  "Busemann",
	  "Buss",
	  "Busse",
	  "Bussmann",
	  "Byrd",
	  "Bäcker",
	  "Böhm",
	  "Bönisch",
	  "Börgeling",
	  "Börner",
	  "Böttner",
	  "Büchele",
	  "Bühler",
	  "Büker",
	  "Büngener",
	  "Bürger",
	  "Bürklein",
	  "Büscher",
	  "Büttner",
	  "Camara",
	  "Carlowitz",
	  "Carlsohn",
	  "Caspari",
	  "Caspers",
	  "Chapron",
	  "Christ",
	  "Cierpinski",
	  "Clarius",
	  "Cleem",
	  "Cleve",
	  "Co",
	  "Conrad",
	  "Cordes",
	  "Cornelsen",
	  "Cors",
	  "Cotthardt",
	  "Crews",
	  "Cronjäger",
	  "Crosskofp",
	  "Da",
	  "Dahm",
	  "Dahmen",
	  "Daimer",
	  "Damaske",
	  "Danneberg",
	  "Danner",
	  "Daub",
	  "Daubner",
	  "Daudrich",
	  "Dauer",
	  "Daum",
	  "Dauth",
	  "Dautzenberg",
	  "De",
	  "Decker",
	  "Deckert",
	  "Deerberg",
	  "Dehmel",
	  "Deja",
	  "Delonge",
	  "Demut",
	  "Dengler",
	  "Denner",
	  "Denzinger",
	  "Derr",
	  "Dertmann",
	  "Dethloff",
	  "Deuschle",
	  "Dieckmann",
	  "Diedrich",
	  "Diekmann",
	  "Dienel",
	  "Dies",
	  "Dietrich",
	  "Dietz",
	  "Dietzsch",
	  "Diezel",
	  "Dilla",
	  "Dingelstedt",
	  "Dippl",
	  "Dittmann",
	  "Dittmar",
	  "Dittmer",
	  "Dix",
	  "Dobbrunz",
	  "Dobler",
	  "Dohring",
	  "Dolch",
	  "Dold",
	  "Dombrowski",
	  "Donie",
	  "Doskoczynski",
	  "Dragu",
	  "Drechsler",
	  "Drees",
	  "Dreher",
	  "Dreier",
	  "Dreissigacker",
	  "Dressler",
	  "Drews",
	  "Duma",
	  "Dutkiewicz",
	  "Dyett",
	  "Dylus",
	  "Dächert",
	  "Döbel",
	  "Döring",
	  "Dörner",
	  "Dörre",
	  "Dück",
	  "Eberhard",
	  "Eberhardt",
	  "Ecker",
	  "Eckhardt",
	  "Edorh",
	  "Effler",
	  "Eggenmueller",
	  "Ehm",
	  "Ehmann",
	  "Ehrig",
	  "Eich",
	  "Eichmann",
	  "Eifert",
	  "Einert",
	  "Eisenlauer",
	  "Ekpo",
	  "Elbe",
	  "Eleyth",
	  "Elss",
	  "Emert",
	  "Emmelmann",
	  "Ender",
	  "Engel",
	  "Engelen",
	  "Engelmann",
	  "Eplinius",
	  "Erdmann",
	  "Erhardt",
	  "Erlei",
	  "Erm",
	  "Ernst",
	  "Ertl",
	  "Erwes",
	  "Esenwein",
	  "Esser",
	  "Evers",
	  "Everts",
	  "Ewald",
	  "Fahner",
	  "Faller",
	  "Falter",
	  "Farber",
	  "Fassbender",
	  "Faulhaber",
	  "Fehrig",
	  "Feld",
	  "Felke",
	  "Feller",
	  "Fenner",
	  "Fenske",
	  "Feuerbach",
	  "Fietz",
	  "Figl",
	  "Figura",
	  "Filipowski",
	  "Filsinger",
	  "Fincke",
	  "Fink",
	  "Finke",
	  "Fischer",
	  "Fitschen",
	  "Fleischer",
	  "Fleischmann",
	  "Floder",
	  "Florczak",
	  "Flore",
	  "Flottmann",
	  "Forkel",
	  "Forst",
	  "Frahmeke",
	  "Frank",
	  "Franke",
	  "Franta",
	  "Frantz",
	  "Franz",
	  "Franzis",
	  "Franzmann",
	  "Frauen",
	  "Frauendorf",
	  "Freigang",
	  "Freimann",
	  "Freimuth",
	  "Freisen",
	  "Frenzel",
	  "Frey",
	  "Fricke",
	  "Fried",
	  "Friedek",
	  "Friedenberg",
	  "Friedmann",
	  "Friedrich",
	  "Friess",
	  "Frisch",
	  "Frohn",
	  "Frosch",
	  "Fuchs",
	  "Fuhlbrügge",
	  "Fusenig",
	  "Fust",
	  "Förster",
	  "Gaba",
	  "Gabius",
	  "Gabler",
	  "Gadschiew",
	  "Gakstädter",
	  "Galander",
	  "Gamlin",
	  "Gamper",
	  "Gangnus",
	  "Ganzmann",
	  "Garatva",
	  "Gast",
	  "Gastel",
	  "Gatzka",
	  "Gauder",
	  "Gebhardt",
	  "Geese",
	  "Gehre",
	  "Gehrig",
	  "Gehring",
	  "Gehrke",
	  "Geiger",
	  "Geisler",
	  "Geissler",
	  "Gelling",
	  "Gens",
	  "Gerbennow",
	  "Gerdel",
	  "Gerhardt",
	  "Gerschler",
	  "Gerson",
	  "Gesell",
	  "Geyer",
	  "Ghirmai",
	  "Ghosh",
	  "Giehl",
	  "Gierisch",
	  "Giesa",
	  "Giesche",
	  "Gilde",
	  "Glatting",
	  "Goebel",
	  "Goedicke",
	  "Goldbeck",
	  "Goldfuss",
	  "Goldkamp",
	  "Goldkühle",
	  "Goller",
	  "Golling",
	  "Gollnow",
	  "Golomski",
	  "Gombert",
	  "Gotthardt",
	  "Gottschalk",
	  "Gotz",
	  "Goy",
	  "Gradzki",
	  "Graf",
	  "Grams",
	  "Grasse",
	  "Gratzky",
	  "Grau",
	  "Greb",
	  "Green",
	  "Greger",
	  "Greithanner",
	  "Greschner",
	  "Griem",
	  "Griese",
	  "Grimm",
	  "Gromisch",
	  "Gross",
	  "Grosser",
	  "Grossheim",
	  "Grosskopf",
	  "Grothaus",
	  "Grothkopp",
	  "Grotke",
	  "Grube",
	  "Gruber",
	  "Grundmann",
	  "Gruning",
	  "Gruszecki",
	  "Gröss",
	  "Grötzinger",
	  "Grün",
	  "Grüner",
	  "Gummelt",
	  "Gunkel",
	  "Gunther",
	  "Gutjahr",
	  "Gutowicz",
	  "Gutschank",
	  "Göbel",
	  "Göckeritz",
	  "Göhler",
	  "Görlich",
	  "Görmer",
	  "Götz",
	  "Götzelmann",
	  "Güldemeister",
	  "Günther",
	  "Günz",
	  "Gürbig",
	  "Haack",
	  "Haaf",
	  "Habel",
	  "Hache",
	  "Hackbusch",
	  "Hackelbusch",
	  "Hadfield",
	  "Hadwich",
	  "Haferkamp",
	  "Hahn",
	  "Hajek",
	  "Hallmann",
	  "Hamann",
	  "Hanenberger",
	  "Hannecker",
	  "Hanniske",
	  "Hansen",
	  "Hardy",
	  "Hargasser",
	  "Harms",
	  "Harnapp",
	  "Harter",
	  "Harting",
	  "Hartlieb",
	  "Hartmann",
	  "Hartwig",
	  "Hartz",
	  "Haschke",
	  "Hasler",
	  "Hasse",
	  "Hassfeld",
	  "Haug",
	  "Hauke",
	  "Haupt",
	  "Haverney",
	  "Heberstreit",
	  "Hechler",
	  "Hecht",
	  "Heck",
	  "Hedermann",
	  "Hehl",
	  "Heidelmann",
	  "Heidler",
	  "Heinemann",
	  "Heinig",
	  "Heinke",
	  "Heinrich",
	  "Heinze",
	  "Heiser",
	  "Heist",
	  "Hellmann",
	  "Helm",
	  "Helmke",
	  "Helpling",
	  "Hengmith",
	  "Henkel",
	  "Hennes",
	  "Henry",
	  "Hense",
	  "Hensel",
	  "Hentel",
	  "Hentschel",
	  "Hentschke",
	  "Hepperle",
	  "Herberger",
	  "Herbrand",
	  "Hering",
	  "Hermann",
	  "Hermecke",
	  "Herms",
	  "Herold",
	  "Herrmann",
	  "Herschmann",
	  "Hertel",
	  "Herweg",
	  "Herwig",
	  "Herzenberg",
	  "Hess",
	  "Hesse",
	  "Hessek",
	  "Hessler",
	  "Hetzler",
	  "Heuck",
	  "Heydemüller",
	  "Hiebl",
	  "Hildebrand",
	  "Hildenbrand",
	  "Hilgendorf",
	  "Hillard",
	  "Hiller",
	  "Hingsen",
	  "Hingst",
	  "Hinrichs",
	  "Hirsch",
	  "Hirschberg",
	  "Hirt",
	  "Hodea",
	  "Hoffman",
	  "Hoffmann",
	  "Hofmann",
	  "Hohenberger",
	  "Hohl",
	  "Hohn",
	  "Hohnheiser",
	  "Hold",
	  "Holdt",
	  "Holinski",
	  "Holl",
	  "Holtfreter",
	  "Holz",
	  "Holzdeppe",
	  "Holzner",
	  "Hommel",
	  "Honz",
	  "Hooss",
	  "Hoppe",
	  "Horak",
	  "Horn",
	  "Horna",
	  "Hornung",
	  "Hort",
	  "Howard",
	  "Huber",
	  "Huckestein",
	  "Hudak",
	  "Huebel",
	  "Hugo",
	  "Huhn",
	  "Hujo",
	  "Huke",
	  "Huls",
	  "Humbert",
	  "Huneke",
	  "Huth",
	  "Häber",
	  "Häfner",
	  "Höcke",
	  "Höft",
	  "Höhne",
	  "Hönig",
	  "Hördt",
	  "Hübenbecker",
	  "Hübl",
	  "Hübner",
	  "Hügel",
	  "Hüttcher",
	  "Hütter",
	  "Ibe",
	  "Ihly",
	  "Illing",
	  "Isak",
	  "Isekenmeier",
	  "Itt",
	  "Jacob",
	  "Jacobs",
	  "Jagusch",
	  "Jahn",
	  "Jahnke",
	  "Jakobs",
	  "Jakubczyk",
	  "Jambor",
	  "Jamrozy",
	  "Jander",
	  "Janich",
	  "Janke",
	  "Jansen",
	  "Jarets",
	  "Jaros",
	  "Jasinski",
	  "Jasper",
	  "Jegorov",
	  "Jellinghaus",
	  "Jeorga",
	  "Jerschabek",
	  "Jess",
	  "John",
	  "Jonas",
	  "Jossa",
	  "Jucken",
	  "Jung",
	  "Jungbluth",
	  "Jungton",
	  "Just",
	  "Jürgens",
	  "Kaczmarek",
	  "Kaesmacher",
	  "Kahl",
	  "Kahlert",
	  "Kahles",
	  "Kahlmeyer",
	  "Kaiser",
	  "Kalinowski",
	  "Kallabis",
	  "Kallensee",
	  "Kampf",
	  "Kampschulte",
	  "Kappe",
	  "Kappler",
	  "Karhoff",
	  "Karrass",
	  "Karst",
	  "Karsten",
	  "Karus",
	  "Kass",
	  "Kasten",
	  "Kastner",
	  "Katzinski",
	  "Kaufmann",
	  "Kaul",
	  "Kausemann",
	  "Kawohl",
	  "Kazmarek",
	  "Kedzierski",
	  "Keil",
	  "Keiner",
	  "Keller",
	  "Kelm",
	  "Kempe",
	  "Kemper",
	  "Kempter",
	  "Kerl",
	  "Kern",
	  "Kesselring",
	  "Kesselschläger",
	  "Kette",
	  "Kettenis",
	  "Keutel",
	  "Kick",
	  "Kiessling",
	  "Kinadeter",
	  "Kinzel",
	  "Kinzy",
	  "Kirch",
	  "Kirst",
	  "Kisabaka",
	  "Klaas",
	  "Klabuhn",
	  "Klapper",
	  "Klauder",
	  "Klaus",
	  "Kleeberg",
	  "Kleiber",
	  "Klein",
	  "Kleinert",
	  "Kleininger",
	  "Kleinmann",
	  "Kleinsteuber",
	  "Kleiss",
	  "Klemme",
	  "Klimczak",
	  "Klinger",
	  "Klink",
	  "Klopsch",
	  "Klose",
	  "Kloss",
	  "Kluge",
	  "Kluwe",
	  "Knabe",
	  "Kneifel",
	  "Knetsch",
	  "Knies",
	  "Knippel",
	  "Knobel",
	  "Knoblich",
	  "Knoll",
	  "Knorr",
	  "Knorscheidt",
	  "Knut",
	  "Kobs",
	  "Koch",
	  "Kochan",
	  "Kock",
	  "Koczulla",
	  "Koderisch",
	  "Koehl",
	  "Koehler",
	  "Koenig",
	  "Koester",
	  "Kofferschlager",
	  "Koha",
	  "Kohle",
	  "Kohlmann",
	  "Kohnle",
	  "Kohrt",
	  "Koj",
	  "Kolb",
	  "Koleiski",
	  "Kolokas",
	  "Komoll",
	  "Konieczny",
	  "Konig",
	  "Konow",
	  "Konya",
	  "Koob",
	  "Kopf",
	  "Kosenkow",
	  "Koster",
	  "Koszewski",
	  "Koubaa",
	  "Kovacs",
	  "Kowalick",
	  "Kowalinski",
	  "Kozakiewicz",
	  "Krabbe",
	  "Kraft",
	  "Kral",
	  "Kramer",
	  "Krauel",
	  "Kraus",
	  "Krause",
	  "Krauspe",
	  "Kreb",
	  "Krebs",
	  "Kreissig",
	  "Kresse",
	  "Kreutz",
	  "Krieger",
	  "Krippner",
	  "Krodinger",
	  "Krohn",
	  "Krol",
	  "Kron",
	  "Krueger",
	  "Krug",
	  "Kruger",
	  "Krull",
	  "Kruschinski",
	  "Krämer",
	  "Kröckert",
	  "Kröger",
	  "Krüger",
	  "Kubera",
	  "Kufahl",
	  "Kuhlee",
	  "Kuhnen",
	  "Kulimann",
	  "Kulma",
	  "Kumbernuss",
	  "Kummle",
	  "Kunz",
	  "Kupfer",
	  "Kupprion",
	  "Kuprion",
	  "Kurnicki",
	  "Kurrat",
	  "Kurschilgen",
	  "Kuschewitz",
	  "Kuschmann",
	  "Kuske",
	  "Kustermann",
	  "Kutscherauer",
	  "Kutzner",
	  "Kwadwo",
	  "Kähler",
	  "Käther",
	  "Köhler",
	  "Köhrbrück",
	  "Köhre",
	  "Kölotzei",
	  "König",
	  "Köpernick",
	  "Köseoglu",
	  "Kúhn",
	  "Kúhnert",
	  "Kühn",
	  "Kühnel",
	  "Kühnemund",
	  "Kühnert",
	  "Kühnke",
	  "Küsters",
	  "Küter",
	  "Laack",
	  "Lack",
	  "Ladewig",
	  "Lakomy",
	  "Lammert",
	  "Lamos",
	  "Landmann",
	  "Lang",
	  "Lange",
	  "Langfeld",
	  "Langhirt",
	  "Lanig",
	  "Lauckner",
	  "Lauinger",
	  "Laurén",
	  "Lausecker",
	  "Laux",
	  "Laws",
	  "Lax",
	  "Leberer",
	  "Lehmann",
	  "Lehner",
	  "Leibold",
	  "Leide",
	  "Leimbach",
	  "Leipold",
	  "Leist",
	  "Leiter",
	  "Leiteritz",
	  "Leitheim",
	  "Leiwesmeier",
	  "Lenfers",
	  "Lenk",
	  "Lenz",
	  "Lenzen",
	  "Leo",
	  "Lepthin",
	  "Lesch",
	  "Leschnik",
	  "Letzelter",
	  "Lewin",
	  "Lewke",
	  "Leyckes",
	  "Lg",
	  "Lichtenfeld",
	  "Lichtenhagen",
	  "Lichtl",
	  "Liebach",
	  "Liebe",
	  "Liebich",
	  "Liebold",
	  "Lieder",
	  "Lienshöft",
	  "Linden",
	  "Lindenberg",
	  "Lindenmayer",
	  "Lindner",
	  "Linke",
	  "Linnenbaum",
	  "Lippe",
	  "Lipske",
	  "Lipus",
	  "Lischka",
	  "Lobinger",
	  "Logsch",
	  "Lohmann",
	  "Lohre",
	  "Lohse",
	  "Lokar",
	  "Loogen",
	  "Lorenz",
	  "Losch",
	  "Loska",
	  "Lott",
	  "Loy",
	  "Lubina",
	  "Ludolf",
	  "Lufft",
	  "Lukoschek",
	  "Lutje",
	  "Lutz",
	  "Löser",
	  "Löwa",
	  "Lübke",
	  "Maak",
	  "Maczey",
	  "Madetzky",
	  "Madubuko",
	  "Mai",
	  "Maier",
	  "Maisch",
	  "Malek",
	  "Malkus",
	  "Mallmann",
	  "Malucha",
	  "Manns",
	  "Manz",
	  "Marahrens",
	  "Marchewski",
	  "Margis",
	  "Markowski",
	  "Marl",
	  "Marner",
	  "Marquart",
	  "Marschek",
	  "Martel",
	  "Marten",
	  "Martin",
	  "Marx",
	  "Marxen",
	  "Mathes",
	  "Mathies",
	  "Mathiszik",
	  "Matschke",
	  "Mattern",
	  "Matthes",
	  "Matula",
	  "Mau",
	  "Maurer",
	  "Mauroff",
	  "May",
	  "Maybach",
	  "Mayer",
	  "Mebold",
	  "Mehl",
	  "Mehlhorn",
	  "Mehlorn",
	  "Meier",
	  "Meisch",
	  "Meissner",
	  "Meloni",
	  "Melzer",
	  "Menga",
	  "Menne",
	  "Mensah",
	  "Mensing",
	  "Merkel",
	  "Merseburg",
	  "Mertens",
	  "Mesloh",
	  "Metzger",
	  "Metzner",
	  "Mewes",
	  "Meyer",
	  "Michallek",
	  "Michel",
	  "Mielke",
	  "Mikitenko",
	  "Milde",
	  "Minah",
	  "Mintzlaff",
	  "Mockenhaupt",
	  "Moede",
	  "Moedl",
	  "Moeller",
	  "Moguenara",
	  "Mohr",
	  "Mohrhard",
	  "Molitor",
	  "Moll",
	  "Moller",
	  "Molzan",
	  "Montag",
	  "Moormann",
	  "Mordhorst",
	  "Morgenstern",
	  "Morhelfer",
	  "Moritz",
	  "Moser",
	  "Motchebon",
	  "Motzenbbäcker",
	  "Mrugalla",
	  "Muckenthaler",
	  "Mues",
	  "Muller",
	  "Mulrain",
	  "Mächtig",
	  "Mäder",
	  "Möcks",
	  "Mögenburg",
	  "Möhsner",
	  "Möldner",
	  "Möllenbeck",
	  "Möller",
	  "Möllinger",
	  "Mörsch",
	  "Mühleis",
	  "Müller",
	  "Münch",
	  "Nabein",
	  "Nabow",
	  "Nagel",
	  "Nannen",
	  "Nastvogel",
	  "Nau",
	  "Naubert",
	  "Naumann",
	  "Ne",
	  "Neimke",
	  "Nerius",
	  "Neubauer",
	  "Neubert",
	  "Neuendorf",
	  "Neumair",
	  "Neumann",
	  "Neupert",
	  "Neurohr",
	  "Neuschwander",
	  "Newton",
	  "Ney",
	  "Nicolay",
	  "Niedermeier",
	  "Nieklauson",
	  "Niklaus",
	  "Nitzsche",
	  "Noack",
	  "Nodler",
	  "Nolte",
	  "Normann",
	  "Norris",
	  "Northoff",
	  "Nowak",
	  "Nussbeck",
	  "Nwachukwu",
	  "Nytra",
	  "Nöh",
	  "Oberem",
	  "Obergföll",
	  "Obermaier",
	  "Ochs",
	  "Oeser",
	  "Olbrich",
	  "Onnen",
	  "Ophey",
	  "Oppong",
	  "Orth",
	  "Orthmann",
	  "Oschkenat",
	  "Osei",
	  "Osenberg",
	  "Ostendarp",
	  "Ostwald",
	  "Otte",
	  "Otto",
	  "Paesler",
	  "Pajonk",
	  "Pallentin",
	  "Panzig",
	  "Paschke",
	  "Patzwahl",
	  "Paukner",
	  "Peselman",
	  "Peter",
	  "Peters",
	  "Petzold",
	  "Pfeiffer",
	  "Pfennig",
	  "Pfersich",
	  "Pfingsten",
	  "Pflieger",
	  "Pflügner",
	  "Philipp",
	  "Pichlmaier",
	  "Piesker",
	  "Pietsch",
	  "Pingpank",
	  "Pinnock",
	  "Pippig",
	  "Pitschugin",
	  "Plank",
	  "Plass",
	  "Platzer",
	  "Plauk",
	  "Plautz",
	  "Pletsch",
	  "Plotzitzka",
	  "Poehn",
	  "Poeschl",
	  "Pogorzelski",
	  "Pohl",
	  "Pohland",
	  "Pohle",
	  "Polifka",
	  "Polizzi",
	  "Pollmächer",
	  "Pomp",
	  "Ponitzsch",
	  "Porsche",
	  "Porth",
	  "Poschmann",
	  "Poser",
	  "Pottel",
	  "Prah",
	  "Prange",
	  "Prediger",
	  "Pressler",
	  "Preuk",
	  "Preuss",
	  "Prey",
	  "Priemer",
	  "Proske",
	  "Pusch",
	  "Pöche",
	  "Pöge",
	  "Raabe",
	  "Rabenstein",
	  "Rach",
	  "Radtke",
	  "Rahn",
	  "Ranftl",
	  "Rangen",
	  "Ranz",
	  "Rapp",
	  "Rath",
	  "Rau",
	  "Raubuch",
	  "Raukuc",
	  "Rautenkranz",
	  "Rehwagen",
	  "Reiber",
	  "Reichardt",
	  "Reichel",
	  "Reichling",
	  "Reif",
	  "Reifenrath",
	  "Reimann",
	  "Reinberg",
	  "Reinelt",
	  "Reinhardt",
	  "Reinke",
	  "Reitze",
	  "Renk",
	  "Rentz",
	  "Renz",
	  "Reppin",
	  "Restle",
	  "Restorff",
	  "Retzke",
	  "Reuber",
	  "Reumann",
	  "Reus",
	  "Reuss",
	  "Reusse",
	  "Rheder",
	  "Rhoden",
	  "Richards",
	  "Richter",
	  "Riedel",
	  "Riediger",
	  "Rieger",
	  "Riekmann",
	  "Riepl",
	  "Riermeier",
	  "Riester",
	  "Riethmüller",
	  "Rietmüller",
	  "Rietscher",
	  "Ringel",
	  "Ringer",
	  "Rink",
	  "Ripken",
	  "Ritosek",
	  "Ritschel",
	  "Ritter",
	  "Rittweg",
	  "Ritz",
	  "Roba",
	  "Rockmeier",
	  "Rodehau",
	  "Rodowski",
	  "Roecker",
	  "Roggatz",
	  "Rohländer",
	  "Rohrer",
	  "Rokossa",
	  "Roleder",
	  "Roloff",
	  "Roos",
	  "Rosbach",
	  "Roschinsky",
	  "Rose",
	  "Rosenauer",
	  "Rosenbauer",
	  "Rosenthal",
	  "Rosksch",
	  "Rossberg",
	  "Rossler",
	  "Roth",
	  "Rother",
	  "Ruch",
	  "Ruckdeschel",
	  "Rumpf",
	  "Rupprecht",
	  "Ruth",
	  "Ryjikh",
	  "Ryzih",
	  "Rädler",
	  "Räntsch",
	  "Rödiger",
	  "Röse",
	  "Röttger",
	  "Rücker",
	  "Rüdiger",
	  "Rüter",
	  "Sachse",
	  "Sack",
	  "Saflanis",
	  "Sagafe",
	  "Sagonas",
	  "Sahner",
	  "Saile",
	  "Sailer",
	  "Salow",
	  "Salzer",
	  "Salzmann",
	  "Sammert",
	  "Sander",
	  "Sarvari",
	  "Sattelmaier",
	  "Sauer",
	  "Sauerland",
	  "Saumweber",
	  "Savoia",
	  "Scc",
	  "Schacht",
	  "Schaefer",
	  "Schaffarzik",
	  "Schahbasian",
	  "Scharf",
	  "Schedler",
	  "Scheer",
	  "Schelk",
	  "Schellenbeck",
	  "Schembera",
	  "Schenk",
	  "Scherbarth",
	  "Scherer",
	  "Schersing",
	  "Scherz",
	  "Scheurer",
	  "Scheuring",
	  "Scheytt",
	  "Schielke",
	  "Schieskow",
	  "Schildhauer",
	  "Schilling",
	  "Schima",
	  "Schimmer",
	  "Schindzielorz",
	  "Schirmer",
	  "Schirrmeister",
	  "Schlachter",
	  "Schlangen",
	  "Schlawitz",
	  "Schlechtweg",
	  "Schley",
	  "Schlicht",
	  "Schlitzer",
	  "Schmalzle",
	  "Schmid",
	  "Schmidt",
	  "Schmidtchen",
	  "Schmitt",
	  "Schmitz",
	  "Schmuhl",
	  "Schneider",
	  "Schnelting",
	  "Schnieder",
	  "Schniedermeier",
	  "Schnürer",
	  "Schoberg",
	  "Scholz",
	  "Schonberg",
	  "Schondelmaier",
	  "Schorr",
	  "Schott",
	  "Schottmann",
	  "Schouren",
	  "Schrader",
	  "Schramm",
	  "Schreck",
	  "Schreiber",
	  "Schreiner",
	  "Schreiter",
	  "Schroder",
	  "Schröder",
	  "Schuermann",
	  "Schuff",
	  "Schuhaj",
	  "Schuldt",
	  "Schult",
	  "Schulte",
	  "Schultz",
	  "Schultze",
	  "Schulz",
	  "Schulze",
	  "Schumacher",
	  "Schumann",
	  "Schupp",
	  "Schuri",
	  "Schuster",
	  "Schwab",
	  "Schwalm",
	  "Schwanbeck",
	  "Schwandke",
	  "Schwanitz",
	  "Schwarthoff",
	  "Schwartz",
	  "Schwarz",
	  "Schwarzer",
	  "Schwarzkopf",
	  "Schwarzmeier",
	  "Schwatlo",
	  "Schweisfurth",
	  "Schwennen",
	  "Schwerdtner",
	  "Schwidde",
	  "Schwirkschlies",
	  "Schwuchow",
	  "Schäfer",
	  "Schäffel",
	  "Schäffer",
	  "Schäning",
	  "Schöckel",
	  "Schönball",
	  "Schönbeck",
	  "Schönberg",
	  "Schönebeck",
	  "Schönenberger",
	  "Schönfeld",
	  "Schönherr",
	  "Schönlebe",
	  "Schötz",
	  "Schüler",
	  "Schüppel",
	  "Schütz",
	  "Schütze",
	  "Seeger",
	  "Seelig",
	  "Sehls",
	  "Seibold",
	  "Seidel",
	  "Seiders",
	  "Seigel",
	  "Seiler",
	  "Seitz",
	  "Semisch",
	  "Senkel",
	  "Sewald",
	  "Siebel",
	  "Siebert",
	  "Siegling",
	  "Sielemann",
	  "Siemon",
	  "Siener",
	  "Sievers",
	  "Siewert",
	  "Sihler",
	  "Sillah",
	  "Simon",
	  "Sinnhuber",
	  "Sischka",
	  "Skibicki",
	  "Sladek",
	  "Slotta",
	  "Smieja",
	  "Soboll",
	  "Sokolowski",
	  "Soller",
	  "Sollner",
	  "Sommer",
	  "Somssich",
	  "Sonn",
	  "Sonnabend",
	  "Spahn",
	  "Spank",
	  "Spelmeyer",
	  "Spiegelburg",
	  "Spielvogel",
	  "Spinner",
	  "Spitzmüller",
	  "Splinter",
	  "Sporrer",
	  "Sprenger",
	  "Spöttel",
	  "Stahl",
	  "Stang",
	  "Stanger",
	  "Stauss",
	  "Steding",
	  "Steffen",
	  "Steffny",
	  "Steidl",
	  "Steigauf",
	  "Stein",
	  "Steinecke",
	  "Steinert",
	  "Steinkamp",
	  "Steinmetz",
	  "Stelkens",
	  "Stengel",
	  "Stengl",
	  "Stenzel",
	  "Stepanov",
	  "Stephan",
	  "Stern",
	  "Steuk",
	  "Stief",
	  "Stifel",
	  "Stoll",
	  "Stolle",
	  "Stolz",
	  "Storl",
	  "Storp",
	  "Stoutjesdijk",
	  "Stratmann",
	  "Straub",
	  "Strausa",
	  "Streck",
	  "Streese",
	  "Strege",
	  "Streit",
	  "Streller",
	  "Strieder",
	  "Striezel",
	  "Strogies",
	  "Strohschank",
	  "Strunz",
	  "Strutz",
	  "Stube",
	  "Stöckert",
	  "Stöppler",
	  "Stöwer",
	  "Stürmer",
	  "Suffa",
	  "Sujew",
	  "Sussmann",
	  "Suthe",
	  "Sutschet",
	  "Swillims",
	  "Szendrei",
	  "Sören",
	  "Sürth",
	  "Tafelmeier",
	  "Tang",
	  "Tasche",
	  "Taufratshofer",
	  "Tegethof",
	  "Teichmann",
	  "Tepper",
	  "Terheiden",
	  "Terlecki",
	  "Teufel",
	  "Theele",
	  "Thieke",
	  "Thimm",
	  "Thiomas",
	  "Thomas",
	  "Thriene",
	  "Thränhardt",
	  "Thust",
	  "Thyssen",
	  "Thöne",
	  "Tidow",
	  "Tiedtke",
	  "Tietze",
	  "Tilgner",
	  "Tillack",
	  "Timmermann",
	  "Tischler",
	  "Tischmann",
	  "Tittman",
	  "Tivontschik",
	  "Tonat",
	  "Tonn",
	  "Trampeli",
	  "Trauth",
	  "Trautmann",
	  "Travan",
	  "Treff",
	  "Tremmel",
	  "Tress",
	  "Tsamonikian",
	  "Tschiers",
	  "Tschirch",
	  "Tuch",
	  "Tucholke",
	  "Tudow",
	  "Tuschmo",
	  "Tächl",
	  "Többen",
	  "Töpfer",
	  "Uhlemann",
	  "Uhlig",
	  "Uhrig",
	  "Uibel",
	  "Uliczka",
	  "Ullmann",
	  "Ullrich",
	  "Umbach",
	  "Umlauft",
	  "Umminger",
	  "Unger",
	  "Unterpaintner",
	  "Urban",
	  "Urbaniak",
	  "Urbansky",
	  "Urhig",
	  "Vahlensieck",
	  "Van",
	  "Vangermain",
	  "Vater",
	  "Venghaus",
	  "Verniest",
	  "Verzi",
	  "Vey",
	  "Viellehner",
	  "Vieweg",
	  "Voelkel",
	  "Vogel",
	  "Vogelgsang",
	  "Vogt",
	  "Voigt",
	  "Vokuhl",
	  "Volk",
	  "Volker",
	  "Volkmann",
	  "Von",
	  "Vona",
	  "Vontein",
	  "Wachenbrunner",
	  "Wachtel",
	  "Wagner",
	  "Waibel",
	  "Wakan",
	  "Waldmann",
	  "Wallner",
	  "Wallstab",
	  "Walter",
	  "Walther",
	  "Walton",
	  "Walz",
	  "Wanner",
	  "Wartenberg",
	  "Waschbüsch",
	  "Wassilew",
	  "Wassiluk",
	  "Weber",
	  "Wehrsen",
	  "Weidlich",
	  "Weidner",
	  "Weigel",
	  "Weight",
	  "Weiler",
	  "Weimer",
	  "Weis",
	  "Weiss",
	  "Weller",
	  "Welsch",
	  "Welz",
	  "Welzel",
	  "Weniger",
	  "Wenk",
	  "Werle",
	  "Werner",
	  "Werrmann",
	  "Wessel",
	  "Wessinghage",
	  "Weyel",
	  "Wezel",
	  "Wichmann",
	  "Wickert",
	  "Wiebe",
	  "Wiechmann",
	  "Wiegelmann",
	  "Wierig",
	  "Wiese",
	  "Wieser",
	  "Wilhelm",
	  "Wilky",
	  "Will",
	  "Willwacher",
	  "Wilts",
	  "Wimmer",
	  "Winkelmann",
	  "Winkler",
	  "Winter",
	  "Wischek",
	  "Wischer",
	  "Wissing",
	  "Wittich",
	  "Wittl",
	  "Wolf",
	  "Wolfarth",
	  "Wolff",
	  "Wollenberg",
	  "Wollmann",
	  "Woytkowska",
	  "Wujak",
	  "Wurm",
	  "Wyludda",
	  "Wölpert",
	  "Wöschler",
	  "Wühn",
	  "Wünsche",
	  "Zach",
	  "Zaczkiewicz",
	  "Zahn",
	  "Zaituc",
	  "Zandt",
	  "Zanner",
	  "Zapletal",
	  "Zauber",
	  "Zeidler",
	  "Zekl",
	  "Zender",
	  "Zeuch",
	  "Zeyen",
	  "Zeyhle",
	  "Ziegler",
	  "Zimanyi",
	  "Zimmer",
	  "Zimmermann",
	  "Zinser",
	  "Zintl",
	  "Zipp",
	  "Zipse",
	  "Zschunke",
	  "Zuber",
	  "Zwiener",
	  "Zümsande",
	  "Östringer",
	  "Überacker"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{nobility_title_prefix} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "zu",
	  "von",
	  "vom",
	  "von der"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Hr.",
	  "Fr.",
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(0###) #########",
	  "(0####) #######",
	  "+49-###-#######",
	  "+49-####-########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(1973);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aigen im Mühlkreis",
	  "Allerheiligen bei Wildon",
	  "Altenfelden",
	  "Arriach",
	  "Axams",
	  "Baumgartenberg",
	  "Bergern im Dunkelsteinerwald",
	  "Berndorf bei Salzburg",
	  "Bregenz",
	  "Breitenbach am Inn",
	  "Deutsch-Wagram",
	  "Dienten am Hochkönig",
	  "Dietach",
	  "Dornbirn",
	  "Dürnkrut",
	  "Eben im Pongau",
	  "Ebenthal in Kärnten",
	  "Eichgraben",
	  "Eisenstadt",
	  "Ellmau",
	  "Feistritz am Wechsel",
	  "Finkenberg",
	  "Fiss",
	  "Frantschach-St. Gertraud",
	  "Fritzens",
	  "Gams bei Hieflau",
	  "Geiersberg",
	  "Graz",
	  "Großhöflein",
	  "Gößnitz",
	  "Hartl",
	  "Hausleiten",
	  "Herzogenburg",
	  "Hinterhornbach",
	  "Hochwolkersdorf",
	  "Ilz",
	  "Ilztal",
	  "Innerbraz",
	  "Innsbruck",
	  "Itter",
	  "Jagerberg",
	  "Jeging",
	  "Johnsbach",
	  "Johnsdorf-Brunn",
	  "Jungholz",
	  "Kirchdorf am Inn",
	  "Klagenfurt",
	  "Kottes-Purk",
	  "Krumau am Kamp",
	  "Krumbach",
	  "Lavamünd",
	  "Lech",
	  "Linz",
	  "Ludesch",
	  "Lödersdorf",
	  "Marbach an der Donau",
	  "Mattsee",
	  "Mautern an der Donau",
	  "Mauterndorf",
	  "Mitterbach am Erlaufsee",
	  "Neudorf bei Passail",
	  "Neudorf bei Staatz",
	  "Neukirchen an der Enknach",
	  "Neustift an der Lafnitz",
	  "Niederleis",
	  "Oberndorf in Tirol",
	  "Oberstorcha",
	  "Oberwaltersdorf",
	  "Oed-Oehling",
	  "Ort im Innkreis",
	  "Pilgersdorf",
	  "Pitschgau",
	  "Pollham",
	  "Preitenegg",
	  "Purbach am Neusiedler See",
	  "Rabenwald",
	  "Raiding",
	  "Rastenfeld",
	  "Ratten",
	  "Rettenegg",
	  "Salzburg",
	  "Sankt Johann im Saggautal",
	  "St. Peter am Kammersberg",
	  "St. Pölten",
	  "St. Veit an der Glan",
	  "Taxenbach",
	  "Tragwein",
	  "Trebesing",
	  "Trieben",
	  "Turnau",
	  "Ungerdorf",
	  "Unterauersbach",
	  "Unterstinkenbrunn",
	  "Untertilliach",
	  "Uttendorf",
	  "Vals",
	  "Velden am Wörther See",
	  "Viehhofen",
	  "Villach",
	  "Vitis",
	  "Waidhofen an der Thaya",
	  "Waldkirchen am Wesen",
	  "Weißkirchen an der Traun",
	  "Wien",
	  "Wimpassing im Schwarzatale",
	  "Ybbs an der Donau",
	  "Ybbsitz",
	  "Yspertal",
	  "Zeillern",
	  "Zell am Pettenfirst",
	  "Zell an der Pram",
	  "Zerlach",
	  "Zwölfaxing",
	  "Öblarn",
	  "Übelbach",
	  "Überackern",
	  "Übersaxen",
	  "Übersbach"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ägypten",
	  "Äquatorialguinea",
	  "Äthiopien",
	  "Österreich",
	  "Afghanistan",
	  "Albanien",
	  "Algerien",
	  "Amerikanisch-Samoa",
	  "Amerikanische Jungferninseln",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarktis",
	  "Antigua und Barbuda",
	  "Argentinien",
	  "Armenien",
	  "Aruba",
	  "Aserbaidschan",
	  "Australien",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesch",
	  "Barbados",
	  "Belarus",
	  "Belgien",
	  "Belize",
	  "Benin",
	  "die Bermudas",
	  "Bhutan",
	  "Bolivien",
	  "Bosnien und Herzegowina",
	  "Botsuana",
	  "Bouvetinsel",
	  "Brasilien",
	  "Britische Jungferninseln",
	  "Britisches Territorium im Indischen Ozean",
	  "Brunei Darussalam",
	  "Bulgarien",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "China",
	  "Cookinseln",
	  "Costa Rica",
	  "Dänemark",
	  "Demokratische Republik Kongo",
	  "Demokratische Volksrepublik Korea",
	  "Deutschland",
	  "Dominica",
	  "Dominikanische Republik",
	  "Dschibuti",
	  "Ecuador",
	  "El Salvador",
	  "Eritrea",
	  "Estland",
	  "Färöer",
	  "Falklandinseln",
	  "Fidschi",
	  "Finnland",
	  "Frankreich",
	  "Französisch-Guayana",
	  "Französisch-Polynesien",
	  "Französische Gebiete im südlichen Indischen Ozean",
	  "Gabun",
	  "Gambia",
	  "Georgien",
	  "Ghana",
	  "Gibraltar",
	  "Grönland",
	  "Grenada",
	  "Griechenland",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard und McDonaldinseln",
	  "Honduras",
	  "Hongkong",
	  "Indien",
	  "Indonesien",
	  "Irak",
	  "Iran",
	  "Irland",
	  "Island",
	  "Israel",
	  "Italien",
	  "Jamaika",
	  "Japan",
	  "Jemen",
	  "Jordanien",
	  "Jugoslawien",
	  "Kaimaninseln",
	  "Kambodscha",
	  "Kamerun",
	  "Kanada",
	  "Kap Verde",
	  "Kasachstan",
	  "Katar",
	  "Kenia",
	  "Kirgisistan",
	  "Kiribati",
	  "Kleinere amerikanische Überseeinseln",
	  "Kokosinseln",
	  "Kolumbien",
	  "Komoren",
	  "Kongo",
	  "Kroatien",
	  "Kuba",
	  "Kuwait",
	  "Laos",
	  "Lesotho",
	  "Lettland",
	  "Libanon",
	  "Liberia",
	  "Libyen",
	  "Liechtenstein",
	  "Litauen",
	  "Luxemburg",
	  "Macau",
	  "Madagaskar",
	  "Malawi",
	  "Malaysia",
	  "Malediven",
	  "Mali",
	  "Malta",
	  "ehemalige jugoslawische Republik Mazedonien",
	  "Marokko",
	  "Marshallinseln",
	  "Martinique",
	  "Mauretanien",
	  "Mauritius",
	  "Mayotte",
	  "Mexiko",
	  "Mikronesien",
	  "Monaco",
	  "Mongolei",
	  "Montserrat",
	  "Mosambik",
	  "Myanmar",
	  "Nördliche Marianen",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Neukaledonien",
	  "Neuseeland",
	  "Nicaragua",
	  "Niederländische Antillen",
	  "Niederlande",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolkinsel",
	  "Norwegen",
	  "Oman",
	  "Osttimor",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Neuguinea",
	  "Paraguay",
	  "Peru",
	  "Philippinen",
	  "Pitcairninseln",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Réunion",
	  "Republik Korea",
	  "Republik Moldau",
	  "Ruanda",
	  "Rumänien",
	  "Russische Föderation",
	  "São Tomé und Príncipe",
	  "Südafrika",
	  "Südgeorgien und Südliche Sandwichinseln",
	  "Salomonen",
	  "Sambia",
	  "Samoa",
	  "San Marino",
	  "Saudi-Arabien",
	  "Schweden",
	  "Schweiz",
	  "Senegal",
	  "Seychellen",
	  "Sierra Leone",
	  "Simbabwe",
	  "Singapur",
	  "Slowakei",
	  "Slowenien",
	  "Somalien",
	  "Spanien",
	  "Sri Lanka",
	  "St. Helena",
	  "St. Kitts und Nevis",
	  "St. Lucia",
	  "St. Pierre und Miquelon",
	  "St. Vincent und die Grenadinen",
	  "Sudan",
	  "Surinam",
	  "Svalbard und Jan Mayen",
	  "Swasiland",
	  "Syrien",
	  "Türkei",
	  "Tadschikistan",
	  "Taiwan",
	  "Tansania",
	  "Thailand",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad und Tobago",
	  "Tschad",
	  "Tschechische Republik",
	  "Tunesien",
	  "Turkmenistan",
	  "Turks- und Caicosinseln",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "Ungarn",
	  "Uruguay",
	  "Usbekistan",
	  "Vanuatu",
	  "Vatikanstadt",
	  "Venezuela",
	  "Vereinigte Arabische Emirate",
	  "Vereinigte Staaten",
	  "Vereinigtes Königreich",
	  "Vietnam",
	  "Wallis und Futuna",
	  "Weihnachtsinsel",
	  "Westsahara",
	  "Zentralafrikanische Republik",
	  "Zypern"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Österreich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(1978);
	address.street_root = __webpack_require__(1987);
	address.building_number = __webpack_require__(1975);
	address.secondary_address = __webpack_require__(1982);
	address.postcode = __webpack_require__(1981);
	address.state = __webpack_require__(1983);
	address.state_abbr = __webpack_require__(1984);
	address.city_name = __webpack_require__(1977);
	address.city = __webpack_require__(1976);
	address.street_name = __webpack_require__(1986);
	address.street_address = __webpack_require__(1985);
	address.default_country = __webpack_require__(1979);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Zimmer ###",
	  "# OG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Burgenland",
	  "Kärnten",
	  "Niederösterreich",
	  "Oberösterreich",
	  "Salzburg",
	  "Steiermark",
	  "Tirol",
	  "Vorarlberg",
	  "Wien"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bgld.",
	  "Ktn.",
	  "NÖ",
	  "OÖ",
	  "Sbg.",
	  "Stmk.",
	  "T",
	  "Vbg.",
	  "W"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ahorn",
	  "Ahorngasse (St. Andrä)",
	  "Alleestraße (Poysbrunn)",
	  "Alpenlandstraße",
	  "Alte Poststraße",
	  "Alte Ufergasse",
	  "Am Kronawett (Hagenbrunn)",
	  "Am Mühlwasser",
	  "Am Rebenhang",
	  "Am Sternweg",
	  "Anton Wildgans-Straße",
	  "Auer-von-Welsbach-Weg",
	  "Auf der Stift",
	  "Aufeldgasse",
	  "Bahngasse",
	  "Bahnhofstraße",
	  "Bahnstraße (Gerhaus)",
	  "Basteigasse",
	  "Berggasse",
	  "Bergstraße",
	  "Birkenweg",
	  "Blasiussteig",
	  "Blattur",
	  "Bruderhofgasse",
	  "Brunnelligasse",
	  "Bühelweg",
	  "Darnautgasse",
	  "Donaugasse",
	  "Dorfplatz (Haselbach)",
	  "Dr.-Oberreiter-Straße",
	  "Dr.Karl Holoubek-Str.",
	  "Drautal Bundesstraße",
	  "Dürnrohrer Straße",
	  "Ebenthalerstraße",
	  "Eckgrabenweg",
	  "Erlenstraße",
	  "Erlenweg",
	  "Eschenweg",
	  "Etrichgasse",
	  "Fassergasse",
	  "Feichteggerwiese",
	  "Feld-Weg",
	  "Feldgasse",
	  "Feldstapfe",
	  "Fischpointweg",
	  "Flachbergstraße",
	  "Flurweg",
	  "Franz Schubert-Gasse",
	  "Franz-Schneeweiß-Weg",
	  "Franz-von-Assisi-Straße",
	  "Fritz-Pregl-Straße",
	  "Fuchsgrubenweg",
	  "Födlerweg",
	  "Föhrenweg",
	  "Fünfhaus (Paasdorf)",
	  "Gabelsbergerstraße",
	  "Gartenstraße",
	  "Geigen",
	  "Geigergasse",
	  "Gemeindeaugasse",
	  "Gemeindeplatz",
	  "Georg-Aichinger-Straße",
	  "Glanfeldbachweg",
	  "Graben (Burgauberg)",
	  "Grub",
	  "Gröretgasse",
	  "Grünbach",
	  "Gösting",
	  "Hainschwang",
	  "Hans-Mauracher-Straße",
	  "Hart",
	  "Teichstraße",
	  "Hauptplatz",
	  "Hauptstraße",
	  "Heideweg",
	  "Heinrich Landauer Gasse",
	  "Helenengasse",
	  "Hermann von Gilmweg",
	  "Hermann-Löns-Gasse",
	  "Herminengasse",
	  "Hernstorferstraße",
	  "Hirsdorf",
	  "Hochfeistritz",
	  "Hochhaus Neue Donau",
	  "Hof",
	  "Hussovits Gasse",
	  "Höggen",
	  "Hütten",
	  "Janzgasse",
	  "Jochriemgutstraße",
	  "Johann-Strauß-Gasse",
	  "Julius-Raab-Straße",
	  "Kahlenberger Straße",
	  "Karl Kraft-Straße",
	  "Kegelprielstraße",
	  "Keltenberg-Eponaweg",
	  "Kennedybrücke",
	  "Kerpelystraße",
	  "Kindergartenstraße",
	  "Kinderheimgasse",
	  "Kirchenplatz",
	  "Kirchweg",
	  "Klagenfurter Straße",
	  "Klamm",
	  "Kleinbaumgarten",
	  "Klingergasse",
	  "Koloniestraße",
	  "Konrad-Duden-Gasse",
	  "Krankenhausstraße",
	  "Kubinstraße",
	  "Köhldorfergasse",
	  "Lackenweg",
	  "Lange Mekotte",
	  "Leifling",
	  "Leopold Frank-Straße (Pellendorf)",
	  "Lerchengasse (Pirka)",
	  "Lichtensternsiedlung V",
	  "Lindenhofstraße",
	  "Lindenweg",
	  "Luegstraße",
	  "Maierhof",
	  "Malerweg",
	  "Mitterweg",
	  "Mittlere Hauptstraße",
	  "Moosbachgasse",
	  "Morettigasse",
	  "Musikpavillon Riezlern",
	  "Mühlboden",
	  "Mühle",
	  "Mühlenweg",
	  "Neustiftgasse",
	  "Niederegg",
	  "Niedergams",
	  "Nordwestbahnbrücke",
	  "Oberbödenalm",
	  "Obere Berggasse",
	  "Oedt",
	  "Am Färberberg",
	  "Ottogasse",
	  "Paul Peters-Gasse",
	  "Perspektivstraße",
	  "Poppichl",
	  "Privatweg",
	  "Prixgasse",
	  "Pyhra",
	  "Radetzkystraße",
	  "Raiden",
	  "Reichensteinstraße",
	  "Reitbauernstraße",
	  "Reiterweg",
	  "Reitschulgasse",
	  "Ringweg",
	  "Rupertistraße",
	  "Römerstraße",
	  "Römerweg",
	  "Sackgasse",
	  "Schaunbergerstraße",
	  "Schloßweg",
	  "Schulgasse (Langeck)",
	  "Schönholdsiedlung",
	  "Seeblick",
	  "Seestraße",
	  "Semriacherstraße",
	  "Simling",
	  "Sipbachzeller Straße",
	  "Sonnenweg",
	  "Spargelfeldgasse",
	  "Spiesmayrweg",
	  "Sportplatzstraße",
	  "St.Ulrich",
	  "Steilmannstraße",
	  "Steingrüneredt",
	  "Strassfeld",
	  "Straßerau",
	  "Stöpflweg",
	  "Stüra",
	  "Taferngasse",
	  "Tennweg",
	  "Thomas Koschat-Gasse",
	  "Tiroler Straße",
	  "Torrogasse",
	  "Uferstraße (Schwarzau am Steinfeld)",
	  "Unterdörfl",
	  "Unterer Sonnrainweg",
	  "Verwaltersiedlung",
	  "Waldhang",
	  "Wasen",
	  "Weidenstraße",
	  "Weiherweg",
	  "Wettsteingasse",
	  "Wiener Straße",
	  "Windisch",
	  "Zebragasse",
	  "Zellerstraße",
	  "Ziehrerstraße",
	  "Zulechnerweg",
	  "Zwergjoch",
	  "Ötzbruck"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+43-6##-#######",
	  "06##-########",
	  "+436#########",
	  "06##########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(1988);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(1993);
	company.legal_form = __webpack_require__(1991);
	company.name = __webpack_require__(1992);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "GmbH",
	  "AG",
	  "Gruppe",
	  "KG",
	  "GmbH & Co. KG",
	  "UG",
	  "OHG"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de_AT = {};
	module['exports'] = de_AT;
	de_AT.title = "German (Austria)";
	de_AT.address = __webpack_require__(1980);
	de_AT.company = __webpack_require__(1990);
	de_AT.internet = __webpack_require__(1997);
	de_AT.name = __webpack_require__(1999);
	de_AT.phone_number = __webpack_require__(2005);
	de_AT.cell_phone = __webpack_require__(1989);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "info",
	  "name",
	  "net",
	  "org",
	  "de",
	  "ch",
	  "at"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(1996);
	internet.domain_suffix = __webpack_require__(1995);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abdul",
	  "Abdullah",
	  "Adam",
	  "Adrian",
	  "Adriano",
	  "Ahmad",
	  "Ahmed",
	  "Ahmet",
	  "Alan",
	  "Albert",
	  "Alessandro",
	  "Alessio",
	  "Alex",
	  "Alexander",
	  "Alfred",
	  "Ali",
	  "Amar",
	  "Amir",
	  "Amon",
	  "Andre",
	  "Andreas",
	  "Andrew",
	  "Angelo",
	  "Ansgar",
	  "Anthony",
	  "Anton",
	  "Antonio",
	  "Arda",
	  "Arian",
	  "Armin",
	  "Arne",
	  "Arno",
	  "Arthur",
	  "Artur",
	  "Arved",
	  "Arvid",
	  "Ayman",
	  "Baran",
	  "Baris",
	  "Bastian",
	  "Batuhan",
	  "Bela",
	  "Ben",
	  "Benedikt",
	  "Benjamin",
	  "Bennet",
	  "Bennett",
	  "Benno",
	  "Bent",
	  "Berat",
	  "Berkay",
	  "Bernd",
	  "Bilal",
	  "Bjarne",
	  "Björn",
	  "Bo",
	  "Boris",
	  "Brandon",
	  "Brian",
	  "Bruno",
	  "Bryan",
	  "Burak",
	  "Calvin",
	  "Can",
	  "Carl",
	  "Carlo",
	  "Carlos",
	  "Caspar",
	  "Cedric",
	  "Cedrik",
	  "Cem",
	  "Charlie",
	  "Chris",
	  "Christian",
	  "Christiano",
	  "Christoph",
	  "Christopher",
	  "Claas",
	  "Clemens",
	  "Colin",
	  "Collin",
	  "Conner",
	  "Connor",
	  "Constantin",
	  "Corvin",
	  "Curt",
	  "Damian",
	  "Damien",
	  "Daniel",
	  "Danilo",
	  "Danny",
	  "Darian",
	  "Dario",
	  "Darius",
	  "Darren",
	  "David",
	  "Davide",
	  "Davin",
	  "Dean",
	  "Deniz",
	  "Dennis",
	  "Denny",
	  "Devin",
	  "Diego",
	  "Dion",
	  "Domenic",
	  "Domenik",
	  "Dominic",
	  "Dominik",
	  "Dorian",
	  "Dustin",
	  "Dylan",
	  "Ecrin",
	  "Eddi",
	  "Eddy",
	  "Edgar",
	  "Edwin",
	  "Efe",
	  "Ege",
	  "Elia",
	  "Eliah",
	  "Elias",
	  "Elijah",
	  "Emanuel",
	  "Emil",
	  "Emilian",
	  "Emilio",
	  "Emir",
	  "Emirhan",
	  "Emre",
	  "Enes",
	  "Enno",
	  "Enrico",
	  "Eren",
	  "Eric",
	  "Erik",
	  "Etienne",
	  "Fabian",
	  "Fabien",
	  "Fabio",
	  "Fabrice",
	  "Falk",
	  "Felix",
	  "Ferdinand",
	  "Fiete",
	  "Filip",
	  "Finlay",
	  "Finley",
	  "Finn",
	  "Finnley",
	  "Florian",
	  "Francesco",
	  "Franz",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Friedrich",
	  "Fritz",
	  "Furkan",
	  "Fynn",
	  "Gabriel",
	  "Georg",
	  "Gerrit",
	  "Gian",
	  "Gianluca",
	  "Gino",
	  "Giuliano",
	  "Giuseppe",
	  "Gregor",
	  "Gustav",
	  "Hagen",
	  "Hamza",
	  "Hannes",
	  "Hanno",
	  "Hans",
	  "Hasan",
	  "Hassan",
	  "Hauke",
	  "Hendrik",
	  "Hennes",
	  "Henning",
	  "Henri",
	  "Henrick",
	  "Henrik",
	  "Henry",
	  "Hugo",
	  "Hussein",
	  "Ian",
	  "Ibrahim",
	  "Ilias",
	  "Ilja",
	  "Ilyas",
	  "Immanuel",
	  "Ismael",
	  "Ismail",
	  "Ivan",
	  "Iven",
	  "Jack",
	  "Jacob",
	  "Jaden",
	  "Jakob",
	  "Jamal",
	  "James",
	  "Jamie",
	  "Jan",
	  "Janek",
	  "Janis",
	  "Janne",
	  "Jannek",
	  "Jannes",
	  "Jannik",
	  "Jannis",
	  "Jano",
	  "Janosch",
	  "Jared",
	  "Jari",
	  "Jarne",
	  "Jarno",
	  "Jaron",
	  "Jason",
	  "Jasper",
	  "Jay",
	  "Jayden",
	  "Jayson",
	  "Jean",
	  "Jens",
	  "Jeremias",
	  "Jeremie",
	  "Jeremy",
	  "Jermaine",
	  "Jerome",
	  "Jesper",
	  "Jesse",
	  "Jim",
	  "Jimmy",
	  "Joe",
	  "Joel",
	  "Joey",
	  "Johann",
	  "Johannes",
	  "John",
	  "Johnny",
	  "Jon",
	  "Jona",
	  "Jonah",
	  "Jonas",
	  "Jonathan",
	  "Jonte",
	  "Joost",
	  "Jordan",
	  "Joris",
	  "Joscha",
	  "Joschua",
	  "Josef",
	  "Joseph",
	  "Josh",
	  "Joshua",
	  "Josua",
	  "Juan",
	  "Julian",
	  "Julien",
	  "Julius",
	  "Juri",
	  "Justin",
	  "Justus",
	  "Kaan",
	  "Kai",
	  "Kalle",
	  "Karim",
	  "Karl",
	  "Karlo",
	  "Kay",
	  "Keanu",
	  "Kenan",
	  "Kenny",
	  "Keno",
	  "Kerem",
	  "Kerim",
	  "Kevin",
	  "Kian",
	  "Kilian",
	  "Kim",
	  "Kimi",
	  "Kjell",
	  "Klaas",
	  "Klemens",
	  "Konrad",
	  "Konstantin",
	  "Koray",
	  "Korbinian",
	  "Kurt",
	  "Lars",
	  "Lasse",
	  "Laurence",
	  "Laurens",
	  "Laurenz",
	  "Laurin",
	  "Lean",
	  "Leander",
	  "Leandro",
	  "Leif",
	  "Len",
	  "Lenn",
	  "Lennard",
	  "Lennart",
	  "Lennert",
	  "Lennie",
	  "Lennox",
	  "Lenny",
	  "Leo",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leonhard",
	  "Leonidas",
	  "Leopold",
	  "Leroy",
	  "Levent",
	  "Levi",
	  "Levin",
	  "Lewin",
	  "Lewis",
	  "Liam",
	  "Lian",
	  "Lias",
	  "Lino",
	  "Linus",
	  "Lio",
	  "Lion",
	  "Lionel",
	  "Logan",
	  "Lorenz",
	  "Lorenzo",
	  "Loris",
	  "Louis",
	  "Luan",
	  "Luc",
	  "Luca",
	  "Lucas",
	  "Lucian",
	  "Lucien",
	  "Ludwig",
	  "Luis",
	  "Luiz",
	  "Luk",
	  "Luka",
	  "Lukas",
	  "Luke",
	  "Lutz",
	  "Maddox",
	  "Mads",
	  "Magnus",
	  "Maik",
	  "Maksim",
	  "Malik",
	  "Malte",
	  "Manuel",
	  "Marc",
	  "Marcel",
	  "Marco",
	  "Marcus",
	  "Marek",
	  "Marian",
	  "Mario",
	  "Marius",
	  "Mark",
	  "Marko",
	  "Markus",
	  "Marlo",
	  "Marlon",
	  "Marten",
	  "Martin",
	  "Marvin",
	  "Marwin",
	  "Mateo",
	  "Mathis",
	  "Matis",
	  "Mats",
	  "Matteo",
	  "Mattes",
	  "Matthias",
	  "Matthis",
	  "Matti",
	  "Mattis",
	  "Maurice",
	  "Max",
	  "Maxim",
	  "Maximilian",
	  "Mehmet",
	  "Meik",
	  "Melvin",
	  "Merlin",
	  "Mert",
	  "Michael",
	  "Michel",
	  "Mick",
	  "Miguel",
	  "Mika",
	  "Mikail",
	  "Mike",
	  "Milan",
	  "Milo",
	  "Mio",
	  "Mirac",
	  "Mirco",
	  "Mirko",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moritz",
	  "Morten",
	  "Muhammed",
	  "Murat",
	  "Mustafa",
	  "Nathan",
	  "Nathanael",
	  "Nelson",
	  "Neo",
	  "Nevio",
	  "Nick",
	  "Niclas",
	  "Nico",
	  "Nicolai",
	  "Nicolas",
	  "Niels",
	  "Nikita",
	  "Niklas",
	  "Niko",
	  "Nikolai",
	  "Nikolas",
	  "Nils",
	  "Nino",
	  "Noah",
	  "Noel",
	  "Norman",
	  "Odin",
	  "Oke",
	  "Ole",
	  "Oliver",
	  "Omar",
	  "Onur",
	  "Oscar",
	  "Oskar",
	  "Pascal",
	  "Patrice",
	  "Patrick",
	  "Paul",
	  "Peer",
	  "Pepe",
	  "Peter",
	  "Phil",
	  "Philip",
	  "Philipp",
	  "Pierre",
	  "Piet",
	  "Pit",
	  "Pius",
	  "Quentin",
	  "Quirin",
	  "Rafael",
	  "Raik",
	  "Ramon",
	  "Raphael",
	  "Rasmus",
	  "Raul",
	  "Rayan",
	  "René",
	  "Ricardo",
	  "Riccardo",
	  "Richard",
	  "Rick",
	  "Rico",
	  "Robert",
	  "Robin",
	  "Rocco",
	  "Roman",
	  "Romeo",
	  "Ron",
	  "Ruben",
	  "Ryan",
	  "Said",
	  "Salih",
	  "Sam",
	  "Sami",
	  "Sammy",
	  "Samuel",
	  "Sandro",
	  "Santino",
	  "Sascha",
	  "Sean",
	  "Sebastian",
	  "Selim",
	  "Semih",
	  "Shawn",
	  "Silas",
	  "Simeon",
	  "Simon",
	  "Sinan",
	  "Sky",
	  "Stefan",
	  "Steffen",
	  "Stephan",
	  "Steve",
	  "Steven",
	  "Sven",
	  "Sönke",
	  "Sören",
	  "Taha",
	  "Tamino",
	  "Tammo",
	  "Tarik",
	  "Tayler",
	  "Taylor",
	  "Teo",
	  "Theo",
	  "Theodor",
	  "Thies",
	  "Thilo",
	  "Thomas",
	  "Thorben",
	  "Thore",
	  "Thorge",
	  "Tiago",
	  "Til",
	  "Till",
	  "Tillmann",
	  "Tim",
	  "Timm",
	  "Timo",
	  "Timon",
	  "Timothy",
	  "Tino",
	  "Titus",
	  "Tizian",
	  "Tjark",
	  "Tobias",
	  "Tom",
	  "Tommy",
	  "Toni",
	  "Tony",
	  "Torben",
	  "Tore",
	  "Tristan",
	  "Tyler",
	  "Tyron",
	  "Umut",
	  "Valentin",
	  "Valentino",
	  "Veit",
	  "Victor",
	  "Viktor",
	  "Vin",
	  "Vincent",
	  "Vito",
	  "Vitus",
	  "Wilhelm",
	  "Willi",
	  "William",
	  "Willy",
	  "Xaver",
	  "Yannic",
	  "Yannick",
	  "Yannik",
	  "Yannis",
	  "Yasin",
	  "Youssef",
	  "Yunus",
	  "Yusuf",
	  "Yven",
	  "Yves",
	  "Ömer",
	  "Aaliyah",
	  "Abby",
	  "Abigail",
	  "Ada",
	  "Adelina",
	  "Adriana",
	  "Aileen",
	  "Aimee",
	  "Alana",
	  "Alea",
	  "Alena",
	  "Alessa",
	  "Alessia",
	  "Alexa",
	  "Alexandra",
	  "Alexia",
	  "Alexis",
	  "Aleyna",
	  "Alia",
	  "Alica",
	  "Alice",
	  "Alicia",
	  "Alina",
	  "Alisa",
	  "Alisha",
	  "Alissa",
	  "Aliya",
	  "Aliyah",
	  "Allegra",
	  "Alma",
	  "Alyssa",
	  "Amalia",
	  "Amanda",
	  "Amelia",
	  "Amelie",
	  "Amina",
	  "Amira",
	  "Amy",
	  "Ana",
	  "Anabel",
	  "Anastasia",
	  "Andrea",
	  "Angela",
	  "Angelina",
	  "Angelique",
	  "Anja",
	  "Ann",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalena",
	  "Anne",
	  "Anneke",
	  "Annelie",
	  "Annemarie",
	  "Anni",
	  "Annie",
	  "Annika",
	  "Anny",
	  "Anouk",
	  "Antonia",
	  "Arda",
	  "Ariana",
	  "Ariane",
	  "Arwen",
	  "Ashley",
	  "Asya",
	  "Aurelia",
	  "Aurora",
	  "Ava",
	  "Ayleen",
	  "Aylin",
	  "Ayse",
	  "Azra",
	  "Betty",
	  "Bianca",
	  "Bianka",
	  "Caitlin",
	  "Cara",
	  "Carina",
	  "Carla",
	  "Carlotta",
	  "Carmen",
	  "Carolin",
	  "Carolina",
	  "Caroline",
	  "Cassandra",
	  "Catharina",
	  "Catrin",
	  "Cecile",
	  "Cecilia",
	  "Celia",
	  "Celina",
	  "Celine",
	  "Ceyda",
	  "Ceylin",
	  "Chantal",
	  "Charleen",
	  "Charlotta",
	  "Charlotte",
	  "Chayenne",
	  "Cheyenne",
	  "Chiara",
	  "Christin",
	  "Christina",
	  "Cindy",
	  "Claire",
	  "Clara",
	  "Clarissa",
	  "Colleen",
	  "Collien",
	  "Cora",
	  "Corinna",
	  "Cosima",
	  "Dana",
	  "Daniela",
	  "Daria",
	  "Darleen",
	  "Defne",
	  "Delia",
	  "Denise",
	  "Diana",
	  "Dilara",
	  "Dina",
	  "Dorothea",
	  "Ecrin",
	  "Eda",
	  "Eileen",
	  "Ela",
	  "Elaine",
	  "Elanur",
	  "Elea",
	  "Elena",
	  "Eleni",
	  "Eleonora",
	  "Eliana",
	  "Elif",
	  "Elina",
	  "Elisa",
	  "Elisabeth",
	  "Ella",
	  "Ellen",
	  "Elli",
	  "Elly",
	  "Elsa",
	  "Emelie",
	  "Emely",
	  "Emilia",
	  "Emilie",
	  "Emily",
	  "Emma",
	  "Emmely",
	  "Emmi",
	  "Emmy",
	  "Enie",
	  "Enna",
	  "Enya",
	  "Esma",
	  "Estelle",
	  "Esther",
	  "Eva",
	  "Evelin",
	  "Evelina",
	  "Eveline",
	  "Evelyn",
	  "Fabienne",
	  "Fatima",
	  "Fatma",
	  "Felicia",
	  "Felicitas",
	  "Felina",
	  "Femke",
	  "Fenja",
	  "Fine",
	  "Finia",
	  "Finja",
	  "Finnja",
	  "Fiona",
	  "Flora",
	  "Florentine",
	  "Francesca",
	  "Franka",
	  "Franziska",
	  "Frederike",
	  "Freya",
	  "Frida",
	  "Frieda",
	  "Friederike",
	  "Giada",
	  "Gina",
	  "Giulia",
	  "Giuliana",
	  "Greta",
	  "Hailey",
	  "Hana",
	  "Hanna",
	  "Hannah",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helin",
	  "Henriette",
	  "Henrike",
	  "Hermine",
	  "Ida",
	  "Ilayda",
	  "Imke",
	  "Ina",
	  "Ines",
	  "Inga",
	  "Inka",
	  "Irem",
	  "Isa",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Ivonne",
	  "Jacqueline",
	  "Jamie",
	  "Jamila",
	  "Jana",
	  "Jane",
	  "Janin",
	  "Janina",
	  "Janine",
	  "Janna",
	  "Janne",
	  "Jara",
	  "Jasmin",
	  "Jasmina",
	  "Jasmine",
	  "Jella",
	  "Jenna",
	  "Jennifer",
	  "Jenny",
	  "Jessica",
	  "Jessy",
	  "Jette",
	  "Jil",
	  "Jill",
	  "Joana",
	  "Joanna",
	  "Joelina",
	  "Joeline",
	  "Joelle",
	  "Johanna",
	  "Joleen",
	  "Jolie",
	  "Jolien",
	  "Jolin",
	  "Jolina",
	  "Joline",
	  "Jona",
	  "Jonah",
	  "Jonna",
	  "Josefin",
	  "Josefine",
	  "Josephin",
	  "Josephine",
	  "Josie",
	  "Josy",
	  "Joy",
	  "Joyce",
	  "Judith",
	  "Judy",
	  "Jule",
	  "Julia",
	  "Juliana",
	  "Juliane",
	  "Julie",
	  "Julienne",
	  "Julika",
	  "Julina",
	  "Juna",
	  "Justine",
	  "Kaja",
	  "Karina",
	  "Karla",
	  "Karlotta",
	  "Karolina",
	  "Karoline",
	  "Kassandra",
	  "Katarina",
	  "Katharina",
	  "Kathrin",
	  "Katja",
	  "Katrin",
	  "Kaya",
	  "Kayra",
	  "Kiana",
	  "Kiara",
	  "Kim",
	  "Kimberley",
	  "Kimberly",
	  "Kira",
	  "Klara",
	  "Korinna",
	  "Kristin",
	  "Kyra",
	  "Laila",
	  "Lana",
	  "Lara",
	  "Larissa",
	  "Laura",
	  "Laureen",
	  "Lavinia",
	  "Lea",
	  "Leah",
	  "Leana",
	  "Leandra",
	  "Leann",
	  "Lee",
	  "Leila",
	  "Lena",
	  "Lene",
	  "Leni",
	  "Lenia",
	  "Lenja",
	  "Lenya",
	  "Leona",
	  "Leoni",
	  "Leonie",
	  "Leonora",
	  "Leticia",
	  "Letizia",
	  "Levke",
	  "Leyla",
	  "Lia",
	  "Liah",
	  "Liana",
	  "Lili",
	  "Lilia",
	  "Lilian",
	  "Liliana",
	  "Lilith",
	  "Lilli",
	  "Lillian",
	  "Lilly",
	  "Lily",
	  "Lina",
	  "Linda",
	  "Lindsay",
	  "Line",
	  "Linn",
	  "Linnea",
	  "Lisa",
	  "Lisann",
	  "Lisanne",
	  "Liv",
	  "Livia",
	  "Liz",
	  "Lola",
	  "Loreen",
	  "Lorena",
	  "Lotta",
	  "Lotte",
	  "Louisa",
	  "Louise",
	  "Luana",
	  "Luca",
	  "Lucia",
	  "Lucie",
	  "Lucienne",
	  "Lucy",
	  "Luisa",
	  "Luise",
	  "Luka",
	  "Luna",
	  "Luzie",
	  "Lya",
	  "Lydia",
	  "Lyn",
	  "Lynn",
	  "Madeleine",
	  "Madita",
	  "Madleen",
	  "Madlen",
	  "Magdalena",
	  "Maike",
	  "Mailin",
	  "Maira",
	  "Maja",
	  "Malena",
	  "Malia",
	  "Malin",
	  "Malina",
	  "Mandy",
	  "Mara",
	  "Marah",
	  "Mareike",
	  "Maren",
	  "Maria",
	  "Mariam",
	  "Marie",
	  "Marieke",
	  "Mariella",
	  "Marika",
	  "Marina",
	  "Marisa",
	  "Marissa",
	  "Marit",
	  "Marla",
	  "Marleen",
	  "Marlen",
	  "Marlena",
	  "Marlene",
	  "Marta",
	  "Martha",
	  "Mary",
	  "Maryam",
	  "Mathilda",
	  "Mathilde",
	  "Matilda",
	  "Maxi",
	  "Maxima",
	  "Maxine",
	  "Maya",
	  "Mayra",
	  "Medina",
	  "Medine",
	  "Meike",
	  "Melanie",
	  "Melek",
	  "Melike",
	  "Melina",
	  "Melinda",
	  "Melis",
	  "Melisa",
	  "Melissa",
	  "Merle",
	  "Merve",
	  "Meryem",
	  "Mette",
	  "Mia",
	  "Michaela",
	  "Michelle",
	  "Mieke",
	  "Mila",
	  "Milana",
	  "Milena",
	  "Milla",
	  "Mina",
	  "Mira",
	  "Miray",
	  "Miriam",
	  "Mirja",
	  "Mona",
	  "Monique",
	  "Nadine",
	  "Nadja",
	  "Naemi",
	  "Nancy",
	  "Naomi",
	  "Natalia",
	  "Natalie",
	  "Nathalie",
	  "Neele",
	  "Nela",
	  "Nele",
	  "Nelli",
	  "Nelly",
	  "Nia",
	  "Nicole",
	  "Nika",
	  "Nike",
	  "Nikita",
	  "Nila",
	  "Nina",
	  "Nisa",
	  "Noemi",
	  "Nora",
	  "Olivia",
	  "Patricia",
	  "Patrizia",
	  "Paula",
	  "Paulina",
	  "Pauline",
	  "Penelope",
	  "Philine",
	  "Phoebe",
	  "Pia",
	  "Rahel",
	  "Rania",
	  "Rebecca",
	  "Rebekka",
	  "Riana",
	  "Rieke",
	  "Rike",
	  "Romina",
	  "Romy",
	  "Ronja",
	  "Rosa",
	  "Rosalie",
	  "Ruby",
	  "Sabrina",
	  "Sahra",
	  "Sally",
	  "Salome",
	  "Samantha",
	  "Samia",
	  "Samira",
	  "Sandra",
	  "Sandy",
	  "Sanja",
	  "Saphira",
	  "Sara",
	  "Sarah",
	  "Saskia",
	  "Selin",
	  "Selina",
	  "Selma",
	  "Sena",
	  "Sidney",
	  "Sienna",
	  "Silja",
	  "Sina",
	  "Sinja",
	  "Smilla",
	  "Sofia",
	  "Sofie",
	  "Sonja",
	  "Sophia",
	  "Sophie",
	  "Soraya",
	  "Stefanie",
	  "Stella",
	  "Stephanie",
	  "Stina",
	  "Sude",
	  "Summer",
	  "Susanne",
	  "Svea",
	  "Svenja",
	  "Sydney",
	  "Tabea",
	  "Talea",
	  "Talia",
	  "Tamara",
	  "Tamia",
	  "Tamina",
	  "Tanja",
	  "Tara",
	  "Tarja",
	  "Teresa",
	  "Tessa",
	  "Thalea",
	  "Thalia",
	  "Thea",
	  "Theresa",
	  "Tia",
	  "Tina",
	  "Tomke",
	  "Tuana",
	  "Valentina",
	  "Valeria",
	  "Valerie",
	  "Vanessa",
	  "Vera",
	  "Veronika",
	  "Victoria",
	  "Viktoria",
	  "Viola",
	  "Vivian",
	  "Vivien",
	  "Vivienne",
	  "Wibke",
	  "Wiebke",
	  "Xenia",
	  "Yara",
	  "Yaren",
	  "Yasmin",
	  "Ylvi",
	  "Ylvie",
	  "Yvonne",
	  "Zara",
	  "Zehra",
	  "Zeynep",
	  "Zoe",
	  "Zoey",
	  "Zoé"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(1998);
	name.last_name = __webpack_require__(2000);
	name.prefix = __webpack_require__(2003);
	name.nobility_title_prefix = __webpack_require__(2002);
	name.name = __webpack_require__(2001);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abel",
	  "Abicht",
	  "Abraham",
	  "Abramovic",
	  "Abt",
	  "Achilles",
	  "Achkinadze",
	  "Ackermann",
	  "Adam",
	  "Adams",
	  "Ade",
	  "Agostini",
	  "Ahlke",
	  "Ahrenberg",
	  "Ahrens",
	  "Aigner",
	  "Albert",
	  "Albrecht",
	  "Alexa",
	  "Alexander",
	  "Alizadeh",
	  "Allgeyer",
	  "Amann",
	  "Amberg",
	  "Anding",
	  "Anggreny",
	  "Apitz",
	  "Arendt",
	  "Arens",
	  "Arndt",
	  "Aryee",
	  "Aschenbroich",
	  "Assmus",
	  "Astafei",
	  "Auer",
	  "Axmann",
	  "Baarck",
	  "Bachmann",
	  "Badane",
	  "Bader",
	  "Baganz",
	  "Bahl",
	  "Bak",
	  "Balcer",
	  "Balck",
	  "Balkow",
	  "Balnuweit",
	  "Balzer",
	  "Banse",
	  "Barr",
	  "Bartels",
	  "Barth",
	  "Barylla",
	  "Baseda",
	  "Battke",
	  "Bauer",
	  "Bauermeister",
	  "Baumann",
	  "Baumeister",
	  "Bauschinger",
	  "Bauschke",
	  "Bayer",
	  "Beavogui",
	  "Beck",
	  "Beckel",
	  "Becker",
	  "Beckmann",
	  "Bedewitz",
	  "Beele",
	  "Beer",
	  "Beggerow",
	  "Beh",
	  "Behr",
	  "Behrenbruch",
	  "Belz",
	  "Bender",
	  "Benecke",
	  "Benner",
	  "Benninger",
	  "Benzing",
	  "Berends",
	  "Berger",
	  "Berner",
	  "Berning",
	  "Bertenbreiter",
	  "Best",
	  "Bethke",
	  "Betz",
	  "Beushausen",
	  "Beutelspacher",
	  "Beyer",
	  "Biba",
	  "Bichler",
	  "Bickel",
	  "Biedermann",
	  "Bieler",
	  "Bielert",
	  "Bienasch",
	  "Bienias",
	  "Biesenbach",
	  "Bigdeli",
	  "Birkemeyer",
	  "Bittner",
	  "Blank",
	  "Blaschek",
	  "Blassneck",
	  "Bloch",
	  "Blochwitz",
	  "Blockhaus",
	  "Blum",
	  "Blume",
	  "Bock",
	  "Bode",
	  "Bogdashin",
	  "Bogenrieder",
	  "Bohge",
	  "Bolm",
	  "Borgschulze",
	  "Bork",
	  "Bormann",
	  "Bornscheuer",
	  "Borrmann",
	  "Borsch",
	  "Boruschewski",
	  "Bos",
	  "Bosler",
	  "Bourrouag",
	  "Bouschen",
	  "Boxhammer",
	  "Boyde",
	  "Bozsik",
	  "Brand",
	  "Brandenburg",
	  "Brandis",
	  "Brandt",
	  "Brauer",
	  "Braun",
	  "Brehmer",
	  "Breitenstein",
	  "Bremer",
	  "Bremser",
	  "Brenner",
	  "Brettschneider",
	  "Breu",
	  "Breuer",
	  "Briesenick",
	  "Bringmann",
	  "Brinkmann",
	  "Brix",
	  "Broening",
	  "Brosch",
	  "Bruckmann",
	  "Bruder",
	  "Bruhns",
	  "Brunner",
	  "Bruns",
	  "Bräutigam",
	  "Brömme",
	  "Brüggmann",
	  "Buchholz",
	  "Buchrucker",
	  "Buder",
	  "Bultmann",
	  "Bunjes",
	  "Burger",
	  "Burghagen",
	  "Burkhard",
	  "Burkhardt",
	  "Burmeister",
	  "Busch",
	  "Buschbaum",
	  "Busemann",
	  "Buss",
	  "Busse",
	  "Bussmann",
	  "Byrd",
	  "Bäcker",
	  "Böhm",
	  "Bönisch",
	  "Börgeling",
	  "Börner",
	  "Böttner",
	  "Büchele",
	  "Bühler",
	  "Büker",
	  "Büngener",
	  "Bürger",
	  "Bürklein",
	  "Büscher",
	  "Büttner",
	  "Camara",
	  "Carlowitz",
	  "Carlsohn",
	  "Caspari",
	  "Caspers",
	  "Chapron",
	  "Christ",
	  "Cierpinski",
	  "Clarius",
	  "Cleem",
	  "Cleve",
	  "Co",
	  "Conrad",
	  "Cordes",
	  "Cornelsen",
	  "Cors",
	  "Cotthardt",
	  "Crews",
	  "Cronjäger",
	  "Crosskofp",
	  "Da",
	  "Dahm",
	  "Dahmen",
	  "Daimer",
	  "Damaske",
	  "Danneberg",
	  "Danner",
	  "Daub",
	  "Daubner",
	  "Daudrich",
	  "Dauer",
	  "Daum",
	  "Dauth",
	  "Dautzenberg",
	  "De",
	  "Decker",
	  "Deckert",
	  "Deerberg",
	  "Dehmel",
	  "Deja",
	  "Delonge",
	  "Demut",
	  "Dengler",
	  "Denner",
	  "Denzinger",
	  "Derr",
	  "Dertmann",
	  "Dethloff",
	  "Deuschle",
	  "Dieckmann",
	  "Diedrich",
	  "Diekmann",
	  "Dienel",
	  "Dies",
	  "Dietrich",
	  "Dietz",
	  "Dietzsch",
	  "Diezel",
	  "Dilla",
	  "Dingelstedt",
	  "Dippl",
	  "Dittmann",
	  "Dittmar",
	  "Dittmer",
	  "Dix",
	  "Dobbrunz",
	  "Dobler",
	  "Dohring",
	  "Dolch",
	  "Dold",
	  "Dombrowski",
	  "Donie",
	  "Doskoczynski",
	  "Dragu",
	  "Drechsler",
	  "Drees",
	  "Dreher",
	  "Dreier",
	  "Dreissigacker",
	  "Dressler",
	  "Drews",
	  "Duma",
	  "Dutkiewicz",
	  "Dyett",
	  "Dylus",
	  "Dächert",
	  "Döbel",
	  "Döring",
	  "Dörner",
	  "Dörre",
	  "Dück",
	  "Eberhard",
	  "Eberhardt",
	  "Ecker",
	  "Eckhardt",
	  "Edorh",
	  "Effler",
	  "Eggenmueller",
	  "Ehm",
	  "Ehmann",
	  "Ehrig",
	  "Eich",
	  "Eichmann",
	  "Eifert",
	  "Einert",
	  "Eisenlauer",
	  "Ekpo",
	  "Elbe",
	  "Eleyth",
	  "Elss",
	  "Emert",
	  "Emmelmann",
	  "Ender",
	  "Engel",
	  "Engelen",
	  "Engelmann",
	  "Eplinius",
	  "Erdmann",
	  "Erhardt",
	  "Erlei",
	  "Erm",
	  "Ernst",
	  "Ertl",
	  "Erwes",
	  "Esenwein",
	  "Esser",
	  "Evers",
	  "Everts",
	  "Ewald",
	  "Fahner",
	  "Faller",
	  "Falter",
	  "Farber",
	  "Fassbender",
	  "Faulhaber",
	  "Fehrig",
	  "Feld",
	  "Felke",
	  "Feller",
	  "Fenner",
	  "Fenske",
	  "Feuerbach",
	  "Fietz",
	  "Figl",
	  "Figura",
	  "Filipowski",
	  "Filsinger",
	  "Fincke",
	  "Fink",
	  "Finke",
	  "Fischer",
	  "Fitschen",
	  "Fleischer",
	  "Fleischmann",
	  "Floder",
	  "Florczak",
	  "Flore",
	  "Flottmann",
	  "Forkel",
	  "Forst",
	  "Frahmeke",
	  "Frank",
	  "Franke",
	  "Franta",
	  "Frantz",
	  "Franz",
	  "Franzis",
	  "Franzmann",
	  "Frauen",
	  "Frauendorf",
	  "Freigang",
	  "Freimann",
	  "Freimuth",
	  "Freisen",
	  "Frenzel",
	  "Frey",
	  "Fricke",
	  "Fried",
	  "Friedek",
	  "Friedenberg",
	  "Friedmann",
	  "Friedrich",
	  "Friess",
	  "Frisch",
	  "Frohn",
	  "Frosch",
	  "Fuchs",
	  "Fuhlbrügge",
	  "Fusenig",
	  "Fust",
	  "Förster",
	  "Gaba",
	  "Gabius",
	  "Gabler",
	  "Gadschiew",
	  "Gakstädter",
	  "Galander",
	  "Gamlin",
	  "Gamper",
	  "Gangnus",
	  "Ganzmann",
	  "Garatva",
	  "Gast",
	  "Gastel",
	  "Gatzka",
	  "Gauder",
	  "Gebhardt",
	  "Geese",
	  "Gehre",
	  "Gehrig",
	  "Gehring",
	  "Gehrke",
	  "Geiger",
	  "Geisler",
	  "Geissler",
	  "Gelling",
	  "Gens",
	  "Gerbennow",
	  "Gerdel",
	  "Gerhardt",
	  "Gerschler",
	  "Gerson",
	  "Gesell",
	  "Geyer",
	  "Ghirmai",
	  "Ghosh",
	  "Giehl",
	  "Gierisch",
	  "Giesa",
	  "Giesche",
	  "Gilde",
	  "Glatting",
	  "Goebel",
	  "Goedicke",
	  "Goldbeck",
	  "Goldfuss",
	  "Goldkamp",
	  "Goldkühle",
	  "Goller",
	  "Golling",
	  "Gollnow",
	  "Golomski",
	  "Gombert",
	  "Gotthardt",
	  "Gottschalk",
	  "Gotz",
	  "Goy",
	  "Gradzki",
	  "Graf",
	  "Grams",
	  "Grasse",
	  "Gratzky",
	  "Grau",
	  "Greb",
	  "Green",
	  "Greger",
	  "Greithanner",
	  "Greschner",
	  "Griem",
	  "Griese",
	  "Grimm",
	  "Gromisch",
	  "Gross",
	  "Grosser",
	  "Grossheim",
	  "Grosskopf",
	  "Grothaus",
	  "Grothkopp",
	  "Grotke",
	  "Grube",
	  "Gruber",
	  "Grundmann",
	  "Gruning",
	  "Gruszecki",
	  "Gröss",
	  "Grötzinger",
	  "Grün",
	  "Grüner",
	  "Gummelt",
	  "Gunkel",
	  "Gunther",
	  "Gutjahr",
	  "Gutowicz",
	  "Gutschank",
	  "Göbel",
	  "Göckeritz",
	  "Göhler",
	  "Görlich",
	  "Görmer",
	  "Götz",
	  "Götzelmann",
	  "Güldemeister",
	  "Günther",
	  "Günz",
	  "Gürbig",
	  "Haack",
	  "Haaf",
	  "Habel",
	  "Hache",
	  "Hackbusch",
	  "Hackelbusch",
	  "Hadfield",
	  "Hadwich",
	  "Haferkamp",
	  "Hahn",
	  "Hajek",
	  "Hallmann",
	  "Hamann",
	  "Hanenberger",
	  "Hannecker",
	  "Hanniske",
	  "Hansen",
	  "Hardy",
	  "Hargasser",
	  "Harms",
	  "Harnapp",
	  "Harter",
	  "Harting",
	  "Hartlieb",
	  "Hartmann",
	  "Hartwig",
	  "Hartz",
	  "Haschke",
	  "Hasler",
	  "Hasse",
	  "Hassfeld",
	  "Haug",
	  "Hauke",
	  "Haupt",
	  "Haverney",
	  "Heberstreit",
	  "Hechler",
	  "Hecht",
	  "Heck",
	  "Hedermann",
	  "Hehl",
	  "Heidelmann",
	  "Heidler",
	  "Heinemann",
	  "Heinig",
	  "Heinke",
	  "Heinrich",
	  "Heinze",
	  "Heiser",
	  "Heist",
	  "Hellmann",
	  "Helm",
	  "Helmke",
	  "Helpling",
	  "Hengmith",
	  "Henkel",
	  "Hennes",
	  "Henry",
	  "Hense",
	  "Hensel",
	  "Hentel",
	  "Hentschel",
	  "Hentschke",
	  "Hepperle",
	  "Herberger",
	  "Herbrand",
	  "Hering",
	  "Hermann",
	  "Hermecke",
	  "Herms",
	  "Herold",
	  "Herrmann",
	  "Herschmann",
	  "Hertel",
	  "Herweg",
	  "Herwig",
	  "Herzenberg",
	  "Hess",
	  "Hesse",
	  "Hessek",
	  "Hessler",
	  "Hetzler",
	  "Heuck",
	  "Heydemüller",
	  "Hiebl",
	  "Hildebrand",
	  "Hildenbrand",
	  "Hilgendorf",
	  "Hillard",
	  "Hiller",
	  "Hingsen",
	  "Hingst",
	  "Hinrichs",
	  "Hirsch",
	  "Hirschberg",
	  "Hirt",
	  "Hodea",
	  "Hoffman",
	  "Hoffmann",
	  "Hofmann",
	  "Hohenberger",
	  "Hohl",
	  "Hohn",
	  "Hohnheiser",
	  "Hold",
	  "Holdt",
	  "Holinski",
	  "Holl",
	  "Holtfreter",
	  "Holz",
	  "Holzdeppe",
	  "Holzner",
	  "Hommel",
	  "Honz",
	  "Hooss",
	  "Hoppe",
	  "Horak",
	  "Horn",
	  "Horna",
	  "Hornung",
	  "Hort",
	  "Howard",
	  "Huber",
	  "Huckestein",
	  "Hudak",
	  "Huebel",
	  "Hugo",
	  "Huhn",
	  "Hujo",
	  "Huke",
	  "Huls",
	  "Humbert",
	  "Huneke",
	  "Huth",
	  "Häber",
	  "Häfner",
	  "Höcke",
	  "Höft",
	  "Höhne",
	  "Hönig",
	  "Hördt",
	  "Hübenbecker",
	  "Hübl",
	  "Hübner",
	  "Hügel",
	  "Hüttcher",
	  "Hütter",
	  "Ibe",
	  "Ihly",
	  "Illing",
	  "Isak",
	  "Isekenmeier",
	  "Itt",
	  "Jacob",
	  "Jacobs",
	  "Jagusch",
	  "Jahn",
	  "Jahnke",
	  "Jakobs",
	  "Jakubczyk",
	  "Jambor",
	  "Jamrozy",
	  "Jander",
	  "Janich",
	  "Janke",
	  "Jansen",
	  "Jarets",
	  "Jaros",
	  "Jasinski",
	  "Jasper",
	  "Jegorov",
	  "Jellinghaus",
	  "Jeorga",
	  "Jerschabek",
	  "Jess",
	  "John",
	  "Jonas",
	  "Jossa",
	  "Jucken",
	  "Jung",
	  "Jungbluth",
	  "Jungton",
	  "Just",
	  "Jürgens",
	  "Kaczmarek",
	  "Kaesmacher",
	  "Kahl",
	  "Kahlert",
	  "Kahles",
	  "Kahlmeyer",
	  "Kaiser",
	  "Kalinowski",
	  "Kallabis",
	  "Kallensee",
	  "Kampf",
	  "Kampschulte",
	  "Kappe",
	  "Kappler",
	  "Karhoff",
	  "Karrass",
	  "Karst",
	  "Karsten",
	  "Karus",
	  "Kass",
	  "Kasten",
	  "Kastner",
	  "Katzinski",
	  "Kaufmann",
	  "Kaul",
	  "Kausemann",
	  "Kawohl",
	  "Kazmarek",
	  "Kedzierski",
	  "Keil",
	  "Keiner",
	  "Keller",
	  "Kelm",
	  "Kempe",
	  "Kemper",
	  "Kempter",
	  "Kerl",
	  "Kern",
	  "Kesselring",
	  "Kesselschläger",
	  "Kette",
	  "Kettenis",
	  "Keutel",
	  "Kick",
	  "Kiessling",
	  "Kinadeter",
	  "Kinzel",
	  "Kinzy",
	  "Kirch",
	  "Kirst",
	  "Kisabaka",
	  "Klaas",
	  "Klabuhn",
	  "Klapper",
	  "Klauder",
	  "Klaus",
	  "Kleeberg",
	  "Kleiber",
	  "Klein",
	  "Kleinert",
	  "Kleininger",
	  "Kleinmann",
	  "Kleinsteuber",
	  "Kleiss",
	  "Klemme",
	  "Klimczak",
	  "Klinger",
	  "Klink",
	  "Klopsch",
	  "Klose",
	  "Kloss",
	  "Kluge",
	  "Kluwe",
	  "Knabe",
	  "Kneifel",
	  "Knetsch",
	  "Knies",
	  "Knippel",
	  "Knobel",
	  "Knoblich",
	  "Knoll",
	  "Knorr",
	  "Knorscheidt",
	  "Knut",
	  "Kobs",
	  "Koch",
	  "Kochan",
	  "Kock",
	  "Koczulla",
	  "Koderisch",
	  "Koehl",
	  "Koehler",
	  "Koenig",
	  "Koester",
	  "Kofferschlager",
	  "Koha",
	  "Kohle",
	  "Kohlmann",
	  "Kohnle",
	  "Kohrt",
	  "Koj",
	  "Kolb",
	  "Koleiski",
	  "Kolokas",
	  "Komoll",
	  "Konieczny",
	  "Konig",
	  "Konow",
	  "Konya",
	  "Koob",
	  "Kopf",
	  "Kosenkow",
	  "Koster",
	  "Koszewski",
	  "Koubaa",
	  "Kovacs",
	  "Kowalick",
	  "Kowalinski",
	  "Kozakiewicz",
	  "Krabbe",
	  "Kraft",
	  "Kral",
	  "Kramer",
	  "Krauel",
	  "Kraus",
	  "Krause",
	  "Krauspe",
	  "Kreb",
	  "Krebs",
	  "Kreissig",
	  "Kresse",
	  "Kreutz",
	  "Krieger",
	  "Krippner",
	  "Krodinger",
	  "Krohn",
	  "Krol",
	  "Kron",
	  "Krueger",
	  "Krug",
	  "Kruger",
	  "Krull",
	  "Kruschinski",
	  "Krämer",
	  "Kröckert",
	  "Kröger",
	  "Krüger",
	  "Kubera",
	  "Kufahl",
	  "Kuhlee",
	  "Kuhnen",
	  "Kulimann",
	  "Kulma",
	  "Kumbernuss",
	  "Kummle",
	  "Kunz",
	  "Kupfer",
	  "Kupprion",
	  "Kuprion",
	  "Kurnicki",
	  "Kurrat",
	  "Kurschilgen",
	  "Kuschewitz",
	  "Kuschmann",
	  "Kuske",
	  "Kustermann",
	  "Kutscherauer",
	  "Kutzner",
	  "Kwadwo",
	  "Kähler",
	  "Käther",
	  "Köhler",
	  "Köhrbrück",
	  "Köhre",
	  "Kölotzei",
	  "König",
	  "Köpernick",
	  "Köseoglu",
	  "Kúhn",
	  "Kúhnert",
	  "Kühn",
	  "Kühnel",
	  "Kühnemund",
	  "Kühnert",
	  "Kühnke",
	  "Küsters",
	  "Küter",
	  "Laack",
	  "Lack",
	  "Ladewig",
	  "Lakomy",
	  "Lammert",
	  "Lamos",
	  "Landmann",
	  "Lang",
	  "Lange",
	  "Langfeld",
	  "Langhirt",
	  "Lanig",
	  "Lauckner",
	  "Lauinger",
	  "Laurén",
	  "Lausecker",
	  "Laux",
	  "Laws",
	  "Lax",
	  "Leberer",
	  "Lehmann",
	  "Lehner",
	  "Leibold",
	  "Leide",
	  "Leimbach",
	  "Leipold",
	  "Leist",
	  "Leiter",
	  "Leiteritz",
	  "Leitheim",
	  "Leiwesmeier",
	  "Lenfers",
	  "Lenk",
	  "Lenz",
	  "Lenzen",
	  "Leo",
	  "Lepthin",
	  "Lesch",
	  "Leschnik",
	  "Letzelter",
	  "Lewin",
	  "Lewke",
	  "Leyckes",
	  "Lg",
	  "Lichtenfeld",
	  "Lichtenhagen",
	  "Lichtl",
	  "Liebach",
	  "Liebe",
	  "Liebich",
	  "Liebold",
	  "Lieder",
	  "Lienshöft",
	  "Linden",
	  "Lindenberg",
	  "Lindenmayer",
	  "Lindner",
	  "Linke",
	  "Linnenbaum",
	  "Lippe",
	  "Lipske",
	  "Lipus",
	  "Lischka",
	  "Lobinger",
	  "Logsch",
	  "Lohmann",
	  "Lohre",
	  "Lohse",
	  "Lokar",
	  "Loogen",
	  "Lorenz",
	  "Losch",
	  "Loska",
	  "Lott",
	  "Loy",
	  "Lubina",
	  "Ludolf",
	  "Lufft",
	  "Lukoschek",
	  "Lutje",
	  "Lutz",
	  "Löser",
	  "Löwa",
	  "Lübke",
	  "Maak",
	  "Maczey",
	  "Madetzky",
	  "Madubuko",
	  "Mai",
	  "Maier",
	  "Maisch",
	  "Malek",
	  "Malkus",
	  "Mallmann",
	  "Malucha",
	  "Manns",
	  "Manz",
	  "Marahrens",
	  "Marchewski",
	  "Margis",
	  "Markowski",
	  "Marl",
	  "Marner",
	  "Marquart",
	  "Marschek",
	  "Martel",
	  "Marten",
	  "Martin",
	  "Marx",
	  "Marxen",
	  "Mathes",
	  "Mathies",
	  "Mathiszik",
	  "Matschke",
	  "Mattern",
	  "Matthes",
	  "Matula",
	  "Mau",
	  "Maurer",
	  "Mauroff",
	  "May",
	  "Maybach",
	  "Mayer",
	  "Mebold",
	  "Mehl",
	  "Mehlhorn",
	  "Mehlorn",
	  "Meier",
	  "Meisch",
	  "Meissner",
	  "Meloni",
	  "Melzer",
	  "Menga",
	  "Menne",
	  "Mensah",
	  "Mensing",
	  "Merkel",
	  "Merseburg",
	  "Mertens",
	  "Mesloh",
	  "Metzger",
	  "Metzner",
	  "Mewes",
	  "Meyer",
	  "Michallek",
	  "Michel",
	  "Mielke",
	  "Mikitenko",
	  "Milde",
	  "Minah",
	  "Mintzlaff",
	  "Mockenhaupt",
	  "Moede",
	  "Moedl",
	  "Moeller",
	  "Moguenara",
	  "Mohr",
	  "Mohrhard",
	  "Molitor",
	  "Moll",
	  "Moller",
	  "Molzan",
	  "Montag",
	  "Moormann",
	  "Mordhorst",
	  "Morgenstern",
	  "Morhelfer",
	  "Moritz",
	  "Moser",
	  "Motchebon",
	  "Motzenbbäcker",
	  "Mrugalla",
	  "Muckenthaler",
	  "Mues",
	  "Muller",
	  "Mulrain",
	  "Mächtig",
	  "Mäder",
	  "Möcks",
	  "Mögenburg",
	  "Möhsner",
	  "Möldner",
	  "Möllenbeck",
	  "Möller",
	  "Möllinger",
	  "Mörsch",
	  "Mühleis",
	  "Müller",
	  "Münch",
	  "Nabein",
	  "Nabow",
	  "Nagel",
	  "Nannen",
	  "Nastvogel",
	  "Nau",
	  "Naubert",
	  "Naumann",
	  "Ne",
	  "Neimke",
	  "Nerius",
	  "Neubauer",
	  "Neubert",
	  "Neuendorf",
	  "Neumair",
	  "Neumann",
	  "Neupert",
	  "Neurohr",
	  "Neuschwander",
	  "Newton",
	  "Ney",
	  "Nicolay",
	  "Niedermeier",
	  "Nieklauson",
	  "Niklaus",
	  "Nitzsche",
	  "Noack",
	  "Nodler",
	  "Nolte",
	  "Normann",
	  "Norris",
	  "Northoff",
	  "Nowak",
	  "Nussbeck",
	  "Nwachukwu",
	  "Nytra",
	  "Nöh",
	  "Oberem",
	  "Obergföll",
	  "Obermaier",
	  "Ochs",
	  "Oeser",
	  "Olbrich",
	  "Onnen",
	  "Ophey",
	  "Oppong",
	  "Orth",
	  "Orthmann",
	  "Oschkenat",
	  "Osei",
	  "Osenberg",
	  "Ostendarp",
	  "Ostwald",
	  "Otte",
	  "Otto",
	  "Paesler",
	  "Pajonk",
	  "Pallentin",
	  "Panzig",
	  "Paschke",
	  "Patzwahl",
	  "Paukner",
	  "Peselman",
	  "Peter",
	  "Peters",
	  "Petzold",
	  "Pfeiffer",
	  "Pfennig",
	  "Pfersich",
	  "Pfingsten",
	  "Pflieger",
	  "Pflügner",
	  "Philipp",
	  "Pichlmaier",
	  "Piesker",
	  "Pietsch",
	  "Pingpank",
	  "Pinnock",
	  "Pippig",
	  "Pitschugin",
	  "Plank",
	  "Plass",
	  "Platzer",
	  "Plauk",
	  "Plautz",
	  "Pletsch",
	  "Plotzitzka",
	  "Poehn",
	  "Poeschl",
	  "Pogorzelski",
	  "Pohl",
	  "Pohland",
	  "Pohle",
	  "Polifka",
	  "Polizzi",
	  "Pollmächer",
	  "Pomp",
	  "Ponitzsch",
	  "Porsche",
	  "Porth",
	  "Poschmann",
	  "Poser",
	  "Pottel",
	  "Prah",
	  "Prange",
	  "Prediger",
	  "Pressler",
	  "Preuk",
	  "Preuss",
	  "Prey",
	  "Priemer",
	  "Proske",
	  "Pusch",
	  "Pöche",
	  "Pöge",
	  "Raabe",
	  "Rabenstein",
	  "Rach",
	  "Radtke",
	  "Rahn",
	  "Ranftl",
	  "Rangen",
	  "Ranz",
	  "Rapp",
	  "Rath",
	  "Rau",
	  "Raubuch",
	  "Raukuc",
	  "Rautenkranz",
	  "Rehwagen",
	  "Reiber",
	  "Reichardt",
	  "Reichel",
	  "Reichling",
	  "Reif",
	  "Reifenrath",
	  "Reimann",
	  "Reinberg",
	  "Reinelt",
	  "Reinhardt",
	  "Reinke",
	  "Reitze",
	  "Renk",
	  "Rentz",
	  "Renz",
	  "Reppin",
	  "Restle",
	  "Restorff",
	  "Retzke",
	  "Reuber",
	  "Reumann",
	  "Reus",
	  "Reuss",
	  "Reusse",
	  "Rheder",
	  "Rhoden",
	  "Richards",
	  "Richter",
	  "Riedel",
	  "Riediger",
	  "Rieger",
	  "Riekmann",
	  "Riepl",
	  "Riermeier",
	  "Riester",
	  "Riethmüller",
	  "Rietmüller",
	  "Rietscher",
	  "Ringel",
	  "Ringer",
	  "Rink",
	  "Ripken",
	  "Ritosek",
	  "Ritschel",
	  "Ritter",
	  "Rittweg",
	  "Ritz",
	  "Roba",
	  "Rockmeier",
	  "Rodehau",
	  "Rodowski",
	  "Roecker",
	  "Roggatz",
	  "Rohländer",
	  "Rohrer",
	  "Rokossa",
	  "Roleder",
	  "Roloff",
	  "Roos",
	  "Rosbach",
	  "Roschinsky",
	  "Rose",
	  "Rosenauer",
	  "Rosenbauer",
	  "Rosenthal",
	  "Rosksch",
	  "Rossberg",
	  "Rossler",
	  "Roth",
	  "Rother",
	  "Ruch",
	  "Ruckdeschel",
	  "Rumpf",
	  "Rupprecht",
	  "Ruth",
	  "Ryjikh",
	  "Ryzih",
	  "Rädler",
	  "Räntsch",
	  "Rödiger",
	  "Röse",
	  "Röttger",
	  "Rücker",
	  "Rüdiger",
	  "Rüter",
	  "Sachse",
	  "Sack",
	  "Saflanis",
	  "Sagafe",
	  "Sagonas",
	  "Sahner",
	  "Saile",
	  "Sailer",
	  "Salow",
	  "Salzer",
	  "Salzmann",
	  "Sammert",
	  "Sander",
	  "Sarvari",
	  "Sattelmaier",
	  "Sauer",
	  "Sauerland",
	  "Saumweber",
	  "Savoia",
	  "Scc",
	  "Schacht",
	  "Schaefer",
	  "Schaffarzik",
	  "Schahbasian",
	  "Scharf",
	  "Schedler",
	  "Scheer",
	  "Schelk",
	  "Schellenbeck",
	  "Schembera",
	  "Schenk",
	  "Scherbarth",
	  "Scherer",
	  "Schersing",
	  "Scherz",
	  "Scheurer",
	  "Scheuring",
	  "Scheytt",
	  "Schielke",
	  "Schieskow",
	  "Schildhauer",
	  "Schilling",
	  "Schima",
	  "Schimmer",
	  "Schindzielorz",
	  "Schirmer",
	  "Schirrmeister",
	  "Schlachter",
	  "Schlangen",
	  "Schlawitz",
	  "Schlechtweg",
	  "Schley",
	  "Schlicht",
	  "Schlitzer",
	  "Schmalzle",
	  "Schmid",
	  "Schmidt",
	  "Schmidtchen",
	  "Schmitt",
	  "Schmitz",
	  "Schmuhl",
	  "Schneider",
	  "Schnelting",
	  "Schnieder",
	  "Schniedermeier",
	  "Schnürer",
	  "Schoberg",
	  "Scholz",
	  "Schonberg",
	  "Schondelmaier",
	  "Schorr",
	  "Schott",
	  "Schottmann",
	  "Schouren",
	  "Schrader",
	  "Schramm",
	  "Schreck",
	  "Schreiber",
	  "Schreiner",
	  "Schreiter",
	  "Schroder",
	  "Schröder",
	  "Schuermann",
	  "Schuff",
	  "Schuhaj",
	  "Schuldt",
	  "Schult",
	  "Schulte",
	  "Schultz",
	  "Schultze",
	  "Schulz",
	  "Schulze",
	  "Schumacher",
	  "Schumann",
	  "Schupp",
	  "Schuri",
	  "Schuster",
	  "Schwab",
	  "Schwalm",
	  "Schwanbeck",
	  "Schwandke",
	  "Schwanitz",
	  "Schwarthoff",
	  "Schwartz",
	  "Schwarz",
	  "Schwarzer",
	  "Schwarzkopf",
	  "Schwarzmeier",
	  "Schwatlo",
	  "Schweisfurth",
	  "Schwennen",
	  "Schwerdtner",
	  "Schwidde",
	  "Schwirkschlies",
	  "Schwuchow",
	  "Schäfer",
	  "Schäffel",
	  "Schäffer",
	  "Schäning",
	  "Schöckel",
	  "Schönball",
	  "Schönbeck",
	  "Schönberg",
	  "Schönebeck",
	  "Schönenberger",
	  "Schönfeld",
	  "Schönherr",
	  "Schönlebe",
	  "Schötz",
	  "Schüler",
	  "Schüppel",
	  "Schütz",
	  "Schütze",
	  "Seeger",
	  "Seelig",
	  "Sehls",
	  "Seibold",
	  "Seidel",
	  "Seiders",
	  "Seigel",
	  "Seiler",
	  "Seitz",
	  "Semisch",
	  "Senkel",
	  "Sewald",
	  "Siebel",
	  "Siebert",
	  "Siegling",
	  "Sielemann",
	  "Siemon",
	  "Siener",
	  "Sievers",
	  "Siewert",
	  "Sihler",
	  "Sillah",
	  "Simon",
	  "Sinnhuber",
	  "Sischka",
	  "Skibicki",
	  "Sladek",
	  "Slotta",
	  "Smieja",
	  "Soboll",
	  "Sokolowski",
	  "Soller",
	  "Sollner",
	  "Sommer",
	  "Somssich",
	  "Sonn",
	  "Sonnabend",
	  "Spahn",
	  "Spank",
	  "Spelmeyer",
	  "Spiegelburg",
	  "Spielvogel",
	  "Spinner",
	  "Spitzmüller",
	  "Splinter",
	  "Sporrer",
	  "Sprenger",
	  "Spöttel",
	  "Stahl",
	  "Stang",
	  "Stanger",
	  "Stauss",
	  "Steding",
	  "Steffen",
	  "Steffny",
	  "Steidl",
	  "Steigauf",
	  "Stein",
	  "Steinecke",
	  "Steinert",
	  "Steinkamp",
	  "Steinmetz",
	  "Stelkens",
	  "Stengel",
	  "Stengl",
	  "Stenzel",
	  "Stepanov",
	  "Stephan",
	  "Stern",
	  "Steuk",
	  "Stief",
	  "Stifel",
	  "Stoll",
	  "Stolle",
	  "Stolz",
	  "Storl",
	  "Storp",
	  "Stoutjesdijk",
	  "Stratmann",
	  "Straub",
	  "Strausa",
	  "Streck",
	  "Streese",
	  "Strege",
	  "Streit",
	  "Streller",
	  "Strieder",
	  "Striezel",
	  "Strogies",
	  "Strohschank",
	  "Strunz",
	  "Strutz",
	  "Stube",
	  "Stöckert",
	  "Stöppler",
	  "Stöwer",
	  "Stürmer",
	  "Suffa",
	  "Sujew",
	  "Sussmann",
	  "Suthe",
	  "Sutschet",
	  "Swillims",
	  "Szendrei",
	  "Sören",
	  "Sürth",
	  "Tafelmeier",
	  "Tang",
	  "Tasche",
	  "Taufratshofer",
	  "Tegethof",
	  "Teichmann",
	  "Tepper",
	  "Terheiden",
	  "Terlecki",
	  "Teufel",
	  "Theele",
	  "Thieke",
	  "Thimm",
	  "Thiomas",
	  "Thomas",
	  "Thriene",
	  "Thränhardt",
	  "Thust",
	  "Thyssen",
	  "Thöne",
	  "Tidow",
	  "Tiedtke",
	  "Tietze",
	  "Tilgner",
	  "Tillack",
	  "Timmermann",
	  "Tischler",
	  "Tischmann",
	  "Tittman",
	  "Tivontschik",
	  "Tonat",
	  "Tonn",
	  "Trampeli",
	  "Trauth",
	  "Trautmann",
	  "Travan",
	  "Treff",
	  "Tremmel",
	  "Tress",
	  "Tsamonikian",
	  "Tschiers",
	  "Tschirch",
	  "Tuch",
	  "Tucholke",
	  "Tudow",
	  "Tuschmo",
	  "Tächl",
	  "Többen",
	  "Töpfer",
	  "Uhlemann",
	  "Uhlig",
	  "Uhrig",
	  "Uibel",
	  "Uliczka",
	  "Ullmann",
	  "Ullrich",
	  "Umbach",
	  "Umlauft",
	  "Umminger",
	  "Unger",
	  "Unterpaintner",
	  "Urban",
	  "Urbaniak",
	  "Urbansky",
	  "Urhig",
	  "Vahlensieck",
	  "Van",
	  "Vangermain",
	  "Vater",
	  "Venghaus",
	  "Verniest",
	  "Verzi",
	  "Vey",
	  "Viellehner",
	  "Vieweg",
	  "Voelkel",
	  "Vogel",
	  "Vogelgsang",
	  "Vogt",
	  "Voigt",
	  "Vokuhl",
	  "Volk",
	  "Volker",
	  "Volkmann",
	  "Von",
	  "Vona",
	  "Vontein",
	  "Wachenbrunner",
	  "Wachtel",
	  "Wagner",
	  "Waibel",
	  "Wakan",
	  "Waldmann",
	  "Wallner",
	  "Wallstab",
	  "Walter",
	  "Walther",
	  "Walton",
	  "Walz",
	  "Wanner",
	  "Wartenberg",
	  "Waschbüsch",
	  "Wassilew",
	  "Wassiluk",
	  "Weber",
	  "Wehrsen",
	  "Weidlich",
	  "Weidner",
	  "Weigel",
	  "Weight",
	  "Weiler",
	  "Weimer",
	  "Weis",
	  "Weiss",
	  "Weller",
	  "Welsch",
	  "Welz",
	  "Welzel",
	  "Weniger",
	  "Wenk",
	  "Werle",
	  "Werner",
	  "Werrmann",
	  "Wessel",
	  "Wessinghage",
	  "Weyel",
	  "Wezel",
	  "Wichmann",
	  "Wickert",
	  "Wiebe",
	  "Wiechmann",
	  "Wiegelmann",
	  "Wierig",
	  "Wiese",
	  "Wieser",
	  "Wilhelm",
	  "Wilky",
	  "Will",
	  "Willwacher",
	  "Wilts",
	  "Wimmer",
	  "Winkelmann",
	  "Winkler",
	  "Winter",
	  "Wischek",
	  "Wischer",
	  "Wissing",
	  "Wittich",
	  "Wittl",
	  "Wolf",
	  "Wolfarth",
	  "Wolff",
	  "Wollenberg",
	  "Wollmann",
	  "Woytkowska",
	  "Wujak",
	  "Wurm",
	  "Wyludda",
	  "Wölpert",
	  "Wöschler",
	  "Wühn",
	  "Wünsche",
	  "Zach",
	  "Zaczkiewicz",
	  "Zahn",
	  "Zaituc",
	  "Zandt",
	  "Zanner",
	  "Zapletal",
	  "Zauber",
	  "Zeidler",
	  "Zekl",
	  "Zender",
	  "Zeuch",
	  "Zeyen",
	  "Zeyhle",
	  "Ziegler",
	  "Zimanyi",
	  "Zimmer",
	  "Zimmermann",
	  "Zinser",
	  "Zintl",
	  "Zipp",
	  "Zipse",
	  "Zschunke",
	  "Zuber",
	  "Zwiener",
	  "Zümsande",
	  "Östringer",
	  "Überacker"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{nobility_title_prefix} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "zu",
	  "von",
	  "vom",
	  "von der"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01 #######",
	  "01#######",
	  "+43-1-#######",
	  "+431#######",
	  "0#### ####",
	  "0#########",
	  "+43-####-####",
	  "+43 ########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2004);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "CH",
	  "CH",
	  "CH",
	  "DE",
	  "AT",
	  "US",
	  "LI",
	  "US",
	  "HK",
	  "VN"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Schweiz"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country_code = __webpack_require__(2006);
	address.postcode = __webpack_require__(2009);
	address.default_country = __webpack_require__(2007);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###",
	  "8###",
	  "9###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2012);
	company.name = __webpack_require__(2011);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} und #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AG",
	  "GmbH",
	  "und Söhne",
	  "und Partner",
	  "& Co.",
	  "Gruppe",
	  "LLC",
	  "Inc."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var de_CH = {};
	module['exports'] = de_CH;
	de_CH.title = "German (Switzerland)";
	de_CH.address = __webpack_require__(2008);
	de_CH.company = __webpack_require__(2010);
	de_CH.internet = __webpack_require__(2015);
	de_CH.name = __webpack_require__(2017);
	de_CH.phone_number = __webpack_require__(2022);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "biz",
	  "ch",
	  "de",
	  "li",
	  "at",
	  "ch",
	  "ch"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2014);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	    "Adolf",
	    "Adrian",
	    "Agnes",
	    "Alain",
	    "Albert",
	    "Alberto",
	    "Aldo",
	    "Alex",
	    "Alexander",
	    "Alexandre",
	    "Alfons",
	    "Alfred",
	    "Alice",
	    "Alois",
	    "André",
	    "Andrea",
	    "Andreas",
	    "Angela",
	    "Angelo",
	    "Anita",
	    "Anna",
	    "Anne",
	    "Anne-Marie",
	    "Annemarie",
	    "Antoine",
	    "Anton",
	    "Antonio",
	    "Armin",
	    "Arnold",
	    "Arthur",
	    "Astrid",
	    "Barbara",
	    "Beat",
	    "Beatrice",
	    "Beatrix",
	    "Bernadette",
	    "Bernard",
	    "Bernhard",
	    "Bettina",
	    "Brigitta",
	    "Brigitte",
	    "Bruno",
	    "Carlo",
	    "Carmen",
	    "Caroline",
	    "Catherine",
	    "Chantal",
	    "Charles",
	    "Charlotte",
	    "Christa",
	    "Christian",
	    "Christiane",
	    "Christina",
	    "Christine",
	    "Christoph",
	    "Christophe",
	    "Claire",
	    "Claude",
	    "Claudia",
	    "Claudine",
	    "Claudio",
	    "Corinne",
	    "Cornelia",
	    "Daniel",
	    "Daniela",
	    "Daniele",
	    "Danielle",
	    "David",
	    "Denis",
	    "Denise",
	    "Didier",
	    "Dieter",
	    "Dominik",
	    "Dominique",
	    "Dora",
	    "Doris",
	    "Edgar",
	    "Edith",
	    "Eduard",
	    "Edwin",
	    "Eliane",
	    "Elisabeth",
	    "Elsa",
	    "Elsbeth",
	    "Emil",
	    "Enrico",
	    "Eric",
	    "Erica",
	    "Erich",
	    "Erika",
	    "Ernst",
	    "Erwin",
	    "Esther",
	    "Eugen",
	    "Eva",
	    "Eveline",
	    "Evelyne",
	    "Fabienne",
	    "Felix",
	    "Ferdinand",
	    "Florence",
	    "Francesco",
	    "Francis",
	    "Franco",
	    "François",
	    "Françoise",
	    "Frank",
	    "Franz",
	    "Franziska",
	    "Frédéric",
	    "Fredy",
	    "Fridolin",
	    "Friedrich",
	    "Fritz",
	    "Gabriel",
	    "Gabriela",
	    "Gabrielle",
	    "Georg",
	    "Georges",
	    "Gérald",
	    "Gérard",
	    "Gerhard",
	    "Gertrud",
	    "Gianni",
	    "Gilbert",
	    "Giorgio",
	    "Giovanni",
	    "Gisela",
	    "Giuseppe",
	    "Gottfried",
	    "Guido",
	    "Guy",
	    "Hanna",
	    "Hans",
	    "Hans-Peter",
	    "Hans-Rudolf",
	    "Hans-Ulrich",
	    "Hansjörg",
	    "Hanspeter",
	    "Hansruedi",
	    "Hansueli",
	    "Harry",
	    "Heidi",
	    "Heinrich",
	    "Heinz",
	    "Helen",
	    "Helena",
	    "Helene",
	    "Helmut",
	    "Henri",
	    "Herbert",
	    "Hermann",
	    "Hildegard",
	    "Hubert",
	    "Hugo",
	    "Ingrid",
	    "Irene",
	    "Iris",
	    "Isabelle",
	    "Jacqueline",
	    "Jacques",
	    "Jakob",
	    "Jan",
	    "Janine",
	    "Jean",
	    "Jean-Claude",
	    "Jean-Daniel",
	    "Jean-François",
	    "Jean-Jacques",
	    "Jean-Louis",
	    "Jean-Luc",
	    "Jean-Marc",
	    "Jean-Marie",
	    "Jean-Paul",
	    "Jean-Pierre",
	    "Johann",
	    "Johanna",
	    "Johannes",
	    "John",
	    "Jolanda",
	    "Jörg",
	    "Josef",
	    "Joseph",
	    "Josette",
	    "Josiane",
	    "Judith",
	    "Julia",
	    "Jürg",
	    "Karin",
	    "Karl",
	    "Katharina",
	    "Klaus",
	    "Konrad",
	    "Kurt",
	    "Laura",
	    "Laurence",
	    "Laurent",
	    "Leo",
	    "Liliane",
	    "Liselotte",
	    "Louis",
	    "Luca",
	    "Luigi",
	    "Lukas",
	    "Lydia",
	    "Madeleine",
	    "Maja",
	    "Manfred",
	    "Manuel",
	    "Manuela",
	    "Marc",
	    "Marcel",
	    "Marco",
	    "Margrit",
	    "Margrith",
	    "Maria",
	    "Marianne",
	    "Mario",
	    "Marion",
	    "Markus",
	    "Marlène",
	    "Marlies",
	    "Marlis",
	    "Martha",
	    "Martin",
	    "Martina",
	    "Martine",
	    "Massimo",
	    "Matthias",
	    "Maurice",
	    "Max",
	    "Maya",
	    "Michael",
	    "Michel",
	    "Michele",
	    "Micheline",
	    "Monica",
	    "Monika",
	    "Monique",
	    "Myriam",
	    "Nadia",
	    "Nadja",
	    "Nathalie",
	    "Nelly",
	    "Nicolas",
	    "Nicole",
	    "Niklaus",
	    "Norbert",
	    "Olivier",
	    "Oskar",
	    "Otto",
	    "Paola",
	    "Paolo",
	    "Pascal",
	    "Patricia",
	    "Patrick",
	    "Paul",
	    "Peter",
	    "Petra",
	    "Philipp",
	    "Philippe",
	    "Pia",
	    "Pierre",
	    "Pierre-Alain",
	    "Pierre-André",
	    "Pius",
	    "Priska",
	    "Rainer",
	    "Raymond",
	    "Regina",
	    "Regula",
	    "Reinhard",
	    "Remo",
	    "Renata",
	    "Renate",
	    "Renato",
	    "Rene",
	    "René",
	    "Reto",
	    "Richard",
	    "Rita",
	    "Robert",
	    "Roberto",
	    "Roger",
	    "Roland",
	    "Rolf",
	    "Roman",
	    "Rosa",
	    "Rosemarie",
	    "Rosmarie",
	    "Rudolf",
	    "Ruedi",
	    "Ruth",
	    "Sabine",
	    "Samuel",
	    "Sandra",
	    "Sandro",
	    "Serge",
	    "Silvia",
	    "Silvio",
	    "Simon",
	    "Simone",
	    "Sonia",
	    "Sonja",
	    "Stefan",
	    "Stephan",
	    "Stéphane",
	    "Stéphanie",
	    "Susanna",
	    "Susanne",
	    "Suzanne",
	    "Sylvia",
	    "Sylvie",
	    "Theo",
	    "Theodor",
	    "Therese",
	    "Thomas",
	    "Toni",
	    "Ueli",
	    "Ulrich",
	    "Urs",
	    "Ursula",
	    "Verena",
	    "Véronique",
	    "Victor",
	    "Viktor",
	    "Vreni",
	    "Walter",
	    "Werner",
	    "Willi",
	    "Willy",
	    "Wolfgang",
	    "Yolande",
	    "Yves",
	    "Yvette",
	    "Yvonne",
	
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2016);
	name.last_name = __webpack_require__(2018);
	name.prefix = __webpack_require__(2020);
	name.name = __webpack_require__(2019);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	    "Ackermann",
	    "Aebi",
	    "Albrecht",
	    "Ammann",
	    "Amrein",
	    "Arnold",
	    "Bachmann",
	    "Bader",
	    "Bär",
	    "Bättig",
	    "Bauer",
	    "Baumann",
	    "Baumgartner",
	    "Baur",
	    "Beck",
	    "Benz",
	    "Berger",
	    "Bernasconi",
	    "Betschart",
	    "Bianchi",
	    "Bieri",
	    "Blaser",
	    "Blum",
	    "Bolliger",
	    "Bosshard",
	    "Braun",
	    "Brun",
	    "Brunner",
	    "Bucher",
	    "Bühler",
	    "Bühlmann",
	    "Burri",
	    "Christen",
	    "Egger",
	    "Egli",
	    "Eichenberger",
	    "Erni",
	    "Ernst",
	    "Eugster",
	    "Fankhauser",
	    "Favre",
	    "Fehr",
	    "Felber",
	    "Felder",
	    "Ferrari",
	    "Fischer",
	    "Flückiger",
	    "Forster",
	    "Frei",
	    "Frey",
	    "Frick",
	    "Friedli",
	    "Fuchs",
	    "Furrer",
	    "Gasser",
	    "Geiger",
	    "Gerber",
	    "Gfeller",
	    "Giger",
	    "Gloor",
	    "Graf",
	    "Grob",
	    "Gross",
	    "Gut",
	    "Haas",
	    "Häfliger",
	    "Hafner",
	    "Hartmann",
	    "Hasler",
	    "Hauser",
	    "Hermann",
	    "Herzog",
	    "Hess",
	    "Hirt",
	    "Hodel",
	    "Hofer",
	    "Hoffmann",
	    "Hofmann",
	    "Hofstetter",
	    "Hotz",
	    "Huber",
	    "Hug",
	    "Hunziker",
	    "Hürlimann",
	    "Imhof",
	    "Isler",
	    "Iten",
	    "Jäggi",
	    "Jenni",
	    "Jost",
	    "Kägi",
	    "Kaiser",
	    "Kälin",
	    "Käser",
	    "Kaufmann",
	    "Keller",
	    "Kern",
	    "Kessler",
	    "Knecht",
	    "Koch",
	    "Kohler",
	    "Kuhn",
	    "Küng",
	    "Kunz",
	    "Lang",
	    "Lanz",
	    "Lehmann",
	    "Leu",
	    "Leunberger",
	    "Lüscher",
	    "Lustenberger",
	    "Lüthi",
	    "Lutz",
	    "Mäder",
	    "Maier",
	    "Marti",
	    "Martin",
	    "Maurer",
	    "Mayer",
	    "Meier",
	    "Meili",
	    "Meister",
	    "Merz",
	    "Mettler",
	    "Meyer",
	    "Michel",
	    "Moser",
	    "Müller",
	    "Näf",
	    "Ott",
	    "Peter",
	    "Pfister",
	    "Portmann",
	    "Probst",
	    "Rey",
	    "Ritter",
	    "Roos",
	    "Roth",
	    "Rüegg",
	    "Schäfer",
	    "Schaller",
	    "Schär",
	    "Schärer",
	    "Schaub",
	    "Scheidegger",
	    "Schenk",
	    "Scherrer",
	    "Schlatter",
	    "Schmid",
	    "Schmidt",
	    "Schneider",
	    "Schnyder",
	    "Schoch",
	    "Schuler",
	    "Schumacher",
	    "Schürch",
	    "Schwab",
	    "Schwarz",
	    "Schweizer",
	    "Seiler",
	    "Senn",
	    "Sidler",
	    "Siegrist",
	    "Sigrist",
	    "Spörri",
	    "Stadelmann",
	    "Stalder",
	    "Staub",
	    "Stauffer",
	    "Steffen",
	    "Steiger",
	    "Steiner",
	    "Steinmann",
	    "Stettler",
	    "Stocker",
	    "Stöckli",
	    "Stucki",
	    "Studer",
	    "Stutz",
	    "Suter",
	    "Sutter",
	    "Tanner",
	    "Thommen",
	    "Tobler",
	    "Vogel",
	    "Vogt",
	    "Wagner",
	    "Walder",
	    "Walter",
	    "Weber",
	    "Wegmann",
	    "Wehrli",
	    "Weibel",
	    "Wenger",
	    "Wettstein",
	    "Widmer",
	    "Winkler",
	    "Wirth",
	    "Wirz",
	    "Wolf",
	    "Wüthrich",
	    "Wyss",
	    "Zbinden",
	    "Zehnder",
	    "Ziegler",
	    "Zimmermann",
	    "Zingg",
	    "Zollinger",
	    "Zürcher"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Hr.",
	  "Fr.",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0800 ### ###",
	  "0800 ## ## ##",
	  "0## ### ## ##",
	  "0## ### ## ##",
	  "+41 ## ### ## ##",
	  "0900 ### ###",
	  "076 ### ## ##",
	  "+4178 ### ## ##",
	  "0041 79 ### ## ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2021);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "North",
	  "East",
	  "West",
	  "South",
	  "New",
	  "Lake",
	  "Port"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Albania",
	  "Algeria",
	  "American Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarctica (the territory South of 60 deg S)",
	  "Antigua and Barbuda",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbaijan",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesh",
	  "Barbados",
	  "Belarus",
	  "Belgium",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivia",
	  "Bosnia and Herzegovina",
	  "Botswana",
	  "Bouvet Island (Bouvetoya)",
	  "Brazil",
	  "British Indian Ocean Territory (Chagos Archipelago)",
	  "Brunei Darussalam",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Cambodia",
	  "Cameroon",
	  "Canada",
	  "Cape Verde",
	  "Cayman Islands",
	  "Central African Republic",
	  "Chad",
	  "Chile",
	  "China",
	  "Christmas Island",
	  "Cocos (Keeling) Islands",
	  "Colombia",
	  "Comoros",
	  "Congo",
	  "Congo",
	  "Cook Islands",
	  "Costa Rica",
	  "Cote d'Ivoire",
	  "Croatia",
	  "Cuba",
	  "Cyprus",
	  "Czech Republic",
	  "Denmark",
	  "Djibouti",
	  "Dominica",
	  "Dominican Republic",
	  "Ecuador",
	  "Egypt",
	  "El Salvador",
	  "Equatorial Guinea",
	  "Eritrea",
	  "Estonia",
	  "Ethiopia",
	  "Faroe Islands",
	  "Falkland Islands (Malvinas)",
	  "Fiji",
	  "Finland",
	  "France",
	  "French Guiana",
	  "French Polynesia",
	  "French Southern Territories",
	  "Gabon",
	  "Gambia",
	  "Georgia",
	  "Germany",
	  "Ghana",
	  "Gibraltar",
	  "Greece",
	  "Greenland",
	  "Grenada",
	  "Guadeloupe",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Holy See (Vatican City State)",
	  "Honduras",
	  "Hong Kong",
	  "Hungary",
	  "Iceland",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Iraq",
	  "Ireland",
	  "Isle of Man",
	  "Israel",
	  "Italy",
	  "Jamaica",
	  "Japan",
	  "Jersey",
	  "Jordan",
	  "Kazakhstan",
	  "Kenya",
	  "Kiribati",
	  "Democratic People's Republic of Korea",
	  "Republic of Korea",
	  "Kuwait",
	  "Kyrgyz Republic",
	  "Lao People's Democratic Republic",
	  "Latvia",
	  "Lebanon",
	  "Lesotho",
	  "Liberia",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lithuania",
	  "Luxembourg",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malaysia",
	  "Maldives",
	  "Mali",
	  "Malta",
	  "Marshall Islands",
	  "Martinique",
	  "Mauritania",
	  "Mauritius",
	  "Mayotte",
	  "Mexico",
	  "Micronesia",
	  "Moldova",
	  "Monaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Morocco",
	  "Mozambique",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Netherlands Antilles",
	  "Netherlands",
	  "New Caledonia",
	  "New Zealand",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Norfolk Island",
	  "Northern Mariana Islands",
	  "Norway",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Palestinian Territory",
	  "Panama",
	  "Papua New Guinea",
	  "Paraguay",
	  "Peru",
	  "Philippines",
	  "Pitcairn Islands",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Reunion",
	  "Romania",
	  "Russian Federation",
	  "Rwanda",
	  "Saint Barthelemy",
	  "Saint Helena",
	  "Saint Kitts and Nevis",
	  "Saint Lucia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tome and Principe",
	  "Saudi Arabia",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leone",
	  "Singapore",
	  "Slovakia (Slovak Republic)",
	  "Slovenia",
	  "Solomon Islands",
	  "Somalia",
	  "South Africa",
	  "South Georgia and the South Sandwich Islands",
	  "Spain",
	  "Sri Lanka",
	  "Sudan",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Sweden",
	  "Switzerland",
	  "Syrian Arab Republic",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Thailand",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad and Tobago",
	  "Tunisia",
	  "Turkey",
	  "Turkmenistan",
	  "Turks and Caicos Islands",
	  "Tuvalu",
	  "Uganda",
	  "Ukraine",
	  "United Arab Emirates",
	  "United Kingdom",
	  "United States of America",
	  "United States Minor Outlying Islands",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Virgin Islands, British",
	  "Virgin Islands, U.S.",
	  "Wallis and Futuna",
	  "Western Sahara",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AD",
	  "AE",
	  "AF",
	  "AG",
	  "AI",
	  "AL",
	  "AM",
	  "AO",
	  "AQ",
	  "AR",
	  "AS",
	  "AT",
	  "AU",
	  "AW",
	  "AX",
	  "AZ",
	  "BA",
	  "BB",
	  "BD",
	  "BE",
	  "BF",
	  "BG",
	  "BH",
	  "BI",
	  "BJ",
	  "BL",
	  "BM",
	  "BN",
	  "BO",
	  "BQ",
	  "BQ",
	  "BR",
	  "BS",
	  "BT",
	  "BV",
	  "BW",
	  "BY",
	  "BZ",
	  "CA",
	  "CC",
	  "CD",
	  "CF",
	  "CG",
	  "CH",
	  "CI",
	  "CK",
	  "CL",
	  "CM",
	  "CN",
	  "CO",
	  "CR",
	  "CU",
	  "CV",
	  "CW",
	  "CX",
	  "CY",
	  "CZ",
	  "DE",
	  "DJ",
	  "DK",
	  "DM",
	  "DO",
	  "DZ",
	  "EC",
	  "EE",
	  "EG",
	  "EH",
	  "ER",
	  "ES",
	  "ET",
	  "FI",
	  "FJ",
	  "FK",
	  "FM",
	  "FO",
	  "FR",
	  "GA",
	  "GB",
	  "GD",
	  "GE",
	  "GF",
	  "GG",
	  "GH",
	  "GI",
	  "GL",
	  "GM",
	  "GN",
	  "GP",
	  "GQ",
	  "GR",
	  "GS",
	  "GT",
	  "GU",
	  "GW",
	  "GY",
	  "HK",
	  "HM",
	  "HN",
	  "HR",
	  "HT",
	  "HU",
	  "ID",
	  "IE",
	  "IL",
	  "IM",
	  "IN",
	  "IO",
	  "IQ",
	  "IR",
	  "IS",
	  "IT",
	  "JE",
	  "JM",
	  "JO",
	  "JP",
	  "KE",
	  "KG",
	  "KH",
	  "KI",
	  "KM",
	  "KN",
	  "KP",
	  "KR",
	  "KW",
	  "KY",
	  "KZ",
	  "LA",
	  "LB",
	  "LC",
	  "LI",
	  "LK",
	  "LR",
	  "LS",
	  "LT",
	  "LU",
	  "LV",
	  "LY",
	  "MA",
	  "MC",
	  "MD",
	  "ME",
	  "MF",
	  "MG",
	  "MH",
	  "MK",
	  "ML",
	  "MM",
	  "MN",
	  "MO",
	  "MP",
	  "MQ",
	  "MR",
	  "MS",
	  "MT",
	  "MU",
	  "MV",
	  "MW",
	  "MX",
	  "MY",
	  "MZ",
	  "NA",
	  "NC",
	  "NE",
	  "NF",
	  "NG",
	  "NI",
	  "NL",
	  "NO",
	  "NP",
	  "NR",
	  "NU",
	  "NZ",
	  "OM",
	  "PA",
	  "PE",
	  "PF",
	  "PG",
	  "PH",
	  "PK",
	  "PL",
	  "PM",
	  "PN",
	  "PR",
	  "PS",
	  "PT",
	  "PW",
	  "PY",
	  "QA",
	  "RE",
	  "RO",
	  "RS",
	  "RU",
	  "RW",
	  "SA",
	  "SB",
	  "SC",
	  "SD",
	  "SE",
	  "SG",
	  "SH",
	  "SI",
	  "SJ",
	  "SK",
	  "SL",
	  "SM",
	  "SN",
	  "SO",
	  "SR",
	  "SS",
	  "ST",
	  "SV",
	  "SX",
	  "SY",
	  "SZ",
	  "TC",
	  "TD",
	  "TF",
	  "TG",
	  "TH",
	  "TJ",
	  "TK",
	  "TL",
	  "TM",
	  "TN",
	  "TO",
	  "TR",
	  "TT",
	  "TV",
	  "TW",
	  "TZ",
	  "UA",
	  "UG",
	  "UM",
	  "US",
	  "UY",
	  "UZ",
	  "VA",
	  "VC",
	  "VE",
	  "VG",
	  "VI",
	  "VN",
	  "VU",
	  "WF",
	  "WS",
	  "YE",
	  "YT",
	  "ZA",
	  "ZM",
	  "ZW"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "United States of America"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2025);
	address.city_suffix = __webpack_require__(2026);
	address.county = __webpack_require__(2029);
	address.country = __webpack_require__(2027);
	address.country_code = __webpack_require__(2028);
	address.building_number = __webpack_require__(2023);
	address.street_suffix = __webpack_require__(2039);
	address.secondary_address = __webpack_require__(2034);
	address.postcode = __webpack_require__(2032);
	address.postcode_by_state = __webpack_require__(2033);
	address.state = __webpack_require__(2035);
	address.state_abbr = __webpack_require__(2036);
	address.time_zone = __webpack_require__(2040);
	address.city = __webpack_require__(2024);
	address.street_name = __webpack_require__(2038);
	address.street_address = __webpack_require__(2037);
	address.default_country = __webpack_require__(2030);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alabama",
	  "Alaska",
	  "Arizona",
	  "Arkansas",
	  "California",
	  "Colorado",
	  "Connecticut",
	  "Delaware",
	  "Florida",
	  "Georgia",
	  "Hawaii",
	  "Idaho",
	  "Illinois",
	  "Indiana",
	  "Iowa",
	  "Kansas",
	  "Kentucky",
	  "Louisiana",
	  "Maine",
	  "Maryland",
	  "Massachusetts",
	  "Michigan",
	  "Minnesota",
	  "Mississippi",
	  "Missouri",
	  "Montana",
	  "Nebraska",
	  "Nevada",
	  "New Hampshire",
	  "New Jersey",
	  "New Mexico",
	  "New York",
	  "North Carolina",
	  "North Dakota",
	  "Ohio",
	  "Oklahoma",
	  "Oregon",
	  "Pennsylvania",
	  "Rhode Island",
	  "South Carolina",
	  "South Dakota",
	  "Tennessee",
	  "Texas",
	  "Utah",
	  "Vermont",
	  "Virginia",
	  "Washington",
	  "West Virginia",
	  "Wisconsin",
	  "Wyoming"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AL",
	  "AK",
	  "AZ",
	  "AR",
	  "CA",
	  "CO",
	  "CT",
	  "DE",
	  "FL",
	  "GA",
	  "HI",
	  "ID",
	  "IL",
	  "IN",
	  "IA",
	  "KS",
	  "KY",
	  "LA",
	  "ME",
	  "MD",
	  "MA",
	  "MI",
	  "MN",
	  "MS",
	  "MO",
	  "MT",
	  "NE",
	  "NV",
	  "NH",
	  "NJ",
	  "NM",
	  "NY",
	  "NC",
	  "ND",
	  "OH",
	  "OK",
	  "OR",
	  "PA",
	  "RI",
	  "SC",
	  "SD",
	  "TN",
	  "TX",
	  "UT",
	  "VT",
	  "VA",
	  "WA",
	  "WV",
	  "WI",
	  "WY"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{building_number} #{street_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name} #{street_suffix}",
	  "#{Name.last_name} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alley",
	  "Avenue",
	  "Branch",
	  "Bridge",
	  "Brook",
	  "Brooks",
	  "Burg",
	  "Burgs",
	  "Bypass",
	  "Camp",
	  "Canyon",
	  "Cape",
	  "Causeway",
	  "Center",
	  "Centers",
	  "Circle",
	  "Circles",
	  "Cliff",
	  "Cliffs",
	  "Club",
	  "Common",
	  "Corner",
	  "Corners",
	  "Course",
	  "Court",
	  "Courts",
	  "Cove",
	  "Coves",
	  "Creek",
	  "Crescent",
	  "Crest",
	  "Crossing",
	  "Crossroad",
	  "Curve",
	  "Dale",
	  "Dam",
	  "Divide",
	  "Drive",
	  "Drive",
	  "Drives",
	  "Estate",
	  "Estates",
	  "Expressway",
	  "Extension",
	  "Extensions",
	  "Fall",
	  "Falls",
	  "Ferry",
	  "Field",
	  "Fields",
	  "Flat",
	  "Flats",
	  "Ford",
	  "Fords",
	  "Forest",
	  "Forge",
	  "Forges",
	  "Fork",
	  "Forks",
	  "Fort",
	  "Freeway",
	  "Garden",
	  "Gardens",
	  "Gateway",
	  "Glen",
	  "Glens",
	  "Green",
	  "Greens",
	  "Grove",
	  "Groves",
	  "Harbor",
	  "Harbors",
	  "Haven",
	  "Heights",
	  "Highway",
	  "Hill",
	  "Hills",
	  "Hollow",
	  "Inlet",
	  "Inlet",
	  "Island",
	  "Island",
	  "Islands",
	  "Islands",
	  "Isle",
	  "Isle",
	  "Junction",
	  "Junctions",
	  "Key",
	  "Keys",
	  "Knoll",
	  "Knolls",
	  "Lake",
	  "Lakes",
	  "Land",
	  "Landing",
	  "Lane",
	  "Light",
	  "Lights",
	  "Loaf",
	  "Lock",
	  "Locks",
	  "Locks",
	  "Lodge",
	  "Lodge",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Manors",
	  "Meadow",
	  "Meadows",
	  "Mews",
	  "Mill",
	  "Mills",
	  "Mission",
	  "Mission",
	  "Motorway",
	  "Mount",
	  "Mountain",
	  "Mountain",
	  "Mountains",
	  "Mountains",
	  "Neck",
	  "Orchard",
	  "Oval",
	  "Overpass",
	  "Park",
	  "Parks",
	  "Parkway",
	  "Parkways",
	  "Pass",
	  "Passage",
	  "Path",
	  "Pike",
	  "Pine",
	  "Pines",
	  "Place",
	  "Plain",
	  "Plains",
	  "Plains",
	  "Plaza",
	  "Plaza",
	  "Point",
	  "Points",
	  "Port",
	  "Port",
	  "Ports",
	  "Ports",
	  "Prairie",
	  "Prairie",
	  "Radial",
	  "Ramp",
	  "Ranch",
	  "Rapid",
	  "Rapids",
	  "Rest",
	  "Ridge",
	  "Ridges",
	  "River",
	  "Road",
	  "Road",
	  "Roads",
	  "Roads",
	  "Route",
	  "Row",
	  "Rue",
	  "Run",
	  "Shoal",
	  "Shoals",
	  "Shore",
	  "Shores",
	  "Skyway",
	  "Spring",
	  "Springs",
	  "Springs",
	  "Spur",
	  "Spurs",
	  "Square",
	  "Square",
	  "Squares",
	  "Squares",
	  "Station",
	  "Station",
	  "Stravenue",
	  "Stravenue",
	  "Stream",
	  "Stream",
	  "Street",
	  "Street",
	  "Streets",
	  "Summit",
	  "Summit",
	  "Terrace",
	  "Throughway",
	  "Trace",
	  "Track",
	  "Trafficway",
	  "Trail",
	  "Trail",
	  "Tunnel",
	  "Tunnel",
	  "Turnpike",
	  "Turnpike",
	  "Underpass",
	  "Union",
	  "Unions",
	  "Valley",
	  "Valleys",
	  "Via",
	  "Viaduct",
	  "View",
	  "Views",
	  "Village",
	  "Village",
	  "Villages",
	  "Ville",
	  "Vista",
	  "Vista",
	  "Walk",
	  "Walks",
	  "Wall",
	  "Way",
	  "Ways",
	  "Well",
	  "Wells"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacific/Midway",
	  "Pacific/Pago_Pago",
	  "Pacific/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europe/Dublin",
	  "Europe/London",
	  "Europe/Lisbon",
	  "Europe/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europe/Belgrade",
	  "Europe/Bratislava",
	  "Europe/Budapest",
	  "Europe/Ljubljana",
	  "Europe/Prague",
	  "Europe/Sarajevo",
	  "Europe/Skopje",
	  "Europe/Warsaw",
	  "Europe/Zagreb",
	  "Europe/Brussels",
	  "Europe/Copenhagen",
	  "Europe/Madrid",
	  "Europe/Paris",
	  "Europe/Amsterdam",
	  "Europe/Berlin",
	  "Europe/Berlin",
	  "Europe/Rome",
	  "Europe/Stockholm",
	  "Europe/Vienna",
	  "Africa/Algiers",
	  "Europe/Bucharest",
	  "Africa/Cairo",
	  "Europe/Helsinki",
	  "Europe/Kiev",
	  "Europe/Riga",
	  "Europe/Sofia",
	  "Europe/Tallinn",
	  "Europe/Vilnius",
	  "Europe/Athens",
	  "Europe/Istanbul",
	  "Europe/Minsk",
	  "Asia/Jerusalem",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacific/Guam",
	  "Pacific/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacific/Noumea",
	  "Pacific/Fiji",
	  "Asia/Kamchatka",
	  "Pacific/Majuro",
	  "Pacific/Auckland",
	  "Pacific/Auckland",
	  "Pacific/Tongatapu",
	  "Pacific/Fakaofo",
	  "Pacific/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.name}",
	  "#{Company.name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var app = {};
	module['exports'] = app;
	app.name = __webpack_require__(2043);
	app.version = __webpack_require__(2044);
	app.author = __webpack_require__(2041);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Redhold",
	  "Treeflex",
	  "Trippledex",
	  "Kanlam",
	  "Bigtax",
	  "Daltfresh",
	  "Toughjoyfax",
	  "Mat Lam Tam",
	  "Otcom",
	  "Tres-Zap",
	  "Y-Solowarm",
	  "Tresom",
	  "Voltsillam",
	  "Biodex",
	  "Greenlam",
	  "Viva",
	  "Matsoft",
	  "Temp",
	  "Zoolab",
	  "Subin",
	  "Rank",
	  "Job",
	  "Stringtough",
	  "Tin",
	  "It",
	  "Home Ing",
	  "Zamit",
	  "Sonsing",
	  "Konklab",
	  "Alpha",
	  "Latlux",
	  "Voyatouch",
	  "Alphazap",
	  "Holdlamis",
	  "Zaam-Dox",
	  "Sub-Ex",
	  "Quo Lux",
	  "Bamity",
	  "Ventosanzap",
	  "Lotstring",
	  "Hatity",
	  "Tempsoft",
	  "Overhold",
	  "Fixflex",
	  "Konklux",
	  "Zontrax",
	  "Tampflex",
	  "Span",
	  "Namfix",
	  "Transcof",
	  "Stim",
	  "Fix San",
	  "Sonair",
	  "Stronghold",
	  "Fintone",
	  "Y-find",
	  "Opela",
	  "Lotlux",
	  "Ronstring",
	  "Zathin",
	  "Duobam",
	  "Keylex"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0.#.#",
	  "0.##",
	  "#.##",
	  "#.#",
	  "#.#.#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "2011-10-12",
	  "2012-11-12",
	  "2015-11-11",
	  "2013-9-12"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1234-2121-1221-1211",
	  "1212-1221-1121-1234",
	  "1211-1221-1234-2201",
	  "1228-1221-1221-1431"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "visa",
	  "mastercard",
	  "americanexpress",
	  "discover"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var business = {};
	module['exports'] = business;
	business.credit_card_numbers = __webpack_require__(2046);
	business.credit_card_expiry_dates = __webpack_require__(2045);
	business.credit_card_types = __webpack_require__(2047);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2049);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "red",
	  "green",
	  "blue",
	  "yellow",
	  "purple",
	  "mint green",
	  "teal",
	  "white",
	  "black",
	  "orange",
	  "pink",
	  "grey",
	  "maroon",
	  "violet",
	  "turquoise",
	  "tan",
	  "sky blue",
	  "salmon",
	  "plum",
	  "orchid",
	  "olive",
	  "magenta",
	  "lime",
	  "ivory",
	  "indigo",
	  "gold",
	  "fuchsia",
	  "cyan",
	  "azure",
	  "lavender",
	  "silver"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Books",
	  "Movies",
	  "Music",
	  "Games",
	  "Electronics",
	  "Computers",
	  "Home",
	  "Garden",
	  "Tools",
	  "Grocery",
	  "Health",
	  "Beauty",
	  "Toys",
	  "Kids",
	  "Baby",
	  "Clothing",
	  "Shoes",
	  "Jewelery",
	  "Sports",
	  "Outdoors",
	  "Automotive",
	  "Industrial"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(2051);
	commerce.department = __webpack_require__(2052);
	commerce.product_name = __webpack_require__(2054);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Small",
	    "Ergonomic",
	    "Rustic",
	    "Intelligent",
	    "Gorgeous",
	    "Incredible",
	    "Fantastic",
	    "Practical",
	    "Sleek",
	    "Awesome",
	    "Generic",
	    "Handcrafted",
	    "Handmade",
	    "Licensed",
	    "Refined",
	    "Unbranded",
	    "Tasty"
	  ],
	  "material": [
	    "Steel",
	    "Wooden",
	    "Concrete",
	    "Plastic",
	    "Cotton",
	    "Granite",
	    "Rubber",
	    "Metal",
	    "Soft",
	    "Fresh",
	    "Frozen"
	  ],
	  "product": [
	    "Chair",
	    "Car",
	    "Computer",
	    "Keyboard",
	    "Mouse",
	    "Bike",
	    "Ball",
	    "Gloves",
	    "Pants",
	    "Shirt",
	    "Table",
	    "Shoes",
	    "Hat",
	    "Towels",
	    "Soap",
	    "Tuna",
	    "Chicken",
	    "Fish",
	    "Cheese",
	    "Bacon",
	    "Pizza",
	    "Salad",
	    "Sausages",
	    "Chips"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2063);
	company.adjective = __webpack_require__(2055);
	company.descriptor = __webpack_require__(2059);
	company.noun = __webpack_require__(2062);
	company.bs_verb = __webpack_require__(2058);
	company.bs_adjective = __webpack_require__(2056);
	company.bs_noun = __webpack_require__(2057);
	company.name = __webpack_require__(2061);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Inc",
	  "and Sons",
	  "LLC",
	  "Group"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/34##-######-####L/",
	  "/37##-######-####L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/30[0-5]#-######-###L/",
	  "/368#-######-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6011-####-####-###L/",
	  "/65##-####-####-###L/",
	  "/64[4-9]#-####-####-###L/",
	  "/6011-62##-####-####-###L/",
	  "/65##-62##-####-####-###L/",
	  "/64[4-9]#-62##-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var credit_card = {};
	module['exports'] = credit_card;
	credit_card.visa = __webpack_require__(2074);
	credit_card.mastercard = __webpack_require__(2071);
	credit_card.discover = __webpack_require__(2066);
	credit_card.american_express = __webpack_require__(2064);
	credit_card.diners_club = __webpack_require__(2065);
	credit_card.jcb = __webpack_require__(2068);
	credit_card.switch = __webpack_require__(2073);
	credit_card.solo = __webpack_require__(2072);
	credit_card.maestro = __webpack_require__(2070);
	credit_card.laser = __webpack_require__(2069);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/3528-####-####-###L/",
	  "/3529-####-####-###L/",
	  "/35[3-8]#-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6304###########L/",
	  "/6706###########L/",
	  "/6771###########L/",
	  "/6709###########L/",
	  "/6304#########{5,6}L/",
	  "/6706#########{5,6}L/",
	  "/6771#########{5,6}L/",
	  "/6709#########{5,6}L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/50#{9,16}L/",
	  "/5[6-8]#{9,16}L/",
	  "/56##{9,16}L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/5[1-5]##-####-####-###L/",
	  "/6771-89##-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6767-####-####-###L/",
	  "/6767-####-####-####-#L/",
	  "/6767-####-####-####-##L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/6759-####-####-###L/",
	  "/6759-####-####-####-#L/",
	  "/6759-####-####-####-##L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "/4###########L/",
	  "/4###-####-####-###L/"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(2076);
	date.weekday = __webpack_require__(2077);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1799
	module["exports"] = {
	  wide: [
	    "January",
	    "February",
	    "March",
	    "April",
	    "May",
	    "June",
	    "July",
	    "August",
	    "September",
	    "October",
	    "November",
	    "December"
	  ],
	  // Property "wide_context" is optional, if not set then "wide" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  wide_context: [
	    "January",
	    "February",
	    "March",
	    "April",
	    "May",
	    "June",
	    "July",
	    "August",
	    "September",
	    "October",
	    "November",
	    "December"
	  ],
	  abbr: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "May",
	    "Jun",
	    "Jul",
	    "Aug",
	    "Sep",
	    "Oct",
	    "Nov",
	    "Dec"
	  ],
	  // Property "abbr_context" is optional, if not set then "abbr" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  abbr_context: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "May",
	    "Jun",
	    "Jul",
	    "Aug",
	    "Sep",
	    "Oct",
	    "Nov",
	    "Dec"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
	module["exports"] = {
	  wide: [
	    "Sunday",
	    "Monday",
	    "Tuesday",
	    "Wednesday",
	    "Thursday",
	    "Friday",
	    "Saturday"
	  ],
	  // Property "wide_context" is optional, if not set then "wide" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  wide_context: [
	    "Sunday",
	    "Monday",
	    "Tuesday",
	    "Wednesday",
	    "Thursday",
	    "Friday",
	    "Saturday"
	  ],
	  abbr: [
	    "Sun",
	    "Mon",
	    "Tue",
	    "Wed",
	    "Thu",
	    "Fri",
	    "Sat"
	  ],
	  // Property "abbr_context" is optional, if not set then "abbr" will be used instead
	  // It is used to specify a word in context, which may differ from a stand-alone word
	  abbr_context: [
	    "Sun",
	    "Mon",
	    "Tue",
	    "Wed",
	    "Thu",
	    "Fri",
	    "Sat"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Checking",
	  "Savings",
	  "Money Market",
	  "Investment",
	  "Home Loan",
	  "Credit Card",
	  "Auto Loan",
	  "Personal Loan"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "UAE Dirham": {
	    "code": "AED",
	    "symbol": ""
	  },
	  "Afghani": {
	    "code": "AFN",
	    "symbol": "؋"
	  },
	  "Lek": {
	    "code": "ALL",
	    "symbol": "Lek"
	  },
	  "Armenian Dram": {
	    "code": "AMD",
	    "symbol": ""
	  },
	  "Netherlands Antillian Guilder": {
	    "code": "ANG",
	    "symbol": "ƒ"
	  },
	  "Kwanza": {
	    "code": "AOA",
	    "symbol": ""
	  },
	  "Argentine Peso": {
	    "code": "ARS",
	    "symbol": "$"
	  },
	  "Australian Dollar": {
	    "code": "AUD",
	    "symbol": "$"
	  },
	  "Aruban Guilder": {
	    "code": "AWG",
	    "symbol": "ƒ"
	  },
	  "Azerbaijanian Manat": {
	    "code": "AZN",
	    "symbol": "ман"
	  },
	  "Convertible Marks": {
	    "code": "BAM",
	    "symbol": "KM"
	  },
	  "Barbados Dollar": {
	    "code": "BBD",
	    "symbol": "$"
	  },
	  "Taka": {
	    "code": "BDT",
	    "symbol": ""
	  },
	  "Bulgarian Lev": {
	    "code": "BGN",
	    "symbol": "лв"
	  },
	  "Bahraini Dinar": {
	    "code": "BHD",
	    "symbol": ""
	  },
	  "Burundi Franc": {
	    "code": "BIF",
	    "symbol": ""
	  },
	  "Bermudian Dollar (customarily known as Bermuda Dollar)": {
	    "code": "BMD",
	    "symbol": "$"
	  },
	  "Brunei Dollar": {
	    "code": "BND",
	    "symbol": "$"
	  },
	  "Boliviano Mvdol": {
	    "code": "BOB BOV",
	    "symbol": "$b"
	  },
	  "Brazilian Real": {
	    "code": "BRL",
	    "symbol": "R$"
	  },
	  "Bahamian Dollar": {
	    "code": "BSD",
	    "symbol": "$"
	  },
	  "Pula": {
	    "code": "BWP",
	    "symbol": "P"
	  },
	  "Belarussian Ruble": {
	    "code": "BYR",
	    "symbol": "p."
	  },
	  "Belize Dollar": {
	    "code": "BZD",
	    "symbol": "BZ$"
	  },
	  "Canadian Dollar": {
	    "code": "CAD",
	    "symbol": "$"
	  },
	  "Congolese Franc": {
	    "code": "CDF",
	    "symbol": ""
	  },
	  "Swiss Franc": {
	    "code": "CHF",
	    "symbol": "CHF"
	  },
	  "Chilean Peso Unidades de fomento": {
	    "code": "CLP CLF",
	    "symbol": "$"
	  },
	  "Yuan Renminbi": {
	    "code": "CNY",
	    "symbol": "¥"
	  },
	  "Colombian Peso Unidad de Valor Real": {
	    "code": "COP COU",
	    "symbol": "$"
	  },
	  "Costa Rican Colon": {
	    "code": "CRC",
	    "symbol": "₡"
	  },
	  "Cuban Peso Peso Convertible": {
	    "code": "CUP CUC",
	    "symbol": "₱"
	  },
	  "Cape Verde Escudo": {
	    "code": "CVE",
	    "symbol": ""
	  },
	  "Czech Koruna": {
	    "code": "CZK",
	    "symbol": "Kč"
	  },
	  "Djibouti Franc": {
	    "code": "DJF",
	    "symbol": ""
	  },
	  "Danish Krone": {
	    "code": "DKK",
	    "symbol": "kr"
	  },
	  "Dominican Peso": {
	    "code": "DOP",
	    "symbol": "RD$"
	  },
	  "Algerian Dinar": {
	    "code": "DZD",
	    "symbol": ""
	  },
	  "Kroon": {
	    "code": "EEK",
	    "symbol": ""
	  },
	  "Egyptian Pound": {
	    "code": "EGP",
	    "symbol": "£"
	  },
	  "Nakfa": {
	    "code": "ERN",
	    "symbol": ""
	  },
	  "Ethiopian Birr": {
	    "code": "ETB",
	    "symbol": ""
	  },
	  "Euro": {
	    "code": "EUR",
	    "symbol": "€"
	  },
	  "Fiji Dollar": {
	    "code": "FJD",
	    "symbol": "$"
	  },
	  "Falkland Islands Pound": {
	    "code": "FKP",
	    "symbol": "£"
	  },
	  "Pound Sterling": {
	    "code": "GBP",
	    "symbol": "£"
	  },
	  "Lari": {
	    "code": "GEL",
	    "symbol": ""
	  },
	  "Cedi": {
	    "code": "GHS",
	    "symbol": ""
	  },
	  "Gibraltar Pound": {
	    "code": "GIP",
	    "symbol": "£"
	  },
	  "Dalasi": {
	    "code": "GMD",
	    "symbol": ""
	  },
	  "Guinea Franc": {
	    "code": "GNF",
	    "symbol": ""
	  },
	  "Quetzal": {
	    "code": "GTQ",
	    "symbol": "Q"
	  },
	  "Guyana Dollar": {
	    "code": "GYD",
	    "symbol": "$"
	  },
	  "Hong Kong Dollar": {
	    "code": "HKD",
	    "symbol": "$"
	  },
	  "Lempira": {
	    "code": "HNL",
	    "symbol": "L"
	  },
	  "Croatian Kuna": {
	    "code": "HRK",
	    "symbol": "kn"
	  },
	  "Gourde US Dollar": {
	    "code": "HTG USD",
	    "symbol": ""
	  },
	  "Forint": {
	    "code": "HUF",
	    "symbol": "Ft"
	  },
	  "Rupiah": {
	    "code": "IDR",
	    "symbol": "Rp"
	  },
	  "New Israeli Sheqel": {
	    "code": "ILS",
	    "symbol": "₪"
	  },
	  "Indian Rupee": {
	    "code": "INR",
	    "symbol": ""
	  },
	  "Indian Rupee Ngultrum": {
	    "code": "INR BTN",
	    "symbol": ""
	  },
	  "Iraqi Dinar": {
	    "code": "IQD",
	    "symbol": ""
	  },
	  "Iranian Rial": {
	    "code": "IRR",
	    "symbol": "﷼"
	  },
	  "Iceland Krona": {
	    "code": "ISK",
	    "symbol": "kr"
	  },
	  "Jamaican Dollar": {
	    "code": "JMD",
	    "symbol": "J$"
	  },
	  "Jordanian Dinar": {
	    "code": "JOD",
	    "symbol": ""
	  },
	  "Yen": {
	    "code": "JPY",
	    "symbol": "¥"
	  },
	  "Kenyan Shilling": {
	    "code": "KES",
	    "symbol": ""
	  },
	  "Som": {
	    "code": "KGS",
	    "symbol": "лв"
	  },
	  "Riel": {
	    "code": "KHR",
	    "symbol": "៛"
	  },
	  "Comoro Franc": {
	    "code": "KMF",
	    "symbol": ""
	  },
	  "North Korean Won": {
	    "code": "KPW",
	    "symbol": "₩"
	  },
	  "Won": {
	    "code": "KRW",
	    "symbol": "₩"
	  },
	  "Kuwaiti Dinar": {
	    "code": "KWD",
	    "symbol": ""
	  },
	  "Cayman Islands Dollar": {
	    "code": "KYD",
	    "symbol": "$"
	  },
	  "Tenge": {
	    "code": "KZT",
	    "symbol": "лв"
	  },
	  "Kip": {
	    "code": "LAK",
	    "symbol": "₭"
	  },
	  "Lebanese Pound": {
	    "code": "LBP",
	    "symbol": "£"
	  },
	  "Sri Lanka Rupee": {
	    "code": "LKR",
	    "symbol": "₨"
	  },
	  "Liberian Dollar": {
	    "code": "LRD",
	    "symbol": "$"
	  },
	  "Lithuanian Litas": {
	    "code": "LTL",
	    "symbol": "Lt"
	  },
	  "Latvian Lats": {
	    "code": "LVL",
	    "symbol": "Ls"
	  },
	  "Libyan Dinar": {
	    "code": "LYD",
	    "symbol": ""
	  },
	  "Moroccan Dirham": {
	    "code": "MAD",
	    "symbol": ""
	  },
	  "Moldovan Leu": {
	    "code": "MDL",
	    "symbol": ""
	  },
	  "Malagasy Ariary": {
	    "code": "MGA",
	    "symbol": ""
	  },
	  "Denar": {
	    "code": "MKD",
	    "symbol": "ден"
	  },
	  "Kyat": {
	    "code": "MMK",
	    "symbol": ""
	  },
	  "Tugrik": {
	    "code": "MNT",
	    "symbol": "₮"
	  },
	  "Pataca": {
	    "code": "MOP",
	    "symbol": ""
	  },
	  "Ouguiya": {
	    "code": "MRO",
	    "symbol": ""
	  },
	  "Mauritius Rupee": {
	    "code": "MUR",
	    "symbol": "₨"
	  },
	  "Rufiyaa": {
	    "code": "MVR",
	    "symbol": ""
	  },
	  "Kwacha": {
	    "code": "MWK",
	    "symbol": ""
	  },
	  "Mexican Peso Mexican Unidad de Inversion (UDI)": {
	    "code": "MXN MXV",
	    "symbol": "$"
	  },
	  "Malaysian Ringgit": {
	    "code": "MYR",
	    "symbol": "RM"
	  },
	  "Metical": {
	    "code": "MZN",
	    "symbol": "MT"
	  },
	  "Naira": {
	    "code": "NGN",
	    "symbol": "₦"
	  },
	  "Cordoba Oro": {
	    "code": "NIO",
	    "symbol": "C$"
	  },
	  "Norwegian Krone": {
	    "code": "NOK",
	    "symbol": "kr"
	  },
	  "Nepalese Rupee": {
	    "code": "NPR",
	    "symbol": "₨"
	  },
	  "New Zealand Dollar": {
	    "code": "NZD",
	    "symbol": "$"
	  },
	  "Rial Omani": {
	    "code": "OMR",
	    "symbol": "﷼"
	  },
	  "Balboa US Dollar": {
	    "code": "PAB USD",
	    "symbol": "B/."
	  },
	  "Nuevo Sol": {
	    "code": "PEN",
	    "symbol": "S/."
	  },
	  "Kina": {
	    "code": "PGK",
	    "symbol": ""
	  },
	  "Philippine Peso": {
	    "code": "PHP",
	    "symbol": "Php"
	  },
	  "Pakistan Rupee": {
	    "code": "PKR",
	    "symbol": "₨"
	  },
	  "Zloty": {
	    "code": "PLN",
	    "symbol": "zł"
	  },
	  "Guarani": {
	    "code": "PYG",
	    "symbol": "Gs"
	  },
	  "Qatari Rial": {
	    "code": "QAR",
	    "symbol": "﷼"
	  },
	  "New Leu": {
	    "code": "RON",
	    "symbol": "lei"
	  },
	  "Serbian Dinar": {
	    "code": "RSD",
	    "symbol": "Дин."
	  },
	  "Russian Ruble": {
	    "code": "RUB",
	    "symbol": "руб"
	  },
	  "Rwanda Franc": {
	    "code": "RWF",
	    "symbol": ""
	  },
	  "Saudi Riyal": {
	    "code": "SAR",
	    "symbol": "﷼"
	  },
	  "Solomon Islands Dollar": {
	    "code": "SBD",
	    "symbol": "$"
	  },
	  "Seychelles Rupee": {
	    "code": "SCR",
	    "symbol": "₨"
	  },
	  "Sudanese Pound": {
	    "code": "SDG",
	    "symbol": ""
	  },
	  "Swedish Krona": {
	    "code": "SEK",
	    "symbol": "kr"
	  },
	  "Singapore Dollar": {
	    "code": "SGD",
	    "symbol": "$"
	  },
	  "Saint Helena Pound": {
	    "code": "SHP",
	    "symbol": "£"
	  },
	  "Leone": {
	    "code": "SLL",
	    "symbol": ""
	  },
	  "Somali Shilling": {
	    "code": "SOS",
	    "symbol": "S"
	  },
	  "Surinam Dollar": {
	    "code": "SRD",
	    "symbol": "$"
	  },
	  "Dobra": {
	    "code": "STD",
	    "symbol": ""
	  },
	  "El Salvador Colon US Dollar": {
	    "code": "SVC USD",
	    "symbol": "$"
	  },
	  "Syrian Pound": {
	    "code": "SYP",
	    "symbol": "£"
	  },
	  "Lilangeni": {
	    "code": "SZL",
	    "symbol": ""
	  },
	  "Baht": {
	    "code": "THB",
	    "symbol": "฿"
	  },
	  "Somoni": {
	    "code": "TJS",
	    "symbol": ""
	  },
	  "Manat": {
	    "code": "TMT",
	    "symbol": ""
	  },
	  "Tunisian Dinar": {
	    "code": "TND",
	    "symbol": ""
	  },
	  "Pa'anga": {
	    "code": "TOP",
	    "symbol": ""
	  },
	  "Turkish Lira": {
	    "code": "TRY",
	    "symbol": "TL"
	  },
	  "Trinidad and Tobago Dollar": {
	    "code": "TTD",
	    "symbol": "TT$"
	  },
	  "New Taiwan Dollar": {
	    "code": "TWD",
	    "symbol": "NT$"
	  },
	  "Tanzanian Shilling": {
	    "code": "TZS",
	    "symbol": ""
	  },
	  "Hryvnia": {
	    "code": "UAH",
	    "symbol": "₴"
	  },
	  "Uganda Shilling": {
	    "code": "UGX",
	    "symbol": ""
	  },
	  "US Dollar": {
	    "code": "USD",
	    "symbol": "$"
	  },
	  "Peso Uruguayo Uruguay Peso en Unidades Indexadas": {
	    "code": "UYU UYI",
	    "symbol": "$U"
	  },
	  "Uzbekistan Sum": {
	    "code": "UZS",
	    "symbol": "лв"
	  },
	  "Bolivar Fuerte": {
	    "code": "VEF",
	    "symbol": "Bs"
	  },
	  "Dong": {
	    "code": "VND",
	    "symbol": "₫"
	  },
	  "Vatu": {
	    "code": "VUV",
	    "symbol": ""
	  },
	  "Tala": {
	    "code": "WST",
	    "symbol": ""
	  },
	  "CFA Franc BEAC": {
	    "code": "XAF",
	    "symbol": ""
	  },
	  "Silver": {
	    "code": "XAG",
	    "symbol": ""
	  },
	  "Gold": {
	    "code": "XAU",
	    "symbol": ""
	  },
	  "Bond Markets Units European Composite Unit (EURCO)": {
	    "code": "XBA",
	    "symbol": ""
	  },
	  "European Monetary Unit (E.M.U.-6)": {
	    "code": "XBB",
	    "symbol": ""
	  },
	  "European Unit of Account 9(E.U.A.-9)": {
	    "code": "XBC",
	    "symbol": ""
	  },
	  "European Unit of Account 17(E.U.A.-17)": {
	    "code": "XBD",
	    "symbol": ""
	  },
	  "East Caribbean Dollar": {
	    "code": "XCD",
	    "symbol": "$"
	  },
	  "SDR": {
	    "code": "XDR",
	    "symbol": ""
	  },
	  "UIC-Franc": {
	    "code": "XFU",
	    "symbol": ""
	  },
	  "CFA Franc BCEAO": {
	    "code": "XOF",
	    "symbol": ""
	  },
	  "Palladium": {
	    "code": "XPD",
	    "symbol": ""
	  },
	  "CFP Franc": {
	    "code": "XPF",
	    "symbol": ""
	  },
	  "Platinum": {
	    "code": "XPT",
	    "symbol": ""
	  },
	  "Codes specifically reserved for testing purposes": {
	    "code": "XTS",
	    "symbol": ""
	  },
	  "Yemeni Rial": {
	    "code": "YER",
	    "symbol": "﷼"
	  },
	  "Rand": {
	    "code": "ZAR",
	    "symbol": "R"
	  },
	  "Rand Loti": {
	    "code": "ZAR LSL",
	    "symbol": ""
	  },
	  "Rand Namibia Dollar": {
	    "code": "ZAR NAD",
	    "symbol": ""
	  },
	  "Zambian Kwacha": {
	    "code": "ZMK",
	    "symbol": ""
	  },
	  "Zimbabwe Dollar": {
	    "code": "ZWL",
	    "symbol": ""
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var finance = {};
	module['exports'] = finance;
	finance.account_type = __webpack_require__(2078);
	finance.transaction_type = __webpack_require__(2081);
	finance.currency = __webpack_require__(2079);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "deposit",
	  "withdrawal",
	  "payment",
	  "invoice"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "TCP",
	  "HTTP",
	  "SDD",
	  "RAM",
	  "GB",
	  "CSS",
	  "SSL",
	  "AGP",
	  "SQL",
	  "FTP",
	  "PCI",
	  "AI",
	  "ADP",
	  "RSS",
	  "XML",
	  "EXE",
	  "COM",
	  "HDD",
	  "THX",
	  "SMTP",
	  "SMS",
	  "USB",
	  "PNG",
	  "SAS",
	  "IB",
	  "SCSI",
	  "JSON",
	  "XSS",
	  "JBOD"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "auxiliary",
	  "primary",
	  "back-end",
	  "digital",
	  "open-source",
	  "virtual",
	  "cross-platform",
	  "redundant",
	  "online",
	  "haptic",
	  "multi-byte",
	  "bluetooth",
	  "wireless",
	  "1080p",
	  "neural",
	  "optical",
	  "solid state",
	  "mobile"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var hacker = {};
	module['exports'] = hacker;
	hacker.abbreviation = __webpack_require__(2082);
	hacker.adjective = __webpack_require__(2083);
	hacker.noun = __webpack_require__(2086);
	hacker.verb = __webpack_require__(2087);
	hacker.ingverb = __webpack_require__(2085);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "backing up",
	  "bypassing",
	  "hacking",
	  "overriding",
	  "compressing",
	  "copying",
	  "navigating",
	  "indexing",
	  "connecting",
	  "generating",
	  "quantifying",
	  "calculating",
	  "synthesizing",
	  "transmitting",
	  "programming",
	  "parsing"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "driver",
	  "protocol",
	  "bandwidth",
	  "panel",
	  "microchip",
	  "program",
	  "port",
	  "card",
	  "array",
	  "interface",
	  "system",
	  "sensor",
	  "firewall",
	  "hard drive",
	  "pixel",
	  "alarm",
	  "feed",
	  "monitor",
	  "application",
	  "transmitter",
	  "bus",
	  "circuit",
	  "capacitor",
	  "matrix"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "back up",
	  "bypass",
	  "hack",
	  "override",
	  "compress",
	  "copy",
	  "navigate",
	  "index",
	  "connect",
	  "generate",
	  "quantify",
	  "calculate",
	  "synthesize",
	  "input",
	  "transmit",
	  "program",
	  "reboot",
	  "parse"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en = {};
	module['exports'] = en;
	en.title = "English";
	en.separator = " & ";
	en.address = __webpack_require__(2031);
	en.credit_card = __webpack_require__(2067);
	en.company = __webpack_require__(2060);
	en.internet = __webpack_require__(2093);
	en.lorem = __webpack_require__(2094);
	en.name = __webpack_require__(2098);
	en.phone_number = __webpack_require__(2105);
	en.cell_phone = __webpack_require__(2050);
	en.business = __webpack_require__(2048);
	en.commerce = __webpack_require__(2053);
	en.team = __webpack_require__(2109);
	en.hacker = __webpack_require__(2084);
	en.app = __webpack_require__(2042);
	en.finance = __webpack_require__(2080);
	en.date = __webpack_require__(2075);
	en.system = __webpack_require__(2106);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jarjan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mahdif/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sprayaga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ruzinav/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Skyhartman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/moscoz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kurafire/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/91bilal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/igorgarybaldi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/calebogden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/malykhinv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joelhelin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kushsolitary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/snowshade/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/areus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/holdenweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heyimjuani/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/envex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/unterdreht/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/collegeman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peejfancher/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andyisonline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ultragex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fuck_you_two/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adellecharles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ateneupopular/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmetalpbalkan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Stievius/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kerem/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osvaldas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelceballos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thierrykoblentz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peterlandt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/catarino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/weglov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandclay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flame_kaizar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmetsulek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicolasfolliot/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jayrobinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorerixon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolage/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michzen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markjenkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicolai_larsen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/noxdzine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alagoon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/idiot/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mizko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chadengle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mutlu82/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/simobenso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vocino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guiiipontes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/soyjavi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshaustin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tomaslau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/VinThomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ManikRathee/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/langate/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cemshid/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leemunroe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_shahedk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BillSKenney/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/divya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshhemsley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sindresorhus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/soffes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/9lessons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/linux29/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Chakintosh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anaami/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joreira/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shadeed9/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottkclark/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jedbridges/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salleedesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marakasina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ariil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BrianPurkiss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelmartinho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bublienko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/devankoshal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ZacharyZorbas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timmillwood/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshuasortino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/damenleeturks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tomas_janousek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herrhaase/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/RussellBishop/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brajeshwar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nachtmeister/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cbracco/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bermonpainter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdullindenis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isacosta/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/suprb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yalozhkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chandlervdw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamgarth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_victa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/commadelimited/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/roybarberuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/axel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladarbatov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ffbel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/syropian/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ankitind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/traneblow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flashmurphy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ChrisFarina78/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baliomega/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saschamt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jm_denis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anoff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kennyadr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chatyrko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dingyi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mds/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terryxlife/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaroni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kinday/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prrstn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eduardostuart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhilipsiva/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/GavicoInd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rohixx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bigmancho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/blakesimkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leeiio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tjrus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uberschizo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kylefoundry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/claudioguglieri/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ripplemdk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/exentrich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jakemoore/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joaoedumedeiros/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/poormini/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tereshenkov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/keryilmaz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haydn_woods/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rude/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/llun/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sgaurav_baghel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jamiebrittain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/badlittleduck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pifagor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/agromov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benefritz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/erwanhesry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/diesellaws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremiaha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/koridhandy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chaensel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewcohen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smaczny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gonzalorobaina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nandini_m/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sydlawrence/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cdharrison/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tgerken/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lewisainslie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charliecwaite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robbschiller/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/flexrs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattdetails/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/raquelwilson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karsh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrmartineau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/opnsrce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hgharrygo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maximseshuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxalex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samihah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chanpory/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sharvin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josemarques/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jefffis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/krystalfister/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lokesh_coder/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thedamianhdez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dpmachado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/funwatercat/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timothycd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ivanfilipovbg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/picard102/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcobarbosa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/krasnoukhov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/g3d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ademilter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rickdt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/operatino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bungiwan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hugomano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/logorado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dc_user/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/horaciobella/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/SlaapMe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teeragit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iqonicd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ilya_pestov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewarrow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ssiskind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/HenryHoffman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rdsaunders/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamsxu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/curiousoffice/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themadray/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michigangraham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kohette/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nickfratter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/runningskull/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madysondesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brenton_clarke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jennyshen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bradenhamm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kurtinc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amanruzaini/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyhaggard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Karimmove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaronalfred/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wtrsld/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jitachi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/therealmarvin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pmeissner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ooomz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chacky14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jesseddy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thinmatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shanehudson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akmur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/IsaryAmairani/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arthurholcombe1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andychipster/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/boxmodel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ehsandiary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/LucasPerdidao/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shalt0ni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/swaplord/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaelifa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/plbabin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guillemboti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arindam_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/renbyrd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thiagovernetti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jmillspaysbills/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikemai2awesome/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jervo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mekal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sta1ex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robergd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/felipecsl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrea211087/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/garand/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhooyenga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abovefunction/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pcridesagain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/randomlies/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BryanHorsey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heykenneth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dahparra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allthingssmitty/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danvernon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/beweinreich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/increase/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falvarad/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alxndrustinov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/souuf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/orkuncaylar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/AM_Kn2/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gearpixels/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bassamology/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vimarethomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kosmar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/SULiik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrjamesnoble/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/silvanmuhlemann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shaneIxD/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nacho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yigitpinarbasi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buzzusborne/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aaronkwhite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rmlewisuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/giancarlon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nbirckel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d_nny_m_cher/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sdidonato/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/atariboy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abotap/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karalek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/psdesignuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ludwiczakpawel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nemanjaivanovic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baluli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ahmadajmi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vovkasolovev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samgrover/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derienzo777/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonathansimmons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nelsonjoyce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/S0ufi4n3/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xtopherpaul/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oaktreemedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nateschulte/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/findingjenny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/namankreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antonyzotov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/we_social/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leehambley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/solid_color/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abelcabans/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mbilderbach/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kkusaa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jordyvdboom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosgavina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pechkinator/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vc27/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rdbannon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/croakx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/suribbles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kerihenare/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/catadeleon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gcmorley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/duivvv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saschadroste/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorDubugras/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wintopia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattbilotti/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/taylorling/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/megdraws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/meln1ks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mahmoudmetwally/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Silveredge9/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derekebradley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/happypeter1983/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/travis_arnold/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artem_kostenko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adobi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/daykiine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alek_djuric/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scips/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/miguelmendes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrhee/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alsobrooks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fronx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mcflydesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/santi_urso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allfordesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stayuber/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bertboerland/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marosholly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamnac/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cynthiasavard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/muringa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hiemil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jackiesaik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zacsnider/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iduuck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antjanus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aroon_sharma/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dshster/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thehacker/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelbrooksjr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryanmclaughlin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/clubb3rry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/taybenlor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xripunov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/myastro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adityasutomo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/digitalmaverick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hjartstrorn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itolmach/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vaughanmoffitt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdots/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isnifer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sergeysafonov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scrapdnb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrismj83/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vitorleal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sokaniwaal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zaki3d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/illyzoren/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mocabyte/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osmanince/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/djsherman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidhemphill/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/waghner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/necodymiconer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/praveen_vijaya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fabbrucci/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cliffseal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/travishines/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kuldarkalvik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Elt_n/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/phillapier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okseanjay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/id835559/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kudretkeskin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anjhero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/duck4fuck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scott_riley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/noufalibrahim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/h1brd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/borges_marcos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/devinhalladay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ciaranr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefooo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikebeecham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tonymillion/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshuaraichur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/irae/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petrangr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dmitriychuta/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charliegann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arashmanteghi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adhamdannaway/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ainsleywagon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/svenlen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/faisalabid/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/beshur/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlyson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dutchnadia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teddyzetterlund/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samuelkraft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aoimedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/toddrew/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/codepoet_ru/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artvavs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benoitboucart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jomarmen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolmarlopez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/creartinc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/homka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gaborenton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robinclediere/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maximsorokin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/plasticine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j2deme/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peachananr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kapaluccio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/de_ascanio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rikas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dawidwu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcoramires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelcreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rpatey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/popey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rehatkathuria/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/the_purplebunny/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/1markiz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ajaxy_ru/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brenmurrell/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dudestein/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oskarlevinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorstuber/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nehfy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vicivadeline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leandrovaranda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottgallant/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victor_haydin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sawrb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryhanhassan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amayvs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a_brixen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karolkrakowiak_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herkulano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geran7/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cggaurav/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chris_witko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lososina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/polarity/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattlat/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonburke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/constantx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/teylorfeliz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craigelimeliah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rachelreveley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reabo101/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rahmeen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rickyyean/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j04ntoh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spbroma/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sebashton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jpenico/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/francis_vega/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oktayelipek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kikillo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fabbianz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/larrygerard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BroumiYoussef/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/0therplanet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mbilalsiddique1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ionuss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/grrr_nl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/liminha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rawdiggie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryandownie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sethlouey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pixage/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arpitnj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/switmer777/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josevnclch/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kanickairaj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/puzik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tbakdesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/besbujupi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/supjoey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lowie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/linkibol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/balintorosz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imcoding/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/agustincruiz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gusoto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thomasschrijer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/superoutman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kalmerrautam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gabrielizalo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gojeanyn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidbaldie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_vojto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/laurengray/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jydesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mymyboy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nellleo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marciotoledo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ninjad3m0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/to_soham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hasslunsford/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/muridrahhal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/levisan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/grahamkennery/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lepetitogre/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antongenkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nessoila/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amandabuzard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/safrankov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cocolero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dss49/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matt3224/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bluesix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/quailandquasar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/AlbertoCococi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lepinski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sementiy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhudobivnik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thibaut_re/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/olgary/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shojberg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mtolokonnikov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bereto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/naupintos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wegotvices/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xadhix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/macxim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rodnylobos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madcampos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madebyvadim/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bartoszdawydzik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/supervova/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markretzloff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vonachoo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/darylws/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stevedesigner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mylesb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/herbigt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/depaulawagner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geshan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gizmeedevil1991/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_scottburgess/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lisovsky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidsasda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/artd_sign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/YoungCutlass/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mgonto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itstotallyamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victorquinn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/osmond/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oksanafrewer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zauerkraut/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamkeithmason/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nitinhayaran/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lmjabreu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mandalareopens/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thinkleft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ponchomendivil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juamperro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brunodesign1206/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/caseycavanagh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/luxe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dotgridline/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spedwig/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madewulf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mattsapii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/helderleal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisstumph/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jayphen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nsamoylov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisvanderkooi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justme_timothyg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/otozk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prinzadi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gu5taf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cyril_gaillard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d_kobelyatsky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/daniloc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nwdsha/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/romanbulah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/skkirilov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dvdwinden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dannol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thekevinjones/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jwalter14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timgthomas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buddhasource/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxpiper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thatonetommy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/diansigitp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adrienths/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/klimmka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gkaam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/derekcramer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jennyyo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nerrsoft/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xalionmalik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edhenderson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/keyuri85/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/roxanejammet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kimcool/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edkf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matkins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alessandroribe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jacksonlatka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lebronjennan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kostaspt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karlkanall/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/moynihan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danpliego/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saulihirvi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wesleytrankin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fjaguero/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bowbrick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mashaaaaal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yassiryahya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dparrelli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fotomagin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aka_james/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/denisepires/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iqbalperkasa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/martinansty/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jarsen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/r_oy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gabrielrosser/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/malgordon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlfairclough/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelabehsera/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pierrestoffe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enjoythetau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/loganjlambert/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rpeezy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coreyginnivan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michalhron/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/msveet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lingeswaran/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kolsvein/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/peter576/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reideiredale/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joeymurdah/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/raphaelnikson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mvdheuvel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maxlinderman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jimmuirhead/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/begreative/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/frankiefreesbie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robturlinckx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Talbi_ConSept/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/longlivemyword/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vanchesz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maiklam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hermanobrother/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rez___a/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregsqueeb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/greenbes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_ragzor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anthonysukow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fluidbrush/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dactrtr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jehnglynn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bergmartin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hugocornejo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_kkga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dzantievm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sawalazar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sovesove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonsgotwood/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/byryan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vytautas_a/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mizhgan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cicerobr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nilshelmersson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d33pthought/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davecraige/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nckjrvs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alexandermayes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jcubic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craigrcoles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bagawarman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rob_thomas10/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cofla/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/maikelk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rtgibbons/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/russell_baylis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhesslow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/codysanfilippo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/webtanya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madebybrenton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dcalonaci/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/perfectflow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jjsiii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/saarabpreet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kumarrajan12123/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamsteffen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themikenagle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ceekaytweet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/larrybolt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/conspirator/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dallasbpeters/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n3dmax/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terpimost/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kirillz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/byrnecore/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/j_drake_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/calebjoyce/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/russoedu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hoangloi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tobysaxon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gofrasdesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dimaposnyy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tjisousa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okandungel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/billyroshan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oskamaya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/motionthinks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/knilob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ashocka18/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marrimo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bartjo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/omnizya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ernestsemerda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andreas_pr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edgarchris99/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thomasgeisen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gseguin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joannefournier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/demersdesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adammarsbar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nasirwd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n_tassone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/javorszky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/themrdave/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yecidsm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicollerich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/canapud/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicoleglynn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/judzhin_miles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/designervzm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kianoshp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/evandrix/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alterchuca/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhrubo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ma_tiax/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ssbb_me/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dorphern/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mauriolg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bruno_mart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mactopus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/the_winslet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joemdesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/Shriiiiimp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jacobbennett/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nfedoroff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamglimy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/allagringaus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aiiaiiaii/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/olaolusoga/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buryaknick/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wim1k/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nicklacke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a1chapone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/steynviljoen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/strikewan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryankirkman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewabogado/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/doooon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jagan123/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ariffsetiawan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elenadissi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mwarkentin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thierrymeier_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/r_garcia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dmackerman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/borantula/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/konus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/spacewood_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryuchi311/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/evanshajed/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tristanlegros/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shoaib253/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aislinnkelly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okcoker/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/timpetricola/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sunshinedgirl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chadami/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleclarsoniv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nomidesigns/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petebernardo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottiedude/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/millinet/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imsoper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imammuht/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/benjamin_knight/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nepdud/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joki4/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lanceguyatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bboy1895/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/amywebbb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rweve/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haruintesettden/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ricburton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nelshd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/batsirai/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/primozcigler/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jffgrdnr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/8d3k/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geneseleznev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/al_li/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/souperphly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mslarkina/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/2fockus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cdavis565/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xiel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/turkutuuli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/uxward/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lebinoclard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gauravjassal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidmerrique/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mdsisto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andrewofficer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kojourin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dnirmal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mr_shiznit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aluisio_azevedo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cloudstudio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danvierich/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alexivanichkin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fran_mchamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/perretmagali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/betraydan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cadikkara/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matbeedotcom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremyworboys/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bpartridge/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelkoper/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/silv3rgvn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alevizio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johnsmithagency/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lawlbwoy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vitor376/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/desastrozo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thimo_cz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jasonmarkjones/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lhausermann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xravil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/guischmitt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vigobronx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/panghal0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/miguelkooreman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/surgeonist/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/christianoliff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/caspergrl/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamkarna/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ipavelek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pierre_nel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/y2graphic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sterlingrules/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elbuscainfo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bennyjien/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stushona/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/estebanuribe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/embrcecreations/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danillos/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elliotlewis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/charlesrpratt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladyn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emmeffess/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosblanco_eu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/leonfedotov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rangafangs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chris_frees/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tgormtx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bryan_topham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jpscribbles/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mighty55/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carbontwelve/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/isaacfifth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/iamjdeleon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/snowwrite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/barputro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/drewbyreese/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sachacorazzi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bistrianiosip/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/magoo04/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pehamondello/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yayteejay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/a_harris88/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/algunsanabria/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zforrester/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ovall/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosjgsousa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/geobikas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ah_lice/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/looneydoodle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nerdgr8/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ddggccaa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zackeeler/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/normanbox/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/el_fuertisimo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ismail_biltagi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juangomezw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jnmnrd/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/patrickcoombe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ryanjohnson_me/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markolschesky/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeffgolenski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kvasnic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lindseyzilla/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gauchomatt/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/afusinatto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevinoh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/okansurreel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adamawesomeface/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emileboudeling/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arishi_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juanmamartinez/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wikiziner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danthms/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mkginfo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/terrorpixel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/curiousonaut/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/prheemo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelcolenso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/foczzi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/martip07/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thaodang17/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johncafazza/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/robinlayfield/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/franciscoamk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/abdulhyeuk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marklamb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/edobene/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andresenfredrik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mikaeljorhult/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chrisslowik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vinciarts/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/meelford/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elliotnolten/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yehudab/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vijaykarthik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bfrohs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josep_martins/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/attacks/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sur4dye/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tumski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/instalox/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mangosango/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/paulfarino/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kazaky999/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kiwiupover/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nvkznemo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tom_even/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ratbus/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/woodsman001/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joshmedeski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thewillbeard/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/psaikali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joe_black/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleinadsays/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcusgorillius/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hota_v/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jghyllebert/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shinze/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/janpalounek/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremiespoken/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/her_ruu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dansowter/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/felipeapiress/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/magugzbrand2d/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/posterjob/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nathalie_fs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bobbytwoshoes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dreizle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremymouton/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/elisabethkjaer/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/notbadart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mohanrohith/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jlsolerdeltoro/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itskawsar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/slowspock/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/zvchkelly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wiljanslofstra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/craighenneberry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/trubeatto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/juaumlol/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/samscouto/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/BenouarradeM/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gipsy_raf/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/netonet_il/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/arkokoley/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/itsajimithing/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smalonso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/victordeanda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_dwite_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/richardgarretts/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregrwilkinson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anatolinicolae/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lu4sh1i/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefanotirloni/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ostirbu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/darcystonge/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/naitanamoreno/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/michaelcomiskey/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/adhiardana/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marcomano_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/davidcazalis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falconerie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gregkilian/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bcrad/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bolzanmarco/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/low_res/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vlajki/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/petar_prog/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jonkspr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akmalfikri/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mfacchinello/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/atanism/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/harry_sistalam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/murrayswift/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bobwassermann/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gavr1l0/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/madshensel/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mr_subtle/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/deviljho_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salimianoff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joetruesdell/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/twittypork/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/airskylar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dnezkumar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dgajjar/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cherif_b/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/salvafc/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/louis_currie/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/deeenright/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cybind/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eyronn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vickyshits/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sweetdelisa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/cboller1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andresdjasso/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/melvindidit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andysolomon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thaisselenator_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lvovenok/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/giuliusa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/belyaev_rs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/overcloacked/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kamal_chaneman/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/incubo82/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hellofeverrrr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mhaligowski/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sunlandictwin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bu7921/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/andytlaw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremery/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/finchjke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/manigm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/umurgdk/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/scottfeltham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ganserene/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mutu_krish/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jodytaggart/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ntfblog/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tanveerrao/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hfalucas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alxleroydeval/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kucingbelang4/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bargaorobalo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/colgruv/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stalewine/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kylefrost/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baumannzone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/angelcolberg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sachingawas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jjshaw14/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ramanathan_pdy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johndezember/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nilshoenson/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonmorreale/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nutzumi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/brandonflatsoda/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sergeyalmone/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/klefue/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kirangopal/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/baumann_alex/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/matthewkay_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jay_wilburn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shesgared/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/apriendeau/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johnriordan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wake_gs/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aleksitappura/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emsgulam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xilantra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/imomenui/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sircalebgrove/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/newbrushes/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hsinyo23/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/m4rio/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/katiemdaly/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/s4f1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ecommerceil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marlinjayakody/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/swooshycueb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sangdth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/coderdiaz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bluefx_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vivekprvr/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sasha_shestakov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eugeneeweb/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dgclegg/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/n1ght_coder/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dixchen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/blakehawksworth/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/trueblood_33/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hai_ninh_nguyen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marclgonzales/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/yesmeck/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stephcoue/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/doronmalki/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ruehldesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/anasnakawa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kijanmaharjan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/wearesavas/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefvdham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tweetubhai/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alecarpentier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/fiterik/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/antonyryndya/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/d00maz/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/theonlyzeke/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/missaaamy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/carlosm/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/manekenthe/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/reetajayendra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jeremyshimko/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/justinrgraham/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/stefanozoffoli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/overra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrebay007/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/shvelo96/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/pyronite/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/thedjpetersen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/rtyukmaev/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_williamguerra/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/albertaugustin/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vikashpathak18/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kevinjohndayy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vj_demien/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/colirpixoil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/goddardlewis/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/laasli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jqiuss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/heycamtaylor/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nastya_mane/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mastermindesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ccinojasso1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/nyancecom/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sandywoodruff/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/bighanddesign/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sbtransparent/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aviddayentonbay/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/richwild/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaysix_dizzy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/tur8le/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/seyedhossein1/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/privetwagner/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/emmandenn/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dev_essentials/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jmfsocial/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_yardenoon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mateaodviteza/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/weavermedia/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mufaddal_mw/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hafeeskhan/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ashernatali/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sulaqo/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eddiechen/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/josecarlospsh/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vm_f/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/enricocicconi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/danmartin70/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/gmourier/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/donjain/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mrxloka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/_pedropinho/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/eitarafa/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/oscarowusu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ralph_lam/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/panchajanyag/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/woodydotmx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/jerrybai1907/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/marshallchen_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/xamorep/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aio___/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/chaabane_wail/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/txcx/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/akashsharma39/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/falling_soul/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sainraja/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mugukamil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/johannesneu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/markwienands/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/karthipanraj/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/balakayuriy/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/alan_zhang_/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/layerssss/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/kaspernordkvist/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/mirfanqureshi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/hanna_smi/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/VMilescu/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/aeon56/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/m_kalibry/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/sreejithexp/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dicesales/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/dhoot_amit/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/smenov/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/lonesomelemon/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vladimirdevic/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/joelcipriano/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/haligaliharun/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/buleswapnil/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/serefka/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/ifarafonow/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/vikasvinfotech/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/urrutimeoli/128.jpg",
	  "https://s3.amazonaws.com/uifaces/faces/twitter/areandacom/128.jpg"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "example.org",
	  "example.com",
	  "example.net"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2092);
	internet.example_email = __webpack_require__(2091);
	internet.domain_suffix = __webpack_require__(2090);
	internet.avatar_uri = __webpack_require__(2089);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2096);
	lorem.supplemental = __webpack_require__(2095);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaliyah",
	  "Aaron",
	  "Abagail",
	  "Abbey",
	  "Abbie",
	  "Abbigail",
	  "Abby",
	  "Abdiel",
	  "Abdul",
	  "Abdullah",
	  "Abe",
	  "Abel",
	  "Abelardo",
	  "Abigail",
	  "Abigale",
	  "Abigayle",
	  "Abner",
	  "Abraham",
	  "Ada",
	  "Adah",
	  "Adalberto",
	  "Adaline",
	  "Adam",
	  "Adan",
	  "Addie",
	  "Addison",
	  "Adela",
	  "Adelbert",
	  "Adele",
	  "Adelia",
	  "Adeline",
	  "Adell",
	  "Adella",
	  "Adelle",
	  "Aditya",
	  "Adolf",
	  "Adolfo",
	  "Adolph",
	  "Adolphus",
	  "Adonis",
	  "Adrain",
	  "Adrian",
	  "Adriana",
	  "Adrianna",
	  "Adriel",
	  "Adrien",
	  "Adrienne",
	  "Afton",
	  "Aglae",
	  "Agnes",
	  "Agustin",
	  "Agustina",
	  "Ahmad",
	  "Ahmed",
	  "Aida",
	  "Aidan",
	  "Aiden",
	  "Aileen",
	  "Aimee",
	  "Aisha",
	  "Aiyana",
	  "Akeem",
	  "Al",
	  "Alaina",
	  "Alan",
	  "Alana",
	  "Alanis",
	  "Alanna",
	  "Alayna",
	  "Alba",
	  "Albert",
	  "Alberta",
	  "Albertha",
	  "Alberto",
	  "Albin",
	  "Albina",
	  "Alda",
	  "Alden",
	  "Alec",
	  "Aleen",
	  "Alejandra",
	  "Alejandrin",
	  "Alek",
	  "Alena",
	  "Alene",
	  "Alessandra",
	  "Alessandro",
	  "Alessia",
	  "Aletha",
	  "Alex",
	  "Alexa",
	  "Alexander",
	  "Alexandra",
	  "Alexandre",
	  "Alexandrea",
	  "Alexandria",
	  "Alexandrine",
	  "Alexandro",
	  "Alexane",
	  "Alexanne",
	  "Alexie",
	  "Alexis",
	  "Alexys",
	  "Alexzander",
	  "Alf",
	  "Alfonso",
	  "Alfonzo",
	  "Alford",
	  "Alfred",
	  "Alfreda",
	  "Alfredo",
	  "Ali",
	  "Alia",
	  "Alice",
	  "Alicia",
	  "Alisa",
	  "Alisha",
	  "Alison",
	  "Alivia",
	  "Aliya",
	  "Aliyah",
	  "Aliza",
	  "Alize",
	  "Allan",
	  "Allen",
	  "Allene",
	  "Allie",
	  "Allison",
	  "Ally",
	  "Alphonso",
	  "Alta",
	  "Althea",
	  "Alva",
	  "Alvah",
	  "Alvena",
	  "Alvera",
	  "Alverta",
	  "Alvina",
	  "Alvis",
	  "Alyce",
	  "Alycia",
	  "Alysa",
	  "Alysha",
	  "Alyson",
	  "Alysson",
	  "Amalia",
	  "Amanda",
	  "Amani",
	  "Amara",
	  "Amari",
	  "Amaya",
	  "Amber",
	  "Ambrose",
	  "Amelia",
	  "Amelie",
	  "Amely",
	  "America",
	  "Americo",
	  "Amie",
	  "Amina",
	  "Amir",
	  "Amira",
	  "Amiya",
	  "Amos",
	  "Amparo",
	  "Amy",
	  "Amya",
	  "Ana",
	  "Anabel",
	  "Anabelle",
	  "Anahi",
	  "Anais",
	  "Anastacio",
	  "Anastasia",
	  "Anderson",
	  "Andre",
	  "Andreane",
	  "Andreanne",
	  "Andres",
	  "Andrew",
	  "Andy",
	  "Angel",
	  "Angela",
	  "Angelica",
	  "Angelina",
	  "Angeline",
	  "Angelita",
	  "Angelo",
	  "Angie",
	  "Angus",
	  "Anibal",
	  "Anika",
	  "Anissa",
	  "Anita",
	  "Aniya",
	  "Aniyah",
	  "Anjali",
	  "Anna",
	  "Annabel",
	  "Annabell",
	  "Annabelle",
	  "Annalise",
	  "Annamae",
	  "Annamarie",
	  "Anne",
	  "Annetta",
	  "Annette",
	  "Annie",
	  "Ansel",
	  "Ansley",
	  "Anthony",
	  "Antoinette",
	  "Antone",
	  "Antonetta",
	  "Antonette",
	  "Antonia",
	  "Antonietta",
	  "Antonina",
	  "Antonio",
	  "Antwan",
	  "Antwon",
	  "Anya",
	  "April",
	  "Ara",
	  "Araceli",
	  "Aracely",
	  "Arch",
	  "Archibald",
	  "Ardella",
	  "Arden",
	  "Ardith",
	  "Arely",
	  "Ari",
	  "Ariane",
	  "Arianna",
	  "Aric",
	  "Ariel",
	  "Arielle",
	  "Arjun",
	  "Arlene",
	  "Arlie",
	  "Arlo",
	  "Armand",
	  "Armando",
	  "Armani",
	  "Arnaldo",
	  "Arne",
	  "Arno",
	  "Arnold",
	  "Arnoldo",
	  "Arnulfo",
	  "Aron",
	  "Art",
	  "Arthur",
	  "Arturo",
	  "Arvel",
	  "Arvid",
	  "Arvilla",
	  "Aryanna",
	  "Asa",
	  "Asha",
	  "Ashlee",
	  "Ashleigh",
	  "Ashley",
	  "Ashly",
	  "Ashlynn",
	  "Ashton",
	  "Ashtyn",
	  "Asia",
	  "Assunta",
	  "Astrid",
	  "Athena",
	  "Aubree",
	  "Aubrey",
	  "Audie",
	  "Audra",
	  "Audreanne",
	  "Audrey",
	  "August",
	  "Augusta",
	  "Augustine",
	  "Augustus",
	  "Aurelia",
	  "Aurelie",
	  "Aurelio",
	  "Aurore",
	  "Austen",
	  "Austin",
	  "Austyn",
	  "Autumn",
	  "Ava",
	  "Avery",
	  "Avis",
	  "Axel",
	  "Ayana",
	  "Ayden",
	  "Ayla",
	  "Aylin",
	  "Baby",
	  "Bailee",
	  "Bailey",
	  "Barbara",
	  "Barney",
	  "Baron",
	  "Barrett",
	  "Barry",
	  "Bart",
	  "Bartholome",
	  "Barton",
	  "Baylee",
	  "Beatrice",
	  "Beau",
	  "Beaulah",
	  "Bell",
	  "Bella",
	  "Belle",
	  "Ben",
	  "Benedict",
	  "Benjamin",
	  "Bennett",
	  "Bennie",
	  "Benny",
	  "Benton",
	  "Berenice",
	  "Bernadette",
	  "Bernadine",
	  "Bernard",
	  "Bernardo",
	  "Berneice",
	  "Bernhard",
	  "Bernice",
	  "Bernie",
	  "Berniece",
	  "Bernita",
	  "Berry",
	  "Bert",
	  "Berta",
	  "Bertha",
	  "Bertram",
	  "Bertrand",
	  "Beryl",
	  "Bessie",
	  "Beth",
	  "Bethany",
	  "Bethel",
	  "Betsy",
	  "Bette",
	  "Bettie",
	  "Betty",
	  "Bettye",
	  "Beulah",
	  "Beverly",
	  "Bianka",
	  "Bill",
	  "Billie",
	  "Billy",
	  "Birdie",
	  "Blair",
	  "Blaise",
	  "Blake",
	  "Blanca",
	  "Blanche",
	  "Blaze",
	  "Bo",
	  "Bobbie",
	  "Bobby",
	  "Bonita",
	  "Bonnie",
	  "Boris",
	  "Boyd",
	  "Brad",
	  "Braden",
	  "Bradford",
	  "Bradley",
	  "Bradly",
	  "Brady",
	  "Braeden",
	  "Brain",
	  "Brandi",
	  "Brando",
	  "Brandon",
	  "Brandt",
	  "Brandy",
	  "Brandyn",
	  "Brannon",
	  "Branson",
	  "Brant",
	  "Braulio",
	  "Braxton",
	  "Brayan",
	  "Breana",
	  "Breanna",
	  "Breanne",
	  "Brenda",
	  "Brendan",
	  "Brenden",
	  "Brendon",
	  "Brenna",
	  "Brennan",
	  "Brennon",
	  "Brent",
	  "Bret",
	  "Brett",
	  "Bria",
	  "Brian",
	  "Briana",
	  "Brianne",
	  "Brice",
	  "Bridget",
	  "Bridgette",
	  "Bridie",
	  "Brielle",
	  "Brigitte",
	  "Brionna",
	  "Brisa",
	  "Britney",
	  "Brittany",
	  "Brock",
	  "Broderick",
	  "Brody",
	  "Brook",
	  "Brooke",
	  "Brooklyn",
	  "Brooks",
	  "Brown",
	  "Bruce",
	  "Bryana",
	  "Bryce",
	  "Brycen",
	  "Bryon",
	  "Buck",
	  "Bud",
	  "Buddy",
	  "Buford",
	  "Bulah",
	  "Burdette",
	  "Burley",
	  "Burnice",
	  "Buster",
	  "Cade",
	  "Caden",
	  "Caesar",
	  "Caitlyn",
	  "Cale",
	  "Caleb",
	  "Caleigh",
	  "Cali",
	  "Calista",
	  "Callie",
	  "Camden",
	  "Cameron",
	  "Camila",
	  "Camilla",
	  "Camille",
	  "Camren",
	  "Camron",
	  "Camryn",
	  "Camylle",
	  "Candace",
	  "Candelario",
	  "Candice",
	  "Candida",
	  "Candido",
	  "Cara",
	  "Carey",
	  "Carissa",
	  "Carlee",
	  "Carleton",
	  "Carley",
	  "Carli",
	  "Carlie",
	  "Carlo",
	  "Carlos",
	  "Carlotta",
	  "Carmel",
	  "Carmela",
	  "Carmella",
	  "Carmelo",
	  "Carmen",
	  "Carmine",
	  "Carol",
	  "Carolanne",
	  "Carole",
	  "Carolina",
	  "Caroline",
	  "Carolyn",
	  "Carolyne",
	  "Carrie",
	  "Carroll",
	  "Carson",
	  "Carter",
	  "Cary",
	  "Casandra",
	  "Casey",
	  "Casimer",
	  "Casimir",
	  "Casper",
	  "Cassandra",
	  "Cassandre",
	  "Cassidy",
	  "Cassie",
	  "Catalina",
	  "Caterina",
	  "Catharine",
	  "Catherine",
	  "Cathrine",
	  "Cathryn",
	  "Cathy",
	  "Cayla",
	  "Ceasar",
	  "Cecelia",
	  "Cecil",
	  "Cecile",
	  "Cecilia",
	  "Cedrick",
	  "Celestine",
	  "Celestino",
	  "Celia",
	  "Celine",
	  "Cesar",
	  "Chad",
	  "Chadd",
	  "Chadrick",
	  "Chaim",
	  "Chance",
	  "Chandler",
	  "Chanel",
	  "Chanelle",
	  "Charity",
	  "Charlene",
	  "Charles",
	  "Charley",
	  "Charlie",
	  "Charlotte",
	  "Chase",
	  "Chasity",
	  "Chauncey",
	  "Chaya",
	  "Chaz",
	  "Chelsea",
	  "Chelsey",
	  "Chelsie",
	  "Chesley",
	  "Chester",
	  "Chet",
	  "Cheyanne",
	  "Cheyenne",
	  "Chloe",
	  "Chris",
	  "Christ",
	  "Christa",
	  "Christelle",
	  "Christian",
	  "Christiana",
	  "Christina",
	  "Christine",
	  "Christop",
	  "Christophe",
	  "Christopher",
	  "Christy",
	  "Chyna",
	  "Ciara",
	  "Cicero",
	  "Cielo",
	  "Cierra",
	  "Cindy",
	  "Citlalli",
	  "Clair",
	  "Claire",
	  "Clara",
	  "Clarabelle",
	  "Clare",
	  "Clarissa",
	  "Clark",
	  "Claud",
	  "Claude",
	  "Claudia",
	  "Claudie",
	  "Claudine",
	  "Clay",
	  "Clemens",
	  "Clement",
	  "Clementina",
	  "Clementine",
	  "Clemmie",
	  "Cleo",
	  "Cleora",
	  "Cleta",
	  "Cletus",
	  "Cleve",
	  "Cleveland",
	  "Clifford",
	  "Clifton",
	  "Clint",
	  "Clinton",
	  "Clotilde",
	  "Clovis",
	  "Cloyd",
	  "Clyde",
	  "Coby",
	  "Cody",
	  "Colby",
	  "Cole",
	  "Coleman",
	  "Colin",
	  "Colleen",
	  "Collin",
	  "Colt",
	  "Colten",
	  "Colton",
	  "Columbus",
	  "Concepcion",
	  "Conner",
	  "Connie",
	  "Connor",
	  "Conor",
	  "Conrad",
	  "Constance",
	  "Constantin",
	  "Consuelo",
	  "Cooper",
	  "Cora",
	  "Coralie",
	  "Corbin",
	  "Cordelia",
	  "Cordell",
	  "Cordia",
	  "Cordie",
	  "Corene",
	  "Corine",
	  "Cornelius",
	  "Cornell",
	  "Corrine",
	  "Cortez",
	  "Cortney",
	  "Cory",
	  "Coty",
	  "Courtney",
	  "Coy",
	  "Craig",
	  "Crawford",
	  "Creola",
	  "Cristal",
	  "Cristian",
	  "Cristina",
	  "Cristobal",
	  "Cristopher",
	  "Cruz",
	  "Crystal",
	  "Crystel",
	  "Cullen",
	  "Curt",
	  "Curtis",
	  "Cydney",
	  "Cynthia",
	  "Cyril",
	  "Cyrus",
	  "Dagmar",
	  "Dahlia",
	  "Daija",
	  "Daisha",
	  "Daisy",
	  "Dakota",
	  "Dale",
	  "Dallas",
	  "Dallin",
	  "Dalton",
	  "Damaris",
	  "Dameon",
	  "Damian",
	  "Damien",
	  "Damion",
	  "Damon",
	  "Dan",
	  "Dana",
	  "Dandre",
	  "Dane",
	  "D'angelo",
	  "Dangelo",
	  "Danial",
	  "Daniela",
	  "Daniella",
	  "Danielle",
	  "Danika",
	  "Dannie",
	  "Danny",
	  "Dante",
	  "Danyka",
	  "Daphne",
	  "Daphnee",
	  "Daphney",
	  "Darby",
	  "Daren",
	  "Darian",
	  "Dariana",
	  "Darien",
	  "Dario",
	  "Darion",
	  "Darius",
	  "Darlene",
	  "Daron",
	  "Darrel",
	  "Darrell",
	  "Darren",
	  "Darrick",
	  "Darrin",
	  "Darrion",
	  "Darron",
	  "Darryl",
	  "Darwin",
	  "Daryl",
	  "Dashawn",
	  "Dasia",
	  "Dave",
	  "David",
	  "Davin",
	  "Davion",
	  "Davon",
	  "Davonte",
	  "Dawn",
	  "Dawson",
	  "Dax",
	  "Dayana",
	  "Dayna",
	  "Dayne",
	  "Dayton",
	  "Dean",
	  "Deangelo",
	  "Deanna",
	  "Deborah",
	  "Declan",
	  "Dedric",
	  "Dedrick",
	  "Dee",
	  "Deion",
	  "Deja",
	  "Dejah",
	  "Dejon",
	  "Dejuan",
	  "Delaney",
	  "Delbert",
	  "Delfina",
	  "Delia",
	  "Delilah",
	  "Dell",
	  "Della",
	  "Delmer",
	  "Delores",
	  "Delpha",
	  "Delphia",
	  "Delphine",
	  "Delta",
	  "Demarco",
	  "Demarcus",
	  "Demario",
	  "Demetris",
	  "Demetrius",
	  "Demond",
	  "Dena",
	  "Denis",
	  "Dennis",
	  "Deon",
	  "Deondre",
	  "Deontae",
	  "Deonte",
	  "Dereck",
	  "Derek",
	  "Derick",
	  "Deron",
	  "Derrick",
	  "Deshaun",
	  "Deshawn",
	  "Desiree",
	  "Desmond",
	  "Dessie",
	  "Destany",
	  "Destin",
	  "Destinee",
	  "Destiney",
	  "Destini",
	  "Destiny",
	  "Devan",
	  "Devante",
	  "Deven",
	  "Devin",
	  "Devon",
	  "Devonte",
	  "Devyn",
	  "Dewayne",
	  "Dewitt",
	  "Dexter",
	  "Diamond",
	  "Diana",
	  "Dianna",
	  "Diego",
	  "Dillan",
	  "Dillon",
	  "Dimitri",
	  "Dina",
	  "Dino",
	  "Dion",
	  "Dixie",
	  "Dock",
	  "Dolly",
	  "Dolores",
	  "Domenic",
	  "Domenica",
	  "Domenick",
	  "Domenico",
	  "Domingo",
	  "Dominic",
	  "Dominique",
	  "Don",
	  "Donald",
	  "Donato",
	  "Donavon",
	  "Donna",
	  "Donnell",
	  "Donnie",
	  "Donny",
	  "Dora",
	  "Dorcas",
	  "Dorian",
	  "Doris",
	  "Dorothea",
	  "Dorothy",
	  "Dorris",
	  "Dortha",
	  "Dorthy",
	  "Doug",
	  "Douglas",
	  "Dovie",
	  "Doyle",
	  "Drake",
	  "Drew",
	  "Duane",
	  "Dudley",
	  "Dulce",
	  "Duncan",
	  "Durward",
	  "Dustin",
	  "Dusty",
	  "Dwight",
	  "Dylan",
	  "Earl",
	  "Earlene",
	  "Earline",
	  "Earnest",
	  "Earnestine",
	  "Easter",
	  "Easton",
	  "Ebba",
	  "Ebony",
	  "Ed",
	  "Eda",
	  "Edd",
	  "Eddie",
	  "Eden",
	  "Edgar",
	  "Edgardo",
	  "Edison",
	  "Edmond",
	  "Edmund",
	  "Edna",
	  "Eduardo",
	  "Edward",
	  "Edwardo",
	  "Edwin",
	  "Edwina",
	  "Edyth",
	  "Edythe",
	  "Effie",
	  "Efrain",
	  "Efren",
	  "Eileen",
	  "Einar",
	  "Eino",
	  "Eladio",
	  "Elaina",
	  "Elbert",
	  "Elda",
	  "Eldon",
	  "Eldora",
	  "Eldred",
	  "Eldridge",
	  "Eleanora",
	  "Eleanore",
	  "Eleazar",
	  "Electa",
	  "Elena",
	  "Elenor",
	  "Elenora",
	  "Eleonore",
	  "Elfrieda",
	  "Eli",
	  "Elian",
	  "Eliane",
	  "Elias",
	  "Eliezer",
	  "Elijah",
	  "Elinor",
	  "Elinore",
	  "Elisa",
	  "Elisabeth",
	  "Elise",
	  "Eliseo",
	  "Elisha",
	  "Elissa",
	  "Eliza",
	  "Elizabeth",
	  "Ella",
	  "Ellen",
	  "Ellie",
	  "Elliot",
	  "Elliott",
	  "Ellis",
	  "Ellsworth",
	  "Elmer",
	  "Elmira",
	  "Elmo",
	  "Elmore",
	  "Elna",
	  "Elnora",
	  "Elody",
	  "Eloisa",
	  "Eloise",
	  "Elouise",
	  "Eloy",
	  "Elroy",
	  "Elsa",
	  "Else",
	  "Elsie",
	  "Elta",
	  "Elton",
	  "Elva",
	  "Elvera",
	  "Elvie",
	  "Elvis",
	  "Elwin",
	  "Elwyn",
	  "Elyse",
	  "Elyssa",
	  "Elza",
	  "Emanuel",
	  "Emelia",
	  "Emelie",
	  "Emely",
	  "Emerald",
	  "Emerson",
	  "Emery",
	  "Emie",
	  "Emil",
	  "Emile",
	  "Emilia",
	  "Emiliano",
	  "Emilie",
	  "Emilio",
	  "Emily",
	  "Emma",
	  "Emmalee",
	  "Emmanuel",
	  "Emmanuelle",
	  "Emmet",
	  "Emmett",
	  "Emmie",
	  "Emmitt",
	  "Emmy",
	  "Emory",
	  "Ena",
	  "Enid",
	  "Enoch",
	  "Enola",
	  "Enos",
	  "Enrico",
	  "Enrique",
	  "Ephraim",
	  "Era",
	  "Eriberto",
	  "Eric",
	  "Erica",
	  "Erich",
	  "Erick",
	  "Ericka",
	  "Erik",
	  "Erika",
	  "Erin",
	  "Erling",
	  "Erna",
	  "Ernest",
	  "Ernestina",
	  "Ernestine",
	  "Ernesto",
	  "Ernie",
	  "Ervin",
	  "Erwin",
	  "Eryn",
	  "Esmeralda",
	  "Esperanza",
	  "Esta",
	  "Esteban",
	  "Estefania",
	  "Estel",
	  "Estell",
	  "Estella",
	  "Estelle",
	  "Estevan",
	  "Esther",
	  "Estrella",
	  "Etha",
	  "Ethan",
	  "Ethel",
	  "Ethelyn",
	  "Ethyl",
	  "Ettie",
	  "Eudora",
	  "Eugene",
	  "Eugenia",
	  "Eula",
	  "Eulah",
	  "Eulalia",
	  "Euna",
	  "Eunice",
	  "Eusebio",
	  "Eva",
	  "Evalyn",
	  "Evan",
	  "Evangeline",
	  "Evans",
	  "Eve",
	  "Eveline",
	  "Evelyn",
	  "Everardo",
	  "Everett",
	  "Everette",
	  "Evert",
	  "Evie",
	  "Ewald",
	  "Ewell",
	  "Ezekiel",
	  "Ezequiel",
	  "Ezra",
	  "Fabian",
	  "Fabiola",
	  "Fae",
	  "Fannie",
	  "Fanny",
	  "Fatima",
	  "Faustino",
	  "Fausto",
	  "Favian",
	  "Fay",
	  "Faye",
	  "Federico",
	  "Felicia",
	  "Felicita",
	  "Felicity",
	  "Felipa",
	  "Felipe",
	  "Felix",
	  "Felton",
	  "Fermin",
	  "Fern",
	  "Fernando",
	  "Ferne",
	  "Fidel",
	  "Filiberto",
	  "Filomena",
	  "Finn",
	  "Fiona",
	  "Flavie",
	  "Flavio",
	  "Fleta",
	  "Fletcher",
	  "Flo",
	  "Florence",
	  "Florencio",
	  "Florian",
	  "Florida",
	  "Florine",
	  "Flossie",
	  "Floy",
	  "Floyd",
	  "Ford",
	  "Forest",
	  "Forrest",
	  "Foster",
	  "Frances",
	  "Francesca",
	  "Francesco",
	  "Francis",
	  "Francisca",
	  "Francisco",
	  "Franco",
	  "Frank",
	  "Frankie",
	  "Franz",
	  "Fred",
	  "Freda",
	  "Freddie",
	  "Freddy",
	  "Frederic",
	  "Frederick",
	  "Frederik",
	  "Frederique",
	  "Fredrick",
	  "Fredy",
	  "Freeda",
	  "Freeman",
	  "Freida",
	  "Frida",
	  "Frieda",
	  "Friedrich",
	  "Fritz",
	  "Furman",
	  "Gabe",
	  "Gabriel",
	  "Gabriella",
	  "Gabrielle",
	  "Gaetano",
	  "Gage",
	  "Gail",
	  "Gardner",
	  "Garett",
	  "Garfield",
	  "Garland",
	  "Garnet",
	  "Garnett",
	  "Garret",
	  "Garrett",
	  "Garrick",
	  "Garrison",
	  "Garry",
	  "Garth",
	  "Gaston",
	  "Gavin",
	  "Gay",
	  "Gayle",
	  "Gaylord",
	  "Gene",
	  "General",
	  "Genesis",
	  "Genevieve",
	  "Gennaro",
	  "Genoveva",
	  "Geo",
	  "Geoffrey",
	  "George",
	  "Georgette",
	  "Georgiana",
	  "Georgianna",
	  "Geovanni",
	  "Geovanny",
	  "Geovany",
	  "Gerald",
	  "Geraldine",
	  "Gerard",
	  "Gerardo",
	  "Gerda",
	  "Gerhard",
	  "Germaine",
	  "German",
	  "Gerry",
	  "Gerson",
	  "Gertrude",
	  "Gia",
	  "Gianni",
	  "Gideon",
	  "Gilbert",
	  "Gilberto",
	  "Gilda",
	  "Giles",
	  "Gillian",
	  "Gina",
	  "Gino",
	  "Giovani",
	  "Giovanna",
	  "Giovanni",
	  "Giovanny",
	  "Gisselle",
	  "Giuseppe",
	  "Gladyce",
	  "Gladys",
	  "Glen",
	  "Glenda",
	  "Glenna",
	  "Glennie",
	  "Gloria",
	  "Godfrey",
	  "Golda",
	  "Golden",
	  "Gonzalo",
	  "Gordon",
	  "Grace",
	  "Gracie",
	  "Graciela",
	  "Grady",
	  "Graham",
	  "Grant",
	  "Granville",
	  "Grayce",
	  "Grayson",
	  "Green",
	  "Greg",
	  "Gregg",
	  "Gregoria",
	  "Gregorio",
	  "Gregory",
	  "Greta",
	  "Gretchen",
	  "Greyson",
	  "Griffin",
	  "Grover",
	  "Guadalupe",
	  "Gudrun",
	  "Guido",
	  "Guillermo",
	  "Guiseppe",
	  "Gunnar",
	  "Gunner",
	  "Gus",
	  "Gussie",
	  "Gust",
	  "Gustave",
	  "Guy",
	  "Gwen",
	  "Gwendolyn",
	  "Hadley",
	  "Hailee",
	  "Hailey",
	  "Hailie",
	  "Hal",
	  "Haleigh",
	  "Haley",
	  "Halie",
	  "Halle",
	  "Hallie",
	  "Hank",
	  "Hanna",
	  "Hannah",
	  "Hans",
	  "Hardy",
	  "Harley",
	  "Harmon",
	  "Harmony",
	  "Harold",
	  "Harrison",
	  "Harry",
	  "Harvey",
	  "Haskell",
	  "Hassan",
	  "Hassie",
	  "Hattie",
	  "Haven",
	  "Hayden",
	  "Haylee",
	  "Hayley",
	  "Haylie",
	  "Hazel",
	  "Hazle",
	  "Heath",
	  "Heather",
	  "Heaven",
	  "Heber",
	  "Hector",
	  "Heidi",
	  "Helen",
	  "Helena",
	  "Helene",
	  "Helga",
	  "Hellen",
	  "Helmer",
	  "Heloise",
	  "Henderson",
	  "Henri",
	  "Henriette",
	  "Henry",
	  "Herbert",
	  "Herman",
	  "Hermann",
	  "Hermina",
	  "Herminia",
	  "Herminio",
	  "Hershel",
	  "Herta",
	  "Hertha",
	  "Hester",
	  "Hettie",
	  "Hilario",
	  "Hilbert",
	  "Hilda",
	  "Hildegard",
	  "Hillard",
	  "Hillary",
	  "Hilma",
	  "Hilton",
	  "Hipolito",
	  "Hiram",
	  "Hobart",
	  "Holden",
	  "Hollie",
	  "Hollis",
	  "Holly",
	  "Hope",
	  "Horace",
	  "Horacio",
	  "Hortense",
	  "Hosea",
	  "Houston",
	  "Howard",
	  "Howell",
	  "Hoyt",
	  "Hubert",
	  "Hudson",
	  "Hugh",
	  "Hulda",
	  "Humberto",
	  "Hunter",
	  "Hyman",
	  "Ian",
	  "Ibrahim",
	  "Icie",
	  "Ida",
	  "Idell",
	  "Idella",
	  "Ignacio",
	  "Ignatius",
	  "Ike",
	  "Ila",
	  "Ilene",
	  "Iliana",
	  "Ima",
	  "Imani",
	  "Imelda",
	  "Immanuel",
	  "Imogene",
	  "Ines",
	  "Irma",
	  "Irving",
	  "Irwin",
	  "Isaac",
	  "Isabel",
	  "Isabell",
	  "Isabella",
	  "Isabelle",
	  "Isac",
	  "Isadore",
	  "Isai",
	  "Isaiah",
	  "Isaias",
	  "Isidro",
	  "Ismael",
	  "Isobel",
	  "Isom",
	  "Israel",
	  "Issac",
	  "Itzel",
	  "Iva",
	  "Ivah",
	  "Ivory",
	  "Ivy",
	  "Izabella",
	  "Izaiah",
	  "Jabari",
	  "Jace",
	  "Jacey",
	  "Jacinthe",
	  "Jacinto",
	  "Jack",
	  "Jackeline",
	  "Jackie",
	  "Jacklyn",
	  "Jackson",
	  "Jacky",
	  "Jaclyn",
	  "Jacquelyn",
	  "Jacques",
	  "Jacynthe",
	  "Jada",
	  "Jade",
	  "Jaden",
	  "Jadon",
	  "Jadyn",
	  "Jaeden",
	  "Jaida",
	  "Jaiden",
	  "Jailyn",
	  "Jaime",
	  "Jairo",
	  "Jakayla",
	  "Jake",
	  "Jakob",
	  "Jaleel",
	  "Jalen",
	  "Jalon",
	  "Jalyn",
	  "Jamaal",
	  "Jamal",
	  "Jamar",
	  "Jamarcus",
	  "Jamel",
	  "Jameson",
	  "Jamey",
	  "Jamie",
	  "Jamil",
	  "Jamir",
	  "Jamison",
	  "Jammie",
	  "Jan",
	  "Jana",
	  "Janae",
	  "Jane",
	  "Janelle",
	  "Janessa",
	  "Janet",
	  "Janice",
	  "Janick",
	  "Janie",
	  "Janis",
	  "Janiya",
	  "Jannie",
	  "Jany",
	  "Jaquan",
	  "Jaquelin",
	  "Jaqueline",
	  "Jared",
	  "Jaren",
	  "Jarod",
	  "Jaron",
	  "Jarred",
	  "Jarrell",
	  "Jarret",
	  "Jarrett",
	  "Jarrod",
	  "Jarvis",
	  "Jasen",
	  "Jasmin",
	  "Jason",
	  "Jasper",
	  "Jaunita",
	  "Javier",
	  "Javon",
	  "Javonte",
	  "Jay",
	  "Jayce",
	  "Jaycee",
	  "Jayda",
	  "Jayde",
	  "Jayden",
	  "Jaydon",
	  "Jaylan",
	  "Jaylen",
	  "Jaylin",
	  "Jaylon",
	  "Jayme",
	  "Jayne",
	  "Jayson",
	  "Jazlyn",
	  "Jazmin",
	  "Jazmyn",
	  "Jazmyne",
	  "Jean",
	  "Jeanette",
	  "Jeanie",
	  "Jeanne",
	  "Jed",
	  "Jedediah",
	  "Jedidiah",
	  "Jeff",
	  "Jefferey",
	  "Jeffery",
	  "Jeffrey",
	  "Jeffry",
	  "Jena",
	  "Jenifer",
	  "Jennie",
	  "Jennifer",
	  "Jennings",
	  "Jennyfer",
	  "Jensen",
	  "Jerad",
	  "Jerald",
	  "Jeramie",
	  "Jeramy",
	  "Jerel",
	  "Jeremie",
	  "Jeremy",
	  "Jermain",
	  "Jermaine",
	  "Jermey",
	  "Jerod",
	  "Jerome",
	  "Jeromy",
	  "Jerrell",
	  "Jerrod",
	  "Jerrold",
	  "Jerry",
	  "Jess",
	  "Jesse",
	  "Jessica",
	  "Jessie",
	  "Jessika",
	  "Jessy",
	  "Jessyca",
	  "Jesus",
	  "Jett",
	  "Jettie",
	  "Jevon",
	  "Jewel",
	  "Jewell",
	  "Jillian",
	  "Jimmie",
	  "Jimmy",
	  "Jo",
	  "Joan",
	  "Joana",
	  "Joanie",
	  "Joanne",
	  "Joannie",
	  "Joanny",
	  "Joany",
	  "Joaquin",
	  "Jocelyn",
	  "Jodie",
	  "Jody",
	  "Joe",
	  "Joel",
	  "Joelle",
	  "Joesph",
	  "Joey",
	  "Johan",
	  "Johann",
	  "Johanna",
	  "Johathan",
	  "John",
	  "Johnathan",
	  "Johnathon",
	  "Johnnie",
	  "Johnny",
	  "Johnpaul",
	  "Johnson",
	  "Jolie",
	  "Jon",
	  "Jonas",
	  "Jonatan",
	  "Jonathan",
	  "Jonathon",
	  "Jordan",
	  "Jordane",
	  "Jordi",
	  "Jordon",
	  "Jordy",
	  "Jordyn",
	  "Jorge",
	  "Jose",
	  "Josefa",
	  "Josefina",
	  "Joseph",
	  "Josephine",
	  "Josh",
	  "Joshua",
	  "Joshuah",
	  "Josiah",
	  "Josiane",
	  "Josianne",
	  "Josie",
	  "Josue",
	  "Jovan",
	  "Jovani",
	  "Jovanny",
	  "Jovany",
	  "Joy",
	  "Joyce",
	  "Juana",
	  "Juanita",
	  "Judah",
	  "Judd",
	  "Jude",
	  "Judge",
	  "Judson",
	  "Judy",
	  "Jules",
	  "Julia",
	  "Julian",
	  "Juliana",
	  "Julianne",
	  "Julie",
	  "Julien",
	  "Juliet",
	  "Julio",
	  "Julius",
	  "June",
	  "Junior",
	  "Junius",
	  "Justen",
	  "Justice",
	  "Justina",
	  "Justine",
	  "Juston",
	  "Justus",
	  "Justyn",
	  "Juvenal",
	  "Juwan",
	  "Kacey",
	  "Kaci",
	  "Kacie",
	  "Kade",
	  "Kaden",
	  "Kadin",
	  "Kaela",
	  "Kaelyn",
	  "Kaia",
	  "Kailee",
	  "Kailey",
	  "Kailyn",
	  "Kaitlin",
	  "Kaitlyn",
	  "Kale",
	  "Kaleb",
	  "Kaleigh",
	  "Kaley",
	  "Kali",
	  "Kallie",
	  "Kameron",
	  "Kamille",
	  "Kamren",
	  "Kamron",
	  "Kamryn",
	  "Kane",
	  "Kara",
	  "Kareem",
	  "Karelle",
	  "Karen",
	  "Kari",
	  "Kariane",
	  "Karianne",
	  "Karina",
	  "Karine",
	  "Karl",
	  "Karlee",
	  "Karley",
	  "Karli",
	  "Karlie",
	  "Karolann",
	  "Karson",
	  "Kasandra",
	  "Kasey",
	  "Kassandra",
	  "Katarina",
	  "Katelin",
	  "Katelyn",
	  "Katelynn",
	  "Katharina",
	  "Katherine",
	  "Katheryn",
	  "Kathleen",
	  "Kathlyn",
	  "Kathryn",
	  "Kathryne",
	  "Katlyn",
	  "Katlynn",
	  "Katrina",
	  "Katrine",
	  "Kattie",
	  "Kavon",
	  "Kay",
	  "Kaya",
	  "Kaycee",
	  "Kayden",
	  "Kayla",
	  "Kaylah",
	  "Kaylee",
	  "Kayleigh",
	  "Kayley",
	  "Kayli",
	  "Kaylie",
	  "Kaylin",
	  "Keagan",
	  "Keanu",
	  "Keara",
	  "Keaton",
	  "Keegan",
	  "Keeley",
	  "Keely",
	  "Keenan",
	  "Keira",
	  "Keith",
	  "Kellen",
	  "Kelley",
	  "Kelli",
	  "Kellie",
	  "Kelly",
	  "Kelsi",
	  "Kelsie",
	  "Kelton",
	  "Kelvin",
	  "Ken",
	  "Kendall",
	  "Kendra",
	  "Kendrick",
	  "Kenna",
	  "Kennedi",
	  "Kennedy",
	  "Kenneth",
	  "Kennith",
	  "Kenny",
	  "Kenton",
	  "Kenya",
	  "Kenyatta",
	  "Kenyon",
	  "Keon",
	  "Keshaun",
	  "Keshawn",
	  "Keven",
	  "Kevin",
	  "Kevon",
	  "Keyon",
	  "Keyshawn",
	  "Khalid",
	  "Khalil",
	  "Kian",
	  "Kiana",
	  "Kianna",
	  "Kiara",
	  "Kiarra",
	  "Kiel",
	  "Kiera",
	  "Kieran",
	  "Kiley",
	  "Kim",
	  "Kimberly",
	  "King",
	  "Kip",
	  "Kira",
	  "Kirk",
	  "Kirsten",
	  "Kirstin",
	  "Kitty",
	  "Kobe",
	  "Koby",
	  "Kody",
	  "Kolby",
	  "Kole",
	  "Korbin",
	  "Korey",
	  "Kory",
	  "Kraig",
	  "Kris",
	  "Krista",
	  "Kristian",
	  "Kristin",
	  "Kristina",
	  "Kristofer",
	  "Kristoffer",
	  "Kristopher",
	  "Kristy",
	  "Krystal",
	  "Krystel",
	  "Krystina",
	  "Kurt",
	  "Kurtis",
	  "Kyla",
	  "Kyle",
	  "Kylee",
	  "Kyleigh",
	  "Kyler",
	  "Kylie",
	  "Kyra",
	  "Lacey",
	  "Lacy",
	  "Ladarius",
	  "Lafayette",
	  "Laila",
	  "Laisha",
	  "Lamar",
	  "Lambert",
	  "Lamont",
	  "Lance",
	  "Landen",
	  "Lane",
	  "Laney",
	  "Larissa",
	  "Laron",
	  "Larry",
	  "Larue",
	  "Laura",
	  "Laurel",
	  "Lauren",
	  "Laurence",
	  "Lauretta",
	  "Lauriane",
	  "Laurianne",
	  "Laurie",
	  "Laurine",
	  "Laury",
	  "Lauryn",
	  "Lavada",
	  "Lavern",
	  "Laverna",
	  "Laverne",
	  "Lavina",
	  "Lavinia",
	  "Lavon",
	  "Lavonne",
	  "Lawrence",
	  "Lawson",
	  "Layla",
	  "Layne",
	  "Lazaro",
	  "Lea",
	  "Leann",
	  "Leanna",
	  "Leanne",
	  "Leatha",
	  "Leda",
	  "Lee",
	  "Leif",
	  "Leila",
	  "Leilani",
	  "Lela",
	  "Lelah",
	  "Leland",
	  "Lelia",
	  "Lempi",
	  "Lemuel",
	  "Lenna",
	  "Lennie",
	  "Lenny",
	  "Lenora",
	  "Lenore",
	  "Leo",
	  "Leola",
	  "Leon",
	  "Leonard",
	  "Leonardo",
	  "Leone",
	  "Leonel",
	  "Leonie",
	  "Leonor",
	  "Leonora",
	  "Leopold",
	  "Leopoldo",
	  "Leora",
	  "Lera",
	  "Lesley",
	  "Leslie",
	  "Lesly",
	  "Lessie",
	  "Lester",
	  "Leta",
	  "Letha",
	  "Letitia",
	  "Levi",
	  "Lew",
	  "Lewis",
	  "Lexi",
	  "Lexie",
	  "Lexus",
	  "Lia",
	  "Liam",
	  "Liana",
	  "Libbie",
	  "Libby",
	  "Lila",
	  "Lilian",
	  "Liliana",
	  "Liliane",
	  "Lilla",
	  "Lillian",
	  "Lilliana",
	  "Lillie",
	  "Lilly",
	  "Lily",
	  "Lilyan",
	  "Lina",
	  "Lincoln",
	  "Linda",
	  "Lindsay",
	  "Lindsey",
	  "Linnea",
	  "Linnie",
	  "Linwood",
	  "Lionel",
	  "Lisa",
	  "Lisandro",
	  "Lisette",
	  "Litzy",
	  "Liza",
	  "Lizeth",
	  "Lizzie",
	  "Llewellyn",
	  "Lloyd",
	  "Logan",
	  "Lois",
	  "Lola",
	  "Lolita",
	  "Loma",
	  "Lon",
	  "London",
	  "Lonie",
	  "Lonnie",
	  "Lonny",
	  "Lonzo",
	  "Lora",
	  "Loraine",
	  "Loren",
	  "Lorena",
	  "Lorenz",
	  "Lorenza",
	  "Lorenzo",
	  "Lori",
	  "Lorine",
	  "Lorna",
	  "Lottie",
	  "Lou",
	  "Louie",
	  "Louisa",
	  "Lourdes",
	  "Louvenia",
	  "Lowell",
	  "Loy",
	  "Loyal",
	  "Loyce",
	  "Lucas",
	  "Luciano",
	  "Lucie",
	  "Lucienne",
	  "Lucile",
	  "Lucinda",
	  "Lucio",
	  "Lucious",
	  "Lucius",
	  "Lucy",
	  "Ludie",
	  "Ludwig",
	  "Lue",
	  "Luella",
	  "Luigi",
	  "Luis",
	  "Luisa",
	  "Lukas",
	  "Lula",
	  "Lulu",
	  "Luna",
	  "Lupe",
	  "Lura",
	  "Lurline",
	  "Luther",
	  "Luz",
	  "Lyda",
	  "Lydia",
	  "Lyla",
	  "Lynn",
	  "Lyric",
	  "Lysanne",
	  "Mabel",
	  "Mabelle",
	  "Mable",
	  "Mac",
	  "Macey",
	  "Maci",
	  "Macie",
	  "Mack",
	  "Mackenzie",
	  "Macy",
	  "Madaline",
	  "Madalyn",
	  "Maddison",
	  "Madeline",
	  "Madelyn",
	  "Madelynn",
	  "Madge",
	  "Madie",
	  "Madilyn",
	  "Madisen",
	  "Madison",
	  "Madisyn",
	  "Madonna",
	  "Madyson",
	  "Mae",
	  "Maegan",
	  "Maeve",
	  "Mafalda",
	  "Magali",
	  "Magdalen",
	  "Magdalena",
	  "Maggie",
	  "Magnolia",
	  "Magnus",
	  "Maia",
	  "Maida",
	  "Maiya",
	  "Major",
	  "Makayla",
	  "Makenna",
	  "Makenzie",
	  "Malachi",
	  "Malcolm",
	  "Malika",
	  "Malinda",
	  "Mallie",
	  "Mallory",
	  "Malvina",
	  "Mandy",
	  "Manley",
	  "Manuel",
	  "Manuela",
	  "Mara",
	  "Marc",
	  "Marcel",
	  "Marcelina",
	  "Marcelino",
	  "Marcella",
	  "Marcelle",
	  "Marcellus",
	  "Marcelo",
	  "Marcia",
	  "Marco",
	  "Marcos",
	  "Marcus",
	  "Margaret",
	  "Margarete",
	  "Margarett",
	  "Margaretta",
	  "Margarette",
	  "Margarita",
	  "Marge",
	  "Margie",
	  "Margot",
	  "Margret",
	  "Marguerite",
	  "Maria",
	  "Mariah",
	  "Mariam",
	  "Marian",
	  "Mariana",
	  "Mariane",
	  "Marianna",
	  "Marianne",
	  "Mariano",
	  "Maribel",
	  "Marie",
	  "Mariela",
	  "Marielle",
	  "Marietta",
	  "Marilie",
	  "Marilou",
	  "Marilyne",
	  "Marina",
	  "Mario",
	  "Marion",
	  "Marisa",
	  "Marisol",
	  "Maritza",
	  "Marjolaine",
	  "Marjorie",
	  "Marjory",
	  "Mark",
	  "Markus",
	  "Marlee",
	  "Marlen",
	  "Marlene",
	  "Marley",
	  "Marlin",
	  "Marlon",
	  "Marques",
	  "Marquis",
	  "Marquise",
	  "Marshall",
	  "Marta",
	  "Martin",
	  "Martina",
	  "Martine",
	  "Marty",
	  "Marvin",
	  "Mary",
	  "Maryam",
	  "Maryjane",
	  "Maryse",
	  "Mason",
	  "Mateo",
	  "Mathew",
	  "Mathias",
	  "Mathilde",
	  "Matilda",
	  "Matilde",
	  "Matt",
	  "Matteo",
	  "Mattie",
	  "Maud",
	  "Maude",
	  "Maudie",
	  "Maureen",
	  "Maurice",
	  "Mauricio",
	  "Maurine",
	  "Maverick",
	  "Mavis",
	  "Max",
	  "Maxie",
	  "Maxime",
	  "Maximilian",
	  "Maximillia",
	  "Maximillian",
	  "Maximo",
	  "Maximus",
	  "Maxine",
	  "Maxwell",
	  "May",
	  "Maya",
	  "Maybell",
	  "Maybelle",
	  "Maye",
	  "Maymie",
	  "Maynard",
	  "Mayra",
	  "Mazie",
	  "Mckayla",
	  "Mckenna",
	  "Mckenzie",
	  "Meagan",
	  "Meaghan",
	  "Meda",
	  "Megane",
	  "Meggie",
	  "Meghan",
	  "Mekhi",
	  "Melany",
	  "Melba",
	  "Melisa",
	  "Melissa",
	  "Mellie",
	  "Melody",
	  "Melvin",
	  "Melvina",
	  "Melyna",
	  "Melyssa",
	  "Mercedes",
	  "Meredith",
	  "Merl",
	  "Merle",
	  "Merlin",
	  "Merritt",
	  "Mertie",
	  "Mervin",
	  "Meta",
	  "Mia",
	  "Micaela",
	  "Micah",
	  "Michael",
	  "Michaela",
	  "Michale",
	  "Micheal",
	  "Michel",
	  "Michele",
	  "Michelle",
	  "Miguel",
	  "Mikayla",
	  "Mike",
	  "Mikel",
	  "Milan",
	  "Miles",
	  "Milford",
	  "Miller",
	  "Millie",
	  "Milo",
	  "Milton",
	  "Mina",
	  "Minerva",
	  "Minnie",
	  "Miracle",
	  "Mireille",
	  "Mireya",
	  "Misael",
	  "Missouri",
	  "Misty",
	  "Mitchel",
	  "Mitchell",
	  "Mittie",
	  "Modesta",
	  "Modesto",
	  "Mohamed",
	  "Mohammad",
	  "Mohammed",
	  "Moises",
	  "Mollie",
	  "Molly",
	  "Mona",
	  "Monica",
	  "Monique",
	  "Monroe",
	  "Monserrat",
	  "Monserrate",
	  "Montana",
	  "Monte",
	  "Monty",
	  "Morgan",
	  "Moriah",
	  "Morris",
	  "Mortimer",
	  "Morton",
	  "Mose",
	  "Moses",
	  "Moshe",
	  "Mossie",
	  "Mozell",
	  "Mozelle",
	  "Muhammad",
	  "Muriel",
	  "Murl",
	  "Murphy",
	  "Murray",
	  "Mustafa",
	  "Mya",
	  "Myah",
	  "Mylene",
	  "Myles",
	  "Myra",
	  "Myriam",
	  "Myrl",
	  "Myrna",
	  "Myron",
	  "Myrtice",
	  "Myrtie",
	  "Myrtis",
	  "Myrtle",
	  "Nadia",
	  "Nakia",
	  "Name",
	  "Nannie",
	  "Naomi",
	  "Naomie",
	  "Napoleon",
	  "Narciso",
	  "Nash",
	  "Nasir",
	  "Nat",
	  "Natalia",
	  "Natalie",
	  "Natasha",
	  "Nathan",
	  "Nathanael",
	  "Nathanial",
	  "Nathaniel",
	  "Nathen",
	  "Nayeli",
	  "Neal",
	  "Ned",
	  "Nedra",
	  "Neha",
	  "Neil",
	  "Nelda",
	  "Nella",
	  "Nelle",
	  "Nellie",
	  "Nels",
	  "Nelson",
	  "Neoma",
	  "Nestor",
	  "Nettie",
	  "Neva",
	  "Newell",
	  "Newton",
	  "Nia",
	  "Nicholas",
	  "Nicholaus",
	  "Nichole",
	  "Nick",
	  "Nicklaus",
	  "Nickolas",
	  "Nico",
	  "Nicola",
	  "Nicolas",
	  "Nicole",
	  "Nicolette",
	  "Nigel",
	  "Nikita",
	  "Nikki",
	  "Nikko",
	  "Niko",
	  "Nikolas",
	  "Nils",
	  "Nina",
	  "Noah",
	  "Noble",
	  "Noe",
	  "Noel",
	  "Noelia",
	  "Noemi",
	  "Noemie",
	  "Noemy",
	  "Nola",
	  "Nolan",
	  "Nona",
	  "Nora",
	  "Norbert",
	  "Norberto",
	  "Norene",
	  "Norma",
	  "Norris",
	  "Norval",
	  "Norwood",
	  "Nova",
	  "Novella",
	  "Nya",
	  "Nyah",
	  "Nyasia",
	  "Obie",
	  "Oceane",
	  "Ocie",
	  "Octavia",
	  "Oda",
	  "Odell",
	  "Odessa",
	  "Odie",
	  "Ofelia",
	  "Okey",
	  "Ola",
	  "Olaf",
	  "Ole",
	  "Olen",
	  "Oleta",
	  "Olga",
	  "Olin",
	  "Oliver",
	  "Ollie",
	  "Oma",
	  "Omari",
	  "Omer",
	  "Ona",
	  "Onie",
	  "Opal",
	  "Ophelia",
	  "Ora",
	  "Oral",
	  "Oran",
	  "Oren",
	  "Orie",
	  "Orin",
	  "Orion",
	  "Orland",
	  "Orlando",
	  "Orlo",
	  "Orpha",
	  "Orrin",
	  "Orval",
	  "Orville",
	  "Osbaldo",
	  "Osborne",
	  "Oscar",
	  "Osvaldo",
	  "Oswald",
	  "Oswaldo",
	  "Otha",
	  "Otho",
	  "Otilia",
	  "Otis",
	  "Ottilie",
	  "Ottis",
	  "Otto",
	  "Ova",
	  "Owen",
	  "Ozella",
	  "Pablo",
	  "Paige",
	  "Palma",
	  "Pamela",
	  "Pansy",
	  "Paolo",
	  "Paris",
	  "Parker",
	  "Pascale",
	  "Pasquale",
	  "Pat",
	  "Patience",
	  "Patricia",
	  "Patrick",
	  "Patsy",
	  "Pattie",
	  "Paul",
	  "Paula",
	  "Pauline",
	  "Paxton",
	  "Payton",
	  "Pearl",
	  "Pearlie",
	  "Pearline",
	  "Pedro",
	  "Peggie",
	  "Penelope",
	  "Percival",
	  "Percy",
	  "Perry",
	  "Pete",
	  "Peter",
	  "Petra",
	  "Peyton",
	  "Philip",
	  "Phoebe",
	  "Phyllis",
	  "Pierce",
	  "Pierre",
	  "Pietro",
	  "Pink",
	  "Pinkie",
	  "Piper",
	  "Polly",
	  "Porter",
	  "Precious",
	  "Presley",
	  "Preston",
	  "Price",
	  "Prince",
	  "Princess",
	  "Priscilla",
	  "Providenci",
	  "Prudence",
	  "Queen",
	  "Queenie",
	  "Quentin",
	  "Quincy",
	  "Quinn",
	  "Quinten",
	  "Quinton",
	  "Rachael",
	  "Rachel",
	  "Rachelle",
	  "Rae",
	  "Raegan",
	  "Rafael",
	  "Rafaela",
	  "Raheem",
	  "Rahsaan",
	  "Rahul",
	  "Raina",
	  "Raleigh",
	  "Ralph",
	  "Ramiro",
	  "Ramon",
	  "Ramona",
	  "Randal",
	  "Randall",
	  "Randi",
	  "Randy",
	  "Ransom",
	  "Raoul",
	  "Raphael",
	  "Raphaelle",
	  "Raquel",
	  "Rashad",
	  "Rashawn",
	  "Rasheed",
	  "Raul",
	  "Raven",
	  "Ray",
	  "Raymond",
	  "Raymundo",
	  "Reagan",
	  "Reanna",
	  "Reba",
	  "Rebeca",
	  "Rebecca",
	  "Rebeka",
	  "Rebekah",
	  "Reece",
	  "Reed",
	  "Reese",
	  "Regan",
	  "Reggie",
	  "Reginald",
	  "Reid",
	  "Reilly",
	  "Reina",
	  "Reinhold",
	  "Remington",
	  "Rene",
	  "Renee",
	  "Ressie",
	  "Reta",
	  "Retha",
	  "Retta",
	  "Reuben",
	  "Reva",
	  "Rex",
	  "Rey",
	  "Reyes",
	  "Reymundo",
	  "Reyna",
	  "Reynold",
	  "Rhea",
	  "Rhett",
	  "Rhianna",
	  "Rhiannon",
	  "Rhoda",
	  "Ricardo",
	  "Richard",
	  "Richie",
	  "Richmond",
	  "Rick",
	  "Rickey",
	  "Rickie",
	  "Ricky",
	  "Rico",
	  "Rigoberto",
	  "Riley",
	  "Rita",
	  "River",
	  "Robb",
	  "Robbie",
	  "Robert",
	  "Roberta",
	  "Roberto",
	  "Robin",
	  "Robyn",
	  "Rocio",
	  "Rocky",
	  "Rod",
	  "Roderick",
	  "Rodger",
	  "Rodolfo",
	  "Rodrick",
	  "Rodrigo",
	  "Roel",
	  "Rogelio",
	  "Roger",
	  "Rogers",
	  "Rolando",
	  "Rollin",
	  "Roma",
	  "Romaine",
	  "Roman",
	  "Ron",
	  "Ronaldo",
	  "Ronny",
	  "Roosevelt",
	  "Rory",
	  "Rosa",
	  "Rosalee",
	  "Rosalia",
	  "Rosalind",
	  "Rosalinda",
	  "Rosalyn",
	  "Rosamond",
	  "Rosanna",
	  "Rosario",
	  "Roscoe",
	  "Rose",
	  "Rosella",
	  "Roselyn",
	  "Rosemarie",
	  "Rosemary",
	  "Rosendo",
	  "Rosetta",
	  "Rosie",
	  "Rosina",
	  "Roslyn",
	  "Ross",
	  "Rossie",
	  "Rowan",
	  "Rowena",
	  "Rowland",
	  "Roxane",
	  "Roxanne",
	  "Roy",
	  "Royal",
	  "Royce",
	  "Rozella",
	  "Ruben",
	  "Rubie",
	  "Ruby",
	  "Rubye",
	  "Rudolph",
	  "Rudy",
	  "Rupert",
	  "Russ",
	  "Russel",
	  "Russell",
	  "Rusty",
	  "Ruth",
	  "Ruthe",
	  "Ruthie",
	  "Ryan",
	  "Ryann",
	  "Ryder",
	  "Rylan",
	  "Rylee",
	  "Ryleigh",
	  "Ryley",
	  "Sabina",
	  "Sabrina",
	  "Sabryna",
	  "Sadie",
	  "Sadye",
	  "Sage",
	  "Saige",
	  "Sallie",
	  "Sally",
	  "Salma",
	  "Salvador",
	  "Salvatore",
	  "Sam",
	  "Samanta",
	  "Samantha",
	  "Samara",
	  "Samir",
	  "Sammie",
	  "Sammy",
	  "Samson",
	  "Sandra",
	  "Sandrine",
	  "Sandy",
	  "Sanford",
	  "Santa",
	  "Santiago",
	  "Santina",
	  "Santino",
	  "Santos",
	  "Sarah",
	  "Sarai",
	  "Sarina",
	  "Sasha",
	  "Saul",
	  "Savanah",
	  "Savanna",
	  "Savannah",
	  "Savion",
	  "Scarlett",
	  "Schuyler",
	  "Scot",
	  "Scottie",
	  "Scotty",
	  "Seamus",
	  "Sean",
	  "Sebastian",
	  "Sedrick",
	  "Selena",
	  "Selina",
	  "Selmer",
	  "Serena",
	  "Serenity",
	  "Seth",
	  "Shad",
	  "Shaina",
	  "Shakira",
	  "Shana",
	  "Shane",
	  "Shanel",
	  "Shanelle",
	  "Shania",
	  "Shanie",
	  "Shaniya",
	  "Shanna",
	  "Shannon",
	  "Shanny",
	  "Shanon",
	  "Shany",
	  "Sharon",
	  "Shaun",
	  "Shawn",
	  "Shawna",
	  "Shaylee",
	  "Shayna",
	  "Shayne",
	  "Shea",
	  "Sheila",
	  "Sheldon",
	  "Shemar",
	  "Sheridan",
	  "Sherman",
	  "Sherwood",
	  "Shirley",
	  "Shyann",
	  "Shyanne",
	  "Sibyl",
	  "Sid",
	  "Sidney",
	  "Sienna",
	  "Sierra",
	  "Sigmund",
	  "Sigrid",
	  "Sigurd",
	  "Silas",
	  "Sim",
	  "Simeon",
	  "Simone",
	  "Sincere",
	  "Sister",
	  "Skye",
	  "Skyla",
	  "Skylar",
	  "Sofia",
	  "Soledad",
	  "Solon",
	  "Sonia",
	  "Sonny",
	  "Sonya",
	  "Sophia",
	  "Sophie",
	  "Spencer",
	  "Stacey",
	  "Stacy",
	  "Stan",
	  "Stanford",
	  "Stanley",
	  "Stanton",
	  "Stefan",
	  "Stefanie",
	  "Stella",
	  "Stephan",
	  "Stephania",
	  "Stephanie",
	  "Stephany",
	  "Stephen",
	  "Stephon",
	  "Sterling",
	  "Steve",
	  "Stevie",
	  "Stewart",
	  "Stone",
	  "Stuart",
	  "Summer",
	  "Sunny",
	  "Susan",
	  "Susana",
	  "Susanna",
	  "Susie",
	  "Suzanne",
	  "Sven",
	  "Syble",
	  "Sydnee",
	  "Sydney",
	  "Sydni",
	  "Sydnie",
	  "Sylvan",
	  "Sylvester",
	  "Sylvia",
	  "Tabitha",
	  "Tad",
	  "Talia",
	  "Talon",
	  "Tamara",
	  "Tamia",
	  "Tania",
	  "Tanner",
	  "Tanya",
	  "Tara",
	  "Taryn",
	  "Tate",
	  "Tatum",
	  "Tatyana",
	  "Taurean",
	  "Tavares",
	  "Taya",
	  "Taylor",
	  "Teagan",
	  "Ted",
	  "Telly",
	  "Terence",
	  "Teresa",
	  "Terrance",
	  "Terrell",
	  "Terrence",
	  "Terrill",
	  "Terry",
	  "Tess",
	  "Tessie",
	  "Tevin",
	  "Thad",
	  "Thaddeus",
	  "Thalia",
	  "Thea",
	  "Thelma",
	  "Theo",
	  "Theodora",
	  "Theodore",
	  "Theresa",
	  "Therese",
	  "Theresia",
	  "Theron",
	  "Thomas",
	  "Thora",
	  "Thurman",
	  "Tia",
	  "Tiana",
	  "Tianna",
	  "Tiara",
	  "Tierra",
	  "Tiffany",
	  "Tillman",
	  "Timmothy",
	  "Timmy",
	  "Timothy",
	  "Tina",
	  "Tito",
	  "Titus",
	  "Tobin",
	  "Toby",
	  "Tod",
	  "Tom",
	  "Tomas",
	  "Tomasa",
	  "Tommie",
	  "Toney",
	  "Toni",
	  "Tony",
	  "Torey",
	  "Torrance",
	  "Torrey",
	  "Toy",
	  "Trace",
	  "Tracey",
	  "Tracy",
	  "Travis",
	  "Travon",
	  "Tre",
	  "Tremaine",
	  "Tremayne",
	  "Trent",
	  "Trenton",
	  "Tressa",
	  "Tressie",
	  "Treva",
	  "Trever",
	  "Trevion",
	  "Trevor",
	  "Trey",
	  "Trinity",
	  "Trisha",
	  "Tristian",
	  "Tristin",
	  "Triston",
	  "Troy",
	  "Trudie",
	  "Trycia",
	  "Trystan",
	  "Turner",
	  "Twila",
	  "Tyler",
	  "Tyra",
	  "Tyree",
	  "Tyreek",
	  "Tyrel",
	  "Tyrell",
	  "Tyrese",
	  "Tyrique",
	  "Tyshawn",
	  "Tyson",
	  "Ubaldo",
	  "Ulices",
	  "Ulises",
	  "Una",
	  "Unique",
	  "Urban",
	  "Uriah",
	  "Uriel",
	  "Ursula",
	  "Vada",
	  "Valentin",
	  "Valentina",
	  "Valentine",
	  "Valerie",
	  "Vallie",
	  "Van",
	  "Vance",
	  "Vanessa",
	  "Vaughn",
	  "Veda",
	  "Velda",
	  "Vella",
	  "Velma",
	  "Velva",
	  "Vena",
	  "Verda",
	  "Verdie",
	  "Vergie",
	  "Verla",
	  "Verlie",
	  "Vern",
	  "Verna",
	  "Verner",
	  "Vernice",
	  "Vernie",
	  "Vernon",
	  "Verona",
	  "Veronica",
	  "Vesta",
	  "Vicenta",
	  "Vicente",
	  "Vickie",
	  "Vicky",
	  "Victor",
	  "Victoria",
	  "Vida",
	  "Vidal",
	  "Vilma",
	  "Vince",
	  "Vincent",
	  "Vincenza",
	  "Vincenzo",
	  "Vinnie",
	  "Viola",
	  "Violet",
	  "Violette",
	  "Virgie",
	  "Virgil",
	  "Virginia",
	  "Virginie",
	  "Vita",
	  "Vito",
	  "Viva",
	  "Vivian",
	  "Viviane",
	  "Vivianne",
	  "Vivien",
	  "Vivienne",
	  "Vladimir",
	  "Wade",
	  "Waino",
	  "Waldo",
	  "Walker",
	  "Wallace",
	  "Walter",
	  "Walton",
	  "Wanda",
	  "Ward",
	  "Warren",
	  "Watson",
	  "Wava",
	  "Waylon",
	  "Wayne",
	  "Webster",
	  "Weldon",
	  "Wellington",
	  "Wendell",
	  "Wendy",
	  "Werner",
	  "Westley",
	  "Weston",
	  "Whitney",
	  "Wilber",
	  "Wilbert",
	  "Wilburn",
	  "Wiley",
	  "Wilford",
	  "Wilfred",
	  "Wilfredo",
	  "Wilfrid",
	  "Wilhelm",
	  "Wilhelmine",
	  "Will",
	  "Willa",
	  "Willard",
	  "William",
	  "Willie",
	  "Willis",
	  "Willow",
	  "Willy",
	  "Wilma",
	  "Wilmer",
	  "Wilson",
	  "Wilton",
	  "Winfield",
	  "Winifred",
	  "Winnifred",
	  "Winona",
	  "Winston",
	  "Woodrow",
	  "Wyatt",
	  "Wyman",
	  "Xander",
	  "Xavier",
	  "Xzavier",
	  "Yadira",
	  "Yasmeen",
	  "Yasmin",
	  "Yasmine",
	  "Yazmin",
	  "Yesenia",
	  "Yessenia",
	  "Yolanda",
	  "Yoshiko",
	  "Yvette",
	  "Yvonne",
	  "Zachariah",
	  "Zachary",
	  "Zachery",
	  "Zack",
	  "Zackary",
	  "Zackery",
	  "Zakary",
	  "Zander",
	  "Zane",
	  "Zaria",
	  "Zechariah",
	  "Zelda",
	  "Zella",
	  "Zelma",
	  "Zena",
	  "Zetta",
	  "Zion",
	  "Zita",
	  "Zoe",
	  "Zoey",
	  "Zoie",
	  "Zoila",
	  "Zola",
	  "Zora",
	  "Zula"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2097);
	name.last_name = __webpack_require__(2099);
	name.prefix = __webpack_require__(2101);
	name.suffix = __webpack_require__(2102);
	name.title = __webpack_require__(2103);
	name.name = __webpack_require__(2100);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abbott",
	  "Abernathy",
	  "Abshire",
	  "Adams",
	  "Altenwerth",
	  "Anderson",
	  "Ankunding",
	  "Armstrong",
	  "Auer",
	  "Aufderhar",
	  "Bahringer",
	  "Bailey",
	  "Balistreri",
	  "Barrows",
	  "Bartell",
	  "Bartoletti",
	  "Barton",
	  "Bashirian",
	  "Batz",
	  "Bauch",
	  "Baumbach",
	  "Bayer",
	  "Beahan",
	  "Beatty",
	  "Bechtelar",
	  "Becker",
	  "Bednar",
	  "Beer",
	  "Beier",
	  "Berge",
	  "Bergnaum",
	  "Bergstrom",
	  "Bernhard",
	  "Bernier",
	  "Bins",
	  "Blanda",
	  "Blick",
	  "Block",
	  "Bode",
	  "Boehm",
	  "Bogan",
	  "Bogisich",
	  "Borer",
	  "Bosco",
	  "Botsford",
	  "Boyer",
	  "Boyle",
	  "Bradtke",
	  "Brakus",
	  "Braun",
	  "Breitenberg",
	  "Brekke",
	  "Brown",
	  "Bruen",
	  "Buckridge",
	  "Carroll",
	  "Carter",
	  "Cartwright",
	  "Casper",
	  "Cassin",
	  "Champlin",
	  "Christiansen",
	  "Cole",
	  "Collier",
	  "Collins",
	  "Conn",
	  "Connelly",
	  "Conroy",
	  "Considine",
	  "Corkery",
	  "Cormier",
	  "Corwin",
	  "Cremin",
	  "Crist",
	  "Crona",
	  "Cronin",
	  "Crooks",
	  "Cruickshank",
	  "Cummerata",
	  "Cummings",
	  "Dach",
	  "D'Amore",
	  "Daniel",
	  "Dare",
	  "Daugherty",
	  "Davis",
	  "Deckow",
	  "Denesik",
	  "Dibbert",
	  "Dickens",
	  "Dicki",
	  "Dickinson",
	  "Dietrich",
	  "Donnelly",
	  "Dooley",
	  "Douglas",
	  "Doyle",
	  "DuBuque",
	  "Durgan",
	  "Ebert",
	  "Effertz",
	  "Eichmann",
	  "Emard",
	  "Emmerich",
	  "Erdman",
	  "Ernser",
	  "Fadel",
	  "Fahey",
	  "Farrell",
	  "Fay",
	  "Feeney",
	  "Feest",
	  "Feil",
	  "Ferry",
	  "Fisher",
	  "Flatley",
	  "Frami",
	  "Franecki",
	  "Friesen",
	  "Fritsch",
	  "Funk",
	  "Gaylord",
	  "Gerhold",
	  "Gerlach",
	  "Gibson",
	  "Gislason",
	  "Gleason",
	  "Gleichner",
	  "Glover",
	  "Goldner",
	  "Goodwin",
	  "Gorczany",
	  "Gottlieb",
	  "Goyette",
	  "Grady",
	  "Graham",
	  "Grant",
	  "Green",
	  "Greenfelder",
	  "Greenholt",
	  "Grimes",
	  "Gulgowski",
	  "Gusikowski",
	  "Gutkowski",
	  "Gutmann",
	  "Haag",
	  "Hackett",
	  "Hagenes",
	  "Hahn",
	  "Haley",
	  "Halvorson",
	  "Hamill",
	  "Hammes",
	  "Hand",
	  "Hane",
	  "Hansen",
	  "Harber",
	  "Harris",
	  "Hartmann",
	  "Harvey",
	  "Hauck",
	  "Hayes",
	  "Heaney",
	  "Heathcote",
	  "Hegmann",
	  "Heidenreich",
	  "Heller",
	  "Herman",
	  "Hermann",
	  "Hermiston",
	  "Herzog",
	  "Hessel",
	  "Hettinger",
	  "Hickle",
	  "Hilll",
	  "Hills",
	  "Hilpert",
	  "Hintz",
	  "Hirthe",
	  "Hodkiewicz",
	  "Hoeger",
	  "Homenick",
	  "Hoppe",
	  "Howe",
	  "Howell",
	  "Hudson",
	  "Huel",
	  "Huels",
	  "Hyatt",
	  "Jacobi",
	  "Jacobs",
	  "Jacobson",
	  "Jakubowski",
	  "Jaskolski",
	  "Jast",
	  "Jenkins",
	  "Jerde",
	  "Johns",
	  "Johnson",
	  "Johnston",
	  "Jones",
	  "Kassulke",
	  "Kautzer",
	  "Keebler",
	  "Keeling",
	  "Kemmer",
	  "Kerluke",
	  "Kertzmann",
	  "Kessler",
	  "Kiehn",
	  "Kihn",
	  "Kilback",
	  "King",
	  "Kirlin",
	  "Klein",
	  "Kling",
	  "Klocko",
	  "Koch",
	  "Koelpin",
	  "Koepp",
	  "Kohler",
	  "Konopelski",
	  "Koss",
	  "Kovacek",
	  "Kozey",
	  "Krajcik",
	  "Kreiger",
	  "Kris",
	  "Kshlerin",
	  "Kub",
	  "Kuhic",
	  "Kuhlman",
	  "Kuhn",
	  "Kulas",
	  "Kunde",
	  "Kunze",
	  "Kuphal",
	  "Kutch",
	  "Kuvalis",
	  "Labadie",
	  "Lakin",
	  "Lang",
	  "Langosh",
	  "Langworth",
	  "Larkin",
	  "Larson",
	  "Leannon",
	  "Lebsack",
	  "Ledner",
	  "Leffler",
	  "Legros",
	  "Lehner",
	  "Lemke",
	  "Lesch",
	  "Leuschke",
	  "Lind",
	  "Lindgren",
	  "Littel",
	  "Little",
	  "Lockman",
	  "Lowe",
	  "Lubowitz",
	  "Lueilwitz",
	  "Luettgen",
	  "Lynch",
	  "Macejkovic",
	  "MacGyver",
	  "Maggio",
	  "Mann",
	  "Mante",
	  "Marks",
	  "Marquardt",
	  "Marvin",
	  "Mayer",
	  "Mayert",
	  "McClure",
	  "McCullough",
	  "McDermott",
	  "McGlynn",
	  "McKenzie",
	  "McLaughlin",
	  "Medhurst",
	  "Mertz",
	  "Metz",
	  "Miller",
	  "Mills",
	  "Mitchell",
	  "Moen",
	  "Mohr",
	  "Monahan",
	  "Moore",
	  "Morar",
	  "Morissette",
	  "Mosciski",
	  "Mraz",
	  "Mueller",
	  "Muller",
	  "Murazik",
	  "Murphy",
	  "Murray",
	  "Nader",
	  "Nicolas",
	  "Nienow",
	  "Nikolaus",
	  "Nitzsche",
	  "Nolan",
	  "Oberbrunner",
	  "O'Connell",
	  "O'Conner",
	  "O'Hara",
	  "O'Keefe",
	  "O'Kon",
	  "Okuneva",
	  "Olson",
	  "Ondricka",
	  "O'Reilly",
	  "Orn",
	  "Ortiz",
	  "Osinski",
	  "Pacocha",
	  "Padberg",
	  "Pagac",
	  "Parisian",
	  "Parker",
	  "Paucek",
	  "Pfannerstill",
	  "Pfeffer",
	  "Pollich",
	  "Pouros",
	  "Powlowski",
	  "Predovic",
	  "Price",
	  "Prohaska",
	  "Prosacco",
	  "Purdy",
	  "Quigley",
	  "Quitzon",
	  "Rath",
	  "Ratke",
	  "Rau",
	  "Raynor",
	  "Reichel",
	  "Reichert",
	  "Reilly",
	  "Reinger",
	  "Rempel",
	  "Renner",
	  "Reynolds",
	  "Rice",
	  "Rippin",
	  "Ritchie",
	  "Robel",
	  "Roberts",
	  "Rodriguez",
	  "Rogahn",
	  "Rohan",
	  "Rolfson",
	  "Romaguera",
	  "Roob",
	  "Rosenbaum",
	  "Rowe",
	  "Ruecker",
	  "Runolfsdottir",
	  "Runolfsson",
	  "Runte",
	  "Russel",
	  "Rutherford",
	  "Ryan",
	  "Sanford",
	  "Satterfield",
	  "Sauer",
	  "Sawayn",
	  "Schaden",
	  "Schaefer",
	  "Schamberger",
	  "Schiller",
	  "Schimmel",
	  "Schinner",
	  "Schmeler",
	  "Schmidt",
	  "Schmitt",
	  "Schneider",
	  "Schoen",
	  "Schowalter",
	  "Schroeder",
	  "Schulist",
	  "Schultz",
	  "Schumm",
	  "Schuppe",
	  "Schuster",
	  "Senger",
	  "Shanahan",
	  "Shields",
	  "Simonis",
	  "Sipes",
	  "Skiles",
	  "Smith",
	  "Smitham",
	  "Spencer",
	  "Spinka",
	  "Sporer",
	  "Stamm",
	  "Stanton",
	  "Stark",
	  "Stehr",
	  "Steuber",
	  "Stiedemann",
	  "Stokes",
	  "Stoltenberg",
	  "Stracke",
	  "Streich",
	  "Stroman",
	  "Strosin",
	  "Swaniawski",
	  "Swift",
	  "Terry",
	  "Thiel",
	  "Thompson",
	  "Tillman",
	  "Torp",
	  "Torphy",
	  "Towne",
	  "Toy",
	  "Trantow",
	  "Tremblay",
	  "Treutel",
	  "Tromp",
	  "Turcotte",
	  "Turner",
	  "Ullrich",
	  "Upton",
	  "Vandervort",
	  "Veum",
	  "Volkman",
	  "Von",
	  "VonRueden",
	  "Waelchi",
	  "Walker",
	  "Walsh",
	  "Walter",
	  "Ward",
	  "Waters",
	  "Watsica",
	  "Weber",
	  "Wehner",
	  "Weimann",
	  "Weissnat",
	  "Welch",
	  "West",
	  "White",
	  "Wiegand",
	  "Wilderman",
	  "Wilkinson",
	  "Will",
	  "Williamson",
	  "Willms",
	  "Windler",
	  "Wintheiser",
	  "Wisoky",
	  "Wisozk",
	  "Witting",
	  "Wiza",
	  "Wolf",
	  "Wolff",
	  "Wuckert",
	  "Wunsch",
	  "Wyman",
	  "Yost",
	  "Yundt",
	  "Zboncak",
	  "Zemlak",
	  "Ziemann",
	  "Zieme",
	  "Zulauf"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Mr.",
	  "Mrs.",
	  "Ms.",
	  "Miss",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####",
	  "###-###-####",
	  "(###) ###-####",
	  "1-###-###-####",
	  "###.###.####",
	  "###-###-#### x###",
	  "(###) ###-#### x###",
	  "1-###-###-#### x###",
	  "###.###.#### x###",
	  "###-###-#### x####",
	  "(###) ###-#### x####",
	  "1-###-###-#### x####",
	  "###.###.#### x####",
	  "###-###-#### x#####",
	  "(###) ###-#### x#####",
	  "1-###-###-#### x#####",
	  "###.###.#### x#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2104);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var system = {};
	module['exports'] = system;
	system.mimeTypes = __webpack_require__(2107);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	
	The MIT License (MIT)
	
	Copyright (c) 2014 Jonathan Ong me@jongleberry.com
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	Definitions from mime-db v1.21.0
	For updates check: https://github.com/jshttp/mime-db/blob/master/db.json
	
	*/
	
	module['exports'] = {
	  "application/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "application/3gpdash-qoe-report+xml": {
	    "source": "iana"
	  },
	  "application/3gpp-ims+xml": {
	    "source": "iana"
	  },
	  "application/a2l": {
	    "source": "iana"
	  },
	  "application/activemessage": {
	    "source": "iana"
	  },
	  "application/alto-costmap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-costmapfilter+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-directory+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointcost+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointcostparams+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointprop+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-endpointpropparams+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-error+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-networkmap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/alto-networkmapfilter+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/aml": {
	    "source": "iana"
	  },
	  "application/andrew-inset": {
	    "source": "iana",
	    "extensions": ["ez"]
	  },
	  "application/applefile": {
	    "source": "iana"
	  },
	  "application/applixware": {
	    "source": "apache",
	    "extensions": ["aw"]
	  },
	  "application/atf": {
	    "source": "iana"
	  },
	  "application/atfx": {
	    "source": "iana"
	  },
	  "application/atom+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["atom"]
	  },
	  "application/atomcat+xml": {
	    "source": "iana",
	    "extensions": ["atomcat"]
	  },
	  "application/atomdeleted+xml": {
	    "source": "iana"
	  },
	  "application/atomicmail": {
	    "source": "iana"
	  },
	  "application/atomsvc+xml": {
	    "source": "iana",
	    "extensions": ["atomsvc"]
	  },
	  "application/atxml": {
	    "source": "iana"
	  },
	  "application/auth-policy+xml": {
	    "source": "iana"
	  },
	  "application/bacnet-xdd+zip": {
	    "source": "iana"
	  },
	  "application/batch-smtp": {
	    "source": "iana"
	  },
	  "application/bdoc": {
	    "compressible": false,
	    "extensions": ["bdoc"]
	  },
	  "application/beep+xml": {
	    "source": "iana"
	  },
	  "application/calendar+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/calendar+xml": {
	    "source": "iana"
	  },
	  "application/call-completion": {
	    "source": "iana"
	  },
	  "application/cals-1840": {
	    "source": "iana"
	  },
	  "application/cbor": {
	    "source": "iana"
	  },
	  "application/ccmp+xml": {
	    "source": "iana"
	  },
	  "application/ccxml+xml": {
	    "source": "iana",
	    "extensions": ["ccxml"]
	  },
	  "application/cdfx+xml": {
	    "source": "iana"
	  },
	  "application/cdmi-capability": {
	    "source": "iana",
	    "extensions": ["cdmia"]
	  },
	  "application/cdmi-container": {
	    "source": "iana",
	    "extensions": ["cdmic"]
	  },
	  "application/cdmi-domain": {
	    "source": "iana",
	    "extensions": ["cdmid"]
	  },
	  "application/cdmi-object": {
	    "source": "iana",
	    "extensions": ["cdmio"]
	  },
	  "application/cdmi-queue": {
	    "source": "iana",
	    "extensions": ["cdmiq"]
	  },
	  "application/cdni": {
	    "source": "iana"
	  },
	  "application/cea": {
	    "source": "iana"
	  },
	  "application/cea-2018+xml": {
	    "source": "iana"
	  },
	  "application/cellml+xml": {
	    "source": "iana"
	  },
	  "application/cfw": {
	    "source": "iana"
	  },
	  "application/cms": {
	    "source": "iana"
	  },
	  "application/cnrp+xml": {
	    "source": "iana"
	  },
	  "application/coap-group+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/commonground": {
	    "source": "iana"
	  },
	  "application/conference-info+xml": {
	    "source": "iana"
	  },
	  "application/cpl+xml": {
	    "source": "iana"
	  },
	  "application/csrattrs": {
	    "source": "iana"
	  },
	  "application/csta+xml": {
	    "source": "iana"
	  },
	  "application/cstadata+xml": {
	    "source": "iana"
	  },
	  "application/csvm+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/cu-seeme": {
	    "source": "apache",
	    "extensions": ["cu"]
	  },
	  "application/cybercash": {
	    "source": "iana"
	  },
	  "application/dart": {
	    "compressible": true
	  },
	  "application/dash+xml": {
	    "source": "iana",
	    "extensions": ["mdp"]
	  },
	  "application/dashdelta": {
	    "source": "iana"
	  },
	  "application/davmount+xml": {
	    "source": "iana",
	    "extensions": ["davmount"]
	  },
	  "application/dca-rft": {
	    "source": "iana"
	  },
	  "application/dcd": {
	    "source": "iana"
	  },
	  "application/dec-dx": {
	    "source": "iana"
	  },
	  "application/dialog-info+xml": {
	    "source": "iana"
	  },
	  "application/dicom": {
	    "source": "iana"
	  },
	  "application/dii": {
	    "source": "iana"
	  },
	  "application/dit": {
	    "source": "iana"
	  },
	  "application/dns": {
	    "source": "iana"
	  },
	  "application/docbook+xml": {
	    "source": "apache",
	    "extensions": ["dbk"]
	  },
	  "application/dskpp+xml": {
	    "source": "iana"
	  },
	  "application/dssc+der": {
	    "source": "iana",
	    "extensions": ["dssc"]
	  },
	  "application/dssc+xml": {
	    "source": "iana",
	    "extensions": ["xdssc"]
	  },
	  "application/dvcs": {
	    "source": "iana"
	  },
	  "application/ecmascript": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["ecma"]
	  },
	  "application/edi-consent": {
	    "source": "iana"
	  },
	  "application/edi-x12": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/edifact": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/emergencycalldata.comment+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.deviceinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.providerinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.serviceinfo+xml": {
	    "source": "iana"
	  },
	  "application/emergencycalldata.subscriberinfo+xml": {
	    "source": "iana"
	  },
	  "application/emma+xml": {
	    "source": "iana",
	    "extensions": ["emma"]
	  },
	  "application/emotionml+xml": {
	    "source": "iana"
	  },
	  "application/encaprtp": {
	    "source": "iana"
	  },
	  "application/epp+xml": {
	    "source": "iana"
	  },
	  "application/epub+zip": {
	    "source": "iana",
	    "extensions": ["epub"]
	  },
	  "application/eshop": {
	    "source": "iana"
	  },
	  "application/exi": {
	    "source": "iana",
	    "extensions": ["exi"]
	  },
	  "application/fastinfoset": {
	    "source": "iana"
	  },
	  "application/fastsoap": {
	    "source": "iana"
	  },
	  "application/fdt+xml": {
	    "source": "iana"
	  },
	  "application/fits": {
	    "source": "iana"
	  },
	  "application/font-sfnt": {
	    "source": "iana"
	  },
	  "application/font-tdpfr": {
	    "source": "iana",
	    "extensions": ["pfr"]
	  },
	  "application/font-woff": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["woff"]
	  },
	  "application/font-woff2": {
	    "compressible": false,
	    "extensions": ["woff2"]
	  },
	  "application/framework-attributes+xml": {
	    "source": "iana"
	  },
	  "application/gml+xml": {
	    "source": "apache",
	    "extensions": ["gml"]
	  },
	  "application/gpx+xml": {
	    "source": "apache",
	    "extensions": ["gpx"]
	  },
	  "application/gxf": {
	    "source": "apache",
	    "extensions": ["gxf"]
	  },
	  "application/gzip": {
	    "source": "iana",
	    "compressible": false
	  },
	  "application/h224": {
	    "source": "iana"
	  },
	  "application/held+xml": {
	    "source": "iana"
	  },
	  "application/http": {
	    "source": "iana"
	  },
	  "application/hyperstudio": {
	    "source": "iana",
	    "extensions": ["stk"]
	  },
	  "application/ibe-key-request+xml": {
	    "source": "iana"
	  },
	  "application/ibe-pkg-reply+xml": {
	    "source": "iana"
	  },
	  "application/ibe-pp-data": {
	    "source": "iana"
	  },
	  "application/iges": {
	    "source": "iana"
	  },
	  "application/im-iscomposing+xml": {
	    "source": "iana"
	  },
	  "application/index": {
	    "source": "iana"
	  },
	  "application/index.cmd": {
	    "source": "iana"
	  },
	  "application/index.obj": {
	    "source": "iana"
	  },
	  "application/index.response": {
	    "source": "iana"
	  },
	  "application/index.vnd": {
	    "source": "iana"
	  },
	  "application/inkml+xml": {
	    "source": "iana",
	    "extensions": ["ink","inkml"]
	  },
	  "application/iotp": {
	    "source": "iana"
	  },
	  "application/ipfix": {
	    "source": "iana",
	    "extensions": ["ipfix"]
	  },
	  "application/ipp": {
	    "source": "iana"
	  },
	  "application/isup": {
	    "source": "iana"
	  },
	  "application/its+xml": {
	    "source": "iana"
	  },
	  "application/java-archive": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["jar","war","ear"]
	  },
	  "application/java-serialized-object": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["ser"]
	  },
	  "application/java-vm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["class"]
	  },
	  "application/javascript": {
	    "source": "iana",
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["js"]
	  },
	  "application/jose": {
	    "source": "iana"
	  },
	  "application/jose+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jrd+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/json": {
	    "source": "iana",
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["json","map"]
	  },
	  "application/json-patch+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/json-seq": {
	    "source": "iana"
	  },
	  "application/json5": {
	    "extensions": ["json5"]
	  },
	  "application/jsonml+json": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["jsonml"]
	  },
	  "application/jwk+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jwk-set+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/jwt": {
	    "source": "iana"
	  },
	  "application/kpml-request+xml": {
	    "source": "iana"
	  },
	  "application/kpml-response+xml": {
	    "source": "iana"
	  },
	  "application/ld+json": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["jsonld"]
	  },
	  "application/link-format": {
	    "source": "iana"
	  },
	  "application/load-control+xml": {
	    "source": "iana"
	  },
	  "application/lost+xml": {
	    "source": "iana",
	    "extensions": ["lostxml"]
	  },
	  "application/lostsync+xml": {
	    "source": "iana"
	  },
	  "application/lxf": {
	    "source": "iana"
	  },
	  "application/mac-binhex40": {
	    "source": "iana",
	    "extensions": ["hqx"]
	  },
	  "application/mac-compactpro": {
	    "source": "apache",
	    "extensions": ["cpt"]
	  },
	  "application/macwriteii": {
	    "source": "iana"
	  },
	  "application/mads+xml": {
	    "source": "iana",
	    "extensions": ["mads"]
	  },
	  "application/manifest+json": {
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["webmanifest"]
	  },
	  "application/marc": {
	    "source": "iana",
	    "extensions": ["mrc"]
	  },
	  "application/marcxml+xml": {
	    "source": "iana",
	    "extensions": ["mrcx"]
	  },
	  "application/mathematica": {
	    "source": "iana",
	    "extensions": ["ma","nb","mb"]
	  },
	  "application/mathml+xml": {
	    "source": "iana",
	    "extensions": ["mathml"]
	  },
	  "application/mathml-content+xml": {
	    "source": "iana"
	  },
	  "application/mathml-presentation+xml": {
	    "source": "iana"
	  },
	  "application/mbms-associated-procedure-description+xml": {
	    "source": "iana"
	  },
	  "application/mbms-deregister+xml": {
	    "source": "iana"
	  },
	  "application/mbms-envelope+xml": {
	    "source": "iana"
	  },
	  "application/mbms-msk+xml": {
	    "source": "iana"
	  },
	  "application/mbms-msk-response+xml": {
	    "source": "iana"
	  },
	  "application/mbms-protection-description+xml": {
	    "source": "iana"
	  },
	  "application/mbms-reception-report+xml": {
	    "source": "iana"
	  },
	  "application/mbms-register+xml": {
	    "source": "iana"
	  },
	  "application/mbms-register-response+xml": {
	    "source": "iana"
	  },
	  "application/mbms-schedule+xml": {
	    "source": "iana"
	  },
	  "application/mbms-user-service-description+xml": {
	    "source": "iana"
	  },
	  "application/mbox": {
	    "source": "iana",
	    "extensions": ["mbox"]
	  },
	  "application/media-policy-dataset+xml": {
	    "source": "iana"
	  },
	  "application/media_control+xml": {
	    "source": "iana"
	  },
	  "application/mediaservercontrol+xml": {
	    "source": "iana",
	    "extensions": ["mscml"]
	  },
	  "application/merge-patch+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/metalink+xml": {
	    "source": "apache",
	    "extensions": ["metalink"]
	  },
	  "application/metalink4+xml": {
	    "source": "iana",
	    "extensions": ["meta4"]
	  },
	  "application/mets+xml": {
	    "source": "iana",
	    "extensions": ["mets"]
	  },
	  "application/mf4": {
	    "source": "iana"
	  },
	  "application/mikey": {
	    "source": "iana"
	  },
	  "application/mods+xml": {
	    "source": "iana",
	    "extensions": ["mods"]
	  },
	  "application/moss-keys": {
	    "source": "iana"
	  },
	  "application/moss-signature": {
	    "source": "iana"
	  },
	  "application/mosskey-data": {
	    "source": "iana"
	  },
	  "application/mosskey-request": {
	    "source": "iana"
	  },
	  "application/mp21": {
	    "source": "iana",
	    "extensions": ["m21","mp21"]
	  },
	  "application/mp4": {
	    "source": "iana",
	    "extensions": ["mp4s","m4p"]
	  },
	  "application/mpeg4-generic": {
	    "source": "iana"
	  },
	  "application/mpeg4-iod": {
	    "source": "iana"
	  },
	  "application/mpeg4-iod-xmt": {
	    "source": "iana"
	  },
	  "application/mrb-consumer+xml": {
	    "source": "iana"
	  },
	  "application/mrb-publish+xml": {
	    "source": "iana"
	  },
	  "application/msc-ivr+xml": {
	    "source": "iana"
	  },
	  "application/msc-mixer+xml": {
	    "source": "iana"
	  },
	  "application/msword": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["doc","dot"]
	  },
	  "application/mxf": {
	    "source": "iana",
	    "extensions": ["mxf"]
	  },
	  "application/nasdata": {
	    "source": "iana"
	  },
	  "application/news-checkgroups": {
	    "source": "iana"
	  },
	  "application/news-groupinfo": {
	    "source": "iana"
	  },
	  "application/news-transmission": {
	    "source": "iana"
	  },
	  "application/nlsml+xml": {
	    "source": "iana"
	  },
	  "application/nss": {
	    "source": "iana"
	  },
	  "application/ocsp-request": {
	    "source": "iana"
	  },
	  "application/ocsp-response": {
	    "source": "iana"
	  },
	  "application/octet-stream": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]
	  },
	  "application/oda": {
	    "source": "iana",
	    "extensions": ["oda"]
	  },
	  "application/odx": {
	    "source": "iana"
	  },
	  "application/oebps-package+xml": {
	    "source": "iana",
	    "extensions": ["opf"]
	  },
	  "application/ogg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ogx"]
	  },
	  "application/omdoc+xml": {
	    "source": "apache",
	    "extensions": ["omdoc"]
	  },
	  "application/onenote": {
	    "source": "apache",
	    "extensions": ["onetoc","onetoc2","onetmp","onepkg"]
	  },
	  "application/oxps": {
	    "source": "iana",
	    "extensions": ["oxps"]
	  },
	  "application/p2p-overlay+xml": {
	    "source": "iana"
	  },
	  "application/parityfec": {
	    "source": "iana"
	  },
	  "application/patch-ops-error+xml": {
	    "source": "iana",
	    "extensions": ["xer"]
	  },
	  "application/pdf": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pdf"]
	  },
	  "application/pdx": {
	    "source": "iana"
	  },
	  "application/pgp-encrypted": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pgp"]
	  },
	  "application/pgp-keys": {
	    "source": "iana"
	  },
	  "application/pgp-signature": {
	    "source": "iana",
	    "extensions": ["asc","sig"]
	  },
	  "application/pics-rules": {
	    "source": "apache",
	    "extensions": ["prf"]
	  },
	  "application/pidf+xml": {
	    "source": "iana"
	  },
	  "application/pidf-diff+xml": {
	    "source": "iana"
	  },
	  "application/pkcs10": {
	    "source": "iana",
	    "extensions": ["p10"]
	  },
	  "application/pkcs12": {
	    "source": "iana"
	  },
	  "application/pkcs7-mime": {
	    "source": "iana",
	    "extensions": ["p7m","p7c"]
	  },
	  "application/pkcs7-signature": {
	    "source": "iana",
	    "extensions": ["p7s"]
	  },
	  "application/pkcs8": {
	    "source": "iana",
	    "extensions": ["p8"]
	  },
	  "application/pkix-attr-cert": {
	    "source": "iana",
	    "extensions": ["ac"]
	  },
	  "application/pkix-cert": {
	    "source": "iana",
	    "extensions": ["cer"]
	  },
	  "application/pkix-crl": {
	    "source": "iana",
	    "extensions": ["crl"]
	  },
	  "application/pkix-pkipath": {
	    "source": "iana",
	    "extensions": ["pkipath"]
	  },
	  "application/pkixcmp": {
	    "source": "iana",
	    "extensions": ["pki"]
	  },
	  "application/pls+xml": {
	    "source": "iana",
	    "extensions": ["pls"]
	  },
	  "application/poc-settings+xml": {
	    "source": "iana"
	  },
	  "application/postscript": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["ai","eps","ps"]
	  },
	  "application/provenance+xml": {
	    "source": "iana"
	  },
	  "application/prs.alvestrand.titrax-sheet": {
	    "source": "iana"
	  },
	  "application/prs.cww": {
	    "source": "iana",
	    "extensions": ["cww"]
	  },
	  "application/prs.hpub+zip": {
	    "source": "iana"
	  },
	  "application/prs.nprend": {
	    "source": "iana"
	  },
	  "application/prs.plucker": {
	    "source": "iana"
	  },
	  "application/prs.rdf-xml-crypt": {
	    "source": "iana"
	  },
	  "application/prs.xsf+xml": {
	    "source": "iana"
	  },
	  "application/pskc+xml": {
	    "source": "iana",
	    "extensions": ["pskcxml"]
	  },
	  "application/qsig": {
	    "source": "iana"
	  },
	  "application/raptorfec": {
	    "source": "iana"
	  },
	  "application/rdap+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/rdf+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rdf"]
	  },
	  "application/reginfo+xml": {
	    "source": "iana",
	    "extensions": ["rif"]
	  },
	  "application/relax-ng-compact-syntax": {
	    "source": "iana",
	    "extensions": ["rnc"]
	  },
	  "application/remote-printing": {
	    "source": "iana"
	  },
	  "application/reputon+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/resource-lists+xml": {
	    "source": "iana",
	    "extensions": ["rl"]
	  },
	  "application/resource-lists-diff+xml": {
	    "source": "iana",
	    "extensions": ["rld"]
	  },
	  "application/rfc+xml": {
	    "source": "iana"
	  },
	  "application/riscos": {
	    "source": "iana"
	  },
	  "application/rlmi+xml": {
	    "source": "iana"
	  },
	  "application/rls-services+xml": {
	    "source": "iana",
	    "extensions": ["rs"]
	  },
	  "application/rpki-ghostbusters": {
	    "source": "iana",
	    "extensions": ["gbr"]
	  },
	  "application/rpki-manifest": {
	    "source": "iana",
	    "extensions": ["mft"]
	  },
	  "application/rpki-roa": {
	    "source": "iana",
	    "extensions": ["roa"]
	  },
	  "application/rpki-updown": {
	    "source": "iana"
	  },
	  "application/rsd+xml": {
	    "source": "apache",
	    "extensions": ["rsd"]
	  },
	  "application/rss+xml": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["rss"]
	  },
	  "application/rtf": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtf"]
	  },
	  "application/rtploopback": {
	    "source": "iana"
	  },
	  "application/rtx": {
	    "source": "iana"
	  },
	  "application/samlassertion+xml": {
	    "source": "iana"
	  },
	  "application/samlmetadata+xml": {
	    "source": "iana"
	  },
	  "application/sbml+xml": {
	    "source": "iana",
	    "extensions": ["sbml"]
	  },
	  "application/scaip+xml": {
	    "source": "iana"
	  },
	  "application/scim+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/scvp-cv-request": {
	    "source": "iana",
	    "extensions": ["scq"]
	  },
	  "application/scvp-cv-response": {
	    "source": "iana",
	    "extensions": ["scs"]
	  },
	  "application/scvp-vp-request": {
	    "source": "iana",
	    "extensions": ["spq"]
	  },
	  "application/scvp-vp-response": {
	    "source": "iana",
	    "extensions": ["spp"]
	  },
	  "application/sdp": {
	    "source": "iana",
	    "extensions": ["sdp"]
	  },
	  "application/sep+xml": {
	    "source": "iana"
	  },
	  "application/sep-exi": {
	    "source": "iana"
	  },
	  "application/session-info": {
	    "source": "iana"
	  },
	  "application/set-payment": {
	    "source": "iana"
	  },
	  "application/set-payment-initiation": {
	    "source": "iana",
	    "extensions": ["setpay"]
	  },
	  "application/set-registration": {
	    "source": "iana"
	  },
	  "application/set-registration-initiation": {
	    "source": "iana",
	    "extensions": ["setreg"]
	  },
	  "application/sgml": {
	    "source": "iana"
	  },
	  "application/sgml-open-catalog": {
	    "source": "iana"
	  },
	  "application/shf+xml": {
	    "source": "iana",
	    "extensions": ["shf"]
	  },
	  "application/sieve": {
	    "source": "iana"
	  },
	  "application/simple-filter+xml": {
	    "source": "iana"
	  },
	  "application/simple-message-summary": {
	    "source": "iana"
	  },
	  "application/simplesymbolcontainer": {
	    "source": "iana"
	  },
	  "application/slate": {
	    "source": "iana"
	  },
	  "application/smil": {
	    "source": "iana"
	  },
	  "application/smil+xml": {
	    "source": "iana",
	    "extensions": ["smi","smil"]
	  },
	  "application/smpte336m": {
	    "source": "iana"
	  },
	  "application/soap+fastinfoset": {
	    "source": "iana"
	  },
	  "application/soap+xml": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/sparql-query": {
	    "source": "iana",
	    "extensions": ["rq"]
	  },
	  "application/sparql-results+xml": {
	    "source": "iana",
	    "extensions": ["srx"]
	  },
	  "application/spirits-event+xml": {
	    "source": "iana"
	  },
	  "application/sql": {
	    "source": "iana"
	  },
	  "application/srgs": {
	    "source": "iana",
	    "extensions": ["gram"]
	  },
	  "application/srgs+xml": {
	    "source": "iana",
	    "extensions": ["grxml"]
	  },
	  "application/sru+xml": {
	    "source": "iana",
	    "extensions": ["sru"]
	  },
	  "application/ssdl+xml": {
	    "source": "apache",
	    "extensions": ["ssdl"]
	  },
	  "application/ssml+xml": {
	    "source": "iana",
	    "extensions": ["ssml"]
	  },
	  "application/tamp-apex-update": {
	    "source": "iana"
	  },
	  "application/tamp-apex-update-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-community-update": {
	    "source": "iana"
	  },
	  "application/tamp-community-update-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-error": {
	    "source": "iana"
	  },
	  "application/tamp-sequence-adjust": {
	    "source": "iana"
	  },
	  "application/tamp-sequence-adjust-confirm": {
	    "source": "iana"
	  },
	  "application/tamp-status-query": {
	    "source": "iana"
	  },
	  "application/tamp-status-response": {
	    "source": "iana"
	  },
	  "application/tamp-update": {
	    "source": "iana"
	  },
	  "application/tamp-update-confirm": {
	    "source": "iana"
	  },
	  "application/tar": {
	    "compressible": true
	  },
	  "application/tei+xml": {
	    "source": "iana",
	    "extensions": ["tei","teicorpus"]
	  },
	  "application/thraud+xml": {
	    "source": "iana",
	    "extensions": ["tfi"]
	  },
	  "application/timestamp-query": {
	    "source": "iana"
	  },
	  "application/timestamp-reply": {
	    "source": "iana"
	  },
	  "application/timestamped-data": {
	    "source": "iana",
	    "extensions": ["tsd"]
	  },
	  "application/ttml+xml": {
	    "source": "iana"
	  },
	  "application/tve-trigger": {
	    "source": "iana"
	  },
	  "application/ulpfec": {
	    "source": "iana"
	  },
	  "application/urc-grpsheet+xml": {
	    "source": "iana"
	  },
	  "application/urc-ressheet+xml": {
	    "source": "iana"
	  },
	  "application/urc-targetdesc+xml": {
	    "source": "iana"
	  },
	  "application/urc-uisocketdesc+xml": {
	    "source": "iana"
	  },
	  "application/vcard+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vcard+xml": {
	    "source": "iana"
	  },
	  "application/vemmi": {
	    "source": "iana"
	  },
	  "application/vividence.scriptfile": {
	    "source": "apache"
	  },
	  "application/vnd.3gpp-prose+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp-prose-pc3ch+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.access-transfer-events+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.bsf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.mid-call+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.pic-bw-large": {
	    "source": "iana",
	    "extensions": ["plb"]
	  },
	  "application/vnd.3gpp.pic-bw-small": {
	    "source": "iana",
	    "extensions": ["psb"]
	  },
	  "application/vnd.3gpp.pic-bw-var": {
	    "source": "iana",
	    "extensions": ["pvb"]
	  },
	  "application/vnd.3gpp.sms": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.srvcc-ext+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.srvcc-info+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.state-and-event-info+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp.ussd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.bcmcsinfo+xml": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.sms": {
	    "source": "iana"
	  },
	  "application/vnd.3gpp2.tcap": {
	    "source": "iana",
	    "extensions": ["tcap"]
	  },
	  "application/vnd.3m.post-it-notes": {
	    "source": "iana",
	    "extensions": ["pwn"]
	  },
	  "application/vnd.accpac.simply.aso": {
	    "source": "iana",
	    "extensions": ["aso"]
	  },
	  "application/vnd.accpac.simply.imp": {
	    "source": "iana",
	    "extensions": ["imp"]
	  },
	  "application/vnd.acucobol": {
	    "source": "iana",
	    "extensions": ["acu"]
	  },
	  "application/vnd.acucorp": {
	    "source": "iana",
	    "extensions": ["atc","acutc"]
	  },
	  "application/vnd.adobe.air-application-installer-package+zip": {
	    "source": "apache",
	    "extensions": ["air"]
	  },
	  "application/vnd.adobe.flash.movie": {
	    "source": "iana"
	  },
	  "application/vnd.adobe.formscentral.fcdt": {
	    "source": "iana",
	    "extensions": ["fcdt"]
	  },
	  "application/vnd.adobe.fxp": {
	    "source": "iana",
	    "extensions": ["fxp","fxpl"]
	  },
	  "application/vnd.adobe.partial-upload": {
	    "source": "iana"
	  },
	  "application/vnd.adobe.xdp+xml": {
	    "source": "iana",
	    "extensions": ["xdp"]
	  },
	  "application/vnd.adobe.xfdf": {
	    "source": "iana",
	    "extensions": ["xfdf"]
	  },
	  "application/vnd.aether.imp": {
	    "source": "iana"
	  },
	  "application/vnd.ah-barcode": {
	    "source": "iana"
	  },
	  "application/vnd.ahead.space": {
	    "source": "iana",
	    "extensions": ["ahead"]
	  },
	  "application/vnd.airzip.filesecure.azf": {
	    "source": "iana",
	    "extensions": ["azf"]
	  },
	  "application/vnd.airzip.filesecure.azs": {
	    "source": "iana",
	    "extensions": ["azs"]
	  },
	  "application/vnd.amazon.ebook": {
	    "source": "apache",
	    "extensions": ["azw"]
	  },
	  "application/vnd.americandynamics.acc": {
	    "source": "iana",
	    "extensions": ["acc"]
	  },
	  "application/vnd.amiga.ami": {
	    "source": "iana",
	    "extensions": ["ami"]
	  },
	  "application/vnd.amundsen.maze+xml": {
	    "source": "iana"
	  },
	  "application/vnd.android.package-archive": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["apk"]
	  },
	  "application/vnd.anki": {
	    "source": "iana"
	  },
	  "application/vnd.anser-web-certificate-issue-initiation": {
	    "source": "iana",
	    "extensions": ["cii"]
	  },
	  "application/vnd.anser-web-funds-transfer-initiation": {
	    "source": "apache",
	    "extensions": ["fti"]
	  },
	  "application/vnd.antix.game-component": {
	    "source": "iana",
	    "extensions": ["atx"]
	  },
	  "application/vnd.apache.thrift.binary": {
	    "source": "iana"
	  },
	  "application/vnd.apache.thrift.compact": {
	    "source": "iana"
	  },
	  "application/vnd.apache.thrift.json": {
	    "source": "iana"
	  },
	  "application/vnd.api+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.apple.installer+xml": {
	    "source": "iana",
	    "extensions": ["mpkg"]
	  },
	  "application/vnd.apple.mpegurl": {
	    "source": "iana",
	    "extensions": ["m3u8"]
	  },
	  "application/vnd.apple.pkpass": {
	    "compressible": false,
	    "extensions": ["pkpass"]
	  },
	  "application/vnd.arastra.swi": {
	    "source": "iana"
	  },
	  "application/vnd.aristanetworks.swi": {
	    "source": "iana",
	    "extensions": ["swi"]
	  },
	  "application/vnd.artsquare": {
	    "source": "iana"
	  },
	  "application/vnd.astraea-software.iota": {
	    "source": "iana",
	    "extensions": ["iota"]
	  },
	  "application/vnd.audiograph": {
	    "source": "iana",
	    "extensions": ["aep"]
	  },
	  "application/vnd.autopackage": {
	    "source": "iana"
	  },
	  "application/vnd.avistar+xml": {
	    "source": "iana"
	  },
	  "application/vnd.balsamiq.bmml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.balsamiq.bmpr": {
	    "source": "iana"
	  },
	  "application/vnd.bekitzur-stech+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.biopax.rdf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.blueice.multipass": {
	    "source": "iana",
	    "extensions": ["mpm"]
	  },
	  "application/vnd.bluetooth.ep.oob": {
	    "source": "iana"
	  },
	  "application/vnd.bluetooth.le.oob": {
	    "source": "iana"
	  },
	  "application/vnd.bmi": {
	    "source": "iana",
	    "extensions": ["bmi"]
	  },
	  "application/vnd.businessobjects": {
	    "source": "iana",
	    "extensions": ["rep"]
	  },
	  "application/vnd.cab-jscript": {
	    "source": "iana"
	  },
	  "application/vnd.canon-cpdl": {
	    "source": "iana"
	  },
	  "application/vnd.canon-lips": {
	    "source": "iana"
	  },
	  "application/vnd.cendio.thinlinc.clientconf": {
	    "source": "iana"
	  },
	  "application/vnd.century-systems.tcp_stream": {
	    "source": "iana"
	  },
	  "application/vnd.chemdraw+xml": {
	    "source": "iana",
	    "extensions": ["cdxml"]
	  },
	  "application/vnd.chipnuts.karaoke-mmd": {
	    "source": "iana",
	    "extensions": ["mmd"]
	  },
	  "application/vnd.cinderella": {
	    "source": "iana",
	    "extensions": ["cdy"]
	  },
	  "application/vnd.cirpack.isdn-ext": {
	    "source": "iana"
	  },
	  "application/vnd.citationstyles.style+xml": {
	    "source": "iana"
	  },
	  "application/vnd.claymore": {
	    "source": "iana",
	    "extensions": ["cla"]
	  },
	  "application/vnd.cloanto.rp9": {
	    "source": "iana",
	    "extensions": ["rp9"]
	  },
	  "application/vnd.clonk.c4group": {
	    "source": "iana",
	    "extensions": ["c4g","c4d","c4f","c4p","c4u"]
	  },
	  "application/vnd.cluetrust.cartomobile-config": {
	    "source": "iana",
	    "extensions": ["c11amc"]
	  },
	  "application/vnd.cluetrust.cartomobile-config-pkg": {
	    "source": "iana",
	    "extensions": ["c11amz"]
	  },
	  "application/vnd.coffeescript": {
	    "source": "iana"
	  },
	  "application/vnd.collection+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.collection.doc+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.collection.next+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.commerce-battelle": {
	    "source": "iana"
	  },
	  "application/vnd.commonspace": {
	    "source": "iana",
	    "extensions": ["csp"]
	  },
	  "application/vnd.contact.cmsg": {
	    "source": "iana",
	    "extensions": ["cdbcmsg"]
	  },
	  "application/vnd.cosmocaller": {
	    "source": "iana",
	    "extensions": ["cmc"]
	  },
	  "application/vnd.crick.clicker": {
	    "source": "iana",
	    "extensions": ["clkx"]
	  },
	  "application/vnd.crick.clicker.keyboard": {
	    "source": "iana",
	    "extensions": ["clkk"]
	  },
	  "application/vnd.crick.clicker.palette": {
	    "source": "iana",
	    "extensions": ["clkp"]
	  },
	  "application/vnd.crick.clicker.template": {
	    "source": "iana",
	    "extensions": ["clkt"]
	  },
	  "application/vnd.crick.clicker.wordbank": {
	    "source": "iana",
	    "extensions": ["clkw"]
	  },
	  "application/vnd.criticaltools.wbs+xml": {
	    "source": "iana",
	    "extensions": ["wbs"]
	  },
	  "application/vnd.ctc-posml": {
	    "source": "iana",
	    "extensions": ["pml"]
	  },
	  "application/vnd.ctct.ws+xml": {
	    "source": "iana"
	  },
	  "application/vnd.cups-pdf": {
	    "source": "iana"
	  },
	  "application/vnd.cups-postscript": {
	    "source": "iana"
	  },
	  "application/vnd.cups-ppd": {
	    "source": "iana",
	    "extensions": ["ppd"]
	  },
	  "application/vnd.cups-raster": {
	    "source": "iana"
	  },
	  "application/vnd.cups-raw": {
	    "source": "iana"
	  },
	  "application/vnd.curl": {
	    "source": "iana"
	  },
	  "application/vnd.curl.car": {
	    "source": "apache",
	    "extensions": ["car"]
	  },
	  "application/vnd.curl.pcurl": {
	    "source": "apache",
	    "extensions": ["pcurl"]
	  },
	  "application/vnd.cyan.dean.root+xml": {
	    "source": "iana"
	  },
	  "application/vnd.cybank": {
	    "source": "iana"
	  },
	  "application/vnd.dart": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["dart"]
	  },
	  "application/vnd.data-vision.rdz": {
	    "source": "iana",
	    "extensions": ["rdz"]
	  },
	  "application/vnd.debian.binary-package": {
	    "source": "iana"
	  },
	  "application/vnd.dece.data": {
	    "source": "iana",
	    "extensions": ["uvf","uvvf","uvd","uvvd"]
	  },
	  "application/vnd.dece.ttml+xml": {
	    "source": "iana",
	    "extensions": ["uvt","uvvt"]
	  },
	  "application/vnd.dece.unspecified": {
	    "source": "iana",
	    "extensions": ["uvx","uvvx"]
	  },
	  "application/vnd.dece.zip": {
	    "source": "iana",
	    "extensions": ["uvz","uvvz"]
	  },
	  "application/vnd.denovo.fcselayout-link": {
	    "source": "iana",
	    "extensions": ["fe_launch"]
	  },
	  "application/vnd.desmume-movie": {
	    "source": "iana"
	  },
	  "application/vnd.dir-bi.plate-dl-nosuffix": {
	    "source": "iana"
	  },
	  "application/vnd.dm.delegation+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dna": {
	    "source": "iana",
	    "extensions": ["dna"]
	  },
	  "application/vnd.document+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.dolby.mlp": {
	    "source": "apache",
	    "extensions": ["mlp"]
	  },
	  "application/vnd.dolby.mobile.1": {
	    "source": "iana"
	  },
	  "application/vnd.dolby.mobile.2": {
	    "source": "iana"
	  },
	  "application/vnd.doremir.scorecloud-binary-document": {
	    "source": "iana"
	  },
	  "application/vnd.dpgraph": {
	    "source": "iana",
	    "extensions": ["dpg"]
	  },
	  "application/vnd.dreamfactory": {
	    "source": "iana",
	    "extensions": ["dfac"]
	  },
	  "application/vnd.drive+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ds-keypoint": {
	    "source": "apache",
	    "extensions": ["kpxx"]
	  },
	  "application/vnd.dtg.local": {
	    "source": "iana"
	  },
	  "application/vnd.dtg.local.flash": {
	    "source": "iana"
	  },
	  "application/vnd.dtg.local.html": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ait": {
	    "source": "iana",
	    "extensions": ["ait"]
	  },
	  "application/vnd.dvb.dvbj": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.esgcontainer": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcdftnotifaccess": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgaccess": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgaccess2": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcesgpdd": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.ipdcroaming": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.iptv.alfec-base": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.iptv.alfec-enhancement": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-aggregate-root+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-container+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-generic+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-msglist+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-registration-request+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-ia-registration-response+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.notif-init+xml": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.pfr": {
	    "source": "iana"
	  },
	  "application/vnd.dvb.service": {
	    "source": "iana",
	    "extensions": ["svc"]
	  },
	  "application/vnd.dxr": {
	    "source": "iana"
	  },
	  "application/vnd.dynageo": {
	    "source": "iana",
	    "extensions": ["geo"]
	  },
	  "application/vnd.dzr": {
	    "source": "iana"
	  },
	  "application/vnd.easykaraoke.cdgdownload": {
	    "source": "iana"
	  },
	  "application/vnd.ecdis-update": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.chart": {
	    "source": "iana",
	    "extensions": ["mag"]
	  },
	  "application/vnd.ecowin.filerequest": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.fileupdate": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.series": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.seriesrequest": {
	    "source": "iana"
	  },
	  "application/vnd.ecowin.seriesupdate": {
	    "source": "iana"
	  },
	  "application/vnd.emclient.accessrequest+xml": {
	    "source": "iana"
	  },
	  "application/vnd.enliven": {
	    "source": "iana",
	    "extensions": ["nml"]
	  },
	  "application/vnd.enphase.envoy": {
	    "source": "iana"
	  },
	  "application/vnd.eprints.data+xml": {
	    "source": "iana"
	  },
	  "application/vnd.epson.esf": {
	    "source": "iana",
	    "extensions": ["esf"]
	  },
	  "application/vnd.epson.msf": {
	    "source": "iana",
	    "extensions": ["msf"]
	  },
	  "application/vnd.epson.quickanime": {
	    "source": "iana",
	    "extensions": ["qam"]
	  },
	  "application/vnd.epson.salt": {
	    "source": "iana",
	    "extensions": ["slt"]
	  },
	  "application/vnd.epson.ssf": {
	    "source": "iana",
	    "extensions": ["ssf"]
	  },
	  "application/vnd.ericsson.quickcall": {
	    "source": "iana"
	  },
	  "application/vnd.eszigno3+xml": {
	    "source": "iana",
	    "extensions": ["es3","et3"]
	  },
	  "application/vnd.etsi.aoc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.asic-e+zip": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.asic-s+zip": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.cug+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvcommand+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvdiscovery+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-bc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-cod+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsad-npvr+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvservice+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvsync+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.iptvueprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.mcid+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.mheg5": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.overload-control-policy-dataset+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.pstn+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.sci+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.simservs+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.timestamp-token": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.tsl+xml": {
	    "source": "iana"
	  },
	  "application/vnd.etsi.tsl.der": {
	    "source": "iana"
	  },
	  "application/vnd.eudora.data": {
	    "source": "iana"
	  },
	  "application/vnd.ezpix-album": {
	    "source": "iana",
	    "extensions": ["ez2"]
	  },
	  "application/vnd.ezpix-package": {
	    "source": "iana",
	    "extensions": ["ez3"]
	  },
	  "application/vnd.f-secure.mobile": {
	    "source": "iana"
	  },
	  "application/vnd.fastcopy-disk-image": {
	    "source": "iana"
	  },
	  "application/vnd.fdf": {
	    "source": "iana",
	    "extensions": ["fdf"]
	  },
	  "application/vnd.fdsn.mseed": {
	    "source": "iana",
	    "extensions": ["mseed"]
	  },
	  "application/vnd.fdsn.seed": {
	    "source": "iana",
	    "extensions": ["seed","dataless"]
	  },
	  "application/vnd.ffsns": {
	    "source": "iana"
	  },
	  "application/vnd.filmit.zfc": {
	    "source": "iana"
	  },
	  "application/vnd.fints": {
	    "source": "iana"
	  },
	  "application/vnd.firemonkeys.cloudcell": {
	    "source": "iana"
	  },
	  "application/vnd.flographit": {
	    "source": "iana",
	    "extensions": ["gph"]
	  },
	  "application/vnd.fluxtime.clip": {
	    "source": "iana",
	    "extensions": ["ftc"]
	  },
	  "application/vnd.font-fontforge-sfd": {
	    "source": "iana"
	  },
	  "application/vnd.framemaker": {
	    "source": "iana",
	    "extensions": ["fm","frame","maker","book"]
	  },
	  "application/vnd.frogans.fnc": {
	    "source": "iana",
	    "extensions": ["fnc"]
	  },
	  "application/vnd.frogans.ltf": {
	    "source": "iana",
	    "extensions": ["ltf"]
	  },
	  "application/vnd.fsc.weblaunch": {
	    "source": "iana",
	    "extensions": ["fsc"]
	  },
	  "application/vnd.fujitsu.oasys": {
	    "source": "iana",
	    "extensions": ["oas"]
	  },
	  "application/vnd.fujitsu.oasys2": {
	    "source": "iana",
	    "extensions": ["oa2"]
	  },
	  "application/vnd.fujitsu.oasys3": {
	    "source": "iana",
	    "extensions": ["oa3"]
	  },
	  "application/vnd.fujitsu.oasysgp": {
	    "source": "iana",
	    "extensions": ["fg5"]
	  },
	  "application/vnd.fujitsu.oasysprs": {
	    "source": "iana",
	    "extensions": ["bh2"]
	  },
	  "application/vnd.fujixerox.art-ex": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.art4": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.ddd": {
	    "source": "iana",
	    "extensions": ["ddd"]
	  },
	  "application/vnd.fujixerox.docuworks": {
	    "source": "iana",
	    "extensions": ["xdw"]
	  },
	  "application/vnd.fujixerox.docuworks.binder": {
	    "source": "iana",
	    "extensions": ["xbd"]
	  },
	  "application/vnd.fujixerox.docuworks.container": {
	    "source": "iana"
	  },
	  "application/vnd.fujixerox.hbpl": {
	    "source": "iana"
	  },
	  "application/vnd.fut-misnet": {
	    "source": "iana"
	  },
	  "application/vnd.fuzzysheet": {
	    "source": "iana",
	    "extensions": ["fzs"]
	  },
	  "application/vnd.genomatix.tuxedo": {
	    "source": "iana",
	    "extensions": ["txd"]
	  },
	  "application/vnd.geo+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.geocube+xml": {
	    "source": "iana"
	  },
	  "application/vnd.geogebra.file": {
	    "source": "iana",
	    "extensions": ["ggb"]
	  },
	  "application/vnd.geogebra.tool": {
	    "source": "iana",
	    "extensions": ["ggt"]
	  },
	  "application/vnd.geometry-explorer": {
	    "source": "iana",
	    "extensions": ["gex","gre"]
	  },
	  "application/vnd.geonext": {
	    "source": "iana",
	    "extensions": ["gxt"]
	  },
	  "application/vnd.geoplan": {
	    "source": "iana",
	    "extensions": ["g2w"]
	  },
	  "application/vnd.geospace": {
	    "source": "iana",
	    "extensions": ["g3w"]
	  },
	  "application/vnd.gerber": {
	    "source": "iana"
	  },
	  "application/vnd.globalplatform.card-content-mgt": {
	    "source": "iana"
	  },
	  "application/vnd.globalplatform.card-content-mgt-response": {
	    "source": "iana"
	  },
	  "application/vnd.gmx": {
	    "source": "iana",
	    "extensions": ["gmx"]
	  },
	  "application/vnd.google-apps.document": {
	    "compressible": false,
	    "extensions": ["gdoc"]
	  },
	  "application/vnd.google-apps.presentation": {
	    "compressible": false,
	    "extensions": ["gslides"]
	  },
	  "application/vnd.google-apps.spreadsheet": {
	    "compressible": false,
	    "extensions": ["gsheet"]
	  },
	  "application/vnd.google-earth.kml+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["kml"]
	  },
	  "application/vnd.google-earth.kmz": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["kmz"]
	  },
	  "application/vnd.gov.sk.e-form+xml": {
	    "source": "iana"
	  },
	  "application/vnd.gov.sk.e-form+zip": {
	    "source": "iana"
	  },
	  "application/vnd.gov.sk.xmldatacontainer+xml": {
	    "source": "iana"
	  },
	  "application/vnd.grafeq": {
	    "source": "iana",
	    "extensions": ["gqf","gqs"]
	  },
	  "application/vnd.gridmp": {
	    "source": "iana"
	  },
	  "application/vnd.groove-account": {
	    "source": "iana",
	    "extensions": ["gac"]
	  },
	  "application/vnd.groove-help": {
	    "source": "iana",
	    "extensions": ["ghf"]
	  },
	  "application/vnd.groove-identity-message": {
	    "source": "iana",
	    "extensions": ["gim"]
	  },
	  "application/vnd.groove-injector": {
	    "source": "iana",
	    "extensions": ["grv"]
	  },
	  "application/vnd.groove-tool-message": {
	    "source": "iana",
	    "extensions": ["gtm"]
	  },
	  "application/vnd.groove-tool-template": {
	    "source": "iana",
	    "extensions": ["tpl"]
	  },
	  "application/vnd.groove-vcard": {
	    "source": "iana",
	    "extensions": ["vcg"]
	  },
	  "application/vnd.hal+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hal+xml": {
	    "source": "iana",
	    "extensions": ["hal"]
	  },
	  "application/vnd.handheld-entertainment+xml": {
	    "source": "iana",
	    "extensions": ["zmm"]
	  },
	  "application/vnd.hbci": {
	    "source": "iana",
	    "extensions": ["hbci"]
	  },
	  "application/vnd.hcl-bireports": {
	    "source": "iana"
	  },
	  "application/vnd.heroku+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hhe.lesson-player": {
	    "source": "iana",
	    "extensions": ["les"]
	  },
	  "application/vnd.hp-hpgl": {
	    "source": "iana",
	    "extensions": ["hpgl"]
	  },
	  "application/vnd.hp-hpid": {
	    "source": "iana",
	    "extensions": ["hpid"]
	  },
	  "application/vnd.hp-hps": {
	    "source": "iana",
	    "extensions": ["hps"]
	  },
	  "application/vnd.hp-jlyt": {
	    "source": "iana",
	    "extensions": ["jlt"]
	  },
	  "application/vnd.hp-pcl": {
	    "source": "iana",
	    "extensions": ["pcl"]
	  },
	  "application/vnd.hp-pclxl": {
	    "source": "iana",
	    "extensions": ["pclxl"]
	  },
	  "application/vnd.httphone": {
	    "source": "iana"
	  },
	  "application/vnd.hydrostatix.sof-data": {
	    "source": "iana",
	    "extensions": ["sfd-hdstx"]
	  },
	  "application/vnd.hyperdrive+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.hzn-3d-crossword": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.afplinedata": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.electronic-media": {
	    "source": "iana"
	  },
	  "application/vnd.ibm.minipay": {
	    "source": "iana",
	    "extensions": ["mpy"]
	  },
	  "application/vnd.ibm.modcap": {
	    "source": "iana",
	    "extensions": ["afp","listafp","list3820"]
	  },
	  "application/vnd.ibm.rights-management": {
	    "source": "iana",
	    "extensions": ["irm"]
	  },
	  "application/vnd.ibm.secure-container": {
	    "source": "iana",
	    "extensions": ["sc"]
	  },
	  "application/vnd.iccprofile": {
	    "source": "iana",
	    "extensions": ["icc","icm"]
	  },
	  "application/vnd.ieee.1905": {
	    "source": "iana"
	  },
	  "application/vnd.igloader": {
	    "source": "iana",
	    "extensions": ["igl"]
	  },
	  "application/vnd.immervision-ivp": {
	    "source": "iana",
	    "extensions": ["ivp"]
	  },
	  "application/vnd.immervision-ivu": {
	    "source": "iana",
	    "extensions": ["ivu"]
	  },
	  "application/vnd.ims.imsccv1p1": {
	    "source": "iana"
	  },
	  "application/vnd.ims.imsccv1p2": {
	    "source": "iana"
	  },
	  "application/vnd.ims.imsccv1p3": {
	    "source": "iana"
	  },
	  "application/vnd.ims.lis.v2.result+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolconsumerprofile+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolproxy+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolproxy.id+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolsettings+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.ims.lti.v2.toolsettings.simple+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.informedcontrol.rms+xml": {
	    "source": "iana"
	  },
	  "application/vnd.informix-visionary": {
	    "source": "iana"
	  },
	  "application/vnd.infotech.project": {
	    "source": "iana"
	  },
	  "application/vnd.infotech.project+xml": {
	    "source": "iana"
	  },
	  "application/vnd.innopath.wamp.notification": {
	    "source": "iana"
	  },
	  "application/vnd.insors.igm": {
	    "source": "iana",
	    "extensions": ["igm"]
	  },
	  "application/vnd.intercon.formnet": {
	    "source": "iana",
	    "extensions": ["xpw","xpx"]
	  },
	  "application/vnd.intergeo": {
	    "source": "iana",
	    "extensions": ["i2g"]
	  },
	  "application/vnd.intertrust.digibox": {
	    "source": "iana"
	  },
	  "application/vnd.intertrust.nncp": {
	    "source": "iana"
	  },
	  "application/vnd.intu.qbo": {
	    "source": "iana",
	    "extensions": ["qbo"]
	  },
	  "application/vnd.intu.qfx": {
	    "source": "iana",
	    "extensions": ["qfx"]
	  },
	  "application/vnd.iptc.g2.catalogitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.conceptitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.knowledgeitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.newsitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.newsmessage+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.packageitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.iptc.g2.planningitem+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ipunplugged.rcprofile": {
	    "source": "iana",
	    "extensions": ["rcprofile"]
	  },
	  "application/vnd.irepository.package+xml": {
	    "source": "iana",
	    "extensions": ["irp"]
	  },
	  "application/vnd.is-xpr": {
	    "source": "iana",
	    "extensions": ["xpr"]
	  },
	  "application/vnd.isac.fcs": {
	    "source": "iana",
	    "extensions": ["fcs"]
	  },
	  "application/vnd.jam": {
	    "source": "iana",
	    "extensions": ["jam"]
	  },
	  "application/vnd.japannet-directory-service": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-jpnstore-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-payment-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-registration": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-registration-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-setstore-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-verification": {
	    "source": "iana"
	  },
	  "application/vnd.japannet-verification-wakeup": {
	    "source": "iana"
	  },
	  "application/vnd.jcp.javame.midlet-rms": {
	    "source": "iana",
	    "extensions": ["rms"]
	  },
	  "application/vnd.jisp": {
	    "source": "iana",
	    "extensions": ["jisp"]
	  },
	  "application/vnd.joost.joda-archive": {
	    "source": "iana",
	    "extensions": ["joda"]
	  },
	  "application/vnd.jsk.isdn-ngn": {
	    "source": "iana"
	  },
	  "application/vnd.kahootz": {
	    "source": "iana",
	    "extensions": ["ktz","ktr"]
	  },
	  "application/vnd.kde.karbon": {
	    "source": "iana",
	    "extensions": ["karbon"]
	  },
	  "application/vnd.kde.kchart": {
	    "source": "iana",
	    "extensions": ["chrt"]
	  },
	  "application/vnd.kde.kformula": {
	    "source": "iana",
	    "extensions": ["kfo"]
	  },
	  "application/vnd.kde.kivio": {
	    "source": "iana",
	    "extensions": ["flw"]
	  },
	  "application/vnd.kde.kontour": {
	    "source": "iana",
	    "extensions": ["kon"]
	  },
	  "application/vnd.kde.kpresenter": {
	    "source": "iana",
	    "extensions": ["kpr","kpt"]
	  },
	  "application/vnd.kde.kspread": {
	    "source": "iana",
	    "extensions": ["ksp"]
	  },
	  "application/vnd.kde.kword": {
	    "source": "iana",
	    "extensions": ["kwd","kwt"]
	  },
	  "application/vnd.kenameaapp": {
	    "source": "iana",
	    "extensions": ["htke"]
	  },
	  "application/vnd.kidspiration": {
	    "source": "iana",
	    "extensions": ["kia"]
	  },
	  "application/vnd.kinar": {
	    "source": "iana",
	    "extensions": ["kne","knp"]
	  },
	  "application/vnd.koan": {
	    "source": "iana",
	    "extensions": ["skp","skd","skt","skm"]
	  },
	  "application/vnd.kodak-descriptor": {
	    "source": "iana",
	    "extensions": ["sse"]
	  },
	  "application/vnd.las.las+xml": {
	    "source": "iana",
	    "extensions": ["lasxml"]
	  },
	  "application/vnd.liberty-request+xml": {
	    "source": "iana"
	  },
	  "application/vnd.llamagraphics.life-balance.desktop": {
	    "source": "iana",
	    "extensions": ["lbd"]
	  },
	  "application/vnd.llamagraphics.life-balance.exchange+xml": {
	    "source": "iana",
	    "extensions": ["lbe"]
	  },
	  "application/vnd.lotus-1-2-3": {
	    "source": "iana",
	    "extensions": ["123"]
	  },
	  "application/vnd.lotus-approach": {
	    "source": "iana",
	    "extensions": ["apr"]
	  },
	  "application/vnd.lotus-freelance": {
	    "source": "iana",
	    "extensions": ["pre"]
	  },
	  "application/vnd.lotus-notes": {
	    "source": "iana",
	    "extensions": ["nsf"]
	  },
	  "application/vnd.lotus-organizer": {
	    "source": "iana",
	    "extensions": ["org"]
	  },
	  "application/vnd.lotus-screencam": {
	    "source": "iana",
	    "extensions": ["scm"]
	  },
	  "application/vnd.lotus-wordpro": {
	    "source": "iana",
	    "extensions": ["lwp"]
	  },
	  "application/vnd.macports.portpkg": {
	    "source": "iana",
	    "extensions": ["portpkg"]
	  },
	  "application/vnd.mapbox-vector-tile": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.actiontoken+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.conftoken+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.license+xml": {
	    "source": "iana"
	  },
	  "application/vnd.marlin.drm.mdcf": {
	    "source": "iana"
	  },
	  "application/vnd.mason+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.maxmind.maxmind-db": {
	    "source": "iana"
	  },
	  "application/vnd.mcd": {
	    "source": "iana",
	    "extensions": ["mcd"]
	  },
	  "application/vnd.medcalcdata": {
	    "source": "iana",
	    "extensions": ["mc1"]
	  },
	  "application/vnd.mediastation.cdkey": {
	    "source": "iana",
	    "extensions": ["cdkey"]
	  },
	  "application/vnd.meridian-slingshot": {
	    "source": "iana"
	  },
	  "application/vnd.mfer": {
	    "source": "iana",
	    "extensions": ["mwf"]
	  },
	  "application/vnd.mfmp": {
	    "source": "iana",
	    "extensions": ["mfm"]
	  },
	  "application/vnd.micro+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.micrografx.flo": {
	    "source": "iana",
	    "extensions": ["flo"]
	  },
	  "application/vnd.micrografx.igx": {
	    "source": "iana",
	    "extensions": ["igx"]
	  },
	  "application/vnd.microsoft.portable-executable": {
	    "source": "iana"
	  },
	  "application/vnd.miele+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.mif": {
	    "source": "iana",
	    "extensions": ["mif"]
	  },
	  "application/vnd.minisoft-hp3000-save": {
	    "source": "iana"
	  },
	  "application/vnd.mitsubishi.misty-guard.trustweb": {
	    "source": "iana"
	  },
	  "application/vnd.mobius.daf": {
	    "source": "iana",
	    "extensions": ["daf"]
	  },
	  "application/vnd.mobius.dis": {
	    "source": "iana",
	    "extensions": ["dis"]
	  },
	  "application/vnd.mobius.mbk": {
	    "source": "iana",
	    "extensions": ["mbk"]
	  },
	  "application/vnd.mobius.mqy": {
	    "source": "iana",
	    "extensions": ["mqy"]
	  },
	  "application/vnd.mobius.msl": {
	    "source": "iana",
	    "extensions": ["msl"]
	  },
	  "application/vnd.mobius.plc": {
	    "source": "iana",
	    "extensions": ["plc"]
	  },
	  "application/vnd.mobius.txf": {
	    "source": "iana",
	    "extensions": ["txf"]
	  },
	  "application/vnd.mophun.application": {
	    "source": "iana",
	    "extensions": ["mpn"]
	  },
	  "application/vnd.mophun.certificate": {
	    "source": "iana",
	    "extensions": ["mpc"]
	  },
	  "application/vnd.motorola.flexsuite": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.adsi": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.fis": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.gotap": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.kmr": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.ttc": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.flexsuite.wem": {
	    "source": "iana"
	  },
	  "application/vnd.motorola.iprm": {
	    "source": "iana"
	  },
	  "application/vnd.mozilla.xul+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xul"]
	  },
	  "application/vnd.ms-3mfdocument": {
	    "source": "iana"
	  },
	  "application/vnd.ms-artgalry": {
	    "source": "iana",
	    "extensions": ["cil"]
	  },
	  "application/vnd.ms-asf": {
	    "source": "iana"
	  },
	  "application/vnd.ms-cab-compressed": {
	    "source": "iana",
	    "extensions": ["cab"]
	  },
	  "application/vnd.ms-color.iccprofile": {
	    "source": "apache"
	  },
	  "application/vnd.ms-excel": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xls","xlm","xla","xlc","xlt","xlw"]
	  },
	  "application/vnd.ms-excel.addin.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlam"]
	  },
	  "application/vnd.ms-excel.sheet.binary.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlsb"]
	  },
	  "application/vnd.ms-excel.sheet.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xlsm"]
	  },
	  "application/vnd.ms-excel.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["xltm"]
	  },
	  "application/vnd.ms-fontobject": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["eot"]
	  },
	  "application/vnd.ms-htmlhelp": {
	    "source": "iana",
	    "extensions": ["chm"]
	  },
	  "application/vnd.ms-ims": {
	    "source": "iana",
	    "extensions": ["ims"]
	  },
	  "application/vnd.ms-lrm": {
	    "source": "iana",
	    "extensions": ["lrm"]
	  },
	  "application/vnd.ms-office.activex+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-officetheme": {
	    "source": "iana",
	    "extensions": ["thmx"]
	  },
	  "application/vnd.ms-opentype": {
	    "source": "apache",
	    "compressible": true
	  },
	  "application/vnd.ms-package.obfuscated-opentype": {
	    "source": "apache"
	  },
	  "application/vnd.ms-pki.seccat": {
	    "source": "apache",
	    "extensions": ["cat"]
	  },
	  "application/vnd.ms-pki.stl": {
	    "source": "apache",
	    "extensions": ["stl"]
	  },
	  "application/vnd.ms-playready.initiator+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-powerpoint": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ppt","pps","pot"]
	  },
	  "application/vnd.ms-powerpoint.addin.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["ppam"]
	  },
	  "application/vnd.ms-powerpoint.presentation.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["pptm"]
	  },
	  "application/vnd.ms-powerpoint.slide.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["sldm"]
	  },
	  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["ppsm"]
	  },
	  "application/vnd.ms-powerpoint.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["potm"]
	  },
	  "application/vnd.ms-printdevicecapabilities+xml": {
	    "source": "iana"
	  },
	  "application/vnd.ms-printing.printticket+xml": {
	    "source": "apache"
	  },
	  "application/vnd.ms-project": {
	    "source": "iana",
	    "extensions": ["mpp","mpt"]
	  },
	  "application/vnd.ms-tnef": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.devicepairing": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.nwprinting.oob": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.printerpairing": {
	    "source": "iana"
	  },
	  "application/vnd.ms-windows.wsd.oob": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.lic-chlg-req": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.lic-resp": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.meter-chlg-req": {
	    "source": "iana"
	  },
	  "application/vnd.ms-wmdrm.meter-resp": {
	    "source": "iana"
	  },
	  "application/vnd.ms-word.document.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["docm"]
	  },
	  "application/vnd.ms-word.template.macroenabled.12": {
	    "source": "iana",
	    "extensions": ["dotm"]
	  },
	  "application/vnd.ms-works": {
	    "source": "iana",
	    "extensions": ["wps","wks","wcm","wdb"]
	  },
	  "application/vnd.ms-wpl": {
	    "source": "iana",
	    "extensions": ["wpl"]
	  },
	  "application/vnd.ms-xpsdocument": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xps"]
	  },
	  "application/vnd.msa-disk-image": {
	    "source": "iana"
	  },
	  "application/vnd.mseq": {
	    "source": "iana",
	    "extensions": ["mseq"]
	  },
	  "application/vnd.msign": {
	    "source": "iana"
	  },
	  "application/vnd.multiad.creator": {
	    "source": "iana"
	  },
	  "application/vnd.multiad.creator.cif": {
	    "source": "iana"
	  },
	  "application/vnd.music-niff": {
	    "source": "iana"
	  },
	  "application/vnd.musician": {
	    "source": "iana",
	    "extensions": ["mus"]
	  },
	  "application/vnd.muvee.style": {
	    "source": "iana",
	    "extensions": ["msty"]
	  },
	  "application/vnd.mynfc": {
	    "source": "iana",
	    "extensions": ["taglet"]
	  },
	  "application/vnd.ncd.control": {
	    "source": "iana"
	  },
	  "application/vnd.ncd.reference": {
	    "source": "iana"
	  },
	  "application/vnd.nervana": {
	    "source": "iana"
	  },
	  "application/vnd.netfpx": {
	    "source": "iana"
	  },
	  "application/vnd.neurolanguage.nlu": {
	    "source": "iana",
	    "extensions": ["nlu"]
	  },
	  "application/vnd.nintendo.nitro.rom": {
	    "source": "iana"
	  },
	  "application/vnd.nintendo.snes.rom": {
	    "source": "iana"
	  },
	  "application/vnd.nitf": {
	    "source": "iana",
	    "extensions": ["ntf","nitf"]
	  },
	  "application/vnd.noblenet-directory": {
	    "source": "iana",
	    "extensions": ["nnd"]
	  },
	  "application/vnd.noblenet-sealer": {
	    "source": "iana",
	    "extensions": ["nns"]
	  },
	  "application/vnd.noblenet-web": {
	    "source": "iana",
	    "extensions": ["nnw"]
	  },
	  "application/vnd.nokia.catalogs": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.conml+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.conml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.iptv.config+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.isds-radio-presets": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmark+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmark+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.landmarkcollection+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.n-gage.ac+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.n-gage.data": {
	    "source": "iana",
	    "extensions": ["ngdat"]
	  },
	  "application/vnd.nokia.n-gage.symbian.install": {
	    "source": "iana",
	    "extensions": ["n-gage"]
	  },
	  "application/vnd.nokia.ncd": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.pcd+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.pcd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.nokia.radio-preset": {
	    "source": "iana",
	    "extensions": ["rpst"]
	  },
	  "application/vnd.nokia.radio-presets": {
	    "source": "iana",
	    "extensions": ["rpss"]
	  },
	  "application/vnd.novadigm.edm": {
	    "source": "iana",
	    "extensions": ["edm"]
	  },
	  "application/vnd.novadigm.edx": {
	    "source": "iana",
	    "extensions": ["edx"]
	  },
	  "application/vnd.novadigm.ext": {
	    "source": "iana",
	    "extensions": ["ext"]
	  },
	  "application/vnd.ntt-local.content-share": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.file-transfer": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.ogw_remote-access": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.sip-ta_remote": {
	    "source": "iana"
	  },
	  "application/vnd.ntt-local.sip-ta_tcp_stream": {
	    "source": "iana"
	  },
	  "application/vnd.oasis.opendocument.chart": {
	    "source": "iana",
	    "extensions": ["odc"]
	  },
	  "application/vnd.oasis.opendocument.chart-template": {
	    "source": "iana",
	    "extensions": ["otc"]
	  },
	  "application/vnd.oasis.opendocument.database": {
	    "source": "iana",
	    "extensions": ["odb"]
	  },
	  "application/vnd.oasis.opendocument.formula": {
	    "source": "iana",
	    "extensions": ["odf"]
	  },
	  "application/vnd.oasis.opendocument.formula-template": {
	    "source": "iana",
	    "extensions": ["odft"]
	  },
	  "application/vnd.oasis.opendocument.graphics": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odg"]
	  },
	  "application/vnd.oasis.opendocument.graphics-template": {
	    "source": "iana",
	    "extensions": ["otg"]
	  },
	  "application/vnd.oasis.opendocument.image": {
	    "source": "iana",
	    "extensions": ["odi"]
	  },
	  "application/vnd.oasis.opendocument.image-template": {
	    "source": "iana",
	    "extensions": ["oti"]
	  },
	  "application/vnd.oasis.opendocument.presentation": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odp"]
	  },
	  "application/vnd.oasis.opendocument.presentation-template": {
	    "source": "iana",
	    "extensions": ["otp"]
	  },
	  "application/vnd.oasis.opendocument.spreadsheet": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["ods"]
	  },
	  "application/vnd.oasis.opendocument.spreadsheet-template": {
	    "source": "iana",
	    "extensions": ["ots"]
	  },
	  "application/vnd.oasis.opendocument.text": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["odt"]
	  },
	  "application/vnd.oasis.opendocument.text-master": {
	    "source": "iana",
	    "extensions": ["odm"]
	  },
	  "application/vnd.oasis.opendocument.text-template": {
	    "source": "iana",
	    "extensions": ["ott"]
	  },
	  "application/vnd.oasis.opendocument.text-web": {
	    "source": "iana",
	    "extensions": ["oth"]
	  },
	  "application/vnd.obn": {
	    "source": "iana"
	  },
	  "application/vnd.oftn.l10n+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.oipf.contentaccessdownload+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.contentaccessstreaming+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.cspg-hexbinary": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.dae.svg+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.dae.xhtml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.mippvcontrolmessage+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.pae.gem": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.spdiscovery+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.spdlist+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.ueprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oipf.userprofile+xml": {
	    "source": "iana"
	  },
	  "application/vnd.olpc-sugar": {
	    "source": "iana",
	    "extensions": ["xo"]
	  },
	  "application/vnd.oma-scws-config": {
	    "source": "iana"
	  },
	  "application/vnd.oma-scws-http-request": {
	    "source": "iana"
	  },
	  "application/vnd.oma-scws-http-response": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.associated-procedure-parameter+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.drm-trigger+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.imd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.ltkm": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.notification+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.provisioningtrigger": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgboot": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgdd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sgdu": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.simple-symbol-container": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.smartcard-trigger+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.sprov+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.bcast.stkm": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-address-book+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-feature-handler+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-pcc+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-subs-invite+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.cab-user-prefs+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dcd": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dcdc": {
	    "source": "iana"
	  },
	  "application/vnd.oma.dd2+xml": {
	    "source": "iana",
	    "extensions": ["dd2"]
	  },
	  "application/vnd.oma.drm.risd+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.group-usage-list+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.pal+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.detailed-progress-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.final-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.groups+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.invocation-descriptor+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.poc.optimized-progress-report+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.push": {
	    "source": "iana"
	  },
	  "application/vnd.oma.scidm.messages+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oma.xcap-directory+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-email+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-file+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omads-folder+xml": {
	    "source": "iana"
	  },
	  "application/vnd.omaloc-supl-init": {
	    "source": "iana"
	  },
	  "application/vnd.openblox.game+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openblox.game-binary": {
	    "source": "iana"
	  },
	  "application/vnd.openeye.oeb": {
	    "source": "iana"
	  },
	  "application/vnd.openofficeorg.extension": {
	    "source": "apache",
	    "extensions": ["oxt"]
	  },
	  "application/vnd.openxmlformats-officedocument.custom-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawing+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.extended-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["pptx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slide": {
	    "source": "iana",
	    "extensions": ["sldx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
	    "source": "iana",
	    "extensions": ["ppsx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.template": {
	    "source": "apache",
	    "extensions": ["potx"]
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["xlsx"]
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
	    "source": "apache",
	    "extensions": ["xltx"]
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.theme+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.themeoverride+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.vmldrawing": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml-template": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["docx"]
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
	    "source": "apache",
	    "extensions": ["dotx"]
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.core-properties+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
	    "source": "iana"
	  },
	  "application/vnd.openxmlformats-package.relationships+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oracle.resource+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.orange.indata": {
	    "source": "iana"
	  },
	  "application/vnd.osa.netdeploy": {
	    "source": "iana"
	  },
	  "application/vnd.osgeo.mapguide.package": {
	    "source": "iana",
	    "extensions": ["mgp"]
	  },
	  "application/vnd.osgi.bundle": {
	    "source": "iana"
	  },
	  "application/vnd.osgi.dp": {
	    "source": "iana",
	    "extensions": ["dp"]
	  },
	  "application/vnd.osgi.subsystem": {
	    "source": "iana",
	    "extensions": ["esa"]
	  },
	  "application/vnd.otps.ct-kip+xml": {
	    "source": "iana"
	  },
	  "application/vnd.oxli.countgraph": {
	    "source": "iana"
	  },
	  "application/vnd.pagerduty+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.palm": {
	    "source": "iana",
	    "extensions": ["pdb","pqa","oprc"]
	  },
	  "application/vnd.panoply": {
	    "source": "iana"
	  },
	  "application/vnd.paos+xml": {
	    "source": "iana"
	  },
	  "application/vnd.paos.xml": {
	    "source": "apache"
	  },
	  "application/vnd.pawaafile": {
	    "source": "iana",
	    "extensions": ["paw"]
	  },
	  "application/vnd.pcos": {
	    "source": "iana"
	  },
	  "application/vnd.pg.format": {
	    "source": "iana",
	    "extensions": ["str"]
	  },
	  "application/vnd.pg.osasli": {
	    "source": "iana",
	    "extensions": ["ei6"]
	  },
	  "application/vnd.piaccess.application-licence": {
	    "source": "iana"
	  },
	  "application/vnd.picsel": {
	    "source": "iana",
	    "extensions": ["efif"]
	  },
	  "application/vnd.pmi.widget": {
	    "source": "iana",
	    "extensions": ["wg"]
	  },
	  "application/vnd.poc.group-advertisement+xml": {
	    "source": "iana"
	  },
	  "application/vnd.pocketlearn": {
	    "source": "iana",
	    "extensions": ["plf"]
	  },
	  "application/vnd.powerbuilder6": {
	    "source": "iana",
	    "extensions": ["pbd"]
	  },
	  "application/vnd.powerbuilder6-s": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder7": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder7-s": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder75": {
	    "source": "iana"
	  },
	  "application/vnd.powerbuilder75-s": {
	    "source": "iana"
	  },
	  "application/vnd.preminet": {
	    "source": "iana"
	  },
	  "application/vnd.previewsystems.box": {
	    "source": "iana",
	    "extensions": ["box"]
	  },
	  "application/vnd.proteus.magazine": {
	    "source": "iana",
	    "extensions": ["mgz"]
	  },
	  "application/vnd.publishare-delta-tree": {
	    "source": "iana",
	    "extensions": ["qps"]
	  },
	  "application/vnd.pvi.ptid1": {
	    "source": "iana",
	    "extensions": ["ptid"]
	  },
	  "application/vnd.pwg-multiplexed": {
	    "source": "iana"
	  },
	  "application/vnd.pwg-xhtml-print+xml": {
	    "source": "iana"
	  },
	  "application/vnd.qualcomm.brew-app-res": {
	    "source": "iana"
	  },
	  "application/vnd.quark.quarkxpress": {
	    "source": "iana",
	    "extensions": ["qxd","qxt","qwd","qwt","qxl","qxb"]
	  },
	  "application/vnd.quobject-quoxdocument": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.moml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-conf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-conn+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-dialog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-audit-stream+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-conf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-base+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-fax-detect+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-group+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-speech+xml": {
	    "source": "iana"
	  },
	  "application/vnd.radisys.msml-dialog-transform+xml": {
	    "source": "iana"
	  },
	  "application/vnd.rainstor.data": {
	    "source": "iana"
	  },
	  "application/vnd.rapid": {
	    "source": "iana"
	  },
	  "application/vnd.realvnc.bed": {
	    "source": "iana",
	    "extensions": ["bed"]
	  },
	  "application/vnd.recordare.musicxml": {
	    "source": "iana",
	    "extensions": ["mxl"]
	  },
	  "application/vnd.recordare.musicxml+xml": {
	    "source": "iana",
	    "extensions": ["musicxml"]
	  },
	  "application/vnd.renlearn.rlprint": {
	    "source": "iana"
	  },
	  "application/vnd.rig.cryptonote": {
	    "source": "iana",
	    "extensions": ["cryptonote"]
	  },
	  "application/vnd.rim.cod": {
	    "source": "apache",
	    "extensions": ["cod"]
	  },
	  "application/vnd.rn-realmedia": {
	    "source": "apache",
	    "extensions": ["rm"]
	  },
	  "application/vnd.rn-realmedia-vbr": {
	    "source": "apache",
	    "extensions": ["rmvb"]
	  },
	  "application/vnd.route66.link66+xml": {
	    "source": "iana",
	    "extensions": ["link66"]
	  },
	  "application/vnd.rs-274x": {
	    "source": "iana"
	  },
	  "application/vnd.ruckus.download": {
	    "source": "iana"
	  },
	  "application/vnd.s3sms": {
	    "source": "iana"
	  },
	  "application/vnd.sailingtracker.track": {
	    "source": "iana",
	    "extensions": ["st"]
	  },
	  "application/vnd.sbm.cid": {
	    "source": "iana"
	  },
	  "application/vnd.sbm.mid2": {
	    "source": "iana"
	  },
	  "application/vnd.scribus": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.3df": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.csf": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.doc": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.eml": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.mht": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.net": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.ppt": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.tiff": {
	    "source": "iana"
	  },
	  "application/vnd.sealed.xls": {
	    "source": "iana"
	  },
	  "application/vnd.sealedmedia.softseal.html": {
	    "source": "iana"
	  },
	  "application/vnd.sealedmedia.softseal.pdf": {
	    "source": "iana"
	  },
	  "application/vnd.seemail": {
	    "source": "iana",
	    "extensions": ["see"]
	  },
	  "application/vnd.sema": {
	    "source": "iana",
	    "extensions": ["sema"]
	  },
	  "application/vnd.semd": {
	    "source": "iana",
	    "extensions": ["semd"]
	  },
	  "application/vnd.semf": {
	    "source": "iana",
	    "extensions": ["semf"]
	  },
	  "application/vnd.shana.informed.formdata": {
	    "source": "iana",
	    "extensions": ["ifm"]
	  },
	  "application/vnd.shana.informed.formtemplate": {
	    "source": "iana",
	    "extensions": ["itp"]
	  },
	  "application/vnd.shana.informed.interchange": {
	    "source": "iana",
	    "extensions": ["iif"]
	  },
	  "application/vnd.shana.informed.package": {
	    "source": "iana",
	    "extensions": ["ipk"]
	  },
	  "application/vnd.simtech-mindmapper": {
	    "source": "iana",
	    "extensions": ["twd","twds"]
	  },
	  "application/vnd.siren+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.smaf": {
	    "source": "iana",
	    "extensions": ["mmf"]
	  },
	  "application/vnd.smart.notebook": {
	    "source": "iana"
	  },
	  "application/vnd.smart.teacher": {
	    "source": "iana",
	    "extensions": ["teacher"]
	  },
	  "application/vnd.software602.filler.form+xml": {
	    "source": "iana"
	  },
	  "application/vnd.software602.filler.form-xml-zip": {
	    "source": "iana"
	  },
	  "application/vnd.solent.sdkm+xml": {
	    "source": "iana",
	    "extensions": ["sdkm","sdkd"]
	  },
	  "application/vnd.spotfire.dxp": {
	    "source": "iana",
	    "extensions": ["dxp"]
	  },
	  "application/vnd.spotfire.sfs": {
	    "source": "iana",
	    "extensions": ["sfs"]
	  },
	  "application/vnd.sss-cod": {
	    "source": "iana"
	  },
	  "application/vnd.sss-dtf": {
	    "source": "iana"
	  },
	  "application/vnd.sss-ntf": {
	    "source": "iana"
	  },
	  "application/vnd.stardivision.calc": {
	    "source": "apache",
	    "extensions": ["sdc"]
	  },
	  "application/vnd.stardivision.draw": {
	    "source": "apache",
	    "extensions": ["sda"]
	  },
	  "application/vnd.stardivision.impress": {
	    "source": "apache",
	    "extensions": ["sdd"]
	  },
	  "application/vnd.stardivision.math": {
	    "source": "apache",
	    "extensions": ["smf"]
	  },
	  "application/vnd.stardivision.writer": {
	    "source": "apache",
	    "extensions": ["sdw","vor"]
	  },
	  "application/vnd.stardivision.writer-global": {
	    "source": "apache",
	    "extensions": ["sgl"]
	  },
	  "application/vnd.stepmania.package": {
	    "source": "iana",
	    "extensions": ["smzip"]
	  },
	  "application/vnd.stepmania.stepchart": {
	    "source": "iana",
	    "extensions": ["sm"]
	  },
	  "application/vnd.street-stream": {
	    "source": "iana"
	  },
	  "application/vnd.sun.wadl+xml": {
	    "source": "iana"
	  },
	  "application/vnd.sun.xml.calc": {
	    "source": "apache",
	    "extensions": ["sxc"]
	  },
	  "application/vnd.sun.xml.calc.template": {
	    "source": "apache",
	    "extensions": ["stc"]
	  },
	  "application/vnd.sun.xml.draw": {
	    "source": "apache",
	    "extensions": ["sxd"]
	  },
	  "application/vnd.sun.xml.draw.template": {
	    "source": "apache",
	    "extensions": ["std"]
	  },
	  "application/vnd.sun.xml.impress": {
	    "source": "apache",
	    "extensions": ["sxi"]
	  },
	  "application/vnd.sun.xml.impress.template": {
	    "source": "apache",
	    "extensions": ["sti"]
	  },
	  "application/vnd.sun.xml.math": {
	    "source": "apache",
	    "extensions": ["sxm"]
	  },
	  "application/vnd.sun.xml.writer": {
	    "source": "apache",
	    "extensions": ["sxw"]
	  },
	  "application/vnd.sun.xml.writer.global": {
	    "source": "apache",
	    "extensions": ["sxg"]
	  },
	  "application/vnd.sun.xml.writer.template": {
	    "source": "apache",
	    "extensions": ["stw"]
	  },
	  "application/vnd.sus-calendar": {
	    "source": "iana",
	    "extensions": ["sus","susp"]
	  },
	  "application/vnd.svd": {
	    "source": "iana",
	    "extensions": ["svd"]
	  },
	  "application/vnd.swiftview-ics": {
	    "source": "iana"
	  },
	  "application/vnd.symbian.install": {
	    "source": "apache",
	    "extensions": ["sis","sisx"]
	  },
	  "application/vnd.syncml+xml": {
	    "source": "iana",
	    "extensions": ["xsm"]
	  },
	  "application/vnd.syncml.dm+wbxml": {
	    "source": "iana",
	    "extensions": ["bdm"]
	  },
	  "application/vnd.syncml.dm+xml": {
	    "source": "iana",
	    "extensions": ["xdm"]
	  },
	  "application/vnd.syncml.dm.notification": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmddf+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmddf+xml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmtnds+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.dmtnds+xml": {
	    "source": "iana"
	  },
	  "application/vnd.syncml.ds.notification": {
	    "source": "iana"
	  },
	  "application/vnd.tao.intent-module-archive": {
	    "source": "iana",
	    "extensions": ["tao"]
	  },
	  "application/vnd.tcpdump.pcap": {
	    "source": "iana",
	    "extensions": ["pcap","cap","dmp"]
	  },
	  "application/vnd.tmd.mediaflex.api+xml": {
	    "source": "iana"
	  },
	  "application/vnd.tml": {
	    "source": "iana"
	  },
	  "application/vnd.tmobile-livetv": {
	    "source": "iana",
	    "extensions": ["tmo"]
	  },
	  "application/vnd.trid.tpt": {
	    "source": "iana",
	    "extensions": ["tpt"]
	  },
	  "application/vnd.triscape.mxs": {
	    "source": "iana",
	    "extensions": ["mxs"]
	  },
	  "application/vnd.trueapp": {
	    "source": "iana",
	    "extensions": ["tra"]
	  },
	  "application/vnd.truedoc": {
	    "source": "iana"
	  },
	  "application/vnd.ubisoft.webplayer": {
	    "source": "iana"
	  },
	  "application/vnd.ufdl": {
	    "source": "iana",
	    "extensions": ["ufd","ufdl"]
	  },
	  "application/vnd.uiq.theme": {
	    "source": "iana",
	    "extensions": ["utz"]
	  },
	  "application/vnd.umajin": {
	    "source": "iana",
	    "extensions": ["umj"]
	  },
	  "application/vnd.unity": {
	    "source": "iana",
	    "extensions": ["unityweb"]
	  },
	  "application/vnd.uoml+xml": {
	    "source": "iana",
	    "extensions": ["uoml"]
	  },
	  "application/vnd.uplanet.alert": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.alert-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.bearer-choice": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.bearer-choice-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.cacheop": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.cacheop-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.channel": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.channel-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.list": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.list-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.listcmd": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.listcmd-wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.uplanet.signal": {
	    "source": "iana"
	  },
	  "application/vnd.uri-map": {
	    "source": "iana"
	  },
	  "application/vnd.valve.source.material": {
	    "source": "iana"
	  },
	  "application/vnd.vcx": {
	    "source": "iana",
	    "extensions": ["vcx"]
	  },
	  "application/vnd.vd-study": {
	    "source": "iana"
	  },
	  "application/vnd.vectorworks": {
	    "source": "iana"
	  },
	  "application/vnd.verimatrix.vcas": {
	    "source": "iana"
	  },
	  "application/vnd.vidsoft.vidconference": {
	    "source": "iana"
	  },
	  "application/vnd.visio": {
	    "source": "iana",
	    "extensions": ["vsd","vst","vss","vsw"]
	  },
	  "application/vnd.visionary": {
	    "source": "iana",
	    "extensions": ["vis"]
	  },
	  "application/vnd.vividence.scriptfile": {
	    "source": "iana"
	  },
	  "application/vnd.vsf": {
	    "source": "iana",
	    "extensions": ["vsf"]
	  },
	  "application/vnd.wap.sic": {
	    "source": "iana"
	  },
	  "application/vnd.wap.slc": {
	    "source": "iana"
	  },
	  "application/vnd.wap.wbxml": {
	    "source": "iana",
	    "extensions": ["wbxml"]
	  },
	  "application/vnd.wap.wmlc": {
	    "source": "iana",
	    "extensions": ["wmlc"]
	  },
	  "application/vnd.wap.wmlscriptc": {
	    "source": "iana",
	    "extensions": ["wmlsc"]
	  },
	  "application/vnd.webturbo": {
	    "source": "iana",
	    "extensions": ["wtb"]
	  },
	  "application/vnd.wfa.p2p": {
	    "source": "iana"
	  },
	  "application/vnd.wfa.wsc": {
	    "source": "iana"
	  },
	  "application/vnd.windows.devicepairing": {
	    "source": "iana"
	  },
	  "application/vnd.wmc": {
	    "source": "iana"
	  },
	  "application/vnd.wmf.bootstrap": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.mathematica": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.mathematica.package": {
	    "source": "iana"
	  },
	  "application/vnd.wolfram.player": {
	    "source": "iana",
	    "extensions": ["nbp"]
	  },
	  "application/vnd.wordperfect": {
	    "source": "iana",
	    "extensions": ["wpd"]
	  },
	  "application/vnd.wqd": {
	    "source": "iana",
	    "extensions": ["wqd"]
	  },
	  "application/vnd.wrq-hp3000-labelled": {
	    "source": "iana"
	  },
	  "application/vnd.wt.stf": {
	    "source": "iana",
	    "extensions": ["stf"]
	  },
	  "application/vnd.wv.csp+wbxml": {
	    "source": "iana"
	  },
	  "application/vnd.wv.csp+xml": {
	    "source": "iana"
	  },
	  "application/vnd.wv.ssp+xml": {
	    "source": "iana"
	  },
	  "application/vnd.xacml+json": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/vnd.xara": {
	    "source": "iana",
	    "extensions": ["xar"]
	  },
	  "application/vnd.xfdl": {
	    "source": "iana",
	    "extensions": ["xfdl"]
	  },
	  "application/vnd.xfdl.webform": {
	    "source": "iana"
	  },
	  "application/vnd.xmi+xml": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.cpkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.dpkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.plan": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.ppkg": {
	    "source": "iana"
	  },
	  "application/vnd.xmpie.xlim": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.hv-dic": {
	    "source": "iana",
	    "extensions": ["hvd"]
	  },
	  "application/vnd.yamaha.hv-script": {
	    "source": "iana",
	    "extensions": ["hvs"]
	  },
	  "application/vnd.yamaha.hv-voice": {
	    "source": "iana",
	    "extensions": ["hvp"]
	  },
	  "application/vnd.yamaha.openscoreformat": {
	    "source": "iana",
	    "extensions": ["osf"]
	  },
	  "application/vnd.yamaha.openscoreformat.osfpvg+xml": {
	    "source": "iana",
	    "extensions": ["osfpvg"]
	  },
	  "application/vnd.yamaha.remote-setup": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.smaf-audio": {
	    "source": "iana",
	    "extensions": ["saf"]
	  },
	  "application/vnd.yamaha.smaf-phrase": {
	    "source": "iana",
	    "extensions": ["spf"]
	  },
	  "application/vnd.yamaha.through-ngn": {
	    "source": "iana"
	  },
	  "application/vnd.yamaha.tunnel-udpencap": {
	    "source": "iana"
	  },
	  "application/vnd.yaoweme": {
	    "source": "iana"
	  },
	  "application/vnd.yellowriver-custom-menu": {
	    "source": "iana",
	    "extensions": ["cmp"]
	  },
	  "application/vnd.zul": {
	    "source": "iana",
	    "extensions": ["zir","zirz"]
	  },
	  "application/vnd.zzazz.deck+xml": {
	    "source": "iana",
	    "extensions": ["zaz"]
	  },
	  "application/voicexml+xml": {
	    "source": "iana",
	    "extensions": ["vxml"]
	  },
	  "application/vq-rtcpxr": {
	    "source": "iana"
	  },
	  "application/watcherinfo+xml": {
	    "source": "iana"
	  },
	  "application/whoispp-query": {
	    "source": "iana"
	  },
	  "application/whoispp-response": {
	    "source": "iana"
	  },
	  "application/widget": {
	    "source": "iana",
	    "extensions": ["wgt"]
	  },
	  "application/winhlp": {
	    "source": "apache",
	    "extensions": ["hlp"]
	  },
	  "application/wita": {
	    "source": "iana"
	  },
	  "application/wordperfect5.1": {
	    "source": "iana"
	  },
	  "application/wsdl+xml": {
	    "source": "iana",
	    "extensions": ["wsdl"]
	  },
	  "application/wspolicy+xml": {
	    "source": "iana",
	    "extensions": ["wspolicy"]
	  },
	  "application/x-7z-compressed": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["7z"]
	  },
	  "application/x-abiword": {
	    "source": "apache",
	    "extensions": ["abw"]
	  },
	  "application/x-ace-compressed": {
	    "source": "apache",
	    "extensions": ["ace"]
	  },
	  "application/x-amf": {
	    "source": "apache"
	  },
	  "application/x-apple-diskimage": {
	    "source": "apache",
	    "extensions": ["dmg"]
	  },
	  "application/x-authorware-bin": {
	    "source": "apache",
	    "extensions": ["aab","x32","u32","vox"]
	  },
	  "application/x-authorware-map": {
	    "source": "apache",
	    "extensions": ["aam"]
	  },
	  "application/x-authorware-seg": {
	    "source": "apache",
	    "extensions": ["aas"]
	  },
	  "application/x-bcpio": {
	    "source": "apache",
	    "extensions": ["bcpio"]
	  },
	  "application/x-bdoc": {
	    "compressible": false,
	    "extensions": ["bdoc"]
	  },
	  "application/x-bittorrent": {
	    "source": "apache",
	    "extensions": ["torrent"]
	  },
	  "application/x-blorb": {
	    "source": "apache",
	    "extensions": ["blb","blorb"]
	  },
	  "application/x-bzip": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["bz"]
	  },
	  "application/x-bzip2": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["bz2","boz"]
	  },
	  "application/x-cbr": {
	    "source": "apache",
	    "extensions": ["cbr","cba","cbt","cbz","cb7"]
	  },
	  "application/x-cdlink": {
	    "source": "apache",
	    "extensions": ["vcd"]
	  },
	  "application/x-cfs-compressed": {
	    "source": "apache",
	    "extensions": ["cfs"]
	  },
	  "application/x-chat": {
	    "source": "apache",
	    "extensions": ["chat"]
	  },
	  "application/x-chess-pgn": {
	    "source": "apache",
	    "extensions": ["pgn"]
	  },
	  "application/x-chrome-extension": {
	    "extensions": ["crx"]
	  },
	  "application/x-cocoa": {
	    "source": "nginx",
	    "extensions": ["cco"]
	  },
	  "application/x-compress": {
	    "source": "apache"
	  },
	  "application/x-conference": {
	    "source": "apache",
	    "extensions": ["nsc"]
	  },
	  "application/x-cpio": {
	    "source": "apache",
	    "extensions": ["cpio"]
	  },
	  "application/x-csh": {
	    "source": "apache",
	    "extensions": ["csh"]
	  },
	  "application/x-deb": {
	    "compressible": false
	  },
	  "application/x-debian-package": {
	    "source": "apache",
	    "extensions": ["deb","udeb"]
	  },
	  "application/x-dgc-compressed": {
	    "source": "apache",
	    "extensions": ["dgc"]
	  },
	  "application/x-director": {
	    "source": "apache",
	    "extensions": ["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]
	  },
	  "application/x-doom": {
	    "source": "apache",
	    "extensions": ["wad"]
	  },
	  "application/x-dtbncx+xml": {
	    "source": "apache",
	    "extensions": ["ncx"]
	  },
	  "application/x-dtbook+xml": {
	    "source": "apache",
	    "extensions": ["dtb"]
	  },
	  "application/x-dtbresource+xml": {
	    "source": "apache",
	    "extensions": ["res"]
	  },
	  "application/x-dvi": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["dvi"]
	  },
	  "application/x-envoy": {
	    "source": "apache",
	    "extensions": ["evy"]
	  },
	  "application/x-eva": {
	    "source": "apache",
	    "extensions": ["eva"]
	  },
	  "application/x-font-bdf": {
	    "source": "apache",
	    "extensions": ["bdf"]
	  },
	  "application/x-font-dos": {
	    "source": "apache"
	  },
	  "application/x-font-framemaker": {
	    "source": "apache"
	  },
	  "application/x-font-ghostscript": {
	    "source": "apache",
	    "extensions": ["gsf"]
	  },
	  "application/x-font-libgrx": {
	    "source": "apache"
	  },
	  "application/x-font-linux-psf": {
	    "source": "apache",
	    "extensions": ["psf"]
	  },
	  "application/x-font-otf": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["otf"]
	  },
	  "application/x-font-pcf": {
	    "source": "apache",
	    "extensions": ["pcf"]
	  },
	  "application/x-font-snf": {
	    "source": "apache",
	    "extensions": ["snf"]
	  },
	  "application/x-font-speedo": {
	    "source": "apache"
	  },
	  "application/x-font-sunos-news": {
	    "source": "apache"
	  },
	  "application/x-font-ttf": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["ttf","ttc"]
	  },
	  "application/x-font-type1": {
	    "source": "apache",
	    "extensions": ["pfa","pfb","pfm","afm"]
	  },
	  "application/x-font-vfont": {
	    "source": "apache"
	  },
	  "application/x-freearc": {
	    "source": "apache",
	    "extensions": ["arc"]
	  },
	  "application/x-futuresplash": {
	    "source": "apache",
	    "extensions": ["spl"]
	  },
	  "application/x-gca-compressed": {
	    "source": "apache",
	    "extensions": ["gca"]
	  },
	  "application/x-glulx": {
	    "source": "apache",
	    "extensions": ["ulx"]
	  },
	  "application/x-gnumeric": {
	    "source": "apache",
	    "extensions": ["gnumeric"]
	  },
	  "application/x-gramps-xml": {
	    "source": "apache",
	    "extensions": ["gramps"]
	  },
	  "application/x-gtar": {
	    "source": "apache",
	    "extensions": ["gtar"]
	  },
	  "application/x-gzip": {
	    "source": "apache"
	  },
	  "application/x-hdf": {
	    "source": "apache",
	    "extensions": ["hdf"]
	  },
	  "application/x-httpd-php": {
	    "compressible": true,
	    "extensions": ["php"]
	  },
	  "application/x-install-instructions": {
	    "source": "apache",
	    "extensions": ["install"]
	  },
	  "application/x-iso9660-image": {
	    "source": "apache",
	    "extensions": ["iso"]
	  },
	  "application/x-java-archive-diff": {
	    "source": "nginx",
	    "extensions": ["jardiff"]
	  },
	  "application/x-java-jnlp-file": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["jnlp"]
	  },
	  "application/x-javascript": {
	    "compressible": true
	  },
	  "application/x-latex": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["latex"]
	  },
	  "application/x-lua-bytecode": {
	    "extensions": ["luac"]
	  },
	  "application/x-lzh-compressed": {
	    "source": "apache",
	    "extensions": ["lzh","lha"]
	  },
	  "application/x-makeself": {
	    "source": "nginx",
	    "extensions": ["run"]
	  },
	  "application/x-mie": {
	    "source": "apache",
	    "extensions": ["mie"]
	  },
	  "application/x-mobipocket-ebook": {
	    "source": "apache",
	    "extensions": ["prc","mobi"]
	  },
	  "application/x-mpegurl": {
	    "compressible": false
	  },
	  "application/x-ms-application": {
	    "source": "apache",
	    "extensions": ["application"]
	  },
	  "application/x-ms-shortcut": {
	    "source": "apache",
	    "extensions": ["lnk"]
	  },
	  "application/x-ms-wmd": {
	    "source": "apache",
	    "extensions": ["wmd"]
	  },
	  "application/x-ms-wmz": {
	    "source": "apache",
	    "extensions": ["wmz"]
	  },
	  "application/x-ms-xbap": {
	    "source": "apache",
	    "extensions": ["xbap"]
	  },
	  "application/x-msaccess": {
	    "source": "apache",
	    "extensions": ["mdb"]
	  },
	  "application/x-msbinder": {
	    "source": "apache",
	    "extensions": ["obd"]
	  },
	  "application/x-mscardfile": {
	    "source": "apache",
	    "extensions": ["crd"]
	  },
	  "application/x-msclip": {
	    "source": "apache",
	    "extensions": ["clp"]
	  },
	  "application/x-msdos-program": {
	    "extensions": ["exe"]
	  },
	  "application/x-msdownload": {
	    "source": "apache",
	    "extensions": ["exe","dll","com","bat","msi"]
	  },
	  "application/x-msmediaview": {
	    "source": "apache",
	    "extensions": ["mvb","m13","m14"]
	  },
	  "application/x-msmetafile": {
	    "source": "apache",
	    "extensions": ["wmf","wmz","emf","emz"]
	  },
	  "application/x-msmoney": {
	    "source": "apache",
	    "extensions": ["mny"]
	  },
	  "application/x-mspublisher": {
	    "source": "apache",
	    "extensions": ["pub"]
	  },
	  "application/x-msschedule": {
	    "source": "apache",
	    "extensions": ["scd"]
	  },
	  "application/x-msterminal": {
	    "source": "apache",
	    "extensions": ["trm"]
	  },
	  "application/x-mswrite": {
	    "source": "apache",
	    "extensions": ["wri"]
	  },
	  "application/x-netcdf": {
	    "source": "apache",
	    "extensions": ["nc","cdf"]
	  },
	  "application/x-ns-proxy-autoconfig": {
	    "compressible": true,
	    "extensions": ["pac"]
	  },
	  "application/x-nzb": {
	    "source": "apache",
	    "extensions": ["nzb"]
	  },
	  "application/x-perl": {
	    "source": "nginx",
	    "extensions": ["pl","pm"]
	  },
	  "application/x-pilot": {
	    "source": "nginx",
	    "extensions": ["prc","pdb"]
	  },
	  "application/x-pkcs12": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["p12","pfx"]
	  },
	  "application/x-pkcs7-certificates": {
	    "source": "apache",
	    "extensions": ["p7b","spc"]
	  },
	  "application/x-pkcs7-certreqresp": {
	    "source": "apache",
	    "extensions": ["p7r"]
	  },
	  "application/x-rar-compressed": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["rar"]
	  },
	  "application/x-redhat-package-manager": {
	    "source": "nginx",
	    "extensions": ["rpm"]
	  },
	  "application/x-research-info-systems": {
	    "source": "apache",
	    "extensions": ["ris"]
	  },
	  "application/x-sea": {
	    "source": "nginx",
	    "extensions": ["sea"]
	  },
	  "application/x-sh": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["sh"]
	  },
	  "application/x-shar": {
	    "source": "apache",
	    "extensions": ["shar"]
	  },
	  "application/x-shockwave-flash": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["swf"]
	  },
	  "application/x-silverlight-app": {
	    "source": "apache",
	    "extensions": ["xap"]
	  },
	  "application/x-sql": {
	    "source": "apache",
	    "extensions": ["sql"]
	  },
	  "application/x-stuffit": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["sit"]
	  },
	  "application/x-stuffitx": {
	    "source": "apache",
	    "extensions": ["sitx"]
	  },
	  "application/x-subrip": {
	    "source": "apache",
	    "extensions": ["srt"]
	  },
	  "application/x-sv4cpio": {
	    "source": "apache",
	    "extensions": ["sv4cpio"]
	  },
	  "application/x-sv4crc": {
	    "source": "apache",
	    "extensions": ["sv4crc"]
	  },
	  "application/x-t3vm-image": {
	    "source": "apache",
	    "extensions": ["t3"]
	  },
	  "application/x-tads": {
	    "source": "apache",
	    "extensions": ["gam"]
	  },
	  "application/x-tar": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["tar"]
	  },
	  "application/x-tcl": {
	    "source": "apache",
	    "extensions": ["tcl","tk"]
	  },
	  "application/x-tex": {
	    "source": "apache",
	    "extensions": ["tex"]
	  },
	  "application/x-tex-tfm": {
	    "source": "apache",
	    "extensions": ["tfm"]
	  },
	  "application/x-texinfo": {
	    "source": "apache",
	    "extensions": ["texinfo","texi"]
	  },
	  "application/x-tgif": {
	    "source": "apache",
	    "extensions": ["obj"]
	  },
	  "application/x-ustar": {
	    "source": "apache",
	    "extensions": ["ustar"]
	  },
	  "application/x-wais-source": {
	    "source": "apache",
	    "extensions": ["src"]
	  },
	  "application/x-web-app-manifest+json": {
	    "compressible": true,
	    "extensions": ["webapp"]
	  },
	  "application/x-www-form-urlencoded": {
	    "source": "iana",
	    "compressible": true
	  },
	  "application/x-x509-ca-cert": {
	    "source": "apache",
	    "extensions": ["der","crt","pem"]
	  },
	  "application/x-xfig": {
	    "source": "apache",
	    "extensions": ["fig"]
	  },
	  "application/x-xliff+xml": {
	    "source": "apache",
	    "extensions": ["xlf"]
	  },
	  "application/x-xpinstall": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["xpi"]
	  },
	  "application/x-xz": {
	    "source": "apache",
	    "extensions": ["xz"]
	  },
	  "application/x-zmachine": {
	    "source": "apache",
	    "extensions": ["z1","z2","z3","z4","z5","z6","z7","z8"]
	  },
	  "application/x400-bp": {
	    "source": "iana"
	  },
	  "application/xacml+xml": {
	    "source": "iana"
	  },
	  "application/xaml+xml": {
	    "source": "apache",
	    "extensions": ["xaml"]
	  },
	  "application/xcap-att+xml": {
	    "source": "iana"
	  },
	  "application/xcap-caps+xml": {
	    "source": "iana"
	  },
	  "application/xcap-diff+xml": {
	    "source": "iana",
	    "extensions": ["xdf"]
	  },
	  "application/xcap-el+xml": {
	    "source": "iana"
	  },
	  "application/xcap-error+xml": {
	    "source": "iana"
	  },
	  "application/xcap-ns+xml": {
	    "source": "iana"
	  },
	  "application/xcon-conference-info+xml": {
	    "source": "iana"
	  },
	  "application/xcon-conference-info-diff+xml": {
	    "source": "iana"
	  },
	  "application/xenc+xml": {
	    "source": "iana",
	    "extensions": ["xenc"]
	  },
	  "application/xhtml+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xhtml","xht"]
	  },
	  "application/xhtml-voice+xml": {
	    "source": "apache"
	  },
	  "application/xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xml","xsl","xsd"]
	  },
	  "application/xml-dtd": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["dtd"]
	  },
	  "application/xml-external-parsed-entity": {
	    "source": "iana"
	  },
	  "application/xml-patch+xml": {
	    "source": "iana"
	  },
	  "application/xmpp+xml": {
	    "source": "iana"
	  },
	  "application/xop+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xop"]
	  },
	  "application/xproc+xml": {
	    "source": "apache",
	    "extensions": ["xpl"]
	  },
	  "application/xslt+xml": {
	    "source": "iana",
	    "extensions": ["xslt"]
	  },
	  "application/xspf+xml": {
	    "source": "apache",
	    "extensions": ["xspf"]
	  },
	  "application/xv+xml": {
	    "source": "iana",
	    "extensions": ["mxml","xhvml","xvml","xvm"]
	  },
	  "application/yang": {
	    "source": "iana",
	    "extensions": ["yang"]
	  },
	  "application/yin+xml": {
	    "source": "iana",
	    "extensions": ["yin"]
	  },
	  "application/zip": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["zip"]
	  },
	  "application/zlib": {
	    "source": "iana"
	  },
	  "audio/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "audio/32kadpcm": {
	    "source": "iana"
	  },
	  "audio/3gpp": {
	    "source": "iana"
	  },
	  "audio/3gpp2": {
	    "source": "iana"
	  },
	  "audio/ac3": {
	    "source": "iana"
	  },
	  "audio/adpcm": {
	    "source": "apache",
	    "extensions": ["adp"]
	  },
	  "audio/amr": {
	    "source": "iana"
	  },
	  "audio/amr-wb": {
	    "source": "iana"
	  },
	  "audio/amr-wb+": {
	    "source": "iana"
	  },
	  "audio/aptx": {
	    "source": "iana"
	  },
	  "audio/asc": {
	    "source": "iana"
	  },
	  "audio/atrac-advanced-lossless": {
	    "source": "iana"
	  },
	  "audio/atrac-x": {
	    "source": "iana"
	  },
	  "audio/atrac3": {
	    "source": "iana"
	  },
	  "audio/basic": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["au","snd"]
	  },
	  "audio/bv16": {
	    "source": "iana"
	  },
	  "audio/bv32": {
	    "source": "iana"
	  },
	  "audio/clearmode": {
	    "source": "iana"
	  },
	  "audio/cn": {
	    "source": "iana"
	  },
	  "audio/dat12": {
	    "source": "iana"
	  },
	  "audio/dls": {
	    "source": "iana"
	  },
	  "audio/dsr-es201108": {
	    "source": "iana"
	  },
	  "audio/dsr-es202050": {
	    "source": "iana"
	  },
	  "audio/dsr-es202211": {
	    "source": "iana"
	  },
	  "audio/dsr-es202212": {
	    "source": "iana"
	  },
	  "audio/dv": {
	    "source": "iana"
	  },
	  "audio/dvi4": {
	    "source": "iana"
	  },
	  "audio/eac3": {
	    "source": "iana"
	  },
	  "audio/encaprtp": {
	    "source": "iana"
	  },
	  "audio/evrc": {
	    "source": "iana"
	  },
	  "audio/evrc-qcp": {
	    "source": "iana"
	  },
	  "audio/evrc0": {
	    "source": "iana"
	  },
	  "audio/evrc1": {
	    "source": "iana"
	  },
	  "audio/evrcb": {
	    "source": "iana"
	  },
	  "audio/evrcb0": {
	    "source": "iana"
	  },
	  "audio/evrcb1": {
	    "source": "iana"
	  },
	  "audio/evrcnw": {
	    "source": "iana"
	  },
	  "audio/evrcnw0": {
	    "source": "iana"
	  },
	  "audio/evrcnw1": {
	    "source": "iana"
	  },
	  "audio/evrcwb": {
	    "source": "iana"
	  },
	  "audio/evrcwb0": {
	    "source": "iana"
	  },
	  "audio/evrcwb1": {
	    "source": "iana"
	  },
	  "audio/evs": {
	    "source": "iana"
	  },
	  "audio/fwdred": {
	    "source": "iana"
	  },
	  "audio/g711-0": {
	    "source": "iana"
	  },
	  "audio/g719": {
	    "source": "iana"
	  },
	  "audio/g722": {
	    "source": "iana"
	  },
	  "audio/g7221": {
	    "source": "iana"
	  },
	  "audio/g723": {
	    "source": "iana"
	  },
	  "audio/g726-16": {
	    "source": "iana"
	  },
	  "audio/g726-24": {
	    "source": "iana"
	  },
	  "audio/g726-32": {
	    "source": "iana"
	  },
	  "audio/g726-40": {
	    "source": "iana"
	  },
	  "audio/g728": {
	    "source": "iana"
	  },
	  "audio/g729": {
	    "source": "iana"
	  },
	  "audio/g7291": {
	    "source": "iana"
	  },
	  "audio/g729d": {
	    "source": "iana"
	  },
	  "audio/g729e": {
	    "source": "iana"
	  },
	  "audio/gsm": {
	    "source": "iana"
	  },
	  "audio/gsm-efr": {
	    "source": "iana"
	  },
	  "audio/gsm-hr-08": {
	    "source": "iana"
	  },
	  "audio/ilbc": {
	    "source": "iana"
	  },
	  "audio/ip-mr_v2.5": {
	    "source": "iana"
	  },
	  "audio/isac": {
	    "source": "apache"
	  },
	  "audio/l16": {
	    "source": "iana"
	  },
	  "audio/l20": {
	    "source": "iana"
	  },
	  "audio/l24": {
	    "source": "iana",
	    "compressible": false
	  },
	  "audio/l8": {
	    "source": "iana"
	  },
	  "audio/lpc": {
	    "source": "iana"
	  },
	  "audio/midi": {
	    "source": "apache",
	    "extensions": ["mid","midi","kar","rmi"]
	  },
	  "audio/mobile-xmf": {
	    "source": "iana"
	  },
	  "audio/mp4": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["mp4a","m4a"]
	  },
	  "audio/mp4a-latm": {
	    "source": "iana"
	  },
	  "audio/mpa": {
	    "source": "iana"
	  },
	  "audio/mpa-robust": {
	    "source": "iana"
	  },
	  "audio/mpeg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["mpga","mp2","mp2a","mp3","m2a","m3a"]
	  },
	  "audio/mpeg4-generic": {
	    "source": "iana"
	  },
	  "audio/musepack": {
	    "source": "apache"
	  },
	  "audio/ogg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["oga","ogg","spx"]
	  },
	  "audio/opus": {
	    "source": "iana"
	  },
	  "audio/parityfec": {
	    "source": "iana"
	  },
	  "audio/pcma": {
	    "source": "iana"
	  },
	  "audio/pcma-wb": {
	    "source": "iana"
	  },
	  "audio/pcmu": {
	    "source": "iana"
	  },
	  "audio/pcmu-wb": {
	    "source": "iana"
	  },
	  "audio/prs.sid": {
	    "source": "iana"
	  },
	  "audio/qcelp": {
	    "source": "iana"
	  },
	  "audio/raptorfec": {
	    "source": "iana"
	  },
	  "audio/red": {
	    "source": "iana"
	  },
	  "audio/rtp-enc-aescm128": {
	    "source": "iana"
	  },
	  "audio/rtp-midi": {
	    "source": "iana"
	  },
	  "audio/rtploopback": {
	    "source": "iana"
	  },
	  "audio/rtx": {
	    "source": "iana"
	  },
	  "audio/s3m": {
	    "source": "apache",
	    "extensions": ["s3m"]
	  },
	  "audio/silk": {
	    "source": "apache",
	    "extensions": ["sil"]
	  },
	  "audio/smv": {
	    "source": "iana"
	  },
	  "audio/smv-qcp": {
	    "source": "iana"
	  },
	  "audio/smv0": {
	    "source": "iana"
	  },
	  "audio/sp-midi": {
	    "source": "iana"
	  },
	  "audio/speex": {
	    "source": "iana"
	  },
	  "audio/t140c": {
	    "source": "iana"
	  },
	  "audio/t38": {
	    "source": "iana"
	  },
	  "audio/telephone-event": {
	    "source": "iana"
	  },
	  "audio/tone": {
	    "source": "iana"
	  },
	  "audio/uemclip": {
	    "source": "iana"
	  },
	  "audio/ulpfec": {
	    "source": "iana"
	  },
	  "audio/vdvi": {
	    "source": "iana"
	  },
	  "audio/vmr-wb": {
	    "source": "iana"
	  },
	  "audio/vnd.3gpp.iufp": {
	    "source": "iana"
	  },
	  "audio/vnd.4sb": {
	    "source": "iana"
	  },
	  "audio/vnd.audiokoz": {
	    "source": "iana"
	  },
	  "audio/vnd.celp": {
	    "source": "iana"
	  },
	  "audio/vnd.cisco.nse": {
	    "source": "iana"
	  },
	  "audio/vnd.cmles.radio-events": {
	    "source": "iana"
	  },
	  "audio/vnd.cns.anp1": {
	    "source": "iana"
	  },
	  "audio/vnd.cns.inf1": {
	    "source": "iana"
	  },
	  "audio/vnd.dece.audio": {
	    "source": "iana",
	    "extensions": ["uva","uvva"]
	  },
	  "audio/vnd.digital-winds": {
	    "source": "iana",
	    "extensions": ["eol"]
	  },
	  "audio/vnd.dlna.adts": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.heaac.1": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.heaac.2": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.mlp": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.mps": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2x": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pl2z": {
	    "source": "iana"
	  },
	  "audio/vnd.dolby.pulse.1": {
	    "source": "iana"
	  },
	  "audio/vnd.dra": {
	    "source": "iana",
	    "extensions": ["dra"]
	  },
	  "audio/vnd.dts": {
	    "source": "iana",
	    "extensions": ["dts"]
	  },
	  "audio/vnd.dts.hd": {
	    "source": "iana",
	    "extensions": ["dtshd"]
	  },
	  "audio/vnd.dvb.file": {
	    "source": "iana"
	  },
	  "audio/vnd.everad.plj": {
	    "source": "iana"
	  },
	  "audio/vnd.hns.audio": {
	    "source": "iana"
	  },
	  "audio/vnd.lucent.voice": {
	    "source": "iana",
	    "extensions": ["lvp"]
	  },
	  "audio/vnd.ms-playready.media.pya": {
	    "source": "iana",
	    "extensions": ["pya"]
	  },
	  "audio/vnd.nokia.mobile-xmf": {
	    "source": "iana"
	  },
	  "audio/vnd.nortel.vbk": {
	    "source": "iana"
	  },
	  "audio/vnd.nuera.ecelp4800": {
	    "source": "iana",
	    "extensions": ["ecelp4800"]
	  },
	  "audio/vnd.nuera.ecelp7470": {
	    "source": "iana",
	    "extensions": ["ecelp7470"]
	  },
	  "audio/vnd.nuera.ecelp9600": {
	    "source": "iana",
	    "extensions": ["ecelp9600"]
	  },
	  "audio/vnd.octel.sbc": {
	    "source": "iana"
	  },
	  "audio/vnd.qcelp": {
	    "source": "iana"
	  },
	  "audio/vnd.rhetorex.32kadpcm": {
	    "source": "iana"
	  },
	  "audio/vnd.rip": {
	    "source": "iana",
	    "extensions": ["rip"]
	  },
	  "audio/vnd.rn-realaudio": {
	    "compressible": false
	  },
	  "audio/vnd.sealedmedia.softseal.mpeg": {
	    "source": "iana"
	  },
	  "audio/vnd.vmx.cvsd": {
	    "source": "iana"
	  },
	  "audio/vnd.wave": {
	    "compressible": false
	  },
	  "audio/vorbis": {
	    "source": "iana",
	    "compressible": false
	  },
	  "audio/vorbis-config": {
	    "source": "iana"
	  },
	  "audio/wav": {
	    "compressible": false,
	    "extensions": ["wav"]
	  },
	  "audio/wave": {
	    "compressible": false,
	    "extensions": ["wav"]
	  },
	  "audio/webm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["weba"]
	  },
	  "audio/x-aac": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["aac"]
	  },
	  "audio/x-aiff": {
	    "source": "apache",
	    "extensions": ["aif","aiff","aifc"]
	  },
	  "audio/x-caf": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["caf"]
	  },
	  "audio/x-flac": {
	    "source": "apache",
	    "extensions": ["flac"]
	  },
	  "audio/x-m4a": {
	    "source": "nginx",
	    "extensions": ["m4a"]
	  },
	  "audio/x-matroska": {
	    "source": "apache",
	    "extensions": ["mka"]
	  },
	  "audio/x-mpegurl": {
	    "source": "apache",
	    "extensions": ["m3u"]
	  },
	  "audio/x-ms-wax": {
	    "source": "apache",
	    "extensions": ["wax"]
	  },
	  "audio/x-ms-wma": {
	    "source": "apache",
	    "extensions": ["wma"]
	  },
	  "audio/x-pn-realaudio": {
	    "source": "apache",
	    "extensions": ["ram","ra"]
	  },
	  "audio/x-pn-realaudio-plugin": {
	    "source": "apache",
	    "extensions": ["rmp"]
	  },
	  "audio/x-realaudio": {
	    "source": "nginx",
	    "extensions": ["ra"]
	  },
	  "audio/x-tta": {
	    "source": "apache"
	  },
	  "audio/x-wav": {
	    "source": "apache",
	    "extensions": ["wav"]
	  },
	  "audio/xm": {
	    "source": "apache",
	    "extensions": ["xm"]
	  },
	  "chemical/x-cdx": {
	    "source": "apache",
	    "extensions": ["cdx"]
	  },
	  "chemical/x-cif": {
	    "source": "apache",
	    "extensions": ["cif"]
	  },
	  "chemical/x-cmdf": {
	    "source": "apache",
	    "extensions": ["cmdf"]
	  },
	  "chemical/x-cml": {
	    "source": "apache",
	    "extensions": ["cml"]
	  },
	  "chemical/x-csml": {
	    "source": "apache",
	    "extensions": ["csml"]
	  },
	  "chemical/x-pdb": {
	    "source": "apache"
	  },
	  "chemical/x-xyz": {
	    "source": "apache",
	    "extensions": ["xyz"]
	  },
	  "font/opentype": {
	    "compressible": true,
	    "extensions": ["otf"]
	  },
	  "image/bmp": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["bmp"]
	  },
	  "image/cgm": {
	    "source": "iana",
	    "extensions": ["cgm"]
	  },
	  "image/fits": {
	    "source": "iana"
	  },
	  "image/g3fax": {
	    "source": "iana",
	    "extensions": ["g3"]
	  },
	  "image/gif": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["gif"]
	  },
	  "image/ief": {
	    "source": "iana",
	    "extensions": ["ief"]
	  },
	  "image/jp2": {
	    "source": "iana"
	  },
	  "image/jpeg": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["jpeg","jpg","jpe"]
	  },
	  "image/jpm": {
	    "source": "iana"
	  },
	  "image/jpx": {
	    "source": "iana"
	  },
	  "image/ktx": {
	    "source": "iana",
	    "extensions": ["ktx"]
	  },
	  "image/naplps": {
	    "source": "iana"
	  },
	  "image/pjpeg": {
	    "compressible": false
	  },
	  "image/png": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["png"]
	  },
	  "image/prs.btif": {
	    "source": "iana",
	    "extensions": ["btif"]
	  },
	  "image/prs.pti": {
	    "source": "iana"
	  },
	  "image/pwg-raster": {
	    "source": "iana"
	  },
	  "image/sgi": {
	    "source": "apache",
	    "extensions": ["sgi"]
	  },
	  "image/svg+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["svg","svgz"]
	  },
	  "image/t38": {
	    "source": "iana"
	  },
	  "image/tiff": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["tiff","tif"]
	  },
	  "image/tiff-fx": {
	    "source": "iana"
	  },
	  "image/vnd.adobe.photoshop": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["psd"]
	  },
	  "image/vnd.airzip.accelerator.azv": {
	    "source": "iana"
	  },
	  "image/vnd.cns.inf2": {
	    "source": "iana"
	  },
	  "image/vnd.dece.graphic": {
	    "source": "iana",
	    "extensions": ["uvi","uvvi","uvg","uvvg"]
	  },
	  "image/vnd.djvu": {
	    "source": "iana",
	    "extensions": ["djvu","djv"]
	  },
	  "image/vnd.dvb.subtitle": {
	    "source": "iana",
	    "extensions": ["sub"]
	  },
	  "image/vnd.dwg": {
	    "source": "iana",
	    "extensions": ["dwg"]
	  },
	  "image/vnd.dxf": {
	    "source": "iana",
	    "extensions": ["dxf"]
	  },
	  "image/vnd.fastbidsheet": {
	    "source": "iana",
	    "extensions": ["fbs"]
	  },
	  "image/vnd.fpx": {
	    "source": "iana",
	    "extensions": ["fpx"]
	  },
	  "image/vnd.fst": {
	    "source": "iana",
	    "extensions": ["fst"]
	  },
	  "image/vnd.fujixerox.edmics-mmr": {
	    "source": "iana",
	    "extensions": ["mmr"]
	  },
	  "image/vnd.fujixerox.edmics-rlc": {
	    "source": "iana",
	    "extensions": ["rlc"]
	  },
	  "image/vnd.globalgraphics.pgb": {
	    "source": "iana"
	  },
	  "image/vnd.microsoft.icon": {
	    "source": "iana"
	  },
	  "image/vnd.mix": {
	    "source": "iana"
	  },
	  "image/vnd.mozilla.apng": {
	    "source": "iana"
	  },
	  "image/vnd.ms-modi": {
	    "source": "iana",
	    "extensions": ["mdi"]
	  },
	  "image/vnd.ms-photo": {
	    "source": "apache",
	    "extensions": ["wdp"]
	  },
	  "image/vnd.net-fpx": {
	    "source": "iana",
	    "extensions": ["npx"]
	  },
	  "image/vnd.radiance": {
	    "source": "iana"
	  },
	  "image/vnd.sealed.png": {
	    "source": "iana"
	  },
	  "image/vnd.sealedmedia.softseal.gif": {
	    "source": "iana"
	  },
	  "image/vnd.sealedmedia.softseal.jpg": {
	    "source": "iana"
	  },
	  "image/vnd.svf": {
	    "source": "iana"
	  },
	  "image/vnd.tencent.tap": {
	    "source": "iana"
	  },
	  "image/vnd.valve.source.texture": {
	    "source": "iana"
	  },
	  "image/vnd.wap.wbmp": {
	    "source": "iana",
	    "extensions": ["wbmp"]
	  },
	  "image/vnd.xiff": {
	    "source": "iana",
	    "extensions": ["xif"]
	  },
	  "image/vnd.zbrush.pcx": {
	    "source": "iana"
	  },
	  "image/webp": {
	    "source": "apache",
	    "extensions": ["webp"]
	  },
	  "image/x-3ds": {
	    "source": "apache",
	    "extensions": ["3ds"]
	  },
	  "image/x-cmu-raster": {
	    "source": "apache",
	    "extensions": ["ras"]
	  },
	  "image/x-cmx": {
	    "source": "apache",
	    "extensions": ["cmx"]
	  },
	  "image/x-freehand": {
	    "source": "apache",
	    "extensions": ["fh","fhc","fh4","fh5","fh7"]
	  },
	  "image/x-icon": {
	    "source": "apache",
	    "compressible": true,
	    "extensions": ["ico"]
	  },
	  "image/x-jng": {
	    "source": "nginx",
	    "extensions": ["jng"]
	  },
	  "image/x-mrsid-image": {
	    "source": "apache",
	    "extensions": ["sid"]
	  },
	  "image/x-ms-bmp": {
	    "source": "nginx",
	    "compressible": true,
	    "extensions": ["bmp"]
	  },
	  "image/x-pcx": {
	    "source": "apache",
	    "extensions": ["pcx"]
	  },
	  "image/x-pict": {
	    "source": "apache",
	    "extensions": ["pic","pct"]
	  },
	  "image/x-portable-anymap": {
	    "source": "apache",
	    "extensions": ["pnm"]
	  },
	  "image/x-portable-bitmap": {
	    "source": "apache",
	    "extensions": ["pbm"]
	  },
	  "image/x-portable-graymap": {
	    "source": "apache",
	    "extensions": ["pgm"]
	  },
	  "image/x-portable-pixmap": {
	    "source": "apache",
	    "extensions": ["ppm"]
	  },
	  "image/x-rgb": {
	    "source": "apache",
	    "extensions": ["rgb"]
	  },
	  "image/x-tga": {
	    "source": "apache",
	    "extensions": ["tga"]
	  },
	  "image/x-xbitmap": {
	    "source": "apache",
	    "extensions": ["xbm"]
	  },
	  "image/x-xcf": {
	    "compressible": false
	  },
	  "image/x-xpixmap": {
	    "source": "apache",
	    "extensions": ["xpm"]
	  },
	  "image/x-xwindowdump": {
	    "source": "apache",
	    "extensions": ["xwd"]
	  },
	  "message/cpim": {
	    "source": "iana"
	  },
	  "message/delivery-status": {
	    "source": "iana"
	  },
	  "message/disposition-notification": {
	    "source": "iana"
	  },
	  "message/external-body": {
	    "source": "iana"
	  },
	  "message/feedback-report": {
	    "source": "iana"
	  },
	  "message/global": {
	    "source": "iana"
	  },
	  "message/global-delivery-status": {
	    "source": "iana"
	  },
	  "message/global-disposition-notification": {
	    "source": "iana"
	  },
	  "message/global-headers": {
	    "source": "iana"
	  },
	  "message/http": {
	    "source": "iana",
	    "compressible": false
	  },
	  "message/imdn+xml": {
	    "source": "iana",
	    "compressible": true
	  },
	  "message/news": {
	    "source": "iana"
	  },
	  "message/partial": {
	    "source": "iana",
	    "compressible": false
	  },
	  "message/rfc822": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["eml","mime"]
	  },
	  "message/s-http": {
	    "source": "iana"
	  },
	  "message/sip": {
	    "source": "iana"
	  },
	  "message/sipfrag": {
	    "source": "iana"
	  },
	  "message/tracking-status": {
	    "source": "iana"
	  },
	  "message/vnd.si.simp": {
	    "source": "iana"
	  },
	  "message/vnd.wfa.wsc": {
	    "source": "iana"
	  },
	  "model/iges": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["igs","iges"]
	  },
	  "model/mesh": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["msh","mesh","silo"]
	  },
	  "model/vnd.collada+xml": {
	    "source": "iana",
	    "extensions": ["dae"]
	  },
	  "model/vnd.dwf": {
	    "source": "iana",
	    "extensions": ["dwf"]
	  },
	  "model/vnd.flatland.3dml": {
	    "source": "iana"
	  },
	  "model/vnd.gdl": {
	    "source": "iana",
	    "extensions": ["gdl"]
	  },
	  "model/vnd.gs-gdl": {
	    "source": "apache"
	  },
	  "model/vnd.gs.gdl": {
	    "source": "iana"
	  },
	  "model/vnd.gtw": {
	    "source": "iana",
	    "extensions": ["gtw"]
	  },
	  "model/vnd.moml+xml": {
	    "source": "iana"
	  },
	  "model/vnd.mts": {
	    "source": "iana",
	    "extensions": ["mts"]
	  },
	  "model/vnd.opengex": {
	    "source": "iana"
	  },
	  "model/vnd.parasolid.transmit.binary": {
	    "source": "iana"
	  },
	  "model/vnd.parasolid.transmit.text": {
	    "source": "iana"
	  },
	  "model/vnd.valve.source.compiled-map": {
	    "source": "iana"
	  },
	  "model/vnd.vtu": {
	    "source": "iana",
	    "extensions": ["vtu"]
	  },
	  "model/vrml": {
	    "source": "iana",
	    "compressible": false,
	    "extensions": ["wrl","vrml"]
	  },
	  "model/x3d+binary": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["x3db","x3dbz"]
	  },
	  "model/x3d+fastinfoset": {
	    "source": "iana"
	  },
	  "model/x3d+vrml": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["x3dv","x3dvz"]
	  },
	  "model/x3d+xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["x3d","x3dz"]
	  },
	  "model/x3d-vrml": {
	    "source": "iana"
	  },
	  "multipart/alternative": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/appledouble": {
	    "source": "iana"
	  },
	  "multipart/byteranges": {
	    "source": "iana"
	  },
	  "multipart/digest": {
	    "source": "iana"
	  },
	  "multipart/encrypted": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/form-data": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/header-set": {
	    "source": "iana"
	  },
	  "multipart/mixed": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/parallel": {
	    "source": "iana"
	  },
	  "multipart/related": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/report": {
	    "source": "iana"
	  },
	  "multipart/signed": {
	    "source": "iana",
	    "compressible": false
	  },
	  "multipart/voice-message": {
	    "source": "iana"
	  },
	  "multipart/x-mixed-replace": {
	    "source": "iana"
	  },
	  "text/1d-interleaved-parityfec": {
	    "source": "iana"
	  },
	  "text/cache-manifest": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["appcache","manifest"]
	  },
	  "text/calendar": {
	    "source": "iana",
	    "extensions": ["ics","ifb"]
	  },
	  "text/calender": {
	    "compressible": true
	  },
	  "text/cmd": {
	    "compressible": true
	  },
	  "text/coffeescript": {
	    "extensions": ["coffee","litcoffee"]
	  },
	  "text/css": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["css"]
	  },
	  "text/csv": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["csv"]
	  },
	  "text/csv-schema": {
	    "source": "iana"
	  },
	  "text/directory": {
	    "source": "iana"
	  },
	  "text/dns": {
	    "source": "iana"
	  },
	  "text/ecmascript": {
	    "source": "iana"
	  },
	  "text/encaprtp": {
	    "source": "iana"
	  },
	  "text/enriched": {
	    "source": "iana"
	  },
	  "text/fwdred": {
	    "source": "iana"
	  },
	  "text/grammar-ref-list": {
	    "source": "iana"
	  },
	  "text/hjson": {
	    "extensions": ["hjson"]
	  },
	  "text/html": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["html","htm","shtml"]
	  },
	  "text/jade": {
	    "extensions": ["jade"]
	  },
	  "text/javascript": {
	    "source": "iana",
	    "compressible": true
	  },
	  "text/jcr-cnd": {
	    "source": "iana"
	  },
	  "text/jsx": {
	    "compressible": true,
	    "extensions": ["jsx"]
	  },
	  "text/less": {
	    "extensions": ["less"]
	  },
	  "text/markdown": {
	    "source": "iana"
	  },
	  "text/mathml": {
	    "source": "nginx",
	    "extensions": ["mml"]
	  },
	  "text/mizar": {
	    "source": "iana"
	  },
	  "text/n3": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["n3"]
	  },
	  "text/parameters": {
	    "source": "iana"
	  },
	  "text/parityfec": {
	    "source": "iana"
	  },
	  "text/plain": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["txt","text","conf","def","list","log","in","ini"]
	  },
	  "text/provenance-notation": {
	    "source": "iana"
	  },
	  "text/prs.fallenstein.rst": {
	    "source": "iana"
	  },
	  "text/prs.lines.tag": {
	    "source": "iana",
	    "extensions": ["dsc"]
	  },
	  "text/raptorfec": {
	    "source": "iana"
	  },
	  "text/red": {
	    "source": "iana"
	  },
	  "text/rfc822-headers": {
	    "source": "iana"
	  },
	  "text/richtext": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtx"]
	  },
	  "text/rtf": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["rtf"]
	  },
	  "text/rtp-enc-aescm128": {
	    "source": "iana"
	  },
	  "text/rtploopback": {
	    "source": "iana"
	  },
	  "text/rtx": {
	    "source": "iana"
	  },
	  "text/sgml": {
	    "source": "iana",
	    "extensions": ["sgml","sgm"]
	  },
	  "text/stylus": {
	    "extensions": ["stylus","styl"]
	  },
	  "text/t140": {
	    "source": "iana"
	  },
	  "text/tab-separated-values": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["tsv"]
	  },
	  "text/troff": {
	    "source": "iana",
	    "extensions": ["t","tr","roff","man","me","ms"]
	  },
	  "text/turtle": {
	    "source": "iana",
	    "extensions": ["ttl"]
	  },
	  "text/ulpfec": {
	    "source": "iana"
	  },
	  "text/uri-list": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["uri","uris","urls"]
	  },
	  "text/vcard": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["vcard"]
	  },
	  "text/vnd.a": {
	    "source": "iana"
	  },
	  "text/vnd.abc": {
	    "source": "iana"
	  },
	  "text/vnd.curl": {
	    "source": "iana",
	    "extensions": ["curl"]
	  },
	  "text/vnd.curl.dcurl": {
	    "source": "apache",
	    "extensions": ["dcurl"]
	  },
	  "text/vnd.curl.mcurl": {
	    "source": "apache",
	    "extensions": ["mcurl"]
	  },
	  "text/vnd.curl.scurl": {
	    "source": "apache",
	    "extensions": ["scurl"]
	  },
	  "text/vnd.debian.copyright": {
	    "source": "iana"
	  },
	  "text/vnd.dmclientscript": {
	    "source": "iana"
	  },
	  "text/vnd.dvb.subtitle": {
	    "source": "iana",
	    "extensions": ["sub"]
	  },
	  "text/vnd.esmertec.theme-descriptor": {
	    "source": "iana"
	  },
	  "text/vnd.fly": {
	    "source": "iana",
	    "extensions": ["fly"]
	  },
	  "text/vnd.fmi.flexstor": {
	    "source": "iana",
	    "extensions": ["flx"]
	  },
	  "text/vnd.graphviz": {
	    "source": "iana",
	    "extensions": ["gv"]
	  },
	  "text/vnd.in3d.3dml": {
	    "source": "iana",
	    "extensions": ["3dml"]
	  },
	  "text/vnd.in3d.spot": {
	    "source": "iana",
	    "extensions": ["spot"]
	  },
	  "text/vnd.iptc.newsml": {
	    "source": "iana"
	  },
	  "text/vnd.iptc.nitf": {
	    "source": "iana"
	  },
	  "text/vnd.latex-z": {
	    "source": "iana"
	  },
	  "text/vnd.motorola.reflex": {
	    "source": "iana"
	  },
	  "text/vnd.ms-mediapackage": {
	    "source": "iana"
	  },
	  "text/vnd.net2phone.commcenter.command": {
	    "source": "iana"
	  },
	  "text/vnd.radisys.msml-basic-layout": {
	    "source": "iana"
	  },
	  "text/vnd.si.uricatalogue": {
	    "source": "iana"
	  },
	  "text/vnd.sun.j2me.app-descriptor": {
	    "source": "iana",
	    "extensions": ["jad"]
	  },
	  "text/vnd.trolltech.linguist": {
	    "source": "iana"
	  },
	  "text/vnd.wap.si": {
	    "source": "iana"
	  },
	  "text/vnd.wap.sl": {
	    "source": "iana"
	  },
	  "text/vnd.wap.wml": {
	    "source": "iana",
	    "extensions": ["wml"]
	  },
	  "text/vnd.wap.wmlscript": {
	    "source": "iana",
	    "extensions": ["wmls"]
	  },
	  "text/vtt": {
	    "charset": "UTF-8",
	    "compressible": true,
	    "extensions": ["vtt"]
	  },
	  "text/x-asm": {
	    "source": "apache",
	    "extensions": ["s","asm"]
	  },
	  "text/x-c": {
	    "source": "apache",
	    "extensions": ["c","cc","cxx","cpp","h","hh","dic"]
	  },
	  "text/x-component": {
	    "source": "nginx",
	    "extensions": ["htc"]
	  },
	  "text/x-fortran": {
	    "source": "apache",
	    "extensions": ["f","for","f77","f90"]
	  },
	  "text/x-gwt-rpc": {
	    "compressible": true
	  },
	  "text/x-handlebars-template": {
	    "extensions": ["hbs"]
	  },
	  "text/x-java-source": {
	    "source": "apache",
	    "extensions": ["java"]
	  },
	  "text/x-jquery-tmpl": {
	    "compressible": true
	  },
	  "text/x-lua": {
	    "extensions": ["lua"]
	  },
	  "text/x-markdown": {
	    "compressible": true,
	    "extensions": ["markdown","md","mkd"]
	  },
	  "text/x-nfo": {
	    "source": "apache",
	    "extensions": ["nfo"]
	  },
	  "text/x-opml": {
	    "source": "apache",
	    "extensions": ["opml"]
	  },
	  "text/x-pascal": {
	    "source": "apache",
	    "extensions": ["p","pas"]
	  },
	  "text/x-processing": {
	    "compressible": true,
	    "extensions": ["pde"]
	  },
	  "text/x-sass": {
	    "extensions": ["sass"]
	  },
	  "text/x-scss": {
	    "extensions": ["scss"]
	  },
	  "text/x-setext": {
	    "source": "apache",
	    "extensions": ["etx"]
	  },
	  "text/x-sfv": {
	    "source": "apache",
	    "extensions": ["sfv"]
	  },
	  "text/x-suse-ymp": {
	    "compressible": true,
	    "extensions": ["ymp"]
	  },
	  "text/x-uuencode": {
	    "source": "apache",
	    "extensions": ["uu"]
	  },
	  "text/x-vcalendar": {
	    "source": "apache",
	    "extensions": ["vcs"]
	  },
	  "text/x-vcard": {
	    "source": "apache",
	    "extensions": ["vcf"]
	  },
	  "text/xml": {
	    "source": "iana",
	    "compressible": true,
	    "extensions": ["xml"]
	  },
	  "text/xml-external-parsed-entity": {
	    "source": "iana"
	  },
	  "text/yaml": {
	    "extensions": ["yaml","yml"]
	  },
	  "video/1d-interleaved-parityfec": {
	    "source": "apache"
	  },
	  "video/3gpp": {
	    "source": "apache",
	    "extensions": ["3gp","3gpp"]
	  },
	  "video/3gpp-tt": {
	    "source": "apache"
	  },
	  "video/3gpp2": {
	    "source": "apache",
	    "extensions": ["3g2"]
	  },
	  "video/bmpeg": {
	    "source": "apache"
	  },
	  "video/bt656": {
	    "source": "apache"
	  },
	  "video/celb": {
	    "source": "apache"
	  },
	  "video/dv": {
	    "source": "apache"
	  },
	  "video/h261": {
	    "source": "apache",
	    "extensions": ["h261"]
	  },
	  "video/h263": {
	    "source": "apache",
	    "extensions": ["h263"]
	  },
	  "video/h263-1998": {
	    "source": "apache"
	  },
	  "video/h263-2000": {
	    "source": "apache"
	  },
	  "video/h264": {
	    "source": "apache",
	    "extensions": ["h264"]
	  },
	  "video/h264-rcdo": {
	    "source": "apache"
	  },
	  "video/h264-svc": {
	    "source": "apache"
	  },
	  "video/jpeg": {
	    "source": "apache",
	    "extensions": ["jpgv"]
	  },
	  "video/jpeg2000": {
	    "source": "apache"
	  },
	  "video/jpm": {
	    "source": "apache",
	    "extensions": ["jpm","jpgm"]
	  },
	  "video/mj2": {
	    "source": "apache",
	    "extensions": ["mj2","mjp2"]
	  },
	  "video/mp1s": {
	    "source": "apache"
	  },
	  "video/mp2p": {
	    "source": "apache"
	  },
	  "video/mp2t": {
	    "source": "apache",
	    "extensions": ["ts"]
	  },
	  "video/mp4": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mp4","mp4v","mpg4"]
	  },
	  "video/mp4v-es": {
	    "source": "apache"
	  },
	  "video/mpeg": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mpeg","mpg","mpe","m1v","m2v"]
	  },
	  "video/mpeg4-generic": {
	    "source": "apache"
	  },
	  "video/mpv": {
	    "source": "apache"
	  },
	  "video/nv": {
	    "source": "apache"
	  },
	  "video/ogg": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["ogv"]
	  },
	  "video/parityfec": {
	    "source": "apache"
	  },
	  "video/pointer": {
	    "source": "apache"
	  },
	  "video/quicktime": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["qt","mov"]
	  },
	  "video/raw": {
	    "source": "apache"
	  },
	  "video/rtp-enc-aescm128": {
	    "source": "apache"
	  },
	  "video/rtx": {
	    "source": "apache"
	  },
	  "video/smpte292m": {
	    "source": "apache"
	  },
	  "video/ulpfec": {
	    "source": "apache"
	  },
	  "video/vc1": {
	    "source": "apache"
	  },
	  "video/vnd.cctv": {
	    "source": "apache"
	  },
	  "video/vnd.dece.hd": {
	    "source": "apache",
	    "extensions": ["uvh","uvvh"]
	  },
	  "video/vnd.dece.mobile": {
	    "source": "apache",
	    "extensions": ["uvm","uvvm"]
	  },
	  "video/vnd.dece.mp4": {
	    "source": "apache"
	  },
	  "video/vnd.dece.pd": {
	    "source": "apache",
	    "extensions": ["uvp","uvvp"]
	  },
	  "video/vnd.dece.sd": {
	    "source": "apache",
	    "extensions": ["uvs","uvvs"]
	  },
	  "video/vnd.dece.video": {
	    "source": "apache",
	    "extensions": ["uvv","uvvv"]
	  },
	  "video/vnd.directv.mpeg": {
	    "source": "apache"
	  },
	  "video/vnd.directv.mpeg-tts": {
	    "source": "apache"
	  },
	  "video/vnd.dlna.mpeg-tts": {
	    "source": "apache"
	  },
	  "video/vnd.dvb.file": {
	    "source": "apache",
	    "extensions": ["dvb"]
	  },
	  "video/vnd.fvt": {
	    "source": "apache",
	    "extensions": ["fvt"]
	  },
	  "video/vnd.hns.video": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.1dparityfec-1010": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.1dparityfec-2005": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.2dparityfec-1010": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.2dparityfec-2005": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.ttsavc": {
	    "source": "apache"
	  },
	  "video/vnd.iptvforum.ttsmpeg2": {
	    "source": "apache"
	  },
	  "video/vnd.motorola.video": {
	    "source": "apache"
	  },
	  "video/vnd.motorola.videop": {
	    "source": "apache"
	  },
	  "video/vnd.mpegurl": {
	    "source": "apache",
	    "extensions": ["mxu","m4u"]
	  },
	  "video/vnd.ms-playready.media.pyv": {
	    "source": "apache",
	    "extensions": ["pyv"]
	  },
	  "video/vnd.nokia.interleaved-multimedia": {
	    "source": "apache"
	  },
	  "video/vnd.nokia.videovoip": {
	    "source": "apache"
	  },
	  "video/vnd.objectvideo": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.mpeg1": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.mpeg4": {
	    "source": "apache"
	  },
	  "video/vnd.sealed.swf": {
	    "source": "apache"
	  },
	  "video/vnd.sealedmedia.softseal.mov": {
	    "source": "apache"
	  },
	  "video/vnd.uvvu.mp4": {
	    "source": "apache",
	    "extensions": ["uvu","uvvu"]
	  },
	  "video/vnd.vivo": {
	    "source": "apache",
	    "extensions": ["viv"]
	  },
	  "video/webm": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["webm"]
	  },
	  "video/x-f4v": {
	    "source": "apache",
	    "extensions": ["f4v"]
	  },
	  "video/x-fli": {
	    "source": "apache",
	    "extensions": ["fli"]
	  },
	  "video/x-flv": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["flv"]
	  },
	  "video/x-m4v": {
	    "source": "apache",
	    "extensions": ["m4v"]
	  },
	  "video/x-matroska": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["mkv","mk3d","mks"]
	  },
	  "video/x-mng": {
	    "source": "apache",
	    "extensions": ["mng"]
	  },
	  "video/x-ms-asf": {
	    "source": "apache",
	    "extensions": ["asf","asx"]
	  },
	  "video/x-ms-vob": {
	    "source": "apache",
	    "extensions": ["vob"]
	  },
	  "video/x-ms-wm": {
	    "source": "apache",
	    "extensions": ["wm"]
	  },
	  "video/x-ms-wmv": {
	    "source": "apache",
	    "compressible": false,
	    "extensions": ["wmv"]
	  },
	  "video/x-ms-wmx": {
	    "source": "apache",
	    "extensions": ["wmx"]
	  },
	  "video/x-ms-wvx": {
	    "source": "apache",
	    "extensions": ["wvx"]
	  },
	  "video/x-msvideo": {
	    "source": "apache",
	    "extensions": ["avi"]
	  },
	  "video/x-sgi-movie": {
	    "source": "apache",
	    "extensions": ["movie"]
	  },
	  "video/x-smv": {
	    "source": "apache",
	    "extensions": ["smv"]
	  },
	  "x-conference/x-cooltalk": {
	    "source": "apache",
	    "extensions": ["ice"]
	  },
	  "x-shader/x-fragment": {
	    "compressible": true
	  },
	  "x-shader/x-vertex": {
	    "compressible": true
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ants",
	  "bats",
	  "bears",
	  "bees",
	  "birds",
	  "buffalo",
	  "cats",
	  "chickens",
	  "cattle",
	  "dogs",
	  "dolphins",
	  "ducks",
	  "elephants",
	  "fishes",
	  "foxes",
	  "frogs",
	  "geese",
	  "goats",
	  "horses",
	  "kangaroos",
	  "lions",
	  "monkeys",
	  "owls",
	  "oxen",
	  "penguins",
	  "people",
	  "pigs",
	  "rabbits",
	  "sheep",
	  "tigers",
	  "whales",
	  "wolves",
	  "zebras",
	  "banshees",
	  "crows",
	  "black cats",
	  "chimeras",
	  "ghosts",
	  "conspirators",
	  "dragons",
	  "dwarves",
	  "elves",
	  "enchanters",
	  "exorcists",
	  "sons",
	  "foes",
	  "giants",
	  "gnomes",
	  "goblins",
	  "gooses",
	  "griffins",
	  "lycanthropes",
	  "nemesis",
	  "ogres",
	  "oracles",
	  "prophets",
	  "sorcerors",
	  "spiders",
	  "spirits",
	  "vampires",
	  "warlocks",
	  "vixens",
	  "werewolves",
	  "witches",
	  "worshipers",
	  "zombies",
	  "druids"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.creature = __webpack_require__(2108);
	team.name = __webpack_require__(2110);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.state} #{creature}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Australia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.state_abbr = __webpack_require__(2116);
	address.state = __webpack_require__(2115);
	address.postcode = __webpack_require__(2114);
	address.building_number = __webpack_require__(2111);
	address.street_suffix = __webpack_require__(2117);
	address.default_country = __webpack_require__(2112);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "New South Wales",
	  "Queensland",
	  "Northern Territory",
	  "South Australia",
	  "Western Australia",
	  "Tasmania",
	  "Australian Capital Territory",
	  "Victoria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "NSW",
	  "QLD",
	  "NT",
	  "SA",
	  "WA",
	  "TAS",
	  "ACT",
	  "VIC"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avenue",
	  "Boulevard",
	  "Circle",
	  "Circuit",
	  "Court",
	  "Crescent",
	  "Crest",
	  "Drive",
	  "Estate Dr",
	  "Grove",
	  "Hill",
	  "Island",
	  "Junction",
	  "Knoll",
	  "Lane",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Meadow",
	  "Mews",
	  "Parade",
	  "Parkway",
	  "Pass",
	  "Place",
	  "Plaza",
	  "Ridge",
	  "Road",
	  "Run",
	  "Square",
	  "Station St",
	  "Street",
	  "Summit",
	  "Terrace",
	  "Track",
	  "Trail",
	  "View Rd",
	  "Way"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2119);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pty Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers",
	  "Partners"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_AU = {};
	module['exports'] = en_AU;
	en_AU.title = "Australia (English)";
	en_AU.name = __webpack_require__(2124);
	en_AU.company = __webpack_require__(2118);
	en_AU.internet = __webpack_require__(2122);
	en_AU.address = __webpack_require__(2113);
	en_AU.phone_number = __webpack_require__(2127);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.au",
	  "com",
	  "net.au",
	  "net",
	  "org.au",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2121);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "William",
	  "Jack",
	  "Oliver",
	  "Joshua",
	  "Thomas",
	  "Lachlan",
	  "Cooper",
	  "Noah",
	  "Ethan",
	  "Lucas",
	  "James",
	  "Samuel",
	  "Jacob",
	  "Liam",
	  "Alexander",
	  "Benjamin",
	  "Max",
	  "Isaac",
	  "Daniel",
	  "Riley",
	  "Ryan",
	  "Charlie",
	  "Tyler",
	  "Jake",
	  "Matthew",
	  "Xavier",
	  "Harry",
	  "Jayden",
	  "Nicholas",
	  "Harrison",
	  "Levi",
	  "Luke",
	  "Adam",
	  "Henry",
	  "Aiden",
	  "Dylan",
	  "Oscar",
	  "Michael",
	  "Jackson",
	  "Logan",
	  "Joseph",
	  "Blake",
	  "Nathan",
	  "Connor",
	  "Elijah",
	  "Nate",
	  "Archie",
	  "Bailey",
	  "Marcus",
	  "Cameron",
	  "Jordan",
	  "Zachary",
	  "Caleb",
	  "Hunter",
	  "Ashton",
	  "Toby",
	  "Aidan",
	  "Hayden",
	  "Mason",
	  "Hamish",
	  "Edward",
	  "Angus",
	  "Eli",
	  "Sebastian",
	  "Christian",
	  "Patrick",
	  "Andrew",
	  "Anthony",
	  "Luca",
	  "Kai",
	  "Beau",
	  "Alex",
	  "George",
	  "Callum",
	  "Finn",
	  "Zac",
	  "Mitchell",
	  "Jett",
	  "Jesse",
	  "Gabriel",
	  "Leo",
	  "Declan",
	  "Charles",
	  "Jasper",
	  "Jonathan",
	  "Aaron",
	  "Hugo",
	  "David",
	  "Christopher",
	  "Chase",
	  "Owen",
	  "Justin",
	  "Ali",
	  "Darcy",
	  "Lincoln",
	  "Cody",
	  "Phoenix",
	  "Sam",
	  "John",
	  "Joel",
	  "Isabella",
	  "Ruby",
	  "Chloe",
	  "Olivia",
	  "Charlotte",
	  "Mia",
	  "Lily",
	  "Emily",
	  "Ella",
	  "Sienna",
	  "Sophie",
	  "Amelia",
	  "Grace",
	  "Ava",
	  "Zoe",
	  "Emma",
	  "Sophia",
	  "Matilda",
	  "Hannah",
	  "Jessica",
	  "Lucy",
	  "Georgia",
	  "Sarah",
	  "Abigail",
	  "Zara",
	  "Eva",
	  "Scarlett",
	  "Jasmine",
	  "Chelsea",
	  "Lilly",
	  "Ivy",
	  "Isla",
	  "Evie",
	  "Isabelle",
	  "Maddison",
	  "Layla",
	  "Summer",
	  "Annabelle",
	  "Alexis",
	  "Elizabeth",
	  "Bella",
	  "Holly",
	  "Lara",
	  "Madison",
	  "Alyssa",
	  "Maya",
	  "Tahlia",
	  "Claire",
	  "Hayley",
	  "Imogen",
	  "Jade",
	  "Ellie",
	  "Sofia",
	  "Addison",
	  "Molly",
	  "Phoebe",
	  "Alice",
	  "Savannah",
	  "Gabriella",
	  "Kayla",
	  "Mikayla",
	  "Abbey",
	  "Eliza",
	  "Willow",
	  "Alexandra",
	  "Poppy",
	  "Samantha",
	  "Stella",
	  "Amy",
	  "Amelie",
	  "Anna",
	  "Piper",
	  "Gemma",
	  "Isabel",
	  "Victoria",
	  "Stephanie",
	  "Caitlin",
	  "Heidi",
	  "Paige",
	  "Rose",
	  "Amber",
	  "Audrey",
	  "Claudia",
	  "Taylor",
	  "Madeline",
	  "Angelina",
	  "Natalie",
	  "Charli",
	  "Lauren",
	  "Ashley",
	  "Violet",
	  "Mackenzie",
	  "Abby",
	  "Skye",
	  "Lillian",
	  "Alana",
	  "Lola",
	  "Leah",
	  "Eve",
	  "Kiara"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2123);
	name.last_name = __webpack_require__(2125);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Smith",
	  "Jones",
	  "Williams",
	  "Brown",
	  "Wilson",
	  "Taylor",
	  "Johnson",
	  "White",
	  "Martin",
	  "Anderson",
	  "Thompson",
	  "Nguyen",
	  "Thomas",
	  "Walker",
	  "Harris",
	  "Lee",
	  "Ryan",
	  "Robinson",
	  "Kelly",
	  "King",
	  "Davis",
	  "Wright",
	  "Evans",
	  "Roberts",
	  "Green",
	  "Hall",
	  "Wood",
	  "Jackson",
	  "Clarke",
	  "Patel",
	  "Khan",
	  "Lewis",
	  "James",
	  "Phillips",
	  "Mason",
	  "Mitchell",
	  "Rose",
	  "Davies",
	  "Rodriguez",
	  "Cox",
	  "Alexander",
	  "Garden",
	  "Campbell",
	  "Johnston",
	  "Moore",
	  "Smyth",
	  "O'neill",
	  "Doherty",
	  "Stewart",
	  "Quinn",
	  "Murphy",
	  "Graham",
	  "Mclaughlin",
	  "Hamilton",
	  "Murray",
	  "Hughes",
	  "Robertson",
	  "Thomson",
	  "Scott",
	  "Macdonald",
	  "Reid",
	  "Clark",
	  "Ross",
	  "Young",
	  "Watson",
	  "Paterson",
	  "Morrison",
	  "Morgan",
	  "Griffiths",
	  "Edwards",
	  "Rees",
	  "Jenkins",
	  "Owen",
	  "Price",
	  "Moss",
	  "Richards",
	  "Abbott",
	  "Adams",
	  "Armstrong",
	  "Bahringer",
	  "Bailey",
	  "Barrows",
	  "Bartell",
	  "Bartoletti",
	  "Barton",
	  "Bauch",
	  "Baumbach",
	  "Bayer",
	  "Beahan",
	  "Beatty",
	  "Becker",
	  "Beier",
	  "Berge",
	  "Bergstrom",
	  "Bode",
	  "Bogan",
	  "Borer",
	  "Bosco",
	  "Botsford",
	  "Boyer",
	  "Boyle",
	  "Braun",
	  "Bruen",
	  "Carroll",
	  "Carter",
	  "Cartwright",
	  "Casper",
	  "Cassin",
	  "Champlin",
	  "Christiansen",
	  "Cole",
	  "Collier",
	  "Collins",
	  "Connelly",
	  "Conroy",
	  "Corkery",
	  "Cormier",
	  "Corwin",
	  "Cronin",
	  "Crooks",
	  "Cruickshank",
	  "Cummings",
	  "D'amore",
	  "Daniel",
	  "Dare",
	  "Daugherty",
	  "Dickens",
	  "Dickinson",
	  "Dietrich",
	  "Donnelly",
	  "Dooley",
	  "Douglas",
	  "Doyle",
	  "Durgan",
	  "Ebert",
	  "Emard",
	  "Emmerich",
	  "Erdman",
	  "Ernser",
	  "Fadel",
	  "Fahey",
	  "Farrell",
	  "Fay",
	  "Feeney",
	  "Feil",
	  "Ferry",
	  "Fisher",
	  "Flatley",
	  "Gibson",
	  "Gleason",
	  "Glover",
	  "Goldner",
	  "Goodwin",
	  "Grady",
	  "Grant",
	  "Greenfelder",
	  "Greenholt",
	  "Grimes",
	  "Gutmann",
	  "Hackett",
	  "Hahn",
	  "Haley",
	  "Hammes",
	  "Hand",
	  "Hane",
	  "Hansen",
	  "Harber",
	  "Hartmann",
	  "Harvey",
	  "Hayes",
	  "Heaney",
	  "Heathcote",
	  "Heller",
	  "Hermann",
	  "Hermiston",
	  "Hessel",
	  "Hettinger",
	  "Hickle",
	  "Hill",
	  "Hills",
	  "Hoppe",
	  "Howe",
	  "Howell",
	  "Hudson",
	  "Huel",
	  "Hyatt",
	  "Jacobi",
	  "Jacobs",
	  "Jacobson",
	  "Jerde",
	  "Johns",
	  "Keeling",
	  "Kemmer",
	  "Kessler",
	  "Kiehn",
	  "Kirlin",
	  "Klein",
	  "Koch",
	  "Koelpin",
	  "Kohler",
	  "Koss",
	  "Kovacek",
	  "Kreiger",
	  "Kris",
	  "Kuhlman",
	  "Kuhn",
	  "Kulas",
	  "Kunde",
	  "Kutch",
	  "Lakin",
	  "Lang",
	  "Langworth",
	  "Larkin",
	  "Larson",
	  "Leannon",
	  "Leffler",
	  "Little",
	  "Lockman",
	  "Lowe",
	  "Lynch",
	  "Mann",
	  "Marks",
	  "Marvin",
	  "Mayer",
	  "Mccullough",
	  "Mcdermott",
	  "Mckenzie",
	  "Miller",
	  "Mills",
	  "Monahan",
	  "Morissette",
	  "Mueller",
	  "Muller",
	  "Nader",
	  "Nicolas",
	  "Nolan",
	  "O'connell",
	  "O'conner",
	  "O'hara",
	  "O'keefe",
	  "Olson",
	  "O'reilly",
	  "Parisian",
	  "Parker",
	  "Quigley",
	  "Reilly",
	  "Reynolds",
	  "Rice",
	  "Ritchie",
	  "Rohan",
	  "Rolfson",
	  "Rowe",
	  "Russel",
	  "Rutherford",
	  "Sanford",
	  "Sauer",
	  "Schmidt",
	  "Schmitt",
	  "Schneider",
	  "Schroeder",
	  "Schultz",
	  "Shields",
	  "Smitham",
	  "Spencer",
	  "Stanton",
	  "Stark",
	  "Stokes",
	  "Swift",
	  "Tillman",
	  "Towne",
	  "Tremblay",
	  "Tromp",
	  "Turcotte",
	  "Turner",
	  "Walsh",
	  "Walter",
	  "Ward",
	  "Waters",
	  "Weber",
	  "Welch",
	  "West",
	  "Wilderman",
	  "Wilkinson",
	  "Williamson",
	  "Windler",
	  "Wolf"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0# #### ####",
	  "+61 # #### ####",
	  "04## ### ###",
	  "+61 4## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2126);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_BORK = {};
	module['exports'] = en_BORK;
	en_BORK.title = "Bork (English)";
	en_BORK.lorem = __webpack_require__(2129);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2130);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Boot",
	  "I",
	  "Nu",
	  "Nur",
	  "Tu",
	  "Um",
	  "a",
	  "becoose-a",
	  "boot",
	  "bork",
	  "burn",
	  "chuuses",
	  "cumplete-a",
	  "cun",
	  "cunseqooences",
	  "curcoomstunces",
	  "dee",
	  "deeslikes",
	  "denuoonceeng",
	  "desures",
	  "du",
	  "eccuoont",
	  "ectooel",
	  "edfuntege-a",
	  "efueeds",
	  "egeeen",
	  "ell",
	  "ere-a",
	  "feend",
	  "foolt",
	  "frum",
	  "geefe-a",
	  "gesh",
	  "greet",
	  "heem",
	  "heppeeness",
	  "hes",
	  "hoo",
	  "hoomun",
	  "idea",
	  "ifer",
	  "in",
	  "incuoonter",
	  "injuy",
	  "itselff",
	  "ixcept",
	  "ixemple-a",
	  "ixerceese-a",
	  "ixpleeen",
	  "ixplurer",
	  "ixpuoond",
	  "ixtremely",
	  "knoo",
	  "lebureeuoos",
	  "lufes",
	  "meestekee",
	  "mester-booeelder",
	  "moost",
	  "mun",
	  "nu",
	  "nut",
	  "oobteeen",
	  "oocceseeunelly",
	  "ooccoor",
	  "ooff",
	  "oone-a",
	  "oor",
	  "peeen",
	  "peeenffool",
	  "physeecel",
	  "pleesoore-a",
	  "poorsooe-a",
	  "poorsooes",
	  "preeesing",
	  "prucoore-a",
	  "prudooces",
	  "reeght",
	  "reshunelly",
	  "resooltunt",
	  "sume-a",
	  "teecheengs",
	  "teke-a",
	  "thees",
	  "thet",
	  "thuse-a",
	  "treefiel",
	  "troot",
	  "tu",
	  "tueel",
	  "und",
	  "undertekes",
	  "unnuyeeng",
	  "uny",
	  "unyune-a",
	  "us",
	  "veell",
	  "veet",
	  "ves",
	  "vheech",
	  "vhu",
	  "yuoo",
	  "zee",
	  "zeere-a"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Canada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.state = __webpack_require__(2134);
	address.state_abbr = __webpack_require__(2135);
	address.default_country = __webpack_require__(2131);
	address.postcode = __webpack_require__(2133);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alberta",
	  "British Columbia",
	  "Manitoba",
	  "New Brunswick",
	  "Newfoundland and Labrador",
	  "Nova Scotia",
	  "Northwest Territories",
	  "Nunavut",
	  "Ontario",
	  "Prince Edward Island",
	  "Quebec",
	  "Saskatchewan",
	  "Yukon"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AB",
	  "BC",
	  "MB",
	  "NB",
	  "NL",
	  "NS",
	  "NU",
	  "NT",
	  "ON",
	  "PE",
	  "QC",
	  "SK",
	  "YT"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_CA = {};
	module['exports'] = en_CA;
	en_CA.title = "Canada (English)";
	en_CA.address = __webpack_require__(2132);
	en_CA.internet = __webpack_require__(2139);
	en_CA.phone_number = __webpack_require__(2141);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ca",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.ca",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2138);
	internet.domain_suffix = __webpack_require__(2137);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###-####",
	  "(###)###-####",
	  "###.###.####",
	  "1-###-###-####",
	  "###-###-#### x###",
	  "(###)###-#### x###",
	  "1-###-###-#### x###",
	  "###.###.#### x###",
	  "###-###-#### x####",
	  "(###)###-#### x####",
	  "1-###-###-#### x####",
	  "###.###.#### x####",
	  "###-###-#### x#####",
	  "(###)###-#### x#####",
	  "1-###-###-#### x#####",
	  "###.###.#### x#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2140);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire",
	  "Central",
	  "Cheshire",
	  "Cleveland",
	  "Clwyd",
	  "Cornwall",
	  "County Antrim",
	  "County Armagh",
	  "County Down",
	  "County Fermanagh",
	  "County Londonderry",
	  "County Tyrone",
	  "Cumbria",
	  "Derbyshire",
	  "Devon",
	  "Dorset",
	  "Dumfries and Galloway",
	  "Durham",
	  "Dyfed",
	  "East Sussex",
	  "Essex",
	  "Fife",
	  "Gloucestershire",
	  "Grampian",
	  "Greater Manchester",
	  "Gwent",
	  "Gwynedd County",
	  "Hampshire",
	  "Herefordshire",
	  "Hertfordshire",
	  "Highlands and Islands",
	  "Humberside",
	  "Isle of Wight",
	  "Kent",
	  "Lancashire",
	  "Leicestershire",
	  "Lincolnshire",
	  "Lothian",
	  "Merseyside",
	  "Mid Glamorgan",
	  "Norfolk",
	  "North Yorkshire",
	  "Northamptonshire",
	  "Northumberland",
	  "Nottinghamshire",
	  "Oxfordshire",
	  "Powys",
	  "Rutland",
	  "Shropshire",
	  "Somerset",
	  "South Glamorgan",
	  "South Yorkshire",
	  "Staffordshire",
	  "Strathclyde",
	  "Suffolk",
	  "Surrey",
	  "Tayside",
	  "Tyne and Wear",
	  "Warwickshire",
	  "West Glamorgan",
	  "West Midlands",
	  "West Sussex",
	  "West Yorkshire",
	  "Wiltshire",
	  "Worcestershire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "England",
	  "Scotland",
	  "Wales",
	  "Northern Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.county = __webpack_require__(2142);
	address.uk_country = __webpack_require__(2146);
	address.default_country = __webpack_require__(2143);
	address.postcode = __webpack_require__(2145);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "??# #??",
	  "??## #??",
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "England",
	  "Scotland",
	  "Wales",
	  "Northern Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "074## ######",
	  "075## ######",
	  "076## ######",
	  "077## ######",
	  "078## ######",
	  "079## ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2147);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_GB = {};
	module['exports'] = en_GB;
	en_GB.title = "Great Britain (English)";
	en_GB.address = __webpack_require__(2144);
	en_GB.internet = __webpack_require__(2151);
	en_GB.phone_number = __webpack_require__(2153);
	en_GB.cell_phone = __webpack_require__(2148);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "co.uk",
	  "com",
	  "biz",
	  "info",
	  "name"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2150);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01#### #####",
	  "01### ######",
	  "01#1 ### ####",
	  "011# ### ####",
	  "02# #### ####",
	  "03## ### ####",
	  "055 #### ####",
	  "056 #### ####",
	  "0800 ### ####",
	  "08## ### ####",
	  "09## ### ####",
	  "016977 ####",
	  "01### #####",
	  "0500 ######",
	  "0800 ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2152);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Carlow",
	  "Cavan",
	  "Clare",
	  "Cork",
	  "Donegal",
	  "Dublin",
	  "Galway",
	  "Kerry",
	  "Kildare",
	  "Kilkenny",
	  "Laois",
	  "Leitrim",
	  "Limerick",
	  "Longford",
	  "Louth",
	  "Mayo",
	  "Meath",
	  "Monaghan",
	  "Offaly",
	  "Roscommon",
	  "Sligo",
	  "Tipperary",
	  "Waterford",
	  "Westmeath",
	  "Wexford",
	  "Wicklow"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ireland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.county = __webpack_require__(2154);
	address.default_country = __webpack_require__(2155);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "082 ### ####",
	  "083 ### ####",
	  "085 ### ####",
	  "086 ### ####",
	  "087 ### ####",
	  "089 ### ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2157);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_IE = {};
	module['exports'] = en_IE;
	en_IE.title = "Ireland (English)";
	en_IE.address = __webpack_require__(2156);
	en_IE.internet = __webpack_require__(2161);
	en_IE.phone_number = __webpack_require__(2163);
	en_IE.cell_phone = __webpack_require__(2158);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ie",
	  "com",
	  "net",
	  "info",
	  "eu"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2160);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01 #######",
	  "021 #######",
	  "022 #######",
	  "023 #######",
	  "024 #######",
	  "025 #######",
	  "026 #######",
	  "027 #######",
	  "028 #######",
	  "029 #######",
	  "0402 #######",
	  "0404 #######",
	  "041 #######",
	  "042 #######",
	  "043 #######",
	  "044 #######",
	  "045 #######",
	  "046 #######",
	  "047 #######",
	  "049 #######",
	  "0504 #######",
	  "0505 #######",
	  "051 #######",
	  "052 #######",
	  "053 #######",
	  "056 #######",
	  "057 #######",
	  "058 #######",
	  "059 #######",
	  "061 #######",
	  "062 #######",
	  "063 #######",
	  "064 #######",
	  "065 #######",
	  "066 #######",
	  "067 #######",
	  "068 #######",
	  "069 #######",
	  "071 #######",
	  "074 #######",
	  "090 #######",
	  "091 #######",
	  "093 #######",
	  "094 #######",
	  "095 #######",
	  "096 #######",
	  "097 #######",
	  "098 #######",
	  "099 #######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2162);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "India",
	  "Indian Republic",
	  "Bharat",
	  "Hindustan"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(2166);
	address.state = __webpack_require__(2167);
	address.state_abbr = __webpack_require__(2168);
	address.default_country = __webpack_require__(2164);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Andra Pradesh",
	  "Arunachal Pradesh",
	  "Assam",
	  "Bihar",
	  "Chhattisgarh",
	  "Goa",
	  "Gujarat",
	  "Haryana",
	  "Himachal Pradesh",
	  "Jammu and Kashmir",
	  "Jharkhand",
	  "Karnataka",
	  "Kerala",
	  "Madya Pradesh",
	  "Maharashtra",
	  "Manipur",
	  "Meghalaya",
	  "Mizoram",
	  "Nagaland",
	  "Orissa",
	  "Punjab",
	  "Rajasthan",
	  "Sikkim",
	  "Tamil Nadu",
	  "Tripura",
	  "Uttaranchal",
	  "Uttar Pradesh",
	  "West Bengal",
	  "Andaman and Nicobar Islands",
	  "Chandigarh",
	  "Dadar and Nagar Haveli",
	  "Daman and Diu",
	  "Delhi",
	  "Lakshadweep",
	  "Pondicherry"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AP",
	  "AR",
	  "AS",
	  "BR",
	  "CG",
	  "DL",
	  "GA",
	  "GJ",
	  "HR",
	  "HP",
	  "JK",
	  "JS",
	  "KA",
	  "KL",
	  "MP",
	  "MH",
	  "MN",
	  "ML",
	  "MZ",
	  "NL",
	  "OR",
	  "PB",
	  "RJ",
	  "SK",
	  "TN",
	  "TR",
	  "UK",
	  "UP",
	  "WB",
	  "AN",
	  "CH",
	  "DN",
	  "DD",
	  "LD",
	  "PY"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2170);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pvt Ltd",
	  "Limited",
	  "Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_IND = {};
	module['exports'] = en_IND;
	en_IND.title = "India (English)";
	en_IND.name = __webpack_require__(2176);
	en_IND.address = __webpack_require__(2165);
	en_IND.internet = __webpack_require__(2174);
	en_IND.company = __webpack_require__(2169);
	en_IND.phone_number = __webpack_require__(2179);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "in",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org",
	  "co.in"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.co.in",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2173);
	internet.domain_suffix = __webpack_require__(2172);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aadrika",
	  "Aanandinii",
	  "Aaratrika",
	  "Aarya",
	  "Arya",
	  "Aashritha",
	  "Aatmaja",
	  "Atmaja",
	  "Abhaya",
	  "Adwitiya",
	  "Agrata",
	  "Ahilya",
	  "Ahalya",
	  "Aishani",
	  "Akshainie",
	  "Akshata",
	  "Akshita",
	  "Akula",
	  "Ambar",
	  "Amodini",
	  "Amrita",
	  "Amritambu",
	  "Anala",
	  "Anamika",
	  "Ananda",
	  "Anandamayi",
	  "Ananta",
	  "Anila",
	  "Anjali",
	  "Anjushri",
	  "Anjushree",
	  "Annapurna",
	  "Anshula",
	  "Anuja",
	  "Anusuya",
	  "Anasuya",
	  "Anasooya",
	  "Anwesha",
	  "Apsara",
	  "Aruna",
	  "Asha",
	  "Aasa",
	  "Aasha",
	  "Aslesha",
	  "Atreyi",
	  "Atreyee",
	  "Avani",
	  "Abani",
	  "Avantika",
	  "Ayushmati",
	  "Baidehi",
	  "Vaidehi",
	  "Bala",
	  "Baala",
	  "Balamani",
	  "Basanti",
	  "Vasanti",
	  "Bela",
	  "Bhadra",
	  "Bhagirathi",
	  "Bhagwanti",
	  "Bhagwati",
	  "Bhamini",
	  "Bhanumati",
	  "Bhaanumati",
	  "Bhargavi",
	  "Bhavani",
	  "Bhilangana",
	  "Bilwa",
	  "Bilva",
	  "Buddhana",
	  "Chakrika",
	  "Chanda",
	  "Chandi",
	  "Chandni",
	  "Chandini",
	  "Chandani",
	  "Chandra",
	  "Chandira",
	  "Chandrabhaga",
	  "Chandrakala",
	  "Chandrakin",
	  "Chandramani",
	  "Chandrani",
	  "Chandraprabha",
	  "Chandraswaroopa",
	  "Chandravati",
	  "Chapala",
	  "Charumati",
	  "Charvi",
	  "Chatura",
	  "Chitrali",
	  "Chitramala",
	  "Chitrangada",
	  "Daksha",
	  "Dakshayani",
	  "Damayanti",
	  "Darshwana",
	  "Deepali",
	  "Dipali",
	  "Deeptimoyee",
	  "Deeptimayee",
	  "Devangana",
	  "Devani",
	  "Devasree",
	  "Devi",
	  "Daevi",
	  "Devika",
	  "Daevika",
	  "Dhaanyalakshmi",
	  "Dhanalakshmi",
	  "Dhana",
	  "Dhanadeepa",
	  "Dhara",
	  "Dharani",
	  "Dharitri",
	  "Dhatri",
	  "Diksha",
	  "Deeksha",
	  "Divya",
	  "Draupadi",
	  "Dulari",
	  "Durga",
	  "Durgeshwari",
	  "Ekaparnika",
	  "Elakshi",
	  "Enakshi",
	  "Esha",
	  "Eshana",
	  "Eshita",
	  "Gautami",
	  "Gayatri",
	  "Geeta",
	  "Geetanjali",
	  "Gitanjali",
	  "Gemine",
	  "Gemini",
	  "Girja",
	  "Girija",
	  "Gita",
	  "Hamsini",
	  "Harinakshi",
	  "Harita",
	  "Heema",
	  "Himadri",
	  "Himani",
	  "Hiranya",
	  "Indira",
	  "Jaimini",
	  "Jaya",
	  "Jyoti",
	  "Jyotsana",
	  "Kali",
	  "Kalinda",
	  "Kalpana",
	  "Kalyani",
	  "Kama",
	  "Kamala",
	  "Kamla",
	  "Kanchan",
	  "Kanishka",
	  "Kanti",
	  "Kashyapi",
	  "Kumari",
	  "Kumuda",
	  "Lakshmi",
	  "Laxmi",
	  "Lalita",
	  "Lavanya",
	  "Leela",
	  "Lila",
	  "Leela",
	  "Madhuri",
	  "Malti",
	  "Malati",
	  "Mandakini",
	  "Mandaakin",
	  "Mangala",
	  "Mangalya",
	  "Mani",
	  "Manisha",
	  "Manjusha",
	  "Meena",
	  "Mina",
	  "Meenakshi",
	  "Minakshi",
	  "Menka",
	  "Menaka",
	  "Mohana",
	  "Mohini",
	  "Nalini",
	  "Nikita",
	  "Ojaswini",
	  "Omana",
	  "Oormila",
	  "Urmila",
	  "Opalina",
	  "Opaline",
	  "Padma",
	  "Parvati",
	  "Poornima",
	  "Purnima",
	  "Pramila",
	  "Prasanna",
	  "Preity",
	  "Prema",
	  "Priya",
	  "Priyala",
	  "Pushti",
	  "Radha",
	  "Rageswari",
	  "Rageshwari",
	  "Rajinder",
	  "Ramaa",
	  "Rati",
	  "Rita",
	  "Rohana",
	  "Rukhmani",
	  "Rukmin",
	  "Rupinder",
	  "Sanya",
	  "Sarada",
	  "Sharda",
	  "Sarala",
	  "Sarla",
	  "Saraswati",
	  "Sarisha",
	  "Saroja",
	  "Shakti",
	  "Shakuntala",
	  "Shanti",
	  "Sharmila",
	  "Shashi",
	  "Shashikala",
	  "Sheela",
	  "Shivakari",
	  "Shobhana",
	  "Shresth",
	  "Shresthi",
	  "Shreya",
	  "Shreyashi",
	  "Shridevi",
	  "Shrishti",
	  "Shubha",
	  "Shubhaprada",
	  "Siddhi",
	  "Sitara",
	  "Sloka",
	  "Smita",
	  "Smriti",
	  "Soma",
	  "Subhashini",
	  "Subhasini",
	  "Sucheta",
	  "Sudeva",
	  "Sujata",
	  "Sukanya",
	  "Suma",
	  "Suma",
	  "Sumitra",
	  "Sunita",
	  "Suryakantam",
	  "Sushma",
	  "Swara",
	  "Swarnalata",
	  "Sweta",
	  "Shwet",
	  "Tanirika",
	  "Tanushree",
	  "Tanushri",
	  "Tanushri",
	  "Tanya",
	  "Tara",
	  "Trisha",
	  "Uma",
	  "Usha",
	  "Vaijayanti",
	  "Vaijayanthi",
	  "Baijayanti",
	  "Vaishvi",
	  "Vaishnavi",
	  "Vaishno",
	  "Varalakshmi",
	  "Vasudha",
	  "Vasundhara",
	  "Veda",
	  "Vedanshi",
	  "Vidya",
	  "Vimala",
	  "Vrinda",
	  "Vrund",
	  "Aadi",
	  "Aadidev",
	  "Aadinath",
	  "Aaditya",
	  "Aagam",
	  "Aagney",
	  "Aamod",
	  "Aanandaswarup",
	  "Anand Swarup",
	  "Aanjaneya",
	  "Anjaneya",
	  "Aaryan",
	  "Aryan",
	  "Aatmaj",
	  "Aatreya",
	  "Aayushmaan",
	  "Aayushman",
	  "Abhaidev",
	  "Abhaya",
	  "Abhirath",
	  "Abhisyanta",
	  "Acaryatanaya",
	  "Achalesvara",
	  "Acharyanandana",
	  "Acharyasuta",
	  "Achintya",
	  "Achyut",
	  "Adheesh",
	  "Adhiraj",
	  "Adhrit",
	  "Adikavi",
	  "Adinath",
	  "Aditeya",
	  "Aditya",
	  "Adityanandan",
	  "Adityanandana",
	  "Adripathi",
	  "Advaya",
	  "Agasti",
	  "Agastya",
	  "Agneya",
	  "Aagneya",
	  "Agnimitra",
	  "Agniprava",
	  "Agnivesh",
	  "Agrata",
	  "Ajit",
	  "Ajeet",
	  "Akroor",
	  "Akshaj",
	  "Akshat",
	  "Akshayakeerti",
	  "Alok",
	  "Aalok",
	  "Amaranaath",
	  "Amarnath",
	  "Amaresh",
	  "Ambar",
	  "Ameyatma",
	  "Amish",
	  "Amogh",
	  "Amrit",
	  "Anaadi",
	  "Anagh",
	  "Anal",
	  "Anand",
	  "Aanand",
	  "Anang",
	  "Anil",
	  "Anilaabh",
	  "Anilabh",
	  "Anish",
	  "Ankal",
	  "Anunay",
	  "Anurag",
	  "Anuraag",
	  "Archan",
	  "Arindam",
	  "Arjun",
	  "Arnesh",
	  "Arun",
	  "Ashlesh",
	  "Ashok",
	  "Atmanand",
	  "Atmananda",
	  "Avadhesh",
	  "Baalaaditya",
	  "Baladitya",
	  "Baalagopaal",
	  "Balgopal",
	  "Balagopal",
	  "Bahula",
	  "Bakula",
	  "Bala",
	  "Balaaditya",
	  "Balachandra",
	  "Balagovind",
	  "Bandhu",
	  "Bandhul",
	  "Bankim",
	  "Bankimchandra",
	  "Bhadrak",
	  "Bhadraksh",
	  "Bhadran",
	  "Bhagavaan",
	  "Bhagvan",
	  "Bharadwaj",
	  "Bhardwaj",
	  "Bharat",
	  "Bhargava",
	  "Bhasvan",
	  "Bhaasvan",
	  "Bhaswar",
	  "Bhaaswar",
	  "Bhaumik",
	  "Bhaves",
	  "Bheeshma",
	  "Bhisham",
	  "Bhishma",
	  "Bhima",
	  "Bhoj",
	  "Bhramar",
	  "Bhudev",
	  "Bhudeva",
	  "Bhupati",
	  "Bhoopati",
	  "Bhoopat",
	  "Bhupen",
	  "Bhushan",
	  "Bhooshan",
	  "Bhushit",
	  "Bhooshit",
	  "Bhuvanesh",
	  "Bhuvaneshwar",
	  "Bilva",
	  "Bodhan",
	  "Brahma",
	  "Brahmabrata",
	  "Brahmanandam",
	  "Brahmaanand",
	  "Brahmdev",
	  "Brajendra",
	  "Brajesh",
	  "Brijesh",
	  "Birjesh",
	  "Budhil",
	  "Chakor",
	  "Chakradhar",
	  "Chakravartee",
	  "Chakravarti",
	  "Chanakya",
	  "Chaanakya",
	  "Chandak",
	  "Chandan",
	  "Chandra",
	  "Chandraayan",
	  "Chandrabhan",
	  "Chandradev",
	  "Chandraketu",
	  "Chandramauli",
	  "Chandramohan",
	  "Chandran",
	  "Chandranath",
	  "Chapal",
	  "Charak",
	  "Charuchandra",
	  "Chaaruchandra",
	  "Charuvrat",
	  "Chatur",
	  "Chaturaanan",
	  "Chaturbhuj",
	  "Chetan",
	  "Chaten",
	  "Chaitan",
	  "Chetanaanand",
	  "Chidaakaash",
	  "Chidaatma",
	  "Chidambar",
	  "Chidambaram",
	  "Chidananda",
	  "Chinmayanand",
	  "Chinmayananda",
	  "Chiranjeev",
	  "Chiranjeeve",
	  "Chitraksh",
	  "Daiwik",
	  "Daksha",
	  "Damodara",
	  "Dandak",
	  "Dandapaani",
	  "Darshan",
	  "Datta",
	  "Dayaamay",
	  "Dayamayee",
	  "Dayaananda",
	  "Dayaanidhi",
	  "Kin",
	  "Deenabandhu",
	  "Deepan",
	  "Deepankar",
	  "Dipankar",
	  "Deependra",
	  "Dipendra",
	  "Deepesh",
	  "Dipesh",
	  "Deeptanshu",
	  "Deeptendu",
	  "Diptendu",
	  "Deeptiman",
	  "Deeptimoy",
	  "Deeptimay",
	  "Dev",
	  "Deb",
	  "Devadatt",
	  "Devagya",
	  "Devajyoti",
	  "Devak",
	  "Devdan",
	  "Deven",
	  "Devesh",
	  "Deveshwar",
	  "Devi",
	  "Devvrat",
	  "Dhananjay",
	  "Dhanapati",
	  "Dhanpati",
	  "Dhanesh",
	  "Dhanu",
	  "Dhanvin",
	  "Dharmaketu",
	  "Dhruv",
	  "Dhyanesh",
	  "Dhyaneshwar",
	  "Digambar",
	  "Digambara",
	  "Dinakar",
	  "Dinkar",
	  "Dinesh",
	  "Divaakar",
	  "Divakar",
	  "Deevakar",
	  "Divjot",
	  "Dron",
	  "Drona",
	  "Dwaipayan",
	  "Dwaipayana",
	  "Eekalabya",
	  "Ekalavya",
	  "Ekaksh",
	  "Ekaaksh",
	  "Ekaling",
	  "Ekdant",
	  "Ekadant",
	  "Gajaadhar",
	  "Gajadhar",
	  "Gajbaahu",
	  "Gajabahu",
	  "Ganak",
	  "Ganaka",
	  "Ganapati",
	  "Gandharv",
	  "Gandharva",
	  "Ganesh",
	  "Gangesh",
	  "Garud",
	  "Garuda",
	  "Gati",
	  "Gatik",
	  "Gaurang",
	  "Gauraang",
	  "Gauranga",
	  "Gouranga",
	  "Gautam",
	  "Gautama",
	  "Goutam",
	  "Ghanaanand",
	  "Ghanshyam",
	  "Ghanashyam",
	  "Giri",
	  "Girik",
	  "Girika",
	  "Girindra",
	  "Giriraaj",
	  "Giriraj",
	  "Girish",
	  "Gopal",
	  "Gopaal",
	  "Gopi",
	  "Gopee",
	  "Gorakhnath",
	  "Gorakhanatha",
	  "Goswamee",
	  "Goswami",
	  "Gotum",
	  "Gautam",
	  "Govinda",
	  "Gobinda",
	  "Gudakesha",
	  "Gudakesa",
	  "Gurdev",
	  "Guru",
	  "Hari",
	  "Harinarayan",
	  "Harit",
	  "Himadri",
	  "Hiranmay",
	  "Hiranmaya",
	  "Hiranya",
	  "Inder",
	  "Indra",
	  "Indra",
	  "Jagadish",
	  "Jagadisha",
	  "Jagathi",
	  "Jagdeep",
	  "Jagdish",
	  "Jagmeet",
	  "Jahnu",
	  "Jai",
	  "Javas",
	  "Jay",
	  "Jitendra",
	  "Jitender",
	  "Jyotis",
	  "Kailash",
	  "Kama",
	  "Kamalesh",
	  "Kamlesh",
	  "Kanak",
	  "Kanaka",
	  "Kannan",
	  "Kannen",
	  "Karan",
	  "Karthik",
	  "Kartik",
	  "Karunanidhi",
	  "Kashyap",
	  "Kiran",
	  "Kirti",
	  "Keerti",
	  "Krishna",
	  "Krishnadas",
	  "Krishnadasa",
	  "Kumar",
	  "Lai",
	  "Lakshman",
	  "Laxman",
	  "Lakshmidhar",
	  "Lakshminath",
	  "Lal",
	  "Laal",
	  "Mahendra",
	  "Mohinder",
	  "Mahesh",
	  "Maheswar",
	  "Mani",
	  "Manik",
	  "Manikya",
	  "Manoj",
	  "Marut",
	  "Mayoor",
	  "Meghnad",
	  "Meghnath",
	  "Mohan",
	  "Mukesh",
	  "Mukul",
	  "Nagabhushanam",
	  "Nanda",
	  "Narayan",
	  "Narendra",
	  "Narinder",
	  "Naveen",
	  "Navin",
	  "Nawal",
	  "Naval",
	  "Nimit",
	  "Niranjan",
	  "Nirbhay",
	  "Niro",
	  "Param",
	  "Paramartha",
	  "Pran",
	  "Pranay",
	  "Prasad",
	  "Prathamesh",
	  "Prayag",
	  "Prem",
	  "Puneet",
	  "Purushottam",
	  "Rahul",
	  "Raj",
	  "Rajan",
	  "Rajendra",
	  "Rajinder",
	  "Rajiv",
	  "Rakesh",
	  "Ramesh",
	  "Rameshwar",
	  "Ranjit",
	  "Ranjeet",
	  "Ravi",
	  "Ritesh",
	  "Rohan",
	  "Rohit",
	  "Rudra",
	  "Sachin",
	  "Sameer",
	  "Samir",
	  "Sanjay",
	  "Sanka",
	  "Sarvin",
	  "Satish",
	  "Satyen",
	  "Shankar",
	  "Shantanu",
	  "Shashi",
	  "Sher",
	  "Shiv",
	  "Siddarth",
	  "Siddhran",
	  "Som",
	  "Somu",
	  "Somnath",
	  "Subhash",
	  "Subodh",
	  "Suman",
	  "Suresh",
	  "Surya",
	  "Suryakant",
	  "Suryakanta",
	  "Sushil",
	  "Susheel",
	  "Swami",
	  "Swapnil",
	  "Tapan",
	  "Tara",
	  "Tarun",
	  "Tej",
	  "Tejas",
	  "Trilochan",
	  "Trilochana",
	  "Trilok",
	  "Trilokesh",
	  "Triloki",
	  "Triloki Nath",
	  "Trilokanath",
	  "Tushar",
	  "Udai",
	  "Udit",
	  "Ujjawal",
	  "Ujjwal",
	  "Umang",
	  "Upendra",
	  "Uttam",
	  "Vasudev",
	  "Vasudeva",
	  "Vedang",
	  "Vedanga",
	  "Vidhya",
	  "Vidur",
	  "Vidhur",
	  "Vijay",
	  "Vimal",
	  "Vinay",
	  "Vishnu",
	  "Bishnu",
	  "Vishwamitra",
	  "Vyas",
	  "Yogendra",
	  "Yoginder",
	  "Yogesh"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2175);
	name.last_name = __webpack_require__(2177);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abbott",
	  "Achari",
	  "Acharya",
	  "Adiga",
	  "Agarwal",
	  "Ahluwalia",
	  "Ahuja",
	  "Arora",
	  "Asan",
	  "Bandopadhyay",
	  "Banerjee",
	  "Bharadwaj",
	  "Bhat",
	  "Butt",
	  "Bhattacharya",
	  "Bhattathiri",
	  "Chaturvedi",
	  "Chattopadhyay",
	  "Chopra",
	  "Desai",
	  "Deshpande",
	  "Devar",
	  "Dhawan",
	  "Dubashi",
	  "Dutta",
	  "Dwivedi",
	  "Embranthiri",
	  "Ganaka",
	  "Gandhi",
	  "Gill",
	  "Gowda",
	  "Guha",
	  "Guneta",
	  "Gupta",
	  "Iyer",
	  "Iyengar",
	  "Jain",
	  "Jha",
	  "Johar",
	  "Joshi",
	  "Kakkar",
	  "Kaniyar",
	  "Kapoor",
	  "Kaul",
	  "Kaur",
	  "Khan",
	  "Khanna",
	  "Khatri",
	  "Kocchar",
	  "Mahajan",
	  "Malik",
	  "Marar",
	  "Menon",
	  "Mehra",
	  "Mehrotra",
	  "Mishra",
	  "Mukhopadhyay",
	  "Nayar",
	  "Naik",
	  "Nair",
	  "Nambeesan",
	  "Namboothiri",
	  "Nehru",
	  "Pandey",
	  "Panicker",
	  "Patel",
	  "Patil",
	  "Pilla",
	  "Pillai",
	  "Pothuvaal",
	  "Prajapat",
	  "Rana",
	  "Reddy",
	  "Saini",
	  "Sethi",
	  "Shah",
	  "Sharma",
	  "Shukla",
	  "Singh",
	  "Sinha",
	  "Somayaji",
	  "Tagore",
	  "Talwar",
	  "Tandon",
	  "Trivedi",
	  "Varrier",
	  "Varma",
	  "Varman",
	  "Verma"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+91###-###-####",
	  "+91##########",
	  "+91-###-#######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2178);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "United States",
	  "United States of America",
	  "USA"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.default_country = __webpack_require__(2180);
	address.postcode_by_state = __webpack_require__(2182);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "AL": "350##",
	  "AK": "995##",
	  "AS": "967##",
	  "AZ": "850##",
	  "AR": "717##",
	  "CA": "900##",
	  "CO": "800##",
	  "CT": "061##",
	  "DC": "204##",
	  "DE": "198##",
	  "FL": "322##",
	  "GA": "301##",
	  "HI": "967##",
	  "ID": "832##",
	  "IL": "600##",
	  "IN": "463##",
	  "IA": "510##",
	  "KS": "666##",
	  "KY": "404##",
	  "LA": "701##",
	  "ME": "042##",
	  "MD": "210##",
	  "MA": "026##",
	  "MI": "480##",
	  "MN": "555##",
	  "MS": "387##",
	  "MO": "650##",
	  "MT": "590##",
	  "NE": "688##",
	  "NV": "898##",
	  "NH": "036##",
	  "NJ": "076##",
	  "NM": "880##",
	  "NY": "122##",
	  "NC": "288##",
	  "ND": "586##",
	  "OH": "444##",
	  "OK": "730##",
	  "OR": "979##",
	  "PA": "186##",
	  "RI": "029##",
	  "SC": "299##",
	  "SD": "577##",
	  "TN": "383##",
	  "TX": "798##",
	  "UT": "847##",
	  "VT": "050##",
	  "VA": "222##",
	  "WA": "990##",
	  "WV": "247##",
	  "WI": "549##",
	  "WY": "831##"
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_US = {};
	module['exports'] = en_US;
	en_US.title = "United States (English)";
	en_US.internet = __webpack_require__(2185);
	en_US.address = __webpack_require__(2181);
	en_US.phone_number = __webpack_require__(2188);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "us",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2184);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "201",
	  "202",
	  "203",
	  "205",
	  "206",
	  "207",
	  "208",
	  "209",
	  "210",
	  "212",
	  "213",
	  "214",
	  "215",
	  "216",
	  "217",
	  "218",
	  "219",
	  "224",
	  "225",
	  "227",
	  "228",
	  "229",
	  "231",
	  "234",
	  "239",
	  "240",
	  "248",
	  "251",
	  "252",
	  "253",
	  "254",
	  "256",
	  "260",
	  "262",
	  "267",
	  "269",
	  "270",
	  "276",
	  "281",
	  "283",
	  "301",
	  "302",
	  "303",
	  "304",
	  "305",
	  "307",
	  "308",
	  "309",
	  "310",
	  "312",
	  "313",
	  "314",
	  "315",
	  "316",
	  "317",
	  "318",
	  "319",
	  "320",
	  "321",
	  "323",
	  "330",
	  "331",
	  "334",
	  "336",
	  "337",
	  "339",
	  "347",
	  "351",
	  "352",
	  "360",
	  "361",
	  "386",
	  "401",
	  "402",
	  "404",
	  "405",
	  "406",
	  "407",
	  "408",
	  "409",
	  "410",
	  "412",
	  "413",
	  "414",
	  "415",
	  "417",
	  "419",
	  "423",
	  "424",
	  "425",
	  "434",
	  "435",
	  "440",
	  "443",
	  "445",
	  "464",
	  "469",
	  "470",
	  "475",
	  "478",
	  "479",
	  "480",
	  "484",
	  "501",
	  "502",
	  "503",
	  "504",
	  "505",
	  "507",
	  "508",
	  "509",
	  "510",
	  "512",
	  "513",
	  "515",
	  "516",
	  "517",
	  "518",
	  "520",
	  "530",
	  "540",
	  "541",
	  "551",
	  "557",
	  "559",
	  "561",
	  "562",
	  "563",
	  "564",
	  "567",
	  "570",
	  "571",
	  "573",
	  "574",
	  "580",
	  "585",
	  "586",
	  "601",
	  "602",
	  "603",
	  "605",
	  "606",
	  "607",
	  "608",
	  "609",
	  "610",
	  "612",
	  "614",
	  "615",
	  "616",
	  "617",
	  "618",
	  "619",
	  "620",
	  "623",
	  "626",
	  "630",
	  "631",
	  "636",
	  "641",
	  "646",
	  "650",
	  "651",
	  "660",
	  "661",
	  "662",
	  "667",
	  "678",
	  "682",
	  "701",
	  "702",
	  "703",
	  "704",
	  "706",
	  "707",
	  "708",
	  "712",
	  "713",
	  "714",
	  "715",
	  "716",
	  "717",
	  "718",
	  "719",
	  "720",
	  "724",
	  "727",
	  "731",
	  "732",
	  "734",
	  "737",
	  "740",
	  "754",
	  "757",
	  "760",
	  "763",
	  "765",
	  "770",
	  "772",
	  "773",
	  "774",
	  "775",
	  "781",
	  "785",
	  "786",
	  "801",
	  "802",
	  "803",
	  "804",
	  "805",
	  "806",
	  "808",
	  "810",
	  "812",
	  "813",
	  "814",
	  "815",
	  "816",
	  "817",
	  "818",
	  "828",
	  "830",
	  "831",
	  "832",
	  "835",
	  "843",
	  "845",
	  "847",
	  "848",
	  "850",
	  "856",
	  "857",
	  "858",
	  "859",
	  "860",
	  "862",
	  "863",
	  "864",
	  "865",
	  "870",
	  "872",
	  "878",
	  "901",
	  "903",
	  "904",
	  "906",
	  "907",
	  "908",
	  "909",
	  "910",
	  "912",
	  "913",
	  "914",
	  "915",
	  "916",
	  "917",
	  "918",
	  "919",
	  "920",
	  "925",
	  "928",
	  "931",
	  "936",
	  "937",
	  "940",
	  "941",
	  "947",
	  "949",
	  "952",
	  "954",
	  "956",
	  "959",
	  "970",
	  "971",
	  "972",
	  "973",
	  "975",
	  "978",
	  "979",
	  "980",
	  "984",
	  "985",
	  "989"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "201",
	  "202",
	  "203",
	  "205",
	  "206",
	  "207",
	  "208",
	  "209",
	  "210",
	  "212",
	  "213",
	  "214",
	  "215",
	  "216",
	  "217",
	  "218",
	  "219",
	  "224",
	  "225",
	  "227",
	  "228",
	  "229",
	  "231",
	  "234",
	  "239",
	  "240",
	  "248",
	  "251",
	  "252",
	  "253",
	  "254",
	  "256",
	  "260",
	  "262",
	  "267",
	  "269",
	  "270",
	  "276",
	  "281",
	  "283",
	  "301",
	  "302",
	  "303",
	  "304",
	  "305",
	  "307",
	  "308",
	  "309",
	  "310",
	  "312",
	  "313",
	  "314",
	  "315",
	  "316",
	  "317",
	  "318",
	  "319",
	  "320",
	  "321",
	  "323",
	  "330",
	  "331",
	  "334",
	  "336",
	  "337",
	  "339",
	  "347",
	  "351",
	  "352",
	  "360",
	  "361",
	  "386",
	  "401",
	  "402",
	  "404",
	  "405",
	  "406",
	  "407",
	  "408",
	  "409",
	  "410",
	  "412",
	  "413",
	  "414",
	  "415",
	  "417",
	  "419",
	  "423",
	  "424",
	  "425",
	  "434",
	  "435",
	  "440",
	  "443",
	  "445",
	  "464",
	  "469",
	  "470",
	  "475",
	  "478",
	  "479",
	  "480",
	  "484",
	  "501",
	  "502",
	  "503",
	  "504",
	  "505",
	  "507",
	  "508",
	  "509",
	  "510",
	  "512",
	  "513",
	  "515",
	  "516",
	  "517",
	  "518",
	  "520",
	  "530",
	  "540",
	  "541",
	  "551",
	  "557",
	  "559",
	  "561",
	  "562",
	  "563",
	  "564",
	  "567",
	  "570",
	  "571",
	  "573",
	  "574",
	  "580",
	  "585",
	  "586",
	  "601",
	  "602",
	  "603",
	  "605",
	  "606",
	  "607",
	  "608",
	  "609",
	  "610",
	  "612",
	  "614",
	  "615",
	  "616",
	  "617",
	  "618",
	  "619",
	  "620",
	  "623",
	  "626",
	  "630",
	  "631",
	  "636",
	  "641",
	  "646",
	  "650",
	  "651",
	  "660",
	  "661",
	  "662",
	  "667",
	  "678",
	  "682",
	  "701",
	  "702",
	  "703",
	  "704",
	  "706",
	  "707",
	  "708",
	  "712",
	  "713",
	  "714",
	  "715",
	  "716",
	  "717",
	  "718",
	  "719",
	  "720",
	  "724",
	  "727",
	  "731",
	  "732",
	  "734",
	  "737",
	  "740",
	  "754",
	  "757",
	  "760",
	  "763",
	  "765",
	  "770",
	  "772",
	  "773",
	  "774",
	  "775",
	  "781",
	  "785",
	  "786",
	  "801",
	  "802",
	  "803",
	  "804",
	  "805",
	  "806",
	  "808",
	  "810",
	  "812",
	  "813",
	  "814",
	  "815",
	  "816",
	  "817",
	  "818",
	  "828",
	  "830",
	  "831",
	  "832",
	  "835",
	  "843",
	  "845",
	  "847",
	  "848",
	  "850",
	  "856",
	  "857",
	  "858",
	  "859",
	  "860",
	  "862",
	  "863",
	  "864",
	  "865",
	  "870",
	  "872",
	  "878",
	  "901",
	  "903",
	  "904",
	  "906",
	  "907",
	  "908",
	  "909",
	  "910",
	  "912",
	  "913",
	  "914",
	  "915",
	  "916",
	  "917",
	  "918",
	  "919",
	  "920",
	  "925",
	  "928",
	  "931",
	  "936",
	  "937",
	  "940",
	  "941",
	  "947",
	  "949",
	  "952",
	  "954",
	  "956",
	  "959",
	  "970",
	  "971",
	  "972",
	  "973",
	  "975",
	  "978",
	  "979",
	  "980",
	  "984",
	  "985",
	  "989"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.area_code = __webpack_require__(2186);
	phone_number.exchange_code = __webpack_require__(2187);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bondi",
	  "Burleigh Heads",
	  "Carlton",
	  "Fitzroy",
	  "Fremantle",
	  "Glenelg",
	  "Manly",
	  "Noosa",
	  "Stones Corner",
	  "St Kilda",
	  "Surry Hills",
	  "Yarra Valley"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Australia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.street_root = __webpack_require__(2199);
	address.street_name = __webpack_require__(2198);
	address.city_prefix = __webpack_require__(2191);
	address.city = __webpack_require__(2190);
	address.state_abbr = __webpack_require__(2197);
	address.region = __webpack_require__(2195);
	address.state = __webpack_require__(2196);
	address.postcode = __webpack_require__(2194);
	address.building_number = __webpack_require__(2189);
	address.street_suffix = __webpack_require__(2200);
	address.default_country = __webpack_require__(2192);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0###",
	  "2###",
	  "3###",
	  "4###",
	  "5###",
	  "6###",
	  "7###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "South East Queensland",
	  "Wide Bay Burnett",
	  "Margaret River",
	  "Port Pirie",
	  "Gippsland",
	  "Elizabeth",
	  "Barossa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "New South Wales",
	  "Queensland",
	  "Northern Territory",
	  "South Australia",
	  "Western Australia",
	  "Tasmania",
	  "Australian Capital Territory",
	  "Victoria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "NSW",
	  "QLD",
	  "NT",
	  "SA",
	  "WA",
	  "TAS",
	  "ACT",
	  "VIC"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ramsay Street",
	  "Bonnie Doon",
	  "Cavill Avenue",
	  "Queen Street"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avenue",
	  "Boulevard",
	  "Circle",
	  "Circuit",
	  "Court",
	  "Crescent",
	  "Crest",
	  "Drive",
	  "Estate Dr",
	  "Grove",
	  "Hill",
	  "Island",
	  "Junction",
	  "Knoll",
	  "Lane",
	  "Loop",
	  "Mall",
	  "Manor",
	  "Meadow",
	  "Mews",
	  "Parade",
	  "Parkway",
	  "Pass",
	  "Place",
	  "Plaza",
	  "Ridge",
	  "Road",
	  "Run",
	  "Square",
	  "Station St",
	  "Street",
	  "Summit",
	  "Terrace",
	  "Track",
	  "Trail",
	  "View Rd",
	  "Way"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2202);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pty Ltd",
	  "and Sons",
	  "Corp",
	  "Group",
	  "Brothers",
	  "Partners"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var en_au_ocker = {};
	module['exports'] = en_au_ocker;
	en_au_ocker.title = "Australia Ocker (English)";
	en_au_ocker.name = __webpack_require__(2207);
	en_au_ocker.company = __webpack_require__(2201);
	en_au_ocker.internet = __webpack_require__(2205);
	en_au_ocker.address = __webpack_require__(2193);
	en_au_ocker.phone_number = __webpack_require__(2211);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.au",
	  "com",
	  "net.au",
	  "net",
	  "org.au",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2204);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Charlotte",
	  "Ava",
	  "Chloe",
	  "Emily",
	  "Olivia",
	  "Zoe",
	  "Lily",
	  "Sophie",
	  "Amelia",
	  "Sofia",
	  "Ella",
	  "Isabella",
	  "Ruby",
	  "Sienna",
	  "Mia+3",
	  "Grace",
	  "Emma",
	  "Ivy",
	  "Layla",
	  "Abigail",
	  "Isla",
	  "Hannah",
	  "Zara",
	  "Lucy",
	  "Evie",
	  "Annabelle",
	  "Madison",
	  "Alice",
	  "Georgia",
	  "Maya",
	  "Madeline",
	  "Audrey",
	  "Scarlett",
	  "Isabelle",
	  "Chelsea",
	  "Mila",
	  "Holly",
	  "Indiana",
	  "Poppy",
	  "Harper",
	  "Sarah",
	  "Alyssa",
	  "Jasmine",
	  "Imogen",
	  "Hayley",
	  "Pheobe",
	  "Eva",
	  "Evelyn",
	  "Mackenzie",
	  "Ayla",
	  "Oliver",
	  "Jack",
	  "Jackson",
	  "William",
	  "Ethan",
	  "Charlie",
	  "Lucas",
	  "Cooper",
	  "Lachlan",
	  "Noah",
	  "Liam",
	  "Alexander",
	  "Max",
	  "Isaac",
	  "Thomas",
	  "Xavier",
	  "Oscar",
	  "Benjamin",
	  "Aiden",
	  "Mason",
	  "Samuel",
	  "James",
	  "Levi",
	  "Riley",
	  "Harrison",
	  "Ryan",
	  "Henry",
	  "Jacob",
	  "Joshua",
	  "Leo",
	  "Zach",
	  "Harry",
	  "Hunter",
	  "Flynn",
	  "Archie",
	  "Tyler",
	  "Elijah",
	  "Hayden",
	  "Jayden",
	  "Blake",
	  "Archer",
	  "Ashton",
	  "Sebastian",
	  "Zachery",
	  "Lincoln",
	  "Mitchell",
	  "Luca",
	  "Nathan",
	  "Kai",
	  "Connor",
	  "Tom",
	  "Nigel",
	  "Matt",
	  "Sean"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2206);
	name.last_name = __webpack_require__(2208);
	name.ocker_first_name = __webpack_require__(2209);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Smith",
	  "Jones",
	  "Williams",
	  "Brown",
	  "Wilson",
	  "Taylor",
	  "Morton",
	  "White",
	  "Martin",
	  "Anderson",
	  "Thompson",
	  "Nguyen",
	  "Thomas",
	  "Walker",
	  "Harris",
	  "Lee",
	  "Ryan",
	  "Robinson",
	  "Kelly",
	  "King",
	  "Rausch",
	  "Ridge",
	  "Connolly",
	  "LeQuesne"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bazza",
	  "Bluey",
	  "Davo",
	  "Johno",
	  "Shano",
	  "Shazza"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0# #### ####",
	  "+61 # #### ####",
	  "04## ### ###",
	  "+61 4## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2210);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  " s/n.",
	  ", #",
	  ", ##",
	  " #",
	  " ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Parla",
	  "Telde",
	  "Baracaldo",
	  "San Fernando",
	  "Torrevieja",
	  "Lugo",
	  "Santiago de Compostela",
	  "Gerona",
	  "Cáceres",
	  "Lorca",
	  "Coslada",
	  "Talavera de la Reina",
	  "El Puerto de Santa María",
	  "Cornellá de Llobregat",
	  "Avilés",
	  "Palencia",
	  "Gecho",
	  "Orihuela",
	  "Pontevedra",
	  "Pozuelo de Alarcón",
	  "Toledo",
	  "El Ejido",
	  "Guadalajara",
	  "Gandía",
	  "Ceuta",
	  "Ferrol",
	  "Chiclana de la Frontera",
	  "Manresa",
	  "Roquetas de Mar",
	  "Ciudad Real",
	  "Rubí",
	  "Benidorm",
	  "San Sebastían de los Reyes",
	  "Ponferrada",
	  "Zamora",
	  "Alcalá de Guadaira",
	  "Fuengirola",
	  "Mijas",
	  "Sanlúcar de Barrameda",
	  "La Línea de la Concepción",
	  "Majadahonda",
	  "Sagunto",
	  "El Prat de LLobregat",
	  "Viladecans",
	  "Linares",
	  "Alcoy",
	  "Irún",
	  "Estepona",
	  "Torremolinos",
	  "Rivas-Vaciamadrid",
	  "Molina de Segura",
	  "Paterna",
	  "Granollers",
	  "Santa Lucía de Tirajana",
	  "Motril",
	  "Cerdañola del Vallés",
	  "Arrecife",
	  "Segovia",
	  "Torrelavega",
	  "Elda",
	  "Mérida",
	  "Ávila",
	  "Valdemoro",
	  "Cuenta",
	  "Collado Villalba",
	  "Benalmádena",
	  "Mollet del Vallés",
	  "Puertollano",
	  "Madrid",
	  "Barcelona",
	  "Valencia",
	  "Sevilla",
	  "Zaragoza",
	  "Málaga",
	  "Murcia",
	  "Palma de Mallorca",
	  "Las Palmas de Gran Canaria",
	  "Bilbao",
	  "Córdoba",
	  "Alicante",
	  "Valladolid",
	  "Vigo",
	  "Gijón",
	  "Hospitalet de LLobregat",
	  "La Coruña",
	  "Granada",
	  "Vitoria",
	  "Elche",
	  "Santa Cruz de Tenerife",
	  "Oviedo",
	  "Badalona",
	  "Cartagena",
	  "Móstoles",
	  "Jerez de la Frontera",
	  "Tarrasa",
	  "Sabadell",
	  "Alcalá de Henares",
	  "Pamplona",
	  "Fuenlabrada",
	  "Almería",
	  "San Sebastián",
	  "Leganés",
	  "Santander",
	  "Burgos",
	  "Castellón de la Plana",
	  "Alcorcón",
	  "Albacete",
	  "Getafe",
	  "Salamanca",
	  "Huelva",
	  "Logroño",
	  "Badajoz",
	  "San Cristróbal de la Laguna",
	  "León",
	  "Tarragona",
	  "Cádiz",
	  "Lérida",
	  "Marbella",
	  "Mataró",
	  "Dos Hermanas",
	  "Santa Coloma de Gramanet",
	  "Jaén",
	  "Algeciras",
	  "Torrejón de Ardoz",
	  "Orense",
	  "Alcobendas",
	  "Reus",
	  "Calahorra",
	  "Inca"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistán",
	  "Albania",
	  "Argelia",
	  "Andorra",
	  "Angola",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbayán",
	  "Bahamas",
	  "Barein",
	  "Bangladesh",
	  "Barbados",
	  "Bielorusia",
	  "Bélgica",
	  "Belice",
	  "Bermuda",
	  "Bután",
	  "Bolivia",
	  "Bosnia Herzegovina",
	  "Botswana",
	  "Brasil",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Camboya",
	  "Camerún",
	  "Canada",
	  "Cabo Verde",
	  "Islas Caimán",
	  "Chad",
	  "Chile",
	  "China",
	  "Isla de Navidad",
	  "Colombia",
	  "Comodos",
	  "Congo",
	  "Costa Rica",
	  "Costa de Marfil",
	  "Croacia",
	  "Cuba",
	  "Chipre",
	  "República Checa",
	  "Dinamarca",
	  "Dominica",
	  "República Dominicana",
	  "Ecuador",
	  "Egipto",
	  "El Salvador",
	  "Guinea Ecuatorial",
	  "Eritrea",
	  "Estonia",
	  "Etiopía",
	  "Islas Faro",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Gabón",
	  "Gambia",
	  "Georgia",
	  "Alemania",
	  "Ghana",
	  "Grecia",
	  "Groenlandia",
	  "Granada",
	  "Guadalupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bisau",
	  "Guayana",
	  "Haiti",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Islandia",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Irak",
	  "Irlanda",
	  "Italia",
	  "Jamaica",
	  "Japón",
	  "Jordania",
	  "Kazajistan",
	  "Kenia",
	  "Kiribati",
	  "Corea",
	  "Kuwait",
	  "Letonia",
	  "Líbano",
	  "Liberia",
	  "Liechtenstein",
	  "Lituania",
	  "Luxemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malasia",
	  "Maldivas",
	  "Mali",
	  "Malta",
	  "Martinica",
	  "Mauritania",
	  "Méjico",
	  "Micronesia",
	  "Moldavia",
	  "Mónaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marruecos",
	  "Mozambique",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Holanda",
	  "Nueva Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Noruega",
	  "Omán",
	  "Pakistan",
	  "Panamá",
	  "Papúa Nueva Guinea",
	  "Paraguay",
	  "Perú",
	  "Filipinas",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Rusia",
	  "Ruanda",
	  "Samoa",
	  "San Marino",
	  "Santo Tomé y Principe",
	  "Arabia Saudí",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leona",
	  "Singapur",
	  "Eslovaquia",
	  "Eslovenia",
	  "Somalia",
	  "España",
	  "Sri Lanka",
	  "Sudán",
	  "Suriname",
	  "Suecia",
	  "Suiza",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tonga",
	  "Trinidad y Tobago",
	  "Tunez",
	  "Turquia",
	  "Uganda",
	  "Ucrania",
	  "Emiratos Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos de América",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "España"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2214);
	address.country = __webpack_require__(2215);
	address.building_number = __webpack_require__(2212);
	address.street_suffix = __webpack_require__(2225);
	address.secondary_address = __webpack_require__(2220);
	address.postcode = __webpack_require__(2218);
	address.province = __webpack_require__(2219);
	address.state = __webpack_require__(2221);
	address.state_abbr = __webpack_require__(2222);
	address.time_zone = __webpack_require__(2226);
	address.city = __webpack_require__(2213);
	address.street_name = __webpack_require__(2224);
	address.street_address = __webpack_require__(2223);
	address.default_country = __webpack_require__(2216);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Álava",
	  "Albacete",
	  "Alicante",
	  "Almería",
	  "Asturias",
	  "Ávila",
	  "Badajoz",
	  "Barcelona",
	  "Burgos",
	  "Cantabria",
	  "Castellón",
	  "Ciudad Real",
	  "Cuenca",
	  "Cáceres",
	  "Cádiz",
	  "Córdoba",
	  "Gerona",
	  "Granada",
	  "Guadalajara",
	  "Guipúzcoa",
	  "Huelva",
	  "Huesca",
	  "Islas Baleares",
	  "Jaén",
	  "La Coruña",
	  "La Rioja",
	  "Las Palmas",
	  "León",
	  "Lugo",
	  "lérida",
	  "Madrid",
	  "Murcia",
	  "Málaga",
	  "Navarra",
	  "Orense",
	  "Palencia",
	  "Pontevedra",
	  "Salamanca",
	  "Santa Cruz de Tenerife",
	  "Segovia",
	  "Sevilla",
	  "Soria",
	  "Tarragona",
	  "Teruel",
	  "Toledo",
	  "Valencia",
	  "Valladolid",
	  "Vizcaya",
	  "Zamora",
	  "Zaragoza"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Esc. ###",
	  "Puerta ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Andalucía",
	  "Aragón",
	  "Principado de Asturias",
	  "Baleares",
	  "Canarias",
	  "Cantabria",
	  "Castilla-La Mancha",
	  "Castilla y León",
	  "Cataluña",
	  "Comunidad Valenciana",
	  "Extremadura",
	  "Galicia",
	  "La Rioja",
	  "Comunidad de Madrid",
	  "Navarra",
	  "País Vasco",
	  "Región de Murcia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "And",
	  "Ara",
	  "Ast",
	  "Bal",
	  "Can",
	  "Cbr",
	  "Man",
	  "Leo",
	  "Cat",
	  "Com",
	  "Ext",
	  "Gal",
	  "Rio",
	  "Mad",
	  "Nav",
	  "Vas",
	  "Mur"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}",
	  "#{street_name}#{building_number} #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.first_name} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aldea",
	  "Apartamento",
	  "Arrabal",
	  "Arroyo",
	  "Avenida",
	  "Bajada",
	  "Barranco",
	  "Barrio",
	  "Bloque",
	  "Calle",
	  "Calleja",
	  "Camino",
	  "Carretera",
	  "Caserio",
	  "Colegio",
	  "Colonia",
	  "Conjunto",
	  "Cuesta",
	  "Chalet",
	  "Edificio",
	  "Entrada",
	  "Escalinata",
	  "Explanada",
	  "Extramuros",
	  "Extrarradio",
	  "Ferrocarril",
	  "Glorieta",
	  "Gran Subida",
	  "Grupo",
	  "Huerta",
	  "Jardines",
	  "Lado",
	  "Lugar",
	  "Manzana",
	  "Masía",
	  "Mercado",
	  "Monte",
	  "Muelle",
	  "Municipio",
	  "Parcela",
	  "Parque",
	  "Partida",
	  "Pasaje",
	  "Paseo",
	  "Plaza",
	  "Poblado",
	  "Polígono",
	  "Prolongación",
	  "Puente",
	  "Puerta",
	  "Quinta",
	  "Ramal",
	  "Rambla",
	  "Rampa",
	  "Riera",
	  "Rincón",
	  "Ronda",
	  "Rua",
	  "Salida",
	  "Sector",
	  "Sección",
	  "Senda",
	  "Solar",
	  "Subida",
	  "Terrenos",
	  "Torrente",
	  "Travesía",
	  "Urbanización",
	  "Vía",
	  "Vía Pública"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacífico/Midway",
	  "Pacífico/Pago_Pago",
	  "Pacífico/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europa/Dublin",
	  "Europa/London",
	  "Europa/Lisbon",
	  "Europa/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europa/Belgrade",
	  "Europa/Bratislava",
	  "Europa/Budapest",
	  "Europa/Ljubljana",
	  "Europa/Prague",
	  "Europa/Sarajevo",
	  "Europa/Skopje",
	  "Europa/Warsaw",
	  "Europa/Zagreb",
	  "Europa/Brussels",
	  "Europa/Copenhagen",
	  "Europa/Madrid",
	  "Europa/Paris",
	  "Europa/Amsterdam",
	  "Europa/Berlin",
	  "Europa/Berlin",
	  "Europa/Rome",
	  "Europa/Stockholm",
	  "Europa/Vienna",
	  "Africa/Algiers",
	  "Europa/Bucharest",
	  "Africa/Cairo",
	  "Europa/Helsinki",
	  "Europa/Kiev",
	  "Europa/Riga",
	  "Europa/Sofia",
	  "Europa/Tallinn",
	  "Europa/Vilnius",
	  "Europa/Athens",
	  "Europa/Istanbul",
	  "Europa/Minsk",
	  "Asia/Jerusalen",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacífico/Guam",
	  "Pacífico/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacífico/Noumea",
	  "Pacífico/Fiji",
	  "Asia/Kamchatka",
	  "Pacífico/Majuro",
	  "Pacífico/Auckland",
	  "Pacífico/Auckland",
	  "Pacífico/Tongatapu",
	  "Pacífico/Fakaofo",
	  "Pacífico/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "6##-###-###",
	  "6##.###.###",
	  "6## ### ###",
	  "6########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2227);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptativo",
	  "Avanzado",
	  "Asimilado",
	  "Automatizado",
	  "Equilibrado",
	  "Centrado en el negocio",
	  "Centralizado",
	  "Clonado",
	  "Compatible",
	  "Configurable",
	  "Multi grupo",
	  "Multi plataforma",
	  "Centrado en el usuario",
	  "Configurable",
	  "Descentralizado",
	  "Digitalizado",
	  "Distribuido",
	  "Diverso",
	  "Reducido",
	  "Mejorado",
	  "Para toda la empresa",
	  "Ergonomico",
	  "Exclusivo",
	  "Expandido",
	  "Extendido",
	  "Cara a cara",
	  "Enfocado",
	  "Totalmente configurable",
	  "Fundamental",
	  "Orígenes",
	  "Horizontal",
	  "Implementado",
	  "Innovador",
	  "Integrado",
	  "Intuitivo",
	  "Inverso",
	  "Gestionado",
	  "Obligatorio",
	  "Monitorizado",
	  "Multi canal",
	  "Multi lateral",
	  "Multi capa",
	  "En red",
	  "Orientado a objetos",
	  "Open-source",
	  "Operativo",
	  "Optimizado",
	  "Opcional",
	  "Organico",
	  "Organizado",
	  "Perseverando",
	  "Persistente",
	  "en fases",
	  "Polarizado",
	  "Pre-emptivo",
	  "Proactivo",
	  "Enfocado a benficios",
	  "Profundo",
	  "Programable",
	  "Progresivo",
	  "Public-key",
	  "Enfocado en la calidad",
	  "Reactivo",
	  "Realineado",
	  "Re-contextualizado",
	  "Re-implementado",
	  "Reducido",
	  "Ingenieria inversa",
	  "Robusto",
	  "Fácil",
	  "Seguro",
	  "Auto proporciona",
	  "Compartible",
	  "Intercambiable",
	  "Sincronizado",
	  "Orientado a equipos",
	  "Total",
	  "Universal",
	  "Mejorado",
	  "Actualizable",
	  "Centrado en el usuario",
	  "Amigable",
	  "Versatil",
	  "Virtual",
	  "Visionario"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 horas",
	  "24/7",
	  "3rd generación",
	  "4th generación",
	  "5th generación",
	  "6th generación",
	  "analizada",
	  "asimétrica",
	  "asíncrona",
	  "monitorizada por red",
	  "bidireccional",
	  "bifurcada",
	  "generada por el cliente",
	  "cliente servidor",
	  "coherente",
	  "cohesiva",
	  "compuesto",
	  "sensible al contexto",
	  "basado en el contexto",
	  "basado en contenido",
	  "dedicada",
	  "generado por la demanda",
	  "didactica",
	  "direccional",
	  "discreta",
	  "dinámica",
	  "potenciada",
	  "acompasada",
	  "ejecutiva",
	  "explícita",
	  "tolerante a fallos",
	  "innovadora",
	  "amplio ábanico",
	  "global",
	  "heurística",
	  "alto nivel",
	  "holística",
	  "homogénea",
	  "hibrida",
	  "incremental",
	  "intangible",
	  "interactiva",
	  "intermedia",
	  "local",
	  "logística",
	  "maximizada",
	  "metódica",
	  "misión crítica",
	  "móbil",
	  "modular",
	  "motivadora",
	  "multimedia",
	  "multiestado",
	  "multitarea",
	  "nacional",
	  "basado en necesidades",
	  "neutral",
	  "nueva generación",
	  "no-volátil",
	  "orientado a objetos",
	  "óptima",
	  "optimizada",
	  "radical",
	  "tiempo real",
	  "recíproca",
	  "regional",
	  "escalable",
	  "secundaria",
	  "orientada a soluciones",
	  "estable",
	  "estatica",
	  "sistemática",
	  "sistémica",
	  "tangible",
	  "terciaria",
	  "transicional",
	  "uniforme",
	  "valor añadido",
	  "vía web",
	  "defectos cero",
	  "tolerancia cero"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2234);
	company.noun = __webpack_require__(2233);
	company.descriptor = __webpack_require__(2230);
	company.adjective = __webpack_require__(2229);
	company.name = __webpack_require__(2232);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} y #{Name.last_name}",
	  "#{Name.last_name} #{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "habilidad",
	  "acceso",
	  "adaptador",
	  "algoritmo",
	  "alianza",
	  "analista",
	  "aplicación",
	  "enfoque",
	  "arquitectura",
	  "archivo",
	  "inteligencia artificial",
	  "array",
	  "actitud",
	  "medición",
	  "gestión presupuestaria",
	  "capacidad",
	  "desafío",
	  "circuito",
	  "colaboración",
	  "complejidad",
	  "concepto",
	  "conglomeración",
	  "contingencia",
	  "núcleo",
	  "fidelidad",
	  "base de datos",
	  "data-warehouse",
	  "definición",
	  "emulación",
	  "codificar",
	  "encriptar",
	  "extranet",
	  "firmware",
	  "flexibilidad",
	  "focus group",
	  "previsión",
	  "base de trabajo",
	  "función",
	  "funcionalidad",
	  "Interfaz Gráfica",
	  "groupware",
	  "Interfaz gráfico de usuario",
	  "hardware",
	  "Soporte",
	  "jerarquía",
	  "conjunto",
	  "implementación",
	  "infraestructura",
	  "iniciativa",
	  "instalación",
	  "conjunto de instrucciones",
	  "interfaz",
	  "intranet",
	  "base del conocimiento",
	  "red de area local",
	  "aprovechar",
	  "matrices",
	  "metodologías",
	  "middleware",
	  "migración",
	  "modelo",
	  "moderador",
	  "monitorizar",
	  "arquitectura abierta",
	  "sistema abierto",
	  "orquestar",
	  "paradigma",
	  "paralelismo",
	  "política",
	  "portal",
	  "estructura de precios",
	  "proceso de mejora",
	  "producto",
	  "productividad",
	  "proyecto",
	  "proyección",
	  "protocolo",
	  "línea segura",
	  "software",
	  "solución",
	  "estandardización",
	  "estrategia",
	  "estructura",
	  "éxito",
	  "superestructura",
	  "soporte",
	  "sinergia",
	  "mediante",
	  "marco de tiempo",
	  "caja de herramientas",
	  "utilización",
	  "website",
	  "fuerza de trabajo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.L.",
	  "e Hijos",
	  "S.A.",
	  "Hermanos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var es = {};
	module['exports'] = es;
	es.title = "Spanish";
	es.address = __webpack_require__(2217);
	es.company = __webpack_require__(2231);
	es.internet = __webpack_require__(2238);
	es.name = __webpack_require__(2240);
	es.phone_number = __webpack_require__(2247);
	es.cell_phone = __webpack_require__(2228);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "es",
	  "info",
	  "com.es",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2237);
	internet.domain_suffix = __webpack_require__(2236);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adán",
	  "Agustín",
	  "Alberto",
	  "Alejandro",
	  "Alfonso",
	  "Alfredo",
	  "Andrés",
	  "Antonio",
	  "Armando",
	  "Arturo",
	  "Benito",
	  "Benjamín",
	  "Bernardo",
	  "Carlos",
	  "César",
	  "Claudio",
	  "Clemente",
	  "Cristian",
	  "Cristobal",
	  "Daniel",
	  "David",
	  "Diego",
	  "Eduardo",
	  "Emilio",
	  "Enrique",
	  "Ernesto",
	  "Esteban",
	  "Federico",
	  "Felipe",
	  "Fernando",
	  "Francisco",
	  "Gabriel",
	  "Gerardo",
	  "Germán",
	  "Gilberto",
	  "Gonzalo",
	  "Gregorio",
	  "Guillermo",
	  "Gustavo",
	  "Hernán",
	  "Homero",
	  "Horacio",
	  "Hugo",
	  "Ignacio",
	  "Jacobo",
	  "Jaime",
	  "Javier",
	  "Jerónimo",
	  "Jesús",
	  "Joaquín",
	  "Jorge",
	  "Jorge Luis",
	  "José",
	  "José Eduardo",
	  "José Emilio",
	  "José Luis",
	  "José María",
	  "Juan",
	  "Juan Carlos",
	  "Julio",
	  "Julio César",
	  "Lorenzo",
	  "Lucas",
	  "Luis",
	  "Luis Miguel",
	  "Manuel",
	  "Marco Antonio",
	  "Marcos",
	  "Mariano",
	  "Mario",
	  "Martín",
	  "Mateo",
	  "Miguel",
	  "Miguel Ángel",
	  "Nicolás",
	  "Octavio",
	  "Óscar",
	  "Pablo",
	  "Patricio",
	  "Pedro",
	  "Rafael",
	  "Ramiro",
	  "Ramón",
	  "Raúl",
	  "Ricardo",
	  "Roberto",
	  "Rodrigo",
	  "Rubén",
	  "Salvador",
	  "Samuel",
	  "Sancho",
	  "Santiago",
	  "Sergio",
	  "Teodoro",
	  "Timoteo",
	  "Tomás",
	  "Vicente",
	  "Víctor",
	  "Adela",
	  "Adriana",
	  "Alejandra",
	  "Alicia",
	  "Amalia",
	  "Ana",
	  "Ana Luisa",
	  "Ana María",
	  "Andrea",
	  "Anita",
	  "Ángela",
	  "Antonia",
	  "Ariadna",
	  "Barbara",
	  "Beatriz",
	  "Berta",
	  "Blanca",
	  "Caridad",
	  "Carla",
	  "Carlota",
	  "Carmen",
	  "Carolina",
	  "Catalina",
	  "Cecilia",
	  "Clara",
	  "Claudia",
	  "Concepción",
	  "Conchita",
	  "Cristina",
	  "Daniela",
	  "Débora",
	  "Diana",
	  "Dolores",
	  "Lola",
	  "Dorotea",
	  "Elena",
	  "Elisa",
	  "Eloisa",
	  "Elsa",
	  "Elvira",
	  "Emilia",
	  "Esperanza",
	  "Estela",
	  "Ester",
	  "Eva",
	  "Florencia",
	  "Francisca",
	  "Gabriela",
	  "Gloria",
	  "Graciela",
	  "Guadalupe",
	  "Guillermina",
	  "Inés",
	  "Irene",
	  "Isabel",
	  "Isabela",
	  "Josefina",
	  "Juana",
	  "Julia",
	  "Laura",
	  "Leonor",
	  "Leticia",
	  "Lilia",
	  "Lorena",
	  "Lourdes",
	  "Lucia",
	  "Luisa",
	  "Luz",
	  "Magdalena",
	  "Manuela",
	  "Marcela",
	  "Margarita",
	  "María",
	  "María del Carmen",
	  "María Cristina",
	  "María Elena",
	  "María Eugenia",
	  "María José",
	  "María Luisa",
	  "María Soledad",
	  "María Teresa",
	  "Mariana",
	  "Maricarmen",
	  "Marilu",
	  "Marisol",
	  "Marta",
	  "Mayte",
	  "Mercedes",
	  "Micaela",
	  "Mónica",
	  "Natalia",
	  "Norma",
	  "Olivia",
	  "Patricia",
	  "Pilar",
	  "Ramona",
	  "Raquel",
	  "Rebeca",
	  "Reina",
	  "Rocio",
	  "Rosa",
	  "Rosalia",
	  "Rosario",
	  "Sara",
	  "Silvia",
	  "Sofia",
	  "Soledad",
	  "Sonia",
	  "Susana",
	  "Teresa",
	  "Verónica",
	  "Victoria",
	  "Virginia",
	  "Yolanda"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2239);
	name.last_name = __webpack_require__(2241);
	name.prefix = __webpack_require__(2243);
	name.suffix = __webpack_require__(2244);
	name.title = __webpack_require__(2245);
	name.name = __webpack_require__(2242);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abeyta",
	  "Abrego",
	  "Abreu",
	  "Acevedo",
	  "Acosta",
	  "Acuña",
	  "Adame",
	  "Adorno",
	  "Agosto",
	  "Aguayo",
	  "Águilar",
	  "Aguilera",
	  "Aguirre",
	  "Alanis",
	  "Alaniz",
	  "Alarcón",
	  "Alba",
	  "Alcala",
	  "Alcántar",
	  "Alcaraz",
	  "Alejandro",
	  "Alemán",
	  "Alfaro",
	  "Alicea",
	  "Almanza",
	  "Almaraz",
	  "Almonte",
	  "Alonso",
	  "Alonzo",
	  "Altamirano",
	  "Alva",
	  "Alvarado",
	  "Alvarez",
	  "Amador",
	  "Amaya",
	  "Anaya",
	  "Anguiano",
	  "Angulo",
	  "Aparicio",
	  "Apodaca",
	  "Aponte",
	  "Aragón",
	  "Araña",
	  "Aranda",
	  "Arce",
	  "Archuleta",
	  "Arellano",
	  "Arenas",
	  "Arevalo",
	  "Arguello",
	  "Arias",
	  "Armas",
	  "Armendáriz",
	  "Armenta",
	  "Armijo",
	  "Arredondo",
	  "Arreola",
	  "Arriaga",
	  "Arroyo",
	  "Arteaga",
	  "Atencio",
	  "Ávalos",
	  "Ávila",
	  "Avilés",
	  "Ayala",
	  "Baca",
	  "Badillo",
	  "Báez",
	  "Baeza",
	  "Bahena",
	  "Balderas",
	  "Ballesteros",
	  "Banda",
	  "Bañuelos",
	  "Barajas",
	  "Barela",
	  "Barragán",
	  "Barraza",
	  "Barrera",
	  "Barreto",
	  "Barrientos",
	  "Barrios",
	  "Batista",
	  "Becerra",
	  "Beltrán",
	  "Benavides",
	  "Benavídez",
	  "Benítez",
	  "Bermúdez",
	  "Bernal",
	  "Berríos",
	  "Bétancourt",
	  "Blanco",
	  "Bonilla",
	  "Borrego",
	  "Botello",
	  "Bravo",
	  "Briones",
	  "Briseño",
	  "Brito",
	  "Bueno",
	  "Burgos",
	  "Bustamante",
	  "Bustos",
	  "Caballero",
	  "Cabán",
	  "Cabrera",
	  "Cadena",
	  "Caldera",
	  "Calderón",
	  "Calvillo",
	  "Camacho",
	  "Camarillo",
	  "Campos",
	  "Canales",
	  "Candelaria",
	  "Cano",
	  "Cantú",
	  "Caraballo",
	  "Carbajal",
	  "Cardenas",
	  "Cardona",
	  "Carmona",
	  "Carranza",
	  "Carrasco",
	  "Carrasquillo",
	  "Carreón",
	  "Carrera",
	  "Carrero",
	  "Carrillo",
	  "Carrion",
	  "Carvajal",
	  "Casanova",
	  "Casares",
	  "Casárez",
	  "Casas",
	  "Casillas",
	  "Castañeda",
	  "Castellanos",
	  "Castillo",
	  "Castro",
	  "Cavazos",
	  "Cazares",
	  "Ceballos",
	  "Cedillo",
	  "Ceja",
	  "Centeno",
	  "Cepeda",
	  "Cerda",
	  "Cervantes",
	  "Cervántez",
	  "Chacón",
	  "Chapa",
	  "Chavarría",
	  "Chávez",
	  "Cintrón",
	  "Cisneros",
	  "Collado",
	  "Collazo",
	  "Colón",
	  "Colunga",
	  "Concepción",
	  "Contreras",
	  "Cordero",
	  "Córdova",
	  "Cornejo",
	  "Corona",
	  "Coronado",
	  "Corral",
	  "Corrales",
	  "Correa",
	  "Cortés",
	  "Cortez",
	  "Cotto",
	  "Covarrubias",
	  "Crespo",
	  "Cruz",
	  "Cuellar",
	  "Curiel",
	  "Dávila",
	  "de Anda",
	  "de Jesús",
	  "Delacrúz",
	  "Delafuente",
	  "Delagarza",
	  "Delao",
	  "Delapaz",
	  "Delarosa",
	  "Delatorre",
	  "Deleón",
	  "Delgadillo",
	  "Delgado",
	  "Delrío",
	  "Delvalle",
	  "Díaz",
	  "Domínguez",
	  "Domínquez",
	  "Duarte",
	  "Dueñas",
	  "Duran",
	  "Echevarría",
	  "Elizondo",
	  "Enríquez",
	  "Escalante",
	  "Escamilla",
	  "Escobar",
	  "Escobedo",
	  "Esparza",
	  "Espinal",
	  "Espino",
	  "Espinosa",
	  "Espinoza",
	  "Esquibel",
	  "Esquivel",
	  "Estévez",
	  "Estrada",
	  "Fajardo",
	  "Farías",
	  "Feliciano",
	  "Fernández",
	  "Ferrer",
	  "Fierro",
	  "Figueroa",
	  "Flores",
	  "Flórez",
	  "Fonseca",
	  "Franco",
	  "Frías",
	  "Fuentes",
	  "Gaitán",
	  "Galarza",
	  "Galindo",
	  "Gallardo",
	  "Gallegos",
	  "Galván",
	  "Gálvez",
	  "Gamboa",
	  "Gamez",
	  "Gaona",
	  "Garay",
	  "García",
	  "Garibay",
	  "Garica",
	  "Garrido",
	  "Garza",
	  "Gastélum",
	  "Gaytán",
	  "Gil",
	  "Girón",
	  "Godínez",
	  "Godoy",
	  "Gómez",
	  "Gonzales",
	  "González",
	  "Gollum",
	  "Gracia",
	  "Granado",
	  "Granados",
	  "Griego",
	  "Grijalva",
	  "Guajardo",
	  "Guardado",
	  "Guerra",
	  "Guerrero",
	  "Guevara",
	  "Guillen",
	  "Gurule",
	  "Gutiérrez",
	  "Guzmán",
	  "Haro",
	  "Henríquez",
	  "Heredia",
	  "Hernádez",
	  "Hernandes",
	  "Hernández",
	  "Herrera",
	  "Hidalgo",
	  "Hinojosa",
	  "Holguín",
	  "Huerta",
	  "Hurtado",
	  "Ibarra",
	  "Iglesias",
	  "Irizarry",
	  "Jaime",
	  "Jaimes",
	  "Jáquez",
	  "Jaramillo",
	  "Jasso",
	  "Jiménez",
	  "Jimínez",
	  "Juárez",
	  "Jurado",
	  "Laboy",
	  "Lara",
	  "Laureano",
	  "Leal",
	  "Lebrón",
	  "Ledesma",
	  "Leiva",
	  "Lemus",
	  "León",
	  "Lerma",
	  "Leyva",
	  "Limón",
	  "Linares",
	  "Lira",
	  "Llamas",
	  "Loera",
	  "Lomeli",
	  "Longoria",
	  "López",
	  "Lovato",
	  "Loya",
	  "Lozada",
	  "Lozano",
	  "Lucero",
	  "Lucio",
	  "Luevano",
	  "Lugo",
	  "Luna",
	  "Macías",
	  "Madera",
	  "Madrid",
	  "Madrigal",
	  "Maestas",
	  "Magaña",
	  "Malave",
	  "Maldonado",
	  "Manzanares",
	  "Mares",
	  "Marín",
	  "Márquez",
	  "Marrero",
	  "Marroquín",
	  "Martínez",
	  "Mascareñas",
	  "Mata",
	  "Mateo",
	  "Matías",
	  "Matos",
	  "Maya",
	  "Mayorga",
	  "Medina",
	  "Medrano",
	  "Mejía",
	  "Meléndez",
	  "Melgar",
	  "Mena",
	  "Menchaca",
	  "Méndez",
	  "Mendoza",
	  "Menéndez",
	  "Meraz",
	  "Mercado",
	  "Merino",
	  "Mesa",
	  "Meza",
	  "Miramontes",
	  "Miranda",
	  "Mireles",
	  "Mojica",
	  "Molina",
	  "Mondragón",
	  "Monroy",
	  "Montalvo",
	  "Montañez",
	  "Montaño",
	  "Montemayor",
	  "Montenegro",
	  "Montero",
	  "Montes",
	  "Montez",
	  "Montoya",
	  "Mora",
	  "Morales",
	  "Moreno",
	  "Mota",
	  "Moya",
	  "Munguía",
	  "Muñiz",
	  "Muñoz",
	  "Murillo",
	  "Muro",
	  "Nájera",
	  "Naranjo",
	  "Narváez",
	  "Nava",
	  "Navarrete",
	  "Navarro",
	  "Nazario",
	  "Negrete",
	  "Negrón",
	  "Nevárez",
	  "Nieto",
	  "Nieves",
	  "Niño",
	  "Noriega",
	  "Núñez",
	  "Ocampo",
	  "Ocasio",
	  "Ochoa",
	  "Ojeda",
	  "Olivares",
	  "Olivárez",
	  "Olivas",
	  "Olivera",
	  "Olivo",
	  "Olmos",
	  "Olvera",
	  "Ontiveros",
	  "Oquendo",
	  "Ordóñez",
	  "Orellana",
	  "Ornelas",
	  "Orosco",
	  "Orozco",
	  "Orta",
	  "Ortega",
	  "Ortiz",
	  "Osorio",
	  "Otero",
	  "Ozuna",
	  "Pabón",
	  "Pacheco",
	  "Padilla",
	  "Padrón",
	  "Páez",
	  "Pagan",
	  "Palacios",
	  "Palomino",
	  "Palomo",
	  "Pantoja",
	  "Paredes",
	  "Parra",
	  "Partida",
	  "Patiño",
	  "Paz",
	  "Pedraza",
	  "Pedroza",
	  "Pelayo",
	  "Peña",
	  "Perales",
	  "Peralta",
	  "Perea",
	  "Peres",
	  "Pérez",
	  "Pichardo",
	  "Piña",
	  "Pineda",
	  "Pizarro",
	  "Polanco",
	  "Ponce",
	  "Porras",
	  "Portillo",
	  "Posada",
	  "Prado",
	  "Preciado",
	  "Prieto",
	  "Puente",
	  "Puga",
	  "Pulido",
	  "Quesada",
	  "Quezada",
	  "Quiñones",
	  "Quiñónez",
	  "Quintana",
	  "Quintanilla",
	  "Quintero",
	  "Quiroz",
	  "Rael",
	  "Ramírez",
	  "Ramón",
	  "Ramos",
	  "Rangel",
	  "Rascón",
	  "Raya",
	  "Razo",
	  "Regalado",
	  "Rendón",
	  "Rentería",
	  "Reséndez",
	  "Reyes",
	  "Reyna",
	  "Reynoso",
	  "Rico",
	  "Rincón",
	  "Riojas",
	  "Ríos",
	  "Rivas",
	  "Rivera",
	  "Rivero",
	  "Robledo",
	  "Robles",
	  "Rocha",
	  "Rodarte",
	  "Rodrígez",
	  "Rodríguez",
	  "Rodríquez",
	  "Rojas",
	  "Rojo",
	  "Roldán",
	  "Rolón",
	  "Romero",
	  "Romo",
	  "Roque",
	  "Rosado",
	  "Rosales",
	  "Rosario",
	  "Rosas",
	  "Roybal",
	  "Rubio",
	  "Ruelas",
	  "Ruiz",
	  "Saavedra",
	  "Sáenz",
	  "Saiz",
	  "Salas",
	  "Salazar",
	  "Salcedo",
	  "Salcido",
	  "Saldaña",
	  "Saldivar",
	  "Salgado",
	  "Salinas",
	  "Samaniego",
	  "Sanabria",
	  "Sanches",
	  "Sánchez",
	  "Sandoval",
	  "Santacruz",
	  "Santana",
	  "Santiago",
	  "Santillán",
	  "Sarabia",
	  "Sauceda",
	  "Saucedo",
	  "Sedillo",
	  "Segovia",
	  "Segura",
	  "Sepúlveda",
	  "Serna",
	  "Serrano",
	  "Serrato",
	  "Sevilla",
	  "Sierra",
	  "Sisneros",
	  "Solano",
	  "Solís",
	  "Soliz",
	  "Solorio",
	  "Solorzano",
	  "Soria",
	  "Sosa",
	  "Sotelo",
	  "Soto",
	  "Suárez",
	  "Tafoya",
	  "Tamayo",
	  "Tamez",
	  "Tapia",
	  "Tejada",
	  "Tejeda",
	  "Téllez",
	  "Tello",
	  "Terán",
	  "Terrazas",
	  "Tijerina",
	  "Tirado",
	  "Toledo",
	  "Toro",
	  "Torres",
	  "Tórrez",
	  "Tovar",
	  "Trejo",
	  "Treviño",
	  "Trujillo",
	  "Ulibarri",
	  "Ulloa",
	  "Urbina",
	  "Ureña",
	  "Urías",
	  "Uribe",
	  "Urrutia",
	  "Vaca",
	  "Valadez",
	  "Valdés",
	  "Valdez",
	  "Valdivia",
	  "Valencia",
	  "Valentín",
	  "Valenzuela",
	  "Valladares",
	  "Valle",
	  "Vallejo",
	  "Valles",
	  "Valverde",
	  "Vanegas",
	  "Varela",
	  "Vargas",
	  "Vásquez",
	  "Vázquez",
	  "Vega",
	  "Vela",
	  "Velasco",
	  "Velásquez",
	  "Velázquez",
	  "Vélez",
	  "Véliz",
	  "Venegas",
	  "Vera",
	  "Verdugo",
	  "Verduzco",
	  "Vergara",
	  "Viera",
	  "Vigil",
	  "Villa",
	  "Villagómez",
	  "Villalobos",
	  "Villalpando",
	  "Villanueva",
	  "Villareal",
	  "Villarreal",
	  "Villaseñor",
	  "Villegas",
	  "Yáñez",
	  "Ybarra",
	  "Zambrano",
	  "Zamora",
	  "Zamudio",
	  "Zapata",
	  "Zaragoza",
	  "Zarate",
	  "Zavala",
	  "Zayas",
	  "Zelaya",
	  "Zepeda",
	  "Zúñiga"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Sta."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Jefe",
	    "Senior",
	    "Directo",
	    "Corporativo",
	    "Dinánmico",
	    "Futuro",
	    "Producto",
	    "Nacional",
	    "Regional",
	    "Distrito",
	    "Central",
	    "Global",
	    "Cliente",
	    "Inversor",
	    "International",
	    "Heredado",
	    "Adelante",
	    "Interno",
	    "Humano",
	    "Gerente",
	    "Director"
	  ],
	  "level": [
	    "Soluciones",
	    "Programa",
	    "Marca",
	    "Seguridada",
	    "Investigación",
	    "Marketing",
	    "Normas",
	    "Implementación",
	    "Integración",
	    "Funcionalidad",
	    "Respuesta",
	    "Paradigma",
	    "Tácticas",
	    "Identidad",
	    "Mercados",
	    "Grupo",
	    "División",
	    "Aplicaciones",
	    "Optimización",
	    "Operaciones",
	    "Infraestructura",
	    "Intranet",
	    "Comunicaciones",
	    "Web",
	    "Calidad",
	    "Seguro",
	    "Mobilidad",
	    "Cuentas",
	    "Datos",
	    "Creativo",
	    "Configuración",
	    "Contabilidad",
	    "Interacciones",
	    "Factores",
	    "Usabilidad",
	    "Métricas"
	  ],
	  "job": [
	    "Supervisor",
	    "Asociado",
	    "Ejecutivo",
	    "Relacciones",
	    "Oficial",
	    "Gerente",
	    "Ingeniero",
	    "Especialista",
	    "Director",
	    "Coordinador",
	    "Administrador",
	    "Arquitecto",
	    "Analista",
	    "Diseñador",
	    "Planificador",
	    "Técnico",
	    "Funcionario",
	    "Desarrollador",
	    "Productor",
	    "Consultor",
	    "Asistente",
	    "Facilitador",
	    "Agente",
	    "Representante",
	    "Estratega"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "9##-###-###",
	  "9##.###.###",
	  "9## ### ###",
	  "9########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2246);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  " s/n.",
	  ", #",
	  ", ##",
	  " #",
	  " ##",
	  " ###",
	  " ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aguascalientes",
	  "Apodaca",
	  "Buenavista",
	  "Campeche",
	  "Cancún",
	  "Cárdenas",
	  "Celaya",
	  "Chalco",
	  "Chetumal",
	  "Chicoloapan",
	  "Chignahuapan",
	  "Chihuahua",
	  "Chilpancingo",
	  "Chimalhuacán",
	  "Ciudad Acuña",
	  "Ciudad de México",
	  "Ciudad del Carmen",
	  "Ciudad López Mateos",
	  "Ciudad Madero",
	  "Ciudad Obregón",
	  "Ciudad Valles",
	  "Ciudad Victoria",
	  "Coatzacoalcos",
	  "Colima-Villa de Álvarez",
	  "Comitán de Dominguez",
	  "Córdoba",
	  "Cuautitlán Izcalli",
	  "Cuautla",
	  "Cuernavaca",
	  "Culiacán",
	  "Delicias",
	  "Durango",
	  "Ensenada",
	  "Fresnillo",
	  "General Escobedo",
	  "Gómez Palacio",
	  "Guadalajara",
	  "Guadalupe",
	  "Guanajuato",
	  "Guaymas",
	  "Hermosillo",
	  "Hidalgo del Parral",
	  "Iguala",
	  "Irapuato",
	  "Ixtapaluca",
	  "Jiutepec",
	  "Juárez",
	  "La Laguna",
	  "La Paz",
	  "La Piedad-Pénjamo",
	  "León",
	  "Los Cabos",
	  "Los Mochis",
	  "Manzanillo",
	  "Matamoros",
	  "Mazatlán",
	  "Mérida",
	  "Mexicali",
	  "Minatitlán",
	  "Miramar",
	  "Monclova",
	  "Monclova-Frontera",
	  "Monterrey",
	  "Morelia",
	  "Naucalpan de Juárez",
	  "Navojoa",
	  "Nezahualcóyotl",
	  "Nogales",
	  "Nuevo Laredo",
	  "Oaxaca",
	  "Ocotlán",
	  "Ojo de agua",
	  "Orizaba",
	  "Pachuca",
	  "Piedras Negras",
	  "Poza Rica",
	  "Puebla",
	  "Puerto Vallarta",
	  "Querétaro",
	  "Reynosa-Río Bravo",
	  "Rioverde-Ciudad Fernández",
	  "Salamanca",
	  "Saltillo",
	  "San Cristobal de las Casas",
	  "San Francisco Coacalco",
	  "San Francisco del Rincón",
	  "San Juan Bautista Tuxtepec",
	  "San Juan del Río",
	  "San Luis Potosí-Soledad",
	  "San Luis Río Colorado",
	  "San Nicolás de los Garza",
	  "San Pablo de las Salinas",
	  "San Pedro Garza García",
	  "Santa Catarina",
	  "Soledad de Graciano Sánchez",
	  "Tampico-Pánuco",
	  "Tapachula",
	  "Tecomán",
	  "Tehuacán",
	  "Tehuacán",
	  "Tehuantepec-Salina Cruz",
	  "Tepexpan",
	  "Tepic",
	  "Tetela de Ocampo",
	  "Texcoco de Mora",
	  "Tijuana",
	  "Tlalnepantla",
	  "Tlaquepaque",
	  "Tlaxcala-Apizaco",
	  "Toluca",
	  "Tonalá",
	  "Torreón",
	  "Tula",
	  "Tulancingo",
	  "Tulancingo de Bravo",
	  "Tuxtla Gutiérrez",
	  "Uruapan",
	  "Uruapan del Progreso",
	  "Valle de México",
	  "Veracruz",
	  "Villa de Álvarez",
	  "Villa Nicolás Romero",
	  "Villahermosa",
	  "Xalapa",
	  "Zacatecas-Guadalupe",
	  "Zacatlan",
	  "Zacatzingo",
	  "Zamora-Jacona",
	  "Zapopan",
	  "Zitacuaro"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistán",
	  "Albania",
	  "Argelia",
	  "Andorra",
	  "Angola",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbayán",
	  "Bahamas",
	  "Barein",
	  "Bangladesh",
	  "Barbados",
	  "Bielorusia",
	  "Bélgica",
	  "Belice",
	  "Bermuda",
	  "Bután",
	  "Bolivia",
	  "Bosnia Herzegovina",
	  "Botswana",
	  "Brasil",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Camboya",
	  "Camerún",
	  "Canada",
	  "Cabo Verde",
	  "Islas Caimán",
	  "Chad",
	  "Chile",
	  "China",
	  "Isla de Navidad",
	  "Colombia",
	  "Comodos",
	  "Congo",
	  "Costa Rica",
	  "Costa de Marfil",
	  "Croacia",
	  "Cuba",
	  "Chipre",
	  "República Checa",
	  "Dinamarca",
	  "Dominica",
	  "República Dominicana",
	  "Ecuador",
	  "Egipto",
	  "El Salvador",
	  "Guinea Ecuatorial",
	  "Eritrea",
	  "Estonia",
	  "Etiopía",
	  "Islas Faro",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Gabón",
	  "Gambia",
	  "Georgia",
	  "Alemania",
	  "Ghana",
	  "Grecia",
	  "Groenlandia",
	  "Granada",
	  "Guadalupe",
	  "Guam",
	  "Guatemala",
	  "Guinea",
	  "Guinea-Bisau",
	  "Guayana",
	  "Haiti",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Islandia",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Irak",
	  "Irlanda",
	  "Italia",
	  "Jamaica",
	  "Japón",
	  "Jordania",
	  "Kazajistan",
	  "Kenia",
	  "Kiribati",
	  "Corea",
	  "Kuwait",
	  "Letonia",
	  "Líbano",
	  "Liberia",
	  "Liechtenstein",
	  "Lituania",
	  "Luxemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malasia",
	  "Maldivas",
	  "Mali",
	  "Malta",
	  "Martinica",
	  "Mauritania",
	  "México",
	  "Micronesia",
	  "Moldavia",
	  "Mónaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marruecos",
	  "Mozambique",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Holanda",
	  "Nueva Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Noruega",
	  "Omán",
	  "Pakistan",
	  "Panamá",
	  "Papúa Nueva Guinea",
	  "Paraguay",
	  "Perú",
	  "Filipinas",
	  "Poland",
	  "Portugal",
	  "Puerto Rico",
	  "Rusia",
	  "Ruanda",
	  "Samoa",
	  "San Marino",
	  "Santo Tomé y Principe",
	  "Arabia Saudí",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leona",
	  "Singapur",
	  "Eslovaquia",
	  "Eslovenia",
	  "Somalia",
	  "España",
	  "Sri Lanka",
	  "Sudán",
	  "Suriname",
	  "Suecia",
	  "Suiza",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tonga",
	  "Trinidad y Tobago",
	  "Tunez",
	  "Turquia",
	  "Uganda",
	  "Ucrania",
	  "Emiratos Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos de América",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "México"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2250);
	address.city_suffix = __webpack_require__(2251);
	address.country = __webpack_require__(2252);
	address.building_number = __webpack_require__(2248);
	address.street_suffix = __webpack_require__(2262);
	address.secondary_address = __webpack_require__(2256);
	address.postcode = __webpack_require__(2255);
	address.state = __webpack_require__(2257);
	address.state_abbr = __webpack_require__(2258);
	address.time_zone = __webpack_require__(2263);
	address.city = __webpack_require__(2249);
	address.street = __webpack_require__(2259);
	address.street_name = __webpack_require__(2261);
	address.street_address = __webpack_require__(2260);
	address.default_country = __webpack_require__(2253);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Esc. ###",
	  "Puerta ###",
	  "Edificio #"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aguascalientes",
	  "Baja California Norte",
	  "Baja California Sur",
	  'Estado de México',
	  "Campeche",
	  "Chiapas",
	  "Chihuahua",
	  "Coahuila",
	  "Colima",
	  "Durango",
	  "Guanajuato",
	  "Guerrero",
	  "Hidalgo",
	  "Jalisco",
	  "Michoacan",
	  "Morelos",
	  "Nayarit",
	  'Nuevo León',
	  "Oaxaca",
	  "Puebla",
	  "Querétaro",
	  "Quintana Roo",
	  "San Luis Potosí",
	  "Sinaloa",
	  "Sonora",
	  "Tabasco",
	  "Tamaulipas",
	  "Tlaxcala",
	  "Veracruz",
	  "Yucatán",
	  "Zacatecas"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AS",
	  "BC",
	  "BS",
	  "CC",
	  "CS",
	  "CH",
	  "CL",
	  "CM",
	  "DF",
	  "DG",
	  "GT",
	  "GR",
	  "HG",
	  "JC",
	  "MC",
	  "MN",
	  "MS",
	  "NT",
	  "NL",
	  "OC",
	  "PL",
	  "QT",
	  "QR",
	  "SP",
	  "SL",
	  "SR",
	  "TC",
	  "TS",
	  "TL",
	  "VZ",
	  "YN",
	  "ZS"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
		"20 de Noviembre",
		"Cinco de Mayo",
		"Cuahutemoc",
		"Manzanares",
		"Donceles",
		"Francisco I. Madero",
		"Juárez",
		"Repúplica de Cuba",
		"Repúplica de Chile",
		"Repúplica de Argentina",
		"Repúplica de Uruguay",
		"Isabel la Católica",
		"Izazaga",
		"Eje Central",
		"Eje 6",
		"Eje 5",
		"La viga",
		"Aniceto Ortega",
		"Miguel Ángel de Quevedo",
		"Amores",
		"Coyoacán",
		"Coruña",
		"Batalla de Naco",
		"La otra banda",
		"Piedra del Comal",
		"Balcón de los edecanes",
		"Barrio la Lonja",
		"Jicolapa",
		"Zacatlán",
		"Zapata",
		"Polotitlan",
		"Calimaya",
		"Flor Marina",
		"Flor Solvestre",
		"San Miguel",
		"Naranjo",
		"Cedro",
		"Jalisco",
		"Avena"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}",
	  "#{street_name}#{building_number} #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.first_name} #{Name.last_name}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}",
	  "#{street_suffix} #{street}"
	
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aldea",
	  "Apartamento",
	  "Arrabal",
	  "Arroyo",
	  "Avenida",
	  "Bajada",
	  "Barranco",
	  "Barrio",
	  "Bloque",
	  "Calle",
	  "Calleja",
	  "Camino",
	  "Carretera",
	  "Caserio",
	  "Colegio",
	  "Colonia",
	  "Conjunto",
	  "Cuesta",
	  "Chalet",
	  "Edificio",
	  "Entrada",
	  "Escalinata",
	  "Explanada",
	  "Extramuros",
	  "Extrarradio",
	  "Ferrocarril",
	  "Glorieta",
	  "Gran Subida",
	  "Grupo",
	  "Huerta",
	  "Jardines",
	  "Lado",
	  "Lugar",
	  "Manzana",
	  "Masía",
	  "Mercado",
	  "Monte",
	  "Muelle",
	  "Municipio",
	  "Parcela",
	  "Parque",
	  "Partida",
	  "Pasaje",
	  "Paseo",
	  "Plaza",
	  "Poblado",
	  "Polígono",
	  "Prolongación",
	  "Puente",
	  "Puerta",
	  "Quinta",
	  "Ramal",
	  "Rambla",
	  "Rampa",
	  "Riera",
	  "Rincón",
	  "Ronda",
	  "Rua",
	  "Salida",
	  "Sector",
	  "Sección",
	  "Senda",
	  "Solar",
	  "Subida",
	  "Terrenos",
	  "Torrente",
	  "Travesía",
	  "Urbanización",
	  "Vía",
	  "Vía Pública"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacífico/Midway",
	  "Pacífico/Pago_Pago",
	  "Pacífico/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europa/Dublin",
	  "Europa/London",
	  "Europa/Lisbon",
	  "Europa/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europa/Belgrade",
	  "Europa/Bratislava",
	  "Europa/Budapest",
	  "Europa/Ljubljana",
	  "Europa/Prague",
	  "Europa/Sarajevo",
	  "Europa/Skopje",
	  "Europa/Warsaw",
	  "Europa/Zagreb",
	  "Europa/Brussels",
	  "Europa/Copenhagen",
	  "Europa/Madrid",
	  "Europa/Paris",
	  "Europa/Amsterdam",
	  "Europa/Berlin",
	  "Europa/Berlin",
	  "Europa/Rome",
	  "Europa/Stockholm",
	  "Europa/Vienna",
	  "Africa/Algiers",
	  "Europa/Bucharest",
	  "Africa/Cairo",
	  "Europa/Helsinki",
	  "Europa/Kiev",
	  "Europa/Riga",
	  "Europa/Sofia",
	  "Europa/Tallinn",
	  "Europa/Vilnius",
	  "Europa/Athens",
	  "Europa/Istanbul",
	  "Europa/Minsk",
	  "Asia/Jerusalen",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Europa/Moscú",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacífico/Guam",
	  "Pacífico/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacífico/Noumea",
	  "Pacífico/Fiji",
	  "Asia/Kamchatka",
	  "Pacífico/Majuro",
	  "Pacífico/Auckland",
	  "Pacífico/Auckland",
	  "Pacífico/Tongatapu",
	  "Pacífico/Fakaofo",
	  "Pacífico/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5##-###-###",
	  "5##.###.###",
	  "5## ### ###",
	  "5########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2264);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "rojo",
	   "verde",
	   "azul",
	   "amarillo",
	   "morado",
	   "Menta verde",
	   "teal",
	   "blanco",
	   "negro",
	   "Naranja",
	   "Rosa",
	   "gris",
	   "marrón",
	   "violeta",
	   "turquesa",
	   "tan",
	   "cielo azul",
	   "salmón",
	   "ciruela",
	   "orquídea",
	   "aceituna",
	   "magenta",
	   "Lima",
	   "marfil",
	   "índigo",
	   "oro",
	   "fucsia",
	   "cian",
	   "azul",
	   "lavanda",
	   "plata"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "Libros",
	   "Películas",
	   "Música",
	   "Juegos",
	   "Electrónica",
	   "Ordenadores",
	   "Hogar",
	   "Jardín",
	   "Herramientas",
	   "Ultramarinos",
	   "Salud",
	   "Belleza",
	   "Juguetes",
	   "Kids",
	   "Baby",
	   "Ropa",
	   "Zapatos",
	   "Joyería",
	   "Deportes",
	   "Aire libre",
	   "Automoción",
	   "Industrial"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(2266);
	commerce.department = __webpack_require__(2267);
	commerce.product_name = __webpack_require__(2269);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	"adjective": [
	     "Pequeño",
	     "Ergonómico",
	     "Rústico",
	     "Inteligente",
	     "Gorgeous",
	     "Increíble",
	     "Fantástico",
	     "Práctica",
	     "Elegante",
	     "Increíble",
	     "Genérica",
	     "Artesanal",
	     "Hecho a mano",
	     "Licencia",
	     "Refinado",
	     "Sin marca",
	     "Sabrosa"
	   ],
	"material": [
	     "Acero",
	     "Madera",
	     "Hormigón",
	     "Plástico",
	     "Cotton",
	     "Granito",
	     "Caucho",
	     "Metal",
	     "Soft",
	     "Fresco",
	     "Frozen"
	   ],
	"product": [
	     "Presidente",
	     "Auto",
	     "Computadora",
	     "Teclado",
	     "Ratón",
	     "Bike",
	     "Pelota",
	     "Guantes",
	     "Pantalones",
	     "Camisa",
	     "Mesa",
	     "Zapatos",
	     "Sombrero",
	     "Toallas",
	     "Jabón",
	     "Tuna",
	     "Pollo",
	     "Pescado",
	     "Queso",
	     "Tocino",
	     "Pizza",
	     "Ensalada",
	     "Embutidos"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptativo",
	  "Avanzado",
	  "Asimilado",
	  "Automatizado",
	  "Equilibrado",
	  "Centrado en el negocio",
	  "Centralizado",
	  "Clonado",
	  "Compatible",
	  "Configurable",
	  "Multi grupo",
	  "Multi plataforma",
	  "Centrado en el usuario",
	  "Configurable",
	  "Descentralizado",
	  "Digitalizado",
	  "Distribuido",
	  "Diverso",
	  "Reducido",
	  "Mejorado",
	  "Para toda la empresa",
	  "Ergonomico",
	  "Exclusivo",
	  "Expandido",
	  "Extendido",
	  "Cara a cara",
	  "Enfocado",
	  "Totalmente configurable",
	  "Fundamental",
	  "Orígenes",
	  "Horizontal",
	  "Implementado",
	  "Innovador",
	  "Integrado",
	  "Intuitivo",
	  "Inverso",
	  "Gestionado",
	  "Obligatorio",
	  "Monitorizado",
	  "Multi canal",
	  "Multi lateral",
	  "Multi capa",
	  "En red",
	  "Orientado a objetos",
	  "Open-source",
	  "Operativo",
	  "Optimizado",
	  "Opcional",
	  "Organico",
	  "Organizado",
	  "Perseverando",
	  "Persistente",
	  "en fases",
	  "Polarizado",
	  "Pre-emptivo",
	  "Proactivo",
	  "Enfocado a benficios",
	  "Profundo",
	  "Programable",
	  "Progresivo",
	  "Public-key",
	  "Enfocado en la calidad",
	  "Reactivo",
	  "Realineado",
	  "Re-contextualizado",
	  "Re-implementado",
	  "Reducido",
	  "Ingenieria inversa",
	  "Robusto",
	  "Fácil",
	  "Seguro",
	  "Auto proporciona",
	  "Compartible",
	  "Intercambiable",
	  "Sincronizado",
	  "Orientado a equipos",
	  "Total",
	  "Universal",
	  "Mejorado",
	  "Actualizable",
	  "Centrado en el usuario",
	  "Amigable",
	  "Versatil",
	  "Virtual",
	  "Visionario"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Clics y mortero",
	  "Valor añadido",
	  "Vertical",
	  "Proactivo",
	  "Robusto",
	  "Revolucionario",
	  "Escalable",
	  "De vanguardia",
	  "Innovador",
	  "Intuitivo",
	  "Estratégico",
	  "E-business",
	  "Misión crítica",
	  "Pegajosa",
	  "Doce y cincuenta y nueve de la noche",
	  "24/7",
	  "De extremo a extremo",
	  "Global",
	  "B2B",
	  "B2C",
	  "Granular",
	  "Fricción",
	  "Virtual",
	  "Viral",
	  "Dinámico",
	  "24/365",
	  "Mejor de su clase",
	  "Asesino",
	  "Magnética",
	  "Filo sangriento",
	  "Habilitado web",
	  "Interactiva",
	  "Punto com",
	  "Sexy",
	  "Back-end",
	  "Tiempo real",
	  "Eficiente",
	  "Frontal",
	  "Distribuida",
	  "Sin costura",
	  "Extensible",
	  "Llave en mano",
	  "Clase mundial",
	  "Código abierto",
	  "Multiplataforma",
	  "Cross-media",
	  "Sinérgico",
	  "ladrillos y clics",
	  "Fuera de la caja",
	  "Empresa",
	  "Integrado",
	  "Impactante",
	  "Inalámbrico",
	  "Transparente",
	  "Próxima generación",
	  "Innovador",
	  "User-centric",
	  "Visionario",
	  "A medida",
	  "Ubicua",
	  "Enchufa y juega",
	  "Colaboración",
	  "Convincente",
	  "Holístico",
	  "Ricos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "sinergias",
	   "web-readiness",
	   "paradigmas",
	   "mercados",
	   "asociaciones",
	   "infraestructuras",
	   "plataformas",
	   "iniciativas",
	   "canales",
	   "ojos",
	   "comunidades",
	   "ROI",
	   "soluciones",
	   "minoristas electrónicos",
	   "e-servicios",
	   "elementos de acción",
	   "portales",
	   "nichos",
	   "tecnologías",
	   "contenido",
	   "vortales",
	   "cadenas de suministro",
	   "convergencia",
	   "relaciones",
	   "arquitecturas",
	   "interfaces",
	   "mercados electrónicos",
	   "e-commerce",
	   "sistemas",
	   "ancho de banda",
	   "infomediarios",
	   "modelos",
	   "Mindshare",
	   "entregables",
	   "usuarios",
	   "esquemas",
	   "redes",
	   "aplicaciones",
	   "métricas",
	   "e-business",
	   "funcionalidades",
	   "experiencias",
	   "servicios web",
	   "metodologías"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	   "poner en práctica",
	   "utilizar",
	   "integrar",
	   "racionalizar",
	   "optimizar",
	   "evolucionar",
	   "transformar",
	   "abrazar",
	   "habilitar",
	   "orquestar",
	   "apalancamiento",
	   "reinventar",
	   "agregado",
	   "arquitecto",
	   "mejorar",
	   "incentivar",
	   "transformarse",
	   "empoderar",
	   "Envisioneer",
	   "monetizar",
	   "arnés",
	   "facilitar",
	   "aprovechar",
	   "desintermediar",
	   "sinergia",
	   "estrategias",
	   "desplegar",
	   "marca",
	   "crecer",
	   "objetivo",
	   "sindicato",
	   "sintetizar",
	   "entregue",
	   "malla",
	   "incubar",
	   "enganchar",
	   "maximizar",
	   "punto de referencia",
	   "acelerar",
	   "reintermediate",
	   "pizarra",
	   "visualizar",
	   "reutilizar",
	   "innovar",
	   "escala",
	   "desatar",
	   "conducir",
	   "extender",
	   "ingeniero",
	   "revolucionar",
	   "generar",
	   "explotar",
	   "transición",
	   "e-enable",
	   "repetir",
	   "cultivar",
	   "matriz",
	   "productize",
	   "redefinir",
	   "recontextualizar"
	]
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 horas",
	  "24/7",
	  "3rd generación",
	  "4th generación",
	  "5th generación",
	  "6th generación",
	  "analizada",
	  "asimétrica",
	  "asíncrona",
	  "monitorizada por red",
	  "bidireccional",
	  "bifurcada",
	  "generada por el cliente",
	  "cliente servidor",
	  "coherente",
	  "cohesiva",
	  "compuesto",
	  "sensible al contexto",
	  "basado en el contexto",
	  "basado en contenido",
	  "dedicada",
	  "generado por la demanda",
	  "didactica",
	  "direccional",
	  "discreta",
	  "dinámica",
	  "potenciada",
	  "acompasada",
	  "ejecutiva",
	  "explícita",
	  "tolerante a fallos",
	  "innovadora",
	  "amplio ábanico",
	  "global",
	  "heurística",
	  "alto nivel",
	  "holística",
	  "homogénea",
	  "hibrida",
	  "incremental",
	  "intangible",
	  "interactiva",
	  "intermedia",
	  "local",
	  "logística",
	  "maximizada",
	  "metódica",
	  "misión crítica",
	  "móbil",
	  "modular",
	  "motivadora",
	  "multimedia",
	  "multiestado",
	  "multitarea",
	  "nacional",
	  "basado en necesidades",
	  "neutral",
	  "nueva generación",
	  "no-volátil",
	  "orientado a objetos",
	  "óptima",
	  "optimizada",
	  "radical",
	  "tiempo real",
	  "recíproca",
	  "regional",
	  "escalable",
	  "secundaria",
	  "orientada a soluciones",
	  "estable",
	  "estatica",
	  "sistemática",
	  "sistémica",
	  "tangible",
	  "terciaria",
	  "transicional",
	  "uniforme",
	  "valor añadido",
	  "vía web",
	  "defectos cero",
	  "tolerancia cero"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2278);
	company.adjective = __webpack_require__(2270);
	company.descriptor = __webpack_require__(2274);
	company.noun = __webpack_require__(2277);
	company.bs_verb = __webpack_require__(2273);
	company.name = __webpack_require__(2276);
	company.bs_adjective = __webpack_require__(2271);
	company.bs_noun = __webpack_require__(2272);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} y #{Name.last_name}",
	  "#{Name.last_name} #{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "habilidad",
	  "acceso",
	  "adaptador",
	  "algoritmo",
	  "alianza",
	  "analista",
	  "aplicación",
	  "enfoque",
	  "arquitectura",
	  "archivo",
	  "inteligencia artificial",
	  "array",
	  "actitud",
	  "medición",
	  "gestión presupuestaria",
	  "capacidad",
	  "desafío",
	  "circuito",
	  "colaboración",
	  "complejidad",
	  "concepto",
	  "conglomeración",
	  "contingencia",
	  "núcleo",
	  "fidelidad",
	  "base de datos",
	  "data-warehouse",
	  "definición",
	  "emulación",
	  "codificar",
	  "encriptar",
	  "extranet",
	  "firmware",
	  "flexibilidad",
	  "focus group",
	  "previsión",
	  "base de trabajo",
	  "función",
	  "funcionalidad",
	  "Interfaz Gráfica",
	  "groupware",
	  "Interfaz gráfico de usuario",
	  "hardware",
	  "Soporte",
	  "jerarquía",
	  "conjunto",
	  "implementación",
	  "infraestructura",
	  "iniciativa",
	  "instalación",
	  "conjunto de instrucciones",
	  "interfaz",
	  "intranet",
	  "base del conocimiento",
	  "red de area local",
	  "aprovechar",
	  "matrices",
	  "metodologías",
	  "middleware",
	  "migración",
	  "modelo",
	  "moderador",
	  "monitorizar",
	  "arquitectura abierta",
	  "sistema abierto",
	  "orquestar",
	  "paradigma",
	  "paralelismo",
	  "política",
	  "portal",
	  "estructura de precios",
	  "proceso de mejora",
	  "producto",
	  "productividad",
	  "proyecto",
	  "proyección",
	  "protocolo",
	  "línea segura",
	  "software",
	  "solución",
	  "estandardización",
	  "estrategia",
	  "estructura",
	  "éxito",
	  "superestructura",
	  "soporte",
	  "sinergia",
	  "mediante",
	  "marco de tiempo",
	  "caja de herramientas",
	  "utilización",
	  "website",
	  "fuerza de trabajo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.L.",
	  "e Hijos",
	  "S.A.",
	  "Hermanos"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var es_MX = {};
	module['exports'] = es_MX;
	es_MX.title = "Spanish Mexico";
	es_MX.separator = " & ";
	es_MX.name = __webpack_require__(2287);
	es_MX.address = __webpack_require__(2254);
	es_MX.company = __webpack_require__(2275);
	es_MX.internet = __webpack_require__(2282);
	es_MX.phone_number = __webpack_require__(2294);
	es_MX.cell_phone = __webpack_require__(2265);
	es_MX.lorem = __webpack_require__(2283);
	es_MX.commerce = __webpack_require__(2268);
	es_MX.team = __webpack_require__(2296);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "mx",
	  "info",
	  "com.mx",
	  "org",
	  "gob.mx"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "nearbpo.com",
	  "corpfolder.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2281);
	internet.domain_suffix = __webpack_require__(2280);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2285);
	lorem.supplemental = __webpack_require__(2284);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	"Abacalero",
	"Abacería",
	"Abacero",
	"Abacial",
	"Abaco",
	"Abacora",
	"Abacorar",
	"Abad",
	"Abada",
	"Abadejo",
	"Abadengo",
	"Abadernar",
	"Abadesa",
	"Abadí",
	"Abadía",
	"Abadiado",
	"Abadiato",
	"Abajadero",
	"Abajamiento",
	"Abajar",
	"Abajeño",
	"Abajera",
	"Abajo",
	"Abalada",
	"Abalanzar",
	"Abalar",
	"Abalaustrado",
	"Abaldonadamente",
	"Abaldonamiento",
	"Bastonada",
	"Bastonazo",
	"Bastoncillo",
	"Bastonear",
	"Bastonero",
	"Bástulo",
	"Basura",
	"Basural",
	"Basurear",
	"Basurero",
	"Bata",
	"Batacazo",
	"Batahola",
	"Batalán",
	"Batalla",
	"Batallador",
	"Batallar",
	"Batallaroso",
	"Batallola",
	"Batallón",
	"Batallona",
	"Batalloso",
	"Batán",
	"Batanar",
	"Batanear",
	"Batanero",
	"Batanga",
	"Bataola",
	"Batata",
	"Batatazo",
	"Batato",
	"Batavia",
	"Bátavo",
	"Batayola",
	"Batazo",
	"Bate",
	"Batea",
	"Bateador",
	"Bateaguas",
	"Cenagar",
	"Cenagoso",
	"Cenal",
	"Cenaoscuras",
	"Ceñar",
	"Cenata",
	"Cenca",
	"Cencapa",
	"Cencellada",
	"Cenceñada",
	"Cenceño",
	"Cencero",
	"Cencerra",
	"Cencerrada",
	"Cencerrado",
	"Cencerrear",
	"Cencerreo",
	"Cencerril",
	"Cencerrillas",
	"Cencerro",
	"Cencerrón",
	"Cencha",
	"Cencido",
	"Cencío",
	"Cencivera",
	"Cenco",
	"Cencuate",
	"Cendal",
	"Cendalí",
	"Céndea",
	"Cendolilla",
	"Cendra",
	"Cendrada",
	"Cendradilla",
	"Cendrado",
	"Cendrar",
	"Cendrazo",
	"Cenefa",
	"Cenegar",
	"Ceneque",
	"Cenero",
	"Cenestesia",
	"Desceñir",
	"Descensión",
	"Descenso",
	"Descentrado",
	"Descentralización",
	"Descentralizador",
	"Descentralizar",
	"Descentrar",
	"Descepar",
	"Descerar",
	"Descercado",
	"Descercador",
	"Descercar",
	"Descerco",
	"Descerebración",
	"Descerebrado",
	"Descerebrar",
	"Descerezar",
	"Descerrajado",
	"Descerrajadura",
	"Descerrajar",
	"Descerrar",
	"Descerrumarse",
	"Descervigamiento",
	"Descervigar",
	"Deschapar",
	"Descharchar",
	"Deschavetado",
	"Deschavetarse",
	"Deschuponar",
	"Descifrable",
	"Descifrador",
	"Desciframiento",
	"Descifrar",
	"Descifre",
	"Descimbramiento",
	"Descimbrar",
	"Engarbarse",
	"Engarberar",
	"Engarbullar",
	"Engarce",
	"Engarfiar",
	"Engargantadura",
	"Engargantar",
	"Engargante",
	"Engargolado",
	"Engargolar",
	"Engaritar",
	"Engarmarse",
	"Engarnio",
	"Engarrafador",
	"Engarrafar",
	"Engarrar",
	"Engarro",
	"Engarronar",
	"Engarrotar",
	"Engarzador",
	"Engarzadura",
	"Engarzar",
	"Engasgarse",
	"Engastador",
	"Engastadura",
	"Engastar",
	"Engaste",
	"Ficción",
	"Fice",
	"Ficha",
	"Fichaje",
	"Fichar",
	"Fichero",
	"Ficoideo",
	"Ficticio",
	"Fidalgo",
	"Fidecomiso",
	"Fidedigno",
	"Fideero",
	"Fideicomisario",
	"Fideicomiso",
	"Fideicomitente",
	"Fideísmo",
	"Fidelidad",
	"Fidelísimo",
	"Fideo",
	"Fido",
	"Fiducia",
	"Geminación",
	"Geminado",
	"Geminar",
	"Géminis",
	"Gémino",
	"Gemíparo",
	"Gemiquear",
	"Gemiqueo",
	"Gemir",
	"Gemología",
	"Gemológico",
	"Gemólogo",
	"Gemonias",
	"Gemoso",
	"Gemoterapia",
	"Gen",
	"Genciana",
	"Gencianáceo",
	"Gencianeo",
	"Gendarme",
	"Gendarmería",
	"Genealogía",
	"Genealógico",
	"Genealogista",
	"Genearca",
	"Geneático",
	"Generable",
	"Generación",
	"Generacional",
	"Generador",
	"General",
	"Generala",
	"Generalato",
	"Generalidad",
	"Generalísimo",
	"Incordio",
	"Incorporación",
	"Incorporal",
	"Incorporalmente",
	"Incorporar",
	"Incorporeidad",
	"Incorpóreo",
	"Incorporo",
	"Incorrección",
	"Incorrectamente",
	"Incorrecto",
	"Incorregibilidad",
	"Incorregible",
	"Incorregiblemente",
	"Incorrupción",
	"Incorruptamente",
	"Incorruptibilidad",
	"Incorruptible",
	"Incorrupto",
	"Incrasar",
	"Increado",
	"Incredibilidad",
	"Incrédulamente",
	"Incredulidad",
	"Incrédulo",
	"Increíble",
	"Increíblemente",
	"Incrementar",
	"Incremento",
	"Increpación",
	"Increpador",
	"Increpar",
	"Incriminación",
	"Incriminar",
	"Incristalizable",
	"Incruentamente",
	"Incruento",
	"Incrustación"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	"Aarón",
	"Abraham",
	"Adán",
	"Agustín",
	"Alan",
	"Alberto",
	"Alejandro",
	"Alexander",
	"Alexis",
	"Alfonso",
	"Alfredo",
	"Andrés",
	"Ángel Daniel",
	"Ángel Gabriel",
	"Antonio",
	"Armando",
	"Arturo",
	"Axel",
	"Benito",
	"Benjamín",
	"Bernardo",
	"Brandon",
	"Brayan",
	"Carlos",
	"César",
	"Claudio",
	"Clemente",
	"Cristian",
	"Cristobal",
	"Damián",
	"Daniel",
	"David",
	"Diego",
	"Eduardo",
	"Elías",
	"Emiliano",
	"Emilio",
	"Emilio",
	"Emmanuel",
	"Enrique",
	"Erick",
	"Ernesto",
	"Esteban",
	"Federico",
	"Felipe",
	"Fernando",
	"Fernando Javier",
	"Francisco",
	"Francisco Javier",
	"Gabriel",
	"Gael",
	"Gerardo",
	"Germán",
	"Gilberto",
	"Gonzalo",
	"Gregorio",
	"Guillermo",
	"Gustavo",
	"Hernán",
	"Homero",
	"Horacio",
	"Hugo",
	"Ignacio",
	"Iker",
	"Isaac",
	"Isaias",
	"Israel",
	"Ivan",
	"Jacobo",
	"Jaime",
	"Javier",
	"Jerónimo",
	"Jesús",
	"Joaquín",
	"Jorge",
	"Jorge Luis",
	"José",
	"José Antonio",
	"Jose Daniel",
	"José Eduardo",
	"José Emilio",
	"José Luis",
	"José María",
	"José Miguel",
	"Juan",
	"Juan Carlos",
	"Juan Manuel",
	"Juan Pablo",
	"Julio",
	"Julio César",
	"Kevin",
	"Leonardo",
	"Lorenzo",
	"Lucas",
	"Luis",
	"Luis Ángel",
	"Luis Fernando",
	"Luis Gabino",
	"Luis Miguel",
	"Manuel",
	"Marco Antonio",
	"Marcos",
	"Mariano",
	"Mario",
	"Martín",
	"Mateo",
	"Matías",
	"Mauricio",
	"Maximiliano",
	"Miguel",
	"Miguel Ángel",
	"Nicolás",
	"Octavio",
	"Óscar",
	"Pablo",
	"Patricio",
	"Pedro",
	"Rafael",
	"Ramiro",
	"Ramón",
	"Raúl",
	"Ricardo",
	"Roberto",
	"Rodrigo",
	"Rubén",
	"Salvador",
	"Samuel",
	"Sancho",
	"Santiago",
	"Saúl",
	"Sebastian",
	"Sergio",
	"Tadeo",
	"Teodoro",
	"Timoteo",
	"Tomás",
	"Uriel",
	"Vicente",
	"Víctor",
	"Victor Manuel",
	"Adriana",
	"Alejandra",
	"Alicia",
	"Amalia",
	"Ana",
	"Ana Luisa",
	"Ana María",
	"Andrea",
	"Ángela",
	"Anita",
	"Antonia",
	"Araceli",
	"Ariadna",
	"Barbara",
	"Beatriz",
	"Berta",
	"Blanca",
	"Caridad",
	"Carla",
	"Carlota",
	"Carmen",
	"Carolina",
	"Catalina",
	"Cecilia",
	"Clara",
	"Claudia",
	"Concepción",
	"Conchita",
	"Cristina",
	"Daniela",
	"Débora",
	"Diana",
	"Dolores",
	"Dorotea",
	"Elena",
	"Elisa",
	"Elizabeth",
	"Eloisa",
	"Elsa",
	"Elvira",
	"Emilia",
	"Esperanza",
	"Estela",
	"Ester",
	"Eva",
	"Florencia",
	"Francisca",
	"Gabriela",
	"Gloria",
	"Graciela",
	"Guadalupe",
	"Guillermina",
	"Inés",
	"Irene",
	"Isabel",
	"Isabela",
	"Josefina",
	"Juana",
	"Julia",
	"Laura",
	"Leonor",
	"Leticia",
	"Lilia",
	"Lola",
	"Lorena",
	"Lourdes",
	"Lucia",
	"Luisa",
	"Luz",
	"Magdalena",
	"Manuela",
	"Marcela",
	"Margarita",
	"María",
	"María Cristina",
	"María de Jesús",
	"María de los Ángeles",
	"María del Carmen",
	"María Elena",
	"María Eugenia",
	"María Guadalupe",
	"María José",
	"María Luisa",
	"María Soledad",
	"María Teresa",
	"Mariana",
	"Maricarmen",
	"Marilu",
	"Marisol",
	"Marta",
	"Mayte",
	"Mercedes",
	"Micaela",
	"Mónica",
	"Natalia",
	"Norma",
	"Olivia",
	"Patricia",
	"Pilar",
	"Ramona",
	"Raquel",
	"Rebeca",
	"Reina",
	"Rocio",
	"Rosa",
	"Rosa María",
	"Rosalia",
	"Rosario",
	"Sara",
	"Silvia",
	"Sofia",
	"Soledad",
	"Sonia",
	"Susana",
	"Teresa",
	"Verónica",
	"Victoria",
	"Virginia",
	"Xochitl",
	"Yolanda",
	"Abigail",
	"Abril",
	"Adela",
	"Alexa",
	"Alondra Romina",
	"Ana Sofía",
	"Ana Victoria",
	"Camila",
	"Carolina",
	"Daniela",
	"Dulce María",
	"Emily",
	"Esmeralda",
	"Estefanía",
	"Evelyn",
	"Fatima",
	"Ivanna",
	"Jazmin",
	"Jennifer",
	"Jimena",
	"Julieta",
	"Kimberly",
	"Liliana",
	"Lizbeth",
	"María Fernanda",
	"Melany",
	"Melissa",
	"Miranda",
	"Monserrat",
	"Naomi",
	"Natalia",
	"Nicole",
	"Paola",
	"Paulina",
	"Regina",
	"Renata",
	"Valentina",
	"Valeria",
	"Vanessa",
	"Ximena",
	"Ximena Guadalupe",
	"Yamileth",
	"Yaretzi",
	"Zoe"
	]
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2286);
	name.last_name = __webpack_require__(2288);
	name.prefix = __webpack_require__(2290);
	name.suffix = __webpack_require__(2291);
	name.title = __webpack_require__(2292);
	name.name = __webpack_require__(2289);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abeyta",
	"Abrego",
	"Abreu",
	"Acevedo",
	"Acosta",
	"Acuña",
	"Adame",
	"Adorno",
	"Agosto",
	"Aguayo",
	"Águilar",
	"Aguilera",
	"Aguirre",
	"Alanis",
	"Alaniz",
	"Alarcón",
	"Alba",
	"Alcala",
	"Alcántar",
	"Alcaraz",
	"Alejandro",
	"Alemán",
	"Alfaro",
	"Alicea",
	"Almanza",
	"Almaraz",
	"Almonte",
	"Alonso",
	"Alonzo",
	"Altamirano",
	"Alva",
	"Alvarado",
	"Alvarez",
	"Amador",
	"Amaya",
	"Anaya",
	"Anguiano",
	"Angulo",
	"Aparicio",
	"Apodaca",
	"Aponte",
	"Aragón",
	"Aranda",
	"Araña",
	"Arce",
	"Archuleta",
	"Arellano",
	"Arenas",
	"Arevalo",
	"Arguello",
	"Arias",
	"Armas",
	"Armendáriz",
	"Armenta",
	"Armijo",
	"Arredondo",
	"Arreola",
	"Arriaga",
	"Arroyo",
	"Arteaga",
	"Atencio",
	"Ávalos",
	"Ávila",
	"Avilés",
	"Ayala",
	"Baca",
	"Badillo",
	"Báez",
	"Baeza",
	"Bahena",
	"Balderas",
	"Ballesteros",
	"Banda",
	"Bañuelos",
	"Barajas",
	"Barela",
	"Barragán",
	"Barraza",
	"Barrera",
	"Barreto",
	"Barrientos",
	"Barrios",
	"Batista",
	"Becerra",
	"Beltrán",
	"Benavides",
	"Benavídez",
	"Benítez",
	"Bermúdez",
	"Bernal",
	"Berríos",
	"Bétancourt",
	"Blanco",
	"Bonilla",
	"Borrego",
	"Botello",
	"Bravo",
	"Briones",
	"Briseño",
	"Brito",
	"Bueno",
	"Burgos",
	"Bustamante",
	"Bustos",
	"Caballero",
	"Cabán",
	"Cabrera",
	"Cadena",
	"Caldera",
	"Calderón",
	"Calvillo",
	"Camacho",
	"Camarillo",
	"Campos",
	"Canales",
	"Candelaria",
	"Cano",
	"Cantú",
	"Caraballo",
	"Carbajal",
	"Cardenas",
	"Cardona",
	"Carmona",
	"Carranza",
	"Carrasco",
	"Carrasquillo",
	"Carreón",
	"Carrera",
	"Carrero",
	"Carrillo",
	"Carrion",
	"Carvajal",
	"Casanova",
	"Casares",
	"Casárez",
	"Casas",
	"Casillas",
	"Castañeda",
	"Castellanos",
	"Castillo",
	"Castro",
	"Cavazos",
	"Cazares",
	"Ceballos",
	"Cedillo",
	"Ceja",
	"Centeno",
	"Cepeda",
	"Cerda",
	"Cervantes",
	"Cervántez",
	"Chacón",
	"Chapa",
	"Chavarría",
	"Chávez",
	"Cintrón",
	"Cisneros",
	"Collado",
	"Collazo",
	"Colón",
	"Colunga",
	"Concepción",
	"Contreras",
	"Cordero",
	"Córdova",
	"Cornejo",
	"Corona",
	"Coronado",
	"Corral",
	"Corrales",
	"Correa",
	"Cortés",
	"Cortez",
	"Cotto",
	"Covarrubias",
	"Crespo",
	"Cruz",
	"Cuellar",
	"Curiel",
	"Dávila",
	"de Anda",
	"de Jesús",
	"Delacrúz",
	"Delafuente",
	"Delagarza",
	"Delao",
	"Delapaz",
	"Delarosa",
	"Delatorre",
	"Deleón",
	"Delgadillo",
	"Delgado",
	"Delrío",
	"Delvalle",
	"Díaz",
	"Domínguez",
	"Domínquez",
	"Duarte",
	"Dueñas",
	"Duran",
	"Echevarría",
	"Elizondo",
	"Enríquez",
	"Escalante",
	"Escamilla",
	"Escobar",
	"Escobedo",
	"Esparza",
	"Espinal",
	"Espino",
	"Espinosa",
	"Espinoza",
	"Esquibel",
	"Esquivel",
	"Estévez",
	"Estrada",
	"Fajardo",
	"Farías",
	"Feliciano",
	"Fernández",
	"Ferrer",
	"Fierro",
	"Figueroa",
	"Flores",
	"Flórez",
	"Fonseca",
	"Franco",
	"Frías",
	"Fuentes",
	"Gaitán",
	"Galarza",
	"Galindo",
	"Gallardo",
	"Gallegos",
	"Galván",
	"Gálvez",
	"Gamboa",
	"Gamez",
	"Gaona",
	"Garay",
	"García",
	"Garibay",
	"Garica",
	"Garrido",
	"Garza",
	"Gastélum",
	"Gaytán",
	"Gil",
	"Girón",
	"Godínez",
	"Godoy",
	"Gollum",
	"Gómez",
	"Gonzales",
	"González",
	"Gracia",
	"Granado",
	"Granados",
	"Griego",
	"Grijalva",
	"Guajardo",
	"Guardado",
	"Guerra",
	"Guerrero",
	"Guevara",
	"Guillen",
	"Gurule",
	"Gutiérrez",
	"Guzmán",
	"Haro",
	"Henríquez",
	"Heredia",
	"Hernádez",
	"Hernandes",
	"Hernández",
	"Herrera",
	"Hidalgo",
	"Hinojosa",
	"Holguín",
	"Huerta",
	"Huixtlacatl",
	"Hurtado",
	"Ibarra",
	"Iglesias",
	"Irizarry",
	"Jaime",
	"Jaimes",
	"Jáquez",
	"Jaramillo",
	"Jasso",
	"Jiménez",
	"Jimínez",
	"Juárez",
	"Jurado",
	"Kadar rodriguez",
	"Kamal",
	"Kamat",
	"Kanaria",
	"Kanea",
	"Kanimal",
	"Kano",
	"Kanzaki",
	"Kaplan",
	"Kara",
	"Karam",
	"Karan",
	"Kardache soto",
	"Karem",
	"Karen",
	"Khalid",
	"Kindelan",
	"Koenig",
	"Korta",
	"Korta hernandez",
	"Kortajarena",
	"Kranz sans",
	"Krasnova",
	"Krauel natera",
	"Kuzmina",
	"Kyra",
	"Laboy",
	"Lara",
	"Laureano",
	"Leal",
	"Lebrón",
	"Ledesma",
	"Leiva",
	"Lemus",
	"León",
	"Lerma",
	"Leyva",
	"Limón",
	"Linares",
	"Lira",
	"Llamas",
	"Loera",
	"Lomeli",
	"Longoria",
	"López",
	"Lovato",
	"Loya",
	"Lozada",
	"Lozano",
	"Lucero",
	"Lucio",
	"Luevano",
	"Lugo",
	"Luna",
	"Macías",
	"Madera",
	"Madrid",
	"Madrigal",
	"Maestas",
	"Magaña",
	"Malave",
	"Maldonado",
	"Manzanares",
	"Mares",
	"Marín",
	"Márquez",
	"Marrero",
	"Marroquín",
	"Martínez",
	"Mascareñas",
	"Mata",
	"Mateo",
	"Matías",
	"Matos",
	"Maya",
	"Mayorga",
	"Medina",
	"Medrano",
	"Mejía",
	"Meléndez",
	"Melgar",
	"Mena",
	"Menchaca",
	"Méndez",
	"Mendoza",
	"Menéndez",
	"Meraz",
	"Mercado",
	"Merino",
	"Mesa",
	"Meza",
	"Miramontes",
	"Miranda",
	"Mireles",
	"Mojica",
	"Molina",
	"Mondragón",
	"Monroy",
	"Montalvo",
	"Montañez",
	"Montaño",
	"Montemayor",
	"Montenegro",
	"Montero",
	"Montes",
	"Montez",
	"Montoya",
	"Mora",
	"Morales",
	"Moreno",
	"Mota",
	"Moya",
	"Munguía",
	"Muñiz",
	"Muñoz",
	"Murillo",
	"Muro",
	"Nájera",
	"Naranjo",
	"Narváez",
	"Nava",
	"Navarrete",
	"Navarro",
	"Nazario",
	"Negrete",
	"Negrón",
	"Nevárez",
	"Nieto",
	"Nieves",
	"Niño",
	"Noriega",
	"Núñez",
	"Ñañez",
	"Ocampo",
	"Ocasio",
	"Ochoa",
	"Ojeda",
	"Olivares",
	"Olivárez",
	"Olivas",
	"Olivera",
	"Olivo",
	"Olmos",
	"Olvera",
	"Ontiveros",
	"Oquendo",
	"Ordóñez",
	"Orellana",
	"Ornelas",
	"Orosco",
	"Orozco",
	"Orta",
	"Ortega",
	"Ortiz",
	"Osorio",
	"Otero",
	"Ozuna",
	"Pabón",
	"Pacheco",
	"Padilla",
	"Padrón",
	"Páez",
	"Pagan",
	"Palacios",
	"Palomino",
	"Palomo",
	"Pantoja",
	"Paredes",
	"Parra",
	"Partida",
	"Patiño",
	"Paz",
	"Pedraza",
	"Pedroza",
	"Pelayo",
	"Peña",
	"Perales",
	"Peralta",
	"Perea",
	"Peres",
	"Pérez",
	"Pichardo",
	"Pineda",
	"Piña",
	"Pizarro",
	"Polanco",
	"Ponce",
	"Porras",
	"Portillo",
	"Posada",
	"Prado",
	"Preciado",
	"Prieto",
	"Puente",
	"Puga",
	"Pulido",
	"Quesada",
	"Quevedo",
	"Quezada",
	"Quinta",
	"Quintairos",
	"Quintana",
	"Quintanilla",
	"Quintero",
	"Quintero cruz",
	"Quintero de la cruz",
	"Quiñones",
	"Quiñónez",
	"Quiros",
	"Quiroz",
	"Rael",
	"Ramírez",
	"Ramón",
	"Ramos",
	"Rangel",
	"Rascón",
	"Raya",
	"Razo",
	"Regalado",
	"Rendón",
	"Rentería",
	"Reséndez",
	"Reyes",
	"Reyna",
	"Reynoso",
	"Rico",
	"Rincón",
	"Riojas",
	"Ríos",
	"Rivas",
	"Rivera",
	"Rivero",
	"Robledo",
	"Robles",
	"Rocha",
	"Rodarte",
	"Rodrígez",
	"Rodríguez",
	"Rodríquez",
	"Rojas",
	"Rojo",
	"Roldán",
	"Rolón",
	"Romero",
	"Romo",
	"Roque",
	"Rosado",
	"Rosales",
	"Rosario",
	"Rosas",
	"Roybal",
	"Rubio",
	"Ruelas",
	"Ruiz",
	"Saavedra",
	"Sáenz",
	"Saiz",
	"Salas",
	"Salazar",
	"Salcedo",
	"Salcido",
	"Saldaña",
	"Saldivar",
	"Salgado",
	"Salinas",
	"Samaniego",
	"Sanabria",
	"Sanches",
	"Sánchez",
	"Sandoval",
	"Santacruz",
	"Santana",
	"Santiago",
	"Santillán",
	"Sarabia",
	"Sauceda",
	"Saucedo",
	"Sedillo",
	"Segovia",
	"Segura",
	"Sepúlveda",
	"Serna",
	"Serrano",
	"Serrato",
	"Sevilla",
	"Sierra",
	"Sisneros",
	"Solano",
	"Solís",
	"Soliz",
	"Solorio",
	"Solorzano",
	"Soria",
	"Sosa",
	"Sotelo",
	"Soto",
	"Suárez",
	"Tafoya",
	"Tamayo",
	"Tamez",
	"Tapia",
	"Tejada",
	"Tejeda",
	"Téllez",
	"Tello",
	"Terán",
	"Terrazas",
	"Tijerina",
	"Tirado",
	"Toledo",
	"Toro",
	"Torres",
	"Tórrez",
	"Tovar",
	"Trejo",
	"Treviño",
	"Trujillo",
	"Ulibarri",
	"Ulloa",
	"Urbina",
	"Ureña",
	"Urías",
	"Uribe",
	"Urrutia",
	"Vaca",
	"Valadez",
	"Valdés",
	"Valdez",
	"Valdivia",
	"Valencia",
	"Valentín",
	"Valenzuela",
	"Valladares",
	"Valle",
	"Vallejo",
	"Valles",
	"Valverde",
	"Vanegas",
	"Varela",
	"Vargas",
	"Vásquez",
	"Vázquez",
	"Vega",
	"Vela",
	"Velasco",
	"Velásquez",
	"Velázquez",
	"Vélez",
	"Véliz",
	"Venegas",
	"Vera",
	"Verdugo",
	"Verduzco",
	"Vergara",
	"Viera",
	"Vigil",
	"Villa",
	"Villagómez",
	"Villalobos",
	"Villalpando",
	"Villanueva",
	"Villareal",
	"Villarreal",
	"Villaseñor",
	"Villegas",
	"Xacon",
	"Xairo Belmonte",
	"Xana",
	"Xenia",
	"Xiana",
	"Xicoy",
	"Yago",
	"Yami",
	"Yanes",
	"Yáñez",
	"Ybarra",
	"Yebra",
	"Yunta",
	"Zabaleta",
	"Zamarreno",
	"Zamarripa",
	"Zambrana",
	"Zambrano",
	"Zamora",
	"Zamudio",
	"Zapata",
	"Zaragoza",
	"Zarate",
	"Zavala",
	"Zayas",
	"Zelaya",
	"Zepeda",
	"Zúñiga"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} de #{last_name}",
	  "#{suffix} #{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Sta."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V",
	  "MD",
	  "DDS",
	  "PhD",
	  "DVM",
	  "Ing.",
	  "Lic.",
	  "Dr.",
	  "Mtro."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) { module["exports"] = {
	  "descriptor": [
	    "Jefe",
	    "Senior",
	    "Directo",
	    "Corporativo",
	    "Dinánmico",
	    "Futuro",
	    "Producto",
	    "Nacional",
	    "Regional",
	    "Distrito",
	    "Central",
	    "Global",
	    "Cliente",
	    "Inversor",
	    "International",
	    "Heredado",
	    "Adelante",
	    "Interno",
	    "Humano",
	    "Gerente",
	    "SubGerente",
	    "Director"
	  ],
	  "level": [
	    "Soluciones",
	    "Programa",
	    "Marca",
	    "Seguridad",
	    "Investigación",
	    "Marketing",
	    "Normas",
	    "Implementación",
	    "Integración",
	    "Funcionalidad",
	    "Respuesta",
	    "Paradigma",
	    "Tácticas",
	    "Identidad",
	    "Mercados",
	    "Grupo",
	    "División",
	    "Aplicaciones",
	    "Optimización",
	    "Operaciones",
	    "Infraestructura",
	    "Intranet",
	    "Comunicaciones",
	    "Web",
	    "Calidad",
	    "Seguro",
	    "Mobilidad",
	    "Cuentas",
	    "Datos",
	    "Creativo",
	    "Configuración",
	    "Contabilidad",
	    "Interacciones",
	    "Factores",
	    "Usabilidad",
	    "Métricas",
	  ],
	  "job": [
	    "Supervisor",
	    "Asociado",
	    "Ejecutivo",
	    "Relacciones",
	    "Oficial",
	    "Gerente",
	    "Ingeniero",
	    "Especialista",
	    "Director",
	    "Coordinador",
	    "Administrador",
	    "Arquitecto",
	    "Analista",
	    "Diseñador",
	    "Planificador",
	    "Técnico",
	    "Funcionario",
	    "Desarrollador",
	    "Productor",
	    "Consultor",
	    "Asistente",
	    "Facilitador",
	    "Agente",
	    "Representante",
	    "Estratega",
	    "Scrum Master",
	    "Scrum Owner",
	    "Product Owner",
	    "Scrum Developer"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5###-###-###",
	  "5##.###.###",
	  "5## ### ###",
	  "5########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2293);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "hormigas",
	   "murciélagos",
	   "osos",
	   "abejas",
	   "pájaros",
	   "búfalo",
	   "gatos",
	   "pollos",
	   "ganado",
	   "perros",
	   "delfines",
	   "patos",
	   "elefantes",
	   "peces",
	   "zorros",
	   "ranas",
	   "gansos",
	   "cabras",
	   "caballos",
	   "canguros",
	   "leones",
	   "monos",
	   "búhos",
	   "bueyes",
	   "pingüinos",
	   "pueblo",
	   "cerdos",
	   "conejos",
	   "ovejas",
	   "tigres",
	   "ballenas",
	   "lobos",
	   "cebras",
	   "almas en pena",
	   "cuervos",
	   "gatos negros",
	   "quimeras",
	   "fantasmas",
	   "conspiradores",
	   "dragones",
	   "enanos",
	   "duendes",
	   "encantadores",
	   "exorcistas",
	   "hijos",
	   "enemigos",
	   "gigantes",
	   "gnomos",
	   "duendes",
	   "gansos",
	   "grifos",
	   "licántropos",
	   "némesis",
	   "ogros",
	   "oráculos",
	   "profetas",
	   "hechiceros",
	   "arañas",
	   "espíritus",
	   "vampiros",
	   "brujos",
	   "zorras",
	   "hombres lobo",
	   "brujas",
	   "adoradores",
	   "zombies",
	   "druidas"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.creature = __webpack_require__(2295);
	team.name = __webpack_require__(2297);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.state} #{creature}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fa = {};
	module['exports'] = fa;
	fa.title = "Farsi";
	fa.name = __webpack_require__(2300);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "آبان دخت",
	  "آبتین",
	  "آتوسا",
	  "آفر",
	  "آفره دخت",
	  "آذرنوش‌",
	  "آذین",
	  "آراه",
	  "آرزو",
	  "آرش",
	  "آرتین",
	  "آرتام",
	  "آرتمن",
	  "آرشام",
	  "آرمان",
	  "آرمین",
	  "آرمیتا",
	  "آریا فر",
	  "آریا",
	  "آریا مهر",
	  "آرین",
	  "آزاده",
	  "آزرم",
	  "آزرمدخت",
	  "آزیتا",
	  "آناهیتا",
	  "آونگ",
	  "آهو",
	  "آیدا",
	  "اتسز",
	  "اختر",
	  "ارد",
	  "ارد شیر",
	  "اردوان",
	  "ارژن",
	  "ارژنگ",
	  "ارسلان",
	  "ارغوان",
	  "ارمغان",
	  "ارنواز",
	  "اروانه",
	  "استر",
	  "اسفندیار",
	  "اشکان",
	  "اشکبوس",
	  "افسانه",
	  "افسون",
	  "افشین",
	  "امید",
	  "انوش (‌ آنوشا )",
	  "انوشروان",
	  "اورنگ",
	  "اوژن",
	  "اوستا",
	  "اهورا",
	  "ایاز",
	  "ایران",
	  "ایراندخت",
	  "ایرج",
	  "ایزدیار",
	  "بابک",
	  "باپوک",
	  "باربد",
	  "بارمان",
	  "بامداد",
	  "بامشاد",
	  "بانو",
	  "بختیار",
	  "برانوش",
	  "بردیا",
	  "برزو",
	  "برزویه",
	  "برزین",
	  "برمک",
	  "بزرگمهر",
	  "بنفشه",
	  "بوژان",
	  "بویان",
	  "بهار",
	  "بهارک",
	  "بهاره",
	  "بهتاش",
	  "بهداد",
	  "بهرام",
	  "بهدیس",
	  "بهرخ",
	  "بهرنگ",
	  "بهروز",
	  "بهزاد",
	  "بهشاد",
	  "بهمن",
	  "بهناز",
	  "بهنام",
	  "بهنود",
	  "بهنوش",
	  "بیتا",
	  "بیژن",
	  "پارسا",
	  "پاکان",
	  "پاکتن",
	  "پاکدخت",
	  "پانته آ",
	  "پدرام",
	  "پرتو",
	  "پرشنگ",
	  "پرتو",
	  "پرستو",
	  "پرویز",
	  "پردیس",
	  "پرهام",
	  "پژمان",
	  "پژوا",
	  "پرنیا",
	  "پشنگ",
	  "پروانه",
	  "پروین",
	  "پری",
	  "پریچهر",
	  "پریدخت",
	  "پریسا",
	  "پرناز",
	  "پریوش",
	  "پریا",
	  "پوپک",
	  "پوران",
	  "پوراندخت",
	  "پوریا",
	  "پولاد",
	  "پویا",
	  "پونه",
	  "پیام",
	  "پیروز",
	  "پیمان",
	  "تابان",
	  "تاباندخت",
	  "تاجی",
	  "تارا",
	  "تاویار",
	  "ترانه",
	  "تناز",
	  "توران",
	  "توراندخت",
	  "تورج",
	  "تورتک",
	  "توفان",
	  "توژال",
	  "تیر داد",
	  "تینا",
	  "تینو",
	  "جابان",
	  "جامین",
	  "جاوید",
	  "جریره",
	  "جمشید",
	  "جوان",
	  "جویا",
	  "جهان",
	  "جهانبخت",
	  "جهانبخش",
	  "جهاندار",
	  "جهانگیر",
	  "جهان بانو",
	  "جهاندخت",
	  "جهان ناز",
	  "جیران",
	  "چابک",
	  "چالاک",
	  "چاوش",
	  "چترا",
	  "چوبین",
	  "چهرزاد",
	  "خاوردخت",
	  "خداداد",
	  "خدایار",
	  "خرم",
	  "خرمدخت",
	  "خسرو",
	  "خشایار",
	  "خورشید",
	  "دادمهر",
	  "دارا",
	  "داراب",
	  "داریا",
	  "داریوش",
	  "دانوش",
	  "داور‌",
	  "دایان",
	  "دریا",
	  "دل آرا",
	  "دل آویز",
	  "دلارام",
	  "دل انگیز",
	  "دلبر",
	  "دلبند",
	  "دلربا",
	  "دلشاد",
	  "دلکش",
	  "دلناز",
	  "دلنواز",
	  "دورشاسب",
	  "دنیا",
	  "دیااکو",
	  "دیانوش",
	  "دیبا",
	  "دیبا دخت",
	  "رابو",
	  "رابین",
	  "رادبانو",
	  "رادمان",
	  "رازبان",
	  "راژانه",
	  "راسا",
	  "رامتین",
	  "رامش",
	  "رامشگر",
	  "رامونا",
	  "رامیار",
	  "رامیلا",
	  "رامین",
	  "راویار",
	  "رژینا",
	  "رخپاک",
	  "رخسار",
	  "رخشانه",
	  "رخشنده",
	  "رزمیار",
	  "رستم",
	  "رکسانا",
	  "روبینا",
	  "رودابه",
	  "روزبه",
	  "روشنک",
	  "روناک",
	  "رهام",
	  "رهی",
	  "ریبار",
	  "راسپینا",
	  "زادبخت",
	  "زاد به",
	  "زاد چهر",
	  "زاد فر",
	  "زال",
	  "زادماسب",
	  "زاوا",
	  "زردشت",
	  "زرنگار",
	  "زری",
	  "زرین",
	  "زرینه",
	  "زمانه",
	  "زونا",
	  "زیبا",
	  "زیبار",
	  "زیما",
	  "زینو",
	  "ژاله",
	  "ژالان",
	  "ژیار",
	  "ژینا",
	  "ژیوار",
	  "سارا",
	  "سارک",
	  "سارنگ",
	  "ساره",
	  "ساسان",
	  "ساغر",
	  "سام",
	  "سامان",
	  "سانا",
	  "ساناز",
	  "سانیار",
	  "ساویز",
	  "ساهی",
	  "ساینا",
	  "سایه",
	  "سپنتا",
	  "سپند",
	  "سپهر",
	  "سپهرداد",
	  "سپیدار",
	  "سپید بانو",
	  "سپیده",
	  "ستاره",
	  "ستی",
	  "سرافراز",
	  "سرور",
	  "سروش",
	  "سرور",
	  "سوبا",
	  "سوبار",
	  "سنبله",
	  "سودابه",
	  "سوری",
	  "سورن",
	  "سورنا",
	  "سوزان",
	  "سوزه",
	  "سوسن",
	  "سومار",
	  "سولان",
	  "سولماز",
	  "سوگند",
	  "سهراب",
	  "سهره",
	  "سهند",
	  "سیامک",
	  "سیاوش",
	  "سیبوبه ‌",
	  "سیما",
	  "سیمدخت",
	  "سینا",
	  "سیمین",
	  "سیمین دخت",
	  "شاپرک",
	  "شادی",
	  "شادمهر",
	  "شاران",
	  "شاهپور",
	  "شاهدخت",
	  "شاهرخ",
	  "شاهین",
	  "شاهیندخت",
	  "شایسته",
	  "شباهنگ",
	  "شب بو",
	  "شبدیز",
	  "شبنم",
	  "شراره",
	  "شرمین",
	  "شروین",
	  "شکوفه",
	  "شکفته",
	  "شمشاد",
	  "شمین",
	  "شوان",
	  "شمیلا",
	  "شورانگیز",
	  "شوری",
	  "شهاب",
	  "شهبار",
	  "شهباز",
	  "شهبال",
	  "شهپر",
	  "شهداد",
	  "شهرآرا",
	  "شهرام",
	  "شهربانو",
	  "شهرزاد",
	  "شهرناز",
	  "شهرنوش",
	  "شهره",
	  "شهریار",
	  "شهرزاد",
	  "شهلا",
	  "شهنواز",
	  "شهین",
	  "شیبا",
	  "شیدا",
	  "شیده",
	  "شیردل",
	  "شیرزاد",
	  "شیرنگ",
	  "شیرو",
	  "شیرین دخت",
	  "شیما",
	  "شینا",
	  "شیرین",
	  "شیوا",
	  "طوس",
	  "طوطی",
	  "طهماسب",
	  "طهمورث",
	  "غوغا",
	  "غنچه",
	  "فتانه",
	  "فدا",
	  "فراز",
	  "فرامرز",
	  "فرانک",
	  "فراهان",
	  "فربد",
	  "فربغ",
	  "فرجاد",
	  "فرخ",
	  "فرخ پی",
	  "فرخ داد",
	  "فرخ رو",
	  "فرخ زاد",
	  "فرخ لقا",
	  "فرخ مهر",
	  "فرداد",
	  "فردیس",
	  "فرین",
	  "فرزاد",
	  "فرزام",
	  "فرزان",
	  "فرزانه",
	  "فرزین",
	  "فرشاد",
	  "فرشته",
	  "فرشید",
	  "فرمان",
	  "فرناز",
	  "فرنگیس",
	  "فرنود",
	  "فرنوش",
	  "فرنیا",
	  "فروتن",
	  "فرود",
	  "فروز",
	  "فروزان",
	  "فروزش",
	  "فروزنده",
	  "فروغ",
	  "فرهاد",
	  "فرهنگ",
	  "فرهود",
	  "فربار",
	  "فریبا",
	  "فرید",
	  "فریدخت",
	  "فریدون",
	  "فریمان",
	  "فریناز",
	  "فرینوش",
	  "فریوش",
	  "فیروز",
	  "فیروزه",
	  "قابوس",
	  "قباد",
	  "قدسی",
	  "کابان",
	  "کابوک",
	  "کارا",
	  "کارو",
	  "کاراکو",
	  "کامبخت",
	  "کامبخش",
	  "کامبیز",
	  "کامجو",
	  "کامدین",
	  "کامران",
	  "کامراوا",
	  "کامک",
	  "کامنوش",
	  "کامیار",
	  "کانیار",
	  "کاووس",
	  "کاوه",
	  "کتایون",
	  "کرشمه",
	  "کسری",
	  "کلاله",
	  "کمبوجیه",
	  "کوشا",
	  "کهبد",
	  "کهرام",
	  "کهزاد",
	  "کیارش",
	  "کیان",
	  "کیانا",
	  "کیانچهر",
	  "کیاندخت",
	  "کیانوش",
	  "کیاوش",
	  "کیخسرو",
	  "کیقباد",
	  "کیکاووس",
	  "کیوان",
	  "کیوان دخت",
	  "کیومرث",
	  "کیهان",
	  "کیاندخت",
	  "کیهانه",
	  "گرد آفرید",
	  "گردان",
	  "گرشا",
	  "گرشاسب",
	  "گرشین",
	  "گرگین",
	  "گزل",
	  "گشتاسب",
	  "گشسب",
	  "گشسب بانو",
	  "گل",
	  "گل آذین",
	  "گل آرا‌",
	  "گلاره",
	  "گل افروز",
	  "گلاله",
	  "گل اندام",
	  "گلاویز",
	  "گلباد",
	  "گلبار",
	  "گلبام",
	  "گلبان",
	  "گلبانو",
	  "گلبرگ",
	  "گلبو",
	  "گلبهار",
	  "گلبیز",
	  "گلپاره",
	  "گلپر",
	  "گلپری",
	  "گلپوش",
	  "گل پونه",
	  "گلچین",
	  "گلدخت",
	  "گلدیس",
	  "گلربا",
	  "گلرخ",
	  "گلرنگ",
	  "گلرو",
	  "گلشن",
	  "گلریز",
	  "گلزاد",
	  "گلزار",
	  "گلسا",
	  "گلشید",
	  "گلنار",
	  "گلناز",
	  "گلنسا",
	  "گلنواز",
	  "گلنوش",
	  "گلی",
	  "گودرز",
	  "گوماتو",
	  "گهر چهر",
	  "گوهر ناز",
	  "گیتی",
	  "گیسو",
	  "گیلدا",
	  "گیو",
	  "لادن",
	  "لاله",
	  "لاله رخ",
	  "لاله دخت",
	  "لبخند",
	  "لقاء",
	  "لومانا",
	  "لهراسب",
	  "مارال",
	  "ماری",
	  "مازیار",
	  "ماکان",
	  "مامک",
	  "مانا",
	  "ماندانا",
	  "مانوش",
	  "مانی",
	  "مانیا",
	  "ماهان",
	  "ماهاندخت",
	  "ماه برزین",
	  "ماه جهان",
	  "ماهچهر",
	  "ماهدخت",
	  "ماهور",
	  "ماهرخ",
	  "ماهزاد",
	  "مردآویز",
	  "مرداس",
	  "مرزبان",
	  "مرمر",
	  "مزدک",
	  "مژده",
	  "مژگان",
	  "مستان",
	  "مستانه",
	  "مشکاندخت",
	  "مشکناز",
	  "مشکین دخت",
	  "منیژه",
	  "منوچهر",
	  "مهبانو",
	  "مهبد",
	  "مه داد",
	  "مهتاب",
	  "مهدیس",
	  "مه جبین",
	  "مه دخت",
	  "مهر آذر",
	  "مهر آرا",
	  "مهر آسا",
	  "مهر آفاق",
	  "مهر افرین",
	  "مهرآب",
	  "مهرداد",
	  "مهر افزون",
	  "مهرام",
	  "مهران",
	  "مهراندخت",
	  "مهراندیش",
	  "مهرانفر",
	  "مهرانگیز",
	  "مهرداد",
	  "مهر دخت",
	  "مهرزاده ‌",
	  "مهرناز",
	  "مهرنوش",
	  "مهرنکار",
	  "مهرنیا",
	  "مهروز",
	  "مهری",
	  "مهریار",
	  "مهسا",
	  "مهستی",
	  "مه سیما",
	  "مهشاد",
	  "مهشید",
	  "مهنام",
	  "مهناز",
	  "مهنوش",
	  "مهوش",
	  "مهیار",
	  "مهین",
	  "مهین دخت",
	  "میترا",
	  "میخک",
	  "مینا",
	  "مینا دخت",
	  "مینو",
	  "مینودخت",
	  "مینو فر",
	  "نادر",
	  "ناز آفرین",
	  "نازبانو",
	  "نازپرور",
	  "نازچهر",
	  "نازفر",
	  "نازلی",
	  "نازی",
	  "نازیدخت",
	  "نامور",
	  "ناهید",
	  "ندا",
	  "نرسی",
	  "نرگس",
	  "نرمک",
	  "نرمین",
	  "نریمان",
	  "نسترن",
	  "نسرین",
	  "نسرین دخت",
	  "نسرین نوش",
	  "نکیسا",
	  "نگار",
	  "نگاره",
	  "نگارین",
	  "نگین",
	  "نوا",
	  "نوش",
	  "نوش آذر",
	  "نوش آور",
	  "نوشا",
	  "نوش آفرین",
	  "نوشدخت",
	  "نوشروان",
	  "نوشفر",
	  "نوشناز",
	  "نوشین",
	  "نوید",
	  "نوین",
	  "نوین دخت",
	  "نیش ا",
	  "نیک بین",
	  "نیک پی",
	  "نیک چهر",
	  "نیک خواه",
	  "نیکداد",
	  "نیکدخت",
	  "نیکدل",
	  "نیکزاد",
	  "نیلوفر",
	  "نیما",
	  "وامق",
	  "ورجاوند",
	  "وریا",
	  "وشمگیر",
	  "وهرز",
	  "وهسودان",
	  "ویدا",
	  "ویس",
	  "ویشتاسب",
	  "ویگن",
	  "هژیر",
	  "هخامنش",
	  "هربد( هیربد )",
	  "هرمز",
	  "همایون",
	  "هما",
	  "همادخت",
	  "همدم",
	  "همراز",
	  "همراه",
	  "هنگامه",
	  "هوتن",
	  "هور",
	  "هورتاش",
	  "هورچهر",
	  "هورداد",
	  "هوردخت",
	  "هورزاد",
	  "هورمند",
	  "هوروش",
	  "هوشنگ",
	  "هوشیار",
	  "هومان",
	  "هومن",
	  "هونام",
	  "هویدا",
	  "هیتاسب",
	  "هیرمند",
	  "هیما",
	  "هیوا",
	  "یادگار",
	  "یاسمن ( یاسمین )",
	  "یاشار",
	  "یاور",
	  "یزدان",
	  "یگانه",
	  "یوشیتا"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2299);
	name.last_name = __webpack_require__(2301);
	name.prefix = __webpack_require__(2302);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "عارف",
	  "عاشوری",
	  "عالی",
	  "عبادی",
	  "عبدالکریمی",
	  "عبدالملکی",
	  "عراقی",
	  "عزیزی",
	  "عصار",
	  "عقیلی",
	  "علم",
	  "علم‌الهدی",
	  "علی عسگری",
	  "علی‌آبادی",
	  "علیا",
	  "علی‌پور",
	  "علی‌زمانی",
	  "عنایت",
	  "غضنفری",
	  "غنی",
	  "فارسی",
	  "فاطمی",
	  "فانی",
	  "فتاحی",
	  "فرامرزی",
	  "فرج",
	  "فرشیدورد",
	  "فرمانفرمائیان",
	  "فروتن",
	  "فرهنگ",
	  "فریاد",
	  "فنایی",
	  "فنی‌زاده",
	  "فولادوند",
	  "فهمیده",
	  "قاضی",
	  "قانعی",
	  "قانونی",
	  "قمیشی",
	  "قنبری",
	  "قهرمان",
	  "قهرمانی",
	  "قهرمانیان",
	  "قهستانی",
	  "کاشی",
	  "کاکاوند",
	  "کامکار",
	  "کاملی",
	  "کاویانی",
	  "کدیور",
	  "کردبچه",
	  "کرمانی",
	  "کریمی",
	  "کلباسی",
	  "کمالی",
	  "کوشکی",
	  "کهنمویی",
	  "کیان",
	  "کیانی (نام خانوادگی)",
	  "کیمیایی",
	  "گل محمدی",
	  "گلپایگانی",
	  "گنجی",
	  "لاجوردی",
	  "لاچینی",
	  "لاهوتی",
	  "لنکرانی",
	  "لوکس",
	  "مجاهد",
	  "مجتبایی",
	  "مجتبوی",
	  "مجتهد شبستری",
	  "مجتهدی",
	  "مجرد",
	  "محجوب",
	  "محجوبی",
	  "محدثی",
	  "محمدرضایی",
	  "محمدی",
	  "مددی",
	  "مرادخانی",
	  "مرتضوی",
	  "مستوفی",
	  "مشا",
	  "مصاحب",
	  "مصباح",
	  "مصباح‌زاده",
	  "مطهری",
	  "مظفر",
	  "معارف",
	  "معروف",
	  "معین",
	  "مفتاح",
	  "مفتح",
	  "مقدم",
	  "ملایری",
	  "ملک",
	  "ملکیان",
	  "منوچهری",
	  "موحد",
	  "موسوی",
	  "موسویان",
	  "مهاجرانی",
	  "مهدی‌پور",
	  "میرباقری",
	  "میردامادی",
	  "میرزاده",
	  "میرسپاسی",
	  "میزبانی",
	  "ناظری",
	  "نامور",
	  "نجفی",
	  "ندوشن",
	  "نراقی",
	  "نعمت‌زاده",
	  "نقدی",
	  "نقیب‌زاده",
	  "نواب",
	  "نوبخت",
	  "نوبختی",
	  "نهاوندی",
	  "نیشابوری",
	  "نیلوفری",
	  "واثقی",
	  "واعظ",
	  "واعظ‌زاده",
	  "واعظی",
	  "وکیلی",
	  "هاشمی",
	  "هاشمی رفسنجانی",
	  "هاشمیان",
	  "هامون",
	  "هدایت",
	  "هراتی",
	  "هروی",
	  "همایون",
	  "همت",
	  "همدانی",
	  "هوشیار",
	  "هومن",
	  "یاحقی",
	  "یادگار",
	  "یثربی",
	  "یلدا"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "آقای",
	  "خانم",
	  "دکتر"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Paris",
	  "Marseille",
	  "Lyon",
	  "Toulouse",
	  "Nice",
	  "Nantes",
	  "Strasbourg",
	  "Montpellier",
	  "Bordeaux",
	  "Lille13",
	  "Rennes",
	  "Reims",
	  "Le Havre",
	  "Saint-Étienne",
	  "Toulon",
	  "Grenoble",
	  "Dijon",
	  "Angers",
	  "Saint-Denis",
	  "Villeurbanne",
	  "Le Mans",
	  "Aix-en-Provence",
	  "Brest",
	  "Nîmes",
	  "Limoges",
	  "Clermont-Ferrand",
	  "Tours",
	  "Amiens",
	  "Metz",
	  "Perpignan",
	  "Besançon",
	  "Orléans",
	  "Boulogne-Billancourt",
	  "Mulhouse",
	  "Rouen",
	  "Caen",
	  "Nancy",
	  "Saint-Denis",
	  "Saint-Paul",
	  "Montreuil",
	  "Argenteuil",
	  "Roubaix",
	  "Dunkerque14",
	  "Tourcoing",
	  "Nanterre",
	  "Avignon",
	  "Créteil",
	  "Poitiers",
	  "Fort-de-France",
	  "Courbevoie",
	  "Versailles",
	  "Vitry-sur-Seine",
	  "Colombes",
	  "Pau",
	  "Aulnay-sous-Bois",
	  "Asnières-sur-Seine",
	  "Rueil-Malmaison",
	  "Saint-Pierre",
	  "Antibes",
	  "Saint-Maur-des-Fossés",
	  "Champigny-sur-Marne",
	  "La Rochelle",
	  "Aubervilliers",
	  "Calais",
	  "Cannes",
	  "Le Tampon",
	  "Béziers",
	  "Colmar",
	  "Bourges",
	  "Drancy",
	  "Mérignac",
	  "Saint-Nazaire",
	  "Valence",
	  "Ajaccio",
	  "Issy-les-Moulineaux",
	  "Villeneuve-d'Ascq",
	  "Levallois-Perret",
	  "Noisy-le-Grand",
	  "Quimper",
	  "La Seyne-sur-Mer",
	  "Antony",
	  "Troyes",
	  "Neuilly-sur-Seine",
	  "Sarcelles",
	  "Les Abymes",
	  "Vénissieux",
	  "Clichy",
	  "Lorient",
	  "Pessac",
	  "Ivry-sur-Seine",
	  "Cergy",
	  "Cayenne",
	  "Niort",
	  "Chambéry",
	  "Montauban",
	  "Saint-Quentin",
	  "Villejuif",
	  "Hyères",
	  "Beauvais",
	  "Cholet"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "France"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.building_number = __webpack_require__(2303);
	address.street_prefix = __webpack_require__(2313);
	address.secondary_address = __webpack_require__(2309);
	address.postcode = __webpack_require__(2308);
	address.state = __webpack_require__(2310);
	address.city_name = __webpack_require__(2305);
	address.city = __webpack_require__(2304);
	address.street_suffix = __webpack_require__(2314);
	address.street_name = __webpack_require__(2312);
	address.street_address = __webpack_require__(2311);
	address.default_country = __webpack_require__(2306);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "# étage"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alsace",
	  "Aquitaine",
	  "Auvergne",
	  "Basse-Normandie",
	  "Bourgogne",
	  "Bretagne",
	  "Centre",
	  "Champagne-Ardenne",
	  "Corse",
	  "Franche-Comté",
	  "Haute-Normandie",
	  "Île-de-France",
	  "Languedoc-Roussillon",
	  "Limousin",
	  "Lorraine",
	  "Midi-Pyrénées",
	  "Nord-Pas-de-Calais",
	  "Pays de la Loire",
	  "Picardie",
	  "Poitou-Charentes",
	  "Provence-Alpes-Côte d'Azur",
	  "Rhône-Alpes"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{building_number} #{street_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Allée, Voie",
	  "Rue",
	  "Avenue",
	  "Boulevard",
	  "Quai",
	  "Passage",
	  "Impasse",
	  "Place"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "de l'Abbaye",
	  "Adolphe Mille",
	  "d'Alésia",
	  "d'Argenteuil",
	  "d'Assas",
	  "du Bac",
	  "de Paris",
	  "La Boétie",
	  "Bonaparte",
	  "de la Bûcherie",
	  "de Caumartin",
	  "Charlemagne",
	  "du Chat-qui-Pêche",
	  "de la Chaussée-d'Antin",
	  "du Dahomey",
	  "Dauphine",
	  "Delesseux",
	  "du Faubourg Saint-Honoré",
	  "du Faubourg-Saint-Denis",
	  "de la Ferronnerie",
	  "des Francs-Bourgeois",
	  "des Grands Augustins",
	  "de la Harpe",
	  "du Havre",
	  "de la Huchette",
	  "Joubert",
	  "Laffitte",
	  "Lepic",
	  "des Lombards",
	  "Marcadet",
	  "Molière",
	  "Monsieur-le-Prince",
	  "de Montmorency",
	  "Montorgueil",
	  "Mouffetard",
	  "de Nesle",
	  "Oberkampf",
	  "de l'Odéon",
	  "d'Orsel",
	  "de la Paix",
	  "des Panoramas",
	  "Pastourelle",
	  "Pierre Charron",
	  "de la Pompe",
	  "de Presbourg",
	  "de Provence",
	  "de Richelieu",
	  "de Rivoli",
	  "des Rosiers",
	  "Royale",
	  "d'Abbeville",
	  "Saint-Honoré",
	  "Saint-Bernard",
	  "Saint-Denis",
	  "Saint-Dominique",
	  "Saint-Jacques",
	  "Saint-Séverin",
	  "des Saussaies",
	  "de Seine",
	  "de Solférino",
	  "Du Sommerard",
	  "de Tilsitt",
	  "Vaneau",
	  "de Vaugirard",
	  "de la Victoire",
	  "Zadkine"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2323);
	company.adjective = __webpack_require__(2315);
	company.descriptor = __webpack_require__(2319);
	company.noun = __webpack_require__(2322);
	company.bs_verb = __webpack_require__(2318);
	company.bs_adjective = __webpack_require__(2316);
	company.bs_noun = __webpack_require__(2317);
	company.name = __webpack_require__(2321);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} et #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "SARL",
	  "SA",
	  "EURL",
	  "SAS",
	  "SEM",
	  "SCOP",
	  "GIE",
	  "EI"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fr = {};
	module['exports'] = fr;
	fr.title = "French";
	fr.address = __webpack_require__(2307);
	fr.company = __webpack_require__(2320);
	fr.internet = __webpack_require__(2327);
	fr.lorem = __webpack_require__(2328);
	fr.name = __webpack_require__(2332);
	fr.phone_number = __webpack_require__(2338);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "fr",
	  "eu",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.fr",
	  "hotmail.fr"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2326);
	internet.domain_suffix = __webpack_require__(2325);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2330);
	lorem.supplemental = __webpack_require__(2329);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Enzo",
	  "Lucas",
	  "Mathis",
	  "Nathan",
	  "Thomas",
	  "Hugo",
	  "Théo",
	  "Tom",
	  "Louis",
	  "Raphaël",
	  "Clément",
	  "Léo",
	  "Mathéo",
	  "Maxime",
	  "Alexandre",
	  "Antoine",
	  "Yanis",
	  "Paul",
	  "Baptiste",
	  "Alexis",
	  "Gabriel",
	  "Arthur",
	  "Jules",
	  "Ethan",
	  "Noah",
	  "Quentin",
	  "Axel",
	  "Evan",
	  "Mattéo",
	  "Romain",
	  "Valentin",
	  "Maxence",
	  "Noa",
	  "Adam",
	  "Nicolas",
	  "Julien",
	  "Mael",
	  "Pierre",
	  "Rayan",
	  "Victor",
	  "Mohamed",
	  "Adrien",
	  "Kylian",
	  "Sacha",
	  "Benjamin",
	  "Léa",
	  "Clara",
	  "Manon",
	  "Chloé",
	  "Camille",
	  "Ines",
	  "Sarah",
	  "Jade",
	  "Lola",
	  "Anaïs",
	  "Lucie",
	  "Océane",
	  "Lilou",
	  "Marie",
	  "Eva",
	  "Romane",
	  "Lisa",
	  "Zoe",
	  "Julie",
	  "Mathilde",
	  "Louise",
	  "Juliette",
	  "Clémence",
	  "Célia",
	  "Laura",
	  "Lena",
	  "Maëlys",
	  "Charlotte",
	  "Ambre",
	  "Maeva",
	  "Pauline",
	  "Lina",
	  "Jeanne",
	  "Lou",
	  "Noémie",
	  "Justine",
	  "Louna",
	  "Elisa",
	  "Alice",
	  "Emilie",
	  "Carla",
	  "Maëlle",
	  "Alicia",
	  "Mélissa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2331);
	name.last_name = __webpack_require__(2333);
	name.prefix = __webpack_require__(2335);
	name.title = __webpack_require__(2336);
	name.name = __webpack_require__(2334);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Martin",
	  "Bernard",
	  "Dubois",
	  "Thomas",
	  "Robert",
	  "Richard",
	  "Petit",
	  "Durand",
	  "Leroy",
	  "Moreau",
	  "Simon",
	  "Laurent",
	  "Lefebvre",
	  "Michel",
	  "Garcia",
	  "David",
	  "Bertrand",
	  "Roux",
	  "Vincent",
	  "Fournier",
	  "Morel",
	  "Girard",
	  "Andre",
	  "Lefevre",
	  "Mercier",
	  "Dupont",
	  "Lambert",
	  "Bonnet",
	  "Francois",
	  "Martinez",
	  "Legrand",
	  "Garnier",
	  "Faure",
	  "Rousseau",
	  "Blanc",
	  "Guerin",
	  "Muller",
	  "Henry",
	  "Roussel",
	  "Nicolas",
	  "Perrin",
	  "Morin",
	  "Mathieu",
	  "Clement",
	  "Gauthier",
	  "Dumont",
	  "Lopez",
	  "Fontaine",
	  "Chevalier",
	  "Robin",
	  "Masson",
	  "Sanchez",
	  "Gerard",
	  "Nguyen",
	  "Boyer",
	  "Denis",
	  "Lemaire",
	  "Duval",
	  "Joly",
	  "Gautier",
	  "Roger",
	  "Roche",
	  "Roy",
	  "Noel",
	  "Meyer",
	  "Lucas",
	  "Meunier",
	  "Jean",
	  "Perez",
	  "Marchand",
	  "Dufour",
	  "Blanchard",
	  "Marie",
	  "Barbier",
	  "Brun",
	  "Dumas",
	  "Brunet",
	  "Schmitt",
	  "Leroux",
	  "Colin",
	  "Fernandez",
	  "Pierre",
	  "Renard",
	  "Arnaud",
	  "Rolland",
	  "Caron",
	  "Aubert",
	  "Giraud",
	  "Leclerc",
	  "Vidal",
	  "Bourgeois",
	  "Renaud",
	  "Lemoine",
	  "Picard",
	  "Gaillard",
	  "Philippe",
	  "Leclercq",
	  "Lacroix",
	  "Fabre",
	  "Dupuis",
	  "Olivier",
	  "Rodriguez",
	  "Da silva",
	  "Hubert",
	  "Louis",
	  "Charles",
	  "Guillot",
	  "Riviere",
	  "Le gall",
	  "Guillaume",
	  "Adam",
	  "Rey",
	  "Moulin",
	  "Gonzalez",
	  "Berger",
	  "Lecomte",
	  "Menard",
	  "Fleury",
	  "Deschamps",
	  "Carpentier",
	  "Julien",
	  "Benoit",
	  "Paris",
	  "Maillard",
	  "Marchal",
	  "Aubry",
	  "Vasseur",
	  "Le roux",
	  "Renault",
	  "Jacquet",
	  "Collet",
	  "Prevost",
	  "Poirier",
	  "Charpentier",
	  "Royer",
	  "Huet",
	  "Baron",
	  "Dupuy",
	  "Pons",
	  "Paul",
	  "Laine",
	  "Carre",
	  "Breton",
	  "Remy",
	  "Schneider",
	  "Perrot",
	  "Guyot",
	  "Barre",
	  "Marty",
	  "Cousin"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "M",
	  "Mme",
	  "Mlle",
	  "Dr",
	  "Prof"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "job": [
	    "Superviseur",
	    "Executif",
	    "Manager",
	    "Ingenieur",
	    "Specialiste",
	    "Directeur",
	    "Coordinateur",
	    "Administrateur",
	    "Architecte",
	    "Analyste",
	    "Designer",
	    "Technicien",
	    "Developpeur",
	    "Producteur",
	    "Consultant",
	    "Assistant",
	    "Agent",
	    "Stagiaire"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01########",
	  "02########",
	  "03########",
	  "04########",
	  "05########",
	  "06########",
	  "07########",
	  "+33 1########",
	  "+33 2########",
	  "+33 3########",
	  "+33 4########",
	  "+33 5########",
	  "+33 6########",
	  "+33 7########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2337);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Canada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(2341);
	address.state = __webpack_require__(2342);
	address.state_abbr = __webpack_require__(2343);
	address.default_country = __webpack_require__(2339);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "?#? #?#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alberta",
	  "Colombie-Britannique",
	  "Manitoba",
	  "Nouveau-Brunswick",
	  "Terre-Neuve-et-Labrador",
	  "Nouvelle-Écosse",
	  "Territoires du Nord-Ouest",
	  "Nunavut",
	  "Ontario",
	  "Île-du-Prince-Édouard",
	  "Québec",
	  "Saskatchewan",
	  "Yukon"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AB",
	  "BC",
	  "MB",
	  "NB",
	  "NL",
	  "NS",
	  "NU",
	  "NT",
	  "ON",
	  "PE",
	  "QC",
	  "SK",
	  "YK"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var fr_CA = {};
	module['exports'] = fr_CA;
	fr_CA.title = "Canada (French)";
	fr_CA.address = __webpack_require__(2340);
	fr_CA.internet = __webpack_require__(2347);
	fr_CA.phone_number = __webpack_require__(2349);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "qc.ca",
	  "ca",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.ca",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2346);
	internet.domain_suffix = __webpack_require__(2345);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "### ###-####",
	  "1 ### ###-####",
	  "### ###-####, poste ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2348);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბასთუმანი",
	  "აბაშა",
	  "ადიგენი",
	  "ამბროლაური",
	  "ანაკლია",
	  "ასპინძა",
	  "ახალგორი",
	  "ახალქალაქი",
	  "ახალციხე",
	  "ახმეტა",
	  "ბათუმი",
	  "ბაკურიანი",
	  "ბაღდათი",
	  "ბახმარო",
	  "ბოლნისი",
	  "ბორჯომი",
	  "გარდაბანი",
	  "გონიო",
	  "გორი",
	  "გრიგოლეთი",
	  "გუდაური",
	  "გურჯაანი",
	  "დედოფლისწყარო",
	  "დმანისი",
	  "დუშეთი",
	  "ვანი",
	  "ზესტაფონი",
	  "ზუგდიდი",
	  "თბილისი",
	  "თეთრიწყარო",
	  "თელავი",
	  "თერჯოლა",
	  "თიანეთი",
	  "კასპი",
	  "კვარიათი",
	  "კიკეთი",
	  "კოჯორი",
	  "ლაგოდეხი",
	  "ლანჩხუთი",
	  "ლენტეხი",
	  "მარნეული",
	  "მარტვილი",
	  "მესტია",
	  "მცხეთა",
	  "მწვანე კონცხი",
	  "ნინოწმინდა",
	  "ოზურგეთი",
	  "ონი",
	  "რუსთავი",
	  "საგარეჯო",
	  "საგურამო",
	  "საირმე",
	  "სამტრედია",
	  "სარფი",
	  "საჩხერე",
	  "სენაკი",
	  "სიღნაღი",
	  "სტეფანწმინდა",
	  "სურამი",
	  "ტაბახმელა",
	  "ტყიბული",
	  "ურეკი",
	  "ფოთი",
	  "ქარელი",
	  "ქედა",
	  "ქობულეთი",
	  "ქუთაისი",
	  "ყვარელი",
	  "შუახევი",
	  "ჩაქვი",
	  "ჩოხატაური",
	  "ცაგერი",
	  "ცხოროჭყუ",
	  "წავკისი",
	  "წალენჯიხა",
	  "წალკა",
	  "წაღვერი",
	  "წეროვანი",
	  "წნორი",
	  "წყალტუბო",
	  "წყნეთი",
	  "ჭიათურა",
	  "ხარაგაული",
	  "ხაშური",
	  "ხელვაჩაური",
	  "ხობი",
	  "ხონი",
	  "ხულო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ახალი",
	  "ძველი",
	  "ზემო",
	  "ქვემო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "სოფელი",
	  "ძირი",
	  "სკარი",
	  "დაბა"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ავსტრალია",
	  "ავსტრია",
	  "ავღანეთი",
	  "აზავადი",
	  "აზერბაიჯანი",
	  "აზიაში",
	  "აზიის",
	  "ალბანეთი",
	  "ალჟირი",
	  "ამაღლება და ტრისტანი-და-კუნია",
	  "ამერიკის ვირჯინიის კუნძულები",
	  "ამერიკის სამოა",
	  "ამერიკის შეერთებული შტატები",
	  "ამერიკის",
	  "ანგილია",
	  "ანგოლა",
	  "ანდორა",
	  "ანტიგუა და ბარბუდა",
	  "არაბეთის საემიროები",
	  "არაბთა გაერთიანებული საამიროები",
	  "არაბული ქვეყნების ლიგის",
	  "არგენტინა",
	  "არუბა",
	  "არცნობილი ქვეყნების სია",
	  "აფრიკაში",
	  "აფრიკაშია",
	  "აღდგომის კუნძული",
	  "აღმ. ტიმორი",
	  "აღმოსავლეთი აფრიკა",
	  "აღმოსავლეთი ტიმორი",
	  "აშშ",
	  "აშშ-ის ვირჯინის კუნძულები",
	  "ახალი ზელანდია",
	  "ახალი კალედონია",
	  "ბანგლადეში",
	  "ბარბადოსი",
	  "ბაჰამის კუნძულები",
	  "ბაჰრეინი",
	  "ბელარუსი",
	  "ბელგია",
	  "ბელიზი",
	  "ბენინი",
	  "ბერმუდა",
	  "ბერმუდის კუნძულები",
	  "ბოლივია",
	  "ბოსნია და ჰერცეგოვინა",
	  "ბოტსვანა",
	  "ბრაზილია",
	  "ბრიტანეთის ვირჯინიის კუნძულები",
	  "ბრიტანეთის ვირჯინის კუნძულები",
	  "ბრიტანეთის ინდოეთის ოკეანის ტერიტორია",
	  "ბრუნეი",
	  "ბულგარეთი",
	  "ბურკინა ფასო",
	  "ბურკინა-ფასო",
	  "ბურუნდი",
	  "ბჰუტანი",
	  "გაბონი",
	  "გაერთიანებული სამეფო",
	  "გაეროს",
	  "გაიანა",
	  "გამბია",
	  "განა",
	  "გერმანია",
	  "გვადელუპა",
	  "გვატემალა",
	  "გვინეა",
	  "გვინეა-ბისაუ",
	  "გიბრალტარი",
	  "გრენადა",
	  "გრენლანდია",
	  "გუამი",
	  "დამოკიდებული ტერ.",
	  "დამოკიდებული ტერიტორია",
	  "დამოკიდებული",
	  "დანია",
	  "დასავლეთი აფრიკა",
	  "დასავლეთი საჰარა",
	  "დიდი ბრიტანეთი",
	  "დომინიკა",
	  "დომინიკელთა რესპუბლიკა",
	  "ეგვიპტე",
	  "ევროკავშირის",
	  "ევროპასთან",
	  "ევროპაშია",
	  "ევროპის ქვეყნები",
	  "ეთიოპია",
	  "ეკვადორი",
	  "ეკვატორული გვინეა",
	  "ეპარსეს კუნძული",
	  "ერაყი",
	  "ერიტრეა",
	  "ესპანეთი",
	  "ესპანეთის სუვერენული ტერიტორიები",
	  "ესტონეთი",
	  "ეშმორის და კარტიეს კუნძულები",
	  "ვანუატუ",
	  "ვატიკანი",
	  "ვენესუელა",
	  "ვიეტნამი",
	  "ზამბია",
	  "ზიმბაბვე",
	  "თურქეთი",
	  "თურქმენეთი",
	  "იამაიკა",
	  "იან მაიენი",
	  "იაპონია",
	  "იემენი",
	  "ინდოეთი",
	  "ინდონეზია",
	  "იორდანია",
	  "ირანი",
	  "ირლანდია",
	  "ისლანდია",
	  "ისრაელი",
	  "იტალია",
	  "კაბო-ვერდე",
	  "კაიმანის კუნძულები",
	  "კამბოჯა",
	  "კამერუნი",
	  "კანადა",
	  "კანარის კუნძულები",
	  "კარიბის ზღვის",
	  "კატარი",
	  "კენია",
	  "კვიპროსი",
	  "კინგმენის რიფი",
	  "კირიბატი",
	  "კლიპერტონი",
	  "კოლუმბია",
	  "კომორი",
	  "კომორის კუნძულები",
	  "კონგოს დემოკრატიული რესპუბლიკა",
	  "კონგოს რესპუბლიკა",
	  "კორეის რესპუბლიკა",
	  "კოსტა-რიკა",
	  "კოტ-დ’ივუარი",
	  "კუბა",
	  "კუკის კუნძულები",
	  "ლაოსი",
	  "ლატვია",
	  "ლესოთო",
	  "ლიბანი",
	  "ლიბერია",
	  "ლიბია",
	  "ლიტვა",
	  "ლიხტენშტაინი",
	  "ლუქსემბურგი",
	  "მადაგასკარი",
	  "მადეირა",
	  "მავრიკი",
	  "მავრიტანია",
	  "მაიოტა",
	  "მაკაო",
	  "მაკედონია",
	  "მალავი",
	  "მალაიზია",
	  "მალდივი",
	  "მალდივის კუნძულები",
	  "მალი",
	  "მალტა",
	  "მაროკო",
	  "მარტინიკა",
	  "მარშალის კუნძულები",
	  "მარჯნის ზღვის კუნძულები",
	  "მელილია",
	  "მექსიკა",
	  "მიანმარი",
	  "მიკრონეზია",
	  "მიკრონეზიის ფედერაციული შტატები",
	  "მიმდებარე კუნძულები",
	  "მოზამბიკი",
	  "მოლდოვა",
	  "მონაკო",
	  "მონსერატი",
	  "მონღოლეთი",
	  "ნამიბია",
	  "ნაურუ",
	  "ნაწილობრივ აფრიკაში",
	  "ნეპალი",
	  "ნიგერი",
	  "ნიგერია",
	  "ნიდერლანდი",
	  "ნიდერლანდის ანტილები",
	  "ნიკარაგუა",
	  "ნიუე",
	  "ნორვეგია",
	  "ნორფოლკის კუნძული",
	  "ოკეანეთის",
	  "ოკეანიას",
	  "ომანი",
	  "პაკისტანი",
	  "პალაუ",
	  "პალესტინა",
	  "პალმირა (ატოლი)",
	  "პანამა",
	  "პანტელერია",
	  "პაპუა-ახალი გვინეა",
	  "პარაგვაი",
	  "პერუ",
	  "პიტკერნის კუნძულები",
	  "პოლონეთი",
	  "პორტუგალია",
	  "პრინც-ედუარდის კუნძული",
	  "პუერტო-რიკო",
	  "რეუნიონი",
	  "როტუმა",
	  "რუანდა",
	  "რუმინეთი",
	  "რუსეთი",
	  "საბერძნეთი",
	  "სადავო ტერიტორიები",
	  "სალვადორი",
	  "სამოა",
	  "სამხ. კორეა",
	  "სამხრეთ ამერიკაშია",
	  "სამხრეთ ამერიკის",
	  "სამხრეთ აფრიკის რესპუბლიკა",
	  "სამხრეთი აფრიკა",
	  "სამხრეთი გეორგია და სამხრეთ სენდვიჩის კუნძულები",
	  "სამხრეთი სუდანი",
	  "სან-მარინო",
	  "სან-ტომე და პრინსიპი",
	  "საუდის არაბეთი",
	  "საფრანგეთი",
	  "საფრანგეთის გვიანა",
	  "საფრანგეთის პოლინეზია",
	  "საქართველო",
	  "საჰარის არაბთა დემოკრატიული რესპუბლიკა",
	  "სეიშელის კუნძულები",
	  "სენ-ბართელმი",
	  "სენ-მარტენი",
	  "სენ-პიერი და მიკელონი",
	  "სენეგალი",
	  "სენტ-ვინსენტი და გრენადინები",
	  "სენტ-კიტსი და ნევისი",
	  "სენტ-ლუსია",
	  "სერბეთი",
	  "სეუტა",
	  "სვაზილენდი",
	  "სვალბარდი",
	  "სიერა-ლეონე",
	  "სინგაპური",
	  "სირია",
	  "სლოვაკეთი",
	  "სლოვენია",
	  "სოკოტრა",
	  "სოლომონის კუნძულები",
	  "სომალი",
	  "სომალილენდი",
	  "სომხეთი",
	  "სუდანი",
	  "სუვერენული სახელმწიფოები",
	  "სურინამი",
	  "ტაივანი",
	  "ტაილანდი",
	  "ტანზანია",
	  "ტაჯიკეთი",
	  "ტერიტორიები",
	  "ტერქსისა და კაიკოსის კუნძულები",
	  "ტოგო",
	  "ტოკელაუ",
	  "ტონგა",
	  "ტრანსკონტინენტური ქვეყანა",
	  "ტრინიდადი და ტობაგო",
	  "ტუვალუ",
	  "ტუნისი",
	  "უგანდა",
	  "უზბეკეთი",
	  "უკრაინა",
	  "უნგრეთი",
	  "უოლისი და ფუტუნა",
	  "ურუგვაი",
	  "ფარერის კუნძულები",
	  "ფილიპინები",
	  "ფინეთი",
	  "ფიჯი",
	  "ფოლკლენდის კუნძულები",
	  "ქვეყნები",
	  "ქოქოსის კუნძულები",
	  "ქუვეითი",
	  "ღაზის სექტორი",
	  "ყაზახეთი",
	  "ყირგიზეთი",
	  "შვედეთი",
	  "შვეიცარია",
	  "შობის კუნძული",
	  "შრი-ლანკა",
	  "ჩადი",
	  "ჩერნოგორია",
	  "ჩეჩნეთის რესპუბლიკა იჩქერია",
	  "ჩეხეთი",
	  "ჩილე",
	  "ჩინეთი",
	  "ჩრდ. კორეა",
	  "ჩრდილოეთ ამერიკის",
	  "ჩრდილოეთ მარიანას კუნძულები",
	  "ჩრდილოეთი აფრიკა",
	  "ჩრდილოეთი კორეა",
	  "ჩრდილოეთი მარიანას კუნძულები",
	  "ცენტრალური აფრიკა",
	  "ცენტრალური აფრიკის რესპუბლიკა",
	  "წევრები",
	  "წმინდა ელენე",
	  "წმინდა ელენეს კუნძული",
	  "ხორვატია",
	  "ჯერსი",
	  "ჯიბუტი",
	  "ჰავაი",
	  "ჰაიტი",
	  "ჰერდი და მაკდონალდის კუნძულები",
	  "ჰონდურასი",
	  "ჰონკონგი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "საქართველო"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2353);
	address.city_suffix = __webpack_require__(2354);
	address.city = __webpack_require__(2351);
	address.country = __webpack_require__(2355);
	address.building_number = __webpack_require__(2350);
	address.street_suffix = __webpack_require__(2362);
	address.secondary_address = __webpack_require__(2359);
	address.postcode = __webpack_require__(2358);
	address.city_name = __webpack_require__(2352);
	address.street_title = __webpack_require__(2363);
	address.street_name = __webpack_require__(2361);
	address.street_address = __webpack_require__(2360);
	address.default_country = __webpack_require__(2356);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "კორპ. ##",
	  "შენობა ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "გამზ.",
	  "გამზირი",
	  "ქ.",
	  "ქუჩა",
	  "ჩიხი",
	  "ხეივანი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბაშიძის",
	  "აბესაძის",
	  "აბულაძის",
	  "აგლაძის",
	  "ადლერის",
	  "ავიაქიმიის",
	  "ავლაბრის",
	  "ათარბეგოვის",
	  "ათონელის",
	  "ალავერდოვის",
	  "ალექსიძის",
	  "ალილუევის",
	  "ალმასიანის",
	  "ამაღლების",
	  "ამირეჯიბის",
	  "ანაგის",
	  "ანდრონიკაშვილის",
	  "ანთელავას",
	  "ანჯაფარიძის",
	  "არაგვის",
	  "არდონის",
	  "არეშიძის",
	  "ასათიანის",
	  "ასკურავას",
	  "ასლანიდის",
	  "ატენის",
	  "აფხაზი",
	  "აღმაშენებლის",
	  "ახალშენის",
	  "ახვლედიანის",
	  "ბააზოვის",
	  "ბაბისხევის",
	  "ბაბუშკინის",
	  "ბაგრატიონის",
	  "ბალანჩივაძეების",
	  "ბალანჩივაძის",
	  "ბალანჩინის",
	  "ბალმაშევის",
	  "ბარამიძის",
	  "ბარნოვის",
	  "ბაშალეიშვილის",
	  "ბევრეთის",
	  "ბელინსკის",
	  "ბელოსტოკის",
	  "ბენაშვილის",
	  "ბეჟანიშვილის",
	  "ბერიძის",
	  "ბოლქვაძის",
	  "ბოცვაძის",
	  "ბოჭორიშვილის",
	  "ბოჭორიძის",
	  "ბუაჩიძის",
	  "ბუდაპეშტის",
	  "ბურკიაშვილის",
	  "ბურძგლას",
	  "გაბესკირიას",
	  "გაგარინის",
	  "გაზაფხულის",
	  "გამრეკელის",
	  "გამსახურდიას",
	  "გარეჯელის",
	  "გეგეჭკორის",
	  "გედაურის",
	  "გელოვანი",
	  "გელოვანის",
	  "გერცენის",
	  "გლდანის",
	  "გოგებაშვილის",
	  "გოგიბერიძის",
	  "გოგოლის",
	  "გონაშვილის",
	  "გორგასლის",
	  "გრანელის",
	  "გრიზოდუბოვას",
	  "გრინევიცკის",
	  "გრომოვას",
	  "გრუზინსკის",
	  "გუდიაშვილის",
	  "გულრიფშის",
	  "გულუას",
	  "გურამიშვილის",
	  "გურგენიძის",
	  "დადიანის",
	  "დავითაშვილის",
	  "დამაკავშირებელი",
	  "დარიალის",
	  "დედოფლისწყაროს",
	  "დეპუტატის",
	  "დიდგორის",
	  "დიდი",
	  "დიდუბის",
	  "დიუმას",
	  "დიღმის",
	  "დიღომში",
	  "დოლიძის",
	  "დუნდუას",
	  "დურმიშიძის",
	  "ელიავას",
	  "ენგელსის",
	  "ენგურის",
	  "ეპისკოპოსის",
	  "ერისთავი",
	  "ერისთავის",
	  "ვაზისუბნის",
	  "ვაკელის",
	  "ვართაგავას",
	  "ვატუტინის",
	  "ვაჩნაძის",
	  "ვაცეკის",
	  "ვეკუას",
	  "ვეშაპურის",
	  "ვირსალაძის",
	  "ვოლოდარსკის",
	  "ვორონინის",
	  "ზაარბრიუკენის",
	  "ზაზიაშვილის",
	  "ზაზიშვილის",
	  "ზაკომოლდინის",
	  "ზანდუკელის",
	  "ზაქარაიას",
	  "ზაქარიაძის",
	  "ზახაროვის",
	  "ზაჰესის",
	  "ზნაურის",
	  "ზურაბაშვილის",
	  "ზღვის",
	  "თაბუკაშვილის",
	  "თავაძის",
	  "თავისუფლების",
	  "თამარაშვილის",
	  "თაქთაქიშვილის",
	  "თბილელის",
	  "თელიას",
	  "თორაძის",
	  "თოფურიძის",
	  "იალბუზის",
	  "იამანიძის",
	  "იაშვილის",
	  "იბერიის",
	  "იერუსალიმის",
	  "ივანიძის",
	  "ივერიელის",
	  "იზაშვილის",
	  "ილურიძის",
	  "იმედაშვილის",
	  "იმედაძის",
	  "იმედის",
	  "ინანიშვილის",
	  "ინგოროყვას",
	  "ინდუსტრიალიზაციის",
	  "ინჟინრის",
	  "ინწკირველის",
	  "ირბახის",
	  "ირემაშვილის",
	  "ისაკაძის",
	  "ისპასჰანლის",
	  "იტალიის",
	  "იუნკერთა",
	  "კათალიკოსის",
	  "კაიროს",
	  "კაკაბაძის",
	  "კაკაბეთის",
	  "კაკლიანის",
	  "კალანდაძის",
	  "კალიაევის",
	  "კალინინის",
	  "კამალოვის",
	  "კამოს",
	  "კაშენის",
	  "კახოვკის",
	  "კედიას",
	  "კელაპტრიშვილის",
	  "კერესელიძის",
	  "კეცხოველის",
	  "კიბალჩიჩის",
	  "კიკნაძის",
	  "კიროვის",
	  "კობარეთის",
	  "კოლექტივიზაციის",
	  "კოლმეურნეობის",
	  "კოლხეთის",
	  "კომკავშირის",
	  "კომუნისტური",
	  "კონსტიტუციის",
	  "კოოპერაციის",
	  "კოსტავას",
	  "კოტეტიშვილის",
	  "კოჩეტკოვის",
	  "კოჯრის",
	  "კრონშტადტის",
	  "კროპოტკინის",
	  "კრუპსკაიას",
	  "კუიბიშევის",
	  "კურნატოვსკის",
	  "კურტანოვსკის",
	  "კუტუზოვის",
	  "ლაღიძის",
	  "ლელაშვილის",
	  "ლენინაშენის",
	  "ლენინგრადის",
	  "ლენინის",
	  "ლენის",
	  "ლეონიძის",
	  "ლვოვის",
	  "ლორთქიფანიძის",
	  "ლოტკინის",
	  "ლუბლიანის",
	  "ლუბოვსკის",
	  "ლუნაჩარსკის",
	  "ლუქსემბურგის",
	  "მაგნიტოგორსკის",
	  "მაზნიაშვილის",
	  "მაისურაძის",
	  "მამარდაშვილის",
	  "მამაცაშვილის",
	  "მანაგაძის",
	  "მანჯგალაძის",
	  "მარის",
	  "მარუაშვილის",
	  "მარქსის",
	  "მარჯანის",
	  "მატროსოვის",
	  "მაჭავარიანი",
	  "მახალდიანის",
	  "მახარაძის",
	  "მებაღიშვილის",
	  "მეგობრობის",
	  "მელაანის",
	  "მერკვილაძის",
	  "მესხიას",
	  "მესხის",
	  "მეტეხის",
	  "მეტრეველი",
	  "მეჩნიკოვის",
	  "მთავარანგელოზის",
	  "მიასნიკოვის",
	  "მილორავას",
	  "მიმინოშვილის",
	  "მიროტაძის",
	  "მიქატაძის",
	  "მიქელაძის",
	  "მონტინის",
	  "მორეტის",
	  "მოსკოვის",
	  "მრევლიშვილის",
	  "მუშკორის",
	  "მუჯირიშვილის",
	  "მშვიდობის",
	  "მცხეთის",
	  "ნადირაძის",
	  "ნაკაშიძის",
	  "ნარიმანოვის",
	  "ნასიძის",
	  "ნაფარეულის",
	  "ნეკრასოვის",
	  "ნიაღვრის",
	  "ნინიძის",
	  "ნიშნიანიძის",
	  "ობოლაძის",
	  "ონიანის",
	  "ოჟიოს",
	  "ორახელაშვილის",
	  "ორბელიანის",
	  "ორჯონიკიძის",
	  "ოქტომბრის",
	  "ოცდაექვსი",
	  "პავლოვის",
	  "პარალელურის",
	  "პარიზის",
	  "პეკინის",
	  "პეროვსკაიას",
	  "პეტეფის",
	  "პიონერის",
	  "პირველი",
	  "პისარევის",
	  "პლეხანოვის",
	  "პრავდის",
	  "პროლეტარიატის",
	  "ჟელიაბოვის",
	  "ჟვანიას",
	  "ჟორდანიას",
	  "ჟღენტი",
	  "ჟღენტის",
	  "რადიანის",
	  "რამიშვილი",
	  "რასკოვას",
	  "რენინგერის",
	  "რინგის",
	  "რიჟინაშვილის",
	  "რობაქიძის",
	  "რობესპიერის",
	  "რუსის",
	  "რუხაძის",
	  "რჩეულიშვილის",
	  "სააკაძის",
	  "საბადურის",
	  "საბაშვილის",
	  "საბურთალოს",
	  "საბჭოს",
	  "საგურამოს",
	  "სამრეკლოს",
	  "სამღერეთის",
	  "სანაკოევის",
	  "სარაჯიშვილის",
	  "საჯაიას",
	  "სევასტოპოლის",
	  "სერგი",
	  "სვანიძის",
	  "სვერდლოვის",
	  "სტახანოვის",
	  "სულთნიშნის",
	  "სურგულაძის",
	  "სხირტლაძის",
	  "ტაბიძის",
	  "ტატიშვილის",
	  "ტელმანის",
	  "ტერევერკოს",
	  "ტეტელაშვილის",
	  "ტოვსტონოგოვის",
	  "ტოროშელიძის",
	  "ტრაქტორის",
	  "ტრიკოტაჟის",
	  "ტურბინის",
	  "უბილავას",
	  "უბინაშვილის",
	  "უზნაძის",
	  "უკლებას",
	  "ულიანოვის",
	  "ურიდიას",
	  "ფაბრიციუსის",
	  "ფაღავას",
	  "ფერისცვალების",
	  "ფიგნერის",
	  "ფიზკულტურის",
	  "ფიოლეტოვის",
	  "ფიფიების",
	  "ფოცხიშვილის",
	  "ქართველიშვილის",
	  "ქართლელიშვილის",
	  "ქინქლაძის",
	  "ქიქოძის",
	  "ქსოვრელის",
	  "ქუთათელაძის",
	  "ქუთათელის",
	  "ქურდიანის",
	  "ღოღობერიძის",
	  "ღუდუშაურის",
	  "ყავლაშვილის",
	  "ყაზბეგის",
	  "ყარყარაშვილის",
	  "ყიფიანის",
	  "ყუშიტაშვილის",
	  "შანიძის",
	  "შარტავას",
	  "შატილოვის",
	  "შაუმიანის",
	  "შენგელაიას",
	  "შერვაშიძის",
	  "შეროზიას",
	  "შირშოვის",
	  "შმიდტის",
	  "შრომის",
	  "შუშინის",
	  "შჩორსის",
	  "ჩალაუბნის",
	  "ჩანტლაძის",
	  "ჩაპაევის",
	  "ჩაჩავას",
	  "ჩელუსკინელების",
	  "ჩერნიახოვსკის",
	  "ჩერქეზიშვილი",
	  "ჩერქეზიშვილის",
	  "ჩვიდმეტი",
	  "ჩიტაიას",
	  "ჩიტაძის",
	  "ჩიქვანაიას",
	  "ჩიქობავას",
	  "ჩიხლაძის",
	  "ჩოდრიშვილის",
	  "ჩოლოყაშვილის",
	  "ჩუღურეთის",
	  "ცაბაძის",
	  "ცაგარელის",
	  "ცეტკინის",
	  "ცინცაძის",
	  "ცისკარიშვილის",
	  "ცურტაველის",
	  "ცქიტიშვილის",
	  "ცხაკაიას",
	  "ძმობის",
	  "ძნელაძის",
	  "წერეთლის",
	  "წითელი",
	  "წითელწყაროს",
	  "წინამძღვრიშვილის",
	  "წულაძის",
	  "წულუკიძის",
	  "ჭაბუკიანის",
	  "ჭავჭავაძის",
	  "ჭანტურიას",
	  "ჭოველიძის",
	  "ჭონქაძის",
	  "ჭყონდიდელის",
	  "ხანძთელის",
	  "ხვამლის",
	  "ხვინგიას",
	  "ხვიჩიას",
	  "ხიმშიაშვილის",
	  "ხმელნიცკის",
	  "ხორნაბუჯის",
	  "ხრამჰესის",
	  "ხუციშვილის",
	  "ჯავახიშვილის",
	  "ჯაფარიძის",
	  "ჯიბლაძის",
	  "ჯორჯიაშვილის"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(+995 32) 2-##-##-##",
	  "032-2-##-##-##",
	  "032-2-######",
	  "032-2-###-###",
	  "032 2 ## ## ##",
	  "032 2 ######",
	  "2 ## ## ##",
	  "2######",
	  "2 ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2364);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(2368);
	company.suffix = __webpack_require__(2369);
	company.name = __webpack_require__(2367);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.first_name}",
	  "#{prefix} #{Name.last_name}",
	  "#{prefix} #{Name.last_name} #{suffix}",
	  "#{prefix} #{Name.first_name} #{suffix}",
	  "#{prefix} #{Name.last_name}-#{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "შპს",
	  "სს",
	  "ააიპ",
	  "სსიპ"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ჯგუფი",
	  "და კომპანია",
	  "სტუდია",
	  "გრუპი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ge = {};
	module['exports'] = ge;
	ge.title = "Georgian";
	ge.separator = " და ";
	ge.name = __webpack_require__(2375);
	ge.address = __webpack_require__(2357);
	ge.internet = __webpack_require__(2373);
	ge.company = __webpack_require__(2366);
	ge.phone_number = __webpack_require__(2381);
	ge.cell_phone = __webpack_require__(2365);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ge",
	  "com",
	  "net",
	  "org",
	  "com.ge",
	  "org.ge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "posta.ge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2372);
	internet.domain_suffix = __webpack_require__(2371);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აგული",
	  "აგუნა",
	  "ადოლა",
	  "ავთანდილ",
	  "ავთო",
	  "აკაკი",
	  "აკო",
	  "ალეკო",
	  "ალექსანდრე",
	  "ალექსი",
	  "ალიო",
	  "ამირან",
	  "ანა",
	  "ანანო",
	  "ანზორ",
	  "ანნა",
	  "ანუკა",
	  "ანუკი",
	  "არჩილ",
	  "ასკილა",
	  "ასლანაზ",
	  "აჩიკო",
	  "ბადრი",
	  "ბაია",
	  "ბარბარე",
	  "ბაქარ",
	  "ბაჩა",
	  "ბაჩანა",
	  "ბაჭუა",
	  "ბაჭუკი",
	  "ბახვა",
	  "ბელა",
	  "ბერა",
	  "ბერდია",
	  "ბესიკ",
	  "ბესიკ",
	  "ბესო",
	  "ბექა",
	  "ბიძინა",
	  "ბიჭიკო",
	  "ბოჩია",
	  "ბოცო",
	  "ბროლა",
	  "ბუბუ",
	  "ბუდუ",
	  "ბუხუტი",
	  "გაგა",
	  "გაგი",
	  "გახა",
	  "გეგა",
	  "გეგი",
	  "გედია",
	  "გელა",
	  "გენადი",
	  "გვადი",
	  "გვანცა",
	  "გვანჯი",
	  "გვიტია",
	  "გვრიტა",
	  "გია",
	  "გიგა",
	  "გიგი",
	  "გიგილო",
	  "გიგლა",
	  "გიგოლი",
	  "გივი",
	  "გივიკო",
	  "გიორგი",
	  "გოგი",
	  "გოგიტა",
	  "გოგიჩა",
	  "გოგოთურ",
	  "გოგოლა",
	  "გოდერძი",
	  "გოლა",
	  "გოჩა",
	  "გრიგოლ",
	  "გუგა",
	  "გუგუ",
	  "გუგულა",
	  "გუგული",
	  "გუგუნა",
	  "გუკა",
	  "გულარისა",
	  "გულვარდი",
	  "გულვარდისა",
	  "გულთამზე",
	  "გულია",
	  "გულიკო",
	  "გულისა",
	  "გულნარა",
	  "გურამ",
	  "დავით",
	  "დალი",
	  "დარეჯან",
	  "დიანა",
	  "დიმიტრი",
	  "დოდო",
	  "დუტუ",
	  "ეთერ",
	  "ეთო",
	  "ეკა",
	  "ეკატერინე",
	  "ელგუჯა",
	  "ელენა",
	  "ელენე",
	  "ელზა",
	  "ელიკო",
	  "ელისო",
	  "ემზარ",
	  "ეშხა",
	  "ვალენტინა",
	  "ვალერი",
	  "ვანო",
	  "ვაჟა",
	  "ვაჟა",
	  "ვარდო",
	  "ვარსკვლავისა",
	  "ვასიკო",
	  "ვასილ",
	  "ვატო",
	  "ვახო",
	  "ვახტანგ",
	  "ვენერა",
	  "ვერა",
	  "ვერიკო",
	  "ზაზა",
	  "ზაირა",
	  "ზაურ",
	  "ზეზვა",
	  "ზვიად",
	  "ზინა",
	  "ზოია",
	  "ზუკა",
	  "ზურა",
	  "ზურაბ",
	  "ზურია",
	  "ზურიკო",
	  "თაზო",
	  "თათა",
	  "თათია",
	  "თათული",
	  "თაია",
	  "თაკო",
	  "თალიკო",
	  "თამაზ",
	  "თამარ",
	  "თამარა",
	  "თამთა",
	  "თამთიკე",
	  "თამი",
	  "თამილა",
	  "თამრიკო",
	  "თამრო",
	  "თამუნა",
	  "თამჩო",
	  "თანანა",
	  "თანდილა",
	  "თაყა",
	  "თეა",
	  "თებრონე",
	  "თეიმურაზ",
	  "თემურ",
	  "თენგიზ",
	  "თენგო",
	  "თეონა",
	  "თიკა",
	  "თიკო",
	  "თიკუნა",
	  "თინა",
	  "თინათინ",
	  "თინიკო",
	  "თმაგიშერა",
	  "თორნიკე",
	  "თუთა",
	  "თუთია",
	  "ია",
	  "იათამზე",
	  "იამზე",
	  "ივანე",
	  "ივერი",
	  "ივქირიონ",
	  "იზოლდა",
	  "ილია",
	  "ილიკო",
	  "იმედა",
	  "ინგა",
	  "იოსებ",
	  "ირაკლი",
	  "ირინა",
	  "ირინე",
	  "ირინკა",
	  "ირმა",
	  "იური",
	  "კაკო",
	  "კალე",
	  "კატო",
	  "კახა",
	  "კახაბერ",
	  "კეკელა",
	  "კესანე",
	  "კესო",
	  "კვირია",
	  "კიტა",
	  "კობა",
	  "კოკა",
	  "კონსტანტინე",
	  "კოსტა",
	  "კოტე",
	  "კუკური",
	  "ლადო",
	  "ლალი",
	  "ლამაზა",
	  "ლამარა",
	  "ლამზირა",
	  "ლაშა",
	  "ლევან",
	  "ლეილა",
	  "ლელა",
	  "ლენა",
	  "ლერწამისა",
	  "ლექსო",
	  "ლია",
	  "ლიანა",
	  "ლიზა",
	  "ლიზიკო",
	  "ლილე",
	  "ლილი",
	  "ლილიკო",
	  "ლომია",
	  "ლუიზა",
	  "მაგული",
	  "მადონა",
	  "მათიკო",
	  "მაია",
	  "მაიკო",
	  "მაისა",
	  "მაკა",
	  "მაკო",
	  "მაკუნა",
	  "მალხაზ",
	  "მამამზე",
	  "მამია",
	  "მამისა",
	  "მამისთვალი",
	  "მამისიმედი",
	  "მამუკა",
	  "მამულა",
	  "მანანა",
	  "მანჩო",
	  "მარადი",
	  "მარი",
	  "მარია",
	  "მარიამი",
	  "მარიკა",
	  "მარინა",
	  "მარინე",
	  "მარიტა",
	  "მაყვალა",
	  "მაყვალა",
	  "მაშიკო",
	  "მაშო",
	  "მაცაცო",
	  "მგელია",
	  "მგელიკა",
	  "მედეა",
	  "მეკაშო",
	  "მელანო",
	  "მერაბ",
	  "მერი",
	  "მეტია",
	  "მზაღო",
	  "მზევინარ",
	  "მზეთამზე",
	  "მზეთვალა",
	  "მზეონა",
	  "მზექალა",
	  "მზეხა",
	  "მზეხათუნი",
	  "მზია",
	  "მზირა",
	  "მზისადარ",
	  "მზისთანადარი",
	  "მზიულა",
	  "მთვარისა",
	  "მინდია",
	  "მიშა",
	  "მიშიკო",
	  "მიხეილ",
	  "მნათობი",
	  "მნათობისა",
	  "მოგელი",
	  "მონავარდისა",
	  "მურმან",
	  "მუხრან",
	  "ნაზი",
	  "ნაზიკო",
	  "ნათელა",
	  "ნათია",
	  "ნაირა",
	  "ნანა",
	  "ნანი",
	  "ნანიკო",
	  "ნანუკა",
	  "ნანული",
	  "ნარგიზი",
	  "ნასყიდა",
	  "ნატალია",
	  "ნატო",
	  "ნელი",
	  "ნენე",
	  "ნესტან",
	  "ნია",
	  "ნიაკო",
	  "ნიკა",
	  "ნიკოლოზ",
	  "ნინა",
	  "ნინაკა",
	  "ნინი",
	  "ნინიკო",
	  "ნინო",
	  "ნინუკა",
	  "ნინუცა",
	  "ნოდარ",
	  "ნოდო",
	  "ნონა",
	  "ნორა",
	  "ნუგზარ",
	  "ნუგო",
	  "ნუკა",
	  "ნუკი",
	  "ნუკრი",
	  "ნუნუ",
	  "ნუნუ",
	  "ნუნუკა",
	  "ნუცა",
	  "ნუცი",
	  "ოთარ",
	  "ოთია",
	  "ოთო",
	  "ომარ",
	  "ორბელ",
	  "ოტია",
	  "ოქროპირ",
	  "პაატა",
	  "პაპუნა",
	  "პატარკაცი",
	  "პატარქალი",
	  "პეპელა",
	  "პირვარდისა",
	  "პირიმზე",
	  "ჟამიერა",
	  "ჟამიტა",
	  "ჟამუტა",
	  "ჟუჟუნა",
	  "რამაზ",
	  "რევაზ",
	  "რეზი",
	  "რეზო",
	  "როზა",
	  "რომან",
	  "რუსკა",
	  "რუსუდან",
	  "საბა",
	  "სალი",
	  "სალომე",
	  "სანათა",
	  "სანდრო",
	  "სერგო",
	  "სესია",
	  "სეხნია",
	  "სვეტლანა",
	  "სიხარულა",
	  "სოსო",
	  "სოფიკო",
	  "სოფიო",
	  "სოფო",
	  "სულა",
	  "სულიკო",
	  "ტარიელ",
	  "ტასიკო",
	  "ტასო",
	  "ტატიანა",
	  "ტატო",
	  "ტეტია",
	  "ტურია",
	  "უმანკო",
	  "უტა",
	  "უჩა",
	  "ფაქიზო",
	  "ფაცია",
	  "ფეფელა",
	  "ფეფენა",
	  "ფეფიკო",
	  "ფეფო",
	  "ფოსო",
	  "ფოფო",
	  "ქაბატო",
	  "ქავთარი",
	  "ქალია",
	  "ქართლოს",
	  "ქეთათო",
	  "ქეთევან",
	  "ქეთი",
	  "ქეთინო",
	  "ქეთო",
	  "ქველი",
	  "ქიტესა",
	  "ქიშვარდი",
	  "ქობული",
	  "ქრისტესია",
	  "ქტისტეფორე",
	  "ქურციკა",
	  "ღარიბა",
	  "ღვთისავარი",
	  "ღვთისია",
	  "ღვთისო",
	  "ღვინია",
	  "ღუღუნა",
	  "ყაითამზა",
	  "ყაყიტა",
	  "ყვარყვარე",
	  "ყიასა",
	  "შაბური",
	  "შაკო",
	  "შალვა",
	  "შალიკო",
	  "შანშე",
	  "შარია",
	  "შაქარა",
	  "შაქრო",
	  "შოთა",
	  "შორენა",
	  "შოშია",
	  "შუქია",
	  "ჩიორა",
	  "ჩიტო",
	  "ჩიტო",
	  "ჩოყოლა",
	  "ცაგო",
	  "ცაგული",
	  "ცანგალა",
	  "ცარო",
	  "ცაცა",
	  "ცაცო",
	  "ციალა",
	  "ციკო",
	  "ცინარა",
	  "ცირა",
	  "ცისანა",
	  "ცისია",
	  "ცისკარა",
	  "ცისკარი",
	  "ცისმარა",
	  "ცისმარი",
	  "ციური",
	  "ციცი",
	  "ციცია",
	  "ციცინო",
	  "ცოტნე",
	  "ცოქალა",
	  "ცუცა",
	  "ცხვარი",
	  "ძაბული",
	  "ძამისა",
	  "ძაღინა",
	  "ძიძია",
	  "წათე",
	  "წყალობა",
	  "ჭაბუკა",
	  "ჭიაბერ",
	  "ჭიკჭიკა",
	  "ჭიჭია",
	  "ჭიჭიკო",
	  "ჭოლა",
	  "ხათუნა",
	  "ხარება",
	  "ხატია",
	  "ხახულა",
	  "ხახუტა",
	  "ხეჩუა",
	  "ხვიჩა",
	  "ხიზანა",
	  "ხირხელა",
	  "ხობელასი",
	  "ხოხია",
	  "ხოხიტა",
	  "ხუტა",
	  "ხუცია",
	  "ჯაბა",
	  "ჯავახი",
	  "ჯარჯი",
	  "ჯემალ",
	  "ჯონდო",
	  "ჯოტო",
	  "ჯუბი",
	  "ჯულიეტა",
	  "ჯუმბერ",
	  "ჰამლეტ"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2374);
	name.last_name = __webpack_require__(2376);
	name.prefix = __webpack_require__(2378);
	name.title = __webpack_require__(2379);
	name.name = __webpack_require__(2377);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "აბაზაძე",
	  "აბაშიძე",
	  "აბრამაშვილი",
	  "აბუსერიძე",
	  "აბშილავა",
	  "ავაზნელი",
	  "ავალიშვილი",
	  "ამილახვარი",
	  "ანთაძე",
	  "ასლამაზიშვილი",
	  "ასპანიძე",
	  "აშკარელი",
	  "ახალბედაშვილი",
	  "ახალკაცი",
	  "ახვლედიანი",
	  "ბარათაშვილი",
	  "ბარდაველიძე",
	  "ბახტაძე",
	  "ბედიანიძე",
	  "ბერიძე",
	  "ბერუაშვილი",
	  "ბეჟანიშვილი",
	  "ბოგველიშვილი",
	  "ბოტკოველი",
	  "გაბრიჩიძე",
	  "გაგნიძე",
	  "გამრეკელი",
	  "გელაშვილი",
	  "გზირიშვილი",
	  "გიგაური",
	  "გურამიშვილი",
	  "გურგენიძე",
	  "დადიანი",
	  "დავითიშვილი",
	  "დათუაშვილი",
	  "დარბაისელი",
	  "დეკანოიძე",
	  "დვალი",
	  "დოლაბერიძე",
	  "ედიშერაშვილი",
	  "ელიზბარაშვილი",
	  "ელიოზაშვილი",
	  "ერისთავი",
	  "ვარამაშვილი",
	  "ვარდიაშვილი",
	  "ვაჩნაძე",
	  "ვარდანიძე",
	  "ველიაშვილი",
	  "ველიჯანაშვილი",
	  "ზარანდია",
	  "ზარიძე",
	  "ზედგინიძე",
	  "ზუბიაშვილი",
	  "თაბაგარი",
	  "თავდგირიძე",
	  "თათარაშვილი",
	  "თამაზაშვილი",
	  "თამარაშვილი",
	  "თაქთაქიშვილი",
	  "თაყაიშვილი",
	  "თბილელი",
	  "თუხარელი",
	  "იაშვილი",
	  "იგითხანიშვილი",
	  "ინასარიძე",
	  "იშხნელი",
	  "კანდელაკი",
	  "კაცია",
	  "კერესელიძე",
	  "კვირიკაშვილი",
	  "კიკნაძე",
	  "კლდიაშვილი",
	  "კოვზაძე",
	  "კოპაძე",
	  "კოპტონაშვილი",
	  "კოშკელაშვილი",
	  "ლაბაძე",
	  "ლეკიშვილი",
	  "ლიქოკელი",
	  "ლოლაძე",
	  "ლურსმანაშვილი",
	  "მაისურაძე",
	  "მარტოლეკი",
	  "მაღალაძე",
	  "მახარაშვილი",
	  "მგალობლიშვილი",
	  "მეგრელიშვილი",
	  "მელაშვილი",
	  "მელიქიძე",
	  "მერაბიშვილი",
	  "მეფარიშვილი",
	  "მუჯირი",
	  "მჭედლიძე",
	  "მხეიძე",
	  "ნათაძე",
	  "ნაჭყებია",
	  "ნოზაძე",
	  "ოდიშვილი",
	  "ონოფრიშვილი",
	  "პარეხელაშვილი",
	  "პეტრიაშვილი",
	  "სააკაძე",
	  "სააკაშვილი",
	  "საგინაშვილი",
	  "სადუნიშვილი",
	  "საძაგლიშვილი",
	  "სებისკვერიძე",
	  "სეთური",
	  "სუთიაშვილი",
	  "სულაშვილი",
	  "ტაბაღუა",
	  "ტყეშელაშვილი",
	  "ულუმბელაშვილი",
	  "უნდილაძე",
	  "ქავთარაძე",
	  "ქართველიშვილი",
	  "ყაზბეგი",
	  "ყაუხჩიშვილი",
	  "შავლაშვილი",
	  "შალიკაშვილი",
	  "შონია",
	  "ჩიბუხაშვილი",
	  "ჩიხრაძე",
	  "ჩიქოვანი",
	  "ჩუბინიძე",
	  "ჩოლოყაშვილი",
	  "ჩოხელი",
	  "ჩხვიმიანი",
	  "ცალუღელაშვილი",
	  "ცაძიკიძე",
	  "ციციშვილი",
	  "ციხელაშვილი",
	  "ციხისთავი",
	  "ცხოვრებაძე",
	  "ცხომარია",
	  "წამალაიძე",
	  "წერეთელი",
	  "წიკლაური",
	  "წიფურია",
	  "ჭაბუკაშვილი",
	  "ჭავჭავაძე",
	  "ჭანტურია",
	  "ჭარელიძე",
	  "ჭიორელი",
	  "ჭუმბურიძე",
	  "ხაბაზი",
	  "ხარაძე",
	  "ხარატიშვილი",
	  "ხარატასშვილი",
	  "ხარისჭირაშვილი",
	  "ხარხელაური",
	  "ხაშმელაშვილი",
	  "ხეთაგური",
	  "ხიზამბარელი",
	  "ხიზანიშვილი",
	  "ხიმშიაშვილი",
	  "ხოსრუაშვილი",
	  "ხოჯივანიშვილი",
	  "ხუციშვილი",
	  "ჯაბადარი",
	  "ჯავახი",
	  "ჯავახიშვილი",
	  "ჯანელიძე",
	  "ჯაფარიძე",
	  "ჯაყელი",
	  "ჯაჯანიძე",
	  "ჯვარელია",
	  "ჯინიუზაშვილი",
	  "ჯუღაშვილი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ბ-ნი",
	  "ბატონი",
	  "ქ-ნი",
	  "ქალბატონი"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "გენერალური",
	    "მთავარი",
	    "სტაჟიორ",
	    "უმცროსი",
	    "ყოფილი",
	    "წამყვანი"
	  ],
	  "level": [
	    "აღრიცხვების",
	    "ბრენდინგის",
	    "ბრენიდს",
	    "ბუღალტერიის",
	    "განყოფილების",
	    "გაყიდვების",
	    "გუნდის",
	    "დახმარების",
	    "დიზაინის",
	    "თავდაცვის",
	    "ინფორმაციის",
	    "კვლევების",
	    "კომუნიკაციების",
	    "მარკეტინგის",
	    "ოპერაციათა",
	    "ოპტიმიზაციების",
	    "პიარ",
	    "პროგრამის",
	    "საქმეთა",
	    "ტაქტიკური",
	    "უსაფრთხოების",
	    "ფინანსთა",
	    "ქსელის",
	    "ხარისხის",
	    "ჯგუფის"
	  ],
	  "job": [
	    "აგენტი",
	    "ადვოკატი",
	    "ადმინისტრატორი",
	    "არქიტექტორი",
	    "ასისტენტი",
	    "აღმასრულებელი დირექტორი",
	    "დეველოპერი",
	    "დეკანი",
	    "დიზაინერი",
	    "დირექტორი",
	    "ელექტრიკოსი",
	    "ექსპერტი",
	    "ინჟინერი",
	    "იურისტი",
	    "კონსტრუქტორი",
	    "კონსულტანტი",
	    "კოორდინატორი",
	    "ლექტორი",
	    "მასაჟისტი",
	    "მემანქანე",
	    "მენეჯერი",
	    "მძღოლი",
	    "მწვრთნელი",
	    "ოპერატორი",
	    "ოფიცერი",
	    "პედაგოგი",
	    "პოლიციელი",
	    "პროგრამისტი",
	    "პროდიუსერი",
	    "პრორექტორი",
	    "ჟურნალისტი",
	    "რექტორი",
	    "სპეციალისტი",
	    "სტრატეგისტი",
	    "ტექნიკოსი",
	    "ფოტოგრაფი",
	    "წარმომადგენელი"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "5##-###-###",
	  "5########",
	  "5## ## ## ##",
	  "5## ######",
	  "5## ### ###",
	  "995 5##-###-###",
	  "995 5########",
	  "995 5## ## ## ##",
	  "995 5## ######",
	  "995 5## ### ###",
	  "+995 5##-###-###",
	  "+995 5########",
	  "+995 5## ## ## ##",
	  "+995 5## ######",
	  "+995 5## ### ###",
	  "(+995) 5##-###-###",
	  "(+995) 5########",
	  "(+995) 5## ## ## ##",
	  "(+995) 5## ######",
	  "(+995) 5## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2380);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [  
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Airmadidi",
	  "Ampana",
	  "Amurang",
	  "Andolo",
	  "Banggai",
	  "Bantaeng",
	  "Barru",
	  "Bau-Bau",
	  "Benteng",
	  "Bitung",
	  "Bolaang Uki",
	  "Boroko",
	  "Bulukumba",
	  "Bungku",
	  "Buol",
	  "Buranga",
	  "Donggala",
	  "Enrekang",
	  "Gorontalo",
	  "Jeneponto",
	  "Kawangkoan",
	  "Kendari",
	  "Kolaka",
	  "Kotamobagu",
	  "Kota Raha",
	  "Kwandang",
	  "Lasusua",
	  "Luwuk",
	  "Majene",
	  "Makale",
	  "Makassar",
	  "Malili",
	  "Mamasa",
	  "Mamuju",
	  "Manado",
	  "Marisa",
	  "Maros",
	  "Masamba",
	  "Melonguane",
	  "Ondong Siau",
	  "Palopo",
	  "Palu",
	  "Pangkajene",
	  "Pare-Pare",
	  "Parigi",
	  "Pasangkayu",
	  "Pinrang",
	  "Polewali",
	  "Poso",
	  "Rantepao",
	  "Ratahan",
	  "Rumbia",
	  "Sengkang",
	  "Sidenreng",
	  "Sigi Biromaru",
	  "Sinjai",
	  "Sunggu Minasa",
	  "Suwawa",
	  "Tahuna",
	  "Takalar",
	  "Tilamuta",
	  "Toli Toli",
	  "Tomohon",
	  "Tondano",
	  "Tutuyan",
	  "Unaaha",
	  "Wangi Wangi",
	  "Wanggudu",
	  "Watampone",
	  "Watan Soppeng",
	  "Ambarawa",
	  "Anyer",
	  "Bandung",
	  "Bangil",
	  "Banjar (Jawa Barat)",
	  "Banjarnegara",
	  "Bangkalan",
	  "Bantul",
	  "Banyumas",
	  "Banyuwangi",
	  "Batang",
	  "Batu",
	  "Bekasi",
	  "Blitar",
	  "Blora",
	  "Bogor",
	  "Bojonegoro",
	  "Bondowoso",
	  "Boyolali",
	  "Bumiayu",
	  "Brebes",
	  "Caruban",
	  "Cianjur",
	  "Ciamis",
	  "Cibinong",
	  "Cikampek",
	  "Cikarang",
	  "Cilacap",
	  "Cilegon",
	  "Cirebon",
	  "Demak",
	  "Depok",
	  "Garut",
	  "Gresik",
	  "Indramayu",
	  "Jakarta",
	  "Jember",
	  "Jepara",
	  "Jombang",
	  "Kajen",
	  "Karanganyar",
	  "Kebumen",
	  "Kediri",
	  "Kendal",
	  "Kepanjen",
	  "Klaten",
	  "Pelabuhan Ratu",
	  "Kraksaan",
	  "Kudus",
	  "Kuningan",
	  "Lamongan",
	  "Lumajang",
	  "Madiun",
	  "Magelang",
	  "Magetan",
	  "Majalengka",
	  "Malang",
	  "Mojokerto",
	  "Mojosari",
	  "Mungkid",
	  "Ngamprah",
	  "Nganjuk",
	  "Ngawi",
	  "Pacitan",
	  "Pamekasan",
	  "Pandeglang",
	  "Pare",
	  "Pati",
	  "Pasuruan",
	  "Pekalongan",
	  "Pemalang",
	  "Ponorogo",
	  "Probolinggo",
	  "Purbalingga",
	  "Purwakarta",
	  "Purwodadi",
	  "Purwokerto",
	  "Purworejo",
	  "Rangkasbitung",
	  "Rembang",
	  "Salatiga",
	  "Sampang",
	  "Semarang",
	  "Serang",
	  "Sidayu",
	  "Sidoarjo",
	  "Singaparna",
	  "Situbondo",
	  "Slawi",
	  "Sleman",
	  "Soreang",
	  "Sragen",
	  "Subang",
	  "Sukabumi",
	  "Sukoharjo",
	  "Sumber",
	  "Sumedang",
	  "Sumenep",
	  "Surabaya",
	  "Surakarta",
	  "Tasikmalaya",
	  "Tangerang",
	  "Tangerang Selatan",
	  "Tegal",
	  "Temanggung",
	  "Tigaraksa",
	  "Trenggalek",
	  "Tuban",
	  "Tulungagung",
	  "Ungaran",
	  "Wates",
	  "Wlingi",
	  "Wonogiri",
	  "Wonosari",
	  "Wonosobo",
	  "Yogyakarta",
	  "Atambua",
	  "Baa",
	  "Badung",
	  "Bajawa",
	  "Bangli",
	  "Bima",
	  "Denpasar",
	  "Dompu",
	  "Ende",
	  "Gianyar",
	  "Kalabahi",
	  "Karangasem",
	  "Kefamenanu",
	  "Klungkung",
	  "Kupang",
	  "Labuhan Bajo",
	  "Larantuka",
	  "Lewoleba",
	  "Maumere",
	  "Mataram",
	  "Mbay",
	  "Negara",
	  "Praya",
	  "Raba",
	  "Ruteng",
	  "Selong",
	  "Singaraja",
	  "Soe",
	  "Sumbawa Besar",
	  "Tabanan",
	  "Taliwang",
	  "Tambolaka",
	  "Tanjung",
	  "Waibakul",
	  "Waikabubak",
	  "Waingapu",
	  "Denpasar",
	  "Negara,Bali",
	  "Singaraja",
	  "Tabanan",
	  "Bangli"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Indonesia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.building_number = __webpack_require__(2382);
	address.postcode = __webpack_require__(2387);
	address.state = __webpack_require__(2388);
	address.city_name = __webpack_require__(2384);
	address.city = __webpack_require__(2383);
	address.street_prefix = __webpack_require__(2391);
	address.street_name = __webpack_require__(2390);
	address.street_address = __webpack_require__(2389);
	address.default_country = __webpack_require__(2385);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aceh",
	  "Sumatera Utara",
	  "Sumatera Barat",
	  "Jambi",
	  "Bangka Belitung",
	  "Riau",
	  "Kepulauan Riau",
	  "Bengkulu",
	  "Sumatera Selatan",
	  "Lampung",
	  "Banten",
	  "DKI Jakarta",
	  "Jawa Barat",
	  "Jawa Tengah",
	  "Jawa Timur",
	  "Nusa Tenggara Timur",
	  "DI Yogyakarta",
	  "Bali",
	  "Nusa Tenggara Barat",
	  "Kalimantan Barat",
	  "Kalimantan Tengah",
	  "Kalimantan Selatan",
	  "Kalimantan Timur",
	  "Kalimantan Utara",
	  "Sulawesi Selatan",
	  "Sulawesi Utara",
	  "Gorontalo",
	  "Sulawesi Tengah",
	  "Sulawesi Barat",
	  "Sulawesi Tenggara",
	  "Maluku",
	  "Maluku Utara",
	  "Papua Barat",
	  "Papua"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} no #{building_number}"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Name.first_name}",
	  "#{street_prefix} #{Name.last_name}"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ds.",
	  "Dk.",
	  "Gg.",
	  "Jln.",
	  "Jr.",
	  "Kpg.",
	  "Ki.",
	  "Psr."
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(2394);
	company.suffix = __webpack_require__(2395);
	company.name = __webpack_require__(2393);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.last_name}",
	  "#{Name.last_name} #{suffix}",
	  "#{prefix} #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "PT",
	  "CV",
	  "UD",
	  "PD",
	  "Perum"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(Persero) Tbk",
	  "Tbk"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(2397);
	date.weekday = __webpack_require__(2398);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  wide: [
	    "Januari",
	    "Februari",
	    "Maret",
	    "April",
	    "Mei",
	    "Juni",
	    "Juli",
	    "Agustus",
	    "September",
	    "Oktober",
	    "November",
	    "Desember"
	  ],
	  wide_context: [
	    "Januari",
	    "Februari",
	    "Maret",
	    "April",
	    "Mei",
	    "Juni",
	    "Juli",
	    "Agustus",
	    "September",
	    "Oktober",
	    "November",
	    "Desember"
	  ],
	  abbr: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "Mei",
	    "Jun",
	    "Jul",
	    "Ags",
	    "Sep",
	    "Okt",
	    "Nov",
	    "Des"
	  ],
	  abbr_context: [
	    "Jan",
	    "Feb",
	    "Mar",
	    "Apr",
	    "Mei",
	    "Jun",
	    "Jul",
	    "Ags",
	    "Sep",
	    "Okt",
	    "Nov",
	    "Des"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  wide: [
	    "Minggu",
	    "Senin",
	    "Selasa",
	    "Rabu",
	    "Kamis",
	    "Jumat",
	    "Sabtu"
	  ],
	  wide_context: [
	    "Minggu",
	    "Senin",
	    "Selasa",
	    "Rabu",
	    "Kamis",
	    "Jumat",
	    "Sabtu"
	  ],
	  abbr: [
	    "Min",
	    "Sen",
	    "Sel",
	    "Rab",
	    "Kam",
	    "Jum",
	    "Sab"
	  ],
	  abbr_context: [
	    "Min",
	    "Sen",
	    "Sel",
	    "Rab",
	    "Kam",
	    "Jum",
	    "Sab"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var id = {};
	module['exports'] = id;
	id.title = "Indonesia";
	id.address = __webpack_require__(2386);
	id.company = __webpack_require__(2392);
	id.internet = __webpack_require__(2402);
	id.date = __webpack_require__(2396);
	id.name = __webpack_require__(2405);
	id.phone_number = __webpack_require__(2412);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "org",
	  "asia",
	  "tv",
	  "biz",
	  "info",
	  "in",
	  "name",
	  "co",
	  "ac.id",
	  "sch.id",
	  "go.id",
	  "mil.id",
	  "co.id",
	  "or.id",
	  "web.id",
	  "my.id",
	  "biz.id",
	  "desa.id"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  'gmail.com',
	  'yahoo.com',
	  'gmail.co.id',
	  'yahoo.co.id'
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2401);
	internet.domain_suffix = __webpack_require__(2400);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ade",
	  "Agnes",
	  "Ajeng",
	  "Amalia",
	  "Anita",
	  "Ayu",
	  "Aisyah",
	  "Ana",
	  "Ami",
	  "Ani",
	  "Azalea",
	  "Aurora",
	  "Alika",
	  "Anastasia",
	  "Amelia",
	  "Almira",
	  "Bella",
	  "Betania",
	  "Belinda",
	  "Citra",
	  "Cindy",
	  "Chelsea",
	  "Clara",
	  "Cornelia",
	  "Cinta",
	  "Cinthia",
	  "Ciaobella",
	  "Cici",
	  "Carla",
	  "Calista",
	  "Devi",
	  "Dewi","Dian",
	  "Diah",
	  "Diana",
	  "Dina",
	  "Dinda",
	  "Dalima",
	  "Eka",
	  "Eva",
	  "Endah",
	  "Elisa",
	  "Eli",
	  "Ella",
	  "Ellis",
	  "Elma",
	  "Elvina",
	  "Fitria",
	  "Fitriani",
	  "Febi",
	  "Faizah",
	  "Farah",
	  "Farhunnisa",
	  "Fathonah",
	  "Gabriella",
	  "Gasti",
	  "Gawati",
	  "Genta",
	  "Ghaliyati",
	  "Gina",
	  "Gilda",
	  "Halima",
	  "Hesti",
	  "Hilda",
	  "Hafshah",
	  "Hamima",
	  "Hana",
	  "Hani",
	  "Hasna",
	  "Humaira",
	  "Ika",
	  "Indah",
	  "Intan",
	  "Irma",
	  "Icha",
	  "Ida",
	  "Ifa",
	  "Ilsa",
	  "Ina",
	  "Ira",
	  "Iriana",
	  "Jamalia",
	  "Janet",
	  "Jane",
	  "Julia",
	  "Juli",
	  "Jessica",
	  "Jasmin",
	  "Jelita",
	  "Kamaria",
	  "Kamila",
	  "Kani",
	  "Karen",
	  "Karimah",
	  "Kartika",
	  "Kasiyah",
	  "Keisha",
	  "Kezia",
	  "Kiandra",
	  "Kayla",
	  "Kania",
	  "Lala",
	  "Lalita",
	  "Latika",
	  "Laila",
	  "Laras",
	  "Lidya",
	  "Lili",
	  "Lintang",
	  "Maria",
	  "Mala",
	  "Maya",
	  "Maida",
	  "Maimunah",
	  "Melinda",
	  "Mila",
	  "Mutia",
	  "Michelle",
	  "Malika",
	  "Nadia",
	  "Nadine",
	  "Nabila",
	  "Natalia",
	  "Novi",
	  "Nova",
	  "Nurul",
	  "Nilam",
	  "Najwa",
	  "Olivia",
	  "Ophelia",
	  "Oni",
	  "Oliva",
	  "Padma",
	  "Putri",
	  "Paramita",
	  "Paris",
	  "Patricia",
	  "Paulin",
	  "Puput",
	  "Puji",
	  "Pia",
	  "Puspa",
	  "Puti",
	  "Putri",
	  "Padmi",
	  "Qori",
	  "Queen",
	  "Ratih",
	  "Ratna",
	  "Restu",
	  "Rini",
	  "Rika",
	  "Rina",
	  "Rahayu",
	  "Rahmi",
	  "Rachel",
	  "Rahmi",
	  "Raisa",
	  "Raina",
	  "Sarah",
	  "Sari",
	  "Siti",
	  "Siska",
	  "Suci",
	  "Syahrini",
	  "Septi",
	  "Sadina",
	  "Safina",
	  "Sakura",
	  "Salimah",
	  "Salwa",
	  "Salsabila",
	  "Samiah",
	  "Shania",
	  "Sabrina",
	  "Silvia",
	  "Shakila",
	  "Talia",
	  "Tami",
	  "Tira",
	  "Tiara",
	  "Titin",
	  "Tania",
	  "Tina",
	  "Tantri",
	  "Tari",
	  "Titi",
	  "Uchita",
	  "Unjani",
	  "Ulya",
	  "Uli",
	  "Ulva",
	  "Umi",
	  "Usyi",
	  "Vanya",
	  "Vanesa",
	  "Vivi",
	  "Vera",
	  "Vicky",
	  "Victoria",
	  "Violet",
	  "Winda",
	  "Widya",
	  "Wulan",
	  "Wirda",
	  "Wani",
	  "Yani",
	  "Yessi",
	  "Yulia",
	  "Yuliana",
	  "Yuni",
	  "Yunita",
	  "Yance",
	  "Zahra",
	  "Zalindra",
	  "Zaenab",
	  "Zulfa",
	  "Zizi",
	  "Zulaikha",
	  "Zamira",
	  "Zelda",
	  "Zelaya"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Agustina",
	  "Andriani",
	  "Anggraini",
	  "Aryani",
	  "Astuti",
	  "Fujiati",
	  "Farida",
	  "Handayani",
	  "Hassanah",
	  "Hartati",
	  "Hasanah",
	  "Haryanti",
	  "Hariyah",
	  "Hastuti",
	  "Halimah",
	  "Kusmawati",
	  "Kuswandari",
	  "Laksmiwati",
	  "Laksita",
	  "Lestari",
	  "Lailasari",
	  "Mandasari",
	  "Mardhiyah",
	  "Mayasari",
	  "Melani",
	  "Mulyani",
	  "Maryati",
	  "Nurdiyanti",
	  "Novitasari",
	  "Nuraini",
	  "Nasyidah",
	  "Nasyiah",
	  "Namaga",
	  "Palastri",
	  "Pudjiastuti",
	  "Puspasari",
	  "Puspita",
	  "Purwanti",
	  "Pratiwi",
	  "Purnawati",
	  "Pertiwi",
	  "Permata",
	  "Prastuti",
	  "Padmasari",
	  "Rahmawati",
	  "Rahayu",
	  "Riyanti",
	  "Rahimah",
	  "Suartini",
	  "Sudiati",
	  "Suryatmi",
	  "Susanti",
	  "Safitri",
	  "Oktaviani",
	  "Utami",
	  "Usamah",
	  "Usada",
	  "Uyainah",
	  "Yuniar",
	  "Yuliarti",
	  "Yulianti",
	  "Yolanda",
	  "Wahyuni",
	  "Wijayanti",
	  "Widiastuti",
	  "Winarsih",
	  "Wulandari",
	  "Wastuti",
	  "Zulaika"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(2406);
	name.male_last_name = __webpack_require__(2407);
	name.female_first_name = __webpack_require__(2403);
	name.female_last_name = __webpack_require__(2404);
	name.prefix = __webpack_require__(2409);
	name.suffix = __webpack_require__(2410);
	name.name = __webpack_require__(2408);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abyasa",
	  "Ade",
	  "Adhiarja",
	  "Adiarja",
	  "Adika",
	  "Adikara",
	  "Adinata",
	  "Aditya",
	  "Agus",
	  "Ajiman",
	  "Ajimat",
	  "Ajimin",
	  "Ajiono",
	  "Akarsana",
	  "Alambana",
	  "Among",
	  "Anggabaya",
	  "Anom",
	  "Argono",
	  "Aris",
	  "Arta",
	  "Artanto",
	  "Artawan",
	  "Arsipatra",
	  "Asirwada",
	  "Asirwanda",
	  "Aslijan",
	  "Asmadi",
	  "Asman",
	  "Asmianto",
	  "Asmuni",
	  "Aswani",
	  "Atma",
	  "Atmaja",
	  "Bagas",
	  "Bagiya",
	  "Bagus",
	  "Bagya",
	  "Bahuraksa",
	  "Bahuwarna",
	  "Bahuwirya",
	  "Bajragin",
	  "Bakda",
	  "Bakiadi",
	  "Bakianto",
	  "Bakidin",
	  "Bakijan",
	  "Bakiman",
	  "Bakiono",
	  "Bakti",
	  "Baktiadi",
	  "Baktianto",
	  "Baktiono",
	  "Bala",
	  "Balamantri",
	  "Balangga",
	  "Balapati",
	  "Balidin",
	  "Balijan",
	  "Bambang",
	  "Banara",
	  "Banawa",
	  "Banawi",
	  "Bancar",
	  "Budi",
	  "Cagak",
	  "Cager",
	  "Cahyadi",
	  "Cahyanto",
	  "Cahya",
	  "Cahyo",
	  "Cahyono",
	  "Caket",
	  "Cakrabirawa",
	  "Cakrabuana",
	  "Cakrajiya",
	  "Cakrawala",
	  "Cakrawangsa",
	  "Candra",
	  "Chandra",
	  "Candrakanta",
	  "Capa",
	  "Caraka",
	  "Carub",
	  "Catur",
	  "Caturangga",
	  "Cawisadi",
	  "Cawisono",
	  "Cawuk",
	  "Cayadi",
	  "Cecep",
	  "Cemani",
	  "Cemeti",
	  "Cemplunk",
	  "Cengkal",
	  "Cengkir",
	  "Dacin",
	  "Dadap",
	  "Dadi",
	  "Dagel",
	  "Daliman",
	  "Dalimin",
	  "Daliono",
	  "Damar",
	  "Damu",
	  "Danang",
	  "Daniswara",
	  "Danu",
	  "Danuja",
	  "Dariati",
	  "Darijan",
	  "Darimin",
	  "Darmaji",
	  "Darman",
	  "Darmana",
	  "Darmanto",
	  "Darsirah",
	  "Dartono",
	  "Daru",
	  "Daruna",
	  "Daryani",
	  "Dasa",
	  "Digdaya",
	  "Dimas",
	  "Dimaz",
	  "Dipa",
	  "Dirja",
	  "Drajat",
	  "Dwi",
	  "Dono",
	  "Dodo",
	  "Edi",
	  "Eka",
	  "Elon",
	  "Eluh",
	  "Eman",
	  "Emas",
	  "Embuh",
	  "Emong",
	  "Empluk",
	  "Endra",
	  "Enteng",
	  "Estiawan",
	  "Estiono",
	  "Eko",
	  "Edi",
	  "Edison",
	  "Edward",
	  "Elvin",
	  "Erik",
	  "Emil",
	  "Ega",
	  "Emin",
	  "Eja",
	  "Gada",
	  "Gadang",
	  "Gaduh",
	  "Gaiman",
	  "Galak",
	  "Galang",
	  "Galar",
	  "Galih",
	  "Galiono",
	  "Galuh",
	  "Galur",
	  "Gaman",
	  "Gamani",
	  "Gamanto",
	  "Gambira",
	  "Gamblang",
	  "Ganda",
	  "Gandewa",
	  "Gandi",
	  "Gandi",
	  "Ganep",
	  "Gangsa",
	  "Gangsar",
	  "Ganjaran",
	  "Gantar",
	  "Gara",
	  "Garan",
	  "Garang",
	  "Garda",
	  "Gatot",
	  "Gatra",
	  "Gilang",
	  "Galih",
	  "Ghani",
	  "Gading",
	  "Hairyanto",
	  "Hardana",
	  "Hardi",
	  "Harimurti",
	  "Harja",
	  "Harjasa",
	  "Harjaya",
	  "Harjo",
	  "Harsana",
	  "Harsanto",
	  "Harsaya",
	  "Hartaka",
	  "Hartana",
	  "Harto",
	  "Hasta",
	  "Heru",
	  "Himawan",
	  "Hadi",
	  "Halim",
	  "Hasim",
	  "Hasan",
	  "Hendra",
	  "Hendri",
	  "Heryanto",
	  "Hamzah",
	  "Hari",
	  "Imam",
	  "Indra",
	  "Irwan",
	  "Irsad",
	  "Ikhsan",
	  "Irfan",
	  "Ian",
	  "Ibrahim",
	  "Ibrani",
	  "Ismail",
	  "Irnanto",
	  "Ilyas",
	  "Ibun",
	  "Ivan",
	  "Ikin",
	  "Ihsan",
	  "Jabal",
	  "Jaeman",
	  "Jaga",
	  "Jagapati",
	  "Jagaraga",
	  "Jail",
	  "Jaiman",
	  "Jaka",
	  "Jarwa",
	  "Jarwadi",
	  "Jarwi",
	  "Jasmani",
	  "Jaswadi",
	  "Jati",
	  "Jatmiko",
	  "Jaya",
	  "Jayadi",
	  "Jayeng",
	  "Jinawi",
	  "Jindra",
	  "Joko",
	  "Jumadi",
	  "Jumari",
	  "Jamal",
	  "Jamil",
	  "Jais",
	  "Jefri",
	  "Johan",
	  "Jono",
	  "Kacung",
	  "Kajen",
	  "Kambali",
	  "Kamidin",
	  "Kariman",
	  "Karja",
	  "Karma",
	  "Karman",
	  "Karna",
	  "Karsa",
	  "Karsana",
	  "Karta",
	  "Kasiran",
	  "Kasusra",
	  "Kawaca",
	  "Kawaya",
	  "Kayun",
	  "Kemba",
	  "Kenari",
	  "Kenes",
	  "Kuncara",
	  "Kunthara",
	  "Kusuma",
	  "Kadir",
	  "Kala",
	  "Kalim",
	  "Kurnia",
	  "Kanda",
	  "Kardi",
	  "Karya",
	  "Kasim",
	  "Kairav",
	  "Kenzie",
	  "Kemal",
	  "Kamal",
	  "Koko",
	  "Labuh",
	  "Laksana",
	  "Lamar",
	  "Lanang",
	  "Langgeng",
	  "Lanjar",
	  "Lantar",
	  "Lega",
	  "Legawa",
	  "Lembah",
	  "Liman",
	  "Limar",
	  "Luhung",
	  "Lukita",
	  "Luluh",
	  "Lulut",
	  "Lurhur",
	  "Luwar",
	  "Luwes",
	  "Latif",
	  "Lasmanto",
	  "Lukman",
	  "Luthfi",
	  "Leo",
	  "Luis",
	  "Lutfan",
	  "Lasmono",
	  "Laswi",
	  "Mahesa",
	  "Makara",
	  "Makuta",
	  "Manah",
	  "Maras",
	  "Margana",
	  "Mariadi",
	  "Marsudi",
	  "Martaka",
	  "Martana",
	  "Martani",
	  "Marwata",
	  "Maryadi",
	  "Maryanto",
	  "Mitra",
	  "Mujur",
	  "Mulya",
	  "Mulyanto",
	  "Mulyono",
	  "Mumpuni",
	  "Muni",
	  "Mursita",
	  "Murti",
	  "Mustika",
	  "Maman",
	  "Mahmud",
	  "Mahdi",
	  "Mahfud",
	  "Malik",
	  "Muhammad",
	  "Mustofa",
	  "Marsito",
	  "Mursinin",
	  "Nalar",
	  "Naradi",
	  "Nardi",
	  "Niyaga",
	  "Nrima",
	  "Nugraha",
	  "Nyana",
	  "Narji",
	  "Nasab",
	  "Nasrullah",
	  "Nasim",
	  "Najib",
	  "Najam",
	  "Nyoman",
	  "Olga",
	  "Ozy",
	  "Omar",
	  "Opan",
	  "Oskar",
	  "Oman",
	  "Okto",
	  "Okta",
	  "Opung",
	  "Paiman",
	  "Panca",
	  "Pangeran",
	  "Pangestu",
	  "Pardi",
	  "Parman",
	  "Perkasa",
	  "Praba",
	  "Prabu",
	  "Prabawa",
	  "Prabowo",
	  "Prakosa",
	  "Pranata",
	  "Pranawa",
	  "Prasetya",
	  "Prasetyo",
	  "Prayitna",
	  "Prayoga",
	  "Prayogo",
	  "Purwadi",
	  "Purwa",
	  "Purwanto",
	  "Panji",
	  "Pandu",
	  "Paiman",
	  "Prima",
	  "Putu",
	  "Raden",
	  "Raditya",
	  "Raharja",
	  "Rama",
	  "Rangga",
	  "Reksa",
	  "Respati",
	  "Rusman",
	  "Rosman",
	  "Rahmat",
	  "Rahman",
	  "Rendy",
	  "Reza",
	  "Rizki",
	  "Ridwan",
	  "Rudi",
	  "Raden",
	  "Radit",
	  "Radika",
	  "Rafi",
	  "Rafid",
	  "Raihan",
	  "Salman",
	  "Saadat",
	  "Saiful",
	  "Surya",
	  "Slamet",
	  "Samsul",
	  "Soleh",
	  "Simon",
	  "Sabar",
	  "Sabri",
	  "Sidiq",
	  "Satya",
	  "Setya",
	  "Saka",
	  "Sakti",
	  "Taswir",
	  "Tedi",
	  "Teddy",
	  "Taufan",
	  "Taufik",
	  "Tomi",
	  "Tasnim",
	  "Teguh",
	  "Tasdik",
	  "Timbul",
	  "Tirta",
	  "Tirtayasa",
	  "Tri",
	  "Tugiman",
	  "Umar",
	  "Usman",
	  "Uda",
	  "Umay",
	  "Unggul",
	  "Utama",
	  "Umaya",
	  "Upik",
	  "Viktor",
	  "Vino",
	  "Vinsen",
	  "Vero",
	  "Vega",
	  "Viman",
	  "Virman",
	  "Wahyu",
	  "Wira",
	  "Wisnu",
	  "Wadi",
	  "Wardi",
	  "Warji",
	  "Waluyo",
	  "Wakiman",
	  "Wage",
	  "Wardaya",
	  "Warsa",
	  "Warsita",
	  "Warta",
	  "Wasis",
	  "Wawan",
	  "Xanana",
	  "Yahya",
	  "Yusuf",
	  "Yosef",
	  "Yono",
	  "Yoga"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adriansyah",
	  "Ardianto",
	  "Anggriawan",
	  "Budiman",
	  "Budiyanto",
	  "Damanik",
	  "Dongoran",
	  "Dabukke",
	  "Firmansyah",
	  "Firgantoro",
	  "Gunarto",
	  "Gunawan",
	  "Hardiansyah",
	  "Habibi",
	  "Hakim",
	  "Halim",
	  "Haryanto",
	  "Hidayat",
	  "Hidayanto",
	  "Hutagalung",
	  "Hutapea",
	  "Hutasoit",
	  "Irawan",
	  "Iswahyudi",
	  "Kuswoyo",
	  "Januar",
	  "Jailani",
	  "Kurniawan",
	  "Kusumo",
	  "Latupono",
	  "Lazuardi",
	  "Maheswara",
	  "Mahendra",
	  "Mustofa",
	  "Mansur",
	  "Mandala",
	  "Megantara",
	  "Maulana",
	  "Maryadi",
	  "Mangunsong",
	  "Manullang",
	  "Marpaung",
	  "Marbun",
	  "Narpati",
	  "Natsir",
	  "Nugroho",
	  "Najmudin",
	  "Nashiruddin",
	  "Nainggolan",
	  "Nababan",
	  "Napitupulu",
	  "Pangestu",
	  "Putra",
	  "Pranowo",
	  "Prabowo",
	  "Pratama",
	  "Prasetya",
	  "Prasetyo",
	  "Pradana",
	  "Pradipta",
	  "Prakasa",
	  "Permadi",
	  "Prasasta",
	  "Prayoga",
	  "Ramadan",
	  "Rajasa",
	  "Rajata",
	  "Saptono",
	  "Santoso",
	  "Saputra",
	  "Saefullah",
	  "Setiawan",
	  "Suryono",
	  "Suwarno",
	  "Siregar",
	  "Sihombing",
	  "Salahudin",
	  "Sihombing",
	  "Samosir",
	  "Saragih",
	  "Sihotang",
	  "Simanjuntak",
	  "Sinaga",
	  "Simbolon",
	  "Sitompul",
	  "Sitorus",
	  "Sirait",
	  "Siregar",
	  "Situmorang",
	  "Tampubolon",
	  "Thamrin",
	  "Tamba",
	  "Tarihoran",
	  "Utama",
	  "Uwais",
	  "Wahyudin",
	  "Waluyo",
	  "Wibowo",
	  "Winarno",
	  "Wibisono",
	  "Wijaya",
	  "Widodo",
	  "Wacana",
	  "Waskita",
	  "Wasita",
	  "Zulkarnain"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_first_name} #{male_last_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_first_name} #{male_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_first_name} #{female_last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.Ked",
	  "S.Gz",
	  "S.Pt",
	  "S.IP",
	  "S.E.I",
	  "S.E.",
	  "S.Kom",
	  "S.H.",
	  "S.T.",
	  "S.Pd",
	  "S.Psi",
	  "S.I.Kom",
	  "S.Sos",
	  "S.Farm",
	  "M.M.",
	  "M.Kom.",
	  "M.TI.",
	  "M.Pd",
	  "M.Farm",
	  "M.Ak"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "02# #### ###",
	  "02## #### ###",
	  "03## #### ###",
	  "04## #### ###",
	  "05## #### ###",
	  "06## #### ###",
	  "07## #### ###",
	  "09## #### ###",
	  "02# #### ####",
	  "02## #### ####",
	  "03## #### ####",
	  "04## #### ####",
	  "05## #### ####",
	  "06## #### ####",
	  "07## #### ####",
	  "09## #### ####",
	  "08## ### ###",
	  "08## #### ###",
	  "08## #### ####",
	  "(+62) 8## ### ###",
	  "(+62) 2# #### ###",
	  "(+62) 2## #### ###",
	  "(+62) 3## #### ###",
	  "(+62) 4## #### ###",
	  "(+62) 5## #### ###",
	  "(+62) 6## #### ###",
	  "(+62) 7## #### ###",
	  "(+62) 8## #### ###",
	  "(+62) 9## #### ###",
	  "(+62) 2# #### ####",
	  "(+62) 2## #### ####",
	  "(+62) 3## #### ####",
	  "(+62) 4## #### ####",
	  "(+62) 5## #### ####",
	  "(+62) 6## #### ####",
	  "(+62) 7## #### ####",
	  "(+62) 8## #### ####",
	  "(+62) 9## #### ####"
	];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2411);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix} #{Name.first_name} #{city_suffix}",
	  "#{city_prefix} #{Name.first_name}",
	  "#{Name.first_name} #{city_suffix}",
	  "#{Name.last_name} #{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "San",
	  "Borgo",
	  "Sesto",
	  "Quarto",
	  "Settimo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "a mare",
	  "lido",
	  "ligure",
	  "del friuli",
	  "salentino",
	  "calabro",
	  "veneto",
	  "nell'emilia",
	  "umbro",
	  "laziale",
	  "terme",
	  "sardo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Albania",
	  "Algeria",
	  "American Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antartide (territori a sud del 60° parallelo)",
	  "Antigua e Barbuda",
	  "Argentina",
	  "Armenia",
	  "Aruba",
	  "Australia",
	  "Austria",
	  "Azerbaijan",
	  "Bahamas",
	  "Bahrain",
	  "Bangladesh",
	  "Barbados",
	  "Bielorussia",
	  "Belgio",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivia",
	  "Bosnia e Herzegovina",
	  "Botswana",
	  "Bouvet Island (Bouvetoya)",
	  "Brasile",
	  "Territorio dell'arcipelago indiano",
	  "Isole Vergini Britanniche",
	  "Brunei Darussalam",
	  "Bulgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Cambogia",
	  "Cameroon",
	  "Canada",
	  "Capo Verde",
	  "Isole Cayman",
	  "Repubblica Centrale Africana",
	  "Chad",
	  "Cile",
	  "Cina",
	  "Isola di Pasqua",
	  "Isola di Cocos (Keeling)",
	  "Colombia",
	  "Comoros",
	  "Congo",
	  "Isole Cook",
	  "Costa Rica",
	  "Costa d'Avorio",
	  "Croazia",
	  "Cuba",
	  "Cipro",
	  "Repubblica Ceca",
	  "Danimarca",
	  "Gibuti",
	  "Repubblica Dominicana",
	  "Equador",
	  "Egitto",
	  "El Salvador",
	  "Guinea Equatoriale",
	  "Eritrea",
	  "Estonia",
	  "Etiopia",
	  "Isole Faroe",
	  "Isole Falkland (Malvinas)",
	  "Fiji",
	  "Finlandia",
	  "Francia",
	  "Guyana Francese",
	  "Polinesia Francese",
	  "Territori Francesi del sud",
	  "Gabon",
	  "Gambia",
	  "Georgia",
	  "Germania",
	  "Ghana",
	  "Gibilterra",
	  "Grecia",
	  "Groenlandia",
	  "Grenada",
	  "Guadalupa",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinea-Bissau",
	  "Guyana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Città del Vaticano",
	  "Honduras",
	  "Hong Kong",
	  "Ungheria",
	  "Islanda",
	  "India",
	  "Indonesia",
	  "Iran",
	  "Iraq",
	  "Irlanda",
	  "Isola di Man",
	  "Israele",
	  "Italia",
	  "Giamaica",
	  "Giappone",
	  "Jersey",
	  "Giordania",
	  "Kazakhstan",
	  "Kenya",
	  "Kiribati",
	  "Korea",
	  "Kuwait",
	  "Republicca Kirgiza",
	  "Repubblica del Laos",
	  "Latvia",
	  "Libano",
	  "Lesotho",
	  "Liberia",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lituania",
	  "Lussemburgo",
	  "Macao",
	  "Macedonia",
	  "Madagascar",
	  "Malawi",
	  "Malesia",
	  "Maldive",
	  "Mali",
	  "Malta",
	  "Isole Marshall",
	  "Martinica",
	  "Mauritania",
	  "Mauritius",
	  "Mayotte",
	  "Messico",
	  "Micronesia",
	  "Moldova",
	  "Principato di Monaco",
	  "Mongolia",
	  "Montenegro",
	  "Montserrat",
	  "Marocco",
	  "Mozambico",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Antille Olandesi",
	  "Olanda",
	  "Nuova Caledonia",
	  "Nuova Zelanda",
	  "Nicaragua",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Isole Norfolk",
	  "Northern Mariana Islands",
	  "Norvegia",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Palestina",
	  "Panama",
	  "Papua Nuova Guinea",
	  "Paraguay",
	  "Peru",
	  "Filippine",
	  "Pitcairn Islands",
	  "Polonia",
	  "Portogallo",
	  "Porto Rico",
	  "Qatar",
	  "Reunion",
	  "Romania",
	  "Russia",
	  "Rwanda",
	  "San Bartolomeo",
	  "Sant'Elena",
	  "Saint Kitts and Nevis",
	  "Saint Lucia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tome and Principe",
	  "Arabia Saudita",
	  "Senegal",
	  "Serbia",
	  "Seychelles",
	  "Sierra Leone",
	  "Singapore",
	  "Slovenia",
	  "Isole Solomon",
	  "Somalia",
	  "Sud Africa",
	  "Georgia del sud e South Sandwich Islands",
	  "Spagna",
	  "Sri Lanka",
	  "Sudan",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Svezia",
	  "Svizzera",
	  "Siria",
	  "Taiwan",
	  "Tajikistan",
	  "Tanzania",
	  "Tailandia",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad e Tobago",
	  "Tunisia",
	  "Turchia",
	  "Turkmenistan",
	  "Isole di Turks and Caicos",
	  "Tuvalu",
	  "Uganda",
	  "Ucraina",
	  "Emirati Arabi Uniti",
	  "Regno Unito",
	  "Stati Uniti d'America",
	  "United States Minor Outlying Islands",
	  "Isole Vergini Statunitensi",
	  "Uruguay",
	  "Uzbekistan",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Wallis and Futuna",
	  "Western Sahara",
	  "Yemen",
	  "Zambia",
	  "Zimbabwe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Italia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2415);
	address.city_suffix = __webpack_require__(2416);
	address.country = __webpack_require__(2417);
	address.building_number = __webpack_require__(2413);
	address.street_suffix = __webpack_require__(2426);
	address.secondary_address = __webpack_require__(2421);
	address.postcode = __webpack_require__(2420);
	address.state = __webpack_require__(2422);
	address.state_abbr = __webpack_require__(2423);
	address.city = __webpack_require__(2414);
	address.street_name = __webpack_require__(2425);
	address.street_address = __webpack_require__(2424);
	address.default_country = __webpack_require__(2418);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Appartamento ##",
	  "Piano #"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Agrigento",
	  "Alessandria",
	  "Ancona",
	  "Aosta",
	  "Arezzo",
	  "Ascoli Piceno",
	  "Asti",
	  "Avellino",
	  "Bari",
	  "Barletta-Andria-Trani",
	  "Belluno",
	  "Benevento",
	  "Bergamo",
	  "Biella",
	  "Bologna",
	  "Bolzano",
	  "Brescia",
	  "Brindisi",
	  "Cagliari",
	  "Caltanissetta",
	  "Campobasso",
	  "Carbonia-Iglesias",
	  "Caserta",
	  "Catania",
	  "Catanzaro",
	  "Chieti",
	  "Como",
	  "Cosenza",
	  "Cremona",
	  "Crotone",
	  "Cuneo",
	  "Enna",
	  "Fermo",
	  "Ferrara",
	  "Firenze",
	  "Foggia",
	  "Forlì-Cesena",
	  "Frosinone",
	  "Genova",
	  "Gorizia",
	  "Grosseto",
	  "Imperia",
	  "Isernia",
	  "La Spezia",
	  "L'Aquila",
	  "Latina",
	  "Lecce",
	  "Lecco",
	  "Livorno",
	  "Lodi",
	  "Lucca",
	  "Macerata",
	  "Mantova",
	  "Massa-Carrara",
	  "Matera",
	  "Messina",
	  "Milano",
	  "Modena",
	  "Monza e della Brianza",
	  "Napoli",
	  "Novara",
	  "Nuoro",
	  "Olbia-Tempio",
	  "Oristano",
	  "Padova",
	  "Palermo",
	  "Parma",
	  "Pavia",
	  "Perugia",
	  "Pesaro e Urbino",
	  "Pescara",
	  "Piacenza",
	  "Pisa",
	  "Pistoia",
	  "Pordenone",
	  "Potenza",
	  "Prato",
	  "Ragusa",
	  "Ravenna",
	  "Reggio Calabria",
	  "Reggio Emilia",
	  "Rieti",
	  "Rimini",
	  "Roma",
	  "Rovigo",
	  "Salerno",
	  "Medio Campidano",
	  "Sassari",
	  "Savona",
	  "Siena",
	  "Siracusa",
	  "Sondrio",
	  "Taranto",
	  "Teramo",
	  "Terni",
	  "Torino",
	  "Ogliastra",
	  "Trapani",
	  "Trento",
	  "Treviso",
	  "Trieste",
	  "Udine",
	  "Varese",
	  "Venezia",
	  "Verbano-Cusio-Ossola",
	  "Vercelli",
	  "Verona",
	  "Vibo Valentia",
	  "Vicenza",
	  "Viterbo"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AG",
	  "AL",
	  "AN",
	  "AO",
	  "AR",
	  "AP",
	  "AT",
	  "AV",
	  "BA",
	  "BT",
	  "BL",
	  "BN",
	  "BG",
	  "BI",
	  "BO",
	  "BZ",
	  "BS",
	  "BR",
	  "CA",
	  "CL",
	  "CB",
	  "CI",
	  "CE",
	  "CT",
	  "CZ",
	  "CH",
	  "CO",
	  "CS",
	  "CR",
	  "KR",
	  "CN",
	  "EN",
	  "FM",
	  "FE",
	  "FI",
	  "FG",
	  "FC",
	  "FR",
	  "GE",
	  "GO",
	  "GR",
	  "IM",
	  "IS",
	  "SP",
	  "AQ",
	  "LT",
	  "LE",
	  "LC",
	  "LI",
	  "LO",
	  "LU",
	  "MC",
	  "MN",
	  "MS",
	  "MT",
	  "ME",
	  "MI",
	  "MO",
	  "MB",
	  "NA",
	  "NO",
	  "NU",
	  "OT",
	  "OR",
	  "PD",
	  "PA",
	  "PR",
	  "PV",
	  "PG",
	  "PU",
	  "PE",
	  "PC",
	  "PI",
	  "PT",
	  "PN",
	  "PZ",
	  "PO",
	  "RG",
	  "RA",
	  "RC",
	  "RE",
	  "RI",
	  "RN",
	  "RM",
	  "RO",
	  "SA",
	  "VS",
	  "SS",
	  "SV",
	  "SI",
	  "SR",
	  "SO",
	  "TA",
	  "TE",
	  "TR",
	  "TO",
	  "OG",
	  "TP",
	  "TN",
	  "TV",
	  "TS",
	  "UD",
	  "VA",
	  "VE",
	  "VB",
	  "VC",
	  "VR",
	  "VV",
	  "VI",
	  "VT"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}",
	  "#{street_name} #{building_number}, #{secondary_address}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Name.first_name}",
	  "#{street_suffix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Piazza",
	  "Strada",
	  "Via",
	  "Borgo",
	  "Contrada",
	  "Rotonda",
	  "Incrocio"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 ore",
	  "24/7",
	  "terza generazione",
	  "quarta generazione",
	  "quinta generazione",
	  "sesta generazione",
	  "asimmetrica",
	  "asincrona",
	  "background",
	  "bi-direzionale",
	  "biforcata",
	  "bottom-line",
	  "coerente",
	  "coesiva",
	  "composita",
	  "sensibile al contesto",
	  "basta sul contesto",
	  "basata sul contenuto",
	  "dedicata",
	  "didattica",
	  "direzionale",
	  "discreta",
	  "dinamica",
	  "eco-centrica",
	  "esecutiva",
	  "esplicita",
	  "full-range",
	  "globale",
	  "euristica",
	  "alto livello",
	  "olistica",
	  "omogenea",
	  "ibrida",
	  "impattante",
	  "incrementale",
	  "intangibile",
	  "interattiva",
	  "intermediaria",
	  "locale",
	  "logistica",
	  "massimizzata",
	  "metodica",
	  "mission-critical",
	  "mobile",
	  "modulare",
	  "motivazionale",
	  "multimedia",
	  "multi-tasking",
	  "nazionale",
	  "neutrale",
	  "nextgeneration",
	  "non-volatile",
	  "object-oriented",
	  "ottima",
	  "ottimizzante",
	  "radicale",
	  "real-time",
	  "reciproca",
	  "regionale",
	  "responsiva",
	  "scalabile",
	  "secondaria",
	  "stabile",
	  "statica",
	  "sistematica",
	  "sistemica",
	  "tangibile",
	  "terziaria",
	  "uniforme",
	  "valore aggiunto"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "valore aggiunto",
	  "verticalizzate",
	  "proattive",
	  "forti",
	  "rivoluzionari",
	  "scalabili",
	  "innovativi",
	  "intuitivi",
	  "strategici",
	  "e-business",
	  "mission-critical",
	  "24/7",
	  "globali",
	  "B2B",
	  "B2C",
	  "granulari",
	  "virtuali",
	  "virali",
	  "dinamiche",
	  "magnetiche",
	  "web",
	  "interattive",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficienti",
	  "front-end",
	  "distributivi",
	  "estensibili",
	  "mondiali",
	  "open-source",
	  "cross-platform",
	  "sinergiche",
	  "out-of-the-box",
	  "enterprise",
	  "integrate",
	  "di impatto",
	  "wireless",
	  "trasparenti",
	  "next-generation",
	  "cutting-edge",
	  "visionari",
	  "plug-and-play",
	  "collaborative",
	  "olistiche",
	  "ricche"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "partnerships",
	  "comunità",
	  "ROI",
	  "soluzioni",
	  "e-services",
	  "nicchie",
	  "tecnologie",
	  "contenuti",
	  "supply-chains",
	  "convergenze",
	  "relazioni",
	  "architetture",
	  "interfacce",
	  "mercati",
	  "e-commerce",
	  "sistemi",
	  "modelli",
	  "schemi",
	  "reti",
	  "applicazioni",
	  "metriche",
	  "e-business",
	  "funzionalità",
	  "esperienze",
	  "webservices",
	  "metodologie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implementate",
	  "utilizzo",
	  "integrate",
	  "ottimali",
	  "evolutive",
	  "abilitate",
	  "reinventate",
	  "aggregate",
	  "migliorate",
	  "incentivate",
	  "monetizzate",
	  "sinergizzate",
	  "strategiche",
	  "deploy",
	  "marchi",
	  "accrescitive",
	  "target",
	  "sintetizzate",
	  "spedizioni",
	  "massimizzate",
	  "innovazione",
	  "guida",
	  "estensioni",
	  "generate",
	  "exploit",
	  "transizionali",
	  "matrici",
	  "ricontestualizzate"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "adattiva",
	  "avanzata",
	  "migliorata",
	  "assimilata",
	  "automatizzata",
	  "bilanciata",
	  "centralizzata",
	  "compatibile",
	  "configurabile",
	  "cross-platform",
	  "decentralizzata",
	  "digitalizzata",
	  "distribuita",
	  "piccola",
	  "ergonomica",
	  "esclusiva",
	  "espansa",
	  "estesa",
	  "configurabile",
	  "fondamentale",
	  "orizzontale",
	  "implementata",
	  "innovativa",
	  "integrata",
	  "intuitiva",
	  "inversa",
	  "gestita",
	  "obbligatoria",
	  "monitorata",
	  "multi-canale",
	  "multi-laterale",
	  "open-source",
	  "operativa",
	  "ottimizzata",
	  "organica",
	  "persistente",
	  "polarizzata",
	  "proattiva",
	  "programmabile",
	  "progressiva",
	  "reattiva",
	  "riallineata",
	  "ricontestualizzata",
	  "ridotta",
	  "robusta",
	  "sicura",
	  "condivisibile",
	  "stand-alone",
	  "switchabile",
	  "sincronizzata",
	  "sinergica",
	  "totale",
	  "universale",
	  "user-friendly",
	  "versatile",
	  "virtuale",
	  "visionaria"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2435);
	company.noun = __webpack_require__(2434);
	company.descriptor = __webpack_require__(2431);
	company.adjective = __webpack_require__(2427);
	company.bs_noun = __webpack_require__(2429);
	company.bs_verb = __webpack_require__(2430);
	company.bs_adjective = __webpack_require__(2428);
	company.name = __webpack_require__(2433);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name} #{suffix}",
	  "#{Name.last_name}, #{Name.last_name} e #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abilità",
	  "Access",
	  "Adattatore",
	  "Algoritmo",
	  "Alleanza",
	  "Analizzatore",
	  "Applicazione",
	  "Approccio",
	  "Architettura",
	  "Archivio",
	  "Intelligenza artificiale",
	  "Array",
	  "Attitudine",
	  "Benchmark",
	  "Capacità",
	  "Sfida",
	  "Circuito",
	  "Collaborazione",
	  "Complessità",
	  "Concetto",
	  "Conglomerato",
	  "Contingenza",
	  "Core",
	  "Database",
	  "Data-warehouse",
	  "Definizione",
	  "Emulazione",
	  "Codifica",
	  "Criptazione",
	  "Firmware",
	  "Flessibilità",
	  "Previsione",
	  "Frame",
	  "framework",
	  "Funzione",
	  "Funzionalità",
	  "Interfaccia grafica",
	  "Hardware",
	  "Help-desk",
	  "Gerarchia",
	  "Hub",
	  "Implementazione",
	  "Infrastruttura",
	  "Iniziativa",
	  "Installazione",
	  "Set di istruzioni",
	  "Interfaccia",
	  "Soluzione internet",
	  "Intranet",
	  "Conoscenza base",
	  "Matrici",
	  "Matrice",
	  "Metodologia",
	  "Middleware",
	  "Migrazione",
	  "Modello",
	  "Moderazione",
	  "Monitoraggio",
	  "Moratoria",
	  "Rete",
	  "Architettura aperta",
	  "Sistema aperto",
	  "Orchestrazione",
	  "Paradigma",
	  "Parallelismo",
	  "Policy",
	  "Portale",
	  "Struttura di prezzo",
	  "Prodotto",
	  "Produttività",
	  "Progetto",
	  "Proiezione",
	  "Protocollo",
	  "Servizio clienti",
	  "Software",
	  "Soluzione",
	  "Standardizzazione",
	  "Strategia",
	  "Struttura",
	  "Successo",
	  "Sovrastruttura",
	  "Supporto",
	  "Sinergia",
	  "Task-force",
	  "Finestra temporale",
	  "Strumenti",
	  "Utilizzazione",
	  "Sito web",
	  "Forza lavoro"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "SPA",
	  "e figli",
	  "Group",
	  "s.r.l."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var it = {};
	module['exports'] = it;
	it.title = "Italian";
	it.address = __webpack_require__(2419);
	it.company = __webpack_require__(2432);
	it.internet = __webpack_require__(2439);
	it.name = __webpack_require__(2441);
	it.phone_number = __webpack_require__(2447);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "com",
	  "com",
	  "net",
	  "org",
	  "it",
	  "it",
	  "it"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "email.it",
	  "libero.it",
	  "yahoo.it"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2438);
	internet.domain_suffix = __webpack_require__(2437);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Akira",
	  "Alberto",
	  "Alessandro",
	  "Alighieri",
	  "Amedeo",
	  "Amos",
	  "Anselmo",
	  "Antonino",
	  "Arcibaldo",
	  "Armando",
	  "Artes",
	  "Audenico",
	  "Ausonio",
	  "Bacchisio",
	  "Battista",
	  "Bernardo",
	  "Boris",
	  "Caio",
	  "Carlo",
	  "Cecco",
	  "Cirino",
	  "Cleros",
	  "Costantino",
	  "Damiano",
	  "Danny",
	  "Davide",
	  "Demian",
	  "Dimitri",
	  "Domingo",
	  "Dylan",
	  "Edilio",
	  "Egidio",
	  "Elio",
	  "Emanuel",
	  "Enrico",
	  "Ercole",
	  "Ermes",
	  "Ethan",
	  "Eusebio",
	  "Evangelista",
	  "Fabiano",
	  "Ferdinando",
	  "Fiorentino",
	  "Flavio",
	  "Fulvio",
	  "Gabriele",
	  "Gastone",
	  "Germano",
	  "Giacinto",
	  "Gianantonio",
	  "Gianleonardo",
	  "Gianmarco",
	  "Gianriccardo",
	  "Gioacchino",
	  "Giordano",
	  "Giuliano",
	  "Graziano",
	  "Guido",
	  "Harry",
	  "Iacopo",
	  "Ilario",
	  "Ione",
	  "Italo",
	  "Jack",
	  "Jari",
	  "Joey",
	  "Joseph",
	  "Kai",
	  "Kociss",
	  "Laerte",
	  "Lauro",
	  "Leonardo",
	  "Liborio",
	  "Lorenzo",
	  "Ludovico",
	  "Maggiore",
	  "Manuele",
	  "Mariano",
	  "Marvin",
	  "Matteo",
	  "Mauro",
	  "Michael",
	  "Mirco",
	  "Modesto",
	  "Muzio",
	  "Nabil",
	  "Nathan",
	  "Nick",
	  "Noah",
	  "Odino",
	  "Olo",
	  "Oreste",
	  "Osea",
	  "Pablo",
	  "Patrizio",
	  "Piererminio",
	  "Pierfrancesco",
	  "Piersilvio",
	  "Priamo",
	  "Quarto",
	  "Quirino",
	  "Radames",
	  "Raniero",
	  "Renato",
	  "Rocco",
	  "Romeo",
	  "Rosalino",
	  "Rudy",
	  "Sabatino",
	  "Samuel",
	  "Santo",
	  "Sebastian",
	  "Serse",
	  "Silvano",
	  "Sirio",
	  "Tancredi",
	  "Terzo",
	  "Timoteo",
	  "Tolomeo",
	  "Trevis",
	  "Ubaldo",
	  "Ulrico",
	  "Valdo",
	  "Neri",
	  "Vinicio",
	  "Walter",
	  "Xavier",
	  "Yago",
	  "Zaccaria",
	  "Abramo",
	  "Adriano",
	  "Alan",
	  "Albino",
	  "Alessio",
	  "Alighiero",
	  "Amerigo",
	  "Anastasio",
	  "Antimo",
	  "Antonio",
	  "Arduino",
	  "Aroldo",
	  "Arturo",
	  "Augusto",
	  "Avide",
	  "Baldassarre",
	  "Bettino",
	  "Bortolo",
	  "Caligola",
	  "Carmelo",
	  "Celeste",
	  "Ciro",
	  "Costanzo",
	  "Dante",
	  "Danthon",
	  "Davis",
	  "Demis",
	  "Dindo",
	  "Domiziano",
	  "Edipo",
	  "Egisto",
	  "Eliziario",
	  "Emidio",
	  "Enzo",
	  "Eriberto",
	  "Erminio",
	  "Ettore",
	  "Eustachio",
	  "Fabio",
	  "Fernando",
	  "Fiorenzo",
	  "Folco",
	  "Furio",
	  "Gaetano",
	  "Gavino",
	  "Gerlando",
	  "Giacobbe",
	  "Giancarlo",
	  "Gianmaria",
	  "Giobbe",
	  "Giorgio",
	  "Giulio",
	  "Gregorio",
	  "Hector",
	  "Ian",
	  "Ippolito",
	  "Ivano",
	  "Jacopo",
	  "Jarno",
	  "Joannes",
	  "Joshua",
	  "Karim",
	  "Kris",
	  "Lamberto",
	  "Lazzaro",
	  "Leone",
	  "Lino",
	  "Loris",
	  "Luigi",
	  "Manfredi",
	  "Marco",
	  "Marino",
	  "Marzio",
	  "Mattia",
	  "Max",
	  "Michele",
	  "Mirko",
	  "Moreno",
	  "Nadir",
	  "Nazzareno",
	  "Nestore",
	  "Nico",
	  "Noel",
	  "Odone",
	  "Omar",
	  "Orfeo",
	  "Osvaldo",
	  "Pacifico",
	  "Pericle",
	  "Pietro",
	  "Primo",
	  "Quasimodo",
	  "Radio",
	  "Raoul",
	  "Renzo",
	  "Rodolfo",
	  "Romolo",
	  "Rosolino",
	  "Rufo",
	  "Sabino",
	  "Sandro",
	  "Sasha",
	  "Secondo",
	  "Sesto",
	  "Silverio",
	  "Siro",
	  "Tazio",
	  "Teseo",
	  "Timothy",
	  "Tommaso",
	  "Tristano",
	  "Umberto",
	  "Ariel",
	  "Artemide",
	  "Assia",
	  "Azue",
	  "Benedetta",
	  "Bibiana",
	  "Brigitta",
	  "Carmela",
	  "Cassiopea",
	  "Cesidia",
	  "Cira",
	  "Clea",
	  "Cleopatra",
	  "Clodovea",
	  "Concetta",
	  "Cosetta",
	  "Cristyn",
	  "Damiana",
	  "Danuta",
	  "Deborah",
	  "Demi",
	  "Diamante",
	  "Diana",
	  "Donatella",
	  "Doriana",
	  "Edvige",
	  "Elda",
	  "Elga",
	  "Elsa",
	  "Emilia",
	  "Enrica",
	  "Erminia",
	  "Eufemia",
	  "Evita",
	  "Fatima",
	  "Felicia",
	  "Filomena",
	  "Flaviana",
	  "Fortunata",
	  "Gelsomina",
	  "Genziana",
	  "Giacinta",
	  "Gilda",
	  "Giovanna",
	  "Giulietta",
	  "Grazia",
	  "Guendalina",
	  "Helga",
	  "Ileana",
	  "Ingrid",
	  "Irene",
	  "Isabel",
	  "Isira",
	  "Ivonne",
	  "Jelena",
	  "Jole",
	  "Claudia",
	  "Kayla",
	  "Kristel",
	  "Laura",
	  "Lucia",
	  "Lia",
	  "Lidia",
	  "Lisa",
	  "Loredana",
	  "Loretta",
	  "Luce",
	  "Lucrezia",
	  "Luna",
	  "Maika",
	  "Marcella",
	  "Maria",
	  "Mariagiulia",
	  "Marianita",
	  "Mariapia",
	  "Marieva",
	  "Marina",
	  "Maristella",
	  "Maruska",
	  "Matilde",
	  "Mecren",
	  "Mercedes",
	  "Mietta",
	  "Miriana",
	  "Miriam",
	  "Monia",
	  "Morgana",
	  "Naomi",
	  "Nayade",
	  "Nicoletta",
	  "Ninfa",
	  "Noemi",
	  "Nunzia",
	  "Olimpia",
	  "Oretta",
	  "Ortensia",
	  "Penelope",
	  "Piccarda",
	  "Prisca",
	  "Rebecca",
	  "Rita",
	  "Rosalba",
	  "Rosaria",
	  "Rosita",
	  "Ruth",
	  "Samira",
	  "Sarita",
	  "Selvaggia",
	  "Shaira",
	  "Sibilla",
	  "Soriana",
	  "Thea",
	  "Tosca",
	  "Ursula",
	  "Vania",
	  "Vera",
	  "Vienna",
	  "Violante",
	  "Vitalba",
	  "Zelida"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2440);
	name.last_name = __webpack_require__(2442);
	name.prefix = __webpack_require__(2444);
	name.suffix = __webpack_require__(2445);
	name.name = __webpack_require__(2443);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Amato",
	  "Barbieri",
	  "Barone",
	  "Basile",
	  "Battaglia",
	  "Bellini",
	  "Benedetti",
	  "Bernardi",
	  "Bianc",
	  "Bianchi",
	  "Bruno",
	  "Caputo",
	  "Carbon",
	  "Caruso",
	  "Cattaneo",
	  "Colombo",
	  "Cont",
	  "Conte",
	  "Coppola",
	  "Costa",
	  "Costantin",
	  "D'amico",
	  "D'angelo",
	  "Damico",
	  "De Angelis",
	  "De luca",
	  "De rosa",
	  "De Santis",
	  "Donati",
	  "Esposito",
	  "Fabbri",
	  "Farin",
	  "Ferrara",
	  "Ferrari",
	  "Ferraro",
	  "Ferretti",
	  "Ferri",
	  "Fior",
	  "Fontana",
	  "Galli",
	  "Gallo",
	  "Gatti",
	  "Gentile",
	  "Giordano",
	  "Giuliani",
	  "Grassi",
	  "Grasso",
	  "Greco",
	  "Guerra",
	  "Leone",
	  "Lombardi",
	  "Lombardo",
	  "Longo",
	  "Mancini",
	  "Marchetti",
	  "Marian",
	  "Marini",
	  "Marino",
	  "Martinelli",
	  "Martini",
	  "Martino",
	  "Mazza",
	  "Messina",
	  "Milani",
	  "Montanari",
	  "Monti",
	  "Morelli",
	  "Moretti",
	  "Negri",
	  "Neri",
	  "Orlando",
	  "Pagano",
	  "Palmieri",
	  "Palumbo",
	  "Parisi",
	  "Pellegrini",
	  "Pellegrino",
	  "Piras",
	  "Ricci",
	  "Rinaldi",
	  "Riva",
	  "Rizzi",
	  "Rizzo",
	  "Romano",
	  "Ross",
	  "Rossetti",
	  "Ruggiero",
	  "Russo",
	  "Sala",
	  "Sanna",
	  "Santoro",
	  "Sartori",
	  "Serr",
	  "Silvestri",
	  "Sorrentino",
	  "Testa",
	  "Valentini",
	  "Villa",
	  "Vitale",
	  "Vitali"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sig.",
	  "Dott.",
	  "Dr.",
	  "Ing."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+## ### ## ## ####",
	  "+## ## #######",
	  "+## ## ########",
	  "+## ### #######",
	  "+## ### ########",
	  "+## #### #######",
	  "+## #### ########",
	  "0## ### ####",
	  "+39 0## ### ###",
	  "3## ### ###",
	  "+39 3## ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2446);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{Name.first_name}#{city_suffix}",
	  "#{Name.first_name}#{city_suffix}",
	  "#{city_prefix}#{Name.last_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北",
	  "東",
	  "西",
	  "南",
	  "新",
	  "湖",
	  "港"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "市",
	  "区",
	  "町",
	  "村"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(2452);
	address.state = __webpack_require__(2453);
	address.state_abbr = __webpack_require__(2454);
	address.city_prefix = __webpack_require__(2449);
	address.city_suffix = __webpack_require__(2450);
	address.city = __webpack_require__(2448);
	address.street_name = __webpack_require__(2455);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北海道",
	  "青森県",
	  "岩手県",
	  "宮城県",
	  "秋田県",
	  "山形県",
	  "福島県",
	  "茨城県",
	  "栃木県",
	  "群馬県",
	  "埼玉県",
	  "千葉県",
	  "東京都",
	  "神奈川県",
	  "新潟県",
	  "富山県",
	  "石川県",
	  "福井県",
	  "山梨県",
	  "長野県",
	  "岐阜県",
	  "静岡県",
	  "愛知県",
	  "三重県",
	  "滋賀県",
	  "京都府",
	  "大阪府",
	  "兵庫県",
	  "奈良県",
	  "和歌山県",
	  "鳥取県",
	  "島根県",
	  "岡山県",
	  "広島県",
	  "山口県",
	  "徳島県",
	  "香川県",
	  "愛媛県",
	  "高知県",
	  "福岡県",
	  "佐賀県",
	  "長崎県",
	  "熊本県",
	  "大分県",
	  "宮崎県",
	  "鹿児島県",
	  "沖縄県"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1",
	  "2",
	  "3",
	  "4",
	  "5",
	  "6",
	  "7",
	  "8",
	  "9",
	  "10",
	  "11",
	  "12",
	  "13",
	  "14",
	  "15",
	  "16",
	  "17",
	  "18",
	  "19",
	  "20",
	  "21",
	  "22",
	  "23",
	  "24",
	  "25",
	  "26",
	  "27",
	  "28",
	  "29",
	  "30",
	  "31",
	  "32",
	  "33",
	  "34",
	  "35",
	  "36",
	  "37",
	  "38",
	  "39",
	  "40",
	  "41",
	  "42",
	  "43",
	  "44",
	  "45",
	  "46",
	  "47"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{street_suffix}",
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "090-####-####",
	  "080-####-####",
	  "070-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2456);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ja = {};
	module['exports'] = ja;
	ja.title = "Japanese";
	ja.address = __webpack_require__(2451);
	ja.phone_number = __webpack_require__(2464);
	ja.cell_phone = __webpack_require__(2457);
	ja.name = __webpack_require__(2460);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "大翔",
	  "蓮",
	  "颯太",
	  "樹",
	  "大和",
	  "陽翔",
	  "陸斗",
	  "太一",
	  "海翔",
	  "蒼空",
	  "翼",
	  "陽菜",
	  "結愛",
	  "結衣",
	  "杏",
	  "莉子",
	  "美羽",
	  "結菜",
	  "心愛",
	  "愛菜",
	  "美咲"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.last_name = __webpack_require__(2461);
	name.first_name = __webpack_require__(2459);
	name.name = __webpack_require__(2462);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "佐藤",
	  "鈴木",
	  "高橋",
	  "田中",
	  "渡辺",
	  "伊藤",
	  "山本",
	  "中村",
	  "小林",
	  "加藤",
	  "吉田",
	  "山田",
	  "佐々木",
	  "山口",
	  "斎藤",
	  "松本",
	  "井上",
	  "木村",
	  "林",
	  "清水"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0####-#-####",
	  "0###-##-####",
	  "0##-###-####",
	  "0#-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2463);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강릉",
	  "양양",
	  "인제",
	  "광주",
	  "구리",
	  "부천",
	  "밀양",
	  "통영",
	  "창원",
	  "거창",
	  "고성",
	  "양산",
	  "김천",
	  "구미",
	  "영주",
	  "광산",
	  "남",
	  "북",
	  "고창",
	  "군산",
	  "남원",
	  "동작",
	  "마포",
	  "송파",
	  "용산",
	  "부평",
	  "강화",
	  "수성"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "구",
	  "시",
	  "군"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(2469);
	address.state = __webpack_require__(2470);
	address.state_abbr = __webpack_require__(2471);
	address.city_suffix = __webpack_require__(2467);
	address.city_name = __webpack_require__(2466);
	address.city = __webpack_require__(2465);
	address.street_root = __webpack_require__(2473);
	address.street_suffix = __webpack_require__(2474);
	address.street_name = __webpack_require__(2472);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강원",
	  "경기",
	  "경남",
	  "경북",
	  "광주",
	  "대구",
	  "대전",
	  "부산",
	  "서울",
	  "울산",
	  "인천",
	  "전남",
	  "전북",
	  "제주",
	  "충남",
	  "충북",
	  "세종"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "강원",
	  "경기",
	  "경남",
	  "경북",
	  "광주",
	  "대구",
	  "대전",
	  "부산",
	  "서울",
	  "울산",
	  "인천",
	  "전남",
	  "전북",
	  "제주",
	  "충남",
	  "충북",
	  "세종"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "상계",
	  "화곡",
	  "신정",
	  "목",
	  "잠실",
	  "면목",
	  "주안",
	  "안양",
	  "중",
	  "정왕",
	  "구로",
	  "신월",
	  "연산",
	  "부평",
	  "창",
	  "만수",
	  "중계",
	  "검단",
	  "시흥",
	  "상도",
	  "방배",
	  "장유",
	  "상",
	  "광명",
	  "신길",
	  "행신",
	  "대명",
	  "동탄"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "읍",
	  "면",
	  "동"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2478);
	company.prefix = __webpack_require__(2477);
	company.name = __webpack_require__(2476);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.first_name}",
	  "#{Name.first_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "주식회사",
	  "한국"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "연구소",
	  "게임즈",
	  "그룹",
	  "전자",
	  "물산",
	  "코리아"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ko = {};
	module['exports'] = ko;
	ko.title = "Korean";
	ko.address = __webpack_require__(2468);
	ko.phone_number = __webpack_require__(2490);
	ko.company = __webpack_require__(2475);
	ko.internet = __webpack_require__(2482);
	ko.lorem = __webpack_require__(2483);
	ko.name = __webpack_require__(2486);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "co.kr",
	  "com",
	  "biz",
	  "info",
	  "ne.kr",
	  "net",
	  "or.kr",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.co.kr",
	  "hanmail.net",
	  "naver.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2481);
	internet.domain_suffix = __webpack_require__(2480);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2484);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "국가는",
	  "법률이",
	  "정하는",
	  "바에",
	  "의하여",
	  "재외국민을",
	  "보호할",
	  "의무를",
	  "진다.",
	  "모든",
	  "국민은",
	  "신체의",
	  "자유를",
	  "가진다.",
	  "국가는",
	  "전통문화의",
	  "계승·발전과",
	  "민족문화의",
	  "창달에",
	  "노력하여야",
	  "한다.",
	  "통신·방송의",
	  "시설기준과",
	  "신문의",
	  "기능을",
	  "보장하기",
	  "위하여",
	  "필요한",
	  "사항은",
	  "법률로",
	  "정한다.",
	  "헌법에",
	  "의하여",
	  "체결·공포된",
	  "조약과",
	  "일반적으로",
	  "승인된",
	  "국제법규는",
	  "국내법과",
	  "같은",
	  "효력을",
	  "가진다.",
	  "다만,",
	  "현행범인인",
	  "경우와",
	  "장기",
	  "3년",
	  "이상의",
	  "형에",
	  "해당하는",
	  "죄를",
	  "범하고",
	  "도피",
	  "또는",
	  "증거인멸의",
	  "염려가",
	  "있을",
	  "때에는",
	  "사후에",
	  "영장을",
	  "청구할",
	  "수",
	  "있다.",
	  "저작자·발명가·과학기술자와",
	  "예술가의",
	  "권리는",
	  "법률로써",
	  "보호한다.",
	  "형사피고인은",
	  "유죄의",
	  "판결이",
	  "확정될",
	  "때까지는",
	  "무죄로",
	  "추정된다.",
	  "모든",
	  "국민은",
	  "행위시의",
	  "법률에",
	  "의하여",
	  "범죄를",
	  "구성하지",
	  "아니하는",
	  "행위로",
	  "소추되지",
	  "아니하며,",
	  "동일한",
	  "범죄에",
	  "대하여",
	  "거듭",
	  "처벌받지",
	  "아니한다.",
	  "국가는",
	  "평생교육을",
	  "진흥하여야",
	  "한다.",
	  "모든",
	  "국민은",
	  "사생활의",
	  "비밀과",
	  "자유를",
	  "침해받지",
	  "아니한다.",
	  "의무교육은",
	  "무상으로",
	  "한다.",
	  "저작자·발명가·과학기술자와",
	  "예술가의",
	  "권리는",
	  "법률로써",
	  "보호한다.",
	  "국가는",
	  "모성의",
	  "보호를",
	  "위하여",
	  "노력하여야",
	  "한다.",
	  "헌법에",
	  "의하여",
	  "체결·공포된",
	  "조약과",
	  "일반적으로",
	  "승인된",
	  "국제법규는",
	  "국내법과",
	  "같은",
	  "효력을",
	  "가진다."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "서연",
	  "민서",
	  "서현",
	  "지우",
	  "서윤",
	  "지민",
	  "수빈",
	  "하은",
	  "예은",
	  "윤서",
	  "민준",
	  "지후",
	  "지훈",
	  "준서",
	  "현우",
	  "예준",
	  "건우",
	  "현준",
	  "민재",
	  "우진",
	  "은주"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.last_name = __webpack_require__(2487);
	name.first_name = __webpack_require__(2485);
	name.name = __webpack_require__(2488);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "김",
	  "이",
	  "박",
	  "최",
	  "정",
	  "강",
	  "조",
	  "윤",
	  "장",
	  "임",
	  "오",
	  "한",
	  "신",
	  "서",
	  "권",
	  "황",
	  "안",
	  "송",
	  "류",
	  "홍"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{last_name} #{first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0#-#####-####",
	  "0##-###-####",
	  "0##-####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2489);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_root}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Fet",
	  "Gjes",
	  "Høy",
	  "Inn",
	  "Fager",
	  "Lille",
	  "Lo",
	  "Mal",
	  "Nord",
	  "Nær",
	  "Sand",
	  "Sme",
	  "Stav",
	  "Stor",
	  "Tand",
	  "Ut",
	  "Vest"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "berg",
	  "borg",
	  "by",
	  "bø",
	  "dal",
	  "eid",
	  "fjell",
	  "fjord",
	  "foss",
	  "grunn",
	  "hamn",
	  "havn",
	  "helle",
	  "mark",
	  "nes",
	  "odden",
	  "sand",
	  "sjøen",
	  "stad",
	  "strand",
	  "strøm",
	  "sund",
	  "vik",
	  "vær",
	  "våg",
	  "ø",
	  "øy",
	  "ås"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "sgate",
	  "svei",
	  "s Gate",
	  "s Vei",
	  "gata",
	  "veien"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Norge"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_root = __webpack_require__(2493);
	address.city_suffix = __webpack_require__(2494);
	address.street_prefix = __webpack_require__(2503);
	address.street_root = __webpack_require__(2504);
	address.street_suffix = __webpack_require__(2505);
	address.common_street_suffix = __webpack_require__(2495);
	address.building_number = __webpack_require__(2491);
	address.secondary_address = __webpack_require__(2499);
	address.postcode = __webpack_require__(2498);
	address.state = __webpack_require__(2500);
	address.city = __webpack_require__(2492);
	address.street_name = __webpack_require__(2502);
	address.street_address = __webpack_require__(2501);
	address.default_country = __webpack_require__(2496);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "####",
	  "####",
	  "0###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Leil. ###",
	  "Oppgang A",
	  "Oppgang B"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  ""
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}",
	  "#{street_prefix} #{street_root}#{street_suffix}",
	  "#{Name.first_name}#{common_street_suffix}",
	  "#{Name.last_name}#{common_street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Øvre",
	  "Nedre",
	  "Søndre",
	  "Gamle",
	  "Østre",
	  "Vestre"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Eike",
	  "Bjørke",
	  "Gran",
	  "Vass",
	  "Furu",
	  "Litj",
	  "Lille",
	  "Høy",
	  "Fosse",
	  "Elve",
	  "Ku",
	  "Konvall",
	  "Soldugg",
	  "Hestemyr",
	  "Granitt",
	  "Hegge",
	  "Rogne",
	  "Fiol",
	  "Sol",
	  "Ting",
	  "Malm",
	  "Klokker",
	  "Preste",
	  "Dam",
	  "Geiterygg",
	  "Bekke",
	  "Berg",
	  "Kirke",
	  "Kors",
	  "Bru",
	  "Blåveis",
	  "Torg",
	  "Sjø"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alléen",
	  "bakken",
	  "berget",
	  "bråten",
	  "eggen",
	  "engen",
	  "ekra",
	  "faret",
	  "flata",
	  "gata",
	  "gjerdet",
	  "grenda",
	  "gropa",
	  "hagen",
	  "haugen",
	  "havna",
	  "holtet",
	  "høgda",
	  "jordet",
	  "kollen",
	  "kroken",
	  "lia",
	  "lunden",
	  "lyngen",
	  "løkka",
	  "marka",
	  "moen",
	  "myra",
	  "plassen",
	  "ringen",
	  "roa",
	  "røa",
	  "skogen",
	  "skrenten",
	  "spranget",
	  "stien",
	  "stranda",
	  "stubben",
	  "stykket",
	  "svingen",
	  "tjernet",
	  "toppen",
	  "tunet",
	  "vollen",
	  "vika",
	  "åsen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2508);
	company.name = __webpack_require__(2507);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} og #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Gruppen",
	  "AS",
	  "ASA",
	  "BA",
	  "RFH",
	  "og Sønner"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nb_NO = {};
	module['exports'] = nb_NO;
	nb_NO.title = "Norwegian";
	nb_NO.address = __webpack_require__(2497);
	nb_NO.company = __webpack_require__(2506);
	nb_NO.internet = __webpack_require__(2511);
	nb_NO.name = __webpack_require__(2514);
	nb_NO.phone_number = __webpack_require__(2521);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "no",
	  "com",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2510);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Emma",
	  "Sara",
	  "Thea",
	  "Ida",
	  "Julie",
	  "Nora",
	  "Emilie",
	  "Ingrid",
	  "Hanna",
	  "Maria",
	  "Sofie",
	  "Anna",
	  "Malin",
	  "Amalie",
	  "Vilde",
	  "Frida",
	  "Andrea",
	  "Tuva",
	  "Victoria",
	  "Mia",
	  "Karoline",
	  "Mathilde",
	  "Martine",
	  "Linnea",
	  "Marte",
	  "Hedda",
	  "Marie",
	  "Helene",
	  "Silje",
	  "Leah",
	  "Maja",
	  "Elise",
	  "Oda",
	  "Kristine",
	  "Aurora",
	  "Kaja",
	  "Camilla",
	  "Mari",
	  "Maren",
	  "Mina",
	  "Selma",
	  "Jenny",
	  "Celine",
	  "Eline",
	  "Sunniva",
	  "Natalie",
	  "Tiril",
	  "Synne",
	  "Sandra",
	  "Madeleine"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Emma",
	  "Sara",
	  "Thea",
	  "Ida",
	  "Julie",
	  "Nora",
	  "Emilie",
	  "Ingrid",
	  "Hanna",
	  "Maria",
	  "Sofie",
	  "Anna",
	  "Malin",
	  "Amalie",
	  "Vilde",
	  "Frida",
	  "Andrea",
	  "Tuva",
	  "Victoria",
	  "Mia",
	  "Karoline",
	  "Mathilde",
	  "Martine",
	  "Linnea",
	  "Marte",
	  "Hedda",
	  "Marie",
	  "Helene",
	  "Silje",
	  "Leah",
	  "Maja",
	  "Elise",
	  "Oda",
	  "Kristine",
	  "Aurora",
	  "Kaja",
	  "Camilla",
	  "Mari",
	  "Maren",
	  "Mina",
	  "Selma",
	  "Jenny",
	  "Celine",
	  "Eline",
	  "Sunniva",
	  "Natalie",
	  "Tiril",
	  "Synne",
	  "Sandra",
	  "Madeleine",
	  "Markus",
	  "Mathias",
	  "Kristian",
	  "Jonas",
	  "Andreas",
	  "Alexander",
	  "Martin",
	  "Sander",
	  "Daniel",
	  "Magnus",
	  "Henrik",
	  "Tobias",
	  "Kristoffer",
	  "Emil",
	  "Adrian",
	  "Sebastian",
	  "Marius",
	  "Elias",
	  "Fredrik",
	  "Thomas",
	  "Sondre",
	  "Benjamin",
	  "Jakob",
	  "Oliver",
	  "Lucas",
	  "Oskar",
	  "Nikolai",
	  "Filip",
	  "Mats",
	  "William",
	  "Erik",
	  "Simen",
	  "Ole",
	  "Eirik",
	  "Isak",
	  "Kasper",
	  "Noah",
	  "Lars",
	  "Joakim",
	  "Johannes",
	  "Håkon",
	  "Sindre",
	  "Jørgen",
	  "Herman",
	  "Anders",
	  "Jonathan",
	  "Even",
	  "Theodor",
	  "Mikkel",
	  "Aksel"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2513);
	name.feminine_name = __webpack_require__(2512);
	name.masculine_name = __webpack_require__(2516);
	name.last_name = __webpack_require__(2515);
	name.prefix = __webpack_require__(2518);
	name.suffix = __webpack_require__(2519);
	name.name = __webpack_require__(2517);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Johansen",
	  "Hansen",
	  "Andersen",
	  "Kristiansen",
	  "Larsen",
	  "Olsen",
	  "Solberg",
	  "Andresen",
	  "Pedersen",
	  "Nilsen",
	  "Berg",
	  "Halvorsen",
	  "Karlsen",
	  "Svendsen",
	  "Jensen",
	  "Haugen",
	  "Martinsen",
	  "Eriksen",
	  "Sørensen",
	  "Johnsen",
	  "Myhrer",
	  "Johannessen",
	  "Nielsen",
	  "Hagen",
	  "Pettersen",
	  "Bakke",
	  "Skuterud",
	  "Løken",
	  "Gundersen",
	  "Strand",
	  "Jørgensen",
	  "Kvarme",
	  "Røed",
	  "Sæther",
	  "Stensrud",
	  "Moe",
	  "Kristoffersen",
	  "Jakobsen",
	  "Holm",
	  "Aas",
	  "Lie",
	  "Moen",
	  "Andreassen",
	  "Vedvik",
	  "Nguyen",
	  "Jacobsen",
	  "Torgersen",
	  "Ruud",
	  "Krogh",
	  "Christiansen",
	  "Bjerke",
	  "Aalerud",
	  "Borge",
	  "Sørlie",
	  "Berge",
	  "Østli",
	  "Ødegård",
	  "Torp",
	  "Henriksen",
	  "Haukelidsæter",
	  "Fjeld",
	  "Danielsen",
	  "Aasen",
	  "Fredriksen",
	  "Dahl",
	  "Berntsen",
	  "Arnesen",
	  "Wold",
	  "Thoresen",
	  "Solheim",
	  "Skoglund",
	  "Bakken",
	  "Amundsen",
	  "Solli",
	  "Smogeli",
	  "Kristensen",
	  "Glosli",
	  "Fossum",
	  "Evensen",
	  "Eide",
	  "Carlsen",
	  "Østby",
	  "Vegge",
	  "Tangen",
	  "Smedsrud",
	  "Olstad",
	  "Lunde",
	  "Kleven",
	  "Huseby",
	  "Bjørnstad",
	  "Ryan",
	  "Rasmussen",
	  "Nygård",
	  "Nordskaug",
	  "Nordby",
	  "Mathisen",
	  "Hopland",
	  "Gran",
	  "Finstad",
	  "Edvardsen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Markus",
	  "Mathias",
	  "Kristian",
	  "Jonas",
	  "Andreas",
	  "Alexander",
	  "Martin",
	  "Sander",
	  "Daniel",
	  "Magnus",
	  "Henrik",
	  "Tobias",
	  "Kristoffer",
	  "Emil",
	  "Adrian",
	  "Sebastian",
	  "Marius",
	  "Elias",
	  "Fredrik",
	  "Thomas",
	  "Sondre",
	  "Benjamin",
	  "Jakob",
	  "Oliver",
	  "Lucas",
	  "Oskar",
	  "Nikolai",
	  "Filip",
	  "Mats",
	  "William",
	  "Erik",
	  "Simen",
	  "Ole",
	  "Eirik",
	  "Isak",
	  "Kasper",
	  "Noah",
	  "Lars",
	  "Joakim",
	  "Johannes",
	  "Håkon",
	  "Sindre",
	  "Jørgen",
	  "Herman",
	  "Anders",
	  "Jonathan",
	  "Even",
	  "Theodor",
	  "Mikkel",
	  "Aksel"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{feminine_name} #{feminine_name} #{last_name}",
	  "#{masculine_name} #{masculine_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "########",
	  "## ## ## ##",
	  "### ## ###",
	  "+47 ## ## ## ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2520);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bhaktapur",
	  "Biratnagar",
	  "Birendranagar",
	  "Birgunj",
	  "Butwal",
	  "Damak",
	  "Dharan",
	  "Gaur",
	  "Gorkha",
	  "Hetauda",
	  "Itahari",
	  "Janakpur",
	  "Kathmandu",
	  "Lahan",
	  "Nepalgunj",
	  "Pokhara"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nepal"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.postcode = __webpack_require__(2525);
	address.state = __webpack_require__(2526);
	address.city = __webpack_require__(2522);
	address.default_country = __webpack_require__(2523);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  0
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Baglung",
	  "Banke",
	  "Bara",
	  "Bardiya",
	  "Bhaktapur",
	  "Bhojupu",
	  "Chitwan",
	  "Dailekh",
	  "Dang",
	  "Dhading",
	  "Dhankuta",
	  "Dhanusa",
	  "Dolakha",
	  "Dolpha",
	  "Gorkha",
	  "Gulmi",
	  "Humla",
	  "Ilam",
	  "Jajarkot",
	  "Jhapa",
	  "Jumla",
	  "Kabhrepalanchok",
	  "Kalikot",
	  "Kapilvastu",
	  "Kaski",
	  "Kathmandu",
	  "Lalitpur",
	  "Lamjung",
	  "Manang",
	  "Mohottari",
	  "Morang",
	  "Mugu",
	  "Mustang",
	  "Myagdi",
	  "Nawalparasi",
	  "Nuwakot",
	  "Palpa",
	  "Parbat",
	  "Parsa",
	  "Ramechhap",
	  "Rauswa",
	  "Rautahat",
	  "Rolpa",
	  "Rupandehi",
	  "Sankhuwasabha",
	  "Sarlahi",
	  "Sindhuli",
	  "Sindhupalchok",
	  "Sunsari",
	  "Surket",
	  "Syangja",
	  "Tanahu",
	  "Terhathum"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2528);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pvt Ltd",
	  "Group",
	  "Ltd",
	  "Limited"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nep = {};
	module['exports'] = nep;
	nep.title = "Nepalese";
	nep.name = __webpack_require__(2534);
	nep.address = __webpack_require__(2524);
	nep.internet = __webpack_require__(2532);
	nep.company = __webpack_require__(2527);
	nep.phone_number = __webpack_require__(2537);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "np",
	  "com",
	  "info",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "worldlink.com.np",
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2531);
	internet.domain_suffix = __webpack_require__(2530);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aarav",
	  "Ajita",
	  "Amit",
	  "Amita",
	  "Amrit",
	  "Arijit",
	  "Ashmi",
	  "Asmita",
	  "Bibek",
	  "Bijay",
	  "Bikash",
	  "Bina",
	  "Bishal",
	  "Bishnu",
	  "Buddha",
	  "Deepika",
	  "Dipendra",
	  "Gagan",
	  "Ganesh",
	  "Khem",
	  "Krishna",
	  "Laxmi",
	  "Manisha",
	  "Nabin",
	  "Nikita",
	  "Niraj",
	  "Nischal",
	  "Padam",
	  "Pooja",
	  "Prabin",
	  "Prakash",
	  "Prashant",
	  "Prem",
	  "Purna",
	  "Rajendra",
	  "Rajina",
	  "Raju",
	  "Rakesh",
	  "Ranjan",
	  "Ratna",
	  "Sagar",
	  "Sandeep",
	  "Sanjay",
	  "Santosh",
	  "Sarita",
	  "Shilpa",
	  "Shirisha",
	  "Shristi",
	  "Siddhartha",
	  "Subash",
	  "Sumeet",
	  "Sunita",
	  "Suraj",
	  "Susan",
	  "Sushant"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2533);
	name.last_name = __webpack_require__(2535);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adhikari",
	  "Aryal",
	  "Baral",
	  "Basnet",
	  "Bastola",
	  "Basynat",
	  "Bhandari",
	  "Bhattarai",
	  "Chettri",
	  "Devkota",
	  "Dhakal",
	  "Dongol",
	  "Ghale",
	  "Gurung",
	  "Gyawali",
	  "Hamal",
	  "Jung",
	  "KC",
	  "Kafle",
	  "Karki",
	  "Khadka",
	  "Koirala",
	  "Lama",
	  "Limbu",
	  "Magar",
	  "Maharjan",
	  "Niroula",
	  "Pandey",
	  "Pradhan",
	  "Rana",
	  "Raut",
	  "Sai",
	  "Shai",
	  "Shakya",
	  "Sherpa",
	  "Shrestha",
	  "Subedi",
	  "Tamang",
	  "Thapa"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "##-#######",
	  "+977-#-#######",
	  "+977########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2536);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###",
	  "###a",
	  "###b",
	  "###c",
	  "### I",
	  "### II",
	  "### III"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{city_suffix}",
	  "#{Name.last_name}#{city_suffix}",
	  "#{city_prefix} #{Name.first_name}#{city_suffix}",
	  "#{city_prefix} #{Name.last_name}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Noord",
	  "Oost",
	  "West",
	  "Zuid",
	  "Nieuw",
	  "Oud"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "dam",
	  "berg",
	  " aan de Rijn",
	  " aan de IJssel",
	  "swaerd",
	  "endrecht",
	  "recht",
	  "ambacht",
	  "enmaes",
	  "wijk",
	  "sland",
	  "stroom",
	  "sluus",
	  "dijk",
	  "dorp",
	  "burg",
	  "veld",
	  "sluis",
	  "koop",
	  "lek",
	  "hout",
	  "geest",
	  "kerk",
	  "woude",
	  "hoven",
	  "hoten",
	  "ingen",
	  "plas",
	  "meer"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afghanistan",
	  "Akrotiri",
	  "Albanië",
	  "Algerije",
	  "Amerikaanse Maagdeneilanden",
	  "Amerikaans-Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antarctica",
	  "Antigua en Barbuda",
	  "Arctic Ocean",
	  "Argentinië",
	  "Armenië",
	  "Aruba",
	  "Ashmore and Cartier Islands",
	  "Atlantic Ocean",
	  "Australië",
	  "Azerbeidzjan",
	  "Bahama's",
	  "Bahrein",
	  "Bangladesh",
	  "Barbados",
	  "Belarus",
	  "België",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolivië",
	  "Bosnië-Herzegovina",
	  "Botswana",
	  "Bouvet Island",
	  "Brazilië",
	  "British Indian Ocean Territory",
	  "Britse Maagdeneilanden",
	  "Brunei",
	  "Bulgarije",
	  "Burkina Faso",
	  "Burundi",
	  "Cambodja",
	  "Canada",
	  "Caymaneilanden",
	  "Centraal-Afrikaanse Republiek",
	  "Chili",
	  "China",
	  "Christmas Island",
	  "Clipperton Island",
	  "Cocos (Keeling) Islands",
	  "Colombia",
	  "Comoren (Unie)",
	  "Congo (Democratische Republiek)",
	  "Congo (Volksrepubliek)",
	  "Cook",
	  "Coral Sea Islands",
	  "Costa Rica",
	  "Cuba",
	  "Cyprus",
	  "Denemarken",
	  "Dhekelia",
	  "Djibouti",
	  "Dominica",
	  "Dominicaanse Republiek",
	  "Duitsland",
	  "Ecuador",
	  "Egypte",
	  "El Salvador",
	  "Equatoriaal-Guinea",
	  "Eritrea",
	  "Estland",
	  "Ethiopië",
	  "European Union",
	  "Falkland",
	  "Faroe Islands",
	  "Fiji",
	  "Filipijnen",
	  "Finland",
	  "Frankrijk",
	  "Frans-Polynesië",
	  "French Southern and Antarctic Lands",
	  "Gabon",
	  "Gambia",
	  "Gaza Strip",
	  "Georgië",
	  "Ghana",
	  "Gibraltar",
	  "Grenada",
	  "Griekenland",
	  "Groenland",
	  "Guam",
	  "Guatemala",
	  "Guernsey",
	  "Guinea",
	  "Guinee-Bissau",
	  "Guyana",
	  "Haïti",
	  "Heard Island and McDonald Islands",
	  "Heilige Stoel",
	  "Honduras",
	  "Hongarije",
	  "Hongkong",
	  "Ierland",
	  "IJsland",
	  "India",
	  "Indian Ocean",
	  "Indonesië",
	  "Irak",
	  "Iran",
	  "Isle of Man",
	  "Israël",
	  "Italië",
	  "Ivoorkust",
	  "Jamaica",
	  "Jan Mayen",
	  "Japan",
	  "Jemen",
	  "Jersey",
	  "Jordanië",
	  "Kaapverdië",
	  "Kameroen",
	  "Kazachstan",
	  "Kenia",
	  "Kirgizstan",
	  "Kiribati",
	  "Koeweit",
	  "Kroatië",
	  "Laos",
	  "Lesotho",
	  "Letland",
	  "Libanon",
	  "Liberia",
	  "Libië",
	  "Liechtenstein",
	  "Litouwen",
	  "Luxemburg",
	  "Macao",
	  "Macedonië",
	  "Madagaskar",
	  "Malawi",
	  "Maldiven",
	  "Maleisië",
	  "Mali",
	  "Malta",
	  "Marokko",
	  "Marshall Islands",
	  "Mauritanië",
	  "Mauritius",
	  "Mayotte",
	  "Mexico",
	  "Micronesia, Federated States of",
	  "Moldavië",
	  "Monaco",
	  "Mongolië",
	  "Montenegro",
	  "Montserrat",
	  "Mozambique",
	  "Myanmar",
	  "Namibië",
	  "Nauru",
	  "Navassa Island",
	  "Nederland",
	  "Nederlandse Antillen",
	  "Nepal",
	  "Ngwane",
	  "Nicaragua",
	  "Nieuw-Caledonië",
	  "Nieuw-Zeeland",
	  "Niger",
	  "Nigeria",
	  "Niue",
	  "Noordelijke Marianen",
	  "Noord-Korea",
	  "Noorwegen",
	  "Norfolk Island",
	  "Oekraïne",
	  "Oezbekistan",
	  "Oman",
	  "Oostenrijk",
	  "Pacific Ocean",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papoea-Nieuw-Guinea",
	  "Paracel Islands",
	  "Paraguay",
	  "Peru",
	  "Pitcairn",
	  "Polen",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Roemenië",
	  "Rusland",
	  "Rwanda",
	  "Saint Helena",
	  "Saint Lucia",
	  "Saint Vincent en de Grenadines",
	  "Saint-Pierre en Miquelon",
	  "Salomon",
	  "Samoa",
	  "San Marino",
	  "São Tomé en Principe",
	  "Saudi-Arabië",
	  "Senegal",
	  "Servië",
	  "Seychellen",
	  "Sierra Leone",
	  "Singapore",
	  "Sint-Kitts en Nevis",
	  "Slovenië",
	  "Slowakije",
	  "Soedan",
	  "Somalië",
	  "South Georgia and the South Sandwich Islands",
	  "Southern Ocean",
	  "Spanje",
	  "Spratly Islands",
	  "Sri Lanka",
	  "Suriname",
	  "Svalbard",
	  "Syrië",
	  "Tadzjikistan",
	  "Taiwan",
	  "Tanzania",
	  "Thailand",
	  "Timor Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidad en Tobago",
	  "Tsjaad",
	  "Tsjechië",
	  "Tunesië",
	  "Turkije",
	  "Turkmenistan",
	  "Turks-en Caicoseilanden",
	  "Tuvalu",
	  "Uganda",
	  "Uruguay",
	  "Vanuatu",
	  "Venezuela",
	  "Verenigd Koninkrijk",
	  "Verenigde Arabische Emiraten",
	  "Verenigde Staten van Amerika",
	  "Vietnam",
	  "Wake Island",
	  "Wallis en Futuna",
	  "Wereld",
	  "West Bank",
	  "Westelijke Sahara",
	  "Zambia",
	  "Zimbabwe",
	  "Zuid-Afrika",
	  "Zuid-Korea",
	  "Zweden",
	  "Zwitserland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nederland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2540);
	address.city_suffix = __webpack_require__(2541);
	address.city = __webpack_require__(2539);
	address.country = __webpack_require__(2542);
	address.building_number = __webpack_require__(2538);
	address.street_suffix = __webpack_require__(2550);
	address.secondary_address = __webpack_require__(2546);
	address.street_name = __webpack_require__(2549);
	address.street_address = __webpack_require__(2548);
	address.postcode = __webpack_require__(2545);
	address.state = __webpack_require__(2547);
	address.default_country = __webpack_require__(2543);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#### ??"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "1 hoog",
	  "2 hoog",
	  "3 hoog"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Noord-Holland",
	  "Zuid-Holland",
	  "Utrecht",
	  "Zeeland",
	  "Overijssel",
	  "Gelderland",
	  "Drenthe",
	  "Friesland",
	  "Groningen",
	  "Noord-Brabant",
	  "Limburg",
	  "Flevoland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.first_name}#{street_suffix}",
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "straat",
	  "laan",
	  "weg",
	  "plantsoen",
	  "park"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2552);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "BV",
	  "V.O.F.",
	  "Group",
	  "en Zonen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var nl = {};
	module['exports'] = nl;
	nl.title = "Dutch";
	nl.address = __webpack_require__(2544);
	nl.company = __webpack_require__(2551);
	nl.internet = __webpack_require__(2556);
	nl.lorem = __webpack_require__(2557);
	nl.name = __webpack_require__(2561);
	nl.phone_number = __webpack_require__(2568);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "nl",
	  "com",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2555);
	internet.domain_suffix = __webpack_require__(2554);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2559);
	lorem.supplemental = __webpack_require__(2558);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Amber",
	  "Anna",
	  "Anne",
	  "Anouk",
	  "Bas",
	  "Bram",
	  "Britt",
	  "Daan",
	  "Emma",
	  "Eva",
	  "Femke",
	  "Finn",
	  "Fleur",
	  "Iris",
	  "Isa",
	  "Jan",
	  "Jasper",
	  "Jayden",
	  "Jesse",
	  "Johannes",
	  "Julia",
	  "Julian",
	  "Kevin",
	  "Lars",
	  "Lieke",
	  "Lisa",
	  "Lotte",
	  "Lucas",
	  "Luuk",
	  "Maud",
	  "Max",
	  "Mike",
	  "Milan",
	  "Nick",
	  "Niels",
	  "Noa",
	  "Rick",
	  "Roos",
	  "Ruben",
	  "Sander",
	  "Sanne",
	  "Sem",
	  "Sophie",
	  "Stijn",
	  "Sven",
	  "Thijs",
	  "Thijs",
	  "Thomas",
	  "Tim",
	  "Tom"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2560);
	name.tussenvoegsel = __webpack_require__(2566);
	name.last_name = __webpack_require__(2562);
	name.prefix = __webpack_require__(2564);
	name.suffix = __webpack_require__(2565);
	name.name = __webpack_require__(2563);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bakker",
	  "Beek",
	  "Berg",
	  "Boer",
	  "Bos",
	  "Bosch",
	  "Brink",
	  "Broek",
	  "Brouwer",
	  "Bruin",
	  "Dam",
	  "Dekker",
	  "Dijk",
	  "Dijkstra",
	  "Graaf",
	  "Groot",
	  "Haan",
	  "Hendriks",
	  "Heuvel",
	  "Hoek",
	  "Jacobs",
	  "Jansen",
	  "Janssen",
	  "Jong",
	  "Klein",
	  "Kok",
	  "Koning",
	  "Koster",
	  "Leeuwen",
	  "Linden",
	  "Maas",
	  "Meer",
	  "Meijer",
	  "Mulder",
	  "Peters",
	  "Ruiter",
	  "Schouten",
	  "Smit",
	  "Smits",
	  "Stichting",
	  "Veen",
	  "Ven",
	  "Vermeulen",
	  "Visser",
	  "Vliet",
	  "Vos",
	  "Vries",
	  "Wal",
	  "Willems",
	  "Wit"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{suffix}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{tussenvoegsel} #{last_name}",
	  "#{first_name} #{tussenvoegsel} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dhr.",
	  "Mevr. Dr.",
	  "Bsc",
	  "Msc",
	  "Prof."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Sr.",
	  "I",
	  "II",
	  "III",
	  "IV",
	  "V"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "van",
	  "van de",
	  "van den",
	  "van 't",
	  "van het",
	  "de",
	  "den"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(####) ######",
	  "##########",
	  "06########",
	  "06 #### ####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2567);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aleksandrów Kujawski",
	  "Aleksandrów Łódzki",
	  "Alwernia",
	  "Andrychów",
	  "Annopol",
	  "Augustów",
	  "Babimost",
	  "Baborów",
	  "Baranów Sandomierski",
	  "Barcin",
	  "Barczewo",
	  "Bardo",
	  "Barlinek",
	  "Bartoszyce",
	  "Barwice",
	  "Bełchatów",
	  "Bełżyce",
	  "Będzin",
	  "Biała",
	  "Biała Piska",
	  "Biała Podlaska",
	  "Biała Rawska",
	  "Białobrzegi",
	  "Białogard",
	  "Biały Bór",
	  "Białystok",
	  "Biecz",
	  "Bielawa",
	  "Bielsk Podlaski",
	  "Bielsko-Biała",
	  "Bieruń",
	  "Bierutów",
	  "Bieżuń",
	  "Biłgoraj",
	  "Biskupiec",
	  "Bisztynek",
	  "Blachownia",
	  "Błaszki",
	  "Błażowa",
	  "Błonie",
	  "Bobolice",
	  "Bobowa",
	  "Bochnia",
	  "Bodzentyn",
	  "Bogatynia",
	  "Boguchwała",
	  "Boguszów-Gorce",
	  "Bojanowo",
	  "Bolesławiec",
	  "Bolków",
	  "Borek Wielkopolski",
	  "Borne Sulinowo",
	  "Braniewo",
	  "Brańsk",
	  "Brodnica",
	  "Brok",
	  "Brusy",
	  "Brwinów",
	  "Brzeg",
	  "Brzeg Dolny",
	  "Brzesko",
	  "Brzeszcze",
	  "Brześć Kujawski",
	  "Brzeziny",
	  "Brzostek",
	  "Brzozów",
	  "Buk",
	  "Bukowno",
	  "Busko-Zdrój",
	  "Bychawa",
	  "Byczyna",
	  "Bydgoszcz",
	  "Bystrzyca Kłodzka",
	  "Bytom",
	  "Bytom Odrzański",
	  "Bytów",
	  "Cedynia",
	  "Chełm",
	  "Chełmek",
	  "Chełmno",
	  "Chełmża",
	  "Chęciny",
	  "Chmielnik",
	  "Chocianów",
	  "Chociwel",
	  "Chodecz",
	  "Chodzież",
	  "Chojna",
	  "Chojnice",
	  "Chojnów",
	  "Choroszcz",
	  "Chorzele",
	  "Chorzów",
	  "Choszczno",
	  "Chrzanów",
	  "Ciechanowiec",
	  "Ciechanów",
	  "Ciechocinek",
	  "Cieszanów",
	  "Cieszyn",
	  "Ciężkowice",
	  "Cybinka",
	  "Czaplinek",
	  "Czarna Białostocka",
	  "Czarna Woda",
	  "Czarne",
	  "Czarnków",
	  "Czchów",
	  "Czechowice-Dziedzice",
	  "Czeladź",
	  "Czempiń",
	  "Czerniejewo",
	  "Czersk",
	  "Czerwieńsk",
	  "Czerwionka-Leszczyny",
	  "Częstochowa",
	  "Człopa",
	  "Człuchów",
	  "Czyżew",
	  "Ćmielów",
	  "Daleszyce",
	  "Darłowo",
	  "Dąbie",
	  "Dąbrowa Białostocka",
	  "Dąbrowa Górnicza",
	  "Dąbrowa Tarnowska",
	  "Debrzno",
	  "Dębica",
	  "Dęblin",
	  "Dębno",
	  "Dobczyce",
	  "Dobiegniew",
	  "Dobra (powiat łobeski)",
	  "Dobra (powiat turecki)",
	  "Dobre Miasto",
	  "Dobrodzień",
	  "Dobrzany",
	  "Dobrzyń nad Wisłą",
	  "Dolsk",
	  "Drawno",
	  "Drawsko Pomorskie",
	  "Drezdenko",
	  "Drobin",
	  "Drohiczyn",
	  "Drzewica",
	  "Dukla",
	  "Duszniki-Zdrój",
	  "Dynów",
	  "Działdowo",
	  "Działoszyce",
	  "Działoszyn",
	  "Dzierzgoń",
	  "Dzierżoniów",
	  "Dziwnów",
	  "Elbląg",
	  "Ełk",
	  "Frampol",
	  "Frombork",
	  "Garwolin",
	  "Gąbin",
	  "Gdańsk",
	  "Gdynia",
	  "Giżycko",
	  "Glinojeck",
	  "Gliwice",
	  "Głogów",
	  "Głogów Małopolski",
	  "Głogówek",
	  "Głowno",
	  "Głubczyce",
	  "Głuchołazy",
	  "Głuszyca",
	  "Gniew",
	  "Gniewkowo",
	  "Gniezno",
	  "Gogolin",
	  "Golczewo",
	  "Goleniów",
	  "Golina",
	  "Golub-Dobrzyń",
	  "Gołańcz",
	  "Gołdap",
	  "Goniądz",
	  "Gorlice",
	  "Gorzów Śląski",
	  "Gorzów Wielkopolski",
	  "Gostynin",
	  "Gostyń",
	  "Gościno",
	  "Gozdnica",
	  "Góra",
	  "Góra Kalwaria",
	  "Górowo Iławeckie",
	  "Górzno",
	  "Grabów nad Prosną",
	  "Grajewo",
	  "Grodków",
	  "Grodzisk Mazowiecki",
	  "Grodzisk Wielkopolski",
	  "Grójec",
	  "Grudziądz",
	  "Grybów",
	  "Gryfice",
	  "Gryfino",
	  "Gryfów Śląski",
	  "Gubin",
	  "Hajnówka",
	  "Halinów",
	  "Hel",
	  "Hrubieszów",
	  "Iława",
	  "Iłowa",
	  "Iłża",
	  "Imielin",
	  "Inowrocław",
	  "Ińsko",
	  "Iwonicz-Zdrój",
	  "Izbica Kujawska",
	  "Jabłonowo Pomorskie",
	  "Janikowo",
	  "Janowiec Wielkopolski",
	  "Janów Lubelski",
	  "Jarocin",
	  "Jarosław",
	  "Jasień",
	  "Jasło",
	  "Jastarnia",
	  "Jastrowie",
	  "Jastrzębie-Zdrój",
	  "Jawor",
	  "Jaworzno",
	  "Jaworzyna Śląska",
	  "Jedlicze",
	  "Jedlina-Zdrój",
	  "Jedwabne",
	  "Jelcz-Laskowice",
	  "Jelenia Góra",
	  "Jeziorany",
	  "Jędrzejów",
	  "Jordanów",
	  "Józefów (powiat biłgorajski)",
	  "Józefów (powiat otwocki)",
	  "Jutrosin",
	  "Kalety",
	  "Kalisz",
	  "Kalisz Pomorski",
	  "Kalwaria Zebrzydowska",
	  "Kałuszyn",
	  "Kamienna Góra",
	  "Kamień Krajeński",
	  "Kamień Pomorski",
	  "Kamieńsk",
	  "Kańczuga",
	  "Karczew",
	  "Kargowa",
	  "Karlino",
	  "Karpacz",
	  "Kartuzy",
	  "Katowice",
	  "Kazimierz Dolny",
	  "Kazimierza Wielka",
	  "Kąty Wrocławskie",
	  "Kcynia",
	  "Kędzierzyn-Koźle",
	  "Kępice",
	  "Kępno",
	  "Kętrzyn",
	  "Kęty",
	  "Kielce",
	  "Kietrz",
	  "Kisielice",
	  "Kleczew",
	  "Kleszczele",
	  "Kluczbork",
	  "Kłecko",
	  "Kłobuck",
	  "Kłodawa",
	  "Kłodzko",
	  "Knurów",
	  "Knyszyn",
	  "Kobylin",
	  "Kobyłka",
	  "Kock",
	  "Kolbuszowa",
	  "Kolno",
	  "Kolonowskie",
	  "Koluszki",
	  "Kołaczyce",
	  "Koło",
	  "Kołobrzeg",
	  "Koniecpol",
	  "Konin",
	  "Konstancin-Jeziorna",
	  "Konstantynów Łódzki",
	  "Końskie",
	  "Koprzywnica",
	  "Korfantów",
	  "Koronowo",
	  "Korsze",
	  "Kosów Lacki",
	  "Kostrzyn",
	  "Kostrzyn nad Odrą",
	  "Koszalin",
	  "Kościan",
	  "Kościerzyna",
	  "Kowal",
	  "Kowalewo Pomorskie",
	  "Kowary",
	  "Koziegłowy",
	  "Kozienice",
	  "Koźmin Wielkopolski",
	  "Kożuchów",
	  "Kórnik",
	  "Krajenka",
	  "Kraków",
	  "Krapkowice",
	  "Krasnobród",
	  "Krasnystaw",
	  "Kraśnik",
	  "Krobia",
	  "Krosno",
	  "Krosno Odrzańskie",
	  "Krośniewice",
	  "Krotoszyn",
	  "Kruszwica",
	  "Krynica Morska",
	  "Krynica-Zdrój",
	  "Krynki",
	  "Krzanowice",
	  "Krzepice",
	  "Krzeszowice",
	  "Krzywiń",
	  "Krzyż Wielkopolski",
	  "Książ Wielkopolski",
	  "Kudowa-Zdrój",
	  "Kunów",
	  "Kutno",
	  "Kuźnia Raciborska",
	  "Kwidzyn",
	  "Lądek-Zdrój",
	  "Legionowo",
	  "Legnica",
	  "Lesko",
	  "Leszno",
	  "Leśna",
	  "Leśnica",
	  "Lewin Brzeski",
	  "Leżajsk",
	  "Lębork",
	  "Lędziny",
	  "Libiąż",
	  "Lidzbark",
	  "Lidzbark Warmiński",
	  "Limanowa",
	  "Lipiany",
	  "Lipno",
	  "Lipsk",
	  "Lipsko",
	  "Lubaczów",
	  "Lubań",
	  "Lubartów",
	  "Lubawa",
	  "Lubawka",
	  "Lubień Kujawski",
	  "Lubin",
	  "Lublin",
	  "Lubliniec",
	  "Lubniewice",
	  "Lubomierz",
	  "Luboń",
	  "Lubraniec",
	  "Lubsko",
	  "Lwówek",
	  "Lwówek Śląski",
	  "Łabiszyn",
	  "Łańcut",
	  "Łapy",
	  "Łasin",
	  "Łask",
	  "Łaskarzew",
	  "Łaszczów",
	  "Łaziska Górne",
	  "Łazy",
	  "Łeba",
	  "Łęczna",
	  "Łęczyca",
	  "Łęknica",
	  "Łobez",
	  "Łobżenica",
	  "Łochów",
	  "Łomianki",
	  "Łomża",
	  "Łosice",
	  "Łowicz",
	  "Łódź",
	  "Łuków",
	  "Maków Mazowiecki",
	  "Maków Podhalański",
	  "Malbork",
	  "Małogoszcz",
	  "Małomice",
	  "Margonin",
	  "Marki",
	  "Maszewo",
	  "Miasteczko Śląskie",
	  "Miastko",
	  "Michałowo",
	  "Miechów",
	  "Miejska Górka",
	  "Mielec",
	  "Mieroszów",
	  "Mieszkowice",
	  "Międzybórz",
	  "Międzychód",
	  "Międzylesie",
	  "Międzyrzec Podlaski",
	  "Międzyrzecz",
	  "Międzyzdroje",
	  "Mikołajki",
	  "Mikołów",
	  "Mikstat",
	  "Milanówek",
	  "Milicz",
	  "Miłakowo",
	  "Miłomłyn",
	  "Miłosław",
	  "Mińsk Mazowiecki",
	  "Mirosławiec",
	  "Mirsk",
	  "Mława",
	  "Młynary",
	  "Mogielnica",
	  "Mogilno",
	  "Mońki",
	  "Morąg",
	  "Mordy",
	  "Moryń",
	  "Mosina",
	  "Mrągowo",
	  "Mrocza",
	  "Mszana Dolna",
	  "Mszczonów",
	  "Murowana Goślina",
	  "Muszyna",
	  "Mysłowice",
	  "Myszków",
	  "Myszyniec",
	  "Myślenice",
	  "Myślibórz",
	  "Nakło nad Notecią",
	  "Nałęczów",
	  "Namysłów",
	  "Narol",
	  "Nasielsk",
	  "Nekla",
	  "Nidzica",
	  "Niemcza",
	  "Niemodlin",
	  "Niepołomice",
	  "Nieszawa",
	  "Nisko",
	  "Nowa Dęba",
	  "Nowa Ruda",
	  "Nowa Sarzyna",
	  "Nowa Sól",
	  "Nowe",
	  "Nowe Brzesko",
	  "Nowe Miasteczko",
	  "Nowe Miasto Lubawskie",
	  "Nowe Miasto nad Pilicą",
	  "Nowe Skalmierzyce",
	  "Nowe Warpno",
	  "Nowogard",
	  "Nowogrodziec",
	  "Nowogród",
	  "Nowogród Bobrzański",
	  "Nowy Dwór Gdański",
	  "Nowy Dwór Mazowiecki",
	  "Nowy Sącz",
	  "Nowy Staw",
	  "Nowy Targ",
	  "Nowy Tomyśl",
	  "Nowy Wiśnicz",
	  "Nysa",
	  "Oborniki",
	  "Oborniki Śląskie",
	  "Obrzycko",
	  "Odolanów",
	  "Ogrodzieniec",
	  "Okonek",
	  "Olecko",
	  "Olesno",
	  "Oleszyce",
	  "Oleśnica",
	  "Olkusz",
	  "Olsztyn",
	  "Olsztynek",
	  "Olszyna",
	  "Oława",
	  "Opalenica",
	  "Opatów",
	  "Opoczno",
	  "Opole",
	  "Opole Lubelskie",
	  "Orneta",
	  "Orzesze",
	  "Orzysz",
	  "Osieczna",
	  "Osiek",
	  "Ostrołęka",
	  "Ostroróg",
	  "Ostrowiec Świętokrzyski",
	  "Ostróda",
	  "Ostrów Lubelski",
	  "Ostrów Mazowiecka",
	  "Ostrów Wielkopolski",
	  "Ostrzeszów",
	  "Ośno Lubuskie",
	  "Oświęcim",
	  "Otmuchów",
	  "Otwock",
	  "Ozimek",
	  "Ozorków",
	  "Ożarów",
	  "Ożarów Mazowiecki",
	  "Pabianice",
	  "Paczków",
	  "Pajęczno",
	  "Pakość",
	  "Parczew",
	  "Pasłęk",
	  "Pasym",
	  "Pelplin",
	  "Pełczyce",
	  "Piaseczno",
	  "Piaski",
	  "Piastów",
	  "Piechowice",
	  "Piekary Śląskie",
	  "Pieniężno",
	  "Pieńsk",
	  "Pieszyce",
	  "Pilawa",
	  "Pilica",
	  "Pilzno",
	  "Piła",
	  "Piława Górna",
	  "Pińczów",
	  "Pionki",
	  "Piotrków Kujawski",
	  "Piotrków Trybunalski",
	  "Pisz",
	  "Piwniczna-Zdrój",
	  "Pleszew",
	  "Płock",
	  "Płońsk",
	  "Płoty",
	  "Pniewy",
	  "Pobiedziska",
	  "Poddębice",
	  "Podkowa Leśna",
	  "Pogorzela",
	  "Polanica-Zdrój",
	  "Polanów",
	  "Police",
	  "Polkowice",
	  "Połaniec",
	  "Połczyn-Zdrój",
	  "Poniatowa",
	  "Poniec",
	  "Poręba",
	  "Poznań",
	  "Prabuty",
	  "Praszka",
	  "Prochowice",
	  "Proszowice",
	  "Prószków",
	  "Pruchnik",
	  "Prudnik",
	  "Prusice",
	  "Pruszcz Gdański",
	  "Pruszków",
	  "Przasnysz",
	  "Przecław",
	  "Przedbórz",
	  "Przedecz",
	  "Przemków",
	  "Przemyśl",
	  "Przeworsk",
	  "Przysucha",
	  "Pszczyna",
	  "Pszów",
	  "Puck",
	  "Puławy",
	  "Pułtusk",
	  "Puszczykowo",
	  "Pyrzyce",
	  "Pyskowice",
	  "Pyzdry",
	  "Rabka-Zdrój",
	  "Raciąż",
	  "Racibórz",
	  "Radków",
	  "Radlin",
	  "Radłów",
	  "Radom",
	  "Radomsko",
	  "Radomyśl Wielki",
	  "Radymno",
	  "Radziejów",
	  "Radzionków",
	  "Radzymin",
	  "Radzyń Chełmiński",
	  "Radzyń Podlaski",
	  "Rajgród",
	  "Rakoniewice",
	  "Raszków",
	  "Rawa Mazowiecka",
	  "Rawicz",
	  "Recz",
	  "Reda",
	  "Rejowiec Fabryczny",
	  "Resko",
	  "Reszel",
	  "Rogoźno",
	  "Ropczyce",
	  "Różan",
	  "Ruciane-Nida",
	  "Ruda Śląska",
	  "Rudnik nad Sanem",
	  "Rumia",
	  "Rybnik",
	  "Rychwał",
	  "Rydułtowy",
	  "Rydzyna",
	  "Ryglice",
	  "Ryki",
	  "Rymanów",
	  "Ryn",
	  "Rypin",
	  "Rzepin",
	  "Rzeszów",
	  "Rzgów",
	  "Sandomierz",
	  "Sanok",
	  "Sejny",
	  "Serock",
	  "Sędziszów",
	  "Sędziszów Małopolski",
	  "Sępopol",
	  "Sępólno Krajeńskie",
	  "Sianów",
	  "Siechnice",
	  "Siedlce",
	  "Siemianowice Śląskie",
	  "Siemiatycze",
	  "Sieniawa",
	  "Sieradz",
	  "Sieraków",
	  "Sierpc",
	  "Siewierz",
	  "Skalbmierz",
	  "Skała",
	  "Skarszewy",
	  "Skaryszew",
	  "Skarżysko-Kamienna",
	  "Skawina",
	  "Skępe",
	  "Skierniewice",
	  "Skoczów",
	  "Skoki",
	  "Skórcz",
	  "Skwierzyna",
	  "Sława",
	  "Sławków",
	  "Sławno",
	  "Słomniki",
	  "Słubice",
	  "Słupca",
	  "Słupsk",
	  "Sobótka",
	  "Sochaczew",
	  "Sokołów Małopolski",
	  "Sokołów Podlaski",
	  "Sokółka",
	  "Solec Kujawski",
	  "Sompolno",
	  "Sopot",
	  "Sosnowiec",
	  "Sośnicowice",
	  "Stalowa Wola",
	  "Starachowice",
	  "Stargard Szczeciński",
	  "Starogard Gdański",
	  "Stary Sącz",
	  "Staszów",
	  "Stawiski",
	  "Stawiszyn",
	  "Stąporków",
	  "Stęszew",
	  "Stoczek Łukowski",
	  "Stronie Śląskie",
	  "Strumień",
	  "Stryków",
	  "Strzegom",
	  "Strzelce Krajeńskie",
	  "Strzelce Opolskie",
	  "Strzelin",
	  "Strzelno",
	  "Strzyżów",
	  "Sucha Beskidzka",
	  "Suchań",
	  "Suchedniów",
	  "Suchowola",
	  "Sulechów",
	  "Sulejów",
	  "Sulejówek",
	  "Sulęcin",
	  "Sulmierzyce",
	  "Sułkowice",
	  "Supraśl",
	  "Suraż",
	  "Susz",
	  "Suwałki",
	  "Swarzędz",
	  "Syców",
	  "Szadek",
	  "Szamocin",
	  "Szamotuły",
	  "Szczawnica",
	  "Szczawno-Zdrój",
	  "Szczebrzeszyn",
	  "Szczecin",
	  "Szczecinek",
	  "Szczekociny",
	  "Szczucin",
	  "Szczuczyn",
	  "Szczyrk",
	  "Szczytna",
	  "Szczytno",
	  "Szepietowo",
	  "Szklarska Poręba",
	  "Szlichtyngowa",
	  "Szprotawa",
	  "Sztum",
	  "Szubin",
	  "Szydłowiec",
	  "Ścinawa",
	  "Ślesin",
	  "Śmigiel",
	  "Śrem",
	  "Środa Śląska",
	  "Środa Wielkopolska",
	  "Świątniki Górne",
	  "Świdnica",
	  "Świdnik",
	  "Świdwin",
	  "Świebodzice",
	  "Świebodzin",
	  "Świecie",
	  "Świeradów-Zdrój",
	  "Świerzawa",
	  "Świętochłowice",
	  "Świnoujście",
	  "Tarczyn",
	  "Tarnobrzeg",
	  "Tarnogród",
	  "Tarnowskie Góry",
	  "Tarnów",
	  "Tczew",
	  "Terespol",
	  "Tłuszcz",
	  "Tolkmicko",
	  "Tomaszów Lubelski",
	  "Tomaszów Mazowiecki",
	  "Toruń",
	  "Torzym",
	  "Toszek",
	  "Trzcianka",
	  "Trzciel",
	  "Trzcińsko-Zdrój",
	  "Trzebiatów",
	  "Trzebinia",
	  "Trzebnica",
	  "Trzemeszno",
	  "Tuchola",
	  "Tuchów",
	  "Tuczno",
	  "Tuliszków",
	  "Turek",
	  "Tuszyn",
	  "Twardogóra",
	  "Tychowo",
	  "Tychy",
	  "Tyczyn",
	  "Tykocin",
	  "Tyszowce",
	  "Ujazd",
	  "Ujście",
	  "Ulanów",
	  "Uniejów",
	  "Ustka",
	  "Ustroń",
	  "Ustrzyki Dolne",
	  "Wadowice",
	  "Wałbrzych",
	  "Wałcz",
	  "Warka",
	  "Warszawa",
	  "Warta",
	  "Wasilków",
	  "Wąbrzeźno",
	  "Wąchock",
	  "Wągrowiec",
	  "Wąsosz",
	  "Wejherowo",
	  "Węgliniec",
	  "Węgorzewo",
	  "Węgorzyno",
	  "Węgrów",
	  "Wiązów",
	  "Wieleń",
	  "Wielichowo",
	  "Wieliczka",
	  "Wieluń",
	  "Wieruszów",
	  "Więcbork",
	  "Wilamowice",
	  "Wisła",
	  "Witkowo",
	  "Witnica",
	  "Wleń",
	  "Władysławowo",
	  "Włocławek",
	  "Włodawa",
	  "Włoszczowa",
	  "Wodzisław Śląski",
	  "Wojcieszów",
	  "Wojkowice",
	  "Wojnicz",
	  "Wolbórz",
	  "Wolbrom",
	  "Wolin",
	  "Wolsztyn",
	  "Wołczyn",
	  "Wołomin",
	  "Wołów",
	  "Woźniki",
	  "Wrocław",
	  "Wronki",
	  "Września",
	  "Wschowa",
	  "Wyrzysk",
	  "Wysoka",
	  "Wysokie Mazowieckie",
	  "Wyszków",
	  "Wyszogród",
	  "Wyśmierzyce",
	  "Zabłudów",
	  "Zabrze",
	  "Zagórów",
	  "Zagórz",
	  "Zakliczyn",
	  "Zakopane",
	  "Zakroczym",
	  "Zalewo",
	  "Zambrów",
	  "Zamość",
	  "Zator",
	  "Zawadzkie",
	  "Zawichost",
	  "Zawidów",
	  "Zawiercie",
	  "Ząbki",
	  "Ząbkowice Śląskie",
	  "Zbąszynek",
	  "Zbąszyń",
	  "Zduny",
	  "Zduńska Wola",
	  "Zdzieszowice",
	  "Zelów",
	  "Zgierz",
	  "Zgorzelec",
	  "Zielona Góra",
	  "Zielonka",
	  "Ziębice",
	  "Złocieniec",
	  "Złoczew",
	  "Złotoryja",
	  "Złotów",
	  "Złoty Stok",
	  "Zwierzyniec",
	  "Zwoleń",
	  "Żabno",
	  "Żagań",
	  "Żarki",
	  "Żarów",
	  "Żary",
	  "Żelechów",
	  "Żerków",
	  "Żmigród",
	  "Żnin",
	  "Żory",
	  "Żukowo",
	  "Żuromin",
	  "Żychlin",
	  "Żyrardów",
	  "Żywiec"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Albania",
	  "Algieria",
	  "Andora",
	  "Angola",
	  "Antigua i Barbuda",
	  "Arabia Saudyjska",
	  "Argentyna",
	  "Armenia",
	  "Australia",
	  "Austria",
	  "Azerbejdżan",
	  "Bahamy",
	  "Bahrajn",
	  "Bangladesz",
	  "Barbados",
	  "Belgia",
	  "Belize",
	  "Benin",
	  "Bhutan",
	  "Białoruś",
	  "Birma",
	  "Boliwia",
	  "Sucre",
	  "Bośnia i Hercegowina",
	  "Botswana",
	  "Brazylia",
	  "Brunei",
	  "Bułgaria",
	  "Burkina Faso",
	  "Burundi",
	  "Chile",
	  "Chiny",
	  "Chorwacja",
	  "Cypr",
	  "Czad",
	  "Czarnogóra",
	  "Czechy",
	  "Dania",
	  "Demokratyczna Republika Konga",
	  "Dominika",
	  "Dominikana",
	  "Dżibuti",
	  "Egipt",
	  "Ekwador",
	  "Erytrea",
	  "Estonia",
	  "Etiopia",
	  "Fidżi",
	  "Filipiny",
	  "Finlandia",
	  "Francja",
	  "Gabon",
	  "Gambia",
	  "Ghana",
	  "Grecja",
	  "Grenada",
	  "Gruzja",
	  "Gujana",
	  "Gwatemala",
	  "Gwinea",
	  "Gwinea Bissau",
	  "Gwinea Równikowa",
	  "Haiti",
	  "Hiszpania",
	  "Holandia",
	  "Haga",
	  "Honduras",
	  "Indie",
	  "Indonezja",
	  "Irak",
	  "Iran",
	  "Irlandia",
	  "Islandia",
	  "Izrael",
	  "Jamajka",
	  "Japonia",
	  "Jemen",
	  "Jordania",
	  "Kambodża",
	  "Kamerun",
	  "Kanada",
	  "Katar",
	  "Kazachstan",
	  "Kenia",
	  "Kirgistan",
	  "Kiribati",
	  "Kolumbia",
	  "Komory",
	  "Kongo",
	  "Korea Południowa",
	  "Korea Północna",
	  "Kostaryka",
	  "Kuba",
	  "Kuwejt",
	  "Laos",
	  "Lesotho",
	  "Liban",
	  "Liberia",
	  "Libia",
	  "Liechtenstein",
	  "Litwa",
	  "Luksemburg",
	  "Łotwa",
	  "Macedonia",
	  "Madagaskar",
	  "Malawi",
	  "Malediwy",
	  "Malezja",
	  "Mali",
	  "Malta",
	  "Maroko",
	  "Mauretania",
	  "Mauritius",
	  "Meksyk",
	  "Mikronezja",
	  "Mołdawia",
	  "Monako",
	  "Mongolia",
	  "Mozambik",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Niemcy",
	  "Niger",
	  "Nigeria",
	  "Nikaragua",
	  "Norwegia",
	  "Nowa Zelandia",
	  "Oman",
	  "Pakistan",
	  "Palau",
	  "Panama",
	  "Papua-Nowa Gwinea",
	  "Paragwaj",
	  "Peru",
	  "Polska",
	  "322 575",
	  "Portugalia",
	  "Republika Południowej Afryki",
	  "Republika Środkowoafrykańska",
	  "Republika Zielonego Przylądka",
	  "Rosja",
	  "Rumunia",
	  "Rwanda",
	  "Saint Kitts i Nevis",
	  "Saint Lucia",
	  "Saint Vincent i Grenadyny",
	  "Salwador",
	  "Samoa",
	  "San Marino",
	  "Senegal",
	  "Serbia",
	  "Seszele",
	  "Sierra Leone",
	  "Singapur",
	  "Słowacja",
	  "Słowenia",
	  "Somalia",
	  "Sri Lanka",
	  "Stany Zjednoczone",
	  "Suazi",
	  "Sudan",
	  "Sudan Południowy",
	  "Surinam",
	  "Syria",
	  "Szwajcaria",
	  "Szwecja",
	  "Tadżykistan",
	  "Tajlandia",
	  "Tanzania",
	  "Timor Wschodni",
	  "Togo",
	  "Tonga",
	  "Trynidad i Tobago",
	  "Tunezja",
	  "Turcja",
	  "Turkmenistan",
	  "Tuvalu",
	  "Funafuti",
	  "Uganda",
	  "Ukraina",
	  "Urugwaj",
	  2008,
	  "Uzbekistan",
	  "Vanuatu",
	  "Watykan",
	  "Wenezuela",
	  "Węgry",
	  "Wielka Brytania",
	  "Wietnam",
	  "Włochy",
	  "Wybrzeże Kości Słoniowej",
	  "Wyspy Marshalla",
	  "Wyspy Salomona",
	  "Wyspy Świętego Tomasza i Książęca",
	  "Zambia",
	  "Zimbabwe",
	  "Zjednoczone Emiraty Arabskie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Polska"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(2572);
	address.building_number = __webpack_require__(2569);
	address.street_prefix = __webpack_require__(2581);
	address.secondary_address = __webpack_require__(2576);
	address.postcode = __webpack_require__(2575);
	address.state = __webpack_require__(2577);
	address.state_abbr = __webpack_require__(2578);
	address.city_name = __webpack_require__(2571);
	address.city = __webpack_require__(2570);
	address.street_name = __webpack_require__(2580);
	address.street_address = __webpack_require__(2579);
	address.default_country = __webpack_require__(2573);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "##-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dolnośląskie",
	  "Kujawsko-pomorskie",
	  "Lubelskie",
	  "Lubuskie",
	  "Łódzkie",
	  "Małopolskie",
	  "Mazowieckie",
	  "Opolskie",
	  "Podkarpackie",
	  "Podlaskie",
	  "Pomorskie",
	  "Śląskie",
	  "Świętokrzyskie",
	  "Warmińsko-mazurskie",
	  "Wielkopolskie",
	  "Zachodniopomorskie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "DŚ",
	  "KP",
	  "LB",
	  "LS",
	  "ŁD",
	  "MP",
	  "MZ",
	  "OP",
	  "PK",
	  "PL",
	  "PM",
	  "ŚL",
	  "ŚK",
	  "WM",
	  "WP",
	  "ZP"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ul.",
	  "al."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "50-###-##-##",
	  "51-###-##-##",
	  "53-###-##-##",
	  "57-###-##-##",
	  "60-###-##-##",
	  "66-###-##-##",
	  "69-###-##-##",
	  "72-###-##-##",
	  "73-###-##-##",
	  "78-###-##-##",
	  "79-###-##-##",
	  "88-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2582);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2592);
	company.adjetive = __webpack_require__(2584);
	company.descriptor = __webpack_require__(2588);
	company.noun = __webpack_require__(2591);
	company.bs_verb = __webpack_require__(2587);
	company.bs_adjective = __webpack_require__(2585);
	company.bs_noun = __webpack_require__(2586);
	company.name = __webpack_require__(2590);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} and #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Inc",
	  "and Sons",
	  "LLC",
	  "Group"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var pl = {};
	module['exports'] = pl;
	pl.title = "Polish";
	pl.name = __webpack_require__(2601);
	pl.address = __webpack_require__(2574);
	pl.company = __webpack_require__(2589);
	pl.internet = __webpack_require__(2596);
	pl.lorem = __webpack_require__(2597);
	pl.phone_number = __webpack_require__(2607);
	pl.cell_phone = __webpack_require__(2583);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "pl",
	  "com.pl",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2595);
	internet.domain_suffix = __webpack_require__(2594);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2599);
	lorem.supplemental = __webpack_require__(2598);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aaron",
	  "Abraham",
	  "Adam",
	  "Adrian",
	  "Atanazy",
	  "Agaton",
	  "Alan",
	  "Albert",
	  "Aleksander",
	  "Aleksy",
	  "Alfred",
	  "Alwar",
	  "Ambroży",
	  "Anatol",
	  "Andrzej",
	  "Antoni",
	  "Apollinary",
	  "Apollo",
	  "Arkady",
	  "Arkadiusz",
	  "Archibald",
	  "Arystarch",
	  "Arnold",
	  "Arseniusz",
	  "Artur",
	  "August",
	  "Baldwin",
	  "Bazyli",
	  "Benedykt",
	  "Beniamin",
	  "Bernard",
	  "Bertrand",
	  "Bertram",
	  "Borys",
	  "Brajan",
	  "Bruno",
	  "Cezary",
	  "Cecyliusz",
	  "Karol",
	  "Krystian",
	  "Krzysztof",
	  "Klarencjusz",
	  "Klaudiusz",
	  "Klemens",
	  "Konrad",
	  "Konstanty",
	  "Konstantyn",
	  "Kornel",
	  "Korneliusz",
	  "Korneli",
	  "Cyryl",
	  "Cyrus",
	  "Damian",
	  "Daniel",
	  "Dariusz",
	  "Dawid",
	  "Dionizy",
	  "Demetriusz",
	  "Dominik",
	  "Donald",
	  "Dorian",
	  "Edgar",
	  "Edmund",
	  "Edward",
	  "Edwin",
	  "Efrem",
	  "Efraim",
	  "Eliasz",
	  "Eleazar",
	  "Emil",
	  "Emanuel",
	  "Erast",
	  "Ernest",
	  "Eugeniusz",
	  "Eustracjusz",
	  "Fabian",
	  "Feliks",
	  "Florian",
	  "Franciszek",
	  "Fryderyk",
	  "Gabriel",
	  "Gedeon",
	  "Galfryd",
	  "Jerzy",
	  "Gerald",
	  "Gerazym",
	  "Gilbert",
	  "Gonsalwy",
	  "Grzegorz",
	  "Gwido",
	  "Harald",
	  "Henryk",
	  "Herbert",
	  "Herman",
	  "Hilary",
	  "Horacy",
	  "Hubert",
	  "Hugo",
	  "Ignacy",
	  "Igor",
	  "Hilarion",
	  "Innocenty",
	  "Hipolit",
	  "Ireneusz",
	  "Erwin",
	  "Izaak",
	  "Izajasz",
	  "Izydor",
	  "Jakub",
	  "Jeremi",
	  "Jeremiasz",
	  "Hieronim",
	  "Gerald",
	  "Joachim",
	  "Jan",
	  "Janusz",
	  "Jonatan",
	  "Józef",
	  "Jozue",
	  "Julian",
	  "Juliusz",
	  "Justyn",
	  "Kalistrat",
	  "Kazimierz",
	  "Wawrzyniec",
	  "Laurenty",
	  "Laurencjusz",
	  "Łazarz",
	  "Leon",
	  "Leonard",
	  "Leonid",
	  "Leon",
	  "Ludwik",
	  "Łukasz",
	  "Lucjan",
	  "Magnus",
	  "Makary",
	  "Marceli",
	  "Marek",
	  "Marcin",
	  "Mateusz",
	  "Maurycy",
	  "Maksym",
	  "Maksymilian",
	  "Michał",
	  "Miron",
	  "Modest",
	  "Mojżesz",
	  "Natan",
	  "Natanael",
	  "Nazariusz",
	  "Nazary",
	  "Nestor",
	  "Mikołaj",
	  "Nikodem",
	  "Olaf",
	  "Oleg",
	  "Oliwier",
	  "Onufry",
	  "Orestes",
	  "Oskar",
	  "Ansgary",
	  "Osmund",
	  "Pankracy",
	  "Pantaleon",
	  "Patryk",
	  "Patrycjusz",
	  "Patrycy",
	  "Paweł",
	  "Piotr",
	  "Filemon",
	  "Filip",
	  "Platon",
	  "Polikarp",
	  "Porfiry",
	  "Porfiriusz",
	  "Prokles",
	  "Prokul",
	  "Prokop",
	  "Kwintyn",
	  "Randolf",
	  "Rafał",
	  "Rajmund",
	  "Reginald",
	  "Rajnold",
	  "Ryszard",
	  "Robert",
	  "Roderyk",
	  "Roger",
	  "Roland",
	  "Roman",
	  "Romeo",
	  "Reginald",
	  "Rudolf",
	  "Samson",
	  "Samuel",
	  "Salwator",
	  "Sebastian",
	  "Serafin",
	  "Sergiusz",
	  "Seweryn",
	  "Zygmunt",
	  "Sylwester",
	  "Szymon",
	  "Salomon",
	  "Spirydion",
	  "Stanisław",
	  "Szczepan",
	  "Stefan",
	  "Terencjusz",
	  "Teodor",
	  "Tomasz",
	  "Tymoteusz",
	  "Tobiasz",
	  "Walenty",
	  "Walentyn",
	  "Walerian",
	  "Walery",
	  "Wiktor",
	  "Wincenty",
	  "Witalis",
	  "Włodzimierz",
	  "Władysław",
	  "Błażej",
	  "Walter",
	  "Walgierz",
	  "Wacław",
	  "Wilfryd",
	  "Wilhelm",
	  "Ksawery",
	  "Ksenofont",
	  "Jerzy",
	  "Zachariasz",
	  "Zachary",
	  "Ada",
	  "Adelajda",
	  "Agata",
	  "Agnieszka",
	  "Agrypina",
	  "Aida",
	  "Aleksandra",
	  "Alicja",
	  "Alina",
	  "Amanda",
	  "Anastazja",
	  "Angela",
	  "Andżelika",
	  "Angelina",
	  "Anna",
	  "Hanna",
	  "—",
	  "Antonina",
	  "Ariadna",
	  "Aurora",
	  "Barbara",
	  "Beatrycze",
	  "Berta",
	  "Brygida",
	  "Kamila",
	  "Karolina",
	  "Karolina",
	  "Kornelia",
	  "Katarzyna",
	  "Cecylia",
	  "Karolina",
	  "Chloe",
	  "Krystyna",
	  "Klara",
	  "Klaudia",
	  "Klementyna",
	  "Konstancja",
	  "Koralia",
	  "Daria",
	  "Diana",
	  "Dina",
	  "Dorota",
	  "Edyta",
	  "Eleonora",
	  "Eliza",
	  "Elżbieta",
	  "Izabela",
	  "Elwira",
	  "Emilia",
	  "Estera",
	  "Eudoksja",
	  "Eudokia",
	  "Eugenia",
	  "Ewa",
	  "Ewelina",
	  "Ferdynanda",
	  "Florencja",
	  "Franciszka",
	  "Gabriela",
	  "Gertruda",
	  "Gloria",
	  "Gracja",
	  "Jadwiga",
	  "Helena",
	  "Henryka",
	  "Nadzieja",
	  "Ida",
	  "Ilona",
	  "Helena",
	  "Irena",
	  "Irma",
	  "Izabela",
	  "Izolda",
	  "Jakubina",
	  "Joanna",
	  "Janina",
	  "Żaneta",
	  "Joanna",
	  "Ginewra",
	  "Józefina",
	  "Judyta",
	  "Julia",
	  "Julia",
	  "Julita",
	  "Justyna",
	  "Kira",
	  "Cyra",
	  "Kleopatra",
	  "Larysa",
	  "Laura",
	  "Laurencja",
	  "Laurentyna",
	  "Lea",
	  "Leila",
	  "Eleonora",
	  "Liliana",
	  "Lilianna",
	  "Lilia",
	  "Lilla",
	  "Liza",
	  "Eliza",
	  "Laura",
	  "Ludwika",
	  "Luiza",
	  "Łucja",
	  "Lucja",
	  "Lidia",
	  "Amabela",
	  "Magdalena",
	  "Malwina",
	  "Małgorzata",
	  "Greta",
	  "Marianna",
	  "Maryna",
	  "Marta",
	  "Martyna",
	  "Maria",
	  "Matylda",
	  "Maja",
	  "Maja",
	  "Melania",
	  "Michalina",
	  "Monika",
	  "Nadzieja",
	  "Noemi",
	  "Natalia",
	  "Nikola",
	  "Nina",
	  "Olga",
	  "Olimpia",
	  "Oliwia",
	  "Ofelia",
	  "Patrycja",
	  "Paula",
	  "Pelagia",
	  "Penelopa",
	  "Filipa",
	  "Paulina",
	  "Rachela",
	  "Rebeka",
	  "Regina",
	  "Renata",
	  "Rozalia",
	  "Róża",
	  "Roksana",
	  "Rufina",
	  "Ruta",
	  "Sabina",
	  "Sara",
	  "Serafina",
	  "Sybilla",
	  "Sylwia",
	  "Zofia",
	  "Stella",
	  "Stefania",
	  "Zuzanna",
	  "Tamara",
	  "Tacjana",
	  "Tekla",
	  "Teodora",
	  "Teresa",
	  "Walentyna",
	  "Waleria",
	  "Wanesa",
	  "Wiara",
	  "Weronika",
	  "Wiktoria",
	  "Wirginia",
	  "Bibiana",
	  "Bibianna",
	  "Wanda",
	  "Wilhelmina",
	  "Ksawera",
	  "Ksenia",
	  "Zoe"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2600);
	name.last_name = __webpack_require__(2602);
	name.prefix = __webpack_require__(2604);
	name.title = __webpack_require__(2605);
	name.name = __webpack_require__(2603);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adamczak",
	  "Adamczyk",
	  "Adamek",
	  "Adamiak",
	  "Adamiec",
	  "Adamowicz",
	  "Adamski",
	  "Adamus",
	  "Aleksandrowicz",
	  "Andrzejczak",
	  "Andrzejewski",
	  "Antczak",
	  "Augustyn",
	  "Augustyniak",
	  "Bagiński",
	  "Balcerzak",
	  "Banach",
	  "Banasiak",
	  "Banasik",
	  "Banaś",
	  "Baran",
	  "Baranowski",
	  "Barański",
	  "Bartczak",
	  "Bartkowiak",
	  "Bartnik",
	  "Bartosik",
	  "Bednarczyk",
	  "Bednarek",
	  "Bednarski",
	  "Bednarz",
	  "Białas",
	  "Białek",
	  "Białkowski",
	  "Bielak",
	  "Bielawski",
	  "Bielecki",
	  "Bielski",
	  "Bieniek",
	  "Biernacki",
	  "Biernat",
	  "Bieńkowski",
	  "Bilski",
	  "Bober",
	  "Bochenek",
	  "Bogucki",
	  "Bogusz",
	  "Borek",
	  "Borkowski",
	  "Borowiec",
	  "Borowski",
	  "Bożek",
	  "Broda",
	  "Brzeziński",
	  "Brzozowski",
	  "Buczek",
	  "Buczkowski",
	  "Buczyński",
	  "Budziński",
	  "Budzyński",
	  "Bujak",
	  "Bukowski",
	  "Burzyński",
	  "Bąk",
	  "Bąkowski",
	  "Błaszczak",
	  "Błaszczyk",
	  "Cebula",
	  "Chmiel",
	  "Chmielewski",
	  "Chmura",
	  "Chojnacki",
	  "Chojnowski",
	  "Cholewa",
	  "Chrzanowski",
	  "Chudzik",
	  "Cichocki",
	  "Cichoń",
	  "Cichy",
	  "Ciesielski",
	  "Cieśla",
	  "Cieślak",
	  "Cieślik",
	  "Ciszewski",
	  "Cybulski",
	  "Cygan",
	  "Czaja",
	  "Czajka",
	  "Czajkowski",
	  "Czapla",
	  "Czarnecki",
	  "Czech",
	  "Czechowski",
	  "Czekaj",
	  "Czerniak",
	  "Czerwiński",
	  "Czyż",
	  "Czyżewski",
	  "Dec",
	  "Dobosz",
	  "Dobrowolski",
	  "Dobrzyński",
	  "Domagała",
	  "Domański",
	  "Dominiak",
	  "Drabik",
	  "Drozd",
	  "Drozdowski",
	  "Drzewiecki",
	  "Dróżdż",
	  "Dubiel",
	  "Duda",
	  "Dudek",
	  "Dudziak",
	  "Dudzik",
	  "Dudziński",
	  "Duszyński",
	  "Dziedzic",
	  "Dziuba",
	  "Dąbek",
	  "Dąbkowski",
	  "Dąbrowski",
	  "Dębowski",
	  "Dębski",
	  "Długosz",
	  "Falkowski",
	  "Fijałkowski",
	  "Filipek",
	  "Filipiak",
	  "Filipowicz",
	  "Flak",
	  "Flis",
	  "Florczak",
	  "Florek",
	  "Frankowski",
	  "Frąckowiak",
	  "Frączek",
	  "Frątczak",
	  "Furman",
	  "Gadomski",
	  "Gajda",
	  "Gajewski",
	  "Gaweł",
	  "Gawlik",
	  "Gawron",
	  "Gawroński",
	  "Gałka",
	  "Gałązka",
	  "Gil",
	  "Godlewski",
	  "Golec",
	  "Gołąb",
	  "Gołębiewski",
	  "Gołębiowski",
	  "Grabowski",
	  "Graczyk",
	  "Grochowski",
	  "Grudzień",
	  "Gruszczyński",
	  "Gruszka",
	  "Grzegorczyk",
	  "Grzelak",
	  "Grzesiak",
	  "Grzesik",
	  "Grześkowiak",
	  "Grzyb",
	  "Grzybowski",
	  "Grzywacz",
	  "Gutowski",
	  "Guzik",
	  "Gwóźdź",
	  "Góra",
	  "Góral",
	  "Górecki",
	  "Górka",
	  "Górniak",
	  "Górny",
	  "Górski",
	  "Gąsior",
	  "Gąsiorowski",
	  "Głogowski",
	  "Głowacki",
	  "Głąb",
	  "Hajduk",
	  "Herman",
	  "Iwański",
	  "Izdebski",
	  "Jabłoński",
	  "Jackowski",
	  "Jagielski",
	  "Jagiełło",
	  "Jagodziński",
	  "Jakubiak",
	  "Jakubowski",
	  "Janas",
	  "Janiak",
	  "Janicki",
	  "Janik",
	  "Janiszewski",
	  "Jankowiak",
	  "Jankowski",
	  "Janowski",
	  "Janus",
	  "Janusz",
	  "Januszewski",
	  "Jaros",
	  "Jarosz",
	  "Jarząbek",
	  "Jasiński",
	  "Jastrzębski",
	  "Jaworski",
	  "Jaśkiewicz",
	  "Jezierski",
	  "Jurek",
	  "Jurkiewicz",
	  "Jurkowski",
	  "Juszczak",
	  "Jóźwiak",
	  "Jóźwik",
	  "Jędrzejczak",
	  "Jędrzejczyk",
	  "Jędrzejewski",
	  "Kacprzak",
	  "Kaczmarczyk",
	  "Kaczmarek",
	  "Kaczmarski",
	  "Kaczor",
	  "Kaczorowski",
	  "Kaczyński",
	  "Kaleta",
	  "Kalinowski",
	  "Kalisz",
	  "Kamiński",
	  "Kania",
	  "Kaniewski",
	  "Kapusta",
	  "Karaś",
	  "Karczewski",
	  "Karpiński",
	  "Karwowski",
	  "Kasperek",
	  "Kasprzak",
	  "Kasprzyk",
	  "Kaszuba",
	  "Kawa",
	  "Kawecki",
	  "Kałuża",
	  "Kaźmierczak",
	  "Kiełbasa",
	  "Kisiel",
	  "Kita",
	  "Klimczak",
	  "Klimek",
	  "Kmiecik",
	  "Kmieć",
	  "Knapik",
	  "Kobus",
	  "Kogut",
	  "Kolasa",
	  "Komorowski",
	  "Konieczna",
	  "Konieczny",
	  "Konopka",
	  "Kopczyński",
	  "Koper",
	  "Kopeć",
	  "Korzeniowski",
	  "Kos",
	  "Kosiński",
	  "Kosowski",
	  "Kostecki",
	  "Kostrzewa",
	  "Kot",
	  "Kotowski",
	  "Kowal",
	  "Kowalczuk",
	  "Kowalczyk",
	  "Kowalewski",
	  "Kowalik",
	  "Kowalski",
	  "Koza",
	  "Kozak",
	  "Kozieł",
	  "Kozioł",
	  "Kozłowski",
	  "Kołakowski",
	  "Kołodziej",
	  "Kołodziejczyk",
	  "Kołodziejski",
	  "Krajewski",
	  "Krakowiak",
	  "Krawczyk",
	  "Krawiec",
	  "Kruk",
	  "Krukowski",
	  "Krupa",
	  "Krupiński",
	  "Kruszewski",
	  "Krysiak",
	  "Krzemiński",
	  "Krzyżanowski",
	  "Król",
	  "Królikowski",
	  "Książek",
	  "Kubacki",
	  "Kubiak",
	  "Kubica",
	  "Kubicki",
	  "Kubik",
	  "Kuc",
	  "Kucharczyk",
	  "Kucharski",
	  "Kuchta",
	  "Kuciński",
	  "Kuczyński",
	  "Kujawa",
	  "Kujawski",
	  "Kula",
	  "Kulesza",
	  "Kulig",
	  "Kulik",
	  "Kuliński",
	  "Kurek",
	  "Kurowski",
	  "Kuś",
	  "Kwaśniewski",
	  "Kwiatkowski",
	  "Kwiecień",
	  "Kwieciński",
	  "Kędzierski",
	  "Kędziora",
	  "Kępa",
	  "Kłos",
	  "Kłosowski",
	  "Lach",
	  "Laskowski",
	  "Lasota",
	  "Lech",
	  "Lenart",
	  "Lesiak",
	  "Leszczyński",
	  "Lewandowski",
	  "Lewicki",
	  "Leśniak",
	  "Leśniewski",
	  "Lipiński",
	  "Lipka",
	  "Lipski",
	  "Lis",
	  "Lisiecki",
	  "Lisowski",
	  "Maciejewski",
	  "Maciąg",
	  "Mackiewicz",
	  "Madej",
	  "Maj",
	  "Majcher",
	  "Majchrzak",
	  "Majewski",
	  "Majka",
	  "Makowski",
	  "Malec",
	  "Malicki",
	  "Malinowski",
	  "Maliszewski",
	  "Marchewka",
	  "Marciniak",
	  "Marcinkowski",
	  "Marczak",
	  "Marek",
	  "Markiewicz",
	  "Markowski",
	  "Marszałek",
	  "Marzec",
	  "Masłowski",
	  "Matusiak",
	  "Matuszak",
	  "Matuszewski",
	  "Matysiak",
	  "Mazur",
	  "Mazurek",
	  "Mazurkiewicz",
	  "Maćkowiak",
	  "Małecki",
	  "Małek",
	  "Maślanka",
	  "Michalak",
	  "Michalczyk",
	  "Michalik",
	  "Michalski",
	  "Michałek",
	  "Michałowski",
	  "Mielczarek",
	  "Mierzejewski",
	  "Mika",
	  "Mikołajczak",
	  "Mikołajczyk",
	  "Mikulski",
	  "Milczarek",
	  "Milewski",
	  "Miller",
	  "Misiak",
	  "Misztal",
	  "Miśkiewicz",
	  "Modzelewski",
	  "Molenda",
	  "Morawski",
	  "Motyka",
	  "Mroczek",
	  "Mroczkowski",
	  "Mrozek",
	  "Mróz",
	  "Mucha",
	  "Murawski",
	  "Musiał",
	  "Muszyński",
	  "Młynarczyk",
	  "Napierała",
	  "Nawrocki",
	  "Nawrot",
	  "Niedziela",
	  "Niedzielski",
	  "Niedźwiecki",
	  "Niemczyk",
	  "Niemiec",
	  "Niewiadomski",
	  "Noga",
	  "Nowacki",
	  "Nowaczyk",
	  "Nowak",
	  "Nowakowski",
	  "Nowicki",
	  "Nowiński",
	  "Olczak",
	  "Olejniczak",
	  "Olejnik",
	  "Olszewski",
	  "Orzechowski",
	  "Orłowski",
	  "Osiński",
	  "Ossowski",
	  "Ostrowski",
	  "Owczarek",
	  "Paczkowski",
	  "Pająk",
	  "Pakuła",
	  "Paluch",
	  "Panek",
	  "Partyka",
	  "Pasternak",
	  "Paszkowski",
	  "Pawelec",
	  "Pawlak",
	  "Pawlicki",
	  "Pawlik",
	  "Pawlikowski",
	  "Pawłowski",
	  "Pałka",
	  "Piasecki",
	  "Piechota",
	  "Piekarski",
	  "Pietras",
	  "Pietruszka",
	  "Pietrzak",
	  "Pietrzyk",
	  "Pilarski",
	  "Pilch",
	  "Piotrowicz",
	  "Piotrowski",
	  "Piwowarczyk",
	  "Piórkowski",
	  "Piątek",
	  "Piątkowski",
	  "Piłat",
	  "Pluta",
	  "Podgórski",
	  "Polak",
	  "Popławski",
	  "Porębski",
	  "Prokop",
	  "Prus",
	  "Przybylski",
	  "Przybysz",
	  "Przybył",
	  "Przybyła",
	  "Ptak",
	  "Puchalski",
	  "Pytel",
	  "Płonka",
	  "Raczyński",
	  "Radecki",
	  "Radomski",
	  "Rak",
	  "Rakowski",
	  "Ratajczak",
	  "Robak",
	  "Rogala",
	  "Rogalski",
	  "Rogowski",
	  "Rojek",
	  "Romanowski",
	  "Rosa",
	  "Rosiak",
	  "Rosiński",
	  "Ruciński",
	  "Rudnicki",
	  "Rudziński",
	  "Rudzki",
	  "Rusin",
	  "Rutkowski",
	  "Rybak",
	  "Rybarczyk",
	  "Rybicki",
	  "Rzepka",
	  "Różański",
	  "Różycki",
	  "Sadowski",
	  "Sawicki",
	  "Serafin",
	  "Siedlecki",
	  "Sienkiewicz",
	  "Sieradzki",
	  "Sikora",
	  "Sikorski",
	  "Sitek",
	  "Siwek",
	  "Skalski",
	  "Skiba",
	  "Skibiński",
	  "Skoczylas",
	  "Skowron",
	  "Skowronek",
	  "Skowroński",
	  "Skrzypczak",
	  "Skrzypek",
	  "Skóra",
	  "Smoliński",
	  "Sobczak",
	  "Sobczyk",
	  "Sobieraj",
	  "Sobolewski",
	  "Socha",
	  "Sochacki",
	  "Sokołowski",
	  "Sokół",
	  "Sosnowski",
	  "Sowa",
	  "Sowiński",
	  "Sołtys",
	  "Sołtysiak",
	  "Sroka",
	  "Stachowiak",
	  "Stachowicz",
	  "Stachura",
	  "Stachurski",
	  "Stanek",
	  "Staniszewski",
	  "Stanisławski",
	  "Stankiewicz",
	  "Stasiak",
	  "Staszewski",
	  "Stawicki",
	  "Stec",
	  "Stefaniak",
	  "Stefański",
	  "Stelmach",
	  "Stolarczyk",
	  "Stolarski",
	  "Strzelczyk",
	  "Strzelecki",
	  "Stępień",
	  "Stępniak",
	  "Surma",
	  "Suski",
	  "Szafrański",
	  "Szatkowski",
	  "Szczepaniak",
	  "Szczepanik",
	  "Szczepański",
	  "Szczerba",
	  "Szcześniak",
	  "Szczygieł",
	  "Szczęsna",
	  "Szczęsny",
	  "Szeląg",
	  "Szewczyk",
	  "Szostak",
	  "Szulc",
	  "Szwarc",
	  "Szwed",
	  "Szydłowski",
	  "Szymański",
	  "Szymczak",
	  "Szymczyk",
	  "Szymkowiak",
	  "Szyszka",
	  "Sławiński",
	  "Słowik",
	  "Słowiński",
	  "Tarnowski",
	  "Tkaczyk",
	  "Tokarski",
	  "Tomala",
	  "Tomaszewski",
	  "Tomczak",
	  "Tomczyk",
	  "Tracz",
	  "Trojanowski",
	  "Trzciński",
	  "Trzeciak",
	  "Turek",
	  "Twardowski",
	  "Urban",
	  "Urbanek",
	  "Urbaniak",
	  "Urbanowicz",
	  "Urbańczyk",
	  "Urbański",
	  "Walczak",
	  "Walkowiak",
	  "Warchoł",
	  "Wasiak",
	  "Wasilewski",
	  "Wawrzyniak",
	  "Wesołowski",
	  "Wieczorek",
	  "Wierzbicki",
	  "Wilczek",
	  "Wilczyński",
	  "Wilk",
	  "Winiarski",
	  "Witczak",
	  "Witek",
	  "Witkowski",
	  "Wiącek",
	  "Więcek",
	  "Więckowski",
	  "Wiśniewski",
	  "Wnuk",
	  "Wojciechowski",
	  "Wojtas",
	  "Wojtasik",
	  "Wojtczak",
	  "Wojtkowiak",
	  "Wolak",
	  "Woliński",
	  "Wolny",
	  "Wolski",
	  "Woś",
	  "Woźniak",
	  "Wrona",
	  "Wroński",
	  "Wróbel",
	  "Wróblewski",
	  "Wypych",
	  "Wysocki",
	  "Wyszyński",
	  "Wójcicki",
	  "Wójcik",
	  "Wójtowicz",
	  "Wąsik",
	  "Węgrzyn",
	  "Włodarczyk",
	  "Włodarski",
	  "Zaborowski",
	  "Zabłocki",
	  "Zagórski",
	  "Zając",
	  "Zajączkowski",
	  "Zakrzewski",
	  "Zalewski",
	  "Zaremba",
	  "Zarzycki",
	  "Zaręba",
	  "Zawada",
	  "Zawadzki",
	  "Zdunek",
	  "Zieliński",
	  "Zielonka",
	  "Ziółkowski",
	  "Zięba",
	  "Ziętek",
	  "Zwoliński",
	  "Zych",
	  "Zygmunt",
	  "Łapiński",
	  "Łuczak",
	  "Łukasiewicz",
	  "Łukasik",
	  "Łukaszewski",
	  "Śliwa",
	  "Śliwiński",
	  "Ślusarczyk",
	  "Świderski",
	  "Świerczyński",
	  "Świątek",
	  "Żak",
	  "Żebrowski",
	  "Żmuda",
	  "Żuk",
	  "Żukowski",
	  "Żurawski",
	  "Żurek",
	  "Żyła"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pan",
	  "Pani"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "12-###-##-##",
	  "13-###-##-##",
	  "14-###-##-##",
	  "15-###-##-##",
	  "16-###-##-##",
	  "17-###-##-##",
	  "18-###-##-##",
	  "22-###-##-##",
	  "23-###-##-##",
	  "24-###-##-##",
	  "25-###-##-##",
	  "29-###-##-##",
	  "32-###-##-##",
	  "33-###-##-##",
	  "34-###-##-##",
	  "41-###-##-##",
	  "42-###-##-##",
	  "43-###-##-##",
	  "44-###-##-##",
	  "46-###-##-##",
	  "48-###-##-##",
	  "52-###-##-##",
	  "54-###-##-##",
	  "55-###-##-##",
	  "56-###-##-##",
	  "58-###-##-##",
	  "59-###-##-##",
	  "61-###-##-##",
	  "62-###-##-##",
	  "63-###-##-##",
	  "65-###-##-##",
	  "67-###-##-##",
	  "68-###-##-##",
	  "71-###-##-##",
	  "74-###-##-##",
	  "75-###-##-##",
	  "76-###-##-##",
	  "77-###-##-##",
	  "81-###-##-##",
	  "82-###-##-##",
	  "83-###-##-##",
	  "84-###-##-##",
	  "85-###-##-##",
	  "86-###-##-##",
	  "87-###-##-##",
	  "89-###-##-##",
	  "91-###-##-##",
	  "94-###-##-##",
	  "95-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2606);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nova",
	  "Velha",
	  "Grande",
	  "Vila",
	  "Município de"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "do Descoberto",
	  "de Nossa Senhora",
	  "do Norte",
	  "do Sul"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afeganistão",
	  "Albânia",
	  "Algéria",
	  "Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla",
	  "Antigua and Barbada",
	  "Argentina",
	  "Armênia",
	  "Aruba",
	  "Austrália",
	  "Áustria",
	  "Alzerbajão",
	  "Bahamas",
	  "Barém",
	  "Bangladesh",
	  "Barbado",
	  "Belgrado",
	  "Bélgica",
	  "Belize",
	  "Benin",
	  "Bermuda",
	  "Bhutan",
	  "Bolívia",
	  "Bôsnia",
	  "Botuasuna",
	  "Bouvetoia",
	  "Brasil",
	  "Arquipélago de Chagos",
	  "Ilhas Virgens",
	  "Brunei",
	  "Bulgária",
	  "Burkina Faso",
	  "Burundi",
	  "Cambójia",
	  "Camarões",
	  "Canadá",
	  "Cabo Verde",
	  "Ilhas Caiman",
	  "República da África Central",
	  "Chad",
	  "Chile",
	  "China",
	  "Ilhas Natal",
	  "Ilhas Cocos",
	  "Colômbia",
	  "Comoros",
	  "Congo",
	  "Ilhas Cook",
	  "Costa Rica",
	  "Costa do Marfim",
	  "Croácia",
	  "Cuba",
	  "Cyprus",
	  "República Tcheca",
	  "Dinamarca",
	  "Djibouti",
	  "Dominica",
	  "República Dominicana",
	  "Equador",
	  "Egito",
	  "El Salvador",
	  "Guiné Equatorial",
	  "Eritrea",
	  "Estônia",
	  "Etiópia",
	  "Ilhas Faroe",
	  "Malvinas",
	  "Fiji",
	  "Finlândia",
	  "França",
	  "Guiné Francesa",
	  "Polinésia Francesa",
	  "Gabão",
	  "Gâmbia",
	  "Georgia",
	  "Alemanha",
	  "Gana",
	  "Gibraltar",
	  "Grécia",
	  "Groelândia",
	  "Granada",
	  "Guadalupe",
	  "Guano",
	  "Guatemala",
	  "Guernsey",
	  "Guiné",
	  "Guiné-Bissau",
	  "Guiana",
	  "Haiti",
	  "Heard Island and McDonald Islands",
	  "Vaticano",
	  "Honduras",
	  "Hong Kong",
	  "Hungria",
	  "Iceland",
	  "Índia",
	  "Indonésia",
	  "Irã",
	  "Iraque",
	  "Irlanda",
	  "Ilha de Man",
	  "Israel",
	  "Itália",
	  "Jamaica",
	  "Japão",
	  "Jersey",
	  "Jordânia",
	  "Cazaquistão",
	  "Quênia",
	  "Kiribati",
	  "Coreia do Norte",
	  "Coreia do Sul",
	  "Kuwait",
	  "Kyrgyz Republic",
	  "República Democrática de Lao People",
	  "Latvia",
	  "Líbano",
	  "Lesotho",
	  "Libéria",
	  "Libyan Arab Jamahiriya",
	  "Liechtenstein",
	  "Lituânia",
	  "Luxemburgo",
	  "Macao",
	  "Macedônia",
	  "Madagascar",
	  "Malawi",
	  "Malásia",
	  "Maldives",
	  "Mali",
	  "Malta",
	  "Ilhas Marshall",
	  "Martinica",
	  "Mauritânia",
	  "Mauritius",
	  "Mayotte",
	  "México",
	  "Micronésia",
	  "Moldova",
	  "Mônaco",
	  "Mongólia",
	  "Montenegro",
	  "Montserrat",
	  "Marrocos",
	  "Moçambique",
	  "Myanmar",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Antilhas Holandesas",
	  "Holanda",
	  "Nova Caledonia",
	  "Nova Zelândia",
	  "Nicarágua",
	  "Nigéria",
	  "Niue",
	  "Ilha Norfolk",
	  "Northern Mariana Islands",
	  "Noruega",
	  "Oman",
	  "Paquistão",
	  "Palau",
	  "Território da Palestina",
	  "Panamá",
	  "Nova Guiné Papua",
	  "Paraguai",
	  "Peru",
	  "Filipinas",
	  "Polônia",
	  "Portugal",
	  "Puerto Rico",
	  "Qatar",
	  "Romênia",
	  "Rússia",
	  "Ruanda",
	  "São Bartolomeu",
	  "Santa Helena",
	  "Santa Lúcia",
	  "Saint Martin",
	  "Saint Pierre and Miquelon",
	  "Saint Vincent and the Grenadines",
	  "Samoa",
	  "San Marino",
	  "Sao Tomé e Príncipe",
	  "Arábia Saudita",
	  "Senegal",
	  "Sérvia",
	  "Seychelles",
	  "Serra Leoa",
	  "Singapura",
	  "Eslováquia",
	  "Eslovênia",
	  "Ilhas Salomão",
	  "Somália",
	  "África do Sul",
	  "South Georgia and the South Sandwich Islands",
	  "Spanha",
	  "Sri Lanka",
	  "Sudão",
	  "Suriname",
	  "Svalbard & Jan Mayen Islands",
	  "Swaziland",
	  "Suécia",
	  "Suíça",
	  "Síria",
	  "Taiwan",
	  "Tajiquistão",
	  "Tanzânia",
	  "Tailândia",
	  "Timor-Leste",
	  "Togo",
	  "Tokelau",
	  "Tonga",
	  "Trinidá e Tobago",
	  "Tunísia",
	  "Turquia",
	  "Turcomenistão",
	  "Turks and Caicos Islands",
	  "Tuvalu",
	  "Uganda",
	  "Ucrânia",
	  "Emirados Árabes Unidos",
	  "Reino Unido",
	  "Estados Unidos da América",
	  "Estados Unidos das Ilhas Virgens",
	  "Uruguai",
	  "Uzbequistão",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnã",
	  "Wallis and Futuna",
	  "Sahara",
	  "Yemen",
	  "Zâmbia",
	  "Zimbábue"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Brasil"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2609);
	address.city_suffix = __webpack_require__(2610);
	address.country = __webpack_require__(2611);
	address.building_number = __webpack_require__(2608);
	address.street_suffix = __webpack_require__(2618);
	address.secondary_address = __webpack_require__(2615);
	address.postcode = __webpack_require__(2614);
	address.state = __webpack_require__(2616);
	address.state_abbr = __webpack_require__(2617);
	address.default_country = __webpack_require__(2612);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "#####-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apto. ###",
	  "Sobrado ##",
	  "Casa #",
	  "Lote ##",
	  "Quadra ##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Acre",
	  "Alagoas",
	  "Amapá",
	  "Amazonas",
	  "Bahia",
	  "Ceará",
	  "Distrito Federal",
	  "Espírito Santo",
	  "Goiás",
	  "Maranhão",
	  "Mato Grosso",
	  "Mato Grosso do Sul",
	  "Minas Gerais",
	  "Pará",
	  "Paraíba",
	  "Paraná",
	  "Pernambuco",
	  "Piauí",
	  "Rio de Janeiro",
	  "Rio Grande do Norte",
	  "Rio Grande do Sul",
	  "Rondônia",
	  "Roraima",
	  "Santa Catarina",
	  "São Paulo",
	  "Sergipe",
	  "Tocantins"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "AC",
	  "AL",
	  "AP",
	  "AM",
	  "BA",
	  "CE",
	  "DF",
	  "ES",
	  "GO",
	  "MA",
	  "MT",
	  "MS",
	  "PA",
	  "PB",
	  "PR",
	  "PE",
	  "PI",
	  "RJ",
	  "RN",
	  "RS",
	  "RO",
	  "RR",
	  "SC",
	  "SP"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Rua",
	  "Avenida",
	  "Travessa",
	  "Ponte",
	  "Alameda",
	  "Marginal",
	  "Viela",
	  "Rodovia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2621);
	company.name = __webpack_require__(2620);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} e #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "S.A.",
	  "LTDA",
	  "e Associados",
	  "Comércio"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var pt_BR = {};
	module['exports'] = pt_BR;
	pt_BR.title = "Portuguese (Brazil)";
	pt_BR.address = __webpack_require__(2613);
	pt_BR.company = __webpack_require__(2619);
	pt_BR.internet = __webpack_require__(2625);
	pt_BR.lorem = __webpack_require__(2626);
	pt_BR.name = __webpack_require__(2629);
	pt_BR.phone_number = __webpack_require__(2634);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "br",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com",
	  "live.com",
	  "bol.com.br"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2624);
	internet.domain_suffix = __webpack_require__(2623);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2627);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alessandro",
	  "Alessandra",
	  "Alexandre",
	  "Aline",
	  "Antônio",
	  "Breno",
	  "Bruna",
	  "Carlos",
	  "Carla",
	  "Célia",
	  "Cecília",
	  "César",
	  "Danilo",
	  "Dalila",
	  "Deneval",
	  "Eduardo",
	  "Eduarda",
	  "Esther",
	  "Elísio",
	  "Fábio",
	  "Fabrício",
	  "Fabrícia",
	  "Félix",
	  "Felícia",
	  "Feliciano",
	  "Frederico",
	  "Fabiano",
	  "Gustavo",
	  "Guilherme",
	  "Gúbio",
	  "Heitor",
	  "Hélio",
	  "Hugo",
	  "Isabel",
	  "Isabela",
	  "Ígor",
	  "João",
	  "Joana",
	  "Júlio César",
	  "Júlio",
	  "Júlia",
	  "Janaína",
	  "Karla",
	  "Kléber",
	  "Lucas",
	  "Lorena",
	  "Lorraine",
	  "Larissa",
	  "Ladislau",
	  "Marcos",
	  "Meire",
	  "Marcelo",
	  "Marcela",
	  "Margarida",
	  "Mércia",
	  "Márcia",
	  "Marli",
	  "Morgana",
	  "Maria",
	  "Norberto",
	  "Natália",
	  "Nataniel",
	  "Núbia",
	  "Ofélia",
	  "Paulo",
	  "Paula",
	  "Pablo",
	  "Pedro",
	  "Raul",
	  "Rafael",
	  "Rafaela",
	  "Ricardo",
	  "Roberto",
	  "Roberta",
	  "Sílvia",
	  "Sílvia",
	  "Silas",
	  "Suélen",
	  "Sara",
	  "Salvador",
	  "Sirineu",
	  "Talita",
	  "Tertuliano",
	  "Vicente",
	  "Víctor",
	  "Vitória",
	  "Yango",
	  "Yago",
	  "Yuri",
	  "Washington",
	  "Warley"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2628);
	name.last_name = __webpack_require__(2630);
	name.prefix = __webpack_require__(2631);
	name.suffix = __webpack_require__(2632);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Silva",
	  "Souza",
	  "Carvalho",
	  "Santos",
	  "Reis",
	  "Xavier",
	  "Franco",
	  "Braga",
	  "Macedo",
	  "Batista",
	  "Barros",
	  "Moraes",
	  "Costa",
	  "Pereira",
	  "Carvalho",
	  "Melo",
	  "Saraiva",
	  "Nogueira",
	  "Oliveira",
	  "Martins",
	  "Moreira",
	  "Albuquerque"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sr.",
	  "Sra.",
	  "Srta.",
	  "Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Jr.",
	  "Neto",
	  "Filho"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(##) ####-####",
	  "+55 (##) ####-####",
	  "(##) #####-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2633);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Москва",
	  "Владимир",
	  "Санкт-Петербург",
	  "Новосибирск",
	  "Екатеринбург",
	  "Нижний Новгород",
	  "Самара",
	  "Казань",
	  "Омск",
	  "Челябинск",
	  "Ростов-на-Дону",
	  "Уфа",
	  "Волгоград",
	  "Пермь",
	  "Красноярск",
	  "Воронеж",
	  "Саратов",
	  "Краснодар",
	  "Тольятти",
	  "Ижевск",
	  "Барнаул",
	  "Ульяновск",
	  "Тюмень",
	  "Иркутск",
	  "Владивосток",
	  "Ярославль",
	  "Хабаровск",
	  "Махачкала",
	  "Оренбург",
	  "Новокузнецк",
	  "Томск",
	  "Кемерово",
	  "Рязань",
	  "Астрахань",
	  "Пенза",
	  "Липецк",
	  "Тула",
	  "Киров",
	  "Чебоксары",
	  "Курск",
	  "Брянскm Магнитогорск",
	  "Иваново",
	  "Тверь",
	  "Ставрополь",
	  "Белгород",
	  "Сочи"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Австралия",
	  "Австрия",
	  "Азербайджан",
	  "Албания",
	  "Алжир",
	  "Американское Самоа (не признана)",
	  "Ангилья",
	  "Ангола",
	  "Андорра",
	  "Антарктика (не признана)",
	  "Антигуа и Барбуда",
	  "Антильские Острова (не признана)",
	  "Аомынь (не признана)",
	  "Аргентина",
	  "Армения",
	  "Афганистан",
	  "Багамские Острова",
	  "Бангладеш",
	  "Барбадос",
	  "Бахрейн",
	  "Беларусь",
	  "Белиз",
	  "Бельгия",
	  "Бенин",
	  "Болгария",
	  "Боливия",
	  "Босния и Герцеговина",
	  "Ботсвана",
	  "Бразилия",
	  "Бруней",
	  "Буркина-Фасо",
	  "Бурунди",
	  "Бутан",
	  "Вануату",
	  "Ватикан",
	  "Великобритания",
	  "Венгрия",
	  "Венесуэла",
	  "Восточный Тимор",
	  "Вьетнам",
	  "Габон",
	  "Гаити",
	  "Гайана",
	  "Гамбия",
	  "Гана",
	  "Гваделупа (не признана)",
	  "Гватемала",
	  "Гвиана (не признана)",
	  "Гвинея",
	  "Гвинея-Бисау",
	  "Германия",
	  "Гондурас",
	  "Гренада",
	  "Греция",
	  "Грузия",
	  "Дания",
	  "Джибути",
	  "Доминика",
	  "Доминиканская Республика",
	  "Египет",
	  "Замбия",
	  "Зимбабве",
	  "Израиль",
	  "Индия",
	  "Индонезия",
	  "Иордания",
	  "Ирак",
	  "Иран",
	  "Ирландия",
	  "Исландия",
	  "Испания",
	  "Италия",
	  "Йемен",
	  "Кабо-Верде",
	  "Казахстан",
	  "Камбоджа",
	  "Камерун",
	  "Канада",
	  "Катар",
	  "Кения",
	  "Кипр",
	  "Кирибати",
	  "Китай",
	  "Колумбия",
	  "Коморские Острова",
	  "Конго",
	  "Демократическая Республика",
	  "Корея (Северная)",
	  "Корея (Южная)",
	  "Косово",
	  "Коста-Рика",
	  "Кот-д'Ивуар",
	  "Куба",
	  "Кувейт",
	  "Кука острова",
	  "Кыргызстан",
	  "Лаос",
	  "Латвия",
	  "Лесото",
	  "Либерия",
	  "Ливан",
	  "Ливия",
	  "Литва",
	  "Лихтенштейн",
	  "Люксембург",
	  "Маврикий",
	  "Мавритания",
	  "Мадагаскар",
	  "Македония",
	  "Малави",
	  "Малайзия",
	  "Мали",
	  "Мальдивы",
	  "Мальта",
	  "Маршалловы Острова",
	  "Мексика",
	  "Микронезия",
	  "Мозамбик",
	  "Молдова",
	  "Монако",
	  "Монголия",
	  "Марокко",
	  "Мьянма",
	  "Намибия",
	  "Науру",
	  "Непал",
	  "Нигер",
	  "Нигерия",
	  "Нидерланды",
	  "Никарагуа",
	  "Новая Зеландия",
	  "Норвегия",
	  "Объединенные Арабские Эмираты",
	  "Оман",
	  "Пакистан",
	  "Палау",
	  "Панама",
	  "Папуа — Новая Гвинея",
	  "Парагвай",
	  "Перу",
	  "Польша",
	  "Португалия",
	  "Республика Конго",
	  "Россия",
	  "Руанда",
	  "Румыния",
	  "Сальвадор",
	  "Самоа",
	  "Сан-Марино",
	  "Сан-Томе и Принсипи",
	  "Саудовская Аравия",
	  "Свазиленд",
	  "Сейшельские острова",
	  "Сенегал",
	  "Сент-Винсент и Гренадины",
	  "Сент-Киттс и Невис",
	  "Сент-Люсия",
	  "Сербия",
	  "Сингапур",
	  "Сирия",
	  "Словакия",
	  "Словения",
	  "Соединенные Штаты Америки",
	  "Соломоновы Острова",
	  "Сомали",
	  "Судан",
	  "Суринам",
	  "Сьерра-Леоне",
	  "Таджикистан",
	  "Таиланд",
	  "Тайвань (не признана)",
	  "Тамил-Илам (не признана)",
	  "Танзания",
	  "Тёркс и Кайкос (не признана)",
	  "Того",
	  "Токелау (не признана)",
	  "Тонга",
	  "Тринидад и Тобаго",
	  "Тувалу",
	  "Тунис",
	  "Турецкая Республика Северного Кипра (не признана)",
	  "Туркменистан",
	  "Турция",
	  "Уганда",
	  "Узбекистан",
	  "Украина",
	  "Уругвай",
	  "Фарерские Острова (не признана)",
	  "Фиджи",
	  "Филиппины",
	  "Финляндия",
	  "Франция",
	  "Французская Полинезия (не признана)",
	  "Хорватия",
	  "Центральноафриканская Республика",
	  "Чад",
	  "Черногория",
	  "Чехия",
	  "Чили",
	  "Швейцария",
	  "Швеция",
	  "Шри-Ланка",
	  "Эквадор",
	  "Экваториальная Гвинея",
	  "Эритрея",
	  "Эстония",
	  "Эфиопия",
	  "Южно-Африканская Республика",
	  "Ямайка",
	  "Япония"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Россия"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(2638);
	address.building_number = __webpack_require__(2635);
	address.street_suffix = __webpack_require__(2646);
	address.secondary_address = __webpack_require__(2642);
	address.postcode = __webpack_require__(2641);
	address.state = __webpack_require__(2643);
	address.street_title = __webpack_require__(2647);
	address.city_name = __webpack_require__(2637);
	address.city = __webpack_require__(2636);
	address.street_name = __webpack_require__(2645);
	address.street_address = __webpack_require__(2644);
	address.default_country = __webpack_require__(2639);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "кв. ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Республика Адыгея",
	  "Республика Башкортостан",
	  "Республика Бурятия",
	  "Республика Алтай Республика Дагестан",
	  "Республика Ингушетия",
	  "Кабардино-Балкарская Республика",
	  "Республика Калмыкия",
	  "Республика Карачаево-Черкессия",
	  "Республика Карелия",
	  "Республика Коми",
	  "Республика Марий Эл",
	  "Республика Мордовия",
	  "Республика Саха (Якутия)",
	  "Республика Северная Осетия-Алания",
	  "Республика Татарстан",
	  "Республика Тыва",
	  "Удмуртская Республика",
	  "Республика Хакасия",
	  "Чувашская Республика",
	  "Алтайский край",
	  "Краснодарский край",
	  "Красноярский край",
	  "Приморский край",
	  "Ставропольский край",
	  "Хабаровский край",
	  "Амурская область",
	  "Архангельская область",
	  "Астраханская область",
	  "Белгородская область",
	  "Брянская область",
	  "Владимирская область",
	  "Волгоградская область",
	  "Вологодская область",
	  "Воронежская область",
	  "Ивановская область",
	  "Иркутская область",
	  "Калиниградская область",
	  "Калужская область",
	  "Камчатская область",
	  "Кемеровская область",
	  "Кировская область",
	  "Костромская область",
	  "Курганская область",
	  "Курская область",
	  "Ленинградская область",
	  "Липецкая область",
	  "Магаданская область",
	  "Московская область",
	  "Мурманская область",
	  "Нижегородская область",
	  "Новгородская область",
	  "Новосибирская область",
	  "Омская область",
	  "Оренбургская область",
	  "Орловская область",
	  "Пензенская область",
	  "Пермская область",
	  "Псковская область",
	  "Ростовская область",
	  "Рязанская область",
	  "Самарская область",
	  "Саратовская область",
	  "Сахалинская область",
	  "Свердловская область",
	  "Смоленская область",
	  "Тамбовская область",
	  "Тверская область",
	  "Томская область",
	  "Тульская область",
	  "Тюменская область",
	  "Ульяновская область",
	  "Челябинская область",
	  "Читинская область",
	  "Ярославская область",
	  "Еврейская автономная область",
	  "Агинский Бурятский авт. округ",
	  "Коми-Пермяцкий автономный округ",
	  "Корякский автономный округ",
	  "Ненецкий автономный округ",
	  "Таймырский (Долгано-Ненецкий) автономный округ",
	  "Усть-Ордынский Бурятский автономный округ",
	  "Ханты-Мансийский автономный округ",
	  "Чукотский автономный округ",
	  "Эвенкийский автономный округ",
	  "Ямало-Ненецкий автономный округ",
	  "Чеченская Республика"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}, #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_suffix} #{Address.street_title}",
	  "#{Address.street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ул.",
	  "улица",
	  "проспект",
	  "пр.",
	  "площадь",
	  "пл."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Советская",
	  "Молодежная",
	  "Центральная",
	  "Школьная",
	  "Новая",
	  "Садовая",
	  "Лесная",
	  "Набережная",
	  "Ленина",
	  "Мира",
	  "Октябрьская",
	  "Зеленая",
	  "Комсомольская",
	  "Заречная",
	  "Первомайская",
	  "Гагарина",
	  "Полевая",
	  "Луговая",
	  "Пионерская",
	  "Кирова",
	  "Юбилейная",
	  "Северная",
	  "Пролетарская",
	  "Степная",
	  "Пушкина",
	  "Калинина",
	  "Южная",
	  "Колхозная",
	  "Рабочая",
	  "Солнечная",
	  "Железнодорожная",
	  "Восточная",
	  "Заводская",
	  "Чапаева",
	  "Нагорная",
	  "Строителей",
	  "Береговая",
	  "Победы",
	  "Горького",
	  "Кооперативная",
	  "Красноармейская",
	  "Совхозная",
	  "Речная",
	  "Школьный",
	  "Спортивная",
	  "Озерная",
	  "Строительная",
	  "Парковая",
	  "Чкалова",
	  "Мичурина",
	  "речень улиц",
	  "Подгорная",
	  "Дружбы",
	  "Почтовая",
	  "Партизанская",
	  "Вокзальная",
	  "Лермонтова",
	  "Свободы",
	  "Дорожная",
	  "Дачная",
	  "Маяковского",
	  "Западная",
	  "Фрунзе",
	  "Дзержинского",
	  "Московская",
	  "Свердлова",
	  "Некрасова",
	  "Гоголя",
	  "Красная",
	  "Трудовая",
	  "Шоссейная",
	  "Чехова",
	  "Коммунистическая",
	  "Труда",
	  "Комарова",
	  "Матросова",
	  "Островского",
	  "Сосновая",
	  "Клубная",
	  "Куйбышева",
	  "Крупской",
	  "Березовая",
	  "Карла Маркса",
	  "8 Марта",
	  "Больничная",
	  "Садовый",
	  "Интернациональная",
	  "Суворова",
	  "Цветочная",
	  "Трактовая",
	  "Ломоносова",
	  "Горная",
	  "Космонавтов",
	  "Энергетиков",
	  "Шевченко",
	  "Весенняя",
	  "Механизаторов",
	  "Коммунальная",
	  "Лесной",
	  "40 лет Победы",
	  "Майская"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "красный",
	  "зеленый",
	  "синий",
	  "желтый",
	  "багровый",
	  "мятный",
	  "зеленовато-голубой",
	  "белый",
	  "черный",
	  "оранжевый",
	  "розовый",
	  "серый",
	  "красно-коричневый",
	  "фиолетовый",
	  "бирюзовый",
	  "желто-коричневый",
	  "небесно голубой",
	  "оранжево-розовый",
	  "темно-фиолетовый",
	  "орхидный",
	  "оливковый",
	  "пурпурный",
	  "лимонный",
	  "кремовый",
	  "сине-фиолетовый",
	  "золотой",
	  "красно-пурпурный",
	  "голубой",
	  "лазурный",
	  "лиловый",
	  "серебряный"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Книги",
	  "Фильмы",
	  "музыка",
	  "игры",
	  "Электроника",
	  "компьютеры",
	  "Дом",
	  "садинструмент",
	  "Бакалея",
	  "здоровье",
	  "красота",
	  "Игрушки",
	  "детское",
	  "для малышей",
	  "Одежда",
	  "обувь",
	  "украшения",
	  "Спорт",
	  "туризм",
	  "Автомобильное",
	  "промышленное"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(2648);
	commerce.department = __webpack_require__(2649);
	commerce.product_name = __webpack_require__(2651);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Маленький",
	    "Эргономичный",
	    "Грубый",
	    "Интеллектуальный",
	    "Великолепный",
	    "Невероятный",
	    "Фантастический",
	    "Практчиный",
	    "Лоснящийся",
	    "Потрясающий"
	  ],
	  "material": [
	    "Стальной",
	    "Деревянный",
	    "Бетонный",
	    "Пластиковый",
	    "Хлопковый",
	    "Гранитный",
	    "Резиновый"
	  ],
	  "product": [
	    "Стул",
	    "Автомобиль",
	    "Компьютер",
	    "Берет",
	    "Кулон",
	    "Стол",
	    "Свитер",
	    "Ремень",
	    "Ботинок"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(2654);
	company.suffix = __webpack_require__(2655);
	company.name = __webpack_require__(2653);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.female_first_name}",
	  "#{prefix} #{Name.male_first_name}",
	  "#{prefix} #{Name.male_last_name}",
	  "#{prefix} #{suffix}#{suffix}",
	  "#{prefix} #{suffix}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}#{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ИП",
	  "ООО",
	  "ЗАО",
	  "ОАО",
	  "НКО",
	  "ТСЖ",
	  "ОП"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Снаб",
	  "Торг",
	  "Пром",
	  "Трейд",
	  "Сбыт"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(2657);
	date.weekday = __webpack_require__(2658);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/ru.xml#L1734
	module["exports"] = {
	  wide: [
	    "январь",
	    "февраль",
	    "март",
	    "апрель",
	    "май",
	    "июнь",
	    "июль",
	    "август",
	    "сентябрь",
	    "октябрь",
	    "ноябрь",
	    "декабрь"
	  ],
	  wide_context: [
	    "января",
	    "февраля",
	    "марта",
	    "апреля",
	    "мая",
	    "июня",
	    "июля",
	    "августа",
	    "сентября",
	    "октября",
	    "ноября",
	    "декабря"
	  ],
	  abbr: [
	    "янв.",
	    "февр.",
	    "март",
	    "апр.",
	    "май",
	    "июнь",
	    "июль",
	    "авг.",
	    "сент.",
	    "окт.",
	    "нояб.",
	    "дек."
	  ],
	  abbr_context: [
	    "янв.",
	    "февр.",
	    "марта",
	    "апр.",
	    "мая",
	    "июня",
	    "июля",
	    "авг.",
	    "сент.",
	    "окт.",
	    "нояб.",
	    "дек."
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/ru.xml#L1825
	module["exports"] = {
	  wide: [
	    "Воскресенье",
	    "Понедельник",
	    "Вторник",
	    "Среда",
	    "Четверг",
	    "Пятница",
	    "Суббота"
	  ],
	  wide_context: [
	    "воскресенье",
	    "понедельник",
	    "вторник",
	    "среда",
	    "четверг",
	    "пятница",
	    "суббота"
	  ],
	  abbr: [
	    "Вс",
	    "Пн",
	    "Вт",
	    "Ср",
	    "Чт",
	    "Пт",
	    "Сб"
	  ],
	  abbr_context: [
	    "вс",
	    "пн",
	    "вт",
	    "ср",
	    "чт",
	    "пт",
	    "сб"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var ru = {};
	module['exports'] = ru;
	ru.title = "Russian";
	ru.separator = " и ";
	ru.address = __webpack_require__(2640);
	ru.internet = __webpack_require__(2662);
	ru.name = __webpack_require__(2666);
	ru.phone_number = __webpack_require__(2674);
	ru.commerce = __webpack_require__(2650);
	ru.company = __webpack_require__(2652);
	ru.date = __webpack_require__(2656);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "ru",
	  "info",
	  "рф",
	  "net",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "yandex.ru",
	  "ya.ru",
	  "mail.ru",
	  "gmail.com",
	  "yahoo.com",
	  "hotmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2661);
	internet.domain_suffix = __webpack_require__(2660);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Анна",
	  "Алёна",
	  "Алевтина",
	  "Александра",
	  "Алина",
	  "Алла",
	  "Анастасия",
	  "Ангелина",
	  "Анжела",
	  "Анжелика",
	  "Антонида",
	  "Антонина",
	  "Анфиса",
	  "Арина",
	  "Валентина",
	  "Валерия",
	  "Варвара",
	  "Василиса",
	  "Вера",
	  "Вероника",
	  "Виктория",
	  "Галина",
	  "Дарья",
	  "Евгения",
	  "Екатерина",
	  "Елена",
	  "Елизавета",
	  "Жанна",
	  "Зинаида",
	  "Зоя",
	  "Ирина",
	  "Кира",
	  "Клавдия",
	  "Ксения",
	  "Лариса",
	  "Лидия",
	  "Любовь",
	  "Людмила",
	  "Маргарита",
	  "Марина",
	  "Мария",
	  "Надежда",
	  "Наталья",
	  "Нина",
	  "Оксана",
	  "Ольга",
	  "Раиса",
	  "Регина",
	  "Римма",
	  "Светлана",
	  "София",
	  "Таисия",
	  "Тамара",
	  "Татьяна",
	  "Ульяна",
	  "Юлия"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Смирнова",
	  "Иванова",
	  "Кузнецова",
	  "Попова",
	  "Соколова",
	  "Лебедева",
	  "Козлова",
	  "Новикова",
	  "Морозова",
	  "Петрова",
	  "Волкова",
	  "Соловьева",
	  "Васильева",
	  "Зайцева",
	  "Павлова",
	  "Семенова",
	  "Голубева",
	  "Виноградова",
	  "Богданова",
	  "Воробьева",
	  "Федорова",
	  "Михайлова",
	  "Беляева",
	  "Тарасова",
	  "Белова",
	  "Комарова",
	  "Орлова",
	  "Киселева",
	  "Макарова",
	  "Андреева",
	  "Ковалева",
	  "Ильина",
	  "Гусева",
	  "Титова",
	  "Кузьмина",
	  "Кудрявцева",
	  "Баранова",
	  "Куликова",
	  "Алексеева",
	  "Степанова",
	  "Яковлева",
	  "Сорокина",
	  "Сергеева",
	  "Романова",
	  "Захарова",
	  "Борисова",
	  "Королева",
	  "Герасимова",
	  "Пономарева",
	  "Григорьева",
	  "Лазарева",
	  "Медведева",
	  "Ершова",
	  "Никитина",
	  "Соболева",
	  "Рябова",
	  "Полякова",
	  "Цветкова",
	  "Данилова",
	  "Жукова",
	  "Фролова",
	  "Журавлева",
	  "Николаева",
	  "Крылова",
	  "Максимова",
	  "Сидорова",
	  "Осипова",
	  "Белоусова",
	  "Федотова",
	  "Дорофеева",
	  "Егорова",
	  "Матвеева",
	  "Боброва",
	  "Дмитриева",
	  "Калинина",
	  "Анисимова",
	  "Петухова",
	  "Антонова",
	  "Тимофеева",
	  "Никифорова",
	  "Веселова",
	  "Филиппова",
	  "Маркова",
	  "Большакова",
	  "Суханова",
	  "Миронова",
	  "Ширяева",
	  "Александрова",
	  "Коновалова",
	  "Шестакова",
	  "Казакова",
	  "Ефимова",
	  "Денисова",
	  "Громова",
	  "Фомина",
	  "Давыдова",
	  "Мельникова",
	  "Щербакова",
	  "Блинова",
	  "Колесникова",
	  "Карпова",
	  "Афанасьева",
	  "Власова",
	  "Маслова",
	  "Исакова",
	  "Тихонова",
	  "Аксенова",
	  "Гаврилова",
	  "Родионова",
	  "Котова",
	  "Горбунова",
	  "Кудряшова",
	  "Быкова",
	  "Зуева",
	  "Третьякова",
	  "Савельева",
	  "Панова",
	  "Рыбакова",
	  "Суворова",
	  "Абрамова",
	  "Воронова",
	  "Мухина",
	  "Архипова",
	  "Трофимова",
	  "Мартынова",
	  "Емельянова",
	  "Горшкова",
	  "Чернова",
	  "Овчинникова",
	  "Селезнева",
	  "Панфилова",
	  "Копылова",
	  "Михеева",
	  "Галкина",
	  "Назарова",
	  "Лобанова",
	  "Лукина",
	  "Белякова",
	  "Потапова",
	  "Некрасова",
	  "Хохлова",
	  "Жданова",
	  "Наумова",
	  "Шилова",
	  "Воронцова",
	  "Ермакова",
	  "Дроздова",
	  "Игнатьева",
	  "Савина",
	  "Логинова",
	  "Сафонова",
	  "Капустина",
	  "Кириллова",
	  "Моисеева",
	  "Елисеева",
	  "Кошелева",
	  "Костина",
	  "Горбачева",
	  "Орехова",
	  "Ефремова",
	  "Исаева",
	  "Евдокимова",
	  "Калашникова",
	  "Кабанова",
	  "Носкова",
	  "Юдина",
	  "Кулагина",
	  "Лапина",
	  "Прохорова",
	  "Нестерова",
	  "Харитонова",
	  "Агафонова",
	  "Муравьева",
	  "Ларионова",
	  "Федосеева",
	  "Зимина",
	  "Пахомова",
	  "Шубина",
	  "Игнатова",
	  "Филатова",
	  "Крюкова",
	  "Рогова",
	  "Кулакова",
	  "Терентьева",
	  "Молчанова",
	  "Владимирова",
	  "Артемьева",
	  "Гурьева",
	  "Зиновьева",
	  "Гришина",
	  "Кононова",
	  "Дементьева",
	  "Ситникова",
	  "Симонова",
	  "Мишина",
	  "Фадеева",
	  "Комиссарова",
	  "Мамонтова",
	  "Носова",
	  "Гуляева",
	  "Шарова",
	  "Устинова",
	  "Вишнякова",
	  "Евсеева",
	  "Лаврентьева",
	  "Брагина",
	  "Константинова",
	  "Корнилова",
	  "Авдеева",
	  "Зыкова",
	  "Бирюкова",
	  "Шарапова",
	  "Никонова",
	  "Щукина",
	  "Дьячкова",
	  "Одинцова",
	  "Сазонова",
	  "Якушева",
	  "Красильникова",
	  "Гордеева",
	  "Самойлова",
	  "Князева",
	  "Беспалова",
	  "Уварова",
	  "Шашкова",
	  "Бобылева",
	  "Доронина",
	  "Белозерова",
	  "Рожкова",
	  "Самсонова",
	  "Мясникова",
	  "Лихачева",
	  "Бурова",
	  "Сысоева",
	  "Фомичева",
	  "Русакова",
	  "Стрелкова",
	  "Гущина",
	  "Тетерина",
	  "Колобова",
	  "Субботина",
	  "Фокина",
	  "Блохина",
	  "Селиверстова",
	  "Пестова",
	  "Кондратьева",
	  "Силина",
	  "Меркушева",
	  "Лыткина",
	  "Турова"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александровна",
	  "Алексеевна",
	  "Альбертовна",
	  "Анатольевна",
	  "Андреевна",
	  "Антоновна",
	  "Аркадьевна",
	  "Арсеньевна",
	  "Артёмовна",
	  "Борисовна",
	  "Вадимовна",
	  "Валентиновна",
	  "Валерьевна",
	  "Васильевна",
	  "Викторовна",
	  "Витальевна",
	  "Владимировна",
	  "Владиславовна",
	  "Вячеславовна",
	  "Геннадьевна",
	  "Георгиевна",
	  "Германовна",
	  "Григорьевна",
	  "Данииловна",
	  "Денисовна",
	  "Дмитриевна",
	  "Евгеньевна",
	  "Егоровна",
	  "Ивановна",
	  "Игнатьевна",
	  "Игоревна",
	  "Ильинична",
	  "Константиновна",
	  "Лаврентьевна",
	  "Леонидовна",
	  "Макаровна",
	  "Максимовна",
	  "Матвеевна",
	  "Михайловна",
	  "Никитична",
	  "Николаевна",
	  "Олеговна",
	  "Романовна",
	  "Семёновна",
	  "Сергеевна",
	  "Станиславовна",
	  "Степановна",
	  "Фёдоровна",
	  "Эдуардовна",
	  "Юрьевна",
	  "Ярославовна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(2667);
	name.male_middle_name = __webpack_require__(2669);
	name.male_last_name = __webpack_require__(2668);
	name.female_first_name = __webpack_require__(2663);
	name.female_middle_name = __webpack_require__(2665);
	name.female_last_name = __webpack_require__(2664);
	name.prefix = __webpack_require__(2671);
	name.suffix = __webpack_require__(2672);
	name.name = __webpack_require__(2670);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александр",
	  "Алексей",
	  "Альберт",
	  "Анатолий",
	  "Андрей",
	  "Антон",
	  "Аркадий",
	  "Арсений",
	  "Артём",
	  "Борис",
	  "Вадим",
	  "Валентин",
	  "Валерий",
	  "Василий",
	  "Виктор",
	  "Виталий",
	  "Владимир",
	  "Владислав",
	  "Вячеслав",
	  "Геннадий",
	  "Георгий",
	  "Герман",
	  "Григорий",
	  "Даниил",
	  "Денис",
	  "Дмитрий",
	  "Евгений",
	  "Егор",
	  "Иван",
	  "Игнатий",
	  "Игорь",
	  "Илья",
	  "Константин",
	  "Лаврентий",
	  "Леонид",
	  "Лука",
	  "Макар",
	  "Максим",
	  "Матвей",
	  "Михаил",
	  "Никита",
	  "Николай",
	  "Олег",
	  "Роман",
	  "Семён",
	  "Сергей",
	  "Станислав",
	  "Степан",
	  "Фёдор",
	  "Эдуард",
	  "Юрий",
	  "Ярослав"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Смирнов",
	  "Иванов",
	  "Кузнецов",
	  "Попов",
	  "Соколов",
	  "Лебедев",
	  "Козлов",
	  "Новиков",
	  "Морозов",
	  "Петров",
	  "Волков",
	  "Соловьев",
	  "Васильев",
	  "Зайцев",
	  "Павлов",
	  "Семенов",
	  "Голубев",
	  "Виноградов",
	  "Богданов",
	  "Воробьев",
	  "Федоров",
	  "Михайлов",
	  "Беляев",
	  "Тарасов",
	  "Белов",
	  "Комаров",
	  "Орлов",
	  "Киселев",
	  "Макаров",
	  "Андреев",
	  "Ковалев",
	  "Ильин",
	  "Гусев",
	  "Титов",
	  "Кузьмин",
	  "Кудрявцев",
	  "Баранов",
	  "Куликов",
	  "Алексеев",
	  "Степанов",
	  "Яковлев",
	  "Сорокин",
	  "Сергеев",
	  "Романов",
	  "Захаров",
	  "Борисов",
	  "Королев",
	  "Герасимов",
	  "Пономарев",
	  "Григорьев",
	  "Лазарев",
	  "Медведев",
	  "Ершов",
	  "Никитин",
	  "Соболев",
	  "Рябов",
	  "Поляков",
	  "Цветков",
	  "Данилов",
	  "Жуков",
	  "Фролов",
	  "Журавлев",
	  "Николаев",
	  "Крылов",
	  "Максимов",
	  "Сидоров",
	  "Осипов",
	  "Белоусов",
	  "Федотов",
	  "Дорофеев",
	  "Егоров",
	  "Матвеев",
	  "Бобров",
	  "Дмитриев",
	  "Калинин",
	  "Анисимов",
	  "Петухов",
	  "Антонов",
	  "Тимофеев",
	  "Никифоров",
	  "Веселов",
	  "Филиппов",
	  "Марков",
	  "Большаков",
	  "Суханов",
	  "Миронов",
	  "Ширяев",
	  "Александров",
	  "Коновалов",
	  "Шестаков",
	  "Казаков",
	  "Ефимов",
	  "Денисов",
	  "Громов",
	  "Фомин",
	  "Давыдов",
	  "Мельников",
	  "Щербаков",
	  "Блинов",
	  "Колесников",
	  "Карпов",
	  "Афанасьев",
	  "Власов",
	  "Маслов",
	  "Исаков",
	  "Тихонов",
	  "Аксенов",
	  "Гаврилов",
	  "Родионов",
	  "Котов",
	  "Горбунов",
	  "Кудряшов",
	  "Быков",
	  "Зуев",
	  "Третьяков",
	  "Савельев",
	  "Панов",
	  "Рыбаков",
	  "Суворов",
	  "Абрамов",
	  "Воронов",
	  "Мухин",
	  "Архипов",
	  "Трофимов",
	  "Мартынов",
	  "Емельянов",
	  "Горшков",
	  "Чернов",
	  "Овчинников",
	  "Селезнев",
	  "Панфилов",
	  "Копылов",
	  "Михеев",
	  "Галкин",
	  "Назаров",
	  "Лобанов",
	  "Лукин",
	  "Беляков",
	  "Потапов",
	  "Некрасов",
	  "Хохлов",
	  "Жданов",
	  "Наумов",
	  "Шилов",
	  "Воронцов",
	  "Ермаков",
	  "Дроздов",
	  "Игнатьев",
	  "Савин",
	  "Логинов",
	  "Сафонов",
	  "Капустин",
	  "Кириллов",
	  "Моисеев",
	  "Елисеев",
	  "Кошелев",
	  "Костин",
	  "Горбачев",
	  "Орехов",
	  "Ефремов",
	  "Исаев",
	  "Евдокимов",
	  "Калашников",
	  "Кабанов",
	  "Носков",
	  "Юдин",
	  "Кулагин",
	  "Лапин",
	  "Прохоров",
	  "Нестеров",
	  "Харитонов",
	  "Агафонов",
	  "Муравьев",
	  "Ларионов",
	  "Федосеев",
	  "Зимин",
	  "Пахомов",
	  "Шубин",
	  "Игнатов",
	  "Филатов",
	  "Крюков",
	  "Рогов",
	  "Кулаков",
	  "Терентьев",
	  "Молчанов",
	  "Владимиров",
	  "Артемьев",
	  "Гурьев",
	  "Зиновьев",
	  "Гришин",
	  "Кононов",
	  "Дементьев",
	  "Ситников",
	  "Симонов",
	  "Мишин",
	  "Фадеев",
	  "Комиссаров",
	  "Мамонтов",
	  "Носов",
	  "Гуляев",
	  "Шаров",
	  "Устинов",
	  "Вишняков",
	  "Евсеев",
	  "Лаврентьев",
	  "Брагин",
	  "Константинов",
	  "Корнилов",
	  "Авдеев",
	  "Зыков",
	  "Бирюков",
	  "Шарапов",
	  "Никонов",
	  "Щукин",
	  "Дьячков",
	  "Одинцов",
	  "Сазонов",
	  "Якушев",
	  "Красильников",
	  "Гордеев",
	  "Самойлов",
	  "Князев",
	  "Беспалов",
	  "Уваров",
	  "Шашков",
	  "Бобылев",
	  "Доронин",
	  "Белозеров",
	  "Рожков",
	  "Самсонов",
	  "Мясников",
	  "Лихачев",
	  "Буров",
	  "Сысоев",
	  "Фомичев",
	  "Русаков",
	  "Стрелков",
	  "Гущин",
	  "Тетерин",
	  "Колобов",
	  "Субботин",
	  "Фокин",
	  "Блохин",
	  "Селиверстов",
	  "Пестов",
	  "Кондратьев",
	  "Силин",
	  "Меркушев",
	  "Лыткин",
	  "Туров"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Александрович",
	  "Алексеевич",
	  "Альбертович",
	  "Анатольевич",
	  "Андреевич",
	  "Антонович",
	  "Аркадьевич",
	  "Арсеньевич",
	  "Артёмович",
	  "Борисович",
	  "Вадимович",
	  "Валентинович",
	  "Валерьевич",
	  "Васильевич",
	  "Викторович",
	  "Витальевич",
	  "Владимирович",
	  "Владиславович",
	  "Вячеславович",
	  "Геннадьевич",
	  "Георгиевич",
	  "Германович",
	  "Григорьевич",
	  "Даниилович",
	  "Денисович",
	  "Дмитриевич",
	  "Евгеньевич",
	  "Егорович",
	  "Иванович",
	  "Игнатьевич",
	  "Игоревич",
	  "Ильич",
	  "Константинович",
	  "Лаврентьевич",
	  "Леонидович",
	  "Лукич",
	  "Макарович",
	  "Максимович",
	  "Матвеевич",
	  "Михайлович",
	  "Никитич",
	  "Николаевич",
	  "Олегович",
	  "Романович",
	  "Семёнович",
	  "Сергеевич",
	  "Станиславович",
	  "Степанович",
	  "Фёдорович",
	  "Эдуардович",
	  "Юрьевич",
	  "Ярославович"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_middle_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name} #{male_middle_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_middle_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name} #{female_middle_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(9##)###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2673);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bánovce nad Bebravou",
	  "Banská Bystrica",
	  "Banská Štiavnica",
	  "Bardejov",
	  "Bratislava I",
	  "Bratislava II",
	  "Bratislava III",
	  "Bratislava IV",
	  "Bratislava V",
	  "Brezno",
	  "Bytča",
	  "Čadca",
	  "Detva",
	  "Dolný Kubín",
	  "Dunajská Streda",
	  "Galanta",
	  "Gelnica",
	  "Hlohovec",
	  "Humenné",
	  "Ilava",
	  "Kežmarok",
	  "Komárno",
	  "Košice I",
	  "Košice II",
	  "Košice III",
	  "Košice IV",
	  "Košice-okolie",
	  "Krupina",
	  "Kysucké Nové Mesto",
	  "Levice",
	  "Levoča",
	  "Liptovský Mikuláš",
	  "Lučenec",
	  "Malacky",
	  "Martin",
	  "Medzilaborce",
	  "Michalovce",
	  "Myjava",
	  "Námestovo",
	  "Nitra",
	  "Nové Mesto n.Váhom",
	  "Nové Zámky",
	  "Partizánske",
	  "Pezinok",
	  "Piešťany",
	  "Poltár",
	  "Poprad",
	  "Považská Bystrica",
	  "Prešov",
	  "Prievidza",
	  "Púchov",
	  "Revúca",
	  "Rimavská Sobota",
	  "Rožňava",
	  "Ružomberok",
	  "Sabinov",
	  "Šaľa",
	  "Senec",
	  "Senica",
	  "Skalica",
	  "Snina",
	  "Sobrance",
	  "Spišská Nová Ves",
	  "Stará Ľubovňa",
	  "Stropkov",
	  "Svidník",
	  "Topoľčany",
	  "Trebišov",
	  "Trenčín",
	  "Trnava",
	  "Turčianske Teplice",
	  "Tvrdošín",
	  "Veľký Krtíš",
	  "Vranov nad Topľou",
	  "Žarnovica",
	  "Žiar nad Hronom",
	  "Žilina",
	  "Zlaté Moravce",
	  "Zvolen"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "North",
	  "East",
	  "West",
	  "South",
	  "New",
	  "Lake",
	  "Port"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "town",
	  "ton",
	  "land",
	  "ville",
	  "berg",
	  "burgh",
	  "borough",
	  "bury",
	  "view",
	  "port",
	  "mouth",
	  "stad",
	  "furt",
	  "chester",
	  "mouth",
	  "fort",
	  "haven",
	  "side",
	  "shire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Afgánsky islamský štát",
	  "Albánsko",
	  "Albánska republika",
	  "Alžírsko",
	  "Alžírska demokratická ľudová republika",
	  "Andorra",
	  "Andorrské kniežatsvo",
	  "Angola",
	  "Angolská republika",
	  "Antigua a Barbuda",
	  "Antigua a Barbuda",
	  "Argentína",
	  "Argentínska republika",
	  "Arménsko",
	  "Arménska republika",
	  "Austrália",
	  "Austrálsky zväz",
	  "Azerbajdžan",
	  "Azerbajdžanská republika",
	  "Bahamy",
	  "Bahamské spoločenstvo",
	  "Bahrajn",
	  "Bahrajnské kráľovstvo",
	  "Bangladéš",
	  "Bangladéšska ľudová republika",
	  "Barbados",
	  "Barbados",
	  "Belgicko",
	  "Belgické kráľovstvo",
	  "Belize",
	  "Belize",
	  "Benin",
	  "Beninská republika",
	  "Bhután",
	  "Bhutánske kráľovstvo",
	  "Bielorusko",
	  "Bieloruská republika",
	  "Bolívia",
	  "Bolívijská republika",
	  "Bosna a Hercegovina",
	  "Republika Bosny a Hercegoviny",
	  "Botswana",
	  "Botswanská republika",
	  "Brazília",
	  "Brazílska federatívna republika",
	  "Brunej",
	  "Brunejský sultanát",
	  "Bulharsko",
	  "Bulharská republika",
	  "Burkina Faso",
	  "Burkina Faso",
	  "Burundi",
	  "Burundská republika",
	  "Cyprus",
	  "Cyperská republika",
	  "Čad",
	  "Republika Čad",
	  "Česko",
	  "Česká republika",
	  "Čína",
	  "Čínska ľudová republika",
	  "Dánsko",
	  "Dánsko kráľovstvo",
	  "Dominika",
	  "Spoločenstvo Dominika",
	  "Dominikánska republika",
	  "Dominikánska republika",
	  "Džibutsko",
	  "Džibutská republika",
	  "Egypt",
	  "Egyptská arabská republika",
	  "Ekvádor",
	  "Ekvádorská republika",
	  "Eritrea",
	  "Eritrejský štát",
	  "Estónsko",
	  "Estónska republika",
	  "Etiópia",
	  "Etiópska federatívna demokratická republika",
	  "Fidži",
	  "Republika ostrovy Fidži",
	  "Filipíny",
	  "Filipínska republika",
	  "Fínsko",
	  "Fínska republika",
	  "Francúzsko",
	  "Francúzska republika",
	  "Gabon",
	  "Gabonská republika",
	  "Gambia",
	  "Gambijská republika",
	  "Ghana",
	  "Ghanská republika",
	  "Grécko",
	  "Helénska republika",
	  "Grenada",
	  "Grenada",
	  "Gruzínsko",
	  "Gruzínsko",
	  "Guatemala",
	  "Guatemalská republika",
	  "Guinea",
	  "Guinejská republika",
	  "Guinea-Bissau",
	  "Republika Guinea-Bissau",
	  "Guayana",
	  "Guayanská republika",
	  "Haiti",
	  "Republika Haiti",
	  "Holandsko",
	  "Holandské kráľovstvo",
	  "Honduras",
	  "Honduraská republika",
	  "Chile",
	  "Čílska republika",
	  "Chorvátsko",
	  "Chorvátska republika",
	  "India",
	  "Indická republika",
	  "Indonézia",
	  "Indonézska republika",
	  "Irak",
	  "Iracká republika",
	  "Irán",
	  "Iránska islamská republika",
	  "Island",
	  "Islandská republika",
	  "Izrael",
	  "Štát Izrael",
	  "Írsko",
	  "Írska republika",
	  "Jamajka",
	  "Jamajka",
	  "Japonsko",
	  "Japonsko",
	  "Jemen",
	  "Jemenská republika",
	  "Jordánsko",
	  "Jordánske hášimovské kráľovstvo",
	  "Južná Afrika",
	  "Juhoafrická republika",
	  "Kambodža",
	  "Kambodžské kráľovstvo",
	  "Kamerun",
	  "Kamerunská republika",
	  "Kanada",
	  "Kanada",
	  "Kapverdy",
	  "Kapverdská republika",
	  "Katar",
	  "Štát Katar",
	  "Kazachstan",
	  "Kazašská republika",
	  "Keňa",
	  "Kenská republika",
	  "Kirgizsko",
	  "Kirgizská republika",
	  "Kiribati",
	  "Kiribatská republika",
	  "Kolumbia",
	  "Kolumbijská republika",
	  "Komory",
	  "Komorská únia",
	  "Kongo",
	  "Konžská demokratická republika",
	  "Kongo (\"Brazzaville\")",
	  "Konžská republika",
	  "Kórea (\"Južná\")",
	  "Kórejská republika",
	  "Kórea (\"Severná\")",
	  "Kórejská ľudovodemokratická republika",
	  "Kostarika",
	  "Kostarická republika",
	  "Kuba",
	  "Kubánska republika",
	  "Kuvajt",
	  "Kuvajtský štát",
	  "Laos",
	  "Laoská ľudovodemokratická republika",
	  "Lesotho",
	  "Lesothské kráľovstvo",
	  "Libanon",
	  "Libanonská republika",
	  "Libéria",
	  "Libérijská republika",
	  "Líbya",
	  "Líbyjská arabská ľudová socialistická džamáhírija",
	  "Lichtenštajnsko",
	  "Lichtenštajnské kniežatstvo",
	  "Litva",
	  "Litovská republika",
	  "Lotyšsko",
	  "Lotyšská republika",
	  "Luxembursko",
	  "Luxemburské veľkovojvodstvo",
	  "Macedónsko",
	  "Macedónska republika",
	  "Madagaskar",
	  "Madagaskarská republika",
	  "Maďarsko",
	  "Maďarská republika",
	  "Malajzia",
	  "Malajzia",
	  "Malawi",
	  "Malawijská republika",
	  "Maldivy",
	  "Maldivská republika",
	  "Mali",
	  "Malijská republika",
	  "Malta",
	  "Malta",
	  "Maroko",
	  "Marocké kráľovstvo",
	  "Marshallove ostrovy",
	  "Republika Marshallových ostrovy",
	  "Mauritánia",
	  "Mauritánska islamská republika",
	  "Maurícius",
	  "Maurícijská republika",
	  "Mexiko",
	  "Spojené štáty mexické",
	  "Mikronézia",
	  "Mikronézske federatívne štáty",
	  "Mjanmarsko",
	  "Mjanmarský zväz",
	  "Moldavsko",
	  "Moldavská republika",
	  "Monako",
	  "Monacké kniežatstvo",
	  "Mongolsko",
	  "Mongolsko",
	  "Mozambik",
	  "Mozambická republika",
	  "Namíbia",
	  "Namíbijská republika",
	  "Nauru",
	  "Naurská republika",
	  "Nemecko",
	  "Nemecká spolková republika",
	  "Nepál",
	  "Nepálske kráľovstvo",
	  "Niger",
	  "Nigerská republika",
	  "Nigéria",
	  "Nigérijská federatívna republika",
	  "Nikaragua",
	  "Nikaragujská republika",
	  "Nový Zéland",
	  "Nový Zéland",
	  "Nórsko",
	  "Nórske kráľovstvo",
	  "Omán",
	  "Ománsky sultanát",
	  "Pakistan",
	  "Pakistanská islamská republika",
	  "Palau",
	  "Palauská republika",
	  "Panama",
	  "Panamská republika",
	  "Papua-Nová Guinea",
	  "Nezávislý štát Papua-Nová Guinea",
	  "Paraguaj",
	  "Paraguajská republika",
	  "Peru",
	  "Peruánska republika",
	  "Pobrežie Slonoviny",
	  "Republika Pobrežie Slonoviny",
	  "Poľsko",
	  "Poľská republika",
	  "Portugalsko",
	  "Portugalská republika",
	  "Rakúsko",
	  "Rakúska republika",
	  "Rovníková Guinea",
	  "Republika Rovníková Guinea",
	  "Rumunsko",
	  "Rumunsko",
	  "Rusko",
	  "Ruská federácia",
	  "Rwanda",
	  "Rwandská republika",
	  "Salvádor",
	  "Salvádorská republika",
	  "Samoa",
	  "Nezávislý štát Samoa",
	  "San Maríno",
	  "Sanmarínska republika",
	  "Saudská Arábia",
	  "Kráľovstvo Saudskej Arábie",
	  "Senegal",
	  "Senegalská republika",
	  "Seychely",
	  "Seychelská republika",
	  "Sierra Leone",
	  "Republika Sierra Leone",
	  "Singapur",
	  "Singapurska republika",
	  "Slovensko",
	  "Slovenská republika",
	  "Slovinsko",
	  "Slovinská republika",
	  "Somálsko",
	  "Somálska demokratická republika",
	  "Spojené arabské emiráty",
	  "Spojené arabské emiráty",
	  "Spojené štáty americké",
	  "Spojené štáty americké",
	  "Srbsko a Čierna Hora",
	  "Srbsko a Čierna Hora",
	  "Srí Lanka",
	  "Demokratická socialistická republika Srí Lanka",
	  "Stredoafrická republika",
	  "Stredoafrická republika",
	  "Sudán",
	  "Sudánska republika",
	  "Surinam",
	  "Surinamská republika",
	  "Svazijsko",
	  "Svazijské kráľovstvo",
	  "Svätá Lucia",
	  "Svätá Lucia",
	  "Svätý Krištof a Nevis",
	  "Federácia Svätý Krištof a Nevis",
	  "Sv. Tomáš a Princov Ostrov",
	  "Demokratická republika Svätý Tomáš a Princov Ostrov",
	  "Sv. Vincent a Grenadíny",
	  "Svätý Vincent a Grenadíny",
	  "Sýria",
	  "Sýrska arabská republika",
	  "Šalamúnove ostrovy",
	  "Šalamúnove ostrovy",
	  "Španielsko",
	  "Španielske kráľovstvo",
	  "Švajčiarsko",
	  "Švajčiarska konfederácia",
	  "Švédsko",
	  "Švédske kráľovstvo",
	  "Tadžikistan",
	  "Tadžická republika",
	  "Taliansko",
	  "Talianska republika",
	  "Tanzánia",
	  "Tanzánijská zjednotená republika",
	  "Thajsko",
	  "Thajské kráľovstvo",
	  "Togo",
	  "Tožská republika",
	  "Tonga",
	  "Tonžské kráľovstvo",
	  "Trinidad a Tobago",
	  "Republika Trinidad a Tobago",
	  "Tunisko",
	  "Tuniská republika",
	  "Turecko",
	  "Turecká republika",
	  "Turkménsko",
	  "Turkménsko",
	  "Tuvalu",
	  "Tuvalu",
	  "Uganda",
	  "Ugandská republika",
	  "Ukrajina",
	  "Uruguaj",
	  "Uruguajská východná republika",
	  "Uzbekistan",
	  "Vanuatu",
	  "Vanuatská republika",
	  "Vatikán",
	  "Svätá Stolica",
	  "Veľká Británia",
	  "Spojené kráľovstvo Veľkej Británie a Severného Írska",
	  "Venezuela",
	  "Venezuelská bolívarovská republika",
	  "Vietnam",
	  "Vietnamská socialistická republika",
	  "Východný Timor",
	  "Demokratická republika Východný Timor",
	  "Zambia",
	  "Zambijská republika",
	  "Zimbabwe",
	  "Zimbabwianska republika"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Slovensko"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2678);
	address.city_suffix = __webpack_require__(2679);
	address.country = __webpack_require__(2680);
	address.building_number = __webpack_require__(2675);
	address.secondary_address = __webpack_require__(2684);
	address.postcode = __webpack_require__(2683);
	address.state = __webpack_require__(2685);
	address.state_abbr = __webpack_require__(2686);
	address.time_zone = __webpack_require__(2690);
	address.city_name = __webpack_require__(2677);
	address.city = __webpack_require__(2676);
	address.street = __webpack_require__(2687);
	address.street_name = __webpack_require__(2689);
	address.street_address = __webpack_require__(2688);
	address.default_country = __webpack_require__(2681);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "### ##",
	  "## ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Apt. ###",
	  "Suite ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adámiho",
	  "Ahoj",
	  "Albína Brunovského",
	  "Albrechtova",
	  "Alejová",
	  "Alešova",
	  "Alibernetová",
	  "Alžbetínska",
	  "Alžbety Gwerkovej",
	  "Ambroseho",
	  "Ambrušova",
	  "Americká",
	  "Americké námestie",
	  "Americké námestie",
	  "Andreja Mráza",
	  "Andreja Plávku",
	  "Andrusovova",
	  "Anenská",
	  "Anenská",
	  "Antolská",
	  "Astronomická",
	  "Astrová",
	  "Azalková",
	  "Azovská",
	  "Babuškova",
	  "Bachova",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajkalská",
	  "Bajzova",
	  "Bancíkovej",
	  "Banícka",
	  "Baníkova",
	  "Banskobystrická",
	  "Banšelova",
	  "Bardejovská",
	  "Bartókova",
	  "Bartoňova",
	  "Bartoškova",
	  "Baštová",
	  "Bazová",
	  "Bažantia",
	  "Beblavého",
	  "Beckovská",
	  "Bedľová",
	  "Belániková",
	  "Belehradská",
	  "Belinského",
	  "Belopotockého",
	  "Beňadická",
	  "Bencúrova",
	  "Benediktiho",
	  "Beniakova",
	  "Bernolákova",
	  "Beskydská",
	  "Betliarska",
	  "Bezručova",
	  "Biela",
	  "Bielkova",
	  "Björnsonova",
	  "Blagoevova",
	  "Blatnická",
	  "Blumentálska",
	  "Blyskáčová",
	  "Bočná",
	  "Bohrova",
	  "Bohúňova",
	  "Bojnická",
	  "Borodáčova",
	  "Borská",
	  "Bosákova",
	  "Botanická",
	  "Bottova",
	  "Boženy Němcovej",
	  "Bôrik",
	  "Bradáčova",
	  "Bradlianska",
	  "Brančská",
	  "Bratská",
	  "Brestová",
	  "Brezovská",
	  "Briežky",
	  "Brnianska",
	  "Brodná",
	  "Brodská",
	  "Broskyňová",
	  "Břeclavská",
	  "Budatínska",
	  "Budatínska",
	  "Budatínska",
	  "Búdkova  cesta",
	  "Budovateľská",
	  "Budyšínska",
	  "Budyšínska",
	  "Buková",
	  "Bukureštská",
	  "Bulharská",
	  "Bulíkova",
	  "Bystrého",
	  "Bzovícka",
	  "Cablkova",
	  "Cesta na Červený most",
	  "Cesta na Červený most",
	  "Cesta na Senec",
	  "Cikkerova",
	  "Cintorínska",
	  "Cintulova",
	  "Cukrová",
	  "Cyrilova",
	  "Čajakova",
	  "Čajkovského",
	  "Čaklovská",
	  "Čalovská",
	  "Čapajevova",
	  "Čapkova",
	  "Čárskeho",
	  "Čavojského",
	  "Čečinová",
	  "Čelakovského",
	  "Čerešňová",
	  "Černyševského",
	  "Červeňova",
	  "Česká",
	  "Československých par",
	  "Čipkárska",
	  "Čmelíkova",
	  "Čmeľovec",
	  "Čulenova",
	  "Daliborovo námestie",
	  "Dankovského",
	  "Dargovská",
	  "Ďatelinová",
	  "Daxnerovo námestie",
	  "Devínska cesta",
	  "Dlhé diely I.",
	  "Dlhé diely II.",
	  "Dlhé diely III.",
	  "Dobrovičova",
	  "Dobrovičova",
	  "Dobrovského",
	  "Dobšinského",
	  "Dohnalova",
	  "Dohnányho",
	  "Doležalova",
	  "Dolná",
	  "Dolnozemská cesta",
	  "Domkárska",
	  "Domové role",
	  "Donnerova",
	  "Donovalova",
	  "Dostojevského rad",
	  "Dr. Vladimíra Clemen",
	  "Drevená",
	  "Drieňová",
	  "Drieňová",
	  "Drieňová",
	  "Drotárska cesta",
	  "Drotárska cesta",
	  "Drotárska cesta",
	  "Družicová",
	  "Družstevná",
	  "Dubnická",
	  "Dubová",
	  "Dúbravská cesta",
	  "Dudova",
	  "Dulovo námestie",
	  "Dulovo námestie",
	  "Dunajská",
	  "Dvořákovo nábrežie",
	  "Edisonova",
	  "Einsteinova",
	  "Elektrárenská",
	  "Exnárova",
	  "F. Kostku",
	  "Fadruszova",
	  "Fajnorovo nábrežie",
	  "Fándlyho",
	  "Farebná",
	  "Farská",
	  "Farského",
	  "Fazuľová",
	  "Fedinova",
	  "Ferienčíkova",
	  "Fialkové údolie",
	  "Fibichova",
	  "Filiálne nádražie",
	  "Flöglova",
	  "Floriánske námestie",
	  "Fraňa Kráľa",
	  "Francisciho",
	  "Francúzskych partizá",
	  "Františkánska",
	  "Františkánske námest",
	  "Furdekova",
	  "Furdekova",
	  "Gabčíkova",
	  "Gagarinova",
	  "Gagarinova",
	  "Gagarinova",
	  "Gajova",
	  "Galaktická",
	  "Galandova",
	  "Gallova",
	  "Galvaniho",
	  "Gašparíkova",
	  "Gaštanová",
	  "Gavlovičova",
	  "Gemerská",
	  "Gercenova",
	  "Gessayova",
	  "Gettingová",
	  "Godrova",
	  "Gogoľova",
	  "Goláňova",
	  "Gondova",
	  "Goralská",
	  "Gorazdova",
	  "Gorkého",
	  "Gregorovej",
	  "Grösslingova",
	  "Gruzínska",
	  "Gunduličova",
	  "Gusevova",
	  "Haanova",
	  "Haburská",
	  "Halašova",
	  "Hálkova",
	  "Hálova",
	  "Hamuliakova",
	  "Hanácka",
	  "Handlovská",
	  "Hany Meličkovej",
	  "Harmanecká",
	  "Hasičská",
	  "Hattalova",
	  "Havlíčkova",
	  "Havrania",
	  "Haydnova",
	  "Herlianska",
	  "Herlianska",
	  "Heydukova",
	  "Hlaváčikova",
	  "Hlavatého",
	  "Hlavné námestie",
	  "Hlboká cesta",
	  "Hlboká cesta",
	  "Hlivová",
	  "Hlučínska",
	  "Hodálova",
	  "Hodžovo námestie",
	  "Holekova",
	  "Holíčska",
	  "Hollého",
	  "Holubyho",
	  "Hontianska",
	  "Horárska",
	  "Horné Židiny",
	  "Horská",
	  "Horská",
	  "Hrad",
	  "Hradné údolie",
	  "Hrachová",
	  "Hraničná",
	  "Hrebendova",
	  "Hríbová",
	  "Hriňovská",
	  "Hrobákova",
	  "Hrobárska",
	  "Hroboňova",
	  "Hudecova",
	  "Humenské námestie",
	  "Hummelova",
	  "Hurbanovo námestie",
	  "Hurbanovo námestie",
	  "Hviezdoslavovo námes",
	  "Hýrošova",
	  "Chalupkova",
	  "Chemická",
	  "Chlumeckého",
	  "Chorvátska",
	  "Chorvátska",
	  "Iľjušinova",
	  "Ilkovičova",
	  "Inovecká",
	  "Inovecká",
	  "Iskerníková",
	  "Ivana Horvátha",
	  "Ivánska cesta",
	  "J.C.Hronského",
	  "Jabloňová",
	  "Jadrová",
	  "Jakabova",
	  "Jakubovo námestie",
	  "Jamnického",
	  "Jána Stanislava",
	  "Janáčkova",
	  "Jančova",
	  "Janíkove role",
	  "Jankolova",
	  "Jánošíkova",
	  "Jánoškova",
	  "Janotova",
	  "Jánska",
	  "Jantárová cesta",
	  "Jarabinková",
	  "Jarná",
	  "Jaroslavova",
	  "Jarošova",
	  "Jaseňová",
	  "Jasná",
	  "Jasovská",
	  "Jastrabia",
	  "Jašíkova",
	  "Javorinská",
	  "Javorová",
	  "Jazdecká",
	  "Jedlíkova",
	  "Jégého",
	  "Jelačičova",
	  "Jelenia",
	  "Jesenná",
	  "Jesenského",
	  "Jiráskova",
	  "Jiskrova",
	  "Jozefská",
	  "Junácka",
	  "Jungmannova",
	  "Jurigovo námestie",
	  "Jurovského",
	  "Jurská",
	  "Justičná",
	  "K lomu",
	  "K Železnej studienke",
	  "Kalinčiakova",
	  "Kamenárska",
	  "Kamenné námestie",
	  "Kapicova",
	  "Kapitulská",
	  "Kapitulský dvor",
	  "Kapucínska",
	  "Kapušianska",
	  "Karadžičova",
	  "Karadžičova",
	  "Karadžičova",
	  "Karadžičova",
	  "Karloveská",
	  "Karloveské rameno",
	  "Karpatská",
	  "Kašmírska",
	  "Kaštielska",
	  "Kaukazská",
	  "Kempelenova",
	  "Kežmarské námestie",
	  "Kladnianska",
	  "Klariská",
	  "Kláštorská",
	  "Klatovská",
	  "Klatovská",
	  "Klemensova",
	  "Klincová",
	  "Klobučnícka",
	  "Klokočova",
	  "Kľukatá",
	  "Kmeťovo námestie",
	  "Koceľova",
	  "Kočánkova",
	  "Kohútova",
	  "Kolárska",
	  "Kolískova",
	  "Kollárovo námestie",
	  "Kollárovo námestie",
	  "Kolmá",
	  "Komárňanská",
	  "Komárnická",
	  "Komárnická",
	  "Komenského námestie",
	  "Kominárska",
	  "Komonicová",
	  "Konopná",
	  "Konvalinková",
	  "Konventná",
	  "Kopanice",
	  "Kopčianska",
	  "Koperníkova",
	  "Korabinského",
	  "Koreničova",
	  "Kostlivého",
	  "Kostolná",
	  "Košická",
	  "Košická",
	  "Košická",
	  "Kováčska",
	  "Kovorobotnícka",
	  "Kozia",
	  "Koziarka",
	  "Kozmonautická",
	  "Krajná",
	  "Krakovská",
	  "Kráľovské údolie",
	  "Krasinského",
	  "Kraskova",
	  "Krásna",
	  "Krásnohorská",
	  "Krasovského",
	  "Krátka",
	  "Krčméryho",
	  "Kremnická",
	  "Kresánkova",
	  "Krivá",
	  "Križkova",
	  "Krížna",
	  "Krížna",
	  "Krížna",
	  "Krížna",
	  "Krmanova",
	  "Krompašská",
	  "Krupinská",
	  "Krupkova",
	  "Kubániho",
	  "Kubínska",
	  "Kuklovská",
	  "Kukučínova",
	  "Kukuričná",
	  "Kulíškova",
	  "Kultúrna",
	  "Kupeckého",
	  "Kúpeľná",
	  "Kutlíkova",
	  "Kutuzovova",
	  "Kuzmányho",
	  "Kvačalova",
	  "Kvetná",
	  "Kýčerského",
	  "Kyjevská",
	  "Kysucká",
	  "Laborecká",
	  "Lackova",
	  "Ladislava Sáru",
	  "Ľadová",
	  "Lachova",
	  "Ľaliová",
	  "Lamačská cesta",
	  "Lamačská cesta",
	  "Lamanského",
	  "Landererova",
	  "Langsfeldova",
	  "Ľanová",
	  "Laskomerského",
	  "Laučekova",
	  "Laurinská",
	  "Lazaretská",
	  "Lazaretská",
	  "Legerského",
	  "Legionárska",
	  "Legionárska",
	  "Lehockého",
	  "Lehockého",
	  "Lenardova",
	  "Lermontovova",
	  "Lesná",
	  "Leškova",
	  "Letecká",
	  "Letisko M.R.Štefánik",
	  "Letná",
	  "Levárska",
	  "Levická",
	  "Levočská",
	  "Lidická",
	  "Lietavská",
	  "Lichardova",
	  "Lipová",
	  "Lipovinová",
	  "Liptovská",
	  "Listová",
	  "Líščie nivy",
	  "Líščie údolie",
	  "Litovská",
	  "Lodná",
	  "Lombardiniho",
	  "Lomonosovova",
	  "Lopenícka",
	  "Lovinského",
	  "Ľubietovská",
	  "Ľubinská",
	  "Ľubľanská",
	  "Ľubochnianska",
	  "Ľubovnianska",
	  "Lúčna",
	  "Ľudové námestie",
	  "Ľudovíta Fullu",
	  "Luhačovická",
	  "Lužická",
	  "Lužná",
	  "Lýcejná",
	  "Lykovcová",
	  "M. Hella",
	  "Magnetová",
	  "Macharova",
	  "Majakovského",
	  "Majerníkova",
	  "Májkova",
	  "Májová",
	  "Makovického",
	  "Malá",
	  "Malé pálenisko",
	  "Malinová",
	  "Malý Draždiak",
	  "Malý trh",
	  "Mamateyova",
	  "Mamateyova",
	  "Mánesovo námestie",
	  "Mariánska",
	  "Marie Curie-Sklodows",
	  "Márie Medveďovej",
	  "Markova",
	  "Marótyho",
	  "Martákovej",
	  "Martinčekova",
	  "Martinčekova",
	  "Martinengova",
	  "Martinská",
	  "Mateja Bela",
	  "Matejkova",
	  "Matičná",
	  "Matúšova",
	  "Medená",
	  "Medzierka",
	  "Medzilaborecká",
	  "Merlotová",
	  "Mesačná",
	  "Mestská",
	  "Meteorová",
	  "Metodova",
	  "Mickiewiczova",
	  "Mierová",
	  "Michalská",
	  "Mikovíniho",
	  "Mikulášska",
	  "Miletičova",
	  "Miletičova",
	  "Mišíkova",
	  "Mišíkova",
	  "Mišíkova",
	  "Mliekárenská",
	  "Mlynarovičova",
	  "Mlynská dolina",
	  "Mlynská dolina",
	  "Mlynská dolina",
	  "Mlynské luhy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlynské nivy",
	  "Mlyny",
	  "Modranská",
	  "Mojmírova",
	  "Mokráň záhon",
	  "Mokrohájska cesta",
	  "Moldavská",
	  "Molecova",
	  "Moravská",
	  "Moskovská",
	  "Most SNP",
	  "Mostová",
	  "Mošovského",
	  "Motýlia",
	  "Moyzesova",
	  "Mozartova",
	  "Mraziarenská",
	  "Mudroňova",
	  "Mudroňova",
	  "Mudroňova",
	  "Muchovo námestie",
	  "Murgašova",
	  "Muškátová",
	  "Muštová",
	  "Múzejná",
	  "Myjavská",
	  "Mýtna",
	  "Mýtna",
	  "Na Baránku",
	  "Na Brezinách",
	  "Na Hrebienku",
	  "Na Kalvárii",
	  "Na Kampárke",
	  "Na kopci",
	  "Na križovatkách",
	  "Na lánoch",
	  "Na paši",
	  "Na piesku",
	  "Na Riviére",
	  "Na Sitine",
	  "Na Slavíne",
	  "Na stráni",
	  "Na Štyridsiatku",
	  "Na úvrati",
	  "Na vŕšku",
	  "Na výslní",
	  "Nábělkova",
	  "Nábrežie arm. gen. L",
	  "Nábrežná",
	  "Nad Dunajom",
	  "Nad lomom",
	  "Nad lúčkami",
	  "Nad lúčkami",
	  "Nad ostrovom",
	  "Nad Sihoťou",
	  "Námestie 1. mája",
	  "Námestie Alexandra D",
	  "Námestie Biely kríž",
	  "Námestie Hraničiarov",
	  "Námestie Jána Pavla",
	  "Námestie Ľudovíta Št",
	  "Námestie Martina Ben",
	  "Nám. M.R.Štefánika",
	  "Námestie slobody",
	  "Námestie slobody",
	  "Námestie SNP",
	  "Námestie SNP",
	  "Námestie sv. Františ",
	  "Narcisová",
	  "Nedbalova",
	  "Nekrasovova",
	  "Neronetová",
	  "Nerudova",
	  "Nevädzová",
	  "Nezábudková",
	  "Niťová",
	  "Nitrianska",
	  "Nížinná",
	  "Nobelova",
	  "Nobelovo námestie",
	  "Nová",
	  "Nová Rožňavská",
	  "Novackého",
	  "Nové pálenisko",
	  "Nové záhrady I",
	  "Nové záhrady II",
	  "Nové záhrady III",
	  "Nové záhrady IV",
	  "Nové záhrady V",
	  "Nové záhrady VI",
	  "Nové záhrady VII",
	  "Novinárska",
	  "Novobanská",
	  "Novohradská",
	  "Novosvetská",
	  "Novosvetská",
	  "Novosvetská",
	  "Obežná",
	  "Obchodná",
	  "Očovská",
	  "Odbojárov",
	  "Odborárska",
	  "Odborárske námestie",
	  "Odborárske námestie",
	  "Ohnicová",
	  "Okánikova",
	  "Okružná",
	  "Olbrachtova",
	  "Olejkárska",
	  "Ondavská",
	  "Ondrejovova",
	  "Oravská",
	  "Orechová cesta",
	  "Orechový rad",
	  "Oriešková",
	  "Ormisova",
	  "Osadná",
	  "Ostravská",
	  "Ostredková",
	  "Osuského",
	  "Osvetová",
	  "Otonelská",
	  "Ovručská",
	  "Ovsištské námestie",
	  "Pajštúnska",
	  "Palackého",
	  "Palárikova",
	  "Palárikova",
	  "Pálavská",
	  "Palisády",
	  "Palisády",
	  "Palisády",
	  "Palkovičova",
	  "Panenská",
	  "Pankúchova",
	  "Panónska cesta",
	  "Panská",
	  "Papánkovo námestie",
	  "Papraďová",
	  "Páričkova",
	  "Parková",
	  "Partizánska",
	  "Pasienky",
	  "Paulínyho",
	  "Pavlovičova",
	  "Pavlovova",
	  "Pavlovská",
	  "Pažického",
	  "Pažítková",
	  "Pečnianska",
	  "Pernecká",
	  "Pestovateľská",
	  "Peterská",
	  "Petzvalova",
	  "Pezinská",
	  "Piesočná",
	  "Piešťanská",
	  "Pifflova",
	  "Pilárikova",
	  "Pionierska",
	  "Pivoňková",
	  "Planckova",
	  "Planét",
	  "Plátenícka",
	  "Pluhová",
	  "Plynárenská",
	  "Plzenská",
	  "Pobrežná",
	  "Pod Bôrikom",
	  "Pod Kalváriou",
	  "Pod lesom",
	  "Pod Rovnicami",
	  "Pod vinicami",
	  "Podhorského",
	  "Podjavorinskej",
	  "Podlučinského",
	  "Podniková",
	  "Podtatranského",
	  "Pohronská",
	  "Polárna",
	  "Poloreckého",
	  "Poľná",
	  "Poľská",
	  "Poludníková",
	  "Porubského",
	  "Poštová",
	  "Považská",
	  "Povraznícka",
	  "Povraznícka",
	  "Pražská",
	  "Predstaničné námesti",
	  "Prepoštská",
	  "Prešernova",
	  "Prešovská",
	  "Prešovská",
	  "Prešovská",
	  "Pri Bielom kríži",
	  "Pri dvore",
	  "Pri Dynamitke",
	  "Pri Habánskom mlyne",
	  "Pri hradnej studni",
	  "Pri seči",
	  "Pri Starej Prachárni",
	  "Pri Starom háji",
	  "Pri Starom Mýte",
	  "Pri strelnici",
	  "Pri Suchom mlyne",
	  "Pri zvonici",
	  "Pribinova",
	  "Pribinova",
	  "Pribinova",
	  "Pribišova",
	  "Pribylinská",
	  "Priečna",
	  "Priekopy",
	  "Priemyselná",
	  "Priemyselná",
	  "Prievozská",
	  "Prievozská",
	  "Prievozská",
	  "Príkopova",
	  "Primaciálne námestie",
	  "Prístav",
	  "Prístavná",
	  "Prokofievova",
	  "Prokopa Veľkého",
	  "Prokopova",
	  "Prúdová",
	  "Prvosienková",
	  "Púpavová",
	  "Pustá",
	  "Puškinova",
	  "Račianska",
	  "Račianska",
	  "Račianske mýto",
	  "Radarová",
	  "Rádiová",
	  "Radlinského",
	  "Radničná",
	  "Radničné námestie",
	  "Radvanská",
	  "Rajská",
	  "Raketová",
	  "Rákosová",
	  "Rastislavova",
	  "Rázusovo nábrežie",
	  "Repná",
	  "Rešetkova",
	  "Revolučná",
	  "Révová",
	  "Revúcka",
	  "Rezedová",
	  "Riazanská",
	  "Riazanská",
	  "Ribayová",
	  "Riečna",
	  "Rigeleho",
	  "Rízlingová",
	  "Riznerova",
	  "Robotnícka",
	  "Romanova",
	  "Röntgenova",
	  "Rosná",
	  "Rovná",
	  "Rovniankova",
	  "Rovníková",
	  "Rozmarínová",
	  "Rožňavská",
	  "Rožňavská",
	  "Rožňavská",
	  "Rubinsteinova",
	  "Rudnayovo námestie",
	  "Rumančeková",
	  "Rusovská cesta",
	  "Ružičková",
	  "Ružinovská",
	  "Ružinovská",
	  "Ružinovská",
	  "Ružomberská",
	  "Ružová dolina",
	  "Ružová dolina",
	  "Rybárska brána",
	  "Rybné námestie",
	  "Rýdziková",
	  "Sabinovská",
	  "Sabinovská",
	  "Sad Janka Kráľa",
	  "Sadová",
	  "Sartorisova",
	  "Sasinkova",
	  "Seberíniho",
	  "Sečovská",
	  "Sedlárska",
	  "Sedmokrásková",
	  "Segnerova",
	  "Sekulská",
	  "Semianova",
	  "Senická",
	  "Senná",
	  "Schillerova",
	  "Schody pri starej vo",
	  "Sibírska",
	  "Sienkiewiczova",
	  "Silvánska",
	  "Sinokvetná",
	  "Skalická cesta",
	  "Skalná",
	  "Sklenárova",
	  "Sklenárska",
	  "Sládkovičova",
	  "Sladová",
	  "Slávičie údolie",
	  "Slavín",
	  "Slepá",
	  "Sliačska",
	  "Sliezska",
	  "Slivková",
	  "Slnečná",
	  "Slovanská",
	  "Slovinská",
	  "Slovnaftská",
	  "Slowackého",
	  "Smetanova",
	  "Smikova",
	  "Smolenická",
	  "Smolnícka",
	  "Smrečianska",
	  "Soferove schody",
	  "Socháňova",
	  "Sokolská",
	  "Solivarská",
	  "Sološnická",
	  "Somolického",
	  "Somolického",
	  "Sosnová",
	  "Spišská",
	  "Spojná",
	  "Spoločenská",
	  "Sputniková",
	  "Sreznevského",
	  "Srnčia",
	  "Stachanovská",
	  "Stálicová",
	  "Staničná",
	  "Stará Černicová",
	  "Stará Ivánska cesta",
	  "Stará Prievozská",
	  "Stará Vajnorská",
	  "Stará vinárska",
	  "Staré Grunty",
	  "Staré ihrisko",
	  "Staré záhrady",
	  "Starhradská",
	  "Starohájska",
	  "Staromestská",
	  "Staroturský chodník",
	  "Staviteľská",
	  "Stodolova",
	  "Stoklasová",
	  "Strakova",
	  "Strážnická",
	  "Strážny dom",
	  "Strečnianska",
	  "Stredná",
	  "Strelecká",
	  "Strmá cesta",
	  "Strojnícka",
	  "Stropkovská",
	  "Struková",
	  "Studená",
	  "Stuhová",
	  "Súbežná",
	  "Súhvezdná",
	  "Suché mýto",
	  "Suchohradská",
	  "Súkennícka",
	  "Súľovská",
	  "Sumbalova",
	  "Súmračná",
	  "Súťažná",
	  "Svätého Vincenta",
	  "Svätoplukova",
	  "Svätoplukova",
	  "Svätovojtešská",
	  "Svetlá",
	  "Svíbová",
	  "Svidnícka",
	  "Svoradova",
	  "Svrčia",
	  "Syslia",
	  "Šafárikovo námestie",
	  "Šafárikovo námestie",
	  "Šafránová",
	  "Šagátova",
	  "Šalviová",
	  "Šancová",
	  "Šancová",
	  "Šancová",
	  "Šancová",
	  "Šándorova",
	  "Šarišská",
	  "Šášovská",
	  "Šaštínska",
	  "Ševčenkova",
	  "Šintavská",
	  "Šípková",
	  "Škarniclova",
	  "Školská",
	  "Škovránčia",
	  "Škultétyho",
	  "Šoltésovej",
	  "Špieszova",
	  "Špitálska",
	  "Športová",
	  "Šrobárovo námestie",
	  "Šťastná",
	  "Štedrá",
	  "Štefánikova",
	  "Štefánikova",
	  "Štefánikova",
	  "Štefanovičova",
	  "Štefunkova",
	  "Štetinova",
	  "Štiavnická",
	  "Štúrova",
	  "Štyndlova",
	  "Šulekova",
	  "Šulekova",
	  "Šulekova",
	  "Šumavská",
	  "Šuňavcova",
	  "Šustekova",
	  "Švabinského",
	  "Tabaková",
	  "Tablicova",
	  "Táborská",
	  "Tajovského",
	  "Tallerova",
	  "Tehelná",
	  "Technická",
	  "Tekovská",
	  "Telocvičná",
	  "Tematínska",
	  "Teplická",
	  "Terchovská",
	  "Teslova",
	  "Tetmayerova",
	  "Thurzova",
	  "Tichá",
	  "Tilgnerova",
	  "Timravina",
	  "Tobrucká",
	  "Tokajícka",
	  "Tolstého",
	  "Tománkova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Tomášikova",
	  "Topoľčianska",
	  "Topoľová",
	  "Továrenská",
	  "Trebišovská",
	  "Trebišovská",
	  "Trebišovská",
	  "Trenčianska",
	  "Treskoňova",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavská cesta",
	  "Trnavské mýto",
	  "Tŕňová",
	  "Trojdomy",
	  "Tučkova",
	  "Tupolevova",
	  "Turbínova",
	  "Turčianska",
	  "Turnianska",
	  "Tvarožkova",
	  "Tylova",
	  "Tyršovo nábrežie",
	  "Údernícka",
	  "Údolná",
	  "Uhorková",
	  "Ukrajinská",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica 29. augusta",
	  "Ulica Imricha Karvaš",
	  "Ulica Jozefa Krónera",
	  "Ulica Viktora Tegelh",
	  "Úprkova",
	  "Úradnícka",
	  "Uránová",
	  "Urbánkova",
	  "Ursínyho",
	  "Uršulínska",
	  "Úzka",
	  "V záhradách",
	  "Vajanského nábrežie",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Vajnorská",
	  "Valašská",
	  "Valchárska",
	  "Vansovej",
	  "Vápenná",
	  "Varínska",
	  "Varšavská",
	  "Varšavská",
	  "Vavilovova",
	  "Vavrínova",
	  "Vazovova",
	  "Včelárska",
	  "Velehradská",
	  "Veltlínska",
	  "Ventúrska",
	  "Veterná",
	  "Veternicová",
	  "Vetvová",
	  "Viedenská cesta",
	  "Viedenská cesta",
	  "Vietnamská",
	  "Vígľašská",
	  "Vihorlatská",
	  "Viktorínova",
	  "Vilová",
	  "Vincenta Hložníka",
	  "Vínna",
	  "Vlastenecké námestie",
	  "Vlčkova",
	  "Vlčkova",
	  "Vlčkova",
	  "Vodný vrch",
	  "Votrubova",
	  "Vrábeľská",
	  "Vrakunská cesta",
	  "Vranovská",
	  "Vretenová",
	  "Vrchná",
	  "Vrútocká",
	  "Vyhliadka",
	  "Vyhnianska cesta",
	  "Vysoká",
	  "Vyšehradská",
	  "Vyšná",
	  "Wattova",
	  "Wilsonova",
	  "Wolkrova",
	  "Za Kasárňou",
	  "Za sokolovňou",
	  "Za Stanicou",
	  "Za tehelňou",
	  "Záborského",
	  "Zadunajská cesta",
	  "Záhorácka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhradnícka",
	  "Záhrebská",
	  "Záhrebská",
	  "Zálužická",
	  "Zámocká",
	  "Zámocké schody",
	  "Zámočnícka",
	  "Západná",
	  "Západný rad",
	  "Záporožská",
	  "Zátišie",
	  "Závodníkova",
	  "Zelená",
	  "Zelinárska",
	  "Zimná",
	  "Zlaté piesky",
	  "Zlaté schody",
	  "Znievska",
	  "Zohorská",
	  "Zochova",
	  "Zrinského",
	  "Zvolenská",
	  "Žabí majer",
	  "Žabotova",
	  "Žehrianska",
	  "Železná",
	  "Železničiarska",
	  "Žellova",
	  "Žiarska",
	  "Židovská",
	  "Žilinská",
	  "Žilinská",
	  "Živnostenská",
	  "Žižkova",
	  "Župné námestie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Pacific/Midway",
	  "Pacific/Pago_Pago",
	  "Pacific/Honolulu",
	  "America/Juneau",
	  "America/Los_Angeles",
	  "America/Tijuana",
	  "America/Denver",
	  "America/Phoenix",
	  "America/Chihuahua",
	  "America/Mazatlan",
	  "America/Chicago",
	  "America/Regina",
	  "America/Mexico_City",
	  "America/Mexico_City",
	  "America/Monterrey",
	  "America/Guatemala",
	  "America/New_York",
	  "America/Indiana/Indianapolis",
	  "America/Bogota",
	  "America/Lima",
	  "America/Lima",
	  "America/Halifax",
	  "America/Caracas",
	  "America/La_Paz",
	  "America/Santiago",
	  "America/St_Johns",
	  "America/Sao_Paulo",
	  "America/Argentina/Buenos_Aires",
	  "America/Guyana",
	  "America/Godthab",
	  "Atlantic/South_Georgia",
	  "Atlantic/Azores",
	  "Atlantic/Cape_Verde",
	  "Europe/Dublin",
	  "Europe/London",
	  "Europe/Lisbon",
	  "Europe/London",
	  "Africa/Casablanca",
	  "Africa/Monrovia",
	  "Etc/UTC",
	  "Europe/Belgrade",
	  "Europe/Bratislava",
	  "Europe/Budapest",
	  "Europe/Ljubljana",
	  "Europe/Prague",
	  "Europe/Sarajevo",
	  "Europe/Skopje",
	  "Europe/Warsaw",
	  "Europe/Zagreb",
	  "Europe/Brussels",
	  "Europe/Copenhagen",
	  "Europe/Madrid",
	  "Europe/Paris",
	  "Europe/Amsterdam",
	  "Europe/Berlin",
	  "Europe/Berlin",
	  "Europe/Rome",
	  "Europe/Stockholm",
	  "Europe/Vienna",
	  "Africa/Algiers",
	  "Europe/Bucharest",
	  "Africa/Cairo",
	  "Europe/Helsinki",
	  "Europe/Kiev",
	  "Europe/Riga",
	  "Europe/Sofia",
	  "Europe/Tallinn",
	  "Europe/Vilnius",
	  "Europe/Athens",
	  "Europe/Istanbul",
	  "Europe/Minsk",
	  "Asia/Jerusalem",
	  "Africa/Harare",
	  "Africa/Johannesburg",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Europe/Moscow",
	  "Asia/Kuwait",
	  "Asia/Riyadh",
	  "Africa/Nairobi",
	  "Asia/Baghdad",
	  "Asia/Tehran",
	  "Asia/Muscat",
	  "Asia/Muscat",
	  "Asia/Baku",
	  "Asia/Tbilisi",
	  "Asia/Yerevan",
	  "Asia/Kabul",
	  "Asia/Yekaterinburg",
	  "Asia/Karachi",
	  "Asia/Karachi",
	  "Asia/Tashkent",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kolkata",
	  "Asia/Kathmandu",
	  "Asia/Dhaka",
	  "Asia/Dhaka",
	  "Asia/Colombo",
	  "Asia/Almaty",
	  "Asia/Novosibirsk",
	  "Asia/Rangoon",
	  "Asia/Bangkok",
	  "Asia/Bangkok",
	  "Asia/Jakarta",
	  "Asia/Krasnoyarsk",
	  "Asia/Shanghai",
	  "Asia/Chongqing",
	  "Asia/Hong_Kong",
	  "Asia/Urumqi",
	  "Asia/Kuala_Lumpur",
	  "Asia/Singapore",
	  "Asia/Taipei",
	  "Australia/Perth",
	  "Asia/Irkutsk",
	  "Asia/Ulaanbaatar",
	  "Asia/Seoul",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Tokyo",
	  "Asia/Yakutsk",
	  "Australia/Darwin",
	  "Australia/Adelaide",
	  "Australia/Melbourne",
	  "Australia/Melbourne",
	  "Australia/Sydney",
	  "Australia/Brisbane",
	  "Australia/Hobart",
	  "Asia/Vladivostok",
	  "Pacific/Guam",
	  "Pacific/Port_Moresby",
	  "Asia/Magadan",
	  "Asia/Magadan",
	  "Pacific/Noumea",
	  "Pacific/Fiji",
	  "Asia/Kamchatka",
	  "Pacific/Majuro",
	  "Pacific/Auckland",
	  "Pacific/Auckland",
	  "Pacific/Tongatapu",
	  "Pacific/Fakaofo",
	  "Pacific/Apia"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adaptive",
	  "Advanced",
	  "Ameliorated",
	  "Assimilated",
	  "Automated",
	  "Balanced",
	  "Business-focused",
	  "Centralized",
	  "Cloned",
	  "Compatible",
	  "Configurable",
	  "Cross-group",
	  "Cross-platform",
	  "Customer-focused",
	  "Customizable",
	  "Decentralized",
	  "De-engineered",
	  "Devolved",
	  "Digitized",
	  "Distributed",
	  "Diverse",
	  "Down-sized",
	  "Enhanced",
	  "Enterprise-wide",
	  "Ergonomic",
	  "Exclusive",
	  "Expanded",
	  "Extended",
	  "Face to face",
	  "Focused",
	  "Front-line",
	  "Fully-configurable",
	  "Function-based",
	  "Fundamental",
	  "Future-proofed",
	  "Grass-roots",
	  "Horizontal",
	  "Implemented",
	  "Innovative",
	  "Integrated",
	  "Intuitive",
	  "Inverse",
	  "Managed",
	  "Mandatory",
	  "Monitored",
	  "Multi-channelled",
	  "Multi-lateral",
	  "Multi-layered",
	  "Multi-tiered",
	  "Networked",
	  "Object-based",
	  "Open-architected",
	  "Open-source",
	  "Operative",
	  "Optimized",
	  "Optional",
	  "Organic",
	  "Organized",
	  "Persevering",
	  "Persistent",
	  "Phased",
	  "Polarised",
	  "Pre-emptive",
	  "Proactive",
	  "Profit-focused",
	  "Profound",
	  "Programmable",
	  "Progressive",
	  "Public-key",
	  "Quality-focused",
	  "Reactive",
	  "Realigned",
	  "Re-contextualized",
	  "Re-engineered",
	  "Reduced",
	  "Reverse-engineered",
	  "Right-sized",
	  "Robust",
	  "Seamless",
	  "Secured",
	  "Self-enabling",
	  "Sharable",
	  "Stand-alone",
	  "Streamlined",
	  "Switchable",
	  "Synchronised",
	  "Synergistic",
	  "Synergized",
	  "Team-oriented",
	  "Total",
	  "Triple-buffered",
	  "Universal",
	  "Up-sized",
	  "Upgradable",
	  "User-centric",
	  "User-friendly",
	  "Versatile",
	  "Virtual",
	  "Visionary",
	  "Vision-oriented"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "clicks-and-mortar",
	  "value-added",
	  "vertical",
	  "proactive",
	  "robust",
	  "revolutionary",
	  "scalable",
	  "leading-edge",
	  "innovative",
	  "intuitive",
	  "strategic",
	  "e-business",
	  "mission-critical",
	  "sticky",
	  "one-to-one",
	  "24/7",
	  "end-to-end",
	  "global",
	  "B2B",
	  "B2C",
	  "granular",
	  "frictionless",
	  "virtual",
	  "viral",
	  "dynamic",
	  "24/365",
	  "best-of-breed",
	  "killer",
	  "magnetic",
	  "bleeding-edge",
	  "web-enabled",
	  "interactive",
	  "dot-com",
	  "sexy",
	  "back-end",
	  "real-time",
	  "efficient",
	  "front-end",
	  "distributed",
	  "seamless",
	  "extensible",
	  "turn-key",
	  "world-class",
	  "open-source",
	  "cross-platform",
	  "cross-media",
	  "synergistic",
	  "bricks-and-clicks",
	  "out-of-the-box",
	  "enterprise",
	  "integrated",
	  "impactful",
	  "wireless",
	  "transparent",
	  "next-generation",
	  "cutting-edge",
	  "user-centric",
	  "visionary",
	  "customized",
	  "ubiquitous",
	  "plug-and-play",
	  "collaborative",
	  "compelling",
	  "holistic",
	  "rich",
	  "synergies",
	  "web-readiness",
	  "paradigms",
	  "markets",
	  "partnerships",
	  "infrastructures",
	  "platforms",
	  "initiatives",
	  "channels",
	  "eyeballs",
	  "communities",
	  "ROI",
	  "solutions",
	  "e-tailers",
	  "e-services",
	  "action-items",
	  "portals",
	  "niches",
	  "technologies",
	  "content",
	  "vortals",
	  "supply-chains",
	  "convergence",
	  "relationships",
	  "architectures",
	  "interfaces",
	  "e-markets",
	  "e-commerce",
	  "systems",
	  "bandwidth",
	  "infomediaries",
	  "models",
	  "mindshare",
	  "deliverables",
	  "users",
	  "schemas",
	  "networks",
	  "applications",
	  "metrics",
	  "e-business",
	  "functionalities",
	  "experiences",
	  "web services",
	  "methodologies"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "implement",
	  "utilize",
	  "integrate",
	  "streamline",
	  "optimize",
	  "evolve",
	  "transform",
	  "embrace",
	  "enable",
	  "orchestrate",
	  "leverage",
	  "reinvent",
	  "aggregate",
	  "architect",
	  "enhance",
	  "incentivize",
	  "morph",
	  "empower",
	  "envisioneer",
	  "monetize",
	  "harness",
	  "facilitate",
	  "seize",
	  "disintermediate",
	  "synergize",
	  "strategize",
	  "deploy",
	  "brand",
	  "grow",
	  "target",
	  "syndicate",
	  "synthesize",
	  "deliver",
	  "mesh",
	  "incubate",
	  "engage",
	  "maximize",
	  "benchmark",
	  "expedite",
	  "reintermediate",
	  "whiteboard",
	  "visualize",
	  "repurpose",
	  "innovate",
	  "scale",
	  "unleash",
	  "drive",
	  "extend",
	  "engineer",
	  "revolutionize",
	  "generate",
	  "exploit",
	  "transition",
	  "e-enable",
	  "iterate",
	  "cultivate",
	  "matrix",
	  "productize",
	  "redefine",
	  "recontextualize"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "24 hour",
	  "24/7",
	  "3rd generation",
	  "4th generation",
	  "5th generation",
	  "6th generation",
	  "actuating",
	  "analyzing",
	  "asymmetric",
	  "asynchronous",
	  "attitude-oriented",
	  "background",
	  "bandwidth-monitored",
	  "bi-directional",
	  "bifurcated",
	  "bottom-line",
	  "clear-thinking",
	  "client-driven",
	  "client-server",
	  "coherent",
	  "cohesive",
	  "composite",
	  "context-sensitive",
	  "contextually-based",
	  "content-based",
	  "dedicated",
	  "demand-driven",
	  "didactic",
	  "directional",
	  "discrete",
	  "disintermediate",
	  "dynamic",
	  "eco-centric",
	  "empowering",
	  "encompassing",
	  "even-keeled",
	  "executive",
	  "explicit",
	  "exuding",
	  "fault-tolerant",
	  "foreground",
	  "fresh-thinking",
	  "full-range",
	  "global",
	  "grid-enabled",
	  "heuristic",
	  "high-level",
	  "holistic",
	  "homogeneous",
	  "human-resource",
	  "hybrid",
	  "impactful",
	  "incremental",
	  "intangible",
	  "interactive",
	  "intermediate",
	  "leading edge",
	  "local",
	  "logistical",
	  "maximized",
	  "methodical",
	  "mission-critical",
	  "mobile",
	  "modular",
	  "motivating",
	  "multimedia",
	  "multi-state",
	  "multi-tasking",
	  "national",
	  "needs-based",
	  "neutral",
	  "next generation",
	  "non-volatile",
	  "object-oriented",
	  "optimal",
	  "optimizing",
	  "radical",
	  "real-time",
	  "reciprocal",
	  "regional",
	  "responsive",
	  "scalable",
	  "secondary",
	  "solution-oriented",
	  "stable",
	  "static",
	  "systematic",
	  "systemic",
	  "system-worthy",
	  "tangible",
	  "tertiary",
	  "transitional",
	  "uniform",
	  "upward-trending",
	  "user-facing",
	  "value-added",
	  "web-enabled",
	  "well-modulated",
	  "zero administration",
	  "zero defect",
	  "zero tolerance"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2698);
	company.adjective = __webpack_require__(2691);
	company.descriptor = __webpack_require__(2694);
	company.noun = __webpack_require__(2697);
	company.bs_verb = __webpack_require__(2693);
	company.bs_noun = __webpack_require__(2692);
	company.name = __webpack_require__(2696);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name} #{suffix}",
	  "#{Name.man_last_name} a #{Name.man_last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ability",
	  "access",
	  "adapter",
	  "algorithm",
	  "alliance",
	  "analyzer",
	  "application",
	  "approach",
	  "architecture",
	  "archive",
	  "artificial intelligence",
	  "array",
	  "attitude",
	  "benchmark",
	  "budgetary management",
	  "capability",
	  "capacity",
	  "challenge",
	  "circuit",
	  "collaboration",
	  "complexity",
	  "concept",
	  "conglomeration",
	  "contingency",
	  "core",
	  "customer loyalty",
	  "database",
	  "data-warehouse",
	  "definition",
	  "emulation",
	  "encoding",
	  "encryption",
	  "extranet",
	  "firmware",
	  "flexibility",
	  "focus group",
	  "forecast",
	  "frame",
	  "framework",
	  "function",
	  "functionalities",
	  "Graphic Interface",
	  "groupware",
	  "Graphical User Interface",
	  "hardware",
	  "help-desk",
	  "hierarchy",
	  "hub",
	  "implementation",
	  "info-mediaries",
	  "infrastructure",
	  "initiative",
	  "installation",
	  "instruction set",
	  "interface",
	  "internet solution",
	  "intranet",
	  "knowledge user",
	  "knowledge base",
	  "local area network",
	  "leverage",
	  "matrices",
	  "matrix",
	  "methodology",
	  "middleware",
	  "migration",
	  "model",
	  "moderator",
	  "monitoring",
	  "moratorium",
	  "neural-net",
	  "open architecture",
	  "open system",
	  "orchestration",
	  "paradigm",
	  "parallelism",
	  "policy",
	  "portal",
	  "pricing structure",
	  "process improvement",
	  "product",
	  "productivity",
	  "project",
	  "projection",
	  "protocol",
	  "secured line",
	  "service-desk",
	  "software",
	  "solution",
	  "standardization",
	  "strategy",
	  "structure",
	  "success",
	  "superstructure",
	  "support",
	  "synergy",
	  "system engine",
	  "task-force",
	  "throughput",
	  "time-frame",
	  "toolset",
	  "utilisation",
	  "website",
	  "workforce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "s.r.o.",
	  "a.s.",
	  "v.o.s."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var sk = {};
	module['exports'] = sk;
	sk.title = "Slovakian";
	sk.address = __webpack_require__(2682);
	sk.company = __webpack_require__(2695);
	sk.internet = __webpack_require__(2702);
	sk.lorem = __webpack_require__(2703);
	sk.name = __webpack_require__(2708);
	sk.phone_number = __webpack_require__(2716);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "sk",
	  "com",
	  "net",
	  "eu",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "gmail.com",
	  "zoznam.sk",
	  "azet.sk"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2701);
	internet.domain_suffix = __webpack_require__(2700);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2705);
	lorem.supplemental = __webpack_require__(2704);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "abbas",
	  "abduco",
	  "abeo",
	  "abscido",
	  "absconditus",
	  "absens",
	  "absorbeo",
	  "absque",
	  "abstergo",
	  "absum",
	  "abundans",
	  "abutor",
	  "accedo",
	  "accendo",
	  "acceptus",
	  "accipio",
	  "accommodo",
	  "accusator",
	  "acer",
	  "acerbitas",
	  "acervus",
	  "acidus",
	  "acies",
	  "acquiro",
	  "acsi",
	  "adamo",
	  "adaugeo",
	  "addo",
	  "adduco",
	  "ademptio",
	  "adeo",
	  "adeptio",
	  "adfectus",
	  "adfero",
	  "adficio",
	  "adflicto",
	  "adhaero",
	  "adhuc",
	  "adicio",
	  "adimpleo",
	  "adinventitias",
	  "adipiscor",
	  "adiuvo",
	  "administratio",
	  "admiratio",
	  "admitto",
	  "admoneo",
	  "admoveo",
	  "adnuo",
	  "adopto",
	  "adsidue",
	  "adstringo",
	  "adsuesco",
	  "adsum",
	  "adulatio",
	  "adulescens",
	  "adultus",
	  "aduro",
	  "advenio",
	  "adversus",
	  "advoco",
	  "aedificium",
	  "aeger",
	  "aegre",
	  "aegrotatio",
	  "aegrus",
	  "aeneus",
	  "aequitas",
	  "aequus",
	  "aer",
	  "aestas",
	  "aestivus",
	  "aestus",
	  "aetas",
	  "aeternus",
	  "ager",
	  "aggero",
	  "aggredior",
	  "agnitio",
	  "agnosco",
	  "ago",
	  "ait",
	  "aiunt",
	  "alienus",
	  "alii",
	  "alioqui",
	  "aliqua",
	  "alius",
	  "allatus",
	  "alo",
	  "alter",
	  "altus",
	  "alveus",
	  "amaritudo",
	  "ambitus",
	  "ambulo",
	  "amicitia",
	  "amiculum",
	  "amissio",
	  "amita",
	  "amitto",
	  "amo",
	  "amor",
	  "amoveo",
	  "amplexus",
	  "amplitudo",
	  "amplus",
	  "ancilla",
	  "angelus",
	  "angulus",
	  "angustus",
	  "animadverto",
	  "animi",
	  "animus",
	  "annus",
	  "anser",
	  "ante",
	  "antea",
	  "antepono",
	  "antiquus",
	  "aperio",
	  "aperte",
	  "apostolus",
	  "apparatus",
	  "appello",
	  "appono",
	  "appositus",
	  "approbo",
	  "apto",
	  "aptus",
	  "apud",
	  "aqua",
	  "ara",
	  "aranea",
	  "arbitro",
	  "arbor",
	  "arbustum",
	  "arca",
	  "arceo",
	  "arcesso",
	  "arcus",
	  "argentum",
	  "argumentum",
	  "arguo",
	  "arma",
	  "armarium",
	  "armo",
	  "aro",
	  "ars",
	  "articulus",
	  "artificiose",
	  "arto",
	  "arx",
	  "ascisco",
	  "ascit",
	  "asper",
	  "aspicio",
	  "asporto",
	  "assentator",
	  "astrum",
	  "atavus",
	  "ater",
	  "atqui",
	  "atrocitas",
	  "atrox",
	  "attero",
	  "attollo",
	  "attonbitus",
	  "auctor",
	  "auctus",
	  "audacia",
	  "audax",
	  "audentia",
	  "audeo",
	  "audio",
	  "auditor",
	  "aufero",
	  "aureus",
	  "auris",
	  "aurum",
	  "aut",
	  "autem",
	  "autus",
	  "auxilium",
	  "avaritia",
	  "avarus",
	  "aveho",
	  "averto",
	  "avoco",
	  "baiulus",
	  "balbus",
	  "barba",
	  "bardus",
	  "basium",
	  "beatus",
	  "bellicus",
	  "bellum",
	  "bene",
	  "beneficium",
	  "benevolentia",
	  "benigne",
	  "bestia",
	  "bibo",
	  "bis",
	  "blandior",
	  "bonus",
	  "bos",
	  "brevis",
	  "cado",
	  "caecus",
	  "caelestis",
	  "caelum",
	  "calamitas",
	  "calcar",
	  "calco",
	  "calculus",
	  "callide",
	  "campana",
	  "candidus",
	  "canis",
	  "canonicus",
	  "canto",
	  "capillus",
	  "capio",
	  "capitulus",
	  "capto",
	  "caput",
	  "carbo",
	  "carcer",
	  "careo",
	  "caries",
	  "cariosus",
	  "caritas",
	  "carmen",
	  "carpo",
	  "carus",
	  "casso",
	  "caste",
	  "casus",
	  "catena",
	  "caterva",
	  "cattus",
	  "cauda",
	  "causa",
	  "caute",
	  "caveo",
	  "cavus",
	  "cedo",
	  "celebrer",
	  "celer",
	  "celo",
	  "cena",
	  "cenaculum",
	  "ceno",
	  "censura",
	  "centum",
	  "cerno",
	  "cernuus",
	  "certe",
	  "certo",
	  "certus",
	  "cervus",
	  "cetera",
	  "charisma",
	  "chirographum",
	  "cibo",
	  "cibus",
	  "cicuta",
	  "cilicium",
	  "cimentarius",
	  "ciminatio",
	  "cinis",
	  "circumvenio",
	  "cito",
	  "civis",
	  "civitas",
	  "clam",
	  "clamo",
	  "claro",
	  "clarus",
	  "claudeo",
	  "claustrum",
	  "clementia",
	  "clibanus",
	  "coadunatio",
	  "coaegresco",
	  "coepi",
	  "coerceo",
	  "cogito",
	  "cognatus",
	  "cognomen",
	  "cogo",
	  "cohaero",
	  "cohibeo",
	  "cohors",
	  "colligo",
	  "colloco",
	  "collum",
	  "colo",
	  "color",
	  "coma",
	  "combibo",
	  "comburo",
	  "comedo",
	  "comes",
	  "cometes",
	  "comis",
	  "comitatus",
	  "commemoro",
	  "comminor",
	  "commodo",
	  "communis",
	  "comparo",
	  "compello",
	  "complectus",
	  "compono",
	  "comprehendo",
	  "comptus",
	  "conatus",
	  "concedo",
	  "concido",
	  "conculco",
	  "condico",
	  "conduco",
	  "confero",
	  "confido",
	  "conforto",
	  "confugo",
	  "congregatio",
	  "conicio",
	  "coniecto",
	  "conitor",
	  "coniuratio",
	  "conor",
	  "conqueror",
	  "conscendo",
	  "conservo",
	  "considero",
	  "conspergo",
	  "constans",
	  "consuasor",
	  "contabesco",
	  "contego",
	  "contigo",
	  "contra",
	  "conturbo",
	  "conventus",
	  "convoco",
	  "copia",
	  "copiose",
	  "cornu",
	  "corona",
	  "corpus",
	  "correptius",
	  "corrigo",
	  "corroboro",
	  "corrumpo",
	  "coruscus",
	  "cotidie",
	  "crapula",
	  "cras",
	  "crastinus",
	  "creator",
	  "creber",
	  "crebro",
	  "credo",
	  "creo",
	  "creptio",
	  "crepusculum",
	  "cresco",
	  "creta",
	  "cribro",
	  "crinis",
	  "cruciamentum",
	  "crudelis",
	  "cruentus",
	  "crur",
	  "crustulum",
	  "crux",
	  "cubicularis",
	  "cubitum",
	  "cubo",
	  "cui",
	  "cuius",
	  "culpa",
	  "culpo",
	  "cultellus",
	  "cultura",
	  "cum",
	  "cunabula",
	  "cunae",
	  "cunctatio",
	  "cupiditas",
	  "cupio",
	  "cuppedia",
	  "cupressus",
	  "cur",
	  "cura",
	  "curatio",
	  "curia",
	  "curiositas",
	  "curis",
	  "curo",
	  "curriculum",
	  "currus",
	  "cursim",
	  "curso",
	  "cursus",
	  "curto",
	  "curtus",
	  "curvo",
	  "curvus",
	  "custodia",
	  "damnatio",
	  "damno",
	  "dapifer",
	  "debeo",
	  "debilito",
	  "decens",
	  "decerno",
	  "decet",
	  "decimus",
	  "decipio",
	  "decor",
	  "decretum",
	  "decumbo",
	  "dedecor",
	  "dedico",
	  "deduco",
	  "defaeco",
	  "defendo",
	  "defero",
	  "defessus",
	  "defetiscor",
	  "deficio",
	  "defigo",
	  "defleo",
	  "defluo",
	  "defungo",
	  "degenero",
	  "degero",
	  "degusto",
	  "deinde",
	  "delectatio",
	  "delego",
	  "deleo",
	  "delibero",
	  "delicate",
	  "delinquo",
	  "deludo",
	  "demens",
	  "demergo",
	  "demitto",
	  "demo",
	  "demonstro",
	  "demoror",
	  "demulceo",
	  "demum",
	  "denego",
	  "denique",
	  "dens",
	  "denuncio",
	  "denuo",
	  "deorsum",
	  "depereo",
	  "depono",
	  "depopulo",
	  "deporto",
	  "depraedor",
	  "deprecator",
	  "deprimo",
	  "depromo",
	  "depulso",
	  "deputo",
	  "derelinquo",
	  "derideo",
	  "deripio",
	  "desidero",
	  "desino",
	  "desipio",
	  "desolo",
	  "desparatus",
	  "despecto",
	  "despirmatio",
	  "infit",
	  "inflammatio",
	  "paens",
	  "patior",
	  "patria",
	  "patrocinor",
	  "patruus",
	  "pauci",
	  "paulatim",
	  "pauper",
	  "pax",
	  "peccatus",
	  "pecco",
	  "pecto",
	  "pectus",
	  "pecunia",
	  "pecus",
	  "peior",
	  "pel",
	  "ocer",
	  "socius",
	  "sodalitas",
	  "sol",
	  "soleo",
	  "solio",
	  "solitudo",
	  "solium",
	  "sollers",
	  "sollicito",
	  "solum",
	  "solus",
	  "solutio",
	  "solvo",
	  "somniculosus",
	  "somnus",
	  "sonitus",
	  "sono",
	  "sophismata",
	  "sopor",
	  "sordeo",
	  "sortitus",
	  "spargo",
	  "speciosus",
	  "spectaculum",
	  "speculum",
	  "sperno",
	  "spero",
	  "spes",
	  "spiculum",
	  "spiritus",
	  "spoliatio",
	  "sponte",
	  "stabilis",
	  "statim",
	  "statua",
	  "stella",
	  "stillicidium",
	  "stipes",
	  "stips",
	  "sto",
	  "strenuus",
	  "strues",
	  "studio",
	  "stultus",
	  "suadeo",
	  "suasoria",
	  "sub",
	  "subito",
	  "subiungo",
	  "sublime",
	  "subnecto",
	  "subseco",
	  "substantia",
	  "subvenio",
	  "succedo",
	  "succurro",
	  "sufficio",
	  "suffoco",
	  "suffragium",
	  "suggero",
	  "sui",
	  "sulum",
	  "sum",
	  "summa",
	  "summisse",
	  "summopere",
	  "sumo",
	  "sumptus",
	  "supellex",
	  "super",
	  "suppellex",
	  "supplanto",
	  "suppono",
	  "supra",
	  "surculus",
	  "surgo",
	  "sursum",
	  "suscipio",
	  "suspendo",
	  "sustineo",
	  "suus",
	  "synagoga",
	  "tabella",
	  "tabernus",
	  "tabesco",
	  "tabgo",
	  "tabula",
	  "taceo",
	  "tactus",
	  "taedium",
	  "talio",
	  "talis",
	  "talus",
	  "tam",
	  "tamdiu",
	  "tamen",
	  "tametsi",
	  "tamisium",
	  "tamquam",
	  "tandem",
	  "tantillus",
	  "tantum",
	  "tardus",
	  "tego",
	  "temeritas",
	  "temperantia",
	  "templum",
	  "temptatio",
	  "tempus",
	  "tenax",
	  "tendo",
	  "teneo",
	  "tener",
	  "tenuis",
	  "tenus",
	  "tepesco",
	  "tepidus",
	  "ter",
	  "terebro",
	  "teres",
	  "terga",
	  "tergeo",
	  "tergiversatio",
	  "tergo",
	  "tergum",
	  "termes",
	  "terminatio",
	  "tero",
	  "terra",
	  "terreo",
	  "territo",
	  "terror",
	  "tersus",
	  "tertius",
	  "testimonium",
	  "texo",
	  "textilis",
	  "textor",
	  "textus",
	  "thalassinus",
	  "theatrum",
	  "theca",
	  "thema",
	  "theologus",
	  "thermae",
	  "thesaurus",
	  "thesis",
	  "thorax",
	  "thymbra",
	  "thymum",
	  "tibi",
	  "timidus",
	  "timor",
	  "titulus",
	  "tolero",
	  "tollo",
	  "tondeo",
	  "tonsor",
	  "torqueo",
	  "torrens",
	  "tot",
	  "totidem",
	  "toties",
	  "totus",
	  "tracto",
	  "trado",
	  "traho",
	  "trans",
	  "tredecim",
	  "tremo",
	  "trepide",
	  "tres",
	  "tribuo",
	  "tricesimus",
	  "triduana",
	  "triginta",
	  "tripudio",
	  "tristis",
	  "triumphus",
	  "trucido",
	  "truculenter",
	  "tubineus",
	  "tui",
	  "tum",
	  "tumultus",
	  "tunc",
	  "turba",
	  "turbo",
	  "turpe",
	  "turpis",
	  "tutamen",
	  "tutis",
	  "tyrannus",
	  "uberrime",
	  "ubi",
	  "ulciscor",
	  "ullus",
	  "ulterius",
	  "ultio",
	  "ultra",
	  "umbra",
	  "umerus",
	  "umquam",
	  "una",
	  "unde",
	  "undique",
	  "universe",
	  "unus",
	  "urbanus",
	  "urbs",
	  "uredo",
	  "usitas",
	  "usque",
	  "ustilo",
	  "ustulo",
	  "usus",
	  "uter",
	  "uterque",
	  "utilis",
	  "utique",
	  "utor",
	  "utpote",
	  "utrimque",
	  "utroque",
	  "utrum",
	  "uxor",
	  "vaco",
	  "vacuus",
	  "vado",
	  "vae",
	  "valde",
	  "valens",
	  "valeo",
	  "valetudo",
	  "validus",
	  "vallum",
	  "vapulus",
	  "varietas",
	  "varius",
	  "vehemens",
	  "vel",
	  "velociter",
	  "velum",
	  "velut",
	  "venia",
	  "venio",
	  "ventito",
	  "ventosus",
	  "ventus",
	  "venustas",
	  "ver",
	  "verbera",
	  "verbum",
	  "vere",
	  "verecundia",
	  "vereor",
	  "vergo",
	  "veritas",
	  "vero",
	  "versus",
	  "verto",
	  "verumtamen",
	  "verus",
	  "vesco",
	  "vesica",
	  "vesper",
	  "vespillo",
	  "vester",
	  "vestigium",
	  "vestrum",
	  "vetus",
	  "via",
	  "vicinus",
	  "vicissitudo",
	  "victoria",
	  "victus",
	  "videlicet",
	  "video",
	  "viduata",
	  "viduo",
	  "vigilo",
	  "vigor",
	  "vilicus",
	  "vilis",
	  "vilitas",
	  "villa",
	  "vinco",
	  "vinculum",
	  "vindico",
	  "vinitor",
	  "vinum",
	  "vir",
	  "virga",
	  "virgo",
	  "viridis",
	  "viriliter",
	  "virtus",
	  "vis",
	  "viscus",
	  "vita",
	  "vitiosus",
	  "vitium",
	  "vito",
	  "vivo",
	  "vix",
	  "vobis",
	  "vociferor",
	  "voco",
	  "volaticus",
	  "volo",
	  "volubilis",
	  "voluntarius",
	  "volup",
	  "volutabrum",
	  "volva",
	  "vomer",
	  "vomica",
	  "vomito",
	  "vorago",
	  "vorax",
	  "voro",
	  "vos",
	  "votum",
	  "voveo",
	  "vox",
	  "vulariter",
	  "vulgaris",
	  "vulgivagus",
	  "vulgo",
	  "vulgus",
	  "vulnero",
	  "vulnus",
	  "vulpes",
	  "vulticulus",
	  "vultuosus",
	  "xiphias"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Alexandra",
	  "Karina",
	  "Daniela",
	  "Andrea",
	  "Antónia",
	  "Bohuslava",
	  "Dáša",
	  "Malvína",
	  "Kristína",
	  "Nataša",
	  "Bohdana",
	  "Drahomíra",
	  "Sára",
	  "Zora",
	  "Tamara",
	  "Ema",
	  "Tatiana",
	  "Erika",
	  "Veronika",
	  "Agáta",
	  "Dorota",
	  "Vanda",
	  "Zoja",
	  "Gabriela",
	  "Perla",
	  "Ida",
	  "Liana",
	  "Miloslava",
	  "Vlasta",
	  "Lívia",
	  "Eleonóra",
	  "Etela",
	  "Romana",
	  "Zlatica",
	  "Anežka",
	  "Bohumila",
	  "Františka",
	  "Angela",
	  "Matilda",
	  "Svetlana",
	  "Ľubica",
	  "Alena",
	  "Soňa",
	  "Vieroslava",
	  "Zita",
	  "Miroslava",
	  "Irena",
	  "Milena",
	  "Estera",
	  "Justína",
	  "Dana",
	  "Danica",
	  "Jela",
	  "Jaroslava",
	  "Jarmila",
	  "Lea",
	  "Anastázia",
	  "Galina",
	  "Lesana",
	  "Hermína",
	  "Monika",
	  "Ingrida",
	  "Viktória",
	  "Blažena",
	  "Žofia",
	  "Sofia",
	  "Gizela",
	  "Viola",
	  "Gertrúda",
	  "Zina",
	  "Júlia",
	  "Juliana",
	  "Želmíra",
	  "Ela",
	  "Vanesa",
	  "Iveta",
	  "Vilma",
	  "Petronela",
	  "Žaneta",
	  "Xénia",
	  "Karolína",
	  "Lenka",
	  "Laura",
	  "Stanislava",
	  "Margaréta",
	  "Dobroslava",
	  "Blanka",
	  "Valéria",
	  "Paulína",
	  "Sidónia",
	  "Adriána",
	  "Beáta",
	  "Petra",
	  "Melánia",
	  "Diana",
	  "Berta",
	  "Patrícia",
	  "Lujza",
	  "Amália",
	  "Milota",
	  "Nina",
	  "Margita",
	  "Kamila",
	  "Dušana",
	  "Magdaléna",
	  "Oľga",
	  "Anna",
	  "Hana",
	  "Božena",
	  "Marta",
	  "Libuša",
	  "Božidara",
	  "Dominika",
	  "Hortenzia",
	  "Jozefína",
	  "Štefánia",
	  "Ľubomíra",
	  "Zuzana",
	  "Darina",
	  "Marcela",
	  "Milica",
	  "Elena",
	  "Helena",
	  "Lýdia",
	  "Anabela",
	  "Jana",
	  "Silvia",
	  "Nikola",
	  "Ružena",
	  "Nora",
	  "Drahoslava",
	  "Linda",
	  "Melinda",
	  "Rebeka",
	  "Rozália",
	  "Regína",
	  "Alica",
	  "Marianna",
	  "Miriama",
	  "Martina",
	  "Mária",
	  "Jolana",
	  "Ľudomila",
	  "Ľudmila",
	  "Olympia",
	  "Eugénia",
	  "Ľuboslava",
	  "Zdenka",
	  "Edita",
	  "Michaela",
	  "Stela",
	  "Viera",
	  "Natália",
	  "Eliška",
	  "Brigita",
	  "Valentína",
	  "Terézia",
	  "Vladimíra",
	  "Hedviga",
	  "Uršuľa",
	  "Alojza",
	  "Kvetoslava",
	  "Sabína",
	  "Dobromila",
	  "Klára",
	  "Simona",
	  "Aurélia",
	  "Denisa",
	  "Renáta",
	  "Irma",
	  "Agnesa",
	  "Klaudia",
	  "Alžbeta",
	  "Elvíra",
	  "Cecília",
	  "Emília",
	  "Katarína",
	  "Henrieta",
	  "Bibiána",
	  "Barbora",
	  "Marína",
	  "Izabela",
	  "Hilda",
	  "Otília",
	  "Lucia",
	  "Branislava",
	  "Bronislava",
	  "Ivica",
	  "Albína",
	  "Kornélia",
	  "Sláva",
	  "Slávka",
	  "Judita",
	  "Dagmara",
	  "Adela",
	  "Nadežda",
	  "Eva",
	  "Filoména",
	  "Ivana",
	  "Milada"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Antalová",
	  "Babková",
	  "Bahnová",
	  "Balážová",
	  "Baranová",
	  "Baranková",
	  "Bartovičová",
	  "Bartošová",
	  "Bačová",
	  "Bernoláková",
	  "Beňová",
	  "Biceková",
	  "Bieliková",
	  "Blahová",
	  "Bondrová",
	  "Bosáková",
	  "Bošková",
	  "Brezinová",
	  "Bukovská",
	  "Chalupková",
	  "Chudíková",
	  "Cibulová",
	  "Cibulková",
	  "Cyprichová",
	  "Cígerová",
	  "Danková",
	  "Daňková",
	  "Daňová",
	  "Debnárová",
	  "Dejová",
	  "Dekýšová",
	  "Doležalová",
	  "Dočolomanská",
	  "Droppová",
	  "Dubovská",
	  "Dudeková",
	  "Dulová",
	  "Dullová",
	  "Dusíková",
	  "Dvončová",
	  "Dzurjaninová",
	  "Dávidová",
	  "Fabianová",
	  "Fabiánová",
	  "Fajnorová",
	  "Farkašovská",
	  "Ficová",
	  "Filcová",
	  "Filipová",
	  "Finková",
	  "Ftoreková",
	  "Gašparová",
	  "Gašparovičová",
	  "Gocníková",
	  "Gregorová",
	  "Gregušová",
	  "Grznárová",
	  "Habláková",
	  "Habšudová",
	  "Haldová",
	  "Halušková",
	  "Haláková",
	  "Hanková",
	  "Hanzalová",
	  "Haščáková",
	  "Heretiková",
	  "Hečková",
	  "Hlaváčeková",
	  "Hlinková",
	  "Holubová",
	  "Holubyová",
	  "Hossová",
	  "Hozová",
	  "Hrašková",
	  "Hricová",
	  "Hrmová",
	  "Hrušovská",
	  "Hubová",
	  "Ihnačáková",
	  "Janečeková",
	  "Janošková",
	  "Jantošovičová",
	  "Janíková",
	  "Jančeková",
	  "Jedľovská",
	  "Jendeková",
	  "Jonatová",
	  "Jurinová",
	  "Jurkovičová",
	  "Juríková",
	  "Jánošíková",
	  "Kafendová",
	  "Kaliská",
	  "Karulová",
	  "Kenížová",
	  "Klapková",
	  "Kmeťová",
	  "Kolesárová",
	  "Kollárová",
	  "Kolniková",
	  "Kolníková",
	  "Kolárová",
	  "Korecová",
	  "Kostkaová",
	  "Kostrecová",
	  "Kováčová",
	  "Kováčiková",
	  "Kozová",
	  "Kočišová",
	  "Krajíčeková",
	  "Krajčová",
	  "Krajčovičová",
	  "Krajčírová",
	  "Králiková",
	  "Krúpová",
	  "Kubíková",
	  "Kyseľová",
	  "Kállayová",
	  "Labudová",
	  "Lepšíková",
	  "Liptáková",
	  "Lisická",
	  "Lubinová",
	  "Lukáčová",
	  "Luptáková",
	  "Líšková",
	  "Madejová",
	  "Majeská",
	  "Malachovská",
	  "Malíšeková",
	  "Mamojková",
	  "Marcinková",
	  "Mariánová",
	  "Masaryková",
	  "Maslová",
	  "Matiašková",
	  "Medveďová",
	  "Melcerová",
	  "Mečiarová",
	  "Michalíková",
	  "Mihaliková",
	  "Mihálová",
	  "Miháliková",
	  "Miklošková",
	  "Mikulíková",
	  "Mikušová",
	  "Mikúšová",
	  "Milotová",
	  "Mináčová",
	  "Mišíková",
	  "Mojžišová",
	  "Mokrošová",
	  "Morová",
	  "Moravčíková",
	  "Mydlová",
	  "Nemcová",
	  "Nováková",
	  "Obšutová",
	  "Ondrušová",
	  "Otčenášová",
	  "Pauková",
	  "Pavlikovská",
	  "Pavúková",
	  "Pašeková",
	  "Pašková",
	  "Pelikánová",
	  "Petrovická",
	  "Petrušková",
	  "Pešková",
	  "Plchová",
	  "Plekanecová",
	  "Podhradská",
	  "Podkonická",
	  "Poliaková",
	  "Pupáková",
	  "Raková",
	  "Repiská",
	  "Romančíková",
	  "Rusová",
	  "Ružičková",
	  "Rybníčeková",
	  "Rybárová",
	  "Rybáriková",
	  "Samsonová",
	  "Sedliaková",
	  "Senková",
	  "Sklenková",
	  "Skokanová",
	  "Skutecká",
	  "Slašťanová",
	  "Slobodová",
	  "Slobodníková",
	  "Slotová",
	  "Slováková",
	  "Smreková",
	  "Stodolová",
	  "Straková",
	  "Strnisková",
	  "Svrbíková",
	  "Sámelová",
	  "Sýkorová",
	  "Tatarová",
	  "Tatarková",
	  "Tatárová",
	  "Tatárkaová",
	  "Thomková",
	  "Tomečeková",
	  "Tomková",
	  "Trubenová",
	  "Turčoková",
	  "Uramová",
	  "Urblíková",
	  "Vajcíková",
	  "Vajdová",
	  "Valachová",
	  "Valachovičová",
	  "Valentová",
	  "Valušková",
	  "Vaneková",
	  "Veselová",
	  "Vicenová",
	  "Višňovská",
	  "Vlachová",
	  "Vojteková",
	  "Vydarená",
	  "Zajacová",
	  "Zimová",
	  "Zimková",
	  "Záborská",
	  "Zúbriková",
	  "Čapkovičová",
	  "Čaplovičová",
	  "Čarnogurská",
	  "Čierná",
	  "Čobrdová",
	  "Ďaďová",
	  "Ďuricová",
	  "Ďurišová",
	  "Šidlová",
	  "Šimonovičová",
	  "Škriniarová",
	  "Škultétyová",
	  "Šmajdová",
	  "Šoltésová",
	  "Šoltýsová",
	  "Štefanová",
	  "Štefanková",
	  "Šulcová",
	  "Šurková",
	  "Švehlová",
	  "Šťastná"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(2709);
	name.female_first_name = __webpack_require__(2706);
	name.male_last_name = __webpack_require__(2710);
	name.female_last_name = __webpack_require__(2707);
	name.prefix = __webpack_require__(2712);
	name.suffix = __webpack_require__(2713);
	name.title = __webpack_require__(2714);
	name.name = __webpack_require__(2711);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Drahoslav",
	  "Severín",
	  "Alexej",
	  "Ernest",
	  "Rastislav",
	  "Radovan",
	  "Dobroslav",
	  "Dalibor",
	  "Vincent",
	  "Miloš",
	  "Timotej",
	  "Gejza",
	  "Bohuš",
	  "Alfonz",
	  "Gašpar",
	  "Emil",
	  "Erik",
	  "Blažej",
	  "Zdenko",
	  "Dezider",
	  "Arpád",
	  "Valentín",
	  "Pravoslav",
	  "Jaromír",
	  "Roman",
	  "Matej",
	  "Frederik",
	  "Viktor",
	  "Alexander",
	  "Radomír",
	  "Albín",
	  "Bohumil",
	  "Kazimír",
	  "Fridrich",
	  "Radoslav",
	  "Tomáš",
	  "Alan",
	  "Branislav",
	  "Bruno",
	  "Gregor",
	  "Vlastimil",
	  "Boleslav",
	  "Eduard",
	  "Jozef",
	  "Víťazoslav",
	  "Blahoslav",
	  "Beňadik",
	  "Adrián",
	  "Gabriel",
	  "Marián",
	  "Emanuel",
	  "Miroslav",
	  "Benjamín",
	  "Hugo",
	  "Richard",
	  "Izidor",
	  "Zoltán",
	  "Albert",
	  "Igor",
	  "Július",
	  "Aleš",
	  "Fedor",
	  "Rudolf",
	  "Valér",
	  "Marcel",
	  "Ervín",
	  "Slavomír",
	  "Vojtech",
	  "Juraj",
	  "Marek",
	  "Jaroslav",
	  "Žigmund",
	  "Florián",
	  "Roland",
	  "Pankrác",
	  "Servác",
	  "Bonifác",
	  "Svetozár",
	  "Bernard",
	  "Júlia",
	  "Urban",
	  "Dušan",
	  "Viliam",
	  "Ferdinand",
	  "Norbert",
	  "Róbert",
	  "Medard",
	  "Zlatko",
	  "Anton",
	  "Vasil",
	  "Vít",
	  "Adolf",
	  "Vratislav",
	  "Alfréd",
	  "Alojz",
	  "Ján",
	  "Tadeáš",
	  "Ladislav",
	  "Peter",
	  "Pavol",
	  "Miloslav",
	  "Prokop",
	  "Cyril",
	  "Metod",
	  "Patrik",
	  "Oliver",
	  "Ivan",
	  "Kamil",
	  "Henrich",
	  "Drahomír",
	  "Bohuslav",
	  "Iľja",
	  "Daniel",
	  "Vladimír",
	  "Jakub",
	  "Krištof",
	  "Ignác",
	  "Gustáv",
	  "Jerguš",
	  "Dominik",
	  "Oskar",
	  "Vavrinec",
	  "Ľubomír",
	  "Mojmír",
	  "Leonard",
	  "Tichomír",
	  "Filip",
	  "Bartolomej",
	  "Ľudovít",
	  "Samuel",
	  "Augustín",
	  "Belo",
	  "Oleg",
	  "Bystrík",
	  "Ctibor",
	  "Ľudomil",
	  "Konštantín",
	  "Ľuboslav",
	  "Matúš",
	  "Móric",
	  "Ľuboš",
	  "Ľubor",
	  "Vladislav",
	  "Cyprián",
	  "Václav",
	  "Michal",
	  "Jarolím",
	  "Arnold",
	  "Levoslav",
	  "František",
	  "Dionýz",
	  "Maximilián",
	  "Koloman",
	  "Boris",
	  "Lukáš",
	  "Kristián",
	  "Vendelín",
	  "Sergej",
	  "Aurel",
	  "Demeter",
	  "Denis",
	  "Hubert",
	  "Karol",
	  "Imrich",
	  "René",
	  "Bohumír",
	  "Teodor",
	  "Tibor",
	  "Maroš",
	  "Martin",
	  "Svätopluk",
	  "Stanislav",
	  "Leopold",
	  "Eugen",
	  "Félix",
	  "Klement",
	  "Kornel",
	  "Milan",
	  "Vratko",
	  "Ondrej",
	  "Andrej",
	  "Edmund",
	  "Oldrich",
	  "Oto",
	  "Mikuláš",
	  "Ambróz",
	  "Radúz",
	  "Bohdan",
	  "Adam",
	  "Štefan",
	  "Dávid",
	  "Silvester"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Antal",
	  "Babka",
	  "Bahna",
	  "Bahno",
	  "Baláž",
	  "Baran",
	  "Baranka",
	  "Bartovič",
	  "Bartoš",
	  "Bača",
	  "Bernolák",
	  "Beňo",
	  "Bicek",
	  "Bielik",
	  "Blaho",
	  "Bondra",
	  "Bosák",
	  "Boška",
	  "Brezina",
	  "Bukovský",
	  "Chalupka",
	  "Chudík",
	  "Cibula",
	  "Cibulka",
	  "Cibuľa",
	  "Cyprich",
	  "Cíger",
	  "Danko",
	  "Daňko",
	  "Daňo",
	  "Debnár",
	  "Dej",
	  "Dekýš",
	  "Doležal",
	  "Dočolomanský",
	  "Droppa",
	  "Dubovský",
	  "Dudek",
	  "Dula",
	  "Dulla",
	  "Dusík",
	  "Dvonč",
	  "Dzurjanin",
	  "Dávid",
	  "Fabian",
	  "Fabián",
	  "Fajnor",
	  "Farkašovský",
	  "Fico",
	  "Filc",
	  "Filip",
	  "Finka",
	  "Ftorek",
	  "Gašpar",
	  "Gašparovič",
	  "Gocník",
	  "Gregor",
	  "Greguš",
	  "Grznár",
	  "Hablák",
	  "Habšuda",
	  "Halda",
	  "Haluška",
	  "Halák",
	  "Hanko",
	  "Hanzal",
	  "Haščák",
	  "Heretik",
	  "Hečko",
	  "Hlaváček",
	  "Hlinka",
	  "Holub",
	  "Holuby",
	  "Hossa",
	  "Hoza",
	  "Hraško",
	  "Hric",
	  "Hrmo",
	  "Hrušovský",
	  "Huba",
	  "Ihnačák",
	  "Janeček",
	  "Janoška",
	  "Jantošovič",
	  "Janík",
	  "Janček",
	  "Jedľovský",
	  "Jendek",
	  "Jonata",
	  "Jurina",
	  "Jurkovič",
	  "Jurík",
	  "Jánošík",
	  "Kafenda",
	  "Kaliský",
	  "Karul",
	  "Keníž",
	  "Klapka",
	  "Kmeť",
	  "Kolesár",
	  "Kollár",
	  "Kolnik",
	  "Kolník",
	  "Kolár",
	  "Korec",
	  "Kostka",
	  "Kostrec",
	  "Kováč",
	  "Kováčik",
	  "Koza",
	  "Kočiš",
	  "Krajíček",
	  "Krajči",
	  "Krajčo",
	  "Krajčovič",
	  "Krajčír",
	  "Králik",
	  "Krúpa",
	  "Kubík",
	  "Kyseľ",
	  "Kállay",
	  "Labuda",
	  "Lepšík",
	  "Lipták",
	  "Lisický",
	  "Lubina",
	  "Lukáč",
	  "Lupták",
	  "Líška",
	  "Madej",
	  "Majeský",
	  "Malachovský",
	  "Malíšek",
	  "Mamojka",
	  "Marcinko",
	  "Marián",
	  "Masaryk",
	  "Maslo",
	  "Matiaško",
	  "Medveď",
	  "Melcer",
	  "Mečiar",
	  "Michalík",
	  "Mihalik",
	  "Mihál",
	  "Mihálik",
	  "Mikloško",
	  "Mikulík",
	  "Mikuš",
	  "Mikúš",
	  "Milota",
	  "Mináč",
	  "Mišík",
	  "Mojžiš",
	  "Mokroš",
	  "Mora",
	  "Moravčík",
	  "Mydlo",
	  "Nemec",
	  "Nitra",
	  "Novák",
	  "Obšut",
	  "Ondruš",
	  "Otčenáš",
	  "Pauko",
	  "Pavlikovský",
	  "Pavúk",
	  "Pašek",
	  "Paška",
	  "Paško",
	  "Pelikán",
	  "Petrovický",
	  "Petruška",
	  "Peško",
	  "Plch",
	  "Plekanec",
	  "Podhradský",
	  "Podkonický",
	  "Poliak",
	  "Pupák",
	  "Rak",
	  "Repiský",
	  "Romančík",
	  "Rus",
	  "Ružička",
	  "Rybníček",
	  "Rybár",
	  "Rybárik",
	  "Samson",
	  "Sedliak",
	  "Senko",
	  "Sklenka",
	  "Skokan",
	  "Skutecký",
	  "Slašťan",
	  "Sloboda",
	  "Slobodník",
	  "Slota",
	  "Slovák",
	  "Smrek",
	  "Stodola",
	  "Straka",
	  "Strnisko",
	  "Svrbík",
	  "Sámel",
	  "Sýkora",
	  "Tatar",
	  "Tatarka",
	  "Tatár",
	  "Tatárka",
	  "Thomka",
	  "Tomeček",
	  "Tomka",
	  "Tomko",
	  "Truben",
	  "Turčok",
	  "Uram",
	  "Urblík",
	  "Vajcík",
	  "Vajda",
	  "Valach",
	  "Valachovič",
	  "Valent",
	  "Valuška",
	  "Vanek",
	  "Vesel",
	  "Vicen",
	  "Višňovský",
	  "Vlach",
	  "Vojtek",
	  "Vydarený",
	  "Zajac",
	  "Zima",
	  "Zimka",
	  "Záborský",
	  "Zúbrik",
	  "Čapkovič",
	  "Čaplovič",
	  "Čarnogurský",
	  "Čierny",
	  "Čobrda",
	  "Ďaďo",
	  "Ďurica",
	  "Ďuriš",
	  "Šidlo",
	  "Šimonovič",
	  "Škriniar",
	  "Škultéty",
	  "Šmajda",
	  "Šoltés",
	  "Šoltýs",
	  "Štefan",
	  "Štefanka",
	  "Šulc",
	  "Šurka",
	  "Švehla",
	  "Šťastný"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{man_first_name} #{man_last_name}",
	  "#{prefix} #{woman_first_name} #{woman_last_name}",
	  "#{man_first_name} #{man_last_name} #{suffix}",
	  "#{woman_first_name} #{woman_last_name} #{suffix}",
	  "#{man_first_name} #{man_last_name}",
	  "#{man_first_name} #{man_last_name}",
	  "#{man_first_name} #{man_last_name}",
	  "#{woman_first_name} #{woman_last_name}",
	  "#{woman_first_name} #{woman_last_name}",
	  "#{woman_first_name} #{woman_last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ing.",
	  "Mgr.",
	  "JUDr.",
	  "MUDr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Phd."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "09## ### ###",
	  "0## #### ####",
	  "0# #### ####",
	  "+421 ### ### ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2715);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Söder",
	  "Norr",
	  "Väst",
	  "Öster",
	  "Aling",
	  "Ar",
	  "Av",
	  "Bo",
	  "Br",
	  "Bå",
	  "Ek",
	  "En",
	  "Esk",
	  "Fal",
	  "Gäv",
	  "Göte",
	  "Ha",
	  "Helsing",
	  "Karl",
	  "Krist",
	  "Kram",
	  "Kung",
	  "Kö",
	  "Lyck",
	  "Ny"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "stad",
	  "land",
	  "sås",
	  "ås",
	  "holm",
	  "tuna",
	  "sta",
	  "berg",
	  "löv",
	  "borg",
	  "mora",
	  "hamn",
	  "fors",
	  "köping",
	  "by",
	  "hult",
	  "torp",
	  "fred",
	  "vik"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "s Väg",
	  "s Gata"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Ryssland",
	  "Kanada",
	  "Kina",
	  "USA",
	  "Brasilien",
	  "Australien",
	  "Indien",
	  "Argentina",
	  "Kazakstan",
	  "Algeriet",
	  "DR Kongo",
	  "Danmark",
	  "Färöarna",
	  "Grönland",
	  "Saudiarabien",
	  "Mexiko",
	  "Indonesien",
	  "Sudan",
	  "Libyen",
	  "Iran",
	  "Mongoliet",
	  "Peru",
	  "Tchad",
	  "Niger",
	  "Angola",
	  "Mali",
	  "Sydafrika",
	  "Colombia",
	  "Etiopien",
	  "Bolivia",
	  "Mauretanien",
	  "Egypten",
	  "Tanzania",
	  "Nigeria",
	  "Venezuela",
	  "Namibia",
	  "Pakistan",
	  "Moçambique",
	  "Turkiet",
	  "Chile",
	  "Zambia",
	  "Marocko",
	  "Västsahara",
	  "Burma",
	  "Afghanistan",
	  "Somalia",
	  "Centralafrikanska republiken",
	  "Sydsudan",
	  "Ukraina",
	  "Botswana",
	  "Madagaskar",
	  "Kenya",
	  "Frankrike",
	  "Franska Guyana",
	  "Jemen",
	  "Thailand",
	  "Spanien",
	  "Turkmenistan",
	  "Kamerun",
	  "Papua Nya Guinea",
	  "Sverige",
	  "Uzbekistan",
	  "Irak",
	  "Paraguay",
	  "Zimbabwe",
	  "Japan",
	  "Tyskland",
	  "Kongo",
	  "Finland",
	  "Malaysia",
	  "Vietnam",
	  "Norge",
	  "Svalbard",
	  "Jan Mayen",
	  "Elfenbenskusten",
	  "Polen",
	  "Italien",
	  "Filippinerna",
	  "Ecuador",
	  "Burkina Faso",
	  "Nya Zeeland",
	  "Gabon",
	  "Guinea",
	  "Storbritannien",
	  "Ghana",
	  "Rumänien",
	  "Laos",
	  "Uganda",
	  "Guyana",
	  "Oman",
	  "Vitryssland",
	  "Kirgizistan",
	  "Senegal",
	  "Syrien",
	  "Kambodja",
	  "Uruguay",
	  "Tunisien",
	  "Surinam",
	  "Nepal",
	  "Bangladesh",
	  "Tadzjikistan",
	  "Grekland",
	  "Nicaragua",
	  "Eritrea",
	  "Nordkorea",
	  "Malawi",
	  "Benin",
	  "Honduras",
	  "Liberia",
	  "Bulgarien",
	  "Kuba",
	  "Guatemala",
	  "Island",
	  "Sydkorea",
	  "Ungern",
	  "Portugal",
	  "Jordanien",
	  "Serbien",
	  "Azerbajdzjan",
	  "Österrike",
	  "Förenade Arabemiraten",
	  "Tjeckien",
	  "Panama",
	  "Sierra Leone",
	  "Irland",
	  "Georgien",
	  "Sri Lanka",
	  "Litauen",
	  "Lettland",
	  "Togo",
	  "Kroatien",
	  "Bosnien och Hercegovina",
	  "Costa Rica",
	  "Slovakien",
	  "Dominikanska republiken",
	  "Bhutan",
	  "Estland",
	  "Danmark",
	  "Färöarna",
	  "Grönland",
	  "Nederländerna",
	  "Schweiz",
	  "Guinea-Bissau",
	  "Taiwan",
	  "Moldavien",
	  "Belgien",
	  "Lesotho",
	  "Armenien",
	  "Albanien",
	  "Salomonöarna",
	  "Ekvatorialguinea",
	  "Burundi",
	  "Haiti",
	  "Rwanda",
	  "Makedonien",
	  "Djibouti",
	  "Belize",
	  "Israel",
	  "El Salvador",
	  "Slovenien",
	  "Fiji",
	  "Kuwait",
	  "Swaziland",
	  "Timor-Leste",
	  "Montenegro",
	  "Bahamas",
	  "Vanuatu",
	  "Qatar",
	  "Gambia",
	  "Jamaica",
	  "Kosovo",
	  "Libanon",
	  "Cypern",
	  "Brunei",
	  "Trinidad och Tobago",
	  "Kap Verde",
	  "Samoa",
	  "Luxemburg",
	  "Komorerna",
	  "Mauritius",
	  "São Tomé och Príncipe",
	  "Kiribati",
	  "Dominica",
	  "Tonga",
	  "Mikronesiens federerade stater",
	  "Singapore",
	  "Bahrain",
	  "Saint Lucia",
	  "Andorra",
	  "Palau",
	  "Seychellerna",
	  "Antigua och Barbuda",
	  "Barbados",
	  "Saint Vincent och Grenadinerna",
	  "Grenada",
	  "Malta",
	  "Maldiverna",
	  "Saint Kitts och Nevis",
	  "Marshallöarna",
	  "Liechtenstein",
	  "San Marino",
	  "Tuvalu",
	  "Nauru",
	  "Monaco",
	  "Vatikanstaten"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Sverige"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2719);
	address.city_suffix = __webpack_require__(2720);
	address.country = __webpack_require__(2722);
	address.common_street_suffix = __webpack_require__(2721);
	address.street_prefix = __webpack_require__(2730);
	address.street_root = __webpack_require__(2731);
	address.street_suffix = __webpack_require__(2732);
	address.state = __webpack_require__(2727);
	address.city = __webpack_require__(2718);
	address.street_name = __webpack_require__(2729);
	address.postcode = __webpack_require__(2725);
	address.building_number = __webpack_require__(2717);
	address.secondary_address = __webpack_require__(2726);
	address.street_address = __webpack_require__(2728);
	address.default_country = __webpack_require__(2723);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Lgh. ###",
	  "Hus ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Blekinge",
	  "Dalarna",
	  "Gotland",
	  "Gävleborg",
	  "Göteborg",
	  "Halland",
	  "Jämtland",
	  "Jönköping",
	  "Kalmar",
	  "Kronoberg",
	  "Norrbotten",
	  "Skaraborg",
	  "Skåne",
	  "Stockholm",
	  "Södermanland",
	  "Uppsala",
	  "Värmland",
	  "Västerbotten",
	  "Västernorrland",
	  "Västmanland",
	  "Älvsborg",
	  "Örebro",
	  "Östergötland"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}#{street_suffix}",
	  "#{street_prefix} #{street_root}#{street_suffix}",
	  "#{Name.first_name}#{common_street_suffix}",
	  "#{Name.last_name}#{common_street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Västra",
	  "Östra",
	  "Norra",
	  "Södra",
	  "Övre",
	  "Undre"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Björk",
	  "Järnvägs",
	  "Ring",
	  "Skol",
	  "Skogs",
	  "Ny",
	  "Gran",
	  "Idrotts",
	  "Stor",
	  "Kyrk",
	  "Industri",
	  "Park",
	  "Strand",
	  "Skol",
	  "Trädgård",
	  "Ängs",
	  "Kyrko",
	  "Villa",
	  "Ek",
	  "Kvarn",
	  "Stations",
	  "Back",
	  "Furu",
	  "Gen",
	  "Fabriks",
	  "Åker",
	  "Bäck",
	  "Asp"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "vägen",
	  "gatan",
	  "gränden",
	  "gärdet",
	  "allén"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  56,
	  62,
	  59
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{common_cell_prefix}-###-####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.common_cell_prefix = __webpack_require__(2733);
	cell_phone.formats = __webpack_require__(2734);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "vit",
	  "silver",
	  "grå",
	  "svart",
	  "röd",
	  "grön",
	  "blå",
	  "gul",
	  "lila",
	  "indigo",
	  "guld",
	  "brun",
	  "rosa",
	  "purpur",
	  "korall"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Böcker",
	  "Filmer",
	  "Musik",
	  "Spel",
	  "Elektronik",
	  "Datorer",
	  "Hem",
	  "Trädgård",
	  "Verktyg",
	  "Livsmedel",
	  "Hälsa",
	  "Skönhet",
	  "Leksaker",
	  "Klädsel",
	  "Skor",
	  "Smycken",
	  "Sport"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var commerce = {};
	module['exports'] = commerce;
	commerce.color = __webpack_require__(2736);
	commerce.department = __webpack_require__(2737);
	commerce.product_name = __webpack_require__(2739);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "adjective": [
	    "Liten",
	    "Ergonomisk",
	    "Robust",
	    "Intelligent",
	    "Söt",
	    "Otrolig",
	    "Fatastisk",
	    "Praktisk",
	    "Slimmad",
	    "Grym"
	  ],
	  "material": [
	    "Stål",
	    "Metall",
	    "Trä",
	    "Betong",
	    "Plast",
	    "Bomul",
	    "Grnit",
	    "Gummi",
	    "Latex"
	  ],
	  "product": [
	    "Stol",
	    "Bil",
	    "Dator",
	    "Handskar",
	    "Pants",
	    "Shirt",
	    "Table",
	    "Shoes",
	    "Hat"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.suffix = __webpack_require__(2742);
	company.name = __webpack_require__(2741);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name} #{suffix}",
	  "#{Name.last_name}-#{Name.last_name}",
	  "#{Name.last_name}, #{Name.last_name} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Gruppen",
	  "AB",
	  "HB",
	  "Group",
	  "Investment",
	  "Kommanditbolag",
	  "Aktiebolag"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var date = {};
	module["exports"] = date;
	date.month = __webpack_require__(2744);
	date.weekday = __webpack_require__(2745);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1799
	module["exports"] = {
	  wide: [
	    "januari",
	    "februari",
	    "mars",
	    "april",
	    "maj",
	    "juni",
	    "juli",
	    "augusti",
	    "september",
	    "oktober",
	    "november",
	    "december"
	  ],
	  abbr: [
	    "jan",
	    "feb",
	    "mar",
	    "apr",
	    "maj",
	    "jun",
	    "jul",
	    "aug",
	    "sep",
	    "okt",
	    "nov",
	    "dec"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
	module["exports"] = {
	  wide: [
	    "söndag",
	    "måndag",
	    "tisdag",
	    "onsdag",
	    "torsdag",
	    "fredag",
	    "lördag"
	  ],
	  abbr: [
	    "sön",
	    "mån",
	    "tis",
	    "ons",
	    "tor",
	    "fre",
	    "lör"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var sv = {};
	module['exports'] = sv;
	sv.title = "Swedish";
	sv.address = __webpack_require__(2724);
	sv.company = __webpack_require__(2740);
	sv.internet = __webpack_require__(2748);
	sv.name = __webpack_require__(2751);
	sv.phone_number = __webpack_require__(2757);
	sv.cell_phone = __webpack_require__(2735);
	sv.commerce = __webpack_require__(2738);
	sv.team = __webpack_require__(2758);
	sv.date = __webpack_require__(2743);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "se",
	  "nu",
	  "info",
	  "com",
	  "org"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2747);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Erik",
	  "Lars",
	  "Karl",
	  "Anders",
	  "Per",
	  "Johan",
	  "Nils",
	  "Lennart",
	  "Emil",
	  "Hans"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Maria",
	  "Anna",
	  "Margareta",
	  "Elisabeth",
	  "Eva",
	  "Birgitta",
	  "Kristina",
	  "Karin",
	  "Elisabet",
	  "Marie"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name_women = __webpack_require__(2750);
	name.first_name_men = __webpack_require__(2749);
	name.last_name = __webpack_require__(2752);
	name.prefix = __webpack_require__(2754);
	name.title = __webpack_require__(2755);
	name.name = __webpack_require__(2753);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Johansson",
	  "Andersson",
	  "Karlsson",
	  "Nilsson",
	  "Eriksson",
	  "Larsson",
	  "Olsson",
	  "Persson",
	  "Svensson",
	  "Gustafsson"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{first_name_women} #{last_name}",
	  "#{first_name_men} #{last_name}",
	  "#{prefix} #{first_name_men} #{last_name}",
	  "#{prefix} #{first_name_women} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Dr.",
	  "Prof.",
	  "PhD."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Lead",
	    "Senior",
	    "Direct",
	    "Corporate",
	    "Dynamic",
	    "Future",
	    "Product",
	    "National",
	    "Regional",
	    "District",
	    "Central",
	    "Global",
	    "Customer",
	    "Investor",
	    "Dynamic",
	    "International",
	    "Legacy",
	    "Forward",
	    "Internal",
	    "Human",
	    "Chief",
	    "Principal"
	  ],
	  "level": [
	    "Solutions",
	    "Program",
	    "Brand",
	    "Security",
	    "Research",
	    "Marketing",
	    "Directives",
	    "Implementation",
	    "Integration",
	    "Functionality",
	    "Response",
	    "Paradigm",
	    "Tactics",
	    "Identity",
	    "Markets",
	    "Group",
	    "Division",
	    "Applications",
	    "Optimization",
	    "Operations",
	    "Infrastructure",
	    "Intranet",
	    "Communications",
	    "Web",
	    "Branding",
	    "Quality",
	    "Assurance",
	    "Mobility",
	    "Accounts",
	    "Data",
	    "Creative",
	    "Configuration",
	    "Accountability",
	    "Interactions",
	    "Factors",
	    "Usability",
	    "Metrics"
	  ],
	  "job": [
	    "Supervisor",
	    "Associate",
	    "Executive",
	    "Liason",
	    "Officer",
	    "Manager",
	    "Engineer",
	    "Specialist",
	    "Director",
	    "Coordinator",
	    "Administrator",
	    "Architect",
	    "Analyst",
	    "Designer",
	    "Planner",
	    "Orchestrator",
	    "Technician",
	    "Developer",
	    "Producer",
	    "Consultant",
	    "Assistant",
	    "Facilitator",
	    "Agent",
	    "Representative",
	    "Strategist"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####-#####",
	  "####-######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2756);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var team = {};
	module['exports'] = team;
	team.suffix = __webpack_require__(2760);
	team.name = __webpack_require__(2759);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Address.city} #{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "IF",
	  "FF",
	  "BK",
	  "HK",
	  "AIF",
	  "SK",
	  "FC",
	  "SK",
	  "BoIS",
	  "FK",
	  "BIS",
	  "FIF",
	  "IK"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###",
	  "##",
	  "#",
	  "##a",
	  "##b",
	  "##c"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Adana",
	  "Adıyaman",
	  "Afyon",
	  "Ağrı",
	  "Amasya",
	  "Ankara",
	  "Antalya",
	  "Artvin",
	  "Aydın",
	  "Balıkesir",
	  "Bilecik",
	  "Bingöl",
	  "Bitlis",
	  "Bolu",
	  "Burdur",
	  "Bursa",
	  "Çanakkale",
	  "Çankırı",
	  "Çorum",
	  "Denizli",
	  "Diyarbakır",
	  "Edirne",
	  "Elazığ",
	  "Erzincan",
	  "Erzurum",
	  "Eskişehir",
	  "Gaziantep",
	  "Giresun",
	  "Gümüşhane",
	  "Hakkari",
	  "Hatay",
	  "Isparta",
	  "İçel (Mersin)",
	  "İstanbul",
	  "İzmir",
	  "Kars",
	  "Kastamonu",
	  "Kayseri",
	  "Kırklareli",
	  "Kırşehir",
	  "Kocaeli",
	  "Konya",
	  "Kütahya",
	  "Malatya",
	  "Manisa",
	  "K.maraş",
	  "Mardin",
	  "Muğla",
	  "Muş",
	  "Nevşehir",
	  "Niğde",
	  "Ordu",
	  "Rize",
	  "Sakarya",
	  "Samsun",
	  "Siirt",
	  "Sinop",
	  "Sivas",
	  "Tekirdağ",
	  "Tokat",
	  "Trabzon",
	  "Tunceli",
	  "Şanlıurfa",
	  "Uşak",
	  "Van",
	  "Yozgat",
	  "Zonguldak",
	  "Aksaray",
	  "Bayburt",
	  "Karaman",
	  "Kırıkkale",
	  "Batman",
	  "Şırnak",
	  "Bartın",
	  "Ardahan",
	  "Iğdır",
	  "Yalova",
	  "Karabük",
	  "Kilis",
	  "Osmaniye",
	  "Düzce"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Afganistan",
	  "Almanya",
	  "Amerika Birleşik Devletleri",
	  "Amerikan Samoa",
	  "Andorra",
	  "Angola",
	  "Anguilla, İngiltere",
	  "Antigua ve Barbuda",
	  "Arjantin",
	  "Arnavutluk",
	  "Aruba, Hollanda",
	  "Avustralya",
	  "Avusturya",
	  "Azerbaycan",
	  "Bahama Adaları",
	  "Bahreyn",
	  "Bangladeş",
	  "Barbados",
	  "Belçika",
	  "Belize",
	  "Benin",
	  "Bermuda, İngiltere",
	  "Beyaz Rusya",
	  "Bhutan",
	  "Birleşik Arap Emirlikleri",
	  "Birmanya (Myanmar)",
	  "Bolivya",
	  "Bosna Hersek",
	  "Botswana",
	  "Brezilya",
	  "Brunei",
	  "Bulgaristan",
	  "Burkina Faso",
	  "Burundi",
	  "Cape Verde",
	  "Cayman Adaları, İngiltere",
	  "Cebelitarık, İngiltere",
	  "Cezayir",
	  "Christmas Adası , Avusturalya",
	  "Cibuti",
	  "Çad",
	  "Çek Cumhuriyeti",
	  "Çin",
	  "Danimarka",
	  "Doğu Timor",
	  "Dominik Cumhuriyeti",
	  "Dominika",
	  "Ekvator",
	  "Ekvator Ginesi",
	  "El Salvador",
	  "Endonezya",
	  "Eritre",
	  "Ermenistan",
	  "Estonya",
	  "Etiyopya",
	  "Fas",
	  "Fiji",
	  "Fildişi Sahili",
	  "Filipinler",
	  "Filistin",
	  "Finlandiya",
	  "Folkland Adaları, İngiltere",
	  "Fransa",
	  "Fransız Guyanası",
	  "Fransız Güney Eyaletleri (Kerguelen Adaları)",
	  "Fransız Polinezyası",
	  "Gabon",
	  "Galler",
	  "Gambiya",
	  "Gana",
	  "Gine",
	  "Gine-Bissau",
	  "Grenada",
	  "Grönland",
	  "Guadalup, Fransa",
	  "Guam, Amerika",
	  "Guatemala",
	  "Guyana",
	  "Güney Afrika",
	  "Güney Georgia ve Güney Sandviç Adaları, İngiltere",
	  "Güney Kıbrıs Rum Yönetimi",
	  "Güney Kore",
	  "Gürcistan H",
	  "Haiti",
	  "Hırvatistan",
	  "Hindistan",
	  "Hollanda",
	  "Hollanda Antilleri",
	  "Honduras",
	  "Irak",
	  "İngiltere",
	  "İran",
	  "İrlanda",
	  "İspanya",
	  "İsrail",
	  "İsveç",
	  "İsviçre",
	  "İtalya",
	  "İzlanda",
	  "Jamaika",
	  "Japonya",
	  "Johnston Atoll, Amerika",
	  "K.K.T.C.",
	  "Kamboçya",
	  "Kamerun",
	  "Kanada",
	  "Kanarya Adaları",
	  "Karadağ",
	  "Katar",
	  "Kazakistan",
	  "Kenya",
	  "Kırgızistan",
	  "Kiribati",
	  "Kolombiya",
	  "Komorlar",
	  "Kongo",
	  "Kongo Demokratik Cumhuriyeti",
	  "Kosova",
	  "Kosta Rika",
	  "Kuveyt",
	  "Kuzey İrlanda",
	  "Kuzey Kore",
	  "Kuzey Maryana Adaları",
	  "Küba",
	  "Laos",
	  "Lesotho",
	  "Letonya",
	  "Liberya",
	  "Libya",
	  "Liechtenstein",
	  "Litvanya",
	  "Lübnan",
	  "Lüksemburg",
	  "Macaristan",
	  "Madagaskar",
	  "Makau (Makao)",
	  "Makedonya",
	  "Malavi",
	  "Maldiv Adaları",
	  "Malezya",
	  "Mali",
	  "Malta",
	  "Marşal Adaları",
	  "Martinik, Fransa",
	  "Mauritius",
	  "Mayotte, Fransa",
	  "Meksika",
	  "Mısır",
	  "Midway Adaları, Amerika",
	  "Mikronezya",
	  "Moğolistan",
	  "Moldavya",
	  "Monako",
	  "Montserrat",
	  "Moritanya",
	  "Mozambik",
	  "Namibia",
	  "Nauru",
	  "Nepal",
	  "Nijer",
	  "Nijerya",
	  "Nikaragua",
	  "Niue, Yeni Zelanda",
	  "Norveç",
	  "Orta Afrika Cumhuriyeti",
	  "Özbekistan",
	  "Pakistan",
	  "Palau Adaları",
	  "Palmyra Atoll, Amerika",
	  "Panama",
	  "Papua Yeni Gine",
	  "Paraguay",
	  "Peru",
	  "Polonya",
	  "Portekiz",
	  "Porto Riko, Amerika",
	  "Reunion, Fransa",
	  "Romanya",
	  "Ruanda",
	  "Rusya Federasyonu",
	  "Saint Helena, İngiltere",
	  "Saint Martin, Fransa",
	  "Saint Pierre ve Miquelon, Fransa",
	  "Samoa",
	  "San Marino",
	  "Santa Kitts ve Nevis",
	  "Santa Lucia",
	  "Santa Vincent ve Grenadinler",
	  "Sao Tome ve Principe",
	  "Senegal",
	  "Seyşeller",
	  "Sırbistan",
	  "Sierra Leone",
	  "Singapur",
	  "Slovakya",
	  "Slovenya",
	  "Solomon Adaları",
	  "Somali",
	  "Sri Lanka",
	  "Sudan",
	  "Surinam",
	  "Suriye",
	  "Suudi Arabistan",
	  "Svalbard, Norveç",
	  "Svaziland",
	  "Şili",
	  "Tacikistan",
	  "Tanzanya",
	  "Tayland",
	  "Tayvan",
	  "Togo",
	  "Tonga",
	  "Trinidad ve Tobago",
	  "Tunus",
	  "Turks ve Caicos Adaları, İngiltere",
	  "Tuvalu",
	  "Türkiye",
	  "Türkmenistan",
	  "Uganda",
	  "Ukrayna",
	  "Umman",
	  "Uruguay",
	  "Ürdün",
	  "Vallis ve Futuna, Fransa",
	  "Vanuatu",
	  "Venezuela",
	  "Vietnam",
	  "Virgin Adaları, Amerika",
	  "Virgin Adaları, İngiltere",
	  "Wake Adaları, Amerika",
	  "Yemen",
	  "Yeni Kaledonya, Fransa",
	  "Yeni Zelanda",
	  "Yunanistan",
	  "Zambiya",
	  "Zimbabve"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Türkiye"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city = __webpack_require__(2762);
	address.street_root = __webpack_require__(2769);
	address.country = __webpack_require__(2763);
	address.postcode = __webpack_require__(2766);
	address.default_country = __webpack_require__(2764);
	address.building_number = __webpack_require__(2761);
	address.street_name = __webpack_require__(2768);
	address.street_address = __webpack_require__(2767);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name} #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Atatürk Bulvarı",
	  "Alparslan Türkeş Bulvarı",
	  "Ali Çetinkaya Caddesi",
	  "Tevfik Fikret Caddesi",
	  "Kocatepe Caddesi",
	  "İsmet Paşa Caddesi",
	  "30 Ağustos Caddesi",
	  "İsmet Attila Caddesi",
	  "Namık Kemal Caddesi",
	  "Lütfi Karadirek Caddesi",
	  "Sarıkaya Caddesi",
	  "Yunus Emre Sokak",
	  "Dar Sokak",
	  "Fatih Sokak ",
	  "Harman Yolu Sokak ",
	  "Ergenekon Sokak  ",
	  "Ülkü Sokak",
	  "Sağlık Sokak",
	  "Okul Sokak",
	  "Harman Altı Sokak",
	  "Kaldırım Sokak",
	  "Mevlana Sokak",
	  "Gül Sokak",
	  "Sıran Söğüt Sokak",
	  "Güven Yaka Sokak",
	  "Saygılı Sokak",
	  "Menekşe Sokak",
	  "Dağınık Evler Sokak",
	  "Sevgi Sokak",
	  "Afyon Kaya Sokak",
	  "Oğuzhan Sokak",
	  "İbn-i Sina Sokak",
	  "Okul Sokak",
	  "Bahçe Sokak",
	  "Köypınar Sokak",
	  "Kekeçoğlu Sokak",
	  "Barış Sokak",
	  "Bayır Sokak",
	  "Kerimoğlu Sokak",
	  "Nalbant Sokak",
	  "Bandak Sokak"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+90-53#-###-##-##",
	  "+90-54#-###-##-##",
	  "+90-55#-###-##-##",
	  "+90-50#-###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2770);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var tr = {};
	module['exports'] = tr;
	tr.title = "Turkish";
	tr.address = __webpack_require__(2765);
	tr.internet = __webpack_require__(2774);
	tr.lorem = __webpack_require__(2775);
	tr.phone_number = __webpack_require__(2784);
	tr.cell_phone = __webpack_require__(2771);
	tr.name = __webpack_require__(2778);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com.tr",
	  "com",
	  "biz",
	  "info",
	  "name",
	  "gov.tr"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2773);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2776);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "alias",
	  "consequatur",
	  "aut",
	  "perferendis",
	  "sit",
	  "voluptatem",
	  "accusantium",
	  "doloremque",
	  "aperiam",
	  "eaque",
	  "ipsa",
	  "quae",
	  "ab",
	  "illo",
	  "inventore",
	  "veritatis",
	  "et",
	  "quasi",
	  "architecto",
	  "beatae",
	  "vitae",
	  "dicta",
	  "sunt",
	  "explicabo",
	  "aspernatur",
	  "aut",
	  "odit",
	  "aut",
	  "fugit",
	  "sed",
	  "quia",
	  "consequuntur",
	  "magni",
	  "dolores",
	  "eos",
	  "qui",
	  "ratione",
	  "voluptatem",
	  "sequi",
	  "nesciunt",
	  "neque",
	  "dolorem",
	  "ipsum",
	  "quia",
	  "dolor",
	  "sit",
	  "amet",
	  "consectetur",
	  "adipisci",
	  "velit",
	  "sed",
	  "quia",
	  "non",
	  "numquam",
	  "eius",
	  "modi",
	  "tempora",
	  "incidunt",
	  "ut",
	  "labore",
	  "et",
	  "dolore",
	  "magnam",
	  "aliquam",
	  "quaerat",
	  "voluptatem",
	  "ut",
	  "enim",
	  "ad",
	  "minima",
	  "veniam",
	  "quis",
	  "nostrum",
	  "exercitationem",
	  "ullam",
	  "corporis",
	  "nemo",
	  "enim",
	  "ipsam",
	  "voluptatem",
	  "quia",
	  "voluptas",
	  "sit",
	  "suscipit",
	  "laboriosam",
	  "nisi",
	  "ut",
	  "aliquid",
	  "ex",
	  "ea",
	  "commodi",
	  "consequatur",
	  "quis",
	  "autem",
	  "vel",
	  "eum",
	  "iure",
	  "reprehenderit",
	  "qui",
	  "in",
	  "ea",
	  "voluptate",
	  "velit",
	  "esse",
	  "quam",
	  "nihil",
	  "molestiae",
	  "et",
	  "iusto",
	  "odio",
	  "dignissimos",
	  "ducimus",
	  "qui",
	  "blanditiis",
	  "praesentium",
	  "laudantium",
	  "totam",
	  "rem",
	  "voluptatum",
	  "deleniti",
	  "atque",
	  "corrupti",
	  "quos",
	  "dolores",
	  "et",
	  "quas",
	  "molestias",
	  "excepturi",
	  "sint",
	  "occaecati",
	  "cupiditate",
	  "non",
	  "provident",
	  "sed",
	  "ut",
	  "perspiciatis",
	  "unde",
	  "omnis",
	  "iste",
	  "natus",
	  "error",
	  "similique",
	  "sunt",
	  "in",
	  "culpa",
	  "qui",
	  "officia",
	  "deserunt",
	  "mollitia",
	  "animi",
	  "id",
	  "est",
	  "laborum",
	  "et",
	  "dolorum",
	  "fuga",
	  "et",
	  "harum",
	  "quidem",
	  "rerum",
	  "facilis",
	  "est",
	  "et",
	  "expedita",
	  "distinctio",
	  "nam",
	  "libero",
	  "tempore",
	  "cum",
	  "soluta",
	  "nobis",
	  "est",
	  "eligendi",
	  "optio",
	  "cumque",
	  "nihil",
	  "impedit",
	  "quo",
	  "porro",
	  "quisquam",
	  "est",
	  "qui",
	  "minus",
	  "id",
	  "quod",
	  "maxime",
	  "placeat",
	  "facere",
	  "possimus",
	  "omnis",
	  "voluptas",
	  "assumenda",
	  "est",
	  "omnis",
	  "dolor",
	  "repellendus",
	  "temporibus",
	  "autem",
	  "quibusdam",
	  "et",
	  "aut",
	  "consequatur",
	  "vel",
	  "illum",
	  "qui",
	  "dolorem",
	  "eum",
	  "fugiat",
	  "quo",
	  "voluptas",
	  "nulla",
	  "pariatur",
	  "at",
	  "vero",
	  "eos",
	  "et",
	  "accusamus",
	  "officiis",
	  "debitis",
	  "aut",
	  "rerum",
	  "necessitatibus",
	  "saepe",
	  "eveniet",
	  "ut",
	  "et",
	  "voluptates",
	  "repudiandae",
	  "sint",
	  "et",
	  "molestiae",
	  "non",
	  "recusandae",
	  "itaque",
	  "earum",
	  "rerum",
	  "hic",
	  "tenetur",
	  "a",
	  "sapiente",
	  "delectus",
	  "ut",
	  "aut",
	  "reiciendis",
	  "voluptatibus",
	  "maiores",
	  "doloribus",
	  "asperiores",
	  "repellat"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Aba",
	  "Abak",
	  "Abaka",
	  "Abakan",
	  "Abakay",
	  "Abar",
	  "Abay",
	  "Abı",
	  "Abılay",
	  "Abluç",
	  "Abşar",
	  "Açığ",
	  "Açık",
	  "Açuk",
	  "Adalan",
	  "Adaldı",
	  "Adalmış",
	  "Adar",
	  "Adaş",
	  "Adberilgen",
	  "Adıgüzel",
	  "Adık",
	  "Adıkutlu",
	  "Adıkutlutaş",
	  "Adlı",
	  "Adlıbeğ",
	  "Adraman",
	  "Adsız",
	  "Afşar",
	  "Afşın",
	  "Ağabay",
	  "Ağakağan",
	  "Ağalak",
	  "Ağlamış",
	  "Ak",
	  "Akaş",
	  "Akata",
	  "Akbaş",
	  "Akbay",
	  "Akboğa",
	  "Akbörü",
	  "Akbudak",
	  "Akbuğra",
	  "Akbulak",
	  "Akça",
	  "Akçakoca",
	  "Akçora",
	  "Akdemir",
	  "Akdoğan",
	  "Akı",
	  "Akıbudak",
	  "Akım",
	  "Akın",
	  "Akınçı",
	  "Akkun",
	  "Akkunlu",
	  "Akkurt",
	  "Akkuş",
	  "Akpıra",
	  "Aksungur",
	  "Aktan",
	  "Al",
	  "Ala",
	  "Alaban",
	  "Alabörü",
	  "Aladağ",
	  "Aladoğan",
	  "Alakurt",
	  "Alayunt",
	  "Alayuntlu",
	  "Aldemir",
	  "Aldıgerey",
	  "Aldoğan",
	  "Algu",
	  "Alımga",
	  "Alka",
	  "Alkabölük",
	  "Alkaevli",
	  "Alkan",
	  "Alkaşı",
	  "Alkış",
	  "Alp",
	  "Alpagut",
	  "Alpamış",
	  "Alparsbeğ",
	  "Alparslan",
	  "Alpata",
	  "Alpay",
	  "Alpaya",
	  "Alpaykağan",
	  "Alpbamsı",
	  "Alpbilge",
	  "Alpdirek",
	  "Alpdoğan",
	  "Alper",
	  "Alperen",
	  "Alpertunga",
	  "Alpgerey",
	  "Alpış",
	  "Alpilig",
	  "Alpkara",
	  "Alpkutlu",
	  "Alpkülük",
	  "Alpşalçı",
	  "Alptegin",
	  "Alptuğrul",
	  "Alptunga",
	  "Alpturan",
	  "Alptutuk",
	  "Alpuluğ",
	  "Alpurungu",
	  "Alpurungututuk",
	  "Alpyörük",
	  "Altan",
	  "Altankağan",
	  "Altankan",
	  "Altay",
	  "Altın",
	  "Altınkağan",
	  "Altınkan",
	  "Altınoba",
	  "Altıntamgan",
	  "Altıntamgantarkan",
	  "Altıntarkan",
	  "Altıntay",
	  "Altmışkara",
	  "Altuga",
	  "Amaç",
	  "Amrak",
	  "Amul",
	  "Ançuk",
	  "Andarıman",
	  "Anıl",
	  "Ant",
	  "Apa",
	  "Apak",
	  "Apatarkan",
	  "Aprançur",
	  "Araboğa",
	  "Arademir",
	  "Aral",
	  "Arbay",
	  "Arbuz",
	  "Arçuk",
	  "Ardıç",
	  "Argıl",
	  "Argu",
	  "Argun",
	  "Arı",
	  "Arıboğa",
	  "Arık",
	  "Arıkağan",
	  "Arıkdoruk",
	  "Arınç",
	  "Arkın",
	  "Arkış",
	  "Armağan",
	  "Arnaç",
	  "Arpat",
	  "Arsal",
	  "Arsıl",
	  "Arslan",
	  "Arslanargun",
	  "Arslanbörü",
	  "Arslansungur",
	  "Arslantegin",
	  "Arslanyabgu",
	  "Arşun",
	  "Artıınal",
	  "Artuk",
	  "Artukaç",
	  "Artut",
	  "Aruk",
	  "Asartegin",
	  "Asığ",
	  "Asrı",
	  "Asuğ",
	  "Aşan",
	  "Aşanboğa",
	  "Aşantuğrul",
	  "Aşantudun",
	  "Aşıkbulmuş",
	  "Aşkın",
	  "Aştaloğul",
	  "Aşuk",
	  "Ataç",
	  "Atakağan",
	  "Atakan",
	  "Atalan",
	  "Ataldı",
	  "Atalmış",
	  "Ataman",
	  "Atasagun",
	  "Atasu",
	  "Atberilgen",
	  "Atıgay",
	  "Atıkutlu",
	  "Atıkutlutaş",
	  "Atıla",
	  "Atılgan",
	  "Atım",
	  "Atımer",
	  "Atış",
	  "Atlı",
	  "Atlıbeğ",
	  "Atlıkağan",
	  "Atmaca",
	  "Atsız",
	  "Atunçu",
	  "Avar",
	  "Avluç",
	  "Avşar",
	  "Ay",
	  "Ayaçı",
	  "Ayas",
	  "Ayaş",
	  "Ayaz",
	  "Aybalta",
	  "Ayban",
	  "Aybars",
	  "Aybeğ",
	  "Aydarkağan",
	  "Aydemir",
	  "Aydın",
	  "Aydınalp",
	  "Aydoğan",
	  "Aydoğdu",
	  "Aydoğmuş",
	  "Aygırak",
	  "Ayıtmış",
	  "Ayız",
	  "Ayızdağ",
	  "Aykağan",
	  "Aykan",
	  "Aykurt",
	  "Ayluç",
	  "Ayluçtarkan",
	  "Ayma",
	  "Ayruk",
	  "Aysılığ",
	  "Aytak",
	  "Ayyıldız",
	  "Azak",
	  "Azban",
	  "Azgan",
	  "Azganaz",
	  "Azıl",
	  "Babır",
	  "Babur",
	  "Baçara",
	  "Baççayman",
	  "Baçman",
	  "Badabul",
	  "Badruk",
	  "Badur",
	  "Bağa",
	  "Bağaalp",
	  "Bağaışbara",
	  "Bağan",
	  "Bağaşatulu",
	  "Bağatarkan",
	  "Bağatengrikağan",
	  "Bağatur",
	  "Bağaturçigşi",
	  "Bağaturgerey",
	  "Bağaturipi",
	  "Bağatursepi",
	  "Bağış",
	  "Bağtaş",
	  "Bakağul",
	  "Bakır",
	  "Bakırsokum",
	  "Baksı",
	  "Bakşı",
	  "Balaban",
	  "Balaka",
	  "Balakatay",
	  "Balamır",
	  "Balçar",
	  "Baldu",
	  "Balkık",
	  "Balta",
	  "Baltacı",
	  "Baltar",
	  "Baltır",
	  "Baltur",
	  "Bamsı",
	  "Bangu",
	  "Barak",
	  "Baraktöre",
	  "Baran",
	  "Barbeğ",
	  "Barboğa",
	  "Barbol",
	  "Barbulsun",
	  "Barça",
	  "Barçadoğdu",
	  "Barçadoğmuş",
	  "Barçadurdu",
	  "Barçadurmuş",
	  "Barçan",
	  "Barçatoyun",
	  "Bardıbay",
	  "Bargan",
	  "Barımtay",
	  "Barın",
	  "Barkan",
	  "Barkdoğdu",
	  "Barkdoğmuş",
	  "Barkdurdu",
	  "Barkdurmuş",
	  "Barkın",
	  "Barlas",
	  "Barlıbay",
	  "Barmaklak",
	  "Barmaklı",
	  "Barman",
	  "Bars",
	  "Barsbeğ",
	  "Barsboğa",
	  "Barsgan",
	  "Barskan",
	  "Barsurungu",
	  "Bartu",
	  "Basademir",
	  "Basan",
	  "Basanyalavaç",
	  "Basar",
	  "Basat",
	  "Baskın",
	  "Basmıl",
	  "Bastı",
	  "Bastuğrul",
	  "Basu",
	  "Basut",
	  "Başak",
	  "Başbuğ",
	  "Başçı",
	  "Başgan",
	  "Başkırt",
	  "Başkurt",
	  "Baştar",
	  "Batrak",
	  "Batu",
	  "Batuk",
	  "Batur",
	  "Baturalp",
	  "Bay",
	  "Bayançar",
	  "Bayankağan",
	  "Bayat",
	  "Bayazıt",
	  "Baybars",
	  "Baybayık",
	  "Baybiçen",
	  "Bayboğa",
	  "Baybora",
	  "Baybüre",
	  "Baydar",
	  "Baydemir",
	  "Baydur",
	  "Bayık",
	  "Bayınçur",
	  "Bayındır",
	  "Baykal",
	  "Baykara",
	  "Baykoca",
	  "Baykuzu",
	  "Baymünke",
	  "Bayna",
	  "Baynal",
	  "Baypüre",
	  "Bayrı",
	  "Bayraç",
	  "Bayrak",
	  "Bayram",
	  "Bayrın",
	  "Bayruk",
	  "Baysungur",
	  "Baytara",
	  "Baytaş",
	  "Bayunçur",
	  "Bayur",
	  "Bayurku",
	  "Bayutmuş",
	  "Bayuttu",
	  "Bazır",
	  "Beçeapa",
	  "Beçkem",
	  "Beğ",
	  "Beğarslan",
	  "Beğbars",
	  "Beğbilgeçikşin",
	  "Beğboğa",
	  "Beğçur",
	  "Beğdemir",
	  "Beğdilli",
	  "Beğdurmuş",
	  "Beğkulu",
	  "Beğtaş",
	  "Beğtegin",
	  "Beğtüzün",
	  "Begi",
	  "Begil",
	  "Begine",
	  "Begitutuk",
	  "Beglen",
	  "Begni",
	  "Bek",
	  "Bekazıl",
	  "Bekbekeç",
	  "Bekeç",
	  "Bekeçarslan",
	  "Bekeçarslantegin",
	  "Bekeçtegin",
	  "Beker",
	  "Beklemiş",
	  "Bektür",
	  "Belçir",
	  "Belek",
	  "Belgi",
	  "Belgüc",
	  "Beltir",
	  "Bengi",
	  "Bengü",
	  "Benlidemir",
	  "Berdibeğ",
	  "Berendey",
	  "Bergü",
	  "Berginsenge",
	  "Berk",
	  "Berke",
	  "Berkiş",
	  "Berkyaruk",
	  "Bermek",
	  "Besentegin",
	  "Betemir",
	  "Beyizçi",
	  "Beyrek",
	  "Beyrem",
	  "Bıçkı",
	  "Bıçkıcı",
	  "Bıdın",
	  "Bıtaybıkı",
	  "Bıtrı",
	  "Biçek",
	  "Bilge",
	  "Bilgebayunçur",
	  "Bilgebeğ",
	  "Bilgeçikşin",
	  "Bilgeışbara",
	  "Bilgeışbaratamgan",
	  "Bilgekağan",
	  "Bilgekan",
	  "Bilgekutluk",
	  "Bilgekülüçur",
	  "Bilgetaçam",
	  "Bilgetamgacı",
	  "Bilgetardu",
	  "Bilgetegin",
	  "Bilgetonyukuk",
	  "Bilgez",
	  "Bilgiç",
	  "Bilgin",
	  "Bilig",
	  "Biligköngülsengün",
	  "Bilik",
	  "Binbeği",
	  "Bindir",
	  "Boğa",
	  "Boğaç",
	  "Boğaçuk",
	  "Boldaz",
	  "Bolmuş",
	  "Bolsun",
	  "Bolun",
	  "Boncuk",
	  "Bongul",
	  "Bongulboğa",
	  "Bora",
	  "Boran",
	  "Borçul",
	  "Borlukçu",
	  "Bornak",
	  "Boyan",
	  "Boyankulu",
	  "Boylabağa",
	  "Boylabağatarkan",
	  "Boylakutlutarkan",
	  "Bozan",
	  "Bozbörü",
	  "Bozdoğan",
	  "Bozkurt",
	  "Bozkuş",
	  "Bozok",
	  "Bögde",
	  "Böge",
	  "Bögü",
	  "Bökde",
	  "Bökde",
	  "Böke",
	  "Bölen",
	  "Bölükbaşı",
	  "Bönek",
	  "Bönge",
	  "Börü",
	  "Börübars",
	  "Börüsengün",
	  "Börteçine",
	  "Buçan",
	  "Buçur",
	  "Budağ",
	  "Budak",
	  "Budunlu",
	  "Buğday",
	  "Buğra",
	  "Buğrakarakağan",
	  "Bukak",
	  "Bukaktutuk",
	  "Bulaçapan",
	  "Bulak",
	  "Bulan",
	  "Buldur",
	  "Bulgak",
	  "Bulmaz",
	  "Bulmuş",
	  "Buluç",
	  "Buluğ",
	  "Buluk",
	  "Buluş",
	  "Bulut",
	  "Bumın",
	  "Bunsuz",
	  "Burçak",
	  "Burguçan",
	  "Burkay",
	  "Burslan",
	  "Burulday",
	  "Burulgu",
	  "Burunduk",
	  "Buşulgan",
	  "Butak",
	  "Butuk",
	  "Buyan",
	  "Buyançuk",
	  "Buyandemir",
	  "Buyankara",
	  "Buyat",
	  "Buyraç",
	  "Buyruç",
	  "Buyruk",
	  "Buzaç",
	  "Buzaçtutuk",
	  "Büdüs",
	  "Büdüstudun",
	  "Bügü",
	  "Bügdüz",
	  "Bügdüzemen",
	  "Büge",
	  "Büğübilge",
	  "Bükdüz",
	  "Büke",
	  "Bükebuyraç",
	  "Bükebuyruç",
	  "Bükey",
	  "Büktegin",
	  "Büküşboğa",
	  "Bümen",
	  "Bünül",
	  "Büre",
	  "Bürgüt",
	  "Bürkek",
	  "Bürküt",
	  "Bürlük",
	  "Cebe",
	  "Ceyhun",
	  "Cılasun",
	  "Çaba",
	  "Çabdar",
	  "Çablı",
	  "Çabuş",
	  "Çağan",
	  "Çağatay",
	  "Çağlar",
	  "Çağlayan",
	  "Çağrı",
	  "Çağrıbeğ",
	  "Çağrıtegin",
	  "Çağru",
	  "Çalapkulu",
	  "Çankız",
	  "Çemen",
	  "Çemgen",
	  "Çeykün",
	  "Çıngır",
	  "Çiçek",
	  "Çiçem",
	  "Çiğdem",
	  "Çilenti",
	  "Çimen",
	  "Çobulmak",
	  "Çocukbörü",
	  "Çokramayul",
	  "Çolman",
	  "Çolpan",
	  "Çölü",
	  "Damla",
	  "Deniz",
	  "Dilek",
	  "Diri",
	  "Dizik",
	  "Duru",
	  "Dururbunsuz",
	  "Duygu",
	  "Ebin",
	  "Ebkızı",
	  "Ebren",
	  "Edil",
	  "Ediz",
	  "Egemen",
	  "Eğrim",
	  "Ekeç",
	  "Ekim",
	  "Ekin",
	  "Elkin",
	  "Elti",
	  "Engin",
	  "Erdem",
	  "Erdeni",
	  "Erdeniözük",
	  "Erdenikatun",
	  "Erentüz",
	  "Ergene",
	  "Ergenekatun",
	  "Erinç",
	  "Erke",
	  "Ermen",
	  "Erten",
	  "Ertenözük",
	  "Esen",
	  "Esenbike",
	  "Eser",
	  "Esin",
	  "Etil",
	  "Evin",
	  "Eyiz",
	  "Gelin",
	  "Gelincik",
	  "Gökbörü",
	  "Gökçe",
	  "Gökçegöl",
	  "Gökçen",
	  "Gökçiçek",
	  "Gökşin",
	  "Gönül",
	  "Görün",
	  "Gözde",
	  "Gülegen",
	  "Gülemen",
	  "Güler",
	  "Gülümser",
	  "Gümüş",
	  "Gün",
	  "Günay",
	  "Günçiçek",
	  "Gündoğdu",
	  "Gündoğmuş",
	  "Güneş",
	  "Günyaruk",
	  "Gürbüz",
	  "Güvercin",
	  "Güzey",
	  "Işığ",
	  "Işık",
	  "Işıl",
	  "Işılay",
	  "Ila",
	  "Ilaçın",
	  "Ilgın",
	  "Inanç",
	  "Irmak",
	  "Isığ",
	  "Isık",
	  "Iyık",
	  "Iyıktağ",
	  "İdil",
	  "İkeme",
	  "İkiçitoyun",
	  "İlbilge",
	  "İldike",
	  "İlgegü",
	  "İmrem",
	  "İnci",
	  "İnç",
	  "İrinç",
	  "İrinçköl",
	  "İrtiş",
	  "İtil",
	  "Kancı",
	  "Kançı",
	  "Kapgar",
	  "Karaca",
	  "Karaça",
	  "Karak",
	  "Kargılaç",
	  "Karlıgaç",
	  "Katun",
	  "Katunkız",
	  "Kayacık",
	  "Kayaçık",
	  "Kayça",
	  "Kaynak",
	  "Kazanç",
	  "Kazkatun",
	  "Kekik",
	  "Keklik",
	  "Kepez",
	  "Kesme",
	  "Keyken",
	  "Kezlik",
	  "Kımız",
	  "Kımızın",
	  "Kımızalma",
	  "Kımızalmıla",
	  "Kırçiçek",
	  "Kırgavul",
	  "Kırlangıç",
	  "Kıvanç",
	  "Kıvılcım",
	  "Kızdurmuş",
	  "Kızılalma"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2777);
	name.last_name = __webpack_require__(2779);
	name.prefix = __webpack_require__(2781);
	name.name = __webpack_require__(2780);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Abacı",
	  "Abadan",
	  "Aclan",
	  "Adal",
	  "Adan",
	  "Adıvar",
	  "Akal",
	  "Akan",
	  "Akar ",
	  "Akay",
	  "Akaydın",
	  "Akbulut",
	  "Akgül",
	  "Akışık",
	  "Akman",
	  "Akyürek",
	  "Akyüz",
	  "Akşit",
	  "Alnıaçık",
	  "Alpuğan",
	  "Alyanak",
	  "Arıcan",
	  "Arslanoğlu",
	  "Atakol",
	  "Atan",
	  "Avan",
	  "Ayaydın",
	  "Aybar",
	  "Aydan",
	  "Aykaç",
	  "Ayverdi",
	  "Ağaoğlu",
	  "Aşıkoğlu",
	  "Babacan",
	  "Babaoğlu",
	  "Bademci",
	  "Bakırcıoğlu",
	  "Balaban",
	  "Balcı",
	  "Barbarosoğlu",
	  "Baturalp",
	  "Baykam",
	  "Başoğlu",
	  "Berberoğlu",
	  "Beşerler",
	  "Beşok",
	  "Biçer",
	  "Bolatlı",
	  "Dalkıran",
	  "Dağdaş",
	  "Dağlaroğlu",
	  "Demirbaş",
	  "Demirel",
	  "Denkel",
	  "Dizdar ",
	  "Doğan ",
	  "Durak ",
	  "Durmaz",
	  "Duygulu",
	  "Düşenkalkar",
	  "Egeli",
	  "Ekici",
	  "Ekşioğlu",
	  "Eliçin",
	  "Elmastaşoğlu",
	  "Elçiboğa",
	  "Erbay",
	  "Erberk",
	  "Erbulak",
	  "Erdoğan",
	  "Erez",
	  "Erginsoy",
	  "Erkekli",
	  "Eronat",
	  "Ertepınar",
	  "Ertürk",
	  "Erçetin",
	  "Evliyaoğlu",
	  "Gönültaş",
	  "Gümüşpala",
	  "Günday",
	  "Gürmen",
	  "Hakyemez",
	  "Hamzaoğlu",
	  "Ilıcalı",
	  "Kahveci",
	  "Kaplangı",
	  "Karabulut",
	  "Karaböcek",
	  "Karadaş",
	  "Karaduman",
	  "Karaer",
	  "Kasapoğlu",
	  "Kavaklıoğlu",
	  "Kaya ",
	  "Keseroğlu",
	  "Keçeci",
	  "Kılıççı",
	  "Kıraç ",
	  "Kocabıyık",
	  "Korol",
	  "Koyuncu",
	  "Koç",
	  "Koçoğlu",
	  "Koçyiğit",
	  "Kuday",
	  "Kulaksızoğlu",
	  "Kumcuoğlu",
	  "Kunt",
	  "Kunter",
	  "Kurutluoğlu",
	  "Kutlay",
	  "Kuzucu",
	  "Körmükçü",
	  "Köybaşı",
	  "Köylüoğlu",
	  "Küçükler",
	  "Limoncuoğlu",
	  "Mayhoş",
	  "Menemencioğlu",
	  "Mertoğlu",
	  "Nalbantoğlu",
	  "Nebioğlu",
	  "Numanoğlu",
	  "Okumuş",
	  "Okur",
	  "Oraloğlu",
	  "Orbay",
	  "Ozansoy",
	  "Paksüt",
	  "Pekkan",
	  "Pektemek",
	  "Polat",
	  "Poyrazoğlu",
	  "Poçan",
	  "Sadıklar",
	  "Samancı",
	  "Sandalcı",
	  "Sarıoğlu",
	  "Saygıner",
	  "Sepetçi",
	  "Sezek",
	  "Sinanoğlu",
	  "Solmaz",
	  "Sözeri",
	  "Süleymanoğlu",
	  "Tahincioğlu",
	  "Tanrıkulu",
	  "Tazegül",
	  "Taşlı",
	  "Taşçı",
	  "Tekand",
	  "Tekelioğlu",
	  "Tokatlıoğlu",
	  "Tokgöz",
	  "Topaloğlu",
	  "Topçuoğlu",
	  "Toraman",
	  "Tunaboylu",
	  "Tunçeri",
	  "Tuğlu",
	  "Tuğluk",
	  "Türkdoğan",
	  "Türkyılmaz",
	  "Tütüncü",
	  "Tüzün",
	  "Uca",
	  "Uluhan",
	  "Velioğlu",
	  "Yalçın",
	  "Yazıcı",
	  "Yetkiner",
	  "Yeşilkaya",
	  "Yıldırım ",
	  "Yıldızoğlu",
	  "Yılmazer",
	  "Yorulmaz",
	  "Çamdalı",
	  "Çapanoğlu",
	  "Çatalbaş",
	  "Çağıran",
	  "Çetin",
	  "Çetiner",
	  "Çevik",
	  "Çörekçi",
	  "Önür",
	  "Örge",
	  "Öymen",
	  "Özberk",
	  "Özbey",
	  "Özbir",
	  "Özdenak",
	  "Özdoğan",
	  "Özgörkey",
	  "Özkara",
	  "Özkök ",
	  "Öztonga",
	  "Öztuna"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bay",
	  "Bayan",
	  "Dr.",
	  "Prof. Dr."
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "392",
	  "510",
	  "512",
	  "522",
	  "562",
	  "564",
	  "592",
	  "594",
	  "800",
	  "811",
	  "822",
	  "850",
	  "888",
	  "898",
	  "900",
	  "322",
	  "416",
	  "272",
	  "472",
	  "382",
	  "358",
	  "312",
	  "242",
	  "478",
	  "466",
	  "256",
	  "266",
	  "378",
	  "488",
	  "458",
	  "228",
	  "426",
	  "434",
	  "374",
	  "248",
	  "224",
	  "286",
	  "376",
	  "364",
	  "258",
	  "412",
	  "380",
	  "284",
	  "424",
	  "446",
	  "442",
	  "222",
	  "342",
	  "454",
	  "456",
	  "438",
	  "326",
	  "476",
	  "246",
	  "216",
	  "212",
	  "232",
	  "344",
	  "370",
	  "338",
	  "474",
	  "366",
	  "352",
	  "318",
	  "288",
	  "386",
	  "348",
	  "262",
	  "332",
	  "274",
	  "422",
	  "236",
	  "482",
	  "324",
	  "252",
	  "436",
	  "384",
	  "388",
	  "452",
	  "328",
	  "464",
	  "264",
	  "362",
	  "484",
	  "368",
	  "346",
	  "414",
	  "486",
	  "282",
	  "356",
	  "462",
	  "428",
	  "276",
	  "432",
	  "226",
	  "354",
	  "372"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "+90-###-###-##-##",
	  "+90-###-###-#-###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.area_code = __webpack_require__(2782);
	phone_number.formats = __webpack_require__(2783);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#",
	  "##",
	  "###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_name}",
	  "#{city_prefix} #{Name.male_first_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Алчевськ",
	  "Артемівськ",
	  "Бердичів",
	  "Бердянськ",
	  "Біла Церква",
	  "Бровари",
	  "Вінниця",
	  "Горлівка",
	  "Дніпродзержинськ",
	  "Дніпропетровськ",
	  "Донецьк",
	  "Євпаторія",
	  "Єнакієве",
	  "Житомир",
	  "Запоріжжя",
	  "Івано-Франківськ",
	  "Ізмаїл",
	  "Кам’янець-Подільський",
	  "Керч",
	  "Київ",
	  "Кіровоград",
	  "Конотоп",
	  "Краматорськ",
	  "Красний Луч",
	  "Кременчук",
	  "Кривий Ріг",
	  "Лисичанськ",
	  "Луганськ",
	  "Луцьк",
	  "Львів",
	  "Макіївка",
	  "Маріуполь",
	  "Мелітополь",
	  "Миколаїв",
	  "Мукачеве",
	  "Нікополь",
	  "Одеса",
	  "Олександрія",
	  "Павлоград",
	  "Полтава",
	  "Рівне",
	  "Севастополь",
	  "Сєвєродонецьк",
	  "Сімферополь",
	  "Слов’янськ",
	  "Суми",
	  "Тернопіль",
	  "Ужгород",
	  "Умань",
	  "Харків",
	  "Херсон",
	  "Хмельницький",
	  "Черкаси",
	  "Чернівці",
	  "Чернігів",
	  "Шостка",
	  "Ялта"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Південний",
	  "Північний",
	  "Східний",
	  "Західний"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "град"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Австралія",
	  "Австрія",
	  "Азербайджан",
	  "Албанія",
	  "Алжир",
	  "Ангола",
	  "Андорра",
	  "Антигуа і Барбуда",
	  "Аргентина",
	  "Афганістан",
	  "Багамські Острови",
	  "Бангладеш",
	  "Барбадос",
	  "Бахрейн",
	  "Беліз",
	  "Бельгія",
	  "Бенін",
	  "Білорусь",
	  "Болгарія",
	  "Болівія",
	  "Боснія і Герцеговина",
	  "Ботсвана",
	  "Бразилія",
	  "Бруней",
	  "Буркіна-Фасо",
	  "Бурунді",
	  "Бутан",
	  "В’єтнам",
	  "Вануату",
	  "Ватикан",
	  "Велика Британія",
	  "Венесуела",
	  "Вірменія",
	  "Габон",
	  "Гаїті",
	  "Гайана",
	  "Гамбія",
	  "Гана",
	  "Гватемала",
	  "Гвінея",
	  "Гвінея-Бісау",
	  "Гондурас",
	  "Гренада",
	  "Греція",
	  "Грузія",
	  "Данія",
	  "Демократична Республіка Конго",
	  "Джибуті",
	  "Домініка",
	  "Домініканська Республіка",
	  "Еквадор",
	  "Екваторіальна Гвінея",
	  "Еритрея",
	  "Естонія",
	  "Ефіопія",
	  "Єгипет",
	  "Ємен",
	  "Замбія",
	  "Зімбабве",
	  "Ізраїль",
	  "Індія",
	  "Індонезія",
	  "Ірак",
	  "Іран",
	  "Ірландія",
	  "Ісландія",
	  "Іспанія",
	  "Італія",
	  "Йорданія",
	  "Кабо-Верде",
	  "Казахстан",
	  "Камбоджа",
	  "Камерун",
	  "Канада",
	  "Катар",
	  "Кенія",
	  "Киргизстан",
	  "Китай",
	  "Кіпр",
	  "Кірибаті",
	  "Колумбія",
	  "Коморські Острови",
	  "Конго",
	  "Коста-Рика",
	  "Кот-д’Івуар",
	  "Куба",
	  "Кувейт",
	  "Лаос",
	  "Латвія",
	  "Лесото",
	  "Литва",
	  "Ліберія",
	  "Ліван",
	  "Лівія",
	  "Ліхтенштейн",
	  "Люксембург",
	  "Маврикій",
	  "Мавританія",
	  "Мадаґаскар",
	  "Македонія",
	  "Малаві",
	  "Малайзія",
	  "Малі",
	  "Мальдіви",
	  "Мальта",
	  "Марокко",
	  "Маршаллові Острови",
	  "Мексика",
	  "Мозамбік",
	  "Молдова",
	  "Монако",
	  "Монголія",
	  "Намібія",
	  "Науру",
	  "Непал",
	  "Нігер",
	  "Нігерія",
	  "Нідерланди",
	  "Нікарагуа",
	  "Німеччина",
	  "Нова Зеландія",
	  "Норвегія",
	  "Об’єднані Арабські Емірати",
	  "Оман",
	  "Пакистан",
	  "Палау",
	  "Панама",
	  "Папуа-Нова Гвінея",
	  "Парагвай",
	  "Перу",
	  "Південна Корея",
	  "Південний Судан",
	  "Південно-Африканська Республіка",
	  "Північна Корея",
	  "Польща",
	  "Португалія",
	  "Російська Федерація",
	  "Руанда",
	  "Румунія",
	  "Сальвадор",
	  "Самоа",
	  "Сан-Марино",
	  "Сан-Томе і Принсіпі",
	  "Саудівська Аравія",
	  "Свазіленд",
	  "Сейшельські Острови",
	  "Сенеґал",
	  "Сент-Вінсент і Гренадини",
	  "Сент-Кітс і Невіс",
	  "Сент-Люсія",
	  "Сербія",
	  "Сирія",
	  "Сінгапур",
	  "Словаччина",
	  "Словенія",
	  "Соломонові Острови",
	  "Сомалі",
	  "Судан",
	  "Суринам",
	  "Східний Тимор",
	  "США",
	  "Сьєрра-Леоне",
	  "Таджикистан",
	  "Таїланд",
	  "Танзанія",
	  "Того",
	  "Тонга",
	  "Тринідад і Тобаго",
	  "Тувалу",
	  "Туніс",
	  "Туреччина",
	  "Туркменістан",
	  "Уганда",
	  "Угорщина",
	  "Узбекистан",
	  "Україна",
	  "Уругвай",
	  "Федеративні Штати Мікронезії",
	  "Фіджі",
	  "Філіппіни",
	  "Фінляндія",
	  "Франція",
	  "Хорватія",
	  "Центральноафриканська Республіка",
	  "Чад",
	  "Чехія",
	  "Чилі",
	  "Чорногорія",
	  "Швейцарія",
	  "Швеція",
	  "Шрі-Ланка",
	  "Ямайка",
	  "Японія"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Україна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.country = __webpack_require__(2790);
	address.building_number = __webpack_require__(2785);
	address.street_prefix = __webpack_require__(2798);
	address.street_suffix = __webpack_require__(2799);
	address.secondary_address = __webpack_require__(2794);
	address.postcode = __webpack_require__(2793);
	address.state = __webpack_require__(2795);
	address.street_title = __webpack_require__(2800);
	address.city_name = __webpack_require__(2787);
	address.city = __webpack_require__(2786);
	address.city_prefix = __webpack_require__(2788);
	address.city_suffix = __webpack_require__(2789);
	address.street_name = __webpack_require__(2797);
	address.street_address = __webpack_require__(2796);
	address.default_country = __webpack_require__(2791);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "кв. ###"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "АР Крим",
	  "Вінницька область",
	  "Волинська область",
	  "Дніпропетровська область",
	  "Донецька область",
	  "Житомирська область",
	  "Закарпатська область",
	  "Запорізька область",
	  "Івано-Франківська область",
	  "Київська область",
	  "Кіровоградська область",
	  "Луганська область",
	  "Львівська область",
	  "Миколаївська область",
	  "Одеська область",
	  "Полтавська область",
	  "Рівненська область",
	  "Сумська область",
	  "Тернопільська область",
	  "Харківська область",
	  "Херсонська область",
	  "Хмельницька область",
	  "Черкаська область",
	  "Чернівецька область",
	  "Чернігівська область",
	  "Київ",
	  "Севастополь"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}, #{building_number}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_prefix} #{Address.street_title}",
	  "#{Address.street_title} #{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "вул.",
	  "вулиця",
	  "пр.",
	  "проспект",
	  "пл.",
	  "площа",
	  "пров.",
	  "провулок"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "майдан"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Зелена",
	  "Молодіжна",
	  "Городоцька",
	  "Стрийська",
	  "Вузька",
	  "Нижанківського",
	  "Староміська",
	  "Ліста",
	  "Вічева",
	  "Брюховичів",
	  "Винників",
	  "Рудного",
	  "Коліївщини"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(2803);
	company.suffix = __webpack_require__(2804);
	company.name = __webpack_require__(2802);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.female_first_name}",
	  "#{prefix} #{Name.male_first_name}",
	  "#{prefix} #{Name.male_last_name}",
	  "#{prefix} #{suffix}#{suffix}",
	  "#{prefix} #{suffix}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}",
	  "#{prefix} #{Address.city_name}#{suffix}#{suffix}#{suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ТОВ",
	  "ПАТ",
	  "ПрАТ",
	  "ТДВ",
	  "КТ",
	  "ПТ",
	  "ДП",
	  "ФОП"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Постач",
	  "Торг",
	  "Пром",
	  "Трейд",
	  "Збут"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var uk = {};
	module['exports'] = uk;
	uk.title = "Ukrainian";
	uk.address = __webpack_require__(2792);
	uk.company = __webpack_require__(2801);
	uk.internet = __webpack_require__(2808);
	uk.name = __webpack_require__(2812);
	uk.phone_number = __webpack_require__(2821);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "cherkassy.ua",
	  "cherkasy.ua",
	  "ck.ua",
	  "cn.ua",
	  "com.ua",
	  "crimea.ua",
	  "cv.ua",
	  "dn.ua",
	  "dnepropetrovsk.ua",
	  "dnipropetrovsk.ua",
	  "donetsk.ua",
	  "dp.ua",
	  "if.ua",
	  "in.ua",
	  "ivano-frankivsk.ua",
	  "kh.ua",
	  "kharkiv.ua",
	  "kharkov.ua",
	  "kherson.ua",
	  "khmelnitskiy.ua",
	  "kiev.ua",
	  "kirovograd.ua",
	  "km.ua",
	  "kr.ua",
	  "ks.ua",
	  "lg.ua",
	  "lt.ua",
	  "lugansk.ua",
	  "lutsk.ua",
	  "lutsk.net",
	  "lviv.ua",
	  "mk.ua",
	  "net.ua",
	  "nikolaev.ua",
	  "od.ua",
	  "odessa.ua",
	  "org.ua",
	  "pl.ua",
	  "pl.ua",
	  "poltava.ua",
	  "rovno.ua",
	  "rv.ua",
	  "sebastopol.ua",
	  "sm.ua",
	  "sumy.ua",
	  "te.ua",
	  "ternopil.ua",
	  "ua",
	  "uz.ua",
	  "uzhgorod.ua",
	  "vinnica.ua",
	  "vn.ua",
	  "volyn.net",
	  "volyn.ua",
	  "yalta.ua",
	  "zaporizhzhe.ua",
	  "zhitomir.ua",
	  "zp.ua",
	  "zt.ua",
	  "укр"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "ukr.net",
	  "ex.ua",
	  "e-mail.ua",
	  "i.ua",
	  "meta.ua",
	  "yandex.ua",
	  "gmail.com"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.free_email = __webpack_require__(2807);
	internet.domain_suffix = __webpack_require__(2806);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Аврелія",
	  "Аврора",
	  "Агапія",
	  "Агата",
	  "Агафія",
	  "Агнеса",
	  "Агнія",
	  "Агрипина",
	  "Ада",
	  "Аделаїда",
	  "Аделіна",
	  "Адріана",
	  "Азалія",
	  "Алевтина",
	  "Аліна",
	  "Алла",
	  "Альбіна",
	  "Альвіна",
	  "Анастасія",
	  "Анастасія",
	  "Анатолія",
	  "Ангеліна",
	  "Анжела",
	  "Анна",
	  "Антонида",
	  "Антоніна",
	  "Антонія",
	  "Анфіса",
	  "Аполлінарія",
	  "Аполлонія",
	  "Аркадія",
	  "Артемія",
	  "Афанасія",
	  "Білослава",
	  "Біляна",
	  "Благовіста",
	  "Богдана",
	  "Богуслава",
	  "Божена",
	  "Болеслава",
	  "Борислава",
	  "Броніслава",
	  "В’ячеслава",
	  "Валентина",
	  "Валерія",
	  "Варвара",
	  "Василина",
	  "Вікторія",
	  "Вілена",
	  "Віленіна",
	  "Віліна",
	  "Віола",
	  "Віолетта",
	  "Віра",
	  "Віргінія",
	  "Віта",
	  "Віталіна",
	  "Влада",
	  "Владислава",
	  "Власта",
	  "Всеслава",
	  "Галина",
	  "Ганна",
	  "Гелена",
	  "Далеслава",
	  "Дана",
	  "Дарина",
	  "Дарислава",
	  "Діана",
	  "Діяна",
	  "Добринка",
	  "Добромила",
	  "Добромира",
	  "Добромисла",
	  "Доброслава",
	  "Долеслава",
	  "Доляна",
	  "Жанна",
	  "Жозефіна",
	  "Забава",
	  "Звенислава",
	  "Зінаїда",
	  "Злата",
	  "Зореслава",
	  "Зорина",
	  "Зоряна",
	  "Зоя",
	  "Іванна",
	  "Ілона",
	  "Інна",
	  "Іннеса",
	  "Ірина",
	  "Ірма",
	  "Калина",
	  "Каріна",
	  "Катерина",
	  "Квітка",
	  "Квітослава",
	  "Клавдія",
	  "Крентта",
	  "Ксенія",
	  "Купава",
	  "Лада",
	  "Лариса",
	  "Леся",
	  "Ликера",
	  "Лідія",
	  "Лілія",
	  "Любава",
	  "Любислава",
	  "Любов",
	  "Любомила",
	  "Любомира",
	  "Люборада",
	  "Любослава",
	  "Людмила",
	  "Людомила",
	  "Майя",
	  "Мальва",
	  "Мар’яна",
	  "Марина",
	  "Марічка",
	  "Марія",
	  "Марта",
	  "Меланія",
	  "Мечислава",
	  "Милодара",
	  "Милослава",
	  "Мирослава",
	  "Мілана",
	  "Мокрина",
	  "Мотря",
	  "Мстислава",
	  "Надія",
	  "Наталія",
	  "Неля",
	  "Немира",
	  "Ніна",
	  "Огняна",
	  "Оксана",
	  "Олександра",
	  "Олена",
	  "Олеся",
	  "Ольга",
	  "Ореста",
	  "Орина",
	  "Орислава",
	  "Орися",
	  "Оріяна",
	  "Павліна",
	  "Палажка",
	  "Пелагея",
	  "Пелагія",
	  "Поліна",
	  "Поляна",
	  "Потішана",
	  "Радміла",
	  "Радослава",
	  "Раїна",
	  "Раїса",
	  "Роксолана",
	  "Ромена",
	  "Ростислава",
	  "Руслана",
	  "Світлана",
	  "Святослава",
	  "Слава",
	  "Сміяна",
	  "Сніжана",
	  "Соломія",
	  "Соня",
	  "Софія",
	  "Станислава",
	  "Сюзана",
	  "Таїсія",
	  "Тамара",
	  "Тетяна",
	  "Устина",
	  "Фаїна",
	  "Февронія",
	  "Федора",
	  "Феодосія",
	  "Харитина",
	  "Христина",
	  "Христя",
	  "Юліанна",
	  "Юлія",
	  "Юстина",
	  "Юхима",
	  "Юхимія",
	  "Яна",
	  "Ярина",
	  "Ярослава"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Андрухович",
	  "Бабух",
	  "Балабан",
	  "Балабуха",
	  "Балакун",
	  "Балицька",
	  "Бамбула",
	  "Бандера",
	  "Барановська",
	  "Бачей",
	  "Башук",
	  "Бердник",
	  "Білич",
	  "Бондаренко",
	  "Борецька",
	  "Боровська",
	  "Борочко",
	  "Боярчук",
	  "Брицька",
	  "Бурмило",
	  "Бутько",
	  "Василишина",
	  "Васильківська",
	  "Вергун",
	  "Вередун",
	  "Верещук",
	  "Витребенько",
	  "Вітряк",
	  "Волощук",
	  "Гайдук",
	  "Гайова",
	  "Гайчук",
	  "Галаєнко",
	  "Галатей",
	  "Галаціон",
	  "Гаман",
	  "Гамула",
	  "Ганич",
	  "Гарай",
	  "Гарун",
	  "Гладківська",
	  "Гладух",
	  "Глинська",
	  "Гнатишина",
	  "Гойко",
	  "Головець",
	  "Горбач",
	  "Гордійчук",
	  "Горова",
	  "Городоцька",
	  "Гречко",
	  "Григоришина",
	  "Гриневецька",
	  "Гриневська",
	  "Гришко",
	  "Громико",
	  "Данилишина",
	  "Данилко",
	  "Демків",
	  "Демчишина",
	  "Дзюб’як",
	  "Дзюба",
	  "Дідух",
	  "Дмитришина",
	  "Дмитрук",
	  "Довгалевська",
	  "Дурдинець",
	  "Євенко",
	  "Євпак",
	  "Ємець",
	  "Єрмак",
	  "Забіла",
	  "Зварич",
	  "Зінкевич",
	  "Зленко",
	  "Іванишина",
	  "Калач",
	  "Кандиба",
	  "Карпух",
	  "Кивач",
	  "Коваленко",
	  "Ковальська",
	  "Коломієць",
	  "Коман",
	  "Компанієць",
	  "Кононець",
	  "Кордун",
	  "Корецька",
	  "Корнїйчук",
	  "Коров’як",
	  "Коцюбинська",
	  "Кулинич",
	  "Кульчицька",
	  "Лагойда",
	  "Лазірко",
	  "Ланова",
	  "Латан",
	  "Латанська",
	  "Лахман",
	  "Левадовська",
	  "Ликович",
	  "Линдик",
	  "Ліхно",
	  "Лобачевська",
	  "Ломова",
	  "Лугова",
	  "Луцька",
	  "Луцьків",
	  "Лученко",
	  "Лучко",
	  "Люта",
	  "Лящук",
	  "Магера",
	  "Мазайло",
	  "Мазило",
	  "Мазун",
	  "Майборода",
	  "Майстренко",
	  "Маковецька",
	  "Малкович",
	  "Мамій",
	  "Маринич",
	  "Марієвська",
	  "Марків",
	  "Махно",
	  "Миклашевська",
	  "Миклухо",
	  "Милославська",
	  "Михайлюк",
	  "Міняйло",
	  "Могилевська",
	  "Москаль",
	  "Москалюк",
	  "Мотрієнко",
	  "Негода",
	  "Ногачевська",
	  "Опенько",
	  "Осадко",
	  "Павленко",
	  "Павлишина",
	  "Павлів",
	  "Пагутяк",
	  "Паламарчук",
	  "Палій",
	  "Паращук",
	  "Пасічник",
	  "Пендик",
	  "Петик",
	  "Петлюра",
	  "Петренко",
	  "Петрина",
	  "Петришина",
	  "Петрів",
	  "Плаксій",
	  "Погиба",
	  "Поліщук",
	  "Пономарів",
	  "Поривай",
	  "Поривайло",
	  "Потебенько",
	  "Потоцька",
	  "Пригода",
	  "Приймак",
	  "Притула",
	  "Прядун",
	  "Розпутня",
	  "Романишина",
	  "Ромей",
	  "Роменець",
	  "Ромочко",
	  "Савицька",
	  "Саєнко",
	  "Свидригайло",
	  "Семеночко",
	  "Семещук",
	  "Сердюк",
	  "Силецька",
	  "Сідлецька",
	  "Сідляк",
	  "Сірко",
	  "Скиба",
	  "Скоропадська",
	  "Слободян",
	  "Сосюра",
	  "Сплюха",
	  "Спотикач",
	  "Степанець",
	  "Стигайло",
	  "Сторожук",
	  "Сторчак",
	  "Стоян",
	  "Сучак",
	  "Сушко",
	  "Тарасюк",
	  "Тиндарей",
	  "Ткаченко",
	  "Третяк",
	  "Троян",
	  "Трублаєвська",
	  "Трясило",
	  "Трясун",
	  "Уманець",
	  "Унич",
	  "Усич",
	  "Федоришина",
	  "Цушко",
	  "Червоній",
	  "Шамрило",
	  "Шевченко",
	  "Шестак",
	  "Шиндарей",
	  "Шиян",
	  "Шкараба",
	  "Шудрик",
	  "Шумило",
	  "Шупик",
	  "Шухевич",
	  "Щербак",
	  "Юрчишина",
	  "Юхно",
	  "Ющик",
	  "Ющук",
	  "Яворівська",
	  "Ялова",
	  "Ялюк",
	  "Янюк",
	  "Ярмак",
	  "Яцишина",
	  "Яцьків",
	  "Ящук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Адамівна",
	  "Азарівна",
	  "Алевтинівна",
	  "Альбертівна",
	  "Анастасівна",
	  "Анатоліївна",
	  "Андріївна",
	  "Антонівна",
	  "Аркадіївна",
	  "Арсенівна",
	  "Арсеніївна",
	  "Артемівна",
	  "Архипівна",
	  "Аскольдівна",
	  "Афанасіївна",
	  "Білославівна",
	  "Богданівна",
	  "Божемирівна",
	  "Боженівна",
	  "Болеславівна",
	  "Боримирівна",
	  "Борисівна",
	  "Бориславівна",
	  "Братиславівна",
	  "В’ячеславівна",
	  "Вадимівна",
	  "Валентинівна",
	  "Валеріївна",
	  "Василівна",
	  "Вікторівна",
	  "Віталіївна",
	  "Владиславівна",
	  "Володимирівна",
	  "Всеволодівна",
	  "Всеславівна",
	  "Гаврилівна",
	  "Гарасимівна",
	  "Георгіївна",
	  "Гнатівна",
	  "Гордіївна",
	  "Григоріївна",
	  "Данилівна",
	  "Даромирівна",
	  "Денисівна",
	  "Дмитрівна",
	  "Добромирівна",
	  "Доброславівна",
	  "Євгенівна",
	  "Захарівна",
	  "Захаріївна",
	  "Збориславівна",
	  "Звенимирівна",
	  "Звениславівна",
	  "Зеновіївна",
	  "Зиновіївна",
	  "Златомирівна",
	  "Зореславівна",
	  "Іванівна",
	  "Ігорівна",
	  "Ізяславівна",
	  "Корнеліївна",
	  "Корнилівна",
	  "Корніївна",
	  "Костянтинівна",
	  "Лаврентіївна",
	  "Любомирівна",
	  "Макарівна",
	  "Максимівна",
	  "Марківна",
	  "Маркіянівна",
	  "Матвіївна",
	  "Мечиславівна",
	  "Микитівна",
	  "Миколаївна",
	  "Миронівна",
	  "Мирославівна",
	  "Михайлівна",
	  "Мстиславівна",
	  "Назарівна",
	  "Назаріївна",
	  "Натанівна",
	  "Немирівна",
	  "Несторівна",
	  "Олегівна",
	  "Олександрівна",
	  "Олексіївна",
	  "Олельківна",
	  "Омелянівна",
	  "Орестівна",
	  "Орхипівна",
	  "Остапівна",
	  "Охрімівна",
	  "Павлівна",
	  "Панасівна",
	  "Пантелеймонівна",
	  "Петрівна",
	  "Пилипівна",
	  "Радимирівна",
	  "Радимівна",
	  "Родіонівна",
	  "Романівна",
	  "Ростиславівна",
	  "Русланівна",
	  "Святославівна",
	  "Сергіївна",
	  "Славутівна",
	  "Станіславівна",
	  "Степанівна",
	  "Стефаніївна",
	  "Тарасівна",
	  "Тимофіївна",
	  "Тихонівна",
	  "Устимівна",
	  "Юріївна",
	  "Юхимівна",
	  "Ярославівна"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.male_first_name = __webpack_require__(2813);
	name.male_middle_name = __webpack_require__(2815);
	name.male_last_name = __webpack_require__(2814);
	name.female_first_name = __webpack_require__(2809);
	name.female_middle_name = __webpack_require__(2811);
	name.female_last_name = __webpack_require__(2810);
	name.prefix = __webpack_require__(2817);
	name.suffix = __webpack_require__(2818);
	name.title = __webpack_require__(2819);
	name.name = __webpack_require__(2816);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Августин",
	  "Аврелій",
	  "Адам",
	  "Адріян",
	  "Азарій",
	  "Алевтин",
	  "Альберт",
	  "Анастас",
	  "Анастасій",
	  "Анатолій",
	  "Андрій",
	  "Антін",
	  "Антон",
	  "Антоній",
	  "Аркадій",
	  "Арсен",
	  "Арсеній",
	  "Артем",
	  "Архип",
	  "Аскольд",
	  "Афанасій",
	  "Біломир",
	  "Білослав",
	  "Богдан",
	  "Божемир",
	  "Божен",
	  "Болеслав",
	  "Боримир",
	  "Боримисл",
	  "Борис",
	  "Борислав",
	  "Братимир",
	  "Братислав",
	  "Братомил",
	  "Братослав",
	  "Брячислав",
	  "Будимир",
	  "Буйтур",
	  "Буревіст",
	  "В’ячеслав",
	  "Вадим",
	  "Валентин",
	  "Валерій",
	  "Василь",
	  "Велемир",
	  "Віктор",
	  "Віталій",
	  "Влад",
	  "Владислав",
	  "Володимир",
	  "Володислав",
	  "Всевлад",
	  "Всеволод",
	  "Всеслав",
	  "Гаврило",
	  "Гарнослав",
	  "Геннадій",
	  "Георгій",
	  "Герасим",
	  "Гліб",
	  "Гнат",
	  "Гордій",
	  "Горимир",
	  "Горислав",
	  "Градимир",
	  "Григорій",
	  "Далемир",
	  "Данило",
	  "Дарій",
	  "Даромир",
	  "Денис",
	  "Дмитро",
	  "Добромир",
	  "Добромисл",
	  "Доброслав",
	  "Євген",
	  "Єремій",
	  "Захар",
	  "Захарій",
	  "Зборислав",
	  "Звенигор",
	  "Звенимир",
	  "Звенислав",
	  "Земислав",
	  "Зеновій",
	  "Зиновій",
	  "Злат",
	  "Златомир",
	  "Зоремир",
	  "Зореслав",
	  "Зорян",
	  "Іван",
	  "Ігор",
	  "Ізяслав",
	  "Ілля",
	  "Кий",
	  "Корнелій",
	  "Корнилій",
	  "Корнило",
	  "Корній",
	  "Костянтин",
	  "Кузьма",
	  "Лаврентій",
	  "Лаврін",
	  "Лад",
	  "Ладислав",
	  "Ладо",
	  "Ладомир",
	  "Левко",
	  "Листвич",
	  "Лук’ян",
	  "Любодар",
	  "Любозар",
	  "Любомир",
	  "Макар",
	  "Максим",
	  "Мар’ян",
	  "Маркіян",
	  "Марко",
	  "Матвій",
	  "Мечислав",
	  "Микита",
	  "Микола",
	  "Мирон",
	  "Мирослав",
	  "Михайло",
	  "Мстислав",
	  "Мусій",
	  "Назар",
	  "Назарій",
	  "Натан",
	  "Немир",
	  "Нестор",
	  "Олег",
	  "Олександр",
	  "Олексій",
	  "Олелько",
	  "Олесь",
	  "Омелян",
	  "Орест",
	  "Орхип",
	  "Остап",
	  "Охрім",
	  "Павло",
	  "Панас",
	  "Пантелеймон",
	  "Петро",
	  "Пилип",
	  "Подолян",
	  "Потап",
	  "Радим",
	  "Радимир",
	  "Ратибор",
	  "Ратимир",
	  "Родіон",
	  "Родослав",
	  "Роксолан",
	  "Роман",
	  "Ростислав",
	  "Руслан",
	  "Святополк",
	  "Святослав",
	  "Семибор",
	  "Сергій",
	  "Синьоок",
	  "Славолюб",
	  "Славомир",
	  "Славута",
	  "Сніжан",
	  "Сологуб",
	  "Станіслав",
	  "Степан",
	  "Стефаній",
	  "Стожар",
	  "Тарас",
	  "Тиміш",
	  "Тимофій",
	  "Тихон",
	  "Тур",
	  "Устим",
	  "Хвалимир",
	  "Хорив",
	  "Чорнота",
	  "Щастислав",
	  "Щек",
	  "Юліан",
	  "Юрій",
	  "Юхим",
	  "Ян",
	  "Ярема",
	  "Яровид",
	  "Яромил",
	  "Яромир",
	  "Ярополк",
	  "Ярослав"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Андрухович",
	  "Бабух",
	  "Балабан",
	  "Балабух",
	  "Балакун",
	  "Балицький",
	  "Бамбула",
	  "Бандера",
	  "Барановський",
	  "Бачей",
	  "Башук",
	  "Бердник",
	  "Білич",
	  "Бондаренко",
	  "Борецький",
	  "Боровський",
	  "Борочко",
	  "Боярчук",
	  "Брицький",
	  "Бурмило",
	  "Бутько",
	  "Василин",
	  "Василишин",
	  "Васильківський",
	  "Вергун",
	  "Вередун",
	  "Верещук",
	  "Витребенько",
	  "Вітряк",
	  "Волощук",
	  "Гайдук",
	  "Гайовий",
	  "Гайчук",
	  "Галаєнко",
	  "Галатей",
	  "Галаціон",
	  "Гаман",
	  "Гамула",
	  "Ганич",
	  "Гарай",
	  "Гарун",
	  "Гладківський",
	  "Гладух",
	  "Глинський",
	  "Гнатишин",
	  "Гойко",
	  "Головець",
	  "Горбач",
	  "Гордійчук",
	  "Горовий",
	  "Городоцький",
	  "Гречко",
	  "Григоришин",
	  "Гриневецький",
	  "Гриневський",
	  "Гришко",
	  "Громико",
	  "Данилишин",
	  "Данилко",
	  "Демків",
	  "Демчишин",
	  "Дзюб’як",
	  "Дзюба",
	  "Дідух",
	  "Дмитришин",
	  "Дмитрук",
	  "Довгалевський",
	  "Дурдинець",
	  "Євенко",
	  "Євпак",
	  "Ємець",
	  "Єрмак",
	  "Забіла",
	  "Зварич",
	  "Зінкевич",
	  "Зленко",
	  "Іванишин",
	  "Іванів",
	  "Іванців",
	  "Калач",
	  "Кандиба",
	  "Карпух",
	  "Каськів",
	  "Кивач",
	  "Коваленко",
	  "Ковальський",
	  "Коломієць",
	  "Коман",
	  "Компанієць",
	  "Кононець",
	  "Кордун",
	  "Корецький",
	  "Корнїйчук",
	  "Коров’як",
	  "Коцюбинський",
	  "Кулинич",
	  "Кульчицький",
	  "Лагойда",
	  "Лазірко",
	  "Лановий",
	  "Латаний",
	  "Латанський",
	  "Лахман",
	  "Левадовський",
	  "Ликович",
	  "Линдик",
	  "Ліхно",
	  "Лобачевський",
	  "Ломовий",
	  "Луговий",
	  "Луцький",
	  "Луцьків",
	  "Лученко",
	  "Лучко",
	  "Лютий",
	  "Лящук",
	  "Магера",
	  "Мазайло",
	  "Мазило",
	  "Мазун",
	  "Майборода",
	  "Майстренко",
	  "Маковецький",
	  "Малкович",
	  "Мамій",
	  "Маринич",
	  "Марієвський",
	  "Марків",
	  "Махно",
	  "Миклашевський",
	  "Миклухо",
	  "Милославський",
	  "Михайлюк",
	  "Міняйло",
	  "Могилевський",
	  "Москаль",
	  "Москалюк",
	  "Мотрієнко",
	  "Негода",
	  "Ногачевський",
	  "Опенько",
	  "Осадко",
	  "Павленко",
	  "Павлишин",
	  "Павлів",
	  "Пагутяк",
	  "Паламарчук",
	  "Палій",
	  "Паращук",
	  "Пасічник",
	  "Пендик",
	  "Петик",
	  "Петлюра",
	  "Петренко",
	  "Петрин",
	  "Петришин",
	  "Петрів",
	  "Плаксій",
	  "Погиба",
	  "Поліщук",
	  "Пономарів",
	  "Поривай",
	  "Поривайло",
	  "Потебенько",
	  "Потоцький",
	  "Пригода",
	  "Приймак",
	  "Притула",
	  "Прядун",
	  "Розпутній",
	  "Романишин",
	  "Романів",
	  "Ромей",
	  "Роменець",
	  "Ромочко",
	  "Савицький",
	  "Саєнко",
	  "Свидригайло",
	  "Семеночко",
	  "Семещук",
	  "Сердюк",
	  "Силецький",
	  "Сідлецький",
	  "Сідляк",
	  "Сірко",
	  "Скиба",
	  "Скоропадський",
	  "Слободян",
	  "Сосюра",
	  "Сплюх",
	  "Спотикач",
	  "Стахів",
	  "Степанець",
	  "Стецьків",
	  "Стигайло",
	  "Сторожук",
	  "Сторчак",
	  "Стоян",
	  "Сучак",
	  "Сушко",
	  "Тарасюк",
	  "Тиндарей",
	  "Ткаченко",
	  "Третяк",
	  "Троян",
	  "Трублаєвський",
	  "Трясило",
	  "Трясун",
	  "Уманець",
	  "Унич",
	  "Усич",
	  "Федоришин",
	  "Хитрово",
	  "Цимбалістий",
	  "Цушко",
	  "Червоній",
	  "Шамрило",
	  "Шевченко",
	  "Шестак",
	  "Шиндарей",
	  "Шиян",
	  "Шкараба",
	  "Шудрик",
	  "Шумило",
	  "Шупик",
	  "Шухевич",
	  "Щербак",
	  "Юрчишин",
	  "Юхно",
	  "Ющик",
	  "Ющук",
	  "Яворівський",
	  "Яловий",
	  "Ялюк",
	  "Янюк",
	  "Ярмак",
	  "Яцишин",
	  "Яцьків",
	  "Ящук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Адамович",
	  "Азарович",
	  "Алевтинович",
	  "Альбертович",
	  "Анастасович",
	  "Анатолійович",
	  "Андрійович",
	  "Антонович",
	  "Аркадійович",
	  "Арсенійович",
	  "Арсенович",
	  "Артемович",
	  "Архипович",
	  "Аскольдович",
	  "Афанасійович",
	  "Білославович",
	  "Богданович",
	  "Божемирович",
	  "Боженович",
	  "Болеславович",
	  "Боримирович",
	  "Борисович",
	  "Бориславович",
	  "Братиславович",
	  "В’ячеславович",
	  "Вадимович",
	  "Валентинович",
	  "Валерійович",
	  "Васильович",
	  "Вікторович",
	  "Віталійович",
	  "Владиславович",
	  "Володимирович",
	  "Всеволодович",
	  "Всеславович",
	  "Гаврилович",
	  "Герасимович",
	  "Георгійович",
	  "Гнатович",
	  "Гордійович",
	  "Григорійович",
	  "Данилович",
	  "Даромирович",
	  "Денисович",
	  "Дмитрович",
	  "Добромирович",
	  "Доброславович",
	  "Євгенович",
	  "Захарович",
	  "Захарійович",
	  "Збориславович",
	  "Звенимирович",
	  "Звениславович",
	  "Зеновійович",
	  "Зиновійович",
	  "Златомирович",
	  "Зореславович",
	  "Іванович",
	  "Ігорович",
	  "Ізяславович",
	  "Корнелійович",
	  "Корнилович",
	  "Корнійович",
	  "Костянтинович",
	  "Лаврентійович",
	  "Любомирович",
	  "Макарович",
	  "Максимович",
	  "Маркович",
	  "Маркіянович",
	  "Матвійович",
	  "Мечиславович",
	  "Микитович",
	  "Миколайович",
	  "Миронович",
	  "Мирославович",
	  "Михайлович",
	  "Мстиславович",
	  "Назарович",
	  "Назарійович",
	  "Натанович",
	  "Немирович",
	  "Несторович",
	  "Олегович",
	  "Олександрович",
	  "Олексійович",
	  "Олелькович",
	  "Омелянович",
	  "Орестович",
	  "Орхипович",
	  "Остапович",
	  "Охрімович",
	  "Павлович",
	  "Панасович",
	  "Пантелеймонович",
	  "Петрович",
	  "Пилипович",
	  "Радимирович",
	  "Радимович",
	  "Родіонович",
	  "Романович",
	  "Ростиславович",
	  "Русланович",
	  "Святославович",
	  "Сергійович",
	  "Славутович",
	  "Станіславович",
	  "Степанович",
	  "Стефанович",
	  "Тарасович",
	  "Тимофійович",
	  "Тихонович",
	  "Устимович",
	  "Юрійович",
	  "Юхимович",
	  "Ярославович"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{male_first_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name}",
	  "#{male_first_name} #{male_middle_name} #{male_last_name}",
	  "#{male_last_name} #{male_first_name} #{male_middle_name}",
	  "#{female_first_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name}",
	  "#{female_first_name} #{female_middle_name} #{female_last_name}",
	  "#{female_last_name} #{female_first_name} #{female_middle_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Пан",
	  "Пані"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "проф.",
	  "доц.",
	  "докт. пед. наук",
	  "докт. політ. наук",
	  "докт. філол. наук",
	  "докт. філос. наук",
	  "докт. і. наук",
	  "докт. юрид. наук",
	  "докт. техн. наук",
	  "докт. психол. наук",
	  "канд. пед. наук",
	  "канд. політ. наук",
	  "канд. філол. наук",
	  "канд. філос. наук",
	  "канд. і. наук",
	  "канд. юрид. наук",
	  "канд. техн. наук",
	  "канд. психол. наук"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = {
	  "descriptor": [
	    "Головний",
	    "Генеральний",
	    "Провідний",
	    "Національний",
	    "Регіональний",
	    "Обласний",
	    "Районний",
	    "Глобальний",
	    "Міжнародний",
	    "Центральний"
	  ],
	  "level": [
	    "маркетинговий",
	    "оптимізаційний",
	    "страховий",
	    "функціональний",
	    "інтеграційний",
	    "логістичний"
	  ],
	  "job": [
	    "інженер",
	    "агент",
	    "адміністратор",
	    "аналітик",
	    "архітектор",
	    "дизайнер",
	    "керівник",
	    "консультант",
	    "координатор",
	    "менеджер",
	    "планувальник",
	    "помічник",
	    "розробник",
	    "спеціаліст",
	    "співробітник",
	    "технік"
	  ]
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "(044) ###-##-##",
	  "(050) ###-##-##",
	  "(063) ###-##-##",
	  "(066) ###-##-##",
	  "(073) ###-##-##",
	  "(091) ###-##-##",
	  "(092) ###-##-##",
	  "(093) ###-##-##",
	  "(094) ###-##-##",
	  "(095) ###-##-##",
	  "(096) ###-##-##",
	  "(097) ###-##-##",
	  "(098) ###-##-##",
	  "(099) ###-##-##"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2820);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_root}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Bắc Giang",
	  "Bắc Kạn",
	  "Bắc Ninh",
	  "Cao Bằng",
	  "Điện Biên",
	  "Hà Giang",
	  "Hà Nam",
	  "Hà Tây",
	  "Hải Dương",
	  "TP Hải Phòng",
	  "Hòa Bình",
	  "Hưng Yên",
	  "Lai Châu",
	  "Lào Cai",
	  "Lạng Sơn",
	  "Nam Định",
	  "Ninh Bình",
	  "Phú Thọ",
	  "Quảng Ninh",
	  "Sơn La",
	  "Thái Bình",
	  "Thái Nguyên",
	  "Tuyên Quang",
	  "Vĩnh Phúc",
	  "Yên Bái",
	  "TP Đà Nẵng",
	  "Bình Định",
	  "Đắk Lắk",
	  "Đắk Nông",
	  "Gia Lai",
	  "Hà Tĩnh",
	  "Khánh Hòa",
	  "Kon Tum",
	  "Nghệ An",
	  "Phú Yên",
	  "Quảng Bình",
	  "Quảng Nam",
	  "Quảng Ngãi",
	  "Quảng Trị",
	  "Thanh Hóa",
	  "Thừa Thiên Huế",
	  "TP TP. Hồ Chí Minh",
	  "An Giang",
	  "Bà Rịa Vũng Tàu",
	  "Bạc Liêu",
	  "Bến Tre",
	  "Bình Dương",
	  "Bình Phước",
	  "Bình Thuận",
	  "Cà Mau",
	  "TP Cần Thơ",
	  "Đồng Nai",
	  "Đồng Tháp",
	  "Hậu Giang",
	  "Kiên Giang",
	  "Lâm Đồng",
	  "Long An",
	  "Ninh Thuận",
	  "Sóc Trăng",
	  "Tây Ninh",
	  "Tiền Giang",
	  "Trà Vinh",
	  "Vĩnh Long"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Avon",
	  "Bedfordshire",
	  "Berkshire",
	  "Borders",
	  "Buckinghamshire",
	  "Cambridgeshire",
	  "Central",
	  "Cheshire",
	  "Cleveland",
	  "Clwyd",
	  "Cornwall",
	  "County Antrim",
	  "County Armagh",
	  "County Down",
	  "County Fermanagh",
	  "County Londonderry",
	  "County Tyrone",
	  "Cumbria",
	  "Derbyshire",
	  "Devon",
	  "Dorset",
	  "Dumfries and Galloway",
	  "Durham",
	  "Dyfed",
	  "East Sussex",
	  "Essex",
	  "Fife",
	  "Gloucestershire",
	  "Grampian",
	  "Greater Manchester",
	  "Gwent",
	  "Gwynedd County",
	  "Hampshire",
	  "Herefordshire",
	  "Hertfordshire",
	  "Highlands and Islands",
	  "Humberside",
	  "Isle of Wight",
	  "Kent",
	  "Lancashire",
	  "Leicestershire",
	  "Lincolnshire",
	  "Lothian",
	  "Merseyside",
	  "Mid Glamorgan",
	  "Norfolk",
	  "North Yorkshire",
	  "Northamptonshire",
	  "Northumberland",
	  "Nottinghamshire",
	  "Oxfordshire",
	  "Powys",
	  "Rutland",
	  "Shropshire",
	  "Somerset",
	  "South Glamorgan",
	  "South Yorkshire",
	  "Staffordshire",
	  "Strathclyde",
	  "Suffolk",
	  "Surrey",
	  "Tayside",
	  "Tyne and Wear",
	  "Việt Nam",
	  "Warwickshire",
	  "West Glamorgan",
	  "West Midlands",
	  "West Sussex",
	  "West Yorkshire",
	  "Wiltshire",
	  "Worcestershire"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Việt Nam"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_root = __webpack_require__(2823);
	address.city = __webpack_require__(2822);
	address.county = __webpack_require__(2824);
	address.default_country = __webpack_require__(2825);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "074## ######",
	  "075## ######",
	  "076## ######",
	  "077## ######",
	  "078## ######",
	  "079## ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var cell_phone = {};
	module['exports'] = cell_phone;
	cell_phone.formats = __webpack_require__(2827);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var company = {};
	module['exports'] = company;
	company.prefix = __webpack_require__(2831);
	company.name = __webpack_require__(2830);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{prefix} #{Name.last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Công ty",
	  "Cty TNHH",
	  "Cty",
	  "Cửa hàng",
	  "Trung tâm",
	  "Chi nhánh"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var vi = {};
	module['exports'] = vi;
	vi.title = "Vietnamese";
	vi.address = __webpack_require__(2826);
	vi.internet = __webpack_require__(2834);
	vi.phone_number = __webpack_require__(2842);
	vi.cell_phone = __webpack_require__(2828);
	vi.name = __webpack_require__(2838);
	vi.company = __webpack_require__(2829);
	vi.lorem = __webpack_require__(2835);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "com",
	  "net",
	  "info",
	  "vn",
	  "com.vn"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var internet = {};
	module['exports'] = internet;
	internet.domain_suffix = __webpack_require__(2833);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var lorem = {};
	module['exports'] = lorem;
	lorem.words = __webpack_require__(2836);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "đã",
	  "đang",
	  "ừ",
	  "ờ",
	  "á",
	  "không",
	  "biết",
	  "gì",
	  "hết",
	  "đâu",
	  "nha",
	  "thế",
	  "thì",
	  "là",
	  "đánh",
	  "đá",
	  "đập",
	  "phá",
	  "viết",
	  "vẽ",
	  "tô",
	  "thuê",
	  "mướn",
	  "mượn",
	  "mua",
	  "một",
	  "hai",
	  "ba",
	  "bốn",
	  "năm",
	  "sáu",
	  "bảy",
	  "tám",
	  "chín",
	  "mười",
	  "thôi",
	  "việc",
	  "nghỉ",
	  "làm",
	  "nhà",
	  "cửa",
	  "xe",
	  "đạp",
	  "ác",
	  "độc",
	  "khoảng",
	  "khoan",
	  "thuyền",
	  "tàu",
	  "bè",
	  "lầu",
	  "xanh",
	  "đỏ",
	  "tím",
	  "vàng",
	  "kim",
	  "chỉ",
	  "khâu",
	  "may",
	  "vá",
	  "em",
	  "anh",
	  "yêu",
	  "thương",
	  "thích",
	  "con",
	  "cái",
	  "bàn",
	  "ghế",
	  "tủ",
	  "quần",
	  "áo",
	  "nón",
	  "dép",
	  "giày",
	  "lỗi",
	  "được",
	  "ghét",
	  "giết",
	  "chết",
	  "hết",
	  "tôi",
	  "bạn",
	  "tui",
	  "trời",
	  "trăng",
	  "mây",
	  "gió",
	  "máy",
	  "hàng",
	  "hóa",
	  "leo",
	  "núi",
	  "bơi",
	  "biển",
	  "chìm",
	  "xuồng",
	  "nước",
	  "ngọt",
	  "ruộng",
	  "đồng",
	  "quê",
	  "hương"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Phạm",
	  "Nguyễn",
	  "Trần",
	  "Lê",
	  "Lý",
	  "Hoàng",
	  "Phan",
	  "Vũ",
	  "Tăng",
	  "Đặng",
	  "Bùi",
	  "Đỗ",
	  "Hồ",
	  "Ngô",
	  "Dương",
	  "Đào",
	  "Đoàn",
	  "Vương",
	  "Trịnh",
	  "Đinh",
	  "Lâm",
	  "Phùng",
	  "Mai",
	  "Tô",
	  "Trương",
	  "Hà"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2837);
	name.last_name = __webpack_require__(2839);
	name.name = __webpack_require__(2840);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Nam",
	  "Trung",
	  "Thanh",
	  "Thị",
	  "Văn",
	  "Dương",
	  "Tăng",
	  "Quốc",
	  "Như",
	  "Phạm",
	  "Nguyễn",
	  "Trần",
	  "Lê",
	  "Lý",
	  "Hoàng",
	  "Phan",
	  "Vũ",
	  "Tăng",
	  "Đặng",
	  "Bùi",
	  "Đỗ",
	  "Hồ",
	  "Ngô",
	  "Dương",
	  "Đào",
	  "Đoàn",
	  "Vương",
	  "Trịnh",
	  "Đinh",
	  "Lâm",
	  "Phùng",
	  "Mai",
	  "Tô",
	  "Trương",
	  "Hà",
	  "Vinh",
	  "Nhung",
	  "Hòa",
	  "Tiến",
	  "Tâm",
	  "Bửu",
	  "Loan",
	  "Hiền",
	  "Hải",
	  "Vân",
	  "Kha",
	  "Minh",
	  "Nhân",
	  "Triệu",
	  "Tuân",
	  "Hữu",
	  "Đức",
	  "Phú",
	  "Khoa",
	  "Thắgn",
	  "Sơn",
	  "Dung",
	  "Tú",
	  "Trinh",
	  "Thảo",
	  "Sa",
	  "Kim",
	  "Long",
	  "Thi",
	  "Cường",
	  "Ngọc",
	  "Sinh",
	  "Khang",
	  "Phong",
	  "Thắm",
	  "Thu",
	  "Thủy",
	  "Nhàn"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name}",
	  "#{first_name} #{last_name} #{last_name} #{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "01#### #####",
	  "01### ######",
	  "01#1 ### ####",
	  "011# ### ####",
	  "02# #### ####",
	  "03## ### ####",
	  "055 #### ####",
	  "056 #### ####",
	  "0800 ### ####",
	  "08## ### ####",
	  "09## ### ####",
	  "016977 ####",
	  "01### #####",
	  "0500 ######",
	  "0800 ######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2841);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#####",
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "长",
	  "上",
	  "南",
	  "西",
	  "北",
	  "诸",
	  "宁",
	  "珠",
	  "武",
	  "衡",
	  "成",
	  "福",
	  "厦",
	  "贵",
	  "吉",
	  "海",
	  "太",
	  "济",
	  "安",
	  "吉",
	  "包"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "沙市",
	  "京市",
	  "宁市",
	  "安市",
	  "乡县",
	  "海市",
	  "码市",
	  "汉市",
	  "阳市",
	  "都市",
	  "州市",
	  "门市",
	  "阳市",
	  "口市",
	  "原市",
	  "南市",
	  "徽市",
	  "林市",
	  "头市"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "中国"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2845);
	address.city_suffix = __webpack_require__(2846);
	address.building_number = __webpack_require__(2843);
	address.street_suffix = __webpack_require__(2854);
	address.postcode = __webpack_require__(2849);
	address.state = __webpack_require__(2850);
	address.state_abbr = __webpack_require__(2851);
	address.city = __webpack_require__(2844);
	address.street_name = __webpack_require__(2853);
	address.street_address = __webpack_require__(2852);
	address.default_country = __webpack_require__(2847);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北京市",
	  "上海市",
	  "天津市",
	  "重庆市",
	  "黑龙江省",
	  "吉林省",
	  "辽宁省",
	  "内蒙古",
	  "河北省",
	  "新疆",
	  "甘肃省",
	  "青海省",
	  "陕西省",
	  "宁夏",
	  "河南省",
	  "山东省",
	  "山西省",
	  "安徽省",
	  "湖北省",
	  "湖南省",
	  "江苏省",
	  "四川省",
	  "贵州省",
	  "云南省",
	  "广西省",
	  "西藏",
	  "浙江省",
	  "江西省",
	  "广东省",
	  "福建省",
	  "台湾省",
	  "海南省",
	  "香港",
	  "澳门"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "京",
	  "沪",
	  "津",
	  "渝",
	  "黑",
	  "吉",
	  "辽",
	  "蒙",
	  "冀",
	  "新",
	  "甘",
	  "青",
	  "陕",
	  "宁",
	  "豫",
	  "鲁",
	  "晋",
	  "皖",
	  "鄂",
	  "湘",
	  "苏",
	  "川",
	  "黔",
	  "滇",
	  "桂",
	  "藏",
	  "浙",
	  "赣",
	  "粤",
	  "闽",
	  "台",
	  "琼",
	  "港",
	  "澳"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}号"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "巷",
	  "街",
	  "路",
	  "桥",
	  "侬",
	  "旁",
	  "中心",
	  "栋"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var zh_CN = {};
	module['exports'] = zh_CN;
	zh_CN.title = "Chinese";
	zh_CN.address = __webpack_require__(2848);
	zh_CN.name = __webpack_require__(2857);
	zh_CN.phone_number = __webpack_require__(2861);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "王",
	  "李",
	  "张",
	  "刘",
	  "陈",
	  "杨",
	  "黄",
	  "吴",
	  "赵",
	  "周",
	  "徐",
	  "孙",
	  "马",
	  "朱",
	  "胡",
	  "林",
	  "郭",
	  "何",
	  "高",
	  "罗",
	  "郑",
	  "梁",
	  "谢",
	  "宋",
	  "唐",
	  "许",
	  "邓",
	  "冯",
	  "韩",
	  "曹",
	  "曾",
	  "彭",
	  "萧",
	  "蔡",
	  "潘",
	  "田",
	  "董",
	  "袁",
	  "于",
	  "余",
	  "叶",
	  "蒋",
	  "杜",
	  "苏",
	  "魏",
	  "程",
	  "吕",
	  "丁",
	  "沈",
	  "任",
	  "姚",
	  "卢",
	  "傅",
	  "钟",
	  "姜",
	  "崔",
	  "谭",
	  "廖",
	  "范",
	  "汪",
	  "陆",
	  "金",
	  "石",
	  "戴",
	  "贾",
	  "韦",
	  "夏",
	  "邱",
	  "方",
	  "侯",
	  "邹",
	  "熊",
	  "孟",
	  "秦",
	  "白",
	  "江",
	  "阎",
	  "薛",
	  "尹",
	  "段",
	  "雷",
	  "黎",
	  "史",
	  "龙",
	  "陶",
	  "贺",
	  "顾",
	  "毛",
	  "郝",
	  "龚",
	  "邵",
	  "万",
	  "钱",
	  "严",
	  "赖",
	  "覃",
	  "洪",
	  "武",
	  "莫",
	  "孔"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2856);
	name.last_name = __webpack_require__(2858);
	name.name = __webpack_require__(2859);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "绍齐",
	  "博文",
	  "梓晨",
	  "胤祥",
	  "瑞霖",
	  "明哲",
	  "天翊",
	  "凯瑞",
	  "健雄",
	  "耀杰",
	  "潇然",
	  "子涵",
	  "越彬",
	  "钰轩",
	  "智辉",
	  "致远",
	  "俊驰",
	  "雨泽",
	  "烨磊",
	  "晟睿",
	  "文昊",
	  "修洁",
	  "黎昕",
	  "远航",
	  "旭尧",
	  "鸿涛",
	  "伟祺",
	  "荣轩",
	  "越泽",
	  "浩宇",
	  "瑾瑜",
	  "皓轩",
	  "擎苍",
	  "擎宇",
	  "志泽",
	  "子轩",
	  "睿渊",
	  "弘文",
	  "哲瀚",
	  "雨泽",
	  "楷瑞",
	  "建辉",
	  "晋鹏",
	  "天磊",
	  "绍辉",
	  "泽洋",
	  "鑫磊",
	  "鹏煊",
	  "昊强",
	  "伟宸",
	  "博超",
	  "君浩",
	  "子骞",
	  "鹏涛",
	  "炎彬",
	  "鹤轩",
	  "越彬",
	  "风华",
	  "靖琪",
	  "明辉",
	  "伟诚",
	  "明轩",
	  "健柏",
	  "修杰",
	  "志泽",
	  "弘文",
	  "峻熙",
	  "嘉懿",
	  "煜城",
	  "懿轩",
	  "烨伟",
	  "苑博",
	  "伟泽",
	  "熠彤",
	  "鸿煊",
	  "博涛",
	  "烨霖",
	  "烨华",
	  "煜祺",
	  "智宸",
	  "正豪",
	  "昊然",
	  "明杰",
	  "立诚",
	  "立轩",
	  "立辉",
	  "峻熙",
	  "弘文",
	  "熠彤",
	  "鸿煊",
	  "烨霖",
	  "哲瀚",
	  "鑫鹏",
	  "昊天",
	  "思聪",
	  "展鹏",
	  "笑愚",
	  "志强",
	  "炫明",
	  "雪松",
	  "思源",
	  "智渊",
	  "思淼",
	  "晓啸",
	  "天宇",
	  "浩然",
	  "文轩",
	  "鹭洋",
	  "振家",
	  "乐驹",
	  "晓博",
	  "文博",
	  "昊焱",
	  "立果",
	  "金鑫",
	  "锦程",
	  "嘉熙",
	  "鹏飞",
	  "子默",
	  "思远",
	  "浩轩",
	  "语堂",
	  "聪健",
	  "明",
	  "文",
	  "果",
	  "思",
	  "鹏",
	  "驰",
	  "涛",
	  "琪",
	  "浩",
	  "航",
	  "彬"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name}#{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "###-########",
	  "####-########",
	  "###########"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2860);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "####",
	  "###",
	  "##",
	  "#"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{city_prefix}#{city_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "臺北",
	  "新北",
	  "桃園",
	  "臺中",
	  "臺南",
	  "高雄",
	  "基隆",
	  "新竹",
	  "嘉義",
	  "苗栗",
	  "彰化",
	  "南投",
	  "雲林",
	  "屏東",
	  "宜蘭",
	  "花蓮",
	  "臺東",
	  "澎湖",
	  "金門",
	  "連江"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "縣",
	  "市"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "Taiwan (R.O.C.)"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var address = {};
	module['exports'] = address;
	address.city_prefix = __webpack_require__(2864);
	address.city_suffix = __webpack_require__(2865);
	address.building_number = __webpack_require__(2862);
	address.street_suffix = __webpack_require__(2873);
	address.postcode = __webpack_require__(2868);
	address.state = __webpack_require__(2869);
	address.state_abbr = __webpack_require__(2870);
	address.city = __webpack_require__(2863);
	address.street_name = __webpack_require__(2872);
	address.street_address = __webpack_require__(2871);
	address.default_country = __webpack_require__(2866);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "福建省",
	  "台灣省"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "北",
	  "新北",
	  "桃",
	  "中",
	  "南",
	  "高",
	  "基",
	  "竹市",
	  "嘉市",
	  "竹縣",
	  "苗",
	  "彰",
	  "投",
	  "雲",
	  "嘉縣",
	  "宜",
	  "花",
	  "東",
	  "澎",
	  "金",
	  "馬"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{street_name}#{building_number}號"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{Name.last_name}#{street_suffix}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "街",
	  "路",
	  "北路",
	  "南路",
	  "東路",
	  "西路"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var zh_TW = {};
	module['exports'] = zh_TW;
	zh_TW.title = "Chinese (Taiwan)";
	zh_TW.address = __webpack_require__(2867);
	zh_TW.name = __webpack_require__(2876);
	zh_TW.phone_number = __webpack_require__(2880);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "王",
	  "李",
	  "張",
	  "劉",
	  "陳",
	  "楊",
	  "黃",
	  "吳",
	  "趙",
	  "週",
	  "徐",
	  "孫",
	  "馬",
	  "朱",
	  "胡",
	  "林",
	  "郭",
	  "何",
	  "高",
	  "羅",
	  "鄭",
	  "梁",
	  "謝",
	  "宋",
	  "唐",
	  "許",
	  "鄧",
	  "馮",
	  "韓",
	  "曹",
	  "曾",
	  "彭",
	  "蕭",
	  "蔡",
	  "潘",
	  "田",
	  "董",
	  "袁",
	  "於",
	  "餘",
	  "葉",
	  "蔣",
	  "杜",
	  "蘇",
	  "魏",
	  "程",
	  "呂",
	  "丁",
	  "沈",
	  "任",
	  "姚",
	  "盧",
	  "傅",
	  "鐘",
	  "姜",
	  "崔",
	  "譚",
	  "廖",
	  "範",
	  "汪",
	  "陸",
	  "金",
	  "石",
	  "戴",
	  "賈",
	  "韋",
	  "夏",
	  "邱",
	  "方",
	  "侯",
	  "鄒",
	  "熊",
	  "孟",
	  "秦",
	  "白",
	  "江",
	  "閻",
	  "薛",
	  "尹",
	  "段",
	  "雷",
	  "黎",
	  "史",
	  "龍",
	  "陶",
	  "賀",
	  "顧",
	  "毛",
	  "郝",
	  "龔",
	  "邵",
	  "萬",
	  "錢",
	  "嚴",
	  "賴",
	  "覃",
	  "洪",
	  "武",
	  "莫",
	  "孔"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var name = {};
	module['exports'] = name;
	name.first_name = __webpack_require__(2875);
	name.last_name = __webpack_require__(2877);
	name.name = __webpack_require__(2878);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "紹齊",
	  "博文",
	  "梓晨",
	  "胤祥",
	  "瑞霖",
	  "明哲",
	  "天翊",
	  "凱瑞",
	  "健雄",
	  "耀傑",
	  "瀟然",
	  "子涵",
	  "越彬",
	  "鈺軒",
	  "智輝",
	  "致遠",
	  "俊馳",
	  "雨澤",
	  "燁磊",
	  "晟睿",
	  "文昊",
	  "修潔",
	  "黎昕",
	  "遠航",
	  "旭堯",
	  "鴻濤",
	  "偉祺",
	  "榮軒",
	  "越澤",
	  "浩宇",
	  "瑾瑜",
	  "皓軒",
	  "擎蒼",
	  "擎宇",
	  "志澤",
	  "子軒",
	  "睿淵",
	  "弘文",
	  "哲瀚",
	  "雨澤",
	  "楷瑞",
	  "建輝",
	  "晉鵬",
	  "天磊",
	  "紹輝",
	  "澤洋",
	  "鑫磊",
	  "鵬煊",
	  "昊強",
	  "偉宸",
	  "博超",
	  "君浩",
	  "子騫",
	  "鵬濤",
	  "炎彬",
	  "鶴軒",
	  "越彬",
	  "風華",
	  "靖琪",
	  "明輝",
	  "偉誠",
	  "明軒",
	  "健柏",
	  "修傑",
	  "志澤",
	  "弘文",
	  "峻熙",
	  "嘉懿",
	  "煜城",
	  "懿軒",
	  "燁偉",
	  "苑博",
	  "偉澤",
	  "熠彤",
	  "鴻煊",
	  "博濤",
	  "燁霖",
	  "燁華",
	  "煜祺",
	  "智宸",
	  "正豪",
	  "昊然",
	  "明杰",
	  "立誠",
	  "立軒",
	  "立輝",
	  "峻熙",
	  "弘文",
	  "熠彤",
	  "鴻煊",
	  "燁霖",
	  "哲瀚",
	  "鑫鵬",
	  "昊天",
	  "思聰",
	  "展鵬",
	  "笑愚",
	  "志強",
	  "炫明",
	  "雪松",
	  "思源",
	  "智淵",
	  "思淼",
	  "曉嘯",
	  "天宇",
	  "浩然",
	  "文軒",
	  "鷺洋",
	  "振家",
	  "樂駒",
	  "曉博",
	  "文博",
	  "昊焱",
	  "立果",
	  "金鑫",
	  "錦程",
	  "嘉熙",
	  "鵬飛",
	  "子默",
	  "思遠",
	  "浩軒",
	  "語堂",
	  "聰健"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "#{first_name}#{last_name}"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {module["exports"] = [
	  "0#-#######",
	  "02-########",
	  "09##-######"
	];
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var phone_number = {};
	module['exports'] = phone_number;
	phone_number.formats = __webpack_require__(2879);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {
	/**
	 *
	 * @namespace faker.lorem
	 */
	var Lorem = function (faker) {
	  var self = this;
	  var Helpers = faker.helpers;
	
	  /**
	   * word
	   *
	   * @method faker.lorem.word
	   * @param {number} num
	   */
	  self.word = function (num) {
	    return faker.random.arrayElement(faker.definitions.lorem.words);
	  };
	
	  /**
	   * generates a space separated list of words
	   *
	   * @method faker.lorem.words
	   * @param {number} num number of words, defaults to 3
	   */
	  self.words = function (num) {
	      if (typeof num == 'undefined') { num = 3; }
	      var words = [];
	      for (var i = 0; i < num; i++) {
	        words.push(faker.lorem.word());
	      }
	      return words.join(' ');
	  };
	
	  /**
	   * sentence
	   *
	   * @method faker.lorem.sentence
	   * @param {number} wordCount defaults to a random number between 3 and 10
	   * @param {number} range
	   */
	  self.sentence = function (wordCount, range) {
	      if (typeof wordCount == 'undefined') { wordCount = faker.random.number({ min: 3, max: 10 }); }
	      // if (typeof range == 'undefined') { range = 7; }
	
	      // strange issue with the node_min_test failing for captialize, please fix and add faker.lorem.back
	      //return  faker.lorem.words(wordCount + Helpers.randomNumber(range)).join(' ').capitalize();
	
	      var sentence = faker.lorem.words(wordCount);
	      return sentence.charAt(0).toUpperCase() + sentence.slice(1) + '.';
	  };
	
	  /**
	   * sentences
	   *
	   * @method faker.lorem.sentences
	   * @param {number} sentenceCount defautls to a random number between 2 and 6
	   * @param {string} separator defaults to `' '`
	   */
	  self.sentences = function (sentenceCount, separator) {
	      if (typeof sentenceCount === 'undefined') { sentenceCount = faker.random.number({ min: 2, max: 6 });}
	      if (typeof separator == 'undefined') { separator = " "; }
	      var sentences = [];
	      for (sentenceCount; sentenceCount > 0; sentenceCount--) {
	        sentences.push(faker.lorem.sentence());
	      }
	      return sentences.join(separator);
	  };
	
	  /**
	   * paragraph
	   *
	   * @method faker.lorem.paragraph
	   * @param {number} sentenceCount defaults to 3
	   */
	  self.paragraph = function (sentenceCount) {
	      if (typeof sentenceCount == 'undefined') { sentenceCount = 3; }
	      return faker.lorem.sentences(sentenceCount + faker.random.number(3));
	  };
	
	  /**
	   * paragraphs
	   *
	   * @method faker.lorem.paragraphs
	   * @param {number} paragraphCount defaults to 3
	   * @param {string} separatora defaults to `'\n \r'`
	   */
	  self.paragraphs = function (paragraphCount, separator) {
	    if (typeof separator === "undefined") {
	      separator = "\n \r";
	    }
	    if (typeof paragraphCount == 'undefined') { paragraphCount = 3; }
	    var paragraphs = [];
	    for (paragraphCount; paragraphCount > 0; paragraphCount--) {
	        paragraphs.push(faker.lorem.paragraph());
	    }
	    return paragraphs.join(separator);
	  }
	
	  /**
	   * returns random text based on a random lorem method
	   *
	   * @method faker.lorem.text
	   * @param {number} times
	   */
	  self.text = function loremText (times) {
	    var loremMethods = ['lorem.word', 'lorem.words', 'lorem.sentence', 'lorem.sentences', 'lorem.paragraph', 'lorem.paragraphs', 'lorem.lines'];
	    var randomLoremMethod = faker.random.arrayElement(loremMethods);
	    return faker.fake('{{' + randomLoremMethod + '}}');
	  };
	
	  /**
	   * returns lines of lorem separated by `'\n'`
	   *
	   * @method faker.lorem.lines
	   * @param {number} lineCount defaults to a random number between 1 and 5
	   */
	  self.lines = function lines (lineCount) {
	    if (typeof lineCount === 'undefined') { lineCount = faker.random.number({ min: 1, max: 5 });}
	    return faker.lorem.sentences(lineCount, '\n')
	  };
	
	  return self;
	};
	
	
	module["exports"] = Lorem;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.name
	 */
	function Name (faker) {
	
	  /**
	   * firstName
	   *
	   * @method firstName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.firstName = function (gender) {
	    if (typeof faker.definitions.name.male_first_name !== "undefined" && typeof faker.definitions.name.female_first_name !== "undefined") {
	      // some locale datasets ( like ru ) have first_name split by gender. since the name.first_name field does not exist in these datasets,
	      // we must randomly pick a name from either gender array so faker.name.firstName will return the correct locale data ( and not fallback )
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_first_name)
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_first_name);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.first_name);
	  };
	
	  /**
	   * lastName
	   *
	   * @method lastName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.lastName = function (gender) {
	    if (typeof faker.definitions.name.male_last_name !== "undefined" && typeof faker.definitions.name.female_last_name !== "undefined") {
	      // some locale datasets ( like ru ) have last_name split by gender. i have no idea how last names can have genders, but also i do not speak russian
	      // see above comment of firstName method
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_last_name);
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_last_name);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.last_name);
	  };
	
	  /**
	   * findName
	   *
	   * @method findName
	   * @param {string} firstName
	   * @param {string} lastName
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.findName = function (firstName, lastName, gender) {
	      var r = faker.random.number(8);
	      var prefix, suffix;
	      // in particular locales first and last names split by gender,
	      // thus we keep consistency by passing 0 as male and 1 as female
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      firstName = firstName || faker.name.firstName(gender);
	      lastName = lastName || faker.name.lastName(gender);
	      switch (r) {
	      case 0:
	          prefix = faker.name.prefix(gender);
	          if (prefix) {
	              return prefix + " " + firstName + " " + lastName;
	          }
	      case 1:
	          suffix = faker.name.suffix(gender);
	          if (suffix) {
	              return firstName + " " + lastName + " " + suffix;
	          }
	      }
	
	      return firstName + " " + lastName;
	  };
	
	  /**
	   * jobTitle
	   *
	   * @method jobTitle
	   * @memberof faker.name
	   */
	  this.jobTitle = function () {
	    return  faker.name.jobDescriptor() + " " +
	      faker.name.jobArea() + " " +
	      faker.name.jobType();
	  };
	  
	  /**
	   * prefix
	   *
	   * @method prefix
	   * @param {mixed} gender
	   * @memberof faker.name
	   */
	  this.prefix = function (gender) {
	    if (typeof faker.definitions.name.male_prefix !== "undefined" && typeof faker.definitions.name.female_prefix !== "undefined") {
	      if (typeof gender !== 'number') {
	        gender = faker.random.number(1);
	      }
	      if (gender === 0) {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.male_prefix);
	      } else {
	        return faker.random.arrayElement(faker.locales[faker.locale].name.female_prefix);
	      }
	    }
	    return faker.random.arrayElement(faker.definitions.name.prefix);
	  };
	
	  /**
	   * suffix
	   *
	   * @method suffix
	   * @memberof faker.name
	   */
	  this.suffix = function () {
	      return faker.random.arrayElement(faker.definitions.name.suffix);
	  };
	
	  /**
	   * title
	   *
	   * @method title
	   * @memberof faker.name
	   */
	  this.title = function() {
	      var descriptor  = faker.random.arrayElement(faker.definitions.name.title.descriptor),
	          level       = faker.random.arrayElement(faker.definitions.name.title.level),
	          job         = faker.random.arrayElement(faker.definitions.name.title.job);
	
	      return descriptor + " " + level + " " + job;
	  };
	
	  /**
	   * jobDescriptor
	   *
	   * @method jobDescriptor
	   * @memberof faker.name
	   */
	  this.jobDescriptor = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.descriptor);
	  };
	
	  /**
	   * jobArea
	   *
	   * @method jobArea
	   * @memberof faker.name
	   */
	  this.jobArea = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.level);
	  };
	
	  /**
	   * jobType
	   *
	   * @method jobType
	   * @memberof faker.name
	   */
	  this.jobType = function () {
	    return faker.random.arrayElement(faker.definitions.name.title.job);
	  };
	
	}
	
	module['exports'] = Name;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 *
	 * @namespace faker.phone
	 */
	var Phone = function (faker) {
	  var self = this;
	
	  /**
	   * phoneNumber
	   *
	   * @method faker.phone.phoneNumber
	   * @param {string} format
	   */
	  self.phoneNumber = function (format) {
	      format = format || faker.phone.phoneFormats();
	      return faker.helpers.replaceSymbolWithNumber(format);
	  };
	
	  // FIXME: this is strange passing in an array index.
	  /**
	   * phoneNumberFormat
	   *
	   * @method faker.phone.phoneFormatsArrayIndex
	   * @param phoneFormatsArrayIndex
	   */
	  self.phoneNumberFormat = function (phoneFormatsArrayIndex) {
	      phoneFormatsArrayIndex = phoneFormatsArrayIndex || 0;
	      return faker.helpers.replaceSymbolWithNumber(faker.definitions.phone_number.formats[phoneFormatsArrayIndex]);
	  };
	
	  /**
	   * phoneFormats
	   *
	   * @method faker.phone.phoneFormats
	   */
	  self.phoneFormats = function () {
	    return faker.random.arrayElement(faker.definitions.phone_number.formats);
	  };
	  
	  return self;
	
	};
	
	module['exports'] = Phone;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {// generates fake data for many computer systems properties
	
	/**
	 *
	 * @namespace faker.system
	 */
	function System (faker) {
	
	  /**
	   * generates a file name with extension or optional type
	   *
	   * @method faker.system.fileName
	   * @param {string} ext
	   * @param {string} type
	   */
	  this.fileName = function (ext, type) {
	    var str = faker.fake("{{random.words}}.{{system.fileExt}}");
	    str = str.replace(/ /g, '_');
	    str = str.replace(/\,/g, '_');
	    str = str.replace(/\-/g, '_');
	    str = str.replace(/\\/g, '_');
	    str = str.toLowerCase();
	    return str;
	  };
	
	  /**
	   * commonFileName
	   *
	   * @method faker.system.commonFileName
	   * @param {string} ext
	   * @param {string} type
	   */
	  this.commonFileName = function (ext, type) {
	    var str = faker.random.words() + "." + (ext || faker.system.commonFileExt());
	    str = str.replace(/ /g, '_');
	    str = str.replace(/\,/g, '_');
	    str = str.replace(/\-/g, '_');
	    str = str.replace(/\\/g, '_');
	    str = str.toLowerCase();
	    return str;
	  };
	
	  /**
	   * mimeType
	   *
	   * @method faker.system.mimeType
	   */
	  this.mimeType = function () {
	    return faker.random.arrayElement(Object.keys(faker.definitions.system.mimeTypes));
	  };
	
	  /**
	   * returns a commonly used file type
	   *
	   * @method faker.system.commonFileType
	   */
	  this.commonFileType = function () {
	    var types = ['video', 'audio', 'image', 'text', 'application'];
	    return faker.random.arrayElement(types)
	  };
	
	  /**
	   * returns a commonly used file extension based on optional type
	   *
	   * @method faker.system.commonFileExt
	   * @param {string} type
	   */
	  this.commonFileExt = function (type) {
	    var types = [
	      'application/pdf',
	      'audio/mpeg',
	      'audio/wav',
	      'image/png',
	      'image/jpeg',
	      'image/gif',
	      'video/mp4',
	      'video/mpeg',
	      'text/html'
	    ];
	    return faker.system.fileExt(faker.random.arrayElement(types));
	  };
	
	
	  /**
	   * returns any file type available as mime-type
	   *
	   * @method faker.system.fileType
	   */
	  this.fileType = function () {
	    var types = [];
	    var mimes = faker.definitions.system.mimeTypes;
	    Object.keys(mimes).forEach(function(m){
	      var parts = m.split('/');
	      if (types.indexOf(parts[0]) === -1) {
	        types.push(parts[0]);
	      }
	    });
	    return faker.random.arrayElement(types);
	  };
	
	  /**
	   * fileExt
	   *
	   * @method faker.system.fileExt
	   * @param {string} mimeType
	   */
	  this.fileExt = function (mimeType) {
	    var exts = [];
	    var mimes = faker.definitions.system.mimeTypes;
	
	    // get specific ext by mime-type
	    if (typeof mimes[mimeType] === "object") {
	      return faker.random.arrayElement(mimes[mimeType].extensions);
	    }
	
	    // reduce mime-types to those with file-extensions
	    Object.keys(mimes).forEach(function(m){
	      if (mimes[m].extensions instanceof Array) {
	        mimes[m].extensions.forEach(function(ext){
	          exts.push(ext)
	        });
	      }
	    });
	    return faker.random.arrayElement(exts);
	  };
	
	  /**
	   * not yet implemented
	   *
	   * @method faker.system.directoryPath
	   */
	  this.directoryPath = function () {
	    // TODO
	  };
	
	  /**
	   * not yet implemented
	   *
	   * @method faker.system.filePath
	   */
	  this.filePath = function () {
	    // TODO
	  };
	
	  /**
	   * semver
	   *
	   * @method faker.system.semver
	   */
	  this.semver = function () {
	      return [faker.random.number(9),
	              faker.random.number(9),
	              faker.random.number(9)].join('.');
	  }
	
	}
	
	module['exports'] = System;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))

/***/ }),
/* 2885 */
/***/ (function(module, exports) {

	// this program is a JavaScript version of Mersenne Twister, with concealment and encapsulation in class,
	// an almost straight conversion from the original program, mt19937ar.c,
	// translated by y. okada on July 17, 2006.
	// and modified a little at july 20, 2006, but there are not any substantial differences.
	// in this program, procedure descriptions and comments of original source code were not removed.
	// lines commented with //c// were originally descriptions of c procedure. and a few following lines are appropriate JavaScript descriptions.
	// lines commented with /* and */ are original comments.
	// lines commented with // are additional comments in this JavaScript version.
	// before using this version, create at least one instance of MersenneTwister19937 class, and initialize the each state, given below in c comments, of all the instances.
	/*
	   A C-program for MT19937, with initialization improved 2002/1/26.
	   Coded by Takuji Nishimura and Makoto Matsumoto.
	
	   Before using, initialize the state by using init_genrand(seed)
	   or init_by_array(init_key, key_length).
	
	   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
	   All rights reserved.
	
	   Redistribution and use in source and binary forms, with or without
	   modification, are permitted provided that the following conditions
	   are met:
	
	     1. Redistributions of source code must retain the above copyright
	        notice, this list of conditions and the following disclaimer.
	
	     2. Redistributions in binary form must reproduce the above copyright
	        notice, this list of conditions and the following disclaimer in the
	        documentation and/or other materials provided with the distribution.
	
	     3. The names of its contributors may not be used to endorse or promote
	        products derived from this software without specific prior written
	        permission.
	
	   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
	   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
	   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
	   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	
	
	   Any feedback is very welcome.
	   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
	   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
	*/
	
	function MersenneTwister19937()
	{
		/* constants should be scoped inside the class */
		var N, M, MATRIX_A, UPPER_MASK, LOWER_MASK;
		/* Period parameters */
		//c//#define N 624
		//c//#define M 397
		//c//#define MATRIX_A 0x9908b0dfUL   /* constant vector a */
		//c//#define UPPER_MASK 0x80000000UL /* most significant w-r bits */
		//c//#define LOWER_MASK 0x7fffffffUL /* least significant r bits */
		N = 624;
		M = 397;
		MATRIX_A = 0x9908b0df;   /* constant vector a */
		UPPER_MASK = 0x80000000; /* most significant w-r bits */
		LOWER_MASK = 0x7fffffff; /* least significant r bits */
		//c//static unsigned long mt[N]; /* the array for the state vector  */
		//c//static int mti=N+1; /* mti==N+1 means mt[N] is not initialized */
		var mt = new Array(N);   /* the array for the state vector  */
		var mti = N+1;           /* mti==N+1 means mt[N] is not initialized */
	
		function unsigned32 (n1) // returns a 32-bits unsiged integer from an operand to which applied a bit operator.
		{
			return n1 < 0 ? (n1 ^ UPPER_MASK) + UPPER_MASK : n1;
		}
	
		function subtraction32 (n1, n2) // emulates lowerflow of a c 32-bits unsiged integer variable, instead of the operator -. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			return n1 < n2 ? unsigned32((0x100000000 - (n2 - n1)) & 0xffffffff) : n1 - n2;
		}
	
		function addition32 (n1, n2) // emulates overflow of a c 32-bits unsiged integer variable, instead of the operator +. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			return unsigned32((n1 + n2) & 0xffffffff)
		}
	
		function multiplication32 (n1, n2) // emulates overflow of a c 32-bits unsiged integer variable, instead of the operator *. these both arguments must be non-negative integers expressible using unsigned 32 bits.
		{
			var sum = 0;
			for (var i = 0; i < 32; ++i){
				if ((n1 >>> i) & 0x1){
					sum = addition32(sum, unsigned32(n2 << i));
				}
			}
			return sum;
		}
	
		/* initializes mt[N] with a seed */
		//c//void init_genrand(unsigned long s)
		this.init_genrand = function (s)
		{
			//c//mt[0]= s & 0xffffffff;
			mt[0]= unsigned32(s & 0xffffffff);
			for (mti=1; mti<N; mti++) {
				mt[mti] =
				//c//(1812433253 * (mt[mti-1] ^ (mt[mti-1] >> 30)) + mti);
				addition32(multiplication32(1812433253, unsigned32(mt[mti-1] ^ (mt[mti-1] >>> 30))), mti);
				/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
				/* In the previous versions, MSBs of the seed affect   */
				/* only MSBs of the array mt[].                        */
				/* 2002/01/09 modified by Makoto Matsumoto             */
				//c//mt[mti] &= 0xffffffff;
				mt[mti] = unsigned32(mt[mti] & 0xffffffff);
				/* for >32 bit machines */
			}
		}
	
		/* initialize by an array with array-length */
		/* init_key is the array for initializing keys */
		/* key_length is its length */
		/* slight change for C++, 2004/2/26 */
		//c//void init_by_array(unsigned long init_key[], int key_length)
		this.init_by_array = function (init_key, key_length)
		{
			//c//int i, j, k;
			var i, j, k;
			//c//init_genrand(19650218);
			this.init_genrand(19650218);
			i=1; j=0;
			k = (N>key_length ? N : key_length);
			for (; k; k--) {
				//c//mt[i] = (mt[i] ^ ((mt[i-1] ^ (mt[i-1] >> 30)) * 1664525))
				//c//	+ init_key[j] + j; /* non linear */
				mt[i] = addition32(addition32(unsigned32(mt[i] ^ multiplication32(unsigned32(mt[i-1] ^ (mt[i-1] >>> 30)), 1664525)), init_key[j]), j);
				mt[i] =
				//c//mt[i] &= 0xffffffff; /* for WORDSIZE > 32 machines */
				unsigned32(mt[i] & 0xffffffff);
				i++; j++;
				if (i>=N) { mt[0] = mt[N-1]; i=1; }
				if (j>=key_length) j=0;
			}
			for (k=N-1; k; k--) {
				//c//mt[i] = (mt[i] ^ ((mt[i-1] ^ (mt[i-1] >> 30)) * 1566083941))
				//c//- i; /* non linear */
				mt[i] = subtraction32(unsigned32((dbg=mt[i]) ^ multiplication32(unsigned32(mt[i-1] ^ (mt[i-1] >>> 30)), 1566083941)), i);
				//c//mt[i] &= 0xffffffff; /* for WORDSIZE > 32 machines */
				mt[i] = unsigned32(mt[i] & 0xffffffff);
				i++;
				if (i>=N) { mt[0] = mt[N-1]; i=1; }
			}
			mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */
		}
	
	    /* moved outside of genrand_int32() by jwatte 2010-11-17; generate less garbage */
	    var mag01 = [0x0, MATRIX_A];
	
		/* generates a random number on [0,0xffffffff]-interval */
		//c//unsigned long genrand_int32(void)
		this.genrand_int32 = function ()
		{
			//c//unsigned long y;
			//c//static unsigned long mag01[2]={0x0UL, MATRIX_A};
			var y;
			/* mag01[x] = x * MATRIX_A  for x=0,1 */
	
			if (mti >= N) { /* generate N words at one time */
				//c//int kk;
				var kk;
	
				if (mti == N+1)   /* if init_genrand() has not been called, */
					//c//init_genrand(5489); /* a default initial seed is used */
					this.init_genrand(5489); /* a default initial seed is used */
	
				for (kk=0;kk<N-M;kk++) {
					//c//y = (mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK);
					//c//mt[kk] = mt[kk+M] ^ (y >> 1) ^ mag01[y & 0x1];
					y = unsigned32((mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK));
					mt[kk] = unsigned32(mt[kk+M] ^ (y >>> 1) ^ mag01[y & 0x1]);
				}
				for (;kk<N-1;kk++) {
					//c//y = (mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK);
					//c//mt[kk] = mt[kk+(M-N)] ^ (y >> 1) ^ mag01[y & 0x1];
					y = unsigned32((mt[kk]&UPPER_MASK)|(mt[kk+1]&LOWER_MASK));
					mt[kk] = unsigned32(mt[kk+(M-N)] ^ (y >>> 1) ^ mag01[y & 0x1]);
				}
				//c//y = (mt[N-1]&UPPER_MASK)|(mt[0]&LOWER_MASK);
				//c//mt[N-1] = mt[M-1] ^ (y >> 1) ^ mag01[y & 0x1];
				y = unsigned32((mt[N-1]&UPPER_MASK)|(mt[0]&LOWER_MASK));
				mt[N-1] = unsigned32(mt[M-1] ^ (y >>> 1) ^ mag01[y & 0x1]);
				mti = 0;
			}
	
			y = mt[mti++];
	
			/* Tempering */
			//c//y ^= (y >> 11);
			//c//y ^= (y << 7) & 0x9d2c5680;
			//c//y ^= (y << 15) & 0xefc60000;
			//c//y ^= (y >> 18);
			y = unsigned32(y ^ (y >>> 11));
			y = unsigned32(y ^ ((y << 7) & 0x9d2c5680));
			y = unsigned32(y ^ ((y << 15) & 0xefc60000));
			y = unsigned32(y ^ (y >>> 18));
	
			return y;
		}
	
		/* generates a random number on [0,0x7fffffff]-interval */
		//c//long genrand_int31(void)
		this.genrand_int31 = function ()
		{
			//c//return (genrand_int32()>>1);
			return (this.genrand_int32()>>>1);
		}
	
		/* generates a random number on [0,1]-real-interval */
		//c//double genrand_real1(void)
		this.genrand_real1 = function ()
		{
			//c//return genrand_int32()*(1.0/4294967295.0);
			return this.genrand_int32()*(1.0/4294967295.0);
			/* divided by 2^32-1 */
		}
	
		/* generates a random number on [0,1)-real-interval */
		//c//double genrand_real2(void)
		this.genrand_real2 = function ()
		{
			//c//return genrand_int32()*(1.0/4294967296.0);
			return this.genrand_int32()*(1.0/4294967296.0);
			/* divided by 2^32 */
		}
	
		/* generates a random number on (0,1)-real-interval */
		//c//double genrand_real3(void)
		this.genrand_real3 = function ()
		{
			//c//return ((genrand_int32()) + 0.5)*(1.0/4294967296.0);
			return ((this.genrand_int32()) + 0.5)*(1.0/4294967296.0);
			/* divided by 2^32 */
		}
	
		/* generates a random number on [0,1) with 53-bit resolution*/
		//c//double genrand_res53(void)
		this.genrand_res53 = function ()
		{
			//c//unsigned long a=genrand_int32()>>5, b=genrand_int32()>>6;
			var a=this.genrand_int32()>>>5, b=this.genrand_int32()>>>6;
			return(a*67108864.0+b)*(1.0/9007199254740992.0);
		}
		/* These real versions are due to Isaku Wada, 2002/01/09 added */
	}
	
	//  Exports: Public API
	
	//  Export the twister class
	exports.MersenneTwister19937 = MersenneTwister19937;
	
	//  Export a simplified function to generate random numbers
	var gen = new MersenneTwister19937;
	gen.init_genrand((new Date).getTime() % 1000000000);
	
	// Added max, min range functionality, Marak Squires Sept 11 2014
	exports.rand = function(max, min) {
	    if (max === undefined)
	        {
	        min = 0;
	        max = 32768;
	        }
	    return Math.floor(gen.genrand_real2() * (max - min) + min);
	}
	exports.seed = function(S) {
	    if (typeof(S) != 'number')
	        {
	        throw new Error("seed(S) must take numeric argument; is " + typeof(S));
	        }
	    gen.init_genrand(S);
	}
	exports.seed_array = function(A) {
	    if (typeof(A) != 'object')
	        {
	        throw new Error("seed_array(A) must take array of numbers; is " + typeof(A));
	        }
	    gen.init_by_array(A);
	}


/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * password-generator
	 * Copyright(c) 2011-2013 Bermi Ferrer <bermi@bermilabs.com>
	 * MIT Licensed
	 */
	(function (root) {
	
	  var localName, consonant, letter, password, vowel;
	  letter = /[a-zA-Z]$/;
	  vowel = /[aeiouAEIOU]$/;
	  consonant = /[bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ]$/;
	
	
	  // Defines the name of the local variable the passwordGenerator library will use
	  // this is specially useful if window.passwordGenerator is already being used
	  // by your application and you want a different name. For example:
	  //    // Declare before including the passwordGenerator library
	  //    var localPasswordGeneratorLibraryName = 'pass';
	  localName = root.localPasswordGeneratorLibraryName || "generatePassword",
	
	  password = function (length, memorable, pattern, prefix) {
	    var char, n;
	    if (length == null) {
	      length = 10;
	    }
	    if (memorable == null) {
	      memorable = true;
	    }
	    if (pattern == null) {
	      pattern = /\w/;
	    }
	    if (prefix == null) {
	      prefix = '';
	    }
	    if (prefix.length >= length) {
	      return prefix;
	    }
	    if (memorable) {
	      if (prefix.match(consonant)) {
	        pattern = vowel;
	      } else {
	        pattern = consonant;
	      }
	    }
	    n = Math.floor(Math.random() * 94) + 33;
	    char = String.fromCharCode(n);
	    if (memorable) {
	      char = char.toLowerCase();
	    }
	    if (!char.match(pattern)) {
	      return password(length, memorable, pattern, prefix);
	    }
	    return password(length, memorable, pattern, "" + prefix + char);
	  };
	
	
	  (( true) ? exports : root)[localName] = password;
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      module.exports = password;
	    }
	  }
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	}(this));

/***/ }),
/* 2887 */
/***/ (function(module, exports) {

	/*
	
	Copyright (c) 2012-2014 Jeffrey Mealo
	
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
	documentation files (the "Software"), to deal in the Software without restriction, including without limitation
	the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
	to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all copies or substantial portions of the
	Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
	WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	------------------------------------------------------------------------------------------------------------------------
	
	Based loosely on Luka Pusic's PHP Script: http://360percents.com/posts/php-random-user-agent-generator/
	
	The license for that script is as follows:
	
	"THE BEER-WARE LICENSE" (Revision 42):
	
	<pusic93@gmail.com> wrote this file. As long as you retain this notice you can do whatever you want with this stuff.
	If we meet some day, and you think this stuff is worth it, you can buy me a beer in return. Luka Pusic
	*/
	
	function rnd(a, b) {
	    //calling rnd() with no arguments is identical to rnd(0, 100)
	    a = a || 0;
	    b = b || 100;
	
	    if (typeof b === 'number' && typeof a === 'number') {
	        //rnd(int min, int max) returns integer between min, max
	        return (function (min, max) {
	            if (min > max) {
	                throw new RangeError('expected min <= max; got min = ' + min + ', max = ' + max);
	            }
	            return Math.floor(Math.random() * (max - min + 1)) + min;
	        }(a, b));
	    }
	
	    if (Object.prototype.toString.call(a) === "[object Array]") {
	        //returns a random element from array (a), even weighting
	        return a[Math.floor(Math.random() * a.length)];
	    }
	
	    if (a && typeof a === 'object') {
	        //returns a random key from the passed object; keys are weighted by the decimal probability in their value
	        return (function (obj) {
	            var rand = rnd(0, 100) / 100, min = 0, max = 0, key, return_val;
	
	            for (key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    max = obj[key] + min;
	                    return_val = key;
	                    if (rand >= min && rand <= max) {
	                        break;
	                    }
	                    min = min + obj[key];
	                }
	            }
	
	            return return_val;
	        }(a));
	    }
	
	    throw new TypeError('Invalid arguments passed to rnd. (' + (b ? a + ', ' + b : a) + ')');
	}
	
	function randomLang() {
	    return rnd(['AB', 'AF', 'AN', 'AR', 'AS', 'AZ', 'BE', 'BG', 'BN', 'BO', 'BR', 'BS', 'CA', 'CE', 'CO', 'CS',
	                'CU', 'CY', 'DA', 'DE', 'EL', 'EN', 'EO', 'ES', 'ET', 'EU', 'FA', 'FI', 'FJ', 'FO', 'FR', 'FY',
	                'GA', 'GD', 'GL', 'GV', 'HE', 'HI', 'HR', 'HT', 'HU', 'HY', 'ID', 'IS', 'IT', 'JA', 'JV', 'KA',
	                'KG', 'KO', 'KU', 'KW', 'KY', 'LA', 'LB', 'LI', 'LN', 'LT', 'LV', 'MG', 'MK', 'MN', 'MO', 'MS',
	                'MT', 'MY', 'NB', 'NE', 'NL', 'NN', 'NO', 'OC', 'PL', 'PT', 'RM', 'RO', 'RU', 'SC', 'SE', 'SK',
	                'SL', 'SO', 'SQ', 'SR', 'SV', 'SW', 'TK', 'TR', 'TY', 'UK', 'UR', 'UZ', 'VI', 'VO', 'YI', 'ZH']);
	}
	
	function randomBrowserAndOS() {
	    var browser = rnd({
	        chrome:    .45132810566,
	        iexplorer: .27477061836,
	        firefox:   .19384170608,
	        safari:    .06186781118,
	        opera:     .01574236955
	    }),
	    os = {
	        chrome:  {win: .89,  mac: .09 , lin: .02},
	        firefox: {win: .83,  mac: .16,  lin: .01},
	        opera:   {win: .91,  mac: .03 , lin: .06},
	        safari:  {win: .04 , mac: .96  },
	        iexplorer: ['win']
	    };
	
	    return [browser, rnd(os[browser])];
	}
	
	function randomProc(arch) {
	    var procs = {
	        lin:['i686', 'x86_64'],
	        mac: {'Intel' : .48, 'PPC': .01, 'U; Intel':.48, 'U; PPC' :.01},
	        win:['', 'WOW64', 'Win64; x64']
	    };
	    return rnd(procs[arch]);
	}
	
	function randomRevision(dots) {
	    var return_val = '';
	    //generate a random revision
	    //dots = 2 returns .x.y where x & y are between 0 and 9
	    for (var x = 0; x < dots; x++) {
	        return_val += '.' + rnd(0, 9);
	    }
	    return return_val;
	}
	
	var version_string = {
	    net: function () {
	        return [rnd(1, 4), rnd(0, 9), rnd(10000, 99999), rnd(0, 9)].join('.');
	    },
	    nt: function () {
	        return rnd(5, 6) + '.' + rnd(0, 3);
	    },
	    ie: function () {
	        return rnd(7, 11);
	    },
	    trident: function () {
	        return rnd(3, 7) + '.' + rnd(0, 1);
	    },
	    osx: function (delim) {
	        return [10, rnd(5, 10), rnd(0, 9)].join(delim || '.');
	    },
	    chrome: function () {
	        return [rnd(13, 39), 0, rnd(800, 899), 0].join('.');
	    },
	    presto: function () {
	        return '2.9.' + rnd(160, 190);
	    },
	    presto2: function () {
	        return rnd(10, 12) + '.00';
	    },
	    safari: function () {
	        return rnd(531, 538) + '.' + rnd(0, 2) + '.' + rnd(0,2);
	    }
	};
	
	var browser = {
	    firefox: function firefox(arch) {
	        //https://developer.mozilla.org/en-US/docs/Gecko_user_agent_string_reference
	        var firefox_ver = rnd(5, 15) + randomRevision(2),
	            gecko_ver = 'Gecko/20100101 Firefox/' + firefox_ver,
	            proc = randomProc(arch),
	            os_ver = (arch === 'win') ? '(Windows NT ' + version_string.nt() + ((proc) ? '; ' + proc : '')
	            : (arch === 'mac') ? '(Macintosh; ' + proc + ' Mac OS X ' + version_string.osx()
	            : '(X11; Linux ' + proc;
	
	        return 'Mozilla/5.0 ' + os_ver + '; rv:' + firefox_ver.slice(0, -2) + ') ' + gecko_ver;
	    },
	
	    iexplorer: function iexplorer() {
	        var ver = version_string.ie();
	
	        if (ver >= 11) {
	            //http://msdn.microsoft.com/en-us/library/ie/hh869301(v=vs.85).aspx
	            return 'Mozilla/5.0 (Windows NT 6.' + rnd(1,3) + '; Trident/7.0; ' + rnd(['Touch; ', '']) + 'rv:11.0) like Gecko';
	        }
	
	        //http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx
	        return 'Mozilla/5.0 (compatible; MSIE ' + ver + '.0; Windows NT ' + version_string.nt() + '; Trident/' +
	            version_string.trident() + ((rnd(0, 1) === 1) ? '; .NET CLR ' + version_string.net() : '') + ')';
	    },
	
	    opera: function opera(arch) {
	        //http://www.opera.com/docs/history/
	        var presto_ver = ' Presto/' + version_string.presto() + ' Version/' + version_string.presto2() + ')',
	            os_ver = (arch === 'win') ? '(Windows NT ' + version_string.nt() + '; U; ' + randomLang() + presto_ver
	            : (arch === 'lin') ? '(X11; Linux ' + randomProc(arch) + '; U; ' + randomLang() + presto_ver
	            : '(Macintosh; Intel Mac OS X ' + version_string.osx() + ' U; ' + randomLang() + ' Presto/' +
	            version_string.presto() + ' Version/' + version_string.presto2() + ')';
	
	        return 'Opera/' + rnd(9, 14) + '.' + rnd(0, 99) + ' ' + os_ver;
	    },
	
	    safari: function safari(arch) {
	        var safari = version_string.safari(),
	            ver = rnd(4, 7) + '.' + rnd(0,1) + '.' + rnd(0,10),
	            os_ver = (arch === 'mac') ? '(Macintosh; ' + randomProc('mac') + ' Mac OS X '+ version_string.osx('_') + ' rv:' + rnd(2, 6) + '.0; '+ randomLang() + ') '
	            : '(Windows; U; Windows NT ' + version_string.nt() + ')';
	
	        return 'Mozilla/5.0 ' + os_ver + 'AppleWebKit/' + safari + ' (KHTML, like Gecko) Version/' + ver + ' Safari/' + safari;
	    },
	
	    chrome: function chrome(arch) {
	        var safari = version_string.safari(),
	            os_ver = (arch === 'mac') ? '(Macintosh; ' + randomProc('mac') + ' Mac OS X ' + version_string.osx('_') + ') '
	            : (arch === 'win') ? '(Windows; U; Windows NT ' + version_string.nt() + ')'
	            : '(X11; Linux ' + randomProc(arch);
	
	        return 'Mozilla/5.0 ' + os_ver + ' AppleWebKit/' + safari + ' (KHTML, like Gecko) Chrome/' + version_string.chrome() + ' Safari/' + safari;
	    }
	};
	
	exports.generate = function generate() {
	    var random = randomBrowserAndOS();
	    return browser[random[0]](random[1]);
	};


/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(4030) !== null) && (__webpack_require__(4031) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ }),
/* 2890 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 2891 */
/***/ (function(module, exports) {

	/**
	 * jQuery-csv (jQuery Plugin)
	 *
	 * This document is licensed as free software under the terms of the
	 * MIT License: http://www.opensource.org/licenses/mit-license.php
	 *
	 * Acknowledgements:
	 * The original design and influence to implement this library as a jquery
	 * plugin is influenced by jquery-json (http://code.google.com/p/jquery-json/).
	 * If you're looking to use native JSON.Stringify but want additional backwards
	 * compatibility for browsers that don't support it, I highly recommend you
	 * check it out.
	 *
	 * A special thanks goes out to rwk@acm.org for providing a lot of valuable
	 * feedback to the project including the core for the new FSM
	 * (Finite State Machine) parsers. If you're looking for a stable TSV parser
	 * be sure to take a look at jquery-tsv (http://code.google.com/p/jquery-tsv/).
	
	 * For legal purposes I'll include the "NO WARRANTY EXPRESSED OR IMPLIED.
	 * USE AT YOUR OWN RISK.". Which, in 'layman's terms' means, by using this
	 * library you are accepting responsibility if it breaks your code.
	 *
	 * Legal jargon aside, I will do my best to provide a useful and stable core
	 * that can effectively be built on.
	 *
	 * Copyrighted 2012 by Evan Plaice.
	 */
	
	RegExp.escape = function (s) {
	  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	};
	
	(function () {
	  'use strict';
	
	  var $;
	
	  // to keep backwards compatibility
	  if (typeof jQuery !== 'undefined' && jQuery) {
	    $ = jQuery;
	  } else {
	    $ = {};
	  }
	
	  /**
	   * jQuery.csv.defaults
	   * Encapsulates the method paramater defaults for the CSV plugin module.
	   */
	
	  $.csv = {
	    defaults: {
	      separator: ',',
	      delimiter: '"',
	      headers: true
	    },
	
	    hooks: {
	      castToScalar: function (value, state) {
	        var hasDot = /\./;
	        if (isNaN(value)) {
	          return value;
	        } else {
	          if (hasDot.test(value)) {
	            return parseFloat(value);
	          } else {
	            var integer = parseInt(value);
	            if (isNaN(integer)) {
	              return null;
	            } else {
	              return integer;
	            }
	          }
	        }
	      }
	    },
	
	    parsers: {
	      parse: function (csv, options) {
	        // cache settings
	        var separator = options.separator;
	        var delimiter = options.delimiter;
	
	        // set initial state if it's missing
	        if (!options.state.rowNum) {
	          options.state.rowNum = 1;
	        }
	        if (!options.state.colNum) {
	          options.state.colNum = 1;
	        }
	
	        // clear initial state
	        var data = [];
	        var entry = [];
	        var state = 0;
	        var value = '';
	        var exit = false;
	
	        function endOfEntry () {
	          // reset the state
	          state = 0;
	          value = '';
	
	          // if 'start' hasn't been met, don't output
	          if (options.start && options.state.rowNum < options.start) {
	            // update global state
	            entry = [];
	            options.state.rowNum++;
	            options.state.colNum = 1;
	            return;
	          }
	
	          if (options.onParseEntry === undefined) {
	            // onParseEntry hook not set
	            data.push(entry);
	          } else {
	            var hookVal = options.onParseEntry(entry, options.state); // onParseEntry Hook
	            // false skips the row, configurable through a hook
	            if (hookVal !== false) {
	              data.push(hookVal);
	            }
	          }
	          // console.log('entry:' + entry);
	
	          // cleanup
	          entry = [];
	
	          // if 'end' is met, stop parsing
	          if (options.end && options.state.rowNum >= options.end) {
	            exit = true;
	          }
	
	          // update global state
	          options.state.rowNum++;
	          options.state.colNum = 1;
	        }
	
	        function endOfValue () {
	          if (options.onParseValue === undefined) {
	            // onParseValue hook not set
	            entry.push(value);
	          } else {
	            var hook = options.onParseValue(value, options.state); // onParseValue Hook
	            // false skips the row, configurable through a hook
	            if (hook !== false) {
	              entry.push(hook);
	            }
	          }
	          // console.log('value:' + value);
	          // reset the state
	          value = '';
	          state = 0;
	          // update global state
	          options.state.colNum++;
	        }
	
	        // escape regex-specific control chars
	        var escSeparator = RegExp.escape(separator);
	        var escDelimiter = RegExp.escape(delimiter);
	
	        // compile the regEx str using the custom delimiter/separator
	        var match = /(D|S|\r\n|\n|\r|[^DS\r\n]+)/;
	        var matchSrc = match.source;
	        matchSrc = matchSrc.replace(/S/g, escSeparator);
	        matchSrc = matchSrc.replace(/D/g, escDelimiter);
	        match = new RegExp(matchSrc, 'gm');
	
	        // put on your fancy pants...
	        // process control chars individually, use look-ahead on non-control chars
	        csv.replace(match, function (m0) {
	          if (exit) {
	            return;
	          }
	          switch (state) {
	            // the start of a value
	            case 0:
	              // null last value
	              if (m0 === separator) {
	                value += '';
	                endOfValue();
	                break;
	              }
	              // opening delimiter
	              if (m0 === delimiter) {
	                state = 1;
	                break;
	              }
	              // null last value
	              if (/^(\r\n|\n|\r)$/.test(m0)) {
	                endOfValue();
	                endOfEntry();
	                break;
	              }
	              // un-delimited value
	              value += m0;
	              state = 3;
	              break;
	
	            // delimited input
	            case 1:
	              // second delimiter? check further
	              if (m0 === delimiter) {
	                state = 2;
	                break;
	              }
	              // delimited data
	              value += m0;
	              state = 1;
	              break;
	
	            // delimiter found in delimited input
	            case 2:
	              // escaped delimiter?
	              if (m0 === delimiter) {
	                value += m0;
	                state = 1;
	                break;
	              }
	              // null value
	              if (m0 === separator) {
	                endOfValue();
	                break;
	              }
	              // end of entry
	              if (/^(\r\n|\n|\r)$/.test(m0)) {
	                endOfValue();
	                endOfEntry();
	                break;
	              }
	              // broken paser?
	              throw new Error('CSVDataError: Illegal State [Row:' + options.state.rowNum + '][Col:' + options.state.colNum + ']');
	
	            // un-delimited input
	            case 3:
	              // null last value
	              if (m0 === separator) {
	                endOfValue();
	                break;
	              }
	              // end of entry
	              if (/^(\r\n|\n|\r)$/.test(m0)) {
	                endOfValue();
	                endOfEntry();
	                break;
	              }
	              if (m0 === delimiter) {
	              // non-compliant data
	                throw new Error('CSVDataError: Illegal Quote [Row:' + options.state.rowNum + '][Col:' + options.state.colNum + ']');
	              }
	              // broken parser?
	              throw new Error('CSVDataError: Illegal Data [Row:' + options.state.rowNum + '][Col:' + options.state.colNum + ']');
	            default:
	              // shenanigans
	              throw new Error('CSVDataError: Unknown State [Row:' + options.state.rowNum + '][Col:' + options.state.colNum + ']');
	          }
	          // console.log('val:' + m0 + ' state:' + state);
	        });
	
	        // submit the last entry
	        // ignore null last line
	        if (entry.length !== 0) {
	          endOfValue();
	          endOfEntry();
	        }
	
	        return data;
	      },
	
	      // a csv-specific line splitter
	      splitLines: function (csv, options) {
	        if (!csv) {
	          return undefined;
	        }
	
	        options = options || {};
	
	        // cache settings
	        var separator = options.separator || $.csv.defaults.separator;
	        var delimiter = options.delimiter || $.csv.defaults.delimiter;
	
	        // set initial state if it's missing
	        options.state = options.state || {};
	        if (!options.state.rowNum) {
	          options.state.rowNum = 1;
	        }
	
	        // clear initial state
	        var entries = [];
	        var state = 0;
	        var entry = '';
	        var exit = false;
	
	        function endOfLine () {
	          // reset the state
	          state = 0;
	
	          // if 'start' hasn't been met, don't output
	          if (options.start && options.state.rowNum < options.start) {
	            // update global state
	            entry = '';
	            options.state.rowNum++;
	            return;
	          }
	
	          if (options.onParseEntry === undefined) {
	            // onParseEntry hook not set
	            entries.push(entry);
	          } else {
	            var hookVal = options.onParseEntry(entry, options.state); // onParseEntry Hook
	            // false skips the row, configurable through a hook
	            if (hookVal !== false) {
	              entries.push(hookVal);
	            }
	          }
	
	          // cleanup
	          entry = '';
	
	          // if 'end' is met, stop parsing
	          if (options.end && options.state.rowNum >= options.end) {
	            exit = true;
	          }
	
	          // update global state
	          options.state.rowNum++;
	        }
	
	        // escape regex-specific control chars
	        var escSeparator = RegExp.escape(separator);
	        var escDelimiter = RegExp.escape(delimiter);
	
	        // compile the regEx str using the custom delimiter/separator
	        var match = /(D|S|\n|\r|[^DS\r\n]+)/;
	        var matchSrc = match.source;
	        matchSrc = matchSrc.replace(/S/g, escSeparator);
	        matchSrc = matchSrc.replace(/D/g, escDelimiter);
	        match = new RegExp(matchSrc, 'gm');
	
	        // put on your fancy pants...
	        // process control chars individually, use look-ahead on non-control chars
	        csv.replace(match, function (m0) {
	          if (exit) {
	            return;
	          }
	          switch (state) {
	            // the start of a value/entry
	            case 0:
	              // null value
	              if (m0 === separator) {
	                entry += m0;
	                state = 0;
	                break;
	              }
	              // opening delimiter
	              if (m0 === delimiter) {
	                entry += m0;
	                state = 1;
	                break;
	              }
	              // end of line
	              if (m0 === '\n') {
	                endOfLine();
	                break;
	              }
	              // phantom carriage return
	              if (/^\r$/.test(m0)) {
	                break;
	              }
	              // un-delimit value
	              entry += m0;
	              state = 3;
	              break;
	
	            // delimited input
	            case 1:
	              // second delimiter? check further
	              if (m0 === delimiter) {
	                entry += m0;
	                state = 2;
	                break;
	              }
	              // delimited data
	              entry += m0;
	              state = 1;
	              break;
	
	            // delimiter found in delimited input
	            case 2:
	              // escaped delimiter?
	              var prevChar = entry.substr(entry.length - 1);
	              if (m0 === delimiter && prevChar === delimiter) {
	                entry += m0;
	                state = 1;
	                break;
	              }
	              // end of value
	              if (m0 === separator) {
	                entry += m0;
	                state = 0;
	                break;
	              }
	              // end of line
	              if (m0 === '\n') {
	                endOfLine();
	                break;
	              }
	              // phantom carriage return
	              if (m0 === '\r') {
	                break;
	              }
	              // broken paser?
	              throw new Error('CSVDataError: Illegal state [Row:' + options.state.rowNum + ']');
	
	            // un-delimited input
	            case 3:
	              // null value
	              if (m0 === separator) {
	                entry += m0;
	                state = 0;
	                break;
	              }
	              // end of line
	              if (m0 === '\n') {
	                endOfLine();
	                break;
	              }
	              // phantom carriage return
	              if (m0 === '\r') {
	                break;
	              }
	              // non-compliant data
	              if (m0 === delimiter) {
	                throw new Error('CSVDataError: Illegal quote [Row:' + options.state.rowNum + ']');
	              }
	              // broken parser?
	              throw new Error('CSVDataError: Illegal state [Row:' + options.state.rowNum + ']');
	            default:
	              // shenanigans
	              throw new Error('CSVDataError: Unknown state [Row:' + options.state.rowNum + ']');
	          }
	          // console.log('val:' + m0 + ' state:' + state);
	        });
	
	        // submit the last entry
	        // ignore null last line
	        if (entry !== '') {
	          endOfLine();
	        }
	
	        return entries;
	      },
	
	      // a csv entry parser
	      parseEntry: function (csv, options) {
	        // cache settings
	        var separator = options.separator;
	        var delimiter = options.delimiter;
	
	        // set initial state if it's missing
	        if (!options.state.rowNum) {
	          options.state.rowNum = 1;
	        }
	        if (!options.state.colNum) {
	          options.state.colNum = 1;
	        }
	
	        // clear initial state
	        var entry = [];
	        var state = 0;
	        var value = '';
	
	        function endOfValue () {
	          if (options.onParseValue === undefined) {
	            // onParseValue hook not set
	            entry.push(value);
	          } else {
	            var hook = options.onParseValue(value, options.state); // onParseValue Hook
	            // false skips the value, configurable through a hook
	            if (hook !== false) {
	              entry.push(hook);
	            }
	          }
	          // reset the state
	          value = '';
	          state = 0;
	          // update global state
	          options.state.colNum++;
	        }
	
	        // checked for a cached regEx first
	        if (!options.match) {
	          // escape regex-specific control chars
	          var escSeparator = RegExp.escape(separator);
	          var escDelimiter = RegExp.escape(delimiter);
	
	          // compile the regEx str using the custom delimiter/separator
	          var match = /(D|S|\n|\r|[^DS\r\n]+)/;
	          var matchSrc = match.source;
	          matchSrc = matchSrc.replace(/S/g, escSeparator);
	          matchSrc = matchSrc.replace(/D/g, escDelimiter);
	          options.match = new RegExp(matchSrc, 'gm');
	        }
	
	        // put on your fancy pants...
	        // process control chars individually, use look-ahead on non-control chars
	        csv.replace(options.match, function (m0) {
	          switch (state) {
	            // the start of a value
	            case 0:
	              // null last value
	              if (m0 === separator) {
	                value += '';
	                endOfValue();
	                break;
	              }
	              // opening delimiter
	              if (m0 === delimiter) {
	                state = 1;
	                break;
	              }
	              // skip un-delimited new-lines
	              if (m0 === '\n' || m0 === '\r') {
	                break;
	              }
	              // un-delimited value
	              value += m0;
	              state = 3;
	              break;
	
	            // delimited input
	            case 1:
	              // second delimiter? check further
	              if (m0 === delimiter) {
	                state = 2;
	                break;
	              }
	              // delimited data
	              value += m0;
	              state = 1;
	              break;
	
	            // delimiter found in delimited input
	            case 2:
	              // escaped delimiter?
	              if (m0 === delimiter) {
	                value += m0;
	                state = 1;
	                break;
	              }
	              // null value
	              if (m0 === separator) {
	                endOfValue();
	                break;
	              }
	              // skip un-delimited new-lines
	              if (m0 === '\n' || m0 === '\r') {
	                break;
	              }
	              // broken paser?
	              throw new Error('CSVDataError: Illegal State [Row:' + options.state.rowNum + '][Col:' + options.state.colNum + ']');
	
	            // un-delimited input
	            case 3:
	              // null last value
	              if (m0 === separator) {
	                endOfValue();
	                break;
	              }
	              // skip un-delimited new-lines
	              if (m0 === '\n' || m0 === '\r') {
	                break;
	              }
	              // non-compliant data
	              if (m0 === delimiter) {
	                throw new Error('CSVDataError: Illegal Quote [Row:' + options.state.rowNum + '][Col:' + options.state.colNum + ']');
	              }
	              // broken parser?
	              throw new Error('CSVDataError: Illegal Data [Row:' + options.state.rowNum + '][Col:' + options.state.colNum + ']');
	            default:
	              // shenanigans
	              throw new Error('CSVDataError: Unknown State [Row:' + options.state.rowNum + '][Col:' + options.state.colNum + ']');
	          }
	          // console.log('val:' + m0 + ' state:' + state);
	        });
	
	        // submit the last value
	        endOfValue();
	
	        return entry;
	      }
	    },
	
	    helpers: {
	
	      /**
	       * $.csv.helpers.collectPropertyNames(objectsArray)
	       * Collects all unique property names from all passed objects.
	       *
	       * @param {Array} objects Objects to collect properties from.
	       *
	       * Returns an array of property names (array will be empty,
	       * if objects have no own properties).
	       */
	      collectPropertyNames: function (objects) {
	        var o = [];
	        var propName = [];
	        var props = [];
	        for (o in objects) {
	          for (propName in objects[o]) {
	            if ((objects[o].hasOwnProperty(propName)) &&
	                (props.indexOf(propName) < 0) &&
	                (typeof objects[o][propName] !== 'function')) {
	              props.push(propName);
	            }
	          }
	        }
	        return props;
	      }
	    },
	
	    /**
	     * $.csv.toArray(csv)
	     * Converts a CSV entry string to a javascript array.
	     *
	     * @param {Array} csv The string containing the CSV data.
	     * @param {Object} [options] An object containing user-defined options.
	     * @param {Character} [separator] An override for the separator character. Defaults to a comma(,).
	     * @param {Character} [delimiter] An override for the delimiter character. Defaults to a double-quote(").
	     *
	     * This method deals with simple CSV strings only. It's useful if you only
	     * need to parse a single entry. If you need to parse more than one line,
	     * use $.csv2Array instead.
	     */
	    toArray: function (csv, options, callback) {
	      options = (options !== undefined ? options : {});
	      var config = {};
	      config.callback = ((callback !== undefined && typeof (callback) === 'function') ? callback : false);
	      config.separator = 'separator' in options ? options.separator : $.csv.defaults.separator;
	      config.delimiter = 'delimiter' in options ? options.delimiter : $.csv.defaults.delimiter;
	      var state = (options.state !== undefined ? options.state : {});
	
	      // setup
	      options = {
	        delimiter: config.delimiter,
	        separator: config.separator,
	        onParseEntry: options.onParseEntry,
	        onParseValue: options.onParseValue,
	        state: state
	      };
	
	      var entry = $.csv.parsers.parseEntry(csv, options);
	
	      // push the value to a callback if one is defined
	      if (!config.callback) {
	        return entry;
	      } else {
	        config.callback('', entry);
	      }
	    },
	
	    /**
	     * $.csv.toArrays(csv)
	     * Converts a CSV string to a javascript array.
	     *
	     * @param {String} csv The string containing the raw CSV data.
	     * @param {Object} [options] An object containing user-defined options.
	     * @param {Character} [separator] An override for the separator character. Defaults to a comma(,).
	     * @param {Character} [delimiter] An override for the delimiter character. Defaults to a double-quote(").
	     *
	     * This method deals with multi-line CSV. The breakdown is simple. The first
	     * dimension of the array represents the line (or entry/row) while the second
	     * dimension contains the values (or values/columns).
	     */
	    toArrays: function (csv, options, callback) {
	      options = (options !== undefined ? options : {});
	      var config = {};
	      config.callback = ((callback !== undefined && typeof (callback) === 'function') ? callback : false);
	      config.separator = 'separator' in options ? options.separator : $.csv.defaults.separator;
	      config.delimiter = 'delimiter' in options ? options.delimiter : $.csv.defaults.delimiter;
	
	      // setup
	      var data = [];
	      options = {
	        delimiter: config.delimiter,
	        separator: config.separator,
	        onPreParse: options.onPreParse,
	        onParseEntry: options.onParseEntry,
	        onParseValue: options.onParseValue,
	        onPostParse: options.onPostParse,
	        start: options.start,
	        end: options.end,
	        state: {
	          rowNum: 1,
	          colNum: 1
	        }
	      };
	
	      // onPreParse hook
	      if (options.onPreParse !== undefined) {
	        options.onPreParse(csv, options.state);
	      }
	
	      // parse the data
	      data = $.csv.parsers.parse(csv, options);
	
	      // onPostParse hook
	      if (options.onPostParse !== undefined) {
	        options.onPostParse(data, options.state);
	      }
	
	      // push the value to a callback if one is defined
	      if (!config.callback) {
	        return data;
	      } else {
	        config.callback('', data);
	      }
	    },
	
	    /**
	     * $.csv.toObjects(csv)
	     * Converts a CSV string to a javascript object.
	     * @param {String} csv The string containing the raw CSV data.
	     * @param {Object} [options] An object containing user-defined options.
	     * @param {Character} [separator] An override for the separator character. Defaults to a comma(,).
	     * @param {Character} [delimiter] An override for the delimiter character. Defaults to a double-quote(").
	     * @param {Boolean} [headers] Indicates whether the data contains a header line. Defaults to true.
	     *
	     * This method deals with multi-line CSV strings. Where the headers line is
	     * used as the key for each value per entry.
	     */
	    toObjects: function (csv, options, callback) {
	      options = (options !== undefined ? options : {});
	      var config = {};
	      config.callback = ((callback !== undefined && typeof (callback) === 'function') ? callback : false);
	      config.separator = 'separator' in options ? options.separator : $.csv.defaults.separator;
	      config.delimiter = 'delimiter' in options ? options.delimiter : $.csv.defaults.delimiter;
	      config.headers = 'headers' in options ? options.headers : $.csv.defaults.headers;
	      options.start = 'start' in options ? options.start : 1;
	
	      // account for headers
	      if (config.headers) {
	        options.start++;
	      }
	      if (options.end && config.headers) {
	        options.end++;
	      }
	
	      // setup
	      var lines = [];
	      var data = [];
	
	      options = {
	        delimiter: config.delimiter,
	        separator: config.separator,
	        onPreParse: options.onPreParse,
	        onParseEntry: options.onParseEntry,
	        onParseValue: options.onParseValue,
	        onPostParse: options.onPostParse,
	        start: options.start,
	        end: options.end,
	        state: {
	          rowNum: 1,
	          colNum: 1
	        },
	        match: false,
	        transform: options.transform
	      };
	
	      // fetch the headers
	      var headerOptions = {
	        delimiter: config.delimiter,
	        separator: config.separator,
	        start: 1,
	        end: 1,
	        state: {
	          rowNum: 1,
	          colNum: 1
	        }
	      };
	
	      // onPreParse hook
	      if (options.onPreParse !== undefined) {
	        options.onPreParse(csv, options.state);
	      }
	
	      // parse the csv
	      var headerLine = $.csv.parsers.splitLines(csv, headerOptions);
	      var headers = $.csv.toArray(headerLine[0], options);
	
	      // fetch the data
	      lines = $.csv.parsers.splitLines(csv, options);
	
	      // reset the state for re-use
	      options.state.colNum = 1;
	      if (headers) {
	        options.state.rowNum = 2;
	      } else {
	        options.state.rowNum = 1;
	      }
	
	      // convert data to objects
	      for (var i = 0, len = lines.length; i < len; i++) {
	        var entry = $.csv.toArray(lines[i], options);
	        var object = {};
	        for (var j = 0; j < headers.length; j++) {
	          object[headers[j]] = entry[j];
	        }
	        if (options.transform !== undefined) {
	          data.push(options.transform.call(undefined, object));
	        } else {
	          data.push(object);
	        }
	
	        // update row state
	        options.state.rowNum++;
	      }
	
	      // onPostParse hook
	      if (options.onPostParse !== undefined) {
	        options.onPostParse(data, options.state);
	      }
	
	      // push the value to a callback if one is defined
	      if (!config.callback) {
	        return data;
	      } else {
	        config.callback('', data);
	      }
	    },
	
	    /**
	    * $.csv.fromArrays(arrays)
	    * Converts a javascript array to a CSV String.
	    *
	    * @param {Array} arrays An array containing an array of CSV entries.
	    * @param {Object} [options] An object containing user-defined options.
	    * @param {Character} [separator] An override for the separator character. Defaults to a comma(,).
	    * @param {Character} [delimiter] An override for the delimiter character. Defaults to a double-quote(").
	    *
	    * This method generates a CSV file from an array of arrays (representing entries).
	    */
	    fromArrays: function (arrays, options, callback) {
	      options = (options !== undefined ? options : {});
	      var config = {};
	      config.callback = ((callback !== undefined && typeof (callback) === 'function') ? callback : false);
	      config.separator = 'separator' in options ? options.separator : $.csv.defaults.separator;
	      config.delimiter = 'delimiter' in options ? options.delimiter : $.csv.defaults.delimiter;
	
	      var output = '';
	      var line;
	      var lineValues;
	      var i;
	      var j;
	
	      for (i = 0; i < arrays.length; i++) {
	        line = arrays[i];
	        lineValues = [];
	        for (j = 0; j < line.length; j++) {
	          var strValue = (line[j] === undefined || line[j] === null) ? '' : line[j].toString();
	          if (strValue.indexOf(config.delimiter) > -1) {
	            strValue = strValue.replace(new RegExp(config.delimiter, 'g'), config.delimiter + config.delimiter);
	          }
	
	          var escMatcher = '\n|\r|S|D';
	          escMatcher = escMatcher.replace('S', config.separator);
	          escMatcher = escMatcher.replace('D', config.delimiter);
	
	          if (strValue.search(escMatcher) > -1) {
	            strValue = config.delimiter + strValue + config.delimiter;
	          }
	          lineValues.push(strValue);
	        }
	        output += lineValues.join(config.separator) + '\r\n';
	      }
	
	      // push the value to a callback if one is defined
	      if (!config.callback) {
	        return output;
	      } else {
	        config.callback('', output);
	      }
	    },
	
	    /**
	     * $.csv.fromObjects(objects)
	     * Converts a javascript dictionary to a CSV string.
	     *
	     * @param {Object} objects An array of objects containing the data.
	     * @param {Object} [options] An object containing user-defined options.
	     * @param {Character} [separator] An override for the separator character. Defaults to a comma(,).
	     * @param {Character} [delimiter] An override for the delimiter character. Defaults to a double-quote(").
	     * @param {Character} [sortOrder] Sort order of columns (named after
	     *   object properties). Use 'alpha' for alphabetic. Default is 'declare',
	     *   which means, that properties will _probably_ appear in order they were
	     *   declared for the object. But without any guarantee.
	     * @param {Character or Array} [manualOrder] Manually order columns. May be
	     * a strin in a same csv format as an output or an array of header names
	     * (array items won't be parsed). All the properties, not present in
	     * `manualOrder` will be appended to the end in accordance with `sortOrder`
	     * option. So the `manualOrder` always takes preference, if present.
	     *
	     * This method generates a CSV file from an array of objects (name:value pairs).
	     * It starts by detecting the headers and adding them as the first line of
	     * the CSV file, followed by a structured dump of the data.
	     */
	    fromObjects: function (objects, options, callback) {
	      options = (options !== undefined ? options : {});
	      var config = {};
	      config.callback = ((callback !== undefined && typeof (callback) === 'function') ? callback : false);
	      config.separator = 'separator' in options ? options.separator : $.csv.defaults.separator;
	      config.delimiter = 'delimiter' in options ? options.delimiter : $.csv.defaults.delimiter;
	      config.headers = 'headers' in options ? options.headers : $.csv.defaults.headers;
	      config.sortOrder = 'sortOrder' in options ? options.sortOrder : 'declare';
	      config.manualOrder = 'manualOrder' in options ? options.manualOrder : [];
	      config.transform = options.transform;
	
	      if (typeof config.manualOrder === 'string') {
	        config.manualOrder = $.csv.toArray(config.manualOrder, config);
	      }
	
	      if (config.transform !== undefined) {
	        var origObjects = objects;
	        objects = [];
	
	        var i;
	        for (i = 0; i < origObjects.length; i++) {
	          objects.push(config.transform.call(undefined, origObjects[i]));
	        }
	      }
	
	      var props = $.csv.helpers.collectPropertyNames(objects);
	
	      if (config.sortOrder === 'alpha') {
	        props.sort();
	      } // else {} - nothing to do for 'declare' order
	
	      if (config.manualOrder.length > 0) {
	        var propsManual = [].concat(config.manualOrder);
	        var p;
	        for (p = 0; p < props.length; p++) {
	          if (propsManual.indexOf(props[p]) < 0) {
	            propsManual.push(props[p]);
	          }
	        }
	        props = propsManual;
	      }
	
	      var o, p, line, output = [], propName;
	      if (config.headers) {
	        output.push(props);
	      }
	
	      for (o = 0; o < objects.length; o++) {
	        line = [];
	        for (p = 0; p < props.length; p++) {
	          propName = props[p];
	          if (propName in objects[o] && typeof objects[o][propName] !== 'function') {
	            line.push(objects[o][propName]);
	          } else {
	            line.push('');
	          }
	        }
	        output.push(line);
	      }
	
	      // push the value to a callback if one is defined
	      return $.csv.fromArrays(output, options, config.callback);
	    }
	  };
	
	  // Maintenance code to maintain backward-compatibility
	  // Will be removed in release 1.0
	  $.csvEntry2Array = $.csv.toArray;
	  $.csv2Array = $.csv.toArrays;
	  $.csv2Dictionary = $.csv.toObjects;
	
	  // CommonJS module is defined
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = $.csv;
	  }
	}).call(this);


/***/ }),
/* 2892 */,
/* 2893 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ }),
/* 2894 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands or `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.3.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseIsEqual = __webpack_require__(2901),
	    bindCallback = __webpack_require__(438),
	    isArray = __webpack_require__(100),
	    pairs = __webpack_require__(2908);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = baseCallback;


/***/ }),
/* 2896 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var keys = __webpack_require__(151);
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = baseEach;


/***/ }),
/* 2898 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ }),
/* 2899 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.6.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 2900 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.7 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArray = __webpack_require__(100),
	    isTypedArray = __webpack_require__(440),
	    keys = __webpack_require__(151);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} value The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var bindCallback = __webpack_require__(438),
	    isIterateeCall = __webpack_require__(2904),
	    restParam = __webpack_require__(2909);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 2903 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ }),
/* 2904 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCallback = __webpack_require__(2895),
	    baseEach = __webpack_require__(2897),
	    baseFind = __webpack_require__(2898),
	    baseFindIndex = __webpack_require__(2899),
	    isArray = __webpack_require__(100);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.exports = find;


/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(1)(module)))

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.3.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var arrayCopy = __webpack_require__(2893),
	    arrayEach = __webpack_require__(2894),
	    createAssigner = __webpack_require__(2902),
	    isArguments = __webpack_require__(150),
	    isArray = __webpack_require__(100),
	    isPlainObject = __webpack_require__(439),
	    isTypedArray = __webpack_require__(440),
	    keys = __webpack_require__(151),
	    toPlainObject = __webpack_require__(2910);
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.merge` without support for argument juggling,
	 * multiple sources, and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {Object} Returns `object`.
	 */
	function baseMerge(object, source, customizer, stackA, stackB) {
	  if (!isObject(object)) {
	    return object;
	  }
	  var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	      props = isSrcArr ? undefined : keys(source);
	
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObjectLike(srcValue)) {
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	      baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	    }
	    else {
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	      }
	      if ((result !== undefined || (isSrcArr && !(key in object))) &&
	          (isCommon || (result === result ? (result !== value) : (value === value)))) {
	        object[key] = result;
	      }
	    }
	  });
	  return object;
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	  var length = stackA.length,
	      srcValue = source[key];
	
	  while (length--) {
	    if (stackA[length] == srcValue) {
	      object[key] = stackB[length];
	      return;
	    }
	  }
	  var value = object[key],
	      result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	      isCommon = result === undefined;
	
	  if (isCommon) {
	    result = srcValue;
	    if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	      result = isArray(value)
	        ? value
	        : (isArrayLike(value) ? arrayCopy(value) : []);
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      result = isArguments(value)
	        ? toPlainObject(value)
	        : (isPlainObject(value) ? value : {});
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate
	  // it with its merged value.
	  stackA.push(srcValue);
	  stackB.push(result);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	  } else if (result === result ? (result !== value) : (value === value)) {
	    object[key] = result;
	  }
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Recursively merges own enumerable properties of the source object(s), that
	 * don't resolve to `undefined` into the destination object. Subsequent sources
	 * overwrite property assignments of previous sources. If `customizer` is
	 * provided it is invoked to produce the merged values of the destination and
	 * source properties. If `customizer` returns `undefined` merging is handled
	 * by the method instead. The `customizer` is bound to `thisArg` and invoked
	 * with five arguments: (objectValue, sourceValue, key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 *
	 * // using a customizer callback
	 * var object = {
	 *   'fruits': ['apple'],
	 *   'vegetables': ['beet']
	 * };
	 *
	 * var other = {
	 *   'fruits': ['banana'],
	 *   'vegetables': ['carrot']
	 * };
	 *
	 * _.merge(object, other, function(a, b) {
	 *   if (_.isArray(a)) {
	 *     return a.concat(b);
	 *   }
	 * });
	 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	 */
	var merge = createAssigner(baseMerge);
	
	module.exports = merge;


/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var keys = __webpack_require__(151);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ }),
/* 2909 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCopy = __webpack_require__(2896),
	    keysIn = __webpack_require__(441);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable
	 * properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return baseCopy(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 2911 */,
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(90);


/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(566);
	
	/*<replacement>*/
	var util = __webpack_require__(121);
	util.inherits = __webpack_require__(64);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(153).Buffer;
	var util = __webpack_require__(4038);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 2917 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(220).PassThrough


/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(220).Transform


/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(219);


/***/ }),
/* 2921 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(76)))

/***/ }),
/* 2924 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(25).Buffer
	var Hash   = __webpack_require__(2924)(Buffer)
	
	exports.sha1 = __webpack_require__(2926)(Buffer, Hash)
	exports.sha256 = __webpack_require__(2927)(Buffer, Hash)
	exports.sha512 = __webpack_require__(2928)(Buffer, Hash)


/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(223).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(223).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(223).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
	 * Sortable
	 * @author	RubaXa   <trash@rubaxa.org>
	 * @license MIT
	 */
	
	(function sortableModule(factory) {
		"use strict";
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if (typeof module != "undefined" && typeof module.exports != "undefined") {
			module.exports = factory();
		}
		else {
			/* jshint sub:true */
			window["Sortable"] = factory();
		}
	})(function sortableFactory() {
		"use strict";
	
		if (typeof window === "undefined" || !window.document) {
			return function sortableError() {
				throw new Error("Sortable.js requires a window with a document");
			};
		}
	
		var dragEl,
			parentEl,
			ghostEl,
			cloneEl,
			rootEl,
			nextEl,
			lastDownEl,
	
			scrollEl,
			scrollParentEl,
			scrollCustomFn,
	
			lastEl,
			lastCSS,
			lastParentCSS,
	
			oldIndex,
			newIndex,
	
			activeGroup,
			putSortable,
	
			autoScroll = {},
	
			tapEvt,
			touchEvt,
	
			moved,
	
			/** @const */
			R_SPACE = /\s+/g,
			R_FLOAT = /left|right|inline/,
	
			expando = 'Sortable' + (new Date).getTime(),
	
			win = window,
			document = win.document,
			parseInt = win.parseInt,
			setTimeout = win.setTimeout,
	
			$ = win.jQuery || win.Zepto,
			Polymer = win.Polymer,
	
			captureMode = false,
			passiveMode = false,
	
			supportDraggable = ('draggable' in document.createElement('div')),
			supportCssPointerEvents = (function (el) {
				// false when IE11
				if (!!navigator.userAgent.match(/(?:Trident.*rv[ :]?11\.|msie)/i)) {
					return false;
				}
				el = document.createElement('x');
				el.style.cssText = 'pointer-events:auto';
				return el.style.pointerEvents === 'auto';
			})(),
	
			_silent = false,
	
			abs = Math.abs,
			min = Math.min,
	
			savedInputChecked = [],
			touchDragOverListeners = [],
	
			_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
				// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
				if (rootEl && options.scroll) {
					var _this = rootEl[expando],
						el,
						rect,
						sens = options.scrollSensitivity,
						speed = options.scrollSpeed,
	
						x = evt.clientX,
						y = evt.clientY,
	
						winWidth = window.innerWidth,
						winHeight = window.innerHeight,
	
						vx,
						vy,
	
						scrollOffsetX,
						scrollOffsetY
					;
	
					// Delect scrollEl
					if (scrollParentEl !== rootEl) {
						scrollEl = options.scroll;
						scrollParentEl = rootEl;
						scrollCustomFn = options.scrollFn;
	
						if (scrollEl === true) {
							scrollEl = rootEl;
	
							do {
								if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
									(scrollEl.offsetHeight < scrollEl.scrollHeight)
								) {
									break;
								}
								/* jshint boss:true */
							} while (scrollEl = scrollEl.parentNode);
						}
					}
	
					if (scrollEl) {
						el = scrollEl;
						rect = scrollEl.getBoundingClientRect();
						vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
						vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
					}
	
	
					if (!(vx || vy)) {
						vx = (winWidth - x <= sens) - (x <= sens);
						vy = (winHeight - y <= sens) - (y <= sens);
	
						/* jshint expr:true */
						(vx || vy) && (el = win);
					}
	
	
					if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
						autoScroll.el = el;
						autoScroll.vx = vx;
						autoScroll.vy = vy;
	
						clearInterval(autoScroll.pid);
	
						if (el) {
							autoScroll.pid = setInterval(function () {
								scrollOffsetY = vy ? vy * speed : 0;
								scrollOffsetX = vx ? vx * speed : 0;
	
								if ('function' === typeof(scrollCustomFn)) {
									return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
								}
	
								if (el === win) {
									win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
								} else {
									el.scrollTop += scrollOffsetY;
									el.scrollLeft += scrollOffsetX;
								}
							}, 24);
						}
					}
				}
			}, 30),
	
			_prepareGroup = function (options) {
				function toFn(value, pull) {
					if (value === void 0 || value === true) {
						value = group.name;
					}
	
					if (typeof value === 'function') {
						return value;
					} else {
						return function (to, from) {
							var fromGroup = from.options.group.name;
	
							return pull
								? value
								: value && (value.join
									? value.indexOf(fromGroup) > -1
									: (fromGroup == value)
								);
						};
					}
				}
	
				var group = {};
				var originalGroup = options.group;
	
				if (!originalGroup || typeof originalGroup != 'object') {
					originalGroup = {name: originalGroup};
				}
	
				group.name = originalGroup.name;
				group.checkPull = toFn(originalGroup.pull, true);
				group.checkPut = toFn(originalGroup.put);
				group.revertClone = originalGroup.revertClone;
	
				options.group = group;
			}
		;
	
		// Detect support a passive mode
		try {
			window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
				get: function () {
					// `false`, because everything starts to work incorrectly and instead of d'n'd,
					// begins the page has scrolled.
					passiveMode = false;
					captureMode = {
						capture: false,
						passive: passiveMode
					};
				}
			}));
		} catch (err) {}
	
		/**
		 * @class  Sortable
		 * @param  {HTMLElement}  el
		 * @param  {Object}       [options]
		 */
		function Sortable(el, options) {
			if (!(el && el.nodeType && el.nodeType === 1)) {
				throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
			}
	
			this.el = el; // root element
			this.options = options = _extend({}, options);
	
	
			// Export instance
			el[expando] = this;
	
			// Default options
			var defaults = {
				group: Math.random(),
				sort: true,
				disabled: false,
				store: null,
				handle: null,
				scroll: true,
				scrollSensitivity: 30,
				scrollSpeed: 10,
				draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
				ghostClass: 'sortable-ghost',
				chosenClass: 'sortable-chosen',
				dragClass: 'sortable-drag',
				ignore: 'a, img',
				filter: null,
				preventOnFilter: true,
				animation: 0,
				setData: function (dataTransfer, dragEl) {
					dataTransfer.setData('Text', dragEl.textContent);
				},
				dropBubble: false,
				dragoverBubble: false,
				dataIdAttr: 'data-id',
				delay: 0,
				forceFallback: false,
				fallbackClass: 'sortable-fallback',
				fallbackOnBody: false,
				fallbackTolerance: 0,
				fallbackOffset: {x: 0, y: 0},
				supportPointer: Sortable.supportPointer !== false
			};
	
	
			// Set default options
			for (var name in defaults) {
				!(name in options) && (options[name] = defaults[name]);
			}
	
			_prepareGroup(options);
	
			// Bind all private methods
			for (var fn in this) {
				if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
					this[fn] = this[fn].bind(this);
				}
			}
	
			// Setup drag mode
			this.nativeDraggable = options.forceFallback ? false : supportDraggable;
	
			// Bind events
			_on(el, 'mousedown', this._onTapStart);
			_on(el, 'touchstart', this._onTapStart);
			options.supportPointer && _on(el, 'pointerdown', this._onTapStart);
	
			if (this.nativeDraggable) {
				_on(el, 'dragover', this);
				_on(el, 'dragenter', this);
			}
	
			touchDragOverListeners.push(this._onDragOver);
	
			// Restore sorting
			options.store && this.sort(options.store.get(this));
		}
	
	
		Sortable.prototype = /** @lends Sortable.prototype */ {
			constructor: Sortable,
	
			_onTapStart: function (/** Event|TouchEvent */evt) {
				var _this = this,
					el = this.el,
					options = this.options,
					preventOnFilter = options.preventOnFilter,
					type = evt.type,
					touch = evt.touches && evt.touches[0],
					target = (touch || evt).target,
					originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0]) || target,
					filter = options.filter,
					startIndex;
	
				_saveInputCheckedState(el);
	
	
				// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
				if (dragEl) {
					return;
				}
	
				if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
					return; // only left button or enabled
				}
	
				// cancel dnd if original target is content editable
				if (originalTarget.isContentEditable) {
					return;
				}
	
				target = _closest(target, options.draggable, el);
	
				if (!target) {
					return;
				}
	
				if (lastDownEl === target) {
					// Ignoring duplicate `down`
					return;
				}
	
				// Get the index of the dragged element within its parent
				startIndex = _index(target, options.draggable);
	
				// Check filter
				if (typeof filter === 'function') {
					if (filter.call(this, evt, target, this)) {
						_dispatchEvent(_this, originalTarget, 'filter', target, el, el, startIndex);
						preventOnFilter && evt.preventDefault();
						return; // cancel dnd
					}
				}
				else if (filter) {
					filter = filter.split(',').some(function (criteria) {
						criteria = _closest(originalTarget, criteria.trim(), el);
	
						if (criteria) {
							_dispatchEvent(_this, criteria, 'filter', target, el, el, startIndex);
							return true;
						}
					});
	
					if (filter) {
						preventOnFilter && evt.preventDefault();
						return; // cancel dnd
					}
				}
	
				if (options.handle && !_closest(originalTarget, options.handle, el)) {
					return;
				}
	
				// Prepare `dragstart`
				this._prepareDragStart(evt, touch, target, startIndex);
			},
	
			_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
				var _this = this,
					el = _this.el,
					options = _this.options,
					ownerDocument = el.ownerDocument,
					dragStartFn;
	
				if (target && !dragEl && (target.parentNode === el)) {
					tapEvt = evt;
	
					rootEl = el;
					dragEl = target;
					parentEl = dragEl.parentNode;
					nextEl = dragEl.nextSibling;
					lastDownEl = target;
					activeGroup = options.group;
					oldIndex = startIndex;
	
					this._lastX = (touch || evt).clientX;
					this._lastY = (touch || evt).clientY;
	
					dragEl.style['will-change'] = 'all';
	
					dragStartFn = function () {
						// Delayed drag has been triggered
						// we can re-enable the events: touchmove/mousemove
						_this._disableDelayedDrag();
	
						// Make the element draggable
						dragEl.draggable = _this.nativeDraggable;
	
						// Chosen item
						_toggleClass(dragEl, options.chosenClass, true);
	
						// Bind the events: dragstart/dragend
						_this._triggerDragStart(evt, touch);
	
						// Drag start event
						_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, rootEl, oldIndex);
					};
	
					// Disable "draggable"
					options.ignore.split(',').forEach(function (criteria) {
						_find(dragEl, criteria.trim(), _disableDraggable);
					});
	
					_on(ownerDocument, 'mouseup', _this._onDrop);
					_on(ownerDocument, 'touchend', _this._onDrop);
					_on(ownerDocument, 'touchcancel', _this._onDrop);
					_on(ownerDocument, 'selectstart', _this);
					options.supportPointer && _on(ownerDocument, 'pointercancel', _this._onDrop);
	
					if (options.delay) {
						// If the user moves the pointer or let go the click or touch
						// before the delay has been reached:
						// disable the delayed drag
						_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
						_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
						_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
						_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
						_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);
						options.supportPointer && _on(ownerDocument, 'pointermove', _this._disableDelayedDrag);
	
						_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
					} else {
						dragStartFn();
					}
	
	
				}
			},
	
			_disableDelayedDrag: function () {
				var ownerDocument = this.el.ownerDocument;
	
				clearTimeout(this._dragStartTimer);
				_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
				_off(ownerDocument, 'touchend', this._disableDelayedDrag);
				_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
				_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
				_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
				_off(ownerDocument, 'pointermove', this._disableDelayedDrag);
			},
	
			_triggerDragStart: function (/** Event */evt, /** Touch */touch) {
				touch = touch || (evt.pointerType == 'touch' ? evt : null);
	
				if (touch) {
					// Touch device support
					tapEvt = {
						target: dragEl,
						clientX: touch.clientX,
						clientY: touch.clientY
					};
	
					this._onDragStart(tapEvt, 'touch');
				}
				else if (!this.nativeDraggable) {
					this._onDragStart(tapEvt, true);
				}
				else {
					_on(dragEl, 'dragend', this);
					_on(rootEl, 'dragstart', this._onDragStart);
				}
	
				try {
					if (document.selection) {
						// Timeout neccessary for IE9
						_nextTick(function () {
							document.selection.empty();
						});
					} else {
						window.getSelection().removeAllRanges();
					}
				} catch (err) {
				}
			},
	
			_dragStarted: function () {
				if (rootEl && dragEl) {
					var options = this.options;
	
					// Apply effect
					_toggleClass(dragEl, options.ghostClass, true);
					_toggleClass(dragEl, options.dragClass, false);
	
					Sortable.active = this;
	
					// Drag start event
					_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, rootEl, oldIndex);
				} else {
					this._nulling();
				}
			},
	
			_emulateDragOver: function () {
				if (touchEvt) {
					if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
						return;
					}
	
					this._lastX = touchEvt.clientX;
					this._lastY = touchEvt.clientY;
	
					if (!supportCssPointerEvents) {
						_css(ghostEl, 'display', 'none');
					}
	
					var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
					var parent = target;
					var i = touchDragOverListeners.length;
	
					if (target && target.shadowRoot) {
						target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
						parent = target;
					}
	
					if (parent) {
						do {
							if (parent[expando]) {
								while (i--) {
									touchDragOverListeners[i]({
										clientX: touchEvt.clientX,
										clientY: touchEvt.clientY,
										target: target,
										rootEl: parent
									});
								}
	
								break;
							}
	
							target = parent; // store last element
						}
						/* jshint boss:true */
						while (parent = parent.parentNode);
					}
	
					if (!supportCssPointerEvents) {
						_css(ghostEl, 'display', '');
					}
				}
			},
	
	
			_onTouchMove: function (/**TouchEvent*/evt) {
				if (tapEvt) {
					var	options = this.options,
						fallbackTolerance = options.fallbackTolerance,
						fallbackOffset = options.fallbackOffset,
						touch = evt.touches ? evt.touches[0] : evt,
						dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
						dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
						translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';
	
					// only set the status to dragging, when we are actually dragging
					if (!Sortable.active) {
						if (fallbackTolerance &&
							min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
						) {
							return;
						}
	
						this._dragStarted();
					}
	
					// as well as creating the ghost element on the document body
					this._appendGhost();
	
					moved = true;
					touchEvt = touch;
	
					_css(ghostEl, 'webkitTransform', translate3d);
					_css(ghostEl, 'mozTransform', translate3d);
					_css(ghostEl, 'msTransform', translate3d);
					_css(ghostEl, 'transform', translate3d);
	
					evt.preventDefault();
				}
			},
	
			_appendGhost: function () {
				if (!ghostEl) {
					var rect = dragEl.getBoundingClientRect(),
						css = _css(dragEl),
						options = this.options,
						ghostRect;
	
					ghostEl = dragEl.cloneNode(true);
	
					_toggleClass(ghostEl, options.ghostClass, false);
					_toggleClass(ghostEl, options.fallbackClass, true);
					_toggleClass(ghostEl, options.dragClass, true);
	
					_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
					_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
					_css(ghostEl, 'width', rect.width);
					_css(ghostEl, 'height', rect.height);
					_css(ghostEl, 'opacity', '0.8');
					_css(ghostEl, 'position', 'fixed');
					_css(ghostEl, 'zIndex', '100000');
					_css(ghostEl, 'pointerEvents', 'none');
	
					options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);
	
					// Fixing dimensions.
					ghostRect = ghostEl.getBoundingClientRect();
					_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
					_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
				}
			},
	
			_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
				var _this = this;
				var dataTransfer = evt.dataTransfer;
				var options = _this.options;
	
				_this._offUpEvents();
	
				if (activeGroup.checkPull(_this, _this, dragEl, evt)) {
					cloneEl = _clone(dragEl);
	
					cloneEl.draggable = false;
					cloneEl.style['will-change'] = '';
	
					_css(cloneEl, 'display', 'none');
					_toggleClass(cloneEl, _this.options.chosenClass, false);
	
					// #1143: IFrame support workaround
					_this._cloneId = _nextTick(function () {
						rootEl.insertBefore(cloneEl, dragEl);
						_dispatchEvent(_this, rootEl, 'clone', dragEl);
					});
				}
	
				_toggleClass(dragEl, options.dragClass, true);
	
				if (useFallback) {
					if (useFallback === 'touch') {
						// Bind touch events
						_on(document, 'touchmove', _this._onTouchMove);
						_on(document, 'touchend', _this._onDrop);
						_on(document, 'touchcancel', _this._onDrop);
	
						if (options.supportPointer) {
							_on(document, 'pointermove', _this._onTouchMove);
							_on(document, 'pointerup', _this._onDrop);
						}
					} else {
						// Old brwoser
						_on(document, 'mousemove', _this._onTouchMove);
						_on(document, 'mouseup', _this._onDrop);
					}
	
					_this._loopId = setInterval(_this._emulateDragOver, 50);
				}
				else {
					if (dataTransfer) {
						dataTransfer.effectAllowed = 'move';
						options.setData && options.setData.call(_this, dataTransfer, dragEl);
					}
	
					_on(document, 'drop', _this);
	
					// #1143: Бывает элемент с IFrame внутри блокирует `drop`,
					// поэтому если вызвался `mouseover`, значит надо отменять весь d'n'd.
					// Breaking Chrome 62+
					// _on(document, 'mouseover', _this);
	
					_this._dragStartId = _nextTick(_this._dragStarted);
				}
			},
	
			_onDragOver: function (/**Event*/evt) {
				var el = this.el,
					target,
					dragRect,
					targetRect,
					revert,
					options = this.options,
					group = options.group,
					activeSortable = Sortable.active,
					isOwner = (activeGroup === group),
					isMovingBetweenSortable = false,
					canSort = options.sort;
	
				if (evt.preventDefault !== void 0) {
					evt.preventDefault();
					!options.dragoverBubble && evt.stopPropagation();
				}
	
				if (dragEl.animated) {
					return;
				}
	
				moved = true;
	
				if (activeSortable && !options.disabled &&
					(isOwner
						? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
						: (
							putSortable === this ||
							(
								(activeSortable.lastPullMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) &&
								group.checkPut(this, activeSortable, dragEl, evt)
							)
						)
					) &&
					(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
				) {
					// Smart auto-scrolling
					_autoScroll(evt, options, this.el);
	
					if (_silent) {
						return;
					}
	
					target = _closest(evt.target, options.draggable, el);
					dragRect = dragEl.getBoundingClientRect();
	
					if (putSortable !== this) {
						putSortable = this;
						isMovingBetweenSortable = true;
					}
	
					if (revert) {
						_cloneHide(activeSortable, true);
						parentEl = rootEl; // actualization
	
						if (cloneEl || nextEl) {
							rootEl.insertBefore(dragEl, cloneEl || nextEl);
						}
						else if (!canSort) {
							rootEl.appendChild(dragEl);
						}
	
						return;
					}
	
	
					if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
						(el === evt.target) && (_ghostIsLast(el, evt))
					) {
						//assign target only if condition is true
						if (el.children.length !== 0 && el.children[0] !== ghostEl && el === evt.target) {
							target = el.lastElementChild;
						}
	
						if (target) {
							if (target.animated) {
								return;
							}
	
							targetRect = target.getBoundingClientRect();
						}
	
						_cloneHide(activeSortable, isOwner);
	
						if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
							if (!dragEl.contains(el)) {
								el.appendChild(dragEl);
								parentEl = el; // actualization
							}
	
							this._animate(dragRect, dragEl);
							target && this._animate(targetRect, target);
						}
					}
					else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
						if (lastEl !== target) {
							lastEl = target;
							lastCSS = _css(target);
							lastParentCSS = _css(target.parentNode);
						}
	
						targetRect = target.getBoundingClientRect();
	
						var width = targetRect.right - targetRect.left,
							height = targetRect.bottom - targetRect.top,
							floating = R_FLOAT.test(lastCSS.cssFloat + lastCSS.display)
								|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
							isWide = (target.offsetWidth > dragEl.offsetWidth),
							isLong = (target.offsetHeight > dragEl.offsetHeight),
							halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
							nextSibling = target.nextElementSibling,
							after = false
						;
	
						if (floating) {
							var elTop = dragEl.offsetTop,
								tgTop = target.offsetTop;
	
							if (elTop === tgTop) {
								after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
							}
							else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
								after = (evt.clientY - targetRect.top) / height > 0.5;
							} else {
								after = tgTop > elTop;
							}
							} else if (!isMovingBetweenSortable) {
							after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
						}
	
						var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
	
						if (moveVector !== false) {
							if (moveVector === 1 || moveVector === -1) {
								after = (moveVector === 1);
							}
	
							_silent = true;
							setTimeout(_unsilent, 30);
	
							_cloneHide(activeSortable, isOwner);
	
							if (!dragEl.contains(el)) {
								if (after && !nextSibling) {
									el.appendChild(dragEl);
								} else {
									target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
								}
							}
	
							parentEl = dragEl.parentNode; // actualization
	
							this._animate(dragRect, dragEl);
							this._animate(targetRect, target);
						}
					}
				}
			},
	
			_animate: function (prevRect, target) {
				var ms = this.options.animation;
	
				if (ms) {
					var currentRect = target.getBoundingClientRect();
	
					if (prevRect.nodeType === 1) {
						prevRect = prevRect.getBoundingClientRect();
					}
	
					_css(target, 'transition', 'none');
					_css(target, 'transform', 'translate3d('
						+ (prevRect.left - currentRect.left) + 'px,'
						+ (prevRect.top - currentRect.top) + 'px,0)'
					);
	
					target.offsetWidth; // repaint
	
					_css(target, 'transition', 'all ' + ms + 'ms');
					_css(target, 'transform', 'translate3d(0,0,0)');
	
					clearTimeout(target.animated);
					target.animated = setTimeout(function () {
						_css(target, 'transition', '');
						_css(target, 'transform', '');
						target.animated = false;
					}, ms);
				}
			},
	
			_offUpEvents: function () {
				var ownerDocument = this.el.ownerDocument;
	
				_off(document, 'touchmove', this._onTouchMove);
				_off(document, 'pointermove', this._onTouchMove);
				_off(ownerDocument, 'mouseup', this._onDrop);
				_off(ownerDocument, 'touchend', this._onDrop);
				_off(ownerDocument, 'pointerup', this._onDrop);
				_off(ownerDocument, 'touchcancel', this._onDrop);
				_off(ownerDocument, 'pointercancel', this._onDrop);
				_off(ownerDocument, 'selectstart', this);
			},
	
			_onDrop: function (/**Event*/evt) {
				var el = this.el,
					options = this.options;
	
				clearInterval(this._loopId);
				clearInterval(autoScroll.pid);
				clearTimeout(this._dragStartTimer);
	
				_cancelNextTick(this._cloneId);
				_cancelNextTick(this._dragStartId);
	
				// Unbind events
				_off(document, 'mouseover', this);
				_off(document, 'mousemove', this._onTouchMove);
	
				if (this.nativeDraggable) {
					_off(document, 'drop', this);
					_off(el, 'dragstart', this._onDragStart);
				}
	
				this._offUpEvents();
	
				if (evt) {
					if (moved) {
						evt.preventDefault();
						!options.dropBubble && evt.stopPropagation();
					}
	
					ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
	
					if (rootEl === parentEl || Sortable.active.lastPullMode !== 'clone') {
						// Remove clone
						cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
					}
	
					if (dragEl) {
						if (this.nativeDraggable) {
							_off(dragEl, 'dragend', this);
						}
	
						_disableDraggable(dragEl);
						dragEl.style['will-change'] = '';
	
						// Remove class's
						_toggleClass(dragEl, this.options.ghostClass, false);
						_toggleClass(dragEl, this.options.chosenClass, false);
	
						// Drag stop event
						_dispatchEvent(this, rootEl, 'unchoose', dragEl, parentEl, rootEl, oldIndex);
	
						if (rootEl !== parentEl) {
							newIndex = _index(dragEl, options.draggable);
	
							if (newIndex >= 0) {
								// Add event
								_dispatchEvent(null, parentEl, 'add', dragEl, parentEl, rootEl, oldIndex, newIndex);
	
								// Remove event
								_dispatchEvent(this, rootEl, 'remove', dragEl, parentEl, rootEl, oldIndex, newIndex);
	
								// drag from one list and drop into another
								_dispatchEvent(null, parentEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
							}
						}
						else {
							if (dragEl.nextSibling !== nextEl) {
								// Get the index of the dragged element within its parent
								newIndex = _index(dragEl, options.draggable);
	
								if (newIndex >= 0) {
									// drag & drop within the same list
									_dispatchEvent(this, rootEl, 'update', dragEl, parentEl, rootEl, oldIndex, newIndex);
									_dispatchEvent(this, rootEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
								}
							}
						}
	
						if (Sortable.active) {
							/* jshint eqnull:true */
							if (newIndex == null || newIndex === -1) {
								newIndex = oldIndex;
							}
	
							_dispatchEvent(this, rootEl, 'end', dragEl, parentEl, rootEl, oldIndex, newIndex);
	
							// Save sorting
							this.save();
						}
					}
	
				}
	
				this._nulling();
			},
	
			_nulling: function() {
				rootEl =
				dragEl =
				parentEl =
				ghostEl =
				nextEl =
				cloneEl =
				lastDownEl =
	
				scrollEl =
				scrollParentEl =
	
				tapEvt =
				touchEvt =
	
				moved =
				newIndex =
	
				lastEl =
				lastCSS =
	
				putSortable =
				activeGroup =
				Sortable.active = null;
	
				savedInputChecked.forEach(function (el) {
					el.checked = true;
				});
				savedInputChecked.length = 0;
			},
	
			handleEvent: function (/**Event*/evt) {
				switch (evt.type) {
					case 'drop':
					case 'dragend':
						this._onDrop(evt);
						break;
	
					case 'dragover':
					case 'dragenter':
						if (dragEl) {
							this._onDragOver(evt);
							_globalDragOver(evt);
						}
						break;
	
					case 'mouseover':
						this._onDrop(evt);
						break;
	
					case 'selectstart':
						evt.preventDefault();
						break;
				}
			},
	
	
			/**
			 * Serializes the item into an array of string.
			 * @returns {String[]}
			 */
			toArray: function () {
				var order = [],
					el,
					children = this.el.children,
					i = 0,
					n = children.length,
					options = this.options;
	
				for (; i < n; i++) {
					el = children[i];
					if (_closest(el, options.draggable, this.el)) {
						order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
					}
				}
	
				return order;
			},
	
	
			/**
			 * Sorts the elements according to the array.
			 * @param  {String[]}  order  order of the items
			 */
			sort: function (order) {
				var items = {}, rootEl = this.el;
	
				this.toArray().forEach(function (id, i) {
					var el = rootEl.children[i];
	
					if (_closest(el, this.options.draggable, rootEl)) {
						items[id] = el;
					}
				}, this);
	
				order.forEach(function (id) {
					if (items[id]) {
						rootEl.removeChild(items[id]);
						rootEl.appendChild(items[id]);
					}
				});
			},
	
	
			/**
			 * Save the current sorting
			 */
			save: function () {
				var store = this.options.store;
				store && store.set(this);
			},
	
	
			/**
			 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
			 * @param   {HTMLElement}  el
			 * @param   {String}       [selector]  default: `options.draggable`
			 * @returns {HTMLElement|null}
			 */
			closest: function (el, selector) {
				return _closest(el, selector || this.options.draggable, this.el);
			},
	
	
			/**
			 * Set/get option
			 * @param   {string} name
			 * @param   {*}      [value]
			 * @returns {*}
			 */
			option: function (name, value) {
				var options = this.options;
	
				if (value === void 0) {
					return options[name];
				} else {
					options[name] = value;
	
					if (name === 'group') {
						_prepareGroup(options);
					}
				}
			},
	
	
			/**
			 * Destroy
			 */
			destroy: function () {
				var el = this.el;
	
				el[expando] = null;
	
				_off(el, 'mousedown', this._onTapStart);
				_off(el, 'touchstart', this._onTapStart);
				_off(el, 'pointerdown', this._onTapStart);
	
				if (this.nativeDraggable) {
					_off(el, 'dragover', this);
					_off(el, 'dragenter', this);
				}
	
				// Remove draggable attributes
				Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
					el.removeAttribute('draggable');
				});
	
				touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);
	
				this._onDrop();
	
				this.el = el = null;
			}
		};
	
	
		function _cloneHide(sortable, state) {
			if (sortable.lastPullMode !== 'clone') {
				state = true;
			}
	
			if (cloneEl && (cloneEl.state !== state)) {
				_css(cloneEl, 'display', state ? 'none' : '');
	
				if (!state) {
					if (cloneEl.state) {
						if (sortable.options.group.revertClone) {
							rootEl.insertBefore(cloneEl, nextEl);
							sortable._animate(dragEl, cloneEl);
						} else {
							rootEl.insertBefore(cloneEl, dragEl);
						}
					}
				}
	
				cloneEl.state = state;
			}
		}
	
	
		function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
			if (el) {
				ctx = ctx || document;
	
				do {
					if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
						return el;
					}
					/* jshint boss:true */
				} while (el = _getParentOrHost(el));
			}
	
			return null;
		}
	
	
		function _getParentOrHost(el) {
			var parent = el.host;
	
			return (parent && parent.nodeType) ? parent : el.parentNode;
		}
	
	
		function _globalDragOver(/**Event*/evt) {
			if (evt.dataTransfer) {
				evt.dataTransfer.dropEffect = 'move';
			}
			evt.preventDefault();
		}
	
	
		function _on(el, event, fn) {
			el.addEventListener(event, fn, captureMode);
		}
	
	
		function _off(el, event, fn) {
			el.removeEventListener(event, fn, captureMode);
		}
	
	
		function _toggleClass(el, name, state) {
			if (el) {
				if (el.classList) {
					el.classList[state ? 'add' : 'remove'](name);
				}
				else {
					var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
					el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
				}
			}
		}
	
	
		function _css(el, prop, val) {
			var style = el && el.style;
	
			if (style) {
				if (val === void 0) {
					if (document.defaultView && document.defaultView.getComputedStyle) {
						val = document.defaultView.getComputedStyle(el, '');
					}
					else if (el.currentStyle) {
						val = el.currentStyle;
					}
	
					return prop === void 0 ? val : val[prop];
				}
				else {
					if (!(prop in style)) {
						prop = '-webkit-' + prop;
					}
	
					style[prop] = val + (typeof val === 'string' ? '' : 'px');
				}
			}
		}
	
	
		function _find(ctx, tagName, iterator) {
			if (ctx) {
				var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
	
				if (iterator) {
					for (; i < n; i++) {
						iterator(list[i], i);
					}
				}
	
				return list;
			}
	
			return [];
		}
	
	
	
		function _dispatchEvent(sortable, rootEl, name, targetEl, toEl, fromEl, startIndex, newIndex) {
			sortable = (sortable || rootEl[expando]);
	
			var evt = document.createEvent('Event'),
				options = sortable.options,
				onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
	
			evt.initEvent(name, true, true);
	
			evt.to = toEl || rootEl;
			evt.from = fromEl || rootEl;
			evt.item = targetEl || rootEl;
			evt.clone = cloneEl;
	
			evt.oldIndex = startIndex;
			evt.newIndex = newIndex;
	
			rootEl.dispatchEvent(evt);
	
			if (options[onName]) {
				options[onName].call(sortable, evt);
			}
		}
	
	
		function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt, willInsertAfter) {
			var evt,
				sortable = fromEl[expando],
				onMoveFn = sortable.options.onMove,
				retVal;
	
			evt = document.createEvent('Event');
			evt.initEvent('move', true, true);
	
			evt.to = toEl;
			evt.from = fromEl;
			evt.dragged = dragEl;
			evt.draggedRect = dragRect;
			evt.related = targetEl || toEl;
			evt.relatedRect = targetRect || toEl.getBoundingClientRect();
			evt.willInsertAfter = willInsertAfter;
	
			fromEl.dispatchEvent(evt);
	
			if (onMoveFn) {
				retVal = onMoveFn.call(sortable, evt, originalEvt);
			}
	
			return retVal;
		}
	
	
		function _disableDraggable(el) {
			el.draggable = false;
		}
	
	
		function _unsilent() {
			_silent = false;
		}
	
	
		/** @returns {HTMLElement|false} */
		function _ghostIsLast(el, evt) {
			var lastEl = el.lastElementChild,
				rect = lastEl.getBoundingClientRect();
	
			// 5 — min delta
			// abs — нельзя добавлять, а то глюки при наведении сверху
			return (evt.clientY - (rect.top + rect.height) > 5) ||
				(evt.clientX - (rect.left + rect.width) > 5);
		}
	
	
		/**
		 * Generate id
		 * @param   {HTMLElement} el
		 * @returns {String}
		 * @private
		 */
		function _generateId(el) {
			var str = el.tagName + el.className + el.src + el.href + el.textContent,
				i = str.length,
				sum = 0;
	
			while (i--) {
				sum += str.charCodeAt(i);
			}
	
			return sum.toString(36);
		}
	
		/**
		 * Returns the index of an element within its parent for a selected set of
		 * elements
		 * @param  {HTMLElement} el
		 * @param  {selector} selector
		 * @return {number}
		 */
		function _index(el, selector) {
			var index = 0;
	
			if (!el || !el.parentNode) {
				return -1;
			}
	
			while (el && (el = el.previousElementSibling)) {
				if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
					index++;
				}
			}
	
			return index;
		}
	
		function _matches(/**HTMLElement*/el, /**String*/selector) {
			if (el) {
				selector = selector.split('.');
	
				var tag = selector.shift().toUpperCase(),
					re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');
	
				return (
					(tag === '' || el.nodeName.toUpperCase() == tag) &&
					(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
				);
			}
	
			return false;
		}
	
		function _throttle(callback, ms) {
			var args, _this;
	
			return function () {
				if (args === void 0) {
					args = arguments;
					_this = this;
	
					setTimeout(function () {
						if (args.length === 1) {
							callback.call(_this, args[0]);
						} else {
							callback.apply(_this, args);
						}
	
						args = void 0;
					}, ms);
				}
			};
		}
	
		function _extend(dst, src) {
			if (dst && src) {
				for (var key in src) {
					if (src.hasOwnProperty(key)) {
						dst[key] = src[key];
					}
				}
			}
	
			return dst;
		}
	
		function _clone(el) {
			if (Polymer && Polymer.dom) {
				return Polymer.dom(el).cloneNode(true);
			}
			else if ($) {
				return $(el).clone(true)[0];
			}
			else {
				return el.cloneNode(true);
			}
		}
	
		function _saveInputCheckedState(root) {
			var inputs = root.getElementsByTagName('input');
			var idx = inputs.length;
	
			while (idx--) {
				var el = inputs[idx];
				el.checked && savedInputChecked.push(el);
			}
		}
	
		function _nextTick(fn) {
			return setTimeout(fn, 0);
		}
	
		function _cancelNextTick(id) {
			return clearTimeout(id);
		}
	
		// Fixed #973:
		_on(document, 'touchmove', function (evt) {
			if (Sortable.active) {
				evt.preventDefault();
			}
		});
	
		// Export utils
		Sortable.utils = {
			on: _on,
			off: _off,
			css: _css,
			find: _find,
			is: function (el, selector) {
				return !!_closest(el, selector, el);
			},
			extend: _extend,
			throttle: _throttle,
			closest: _closest,
			toggleClass: _toggleClass,
			clone: _clone,
			index: _index,
			nextTick: _nextTick,
			cancelNextTick: _cancelNextTick
		};
	
	
		/**
		 * Create sortable instance
		 * @param {HTMLElement}  el
		 * @param {Object}      [options]
		 */
		Sortable.create = function (el, options) {
			return new Sortable(el, options);
		};
	
	
		// Export
		Sortable.version = '1.7.0';
		return Sortable;
	});


/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(218).EventEmitter;
	var inherits = __webpack_require__(64);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(220);
	Stream.Writable = __webpack_require__(2920);
	Stream.Duplex = __webpack_require__(2914);
	Stream.Transform = __webpack_require__(2919);
	Stream.PassThrough = __webpack_require__(2918);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _colorLuminance = __webpack_require__(155);
	
	var _getModal = __webpack_require__(154);
	
	var _hasClass$isDescendant = __webpack_require__(122);
	
	/*
	 * User clicked on "Confirm"/"OK" or "Cancel"
	 */
	var handleButton = function handleButton(event, params, modal) {
	  var e = event || window.event;
	  var target = e.target || e.srcElement;
	
	  var targetedConfirm = target.className.indexOf('confirm') !== -1;
	  var targetedOverlay = target.className.indexOf('sweet-overlay') !== -1;
	  var modalIsVisible = _hasClass$isDescendant.hasClass(modal, 'visible');
	  var doneFunctionExists = params.doneFunction && modal.getAttribute('data-has-done-function') === 'true';
	
	  // Since the user can change the background-color of the confirm button programmatically,
	  // we must calculate what the color should be on hover/active
	  var normalColor, hoverColor, activeColor;
	  if (targetedConfirm && params.confirmButtonColor) {
	    normalColor = params.confirmButtonColor;
	    hoverColor = _colorLuminance.colorLuminance(normalColor, -0.04);
	    activeColor = _colorLuminance.colorLuminance(normalColor, -0.14);
	  }
	
	  function shouldSetConfirmButtonColor(color) {
	    if (targetedConfirm && params.confirmButtonColor) {
	      target.style.backgroundColor = color;
	    }
	  }
	
	  switch (e.type) {
	    case 'mouseover':
	      shouldSetConfirmButtonColor(hoverColor);
	      break;
	
	    case 'mouseout':
	      shouldSetConfirmButtonColor(normalColor);
	      break;
	
	    case 'mousedown':
	      shouldSetConfirmButtonColor(activeColor);
	      break;
	
	    case 'mouseup':
	      shouldSetConfirmButtonColor(hoverColor);
	      break;
	
	    case 'focus':
	      var $confirmButton = modal.querySelector('button.confirm');
	      var $cancelButton = modal.querySelector('button.cancel');
	
	      if (targetedConfirm) {
	        $cancelButton.style.boxShadow = 'none';
	      } else {
	        $confirmButton.style.boxShadow = 'none';
	      }
	      break;
	
	    case 'click':
	      var clickedOnModal = modal === target;
	      var clickedOnModalChild = _hasClass$isDescendant.isDescendant(modal, target);
	
	      // Ignore click outside if allowOutsideClick is false
	      if (!clickedOnModal && !clickedOnModalChild && modalIsVisible && !params.allowOutsideClick) {
	        break;
	      }
	
	      if (targetedConfirm && doneFunctionExists && modalIsVisible) {
	        handleConfirm(modal, params);
	      } else if (doneFunctionExists && modalIsVisible || targetedOverlay) {
	        handleCancel(modal, params);
	      } else if (_hasClass$isDescendant.isDescendant(modal, target) && target.tagName === 'BUTTON') {
	        sweetAlert.close();
	      }
	      break;
	  }
	};
	
	/*
	 *  User clicked on "Confirm"/"OK"
	 */
	var handleConfirm = function handleConfirm(modal, params) {
	  var callbackValue = true;
	
	  if (_hasClass$isDescendant.hasClass(modal, 'show-input')) {
	    callbackValue = modal.querySelector('input').value;
	
	    if (!callbackValue) {
	      callbackValue = '';
	    }
	  }
	
	  params.doneFunction(callbackValue);
	
	  if (params.closeOnConfirm) {
	    sweetAlert.close();
	  }
	  // Disable cancel and confirm button if the parameter is true
	  if (params.showLoaderOnConfirm) {
	    sweetAlert.disableButtons();
	  }
	};
	
	/*
	 *  User clicked on "Cancel"
	 */
	var handleCancel = function handleCancel(modal, params) {
	  // Check if callback function expects a parameter (to track cancel actions)
	  var functionAsStr = String(params.doneFunction).replace(/\s/g, '');
	  var functionHandlesCancel = functionAsStr.substring(0, 9) === 'function(' && functionAsStr.substring(9, 10) !== ')';
	
	  if (functionHandlesCancel) {
	    params.doneFunction(false);
	  }
	
	  if (params.closeOnCancel) {
	    sweetAlert.close();
	  }
	};
	
	exports['default'] = {
	  handleButton: handleButton,
	  handleConfirm: handleConfirm,
	  handleCancel: handleCancel
	};
	module.exports = exports['default'];

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _stopEventPropagation$fireClick = __webpack_require__(122);
	
	var _setFocusStyle = __webpack_require__(154);
	
	var handleKeyDown = function handleKeyDown(event, params, modal) {
	  var e = event || window.event;
	  var keyCode = e.keyCode || e.which;
	
	  var $okButton = modal.querySelector('button.confirm');
	  var $cancelButton = modal.querySelector('button.cancel');
	  var $modalButtons = modal.querySelectorAll('button[tabindex]');
	
	  if ([9, 13, 32, 27].indexOf(keyCode) === -1) {
	    // Don't do work on keys we don't care about.
	    return;
	  }
	
	  var $targetElement = e.target || e.srcElement;
	
	  var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
	  for (var i = 0; i < $modalButtons.length; i++) {
	    if ($targetElement === $modalButtons[i]) {
	      btnIndex = i;
	      break;
	    }
	  }
	
	  if (keyCode === 9) {
	    // TAB
	    if (btnIndex === -1) {
	      // No button focused. Jump to the confirm button.
	      $targetElement = $okButton;
	    } else {
	      // Cycle to the next button
	      if (btnIndex === $modalButtons.length - 1) {
	        $targetElement = $modalButtons[0];
	      } else {
	        $targetElement = $modalButtons[btnIndex + 1];
	      }
	    }
	
	    _stopEventPropagation$fireClick.stopEventPropagation(e);
	    $targetElement.focus();
	
	    if (params.confirmButtonColor) {
	      _setFocusStyle.setFocusStyle($targetElement, params.confirmButtonColor);
	    }
	  } else {
	    if (keyCode === 13) {
	      if ($targetElement.tagName === 'INPUT') {
	        $targetElement = $okButton;
	        $okButton.focus();
	      }
	
	      if (btnIndex === -1) {
	        // ENTER/SPACE clicked outside of a button.
	        $targetElement = $okButton;
	      } else {
	        // Do nothing - let the browser handle it.
	        $targetElement = undefined;
	      }
	    } else if (keyCode === 27 && params.allowEscapeKey === true) {
	      $targetElement = $cancelButton;
	      _stopEventPropagation$fireClick.fireClick($targetElement, e);
	    } else {
	      // Fallback - let the browser handle it.
	      $targetElement = undefined;
	    }
	  }
	};
	
	exports['default'] = handleKeyDown;
	module.exports = exports['default'];

/***/ }),
/* 2933 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var injectedHTML =
	
	// Dark overlay
	"<div class=\"sweet-overlay\" tabIndex=\"-1\"></div>" +
	
	// Modal
	"<div class=\"sweet-alert\">" +
	
	// Error icon
	"<div class=\"sa-icon sa-error\">\n      <span class=\"sa-x-mark\">\n        <span class=\"sa-line sa-left\"></span>\n        <span class=\"sa-line sa-right\"></span>\n      </span>\n    </div>" +
	
	// Warning icon
	"<div class=\"sa-icon sa-warning\">\n      <span class=\"sa-body\"></span>\n      <span class=\"sa-dot\"></span>\n    </div>" +
	
	// Info icon
	"<div class=\"sa-icon sa-info\"></div>" +
	
	// Success icon
	"<div class=\"sa-icon sa-success\">\n      <span class=\"sa-line sa-tip\"></span>\n      <span class=\"sa-line sa-long\"></span>\n\n      <div class=\"sa-placeholder\"></div>\n      <div class=\"sa-fix\"></div>\n    </div>" + "<div class=\"sa-icon sa-custom\"></div>" +
	
	// Title, text and input
	"<h2>Title</h2>\n    <p>Text</p>\n    <fieldset>\n      <input type=\"text\" tabIndex=\"3\" />\n      <div class=\"sa-input-error\"></div>\n    </fieldset>" +
	
	// Input errors
	"<div class=\"sa-error-container\">\n      <div class=\"icon\">!</div>\n      <p>Not valid!</p>\n    </div>" +
	
	// Cancel and confirm buttons
	"<div class=\"sa-button-container\">\n      <button class=\"cancel\" tabIndex=\"2\">Cancel</button>\n      <div class=\"sa-confirm-button-container\">\n        <button class=\"confirm\" tabIndex=\"1\">OK</button>" +
	
	// Loading animation
	"<div class=\"la-ball-fall\">\n          <div></div>\n          <div></div>\n          <div></div>\n        </div>\n      </div>\n    </div>" +
	
	// End of modal
	"</div>";
	
	exports["default"] = injectedHTML;
	module.exports = exports["default"];

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _isIE8 = __webpack_require__(155);
	
	var _getModal$getInput$setFocusStyle = __webpack_require__(154);
	
	var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide = __webpack_require__(122);
	
	var alertTypes = ['error', 'warning', 'info', 'success', 'input', 'prompt'];
	
	/*
	 * Set type, text and actions on modal
	 */
	var setParameters = function setParameters(params) {
	  var modal = _getModal$getInput$setFocusStyle.getModal();
	
	  var $title = modal.querySelector('h2');
	  var $text = modal.querySelector('p');
	  var $cancelBtn = modal.querySelector('button.cancel');
	  var $confirmBtn = modal.querySelector('button.confirm');
	
	  /*
	   * Title
	   */
	  $title.innerHTML = params.html ? params.title : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.title).split('\n').join('<br>');
	
	  /*
	   * Text
	   */
	  $text.innerHTML = params.html ? params.text : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.text || '').split('\n').join('<br>');
	  if (params.text) _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($text);
	
	  /*
	   * Custom class
	   */
	  if (params.customClass) {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, params.customClass);
	    modal.setAttribute('data-custom-class', params.customClass);
	  } else {
	    // Find previously set classes and remove them
	    var customClass = modal.getAttribute('data-custom-class');
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.removeClass(modal, customClass);
	    modal.setAttribute('data-custom-class', '');
	  }
	
	  /*
	   * Icon
	   */
	  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide(modal.querySelectorAll('.sa-icon'));
	
	  if (params.type && !_isIE8.isIE8()) {
	    var _ret = (function () {
	
	      var validType = false;
	
	      for (var i = 0; i < alertTypes.length; i++) {
	        if (params.type === alertTypes[i]) {
	          validType = true;
	          break;
	        }
	      }
	
	      if (!validType) {
	        logStr('Unknown alert type: ' + params.type);
	        return {
	          v: false
	        };
	      }
	
	      var typesWithIcons = ['success', 'error', 'warning', 'info'];
	      var $icon = undefined;
	
	      if (typesWithIcons.indexOf(params.type) !== -1) {
	        $icon = modal.querySelector('.sa-icon.' + 'sa-' + params.type);
	        _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($icon);
	      }
	
	      var $input = _getModal$getInput$setFocusStyle.getInput();
	
	      // Animate icon
	      switch (params.type) {
	
	        case 'success':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animate');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-tip'), 'animateSuccessTip');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-long'), 'animateSuccessLong');
	          break;
	
	        case 'error':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animateErrorIcon');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-x-mark'), 'animateXMark');
	          break;
	
	        case 'warning':
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'pulseWarning');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-body'), 'pulseWarningIns');
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-dot'), 'pulseWarningIns');
	          break;
	
	        case 'input':
	        case 'prompt':
	          $input.setAttribute('type', params.inputType);
	          $input.value = params.inputValue;
	          $input.setAttribute('placeholder', params.inputPlaceholder);
	          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, 'show-input');
	          setTimeout(function () {
	            $input.focus();
	            $input.addEventListener('keyup', swal.resetInputError);
	          }, 400);
	          break;
	      }
	    })();
	
	    if (typeof _ret === 'object') {
	      return _ret.v;
	    }
	  }
	
	  /*
	   * Custom image
	   */
	  if (params.imageUrl) {
	    var $customIcon = modal.querySelector('.sa-icon.sa-custom');
	
	    $customIcon.style.backgroundImage = 'url(' + params.imageUrl + ')';
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($customIcon);
	
	    var _imgWidth = 80;
	    var _imgHeight = 80;
	
	    if (params.imageSize) {
	      var dimensions = params.imageSize.toString().split('x');
	      var imgWidth = dimensions[0];
	      var imgHeight = dimensions[1];
	
	      if (!imgWidth || !imgHeight) {
	        logStr('Parameter imageSize expects value with format WIDTHxHEIGHT, got ' + params.imageSize);
	      } else {
	        _imgWidth = imgWidth;
	        _imgHeight = imgHeight;
	      }
	    }
	
	    $customIcon.setAttribute('style', $customIcon.getAttribute('style') + 'width:' + _imgWidth + 'px; height:' + _imgHeight + 'px');
	  }
	
	  /*
	   * Show cancel button?
	   */
	  modal.setAttribute('data-has-cancel-button', params.showCancelButton);
	  if (params.showCancelButton) {
	    $cancelBtn.style.display = 'inline-block';
	  } else {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($cancelBtn);
	  }
	
	  /*
	   * Show confirm button?
	   */
	  modal.setAttribute('data-has-confirm-button', params.showConfirmButton);
	  if (params.showConfirmButton) {
	    $confirmBtn.style.display = 'inline-block';
	  } else {
	    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($confirmBtn);
	  }
	
	  /*
	   * Custom text on cancel/confirm buttons
	   */
	  if (params.cancelButtonText) {
	    $cancelBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.cancelButtonText);
	  }
	  if (params.confirmButtonText) {
	    $confirmBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.confirmButtonText);
	  }
	
	  /*
	   * Custom color on confirm button
	   */
	  if (params.confirmButtonColor) {
	    // Set confirm button to selected background color
	    $confirmBtn.style.backgroundColor = params.confirmButtonColor;
	
	    // Set the confirm button color to the loading ring
	    $confirmBtn.style.borderLeftColor = params.confirmLoadingButtonColor;
	    $confirmBtn.style.borderRightColor = params.confirmLoadingButtonColor;
	
	    // Set box-shadow to default focused button
	    _getModal$getInput$setFocusStyle.setFocusStyle($confirmBtn, params.confirmButtonColor);
	  }
	
	  /*
	   * Allow outside click
	   */
	  modal.setAttribute('data-allow-outside-click', params.allowOutsideClick);
	
	  /*
	   * Callback function
	   */
	  var hasDoneFunction = params.doneFunction ? true : false;
	  modal.setAttribute('data-has-done-function', hasDoneFunction);
	
	  /*
	   * Animation
	   */
	  if (!params.animation) {
	    modal.setAttribute('data-animation', 'none');
	  } else if (typeof params.animation === 'string') {
	    modal.setAttribute('data-animation', params.animation); // Custom animation
	  } else {
	    modal.setAttribute('data-animation', 'pop');
	  }
	
	  /*
	   * Timer
	   */
	  modal.setAttribute('data-timer', params.timer);
	};
	
	exports['default'] = setParameters;
	module.exports = exports['default'];

/***/ }),
/* 2935 */,
/* 2936 */,
/* 2937 */,
/* 2938 */,
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */,
/* 2944 */,
/* 2945 */,
/* 2946 */,
/* 2947 */,
/* 2948 */,
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */,
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3009 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 3010 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueInfiniteLoading=t():e.VueInfiniteLoading=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(n){if(i[n])return i[n].exports;var a=i[n]={i:n,l:!1,exports:{}};return e[n].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var i={};return t.m=e,t.c=i,t.d=function(e,i,n){t.o(e,i)||Object.defineProperty(e,i,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var i=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(i,"a",i),i},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=3)}([function(e,t){function i(e,t){var i=e[1]||"",a=e[3];if(!a)return i;if(t&&"function"==typeof btoa){var r=n(a);return[i].concat(a.sources.map(function(e){return"/*# sourceURL="+a.sourceRoot+e+" */"})).concat([r]).join("\n")}return[i].join("\n")}function n(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var n=i(t,e);return t[2]?"@media "+t[2]+"{"+n+"}":n}).join("")},t.i=function(e,i){"string"==typeof e&&(e=[[null,e,""]]);for(var n={},a=0;a<this.length;a++){var r=this[a][0];"number"==typeof r&&(n[r]=!0)}for(a=0;a<e.length;a++){var o=e[a];"number"==typeof o[0]&&n[o[0]]||(i&&!o[2]?o[2]=i:i&&(o[2]="("+o[2]+") and ("+i+")"),t.push(o))}},t}},function(e,t,i){function n(e){for(var t=0;t<e.length;t++){var i=e[t],n=f[i.id];if(n){n.refs++;for(var a=0;a<n.parts.length;a++)n.parts[a](i.parts[a]);for(;a<i.parts.length;a++)n.parts.push(r(i.parts[a]));n.parts.length>i.parts.length&&(n.parts.length=i.parts.length)}else{for(var o=[],a=0;a<i.parts.length;a++)o.push(r(i.parts[a]));f[i.id]={id:i.id,refs:1,parts:o}}}}function a(){var e=document.createElement("style");return e.type="text/css",c.appendChild(e),e}function r(e){var t,i,n=document.querySelector('style[data-vue-ssr-id~="'+e.id+'"]');if(n){if(m)return h;n.parentNode.removeChild(n)}if(b){var r=p++;n=u||(u=a()),t=o.bind(null,n,r,!1),i=o.bind(null,n,r,!0)}else n=a(),t=s.bind(null,n),i=function(){n.parentNode.removeChild(n)};return t(e),function(n){if(n){if(n.css===e.css&&n.media===e.media&&n.sourceMap===e.sourceMap)return;t(e=n)}else i()}}function o(e,t,i,n){var a=i?"":n.css;if(e.styleSheet)e.styleSheet.cssText=g(t,a);else{var r=document.createTextNode(a),o=e.childNodes;o[t]&&e.removeChild(o[t]),o.length?e.insertBefore(r,o[t]):e.appendChild(r)}}function s(e,t){var i=t.css,n=t.media,a=t.sourceMap;if(n&&e.setAttribute("media",n),a&&(i+="\n/*# sourceURL="+a.sources[0]+" */",i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),e.styleSheet)e.styleSheet.cssText=i;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(i))}}var l="undefined"!=typeof document;if(false)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var d=i(7),f={},c=l&&(document.head||document.getElementsByTagName("head")[0]),u=null,p=0,m=!1,h=function(){},b="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());e.exports=function(e,t,i){m=i;var a=d(e,t);return n(a),function(t){for(var i=[],r=0;r<a.length;r++){var o=a[r],s=f[o.id];s.refs--,i.push(s)}t?(a=d(e,t),n(a)):a=[];for(var r=0;r<i.length;r++){var s=i[r];if(0===s.refs){for(var l=0;l<s.parts.length;l++)s.parts[l]();delete f[s.id]}}}};var g=function(){var e=[];return function(t,i){return e[t]=i,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e,t,i,n,a,r){var o,s=e=e||{},l=typeof e.default;"object"!==l&&"function"!==l||(o=e,s=e.default);var d="function"==typeof s?s.options:s;t&&(d.render=t.render,d.staticRenderFns=t.staticRenderFns,d._compiled=!0),i&&(d.functional=!0),a&&(d._scopeId=a);var f;if(r?(f=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),n&&n.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r)},d._ssrRegister=f):n&&(f=n),f){var c=d.functional,u=c?d.render:d.beforeCreate;c?(d._injectStyles=f,d.render=function(e,t){return f.call(t),u(e,t)}):d.beforeCreate=u?[].concat(u,f):[f]}return{esModule:o,exports:s,options:d}}},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=i(4);t.default=n.a,"undefined"!=typeof window&&window.Vue&&window.Vue.component("infinite-loading",n.a)},function(e,t,i){"use strict";function n(e){i(5)}var a=i(8),r=i(14),o=i(2),s=n,l=o(a.a,r.a,!1,s,"data-v-fb2c869e",null);t.a=l.exports},function(e,t,i){var n=i(6);"string"==typeof n&&(n=[[e.i,n,""]]),n.locals&&(e.exports=n.locals);i(1)("2249d7a7",n,!0)},function(e,t,i){t=e.exports=i(0)(void 0),t.push([e.i,".infinite-loading-container[data-v-fb2c869e]{clear:both;text-align:center}.infinite-loading-container[data-v-fb2c869e] [class^=loading-]{display:inline-block;margin:15px 0;width:28px;height:28px;font-size:28px;line-height:28px;border-radius:50%}.infinite-status-prompt[data-v-fb2c869e]{color:#666;font-size:14px;text-align:center;padding:10px 0}",""])},function(e,t){e.exports=function(e,t){for(var i=[],n={},a=0;a<t.length;a++){var r=t[a],o=r[0],s=r[1],l=r[2],d=r[3],f={id:e+":"+a,css:s,media:l,sourceMap:d};n[o]?n[o].parts.push(f):i.push(n[o]={id:o,parts:[f]})}return i}},function(e,t,i){"use strict";var n=i(9),a={STATE_CHANGER:["[Vue-infinite-loading warn]: emit `loaded` and `complete` event through component instance of `$refs` may cause error, so it will be deprecated soon, please use the `$state` argument instead (`$state` just the special `$event` variable):","\ntemplate:",'<infinite-loading @infinite="infiniteHandler"></infinite-loading>',"\nscript:\n...\ninfiniteHandler($state) {\n  ajax('https://www.example.com/api/news')\n    .then((res) => {\n      if (res.data.length) {\n        $state.loaded();\n      } else {\n        $state.complete();\n      }\n    });\n}\n...","","more details: https://github.com/PeachScript/vue-infinite-loading/issues/57#issuecomment-324370549"].join("\n"),INFINITE_EVENT:"[Vue-infinite-loading warn]: `:on-infinite` property will be deprecated soon, please use `@infinite` event instead."},r={INFINITE_LOOP:["[Vue-infinite-loading error]: executed the callback function more than 10 times for a short time, it looks like searched a wrong scroll wrapper that doest not has fixed height or maximum height, please check it. If you want to force to set a element as scroll wrapper ranther than automatic searching, you can do this:",'\n\x3c!-- add a special attribute for the real scroll wrapper --\x3e\n<div infinite-wrapper>\n  ...\n  \x3c!-- set force-use-infinite-wrapper to true --\x3e\n  <infinite-loading force-use-infinite-wrapper="true"></infinite-loading>\n</div>\n    ',"more details: https://github.com/PeachScript/vue-infinite-loading/issues/55#issuecomment-316934169"].join("\n")};t.a={name:"InfiniteLoading",data:function(){return{scrollParent:null,scrollHandler:null,isLoading:!1,isComplete:!1,isFirstLoad:!0,debounceTimer:null,debounceDuration:50,infiniteLoopChecked:!1,infiniteLoopTimer:null,continuousCallTimes:0}},components:{Spinner:n.a},computed:{isNoResults:{cache:!1,get:function(){var e=this.$slots["no-results"],t=e&&e[0].elm&&""===e[0].elm.textContent;return!this.isLoading&&this.isComplete&&this.isFirstLoad&&!t}},isNoMore:{cache:!1,get:function(){var e=this.$slots["no-more"],t=e&&e[0].elm&&""===e[0].elm.textContent;return!this.isLoading&&this.isComplete&&!this.isFirstLoad&&!t}}},props:{distance:{type:Number,default:100},onInfinite:Function,spinner:String,direction:{type:String,default:"bottom"},forceUseInfiniteWrapper:null},mounted:function(){var e=this;this.scrollParent=this.getScrollParent(),this.scrollHandler=function(e){this.isLoading||(clearTimeout(this.debounceTimer),e&&e.constructor===Event?this.debounceTimer=setTimeout(this.attemptLoad,this.debounceDuration):this.attemptLoad())}.bind(this),setTimeout(this.scrollHandler,1),this.scrollParent.addEventListener("scroll",this.scrollHandler),this.$on("$InfiniteLoading:loaded",function(t){e.isFirstLoad=!1,e.isLoading&&e.$nextTick(e.attemptLoad.bind(null,!0)),t&&t.target===e||console.warn(a.STATE_CHANGER)}),this.$on("$InfiniteLoading:complete",function(t){e.isLoading=!1,e.isComplete=!0,e.$nextTick(function(){e.$forceUpdate()}),e.scrollParent.removeEventListener("scroll",e.scrollHandler),t&&t.target===e||console.warn(a.STATE_CHANGER)}),this.$on("$InfiniteLoading:reset",function(){e.isLoading=!1,e.isComplete=!1,e.isFirstLoad=!0,e.scrollParent.addEventListener("scroll",e.scrollHandler),setTimeout(e.scrollHandler,1)}),this.onInfinite&&console.warn(a.INFINITE_EVENT),this.stateChanger={loaded:function(){e.$emit("$InfiniteLoading:loaded",{target:e})},complete:function(){e.$emit("$InfiniteLoading:complete",{target:e})},reset:function(){e.$emit("$InfiniteLoading:reset",{target:e})}},this.$watch("forceUseInfiniteWrapper",function(){e.scrollParent=e.getScrollParent()})},deactivated:function(){this.isLoading=!1,this.scrollParent.removeEventListener("scroll",this.scrollHandler)},activated:function(){this.scrollParent.addEventListener("scroll",this.scrollHandler)},methods:{attemptLoad:function(e){var t=this,i=this.getCurrentDistance();!this.isComplete&&i<=this.distance&&this.$el.offsetWidth+this.$el.offsetHeight>0?(this.isLoading=!0,"function"==typeof this.onInfinite?this.onInfinite.call(null,this.stateChanger):this.$emit("infinite",this.stateChanger),!e||this.forceUseInfiniteWrapper||this.infiniteLoopChecked||(this.continuousCallTimes+=1,clearTimeout(this.infiniteLoopTimer),this.infiniteLoopTimer=setTimeout(function(){t.infiniteLoopChecked=!0},1e3),this.continuousCallTimes>10&&(console.error(r.INFINITE_LOOP),this.infiniteLoopChecked=!0))):this.isLoading=!1},getCurrentDistance:function(){var e=void 0;if("top"===this.direction)e=isNaN(this.scrollParent.scrollTop)?this.scrollParent.pageYOffset:this.scrollParent.scrollTop;else{e=this.$el.getBoundingClientRect().top-(this.scrollParent===window?window.innerHeight:this.scrollParent.getBoundingClientRect().bottom)}return e},getScrollParent:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.$el,t=void 0;return"BODY"===e.tagName?t=window:!this.forceUseInfiniteWrapper&&["scroll","auto"].indexOf(getComputedStyle(e).overflowY)>-1?t=e:(e.hasAttribute("infinite-wrapper")||e.hasAttribute("data-infinite-wrapper"))&&(t=e),t||this.getScrollParent(e.parentNode)}},destroyed:function(){this.isComplete||this.scrollParent.removeEventListener("scroll",this.scrollHandler)}}},function(e,t,i){"use strict";function n(e){i(10)}var a=i(12),r=i(13),o=i(2),s=n,l=o(a.a,r.a,!1,s,"data-v-6e1fd88f",null);t.a=l.exports},function(e,t,i){var n=i(11);"string"==typeof n&&(n=[[e.i,n,""]]),n.locals&&(e.exports=n.locals);i(1)("29881045",n,!0)},function(e,t,i){t=e.exports=i(0)(void 0),t.push([e.i,'.loading-wave-dots[data-v-6e1fd88f]{position:relative}.loading-wave-dots[data-v-6e1fd88f] .wave-item{position:absolute;top:50%;left:50%;display:inline-block;margin-top:-4px;width:8px;height:8px;border-radius:50%;-webkit-animation:loading-wave-dots-data-v-6e1fd88f linear 2.8s infinite;animation:loading-wave-dots-data-v-6e1fd88f linear 2.8s infinite}.loading-wave-dots[data-v-6e1fd88f] .wave-item:first-child{margin-left:-36px}.loading-wave-dots[data-v-6e1fd88f] .wave-item:nth-child(2){margin-left:-20px;-webkit-animation-delay:.14s;animation-delay:.14s}.loading-wave-dots[data-v-6e1fd88f] .wave-item:nth-child(3){margin-left:-4px;-webkit-animation-delay:.28s;animation-delay:.28s}.loading-wave-dots[data-v-6e1fd88f] .wave-item:nth-child(4){margin-left:12px;-webkit-animation-delay:.42s;animation-delay:.42s}.loading-wave-dots[data-v-6e1fd88f] .wave-item:last-child{margin-left:28px;-webkit-animation-delay:.56s;animation-delay:.56s}@-webkit-keyframes loading-wave-dots-data-v-6e1fd88f{0%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}10%{-webkit-transform:translateY(-6px);transform:translateY(-6px);background:#999}20%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}to{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}}@keyframes loading-wave-dots-data-v-6e1fd88f{0%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}10%{-webkit-transform:translateY(-6px);transform:translateY(-6px);background:#999}20%{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}to{-webkit-transform:translateY(0);transform:translateY(0);background:#bbb}}.loading-circles[data-v-6e1fd88f] .circle-item{width:5px;height:5px;-webkit-animation:loading-circles-data-v-6e1fd88f linear .75s infinite;animation:loading-circles-data-v-6e1fd88f linear .75s infinite}.loading-circles[data-v-6e1fd88f] .circle-item:first-child{margin-top:-14.5px;margin-left:-2.5px}.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(2){margin-top:-11.26px;margin-left:6.26px}.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(3){margin-top:-2.5px;margin-left:9.5px}.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(4){margin-top:6.26px;margin-left:6.26px}.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(5){margin-top:9.5px;margin-left:-2.5px}.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(6){margin-top:6.26px;margin-left:-11.26px}.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(7){margin-top:-2.5px;margin-left:-14.5px}.loading-circles[data-v-6e1fd88f] .circle-item:last-child{margin-top:-11.26px;margin-left:-11.26px}@-webkit-keyframes loading-circles-data-v-6e1fd88f{0%{background:#dfdfdf}90%{background:#505050}to{background:#dfdfdf}}@keyframes loading-circles-data-v-6e1fd88f{0%{background:#dfdfdf}90%{background:#505050}to{background:#dfdfdf}}.loading-bubbles[data-v-6e1fd88f] .bubble-item{background:#666;-webkit-animation:loading-bubbles-data-v-6e1fd88f linear .75s infinite;animation:loading-bubbles-data-v-6e1fd88f linear .75s infinite}.loading-bubbles[data-v-6e1fd88f] .bubble-item:first-child{margin-top:-12.5px;margin-left:-.5px}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(2){margin-top:-9.26px;margin-left:8.26px}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(3){margin-top:-.5px;margin-left:11.5px}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(4){margin-top:8.26px;margin-left:8.26px}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(5){margin-top:11.5px;margin-left:-.5px}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(6){margin-top:8.26px;margin-left:-9.26px}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(7){margin-top:-.5px;margin-left:-12.5px}.loading-bubbles[data-v-6e1fd88f] .bubble-item:last-child{margin-top:-9.26px;margin-left:-9.26px}@-webkit-keyframes loading-bubbles-data-v-6e1fd88f{0%{width:1px;height:1px;box-shadow:0 0 0 3px #666}90%{width:1px;height:1px;box-shadow:0 0 0 0 #666}to{width:1px;height:1px;box-shadow:0 0 0 3px #666}}@keyframes loading-bubbles-data-v-6e1fd88f{0%{width:1px;height:1px;box-shadow:0 0 0 3px #666}90%{width:1px;height:1px;box-shadow:0 0 0 0 #666}to{width:1px;height:1px;box-shadow:0 0 0 3px #666}}.loading-default[data-v-6e1fd88f]{position:relative;border:1px solid #999;-webkit-animation:loading-rotating-data-v-6e1fd88f ease 1.5s infinite;animation:loading-rotating-data-v-6e1fd88f ease 1.5s infinite}.loading-default[data-v-6e1fd88f]:before{content:"";position:absolute;display:block;top:0;left:50%;margin-top:-3px;margin-left:-3px;width:6px;height:6px;background-color:#999;border-radius:50%}.loading-spiral[data-v-6e1fd88f]{border:2px solid #777;border-right-color:transparent;-webkit-animation:loading-rotating-data-v-6e1fd88f linear .85s infinite;animation:loading-rotating-data-v-6e1fd88f linear .85s infinite}@-webkit-keyframes loading-rotating-data-v-6e1fd88f{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-rotating-data-v-6e1fd88f{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loading-bubbles[data-v-6e1fd88f],.loading-circles[data-v-6e1fd88f]{position:relative}.loading-bubbles[data-v-6e1fd88f] .bubble-item,.loading-circles[data-v-6e1fd88f] .circle-item{position:absolute;top:50%;left:50%;display:inline-block;border-radius:50%}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(2),.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(2){-webkit-animation-delay:93ms;animation-delay:93ms}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(3),.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(3){-webkit-animation-delay:.186s;animation-delay:.186s}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(4),.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(4){-webkit-animation-delay:.279s;animation-delay:.279s}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(5),.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(5){-webkit-animation-delay:.372s;animation-delay:.372s}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(6),.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(6){-webkit-animation-delay:.465s;animation-delay:.465s}.loading-bubbles[data-v-6e1fd88f] .bubble-item:nth-child(7),.loading-circles[data-v-6e1fd88f] .circle-item:nth-child(7){-webkit-animation-delay:.558s;animation-delay:.558s}.loading-bubbles[data-v-6e1fd88f] .bubble-item:last-child,.loading-circles[data-v-6e1fd88f] .circle-item:last-child{-webkit-animation-delay:.651s;animation-delay:.651s}',""])},function(e,t,i){"use strict";var n={BUBBLES:{render:function(e){return e("span",{attrs:{class:"loading-bubbles"}},Array.apply(Array,Array(8)).map(function(){return e("span",{attrs:{class:"bubble-item"}})}))}},CIRCLES:{render:function(e){return e("span",{attrs:{class:"loading-circles"}},Array.apply(Array,Array(8)).map(function(){return e("span",{attrs:{class:"circle-item"}})}))}},DEFAULT:{render:function(e){return e("i",{attrs:{class:"loading-default"}})}},SPIRAL:{render:function(e){return e("i",{attrs:{class:"loading-spiral"}})}},WAVEDOTS:{render:function(e){return e("span",{attrs:{class:"loading-wave-dots"}},Array.apply(Array,Array(5)).map(function(){return e("span",{attrs:{class:"wave-item"}})}))}}};t.a={name:"spinner",computed:{spinnerView:function(){return n[(this.spinner||"").toUpperCase()]||n.DEFAULT}},props:{spinner:String}}},function(e,t,i){"use strict";var n=function(){var e=this,t=e.$createElement;return(e._self._c||t)(e.spinnerView,{tag:"component"})},a=[],r={render:n,staticRenderFns:a};t.a=r},function(e,t,i){"use strict";var n=function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("div",{staticClass:"infinite-loading-container"},[i("div",{directives:[{name:"show",rawName:"v-show",value:e.isLoading,expression:"isLoading"}]},[e._t("spinner",[i("spinner",{attrs:{spinner:e.spinner}})])],2),e._v(" "),i("div",{directives:[{name:"show",rawName:"v-show",value:e.isNoResults,expression:"isNoResults"}],staticClass:"infinite-status-prompt"},[e._t("no-results",[e._v("No results :(")])],2),e._v(" "),i("div",{directives:[{name:"show",rawName:"v-show",value:e.isNoMore,expression:"isNoMore"}],staticClass:"infinite-status-prompt"},[e._t("no-more",[e._v("No more data :)")])],2)])},a=[],r={render:n,staticRenderFns:a};t.a=r}])});

/***/ }),
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */,
/* 3022 */,
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */,
/* 3059 */,
/* 3060 */,
/* 3061 */,
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */,
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */,
/* 3252 */,
/* 3253 */,
/* 3254 */,
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */,
/* 3343 */,
/* 3344 */,
/* 3345 */,
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */,
/* 3364 */,
/* 3365 */,
/* 3366 */,
/* 3367 */,
/* 3368 */,
/* 3369 */,
/* 3370 */,
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */,
/* 3375 */,
/* 3376 */,
/* 3377 */,
/* 3378 */,
/* 3379 */,
/* 3380 */,
/* 3381 */,
/* 3382 */,
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */,
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */,
/* 3401 */,
/* 3402 */,
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */,
/* 3411 */,
/* 3412 */,
/* 3413 */,
/* 3414 */,
/* 3415 */,
/* 3416 */,
/* 3417 */,
/* 3418 */,
/* 3419 */,
/* 3420 */,
/* 3421 */,
/* 3422 */,
/* 3423 */,
/* 3424 */,
/* 3425 */,
/* 3426 */,
/* 3427 */,
/* 3428 */,
/* 3429 */,
/* 3430 */,
/* 3431 */,
/* 3432 */,
/* 3433 */,
/* 3434 */,
/* 3435 */,
/* 3436 */,
/* 3437 */,
/* 3438 */,
/* 3439 */,
/* 3440 */,
/* 3441 */,
/* 3442 */,
/* 3443 */,
/* 3444 */,
/* 3445 */,
/* 3446 */,
/* 3447 */,
/* 3448 */,
/* 3449 */,
/* 3450 */,
/* 3451 */,
/* 3452 */,
/* 3453 */,
/* 3454 */,
/* 3455 */,
/* 3456 */,
/* 3457 */,
/* 3458 */,
/* 3459 */,
/* 3460 */,
/* 3461 */,
/* 3462 */,
/* 3463 */,
/* 3464 */,
/* 3465 */,
/* 3466 */,
/* 3467 */,
/* 3468 */,
/* 3469 */,
/* 3470 */,
/* 3471 */,
/* 3472 */,
/* 3473 */,
/* 3474 */,
/* 3475 */,
/* 3476 */,
/* 3477 */,
/* 3478 */,
/* 3479 */,
/* 3480 */,
/* 3481 */,
/* 3482 */,
/* 3483 */,
/* 3484 */,
/* 3485 */,
/* 3486 */,
/* 3487 */,
/* 3488 */,
/* 3489 */,
/* 3490 */,
/* 3491 */,
/* 3492 */,
/* 3493 */,
/* 3494 */,
/* 3495 */,
/* 3496 */,
/* 3497 */,
/* 3498 */,
/* 3499 */,
/* 3500 */,
/* 3501 */,
/* 3502 */,
/* 3503 */,
/* 3504 */,
/* 3505 */,
/* 3506 */,
/* 3507 */,
/* 3508 */,
/* 3509 */,
/* 3510 */,
/* 3511 */,
/* 3512 */,
/* 3513 */,
/* 3514 */,
/* 3515 */,
/* 3516 */,
/* 3517 */,
/* 3518 */,
/* 3519 */,
/* 3520 */,
/* 3521 */,
/* 3522 */,
/* 3523 */,
/* 3524 */,
/* 3525 */,
/* 3526 */,
/* 3527 */,
/* 3528 */,
/* 3529 */,
/* 3530 */,
/* 3531 */,
/* 3532 */,
/* 3533 */,
/* 3534 */,
/* 3535 */,
/* 3536 */,
/* 3537 */,
/* 3538 */,
/* 3539 */,
/* 3540 */,
/* 3541 */,
/* 3542 */,
/* 3543 */,
/* 3544 */,
/* 3545 */,
/* 3546 */,
/* 3547 */,
/* 3548 */,
/* 3549 */,
/* 3550 */,
/* 3551 */,
/* 3552 */,
/* 3553 */,
/* 3554 */,
/* 3555 */,
/* 3556 */,
/* 3557 */,
/* 3558 */,
/* 3559 */,
/* 3560 */,
/* 3561 */,
/* 3562 */,
/* 3563 */,
/* 3564 */,
/* 3565 */,
/* 3566 */,
/* 3567 */,
/* 3568 */,
/* 3569 */,
/* 3570 */,
/* 3571 */,
/* 3572 */,
/* 3573 */,
/* 3574 */,
/* 3575 */,
/* 3576 */,
/* 3577 */,
/* 3578 */,
/* 3579 */,
/* 3580 */,
/* 3581 */,
/* 3582 */,
/* 3583 */,
/* 3584 */,
/* 3585 */,
/* 3586 */,
/* 3587 */,
/* 3588 */,
/* 3589 */,
/* 3590 */,
/* 3591 */,
/* 3592 */,
/* 3593 */,
/* 3594 */,
/* 3595 */,
/* 3596 */,
/* 3597 */,
/* 3598 */,
/* 3599 */,
/* 3600 */,
/* 3601 */,
/* 3602 */,
/* 3603 */,
/* 3604 */,
/* 3605 */,
/* 3606 */,
/* 3607 */,
/* 3608 */,
/* 3609 */,
/* 3610 */,
/* 3611 */,
/* 3612 */,
/* 3613 */,
/* 3614 */,
/* 3615 */,
/* 3616 */,
/* 3617 */,
/* 3618 */,
/* 3619 */,
/* 3620 */,
/* 3621 */,
/* 3622 */,
/* 3623 */,
/* 3624 */,
/* 3625 */,
/* 3626 */,
/* 3627 */,
/* 3628 */,
/* 3629 */,
/* 3630 */,
/* 3631 */,
/* 3632 */,
/* 3633 */,
/* 3634 */,
/* 3635 */,
/* 3636 */,
/* 3637 */,
/* 3638 */,
/* 3639 */,
/* 3640 */,
/* 3641 */,
/* 3642 */,
/* 3643 */,
/* 3644 */,
/* 3645 */,
/* 3646 */,
/* 3647 */,
/* 3648 */,
/* 3649 */,
/* 3650 */,
/* 3651 */,
/* 3652 */,
/* 3653 */,
/* 3654 */,
/* 3655 */,
/* 3656 */,
/* 3657 */,
/* 3658 */,
/* 3659 */,
/* 3660 */,
/* 3661 */,
/* 3662 */,
/* 3663 */,
/* 3664 */,
/* 3665 */,
/* 3666 */,
/* 3667 */,
/* 3668 */,
/* 3669 */,
/* 3670 */,
/* 3671 */,
/* 3672 */,
/* 3673 */,
/* 3674 */,
/* 3675 */,
/* 3676 */,
/* 3677 */,
/* 3678 */,
/* 3679 */,
/* 3680 */,
/* 3681 */,
/* 3682 */,
/* 3683 */,
/* 3684 */,
/* 3685 */,
/* 3686 */,
/* 3687 */,
/* 3688 */,
/* 3689 */,
/* 3690 */,
/* 3691 */,
/* 3692 */,
/* 3693 */,
/* 3694 */,
/* 3695 */,
/* 3696 */,
/* 3697 */,
/* 3698 */,
/* 3699 */,
/* 3700 */,
/* 3701 */,
/* 3702 */,
/* 3703 */,
/* 3704 */,
/* 3705 */,
/* 3706 */,
/* 3707 */,
/* 3708 */,
/* 3709 */,
/* 3710 */,
/* 3711 */,
/* 3712 */,
/* 3713 */,
/* 3714 */,
/* 3715 */,
/* 3716 */,
/* 3717 */,
/* 3718 */,
/* 3719 */,
/* 3720 */,
/* 3721 */,
/* 3722 */,
/* 3723 */,
/* 3724 */,
/* 3725 */,
/* 3726 */,
/* 3727 */,
/* 3728 */,
/* 3729 */,
/* 3730 */,
/* 3731 */,
/* 3732 */,
/* 3733 */,
/* 3734 */,
/* 3735 */,
/* 3736 */,
/* 3737 */,
/* 3738 */,
/* 3739 */,
/* 3740 */,
/* 3741 */,
/* 3742 */,
/* 3743 */,
/* 3744 */,
/* 3745 */,
/* 3746 */,
/* 3747 */,
/* 3748 */,
/* 3749 */,
/* 3750 */,
/* 3751 */,
/* 3752 */,
/* 3753 */,
/* 3754 */,
/* 3755 */,
/* 3756 */,
/* 3757 */,
/* 3758 */,
/* 3759 */,
/* 3760 */,
/* 3761 */,
/* 3762 */,
/* 3763 */,
/* 3764 */,
/* 3765 */,
/* 3766 */,
/* 3767 */,
/* 3768 */,
/* 3769 */,
/* 3770 */,
/* 3771 */,
/* 3772 */,
/* 3773 */,
/* 3774 */,
/* 3775 */,
/* 3776 */,
/* 3777 */,
/* 3778 */,
/* 3779 */,
/* 3780 */,
/* 3781 */,
/* 3782 */,
/* 3783 */,
/* 3784 */,
/* 3785 */,
/* 3786 */,
/* 3787 */,
/* 3788 */,
/* 3789 */,
/* 3790 */,
/* 3791 */,
/* 3792 */,
/* 3793 */,
/* 3794 */,
/* 3795 */,
/* 3796 */,
/* 3797 */,
/* 3798 */,
/* 3799 */,
/* 3800 */,
/* 3801 */,
/* 3802 */,
/* 3803 */,
/* 3804 */,
/* 3805 */,
/* 3806 */,
/* 3807 */,
/* 3808 */,
/* 3809 */,
/* 3810 */,
/* 3811 */,
/* 3812 */,
/* 3813 */,
/* 3814 */,
/* 3815 */,
/* 3816 */,
/* 3817 */,
/* 3818 */,
/* 3819 */,
/* 3820 */,
/* 3821 */,
/* 3822 */,
/* 3823 */,
/* 3824 */,
/* 3825 */,
/* 3826 */,
/* 3827 */,
/* 3828 */,
/* 3829 */,
/* 3830 */,
/* 3831 */,
/* 3832 */,
/* 3833 */,
/* 3834 */,
/* 3835 */,
/* 3836 */,
/* 3837 */,
/* 3838 */,
/* 3839 */,
/* 3840 */,
/* 3841 */,
/* 3842 */,
/* 3843 */,
/* 3844 */,
/* 3845 */,
/* 3846 */,
/* 3847 */,
/* 3848 */,
/* 3849 */,
/* 3850 */,
/* 3851 */,
/* 3852 */,
/* 3853 */,
/* 3854 */,
/* 3855 */,
/* 3856 */,
/* 3857 */,
/* 3858 */,
/* 3859 */,
/* 3860 */,
/* 3861 */,
/* 3862 */,
/* 3863 */,
/* 3864 */,
/* 3865 */,
/* 3866 */,
/* 3867 */,
/* 3868 */,
/* 3869 */,
/* 3870 */,
/* 3871 */,
/* 3872 */,
/* 3873 */,
/* 3874 */,
/* 3875 */,
/* 3876 */,
/* 3877 */,
/* 3878 */,
/* 3879 */,
/* 3880 */,
/* 3881 */,
/* 3882 */,
/* 3883 */,
/* 3884 */,
/* 3885 */,
/* 3886 */,
/* 3887 */,
/* 3888 */,
/* 3889 */,
/* 3890 */,
/* 3891 */,
/* 3892 */,
/* 3893 */,
/* 3894 */,
/* 3895 */,
/* 3896 */,
/* 3897 */,
/* 3898 */,
/* 3899 */,
/* 3900 */,
/* 3901 */,
/* 3902 */,
/* 3903 */,
/* 3904 */,
/* 3905 */,
/* 3906 */,
/* 3907 */,
/* 3908 */,
/* 3909 */,
/* 3910 */,
/* 3911 */,
/* 3912 */,
/* 3913 */,
/* 3914 */,
/* 3915 */,
/* 3916 */,
/* 3917 */,
/* 3918 */,
/* 3919 */,
/* 3920 */,
/* 3921 */,
/* 3922 */,
/* 3923 */,
/* 3924 */,
/* 3925 */,
/* 3926 */,
/* 3927 */,
/* 3928 */,
/* 3929 */,
/* 3930 */,
/* 3931 */,
/* 3932 */,
/* 3933 */,
/* 3934 */,
/* 3935 */,
/* 3936 */,
/* 3937 */,
/* 3938 */,
/* 3939 */,
/* 3940 */,
/* 3941 */,
/* 3942 */,
/* 3943 */,
/* 3944 */,
/* 3945 */,
/* 3946 */,
/* 3947 */,
/* 3948 */,
/* 3949 */,
/* 3950 */,
/* 3951 */,
/* 3952 */,
/* 3953 */,
/* 3954 */,
/* 3955 */,
/* 3956 */,
/* 3957 */,
/* 3958 */,
/* 3959 */,
/* 3960 */,
/* 3961 */,
/* 3962 */,
/* 3963 */,
/* 3964 */,
/* 3965 */,
/* 3966 */,
/* 3967 */,
/* 3968 */,
/* 3969 */,
/* 3970 */,
/* 3971 */,
/* 3972 */,
/* 3973 */,
/* 3974 */,
/* 3975 */,
/* 3976 */,
/* 3977 */,
/* 3978 */,
/* 3979 */,
/* 3980 */,
/* 3981 */,
/* 3982 */,
/* 3983 */,
/* 3984 */,
/* 3985 */,
/* 3986 */,
/* 3987 */,
/* 3988 */,
/* 3989 */,
/* 3990 */,
/* 3991 */,
/* 3992 */,
/* 3993 */,
/* 3994 */,
/* 3995 */,
/* 3996 */,
/* 3997 */,
/* 3998 */,
/* 3999 */,
/* 4000 */,
/* 4001 */,
/* 4002 */,
/* 4003 */,
/* 4004 */,
/* 4005 */,
/* 4006 */,
/* 4007 */,
/* 4008 */,
/* 4009 */,
/* 4010 */,
/* 4011 */,
/* 4012 */,
/* 4013 */,
/* 4014 */,
/* 4015 */,
/* 4016 */,
/* 4017 */,
/* 4018 */,
/* 4019 */,
/* 4020 */,
/* 4021 */,
/* 4022 */,
/* 4023 */,
/* 4024 */
/***/ (function(module, exports) {

	var parallaxjs = function parallaxjs(options) {
	  this.options = options;
	};
	
	parallaxjs.prototype = {
	  items: [],
	  active: true,
	
	  setStyle: function setStyle(item, value) {
	    if (item.modifiers.centerX) value += ' translateX(-50%)';
	
	    var el = item.el;
	    var prop = 'Transform';
	    el.style["webkit" + prop] = value;
	    el.style["moz" + prop] = value;
	    el.style["ms" + prop] = value;
	  },
	  add: function add(el, binding) {
	    var value = binding.value;
	    var arg = binding.arg;
	    var style = el.currentStyle || window.getComputedStyle(el);
	
	    var height = binding.modifiers.absY ? window.innerHeight : el.clientHeight || el.offsetHeight || el.scrollHeight;
	    this.items.push({
	      el: el,
	      initialOffsetTop: el.offsetTop + el.offsetParent.offsetTop - parseInt(style.marginTop),
	      style: style,
	      value: value,
	      arg: arg,
	      modifiers: binding.modifiers,
	      clientHeight: height,
	      count: 0
	    });
	  },
	  move: function move() {
	    var _this = this;
	
	    if (!this.active) return;
	    if (window.innerWidth < this.options.minWidth || 0) {
	      this.items.map(function (item) {
	        _this.setStyle(item, 'translateY(' + 0 + 'px) translateZ(0px)');
	      });
	
	      return;
	    }
	
	    var scrollTop = window.scrollY || window.pageYOffset;
	    var windowHeight = window.innerHeight;
	    var windowWidth = window.innerWidth;
	
	    this.items.map(function (item) {
	      var pos = scrollTop + windowHeight;
	      var elH = item.clientHeight;
	
	      pos = pos - elH / 2;
	      pos = pos - windowHeight / 2;
	      pos = pos * item.value;
	
	      var offset = item.initialOffsetTop;
	      offset = offset * -1;
	      offset = offset * item.value;
	      pos = pos + offset;
	
	      pos = pos.toFixed(2);
	
	      _this.setStyle(item, 'translateY(' + pos + 'px)');
	    });
	  }
	};
	
	var VueParallaxJs = {
	  install: function install(Vue) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var p = new parallaxjs(options);
	
	    window.addEventListener('scroll', function () {
	      requestAnimationFrame(function () {
	        p.move(p);
	      });
	    }, { passive: true });
	    window.addEventListener('resize', function () {
	      requestAnimationFrame(function () {
	        p.move(p);
	      });
	    }, { passive: true });
	
	    Vue.prototype.$parallaxjs = p;
	    window.$parallaxjs = p;
	    Vue.directive('parallax', {
	      bind: function bind(el, binding) {},
	      inserted: function inserted(el, binding) {
	        p.add(el, binding);
	        p.move(p);
	      }
	    });
	  }
	};
	
	module.exports = VueParallaxJs;


/***/ }),
/* 4025 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-resource v1.5.1
	 * https://github.com/pagekit/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	
	function Promise$1(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$1.reject = function (r) {
	    return new Promise$1(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$1.resolve = function (x) {
	    return new Promise$1(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$1.all = function all(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        var count = 0, result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$1.race = function race(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p = Promise$1.prototype;
	
	p.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && typeof x === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$1(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	/**
	 * Promise adapter.
	 */
	
	if (typeof Promise === 'undefined') {
	    window.Promise = Promise$1;
	}
	
	function PromiseObj(executor, context) {
	
	    if (executor instanceof Promise) {
	        this.promise = executor;
	    } else {
	        this.promise = new Promise(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	PromiseObj.all = function (iterable, context) {
	    return new PromiseObj(Promise.all(iterable), context);
	};
	
	PromiseObj.resolve = function (value, context) {
	    return new PromiseObj(Promise.resolve(value), context);
	};
	
	PromiseObj.reject = function (reason, context) {
	    return new PromiseObj(Promise.reject(reason), context);
	};
	
	PromiseObj.race = function (iterable, context) {
	    return new PromiseObj(Promise.race(iterable), context);
	};
	
	var p$1 = PromiseObj.prototype;
	
	p$1.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p$1.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p$1.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.catch(rejected), this.context);
	};
	
	p$1.finally = function (callback) {
	
	    return this.then(function (value) {
	        callback.call(this);
	        return value;
	    }, function (reason) {
	        callback.call(this);
	        return Promise.reject(reason);
	    }
	    );
	};
	
	/**
	 * Utility functions.
	 */
	
	var ref = {};
	var hasOwnProperty = ref.hasOwnProperty;
	var ref$1 = [];
	var slice = ref$1.slice;
	var debug = false, ntick;
	
	var inBrowser = typeof window !== 'undefined';
	
	function Util (ref) {
	    var config = ref.config;
	    var nextTick = ref.nextTick;
	
	    ntick = nextTick;
	    debug = config.debug || !config.silent;
	}
	
	function warn(msg) {
	    if (typeof console !== 'undefined' && debug) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (typeof console !== 'undefined') {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return ntick(cb, ctx);
	}
	
	function trim(str) {
	    return str ? str.replace(/^\s*|\s*$/g, '') : '';
	}
	
	function trimEnd(str, chars) {
	
	    if (str && chars === undefined) {
	        return str.replace(/\s+$/, '');
	    }
	
	    if (!str || !chars) {
	        return str;
	    }
	
	    return str.replace(new RegExp(("[" + chars + "]+$")), '');
	}
	
	function toLower(str) {
	    return str ? str.toLowerCase() : '';
	}
	
	function toUpper(str) {
	    return str ? str.toUpperCase() : '';
	}
	
	var isArray = Array.isArray;
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && typeof obj === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function isBlob(obj) {
	    return typeof Blob !== 'undefined' && obj instanceof Blob;
	}
	
	function isFormData(obj) {
	    return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = PromiseObj.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (isArray(obj)) {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (hasOwnProperty.call(obj, key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	var assign = Object.assign || _assign;
	
	function merge(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source, true);
	    });
	
	    return target;
	}
	
	function defaults(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	
	        for (var key in source) {
	            if (target[key] === undefined) {
	                target[key] = source[key];
	            }
	        }
	
	    });
	
	    return target;
	}
	
	function _assign(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	/**
	 * Root Prefix Transform.
	 */
	
	function root (options$$1, next) {
	
	    var url = next(options$$1);
	
	    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
	        url = trimEnd(options$$1.root, '/') + '/' + url;
	    }
	
	    return url;
	}
	
	/**
	 * Query Parameter Transform.
	 */
	
	function query (options$$1, next) {
	
	    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);
	
	    each(options$$1.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url), expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];
	
	    return {
	        vars: variables,
	        expand: function expand(context) {
	            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null, values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key], result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	/**
	 * URL Template (RFC 6570) Transform.
	 */
	
	function template (options) {
	
	    var variables = [], url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	
	function Url(url, params) {
	
	    var self = this || {}, options$$1 = url, transform;
	
	    if (isString(url)) {
	        options$$1 = {url: url, params: params};
	    }
	
	    options$$1 = merge({}, Url.options, self.$options, options$$1);
	
	    Url.transforms.forEach(function (handler) {
	
	        if (isString(handler)) {
	            handler = Url.transform[handler];
	        }
	
	        if (isFunction(handler)) {
	            transform = factory(handler, transform, self.$vm);
	        }
	
	    });
	
	    return transform(options$$1);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transform = {template: template, query: query, root: root};
	Url.transforms = ['template', 'query', 'root'];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [], escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    var el = document.createElement('a');
	
	    if (document.documentMode) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options$$1) {
	        return handler.call(vm, options$$1, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj), plain = isPlainObject(obj), hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	/**
	 * XDomain client (Internet Explorer).
	 */
	
	function xdrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xdr = new XDomainRequest(), handler = function (ref) {
	                var type = ref.type;
	
	
	                var status = 0;
	
	                if (type === 'load') {
	                    status = 200;
	                } else if (type === 'error') {
	                    status = 500;
	                }
	
	                resolve(request.respondWith(xdr.responseText, {status: status}));
	            };
	
	        request.abort = function () { return xdr.abort(); };
	
	        xdr.open(request.method, request.getUrl());
	
	        if (request.timeout) {
	            xdr.timeout = request.timeout;
	        }
	
	        xdr.onload = handler;
	        xdr.onabort = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = handler;
	        xdr.onprogress = function () {};
	        xdr.send(request.getBody());
	    });
	}
	
	/**
	 * CORS Interceptor.
	 */
	
	var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
	
	function cors (request) {
	
	    if (inBrowser) {
	
	        var orgUrl = Url.parse(location.href);
	        var reqUrl = Url.parse(request.getUrl());
	
	        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
	
	            request.crossOrigin = true;
	            request.emulateHTTP = false;
	
	            if (!SUPPORTS_CORS) {
	                request.client = xdrClient;
	            }
	        }
	    }
	
	}
	
	/**
	 * Form data Interceptor.
	 */
	
	function form (request) {
	
	    if (isFormData(request.body)) {
	        request.headers.delete('Content-Type');
	    } else if (isObject(request.body) && request.emulateJSON) {
	        request.body = Url.params(request.body);
	        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	    }
	
	}
	
	/**
	 * JSON Interceptor.
	 */
	
	function json (request) {
	
	    var type = request.headers.get('Content-Type') || '';
	
	    if (isObject(request.body) && type.indexOf('application/json') === 0) {
	        request.body = JSON.stringify(request.body);
	    }
	
	    return function (response) {
	
	        return response.bodyText ? when(response.text(), function (text) {
	
	            var type = response.headers.get('Content-Type') || '';
	
	            if (type.indexOf('application/json') === 0 || isJson(text)) {
	
	                try {
	                    response.body = JSON.parse(text);
	                } catch (e) {
	                    response.body = null;
	                }
	
	            } else {
	                response.body = text;
	            }
	
	            return response;
	
	        }) : response;
	
	    };
	}
	
	function isJson(str) {
	
	    var start = str.match(/^\s*(\[|\{)/);
	    var end = {'[': /]\s*$/, '{': /}\s*$/};
	
	    return start && end[start[1]].test(str);
	}
	
	/**
	 * JSONP client (Browser).
	 */
	
	function jsonpClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;
	
	        handler = function (ref) {
	            var type = ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load' && body !== null) {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            if (status && window[callback]) {
	                delete window[callback];
	                document.body.removeChild(script);
	            }
	
	            resolve(request.respondWith(body, {status: status}));
	        };
	
	        window[callback] = function (result) {
	            body = JSON.stringify(result);
	        };
	
	        request.abort = function () {
	            handler({type: 'abort'});
	        };
	
	        request.params[name] = callback;
	
	        if (request.timeout) {
	            setTimeout(request.abort, request.timeout);
	        }
	
	        script = document.createElement('script');
	        script.src = request.getUrl();
	        script.type = 'text/javascript';
	        script.async = true;
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	}
	
	/**
	 * JSONP Interceptor.
	 */
	
	function jsonp (request) {
	
	    if (request.method == 'JSONP') {
	        request.client = jsonpClient;
	    }
	
	}
	
	/**
	 * Before Interceptor.
	 */
	
	function before (request) {
	
	    if (isFunction(request.before)) {
	        request.before.call(this, request);
	    }
	
	}
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	function method (request) {
	
	    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	        request.headers.set('X-HTTP-Method-Override', request.method);
	        request.method = 'POST';
	    }
	
	}
	
	/**
	 * Header Interceptor.
	 */
	
	function header (request) {
	
	    var headers = assign({}, Http.headers.common,
	        !request.crossOrigin ? Http.headers.custom : {},
	        Http.headers[toLower(request.method)]
	    );
	
	    each(headers, function (value, name) {
	        if (!request.headers.has(name)) {
	            request.headers.set(name, value);
	        }
	    });
	
	}
	
	/**
	 * XMLHttp client (Browser).
	 */
	
	function xhrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xhr = new XMLHttpRequest(), handler = function (event) {
	
	                var response = request.respondWith(
	                'response' in xhr ? xhr.response : xhr.responseText, {
	                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
	                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
	                });
	
	                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
	                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
	                });
	
	                resolve(response);
	            };
	
	        request.abort = function () { return xhr.abort(); };
	
	        xhr.open(request.method, request.getUrl(), true);
	
	        if (request.timeout) {
	            xhr.timeout = request.timeout;
	        }
	
	        if (request.responseType && 'responseType' in xhr) {
	            xhr.responseType = request.responseType;
	        }
	
	        if (request.withCredentials || request.credentials) {
	            xhr.withCredentials = true;
	        }
	
	        if (!request.crossOrigin) {
	            request.headers.set('X-Requested-With', 'XMLHttpRequest');
	        }
	
	        // deprecated use downloadProgress
	        if (isFunction(request.progress) && request.method === 'GET') {
	            xhr.addEventListener('progress', request.progress);
	        }
	
	        if (isFunction(request.downloadProgress)) {
	            xhr.addEventListener('progress', request.downloadProgress);
	        }
	
	        // deprecated use uploadProgress
	        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
	            xhr.upload.addEventListener('progress', request.progress);
	        }
	
	        if (isFunction(request.uploadProgress) && xhr.upload) {
	            xhr.upload.addEventListener('progress', request.uploadProgress);
	        }
	
	        request.headers.forEach(function (value, name) {
	            xhr.setRequestHeader(name, value);
	        });
	
	        xhr.onload = handler;
	        xhr.onabort = handler;
	        xhr.onerror = handler;
	        xhr.ontimeout = handler;
	        xhr.send(request.getBody());
	    });
	}
	
	/**
	 * Http client (Node).
	 */
	
	function nodeClient (request) {
	
	    var client = __webpack_require__(4039);
	
	    return new PromiseObj(function (resolve) {
	
	        var url = request.getUrl();
	        var body = request.getBody();
	        var method = request.method;
	        var headers = {}, handler;
	
	        request.headers.forEach(function (value, name) {
	            headers[name] = value;
	        });
	
	        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {
	
	            var response = request.respondWith(resp.body, {
	                status: resp.statusCode,
	                statusText: trim(resp.statusMessage)
	            });
	
	            each(resp.headers, function (value, name) {
	                response.headers.set(name, value);
	            });
	
	            resolve(response);
	
	        }, function (error$$1) { return handler(error$$1.response); });
	    });
	}
	
	/**
	 * Base client.
	 */
	
	function Client (context) {
	
	    var reqHandlers = [sendRequest], resHandlers = [];
	
	    if (!isObject(context)) {
	        context = null;
	    }
	
	    function Client(request) {
	        while (reqHandlers.length) {
	
	            var handler = reqHandlers.pop();
	
	            if (isFunction(handler)) {
	
	                var response = (void 0), next = (void 0);
	
	                response = handler.call(context, request, function (val) { return next = val; }) || next;
	
	                if (isObject(response)) {
	                    return new PromiseObj(function (resolve, reject) {
	
	                        resHandlers.forEach(function (handler) {
	                            response = when(response, function (response) {
	                                return handler.call(context, response) || response;
	                            }, reject);
	                        });
	
	                        when(response, resolve, reject);
	
	                    }, context);
	                }
	
	                if (isFunction(response)) {
	                    resHandlers.unshift(response);
	                }
	
	            } else {
	                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
	            }
	        }
	    }
	
	    Client.use = function (handler) {
	        reqHandlers.push(handler);
	    };
	
	    return Client;
	}
	
	function sendRequest(request) {
	
	    var client = request.client || (inBrowser ? xhrClient : nodeClient);
	
	    return client(request);
	}
	
	/**
	 * HTTP Headers.
	 */
	
	var Headers = function Headers(headers) {
	    var this$1 = this;
	
	
	    this.map = {};
	
	    each(headers, function (value, name) { return this$1.append(name, value); });
	};
	
	Headers.prototype.has = function has (name) {
	    return getName(this.map, name) !== null;
	};
	
	Headers.prototype.get = function get (name) {
	
	    var list = this.map[getName(this.map, name)];
	
	    return list ? list.join() : null;
	};
	
	Headers.prototype.getAll = function getAll (name) {
	    return this.map[getName(this.map, name)] || [];
	};
	
	Headers.prototype.set = function set (name, value) {
	    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
	};
	
	Headers.prototype.append = function append (name, value) {
	
	    var list = this.map[getName(this.map, name)];
	
	    if (list) {
	        list.push(trim(value));
	    } else {
	        this.set(name, value);
	    }
	};
	
	Headers.prototype.delete = function delete$1 (name) {
	    delete this.map[getName(this.map, name)];
	};
	
	Headers.prototype.deleteAll = function deleteAll () {
	    this.map = {};
	};
	
	Headers.prototype.forEach = function forEach (callback, thisArg) {
	        var this$1 = this;
	
	    each(this.map, function (list, name) {
	        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
	    });
	};
	
	function getName(map, name) {
	    return Object.keys(map).reduce(function (prev, curr) {
	        return toLower(name) === toLower(curr) ? curr : prev;
	    }, null);
	}
	
	function normalizeName(name) {
	
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	        throw new TypeError('Invalid character in header field name');
	    }
	
	    return trim(name);
	}
	
	/**
	 * HTTP Response.
	 */
	
	var Response = function Response(body, ref) {
	    var url = ref.url;
	    var headers = ref.headers;
	    var status = ref.status;
	    var statusText = ref.statusText;
	
	
	    this.url = url;
	    this.ok = status >= 200 && status < 300;
	    this.status = status || 0;
	    this.statusText = statusText || '';
	    this.headers = new Headers(headers);
	    this.body = body;
	
	    if (isString(body)) {
	
	        this.bodyText = body;
	
	    } else if (isBlob(body)) {
	
	        this.bodyBlob = body;
	
	        if (isBlobText(body)) {
	            this.bodyText = blobText(body);
	        }
	    }
	};
	
	Response.prototype.blob = function blob () {
	    return when(this.bodyBlob);
	};
	
	Response.prototype.text = function text () {
	    return when(this.bodyText);
	};
	
	Response.prototype.json = function json () {
	    return when(this.text(), function (text) { return JSON.parse(text); });
	};
	
	Object.defineProperty(Response.prototype, 'data', {
	
	    get: function get() {
	        return this.body;
	    },
	
	    set: function set(body) {
	        this.body = body;
	    }
	
	});
	
	function blobText(body) {
	    return new PromiseObj(function (resolve) {
	
	        var reader = new FileReader();
	
	        reader.readAsText(body);
	        reader.onload = function () {
	            resolve(reader.result);
	        };
	
	    });
	}
	
	function isBlobText(body) {
	    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
	}
	
	/**
	 * HTTP Request.
	 */
	
	var Request = function Request(options$$1) {
	
	    this.body = null;
	    this.params = {};
	
	    assign(this, options$$1, {
	        method: toUpper(options$$1.method || 'GET')
	    });
	
	    if (!(this.headers instanceof Headers)) {
	        this.headers = new Headers(this.headers);
	    }
	};
	
	Request.prototype.getUrl = function getUrl () {
	    return Url(this);
	};
	
	Request.prototype.getBody = function getBody () {
	    return this.body;
	};
	
	Request.prototype.respondWith = function respondWith (body, options$$1) {
	    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
	};
	
	/**
	 * Service for sending network requests.
	 */
	
	var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
	var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};
	
	function Http(options$$1) {
	
	    var self = this || {}, client = Client(self.$vm);
	
	    defaults(options$$1 || {}, self.$options, Http.options);
	
	    Http.interceptors.forEach(function (handler) {
	
	        if (isString(handler)) {
	            handler = Http.interceptor[handler];
	        }
	
	        if (isFunction(handler)) {
	            client.use(handler);
	        }
	
	    });
	
	    return client(new Request(options$$1)).then(function (response) {
	
	        return response.ok ? response : PromiseObj.reject(response);
	
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return PromiseObj.reject(response);
	    });
	}
	
	Http.options = {};
	
	Http.headers = {
	    put: JSON_CONTENT_TYPE,
	    post: JSON_CONTENT_TYPE,
	    patch: JSON_CONTENT_TYPE,
	    delete: JSON_CONTENT_TYPE,
	    common: COMMON_HEADERS,
	    custom: {}
	};
	
	Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
	Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
	
	['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
	
	    Http[method$$1] = function (url, options$$1) {
	        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
	    };
	
	});
	
	['post', 'put', 'patch'].forEach(function (method$$1) {
	
	    Http[method$$1] = function (url, body, options$$1) {
	        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
	    };
	
	});
	
	/**
	 * Service for interacting with RESTful services.
	 */
	
	function Resource(url, params, actions, options$$1) {
	
	    var self = this || {}, resource = {};
	
	    actions = assign({},
	        Resource.actions,
	        actions
	    );
	
	    each(actions, function (action, name) {
	
	        action = merge({url: url, params: assign({}, params)}, options$$1, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options$$1 = assign({}, action), params = {}, body;
	
	    switch (args.length) {
	
	        case 2:
	
	            params = args[0];
	            body = args[1];
	
	            break;
	
	        case 1:
	
	            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
	                body = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
	    }
	
	    options$$1.body = body;
	    options$$1.params = assign({}, options$$1.params, params);
	
	    return options$$1;
	}
	
	Resource.actions = {
	
	    get: {method: 'GET'},
	    save: {method: 'POST'},
	    query: {method: 'GET'},
	    update: {method: 'PUT'},
	    remove: {method: 'DELETE'},
	    delete: {method: 'DELETE'}
	
	};
	
	/**
	 * Install plugin.
	 */
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = PromiseObj;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function get() {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function get() {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function get() {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function get() {
	                var this$1 = this;
	
	                return function (executor) { return new Vue.Promise(executor, this$1); };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;


/***/ }),
/* 4026 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(__webpack_require__(2889)) :
	  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
	  (factory(global.Hammer));
	}(this, (function (Hammer) { 'use strict';
	
	Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;
	
	function assign(target) {
	  var sources = [], len = arguments.length - 1;
	  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
	  for (var i = 0; i < sources.length; i++) {
	    var source = sources[i];
	    var keys = Object.keys(source);
	    for (var i$1 = 0; i$1 < keys.length; i$1++) {
	      var key = keys[i$1];
	      target[key] = source[key];
	    }
	  }
	  return target
	}
	function createProp() {
	  return {
	    type: Object,
	    default: function() { return {} }
	  }
	}
	function capitalize (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	}
	var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
	function guardDirections (options) {
	  var dir = options.direction;
	  if (typeof dir === 'string') {
	    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
	    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
	      options.direction = Hammer[hammerDirection];
	    } else {
	      console.warn('[vue-touch] invalid direction: ' + dir);
	    }
	  }
	  return options
	}
	var config = {
	};
	var customEvents = {
	};
	var gestures = [
	  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
	  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
	  'press','pressup',
	  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
	  'swipe','swipeleft','swiperight','swipeup','swipedown',
	  'tap'
	];
	var gestureMap = {
	  pan: 'pan',
	  panstart: 'pan',
	  panmove: 'pan',
	  panend: 'pan',
	  pancancel: 'pan',
	  panleft: 'pan',
	  panright: 'pan',
	  panup: 'pan',
	  pandown: 'pan',
	  pinch: 'pinch',
	  pinchstart: 'pinch',
	  pinchmove: 'pinch',
	  pinchend: 'pinch',
	  pinchcancel: 'pinch',
	  pinchin: 'pinch',
	  pinchout: 'pinch',
	  press: 'press',
	  pressup: 'press',
	  rotate: 'rotate',
	  rotatestart: 'rotate',
	  rotatemove: 'rotate',
	  rotateend: 'rotate',
	  rotatecancel: 'rotate',
	  swipe: 'swipe',
	  swipeleft: 'swipe',
	  swiperight: 'swipe',
	  swipeup: 'swipe',
	  swipedown: 'swipe',
	  tap: 'tap'
	};
	
	var Component = {
	  props: {
	    options: createProp(),
	    tapOptions: createProp(),
	    panOptions: createProp(),
	    pinchOptions: createProp(),
	    pressOptions: createProp(),
	    rotateOptions: createProp(),
	    swipeOptions: createProp(),
	    tag: { type: String, default: 'div' },
	    enabled: {
	      default: true,
	      type: [Boolean, Object],
	    }
	  },
	  mounted: function mounted() {
	    if (!this.$isServer) {
	      this.hammer = new Hammer.Manager(this.$el, this.options);
	      this.recognizers = {};
	      this.setupBuiltinRecognizers();
	      this.setupCustomRecognizers();
	      this.updateEnabled(this.enabled);
	    }
	  },
	  destroyed: function destroyed() {
	    if (!this.$isServer) {
	      this.hammer.destroy();
	    }
	  },
	  watch: {
	    enabled: {
	      deep: true,
	      handler: function handler() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	        (ref = this).updateEnabled.apply(ref, args);
	        var ref;
	      }
	    }
	  },
	  methods: {
	    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
	      var this$1 = this;
	      for (var i = 0; i < gestures.length; i++) {
	        var gesture = gestures[i];
	        if (this$1._events[gesture]) {
	          var mainGesture = gestureMap[gesture];
	          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
	          this$1.addRecognizer(mainGesture, options);
	          this$1.addEvent(gesture);
	        }
	      }
	    },
	    setupCustomRecognizers: function setupCustomRecognizers() {
	      var this$1 = this;
	      var gestures$$1 = Object.keys(customEvents);
	      for (var i = 0; i < gestures$$1.length; i++) {
	        var gesture = gestures$$1[i];
	        if (this$1._events[gesture]) {
	          var opts = customEvents[gesture];
	          var localCustomOpts = this$1[(gesture + "Options")] || {};
	          var options = assign({}, opts, localCustomOpts);
	          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
	          this$1.addEvent(gesture);
	        }
	      }
	    },
	    addRecognizer: function addRecognizer(gesture, options, ref) {
	      if ( ref === void 0 ) ref = {};
	      var mainGesture = ref.mainGesture;
	      if (!this.recognizers[gesture]) {
	        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
	        this.recognizers[gesture] = recognizer;
	        this.hammer.add(recognizer);
	        recognizer.recognizeWith(this.hammer.recognizers);
	      }
	    },
	    addEvent: function addEvent(gesture) {
	      var this$1 = this;
	      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
	    },
	    updateEnabled: function updateEnabled(newVal, oldVal) {
	      var this$1 = this;
	      if (newVal === true) {
	        this.enableAll();
	      } else if (newVal === false) {
	        this.disableAll();
	      } else if (typeof newVal === 'object') {
	        var keys = Object.keys(newVal);
	        for (var i = 0; i < keys.length; i++) {
	          var event = keys[i];
	          if (this$1.recognizers[event]) {
	            newVal[event]
	              ? this$1.enable(event)
	              : this$1.disable(event);
	          }
	        }
	      }
	    },
	    enable: function enable(r) {
	      var recognizer = this.recognizers[r];
	      if (!recognizer.options.enable) {
	        recognizer.set({ enable: true });
	      }
	    },
	    disable: function disable(r) {
	      var recognizer = this.recognizers[r];
	      if (recognizer.options.enable) {
	        recognizer.set({ enable: false });
	      }
	    },
	    toggle: function toggle(r) {
	      var recognizer = this.recognizers[r];
	      if (recognizer) {
	        recognizer.options.enable
	          ? this.disable(r)
	          : this.enable(r);
	      }
	    },
	    enableAll: function enableAll(r) {
	      this.toggleAll({ enable: true });
	    },
	    disableAll: function disableAll(r) {
	      this.toggleAll({ enable: false });
	    },
	    toggleAll: function toggleAll(ref) {
	      var this$1 = this;
	      var enable = ref.enable;
	      var keys = Object.keys(this.recognizers);
	      for (var i = 0; i < keys.length; i++) {
	        var r = this$1.recognizers[keys[i]];
	        if (r.options.enable !== enable) {
	          r.set({ enable: enable });
	        }
	      }
	    },
	    isEnabled: function isEnabled(r) {
	      return this.recognizers[r] && this.recognizers[r].options.enable
	    }
	  },
	  render: function render(h) {
	    return h(this.tag, {}, this.$slots.default)
	  }
	};
	
	var installed = false;
	var vueTouch = { config: config, customEvents: customEvents };
	vueTouch.install = function install(Vue, opts) {
	  if ( opts === void 0 ) opts = {};
	  var name = opts.name || 'v-touch';
	  Vue.component(name, assign(Component, { name: name }));
	  installed = true;
	}.bind(vueTouch);
	vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
	  if ( options === void 0 ) options = {};
	  if (installed) {
	    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
	    return
	  }
	  options.event = event;
	  customEvents[event] = options;
	  Component.props[(event + "Options")] = {
	    type: Object,
	    default: function default$1() { return {} }
	  };
	}.bind(vueTouch);
	vueTouch.component = Component;
	if (true) {
	  module.exports = vueTouch;
	} else if (typeof define == "function" && define.amd) {
	  define([], function(){ return vueTouch });
	} else if (typeof window !== 'undefined' && window.Vue) {
	  window.VueTouch = vueTouch;
	  Vue.use(vueTouch);
	}
	
	})));
	//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 4027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	(function () {
	  "use strict";
	
	  if (!Array.from) {
	    Array.from = function (object) {
	      return [].slice.call(object);
	    };
	  }
	
	  function buildAttribute(object, propName, value) {
	    if (value == undefined) {
	      return object;
	    }
	    object = object == null ? {} : object;
	    object[propName] = value;
	    return object;
	  }
	
	  function buildDraggable(Sortable) {
	    function removeNode(node) {
	      node.parentElement.removeChild(node);
	    }
	
	    function insertNodeAt(fatherNode, node, position) {
	      var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
	      fatherNode.insertBefore(node, refNode);
	    }
	
	    function computeVmIndex(vnodes, element) {
	      return vnodes.map(function (elt) {
	        return elt.elm;
	      }).indexOf(element);
	    }
	
	    function _computeIndexes(slots, children, isTransition) {
	      if (!slots) {
	        return [];
	      }
	
	      var elmFromNodes = slots.map(function (elt) {
	        return elt.elm;
	      });
	      var rawIndexes = [].concat(_toConsumableArray(children)).map(function (elt) {
	        return elmFromNodes.indexOf(elt);
	      });
	      return isTransition ? rawIndexes.filter(function (ind) {
	        return ind !== -1;
	      }) : rawIndexes;
	    }
	
	    function emit(evtName, evtData) {
	      var _this = this;
	
	      this.$nextTick(function () {
	        return _this.$emit(evtName.toLowerCase(), evtData);
	      });
	    }
	
	    function delegateAndEmit(evtName) {
	      var _this2 = this;
	
	      return function (evtData) {
	        if (_this2.realList !== null) {
	          _this2['onDrag' + evtName](evtData);
	        }
	        emit.call(_this2, evtName, evtData);
	      };
	    }
	
	    var eventsListened = ['Start', 'Add', 'Remove', 'Update', 'End'];
	    var eventsToEmit = ['Choose', 'Sort', 'Filter', 'Clone'];
	    var readonlyProperties = ['Move'].concat(eventsListened, eventsToEmit).map(function (evt) {
	      return 'on' + evt;
	    });
	    var draggingElement = null;
	
	    var props = {
	      options: Object,
	      list: {
	        type: Array,
	        required: false,
	        default: null
	      },
	      value: {
	        type: Array,
	        required: false,
	        default: null
	      },
	      noTransitionOnDrag: {
	        type: Boolean,
	        default: false
	      },
	      clone: {
	        type: Function,
	        default: function _default(original) {
	          return original;
	        }
	      },
	      element: {
	        type: String,
	        default: 'div'
	      },
	      move: {
	        type: Function,
	        default: null
	      },
	      componentData: {
	        type: Object,
	        required: false,
	        default: null
	      }
	    };
	
	    var draggableComponent = {
	      name: 'draggable',
	
	      props: props,
	
	      data: function data() {
	        return {
	          transitionMode: false,
	          noneFunctionalComponentMode: false,
	          init: false
	        };
	      },
	      render: function render(h) {
	        var slots = this.$slots.default;
	        if (slots && slots.length === 1) {
	          var child = slots[0];
	          if (child.componentOptions && child.componentOptions.tag === "transition-group") {
	            this.transitionMode = true;
	          }
	        }
	        var children = slots;
	        var footer = this.$slots.footer;
	
	        if (footer) {
	          children = slots ? [].concat(_toConsumableArray(slots), _toConsumableArray(footer)) : [].concat(_toConsumableArray(footer));
	        }
	        var attributes = null;
	        var update = function update(name, value) {
	          attributes = buildAttribute(attributes, name, value);
	        };
	        update('attrs', this.$attrs);
	        if (this.componentData) {
	          var _componentData = this.componentData,
	              on = _componentData.on,
	              _props = _componentData.props;
	
	          update('on', on);
	          update('props', _props);
	        }
	        return h(this.element, attributes, children);
	      },
	      mounted: function mounted() {
	        var _this3 = this;
	
	        this.noneFunctionalComponentMode = this.element.toLowerCase() !== this.$el.nodeName.toLowerCase();
	        if (this.noneFunctionalComponentMode && this.transitionMode) {
	          throw new Error('Transition-group inside component is not supported. Please alter element value or remove transition-group. Current element value: ' + this.element);
	        }
	        var optionsAdded = {};
	        eventsListened.forEach(function (elt) {
	          optionsAdded['on' + elt] = delegateAndEmit.call(_this3, elt);
	        });
	
	        eventsToEmit.forEach(function (elt) {
	          optionsAdded['on' + elt] = emit.bind(_this3, elt);
	        });
	
	        var options = _extends({}, this.options, optionsAdded, { onMove: function onMove(evt, originalEvent) {
	            return _this3.onDragMove(evt, originalEvent);
	          } });
	        !('draggable' in options) && (options.draggable = '>*');
	        this._sortable = new Sortable(this.rootContainer, options);
	        this.computeIndexes();
	      },
	      beforeDestroy: function beforeDestroy() {
	        this._sortable.destroy();
	      },
	
	
	      computed: {
	        rootContainer: function rootContainer() {
	          return this.transitionMode ? this.$el.children[0] : this.$el;
	        },
	        isCloning: function isCloning() {
	          return !!this.options && !!this.options.group && this.options.group.pull === 'clone';
	        },
	        realList: function realList() {
	          return !!this.list ? this.list : this.value;
	        }
	      },
	
	      watch: {
	        options: {
	          handler: function handler(newOptionValue) {
	            for (var property in newOptionValue) {
	              if (readonlyProperties.indexOf(property) == -1) {
	                this._sortable.option(property, newOptionValue[property]);
	              }
	            }
	          },
	
	          deep: true
	        },
	
	        realList: function realList() {
	          this.computeIndexes();
	        }
	      },
	
	      methods: {
	        getChildrenNodes: function getChildrenNodes() {
	          if (!this.init) {
	            this.noneFunctionalComponentMode = this.noneFunctionalComponentMode && this.$children.length == 1;
	            this.init = true;
	          }
	
	          if (this.noneFunctionalComponentMode) {
	            return this.$children[0].$slots.default;
	          }
	          var rawNodes = this.$slots.default;
	          return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
	        },
	        computeIndexes: function computeIndexes() {
	          var _this4 = this;
	
	          this.$nextTick(function () {
	            _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode);
	          });
	        },
	        getUnderlyingVm: function getUnderlyingVm(htmlElt) {
	          var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
	          if (index === -1) {
	            //Edge case during move callback: related element might be
	            //an element different from collection
	            return null;
	          }
	          var element = this.realList[index];
	          return { index: index, element: element };
	        },
	        getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
	          var __vue__ = _ref.__vue__;
	
	          if (!__vue__ || !__vue__.$options || __vue__.$options._componentTag !== "transition-group") {
	            return __vue__;
	          }
	          return __vue__.$parent;
	        },
	        emitChanges: function emitChanges(evt) {
	          var _this5 = this;
	
	          this.$nextTick(function () {
	            _this5.$emit('change', evt);
	          });
	        },
	        alterList: function alterList(onList) {
	          if (!!this.list) {
	            onList(this.list);
	          } else {
	            var newList = [].concat(_toConsumableArray(this.value));
	            onList(newList);
	            this.$emit('input', newList);
	          }
	        },
	        spliceList: function spliceList() {
	          var _arguments = arguments;
	
	          var spliceList = function spliceList(list) {
	            return list.splice.apply(list, _arguments);
	          };
	          this.alterList(spliceList);
	        },
	        updatePosition: function updatePosition(oldIndex, newIndex) {
	          var updatePosition = function updatePosition(list) {
	            return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
	          };
	          this.alterList(updatePosition);
	        },
	        getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
	          var to = _ref2.to,
	              related = _ref2.related;
	
	          var component = this.getUnderlyingPotencialDraggableComponent(to);
	          if (!component) {
	            return { component: component };
	          }
	          var list = component.realList;
	          var context = { list: list, component: component };
	          if (to !== related && list && component.getUnderlyingVm) {
	            var destination = component.getUnderlyingVm(related);
	            if (destination) {
	              return _extends(destination, context);
	            }
	          }
	
	          return context;
	        },
	        getVmIndex: function getVmIndex(domIndex) {
	          var indexes = this.visibleIndexes;
	          var numberIndexes = indexes.length;
	          return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
	        },
	        getComponent: function getComponent() {
	          return this.$slots.default[0].componentInstance;
	        },
	        resetTransitionData: function resetTransitionData(index) {
	          if (!this.noTransitionOnDrag || !this.transitionMode) {
	            return;
	          }
	          var nodes = this.getChildrenNodes();
	          nodes[index].data = null;
	          var transitionContainer = this.getComponent();
	          transitionContainer.children = [];
	          transitionContainer.kept = undefined;
	        },
	        onDragStart: function onDragStart(evt) {
	          this.context = this.getUnderlyingVm(evt.item);
	          evt.item._underlying_vm_ = this.clone(this.context.element);
	          draggingElement = evt.item;
	        },
	        onDragAdd: function onDragAdd(evt) {
	          var element = evt.item._underlying_vm_;
	          if (element === undefined) {
	            return;
	          }
	          removeNode(evt.item);
	          var newIndex = this.getVmIndex(evt.newIndex);
	          this.spliceList(newIndex, 0, element);
	          this.computeIndexes();
	          var added = { element: element, newIndex: newIndex };
	          this.emitChanges({ added: added });
	        },
	        onDragRemove: function onDragRemove(evt) {
	          insertNodeAt(this.rootContainer, evt.item, evt.oldIndex);
	          if (this.isCloning) {
	            removeNode(evt.clone);
	            return;
	          }
	          var oldIndex = this.context.index;
	          this.spliceList(oldIndex, 1);
	          var removed = { element: this.context.element, oldIndex: oldIndex };
	          this.resetTransitionData(oldIndex);
	          this.emitChanges({ removed: removed });
	        },
	        onDragUpdate: function onDragUpdate(evt) {
	          removeNode(evt.item);
	          insertNodeAt(evt.from, evt.item, evt.oldIndex);
	          var oldIndex = this.context.index;
	          var newIndex = this.getVmIndex(evt.newIndex);
	          this.updatePosition(oldIndex, newIndex);
	          var moved = { element: this.context.element, oldIndex: oldIndex, newIndex: newIndex };
	          this.emitChanges({ moved: moved });
	        },
	        computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
	          if (!relatedContext.element) {
	            return 0;
	          }
	          var domChildren = [].concat(_toConsumableArray(evt.to.children)).filter(function (el) {
	            return el.style['display'] !== 'none';
	          });
	          var currentDOMIndex = domChildren.indexOf(evt.related);
	          var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
	          var draggedInList = domChildren.indexOf(draggingElement) != -1;
	          return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
	        },
	        onDragMove: function onDragMove(evt, originalEvent) {
	          var onMove = this.move;
	          if (!onMove || !this.realList) {
	            return true;
	          }
	
	          var relatedContext = this.getRelatedContextFromMoveEvent(evt);
	          var draggedContext = this.context;
	          var futureIndex = this.computeFutureIndex(relatedContext, evt);
	          _extends(draggedContext, { futureIndex: futureIndex });
	          _extends(evt, { relatedContext: relatedContext, draggedContext: draggedContext });
	          return onMove(evt, originalEvent);
	        },
	        onDragEnd: function onDragEnd(evt) {
	          this.computeIndexes();
	          draggingElement = null;
	        }
	      }
	    };
	    return draggableComponent;
	  }
	
	  if (true) {
	    var Sortable = __webpack_require__(2929);
	    module.exports = buildDraggable(Sortable);
	  } else if (typeof define == "function" && define.amd) {
	    define(['sortablejs'], function (Sortable) {
	      return buildDraggable(Sortable);
	    });
	  } else if (window && window.Vue && window.Sortable) {
	    var draggable = buildDraggable(window.Sortable);
	    Vue.component('draggable', draggable);
	  }
	})();

/***/ }),
/* 4028 */
/***/ (function(module, exports) {

	exports.sync = function (store, router, options) {
	  var moduleName = (options || {}).moduleName || 'route'
	
	  store.registerModule(moduleName, {
	    namespaced: true,
	    state: cloneRoute(router.currentRoute),
	    mutations: {
	      'ROUTE_CHANGED': function ROUTE_CHANGED (state, transition) {
	        store.state[moduleName] = cloneRoute(transition.to, transition.from)
	      }
	    }
	  })
	
	  var isTimeTraveling = false
	  var currentPath
	
	  // sync router on store change
	  var storeUnwatch = store.watch(
	    function (state) { return state[moduleName]; },
	    function (route) {
	      var fullPath = route.fullPath;
	      if (fullPath === currentPath) {
	        return
	      }
	      if (currentPath != null) {
	        isTimeTraveling = true
	        router.push(route)
	      }
	      currentPath = fullPath
	    },
	    { sync: true }
	  )
	
	  // sync store on router navigation
	  var afterEachUnHook = router.afterEach(function (to, from) {
	    if (isTimeTraveling) {
	      isTimeTraveling = false
	      return
	    }
	    currentPath = to.fullPath
	    store.commit(moduleName + '/ROUTE_CHANGED', { to: to, from: from })
	  })
	
	  return function unsync () {
	    // On unsync, remove router hook
	    if (afterEachUnHook != null) {
	      afterEachUnHook()
	    }
	
	    // On unsync, remove store watch
	    if (storeUnwatch != null) {
	      storeUnwatch()
	    }
	
	    // On unsync, unregister Module with store
	    store.unregisterModule(moduleName)
	  }
	}
	
	function cloneRoute (to, from) {
	  var clone = {
	    name: to.name,
	    path: to.path,
	    hash: to.hash,
	    query: to.query,
	    params: to.params,
	    fullPath: to.fullPath,
	    meta: to.meta
	  }
	  if (from) {
	    clone.from = cloneRoute(from)
	  }
	  return Object.freeze(clone)
	}
	


/***/ }),
/* 4029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var isArray = Array.isArray;
	var isPlainObject = __webpack_require__(439);
	var merge = __webpack_require__(2907);
	var find = __webpack_require__(2905);
	var isEqual = __webpack_require__(2906);
	
	var loaderNameRe = /^([^\?]+)/ig;
	
	function mergeLoaders(currentLoaders, newLoaders) {
	  return newLoaders.reduce(function (mergedLoaders, loader) {
	    if (mergedLoaders.every(function (l) {
	      return loader.match(loaderNameRe)[0] !== l.match(loaderNameRe)[0];
	    })) {
	      return mergedLoaders.concat([loader]);
	    }
	    return mergedLoaders;
	  }, currentLoaders);
	}
	
	/**
	 * Check equality of two values using lodash's isEqual
	 * Arrays need to be sorted for equality checking
	 * but clone them first so as not to disrupt the sort order in tests
	 */
	function isSameValue(a, b) {
	  var _map = [a, b].map(function (value) {
	    return isArray(value) ? value.slice().sort() : value;
	  });
	
	  var _map2 = _slicedToArray(_map, 2);
	
	  var propA = _map2[0];
	  var propB = _map2[1];
	
	
	  return isEqual(propA, propB);
	}
	
	function reduceLoaders(mergedLoaderConfigs, loaderConfig) {
	  var foundLoader = find(mergedLoaderConfigs, function (l) {
	    return String(l.test) === String(loaderConfig.test);
	  });
	
	  if (foundLoader) {
	    /**
	     * When both loaders have different `include` or `exclude`
	     * properties, concat them
	     */
	    if (foundLoader.include && !isSameValue(foundLoader.include, loaderConfig.include) || foundLoader.exclude && !isSameValue(foundLoader.exclude, loaderConfig.exclude)) {
	      return mergedLoaderConfigs.concat([loaderConfig]);
	    }
	
	    // foundLoader.loader is intentionally ignored, because a string loader value should always override
	    if (foundLoader.loaders) {
	      var newLoaders = loaderConfig.loader ? [loaderConfig.loader] : loaderConfig.loaders || [];
	
	      foundLoader.loaders = mergeLoaders(foundLoader.loaders, newLoaders);
	    }
	
	    if (loaderConfig.include) {
	      foundLoader.include = loaderConfig.include;
	    }
	
	    if (loaderConfig.exclude) {
	      foundLoader.exclude = loaderConfig.exclude;
	    }
	
	    return mergedLoaderConfigs;
	  }
	
	  return mergedLoaderConfigs.concat([loaderConfig]);
	}
	
	function joinArrays(customizer, a, b, key) {
	  if (isArray(a) && isArray(b)) {
	    var customResult = customizer(a, b, key);
	
	    if (!b.length) {
	      return [];
	    }
	
	    if (customResult) {
	      return customResult;
	    }
	
	    if (isLoader(key)) {
	      return b.concat(a);
	    }
	
	    return a.concat(b);
	  }
	
	  if (isPlainObject(a) && isPlainObject(b)) {
	    if (!Object.keys(b).length) {
	      return {};
	    }
	
	    return merge({}, a, b, joinArrays.bind(null, customizer));
	  }
	
	  return b;
	}
	
	module.exports = function () {
	  var args = Array.prototype.slice.call(arguments);
	
	  return merge.apply(null, [{}].concat(args).concat([joinArrays.bind(null, function () {})]));
	};
	
	module.exports.smart = function webpackMerge() {
	  var args = Array.prototype.slice.call(arguments);
	
	  return merge.apply(null, [{}].concat(args).concat([joinArrays.bind(null, function (a, b, key) {
	    if (isLoader(key)) {
	      return a.reduce(reduceLoaders, b.slice());
	    }
	  })]));
	};
	
	function isLoader(key) {
	  return ['loaders', 'preLoaders', 'postLoaders'].indexOf(key) >= 0;
	}

/***/ }),
/* 4030 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 4031 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 4032 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W100 */
	var cptable = {version:"1.12.0"};
	cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[932] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	return {"enc": e, "dec": d }; })();
	cptable[936] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
	return {"enc": e, "dec": d }; })();
	cptable[949] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	return {"enc": e, "dec": d }; })();
	cptable[950] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	return {"enc": e, "dec": d }; })();
	cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	return {"enc": e, "dec": d }; })();
	cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	// eslint-disable-next-line no-undef
	if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
	/* cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ft=javascript: */
	/*jshint newcap: false */
	(function(root, factory) {
	  /*jshint ignore:start */
	  /*eslint-disable */
	  "use strict";
	  if(typeof cptable === "undefined") {
	    if(true){
	      var cpt = cptable;
	      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
	      else root.cptable = factory(cpt);
	    } else throw new Error("cptable not found");
	  } else cptable = factory(cptable);
	  /*eslint-enable */
	  /*jshint ignore:end */
	}(this, function(cpt){
	  "use strict";
	  /*global module, Buffer */
	  var magic = {
	    "1200":"utf16le",
	    "1201":"utf16be",
	    "12000":"utf32le",
	    "12001":"utf32be",
	    "16969":"utf64le",
	    "20127":"ascii",
	    "65000":"utf7",
	    "65001":"utf8"
	  };
	
	  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
	  var dbcs_cache = [932,936,949,950];
	  var magic_cache = [65001];
	  var magic_decode = {};
	  var magic_encode = {};
	  var cpdcache = {};
	  var cpecache = {};
	
	  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
	  var cca = function cca(x) { return x.charCodeAt(0); };
	
	  var has_buf = (typeof Buffer !== 'undefined');
	  if(has_buf) {
	    var mdl = 1024, mdb = new Buffer(mdl);
	    var make_EE = function make_EE(E){
	      var EE = new Buffer(65536);
	      for(var i = 0; i < 65536;++i) EE[i] = 0;
	      var keys = Object.keys(E), len = keys.length;
	      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
	        if(!(e = keys[ee])) continue;
	        EE[e.charCodeAt(0)] = E[e];
	      }
	      return EE;
	    };
	    var sbcs_encode = function make_sbcs_encode(cp) {
	      var EE = make_EE(cpt[cp].enc);
	      return function sbcs_e(data, ofmt) {
	        var len = data.length;
	        var out, i=0, j=0, D=0, w=0;
	        if(typeof data === 'string') {
	          out = new Buffer(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
	        } else if(Buffer.isBuffer(data)) {
	          out = new Buffer(2*len);
	          j = 0;
	          for(i = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) out[j++] = EE[D];
	            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
	            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
	            else {
	              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
	              if(w < 65536) out[j++] = EE[w];
	              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
	            }
	          }
	          out = out.slice(0,j);
	        } else {
	          out = new Buffer(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var sbcs_decode = function make_sbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = new Buffer(131072), d=0, c="";
	      for(d=0;d<D.length;++d) {
	        if(!(c=D[d])) continue;
	        var w = c.charCodeAt(0);
	        DD[2*d] = w&255; DD[2*d+1] = w>>8;
	      }
	      return function sbcs_d(data) {
	        var len = data.length, i=0, j=0;
	        if(2 * len > mdl) { mdl = 2 * len; mdb = new Buffer(mdl); }
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        }
	        return mdb.slice(0, 2 * len).toString('ucs2');
	      };
	    };
	    var dbcs_encode = function make_dbcs_encode(cp) {
	      var E = cpt[cp].enc;
	      var EE = new Buffer(131072);
	      for(var i = 0; i < 131072; ++i) EE[i] = 0;
	      var keys = Object.keys(E);
	      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
	        if(!(e = keys[ee])) continue;
	        var f = e.charCodeAt(0);
	        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
	      }
	      return function dbcs_e(data, ofmt) {
	        var len = data.length, out = new Buffer(2*len), i=0, j=0, jj=0, k=0, D=0;
	        if(typeof data === 'string') {
	          for(i = k = 0; i < len; ++i) {
	            j = data.charCodeAt(i)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	          out = out.slice(0,k);
	        } else if(Buffer.isBuffer(data)) {
	          for(i = k = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) j = D;
	            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
	            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
	            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
	            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
	            else { jj = j-65536;
	              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	            }
	          }
	          out = out.slice(0,k);
	        } else {
	          for(i = k = 0; i < len; i++) {
	            j = data[i].charCodeAt(0)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var dbcs_decode = function make_dbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = new Buffer(131072), d=0, c, w=0, j=0, i=0;
	      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
	      for(d = 0; d < D.length; ++d) {
	        if(!(c=D[d])) continue;
	        w = c.charCodeAt(0);
	        j = 2*d;
	        DD[j] = w&255; DD[j+1] = w>>8;
	      }
	      return function dbcs_d(data) {
	        var len = data.length, out = new Buffer(2*len), i=0, j=0, k=0;
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        }
	        return out.slice(0,k).toString('ucs2');
	      };
	    };
	    magic_decode[65001] = function utf8_d(data) {
	      if(typeof data === "string") return utf8_d(data.split("").map(cca));
	      var len = data.length, w = 0, ww = 0;
	      if(4 * len > mdl) { mdl = 4 * len; mdb = new Buffer(mdl); }
	      var i = 0;
	      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
	        j = 1; D = data[i];
	        if(D < 128) w = D;
	        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
	        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
	        else {
	          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
	        }
	      }
	      return mdb.slice(0,k).toString('ucs2');
	    };
	    magic_encode[65001] = function utf8_e(data, ofmt) {
	      if(has_buf && Buffer.isBuffer(data)) {
	        if(!ofmt || ofmt === 'buf') return data;
	        if(ofmt !== 'arr') return data.toString('binary');
	        return [].slice.call(data);
	      }
	      var len = data.length, w = 0, ww = 0, j = 0;
	      var direct = typeof data === "string";
	      if(4 * len > mdl) { mdl = 4 * len; mdb = new Buffer(mdl); }
	      for(var i = 0; i < len; ++i) {
	        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
	        if(w <= 0x007F) mdb[j++] = w;
	        else if(w <= 0x07FF) {
	          mdb[j++] = 192 + (w >> 6);
	          mdb[j++] = 128 + (w&63);
	        } else if(w >= 0xD800 && w <= 0xDFFF) {
	          w -= 0xD800; ++i;
	          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
	          mdb[j++] = 240 + ((ww>>>18) & 0x07);
	          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
	          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
	          mdb[j++] = 128 + (ww & 0x3F);
	        } else {
	          mdb[j++] = 224 + (w >> 12);
	          mdb[j++] = 128 + ((w >> 6)&63);
	          mdb[j++] = 128 + (w&63);
	        }
	      }
	      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
	      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
	      return [].slice.call(mdb, 0, j);
	    };
	  }
	
	  var encache = function encache() {
	    if(has_buf) {
	      if(cpdcache[sbcs_cache[0]]) return;
	      var i=0, s=0;
	      for(i = 0; i < sbcs_cache.length; ++i) {
	        s = sbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = sbcs_decode(s);
	          cpecache[s] = sbcs_encode(s);
	        }
	      }
	      for(i = 0; i < dbcs_cache.length; ++i) {
	        s = dbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = dbcs_decode(s);
	          cpecache[s] = dbcs_encode(s);
	        }
	      }
	      for(i = 0; i < magic_cache.length; ++i) {
	        s = magic_cache[i];
	        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
	        if(magic_encode[s]) cpecache[s] = magic_encode[s];
	      }
	    }
	  };
	  var null_enc = function(data, ofmt) { void ofmt; return ""; };
	  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
	  var decache = function decache() {
	    if(has_buf) {
	      if(!cpdcache[sbcs_cache[0]]) return;
	      sbcs_cache.forEach(cp_decache);
	      dbcs_cache.forEach(cp_decache);
	      magic_cache.forEach(cp_decache);
	    }
	    last_enc = null_enc; last_cp = 0;
	  };
	  var cache = {
	    encache: encache,
	    decache: decache,
	    sbcs: sbcs_cache,
	    dbcs: dbcs_cache
	  };
	
	  encache();
	
	  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
	  var last_enc = null_enc, last_cp = 0;
	  var encode = function encode(cp, data, ofmt) {
	    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
	    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
	    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
	    var len = data.length;
	    var out = has_buf ? new Buffer(4*len) : [], w=0, i=0, j = 0, ww=0;
	    var C = cpt[cp], E, M = "";
	    var isstr = typeof data === 'string';
	    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
	      w = E[isstr? data.charAt(i) : data[i]];
	      if(w > 255) {
	        out[j] = w>>8;
	        out[++j] = w&255;
	      } else out[j] = w&255;
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(has_buf && isstr) { out = new Buffer(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else if(w <= 0x07FF) {
	            out[j]   = 192 + (w >> 6);
	            out[++j] = 128 + (w&63);
	          } else if(w >= 0xD800 && w <= 0xDFFF) {
	            w -= 0xD800;
	            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
	            out[j]   = 240 + ((ww>>>18) & 0x07);
	            out[++j] = 144 + ((ww>>>12) & 0x3F);
	            out[++j] = 128 + ((ww>>>6) & 0x3F);
	            out[++j] = 128 + (ww & 0x3F);
	          } else {
	            out[j]   = 224 + (w >> 12);
	            out[++j] = 128 + ((w >> 6)&63);
	            out[++j] = 128 + (w&63);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && typeof data === "string") { out = new Buffer(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else throw new Error("bad ascii " + w);
	        }
	        break;
	      case "utf16le":
	        if(has_buf && typeof data === "string") { out = new Buffer(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w&255;
	          out[j++] = w>>8;
	        }
	        break;
	      case "utf16be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w>>8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32le":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j+3] = w&255; w >>= 8;
	          out[j+2] = w&255; w >>= 8;
	          out[j+1] = w&255; w >>= 8;
	          out[j] = w&255;
	          j+=4;
	        }
	        break;
	      case "utf7":
	        for(i = 0; i < len; i++) {
	          var c = isstr ? data.charAt(i) : data[i].charAt(0);
	          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
	          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
	          var tt = encode(1201, c);
	          out[j++] = 0x2b;
	          out[j++] = BM.charCodeAt(tt[0]>>2);
	          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
	          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
	          out[j++] = 0x2d;
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out = out.slice(0,j);
	    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
	    if(!ofmt || ofmt === 'buf') return out;
	    if(ofmt !== 'arr') return out.toString('binary');
	    return [].slice.call(out);
	  };
	  var decode = function decode(cp, data) {
	    var F; if((F=cpdcache[cp])) return F(data);
	    if(typeof data === "string") return decode(cp, data.split("").map(cca));
	    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
	    var C = cpt[cp], D, M="";
	    if(C && (D=C.dec)) {
	      for(i = 0; i < len; i+=j) {
	        j = 2;
	        s = D[(data[i]<<8)+ data[i+1]];
	        if(!s) {
	          j = 1;
	          s = D[data[i]];
	        }
	        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
	        out[k++] = s;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	        for(; i < len; i+=j) {
	          j = 1;
	          if(data[i] < 128) w = data[i];
	          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
	          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	          if(w < 65536) { out[k++] = String.fromCharCode(w); }
	          else {
	            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
	        k = len; break;
	      case "utf16le":
	        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
	        }
	        break;
	      case "utf16be":
	        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
	        }
	        break;
	      case "utf32le":
	        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf32be":
	        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf7":
	        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
	          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
	          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
	        }
	        for(; i < len; i+=j) {
	          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
	          j=1;
	          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
	          // eslint-disable-next-line no-useless-escape
	          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
	          var dash = 0;
	          if(data[i+j] === 0x2d) { ++j; dash=1; }
	          var tt = [];
	          var o64 = "";
	          var c1=0, c2=0, c3=0;
	          var e1=0, e2=0, e3=0, e4=0;
	          for(var l = 1; l < j - dash;) {
	            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            c1 = e1 << 2 | e2 >> 4;
	            tt.push(c1);
	            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e3 === -1) break;
	            c2 = (e2 & 15) << 4 | e3 >> 2;
	            tt.push(c2);
	            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e4 === -1) break;
	            c3 = (e3 & 3) << 6 | e4;
	            if(e4 < 64) tt.push(c3);
	          }
	          o64 = decode(1201, tt);
	          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    return out.slice(0,k).join("");
	  };
	  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
	  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
	  return cpt;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 4033 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	
	JSZip - A Javascript class for generating and reading zip files
	<http://stuartk.com/jszip>
	
	(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
	Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.
	
	JSZip uses the library pako released under the MIT license :
	https://github.com/nodeca/pako/blob/master/LICENSE
	*/
	(function(e){
		if("object"==typeof exports&&"undefined"!=typeof module&&"undefined"==typeof DO_NOT_EXPORT_JSZIP)module.exports=e();
		else if(true){JSZip=e();!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}
		else{
			var f;
			"undefined"!=typeof window?f=window:
			"undefined"!=typeof global?f=global:
			"undefined"!=typeof $ && $.global?f=$.global:
			"undefined"!=typeof self&&(f=self),f.JSZip=e()
		}
	}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	
	    }
	
	    return output;
	};
	
	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }
	
	    }
	
	    return output;
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;
	
	},{}],3:[function(_dereq_,module,exports){
	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = _dereq_('./flate');
	
	},{"./flate":8}],4:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];
	
	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;
	
	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }
	
	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:
	
	},{"./utils":21}],5:[function(_dereq_,module,exports){
	'use strict';
	var utils = _dereq_('./utils');
	
	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;
	
	},{"./utils":21}],6:[function(_dereq_,module,exports){
	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.comment = null;
	
	},{}],7:[function(_dereq_,module,exports){
	'use strict';
	var utils = _dereq_('./utils');
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
	
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};
	
	
	},{"./utils":21}],8:[function(_dereq_,module,exports){
	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = _dereq_("pako");
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	exports.compress = function(input) {
	    return pako.deflateRaw(input);
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};
	
	},{"pako":24}],9:[function(_dereq_,module,exports){
	'use strict';
	
	var base64 = _dereq_('./base64');
	
	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");
	
	   base64zip = zip.generate();
	
	**/
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZip(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) return new JSZip(data, options);
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = _dereq_('./object');
	JSZip.prototype.load = _dereq_('./load');
	JSZip.support = _dereq_('./support');
	JSZip.defaults = _dereq_('./defaults');
	
	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZip.utils = _dereq_('./deprecatedPublicUtils');
	
	JSZip.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZip.compressions = _dereq_('./compressions');
	module.exports = JSZip;
	
	},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(_dereq_,module,exports){
	'use strict';
	var base64 = _dereq_('./base64');
	var ZipEntries = _dereq_('./zipEntries');
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = options || {};
	    if (options.base64) {
	        data = base64.decode(data);
	    }
	
	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileName, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileComment.length ? input.fileComment : null,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }
	
	    return this;
	};
	
	},{"./base64":1,"./zipEntries":22}],11:[function(_dereq_,module,exports){
	(function (Buffer){
	'use strict';
	module.exports = function(data, encoding){
	    return new Buffer(data, encoding);
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};
	}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
	},{}],12:[function(_dereq_,module,exports){
	'use strict';
	var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
	
	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;
	
	},{"./uint8ArrayReader":18}],13:[function(_dereq_,module,exports){
	'use strict';
	var support = _dereq_('./support');
	var utils = _dereq_('./utils');
	var crc32 = _dereq_('./crc32');
	var signature = _dereq_('./signature');
	var defaults = _dereq_('./defaults');
	var base64 = _dereq_('./base64');
	var compressions = _dereq_('./compressions');
	var CompressedObject = _dereq_('./compressedObject');
	var nodeBuffer = _dereq_('./nodeBuffer');
	var utf8 = _dereq_('./utf8');
	var StringWriter = _dereq_('./stringWriter');
	var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');
	
	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;
	
	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};
	
	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};
	
	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }
	
	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	
	    this._data = data;
	    this.options = options;
	
	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	var extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();
	
	    return o;
	};
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	    o = prepareFileAttrs(o);
	
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;
	
	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }
	
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }
	
	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    // Check the name ends with a /
	    if (name.slice(-1) != "/") {
	        name += "/"; // IE doesn't like substr(-1)
	    }
	
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression) {
	    var result = new CompressedObject(),
	        content;
	
	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;
	
	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	    }
	
	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;
	
	    return result;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset) {
	    var data = compressedObject.compressedContent,
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;
	
	
	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }
	
	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }
	
	
	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;
	
	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(utfEncodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(utfEncodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(utfEncodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    "\x14\x00" +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(utfEncodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    // internal file attributes TODO
	    "\x00\x00" +
	    // external file attributes
	    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    utfEncodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    utfEncodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};
	
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            type: "base64",
	            comment: null
	        });
	
	        utils.checkSupport(options.type);
	
	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));
	
	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            if (!this.files.hasOwnProperty(name)) {
	                continue;
	            }
	            var file = this.files[name];
	
	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	
	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);
	
	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }
	
	        var dirEnd = "";
	
	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(utfEncodedComment.length, 2) +
	        // .ZIP file comment
	        utfEncodedComment;
	
	
	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }
	
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }
	
	        writer.append(dirEnd);
	
	        var zip = writer.finalize();
	
	
	
	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }
	
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;
	
	},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(_dereq_,module,exports){
	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";
	
	},{}],15:[function(_dereq_,module,exports){
	'use strict';
	var DataReader = _dereq_('./dataReader');
	var utils = _dereq_('./utils');
	
	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig);
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;
	
	},{"./dataReader":5,"./utils":21}],16:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};
	
	module.exports = StringWriter;
	
	},{"./utils":21}],17:[function(_dereq_,module,exports){
	(function (Buffer){
	'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
	},{}],18:[function(_dereq_,module,exports){
	'use strict';
	var DataReader = _dereq_('./dataReader');
	
	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	    }
	}
	Uint8ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	Uint8ArrayReader.prototype.byteAt = function(i) {
	    return this.data[i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;
	
	},{"./dataReader":5}],19:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};
	
	module.exports = Uint8ArrayWriter;
	
	},{"./utils":21}],20:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	var support = _dereq_('./support');
	var nodeBuffer = _dereq_('./nodeBuffer');
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");
	
	};
	// vim: set shiftwidth=4 softtabstop=4:
	
	},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(_dereq_,module,exports){
	'use strict';
	var support = _dereq_('./support');
	var compressions = _dereq_('./compressions');
	var nodeBuffer = _dereq_('./nodeBuffer');
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: "application/zip"
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob('application/zip');
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }
	
	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};
	
	
	},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(_dereq_,module,exports){
	'use strict';
	var StringReader = _dereq_('./stringReader');
	var NodeBufferReader = _dereq_('./nodeBufferReader');
	var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
	var utils = _dereq_('./utils');
	var sig = _dereq_('./signature');
	var ZipEntry = _dereq_('./zipEntry');
	var support = _dereq_('./support');
	var jszipProto = _dereq_('./object');
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        this.zipComment = this.reader.readString(this.zipCommentLength);
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded.
	        this.zipComment = jszipProto.utf8decode(this.zipComment);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset === -1) {
	            throw new Error("Corrupted zip : can't find end of central directory");
	        }
	        this.reader.setIndex(offset);
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset === -1) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;
	
	},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(_dereq_,module,exports){
	'use strict';
	var StringReader = _dereq_('./stringReader');
	var utils = _dereq_('./utils');
	var CompressedObject = _dereq_('./compressedObject');
	var jszipProto = _dereq_('./object');
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);
	
	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {
	
	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);
	
	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	
	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readString(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }
	
	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
	
	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readString(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        this.fileName = reader.readString(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readString(this.fileCommentLength);
	
	        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
	        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
	    },
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        this.extraFields = this.extraFields || {};
	
	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        if (this.useUTF8()) {
	            this.fileName = jszipProto.utf8decode(this.fileName);
	            this.fileComment = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileName = upath;
	            }
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileComment = ucomment;
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;
	
	},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(_dereq_,module,exports){
	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = _dereq_('./lib/utils/common').assign;
	
	var deflate   = _dereq_('./lib/deflate');
	var inflate   = _dereq_('./lib/inflate');
	var constants = _dereq_('./lib/zlib/constants');
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;
	},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(_dereq_,module,exports){
	'use strict';
	
	
	var zlib_deflate = _dereq_('./zlib/deflate.js');
	var utils = _dereq_('./utils/common');
	var strings = _dereq_('./utils/strings');
	var msg = _dereq_('./zlib/messages');
	var zstream = _dereq_('./zlib/zstream');
	
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overriden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	var Deflate = function(options) {
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new zstream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	};
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|String): input data. Strings will be converted to
	 *   utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
	 * [[Deflate#onEnd]].
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function(data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && _mode === Z_FINISH)) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function(chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that input stream complete
	 * or error happenned. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function(status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate alrorythm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;
	},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(_dereq_,module,exports){
	'use strict';
	
	
	var zlib_inflate = _dereq_('./zlib/inflate.js');
	var utils = _dereq_('./utils/common');
	var strings = _dereq_('./utils/strings');
	var c = _dereq_('./zlib/constants');
	var msg = _dereq_('./zlib/messages');
	var zstream = _dereq_('./zlib/zstream');
	var gzheader = _dereq_('./zlib/gzheader');
	
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overriden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	var Inflate = function(options) {
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new zstream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new gzheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	};
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
	 * [[Inflate#onEnd]].
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function(data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && _mode === c.Z_FINISH)) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	  } while ((strm.avail_in > 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function(chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell inflate that input stream complete
	 * or error happenned. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function(status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 alligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;
	
	},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(_dereq_,module,exports){
	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof(source) !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs+len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for(var i=0; i<len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function(chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i=0, l=chunks.length; i<l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i=0, l=chunks.length; i<l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for(var i=0; i<len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function(chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);
	},{}],28:[function(_dereq_,module,exports){
	// String encode/decode helpers
	'use strict';
	
	
	var utils = _dereq_('./common');
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safary
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [0]); } catch(__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch(__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	      c2 = str.charCodeAt(m_pos+1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	      c2 = str.charCodeAt(m_pos+1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // use fallback for big arrays to avoid stack overflow
	  if (len < 65537) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for(var i=0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function(buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function(str) {
	  var buf = new utils.Buf8(str.length);
	  for(var i=0, len=buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len*2);
	
	  for (out=0, i=0; i<len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function(buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max-1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Fuckup - very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means vuffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	},{"./common":27}],29:[function(_dereq_,module,exports){
	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0
	    , s2 = ((adler >>> 16) & 0xffff) |0
	    , n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;
	},{}],30:[function(_dereq_,module,exports){
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};
	},{}],31:[function(_dereq_,module,exports){
	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for(var n =0; n < 256; n++){
	    c = n;
	    for(var k =0; k < 8; k++){
	      c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable
	    , end = pos + len;
	
	  crc = crc ^ (-1);
	
	  for (var i = pos; i < end; i++ ) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;
	},{}],32:[function(_dereq_,module,exports){
	'use strict';
	
	var utils   = _dereq_('../utils/common');
	var trees   = _dereq_('./trees');
	var adler32 = _dereq_('./adler32');
	var crc32   = _dereq_('./crc32');
	var msg   = _dereq_('./messages');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2*L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only (s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH-1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH-1)) ? s.strstart : MIN_MATCH-1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH-1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size-MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH-1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1- s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length-1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH-1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH-1 ? s.strstart : MIN_MATCH-1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	};
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2*D_CODES+1) * 2);
	  this.bl_tree    = new utils.Buf16((2*BL_CODES+1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS+1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2*L_CODES+1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2*L_CODES+1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  s.d_buf = s.lit_bufsize >> 1;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg){
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	/* =========================================================================
	 * Copy the source state to the destination state
	 */
	//function deflateCopy(dest, source) {
	//
	//}
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/
	},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(_dereq_,module,exports){
	'use strict';
	
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;
	},{}],34:[function(_dereq_,module,exports){
	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  var window;                 /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};
	
	},{}],35:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	var adler32 = _dereq_('./adler32');
	var crc32   = _dereq_('./crc32');
	var inflate_fast = _dereq_('./inffast');
	var inflate_table = _dereq_('./inftrees');
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function ZSWAP32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, {bits: 9});
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, {bits: 5});
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window,src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window,src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window,src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = ZSWAP32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = {bits: state.lenbits};
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = {bits: state.lenbits};
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = {bits: state.distbits};
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) -1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) -1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
	        if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/
	},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	      base = extra = work;    /* dummy value--not used */
	      end = 19;
	  } else if (type === LENS) {
	      base = lbase;
	      base_index -= 257;
	      extra = lext;
	      extra_index -= 257;
	      end = 256;
	  } else {                    /* DISTS */
	      base = dbase;
	      extra = dext;
	      end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i=0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};
	
	},{"../utils/common":27}],37:[function(_dereq_,module,exports){
	'use strict';
	
	module.exports = {
	  '2':    'need dictionary',     /* Z_NEED_DICT       2  */
	  '1':    'stream end',          /* Z_STREAM_END      1  */
	  '0':    '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};
	},{}],38:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2*L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES+2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH-MIN_MATCH+1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	};
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	var TreeDesc = function(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	};
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short (s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c*2]/*.Code*/, tree[c*2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max]*2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max+1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n*2 +1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n*2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n-base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n*2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length-1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits+1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m*2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m*2 + 1]/*.Len*/)*tree[m*2]/*.Freq*/;
	        tree[m*2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS+1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits-1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n*2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n*2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS+1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES-1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1<<extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length-1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0 ; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1<<extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for ( ; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1<<(extra_dbits[code]-7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n*2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n*2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n*2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n*2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES+1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n*2 + 1]/*.Len*/ = 5;
	    static_dtree[n*2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS+1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc =new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n*2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n*2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n*2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK*2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n*2;
	  var _m2 = m*2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j+1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx*2] << 8) | (s.pending_buf[s.d_buf + lx*2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code+LITERALS+1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n*2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node*2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n*2 + 1]/*.Dad*/ = tree[m*2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code+1)*2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n+1)*2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6*2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10*2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138*2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n+1)*2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count-3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count-3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count-11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES-1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex]*2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3*(max_blindex+1) + 5+5+4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes-257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes-1,   5);
	  send_bits(s, blcodes-4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank]*2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes-1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes-1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n*2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK<<1)+(last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES<<1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len+3+7) >>> 3;
	    static_lenb = (s.static_len+3+7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len+4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES<<1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES<<1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code+1, s.d_desc.max_code+1, max_blindex+1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc*2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc]+LITERALS+1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize-1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;
	},{"../utils/common":27}],39:[function(_dereq_,module,exports){
	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;
	},{}]},{},[9])
	(9)
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25).Buffer))

/***/ }),
/* 4034 */,
/* 4035 */,
/* 4036 */,
/* 4037 */,
/* 4038 */,
/* 4039 */,
/* 4040 */,
/* 4041 */,
/* 4042 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 4043 */,
/* 4044 */,
/* 4045 */,
/* 4046 */,
/* 4047 */,
/* 4048 */,
/* 4049 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.f0feafbc335c9872f364.js